(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire86be"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire86be"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2PPWI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1xCtz"));

});
parcelRegister("1xCtz", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $11f6b80438a4932e$export$ffb0004e005737fa; }, function (v) { return $11f6b80438a4932e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $11f6b80438a4932e$export$34b9dba7ce09269b; }, function (v) { return $11f6b80438a4932e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $11f6b80438a4932e$export$25062201e9e25d76; }, function (v) { return $11f6b80438a4932e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11f6b80438a4932e$export$ffb0004e005737fa;
var $11f6b80438a4932e$export$34b9dba7ce09269b;
var $11f6b80438a4932e$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("8FY87"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, "key")) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
            });
            var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $11f6b80438a4932e$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $11f6b80438a4932e$export$34b9dba7ce09269b = jsx;
    $11f6b80438a4932e$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("8FY87", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9deOe"));

});
parcelRegister("9deOe", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.3.1";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});




parcelRegister("8U9kV", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $67bacbba53424d7b$export$ae55be85d98224ed; }, function (v) { return $67bacbba53424d7b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $67bacbba53424d7b$export$d39a5bbd09211389; }, function (v) { return $67bacbba53424d7b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $67bacbba53424d7b$export$882461b6382ed46c; }, function (v) { return $67bacbba53424d7b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $67bacbba53424d7b$export$466bfc07425424d5; }, function (v) { return $67bacbba53424d7b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $67bacbba53424d7b$export$cd75ccfd720a3cd4; }, function (v) { return $67bacbba53424d7b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $67bacbba53424d7b$export$fa8d919ba61d84db; }, function (v) { return $67bacbba53424d7b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $67bacbba53424d7b$export$757ceba2d55c277e; }, function (v) { return $67bacbba53424d7b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $67bacbba53424d7b$export$b3890eb0ae9dca99; }, function (v) { return $67bacbba53424d7b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $67bacbba53424d7b$export$502457920280e6be; }, function (v) { return $67bacbba53424d7b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $67bacbba53424d7b$export$c78a37762a8d58e1; }, function (v) { return $67bacbba53424d7b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $67bacbba53424d7b$export$dc54d992c10e8a18; }, function (v) { return $67bacbba53424d7b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $67bacbba53424d7b$export$83d89fbfd8236492; }, function (v) { return $67bacbba53424d7b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $67bacbba53424d7b$export$ae55be85d98224ed;
var $67bacbba53424d7b$export$d39a5bbd09211389;
var $67bacbba53424d7b$export$882461b6382ed46c;
var $67bacbba53424d7b$export$466bfc07425424d5;
var $67bacbba53424d7b$export$cd75ccfd720a3cd4;
var $67bacbba53424d7b$export$fa8d919ba61d84db;
var $67bacbba53424d7b$export$757ceba2d55c277e;
var $67bacbba53424d7b$export$b3890eb0ae9dca99;
var $67bacbba53424d7b$export$502457920280e6be;
var $67bacbba53424d7b$export$c78a37762a8d58e1;
var $67bacbba53424d7b$export$dc54d992c10e8a18;
var $67bacbba53424d7b$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8FY87"));
    var Scheduler = (parcelRequire("9LPgQ"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === "function" && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.3.1";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $67bacbba53424d7b$export$ae55be85d98224ed = Internals;
    $67bacbba53424d7b$export$d39a5bbd09211389 = createPortal$1;
    $67bacbba53424d7b$export$882461b6382ed46c = createRoot$1;
    $67bacbba53424d7b$export$466bfc07425424d5 = findDOMNode;
    $67bacbba53424d7b$export$cd75ccfd720a3cd4 = flushSync$1;
    $67bacbba53424d7b$export$fa8d919ba61d84db = hydrate;
    $67bacbba53424d7b$export$757ceba2d55c277e = hydrateRoot$1;
    $67bacbba53424d7b$export$b3890eb0ae9dca99 = render;
    $67bacbba53424d7b$export$502457920280e6be = unmountComponentAtNode;
    $67bacbba53424d7b$export$c78a37762a8d58e1 = batchedUpdates$1;
    $67bacbba53424d7b$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $67bacbba53424d7b$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("9LPgQ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2KkxT"));

});
parcelRegister("2KkxT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1fffd090be31e0e0$export$c4744153514ff05d; }, function (v) { return $1fffd090be31e0e0$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1fffd090be31e0e0$export$3e506c1ccc9cc1a7; }, function (v) { return $1fffd090be31e0e0$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1fffd090be31e0e0$export$e26fe2ed2fa76875; }, function (v) { return $1fffd090be31e0e0$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1fffd090be31e0e0$export$502329bbf4b505b1; }, function (v) { return $1fffd090be31e0e0$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1fffd090be31e0e0$export$6e3807111c4874c4; }, function (v) { return $1fffd090be31e0e0$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1fffd090be31e0e0$export$c27134553091fb3a; }, function (v) { return $1fffd090be31e0e0$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1fffd090be31e0e0$export$33ee1acdc04fd2a2; }, function (v) { return $1fffd090be31e0e0$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1fffd090be31e0e0$export$b00a404bbd5edef2; }, function (v) { return $1fffd090be31e0e0$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1fffd090be31e0e0$export$8352ce38b91d0c62; }, function (v) { return $1fffd090be31e0e0$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1fffd090be31e0e0$export$d66a1c1c77bd778b; }, function (v) { return $1fffd090be31e0e0$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1fffd090be31e0e0$export$d3dfb8e4810cb555; }, function (v) { return $1fffd090be31e0e0$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1fffd090be31e0e0$export$839f9183b0465a69; }, function (v) { return $1fffd090be31e0e0$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1fffd090be31e0e0$export$72fdf0e06517287b; }, function (v) { return $1fffd090be31e0e0$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1fffd090be31e0e0$export$4b844e58a3e414b4; }, function (v) { return $1fffd090be31e0e0$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1fffd090be31e0e0$export$816d2913ae6b83b1; }, function (v) { return $1fffd090be31e0e0$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1fffd090be31e0e0$export$61bcfe829111a1d0; }, function (v) { return $1fffd090be31e0e0$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1fffd090be31e0e0$export$7ee8c9beb337bc3f; }, function (v) { return $1fffd090be31e0e0$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1fffd090be31e0e0$export$b5836b71941fa3ed; }, function (v) { return $1fffd090be31e0e0$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1fffd090be31e0e0$export$cf845f2c119da08a; }, function (v) { return $1fffd090be31e0e0$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1fffd090be31e0e0$export$c4744153514ff05d;
var $1fffd090be31e0e0$export$3e506c1ccc9cc1a7;
var $1fffd090be31e0e0$export$e26fe2ed2fa76875;
var $1fffd090be31e0e0$export$502329bbf4b505b1;
var $1fffd090be31e0e0$export$6e3807111c4874c4;
var $1fffd090be31e0e0$export$c27134553091fb3a;
var $1fffd090be31e0e0$export$33ee1acdc04fd2a2;
var $1fffd090be31e0e0$export$b00a404bbd5edef2;
var $1fffd090be31e0e0$export$8352ce38b91d0c62;
var $1fffd090be31e0e0$export$d66a1c1c77bd778b;
var $1fffd090be31e0e0$export$d3dfb8e4810cb555;
var $1fffd090be31e0e0$export$839f9183b0465a69;
var $1fffd090be31e0e0$export$72fdf0e06517287b;
var $1fffd090be31e0e0$export$4b844e58a3e414b4;
var $1fffd090be31e0e0$export$816d2913ae6b83b1;
var $1fffd090be31e0e0$export$61bcfe829111a1d0;
var $1fffd090be31e0e0$export$7ee8c9beb337bc3f;
var $1fffd090be31e0e0$export$b5836b71941fa3ed;
var $1fffd090be31e0e0$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $1fffd090be31e0e0$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $1fffd090be31e0e0$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $1fffd090be31e0e0$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $1fffd090be31e0e0$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $1fffd090be31e0e0$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $1fffd090be31e0e0$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $1fffd090be31e0e0$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($1fffd090be31e0e0$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $1fffd090be31e0e0$export$3e506c1ccc9cc1a7 = IdlePriority;
    $1fffd090be31e0e0$export$e26fe2ed2fa76875 = ImmediatePriority;
    $1fffd090be31e0e0$export$502329bbf4b505b1 = LowPriority;
    $1fffd090be31e0e0$export$6e3807111c4874c4 = NormalPriority;
    $1fffd090be31e0e0$export$c27134553091fb3a = unstable_Profiling;
    $1fffd090be31e0e0$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $1fffd090be31e0e0$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $1fffd090be31e0e0$export$8352ce38b91d0c62 = unstable_continueExecution;
    $1fffd090be31e0e0$export$d66a1c1c77bd778b = forceFrameRate;
    $1fffd090be31e0e0$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $1fffd090be31e0e0$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $1fffd090be31e0e0$export$72fdf0e06517287b = unstable_next;
    $1fffd090be31e0e0$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $1fffd090be31e0e0$export$816d2913ae6b83b1 = unstable_requestPaint;
    $1fffd090be31e0e0$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $1fffd090be31e0e0$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $1fffd090be31e0e0$export$b5836b71941fa3ed = shouldYieldToHost;
    $1fffd090be31e0e0$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("9s93Y", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("aTRs6", function(module, exports) {

$parcel$export(module.exports, "IS_DISCORD_ACTIVITY", function () { return $75f663422c53033a$export$dba67fba4aff0023; });
$parcel$export(module.exports, "CDN_HOST", function () { return $75f663422c53033a$export$4e2a8144f21bf311; });
$parcel$export(module.exports, "BP_MOBILE_CHAT", function () { return $75f663422c53033a$export$67bd39600f23cb85; });
$parcel$export(module.exports, "FAILURE_TIMEOUT_SECONDS", function () { return $75f663422c53033a$export$59ef9be27f51566d; });
$parcel$export(module.exports, "LS_HASSEENWORLDINTRO_KEY", function () { return $75f663422c53033a$export$432b15cee471a58b; });
$parcel$export(module.exports, "LS_HASSEENSHOP_KEY", function () { return $75f663422c53033a$export$325115ee4aff31f9; });
$parcel$export(module.exports, "LS_NEWSMODAL_LAST_VERSION_SEEN_KEY", function () { return $75f663422c53033a$export$514805d75386b7a2; });
$parcel$export(module.exports, "FEED_MESSAGES_TO_LOAD", function () { return $75f663422c53033a$export$890bcb35b2d29224; });
const $75f663422c53033a$export$dba67fba4aff0023 = window.location.hostname.endsWith("discordsays.com");
const $75f663422c53033a$export$4e2a8144f21bf311 = $75f663422c53033a$export$dba67fba4aff0023 ? "/.proxy/cdn/" : "https://cdn.ariseworlds.com/";
const $75f663422c53033a$export$67bd39600f23cb85 = 992; // Also referenced in globals.scss
const $75f663422c53033a$export$59ef9be27f51566d = 5;
const $75f663422c53033a$export$432b15cee471a58b = "ARISE_HASSEENWORLDINTRO";
const $75f663422c53033a$export$325115ee4aff31f9 = "ARISE_HASSEENSHOP";
const $75f663422c53033a$export$514805d75386b7a2 = "ARISE_NEWSMODAL_LAST_VERSION_SEEN";
const $75f663422c53033a$export$890bcb35b2d29224 = 20;

});

parcelRegister("6lYLL", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $160cd041adcc0a26$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $160cd041adcc0a26$export$a7347740d65f620b; });
$parcel$export(module.exports, "Provider", function () { return $160cd041adcc0a26$export$2881499e37b75b9a; });

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("4AlPA");
var $dRnhz = parcelRequire("dRnhz");
var $7TfqD = parcelRequire("7TfqD");
var $6cnQI = parcelRequire("6cnQI");

var $jvvee = parcelRequire("jvvee");

var $jJtwY = parcelRequire("jJtwY");

var $baXkz = parcelRequire("baXkz");

var $kyBxf = parcelRequire("kyBxf");

var $4KKbJ = parcelRequire("4KKbJ");

var $hzaQx = parcelRequire("hzaQx");
const $160cd041adcc0a26$var$store = (0, $jvvee.configureStore)({
    reducer: {
        app: (0, $baXkz.default),
        auth: (0, $jJtwY.default),
        feed: (0, $kyBxf.feedReducer),
        profile: (0, $4KKbJ.default),
        discord: (0, $hzaQx.default)
    }
});
const $160cd041adcc0a26$export$f51d452c10d5b956 = ()=>(0, $7TfqD.useDispatch)();
const $160cd041adcc0a26$export$a7347740d65f620b = (0, $6cnQI.useSelector);
var $160cd041adcc0a26$export$2e2bcd8739ae039 = $160cd041adcc0a26$var$store;
function $160cd041adcc0a26$export$2881499e37b75b9a({ children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dRnhz.default), {
        store: $160cd041adcc0a26$var$store,
        children: children
    });
}

});
parcelRegister("4AlPA", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("gzuKA")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("dRnhz")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7TfqD")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("6cnQI")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $arzaR = parcelRequire("arzaR");

var $l80b5 = parcelRequire("l80b5");
parcelRequire("1A4Yp");
var $95gxM = parcelRequire("95gxM");

var $j4QCj = parcelRequire("j4QCj");

var $6cnQI = parcelRequire("6cnQI");

var $gzuKA = parcelRequire("gzuKA");
parcelRequire("h6R5A");
(0, $6cnQI.initializeUseSelector)((0, $l80b5.useSyncExternalStoreWithSelector));
(0, $gzuKA.initializeConnect)((0, $arzaR.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $j4QCj.setBatch)((0, $95gxM.unstable_batchedUpdates));

});
parcelRegister("arzaR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jHH9T"));

});
parcelRegister("jHH9T", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $e58382da549a21e2$export$306c0aa65ff9ec16; }, function (v) { return $e58382da549a21e2$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e58382da549a21e2$export$306c0aa65ff9ec16;
"use strict";

(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8FY87"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    // dispatch for CommonJS interop named imports.
    var useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
    var didWarnOld18Alpha = false;
    var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
    // because of a very particular set of implementation details and assumptions
    // -- change any one of them and it will break. The most important assumption
    // is that updates are always synchronous, because concurrent rendering is
    // only available in versions of React that also have a built-in
    // useSyncExternalStore API. And we only use this shim when the built-in API
    // does not exist.
    //
    // Do not assume that the clever hacks used by this hook also work in general.
    // The point of this shim is to replace the need for hacks by other libraries.
    function useSyncExternalStore(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    getServerSnapshot) {
        if (!didWarnOld18Alpha) {
            if (React.startTransition !== undefined) {
                didWarnOld18Alpha = true;
                error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
        }
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _useState = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        }), inst = _useState[0].inst, forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
            // commit phase if there was an interleaved mutation. In concurrent mode
            // this can happen all the time, but even in synchronous mode, an earlier
            // effect may have mutated the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
            var handleStoreChange = function() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) // Force a re-render.
                forceUpdate({
                    inst: inst
                });
            }; // Subscribe to the store and return a clean-up function.
            return subscribe(handleStoreChange);
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var isServerEnvironment = !canUseDOM;
    var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
    var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;
    $e58382da549a21e2$export$306c0aa65ff9ec16 = useSyncExternalStore$2;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});


parcelRegister("l80b5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("djdLo"));

});
parcelRegister("djdLo", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $9b07b9d1d1ed80cd$export$bf730a2d8bf68b42; }, function (v) { return $9b07b9d1d1ed80cd$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9b07b9d1d1ed80cd$export$bf730a2d8bf68b42;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8FY87"));
    var shim = (parcelRequire("arzaR"));
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var useSyncExternalStore = shim.useSyncExternalStore;
    // for CommonJS interop.
    var useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.
    function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
            inst = {
                hasValue: false,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        var _useMemo = useMemo(function() {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function(nextSnapshot) {
                if (!hasMemo) {
                    // The first time the hook is called, there is no memoized result.
                    hasMemo = true;
                    memoizedSnapshot = nextSnapshot;
                    var _nextSelection = selector(nextSnapshot);
                    if (isEqual !== undefined) // Even if the selector has changed, the currently rendered selection
                    // may be equal to the new selection. We should attempt to reuse the
                    // current value if possible, to preserve downstream memoizations.
                    {
                        if (inst.hasValue) {
                            var currentSelection = inst.value;
                            if (isEqual(currentSelection, _nextSelection)) {
                                memoizedSelection = currentSelection;
                                return currentSelection;
                            }
                        }
                    }
                    memoizedSelection = _nextSelection;
                    return _nextSelection;
                } // We may be able to reuse the previous invocation's result.
                // We may be able to reuse the previous invocation's result.
                var prevSnapshot = memoizedSnapshot;
                var prevSelection = memoizedSelection;
                if (objectIs(prevSnapshot, nextSnapshot)) // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
                 // The snapshot has changed, so we need to compute a new selection.
                // The snapshot has changed, so we need to compute a new selection.
                var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) return prevSelection;
                memoizedSnapshot = nextSnapshot;
                memoizedSelection = nextSelection;
                return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.
            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function() {
                return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            };
            return [
                getSnapshotWithSelector,
                getServerSnapshotWithSelector
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function() {
            inst.hasValue = true;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    }
    $9b07b9d1d1ed80cd$export$bf730a2d8bf68b42 = useSyncExternalStoreWithSelector;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});


parcelRegister("1A4Yp", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("95gxM")).unstable_batchedUpdates; });

var $95gxM = parcelRequire("95gxM");

});
parcelRegister("95gxM", function(module, exports) {
"use strict";
function $69d169f7fc8722a7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("8U9kV"));

});


parcelRegister("j4QCj", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $de3734a5768ff50b$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $de3734a5768ff50b$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $de3734a5768ff50b$var$defaultNoopBatch(callback) {
    callback();
}
let $de3734a5768ff50b$var$batch = $de3734a5768ff50b$var$defaultNoopBatch; // Allow injecting another batching function later
const $de3734a5768ff50b$export$4b9874722d0da7bc = (newBatch)=>$de3734a5768ff50b$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $de3734a5768ff50b$export$fc47d4c0ba3bd2c6 = ()=>$de3734a5768ff50b$var$batch;

});

parcelRegister("6cnQI", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $48365d0769da4400$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $48365d0769da4400$export$2105062e25df4afe; });

var $8FY87 = parcelRequire("8FY87");

var $53PpI = parcelRequire("53PpI");

var $5Zy0y = parcelRequire("5Zy0y");

var $eggdA = parcelRequire("eggdA");
let $48365d0769da4400$var$useSyncExternalStoreWithSelector = (0, $eggdA.notInitialized);
const $48365d0769da4400$export$e2e6e3f3f3b782e3 = (fn)=>{
    $48365d0769da4400$var$useSyncExternalStoreWithSelector = fn;
};
const $48365d0769da4400$var$refEquality = (a, b)=>a === b;
function $48365d0769da4400$export$2b53f90d2bd1cbfb(context = (0, $5Zy0y.ReactReduxContext)) {
    const useReduxContext = context === (0, $5Zy0y.ReactReduxContext) ? (0, $53PpI.useReduxContext) : (0, $53PpI.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $48365d0769da4400$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        if (!selector) throw new Error(`You must pass a selector to useSelector`);
        if (typeof selector !== "function") throw new Error(`You must pass a function as a selector to useSelector`);
        if (typeof equalityFn !== "function") throw new Error(`You must pass a function as an equality function to useSelector`);
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $8FY87.useRef)(true);
        const wrappedSelector = (0, $8FY87.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                {
                    const finalStabilityCheck = typeof stabilityCheck === "undefined" ? globalStabilityCheck : stabilityCheck;
                    if (finalStabilityCheck === "always" || finalStabilityCheck === "once" && firstRun.current) {
                        const toCompare = selector(state);
                        if (!equalityFn(selected, toCompare)) {
                            let stack = undefined;
                            try {
                                throw new Error();
                            } catch (e) {
                                ({ stack: stack } = e);
                            }
                            console.warn("Selector " + (selector.name || "unknown") + " returned a different result when called with the same parameters. This can lead to unnecessary rerenders." + "\nSelectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization", {
                                state: state,
                                selected: selected,
                                selected2: toCompare,
                                stack: stack
                            });
                        }
                    }
                    const finalNoopCheck = typeof noopCheck === "undefined" ? globalNoopCheck : noopCheck;
                    if (finalNoopCheck === "always" || finalNoopCheck === "once" && firstRun.current) // @ts-ignore
                    {
                        if (selected === state) {
                            let stack = undefined;
                            try {
                                throw new Error();
                            } catch (e) {
                                ({ stack: stack } = e);
                            }
                            console.warn("Selector " + (selector.name || "unknown") + " returned the root state when called. This can lead to unnecessary rerenders." + "\nSelectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.", {
                                stack: stack
                            });
                        }
                    }
                    if (firstRun.current) firstRun.current = false;
                }
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $48365d0769da4400$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $8FY87.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $48365d0769da4400$export$2105062e25df4afe = /*#__PURE__*/ $48365d0769da4400$export$2b53f90d2bd1cbfb();

});
parcelRegister("53PpI", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $3af51d3feaf9e048$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $3af51d3feaf9e048$export$c1275ca9a6fd3ec5; });

var $8FY87 = parcelRequire("8FY87");

var $5Zy0y = parcelRequire("5Zy0y");
function $3af51d3feaf9e048$export$d4d6226d5fc61558(context = (0, $5Zy0y.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $8FY87.useContext)(context);
        if (!contextValue) throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
        return contextValue;
    };
}
const $3af51d3feaf9e048$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $3af51d3feaf9e048$export$d4d6226d5fc61558();

});
parcelRegister("5Zy0y", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $45cd0786f8a3356e$export$cc80c08dc91f1c00; });

var $8FY87 = parcelRequire("8FY87");
const $45cd0786f8a3356e$var$ContextKey = Symbol.for(`react-redux-context`);
const $45cd0786f8a3356e$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $45cd0786f8a3356e$var$getContext() {
    var _gT$ContextKey;
    if (!$8FY87.createContext) return {};
    const contextMap = (_gT$ContextKey = $45cd0786f8a3356e$var$gT[$45cd0786f8a3356e$var$ContextKey]) != null ? _gT$ContextKey : $45cd0786f8a3356e$var$gT[$45cd0786f8a3356e$var$ContextKey] = new Map();
    let realContext = contextMap.get($8FY87.createContext);
    if (!realContext) {
        realContext = $8FY87.createContext(null);
        realContext.displayName = "ReactRedux";
        contextMap.set($8FY87.createContext, realContext);
    }
    return realContext;
}
const $45cd0786f8a3356e$export$cc80c08dc91f1c00 = /*#__PURE__*/ $45cd0786f8a3356e$var$getContext();
var $45cd0786f8a3356e$export$2e2bcd8739ae039 = $45cd0786f8a3356e$export$cc80c08dc91f1c00;

});


parcelRegister("eggdA", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $a61f23e09e8a9886$export$20656a4825650bd0; });
const $a61f23e09e8a9886$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("gzuKA", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $c107c49efadef15f$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $c107c49efadef15f$export$2e2bcd8739ae039; });

var $zgVxD = parcelRequire("zgVxD");

var $93aRW = parcelRequire("93aRW");

var $7bVaI = parcelRequire("7bVaI");

var $8FY87 = parcelRequire("8FY87");

var $7mumt = parcelRequire("7mumt");

var $7KG1X = parcelRequire("7KG1X");

var $jT9il = parcelRequire("jT9il");

var $eBTvO = parcelRequire("eBTvO");

var $1pNKX = parcelRequire("1pNKX");

var $9dpOB = parcelRequire("9dpOB");

var $4z0As = parcelRequire("4z0As");

var $9I3Ix = parcelRequire("9I3Ix");

var $6BMn6 = parcelRequire("6BMn6");

var $5Zy0y = parcelRequire("5Zy0y");

var $eggdA = parcelRequire("eggdA");
const $c107c49efadef15f$var$_excluded = [
    "reactReduxForwardedRef"
];
let $c107c49efadef15f$var$useSyncExternalStore = (0, $eggdA.notInitialized);
const $c107c49efadef15f$export$36d45daa6a4925b8 = (fn)=>{
    $c107c49efadef15f$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $c107c49efadef15f$var$EMPTY_ARRAY = [
    null,
    0
];
const $c107c49efadef15f$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $c107c49efadef15f$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $c107c49efadef15f$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $4z0As.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $c107c49efadef15f$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $c107c49efadef15f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $c107c49efadef15f$var$initStateUpdates = ()=>$c107c49efadef15f$var$EMPTY_ARRAY;
function $c107c49efadef15f$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $c107c49efadef15f$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $c107c49efadef15f$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $c107c49efadef15f$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $9I3Ix.default), areStatePropsEqual: areStatePropsEqual = (0, $9I3Ix.default), areMergedPropsEqual: areMergedPropsEqual = (0, $9I3Ix.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $5Zy0y.ReactReduxContext) } = {}) {
    if (pure !== undefined && !$c107c49efadef15f$var$hasWarnedAboutDeprecatedPureOption) {
        $c107c49efadef15f$var$hasWarnedAboutDeprecatedPureOption = true;
        (0, $6BMn6.default)('The `pure` option has been removed. `connect` is now always a "pure/memoized" component');
    }
    const Context = context;
    const initMapStateToProps = (0, $eBTvO.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $jT9il.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $1pNKX.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        if (!(0, $7mumt.isValidElementType)(WrappedComponent)) throw new Error(`You must pass a component to the function returned by connect. Instead received ${$c107c49efadef15f$var$stringifyComponent(WrappedComponent)}`);
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $8FY87.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $93aRW.default)(props, $c107c49efadef15f$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $8FY87.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $7mumt.isContextConsumer)(/*#__PURE__*/ $8FY87.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $8FY87.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            if (!didStoreComeFromProps && !didStoreComeFromContext) throw new Error(`Could not find "store" in the context of ` + `"${displayName}". Either wrap the root component in a <Provider>, ` + `or pass a custom React context provider to <Provider> and the corresponding ` + `React context consumer to ${displayName} in connect options.`);
             // Based on the previous check, one of these must be true
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $8FY87.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $7KG1X.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $8FY87.useMemo(()=>{
                if (!shouldHandleStateChanges) return $c107c49efadef15f$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $9dpOB.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $8FY87.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $zgVxD.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $8FY87.useRef();
            const lastWrapperProps = $8FY87.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $8FY87.useRef();
            const renderIsScheduled = $8FY87.useRef(false);
            const isProcessingDispatch = $8FY87.useRef(false);
            const isMounted = $8FY87.useRef(false);
            const latestSubscriptionCallbackError = $8FY87.useRef();
            (0, $4z0As.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $8FY87.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $8FY87.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $c107c49efadef15f$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c107c49efadef15f$var$useIsomorphicLayoutEffectWithArgs($c107c49efadef15f$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $c107c49efadef15f$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $4z0As.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $8FY87.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $8FY87.createElement(WrappedComponent, (0, $zgVxD.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $8FY87.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $8FY87.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $8FY87.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $8FY87.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $8FY87.createElement(Connect, (0, $zgVxD.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7bVaI)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7bVaI)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c107c49efadef15f$export$2e2bcd8739ae039 = $c107c49efadef15f$var$connect;

});
parcelRegister("zgVxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06a0665dcc321f02$export$2e2bcd8739ae039; });
function $06a0665dcc321f02$export$2e2bcd8739ae039() {
    return $06a0665dcc321f02$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $06a0665dcc321f02$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("93aRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $696cd33f2f0a6e01$export$2e2bcd8739ae039; });
function $696cd33f2f0a6e01$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("7bVaI", function(module, exports) {
"use strict";

var $gvQV5 = parcelRequire("gvQV5");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $53c5e898301e8eb2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $53c5e898301e8eb2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $53c5e898301e8eb2$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $53c5e898301e8eb2$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $53c5e898301e8eb2$var$TYPE_STATICS = {};
$53c5e898301e8eb2$var$TYPE_STATICS[$gvQV5.ForwardRef] = $53c5e898301e8eb2$var$FORWARD_REF_STATICS;
$53c5e898301e8eb2$var$TYPE_STATICS[$gvQV5.Memo] = $53c5e898301e8eb2$var$MEMO_STATICS;
function $53c5e898301e8eb2$var$getStatics(component) {
    // React v16.11 and below
    if ($gvQV5.isMemo(component)) return $53c5e898301e8eb2$var$MEMO_STATICS;
     // React v16.12 and above
    return $53c5e898301e8eb2$var$TYPE_STATICS[component["$$typeof"]] || $53c5e898301e8eb2$var$REACT_STATICS;
}
var $53c5e898301e8eb2$var$defineProperty = Object.defineProperty;
var $53c5e898301e8eb2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $53c5e898301e8eb2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $53c5e898301e8eb2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $53c5e898301e8eb2$var$getPrototypeOf = Object.getPrototypeOf;
var $53c5e898301e8eb2$var$objectPrototype = Object.prototype;
function $53c5e898301e8eb2$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($53c5e898301e8eb2$var$objectPrototype) {
            var inheritedComponent = $53c5e898301e8eb2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $53c5e898301e8eb2$var$objectPrototype) $53c5e898301e8eb2$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $53c5e898301e8eb2$var$getOwnPropertyNames(sourceComponent);
        if ($53c5e898301e8eb2$var$getOwnPropertySymbols) keys = keys.concat($53c5e898301e8eb2$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $53c5e898301e8eb2$var$getStatics(targetComponent);
        var sourceStatics = $53c5e898301e8eb2$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$53c5e898301e8eb2$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $53c5e898301e8eb2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $53c5e898301e8eb2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $53c5e898301e8eb2$var$hoistNonReactStatics;

});
parcelRegister("gvQV5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4V2sF"));

});
parcelRegister("4V2sF", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $394e651848888462$export$2b8d127b894957b9; }, function (v) { return $394e651848888462$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $394e651848888462$export$cea3a54a6425200c; }, function (v) { return $394e651848888462$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $394e651848888462$export$a7c73072b1a182ae; }, function (v) { return $394e651848888462$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $394e651848888462$export$9f27bc3417b4524d; }, function (v) { return $394e651848888462$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $394e651848888462$export$db77ccec0bb4ccac; }, function (v) { return $394e651848888462$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $394e651848888462$export$8392c0c9d3dcbd35; }, function (v) { return $394e651848888462$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $394e651848888462$export$ffb0004e005737fa; }, function (v) { return $394e651848888462$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $394e651848888462$export$b624eff549462981; }, function (v) { return $394e651848888462$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $394e651848888462$export$7897aa7841a5380c; }, function (v) { return $394e651848888462$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $394e651848888462$export$602eac185826482c; }, function (v) { return $394e651848888462$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $394e651848888462$export$e2c29f18771995cb; }, function (v) { return $394e651848888462$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $394e651848888462$export$5f8d39834fd61797; }, function (v) { return $394e651848888462$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $394e651848888462$export$74bf444e3cd11ea5; }, function (v) { return $394e651848888462$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $394e651848888462$export$92387174baf9b227; }, function (v) { return $394e651848888462$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $394e651848888462$export$ec112efeb987d9c6; }, function (v) { return $394e651848888462$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $394e651848888462$export$b706b080d889d2c9; }, function (v) { return $394e651848888462$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $394e651848888462$export$5be5a87408f70ddc; }, function (v) { return $394e651848888462$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $394e651848888462$export$45a5e7f76e0caa8d; }, function (v) { return $394e651848888462$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $394e651848888462$export$455c2e768291efa6; }, function (v) { return $394e651848888462$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $394e651848888462$export$9522e17588c12572; }, function (v) { return $394e651848888462$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $394e651848888462$export$2110ac352bb060b9; }, function (v) { return $394e651848888462$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $394e651848888462$export$56885ab8b9c456ab; }, function (v) { return $394e651848888462$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $394e651848888462$export$d927fcb6adf8f9de; }, function (v) { return $394e651848888462$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $394e651848888462$export$b82d16f27459e05a; }, function (v) { return $394e651848888462$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $394e651848888462$export$522c17b4f5e123e8; }, function (v) { return $394e651848888462$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $394e651848888462$export$1aabd8a0274ecfd6; }, function (v) { return $394e651848888462$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $394e651848888462$export$9b621391a187a31a; }, function (v) { return $394e651848888462$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $394e651848888462$export$f5bbd400c2f4426f; }, function (v) { return $394e651848888462$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $394e651848888462$export$2b8d127b894957b9;
var $394e651848888462$export$cea3a54a6425200c;
var $394e651848888462$export$a7c73072b1a182ae;
var $394e651848888462$export$9f27bc3417b4524d;
var $394e651848888462$export$db77ccec0bb4ccac;
var $394e651848888462$export$8392c0c9d3dcbd35;
var $394e651848888462$export$ffb0004e005737fa;
var $394e651848888462$export$b624eff549462981;
var $394e651848888462$export$7897aa7841a5380c;
var $394e651848888462$export$602eac185826482c;
var $394e651848888462$export$e2c29f18771995cb;
var $394e651848888462$export$5f8d39834fd61797;
var $394e651848888462$export$74bf444e3cd11ea5;
var $394e651848888462$export$92387174baf9b227;
var $394e651848888462$export$ec112efeb987d9c6;
var $394e651848888462$export$b706b080d889d2c9;
var $394e651848888462$export$5be5a87408f70ddc;
var $394e651848888462$export$45a5e7f76e0caa8d;
var $394e651848888462$export$455c2e768291efa6;
var $394e651848888462$export$9522e17588c12572;
var $394e651848888462$export$2110ac352bb060b9;
var $394e651848888462$export$56885ab8b9c456ab;
var $394e651848888462$export$d927fcb6adf8f9de;
var $394e651848888462$export$b82d16f27459e05a;
var $394e651848888462$export$522c17b4f5e123e8;
var $394e651848888462$export$1aabd8a0274ecfd6;
var $394e651848888462$export$9b621391a187a31a;
var $394e651848888462$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $394e651848888462$export$2b8d127b894957b9 = AsyncMode;
    $394e651848888462$export$cea3a54a6425200c = ConcurrentMode;
    $394e651848888462$export$a7c73072b1a182ae = ContextConsumer;
    $394e651848888462$export$9f27bc3417b4524d = ContextProvider;
    $394e651848888462$export$db77ccec0bb4ccac = Element;
    $394e651848888462$export$8392c0c9d3dcbd35 = ForwardRef;
    $394e651848888462$export$ffb0004e005737fa = Fragment;
    $394e651848888462$export$b624eff549462981 = Lazy;
    $394e651848888462$export$7897aa7841a5380c = Memo;
    $394e651848888462$export$602eac185826482c = Portal;
    $394e651848888462$export$e2c29f18771995cb = Profiler;
    $394e651848888462$export$5f8d39834fd61797 = StrictMode;
    $394e651848888462$export$74bf444e3cd11ea5 = Suspense;
    $394e651848888462$export$92387174baf9b227 = isAsyncMode;
    $394e651848888462$export$ec112efeb987d9c6 = isConcurrentMode;
    $394e651848888462$export$b706b080d889d2c9 = isContextConsumer;
    $394e651848888462$export$5be5a87408f70ddc = isContextProvider;
    $394e651848888462$export$45a5e7f76e0caa8d = isElement;
    $394e651848888462$export$455c2e768291efa6 = isForwardRef;
    $394e651848888462$export$9522e17588c12572 = isFragment;
    $394e651848888462$export$2110ac352bb060b9 = isLazy;
    $394e651848888462$export$56885ab8b9c456ab = isMemo;
    $394e651848888462$export$d927fcb6adf8f9de = isPortal;
    $394e651848888462$export$b82d16f27459e05a = isProfiler;
    $394e651848888462$export$522c17b4f5e123e8 = isStrictMode;
    $394e651848888462$export$1aabd8a0274ecfd6 = isSuspense;
    $394e651848888462$export$9b621391a187a31a = isValidElementType;
    $394e651848888462$export$f5bbd400c2f4426f = typeOf;
})();

});



parcelRegister("7mumt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("h4Oko"));

});
parcelRegister("h4Oko", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c6e9d97a37fbe13c$export$a7c73072b1a182ae; }, function (v) { return $c6e9d97a37fbe13c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c6e9d97a37fbe13c$export$9f27bc3417b4524d; }, function (v) { return $c6e9d97a37fbe13c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c6e9d97a37fbe13c$export$db77ccec0bb4ccac; }, function (v) { return $c6e9d97a37fbe13c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c6e9d97a37fbe13c$export$8392c0c9d3dcbd35; }, function (v) { return $c6e9d97a37fbe13c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c6e9d97a37fbe13c$export$ffb0004e005737fa; }, function (v) { return $c6e9d97a37fbe13c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c6e9d97a37fbe13c$export$b624eff549462981; }, function (v) { return $c6e9d97a37fbe13c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c6e9d97a37fbe13c$export$7897aa7841a5380c; }, function (v) { return $c6e9d97a37fbe13c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c6e9d97a37fbe13c$export$602eac185826482c; }, function (v) { return $c6e9d97a37fbe13c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c6e9d97a37fbe13c$export$e2c29f18771995cb; }, function (v) { return $c6e9d97a37fbe13c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c6e9d97a37fbe13c$export$5f8d39834fd61797; }, function (v) { return $c6e9d97a37fbe13c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c6e9d97a37fbe13c$export$74bf444e3cd11ea5; }, function (v) { return $c6e9d97a37fbe13c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $c6e9d97a37fbe13c$export$998bcd577473dd93; }, function (v) { return $c6e9d97a37fbe13c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c6e9d97a37fbe13c$export$92387174baf9b227; }, function (v) { return $c6e9d97a37fbe13c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c6e9d97a37fbe13c$export$ec112efeb987d9c6; }, function (v) { return $c6e9d97a37fbe13c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c6e9d97a37fbe13c$export$b706b080d889d2c9; }, function (v) { return $c6e9d97a37fbe13c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c6e9d97a37fbe13c$export$5be5a87408f70ddc; }, function (v) { return $c6e9d97a37fbe13c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c6e9d97a37fbe13c$export$45a5e7f76e0caa8d; }, function (v) { return $c6e9d97a37fbe13c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c6e9d97a37fbe13c$export$455c2e768291efa6; }, function (v) { return $c6e9d97a37fbe13c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c6e9d97a37fbe13c$export$9522e17588c12572; }, function (v) { return $c6e9d97a37fbe13c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c6e9d97a37fbe13c$export$2110ac352bb060b9; }, function (v) { return $c6e9d97a37fbe13c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c6e9d97a37fbe13c$export$56885ab8b9c456ab; }, function (v) { return $c6e9d97a37fbe13c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c6e9d97a37fbe13c$export$d927fcb6adf8f9de; }, function (v) { return $c6e9d97a37fbe13c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c6e9d97a37fbe13c$export$b82d16f27459e05a; }, function (v) { return $c6e9d97a37fbe13c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c6e9d97a37fbe13c$export$522c17b4f5e123e8; }, function (v) { return $c6e9d97a37fbe13c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c6e9d97a37fbe13c$export$1aabd8a0274ecfd6; }, function (v) { return $c6e9d97a37fbe13c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $c6e9d97a37fbe13c$export$3d6c20d97e46b957; }, function (v) { return $c6e9d97a37fbe13c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c6e9d97a37fbe13c$export$9b621391a187a31a; }, function (v) { return $c6e9d97a37fbe13c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c6e9d97a37fbe13c$export$f5bbd400c2f4426f; }, function (v) { return $c6e9d97a37fbe13c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c6e9d97a37fbe13c$export$a7c73072b1a182ae;
var $c6e9d97a37fbe13c$export$9f27bc3417b4524d;
var $c6e9d97a37fbe13c$export$db77ccec0bb4ccac;
var $c6e9d97a37fbe13c$export$8392c0c9d3dcbd35;
var $c6e9d97a37fbe13c$export$ffb0004e005737fa;
var $c6e9d97a37fbe13c$export$b624eff549462981;
var $c6e9d97a37fbe13c$export$7897aa7841a5380c;
var $c6e9d97a37fbe13c$export$602eac185826482c;
var $c6e9d97a37fbe13c$export$e2c29f18771995cb;
var $c6e9d97a37fbe13c$export$5f8d39834fd61797;
var $c6e9d97a37fbe13c$export$74bf444e3cd11ea5;
var $c6e9d97a37fbe13c$export$998bcd577473dd93;
var $c6e9d97a37fbe13c$export$92387174baf9b227;
var $c6e9d97a37fbe13c$export$ec112efeb987d9c6;
var $c6e9d97a37fbe13c$export$b706b080d889d2c9;
var $c6e9d97a37fbe13c$export$5be5a87408f70ddc;
var $c6e9d97a37fbe13c$export$45a5e7f76e0caa8d;
var $c6e9d97a37fbe13c$export$455c2e768291efa6;
var $c6e9d97a37fbe13c$export$9522e17588c12572;
var $c6e9d97a37fbe13c$export$2110ac352bb060b9;
var $c6e9d97a37fbe13c$export$56885ab8b9c456ab;
var $c6e9d97a37fbe13c$export$d927fcb6adf8f9de;
var $c6e9d97a37fbe13c$export$b82d16f27459e05a;
var $c6e9d97a37fbe13c$export$522c17b4f5e123e8;
var $c6e9d97a37fbe13c$export$1aabd8a0274ecfd6;
var $c6e9d97a37fbe13c$export$3d6c20d97e46b957;
var $c6e9d97a37fbe13c$export$9b621391a187a31a;
var $c6e9d97a37fbe13c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $c6e9d97a37fbe13c$export$a7c73072b1a182ae = ContextConsumer;
    $c6e9d97a37fbe13c$export$9f27bc3417b4524d = ContextProvider;
    $c6e9d97a37fbe13c$export$db77ccec0bb4ccac = Element;
    $c6e9d97a37fbe13c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c6e9d97a37fbe13c$export$ffb0004e005737fa = Fragment;
    $c6e9d97a37fbe13c$export$b624eff549462981 = Lazy;
    $c6e9d97a37fbe13c$export$7897aa7841a5380c = Memo;
    $c6e9d97a37fbe13c$export$602eac185826482c = Portal;
    $c6e9d97a37fbe13c$export$e2c29f18771995cb = Profiler;
    $c6e9d97a37fbe13c$export$5f8d39834fd61797 = StrictMode;
    $c6e9d97a37fbe13c$export$74bf444e3cd11ea5 = Suspense;
    $c6e9d97a37fbe13c$export$998bcd577473dd93 = SuspenseList;
    $c6e9d97a37fbe13c$export$92387174baf9b227 = isAsyncMode;
    $c6e9d97a37fbe13c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c6e9d97a37fbe13c$export$b706b080d889d2c9 = isContextConsumer;
    $c6e9d97a37fbe13c$export$5be5a87408f70ddc = isContextProvider;
    $c6e9d97a37fbe13c$export$45a5e7f76e0caa8d = isElement;
    $c6e9d97a37fbe13c$export$455c2e768291efa6 = isForwardRef;
    $c6e9d97a37fbe13c$export$9522e17588c12572 = isFragment;
    $c6e9d97a37fbe13c$export$2110ac352bb060b9 = isLazy;
    $c6e9d97a37fbe13c$export$56885ab8b9c456ab = isMemo;
    $c6e9d97a37fbe13c$export$d927fcb6adf8f9de = isPortal;
    $c6e9d97a37fbe13c$export$b82d16f27459e05a = isProfiler;
    $c6e9d97a37fbe13c$export$522c17b4f5e123e8 = isStrictMode;
    $c6e9d97a37fbe13c$export$1aabd8a0274ecfd6 = isSuspense;
    $c6e9d97a37fbe13c$export$3d6c20d97e46b957 = isSuspenseList;
    $c6e9d97a37fbe13c$export$9b621391a187a31a = isValidElementType;
    $c6e9d97a37fbe13c$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("7KG1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a4d6eab25d6d939$export$2e2bcd8739ae039; });

var $93aRW = parcelRequire("93aRW");

var $3yems = parcelRequire("3yems");
const $5a4d6eab25d6d939$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $5a4d6eab25d6d939$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $5a4d6eab25d6d939$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $93aRW.default)(_ref, $5a4d6eab25d6d939$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    (0, $3yems.default)(mapStateToProps, mapDispatchToProps, mergeProps);
    return $5a4d6eab25d6d939$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("3yems", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $295fafeabfa981ac$export$2e2bcd8739ae039; });

var $6BMn6 = parcelRequire("6BMn6");
function $295fafeabfa981ac$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $6BMn6.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $295fafeabfa981ac$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $295fafeabfa981ac$var$verify(mapStateToProps, "mapStateToProps");
    $295fafeabfa981ac$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $295fafeabfa981ac$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("6BMn6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cfbb86502e85a77$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $4cfbb86502e85a77$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("jT9il", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $e7aa5d25488940ed$export$b69a785ceac019a6; });

var $5XmnW = parcelRequire("5XmnW");

var $6xehd = parcelRequire("6xehd");

var $5XLKr = parcelRequire("5XLKr");
function $e7aa5d25488940ed$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $6xehd.wrapMapToPropsConstant)((dispatch)=>(0, $5XmnW.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $6xehd.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $6xehd.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $5XLKr.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("5XmnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4563d3a4638dad58$export$2e2bcd8739ae039; });
function $4563d3a4638dad58$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("6xehd", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $4c20e62b4a0a1595$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $4c20e62b4a0a1595$export$8d46c7f53c8c602f; });

var $21Qdw = parcelRequire("21Qdw");
function $4c20e62b4a0a1595$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $4c20e62b4a0a1595$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $4c20e62b4a0a1595$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $4c20e62b4a0a1595$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $4c20e62b4a0a1595$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            (0, $21Qdw.default)(props, displayName, methodName);
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("21Qdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a42dfc0fe67e74$export$2e2bcd8739ae039; });

var $3I7JL = parcelRequire("3I7JL");

var $6BMn6 = parcelRequire("6BMn6");
function $17a42dfc0fe67e74$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $3I7JL.default)(value)) (0, $6BMn6.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("3I7JL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b3b7b9881141950$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $2b3b7b9881141950$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("5XLKr", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $4577803b7ee2853d$export$19ef7b929f7e2559; });
function $4577803b7ee2853d$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("eBTvO", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $aa2f94ec0bd4e4fa$export$e00e93951827eda7; });

var $6xehd = parcelRequire("6xehd");

var $5XLKr = parcelRequire("5XLKr");
function $aa2f94ec0bd4e4fa$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $6xehd.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $6xehd.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $5XLKr.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("1pNKX", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $107eb8d87989c849$export$17457cf6fa742f84; });

var $zgVxD = parcelRequire("zgVxD");

var $21Qdw = parcelRequire("21Qdw");

var $5XLKr = parcelRequire("5XLKr");
function $107eb8d87989c849$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $zgVxD.default)({}, ownProps, stateProps, dispatchProps);
}
function $107eb8d87989c849$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
                (0, $21Qdw.default)(mergedProps, displayName, "mergeProps");
            }
            return mergedProps;
        };
    };
}
function $107eb8d87989c849$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$107eb8d87989c849$export$691c327fc30bc857 : typeof mergeProps === "function" ? $107eb8d87989c849$export$5b105939c84b5234(mergeProps) : (0, $5XLKr.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("9dpOB", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $6b595a520f16d044$export$d567d2b9af322f8f; });

var $j4QCj = parcelRequire("j4QCj");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $6b595a520f16d044$var$createListenerCollection() {
    const batch = (0, $j4QCj.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $6b595a520f16d044$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $6b595a520f16d044$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $6b595a520f16d044$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $6b595a520f16d044$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $6b595a520f16d044$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("4z0As", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $352ae2e70ed661ed$export$700979bc83e7db82; });

var $8FY87 = parcelRequire("8FY87");
const $352ae2e70ed661ed$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $352ae2e70ed661ed$export$700979bc83e7db82 = $352ae2e70ed661ed$export$71594e8a50f746f4 ? $8FY87.useLayoutEffect : $8FY87.useEffect;

});

parcelRegister("9I3Ix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $711b1b4ccad7a564$export$2e2bcd8739ae039; });
function $711b1b4ccad7a564$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $711b1b4ccad7a564$export$2e2bcd8739ae039(objA, objB) {
    if ($711b1b4ccad7a564$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$711b1b4ccad7a564$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("h6R5A", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("dRnhz")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("gzuKA")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7TfqD")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("6cnQI")).useSelector; });

var $dRnhz = parcelRequire("dRnhz");

var $gzuKA = parcelRequire("gzuKA");

var $5Zy0y = parcelRequire("5Zy0y");

var $7TfqD = parcelRequire("7TfqD");

var $6cnQI = parcelRequire("6cnQI");

var $ahAnB = parcelRequire("ahAnB");

var $9I3Ix = parcelRequire("9I3Ix");
parcelRequire("3sGaX");

});
parcelRegister("dRnhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17248fe07c27767$export$2e2bcd8739ae039; });

var $8FY87 = parcelRequire("8FY87");

var $5Zy0y = parcelRequire("5Zy0y");

var $9dpOB = parcelRequire("9dpOB");

var $4z0As = parcelRequire("4z0As");
function $a17248fe07c27767$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $8FY87.useMemo(()=>{
        const subscription = (0, $9dpOB.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $8FY87.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $4z0As.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $5Zy0y.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $8FY87.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $a17248fe07c27767$export$2e2bcd8739ae039 = $a17248fe07c27767$var$Provider;

});

parcelRegister("7TfqD", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $5be9a33e43d93d94$export$8ad76b76a4c905f8; });

var $5Zy0y = parcelRequire("5Zy0y");

var $ahAnB = parcelRequire("ahAnB");
function $5be9a33e43d93d94$export$bc9b55530897c558(context = (0, $5Zy0y.ReactReduxContext)) {
    const useStore = context === (0, $5Zy0y.ReactReduxContext) ? (0, $ahAnB.useStore) : (0, $ahAnB.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $5be9a33e43d93d94$export$8ad76b76a4c905f8 = /*#__PURE__*/ $5be9a33e43d93d94$export$bc9b55530897c558();

});
parcelRegister("ahAnB", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $77c7b62af1902c85$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $77c7b62af1902c85$export$6ccbb43953eebf8; });

var $5Zy0y = parcelRequire("5Zy0y");

var $53PpI = parcelRequire("53PpI");
function $77c7b62af1902c85$export$671dba69185d0304(context = (0, $5Zy0y.ReactReduxContext)) {
    const useReduxContext = context === (0, $5Zy0y.ReactReduxContext) ? (0, $53PpI.useReduxContext) : (0, $53PpI.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $77c7b62af1902c85$export$6ccbb43953eebf8 = /*#__PURE__*/ $77c7b62af1902c85$export$671dba69185d0304();

});


parcelRegister("3sGaX", function(module, exports) {

});



parcelRegister("jvvee", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $e33922eaa37ad762$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSlice", function () { return $e33922eaa37ad762$export$4d8d9bd83c24ae8b; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $e33922eaa37ad762$export$6abd22dc03e5063f; });

var $f5gFb = parcelRequire("f5gFb");

var $7JEQD = parcelRequire("7JEQD");

var $4Ulme = parcelRequire("4Ulme");

var $2fDyW = parcelRequire("2fDyW");

var $8dWjV = parcelRequire("8dWjV");
var $e33922eaa37ad762$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e33922eaa37ad762$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $e33922eaa37ad762$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $e33922eaa37ad762$var$__defProp = Object.defineProperty;
var $e33922eaa37ad762$var$__defProps = Object.defineProperties;
var $e33922eaa37ad762$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e33922eaa37ad762$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e33922eaa37ad762$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e33922eaa37ad762$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e33922eaa37ad762$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $e33922eaa37ad762$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $e33922eaa37ad762$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($e33922eaa37ad762$var$__hasOwnProp.call(b, prop)) $e33922eaa37ad762$var$__defNormalProp(a, prop, b[prop]);
    if ($e33922eaa37ad762$var$__getOwnPropSymbols) for(var _i = 0, _c = $e33922eaa37ad762$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($e33922eaa37ad762$var$__propIsEnum.call(b, prop)) $e33922eaa37ad762$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e33922eaa37ad762$var$__spreadProps = function(a, b) {
    return $e33922eaa37ad762$var$__defProps(a, $e33922eaa37ad762$var$__getOwnPropDescs(b));
};
var $e33922eaa37ad762$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $e33922eaa37ad762$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $4Ulme.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $e33922eaa37ad762$var$__spreadArray([
            (0, $f5gFb.isDraft)(value) ? (0, $f5gFb.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $e33922eaa37ad762$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $7JEQD.compose;
    return (0, $7JEQD.compose).apply(null, arguments);
};
var $e33922eaa37ad762$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $e33922eaa37ad762$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $e33922eaa37ad762$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $e33922eaa37ad762$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $e33922eaa37ad762$var$__spreadValues($e33922eaa37ad762$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $e33922eaa37ad762$export$b956e38827fca970(action) {
    return $e33922eaa37ad762$export$53b83ca8eaab0383(action) && "type" in action;
}
function $e33922eaa37ad762$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $e33922eaa37ad762$var$hasMatchFunction(action);
}
function $e33922eaa37ad762$export$ebd532f9034651f3(action) {
    return $e33922eaa37ad762$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($e33922eaa37ad762$var$isValidKey);
}
function $e33922eaa37ad762$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $e33922eaa37ad762$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $e33922eaa37ad762$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $e33922eaa37ad762$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c = options.isActionCreator, isActionCreator2 = _c === void 0 ? $e33922eaa37ad762$export$4e5cad2c7f795b8f : _c;
    return function() {
        return function(next) {
            return function(action) {
                if (isActionCreator2(action)) console.warn($e33922eaa37ad762$var$getMessage(action.type));
                return next(action);
            };
        };
    };
}
function $e33922eaa37ad762$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $e33922eaa37ad762$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $e33922eaa37ad762$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $e33922eaa37ad762$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $e33922eaa37ad762$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $e33922eaa37ad762$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $e33922eaa37ad762$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $e33922eaa37ad762$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $e33922eaa37ad762$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $e33922eaa37ad762$var$freezeDraftable(val) {
    return (0, $f5gFb.isDraftable)(val) ? (0, $f5gFb.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $e33922eaa37ad762$var$isProduction = false;
var $e33922eaa37ad762$var$prefix = "Invariant failed";
function $e33922eaa37ad762$var$invariant(condition, message) {
    if (condition) return;
    if ($e33922eaa37ad762$var$isProduction) throw new Error($e33922eaa37ad762$var$prefix);
    throw new Error($e33922eaa37ad762$var$prefix + ": " + (message || ""));
}
function $e33922eaa37ad762$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $e33922eaa37ad762$var$getSerialize(serializer, decycler), indent);
}
function $e33922eaa37ad762$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $e33922eaa37ad762$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $e33922eaa37ad762$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $e33922eaa37ad762$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $e33922eaa37ad762$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $e33922eaa37ad762$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $e33922eaa37ad762$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $e33922eaa37ad762$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $e33922eaa37ad762$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $e33922eaa37ad762$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c = options.isImmutable, isImmutable = _c === void 0 ? $e33922eaa37ad762$export$9021b2733a0028a3 : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = $e33922eaa37ad762$var$trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function(_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function(next) {
            return function(action) {
                var measureUtils = $e33922eaa37ad762$var$getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
                measureUtils.measureTime(function() {
                    state = getState();
                    result = tracker.detectMutations();
                    tracker = track(state);
                    $e33922eaa37ad762$var$invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
                });
                var dispatchedAction = next(action);
                measureUtils.measureTime(function() {
                    state = getState();
                    result = tracker.detectMutations();
                    tracker = track(state);
                    result.wasMutated && $e33922eaa37ad762$var$invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + $e33922eaa37ad762$var$stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
                });
                measureUtils.warnIfExceeded();
                return dispatchedAction;
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $e33922eaa37ad762$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $e33922eaa37ad762$export$53b83ca8eaab0383(val);
}
function $e33922eaa37ad762$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $e33922eaa37ad762$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $e33922eaa37ad762$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $e33922eaa37ad762$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $e33922eaa37ad762$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$e33922eaa37ad762$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $e33922eaa37ad762$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c = options.isSerializable, isSerializable = _c === void 0 ? $e33922eaa37ad762$export$77670485918dab4e : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? [
        "meta.arg",
        "meta.baseQueryMeta"
    ] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function(storeAPI) {
        return function(next) {
            return function(action) {
                var result = next(action);
                var measureUtils = $e33922eaa37ad762$var$getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
                if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) measureUtils.measureTime(function() {
                    var foundActionNonSerializableValue = $e33922eaa37ad762$export$ada5dca0b571bc7(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                    if (foundActionNonSerializableValue) {
                        var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                        console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                    }
                });
                if (!ignoreState) {
                    measureUtils.measureTime(function() {
                        var state = storeAPI.getState();
                        var foundStateNonSerializableValue = $e33922eaa37ad762$export$ada5dca0b571bc7(state, "", isSerializable, getEntries, ignoredPaths, cache);
                        if (foundStateNonSerializableValue) {
                            var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                            console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                        }
                    });
                    measureUtils.warnIfExceeded();
                }
                return result;
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $e33922eaa37ad762$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $e33922eaa37ad762$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $e33922eaa37ad762$export$36c1185aeee5b0a6(options);
    };
}
function $e33922eaa37ad762$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $e33922eaa37ad762$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($e33922eaa37ad762$var$isBoolean(thunk)) middlewareArray.push((0, $2fDyW.default));
        else middlewareArray.push((0, $2fDyW.default).withExtraArgument(thunk.extraArgument));
    }
    if (immutableCheck) {
        var immutableOptions = {};
        if (!$e33922eaa37ad762$var$isBoolean(immutableCheck)) immutableOptions = immutableCheck;
        middlewareArray.unshift($e33922eaa37ad762$export$9181bb1a5474289(immutableOptions));
    }
    if (serializableCheck) {
        var serializableOptions = {};
        if (!$e33922eaa37ad762$var$isBoolean(serializableCheck)) serializableOptions = serializableCheck;
        middlewareArray.push($e33922eaa37ad762$export$6dea1aad6dac5ac2(serializableOptions));
    }
    if (actionCreatorCheck) {
        var actionCreatorOptions = {};
        if (!$e33922eaa37ad762$var$isBoolean(actionCreatorCheck)) actionCreatorOptions = actionCreatorCheck;
        middlewareArray.unshift($e33922eaa37ad762$export$6a1fcb4ceef578f(actionCreatorOptions));
    }
    return middlewareArray;
}
// src/configureStore.ts
var $e33922eaa37ad762$var$IS_PRODUCTION = false;
function $e33922eaa37ad762$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $e33922eaa37ad762$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($e33922eaa37ad762$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $7JEQD.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$e33922eaa37ad762$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$e33922eaa37ad762$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $7JEQD.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $7JEQD.compose);
    if (devTools) finalCompose = $e33922eaa37ad762$var$composeWithDevTools($e33922eaa37ad762$var$__spreadValues({
        trace: !$e33922eaa37ad762$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $e33922eaa37ad762$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $e33922eaa37ad762$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $7JEQD.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $e33922eaa37ad762$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            if (actionMatchers.length > 0) throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
            if (defaultCaseReducer) throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            if (defaultCaseReducer) throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            if (defaultCaseReducer) throw new Error("`builder.addDefaultCase` can only be called once");
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $e33922eaa37ad762$var$isStateFunction(x) {
    return typeof x === "function";
}
var $e33922eaa37ad762$var$hasWarnedAboutObjectNotation = false;
function $e33922eaa37ad762$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    if (typeof mapOrBuilderCallback === "object") {
        if (!$e33922eaa37ad762$var$hasWarnedAboutObjectNotation) {
            $e33922eaa37ad762$var$hasWarnedAboutObjectNotation = true;
            console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
        }
    }
    var _c = typeof mapOrBuilderCallback === "function" ? $e33922eaa37ad762$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($e33922eaa37ad762$var$isStateFunction(initialState)) getInitialState = function() {
        return $e33922eaa37ad762$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $e33922eaa37ad762$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $e33922eaa37ad762$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $f5gFb.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $f5gFb.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $f5gFb.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $e33922eaa37ad762$var$hasWarnedAboutObjectNotation2 = false;
function $e33922eaa37ad762$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $e33922eaa37ad762$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $8dWjV;
    var initialState = typeof options.initialState == "function" ? options.initialState : $e33922eaa37ad762$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $e33922eaa37ad762$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $e33922eaa37ad762$export$309c7a02b0b0bc62(type, prepareCallback) : $e33922eaa37ad762$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        if (typeof options.extraReducers === "object") {
            if (!$e33922eaa37ad762$var$hasWarnedAboutObjectNotation2) {
                $e33922eaa37ad762$var$hasWarnedAboutObjectNotation2 = true;
                console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
            }
        }
        var _c = typeof options.extraReducers === "function" ? $e33922eaa37ad762$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $e33922eaa37ad762$var$__spreadValues($e33922eaa37ad762$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $e33922eaa37ad762$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $e33922eaa37ad762$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $e33922eaa37ad762$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($e33922eaa37ad762$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $e33922eaa37ad762$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $e33922eaa37ad762$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $e33922eaa37ad762$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $e33922eaa37ad762$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $e33922eaa37ad762$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $e33922eaa37ad762$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $e33922eaa37ad762$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $e33922eaa37ad762$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $e33922eaa37ad762$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $e33922eaa37ad762$var$createSingleArgumentStateOperator(mutator) {
    var operator = $e33922eaa37ad762$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $e33922eaa37ad762$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $e33922eaa37ad762$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $f5gFb.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $f5gFb.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $e33922eaa37ad762$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (key === void 0) console.warn("The entity passed to the `selectId` implementation returned undefined.", "You should probably provide your own `selectId` implementation.", "The entity that was passed:", entity, "The `selectId` implementation:", selectId.toString());
    return key;
}
function $e33922eaa37ad762$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $e33922eaa37ad762$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $e33922eaa37ad762$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $e33922eaa37ad762$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $e33922eaa37ad762$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $e33922eaa37ad762$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $e33922eaa37ad762$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $e33922eaa37ad762$var$__spreadValues($e33922eaa37ad762$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $e33922eaa37ad762$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $e33922eaa37ad762$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $e33922eaa37ad762$var$createStateOperator(addOneMutably),
        addMany: $e33922eaa37ad762$var$createStateOperator(addManyMutably),
        setOne: $e33922eaa37ad762$var$createStateOperator(setOneMutably),
        setMany: $e33922eaa37ad762$var$createStateOperator(setManyMutably),
        setAll: $e33922eaa37ad762$var$createStateOperator(setAllMutably),
        updateOne: $e33922eaa37ad762$var$createStateOperator(updateOneMutably),
        updateMany: $e33922eaa37ad762$var$createStateOperator(updateManyMutably),
        upsertOne: $e33922eaa37ad762$var$createStateOperator(upsertOneMutably),
        upsertMany: $e33922eaa37ad762$var$createStateOperator(upsertManyMutably),
        removeOne: $e33922eaa37ad762$var$createStateOperator(removeOneMutably),
        removeMany: $e33922eaa37ad762$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $e33922eaa37ad762$var$createSortedStateAdapter(selectId, sort) {
    var _c = $e33922eaa37ad762$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($e33922eaa37ad762$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $e33922eaa37ad762$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $e33922eaa37ad762$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $e33922eaa37ad762$var$createStateOperator(addOneMutably),
        updateOne: $e33922eaa37ad762$var$createStateOperator(updateOneMutably),
        upsertOne: $e33922eaa37ad762$var$createStateOperator(upsertOneMutably),
        setOne: $e33922eaa37ad762$var$createStateOperator(setOneMutably),
        setMany: $e33922eaa37ad762$var$createStateOperator(setManyMutably),
        setAll: $e33922eaa37ad762$var$createStateOperator(setAllMutably),
        addMany: $e33922eaa37ad762$var$createStateOperator(addManyMutably),
        updateMany: $e33922eaa37ad762$var$createStateOperator(updateManyMutably),
        upsertMany: $e33922eaa37ad762$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $e33922eaa37ad762$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $e33922eaa37ad762$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $e33922eaa37ad762$var$createInitialStateFactory();
    var selectorsFactory = $e33922eaa37ad762$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $e33922eaa37ad762$var$createSortedStateAdapter(selectId, sortComparer) : $e33922eaa37ad762$var$createUnsortedStateAdapter(selectId);
    return $e33922eaa37ad762$var$__spreadValues($e33922eaa37ad762$var$__spreadValues($e33922eaa37ad762$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $e33922eaa37ad762$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $e33922eaa37ad762$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $e33922eaa37ad762$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $e33922eaa37ad762$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $e33922eaa37ad762$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $e33922eaa37ad762$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $e33922eaa37ad762$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $e33922eaa37ad762$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $e33922eaa37ad762$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $e33922eaa37ad762$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $e33922eaa37ad762$var$__spreadProps($e33922eaa37ad762$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $e33922eaa37ad762$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $e33922eaa37ad762$var$__spreadProps($e33922eaa37ad762$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $e33922eaa37ad762$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $e33922eaa37ad762$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $e33922eaa37ad762$var$__spreadProps($e33922eaa37ad762$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {
                if (!displayedWarning) {
                    displayedWarning = true;
                    console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.");
                }
            };
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $e33922eaa37ad762$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $e33922eaa37ad762$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $e33922eaa37ad762$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$e33922eaa37ad762$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $e33922eaa37ad762$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $e33922eaa37ad762$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $e33922eaa37ad762$var$RejectWithValue) throw result;
                                                if (result instanceof $e33922eaa37ad762$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $e33922eaa37ad762$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($e33922eaa37ad762$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $e33922eaa37ad762$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $e33922eaa37ad762$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $e33922eaa37ad762$var$matches = function(matcher, action) {
    if ($e33922eaa37ad762$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $e33922eaa37ad762$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $e33922eaa37ad762$var$matches(matcher, action);
        });
    };
}
function $e33922eaa37ad762$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $e33922eaa37ad762$var$matches(matcher, action);
        });
    };
}
function $e33922eaa37ad762$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $e33922eaa37ad762$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $e33922eaa37ad762$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $e33922eaa37ad762$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$e33922eaa37ad762$var$isAsyncThunkArray(asyncThunks)) return $e33922eaa37ad762$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $e33922eaa37ad762$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $e33922eaa37ad762$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $e33922eaa37ad762$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$e33922eaa37ad762$var$isAsyncThunkArray(asyncThunks)) return $e33922eaa37ad762$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $e33922eaa37ad762$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $e33922eaa37ad762$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $e33922eaa37ad762$export$9dd1fb32974da385($e33922eaa37ad762$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$e33922eaa37ad762$var$isAsyncThunkArray(asyncThunks)) return $e33922eaa37ad762$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $e33922eaa37ad762$export$9dd1fb32974da385($e33922eaa37ad762$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $e33922eaa37ad762$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $e33922eaa37ad762$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$e33922eaa37ad762$var$isAsyncThunkArray(asyncThunks)) return $e33922eaa37ad762$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $e33922eaa37ad762$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $e33922eaa37ad762$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $e33922eaa37ad762$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$e33922eaa37ad762$var$isAsyncThunkArray(asyncThunks)) return $e33922eaa37ad762$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $e33922eaa37ad762$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $e33922eaa37ad762$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $e33922eaa37ad762$var$noop = function() {};
var $e33922eaa37ad762$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $e33922eaa37ad762$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $e33922eaa37ad762$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $e33922eaa37ad762$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $e33922eaa37ad762$var$task = "task";
var $e33922eaa37ad762$var$listener = "listener";
var $e33922eaa37ad762$var$completed = "completed";
var $e33922eaa37ad762$var$cancelled = "cancelled";
var $e33922eaa37ad762$var$taskCancelled = "task-" + $e33922eaa37ad762$var$cancelled;
var $e33922eaa37ad762$var$taskCompleted = "task-" + $e33922eaa37ad762$var$completed;
var $e33922eaa37ad762$var$listenerCancelled = $e33922eaa37ad762$var$listener + "-" + $e33922eaa37ad762$var$cancelled;
var $e33922eaa37ad762$var$listenerCompleted = $e33922eaa37ad762$var$listener + "-" + $e33922eaa37ad762$var$completed;
var $e33922eaa37ad762$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $e33922eaa37ad762$var$task + " " + $e33922eaa37ad762$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $e33922eaa37ad762$var$validateActive = function(signal) {
    if (signal.aborted) throw new $e33922eaa37ad762$export$cb1bdac908fed7f(signal.reason);
};
function $e33922eaa37ad762$var$raceWithSignal(signal, promise2) {
    var cleanup = $e33922eaa37ad762$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $e33922eaa37ad762$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $e33922eaa37ad762$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $e33922eaa37ad762$var$noop;
    });
}
var $e33922eaa37ad762$var$runTask = function(task2, cleanUp) {
    return $e33922eaa37ad762$var$__async(void 0, null, function() {
        var value, error_1;
        return $e33922eaa37ad762$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $e33922eaa37ad762$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $e33922eaa37ad762$var$createPause = function(signal) {
    return function(promise2) {
        return $e33922eaa37ad762$var$catchRejection($e33922eaa37ad762$var$raceWithSignal(signal, promise2).then(function(output) {
            $e33922eaa37ad762$var$validateActive(signal);
            return output;
        }));
    };
};
var $e33922eaa37ad762$var$createDelay = function(signal) {
    var pause = $e33922eaa37ad762$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $e33922eaa37ad762$var$assign = Object.assign;
var $e33922eaa37ad762$var$INTERNAL_NIL_TOKEN = {};
var $e33922eaa37ad762$var$alm = "listenerMiddleware";
var $e33922eaa37ad762$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $e33922eaa37ad762$var$addAbortSignalListener(parentAbortSignal, function() {
            return $e33922eaa37ad762$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $e33922eaa37ad762$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $e33922eaa37ad762$var$runTask(function() {
            return $e33922eaa37ad762$var$__async(void 0, null, function() {
                var result2;
                return $e33922eaa37ad762$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $e33922eaa37ad762$var$validateActive(parentAbortSignal);
                            $e33922eaa37ad762$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $e33922eaa37ad762$var$createPause(childAbortController.signal),
                                    delay: $e33922eaa37ad762$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $e33922eaa37ad762$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $e33922eaa37ad762$var$abortControllerWithReason(childAbortController, $e33922eaa37ad762$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $e33922eaa37ad762$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $e33922eaa37ad762$var$abortControllerWithReason(childAbortController, $e33922eaa37ad762$var$taskCancelled);
            }
        };
    };
};
var $e33922eaa37ad762$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $e33922eaa37ad762$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $e33922eaa37ad762$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $e33922eaa37ad762$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $e33922eaa37ad762$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $e33922eaa37ad762$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $e33922eaa37ad762$var$catchRejection(take(predicate, timeout));
    };
};
var $e33922eaa37ad762$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $e33922eaa37ad762$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $e33922eaa37ad762$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $e33922eaa37ad762$var$createListenerEntry = function(options) {
    var _c = $e33922eaa37ad762$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $e33922eaa37ad762$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $e33922eaa37ad762$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $e33922eaa37ad762$var$abortControllerWithReason(controller, $e33922eaa37ad762$var$listenerCancelled);
    });
};
var $e33922eaa37ad762$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($e33922eaa37ad762$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $e33922eaa37ad762$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $e33922eaa37ad762$export$f03a6b845d3fb58b = $e33922eaa37ad762$export$309c7a02b0b0bc62($e33922eaa37ad762$var$alm + "/add");
var $e33922eaa37ad762$export$b1b8022855fb2b71 = $e33922eaa37ad762$export$309c7a02b0b0bc62($e33922eaa37ad762$var$alm + "/removeAll");
var $e33922eaa37ad762$export$b03e9483f936dccb = $e33922eaa37ad762$export$309c7a02b0b0bc62($e33922eaa37ad762$var$alm + "/remove");
var $e33922eaa37ad762$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $e33922eaa37ad762$var$__spreadArray([
        $e33922eaa37ad762$var$alm + "/error"
    ], args));
};
function $e33922eaa37ad762$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $e33922eaa37ad762$var$defaultErrorHandler : _c;
    $e33922eaa37ad762$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $e33922eaa37ad762$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $e33922eaa37ad762$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $e33922eaa37ad762$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $e33922eaa37ad762$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $e33922eaa37ad762$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $e33922eaa37ad762$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $e33922eaa37ad762$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $e33922eaa37ad762$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $e33922eaa37ad762$var$createDelay(internalTaskController.signal),
                                pause: $e33922eaa37ad762$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $e33922eaa37ad762$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $e33922eaa37ad762$var$abortControllerWithReason(controller, $e33922eaa37ad762$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $e33922eaa37ad762$export$cb1bdac908fed7f)) $e33922eaa37ad762$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $e33922eaa37ad762$var$abortControllerWithReason(internalTaskController, $e33922eaa37ad762$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $e33922eaa37ad762$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$e33922eaa37ad762$export$b956e38827fca970(action)) return next(action);
                if ($e33922eaa37ad762$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($e33922eaa37ad762$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($e33922eaa37ad762$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $e33922eaa37ad762$var$INTERNAL_NIL_TOKEN) throw new Error($e33922eaa37ad762$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $e33922eaa37ad762$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $e33922eaa37ad762$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $e33922eaa37ad762$export$8fb31c0f05df007b = "RTK_autoBatch";
var $e33922eaa37ad762$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$e33922eaa37ad762$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $e33922eaa37ad762$var$promise;
var $e33922eaa37ad762$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($e33922eaa37ad762$var$promise || ($e33922eaa37ad762$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $e33922eaa37ad762$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $e33922eaa37ad762$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $e33922eaa37ad762$var$createQueueWithTimer(10);
var $e33922eaa37ad762$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $e33922eaa37ad762$var$queueMicrotaskShim : options.type === "raf" ? $e33922eaa37ad762$var$rAF : options.type === "callback" ? options.queueNotification : $e33922eaa37ad762$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$e33922eaa37ad762$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $f5gFb.enableES5)();

});
parcelRegister("f5gFb", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $afb43fa4b8d79016$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i = Y[n], o = i ? "function" == typeof i ? i.apply(null, t) : i : "unknown error nr: " + n;
    throw Error("[Immer] " + o);
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U || n(0), U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (c === o && n(5), r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return f(r), en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                f(t), en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return isNaN(parseInt(t)) && n(13), on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return "length" !== t && isNaN(parseInt(t)) && n(14), en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        e && e.C || n(9), e.I && n(10);
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $afb43fa4b8d79016$export$2e2bcd8739ae039 = fn;

});

parcelRegister("7JEQD", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $5a1c6be634076347$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $5a1c6be634076347$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $5a1c6be634076347$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $5a1c6be634076347$export$9ff26e0402cc7b7; });

var $q31I7 = parcelRequire("q31I7");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $5a1c6be634076347$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $5a1c6be634076347$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $5a1c6be634076347$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $5a1c6be634076347$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $5a1c6be634076347$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $5a1c6be634076347$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $5a1c6be634076347$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $5a1c6be634076347$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $5a1c6be634076347$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($5a1c6be634076347$var$isDate(val)) return "date";
    if ($5a1c6be634076347$var$isError(val)) return "error";
    var constructorName = $5a1c6be634076347$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $5a1c6be634076347$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $5a1c6be634076347$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $5a1c6be634076347$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $5a1c6be634076347$var$kindOf(val) {
    var typeOfVal = typeof val;
    typeOfVal = $5a1c6be634076347$var$miniKindOf(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $5a1c6be634076347$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function. Instead, received: '" + $5a1c6be634076347$var$kindOf(enhancer) + "'");
        return enhancer($5a1c6be634076347$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the root reducer to be a function. Instead, received: '" + $5a1c6be634076347$var$kindOf(reducer) + "'");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function. Instead, received: '" + $5a1c6be634076347$var$kindOf(listener) + "'");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$5a1c6be634076347$var$isPlainObject(action)) throw new Error("Actions must be plain objects. Instead, the actual type was: '" + $5a1c6be634076347$var$kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function. Instead, received: '" + $5a1c6be634076347$var$kindOf(nextReducer));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $5a1c6be634076347$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error("Expected the observer to be an object. Instead, received: '" + $5a1c6be634076347$var$kindOf(observer) + "'");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$5a1c6be634076347$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $5a1c6be634076347$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$5a1c6be634076347$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $5a1c6be634076347$export$8928921ea2d3b126 = $5a1c6be634076347$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5a1c6be634076347$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $5a1c6be634076347$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $5a1c6be634076347$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$5a1c6be634076347$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $5a1c6be634076347$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $5a1c6be634076347$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $5a1c6be634076347$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $5a1c6be634076347$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: $5a1c6be634076347$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + $5a1c6be634076347$export$4219e499db7ca678.INIT + '\' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $5a1c6be634076347$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "undefined") $5a1c6be634076347$var$warning('No reducer provided for key "' + key + '"');
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    unexpectedKeyCache = {};
    var shapeAssertionError;
    try {
        $5a1c6be634076347$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage = $5a1c6be634076347$var$getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
        if (warningMessage) $5a1c6be634076347$var$warning(warningMessage);
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error("When called with an action of type " + (actionType ? '"' + String(actionType) + '"' : "(unknown type)") + ', the slice reducer for key "' + _key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $5a1c6be634076347$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $5a1c6be634076347$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $5a1c6be634076347$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, but instead received: '" + $5a1c6be634076347$var$kindOf(actionCreators) + "'. " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $5a1c6be634076347$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $5a1c6be634076347$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $5a1c6be634076347$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $5a1c6be634076347$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $q31I7.default)((0, $q31I7.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("q31I7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04e4c6d726c3cd8e$export$2e2bcd8739ae039; });

var $aZohx = parcelRequire("aZohx");
function $04e4c6d726c3cd8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04e4c6d726c3cd8e$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04e4c6d726c3cd8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $aZohx.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04e4c6d726c3cd8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("aZohx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80026fbd0f58078f$export$2e2bcd8739ae039; });

var $2sY8q = parcelRequire("2sY8q");
function $80026fbd0f58078f$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $2sY8q.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("2sY8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cbcd7daa26675d5$export$2e2bcd8739ae039; });

var $bnkh5 = parcelRequire("bnkh5");

var $kkh5l = parcelRequire("kkh5l");
function $1cbcd7daa26675d5$export$2e2bcd8739ae039(t) {
    var i = (0, $kkh5l.default)(t, "string");
    return "symbol" == (0, $bnkh5.default)(i) ? i : i + "";
}

});
parcelRegister("bnkh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848191c8fddb8554$export$2e2bcd8739ae039; });
function $848191c8fddb8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $848191c8fddb8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $848191c8fddb8554$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kkh5l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecc2eda95ccfb50c$export$2e2bcd8739ae039; });

var $bnkh5 = parcelRequire("bnkh5");
function $ecc2eda95ccfb50c$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bnkh5.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bnkh5.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("4Ulme", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $392cf5917b531dba$export$595d22ed68ca2841; });

var $VUzz6 = parcelRequire("VUzz6");
function $392cf5917b531dba$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $392cf5917b531dba$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $392cf5917b531dba$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $392cf5917b531dba$export$595d22ed68ca2841 = /* #__PURE__ */ $392cf5917b531dba$export$5943f4447f6ef248((0, $VUzz6.defaultMemoize));
var $392cf5917b531dba$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $392cf5917b531dba$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("VUzz6", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $0ae13521eb8cf54a$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $0ae13521eb8cf54a$var$NOT_FOUND = "NOT_FOUND";
function $0ae13521eb8cf54a$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $0ae13521eb8cf54a$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $0ae13521eb8cf54a$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $0ae13521eb8cf54a$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $0ae13521eb8cf54a$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $0ae13521eb8cf54a$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $0ae13521eb8cf54a$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $0ae13521eb8cf54a$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $0ae13521eb8cf54a$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $0ae13521eb8cf54a$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $0ae13521eb8cf54a$var$createSingletonCache(comparator) : $0ae13521eb8cf54a$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $0ae13521eb8cf54a$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("2fDyW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3babc56946dc0b$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $1a3babc56946dc0b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $1a3babc56946dc0b$var$thunk = $1a3babc56946dc0b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$1a3babc56946dc0b$var$thunk.withExtraArgument = $1a3babc56946dc0b$var$createThunkMiddleware;
var $1a3babc56946dc0b$export$2e2bcd8739ae039 = $1a3babc56946dc0b$var$thunk;

});

parcelRegister("8dWjV", function(module, exports) {
// shim for using process in browser
var $5fccc6d11b1c7fac$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $5fccc6d11b1c7fac$var$cachedSetTimeout;
var $5fccc6d11b1c7fac$var$cachedClearTimeout;
function $5fccc6d11b1c7fac$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $5fccc6d11b1c7fac$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        else $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = $5fccc6d11b1c7fac$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        else $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    } catch (e) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = $5fccc6d11b1c7fac$var$defaultClearTimeout;
    }
})();
function $5fccc6d11b1c7fac$var$runTimeout(fun) {
    if ($5fccc6d11b1c7fac$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedSetTimeout === $5fccc6d11b1c7fac$var$defaultSetTimout || !$5fccc6d11b1c7fac$var$cachedSetTimeout) && setTimeout) {
        $5fccc6d11b1c7fac$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $5fccc6d11b1c7fac$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $5fccc6d11b1c7fac$var$runClearTimeout(marker) {
    if ($5fccc6d11b1c7fac$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($5fccc6d11b1c7fac$var$cachedClearTimeout === $5fccc6d11b1c7fac$var$defaultClearTimeout || !$5fccc6d11b1c7fac$var$cachedClearTimeout) && clearTimeout) {
        $5fccc6d11b1c7fac$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $5fccc6d11b1c7fac$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $5fccc6d11b1c7fac$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $5fccc6d11b1c7fac$var$queue = [];
var $5fccc6d11b1c7fac$var$draining = false;
var $5fccc6d11b1c7fac$var$currentQueue;
var $5fccc6d11b1c7fac$var$queueIndex = -1;
function $5fccc6d11b1c7fac$var$cleanUpNextTick() {
    if (!$5fccc6d11b1c7fac$var$draining || !$5fccc6d11b1c7fac$var$currentQueue) return;
    $5fccc6d11b1c7fac$var$draining = false;
    if ($5fccc6d11b1c7fac$var$currentQueue.length) $5fccc6d11b1c7fac$var$queue = $5fccc6d11b1c7fac$var$currentQueue.concat($5fccc6d11b1c7fac$var$queue);
    else $5fccc6d11b1c7fac$var$queueIndex = -1;
    if ($5fccc6d11b1c7fac$var$queue.length) $5fccc6d11b1c7fac$var$drainQueue();
}
function $5fccc6d11b1c7fac$var$drainQueue() {
    if ($5fccc6d11b1c7fac$var$draining) return;
    var timeout = $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$cleanUpNextTick);
    $5fccc6d11b1c7fac$var$draining = true;
    var len = $5fccc6d11b1c7fac$var$queue.length;
    while(len){
        $5fccc6d11b1c7fac$var$currentQueue = $5fccc6d11b1c7fac$var$queue;
        $5fccc6d11b1c7fac$var$queue = [];
        while(++$5fccc6d11b1c7fac$var$queueIndex < len)if ($5fccc6d11b1c7fac$var$currentQueue) $5fccc6d11b1c7fac$var$currentQueue[$5fccc6d11b1c7fac$var$queueIndex].run();
        $5fccc6d11b1c7fac$var$queueIndex = -1;
        len = $5fccc6d11b1c7fac$var$queue.length;
    }
    $5fccc6d11b1c7fac$var$currentQueue = null;
    $5fccc6d11b1c7fac$var$draining = false;
    $5fccc6d11b1c7fac$var$runClearTimeout(timeout);
}
$5fccc6d11b1c7fac$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $5fccc6d11b1c7fac$var$queue.push(new $5fccc6d11b1c7fac$var$Item(fun, args));
    if ($5fccc6d11b1c7fac$var$queue.length === 1 && !$5fccc6d11b1c7fac$var$draining) $5fccc6d11b1c7fac$var$runTimeout($5fccc6d11b1c7fac$var$drainQueue);
};
// v8 likes predictible objects
function $5fccc6d11b1c7fac$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$5fccc6d11b1c7fac$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$5fccc6d11b1c7fac$var$process.title = "browser";
$5fccc6d11b1c7fac$var$process.browser = true;
$5fccc6d11b1c7fac$var$process.env = {};
$5fccc6d11b1c7fac$var$process.argv = [];
$5fccc6d11b1c7fac$var$process.version = ""; // empty string to avoid regexp issues
$5fccc6d11b1c7fac$var$process.versions = {};
function $5fccc6d11b1c7fac$var$noop() {}
$5fccc6d11b1c7fac$var$process.on = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.addListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.once = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.off = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.removeAllListeners = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.emit = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.prependOnceListener = $5fccc6d11b1c7fac$var$noop;
$5fccc6d11b1c7fac$var$process.listeners = function(name) {
    return [];
};
$5fccc6d11b1c7fac$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$5fccc6d11b1c7fac$var$process.cwd = function() {
    return "/";
};
$5fccc6d11b1c7fac$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$5fccc6d11b1c7fac$var$process.umask = function() {
    return 0;
};

});


parcelRegister("jJtwY", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $d62b5094e9039326$export$596d806903d1f59e; });
$parcel$export(module.exports, "postLogin", function () { return $d62b5094e9039326$export$f2b793fb6eff54de; });
$parcel$export(module.exports, "loginAsGuest", function () { return $d62b5094e9039326$export$cac7a67f197c8403; });
$parcel$export(module.exports, "logout", function () { return $d62b5094e9039326$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "register", function () { return $d62b5094e9039326$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "initialAuthCheck", function () { return $d62b5094e9039326$export$77eefe1bac88f916; });
$parcel$export(module.exports, "initialAuthFlow", function () { return $d62b5094e9039326$export$e3ffc48508b7a7fa; });
$parcel$export(module.exports, "updateIsLoggedIn", function () { return $d62b5094e9039326$export$9e944975420e1fad; });
$parcel$export(module.exports, "updateUser", function () { return $d62b5094e9039326$export$e3ac7a5d19605772; });
$parcel$export(module.exports, "default", function () { return $d62b5094e9039326$export$2e2bcd8739ae039; });

var $jvvee = parcelRequire("jvvee");

var $baXkz = parcelRequire("baXkz");

var $f9aoP = parcelRequire("f9aoP");

var $4KKbJ = parcelRequire("4KKbJ");

var $27K0D = parcelRequire("27K0D");

var $i7H0N = parcelRequire("i7H0N");

var $lXNKs = parcelRequire("lXNKs");

var $aTRs6 = parcelRequire("aTRs6");
const $d62b5094e9039326$var$initialState = {
    loggedIn: false,
    isLoggingIn: false,
    intialAuthCheckComplete: false,
    isInitialAuthCheckInProgress: false,
    isRegistering: false,
    isRegistrationSuccessful: false
};
const $d62b5094e9039326$export$a87928eef029cbb4 = $d62b5094e9039326$var$initialState;
const $d62b5094e9039326$export$596d806903d1f59e = (0, $jvvee.createAsyncThunk)("auth/login", async ([email, password], thunkApi)=>{
    try {
        await $f9aoP.login(email, password);
        thunkApi.dispatch($d62b5094e9039326$export$f2b793fb6eff54de());
    } catch (error) {
        return thunkApi.rejectWithValue(error.message || "UNKNOWN_ERROR");
    }
});
const $d62b5094e9039326$export$f2b793fb6eff54de = (0, $jvvee.createAsyncThunk)("auth/postLogin", async (_, thunkApi)=>{
    const user = await $f9aoP.me();
    (0, $27K0D.setUserId)(user.id);
    (0, $i7H0N.sendEvent)("login");
    return user;
});
const $d62b5094e9039326$export$cac7a67f197c8403 = (0, $jvvee.createAsyncThunk)("auth/loginGuest", async (_, thunkApi)=>{
    await $f9aoP.loginAsGuest();
    thunkApi.dispatch($d62b5094e9039326$export$f2b793fb6eff54de());
});
const $d62b5094e9039326$export$a0973bcfe11b05c9 = (0, $jvvee.createAsyncThunk)("auth/logout", async (_, t)=>{
    await $f9aoP.logout();
    t.dispatch((0, $baXkz.resetAppState)());
    t.dispatch((0, $4KKbJ.resetProfileState)());
});
const $d62b5094e9039326$export$6503ec6e8aabbaf = (0, $jvvee.createAsyncThunk)("auth/register", async ([email, password, turnstileToken], thunkApi)=>{
    try {
        const result = await $f9aoP.register(email, password, turnstileToken);
        return result.success;
    } catch (error) {
        return thunkApi.rejectWithValue(error.message || "UNKNOWN_ERROR");
    }
});
const $d62b5094e9039326$export$77eefe1bac88f916 = (0, $jvvee.createAsyncThunk)("auth/initialAuthCheck", async (_, thunkApi)=>{
    if (!$f9aoP.getAuthToken()) return null;
    let user;
    try {
        user = await $f9aoP.me();
    } catch (error) {
        $f9aoP.setAuthToken("");
        await thunkApi.dispatch($d62b5094e9039326$export$cac7a67f197c8403());
        user = await $f9aoP.me();
    }
    if (user) {
        (0, $27K0D.setUserId)(user.id);
        (0, $i7H0N.sendEvent)("reopened_app");
        return user;
    }
    return null;
});
const $d62b5094e9039326$export$e3ffc48508b7a7fa = (0, $jvvee.createAsyncThunk)("auth/initialAuthFlow", async (_, thunkApi)=>{
    if (0, $aTRs6.IS_DISCORD_ACTIVITY) return null;
    if (!$f9aoP.getAuthToken()) await $f9aoP.loginAsGuest();
    let userId;
    try {
        const token = $f9aoP.getAuthToken();
        const data = (0, $lXNKs.getTokenPayload)(token);
        userId = data.sub;
        (0, $27K0D.setUserId)(userId);
        thunkApi.dispatch($d62b5094e9039326$export$9e944975420e1fad(true));
    } catch (error) {
        console.error("Error decoding token:", error);
    }
    return null;
});
const $d62b5094e9039326$var$handlePendingLogin = (state)=>{
    state.isLoggingIn = true;
    state.loginError = undefined;
};
const $d62b5094e9039326$var$handleRejectedLogin = (state, errorMessage)=>{
    // state.loggedIn = false;
    state.isLoggingIn = false;
    state.loginError = errorMessage;
};
const $d62b5094e9039326$var$auth = (0, $jvvee.createSlice)({
    name: "auth",
    initialState: $d62b5094e9039326$var$initialState,
    reducers: {
        updateUser (state, action) {
            state.user = action.payload;
        },
        updateIsLoggedIn (state, action) {
            state.loggedIn = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($d62b5094e9039326$export$596d806903d1f59e.pending, $d62b5094e9039326$var$handlePendingLogin);
        builder.addCase($d62b5094e9039326$export$596d806903d1f59e.rejected, (state, action)=>{
            $d62b5094e9039326$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($d62b5094e9039326$export$cac7a67f197c8403.pending, $d62b5094e9039326$var$handlePendingLogin);
        builder.addCase($d62b5094e9039326$export$cac7a67f197c8403.rejected, (state, action)=>{
            $d62b5094e9039326$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($d62b5094e9039326$export$f2b793fb6eff54de.fulfilled, (state, action)=>{
            state.user = action.payload;
            state.loggedIn = true;
            state.isLoggingIn = false;
            state.loginError = undefined;
        });
        builder.addCase($d62b5094e9039326$export$f2b793fb6eff54de.rejected, (state, action)=>{
            $d62b5094e9039326$var$handleRejectedLogin(state, action.payload);
        });
        builder.addCase($d62b5094e9039326$export$6503ec6e8aabbaf.pending, (state)=>{
            state.isRegistering = true;
            state.registerError = undefined;
            state.isRegistrationSuccessful = false;
        });
        builder.addCase($d62b5094e9039326$export$6503ec6e8aabbaf.fulfilled, (state)=>{
            state.isRegistering = false;
            state.isRegistrationSuccessful = true;
        });
        builder.addCase($d62b5094e9039326$export$6503ec6e8aabbaf.rejected, (state, action)=>{
            state.isRegistering = false;
            state.registerError = action.payload;
            state.isRegistrationSuccessful = false;
        });
        builder.addCase($d62b5094e9039326$export$77eefe1bac88f916.pending, (state)=>{
            state.isInitialAuthCheckInProgress = true;
        });
        builder.addCase($d62b5094e9039326$export$77eefe1bac88f916.fulfilled, (state, action)=>{
            if (action.payload) {
                state.user = action.payload;
                state.loggedIn = !!action.payload;
            }
            state.isInitialAuthCheckInProgress = false;
            state.intialAuthCheckComplete = true;
        });
        builder.addCase($d62b5094e9039326$export$77eefe1bac88f916.rejected, (state, action)=>{
            state.isInitialAuthCheckInProgress = false;
            state.intialAuthCheckComplete = true;
        });
        builder.addCase($d62b5094e9039326$export$a0973bcfe11b05c9.pending, (state)=>{
            state.loggedIn = false;
            state.intialAuthCheckComplete = true;
            state.user = undefined;
            state.isLoggingIn = false;
            state.hasLoggedOut = true;
        });
        builder.addCase($d62b5094e9039326$export$a0973bcfe11b05c9.rejected, (state, action)=>{
            console.log(action.error);
        });
        builder.addCase($d62b5094e9039326$export$a0973bcfe11b05c9.fulfilled, (state)=>{
        // ?
        });
    }
});
const { updateUser: $d62b5094e9039326$export$e3ac7a5d19605772, updateIsLoggedIn: $d62b5094e9039326$export$9e944975420e1fad } = $d62b5094e9039326$var$auth.actions;
const { actions: $d62b5094e9039326$export$2b4c6dd0b4533a88, reducer: $d62b5094e9039326$export$b3aa4dbb59e7857d } = $d62b5094e9039326$var$auth;
var $d62b5094e9039326$export$2e2bcd8739ae039 = $d62b5094e9039326$export$b3aa4dbb59e7857d;

});
parcelRegister("baXkz", function(module, exports) {

$parcel$export(module.exports, "loadInstance", function () { return $d31b000e231df651$export$87e299862ee2a235; });
$parcel$export(module.exports, "loadLocation", function () { return $d31b000e231df651$export$4297fea210b644d9; });
$parcel$export(module.exports, "loadLocations", function () { return $d31b000e231df651$export$2a5930d51041cae6; });
$parcel$export(module.exports, "loadSceneSelectorData", function () { return $d31b000e231df651$export$9e85acb980e0a28d; });
$parcel$export(module.exports, "loadInventory", function () { return $d31b000e231df651$export$45aba0c57314d190; });
$parcel$export(module.exports, "failedGame", function () { return $d31b000e231df651$export$55d755f3fb83609f; });
$parcel$export(module.exports, "clearFailed", function () { return $d31b000e231df651$export$de1483e67cebf1c9; });
$parcel$export(module.exports, "submitFeedUpdate", function () { return $d31b000e231df651$export$e36b950b6d863b55; });
$parcel$export(module.exports, "submitArisewareScore", function () { return $d31b000e231df651$export$2ffd3871cec7b2d9; });
$parcel$export(module.exports, "toggleInventory", function () { return $d31b000e231df651$export$ce18e5b72073dbce; });
$parcel$export(module.exports, "toggleShowingSettingsMenu", function () { return $d31b000e231df651$export$dd2c4aaede92d637; });
$parcel$export(module.exports, "setShowingSettingsMenu", function () { return $d31b000e231df651$export$47784c5e07fa5b05; });
$parcel$export(module.exports, "setHasWorldIntroPlayed", function () { return $d31b000e231df651$export$6f9a7cf27ab4b017; });
$parcel$export(module.exports, "setNewsModalLastVersionSeen", function () { return $d31b000e231df651$export$788d6e8e2edf42f8; });
$parcel$export(module.exports, "setShouldShowGuestSignUpModal", function () { return $d31b000e231df651$export$31d571dbf2a7d893; });
$parcel$export(module.exports, "setHasSeenShop", function () { return $d31b000e231df651$export$efafe52fdfb810ce; });
$parcel$export(module.exports, "setIsInventoryOpen", function () { return $d31b000e231df651$export$afcd214d843b4ec0; });
$parcel$export(module.exports, "setIsNewsTickerVisible", function () { return $d31b000e231df651$export$2f1a15ef644a27f9; });
$parcel$export(module.exports, "setIsLeaderboardOpen", function () { return $d31b000e231df651$export$c47ad9502cddc183; });
$parcel$export(module.exports, "setIsExitLocationModalOpen", function () { return $d31b000e231df651$export$863e57c4bfe9488d; });
$parcel$export(module.exports, "openProfile", function () { return $d31b000e231df651$export$c10e7cabab300b11; });
$parcel$export(module.exports, "closeProfile", function () { return $d31b000e231df651$export$eec6a89ec39aab8c; });
$parcel$export(module.exports, "updateCurrentlyViewingProfileIfMatches", function () { return $d31b000e231df651$export$85ea600332a89f56; });
$parcel$export(module.exports, "toggleSidebarOpen", function () { return $d31b000e231df651$export$1d54456469cf71ed; });
$parcel$export(module.exports, "setIsInformationOpen", function () { return $d31b000e231df651$export$d730e57b4ba196e5; });
$parcel$export(module.exports, "setIsSidebarOpen", function () { return $d31b000e231df651$export$7228de5ae4af2ef0; });
$parcel$export(module.exports, "toggleShopOpen", function () { return $d31b000e231df651$export$9c34bafc33bfcb6e; });
$parcel$export(module.exports, "setIsShopOpen", function () { return $d31b000e231df651$export$abd1221cd0a2b4b6; });
$parcel$export(module.exports, "setIsMyPrizesOpen", function () { return $d31b000e231df651$export$4e3e5b8b3f8dabb1; });
$parcel$export(module.exports, "toggleDebugMenu", function () { return $d31b000e231df651$export$37c982b2c0e2abef; });
$parcel$export(module.exports, "setAuthModalScreen", function () { return $d31b000e231df651$export$257f2f650e025aa4; });
$parcel$export(module.exports, "reevaluateIfFeedsAreOpen", function () { return $d31b000e231df651$export$5c31e51f56cbe8c4; });
$parcel$export(module.exports, "updateLocation", function () { return $d31b000e231df651$export$735c4579e2cd6507; });
$parcel$export(module.exports, "setInventory", function () { return $d31b000e231df651$export$1951e9681e66c182; });
$parcel$export(module.exports, "setHasFailed", function () { return $d31b000e231df651$export$e3f584b95020ea06; });
$parcel$export(module.exports, "resetAppState", function () { return $d31b000e231df651$export$10d871c0f32f1a89; });
$parcel$export(module.exports, "selectInventoryItem", function () { return $d31b000e231df651$export$5ab3b4955234c7ca; });
$parcel$export(module.exports, "setIsInventoryUsingItem", function () { return $d31b000e231df651$export$a484e967e6f27430; });
$parcel$export(module.exports, "setIsUnseenItemInInventory", function () { return $d31b000e231df651$export$11201f4135d2107c; });
$parcel$export(module.exports, "queueAchievement", function () { return $d31b000e231df651$export$b0c9ef114e574e3; });
$parcel$export(module.exports, "removeFirstAchievementFromQueue", function () { return $d31b000e231df651$export$c749ed39a48316f5; });
$parcel$export(module.exports, "setShareModalOpen", function () { return $d31b000e231df651$export$15bf4e8c69648d0d; });
$parcel$export(module.exports, "setStartShare", function () { return $d31b000e231df651$export$d9714b27df2ad16a; });
$parcel$export(module.exports, "setIsPurchaseInProgress", function () { return $d31b000e231df651$export$a6b80e802e587e44; });
$parcel$export(module.exports, "setCurrentlyViewingMedia", function () { return $d31b000e231df651$export$b2c71eabfbfbf430; });
$parcel$export(module.exports, "setCurrentlyViewingPrize", function () { return $d31b000e231df651$export$2ea407fb1a07bfa9; });
$parcel$export(module.exports, "setInstanceLoadTimestamp", function () { return $d31b000e231df651$export$f8be399f744c5165; });
$parcel$export(module.exports, "setShouldHideUI", function () { return $d31b000e231df651$export$512719d933c74d6; });
$parcel$export(module.exports, "setLangIso", function () { return $d31b000e231df651$export$5636fe289543a2cf; });
$parcel$export(module.exports, "default", function () { return $d31b000e231df651$export$2e2bcd8739ae039; });

var $cpVbU = parcelRequire("cpVbU");

var $jvvee = parcelRequire("jvvee");

var $f9aoP = parcelRequire("f9aoP");

var $jJtwY = parcelRequire("jJtwY");

var $aTKgi = parcelRequire("aTKgi");

var $jLk8j = parcelRequire("jLk8j");

var $g4EEF = parcelRequire("g4EEF");

var $aTRs6 = parcelRequire("aTRs6");

var $lOBrS = parcelRequire("lOBrS");
const $d31b000e231df651$var$instanceToTheme = {
    titan: (0, $cpVbU.TitanTheme),
    phobos: (0, $cpVbU.PhobosTheme),
    hyperion: (0, $cpVbU.HyperionTheme),
    mimas: (0, $cpVbU.MimasTheme),
    rana: (0, $cpVbU.RanaTheme),
    deimos: (0, $cpVbU.DeimosTheme),
    umbra: (0, $cpVbU.UmbraTheme),
    brickhouse: (0, $cpVbU.BrickhouseTheme),
    dakota: (0, $cpVbU.DakotaTheme)
};
const $d31b000e231df651$var$initialState = {
    instance: "",
    instanceLoaded: false,
    isInstanceLoading: false,
    instanceLoadTimestamp: undefined,
    theme: $d31b000e231df651$var$instanceToTheme["brickhouse"] || (0, $cpVbU.defaultTheme),
    isLocationLoading: false,
    isInventoryOpen: false,
    inventoryToggledAt: Date.now(),
    isInventoryUsingItem: false,
    isProfileOpen: false,
    isMyPrizesOpen: false,
    isInformationOpen: false,
    isShopOpen: false,
    isDebugMenuOpen: false,
    isNewsTickerVisible: false,
    isExitLocationModalOpen: false,
    isSidebarOpen: false,
    isFetchingAreas: false,
    isFetchingLocations: false,
    isFetchingRegions: false,
    // TODO: don't hardcode this
    universeId: window.localStorage.getItem("ARISE_UNIVERSEID") || "718b65bf-9225-48da-93f2-6a7255127896",
    isSettingsMenuShowing: false,
    isSwitchingWorld: false,
    hasWorldIntroPlayed: false,
    guestModalCount: 0,
    hasSeenShop: !!window.localStorage.getItem((0, $aTRs6.LS_HASSEENSHOP_KEY)),
    inventory: [],
    isFetchingInventory: false,
    failedAt: undefined,
    achievementQueue: [],
    shareModalOpen: false,
    shareMessage: "",
    shareURL: "",
    shareModalTitle: "Share",
    translations: {},
    isFetchingTranslations: false,
    translationsLoaded: false,
    langIso: "en-US",
    availableLangs: []
};
const $d31b000e231df651$export$3a00184c4304ec2e = $d31b000e231df651$var$initialState;
const $d31b000e231df651$export$87e299862ee2a235 = (0, $jvvee.createAsyncThunk)("app/loadInstance", async (universeId, thunkApi)=>{
    const state = thunkApi.getState();
    // Prevent multiple concurrent calls
    if (state.app.isInstanceLoading) return thunkApi.rejectWithValue("Instance loading already in progress");
    let theme = (0, $cpVbU.defaultTheme);
    if ($d31b000e231df651$var$instanceToTheme["brickhouse"]) theme = $d31b000e231df651$var$instanceToTheme["brickhouse"];
    const [res, metadata] = await Promise.all([
        $f9aoP.getMedia(universeId),
        $f9aoP.getUniverseMetadata(universeId)
    ]);
    theme = {
        ...theme,
        loaded: true,
        assetBasePath: "/assets",
        customJSON: res.customJSON,
        files: {
            ...theme.files,
            logo: (0, $aTKgi.pathToURL)(res.logoPath),
            // splash_bg: pathToURL(res.splashBgPath),
            inventory_backdrop: (0, $aTKgi.pathToURL)(res.inventoryBackdropPath),
            instance_mark: (0, $aTKgi.pathToURL)(res.instanceMarkPath)
        },
        title: metadata.title,
        metadata: metadata
    };
    return {
        name: universeId,
        theme: theme
    };
});
const $d31b000e231df651$export$4297fea210b644d9 = (0, $jvvee.createAsyncThunk)("app/loadLocation", async (locationId, thunkApi)=>{
    let { locations: locations } = thunkApi.getState().app;
    if (!locations) {
        const res = await thunkApi.dispatch($d31b000e231df651$export$2a5930d51041cae6());
        const loc = res.payload.find((l)=>l.id === locationId);
        if (loc) return loc;
        else throw new Error(locationId);
    }
    const location = locations[locationId];
    if (location) return location;
    const res = await thunkApi.dispatch($d31b000e231df651$export$2a5930d51041cae6());
    const loc = res.payload.find((l)=>l.id === locationId);
    if (loc) return loc;
    throw new Error(locationId);
});
const $d31b000e231df651$export$2a5930d51041cae6 = (0, $jvvee.createAsyncThunk)("app/loadLocations", async (_, thunkApi)=>{
    const res = await $f9aoP.getLocations();
    return (0, $lOBrS.cleanCDNUrls)(res);
});
const $d31b000e231df651$export$a910cb9907254b94 = (0, $jvvee.createAsyncThunk)("app/loadAreas", async (_, thunkApi)=>{
    const res = await $f9aoP.getAreas();
    return res;
});
const $d31b000e231df651$export$497a83f5fe7b296b = (0, $jvvee.createAsyncThunk)("app/loadRegions", async (_, thunkApi)=>{
    const res = await $f9aoP.getRegions();
    return res;
});
const $d31b000e231df651$export$9e85acb980e0a28d = (0, $jvvee.createAsyncThunk)("app/loadSceneSelectorData", async (_, thunkApi)=>{
    const res = await $f9aoP.getSceneSelectorSettings();
    return res;
});
const $d31b000e231df651$export$6b0a6f944ed084f5 = (0, $jvvee.createAsyncThunk)("app/switchWorld", async ([worldId, themeId, navigate], thunkApi)=>{
    thunkApi.dispatch($d31b000e231df651$var$app.actions.setIsSwitchingWorld(true));
    thunkApi.dispatch($d31b000e231df651$var$app.actions.setShowingSettingsMenu(false));
    // Waiting 1.5 sec to simulate something
    // TODO
    await new Promise((resolve)=>setTimeout(resolve, 1500));
    thunkApi.dispatch($d31b000e231df651$var$app.actions.clearData());
    thunkApi.dispatch($d31b000e231df651$var$app.actions.setUniverseId(worldId));
    thunkApi.dispatch((0, $jJtwY.logout)());
    thunkApi.dispatch($d31b000e231df651$var$app.actions.setIsSwitchingWorld(false));
// TODO: clear all state (locations, areas, etc)
// thunkApi.dispatch(app.actions.setUniverseId(worldId));
// navigate('/auth/login');
});
const $d31b000e231df651$export$500419e4e8ac909f = (0, $jvvee.createAsyncThunk)("app/loadAllLocationData", async (_, thunkApi)=>{
    const state = thunkApi.getState();
    const uId = state.app.universeId;
    if (!uId) {
        console.error("No universe id set");
        return;
    }
    thunkApi.dispatch($d31b000e231df651$export$a910cb9907254b94());
    thunkApi.dispatch($d31b000e231df651$export$2a5930d51041cae6());
    thunkApi.dispatch($d31b000e231df651$export$497a83f5fe7b296b());
});
const $d31b000e231df651$export$45aba0c57314d190 = (0, $jvvee.createAsyncThunk)("app/loadInventory", async (_, thunkApi)=>{
    const res = await $f9aoP.getInventory();
    return res;
});
const $d31b000e231df651$export$55d755f3fb83609f = (0, $jvvee.createAsyncThunk)("app/failedGame", async ({ arisewareProjectID: arisewareProjectID }, thunkApi)=>{
    const { dispatch: dispatch } = thunkApi;
    const s = thunkApi.getState();
    dispatch($d31b000e231df651$var$app.actions.setHasFailed(true));
    dispatch($d31b000e231df651$var$app.actions.setIsSidebarOpen(true));
    dispatch($d31b000e231df651$var$app.actions.setIsInventoryOpen(false));
    dispatch($d31b000e231df651$var$app.actions.setIsExitLocationModalOpen(false));
    await $f9aoP.failedAriseware(arisewareProjectID);
});
const $d31b000e231df651$export$de1483e67cebf1c9 = (0, $jvvee.createAsyncThunk)("app/clearFailed", async (_, thunkApi)=>{
    const { dispatch: dispatch } = thunkApi;
    dispatch($d31b000e231df651$var$app.actions.setHasFailed(false));
    if ((0, $jLk8j.isMobileWidth)()) dispatch($d31b000e231df651$var$app.actions.setIsSidebarOpen(false));
});
const $d31b000e231df651$export$e36b950b6d863b55 = (0, $jvvee.createAsyncThunk)("app/failedGame", async (type, thunkApi)=>{
    const s = thunkApi.getState();
    if (!s.app?.location?.isFeedOpen) return;
    try {
        await $f9aoP.submitFeedUpdate(s.app.location.id, type);
    } catch (error) {
        console.error("Failed to submit feed update", error);
    }
});
const $d31b000e231df651$export$2ffd3871cec7b2d9 = (0, $jvvee.createAsyncThunk)("app/submitArisewareScore", async (data, thunkApi)=>{
    try {
        await $f9aoP.submitArisewareScore(data);
    } catch (error) {
        console.error("Failed to submit arise score", error);
    }
});
const $d31b000e231df651$export$d0a0663b151c7564 = (0, $jvvee.createAsyncThunk)("app/loadTranslations", async (_, thunkApi)=>{
    let lastError;
    for(let attempt = 1; attempt <= 3; attempt++)try {
        const res = await $f9aoP.getTranslations();
        const { langs: langs, ...translations } = res;
        return {
            translations: translations,
            langs: langs || []
        };
    } catch (error) {
        lastError = error;
        console.error(`Failed to load translations (attempt ${attempt}/3)`, error);
        if (attempt < 3) await new Promise((resolve)=>setTimeout(resolve, 1000 * attempt));
    }
    throw lastError;
});
const $d31b000e231df651$var$app = (0, $jvvee.createSlice)({
    name: "app",
    initialState: $d31b000e231df651$var$initialState,
    reducers: {
        toggleInventory (state) {
            state.isInventoryOpen = !state.isInventoryOpen;
        },
        setIsInventoryOpen (state, action) {
            if (Date.now() - state.inventoryToggledAt > 750) {
                state.inventoryToggledAt = Date.now();
                state.isInventoryOpen = action.payload;
            }
        },
        setIsNewsTickerVisible (state, action) {
            state.isNewsTickerVisible = action.payload;
        },
        setIsLeaderboardOpen (state, action) {
            state.isLeaderboardOpen = action.payload;
        },
        setIsExitLocationModalOpen (state, action) {
            state.isExitLocationModalOpen = action.payload;
        },
        toggleSidebarOpen (state) {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        setIsSidebarOpen (state, action) {
            state.isSidebarOpen = action.payload;
        },
        openProfile (state) {
            // state.currentlyViewingProfile = action.payload;
            state.isSidebarOpen = true;
            state.isProfileOpen = true;
            state.isShopOpen = false;
            state.isMyPrizesOpen = false;
            state.isInformationOpen = false;
        },
        setCurrentlyViewingMedia (state, action) {
            state.currentlyViewingMedia = action.payload;
            if (state.currentlyViewingMedia?.resourceType === "video") state.shouldArisewareBeMuted = true;
            else state.shouldArisewareBeMuted = false;
        },
        setCurrentlyViewingPrize (state, action) {
            state.currentlyViewingPrize = action.payload;
        },
        closeProfile (state) {
            state.isProfileOpen = false;
        },
        toggleShopOpen (state) {
            if (!state.isShopOpen) {
                // If shop will become open
                state.isProfileOpen = false;
                state.isSidebarOpen = true;
            }
            state.isShopOpen = !state.isShopOpen;
        },
        setIsShopOpen (state, action) {
            if (action.payload === true) {
                // If shop will become open
                state.isProfileOpen = false;
                state.isSidebarOpen = true;
            }
            state.isShopOpen = action.payload;
        },
        setIsMyPrizesOpen (state, action) {
            if (action.payload === true) {
                state.isProfileOpen = true;
                state.isSidebarOpen = true;
            }
            state.isMyPrizesOpen = action.payload;
        },
        setIsInformationOpen (state, action) {
            if (action.payload === true) state.isProfileOpen = false;
            state.isInformationOpen = action.payload;
        },
        toggleDebugMenu (state) {
            state.isDebugMenuOpen = !state.isDebugMenuOpen;
        },
        setAuthModalScreen (state, action) {
            state.authModalScreen = action.payload;
        },
        updateCurrentlyViewingProfileIfMatches (state, action) {
            if (state.currentlyViewingProfile?.id === action.payload?.id) state.currentlyViewingProfile = action.payload;
        },
        setUniverseId (state, action) {
            window.localStorage.setItem("ARISE_UNIVERSEID", action.payload);
            $f9aoP.setUniverseID(action.payload);
            state.universeId = action.payload;
        },
        toggleShowingSettingsMenu (state) {
            state.isSettingsMenuShowing = !state.isSettingsMenuShowing;
        },
        setShowingSettingsMenu (state, action) {
            state.isSettingsMenuShowing = action.payload;
        },
        setIsSwitchingWorld (state, action) {
            state.isSwitchingWorld = action.payload;
        },
        setHasWorldIntroPlayed (state, action) {
            state.hasWorldIntroPlayed = action.payload;
        },
        setNewsModalLastVersionSeen (state, action) {
            state.newsModalLastVersionSeen = action.payload;
        },
        setShouldShowGuestSignUpModal (state, action) {
            state.shouldShowGuestSignUpModal = action.payload;
            if (action.payload === true) state.guestModalCount = state.guestModalCount + 1;
        },
        setHasSeenShop (state, action) {
            state.hasSeenShop = action.payload;
        },
        clearData (state) {
            state.areas = undefined;
            state.locations = undefined;
            state.regions = undefined;
        },
        updateLocation (state, action) {
            const updatedLocation = (0, $g4EEF.processLocationData)(action.payload);
            if (state.locations) {
                state.locations[updatedLocation.id] = updatedLocation;
                if (state.location?.id === updatedLocation.id) state.location = updatedLocation;
            }
        },
        reevaluateIfFeedsAreOpen (state) {
            for(var locationKey in state.locations)if (state.locations.hasOwnProperty(locationKey)) {
                const location = state.locations[locationKey];
                location.isFeedOpen = (0, $g4EEF.isFeedOpen)(location);
            }
            if (state.location) state.location.isFeedOpen = (0, $g4EEF.isFeedOpen)(state.location);
        },
        setInventory (state, action) {
            state.inventory = action.payload;
        },
        toggleHasFailed (state) {
            // It's oddly difficult to call another reducer from within a reducer,
            // so we duplicate the logic here and in the method below
            if (!state.failedAt) {
                state.isProfileOpen = false;
                state.failedAt = Date.now();
            } else state.failedAt = undefined;
        },
        setHasFailed (state, action) {
            if (action.payload) {
                state.isProfileOpen = false;
                state.failedAt = Date.now();
            } else state.failedAt = undefined;
        },
        resetAppState (state) {
            Object.assign(state, $d31b000e231df651$var$initialState);
        },
        selectInventoryItem (state) {
            state.isInventoryOpen = true;
            state.isInventoryUsingItem = true;
            state.inventoryToggledAt = Date.now();
        },
        setIsInventoryUsingItem (state, action) {
            state.isInventoryUsingItem = action.payload;
        },
        setIsUnseenItemInInventory (state, action) {
            state.isUnseenItemInInventory = action.payload;
        },
        queueAchievement (state, action) {
            state.achievementQueue.push(action.payload);
        },
        removeFirstAchievementFromQueue (state) {
            state.achievementQueue.shift();
        },
        setStartShare (state, action) {
            const [message, url, title] = action.payload;
            state.shareURL = url;
            state.shareMessage = message;
            state.shareModalOpen = true;
            state.shareModalTitle = title;
        },
        setShareModalOpen (state, action) {
            state.shareModalOpen = action.payload;
        },
        setIsPurchaseInProgress (state, action) {
            state.isPurchaseInProgress = action.payload;
        },
        setInstanceLoadTimestamp (state) {
            state.instanceLoadTimestamp = Date.now();
        },
        setShouldHideUI (state, action) {
            state.shouldHideUi = action.payload;
        },
        setLangIso (state, action) {
            state.langIso = action.payload;
        },
        setShouldArisewareBeMuted (state, action) {
            state.shouldArisewareBeMuted = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($d31b000e231df651$export$87e299862ee2a235.pending, (state, action)=>{
            const now = Date.now();
            if (!state.instanceLoadTimestamp || now - state.instanceLoadTimestamp > 5000) {
                state.isInstanceLoading = true;
                state.instanceLoadTimestamp = now;
            }
        });
        builder.addCase($d31b000e231df651$export$87e299862ee2a235.fulfilled, (state, action)=>{
            state.instance = action.payload.name;
            state.theme = {
                ...action.payload.theme,
                loaded: true
            };
            state.instanceLoaded = true;
            state.isInstanceLoading = false;
        });
        builder.addCase($d31b000e231df651$export$87e299862ee2a235.rejected, (state, action)=>{
            console.error("Failed to load instance", action.error);
            state.isInstanceLoading = false;
        });
        builder.addCase($d31b000e231df651$export$4297fea210b644d9.pending, (state, action)=>{
            state.isLocationLoading = true;
            state.locationLoadErrorId = null;
        });
        builder.addCase($d31b000e231df651$export$4297fea210b644d9.fulfilled, (state, action)=>{
            state.location = action.payload;
            state.isLocationLoading = false;
            state.locationLoadErrorId = null;
        });
        builder.addCase($d31b000e231df651$export$4297fea210b644d9.rejected, (state, action)=>{
            console.error("Failed to load location", action.error);
            state.locationLoadErrorId = action?.error?.message;
            state.isLocationLoading = false;
        });
        builder.addCase($d31b000e231df651$export$a910cb9907254b94.pending, (state, action)=>{
            state.isFetchingAreas = true;
        });
        builder.addCase($d31b000e231df651$export$a910cb9907254b94.fulfilled, (state, action)=>{
            state.areas = {};
            action.payload?.forEach((area)=>{
                state.areas[area.id] = area;
            });
            state.isFetchingAreas = false;
        });
        builder.addCase($d31b000e231df651$export$a910cb9907254b94.rejected, (state, action)=>{
            console.error("Failed to load areas", action.error);
            state.isFetchingAreas = false;
        });
        builder.addCase($d31b000e231df651$export$2a5930d51041cae6.pending, (state, action)=>{
            state.isFetchingLocations = true;
        });
        builder.addCase($d31b000e231df651$export$2a5930d51041cae6.fulfilled, (state, action)=>{
            state.locations = {};
            action.payload?.forEach((location)=>{
                state.locations[location.id] = location;
                if (state.location?.id === location.id) state.location = location;
            });
            state.isFetchingLocations = false;
        });
        builder.addCase($d31b000e231df651$export$2a5930d51041cae6.rejected, (state, action)=>{
            console.error("Failed to load locations", action.error);
            state.isFetchingLocations = false;
        });
        builder.addCase($d31b000e231df651$export$497a83f5fe7b296b.pending, (state, action)=>{
            state.isFetchingRegions = true;
        });
        builder.addCase($d31b000e231df651$export$497a83f5fe7b296b.fulfilled, (state, action)=>{
            state.regions = {};
            action.payload?.forEach((region)=>{
                state.regions[region.id] = region;
            });
            state.isFetchingRegions = false;
        });
        builder.addCase($d31b000e231df651$export$497a83f5fe7b296b.rejected, (state, action)=>{
            console.error("Failed to load regions", action.error);
            state.isFetchingRegions = false;
        });
        builder.addCase($d31b000e231df651$export$6b0a6f944ed084f5.pending, (state, action)=>{
            state.isSwitchingWorld = true;
        });
        builder.addCase($d31b000e231df651$export$6b0a6f944ed084f5.fulfilled, (state, action)=>{
            state.isSwitchingWorld = false;
        });
        builder.addCase($d31b000e231df651$export$6b0a6f944ed084f5.rejected, (state, action)=>{
            console.error("Failed to switch world", action.error);
            state.isSwitchingWorld = false;
        });
        builder.addCase($d31b000e231df651$export$45aba0c57314d190.pending, (state, action)=>{
            state.isFetchingInventory = true;
        });
        builder.addCase($d31b000e231df651$export$45aba0c57314d190.fulfilled, (state, action)=>{
            state.inventory = action.payload;
            state.isFetchingInventory = false;
        });
        builder.addCase($d31b000e231df651$export$45aba0c57314d190.rejected, (state, action)=>{
            console.error("Failed to load inventory", action.error);
            state.isFetchingInventory = false;
        });
        builder.addCase($d31b000e231df651$export$9e85acb980e0a28d.fulfilled, (state, action)=>{
            state.sceneSelectorData = action.payload;
        });
        builder.addCase($d31b000e231df651$export$d0a0663b151c7564.pending, (state)=>{
            state.isFetchingTranslations = true;
        });
        builder.addCase($d31b000e231df651$export$d0a0663b151c7564.fulfilled, (state, action)=>{
            state.translations = action.payload.translations;
            state.availableLangs = action.payload.langs;
            state.isFetchingTranslations = false;
            state.translationsLoaded = true;
        });
        builder.addCase($d31b000e231df651$export$d0a0663b151c7564.rejected, (state, action)=>{
            console.error("Failed to load translations", action.error);
            state.isFetchingTranslations = false;
        });
    }
});
const { toggleInventory: $d31b000e231df651$export$ce18e5b72073dbce, setUniverseId: $d31b000e231df651$export$50dc8d5390587977, toggleShowingSettingsMenu: $d31b000e231df651$export$dd2c4aaede92d637, setShowingSettingsMenu: $d31b000e231df651$export$47784c5e07fa5b05, setHasWorldIntroPlayed: $d31b000e231df651$export$6f9a7cf27ab4b017, setNewsModalLastVersionSeen: $d31b000e231df651$export$788d6e8e2edf42f8, setShouldShowGuestSignUpModal: $d31b000e231df651$export$31d571dbf2a7d893, setHasSeenShop: $d31b000e231df651$export$efafe52fdfb810ce, setIsInventoryOpen: $d31b000e231df651$export$afcd214d843b4ec0, setIsNewsTickerVisible: $d31b000e231df651$export$2f1a15ef644a27f9, setIsLeaderboardOpen: $d31b000e231df651$export$c47ad9502cddc183, setIsExitLocationModalOpen: $d31b000e231df651$export$863e57c4bfe9488d, openProfile: $d31b000e231df651$export$c10e7cabab300b11, closeProfile: $d31b000e231df651$export$eec6a89ec39aab8c, updateCurrentlyViewingProfileIfMatches: $d31b000e231df651$export$85ea600332a89f56, toggleSidebarOpen: $d31b000e231df651$export$1d54456469cf71ed, setIsInformationOpen: $d31b000e231df651$export$d730e57b4ba196e5, setIsSidebarOpen: $d31b000e231df651$export$7228de5ae4af2ef0, toggleShopOpen: $d31b000e231df651$export$9c34bafc33bfcb6e, setIsShopOpen: $d31b000e231df651$export$abd1221cd0a2b4b6, setIsMyPrizesOpen: $d31b000e231df651$export$4e3e5b8b3f8dabb1, toggleDebugMenu: $d31b000e231df651$export$37c982b2c0e2abef, setAuthModalScreen: $d31b000e231df651$export$257f2f650e025aa4, reevaluateIfFeedsAreOpen: $d31b000e231df651$export$5c31e51f56cbe8c4, updateLocation: $d31b000e231df651$export$735c4579e2cd6507, setInventory: $d31b000e231df651$export$1951e9681e66c182, toggleHasFailed: $d31b000e231df651$export$d3e8133f89ca00c6, setHasFailed: $d31b000e231df651$export$e3f584b95020ea06, resetAppState: $d31b000e231df651$export$10d871c0f32f1a89, selectInventoryItem: $d31b000e231df651$export$5ab3b4955234c7ca, setIsInventoryUsingItem: $d31b000e231df651$export$a484e967e6f27430, setIsUnseenItemInInventory: $d31b000e231df651$export$11201f4135d2107c, queueAchievement: $d31b000e231df651$export$b0c9ef114e574e3, removeFirstAchievementFromQueue: $d31b000e231df651$export$c749ed39a48316f5, setShareModalOpen: $d31b000e231df651$export$15bf4e8c69648d0d, setStartShare: $d31b000e231df651$export$d9714b27df2ad16a, setIsPurchaseInProgress: $d31b000e231df651$export$a6b80e802e587e44, setCurrentlyViewingMedia: $d31b000e231df651$export$b2c71eabfbfbf430, setCurrentlyViewingPrize: $d31b000e231df651$export$2ea407fb1a07bfa9, setInstanceLoadTimestamp: $d31b000e231df651$export$f8be399f744c5165, setShouldHideUI: $d31b000e231df651$export$512719d933c74d6, setLangIso: $d31b000e231df651$export$5636fe289543a2cf, setShouldArisewareBeMuted: $d31b000e231df651$export$e8a120f4c8ccb9a3 } = $d31b000e231df651$var$app.actions;
const { actions: $d31b000e231df651$export$cb8424a6e24c1eca, reducer: $d31b000e231df651$export$23ada22b619801be } = $d31b000e231df651$var$app;
var $d31b000e231df651$export$2e2bcd8739ae039 = $d31b000e231df651$export$23ada22b619801be;

});
parcelRegister("cpVbU", function(module, exports) {

$parcel$export(module.exports, "ThemeIds", function () { return $ec34120afaf0d3a1$export$cd9fd31d4e88d2ee; });
$parcel$export(module.exports, "defaultTheme", function () { return $ec34120afaf0d3a1$export$164de7ab8df77ef0; });
$parcel$export(module.exports, "TitanTheme", function () { return $ec34120afaf0d3a1$export$a53e903714f41d6f; });
$parcel$export(module.exports, "PhobosTheme", function () { return $ec34120afaf0d3a1$export$dc830f52acce79df; });
$parcel$export(module.exports, "HyperionTheme", function () { return $ec34120afaf0d3a1$export$b90c99545b77fd72; });
$parcel$export(module.exports, "MimasTheme", function () { return $ec34120afaf0d3a1$export$82c5380410702a78; });
$parcel$export(module.exports, "RanaTheme", function () { return $ec34120afaf0d3a1$export$619f3429ba3f527d; });
$parcel$export(module.exports, "DeimosTheme", function () { return $ec34120afaf0d3a1$export$51184b5f01eae579; });
$parcel$export(module.exports, "UmbraTheme", function () { return $ec34120afaf0d3a1$export$3e0b756d8b9d706e; });
$parcel$export(module.exports, "BrickhouseTheme", function () { return $ec34120afaf0d3a1$export$2bfc74427d664a08; });
$parcel$export(module.exports, "DakotaTheme", function () { return $ec34120afaf0d3a1$export$b5509123a248d3f3; });
// Temporary place to put themes.
// In the future these should be loaded from a database.
// TODO - Remove things from here which are now delivered via CMS
var $ec34120afaf0d3a1$export$cd9fd31d4e88d2ee;
(function(ThemeIds) {
    ThemeIds["default"] = "default";
    ThemeIds["Titan"] = "titan";
    ThemeIds["Phobos"] = "phobos";
    ThemeIds["Hyperion"] = "hyperion";
    ThemeIds["Mimas"] = "mimas";
    ThemeIds["Rana"] = "rana";
    ThemeIds["Deimos"] = "deimos";
    ThemeIds["Umbra"] = "umbra";
    ThemeIds["Brickhouse"] = "brickhouse";
    ThemeIds["Dakota"] = "dakota";
})($ec34120afaf0d3a1$export$cd9fd31d4e88d2ee || ($ec34120afaf0d3a1$export$cd9fd31d4e88d2ee = {}));
const $ec34120afaf0d3a1$var$defaultLight = "#9E9E9E";
const $ec34120afaf0d3a1$var$defaultMid = "#1D1D1D";
const $ec34120afaf0d3a1$var$defaultDark = "#0c0c0cff";
const $ec34120afaf0d3a1$export$164de7ab8df77ef0 = {
    themeId: "default",
    title: "",
    loaded: false,
    assetBasePath: "/assets",
    fonts: {
        primary: "ChakraPetchTitle",
        secondary: "ChakraPetch",
        tertiary: "ChakraPetch",
        quaternary: "ChakraPetch"
    },
    files: {
        logo: "",
        // splash_bg: '',
        inventory_backdrop: "",
        instance_mark: ""
    },
    tokens: {
        AriseTheme1RarityRarityCommonLight: "#7f8693ff",
        AriseTheme1RarityRarityCommonMid: "#292f3aff",
        AriseTheme1RarityRarityCommonDark: "#1c2129ff",
        AriseTheme1RarityRarityUncommonLight: "#8fff97ff",
        AriseTheme1RarityRarityUncommonMid: "#265d3fff",
        AriseTheme1RarityRarityUncommonDark: "#12251bff",
        AriseTheme1RarityRarityRareLight: "#a7f0feff",
        AriseTheme1RarityRarityRareMid: "#19646fff",
        AriseTheme1RarityRarityRareDark: "#0e2f34ff",
        AriseTheme1RarityRarityEpicLight: "#e569fbff",
        AriseTheme1RarityRarityEpicMid: "#582f59ff",
        AriseTheme1RarityRarityEpicDark: "#3a1f3bff",
        AriseTheme1RarityRarityLegendaryLight: "#fd8917ff",
        AriseTheme1RarityRarityLegendaryMid: "#803e18ff",
        AriseTheme1RarityRarityLegendaryDark: "#40210fff",
        AriseTheme1StateStateErrorLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1StateStateErrorMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1StateStateErrorDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1StateStateSuccessLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1StateStateSuccessMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1StateStateSuccessDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1StateStateDefaultLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1StateStateDefaultMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1StateStateDefaultDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1UpdatesUpdatesPositiveLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1UpdatesUpdatesPositiveMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1UpdatesUpdatesPositiveDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1UpdatesUpdatesGeneralLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1UpdatesUpdatesGeneralMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1UpdatesUpdatesGeneralDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1UpdatesUpdatesAchievementLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1UpdatesUpdatesAchievementMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1UpdatesUpdatesAchievementDark: $ec34120afaf0d3a1$var$defaultDark,
        AriseTheme1UpdatesUpdatesNegativeLight: $ec34120afaf0d3a1$var$defaultLight,
        AriseTheme1UpdatesUpdatesNegativeMid: $ec34120afaf0d3a1$var$defaultMid,
        AriseTheme1UpdatesUpdatesNegativeDark: $ec34120afaf0d3a1$var$defaultDark,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: "#ffffffff",
        AccentTheme1InterfaceMonoInterfaceMonoActive: "#bdbdbdff",
        AccentTheme1InterfaceMonoInterfaceMonoForeground: "#797979",
        AccentTheme1InterfaceMonoInterfaceMonoMidground: "#1b1b1bff",
        AccentTheme1InterfaceMonoInterfaceMonoBackground: "#111111",
        AccentTheme1InterfaceMonoInterfaceMonoBlack: "#000000ff",
        AccentTheme1InterfaceBrandInterfaceActive: "#a8a8a8ff",
        AccentTheme1InterfaceBrandInterfaceForeground: "#797979",
        AccentTheme1InterfaceBrandInterfaceMidground: "#313131",
        AccentTheme1InterfaceBrandInterfaceBackground: "#111111",
        AccentTheme1BorderBorderDefault: "#9b9b9bff",
        AccentTheme1BorderBorderHighlight: "#c4c4c4ff",
        AccentTheme1BorderBorderInactive: "#5c5c5cff",
        AccentTheme1BorderBorderActive: "#d8d8d8ff",
        AccentTheme1BrandPaletteBrandAccent1: "#b3b3b3ff",
        AccentTheme1BrandPaletteBrandAccent2: "#262626",
        AccentTheme1BrandPaletteBrandContrast1: "#a0a0a0ff",
        AccentTheme1BrandPaletteBrandContrast2: "#8b8b8bff",
        AccentTheme1BrandPaletteBrandScale1: "#adadadff",
        AccentTheme1BrandPaletteBrandScale2: "#878787ff",
        AccentTheme1BrandPaletteBrandScale3: "#3f3f3fff",
        AccentTheme1BrandPaletteBrandColour: "#262626",
        AccentTheme1BrandPaletteBrandColourContrast: "#ffffffff",
        AccentTheme1ButtonButtonDefault: "#313131",
        AccentTheme1ButtonButtonHighlight: "#565656ff",
        AccentTheme1ButtonButtonActive: "#b7b7b7ff",
        AccentTheme1ButtonButtonInactive: "#545454ff",
        AccentTheme1ButtonButtonSecondaryDefault: "#666666",
        AccentTheme1ButtonButtonSecondaryHighlight: "#b5b5b5ff",
        AccentTheme1ButtonButtonSecondaryActive: "#c4c4c4ff",
        AccentTheme1ButtonButtonSecondaryInactive: "#3f3f3fff",
        AccentTheme1TextTextDefault: "#ffffffff",
        AccentTheme1TextTextInactive: "#797979",
        AccentTheme1TextTextBrand2: "#999999ff",
        AccentTheme1TextTextBrand1: "#9b9b9bff",
        AccentTheme1TextTextContrastDefault: "#151515ff",
        AccentTheme1TextTextLink: "#878787ff",
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: "#3a3a3aff",
        LEGACYAccentTheme1TextTextActive: "#ffffffff",
        LEGACYAccentTheme1TextTextSecondary: "#9d9d9dff",
        LEGACYAccentTheme1InterfaceInterfaceActive: "#9d9d9dff",
        LEGACYAccentTheme1InterfaceInterfaceForeground: "#2a2a2aff",
        LEGACYAccentTheme1InterfaceInterfaceMidground: "#141414ff",
        LEGACYAccentTheme1InterfaceInterfaceBackground: "#0f0f0fff",
        LEGACYAccentTheme1InterfaceInterfaceWhite: "#ffffffff",
        LEGACYAccentTheme1InterfaceInterfaceGrey: "#828282ff",
        LEGACYAccentTheme1InterfaceInterfaceBlack: "#0b0b0bff",
        LEGACYAccentTheme1BrandColour: "#8c8c8cff",
        LEGACYAccentTheme1BrandColourContrast: "#0b0b0bff"
    },
    customJSON: {}
};
const $ec34120afaf0d3a1$export$a53e903714f41d6f = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "titan",
    fonts: {
        primary: "CheapSignage",
        secondary: "Alexandria",
        tertiary: "Inter",
        quaternary: "Oswald"
    },
    tokens: {
        ...$ec34120afaf0d3a1$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: "#ffffffff",
        AccentTheme1InterfaceMonoInterfaceMonoActive: "#d7d7d7ff",
        AccentTheme1InterfaceMonoInterfaceMonoForeground: "#a5a5a5ff",
        AccentTheme1InterfaceMonoInterfaceMonoMidground: "#2c2c2cff",
        AccentTheme1InterfaceMonoInterfaceMonoBackground: "#1b1b1bff",
        AccentTheme1InterfaceMonoInterfaceMonoBlack: "#000000ff",
        AccentTheme1InterfaceBrandInterfaceActive: "#BCA8A8",
        AccentTheme1InterfaceBrandInterfaceForeground: "#796262",
        AccentTheme1InterfaceBrandInterfaceMidground: "#2A2E36",
        AccentTheme1InterfaceBrandInterfaceBackground: "#0F0F0F",
        AccentTheme1BorderBorderDefault: "#8e1f22ff",
        AccentTheme1BorderBorderHighlight: "#f02d32ff",
        AccentTheme1BorderBorderInactive: "#690508ff",
        AccentTheme1BorderBorderActive: "#fb3b40ff",
        AccentTheme1BrandPaletteBrandAccent1: "#d42126ff",
        AccentTheme1BrandPaletteBrandAccent2: "#d42126ff",
        AccentTheme1BrandPaletteBrandContrast1: "#93b6c6ff",
        AccentTheme1BrandPaletteBrandContrast2: "#57b4ddff",
        AccentTheme1BrandPaletteBrandScale1: "#d4a98aff",
        AccentTheme1BrandPaletteBrandScale2: "#a77e61ff",
        AccentTheme1BrandPaletteBrandScale3: "#3f3128ff",
        AccentTheme1BrandPaletteBrandColour: "#d42126ff",
        AccentTheme1BrandPaletteBrandColourContrast: "#ffffffff",
        AccentTheme1ButtonButtonDefault: "#d42126ff",
        AccentTheme1ButtonButtonHighlight: "#ff604bff",
        AccentTheme1ButtonButtonActive: "#ff2e00ff",
        AccentTheme1ButtonButtonInactive: "#3f1f1fff",
        AccentTheme1ButtonButtonSecondaryDefault: "#a7a7a7ff",
        AccentTheme1ButtonButtonSecondaryHighlight: "#cececeff",
        AccentTheme1ButtonButtonSecondaryActive: "#d8d8d8ff",
        AccentTheme1ButtonButtonSecondaryInactive: "#505050ff",
        AccentTheme1TextTextDefault: "#ffffffff",
        AccentTheme1TextTextInactive: "#505050ff",
        AccentTheme1TextTextBrand2: "#ca8e54ff",
        AccentTheme1TextTextBrand1: "#ff473bff",
        AccentTheme1TextTextContrastDefault: "#151515ff",
        AccentTheme1TextTextLink: "#a5a5a5ff",
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: "#dcdcdcff",
        LEGACYAccentTheme1TextTextActive: "#ffffffff",
        LEGACYAccentTheme1TextTextSecondary: "#dcdcdcff",
        LEGACYAccentTheme1InterfaceInterfaceActive: "#ffffffff",
        LEGACYAccentTheme1InterfaceInterfaceForeground: "#3d3d3dff",
        LEGACYAccentTheme1InterfaceInterfaceMidground: "#1e1e1eff",
        LEGACYAccentTheme1InterfaceInterfaceBackground: "#151515ff",
        LEGACYAccentTheme1InterfaceInterfaceWhite: "#ffffffff",
        LEGACYAccentTheme1InterfaceInterfaceGrey: "#bdbdbdff",
        LEGACYAccentTheme1InterfaceInterfaceBlack: "#000000ff",
        LEGACYAccentTheme1BrandColour: "#e81f25ff",
        LEGACYAccentTheme1BrandColourContrast: "#ffffffff"
    }
};
const $ec34120afaf0d3a1$export$dc830f52acce79df = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "phobos",
    tokens: {
        ...$ec34120afaf0d3a1$export$a53e903714f41d6f.tokens
    }
};
const $ec34120afaf0d3a1$export$b90c99545b77fd72 = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "hyperion",
    fonts: {
        ...$ec34120afaf0d3a1$export$164de7ab8df77ef0.fonts,
        quaternary: "HomePlanetBB"
    },
    tokens: {
        ...$ec34120afaf0d3a1$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: "#ffffffff",
        AccentTheme1InterfaceMonoInterfaceMonoActive: "#d7d7d7ff",
        AccentTheme1InterfaceMonoInterfaceMonoForeground: "#a5a5a5ff",
        AccentTheme1InterfaceMonoInterfaceMonoMidground: "#2c2c2cff",
        AccentTheme1InterfaceMonoInterfaceMonoBackground: "#1b1b1bff",
        AccentTheme1InterfaceMonoInterfaceMonoBlack: "#000000ff",
        AccentTheme1InterfaceBrandInterfaceActive: "#a8b2bcff",
        AccentTheme1InterfaceBrandInterfaceForeground: "#626b79ff",
        AccentTheme1InterfaceBrandInterfaceMidground: "#2a2e36ff",
        AccentTheme1InterfaceBrandInterfaceBackground: "#15191fff",
        AccentTheme1BorderBorderDefault: "#0ab4f3ff",
        AccentTheme1BorderBorderHighlight: "#2fc6ffff",
        AccentTheme1BorderBorderInactive: "#0d8ebfff",
        AccentTheme1BorderBorderActive: "#42c9fcff",
        AccentTheme1BrandPaletteBrandAccent1: "#00a0dcff",
        AccentTheme1BrandPaletteBrandAccent2: "#fbee23ff",
        AccentTheme1BrandPaletteBrandContrast1: "#ffffffff",
        AccentTheme1BrandPaletteBrandContrast2: "#000000ff",
        AccentTheme1BrandPaletteBrandScale1: "#5bd2ffff",
        AccentTheme1BrandPaletteBrandScale2: "#00a0dcff",
        AccentTheme1BrandPaletteBrandScale3: "#0c6485ff",
        AccentTheme1BrandPaletteBrandColour: "#00a0dcff",
        AccentTheme1BrandPaletteBrandColourContrast: "#ffffffff",
        AccentTheme1ButtonButtonDefault: "#00a0dcff",
        AccentTheme1ButtonButtonHighlight: "#0ab4f3ff",
        AccentTheme1ButtonButtonActive: "#00b9ffff",
        AccentTheme1ButtonButtonInactive: "#003447ff",
        AccentTheme1ButtonButtonSecondaryDefault: "#a7a7a7ff",
        AccentTheme1ButtonButtonSecondaryHighlight: "#cececeff",
        AccentTheme1ButtonButtonSecondaryActive: "#d8d8d8ff",
        AccentTheme1ButtonButtonSecondaryInactive: "#505050ff",
        AccentTheme1TextTextDefault: "#ffffffff",
        AccentTheme1TextTextInactive: "#505050ff",
        AccentTheme1TextTextBrand2: "#ca8e54ff",
        AccentTheme1TextTextBrand1: "#00a0dcff",
        AccentTheme1TextTextContrastDefault: "#151515ff",
        AccentTheme1TextTextLink: "#a5a5a5ff"
    }
};
const $ec34120afaf0d3a1$export$82c5380410702a78 = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "mimas",
    tokens: {
        ...$ec34120afaf0d3a1$export$164de7ab8df77ef0.tokens,
        AccentTheme1ButtonButtonDefault: "#FF6A00",
        AccentTheme1BrandPaletteBrandColour: "#FF6A00",
        AccentTheme1BrandPaletteBrandAccent1: "#FFAA01",
        AriseTheme1UpdatesUpdatesPositiveLight: "#CCCCCC",
        AriseTheme1UpdatesUpdatesPositiveMid: "#555555",
        AriseTheme1UpdatesUpdatesPositiveDark: "#0E0E0E",
        AriseTheme1UpdatesUpdatesGeneralLight: "#FFFFFF",
        AriseTheme1UpdatesUpdatesGeneralMid: "#909090",
        AriseTheme1UpdatesUpdatesGeneralDark: "#6B6B6B",
        AriseTheme1UpdatesUpdatesAchievementLight: "#FFEADA",
        AriseTheme1UpdatesUpdatesAchievementMid: "#FF6A00",
        AriseTheme1UpdatesUpdatesAchievementDark: "#A44400",
        AriseTheme1UpdatesUpdatesNegativeLight: "#FC3232",
        AriseTheme1UpdatesUpdatesNegativeMid: "#7F0B10",
        AriseTheme1UpdatesUpdatesNegativeDark: "#200506",
        AriseTheme1StateStateErrorLight: "#FFFFFF",
        AriseTheme1StateStateErrorMid: "#909090",
        AriseTheme1StateStateErrorDark: "#6B6B6B",
        AriseTheme1StateStateSuccessLight: "#CCCCCC",
        AriseTheme1StateStateSuccessMid: "#0E0E0E",
        AriseTheme1StateStateSuccessDark: "#0E0E0E"
    }
};
const $ec34120afaf0d3a1$export$619f3429ba3f527d = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "rana"
};
const $ec34120afaf0d3a1$export$51184b5f01eae579 = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "deimos"
};
const $ec34120afaf0d3a1$export$3e0b756d8b9d706e = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "umbra",
    tokens: {
        ...$ec34120afaf0d3a1$export$164de7ab8df77ef0.tokens,
        AccentTheme1InterfaceBrandInterfaceForeground: "#223757ff",
        AccentTheme1InterfaceBrandInterfaceMidground: "#0D2322",
        AccentTheme1InterfaceBrandInterfaceBackground: "#001614",
        AccentTheme1InterfaceMonoInterfaceMonoBackground: "#0D2322",
        AccentTheme1InterfaceMonoInterfaceMonoMidground: "#0D2322",
        AccentTheme1ButtonButtonDefault: "#194543ff",
        AccentTheme1ButtonButtonHighlight: "#0D2322",
        AccentTheme1TextTextDefault: "#ffffffff",
        AccentTheme1BrandPaletteBrandAccent1: "#79DBD6",
        AccentTheme1BrandPaletteBrandColour: "#0D2322",
        AriseTheme1UpdatesUpdatesPositiveLight: "#4390C0",
        AriseTheme1UpdatesUpdatesPositiveMid: "#20394C",
        AriseTheme1UpdatesUpdatesPositiveDark: "#0F1922",
        AriseTheme1UpdatesUpdatesGeneralLight: "#4FA5A2",
        AriseTheme1UpdatesUpdatesGeneralMid: "#274B4C",
        AriseTheme1UpdatesUpdatesGeneralDark: "#0D2322",
        AriseTheme1UpdatesUpdatesAchievementLight: "#79DBD6",
        AriseTheme1UpdatesUpdatesAchievementMid: "#274B4C",
        AriseTheme1UpdatesUpdatesAchievementDark: "#0D2322",
        AriseTheme1UpdatesUpdatesNegativeLight: "#FC3232",
        AriseTheme1UpdatesUpdatesNegativeMid: "#7F0B10",
        AriseTheme1UpdatesUpdatesNegativeDark: "#200506",
        AriseTheme1StateStateErrorLight: "#B55E5D",
        AriseTheme1StateStateErrorMid: "#351D1D",
        AriseTheme1StateStateErrorDark: "#180F0F",
        AriseTheme1StateStateSuccessLight: "#81CFCE",
        AriseTheme1StateStateSuccessMid: "#274B4C",
        AriseTheme1StateStateSuccessDark: "#0D2322",
        AriseTheme1StateStateDefaultLight: "#4390C0",
        AriseTheme1StateStateDefaultMid: "#20394C",
        AriseTheme1StateStateDefaultDark: "#0F1922"
    }
};
const $ec34120afaf0d3a1$export$2bfc74427d664a08 = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "brickhouse"
};
const $ec34120afaf0d3a1$export$b5509123a248d3f3 = {
    ...$ec34120afaf0d3a1$export$164de7ab8df77ef0,
    themeId: "dakota"
};

});

parcelRegister("f9aoP", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", function () { return $92d876b75800cd92$export$3c4602e16d9ace38; });
$parcel$export(module.exports, "getAuthToken", function () { return $92d876b75800cd92$export$38e1f53b76ec7fed; });
$parcel$export(module.exports, "setUniverseID", function () { return $92d876b75800cd92$export$a40109d413fb54d2; });
$parcel$export(module.exports, "register", function () { return $92d876b75800cd92$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "createProfile", function () { return $92d876b75800cd92$export$6660b028f5be10a7; });
$parcel$export(module.exports, "editProfile", function () { return $92d876b75800cd92$export$b48a0400035b8336; });
$parcel$export(module.exports, "setUserCurrentAsset", function () { return $92d876b75800cd92$export$23b525d73e27f867; });
$parcel$export(module.exports, "unsetUserCurrentAsset", function () { return $92d876b75800cd92$export$ca16a15978424500; });
$parcel$export(module.exports, "addProfileTitle", function () { return $92d876b75800cd92$export$9dfcfbbdda3e8151; });
$parcel$export(module.exports, "addProfileBadge", function () { return $92d876b75800cd92$export$9190de6d98541d88; });
$parcel$export(module.exports, "setProfileTitle", function () { return $92d876b75800cd92$export$982894037bdd2b82; });
$parcel$export(module.exports, "setProfileFaction", function () { return $92d876b75800cd92$export$63f1075dd6373efe; });
$parcel$export(module.exports, "login", function () { return $92d876b75800cd92$export$596d806903d1f59e; });
$parcel$export(module.exports, "loginAsGuest", function () { return $92d876b75800cd92$export$cac7a67f197c8403; });
$parcel$export(module.exports, "oAuthExchange", function () { return $92d876b75800cd92$export$61e4f6c18a9ae3d3; });
$parcel$export(module.exports, "passwordReset", function () { return $92d876b75800cd92$export$ee2fcf8e7aed6a8; });
$parcel$export(module.exports, "passwordChange", function () { return $92d876b75800cd92$export$4f6a6a61ca2ea38; });
$parcel$export(module.exports, "me", function () { return $92d876b75800cd92$export$3e32638432616b6; });
$parcel$export(module.exports, "getAreas", function () { return $92d876b75800cd92$export$67b1a98bf17825a2; });
$parcel$export(module.exports, "getLocations", function () { return $92d876b75800cd92$export$c07c686062478869; });
$parcel$export(module.exports, "getRegions", function () { return $92d876b75800cd92$export$14682eeac6801e56; });
$parcel$export(module.exports, "getUserOwnedAssets", function () { return $92d876b75800cd92$export$9f8fe36349548c9e; });
$parcel$export(module.exports, "getBackgrounds", function () { return $92d876b75800cd92$export$4ca6af37edce589f; });
$parcel$export(module.exports, "getCharacters", function () { return $92d876b75800cd92$export$1a274d8250f0d7c4; });
$parcel$export(module.exports, "getFactions", function () { return $92d876b75800cd92$export$dc78d06890d2a1b4; });
$parcel$export(module.exports, "getFactionSettings", function () { return $92d876b75800cd92$export$21f920853926909c; });
$parcel$export(module.exports, "getSceneSelectorSettings", function () { return $92d876b75800cd92$export$1665209a71d448bd; });
$parcel$export(module.exports, "getProfiles", function () { return $92d876b75800cd92$export$585c1c8d79d3e628; });
$parcel$export(module.exports, "getTitles", function () { return $92d876b75800cd92$export$965b5fd3c89734c9; });
$parcel$export(module.exports, "getCurrentUserProfileV2", function () { return $92d876b75800cd92$export$eb34882c86121926; });
$parcel$export(module.exports, "getAvailableTitles", function () { return $92d876b75800cd92$export$1ad62c2a69d5bd2; });
$parcel$export(module.exports, "getAvailableBadges", function () { return $92d876b75800cd92$export$4b8380d51d91c627; });
$parcel$export(module.exports, "setProfileMissionCompleted", function () { return $92d876b75800cd92$export$b71e06acfb528d9e; });
$parcel$export(module.exports, "resetProfileMissionCompleted", function () { return $92d876b75800cd92$export$3db22106dcbe396f; });
$parcel$export(module.exports, "resetProfileBadges", function () { return $92d876b75800cd92$export$a4b2cc08ab31359a; });
$parcel$export(module.exports, "resetProfileTitles", function () { return $92d876b75800cd92$export$4634c4b4f068f3e6; });
$parcel$export(module.exports, "logout", function () { return $92d876b75800cd92$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "lastChats", function () { return $92d876b75800cd92$export$cafaddd023065ca3; });
$parcel$export(module.exports, "sendMessage", function () { return $92d876b75800cd92$export$465cb47180de50f0; });
$parcel$export(module.exports, "sendCommand", function () { return $92d876b75800cd92$export$73568989eb8fa899; });
$parcel$export(module.exports, "getMedia", function () { return $92d876b75800cd92$export$a854ab43349813f2; });
$parcel$export(module.exports, "getUniverseMetadata", function () { return $92d876b75800cd92$export$ce7a1c7c49373e0f; });
$parcel$export(module.exports, "getInventory", function () { return $92d876b75800cd92$export$49d4f2709aaa7675; });
$parcel$export(module.exports, "takeItem", function () { return $92d876b75800cd92$export$6cf716400a40251e; });
$parcel$export(module.exports, "dropItem", function () { return $92d876b75800cd92$export$c52897da6060f038; });
$parcel$export(module.exports, "toggleMessageReaction", function () { return $92d876b75800cd92$export$374ea87e421dfcbd; });
$parcel$export(module.exports, "listReactionTypes", function () { return $92d876b75800cd92$export$1d06f08a48d351a6; });
$parcel$export(module.exports, "deleteMessage", function () { return $92d876b75800cd92$export$b7572a81e749f23f; });
$parcel$export(module.exports, "banUser", function () { return $92d876b75800cd92$export$79caefb11d80e008; });
$parcel$export(module.exports, "getArisewareState", function () { return $92d876b75800cd92$export$64134de32d67ad9c; });
$parcel$export(module.exports, "updateArisewareState", function () { return $92d876b75800cd92$export$d09d18a35643cf7e; });
$parcel$export(module.exports, "failedAriseware", function () { return $92d876b75800cd92$export$21f38724403a0b93; });
$parcel$export(module.exports, "getArisewareScoresForUser", function () { return $92d876b75800cd92$export$955dbe6c8b0c40c3; });
$parcel$export(module.exports, "submitArisewareScore", function () { return $92d876b75800cd92$export$2ffd3871cec7b2d9; });
$parcel$export(module.exports, "submitFeedUpdate", function () { return $92d876b75800cd92$export$e36b950b6d863b55; });
$parcel$export(module.exports, "searchByDisplayName", function () { return $92d876b75800cd92$export$3c6a03b5f9aad8de; });
$parcel$export(module.exports, "getEventById", function () { return $92d876b75800cd92$export$d89643108630328f; });
$parcel$export(module.exports, "tokenExchange", function () { return $92d876b75800cd92$export$bbbf59fcba7cc7a5; });
$parcel$export(module.exports, "heartbeat", function () { return $92d876b75800cd92$export$cae72505676c6ee7; });
$parcel$export(module.exports, "scrollV2", function () { return $92d876b75800cd92$export$2e87daf0acb6f156; });
$parcel$export(module.exports, "getInstanceData", function () { return $92d876b75800cd92$export$4fa9bff493b99b77; });
$parcel$export(module.exports, "getAssetPacks", function () { return $92d876b75800cd92$export$bac712d3b6774391; });
$parcel$export(module.exports, "getShopExternalItems", function () { return $92d876b75800cd92$export$853594461ca82308; });
$parcel$export(module.exports, "checkoutShopItem", function () { return $92d876b75800cd92$export$f0d2d182751d3250; });
$parcel$export(module.exports, "getSessionStatus", function () { return $92d876b75800cd92$export$6f5cc5586c0c38b3; });
$parcel$export(module.exports, "getMyPrizes", function () { return $92d876b75800cd92$export$dc3259cd9852d1fc; });
$parcel$export(module.exports, "getNewsModal", function () { return $92d876b75800cd92$export$46467cd6f4ed0eba; });
$parcel$export(module.exports, "getSupplyRunLeaderboardData", function () { return $92d876b75800cd92$export$2d40d82c3909ac8a; });
$parcel$export(module.exports, "getSupplyRunUserProfileStats", function () { return $92d876b75800cd92$export$1f95aa99543d6cd7; });
$parcel$export(module.exports, "getNewsTickerData", function () { return $92d876b75800cd92$export$589937ab777fd063; });
$parcel$export(module.exports, "getTranslations", function () { return $92d876b75800cd92$export$a7e3aedd9ea505f2; });
$parcel$export(module.exports, "userEvent", function () { return $92d876b75800cd92$export$654456eab607fa62; });
$parcel$export(module.exports, "getPollData", function () { return $92d876b75800cd92$export$1bbe11425004cf13; });
$parcel$export(module.exports, "submitPollVote", function () { return $92d876b75800cd92$export$6ce1780c266b47d2; });
$parcel$export(module.exports, "getGenericLeaderboardData", function () { return $92d876b75800cd92$export$c32ea153aed7ef7c; });
$parcel$export(module.exports, "submitScore", function () { return $92d876b75800cd92$export$22f3e7e7d561b982; });

var $aTKgi = parcelRequire("aTKgi");

var $g4EEF = parcelRequire("g4EEF");

var $fL4mk = parcelRequire("fL4mk");

var $lXNKs = parcelRequire("lXNKs");

var $3TCPC = parcelRequire("3TCPC");

var $aTRs6 = parcelRequire("aTRs6");

var $bEiLm = parcelRequire("bEiLm");
const $92d876b75800cd92$var$API_HOST = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? "/.proxy/api" : "https://api.ariseworlds.com";
const $92d876b75800cd92$var$STATIC_DATA_HOST = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? "/.proxy/static-data" : "https://static-data.ariseworlds.com";
const $92d876b75800cd92$var$LOCAL_FILE_PREFIX = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? "/.proxy" : "";
const $92d876b75800cd92$var$AUTHTOKEN_KEY = "ARISEENGINE_AUTHTOKEN";
let $92d876b75800cd92$var$authToken = "";
let $92d876b75800cd92$var$currentUserId = "";
let $92d876b75800cd92$var$universeID = window.localStorage.getItem("ARISE_UNIVERSEID") || "718b65bf-9225-48da-93f2-6a7255127896";
const $92d876b75800cd92$var$USE_STATIC_DATA = true; // If true, use json from public/staticData where possible
(0, $lXNKs.manageTokenExpiry)();
if (typeof window !== "undefined") {
    $92d876b75800cd92$var$authToken = window.localStorage.getItem($92d876b75800cd92$var$AUTHTOKEN_KEY) || "";
    $92d876b75800cd92$var$setCurrentUserId();
}
function $92d876b75800cd92$export$3c4602e16d9ace38(token) {
    if (!token || !(0, $lXNKs.isJWTFormat)(token)) {
        console.warn("Tried to call setAuthToken with an invalid or incorrectly formatted token:", token);
        return;
    }
    $92d876b75800cd92$var$authToken = token;
    window.localStorage.setItem($92d876b75800cd92$var$AUTHTOKEN_KEY, token);
    // manageTokenExpiry();
    $92d876b75800cd92$var$setCurrentUserId();
}
function $92d876b75800cd92$var$setCurrentUserId() {
    try {
        const data = (0, $lXNKs.getTokenPayload)($92d876b75800cd92$var$authToken);
        $92d876b75800cd92$var$currentUserId = data.sub || "";
    } catch (error) {}
}
function $92d876b75800cd92$export$38e1f53b76ec7fed() {
    return $92d876b75800cd92$var$authToken;
}
function $92d876b75800cd92$export$a40109d413fb54d2(id) {
    $92d876b75800cd92$var$universeID = id;
}
async function $92d876b75800cd92$export$6503ec6e8aabbaf(email, password, turnstileToken) {
    const body = {
        email: email,
        password: password,
        turnstileToken: turnstileToken
    };
    return await $92d876b75800cd92$var$call("/register", "POST", body);
}
async function $92d876b75800cd92$export$6660b028f5be10a7(body) {
    return await $92d876b75800cd92$var$call("/profile/new", "POST", body);
}
async function $92d876b75800cd92$export$b48a0400035b8336(profileId, body) {
    return await $92d876b75800cd92$var$call(`/profile/${profileId}`, "PUT", body);
}
async function $92d876b75800cd92$export$23b525d73e27f867(assetType, assetID) {
    const body = {
        universeID: $92d876b75800cd92$var$universeID,
        assetID: assetID,
        assetType: assetType
    };
    return await $92d876b75800cd92$var$call(`/userCurrentAssets`, "POST", body);
}
async function $92d876b75800cd92$export$ca16a15978424500(assetType) {
    const body = {
        universeID: $92d876b75800cd92$var$universeID,
        assetType: assetType
    };
    return await $92d876b75800cd92$var$call(`/userCurrentAssets`, "DELETE", body);
}
async function $92d876b75800cd92$export$9dfcfbbdda3e8151(id) {
    const body = {
        id: id
    };
    if ($92d876b75800cd92$var$authToken) return await $92d876b75800cd92$var$call("/profileTitle/add", "POST", body);
}
async function $92d876b75800cd92$export$9190de6d98541d88(rank) {
    const body = {
        rank: rank
    };
    if ($92d876b75800cd92$var$authToken) return await $92d876b75800cd92$var$call("/profileBadge/add", "POST", body);
}
async function $92d876b75800cd92$export$982894037bdd2b82(id) {
    const body = {
        id: id
    };
    return await $92d876b75800cd92$var$call("/profileTitle/set", "PUT", body);
}
async function $92d876b75800cd92$export$63f1075dd6373efe(factionID) {
    const body = {
        factionID: factionID
    };
    return await $92d876b75800cd92$var$call("/userFaction", "PUT", body);
}
async function $92d876b75800cd92$export$596d806903d1f59e(email, password) {
    const body = {
        email: email,
        password: password
    };
    const res = await $92d876b75800cd92$var$call("/login", "POST", body);
    $92d876b75800cd92$export$3c4602e16d9ace38(res.authToken);
}
async function $92d876b75800cd92$export$cac7a67f197c8403() {
    const res = await $92d876b75800cd92$var$call("/login/guest", "POST");
    $92d876b75800cd92$export$3c4602e16d9ace38(res.authToken);
}
async function $92d876b75800cd92$export$61e4f6c18a9ae3d3(token) {
    const res = await $92d876b75800cd92$var$call(`/auth/oauth/exchange`, "POST", {
        token: token
    });
    $92d876b75800cd92$export$3c4602e16d9ace38(res.authToken);
}
async function $92d876b75800cd92$export$ee2fcf8e7aed6a8(email) {
    await $92d876b75800cd92$var$call(`/auth/password-reset`, "POST", {
        email: email
    });
}
async function $92d876b75800cd92$export$4f6a6a61ca2ea38(email, token, password) {
    await $92d876b75800cd92$var$call(`/auth/password-change`, "POST", {
        email: email,
        token: token,
        password: password
    });
}
async function $92d876b75800cd92$export$3e32638432616b6() {
    try {
        const res = await $92d876b75800cd92$var$call("/me", "GET");
        return res;
    } catch (error) {
        throw error;
    }
}
async function $92d876b75800cd92$var$call(path, method, body, apiHostOverride) {
    const apiHost = apiHostOverride ?? $92d876b75800cd92$var$API_HOST;
    const additionalHeaders = {};
    let response = await fetch(`${apiHost}${path}`, {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            "Content-Type": "application/json",
            "X-Auth-Token": $92d876b75800cd92$var$authToken,
            "X-Universe-ID": $92d876b75800cd92$var$universeID,
            ...additionalHeaders
        }
    });
    if (!response.ok) {
        // Try to parse the error code from the response body
        let errorMessage = "UNKNOWN_ERROR"; // Fallback
        try {
            const errorBody = await response.json();
            errorMessage = errorBody.errorCode ?? "UNKNOWN_ERROR";
        } catch  {}
        throw new Error(errorMessage);
    }
    return await response.json();
}
async function $92d876b75800cd92$var$callStatic(path) {
    try {
        let response = await fetch(`${$92d876b75800cd92$var$STATIC_DATA_HOST}/${$92d876b75800cd92$var$universeID}-${path}`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("UNKNOWN_ERROR");
        return await response.json();
    } catch (error) {
        console.error(`Static data missing or invalid: /staticData/${path}`);
        throw new Error("UNKNOWN_ERROR");
    }
}
async function $92d876b75800cd92$var$callPath(path) {
    try {
        let response = await fetch(`${$92d876b75800cd92$var$LOCAL_FILE_PREFIX}/${path}`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("UNKNOWN_ERROR");
        return await response.json();
    } catch (error) {
        console.error(`Could not call path ${path}`);
        throw new Error("UNKNOWN_ERROR");
    }
}
function $92d876b75800cd92$var$sendBeaconWithFallback(path, data, apiHostOverride) {
    const apiHost = apiHostOverride ?? $92d876b75800cd92$var$API_HOST;
    const url = `${apiHost}${path}`;
    const payload = JSON.stringify(data);
    try {
        if (!navigator?.sendBeacon) throw new Error("sendBeacon not supported");
        const ok = navigator.sendBeacon(url, payload);
        if (!ok) throw new Error("sendBeacon failed");
    } catch  {
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "text/plain"
            },
            body: payload,
            keepalive: true
        }).catch(()=>{
        // Fail silently
        });
    }
}
// Make a request with a maximum timeout and default value
const $92d876b75800cd92$var$withTimeout = async (request, timeoutMs, defaultValue)=>{
    const timeout = new Promise((resolve)=>setTimeout(()=>{
            resolve(defaultValue);
        }, timeoutMs));
    try {
        return await Promise.race([
            request,
            timeout
        ]);
    } catch  {
        return defaultValue;
    }
};
async function $92d876b75800cd92$export$67b1a98bf17825a2(limit = 100) {
    return await $92d876b75800cd92$var$call(`/area/list?universeID=${$92d876b75800cd92$var$universeID}&limit=${limit}`, "GET");
}
async function $92d876b75800cd92$export$c07c686062478869(limit = 100) {
    let locations = $92d876b75800cd92$var$USE_STATIC_DATA ? await $92d876b75800cd92$var$callStatic("locations.json") : await $92d876b75800cd92$var$call(`/environment/list?universeID=${$92d876b75800cd92$var$universeID}&limit=${limit}`, "GET");
    locations = (0, $aTKgi.parsePayloadURLS)(locations);
    return locations.map((location)=>(0, $g4EEF.processLocationData)(location));
}
async function $92d876b75800cd92$export$14682eeac6801e56(limit = 100) {
    return await $92d876b75800cd92$var$call(`/region/list?universeID=${$92d876b75800cd92$var$universeID}&limit=${limit}`, "GET");
}
async function $92d876b75800cd92$export$9f8fe36349548c9e() {
    return await $92d876b75800cd92$var$call(`/userOwnedAssets`, "GET");
}
async function $92d876b75800cd92$export$4ca6af37edce589f() {
    return await $92d876b75800cd92$var$call(`/background/list`, "GET");
}
async function $92d876b75800cd92$export$1a274d8250f0d7c4() {
    return await $92d876b75800cd92$var$call(`/character/list`, "GET");
}
async function $92d876b75800cd92$export$f6d6ee07efc33b16() {
    return await $92d876b75800cd92$var$call(`/avatarFrame/list`, "GET");
}
async function $92d876b75800cd92$export$dc78d06890d2a1b4() {
    return await $92d876b75800cd92$var$call(`/faction/list`, "GET");
}
async function $92d876b75800cd92$export$21f920853926909c() {
    return await $92d876b75800cd92$var$call(`/factionSettings/list`, "GET");
}
async function $92d876b75800cd92$export$1665209a71d448bd() {
    const res = await $92d876b75800cd92$var$call(`/sceneSelectorSettings/list`, "GET");
    return (0, $aTKgi.parsePayloadURLS)(res);
}
async function $92d876b75800cd92$export$585c1c8d79d3e628(userIds) {
    const params = userIds.map((userId)=>`id=${userId}`).join("&");
    const profiles = await $92d876b75800cd92$var$call(`/profile/list?${params}`, "GET");
    return profiles.map((profile)=>(0, $fL4mk.processProfileData)(profile));
}
async function $92d876b75800cd92$export$965b5fd3c89734c9(userId, forceUseRemoteData) {
    // Legacy
    if ($92d876b75800cd92$var$USE_STATIC_DATA) {
        const localTitles = await (0, $3TCPC.getLocalUserTitles)();
        if (localTitles.length && !forceUseRemoteData) return localTitles;
        else {
            const id = userId || $92d876b75800cd92$var$currentUserId; // If no user id passed in, try use local currentUserId
            if (!id) return localTitles;
            // If there are no local titles or forceUseRemoteData is true, try get remote titles
            const remoteTitles = await $92d876b75800cd92$var$withTimeout($92d876b75800cd92$var$call(`/profile/title/history/${id}`, "GET"), 5000, []);
            if (Array.isArray(remoteTitles) && remoteTitles.length) {
                (0, $3TCPC.setLocalUserTitles)(remoteTitles);
                return remoteTitles;
            }
            // If remote is empty or failed, return local
            return localTitles;
        }
    } else return await $92d876b75800cd92$var$call(`/profile/title/history/${userId}`, "GET");
}
async function $92d876b75800cd92$export$eb34882c86121926() {
    // If localstorage version return that, otherwise return remote profile
    const localProfile = (0, $bEiLm.getProfileV2FromLocalStorage)();
    if (localProfile) return localProfile;
    if ($92d876b75800cd92$var$currentUserId) {
        const remoteResponse = await $92d876b75800cd92$var$withTimeout($92d876b75800cd92$var$call(`/profiles/${$92d876b75800cd92$var$currentUserId}`, "GET"), 5000, null);
        return remoteResponse.profile;
    }
}
async function $92d876b75800cd92$export$1ad62c2a69d5bd2() {
    const result = await $92d876b75800cd92$var$callStatic("titleList.json");
    return (0, $fL4mk.processTitles)(result);
}
async function $92d876b75800cd92$export$4b8380d51d91c627() {
    return await $92d876b75800cd92$var$callStatic("badges.json");
}
async function $92d876b75800cd92$export$b71e06acfb528d9e() {
    return await $92d876b75800cd92$var$call(`/profile/mission-completed`, "POST");
}
async function $92d876b75800cd92$export$3db22106dcbe396f() {
    return await $92d876b75800cd92$var$call(`/profile/reset-mission-completed`, "POST");
}
async function $92d876b75800cd92$export$a4b2cc08ab31359a() {
    return await $92d876b75800cd92$var$call(`/profile/reset-badges`, "POST");
}
async function $92d876b75800cd92$export$4634c4b4f068f3e6() {
    return await $92d876b75800cd92$var$call(`/profile/reset-titles`, "POST");
}
async function $92d876b75800cd92$export$a0973bcfe11b05c9() {
    // TODO: call logout endpoint
    $92d876b75800cd92$export$3c4602e16d9ace38("");
}
async function $92d876b75800cd92$export$cafaddd023065ca3(locationId, from, num, isGlobalChat, isLatest) {
    // time is a unix timestamp in seconds, or 'latest' if first call
    const time = isLatest ? "latest" : from || Math.ceil(Date.now() / 1000);
    num = num || (0, $aTRs6.FEED_MESSAGES_TO_LOAD);
    const messages = await $92d876b75800cd92$var$call(`/chat/lastChats?locationID=${locationId}&time=${time}&num=${num}${isGlobalChat ? "&globalchat=true" : ""}`, "GET");
    return messages.map((message)=>{
        if (message.data.profile) message.data.profile = (0, $fL4mk.processProfileData)(message.data.profile);
        return message;
    });
}
async function $92d876b75800cd92$export$465cb47180de50f0(locationId, message) {
    const body = {
        locationID: locationId,
        chatText: message
    };
    return await $92d876b75800cd92$var$call(`/chat`, "POST", body);
}
async function $92d876b75800cd92$export$73568989eb8fa899(locationId, command) {
    const body = {
        environmentID: locationId,
        command: command
    };
    return await $92d876b75800cd92$var$call(`/command`, "POST", body);
}
async function $92d876b75800cd92$export$a854ab43349813f2(universeId) {
    const res = $92d876b75800cd92$var$USE_STATIC_DATA ? await $92d876b75800cd92$var$callStatic("universeMedia.json") : await $92d876b75800cd92$var$call(`/universeMedia/` + universeId, "GET");
    return (0, $aTKgi.parsePayloadURLS)(res);
}
async function $92d876b75800cd92$export$ce7a1c7c49373e0f(universeId = $92d876b75800cd92$var$universeID) {
    const res = $92d876b75800cd92$var$USE_STATIC_DATA ? await $92d876b75800cd92$var$callStatic("universe.json") : await $92d876b75800cd92$var$call(`/universe/` + universeId, "GET");
    return (0, $aTKgi.parsePayloadURLS)(res);
}
async function $92d876b75800cd92$export$49d4f2709aaa7675() {
    const response = await $92d876b75800cd92$var$call(`/inventory`, "GET");
    const inventory = response.map((d)=>{
        return {
            id: d.id,
            itemId: d.item.id,
            name: d.item.name,
            description: d.item.description,
            inventoryThumbnailUrl: d.item.imagePath ? (0, $aTKgi.pathToURL)(d.item.imagePath) : d.item.imageURL,
            customJson: d.item.customJson
        };
    });
    return inventory;
}
async function $92d876b75800cd92$export$6cf716400a40251e(itemId) {
    return $92d876b75800cd92$var$call(`/inventory`, "POST", {
        universeID: $92d876b75800cd92$var$universeID,
        itemID: itemId
    });
}
async function $92d876b75800cd92$export$c52897da6060f038(inventoryItemId) {
    return $92d876b75800cd92$var$call(`/inventory/${inventoryItemId}`, "DELETE");
}
async function $92d876b75800cd92$export$374ea87e421dfcbd(messageId, reaction, locationId) {
    return await $92d876b75800cd92$var$call(`/reaction/toggle`, "POST", {
        chatID: messageId,
        reaction: reaction,
        environmentID: locationId
    });
}
async function $92d876b75800cd92$export$1d06f08a48d351a6() {
    return await $92d876b75800cd92$var$call(`/reactions/list`, "GET");
}
async function $92d876b75800cd92$export$b7572a81e749f23f(messageId) {
    return await $92d876b75800cd92$var$call(`/moderationActions/removeChat`, "PUT", {
        ChatID: messageId
    });
}
async function $92d876b75800cd92$export$79caefb11d80e008(userID, seconds, reason) {
    const bannedUntil = new Date(Date.now() + seconds * 1000).toISOString();
    return await $92d876b75800cd92$var$call(`/moderationActions/ban`, "POST", {
        userID: userID,
        bannedUntil: bannedUntil,
        reason: reason
    });
}
async function $92d876b75800cd92$export$64134de32d67ad9c(projectId) {
    return await $92d876b75800cd92$var$call(`/ariseware/state/${projectId}`, "GET");
}
async function $92d876b75800cd92$export$d09d18a35643cf7e(projectId, data) {
    return await $92d876b75800cd92$var$call(`/ariseware/state/${projectId}`, "PUT", data);
}
async function $92d876b75800cd92$export$21f38724403a0b93(projectId) {
    // TODO: remove
    return new Promise((resolve)=>setTimeout(resolve, 1000));
// return await call<any>(`/ariseware/failed/${projectId}`, 'POST');
}
async function $92d876b75800cd92$export$955dbe6c8b0c40c3(userId) {
    return await $92d876b75800cd92$var$call(`/arisewareScore/${userId}`, "GET");
}
async function $92d876b75800cd92$export$2ffd3871cec7b2d9(data) {
    // Legacy
    return await $92d876b75800cd92$var$call(`/arisewareScore`, "PUT", data);
}
async function $92d876b75800cd92$export$e36b950b6d863b55(locationId, id) {
    return await $92d876b75800cd92$var$call(`/feedUpdate`, "POST", {
        environmentID: locationId,
        id: id
    });
}
async function $92d876b75800cd92$export$3c6a03b5f9aad8de(query) {
    return await $92d876b75800cd92$var$call(`/profile/searchByDisplayName?query=${encodeURIComponent(query)}`, "GET");
}
async function $92d876b75800cd92$export$d89643108630328f(eventID) {
    return await $92d876b75800cd92$var$call(`/chatEvent?eventID=${eventID}`, "GET");
}
async function $92d876b75800cd92$export$bbbf59fcba7cc7a5(token, source) {
    const res = await $92d876b75800cd92$var$call(`/auth/tokenExchange`, "POST", {
        token: token,
        source: source
    });
    $92d876b75800cd92$export$3c4602e16d9ace38(res.ariseToken);
    return res;
}
let $92d876b75800cd92$var$_heartbeat_has_joined = false;
async function $92d876b75800cd92$export$cae72505676c6ee7(locationId) {
    if (!$92d876b75800cd92$var$authToken) return;
    try {
        await $92d876b75800cd92$var$call("/presence/heartbeat", "POST", {
            environmentId: locationId,
            ...!$92d876b75800cd92$var$_heartbeat_has_joined && {
                joinedLocation: true
            }
        });
        $92d876b75800cd92$var$_heartbeat_has_joined = true;
    } catch (error) {
        console.error("Failed to send heartbeat", error);
    }
}
async function $92d876b75800cd92$export$209876d7b1ac8f3(data) {
    let apiHostOverride = null;
    console.log("--env", "prod");
    return await $92d876b75800cd92$var$call(`/scroll`, "POST", data, apiHostOverride);
}
async function $92d876b75800cd92$export$2e87daf0acb6f156(data, useBeacon) {
    const PATH = "/scrollv2";
    if (useBeacon) $92d876b75800cd92$var$sendBeaconWithFallback(PATH, data);
    else return await $92d876b75800cd92$var$call(PATH, "POST", data);
}
function $92d876b75800cd92$export$4fa9bff493b99b77() {
    return {
        universeID: $92d876b75800cd92$var$universeID,
        userAuthToken: $92d876b75800cd92$var$authToken,
        apiHost: $92d876b75800cd92$var$API_HOST
    };
}
async function $92d876b75800cd92$export$bac712d3b6774391() {
    return await $92d876b75800cd92$var$call(`/assetpack/list`, "GET");
}
async function $92d876b75800cd92$export$853594461ca82308() {
    return await $92d876b75800cd92$var$call(`/shop/external`, "GET");
}
async function $92d876b75800cd92$export$f0d2d182751d3250(itemID, type) {
    let body = {
        items: [
            {
                type: type,
                id: itemID
            }
        ],
        redirectURL: window.location.href + "?checkout=true"
    };
    return await $92d876b75800cd92$var$call("/shop/checkout", "POST", body);
}
async function $92d876b75800cd92$export$6f5cc5586c0c38b3(id) {
    return await $92d876b75800cd92$var$call(`/shop/checkout/${id}`, "GET");
}
async function $92d876b75800cd92$export$dc3259cd9852d1fc() {
    return await $92d876b75800cd92$var$call(`/prizes/list`, "GET");
}
async function $92d876b75800cd92$export$46467cd6f4ed0eba() {
    return await $92d876b75800cd92$var$call(`/modal/list`, "GET");
}
// Supply run APIs
const $92d876b75800cd92$var$SUPPLY_RUN_API_HOST = undefined;
async function $92d876b75800cd92$export$2d40d82c3909ac8a() {
    return await $92d876b75800cd92$var$call(`/supply-run/stats`, "GET", null, $92d876b75800cd92$var$SUPPLY_RUN_API_HOST);
}
async function $92d876b75800cd92$export$1f95aa99543d6cd7(userID) {
    return await $92d876b75800cd92$var$call(`/supply-run/user-profile-stats?userId=${userID}`, "GET", null, $92d876b75800cd92$var$SUPPLY_RUN_API_HOST);
}
async function $92d876b75800cd92$export$589937ab777fd063() {
    return await $92d876b75800cd92$var$callStatic("newsTicker.json");
}
async function $92d876b75800cd92$export$a7e3aedd9ea505f2() {
    return await $92d876b75800cd92$var$call("/translations", "GET");
}
async function $92d876b75800cd92$export$654456eab607fa62(environmentID, eventType) {
    if ($92d876b75800cd92$var$authToken) {
        const body = {
            environmentID: environmentID,
            eventType: eventType
        };
        return await $92d876b75800cd92$var$call("/userEvents", "POST", body);
    }
}
async function $92d876b75800cd92$export$1bbe11425004cf13(id, numberOfResults = 5) {
    try {
        const res = await $92d876b75800cd92$var$call(`/polls/${id}?numberOfResults=${numberOfResults}`, "GET");
        return res;
    } catch (error) {
        console.error("Failed to fetch poll data", error);
        return $92d876b75800cd92$var$fetchStaticData(`/${id}.json`);
    }
}
async function $92d876b75800cd92$export$6ce1780c266b47d2(id, selectedOptionIds, numberOfResults = 5) {
    const body = {
        pollId: id,
        selectedOptionIds: selectedOptionIds
    };
    return await $92d876b75800cd92$var$call(`/polls/${id}/votes?numberOfResults=${numberOfResults}`, "POST", body);
}
async function $92d876b75800cd92$var$fetchStaticData(path) {
    const data = await fetch($92d876b75800cd92$var$STATIC_DATA_HOST + path).then((res)=>res.json()).catch(()=>null);
    return data;
}
async function $92d876b75800cd92$export$c32ea153aed7ef7c() {
    return await $92d876b75800cd92$var$call("/leaderboards", "GET");
}
async function $92d876b75800cd92$export$22f3e7e7d561b982(score) {
    const body = {
        score: score
    };
    return await $92d876b75800cd92$var$call("/leaderboards/submit", "POST", body);
}

});
parcelRegister("aTKgi", function(module, exports) {

$parcel$export(module.exports, "pathToURL", function () { return $86451450bb9389d8$export$730bcc5b37bd203c; });
$parcel$export(module.exports, "parsePayloadURLS", function () { return $86451450bb9389d8$export$f1f7f18ce5ce1e90; });

var $aTRs6 = parcelRequire("aTRs6");
function $86451450bb9389d8$export$730bcc5b37bd203c(path) {
    // if (path?.startsWith('/')) return path; // To allow local paths to work in storybook
    return path && (0, $aTRs6.CDN_HOST) + path;
}
function $86451450bb9389d8$export$f1f7f18ce5ce1e90(json) {
    if (!(0, $aTRs6.IS_DISCORD_ACTIVITY)) return json;
    // Ideally we don't do this here, and also not hardcode twd stuff.
    const jsonString = JSON.stringify(json).replaceAll("https://content.ariseworlds.com/ariseware/", "/.proxy/arisecontent/ariseware/").replaceAll("https://twd.dev.arise-engine.com/", "/.proxy/twddev/").replaceAll("https://cdn.ariseworlds.com/", "/.proxy/twdprod/").replaceAll('"/assets/', '"/.proxy/twdprod/assets/');
    return JSON.parse(jsonString);
}

});

parcelRegister("g4EEF", function(module, exports) {

$parcel$export(module.exports, "processLocationData", function () { return $359d7bcc1b2b519d$export$6bf8211c3d1a27a0; });
$parcel$export(module.exports, "isFeedOpen", function () { return $359d7bcc1b2b519d$export$258fc13dede33c6d; });

var $1bTT8 = parcelRequire("1bTT8");
function $359d7bcc1b2b519d$export$6bf8211c3d1a27a0(location) {
    return {
        ...location,
        isOpen: $359d7bcc1b2b519d$export$1699291294853e2a(location),
        isFeedOpen: $359d7bcc1b2b519d$export$258fc13dede33c6d(location)
    };
}
function $359d7bcc1b2b519d$export$1699291294853e2a(location) {
    // Default to open if there is no opening time
    const isAfterOpeningTime = !location.opensTime || (0, $1bTT8.msTimeDifferenceFromNow)(location.opensTime) <= 0;
    const isAfterClosingTime = location.closesTime && (0, $1bTT8.msTimeDifferenceFromNow)(location.closesTime) <= 0;
    return isAfterOpeningTime && !isAfterClosingTime;
}
function $359d7bcc1b2b519d$export$258fc13dede33c6d(location) {
    // Default to open if there is no opening time
    const isAfterFeedOpeningTime = !location.feedOpensTime || (0, $1bTT8.msTimeDifferenceFromNow)(location.feedOpensTime) <= 0;
    const isAfterFeedClosingTime = location.feedClosesTime && (0, $1bTT8.msTimeDifferenceFromNow)(location.feedClosesTime) <= 0;
    return isAfterFeedOpeningTime && !isAfterFeedClosingTime;
}

});
parcelRegister("1bTT8", function(module, exports) {

$parcel$export(module.exports, "msTimeDifferenceFromNow", function () { return $eb5cd48f4fed9935$export$f9df06a9562f6a5e; });
$parcel$export(module.exports, "millisecondsLeftFromTimeAndDuration", function () { return $eb5cd48f4fed9935$export$6e73a1cb7e512394; });
$parcel$export(module.exports, "msTimeDifferenceBetweenUTCDates", function () { return $eb5cd48f4fed9935$export$161d202e6e5e416c; });
$parcel$export(module.exports, "MAX_TIMEOUT", function () { return $eb5cd48f4fed9935$export$2e938eec3c826007; });
$parcel$export(module.exports, "secondsIntoTimeString", function () { return $eb5cd48f4fed9935$export$2728ca2f1217d22d; });
/**
 * Returns the time difference between an ISO date string and now
 * @param dateString example: 2023-12-27T15:05:00Z
 * @returns {number} number in ms
 */ function $eb5cd48f4fed9935$export$f9df06a9562f6a5e(dateString) {
    return new Date(dateString).getTime() - new Date().getTime();
}
function $eb5cd48f4fed9935$export$6e73a1cb7e512394(from, durationSeconds) {
    return Math.max(0, durationSeconds * 1000 - Math.floor(Date.now() - from));
}
function $eb5cd48f4fed9935$export$161d202e6e5e416c(dateString1, dateString2) {
    const time1 = new Date(dateString1).getTime();
    const time2 = new Date(dateString2).getTime();
    return Math.abs(time1 - time2);
}
const $eb5cd48f4fed9935$export$2e938eec3c826007 = 604800000;
function $eb5cd48f4fed9935$export$2728ca2f1217d22d(seconds) {
    if (seconds < 0) throw new Error("The number of seconds cannot be negative.");
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const secs = Math.floor(seconds % 60);
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0 || hours > 0 && secs > 0) parts.push(`${minutes}m`);
    if (secs > 0) parts.push(`${secs}s`);
    return parts.join(" ");
}

});


parcelRegister("fL4mk", function(module, exports) {

$parcel$export(module.exports, "processProfileData", function () { return $75b085eacb42c7cc$export$4c7c5ef3bd60c5e1; });
$parcel$export(module.exports, "processTitles", function () { return $75b085eacb42c7cc$export$fbf4e217491106b1; });
$parcel$export(module.exports, "setProfileAsset", function () { return $75b085eacb42c7cc$export$dac150185429c35d; });
$parcel$export(module.exports, "unsetProfileAsset", function () { return $75b085eacb42c7cc$export$68d8baec7d43174d; });
$parcel$export(module.exports, "setProfileTitle", function () { return $75b085eacb42c7cc$export$982894037bdd2b82; });
$parcel$export(module.exports, "profileHasOnboarded", function () { return $75b085eacb42c7cc$export$93c3c111f074f9c1; });

var $f9aoP = parcelRequire("f9aoP");

var $1bTT8 = parcelRequire("1bTT8");

var $aTKgi = parcelRequire("aTKgi");
function $75b085eacb42c7cc$export$4c7c5ef3bd60c5e1(profile) {
    return {
        ...profile,
        factionImageUrl: (0, $aTKgi.pathToURL)(profile.faction.imagePath),
        faction: {
            ...profile.faction,
            iconImageUrl: (0, $aTKgi.pathToURL)(profile.faction.iconPath)
        },
        isBanned: profile.bannedUntil && (0, $1bTT8.msTimeDifferenceFromNow)(profile.bannedUntil) > 0
    };
}
function $75b085eacb42c7cc$export$fbf4e217491106b1(titles) {
    if (!titles.length) return [];
    // Remove duplicates based on the title property
    const uniqueTitlesMap = new Map();
    titles?.forEach((title)=>{
        uniqueTitlesMap.set(title.title, title);
    });
    // Convert the map back to an array
    const uniqueTitles = Array.from(uniqueTitlesMap.values());
    // Define the order of rarities
    const rarityOrder = {
        common: 1,
        uncommon: 2,
        rare: 3,
        epic: 4,
        legendary: 5
    };
    // Sort the unique titles based on the rarity order (case-insensitive)
    uniqueTitles.sort((a, b)=>{
        const rarityA = rarityOrder[a.rarity.toLowerCase()] || 0;
        const rarityB = rarityOrder[b.rarity.toLowerCase()] || 0;
        return rarityA - rarityB;
    });
    return uniqueTitles;
}
async function $75b085eacb42c7cc$export$dac150185429c35d(type, itemId) {
    let wasSuccessful = false;
    try {
        await $f9aoP.setUserCurrentAsset(type, itemId);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user asset: ${type + " " + itemId}, ${error}`);
    }
    return wasSuccessful;
}
async function $75b085eacb42c7cc$export$68d8baec7d43174d(type) {
    try {
        await $f9aoP.unsetUserCurrentAsset(type);
    } catch (error) {
        console.warn(`Could not unset user asset type: ${type}, ${error}`);
    }
}
async function $75b085eacb42c7cc$export$982894037bdd2b82(id) {
    let wasSuccessful = false;
    try {
        await $f9aoP.setProfileTitle(id);
        wasSuccessful = true;
    } catch (error) {
        console.warn(`Could not set user title: ${id}, ${error}`);
    }
    return wasSuccessful;
}
function $75b085eacb42c7cc$export$93c3c111f074f9c1(profile) {
    return profile && profile?.background && profile?.character && profile?.faction;
}

});

parcelRegister("lXNKs", function(module, exports) {

$parcel$export(module.exports, "manageTokenExpiry", function () { return $1bada6748e516a38$export$8769fd2af7f9fba0; });
$parcel$export(module.exports, "getTokenPayload", function () { return $1bada6748e516a38$export$26ddc56bc995240a; });
$parcel$export(module.exports, "isJWTFormat", function () { return $1bada6748e516a38$export$260587c9bdc229e; });
// Decode a JWT token.

var $aTRs6 = parcelRequire("aTRs6");
function $1bada6748e516a38$export$9a62e6c0a30e00bc(token) {
    // Split the token into parts
    const parts = token.split(".");
    if (parts.length !== 3) throw new Error("Invalid JWT: The token should consist of three parts.");
    // Decode the header and payload
    const header = JSON.parse(window.atob(parts[0].replace(/-/g, "+").replace(/_/g, "/")));
    const payload = JSON.parse(window.atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
    return {
        header: header,
        payload: payload
    };
}
let $1bada6748e516a38$var$checkTokenInterval = null;
function $1bada6748e516a38$export$8769fd2af7f9fba0() {
    const insidersToken = localStorage.getItem("ARISE_INSIDERS_TOKEN");
    const ariseToken = localStorage.getItem("ARISEENGINE_AUTHTOKEN");
    if (!insidersToken && !ariseToken) // If there are no tokens to check, return
    return;
    let expiry = null;
    if (insidersToken) expiry = $1bada6748e516a38$var$getTokenExpiry(insidersToken);
    if (ariseToken) {
        const ariseTokenExpiry = $1bada6748e516a38$var$getTokenExpiry(ariseToken);
        if (!expiry || ariseTokenExpiry < expiry) expiry = ariseTokenExpiry;
    }
    const hasExpired = ()=>{
        if (new Date() > expiry) {
            localStorage.removeItem("ARISE_INSIDERS_TOKEN");
            localStorage.removeItem("ARISEENGINE_AUTHTOKEN");
            if (!(0, $aTRs6.IS_DISCORD_ACTIVITY)) {
                console.log("Token has expired, refreshing page.");
                // TODO: add a toast or modal to notify the user that they have been logged out
                window.location.reload();
            }
        }
    };
    hasExpired();
// clearInterval(checkTokenInterval);
// checkTokenInterval = setInterval(hasExpired, 60 * 1000);
}
function $1bada6748e516a38$var$getTokenExpiry(token) {
    try {
        const { payload: payload } = $1bada6748e516a38$export$9a62e6c0a30e00bc(token);
        return new Date(payload.exp * 1000);
    } catch (error) {
        return new Date(0);
    }
}
function $1bada6748e516a38$export$26ddc56bc995240a(token) {
    const { payload: payload } = $1bada6748e516a38$export$9a62e6c0a30e00bc(token);
    return payload;
}
function $1bada6748e516a38$export$260587c9bdc229e(token) {
    return typeof token === "string" && token.split(".").length === 3;
}

});

parcelRegister("3TCPC", function(module, exports) {

$parcel$export(module.exports, "setLocalUserTitles", function () { return $b7aba12393bfc145$export$df2db7b6b4688d49; });
$parcel$export(module.exports, "getLocalUserTitles", function () { return $b7aba12393bfc145$export$77b6f2d55599795; });

var $f9aoP = parcelRequire("f9aoP");
const $b7aba12393bfc145$export$800da642f4d920ac = "ARISE_TITLES";
function $b7aba12393bfc145$export$c9b82301b675e7bb(id) {
    // Get the localstorage array of title IDs and add a new ID to it
    try {
        if (!id || typeof id !== "string") return;
        const titles = $b7aba12393bfc145$var$getLocalUserTitleIds();
        if (!titles.includes(id)) {
            titles.push(id);
            localStorage.setItem($b7aba12393bfc145$export$800da642f4d920ac, JSON.stringify(titles));
        }
    } catch (error) {
        console.error("Could not add local title ", error);
    }
}
function $b7aba12393bfc145$var$getLocalUserTitleIds() {
    // Get the localstorage array of title IDs and return it
    try {
        const storedTitles = localStorage.getItem($b7aba12393bfc145$export$800da642f4d920ac);
        const titles = storedTitles ? JSON.parse(storedTitles) : [];
        return Array.isArray(titles) && titles.every((item)=>typeof item === "string") ? titles : [];
    } catch  {
        return [];
    }
}
function $b7aba12393bfc145$export$df2db7b6b4688d49(titles) {
    // Replace the local storage title IDs with a new array
    try {
        if (Array.isArray(titles) && titles.length) {
            // Convert array of titles to array of title IDs
            const ids = titles.map((title)=>title.id);
            localStorage.setItem($b7aba12393bfc145$export$800da642f4d920ac, JSON.stringify(ids));
        }
    } catch (error) {
        console.error("Could not set local user titles ", error);
    }
}
async function $b7aba12393bfc145$export$77b6f2d55599795() {
    // Get local title IDs, hydrate them into full Titles and return as array
    try {
        const localIds = $b7aba12393bfc145$var$getLocalUserTitleIds();
        const availableTitles = await (0, $f9aoP.getAvailableTitles)();
        return availableTitles.filter((title)=>localIds.includes(title.id));
    } catch (error) {
        return [];
    }
}

});

parcelRegister("bEiLm", function(module, exports) {

$parcel$export(module.exports, "storeProfileV2InLocalStorage", function () { return $433151edbead508c$export$dea18351651bc371; });
$parcel$export(module.exports, "getProfileV2FromLocalStorage", function () { return $433151edbead508c$export$2742d9445e1c1ec1; });
$parcel$export(module.exports, "clearProfileV2FromLocalStorage", function () { return $433151edbead508c$export$b8a28b9d2fdf374c; });
const $433151edbead508c$export$a60fc18650a0e1c7 = "ARISE_PROFILE";
function $433151edbead508c$export$dea18351651bc371(profile) {
    try {
        localStorage.setItem($433151edbead508c$export$a60fc18650a0e1c7, JSON.stringify(profile));
    } catch (error) {
        console.error("storeProfileV2InLocalStorage error: Could not store local profile", error);
    }
}
function $433151edbead508c$export$2742d9445e1c1ec1() {
    try {
        const storedProfile = localStorage.getItem($433151edbead508c$export$a60fc18650a0e1c7);
        if (!storedProfile) return undefined;
        const parsed = JSON.parse(storedProfile);
        // Validate essential structure to ensure it's a real ProfileV2
        if (parsed && typeof parsed === "object" && Array.isArray(parsed.titles) && Array.isArray(parsed.badges) && typeof parsed.displayName === "string") return parsed;
        console.warn("getProfileV2FromLocalStorage: Invalid profile format in storage");
        return undefined;
    } catch (error) {
        console.error("getProfileV2FromLocalStorage error: Could not parse local profile", error);
        return undefined;
    }
}
function $433151edbead508c$export$b8a28b9d2fdf374c() {
    try {
        localStorage.removeItem($433151edbead508c$export$a60fc18650a0e1c7);
    } catch (error) {
        console.error("clearProfileV2FromLocalStorage error: Could not clear local profile", error);
    }
}

});


parcelRegister("jLk8j", function(module, exports) {

$parcel$export(module.exports, "isTouchDevice", function () { return $cf1dc52f588afe83$export$a1d0d20ee9546562; });
$parcel$export(module.exports, "isMobileWidth", function () { return $cf1dc52f588afe83$export$d0c5bde6e810b912; });
$parcel$export(module.exports, "getDeviceType", function () { return $cf1dc52f588afe83$export$abfb0136cf8e916b; });

var $aTRs6 = parcelRequire("aTRs6");
function $cf1dc52f588afe83$export$a1d0d20ee9546562() {
    // @ts-ignore
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function $cf1dc52f588afe83$export$d0c5bde6e810b912() {
    return window.innerWidth <= (0, $aTRs6.BP_MOBILE_CHAT);
}
function $cf1dc52f588afe83$export$abfb0136cf8e916b() {
    const MOBILE_MAX_WIDTH = 767;
    const TABLET_MAX_WIDTH = 1024;
    const ua = navigator.userAgent || navigator.vendor || "";
    // Modern iPad detection (iPadOS 13+ reports as Mac)
    if (/Macintosh/.test(ua) && $cf1dc52f588afe83$export$a1d0d20ee9546562()) return "tablet";
    // Explicit device detection
    if (/iPhone|iPod/.test(ua)) return "mobile";
    if (/iPad/.test(ua)) return "tablet";
    if (/Android/.test(ua)) return /mobile/i.test(ua) ? "mobile" : "tablet";
    if (/Windows Phone|BlackBerry|webOS/.test(ua)) return "mobile";
    if (/Kindle|Silk|PlayBook/.test(ua)) return "tablet";
    // Fallback: use touch + screen size
    if ($cf1dc52f588afe83$export$a1d0d20ee9546562()) {
        const smallestDimension = Math.min(window.innerWidth, window.innerHeight);
        if (smallestDimension <= MOBILE_MAX_WIDTH) return "mobile";
        if (smallestDimension <= TABLET_MAX_WIDTH) return "tablet";
    }
    return "desktop";
}

});

parcelRegister("lOBrS", function(module, exports) {

$parcel$export(module.exports, "cleanCDNUrls", function () { return $51dbed78e4856580$export$dd24a421a2d0451c; });
// Clean the references to old TWD CDN urls.
function $51dbed78e4856580$export$dd24a421a2d0451c(data) {
    // Only clean if the environment is not localhost and is a specific instance
    const shouldClean = window.location.hostname !== "localhost" && [
        "rana"
    ].includes("brickhouse");
    if (!shouldClean) return data;
    let stringData = JSON.stringify(data);
    stringData = stringData.replaceAll("twd.dev.arise-engine.com", window.location.host);
    return JSON.parse(stringData);
}

});


parcelRegister("4KKbJ", function(module, exports) {

$parcel$export(module.exports, "awardBadge", function () { return $0c9a91cab969da4c$export$6a5f4639d5f54182; });
$parcel$export(module.exports, "awardTitle", function () { return $0c9a91cab969da4c$export$98e673d8352392d9; });
$parcel$export(module.exports, "setMissionComplete", function () { return $0c9a91cab969da4c$export$55aca55dfe74c941; });
$parcel$export(module.exports, "setProfileTitle", function () { return $0c9a91cab969da4c$export$982894037bdd2b82; });
$parcel$export(module.exports, "setProfileFaction", function () { return $0c9a91cab969da4c$export$63f1075dd6373efe; });
$parcel$export(module.exports, "loadCurrentUserProfile", function () { return $0c9a91cab969da4c$export$7d774fa20a125bda; });
$parcel$export(module.exports, "loadCurrentUserProfileV2", function () { return $0c9a91cab969da4c$export$74ed0707f1b17d9a; });
$parcel$export(module.exports, "getAvailableBadges", function () { return $0c9a91cab969da4c$export$4b8380d51d91c627; });
$parcel$export(module.exports, "getAvailableTitles", function () { return $0c9a91cab969da4c$export$1ad62c2a69d5bd2; });
$parcel$export(module.exports, "loadUserProfiles", function () { return $0c9a91cab969da4c$export$7a8c9198471b4fff; });
$parcel$export(module.exports, "updateProfile", function () { return $0c9a91cab969da4c$export$5880729c5d131040; });
$parcel$export(module.exports, "resetProfileState", function () { return $0c9a91cab969da4c$export$c3b1dabb99da127e; });
$parcel$export(module.exports, "setProfileV2DisplayName", function () { return $0c9a91cab969da4c$export$1558266d2104261f; });
$parcel$export(module.exports, "default", function () { return $0c9a91cab969da4c$export$2e2bcd8739ae039; });

var $jvvee = parcelRequire("jvvee");

var $f9aoP = parcelRequire("f9aoP");

var $cVQse = parcelRequire("cVQse");

var $baXkz = parcelRequire("baXkz");

var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");

var $bEiLm = parcelRequire("bEiLm");
const $0c9a91cab969da4c$var$initialState = {
    currentUserProfileCheckInProgress: false,
    currentUserProfileCheckComplete: false,
    currentUserProfileV2: (0, $cVQse.EMPTY_PROFILE_V2),
    availableBadges: [],
    availableTitles: [],
    profileByUserId: {},
    isFetchingProfileById: {}
};
const $0c9a91cab969da4c$export$1bdb4bb387fd9359 = $0c9a91cab969da4c$var$initialState;
const $0c9a91cab969da4c$export$6a5f4639d5f54182 = (badgeRank)=>async (dispatch, getState)=>{
        // Send to API
        $f9aoP.addProfileBadge(badgeRank).catch(()=>{
            console.warn("Failed to send badge to API");
        });
        // Send stat
        (0, $i7H0N.sendEventV2)("badge_awarded", [
            badgeRank
        ]);
        const profileState = getState()?.profile;
        // Check if valid badge
        const availableBadges = profileState.availableBadges;
        if (!Array.isArray(availableBadges)) {
            console.warn("Cannot award badge - availableBadges not an array");
            return;
        }
        const hydratedBadge = availableBadges.find((availableBadge)=>availableBadge.rank === badgeRank);
        if (!hydratedBadge) {
            console.warn(`Cannot award badge - "${badgeRank}" is not a valid badge rank`);
            return;
        }
        // Check if already earned
        const profileBadges = profileState?.currentUserProfileV2?.badges ?? [];
        const alreadyEarned = profileBadges.find((b)=>b.rank === badgeRank);
        if (alreadyEarned) {
            console.log(`Badge already earned: ${alreadyEarned.name}`);
            return;
        }
        // Update local state
        dispatch($0c9a91cab969da4c$var$profile.actions.awardBadgeLocal(hydratedBadge));
        // Send achievement
        dispatch((0, $baXkz.queueAchievement)({
            actionPrefix: "You earned the ",
            action: `${hydratedBadge.name} Badge!`,
            type: "success",
            icon: "badge",
            onClickAction: "open-profile"
        }));
    };
const $0c9a91cab969da4c$export$98e673d8352392d9 = (titleId)=>async (dispatch, getState)=>{
        // Send to API
        $f9aoP.addProfileTitle(titleId).catch(()=>{
            console.warn("Failed to send title to API");
        });
        // Send stat
        (0, $i7H0N.sendEventV2)("title_awarded", [
            titleId
        ]);
        const profileState = getState()?.profile;
        const availableTitles = profileState.availableTitles;
        if (!Array.isArray(availableTitles)) {
            console.warn("Cannot award title - availableTitles not an array");
            return;
        }
        // Check if valid title
        const hydratedTitle = availableTitles.find((availableTitle)=>availableTitle.id === titleId);
        if (!hydratedTitle) {
            console.warn(`Cannot award title - "${titleId}" is not a valid title ID`);
            return;
        }
        // Check if already earned
        const profileTitles = profileState?.currentUserProfileV2?.titles ?? [];
        const alreadyEarned = profileTitles.find((b)=>b.id === titleId);
        if (alreadyEarned) {
            console.log(`Title already earned: ${alreadyEarned.title}`);
            return;
        }
        // Update local state
        dispatch($0c9a91cab969da4c$var$profile.actions.awardTitleLocal(hydratedTitle));
        // Send achievement
        dispatch((0, $baXkz.queueAchievement)({
            actionPrefix: "You earned the title ",
            action: `\u{201C}${hydratedTitle.title}\u{201D}`,
            type: "success",
            icon: "badge",
            onClickAction: "open-profile"
        }));
    };
const $0c9a91cab969da4c$export$55aca55dfe74c941 = ()=>async (dispatch, getState)=>{
        // Send to API
        $f9aoP.setProfileMissionCompleted().catch(()=>{
            console.warn("Failed to send mission complete to API");
        });
        // TEMP removed
        // Check if already earned
        // const isAlreadyComplete = getState()?.profile?.currentUserProfileV2.missionCompleted;
        // if (isAlreadyComplete) {
        //     console.log('Mission is already complete');
        //     return;
        // }
        // Update local state
        dispatch($0c9a91cab969da4c$var$profile.actions.setMissionCompletedLocal());
        // Send achievement
        // TEMP making it say quest everywhere for now.
        dispatch((0, $baXkz.queueAchievement)({
            actionPrefix: "You completed the ",
            action: "Quest!",
            type: "success",
            icon: "quest",
            onClickAction: "open-profile"
        }));
    // dispatch(
    //     queueAchievement({
    //         actionPrefix: 'You completed the ',
    //         action: IS_DISCORD_ACTIVITY ? 'Quest!' : 'Mission!',
    //         type: 'success',
    //         icon: IS_DISCORD_ACTIVITY ? 'quest' : 'mission',
    //         onClickAction: 'open-profile',
    //     }),
    // );
    };
const $0c9a91cab969da4c$export$982894037bdd2b82 = (0, $jvvee.createAsyncThunk)("profile/setProfileTitle", async (id)=>{
    const result = await $f9aoP.setProfileTitle(id);
    return result.success;
});
const $0c9a91cab969da4c$export$63f1075dd6373efe = (0, $jvvee.createAsyncThunk)("profile/setProfileFaction", async (id)=>{
    const result = await $f9aoP.setProfileFaction(id);
    return result.success;
});
const $0c9a91cab969da4c$export$7d774fa20a125bda = (0, $jvvee.createAsyncThunk)("profile/load", async (userId)=>{
    const profiles = await $f9aoP.getProfiles(userId);
    return profiles[0] ?? undefined;
});
const $0c9a91cab969da4c$export$74ed0707f1b17d9a = (0, $jvvee.createAsyncThunk)("profileV2/load", async ()=>{
    const profile = await $f9aoP.getCurrentUserProfileV2();
    if (!profile) throw new Error("No profile found");
    return profile;
});
const $0c9a91cab969da4c$export$4b8380d51d91c627 = (0, $jvvee.createAsyncThunk)("profile/getAvailableBadges", async ()=>{
    const result = await $f9aoP.getAvailableBadges();
    if (!Array.isArray(result)) {
        console.warn("getAvailableBadges response not valid");
        return [];
    }
    return result;
});
const $0c9a91cab969da4c$export$1ad62c2a69d5bd2 = (0, $jvvee.createAsyncThunk)("profile/getAvailableTitles", async ()=>{
    const result = await $f9aoP.getAvailableTitles();
    if (!Array.isArray(result)) {
        console.warn("getAvailableTitles response not valid");
        return [];
    }
    return result;
});
const $0c9a91cab969da4c$export$7a8c9198471b4fff = (0, $jvvee.createAsyncThunk)("profile/loadUserProfiles", async (userIds, thunkApi)=>{
    const state = thunkApi.getState();
    const ttl = Date.now() + 60000;
    const cleanedUserIds = userIds.filter((id)=>{
        return !state.profile.isFetchingProfileById[id] && (!state.profile.profileByUserId[id] || state.profile.profileByUserId[id] && state.profile.profileByUserId[id].fetchedAt > ttl);
    });
    if (cleanedUserIds.length === 0) return null;
    thunkApi.dispatch($0c9a91cab969da4c$var$profile.actions.markProfilesAsFetching(cleanedUserIds));
    return await $f9aoP.getProfiles(cleanedUserIds);
});
const $0c9a91cab969da4c$var$profile = (0, $jvvee.createSlice)({
    name: "profile",
    initialState: $0c9a91cab969da4c$var$initialState,
    reducers: {
        markProfilesAsFetching: (state, action)=>{
            action.payload.forEach((id)=>{
                state.isFetchingProfileById[id] = true;
            });
        },
        updateProfile: (state, action)=>{
            const data = action.payload;
            const profile = (0, $fL4mk.processProfileData)(data);
            const now = Date.now();
            profile.fetchedAt = now;
            // Not currenlty using the profile cache so commenting this out to avoid using unnecessary memory
            // state.profileByUserId[profile.userID] = profile;
            if (state.currentUserProfile?.id === profile.id) state.currentUserProfile = profile;
        },
        resetProfileState: (state)=>{
            const newState = {
                ...$0c9a91cab969da4c$var$initialState,
                profileByUserId: state.profileByUserId,
                isFetchingProfileById: state.isFetchingProfileById
            };
            Object.assign(state, newState);
        },
        setProfileV2DisplayName: (state, action)=>{
            if (state.currentUserProfileV2) state.currentUserProfileV2.displayName = action.payload;
        },
        awardBadgeLocal: (state, action)=>{
            if (Array.isArray(state?.currentUserProfileV2?.badges)) {
                state.currentUserProfileV2.badges.push(action.payload);
                (0, $bEiLm.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log("awardBadgeLocal skipping as badges array not valid");
        },
        awardTitleLocal: (state, action)=>{
            if (Array.isArray(state?.currentUserProfileV2?.titles)) {
                state.currentUserProfileV2.titles.push(action.payload);
                (0, $bEiLm.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log("awardTitleLocal skipping as titles array not valid");
        },
        setMissionCompletedLocal: (state)=>{
            if (state.currentUserProfileV2) {
                state.currentUserProfileV2.missionCompleted = true;
                (0, $bEiLm.storeProfileV2InLocalStorage)(state.currentUserProfileV2);
            } else console.log("setMissionCompleted skipping currentUserProfileV2 not loaded");
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($0c9a91cab969da4c$export$7d774fa20a125bda.pending, (state)=>{
            state.currentUserProfileCheckInProgress = true;
            state.currentUserProfileCheckComplete = false;
        });
        builder.addCase($0c9a91cab969da4c$export$7d774fa20a125bda.fulfilled, (state, action)=>{
            state.currentUserProfile = action.payload;
            state.currentUserProfileCheckInProgress = false;
            state.currentUserProfileCheckComplete = true;
        });
        builder.addCase($0c9a91cab969da4c$export$7d774fa20a125bda.rejected, (state, action)=>{
            console.error("Failed to load current user profile", action.error);
            state.currentUserProfileCheckInProgress = false;
            state.currentUserProfileCheckComplete = true;
        });
        builder.addCase($0c9a91cab969da4c$export$74ed0707f1b17d9a.fulfilled, (state, action)=>{
            state.currentUserProfileV2 = action.payload;
        });
        builder.addCase($0c9a91cab969da4c$export$7a8c9198471b4fff.fulfilled, (state, action)=>{
            action.meta.arg.forEach((id)=>{
                state.isFetchingProfileById[id] = false;
            });
            const now = Date.now();
            action.payload?.forEach((profile)=>{
                const p = profile;
                p.fetchedAt = now;
                state.profileByUserId[p.userID] = p;
            });
        });
        builder.addCase($0c9a91cab969da4c$export$7a8c9198471b4fff.rejected, (state, action)=>{
            console.error(action.error);
            action.meta.arg.forEach((id)=>{
                state.isFetchingProfileById[id] = false;
            });
        });
        builder.addCase($0c9a91cab969da4c$export$4b8380d51d91c627.fulfilled, (state, action)=>{
            state.availableBadges = action.payload;
        });
        builder.addCase($0c9a91cab969da4c$export$1ad62c2a69d5bd2.fulfilled, (state, action)=>{
            state.availableTitles = action.payload;
        });
    }
});
const { updateProfile: $0c9a91cab969da4c$export$5880729c5d131040, resetProfileState: $0c9a91cab969da4c$export$c3b1dabb99da127e, setProfileV2DisplayName: $0c9a91cab969da4c$export$1558266d2104261f } = $0c9a91cab969da4c$var$profile.actions;
const { actions: $0c9a91cab969da4c$export$13e13f83d4c0e6c7, reducer: $0c9a91cab969da4c$export$48f9ba8d956d63bb } = $0c9a91cab969da4c$var$profile;
var $0c9a91cab969da4c$export$2e2bcd8739ae039 = $0c9a91cab969da4c$export$48f9ba8d956d63bb;

});
parcelRegister("cVQse", function(module, exports) {

$parcel$export(module.exports, "EMPTY_PROFILE_V2", function () { return $aea5809635245155$export$9b21b9392956745c; });
const $aea5809635245155$export$9b21b9392956745c = {
    displayName: "Guest",
    titles: [],
    badges: [],
    missionCompleted: false,
    createdAt: "",
    updatedAt: "",
    userId: ""
};
function $aea5809635245155$export$56d9ca79edb967e7() {
    return {
        id: "",
        universeID: "",
        displayName: "",
        factionID: "",
        avatarFrame: {
            id: "",
            imagePath: "",
            name: "",
            price: 0
        },
        background: {
            id: "",
            colour: "",
            imagePath: "",
            name: "",
            price: 0,
            rivFileURL: "",
            thumbnailPath: ""
        },
        character: {
            id: "",
            imagePath: "",
            name: "",
            price: 0,
            rivFileURL: "",
            thumbnailPath: ""
        },
        createdAt: "",
        updatedAt: "",
        userID: "",
        faction: {
            id: "",
            name: "",
            imagePath: "",
            iconPath: "",
            iconImageUrl: "",
            rankImagePath: ""
        },
        supplyRunRank: null,
        title: {
            id: "",
            titleID: undefined,
            title: "",
            rarity: "Common"
        },
        role: "user",
        fetchedAt: 0,
        isBanned: false,
        bannedUntil: undefined,
        bannedReason: undefined,
        factionImageUrl: ""
    };
}

});

parcelRegister("i7H0N", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $d29c0adb154f317b$export$2cd8252107eb640b; });
$parcel$export(module.exports, "sendEvent", function () { return $d29c0adb154f317b$export$7329bcdc3edcd90e; });
$parcel$export(module.exports, "sendEventV2", function () { return $d29c0adb154f317b$export$fe860283b770a141; });
$parcel$export(module.exports, "sendEventV2Once", function () { return $d29c0adb154f317b$export$93a2a8ff75adccc8; });

var $1URoE = parcelRequire("1URoE");

var $hyX96 = parcelRequire("hyX96");

var $27K0D = parcelRequire("27K0D");
let $d29c0adb154f317b$var$initialised = false;
async function $d29c0adb154f317b$export$2cd8252107eb640b(gaId, amplitudeKey) {
    // if (!initialised && gaId && amplitudeKey) {
    //     initaliseGA(gaId);
    //     setAmplitudeKey(amplitudeKey);
    //     initialised = true;
    // }
    try {
        if (!$d29c0adb154f317b$var$initialised && gaId && await $d29c0adb154f317b$export$7411ea8341c49b9f()) {
            (0, $hyX96.initaliseGA)(gaId);
            $d29c0adb154f317b$var$initialised = true;
        }
    } catch (error) {}
}
async function $d29c0adb154f317b$export$7329bcdc3edcd90e(name, data) {
// Previously, this sent events to the old analytics system.
// Many old files still call this function.
// Any important analytics calling this should call sendEventV2 instead.
}
async function $d29c0adb154f317b$export$fe860283b770a141(name, strings = [], numbers = [], isExternal, useBeacon) {
    try {
        (0, $27K0D.sendEventV2)(name, strings, numbers, isExternal, useBeacon);
        if (await $d29c0adb154f317b$export$7411ea8341c49b9f()) (0, $hyX96.sendEvent)(name, {
            metadata: {
                strings: strings,
                numbers: numbers
            }
        });
    } catch (error) {}
}
const $d29c0adb154f317b$var$sentEvents = {};
function $d29c0adb154f317b$export$93a2a8ff75adccc8(...args) {
    const name = args[0];
    if ($d29c0adb154f317b$var$sentEvents[name]) return;
    $d29c0adb154f317b$var$sentEvents[name] = true;
    return $d29c0adb154f317b$export$fe860283b770a141(...args);
}
async function $d29c0adb154f317b$export$7411ea8341c49b9f() {
    // Only paramount instances have cbsoptanon script currently
    if (!(0, $1URoE.isParamountInstance)) return true;
    try {
        return await window["cbsoptanon"]?.ot?.getConsentPreferences(2);
    } catch (error) {
        console.log("areAnalyticsAllowed() - Could not getConsentPreferences so defaulting to false");
        return false;
    }
}

});
parcelRegister("1URoE", function(module, exports) {

$parcel$export(module.exports, "homePath", function () { return $d42ae8537299edc7$export$5d5930b97498321d; });
$parcel$export(module.exports, "isHomePath", function () { return $d42ae8537299edc7$export$c6f795ee6cb9c0a5; });
$parcel$export(module.exports, "exitModalText", function () { return $d42ae8537299edc7$export$7e897824870b749a; });
$parcel$export(module.exports, "getInsidersLoginUrl", function () { return $d42ae8537299edc7$export$5f6bbcf3b38d23c9; });
$parcel$export(module.exports, "getInsidersRegisterUrl", function () { return $d42ae8537299edc7$export$e3192afa1eb299f2; });
$parcel$export(module.exports, "SUPPORT_EMAIL", function () { return $d42ae8537299edc7$export$fc5cbb021d0697ad; });
$parcel$export(module.exports, "isInsidersInstance", function () { return $d42ae8537299edc7$export$9bae8a72c0a0800e; });
$parcel$export(module.exports, "isThoseBeyondInstance", function () { return $d42ae8537299edc7$export$2c2e61be4a755d74; });
$parcel$export(module.exports, "isParamountInstance", function () { return $d42ae8537299edc7$export$37d78445bafeaee9; });
const $d42ae8537299edc7$export$5d5930b97498321d = "/location/b34a3a12-e37a-49c7-88ba-b46eb7ecd957" ?? "/selector";
const $d42ae8537299edc7$export$c6f795ee6cb9c0a5 = ()=>{
    const url = new URL(window.location.href);
    return url?.pathname === $d42ae8537299edc7$export$5d5930b97498321d;
};
const $d42ae8537299edc7$export$7e897824870b749a = "Back to World";
const $d42ae8537299edc7$export$5f6bbcf3b38d23c9 = ()=>{
    const returnUrl = window.location.origin + "/auth/insiders";
    const base64Url = btoa(returnUrl);
    return `${undefined}?return_to=${base64Url}`;
};
const $d42ae8537299edc7$export$e3192afa1eb299f2 = ()=>{
    const returnUrl = window.location.origin + "/auth/insiders";
    const base64Url = btoa(returnUrl);
    return `${undefined}?return_to=${base64Url}`;
};
const $d42ae8537299edc7$export$fc5cbb021d0697ad = "support@thosebeyond.io";
const $d42ae8537299edc7$export$9bae8a72c0a0800e = false;
const $d42ae8537299edc7$export$2c2e61be4a755d74 = !$d42ae8537299edc7$export$9bae8a72c0a0800e;
const $d42ae8537299edc7$export$37d78445bafeaee9 = false;

});

parcelRegister("hyX96", function(module, exports) {

$parcel$export(module.exports, "initaliseGA", function () { return $d0331fa94bc4db6a$export$e8c85dfc4a2555; });
$parcel$export(module.exports, "sendEvent", function () { return $d0331fa94bc4db6a$export$7329bcdc3edcd90e; });
function $d0331fa94bc4db6a$export$e8c85dfc4a2555(id) {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    script.async = true;
    document.head.appendChild(script);
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    function gtag(a, b) {
        // @ts-ignore
        window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", id);
    const additional_ids = undefined;
    if (additional_ids) {
        const ids = additional_ids.split(",");
        ids.forEach((additional_id)=>{
            gtag("config", additional_id);
        });
    }
    // @ts-ignore
    window.gtag = gtag;
}
function $d0331fa94bc4db6a$export$7329bcdc3edcd90e(name, data) {
    // @ts-ignore
    if (window.gtag) // @ts-ignore
    window.gtag("event", name, data);
}

});

parcelRegister("27K0D", function(module, exports) {

$parcel$export(module.exports, "setUserId", function () { return $c9e2ee2e10ca4897$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "sendEventV2", function () { return $c9e2ee2e10ca4897$export$fe860283b770a141; });

var $f9aoP = parcelRequire("f9aoP");

var $jLk8j = parcelRequire("jLk8j");
let $c9e2ee2e10ca4897$var$userId = undefined;
let $c9e2ee2e10ca4897$var$deviceId = window.localStorage.getItem("ARISE_DEVICE_ID");
const $c9e2ee2e10ca4897$var$sessionId = $c9e2ee2e10ca4897$var$uuidv4();
const $c9e2ee2e10ca4897$var$sessionStartTime = Date.now();
const $c9e2ee2e10ca4897$var$deviceType = (0, $jLk8j.getDeviceType)();
if (!$c9e2ee2e10ca4897$var$deviceId) {
    $c9e2ee2e10ca4897$var$deviceId = $c9e2ee2e10ca4897$var$uuidv4();
    window.localStorage.setItem("ARISE_DEVICE_ID", $c9e2ee2e10ca4897$var$deviceId);
}
function $c9e2ee2e10ca4897$export$7f5abdb7f5093137(id) {
    $c9e2ee2e10ca4897$var$userId = id;
}
function $c9e2ee2e10ca4897$export$fe860283b770a141(name, strings = [], numbers = [], isExternal, useBeacon) {
    return (0, $f9aoP.scrollV2)({
        sessionId: $c9e2ee2e10ca4897$var$sessionId,
        deviceId: $c9e2ee2e10ca4897$var$deviceId,
        eventType: name,
        userId: $c9e2ee2e10ca4897$var$userId,
        universeId: "718b65bf-9225-48da-93f2-6a7255127896",
        deviceType: $c9e2ee2e10ca4897$var$deviceType,
        timestamp: Date.now(),
        sessionDuration: Date.now() - $c9e2ee2e10ca4897$var$sessionStartTime,
        metadata: {
            strings: strings,
            numbers: numbers
        },
        isExternal: isExternal ?? false
    }, useBeacon).catch((e)=>{
    // Silently fail
    });
}
function $c9e2ee2e10ca4897$var$uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});




parcelRegister("kyBxf", function(module, exports) {

$parcel$export(module.exports, "getPreviousMessages", function () { return $0295deea2142eca5$export$165373646bd00c5b; });
$parcel$export(module.exports, "submitMessage", function () { return $0295deea2142eca5$export$8fd5706e716dbba; });
$parcel$export(module.exports, "submitCommand", function () { return $0295deea2142eca5$export$da0e5c5d04f0c39d; });
$parcel$export(module.exports, "toggleMessageReaction", function () { return $0295deea2142eca5$export$374ea87e421dfcbd; });
$parcel$export(module.exports, "loadAvailableReactions", function () { return $0295deea2142eca5$export$abf5a3bc7da4a0e8; });
$parcel$export(module.exports, "fetchEventById", function () { return $0295deea2142eca5$export$df4a6caaec0ed72; });
$parcel$export(module.exports, "addItem", function () { return $0295deea2142eca5$export$fb9705de59d96855; });
$parcel$export(module.exports, "updateItem", function () { return $0295deea2142eca5$export$72b8c6d38aa6195b; });
$parcel$export(module.exports, "updateMessageReaction", function () { return $0295deea2142eca5$export$8ef646fc7ce1e61a; });
$parcel$export(module.exports, "removeItem", function () { return $0295deea2142eca5$export$fe2d9b4e03920b4c; });
$parcel$export(module.exports, "openModerationAction", function () { return $0295deea2142eca5$export$15c5b98f35a1b493; });
$parcel$export(module.exports, "closeModerationAction", function () { return $0295deea2142eca5$export$af5cffdacb983b8b; });
$parcel$export(module.exports, "updateFeedProfile", function () { return $0295deea2142eca5$export$49016349ee22be52; });
$parcel$export(module.exports, "addItemsToTop", function () { return $0295deea2142eca5$export$4af234c3811a0f9a; });
$parcel$export(module.exports, "setCurrentEvent", function () { return $0295deea2142eca5$export$1823a1e5a4a9f912; });
$parcel$export(module.exports, "clearCurrentEvent", function () { return $0295deea2142eca5$export$3d0654350350f0e1; });
$parcel$export(module.exports, "updateEventParticipant", function () { return $0295deea2142eca5$export$3a83b7b6b9b90ee8; });
$parcel$export(module.exports, "setCurrentEventIsActive", function () { return $0295deea2142eca5$export$f5becc12572fad3c; });
$parcel$export(module.exports, "queueNewsTickerItem", function () { return $0295deea2142eca5$export$2475777bb1976781; });
$parcel$export(module.exports, "removeFirstNewsTickerItemFromQueue", function () { return $0295deea2142eca5$export$a26bb05919391d5d; });
$parcel$export(module.exports, "setNewsTickerTag", function () { return $0295deea2142eca5$export$6bfb177ddaeee246; });
$parcel$export(module.exports, "feedReducer", function () { return $0295deea2142eca5$export$c4bc848778eef518; });

var $jvvee = parcelRequire("jvvee");

var $f9aoP = parcelRequire("f9aoP");

var $4KKbJ = parcelRequire("4KKbJ");

var $aTKgi = parcelRequire("aTKgi");
const $0295deea2142eca5$var$initialState = {
    connected: false,
    isLoadingPastMessages: false,
    isMessageSubmitting: false,
    messages: [],
    isSubmittingToySuccess: false,
    moderationActionOpenOnMessageId: null,
    feedUpdateTicker: 0,
    availableReactions: {},
    storedEvents: {},
    newsTickerQueue: []
};
const $0295deea2142eca5$export$4b387b939f249d89 = $0295deea2142eca5$var$initialState;
const $0295deea2142eca5$export$165373646bd00c5b = (0, $jvvee.createAsyncThunk)("feed/getPreviousMessages", async ({ id: id, globalChat: globalChat, isLatest: isLatest })=>{
    const messages = await $f9aoP.lastChats(id, undefined, undefined, globalChat, isLatest);
    return [
        id,
        messages
    ];
});
const $0295deea2142eca5$export$8fd5706e716dbba = (0, $jvvee.createAsyncThunk)("feed/submitMessage", async ([locationId, message])=>{
    await $f9aoP.sendMessage(locationId, message);
});
const $0295deea2142eca5$export$da0e5c5d04f0c39d = (0, $jvvee.createAsyncThunk)("feed/submitCommand", async ([locationId, message])=>{
    await $f9aoP.sendCommand(locationId, message);
});
const $0295deea2142eca5$export$374ea87e421dfcbd = (0, $jvvee.createAsyncThunk)("feed/toggleMessageReaction", async ([messageId, reaction, locationId])=>{
    await $f9aoP.toggleMessageReaction(messageId, reaction, locationId);
});
const $0295deea2142eca5$export$abf5a3bc7da4a0e8 = (0, $jvvee.createAsyncThunk)("feed/loadAvailableReactions", async ()=>{
    function convertArrayToObject(arrayOfReactions) {
        let reactionsAsObject = {};
        arrayOfReactions.forEach((reaction)=>{
            reactionsAsObject[reaction.type] = {
                ...reaction,
                imageUrl: (0, $aTKgi.pathToURL)(reaction.imagePath)
            };
        });
        return reactionsAsObject;
    }
    const reactions = await $f9aoP.listReactionTypes();
    return convertArrayToObject(reactions);
});
const $0295deea2142eca5$export$2c068985d74c0fcd = (0, $jvvee.createAsyncThunk)("feed/getUserDataForChat", async (messages, thunkApi)=>{
    const userIds = new Set();
    messages.forEach((m)=>{
        switch(m.type){
            case "chat-message":
                userIds.add(m.data.senderId);
                break;
            case "feed-update":
                userIds.add(m.data.subjectId);
                break;
        }
    });
    thunkApi.dispatch((0, $4KKbJ.loadUserProfiles)(Array.from(userIds)));
});
const $0295deea2142eca5$export$df4a6caaec0ed72 = (0, $jvvee.createAsyncThunk)("feed/fetchEventById", async (eventID)=>{
    return await $f9aoP.getEventById(eventID);
});
const $0295deea2142eca5$var$feed = (0, $jvvee.createSlice)({
    name: "feed",
    initialState: $0295deea2142eca5$var$initialState,
    reducers: {
        addItem: (state, action)=>{
            state.messages.push(action.payload);
        },
        updateItem: (state, action)=>{
            const index = state.messages.findIndex((m)=>m.id === action.payload.id);
            const previousItem = state.messages[index];
            if (index >= 0) {
                // Check if the number of reactions has changed.
                // This is used to trigger the autoscroll, as the height of the message element will change based on whether there are reactions or not.
                if (previousItem.type === "chat-message" && action.payload.type === "chat-message" || previousItem.type === "feed-update" && action.payload.type === "feed-update") {
                    const previousReactionCount = previousItem.data.reactions && previousItem.data.reactions.length ? previousItem.data.reactions.length : 0;
                    const newReactionCount = action.payload.data && action.payload.data.reactions ? action.payload.data.reactions.length : 0;
                    if (previousReactionCount !== newReactionCount && (previousReactionCount > 0 || newReactionCount > 0)) state.feedUpdateTicker++;
                }
                state.messages[index] = action.payload;
            }
        },
        updateMessageReaction: (state, action)=>{
            const indexOfMessage = state.messages.findIndex((m)=>m.id === action.payload.data.id);
            const messageData = state.messages[indexOfMessage]?.data;
            if (!messageData) return;
            if (!messageData.reactions) messageData.reactions = [];
            const messageReactions = messageData.reactions;
            const payload = action.payload.data.reaction;
            if (messageReactions) {
                state.feedUpdateTicker++;
                const indexOfReaction = messageReactions.findIndex((r)=>r.type === payload.type);
                const reactionToUpdate = messageReactions[indexOfReaction];
                if (payload.action === "add") {
                    const newUserReactedBy = {
                        userID: action.payload.data.reaction.userID,
                        displayName: action.payload.data.reaction.displayName
                    };
                    if (reactionToUpdate) {
                        // Reaction type is already on this message
                        // So increase reaction count and add user to list
                        reactionToUpdate.count++;
                        reactionToUpdate.reactedBy.push(newUserReactedBy);
                    } else // Reaction type is not on this message yet
                    // So add the reaction
                    messageReactions.push({
                        type: payload.type,
                        count: 1,
                        reactedBy: [
                            newUserReactedBy
                        ]
                    });
                } else if (payload.action === "remove") {
                    if (reactionToUpdate) {
                        // Reaction type is already on this message
                        if (reactionToUpdate.count === 1) // If only count of 1, remove this reaction completely
                        messageReactions.splice(indexOfReaction, 1);
                        else {
                            // Otherwise just decrease the count and remove user from list
                            reactionToUpdate.count--;
                            reactionToUpdate.reactedBy = reactionToUpdate.reactedBy.filter((r)=>r.userID !== payload.userID);
                        }
                    } else ;
                }
            }
        },
        removeItem: (state, action)=>{
            const index = state.messages.findIndex((m)=>m.id === action.payload);
            if (index >= 0) state.messages.splice(index, 1);
        },
        setConnectionStatus: (state, action)=>{
            state.connected = action.payload;
        },
        openModerationAction: (state, action)=>{
            state.moderationActionOpenOnMessageId = action.payload;
        },
        closeModerationAction: (state)=>{
            state.moderationActionOpenOnMessageId = null;
        },
        updateFeedProfile: (state, action)=>{
            const profile = action.payload;
            state.messages = state.messages.map((m)=>{
                if (m.type === "chat-message") {
                    const message = m.data;
                    if (message.senderId === profile.userID) message.profile = profile;
                }
                if (m.type === "feed-update") {
                    const update = m.data;
                    if (update.subjectId === profile.userID) update.profile = profile;
                }
                return m;
            });
        },
        addItemsToTop: (state, action)=>{
            state.messages = [
                ...action.payload,
                ...state.messages
            ];
        },
        setCurrentEvent: (state, action)=>{
            state.currentEvent = action.payload;
        },
        setCurrentEventIsActive: (state, action)=>{
            state.currentEvent.isActive = action.payload;
        },
        clearCurrentEvent: (state)=>{
            state.currentEvent = null;
        },
        updateEventParticipant: (state, action)=>{
            // Only update if is for current active event
            if (action.payload?.data?.eventID !== state.currentEvent?.eventID) return;
            const participant = {
                ...action.payload.data.participant,
                lastUpdated: action.payload.timestamp
            };
            state.currentEvent.participants = [
                participant
            ];
        },
        queueNewsTickerItem: (state, action)=>{
            state.newsTickerQueue.push(action.payload);
        },
        removeFirstNewsTickerItemFromQueue: (state)=>{
            state.newsTickerQueue.shift();
        },
        setNewsTickerTag: (state, action)=>{
            state.newsTickerTag = action.payload;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($0295deea2142eca5$export$165373646bd00c5b.pending, (state)=>{
            state.isLoadingPastMessages = true;
            state.loadingPastMessagesError = undefined;
        });
        builder.addCase($0295deea2142eca5$export$165373646bd00c5b.fulfilled, (state, action)=>{
            state.isLoadingPastMessages = false;
            state.roomId = action.payload[0];
            state.messages = action.payload[1];
            state.loadingPastMessagesError = undefined;
        });
        builder.addCase($0295deea2142eca5$export$165373646bd00c5b.rejected, (state, action)=>{
            state.isLoadingPastMessages = false;
            state.loadingPastMessagesError = action.error.message;
        });
        builder.addCase($0295deea2142eca5$export$8fd5706e716dbba.pending, (state)=>{
            state.isMessageSubmitting = true;
            state.messageSubmittingError = undefined;
        });
        builder.addCase($0295deea2142eca5$export$8fd5706e716dbba.fulfilled, (state)=>{
            state.isMessageSubmitting = false;
            state.messageSubmittingError = undefined;
        });
        builder.addCase($0295deea2142eca5$export$8fd5706e716dbba.rejected, (state, action)=>{
            state.isMessageSubmitting = false;
            state.messageSubmittingError = action.error.message;
        });
        builder.addCase($0295deea2142eca5$export$374ea87e421dfcbd.rejected, (_, action)=>{
            console.error(action.error);
        });
        builder.addCase($0295deea2142eca5$export$abf5a3bc7da4a0e8.fulfilled, (state, action)=>{
            state.availableReactions = action.payload;
        });
        builder.addCase($0295deea2142eca5$export$df4a6caaec0ed72.pending, (state, action)=>{
            const id = action.meta.arg;
            state.storedEvents[id] = {
                lastFetched: Date.now(),
                data: null
            };
        });
        builder.addCase($0295deea2142eca5$export$df4a6caaec0ed72.fulfilled, (state, action)=>{
            // If data is for current event, update the participants to update event status UI
            if (state.currentEvent && state.currentEvent?.eventID === action.payload.eventData.eventID) {
                const event = {
                    ...state.currentEvent,
                    participants: action.payload.eventData.participants
                };
                state.currentEvent = event;
            }
            const id = action.meta.arg;
            state.storedEvents[id] = {
                lastFetched: state.storedEvents?.[id]?.lastFetched ?? Date.now(),
                data: action.payload
            };
        });
    }
});
const { addItem: $0295deea2142eca5$export$fb9705de59d96855, updateItem: $0295deea2142eca5$export$72b8c6d38aa6195b, updateMessageReaction: $0295deea2142eca5$export$8ef646fc7ce1e61a, removeItem: $0295deea2142eca5$export$fe2d9b4e03920b4c, openModerationAction: $0295deea2142eca5$export$15c5b98f35a1b493, closeModerationAction: $0295deea2142eca5$export$af5cffdacb983b8b, updateFeedProfile: $0295deea2142eca5$export$49016349ee22be52, addItemsToTop: $0295deea2142eca5$export$4af234c3811a0f9a, setCurrentEvent: $0295deea2142eca5$export$1823a1e5a4a9f912, clearCurrentEvent: $0295deea2142eca5$export$3d0654350350f0e1, updateEventParticipant: $0295deea2142eca5$export$3a83b7b6b9b90ee8, setCurrentEventIsActive: $0295deea2142eca5$export$f5becc12572fad3c, queueNewsTickerItem: $0295deea2142eca5$export$2475777bb1976781, removeFirstNewsTickerItemFromQueue: $0295deea2142eca5$export$a26bb05919391d5d, setNewsTickerTag: $0295deea2142eca5$export$6bfb177ddaeee246 } = $0295deea2142eca5$var$feed.actions;
const { reducer: $0295deea2142eca5$export$c4bc848778eef518 } = $0295deea2142eca5$var$feed;

});

parcelRegister("hzaQx", function(module, exports) {

$parcel$export(module.exports, "setQuestStatus", function () { return $ea0ec6b2e0407369$export$d9c581ded82a5d9d; });
$parcel$export(module.exports, "setWindowSize", function () { return $ea0ec6b2e0407369$export$1c6a7f8bbb9bfe58; });
$parcel$export(module.exports, "default", function () { return $ea0ec6b2e0407369$export$2e2bcd8739ae039; });

var $jvvee = parcelRequire("jvvee");
const $ea0ec6b2e0407369$var$initialState = {
    questStatus: undefined,
    windowSize: "maximized"
};
const $ea0ec6b2e0407369$export$170ce47b0e55421b = $ea0ec6b2e0407369$var$initialState;
const $ea0ec6b2e0407369$var$discord = (0, $jvvee.createSlice)({
    name: "discord",
    initialState: $ea0ec6b2e0407369$var$initialState,
    reducers: {
        setQuestStatus (state, action) {
            state.questStatus = action.payload;
            state.questStatusChecked = true;
        },
        setWindowSize (state, action) {
            state.windowSize = action.payload;
        }
    },
    extraReducers: (builder)=>{}
});
const { setQuestStatus: $ea0ec6b2e0407369$export$d9c581ded82a5d9d, setWindowSize: $ea0ec6b2e0407369$export$1c6a7f8bbb9bfe58 } = $ea0ec6b2e0407369$var$discord.actions;
const { actions: $ea0ec6b2e0407369$export$24ff1a8c3ea9d8d6, reducer: $ea0ec6b2e0407369$export$6aeaca12df723c2b } = $ea0ec6b2e0407369$var$discord;
var $ea0ec6b2e0407369$export$2e2bcd8739ae039 = $ea0ec6b2e0407369$export$6aeaca12df723c2b;

});


parcelRegister("cEIti", function(module, exports) {

$parcel$export(module.exports, "useTheme", function () { return $9418ace2cd029e59$export$93d4e7f90805808f; });
$parcel$export(module.exports, "ThemeStylesProvider", function () { return $9418ace2cd029e59$export$933d196347d99b1f; });

var $2PPWI = parcelRequire("2PPWI");

var $764u1 = parcelRequire("764u1");

var $6lYLL = parcelRequire("6lYLL");
const $9418ace2cd029e59$export$93d4e7f90805808f = ()=>{
    const theme = (0, $6lYLL.useAppSelector)((state)=>state.app.theme);
    return theme;
};
function $9418ace2cd029e59$export$933d196347d99b1f() {
    const theme = $9418ace2cd029e59$export$93d4e7f90805808f();
    // UI Safe area vars are provided by discord (not always)
    const discordUiSafeAreas = `
        --sait: var(--discord-safe-area-inset-top);
        --saib: var(--discord-safe-area-inset-bottom);
        --sail: var(--discord-safe-area-inset-left);
        --sair: var(--discord-safe-area-inset-right);
    `;
    const defaultSafeAreas = `
        --sait: 0px;
        --saib: 0px;
        --sail: 0px;
        --sair: 0px;
    `;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("style", {
        children: `
                :root {
                    color: ${theme.tokens.AccentTheme1TextTextDefault};

                    --font-primary: '${theme.fonts.primary}';
                    --font-secondary: '${theme.fonts.secondary}';
                    --font-tertiary: '${theme.fonts.tertiary}';
                    --font-quaternary: '${theme.fonts.quaternary}';
                    
                    --token-arise-theme-1-rarity-rarity-common-light: ${theme.tokens.AriseTheme1RarityRarityCommonLight};
                    --token-arise-theme-1-rarity-rarity-common-mid: ${theme.tokens.AriseTheme1RarityRarityCommonMid};
                    --token-arise-theme-1-rarity-rarity-common-dark: ${theme.tokens.AriseTheme1RarityRarityCommonDark};
                    --token-arise-theme-1-rarity-rarity-uncommon-light: ${theme.tokens.AriseTheme1RarityRarityUncommonLight};
                    --token-arise-theme-1-rarity-rarity-uncommon-mid: ${theme.tokens.AriseTheme1RarityRarityUncommonMid};
                    --token-arise-theme-1-rarity-rarity-uncommon-dark: ${theme.tokens.AriseTheme1RarityRarityUncommonDark};
                    --token-arise-theme-1-rarity-rarity-rare-light: ${theme.tokens.AriseTheme1RarityRarityRareLight};
                    --token-arise-theme-1-rarity-rarity-rare-mid: ${theme.tokens.AriseTheme1RarityRarityRareMid};
                    --token-arise-theme-1-rarity-rarity-rare-dark: ${theme.tokens.AriseTheme1RarityRarityRareDark};
                    --token-arise-theme-1-rarity-rarity-epic-light: ${theme.tokens.AriseTheme1RarityRarityEpicLight};
                    --token-arise-theme-1-rarity-rarity-epic-mid: ${theme.tokens.AriseTheme1RarityRarityEpicMid};
                    --token-arise-theme-1-rarity-rarity-epic-dark: ${theme.tokens.AriseTheme1RarityRarityEpicDark};
                    --token-arise-theme-1-rarity-rarity-legendary-light: ${theme.tokens.AriseTheme1RarityRarityLegendaryLight};
                    --token-arise-theme-1-rarity-rarity-legendary-mid: ${theme.tokens.AriseTheme1RarityRarityLegendaryMid};
                    --token-arise-theme-1-rarity-rarity-legendary-dark: ${theme.tokens.AriseTheme1RarityRarityLegendaryDark};
                    --token-arise-theme-1-state-state-error-light: ${theme.tokens.AriseTheme1StateStateErrorLight};
                    --token-arise-theme-1-state-state-error-mid: ${theme.tokens.AriseTheme1StateStateErrorMid};
                    --token-arise-theme-1-state-state-error-dark: ${theme.tokens.AriseTheme1StateStateErrorDark};
                    --token-arise-theme-1-state-state-success-light: ${theme.tokens.AriseTheme1StateStateSuccessLight};
                    --token-arise-theme-1-state-state-success-mid: ${theme.tokens.AriseTheme1StateStateSuccessMid};
                    --token-arise-theme-1-state-state-success-dark: ${theme.tokens.AriseTheme1StateStateSuccessDark};
                    --token-arise-theme-1-state-state-default-light: ${theme.tokens.AriseTheme1StateStateDefaultLight};
                    --token-arise-theme-1-state-state-default-mid: ${theme.tokens.AriseTheme1StateStateDefaultMid};
                    --token-arise-theme-1-state-state-default-dark: ${theme.tokens.AriseTheme1StateStateDefaultDark};
                    --token-arise-theme-1-updates-updates-positive-light: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveLight};
                    --token-arise-theme-1-updates-updates-positive-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveMid};
                    --token-arise-theme-1-updates-updates-positive-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesPositiveDark};
                    --token-arise-theme-1-updates-updates-general-light: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralLight};
                    --token-arise-theme-1-updates-updates-general-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralMid};
                    --token-arise-theme-1-updates-updates-general-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesGeneralDark};
                    --token-arise-theme-1-updates-updates-achievement-light: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementLight};
                    --token-arise-theme-1-updates-updates-achievement-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementMid};
                    --token-arise-theme-1-updates-updates-achievement-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesAchievementDark};
                    --token-arise-theme-1-updates-updates-negative-light: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeLight};
                    --token-arise-theme-1-updates-updates-negative-mid: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeMid};
                    --token-arise-theme-1-updates-updates-negative-dark: ${theme.tokens.AriseTheme1UpdatesUpdatesNegativeDark};
                    --token-accent-theme-1-interface-mono-interface-white: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoWhite};
                    --token-accent-theme-1-interface-mono-interface-active: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoActive};
                    --token-accent-theme-1-interface-mono-interface-foreground: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoForeground};
                    --token-accent-theme-1-interface-mono-interface-midground: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoMidground};
                    --token-accent-theme-1-interface-mono-interface-background: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoBackground};
                    --token-accent-theme-1-interface-mono-interface-black: ${theme.tokens.AccentTheme1InterfaceMonoInterfaceMonoBlack};
                    --token-accent-theme-1-interface-brand-interface-active: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceActive};
                    --token-accent-theme-1-interface-brand-interface-foreground: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceForeground};
                    --token-accent-theme-1-interface-brand-interface-midground: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceMidground};
                    --token-accent-theme-1-interface-brand-interface-background: ${theme.tokens.AccentTheme1InterfaceBrandInterfaceBackground};
                    --token-accent-theme-1-border-border-default: ${theme.tokens.AccentTheme1BorderBorderDefault};
                    --token-accent-theme-1-border-border-highlight: ${theme.tokens.AccentTheme1BorderBorderHighlight};
                    --token-accent-theme-1-border-border-inactive: ${theme.tokens.AccentTheme1BorderBorderInactive};
                    --token-accent-theme-1-border-border-active: ${theme.tokens.AccentTheme1BorderBorderActive};
                    --token-accent-theme-1-brand-palette-brand-accent-1: ${theme.tokens.AccentTheme1BrandPaletteBrandAccent1};
                    --token-accent-theme-1-brand-palette-brand-accent-2: ${theme.tokens.AccentTheme1BrandPaletteBrandAccent2};
                    --token-accent-theme-1-brand-palette-brand-contrast-1: ${theme.tokens.AccentTheme1BrandPaletteBrandContrast1};
                    --token-accent-theme-1-brand-palette-brand-contrast-2: ${theme.tokens.AccentTheme1BrandPaletteBrandContrast2};
                    --token-accent-theme-1-brand-palette-brand-scale-1: ${theme.tokens.AccentTheme1BrandPaletteBrandScale1};
                    --token-accent-theme-1-brand-palette-brand-scale-2: ${theme.tokens.AccentTheme1BrandPaletteBrandScale2};
                    --token-accent-theme-1-brand-palette-brand-scale-3: ${theme.tokens.AccentTheme1BrandPaletteBrandScale3};
                    --token-accent-theme-1-brand-palette-brand-colour: ${theme.tokens.AccentTheme1BrandPaletteBrandColour};
                    --token-accent-theme-1-brand-palette-brand-colour-contrast: ${theme.tokens.AccentTheme1BrandPaletteBrandColourContrast};
                    --token-accent-theme-1-button-button-default: ${theme.tokens.AccentTheme1ButtonButtonDefault};
                    --token-accent-theme-1-button-button-highlight: ${theme.tokens.AccentTheme1ButtonButtonHighlight};
                    --token-accent-theme-1-button-button-active: ${theme.tokens.AccentTheme1ButtonButtonActive};
                    --token-accent-theme-1-button-button-inactive: ${theme.tokens.AccentTheme1ButtonButtonInactive};
                    --token-accent-theme-1-button-button-secondary-default: ${theme.tokens.AccentTheme1ButtonButtonSecondaryDefault};
                    --token-accent-theme-1-button-button-secondary-highlight: ${theme.tokens.AccentTheme1ButtonButtonSecondaryHighlight};
                    --token-accent-theme-1-button-button-secondary-active: ${theme.tokens.AccentTheme1ButtonButtonSecondaryActive};
                    --token-accent-theme-1-button-button-secondary-inactive: ${theme.tokens.AccentTheme1ButtonButtonSecondaryInactive};
                    --token-accent-theme-1-text-text-default: ${theme.tokens.AccentTheme1TextTextDefault};
                    --token-accent-theme-1-text-text-inactive: ${theme.tokens.AccentTheme1TextTextInactive};
                    --token-accent-theme-1-text-text-brand-2: ${theme.tokens.AccentTheme1TextTextBrand2};
                    --token-accent-theme-1-text-text-brand-1: ${theme.tokens.AccentTheme1TextTextBrand1};
                    --token-accent-theme-1-text-text-contrast-default: ${theme.tokens.AccentTheme1TextTextContrastDefault};
                    --token-accent-theme-1-text-text-link: ${theme.tokens.AccentTheme1TextTextLink};
                    --token-LEGACY-accent-theme-1-button-button-secondary: ${theme.tokens.LEGACYAccentTheme1ButtonButtonSecondary};
                    --token-LEGACY-accent-theme-1-text-text-active: ${theme.tokens.LEGACYAccentTheme1TextTextActive};
                    --token-LEGACY-accent-theme-1-text-text-secondary: ${theme.tokens.LEGACYAccentTheme1TextTextSecondary};
                    --token-LEGACY-accent-theme-1-interface-interface-active: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceActive};
                    --token-LEGACY-accent-theme-1-interface-interface-foreground: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceForeground};
                    --token-LEGACY-accent-theme-1-interface-interface-midground: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceMidground};
                    --token-LEGACY-accent-theme-1-interface-interface-background: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceBackground};
                    --token-LEGACY-accent-theme-1-interface-interface-white: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceWhite};
                    --token-LEGACY-accent-theme-1-interface-interface-grey: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceGrey};
                    --token-LEGACY-accent-theme-1-interface-interface-black: ${theme.tokens.LEGACYAccentTheme1InterfaceInterfaceBlack};
                    --token-LEGACY-accent-theme-1-brand-colour: ${theme.tokens.LEGACYAccentTheme1BrandColour};
                    --token-LEGACY-accent-theme-1-brand-colour-contrast: ${theme.tokens.LEGACYAccentTheme1BrandColourContrast};

                    --token-system-brand: #FF3319;
                    --token-system-brand-mono: #2E3035;
                    --token-system-text-default: #FFFFFF;
                    --token-system-text-alt: #ADADAD;
                    --token-system-interface-background: #141414;
                    --token-system-interface-midground: #282828;
                    --token-system-interface-foreground: #D9D9D9;
                    --token-system-interface-foreground-alt: #3A3A3A;
                    --token-system-state-error: #D81818;

                    ${(0, $764u1.isDiscordOnMobile)() ? discordUiSafeAreas : defaultSafeAreas}
                }
            `
    });
}

});
parcelRegister("764u1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13737b57871801e0$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "setQuestCompleted", function () { return $13737b57871801e0$export$1ae8fa5f3e29b54b; });
$parcel$export(module.exports, "setQuestProgress", function () { return $13737b57871801e0$export$4cfc0f2a1731c39b; });
$parcel$export(module.exports, "openExternalLinkDiscord", function () { return $13737b57871801e0$export$5b17b3e1f2afc156; });
$parcel$export(module.exports, "isDiscordOnMobile", function () { return $13737b57871801e0$export$b49c70d05fdcc765; });
$parcel$export(module.exports, "discordPlatform", function () { return $13737b57871801e0$export$787fabc8927c959b; });
$parcel$export(module.exports, "triggerDiscordShare", function () { return $13737b57871801e0$export$6cd85e0372786ce6; });
$parcel$export(module.exports, "shareImageInDiscordDesktop", function () { return $13737b57871801e0$export$48dd506b03a6eff7; });
parcelRequire("11xnK");
var $fo3Dl = parcelRequire("fo3Dl");
var $bAlFZ = parcelRequire("bAlFZ");

var $6YzEC = parcelRequire("6YzEC");

var $8FY87 = parcelRequire("8FY87");

var $aTRs6 = parcelRequire("aTRs6");

var $f9aoP = parcelRequire("f9aoP");

var $6lYLL = parcelRequire("6lYLL");

var $hzaQx = parcelRequire("hzaQx");

var $jJtwY = parcelRequire("jJtwY");

var $4KKbJ = parcelRequire("4KKbJ");

var $baXkz = parcelRequire("baXkz");

var $lXNKs = parcelRequire("lXNKs");

var $27K0D = parcelRequire("27K0D");

var $i7H0N = parcelRequire("i7H0N");

var $cEIti = parcelRequire("cEIti");

var $aooMk = parcelRequire("aooMk");
const $13737b57871801e0$var$CLIENT_ID = "1432744718667743306";
const $13737b57871801e0$var$url = new URL(window.location.href);
const $13737b57871801e0$var$ARISE_SESSION_ID = $13737b57871801e0$var$url.searchParams.get("arise_session_id");
const $13737b57871801e0$var$ARISE_SESSION_DATA = $13737b57871801e0$var$url.searchParams.get("arise_session_data");
const $13737b57871801e0$var$activityStartTime = Date.now();
// remove the session parameters from the URL and update the URL without reloading the page
if ($13737b57871801e0$var$ARISE_SESSION_ID) {
    console.log("[Arise] Removing session ID from URL");
    $13737b57871801e0$var$url.searchParams.delete("arise_session_id");
}
if ($13737b57871801e0$var$ARISE_SESSION_DATA) {
    console.log("[Arise] Removing session data from URL");
    $13737b57871801e0$var$url.searchParams.delete("arise_session_data");
}
window.history.replaceState({}, "", $13737b57871801e0$var$url.toString());
let $13737b57871801e0$var$userDiscordAccessToken = null;
let $13737b57871801e0$var$discordSDK = null;
try {
    // We need to instatiate this here on pageload so that the arise frontend does not change the query params in the URL that the discord sdk uses
    $13737b57871801e0$var$discordSDK = new (0, $fo3Dl.DiscordSDK)($13737b57871801e0$var$CLIENT_ID);
} catch (error) {
    if (0, $aTRs6.IS_DISCORD_ACTIVITY) console.error("[Arise] Discord SDK not instatiated", error);
}
let $13737b57871801e0$var$firstLayoutUpdateReceived = false;
function $13737b57871801e0$export$2e2bcd8739ae039() {
    const discord = (0, $8FY87.useRef)();
    const [user, setUser] = (0, $8FY87.useState)(null);
    const [authLoading, setAuthLoading] = (0, $8FY87.useState)(false);
    const [authError, setAuthError] = (0, $8FY87.useState)("");
    const [authDenied, setAuthDenied] = (0, $8FY87.useState)(false);
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    // not sure if we need this
    const [authData, setAuthData] = (0, $8FY87.useState)();
    const ariseRegister = $13737b57871801e0$var$useAriseRegister();
    const quest = $13737b57871801e0$var$useDiscordQuest();
    const { setLang: setLang } = (0, $aooMk.useLang)();
    (0, $8FY87.useEffect)(()=>{
        (async ()=>{
            try {
                if (!$13737b57871801e0$var$CLIENT_ID) {
                    console.error("[Arise] No PUBLIC_DISCORD_CLIENT_ID set");
                    return;
                }
                discord.current = $13737b57871801e0$var$discordSDK;
                let ok = false;
                if (!$13737b57871801e0$var$ARISE_SESSION_ID) {
                    console.log("[Arise] Waiting for Discord SDK to be ready");
                    await discord.current.ready();
                    console.log("[Arise] Discord SDK is ready");
                    // authorise immediately
                    ok = await authorize();
                } else {
                    console.log("[Arise] Forcing Discord SDK to be ready");
                    discord.current["isReady"] = true;
                    await discord.current.ready();
                    console.log("[Arise] Discord SDK is ready (forced)");
                    authoriseFromSession();
                }
                if (ok) (0, $i7H0N.sendEventV2Once)("discord_authenticated");
                quest.check();
                console.log("[Arise] Discord authorized");
            } catch (error) {
                console.log("[Arise] Could not get discord sdk ready", error);
            }
        })();
    }, []);
    async function setLanguageFromDiscordLocale() {
        try {
            const { locale: locale } = await discord.current.commands.userSettingsGetLocale();
            setLang(locale);
            console.info("[Arise] Setting language to:", locale);
            (0, $i7H0N.sendEventV2Once)("discord_locale", [
                locale
            ]);
        } catch (error) {
            console.warn("[Arise] Could not set discord locale:", error);
        }
    }
    async function authoriseFromSession() {
        console.log("[Arise] Authorizing from session");
        if (!$13737b57871801e0$var$ARISE_SESSION_DATA) {
            console.error("[Arise] No session data found in URL");
            return;
        }
        const data = JSON.parse($13737b57871801e0$var$ARISE_SESSION_DATA);
        console.log("[Arise] Session data from URL", data);
        if ($13737b57871801e0$var$ARISE_SESSION_DATA) {
            if (data.auth && data.authData) {
                setUser(data.auth.user);
                setLanguageFromDiscordLocale();
                dispatch((0, $4KKbJ.setProfileV2DisplayName)(data.auth.user.global_name || data.auth.user.username));
                $13737b57871801e0$var$userDiscordAccessToken = data.authData.access_token;
                $6YzEC.setAuthToken(data.authData.token);
                setAuthData(data.authData);
                console.log("[Arise] Restored Discord session from localStorage");
            } else console.error("[Arise] invalid session data in localStorage", $13737b57871801e0$var$ARISE_SESSION_DATA);
        } else console.error("[Arise] No session data found in localStorage");
    }
    async function authorize() {
        if (authLoading) return;
        setAuthLoading(true);
        setAuthDenied(false);
        setAuthError("");
        try {
            console.log("[Arise] No auth code found in URL, requesting authorization from Discord");
            const authRes = await discord.current.commands.authorize({
                client_id: $13737b57871801e0$var$CLIENT_ID,
                response_type: "code",
                state: "",
                prompt: "none",
                scope: [
                    "identify",
                    "applications.entitlements"
                ]
            });
            const code = authRes.code;
            (0, $i7H0N.sendEventV2)("discordlogin__prompt_accepted");
            let authData;
            try {
                authData = await $13737b57871801e0$var$tryXTimes(async ()=>{
                    const res = await $6YzEC.authorize(code);
                    if (!res.access_token) {
                        (0, $i7H0N.sendEventV2)("discordlogin__authexchange_no_token");
                        throw new Error("No auth data");
                    }
                    return res;
                }, 3);
            } catch (error) {
                console.error("[Arise] Error exchanging auth code for access token", error);
                (0, $i7H0N.sendEventV2)("discordlogin__authexchange_failed");
                const fallbackDisplayName = theme?.customJSON?.settings?.guestUsernamePrefix ?? "Guest";
                dispatch((0, $4KKbJ.setProfileV2DisplayName)(fallbackDisplayName));
                // @ts-ignore
                setUser({
                    username: fallbackDisplayName
                });
                setAuthLoading(false);
                return false;
            }
            const auth = await discord.current.commands.authenticate({
                access_token: authData.access_token
            });
            // Setup listeners
            // note: layout listerners do not work on password protected activities
            setupLayoutListeners();
            setUser(auth.user);
            dispatch((0, $4KKbJ.setProfileV2DisplayName)(auth.user.global_name || auth.user.username));
            setLanguageFromDiscordLocale();
            $13737b57871801e0$var$userDiscordAccessToken = authData.access_token;
            setAuthLoading(false);
            setAuthData(authData);
            $6YzEC.setAuthToken(authData.token);
            encourageHardwareAcceleration();
        } catch (error) {
            // User denied authorization
            if (error.code === 5000) {
                (0, $i7H0N.sendEventV2)("discordlogin__prompt_denied");
                setAuthDenied(true);
            } else if (error.code === 4002) ;
            else {
                (0, $i7H0N.sendEventV2)("discordlogin__error", [
                    error instanceof Error ? error.message : typeof error === "string" ? error : JSON.stringify(error)
                ]);
                console.log("[Arise] Authorizing Error", error);
                setAuthError("Error authorizing with Discord");
            }
        } finally{
            setAuthLoading(false);
        }
        // Register with Arise
        // This is an async call that doesn't return anything so we don't need to await it
        ariseRegisterFlow();
        return true;
    }
    async function ariseRegisterFlow() {
        try {
            await ariseRegister.register();
        } catch (e) {
            console.error("[Arise] Error registering with Arise", e);
        }
    }
    function openExternalLink(url) {
        if (discord.current) discord.current.commands.openExternalLink({
            url: url
        });
    }
    function onMinimise() {
        console.log("[Arise] Minimise");
        dispatch((0, $hzaQx.setWindowSize)("minimized"));
        dispatch((0, $baXkz.setShouldHideUI)(true));
    }
    function onMaximise() {
        console.log("[Arise] Maximise");
        dispatch((0, $hzaQx.setWindowSize)("maximized"));
        dispatch((0, $baXkz.setShouldHideUI)(false));
        setTimeout(()=>{
            quest.recheckEnrollment();
        }, 1000);
    }
    async function setupLayoutListeners() {
        const onActivityLayoutModeUpdate = (e)=>{
            console.log("[Arise] Activity layout mode update", e);
            if (!$13737b57871801e0$var$firstLayoutUpdateReceived) {
                $13737b57871801e0$var$firstLayoutUpdateReceived = true;
                return;
            }
            if (e.layout_mode === 1) onMinimise();
            else if (e.layout_mode === 0) onMaximise();
            else {
                console.log("[Arise] Unhandled layout mode", e.layout_mode);
                onMaximise();
            }
        };
        async function onQuestStatusUpdate(e) {
            console.log("[Arise] Quest status update from sdk", e);
        }
        if (discord.current) {
            await discord.current.subscribe((0, $bAlFZ.Events).ACTIVITY_LAYOUT_MODE_UPDATE, onActivityLayoutModeUpdate);
            await discord.current.subscribe((0, $bAlFZ.Events).QUEST_ENROLLMENT_STATUS_UPDATE, onQuestStatusUpdate);
        } else console.error("[Arise] Unable to setup listener");
        return ()=>{
            if (discord.current) {
                discord.current.unsubscribe((0, $bAlFZ.Events).ACTIVITY_LAYOUT_MODE_UPDATE, onActivityLayoutModeUpdate);
                discord.current.unsubscribe((0, $bAlFZ.Events).QUEST_ENROLLMENT_STATUS_UPDATE, onQuestStatusUpdate);
            }
        };
    }
    async function encourageHardwareAcceleration() {
        try {
            const res = await discord.current.commands.encourageHardwareAcceleration();
            (0, $i7H0N.sendEventV2)("encourage_hardware_acceleration", [
                res.enabled ? "enabled" : "disabled"
            ]);
        } catch (error) {
            console.error("[Arise] Error encouraging hardware acceleration", error);
        }
    }
    return {
        authorize: authorize,
        openExternalLink: openExternalLink,
        user: user,
        authError: authError,
        ariseRegister: ariseRegister,
        authDenied: authDenied,
        quest: quest,
        authLoading: authLoading
    };
}
function $13737b57871801e0$var$useAriseRegister() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const [trying, setTrying] = (0, $8FY87.useState)(false);
    const [failed, setFailed] = (0, $8FY87.useState)(false);
    async function register() {
        const totalAttempts = 3;
        let attempts = 0;
        let success = false;
        setTrying(true);
        while(!success && attempts < totalAttempts)try {
            const res = await $6YzEC.register();
            $f9aoP.setAuthToken(res.authToken);
            dispatch((0, $jJtwY.updateIsLoggedIn)(true));
            try {
                const payload = (0, $lXNKs.getTokenPayload)(res.authToken);
                (0, $27K0D.setUserId)(payload.sub);
            } catch (error) {}
            success = true;
            break;
        } catch (error) {
            console.log("[Arise] Error registering with Arise", error);
            attempts++;
        }
        setTrying(false);
        if (!success) setFailed(true);
    }
    return {
        register: register,
        trying: trying,
        failed: failed
    };
}
function $13737b57871801e0$var$useDiscordQuest() {
    const id = "1445135504210395167";
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const status = (0, $6lYLL.useAppSelector)((state)=>state.discord.questStatus);
    const checked = (0, $6lYLL.useAppSelector)((state)=>state.discord.questStatusChecked);
    async function check() {
        try {
            $13737b57871801e0$var$getQuestStatusAsync();
            const data = await $6YzEC.checkQuest();
            let status = "not_enrolled";
            if (data.completed_at) status = "completed";
            else if (data.enrolled_at) status = "enrolled";
            dispatch((0, $hzaQx.setQuestStatus)(status));
            return {
                status: status,
                checked: true
            };
        } catch (error) {
            console.log("[Arise] Error checking quest status", error);
        }
        return {
            status: "not_enrolled",
            checked: false
        };
    }
    async function complete() {
        await $13737b57871801e0$export$1ae8fa5f3e29b54b();
        dispatch((0, $hzaQx.setQuestStatus)("completed"));
    }
    async function progress(val) {
        await $13737b57871801e0$export$4cfc0f2a1731c39b(val);
    }
    async function recheckEnrollment() {
        console.log("[Arise] Rechecking enrollment");
        if (status === "not_enrolled" || !status) await check();
    }
    return {
        check: check,
        checked: checked,
        status: status,
        complete: complete,
        recheckEnrollment: recheckEnrollment,
        id: id,
        progress: progress
    };
}
function $13737b57871801e0$export$30668231c031c47c() {
    if ($13737b57871801e0$var$discordSDK) $13737b57871801e0$var$discordSDK.commands.openExternalLink({
        url: `https://discord.com/quests/${"1445135504210395167"}`
    });
}
function $13737b57871801e0$export$5b17b3e1f2afc156(url) {
    if ($13737b57871801e0$var$discordSDK && url) $13737b57871801e0$var$discordSDK.commands.openExternalLink({
        url: url
    });
}
function $13737b57871801e0$export$60ee035e6a733fa1() {
    // Some quests are 0-1 and some 0-100
    return Number(undefined) || 1;
}
async function $13737b57871801e0$export$4cfc0f2a1731c39b(val) {
    try {
        const maxProgress = $13737b57871801e0$export$60ee035e6a733fa1();
        if (maxProgress === 1 || val > maxProgress) {
            console.log("[Arise] Cannot set quest progress - value is invalid for this quest", val);
            return;
        }
        (0, $i7H0N.sendEventV2)("quest_progress", [], [
            Date.now() - $13737b57871801e0$var$activityStartTime,
            val
        ]);
        await $6YzEC.questProgress(val);
    } catch (error) {
        console.log("[Arise] Error progressing quest", error);
    }
}
async function $13737b57871801e0$export$1ae8fa5f3e29b54b() {
    try {
        (0, $i7H0N.sendEventV2)("quest_complete", [], [
            Date.now() - $13737b57871801e0$var$activityStartTime
        ]);
        const maxProgress = $13737b57871801e0$export$60ee035e6a733fa1();
        await $6YzEC.questProgress(maxProgress);
    } catch (error) {
        console.log("[Arise] Error completing quest", error);
    }
}
function $13737b57871801e0$export$b49c70d05fdcc765() {
    return $13737b57871801e0$var$discordSDK?.platform === "mobile";
}
function $13737b57871801e0$export$787fabc8927c959b() {
    return $13737b57871801e0$var$discordSDK?.platform;
}
async function $13737b57871801e0$export$6cd85e0372786ce6(text = "") {
    if ($13737b57871801e0$var$discordSDK) try {
        const shouldLinkToQuest = "1445135504210395167";
        const url = shouldLinkToQuest ? `https://discord.com/quests/${"1445135504210395167"}` : `https://discord.com/activities/${"1432744718667743306"}`;
        (0, $i7H0N.sendEventV2)("share", [
            "discord_internal",
            text,
            url
        ]);
        await $13737b57871801e0$var$discordSDK.commands.shareLink({
            message: `${text} ${url}`
        });
    } catch (error) {
        console.error("[Arise] Share Dialogue Error: ", JSON.stringify(error));
    }
    else console.error("[Arise] Discord SDK not available");
}
async function $13737b57871801e0$export$e6472d92d4dedd21(imageUrl, filename) {
    const mediaUrl = await $13737b57871801e0$var$uploadImageToDiscordCDN(imageUrl, filename);
    await $13737b57871801e0$var$discordSDK.commands.openExternalLink({
        url: mediaUrl
    });
}
async function $13737b57871801e0$var$uploadImageToDiscordCDN(imageURL, filename) {
    const response = await fetch(imageURL);
    const blob = await response.blob();
    const mimeType = "image/jpeg";
    const buf = await blob.arrayBuffer();
    const imageFile = new File([
        buf
    ], filename, {
        type: mimeType
    });
    const body = new FormData();
    body.append("file", imageFile);
    const attachmentResponse = await fetch(`https://discord.com/api/v10/applications/${$13737b57871801e0$var$CLIENT_ID}/attachment`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${$13737b57871801e0$var$userDiscordAccessToken}`
        },
        body: body
    });
    const attachmentJson = await attachmentResponse.json();
    const mediaUrl = attachmentJson.attachment.url;
    return mediaUrl;
}
async function $13737b57871801e0$export$48dd506b03a6eff7(imageUrl, filename) {
    try {
        const mediaUrl = await $13737b57871801e0$var$uploadImageToDiscordCDN(imageUrl, filename);
        await $13737b57871801e0$var$discordSDK.commands.openShareMomentDialog({
            mediaUrl: mediaUrl
        });
    } catch (error) {
        console.log("[Arise] Could not openShareMomentDialog", error);
    }
}
function $13737b57871801e0$var$tryXTimes(fn, times) {
    return new Promise((resolve, reject)=>{
        let attempts = 0;
        const tryFn = async ()=>{
            try {
                const res = await fn();
                resolve(res);
            } catch (error) {
                console.log(`[Arise] Attempt ${attempts + 1} failed`, error);
                if (attempts < times) {
                    attempts++;
                    setTimeout(tryFn, 1000);
                } else {
                    console.error(`[Arise] All ${times} attempts failed`, error);
                    reject(error);
                }
            }
        };
        tryFn();
    });
}
async function $13737b57871801e0$var$getQuestStatusAsync() {
    const id = "1445135504210395167";
    const status = await $13737b57871801e0$var$discordSDK?.commands.getQuestEnrollmentStatus({
        quest_id: id || ""
    });
    console.log("[Arise] Quest status from sdk", status);
}

});
parcelRegister("11xnK", function(module, exports) {

$parcel$export(module.exports, "DiscordSDK", function () { return (parcelRequire("fo3Dl")).DiscordSDK; });
$parcel$export(module.exports, "Events", function () { return (parcelRequire("bAlFZ")).Events; });

var $fo3Dl = parcelRequire("fo3Dl");

var $bAlFZ = parcelRequire("bAlFZ");

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $gROQ6 = parcelRequire("gROQ6");

var $8hKTE = parcelRequire("8hKTE");

var $7dLbJ = parcelRequire("7dLbJ");

var $02mKu = parcelRequire("02mKu");

var $WjFKr = parcelRequire("WjFKr");
const { Commands: $cd7c058facc8ebbe$export$ba30f7724cb0e54e } = $kq6d3;

});
parcelRegister("fo3Dl", function(module, exports) {

$parcel$export(module.exports, "DiscordSDK", function () { return $fb315b61917af159$export$7cb9b6936cca2046; });

var $eph6D = parcelRequire("eph6D");

var $fOga2 = parcelRequire("fOga2");

var $6nXjj = parcelRequire("6nXjj");

var $fZxXb = parcelRequire("fZxXb");

var $bAlFZ = parcelRequire("bAlFZ");

var $gROQ6 = parcelRequire("gROQ6");

var $8jr1s = parcelRequire("8jr1s");

var $4P8oU = parcelRequire("4P8oU");

var $16B0t = parcelRequire("16B0t");

var $kq6d3 = parcelRequire("kq6d3");

var $iMbuh = parcelRequire("iMbuh");
var $fb315b61917af159$export$6354ae5022ad3977;
(function(Opcodes) {
    Opcodes[Opcodes["HANDSHAKE"] = 0] = "HANDSHAKE";
    Opcodes[Opcodes["FRAME"] = 1] = "FRAME";
    Opcodes[Opcodes["CLOSE"] = 2] = "CLOSE";
    Opcodes[Opcodes["HELLO"] = 3] = "HELLO";
})($fb315b61917af159$export$6354ae5022ad3977 || ($fb315b61917af159$export$6354ae5022ad3977 = {}));
const $fb315b61917af159$var$ALLOWED_ORIGINS = new Set($fb315b61917af159$var$getAllowedOrigins());
function $fb315b61917af159$var$getAllowedOrigins() {
    if (typeof window === "undefined") return [];
    return [
        window.location.origin,
        "https://discord.com",
        "https://discordapp.com",
        "https://ptb.discord.com",
        "https://ptb.discordapp.com",
        "https://canary.discord.com",
        "https://canary.discordapp.com",
        "https://staging.discord.co",
        "http://localhost:3333",
        "https://pax.discord.com",
        "null"
    ];
}
/**
 * The embedded application is running in an IFrame either within the main Discord client window or in a popout. The RPC server is always running in the main Discord client window. In either case, the referrer is the correct origin.
 */ function $fb315b61917af159$var$getRPCServerSource() {
    var _a;
    return [
        (_a = window.parent.opener) !== null && _a !== void 0 ? _a : window.parent,
        !!document.referrer ? document.referrer : "*"
    ];
}
class $fb315b61917af159$export$7cb9b6936cca2046 {
    getTransfer(payload) {
        var _a;
        switch(payload.cmd){
            case (0, $kq6d3.Commands).SUBSCRIBE:
            case (0, $kq6d3.Commands).UNSUBSCRIBE:
                return undefined;
            default:
                return (_a = payload.transfer) !== null && _a !== void 0 ? _a : undefined;
        }
    }
    constructor(clientId, configuration){
        this.sdkVersion = (0, $16B0t.version);
        this.mobileAppVersion = null;
        this.source = null;
        this.sourceOrigin = "";
        this.eventBus = new (0, $eph6D.default)();
        this.pendingCommands = new Map();
        this.sendCommand = (payload)=>{
            var _a;
            if (this.source == null) throw new Error("Attempting to send message before initialization");
            const nonce = (0, $iMbuh.default)();
            (_a = this.source) === null || _a === void 0 || _a.postMessage([
                $fb315b61917af159$export$6354ae5022ad3977.FRAME,
                Object.assign(Object.assign({}, payload), {
                    nonce: nonce
                })
            ], this.sourceOrigin, this.getTransfer(payload));
            const promise = new Promise((resolve, reject)=>{
                this.pendingCommands.set(nonce, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return promise;
        };
        this.commands = (0, $6nXjj.default)(this.sendCommand);
        /**
         * WARNING - All "console" logs are emitted as messages to the Discord client
         *  If you write "console.log" anywhere in handleMessage or subsequent message handling
         * there is a good chance you will cause an infinite loop where you receive a message
         * which causes "console.log" which sends a message, which causes the discord client to
         * send a reply which causes handleMessage to fire again, and again to inifinity
         *
         * If you need to log within handleMessage, consider setting
         * config.disableConsoleLogOverride to true when initializing the SDK
         */ this.handleMessage = (event)=>{
            if (!$fb315b61917af159$var$ALLOWED_ORIGINS.has(event.origin)) return;
            const tuple = event.data;
            if (!Array.isArray(tuple)) return;
            const [opcode, data] = tuple;
            switch(opcode){
                case $fb315b61917af159$export$6354ae5022ad3977.HELLO:
                    // backwards compat; the Discord client will still send HELLOs for old applications.
                    //
                    // TODO: figure out compatibility approach; it would be easier to maintain compatibility at the SDK level, not the underlying RPC protocol level...
                    return;
                case $fb315b61917af159$export$6354ae5022ad3977.CLOSE:
                    return this.handleClose(data);
                case $fb315b61917af159$export$6354ae5022ad3977.HANDSHAKE:
                    return this.handleHandshake();
                case $fb315b61917af159$export$6354ae5022ad3977.FRAME:
                    return this.handleFrame(data);
                default:
                    throw new Error("Invalid message format");
            }
        };
        this.isReady = false;
        this.clientId = clientId;
        this.configuration = configuration !== null && configuration !== void 0 ? configuration : (0, $8jr1s.default)();
        if (typeof window !== "undefined") window.addEventListener("message", this.handleMessage);
        if (typeof window === "undefined") {
            this.frameId = "";
            this.instanceId = "";
            this.customId = null;
            this.referrerId = null;
            this.platform = (0, $gROQ6.Platform).DESKTOP;
            this.guildId = null;
            this.channelId = null;
            this.locationId = null;
            return;
        }
        // START Capture URL Query Params
        const urlParams = new URLSearchParams(this._getSearch());
        const frameId = urlParams.get("frame_id");
        if (!frameId) throw new Error("frame_id query param is not defined");
        this.frameId = frameId;
        const instanceId = urlParams.get("instance_id");
        if (!instanceId) throw new Error("instance_id query param is not defined");
        this.instanceId = instanceId;
        const platform = urlParams.get("platform");
        if (!platform) throw new Error("platform query param is not defined");
        else if (platform !== (0, $gROQ6.Platform).DESKTOP && platform !== (0, $gROQ6.Platform).MOBILE) throw new Error(`Invalid query param "platform" of "${platform}". Valid values are "${(0, $gROQ6.Platform).DESKTOP}" or "${(0, $gROQ6.Platform).MOBILE}"`);
        this.platform = platform;
        this.customId = urlParams.get("custom_id");
        this.referrerId = urlParams.get("referrer_id");
        this.guildId = urlParams.get("guild_id");
        this.channelId = urlParams.get("channel_id");
        this.locationId = urlParams.get("location_id");
        this.mobileAppVersion = urlParams.get("mobile_app_version");
        // END Capture URL Query Params
        [this.source, this.sourceOrigin] = $fb315b61917af159$var$getRPCServerSource();
        this.addOnReadyListener();
        this.handshake();
    }
    close(code, message) {
        var _a;
        window.removeEventListener("message", this.handleMessage);
        const nonce = (0, $iMbuh.default)();
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $fb315b61917af159$export$6354ae5022ad3977.CLOSE,
            {
                code: code,
                message: message,
                nonce: nonce
            }
        ], this.sourceOrigin);
    }
    async subscribe(event, listener, ...rest) {
        const [subscribeArgs] = rest;
        const listenerCount = this.eventBus.listenerCount(event);
        const emitter = this.eventBus.on(event, listener);
        // If first subscription, subscribe via RPC
        if (Object.values((0, $bAlFZ.Events)).includes(event) && event !== (0, $bAlFZ.Events).READY && listenerCount === 0) await this.sendCommand({
            cmd: (0, $kq6d3.Commands).SUBSCRIBE,
            args: subscribeArgs,
            evt: event
        });
        return emitter;
    }
    async unsubscribe(event, listener, ...rest) {
        const [unsubscribeArgs] = rest;
        if (event !== (0, $bAlFZ.Events).READY && this.eventBus.listenerCount(event) === 1) await this.sendCommand({
            cmd: (0, $kq6d3.Commands).UNSUBSCRIBE,
            evt: event,
            args: unsubscribeArgs
        });
        return this.eventBus.off(event, listener);
    }
    async ready() {
        if (this.isReady) return;
        else await new Promise((resolve)=>{
            this.eventBus.once((0, $bAlFZ.Events).READY, resolve);
        });
    }
    parseMajorMobileVersion() {
        if (this.mobileAppVersion && this.mobileAppVersion.includes(".")) try {
            return parseInt(this.mobileAppVersion.split(".")[0]);
        } catch (_a) {
            return 0, $gROQ6.UNKNOWN_VERSION_NUMBER;
        }
        return 0, $gROQ6.UNKNOWN_VERSION_NUMBER;
    }
    handshake() {
        var _a;
        const handshakePayload = {
            v: 1,
            encoding: "json",
            client_id: this.clientId,
            frame_id: this.frameId
        };
        const majorMobileVersion = this.parseMajorMobileVersion();
        if (this.platform === (0, $gROQ6.Platform).DESKTOP || majorMobileVersion >= (0, $gROQ6.HANDSHAKE_SDK_VERSION_MINIMUM_MOBILE_VERSION)) handshakePayload["sdk_version"] = this.sdkVersion;
        (_a = this.source) === null || _a === void 0 || _a.postMessage([
            $fb315b61917af159$export$6354ae5022ad3977.HANDSHAKE,
            handshakePayload
        ], this.sourceOrigin);
    }
    addOnReadyListener() {
        this.eventBus.once((0, $bAlFZ.Events).READY, ()=>{
            this.overrideConsoleLogging();
            this.isReady = true;
        });
    }
    overrideConsoleLogging() {
        if (this.configuration.disableConsoleLogOverride) return;
        const sendCaptureLogCommand = (level, message)=>{
            this.commands.captureLog({
                level: level,
                message: message
            });
        };
        (0, $4P8oU.consoleLevels).forEach((level)=>{
            (0, $4P8oU.wrapConsoleMethod)(console, level, sendCaptureLogCommand);
        });
    }
    handleClose(data) {
        (0, $fOga2.ClosePayload).parse(data);
    }
    handleHandshake() {}
    handleFrame(payload) {
        var _a, _b;
        let parsed;
        try {
            parsed = (0, $fOga2.parseIncomingPayload)(payload);
        } catch (e) {
            console.error("Failed to parse", payload);
            console.error(e);
            return;
        }
        if (parsed.cmd === "DISPATCH") this.eventBus.emit(parsed.evt, parsed.data);
        else {
            if (parsed.evt === (0, $bAlFZ.ERROR)) {
                // In response to a command
                if (parsed.nonce != null) {
                    (_a = this.pendingCommands.get(parsed.nonce)) === null || _a === void 0 || _a.reject(parsed.data);
                    this.pendingCommands.delete(parsed.nonce);
                    return;
                }
                // General error
                this.eventBus.emit("error", new (0, $fZxXb.SDKError)(parsed.data.code, parsed.data.message));
            }
            if (parsed.nonce == null) {
                console.error("Missing nonce", payload);
                return;
            }
            (_b = this.pendingCommands.get(parsed.nonce)) === null || _b === void 0 || _b.resolve(parsed);
            this.pendingCommands.delete(parsed.nonce);
        }
    }
    _getSearch() {
        return typeof window === "undefined" ? "" : window.location.search;
    }
}

});
parcelRegister("eph6D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6099179212b82c$export$2e2bcd8739ae039; });

var $fgm47 = parcelRequire("fgm47");

var $5wgJB = parcelRequire("5wgJB");
var $ed6099179212b82c$var$eventemitter3Exports = (0, $5wgJB.__require)();
var $ed6099179212b82c$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fgm47.getDefaultExportFromCjs)($ed6099179212b82c$var$eventemitter3Exports);

});
parcelRegister("fgm47", function(module, exports) {

$parcel$export(module.exports, "commonjsGlobal", function () { return $ec92f086ba857d61$export$a441d440b06e3168; });
$parcel$export(module.exports, "getDefaultExportFromCjs", function () { return $ec92f086ba857d61$export$22b09f878622677a; });
var $ec92f086ba857d61$export$a441d440b06e3168 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $ec92f086ba857d61$export$22b09f878622677a(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}

});

parcelRegister("5wgJB", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $c9ba5ea0c7807264$export$b88c30a9414655a0; });

var $845OY = parcelRequire("845OY");
var $c9ba5ea0c7807264$var$hasRequiredEventemitter3;
function $c9ba5ea0c7807264$export$b88c30a9414655a0() {
    if ($c9ba5ea0c7807264$var$hasRequiredEventemitter3) return (0, $845OY.__module).exports;
    $c9ba5ea0c7807264$var$hasRequiredEventemitter3 = 1;
    (function(module) {
        var has = Object.prototype.hasOwnProperty, prefix = "~";
        /**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */ function Events() {}
        //
        // We try to not inherit from `Object.prototype`. In some engines creating an
        // instance in this way is faster than calling `Object.create(null)` directly.
        // If `Object.create(null)` is not supported we prefix the event names with a
        // character to make sure that the built-in object properties are not
        // overridden or used as an attack vector.
        //
        if (Object.create) {
            Events.prototype = Object.create(null);
            //
            // This hack is needed because the `__proto__` property is still inherited in
            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
            //
            if (!new Events().__proto__) prefix = false;
        }
        /**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */ function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        /**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */ function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== "function") throw new TypeError("The listener must be a function");
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        /**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */ function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        /**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */ function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        /**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */ EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        /**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */ EventEmitter.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        /**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        /**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        /**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        /**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        /**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                //
                // Reset the array, or remove it completely if we have no more listeners.
                //
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        /**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        //
        // Alias methods names because people roll like that.
        //
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
        //
        // Expose the prefix.
        //
        EventEmitter.prefixed = prefix;
        //
        // Allow `EventEmitter` to be imported as module namespace.
        //
        EventEmitter.EventEmitter = EventEmitter;
        module.exports = EventEmitter;
    })((0, $845OY.__module));
    return (0, $845OY.__module).exports;
}

});
parcelRegister("845OY", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $9bf576f803722863$export$5edeffb658f039f4; });
var $9bf576f803722863$export$5edeffb658f039f4 = {
    exports: {}
};

});



parcelRegister("fOga2", function(module, exports) {

$parcel$export(module.exports, "ClosePayload", function () { return $c9ee8a77a8906e58$export$46b1619f8b73becb; });
$parcel$export(module.exports, "parseIncomingPayload", function () { return $c9ee8a77a8906e58$export$97b1c66ab98393bd; });

var $TGurO = parcelRequire("TGurO");

var $bAlFZ = parcelRequire("bAlFZ");

var $f7w82 = parcelRequire("f7w82");

var $kq6d3 = parcelRequire("kq6d3");

var $gROQ6 = parcelRequire("gROQ6");
(0, $TGurO.object)({
    frame_id: (0, $TGurO.string)(),
    platform: (0, $TGurO.nativeEnum)((0, $gROQ6.Platform)).optional().nullable()
});
(0, $TGurO.object)({
    v: (0, $TGurO.literal)(1),
    encoding: (0, $TGurO.literal)("json").optional(),
    client_id: (0, $TGurO.string)(),
    frame_id: (0, $TGurO.string)()
});
const $c9ee8a77a8906e58$export$46b1619f8b73becb = (0, $TGurO.object)({
    code: (0, $TGurO.number)(),
    message: (0, $TGurO.string)().optional()
});
const $c9ee8a77a8906e58$export$d3f475fe77824935 = (0, $TGurO.object)({
    evt: (0, $TGurO.string)().nullable(),
    nonce: (0, $TGurO.string)().nullable(),
    data: (0, $TGurO.unknown)().nullable(),
    cmd: (0, $TGurO.string)()
}).passthrough();
function $c9ee8a77a8906e58$export$97b1c66ab98393bd(payload) {
    const incoming = $c9ee8a77a8906e58$export$d3f475fe77824935.parse(payload);
    if (incoming.evt != null) {
        if (incoming.evt === (0, $bAlFZ.ERROR)) return (0, $bAlFZ.ErrorEvent).parse(incoming);
        return (0, $bAlFZ.parseEventPayload)((0, $bAlFZ.EventFrame).parse(incoming));
    } else return (0, $f7w82.parseResponsePayload)((0, $f7w82.ResponseFrame).passthrough().parse(incoming));
}

});
parcelRegister("TGurO", function(module, exports) {

$parcel$export(module.exports, "custom", function () { return $1c799876e31a42dd$export$4c00f665f0d4b443; });
$parcel$export(module.exports, "string", function () { return $1c799876e31a42dd$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $1c799876e31a42dd$export$98e628dec113755e; });
$parcel$export(module.exports, "bigint", function () { return $1c799876e31a42dd$export$a0f65b52274bcc00; });
$parcel$export(module.exports, "boolean", function () { return $1c799876e31a42dd$export$4a21f16c33752377; });
$parcel$export(module.exports, "null", function () { return $1c799876e31a42dd$export$7b1b591b262c240; });
$parcel$export(module.exports, "unknown", function () { return $1c799876e31a42dd$export$19282c40b967aec6; });
$parcel$export(module.exports, "array", function () { return $1c799876e31a42dd$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $1c799876e31a42dd$export$be5493f9613cbbe; });
$parcel$export(module.exports, "union", function () { return $1c799876e31a42dd$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "literal", function () { return $1c799876e31a42dd$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "nativeEnum", function () { return $1c799876e31a42dd$export$6fe7eca19ebe5199; });
$parcel$export(module.exports, "optional", function () { return $1c799876e31a42dd$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "preprocess", function () { return $1c799876e31a42dd$export$fc37fe19dfda43ee; });
$parcel$export(module.exports, "default", function () { return $1c799876e31a42dd$export$2e2bcd8739ae039; });
var $1c799876e31a42dd$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($1c799876e31a42dd$export$7debb50ef11d5e0b || ($1c799876e31a42dd$export$7debb50ef11d5e0b = {}));
var $1c799876e31a42dd$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($1c799876e31a42dd$export$4aa2142c225fd5c7 || ($1c799876e31a42dd$export$4aa2142c225fd5c7 = {}));
const $1c799876e31a42dd$export$5716da67bfaa244d = $1c799876e31a42dd$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $1c799876e31a42dd$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $1c799876e31a42dd$export$5716da67bfaa244d.undefined;
        case "string":
            return $1c799876e31a42dd$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $1c799876e31a42dd$export$5716da67bfaa244d.nan : $1c799876e31a42dd$export$5716da67bfaa244d.number;
        case "boolean":
            return $1c799876e31a42dd$export$5716da67bfaa244d.boolean;
        case "function":
            return $1c799876e31a42dd$export$5716da67bfaa244d.function;
        case "bigint":
            return $1c799876e31a42dd$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $1c799876e31a42dd$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $1c799876e31a42dd$export$5716da67bfaa244d.array;
            if (data === null) return $1c799876e31a42dd$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $1c799876e31a42dd$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $1c799876e31a42dd$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $1c799876e31a42dd$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $1c799876e31a42dd$export$5716da67bfaa244d.date;
            return $1c799876e31a42dd$export$5716da67bfaa244d.object;
        default:
            return $1c799876e31a42dd$export$5716da67bfaa244d.unknown;
    }
};
const $1c799876e31a42dd$export$5ba560653e4a1035 = $1c799876e31a42dd$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $1c799876e31a42dd$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $1c799876e31a42dd$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $1c799876e31a42dd$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $1c799876e31a42dd$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$1c799876e31a42dd$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $1c799876e31a42dd$export$f98dac4b251ab333(issues);
    return error;
};
const $1c799876e31a42dd$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $1c799876e31a42dd$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $1c799876e31a42dd$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$1c799876e31a42dd$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$1c799876e31a42dd$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$1c799876e31a42dd$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $1c799876e31a42dd$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $1c799876e31a42dd$var$overrideErrorMap = $1c799876e31a42dd$export$341b0b6e0a6f5099;
function $1c799876e31a42dd$export$1097a8289cfd22d7(map) {
    $1c799876e31a42dd$var$overrideErrorMap = map;
}
function $1c799876e31a42dd$export$32f27c719778d4c4() {
    return $1c799876e31a42dd$var$overrideErrorMap;
}
const $1c799876e31a42dd$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $1c799876e31a42dd$export$1526d2e05f74572 = [];
function $1c799876e31a42dd$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $1c799876e31a42dd$export$32f27c719778d4c4();
    const issue = $1c799876e31a42dd$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $1c799876e31a42dd$export$341b0b6e0a6f5099 ? undefined : $1c799876e31a42dd$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $1c799876e31a42dd$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $1c799876e31a42dd$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $1c799876e31a42dd$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $1c799876e31a42dd$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $1c799876e31a42dd$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $1c799876e31a42dd$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $1c799876e31a42dd$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $1c799876e31a42dd$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $1c799876e31a42dd$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return state.get(receiver);
}
function $1c799876e31a42dd$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $1c799876e31a42dd$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($1c799876e31a42dd$var$errorUtil || ($1c799876e31a42dd$var$errorUtil = {}));
var $1c799876e31a42dd$var$_ZodEnum_cache, $1c799876e31a42dd$var$_ZodNativeEnum_cache;
class $1c799876e31a42dd$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $1c799876e31a42dd$var$handleResult = (ctx, result)=>{
    if ($1c799876e31a42dd$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $1c799876e31a42dd$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $1c799876e31a42dd$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $1c799876e31a42dd$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $1c799876e31a42dd$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $1c799876e31a42dd$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $1c799876e31a42dd$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($1c799876e31a42dd$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $1c799876e31a42dd$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $1c799876e31a42dd$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $1c799876e31a42dd$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($1c799876e31a42dd$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $1c799876e31a42dd$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $1c799876e31a42dd$export$a60af00cc0ce2582({
            schema: this,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $1c799876e31a42dd$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $1c799876e31a42dd$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $1c799876e31a42dd$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $1c799876e31a42dd$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $1c799876e31a42dd$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $1c799876e31a42dd$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $1c799876e31a42dd$export$a60af00cc0ce2582({
            ...$1c799876e31a42dd$var$processCreateParams(this._def),
            schema: this,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $1c799876e31a42dd$export$bb19b37874861e7e({
            ...$1c799876e31a42dd$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $1c799876e31a42dd$export$66b0c798a395271f({
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$1c799876e31a42dd$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $1c799876e31a42dd$export$75a44ec6249ac76b({
            ...$1c799876e31a42dd$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $1c799876e31a42dd$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $1c799876e31a42dd$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $1c799876e31a42dd$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $1c799876e31a42dd$var$cuid2Regex = /^[0-9a-z]+$/;
const $1c799876e31a42dd$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $1c799876e31a42dd$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $1c799876e31a42dd$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $1c799876e31a42dd$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $1c799876e31a42dd$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $1c799876e31a42dd$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $1c799876e31a42dd$var$emojiRegex;
// faster, simpler, safer
const $1c799876e31a42dd$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $1c799876e31a42dd$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $1c799876e31a42dd$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $1c799876e31a42dd$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $1c799876e31a42dd$var$dateRegex = new RegExp(`^${$1c799876e31a42dd$var$dateRegexSource}$`);
function $1c799876e31a42dd$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $1c799876e31a42dd$var$timeRegex(args) {
    return new RegExp(`^${$1c799876e31a42dd$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $1c799876e31a42dd$export$a4b563879add27a(args) {
    let regex = `${$1c799876e31a42dd$var$dateRegexSource}T${$1c799876e31a42dd$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $1c799876e31a42dd$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $1c799876e31a42dd$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $1c799876e31a42dd$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $1c799876e31a42dd$export$1230eb29b8d3b502 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const status = new $1c799876e31a42dd$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$1c799876e31a42dd$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$1c799876e31a42dd$var$emojiRegex) $1c799876e31a42dd$var$emojiRegex = new RegExp($1c799876e31a42dd$var$_emojiRegex, "u");
                if (!$1c799876e31a42dd$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$1c799876e31a42dd$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$1c799876e31a42dd$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$1c799876e31a42dd$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$1c799876e31a42dd$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$1c799876e31a42dd$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $1c799876e31a42dd$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $1c799876e31a42dd$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $1c799876e31a42dd$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$1c799876e31a42dd$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$1c799876e31a42dd$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$1c799876e31a42dd$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_string,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $1c799876e31a42dd$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$1c799876e31a42dd$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $1c799876e31a42dd$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $1c799876e31a42dd$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $1c799876e31a42dd$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $1c799876e31a42dd$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$1c799876e31a42dd$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $1c799876e31a42dd$export$1230eb29b8d3b502({
        checks: [],
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $1c799876e31a42dd$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $1c799876e31a42dd$export$5b070a55c0c43e09 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $1c799876e31a42dd$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$1c799876e31a42dd$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($1c799876e31a42dd$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $1c799876e31a42dd$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $1c799876e31a42dd$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $1c799876e31a42dd$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $1c799876e31a42dd$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$1c799876e31a42dd$export$5b070a55c0c43e09.create = (params)=>{
    return new $1c799876e31a42dd$export$5b070a55c0c43e09({
        checks: [],
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$67d741fd70ff98f4 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $1c799876e31a42dd$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $1c799876e31a42dd$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $1c799876e31a42dd$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $1c799876e31a42dd$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $1c799876e31a42dd$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$1c799876e31a42dd$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $1c799876e31a42dd$export$67d741fd70ff98f4({
        checks: [],
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$723d146f80596191 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$723d146f80596191.create = (params)=>{
    return new $1c799876e31a42dd$export$723d146f80596191({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$e974be33bdc55521 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_date
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const status = new $1c799876e31a42dd$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $1c799876e31a42dd$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $1c799876e31a42dd$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$1c799876e31a42dd$export$e974be33bdc55521.create = (params)=>{
    return new $1c799876e31a42dd$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodDate,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$bcc3b40f6b638044 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$bcc3b40f6b638044.create = (params)=>{
    return new $1c799876e31a42dd$export$bcc3b40f6b638044({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodSymbol,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$4e780e961c30340d extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$4e780e961c30340d.create = (params)=>{
    return new $1c799876e31a42dd$export$4e780e961c30340d({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodUndefined,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$a96281f914484f2d extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$a96281f914484f2d.create = (params)=>{
    return new $1c799876e31a42dd$export$a96281f914484f2d({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNull,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$b9d1edb536b4e4eb extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $1c799876e31a42dd$export$b9d1edb536b4e4eb({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodAny,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$ef3b1bb1630977ae extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$ef3b1bb1630977ae.create = (params)=>{
    return new $1c799876e31a42dd$export$ef3b1bb1630977ae({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodUnknown,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$1e576a20c3ce9fb5 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
            code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
            expected: $1c799876e31a42dd$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $1c799876e31a42dd$export$9a105a556e65c2c0;
    }
}
$1c799876e31a42dd$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $1c799876e31a42dd$export$1e576a20c3ce9fb5({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNever,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$7d39f5df85f21031 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
}
$1c799876e31a42dd$export$7d39f5df85f21031.create = (params)=>{
    return new $1c799876e31a42dd$export$7d39f5df85f21031({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodVoid,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$7acfc3e64785411 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.array) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $1c799876e31a42dd$export$5ba560653e4a1035.too_big : $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $1c799876e31a42dd$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $1c799876e31a42dd$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $1c799876e31a42dd$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $1c799876e31a42dd$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $1c799876e31a42dd$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $1c799876e31a42dd$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$1c799876e31a42dd$export$7acfc3e64785411.create = (schema, params)=>{
    return new $1c799876e31a42dd$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodArray,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
function $1c799876e31a42dd$var$deepPartialify(schema) {
    if (schema instanceof $1c799876e31a42dd$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $1c799876e31a42dd$export$aa56fec1e9d629b8.create($1c799876e31a42dd$var$deepPartialify(fieldSchema));
        }
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $1c799876e31a42dd$export$7acfc3e64785411) return new $1c799876e31a42dd$export$7acfc3e64785411({
        ...schema._def,
        type: $1c799876e31a42dd$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $1c799876e31a42dd$export$aa56fec1e9d629b8) return $1c799876e31a42dd$export$aa56fec1e9d629b8.create($1c799876e31a42dd$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $1c799876e31a42dd$export$aaac0b8b429cef5) return $1c799876e31a42dd$export$aaac0b8b429cef5.create($1c799876e31a42dd$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $1c799876e31a42dd$export$e2a18bb771d8e6a3) return $1c799876e31a42dd$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$1c799876e31a42dd$var$deepPartialify(item)));
    else return schema;
}
class $1c799876e31a42dd$export$736315c5b55efbad extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $1c799876e31a42dd$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $1c799876e31a42dd$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                        code: $1c799876e31a42dd$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $1c799876e31a42dd$var$errorUtil.errToObj;
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $1c799876e31a42dd$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $1c799876e31a42dd$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $1c799876e31a42dd$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $1c799876e31a42dd$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $1c799876e31a42dd$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $1c799876e31a42dd$var$createZodEnum($1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$1c799876e31a42dd$export$736315c5b55efbad.create = (shape, params)=>{
    return new $1c799876e31a42dd$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $1c799876e31a42dd$export$1e576a20c3ce9fb5.create(),
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodObject,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
$1c799876e31a42dd$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $1c799876e31a42dd$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $1c799876e31a42dd$export$1e576a20c3ce9fb5.create(),
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodObject,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
$1c799876e31a42dd$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $1c799876e31a42dd$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $1c799876e31a42dd$export$1e576a20c3ce9fb5.create(),
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodObject,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$a8b236cb5070a311 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $1c799876e31a42dd$export$f98dac4b251ab333(result.ctx.common.issues));
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $1c799876e31a42dd$export$f98dac4b251ab333(issues));
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$1c799876e31a42dd$export$a8b236cb5070a311.create = (types, params)=>{
    return new $1c799876e31a42dd$export$a8b236cb5070a311({
        options: types,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodUnion,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $1c799876e31a42dd$var$getDiscriminator = (type)=>{
    if (type instanceof $1c799876e31a42dd$export$378d0cfce37406e6) return $1c799876e31a42dd$var$getDiscriminator(type.schema);
    else if (type instanceof $1c799876e31a42dd$export$a60af00cc0ce2582) return $1c799876e31a42dd$var$getDiscriminator(type.innerType());
    else if (type instanceof $1c799876e31a42dd$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $1c799876e31a42dd$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $1c799876e31a42dd$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $1c799876e31a42dd$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $1c799876e31a42dd$export$bb19b37874861e7e) return $1c799876e31a42dd$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $1c799876e31a42dd$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $1c799876e31a42dd$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $1c799876e31a42dd$export$aa56fec1e9d629b8) return [
        undefined,
        ...$1c799876e31a42dd$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $1c799876e31a42dd$export$aaac0b8b429cef5) return [
        null,
        ...$1c799876e31a42dd$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $1c799876e31a42dd$export$66b0c798a395271f) return $1c799876e31a42dd$var$getDiscriminator(type.unwrap());
    else if (type instanceof $1c799876e31a42dd$export$5d1f7ef05c4e493a) return $1c799876e31a42dd$var$getDiscriminator(type.unwrap());
    else if (type instanceof $1c799876e31a42dd$export$75a44ec6249ac76b) return $1c799876e31a42dd$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $1c799876e31a42dd$export$5ef2424805ac76a3 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.object) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $1c799876e31a42dd$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $1c799876e31a42dd$export$5ef2424805ac76a3({
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$1c799876e31a42dd$var$processCreateParams(params)
        });
    }
}
function $1c799876e31a42dd$var$mergeValues(a, b) {
    const aType = $1c799876e31a42dd$export$3e9057828ebd5c7a(a);
    const bType = $1c799876e31a42dd$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $1c799876e31a42dd$export$5716da67bfaa244d.object && bType === $1c799876e31a42dd$export$5716da67bfaa244d.object) {
        const bKeys = $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $1c799876e31a42dd$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $1c799876e31a42dd$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $1c799876e31a42dd$export$5716da67bfaa244d.array && bType === $1c799876e31a42dd$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $1c799876e31a42dd$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $1c799876e31a42dd$export$5716da67bfaa244d.date && bType === $1c799876e31a42dd$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $1c799876e31a42dd$export$c02deaf0bb5203d4 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($1c799876e31a42dd$export$afa861e3c5730743(parsedLeft) || $1c799876e31a42dd$export$afa861e3c5730743(parsedRight)) return $1c799876e31a42dd$export$9a105a556e65c2c0;
            const merged = $1c799876e31a42dd$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $1c799876e31a42dd$export$9a105a556e65c2c0;
            }
            if ($1c799876e31a42dd$export$910b6cdd390341b3(parsedLeft) || $1c799876e31a42dd$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$1c799876e31a42dd$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $1c799876e31a42dd$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodIntersection,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$e2a18bb771d8e6a3 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.array) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $1c799876e31a42dd$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$1c799876e31a42dd$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $1c799876e31a42dd$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$a2acc09968cb4b7f extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.object) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $1c799876e31a42dd$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $1c799876e31a42dd$export$19342e026b58ebb7) return new $1c799876e31a42dd$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodRecord,
            ...$1c799876e31a42dd$var$processCreateParams(third)
        });
        return new $1c799876e31a42dd$export$a2acc09968cb4b7f({
            keyType: $1c799876e31a42dd$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodRecord,
            ...$1c799876e31a42dd$var$processCreateParams(second)
        });
    }
}
class $1c799876e31a42dd$export$163b6a2b712d9542 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.map) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$1c799876e31a42dd$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $1c799876e31a42dd$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodMap,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$977057706f816712 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.set) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $1c799876e31a42dd$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $1c799876e31a42dd$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $1c799876e31a42dd$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $1c799876e31a42dd$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $1c799876e31a42dd$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$1c799876e31a42dd$export$977057706f816712.create = (valueType, params)=>{
    return new $1c799876e31a42dd$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodSet,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$d4602ba55673f53c extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.function) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $1c799876e31a42dd$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $1c799876e31a42dd$export$32f27c719778d4c4(),
                    $1c799876e31a42dd$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $1c799876e31a42dd$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $1c799876e31a42dd$export$32f27c719778d4c4(),
                    $1c799876e31a42dd$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $1c799876e31a42dd$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $1c799876e31a42dd$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $1c799876e31a42dd$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $1c799876e31a42dd$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $1c799876e31a42dd$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $1c799876e31a42dd$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $1c799876e31a42dd$export$d4602ba55673f53c({
            ...this._def,
            args: $1c799876e31a42dd$export$e2a18bb771d8e6a3.create(items).rest($1c799876e31a42dd$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $1c799876e31a42dd$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $1c799876e31a42dd$export$d4602ba55673f53c({
            args: args ? args : $1c799876e31a42dd$export$e2a18bb771d8e6a3.create([]).rest($1c799876e31a42dd$export$ef3b1bb1630977ae.create()),
            returns: returns || $1c799876e31a42dd$export$ef3b1bb1630977ae.create(),
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodFunction,
            ...$1c799876e31a42dd$var$processCreateParams(params)
        });
    }
}
class $1c799876e31a42dd$export$378d0cfce37406e6 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$1c799876e31a42dd$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $1c799876e31a42dd$export$378d0cfce37406e6({
        getter: getter,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodLazy,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$7e44096782a165d3 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$1c799876e31a42dd$export$7e44096782a165d3.create = (value, params)=>{
    return new $1c799876e31a42dd$export$7e44096782a165d3({
        value: value,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodLiteral,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
function $1c799876e31a42dd$var$createZodEnum(values, params) {
    return new $1c799876e31a42dd$export$d325d1f0e1c20179({
        values: values,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodEnum,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
}
class $1c799876e31a42dd$export$d325d1f0e1c20179 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $1c799876e31a42dd$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                expected: $1c799876e31a42dd$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (!$1c799876e31a42dd$var$__classPrivateFieldGet(this, $1c799876e31a42dd$var$_ZodEnum_cache)) $1c799876e31a42dd$var$__classPrivateFieldSet(this, $1c799876e31a42dd$var$_ZodEnum_cache, new Set(this._def.values));
        if (!$1c799876e31a42dd$var$__classPrivateFieldGet(this, $1c799876e31a42dd$var$_ZodEnum_cache).has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $1c799876e31a42dd$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $1c799876e31a42dd$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$1c799876e31a42dd$var$_ZodEnum_cache = new WeakMap();
$1c799876e31a42dd$export$d325d1f0e1c20179.create = $1c799876e31a42dd$var$createZodEnum;
class $1c799876e31a42dd$export$370b2e8d6d6f5c56 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $1c799876e31a42dd$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $1c799876e31a42dd$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.string && ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.number) {
            const expectedValues = $1c799876e31a42dd$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                expected: $1c799876e31a42dd$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        if (!$1c799876e31a42dd$var$__classPrivateFieldGet(this, $1c799876e31a42dd$var$_ZodNativeEnum_cache)) $1c799876e31a42dd$var$__classPrivateFieldSet(this, $1c799876e31a42dd$var$_ZodNativeEnum_cache, new Set($1c799876e31a42dd$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)));
        if (!$1c799876e31a42dd$var$__classPrivateFieldGet(this, $1c799876e31a42dd$var$_ZodNativeEnum_cache).has(input.data)) {
            const expectedValues = $1c799876e31a42dd$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$1c799876e31a42dd$var$_ZodNativeEnum_cache = new WeakMap();
$1c799876e31a42dd$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $1c799876e31a42dd$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNativeEnum,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$3f196b0127d6e50a extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $1c799876e31a42dd$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $1c799876e31a42dd$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$1c799876e31a42dd$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $1c799876e31a42dd$export$3f196b0127d6e50a({
        type: schema,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodPromise,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$a60af00cc0ce2582 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $1c799876e31a42dd$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $1c799876e31a42dd$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $1c799876e31a42dd$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $1c799876e31a42dd$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $1c799876e31a42dd$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $1c799876e31a42dd$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$1c799876e31a42dd$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$1c799876e31a42dd$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $1c799876e31a42dd$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$1c799876e31a42dd$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $1c799876e31a42dd$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
$1c799876e31a42dd$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $1c799876e31a42dd$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodEffects,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$aa56fec1e9d629b8 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $1c799876e31a42dd$export$5716da67bfaa244d.undefined) return $1c799876e31a42dd$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$1c799876e31a42dd$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $1c799876e31a42dd$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodOptional,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$aaac0b8b429cef5 extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $1c799876e31a42dd$export$5716da67bfaa244d.null) return $1c799876e31a42dd$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$1c799876e31a42dd$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $1c799876e31a42dd$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNullable,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$bb19b37874861e7e extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $1c799876e31a42dd$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$1c799876e31a42dd$export$bb19b37874861e7e.create = (type, params)=>{
    return new $1c799876e31a42dd$export$bb19b37874861e7e({
        innerType: type,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$75a44ec6249ac76b extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($1c799876e31a42dd$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $1c799876e31a42dd$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $1c799876e31a42dd$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$1c799876e31a42dd$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $1c799876e31a42dd$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
class $1c799876e31a42dd$export$26ccfa0145e8511f extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $1c799876e31a42dd$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $1c799876e31a42dd$export$db7caee60e5d514d(ctx, {
                code: $1c799876e31a42dd$export$5ba560653e4a1035.invalid_type,
                expected: $1c799876e31a42dd$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $1c799876e31a42dd$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$1c799876e31a42dd$export$26ccfa0145e8511f.create = (params)=>{
    return new $1c799876e31a42dd$export$26ccfa0145e8511f({
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodNaN,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
const $1c799876e31a42dd$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $1c799876e31a42dd$export$66b0c798a395271f extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $1c799876e31a42dd$export$a3c3ef8a0e95c6da extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $1c799876e31a42dd$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $1c799876e31a42dd$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $1c799876e31a42dd$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $1c799876e31a42dd$export$5d1f7ef05c4e493a extends $1c799876e31a42dd$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($1c799876e31a42dd$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $1c799876e31a42dd$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$1c799876e31a42dd$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $1c799876e31a42dd$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $1c799876e31a42dd$export$558106ce543bd011.ZodReadonly,
        ...$1c799876e31a42dd$var$processCreateParams(params)
    });
};
function $1c799876e31a42dd$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $1c799876e31a42dd$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $1c799876e31a42dd$export$b9d1edb536b4e4eb.create();
}
const $1c799876e31a42dd$export$1ee8ee30835eab8b = {
    object: $1c799876e31a42dd$export$736315c5b55efbad.lazycreate
};
var $1c799876e31a42dd$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($1c799876e31a42dd$export$558106ce543bd011 || ($1c799876e31a42dd$export$558106ce543bd011 = {}));
const $1c799876e31a42dd$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$1c799876e31a42dd$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $1c799876e31a42dd$export$22b082955e083ec3 = $1c799876e31a42dd$export$1230eb29b8d3b502.create;
const $1c799876e31a42dd$export$98e628dec113755e = $1c799876e31a42dd$export$5b070a55c0c43e09.create;
const $1c799876e31a42dd$export$9e06de0973666692 = $1c799876e31a42dd$export$26ccfa0145e8511f.create;
const $1c799876e31a42dd$export$a0f65b52274bcc00 = $1c799876e31a42dd$export$67d741fd70ff98f4.create;
const $1c799876e31a42dd$export$4a21f16c33752377 = $1c799876e31a42dd$export$723d146f80596191.create;
const $1c799876e31a42dd$export$324d90190a8b822a = $1c799876e31a42dd$export$e974be33bdc55521.create;
const $1c799876e31a42dd$export$8f701197936bc2a6 = $1c799876e31a42dd$export$bcc3b40f6b638044.create;
const $1c799876e31a42dd$export$1db45310990710a5 = $1c799876e31a42dd$export$4e780e961c30340d.create;
const $1c799876e31a42dd$export$7b1b591b262c240 = $1c799876e31a42dd$export$a96281f914484f2d.create;
const $1c799876e31a42dd$export$4154a199d7d90455 = $1c799876e31a42dd$export$b9d1edb536b4e4eb.create;
const $1c799876e31a42dd$export$19282c40b967aec6 = $1c799876e31a42dd$export$ef3b1bb1630977ae.create;
const $1c799876e31a42dd$export$b3e22bcfd64c1022 = $1c799876e31a42dd$export$1e576a20c3ce9fb5.create;
const $1c799876e31a42dd$export$490e536ee7389aeb = $1c799876e31a42dd$export$7d39f5df85f21031.create;
const $1c799876e31a42dd$export$2f23118c22fb2630 = $1c799876e31a42dd$export$7acfc3e64785411.create;
const $1c799876e31a42dd$export$be5493f9613cbbe = $1c799876e31a42dd$export$736315c5b55efbad.create;
const $1c799876e31a42dd$export$8fb0df5f40d0b477 = $1c799876e31a42dd$export$736315c5b55efbad.strictCreate;
const $1c799876e31a42dd$export$971dd5b0dfd021b6 = $1c799876e31a42dd$export$a8b236cb5070a311.create;
const $1c799876e31a42dd$export$4b888e40c4ee26dd = $1c799876e31a42dd$export$5ef2424805ac76a3.create;
const $1c799876e31a42dd$export$bc86dfbf7795668c = $1c799876e31a42dd$export$c02deaf0bb5203d4.create;
const $1c799876e31a42dd$export$65e3907585753458 = $1c799876e31a42dd$export$e2a18bb771d8e6a3.create;
const $1c799876e31a42dd$export$e5185e241753e543 = $1c799876e31a42dd$export$a2acc09968cb4b7f.create;
const $1c799876e31a42dd$export$871de8747c9eaa88 = $1c799876e31a42dd$export$163b6a2b712d9542.create;
const $1c799876e31a42dd$export$adaa4cf7ef1b65be = $1c799876e31a42dd$export$977057706f816712.create;
const $1c799876e31a42dd$export$44e51c8aac7c2deb = $1c799876e31a42dd$export$d4602ba55673f53c.create;
const $1c799876e31a42dd$export$488013bae63b21da = $1c799876e31a42dd$export$378d0cfce37406e6.create;
const $1c799876e31a42dd$export$c8ec6e1ec9fefcb0 = $1c799876e31a42dd$export$7e44096782a165d3.create;
const $1c799876e31a42dd$export$78a99c8d44d72635 = $1c799876e31a42dd$export$d325d1f0e1c20179.create;
const $1c799876e31a42dd$export$6fe7eca19ebe5199 = $1c799876e31a42dd$export$370b2e8d6d6f5c56.create;
const $1c799876e31a42dd$export$c957ef27a0ebfd4 = $1c799876e31a42dd$export$3f196b0127d6e50a.create;
const $1c799876e31a42dd$export$dc573d8a6576cdb3 = $1c799876e31a42dd$export$a60af00cc0ce2582.create;
const $1c799876e31a42dd$export$516e28dec6a4b6d4 = $1c799876e31a42dd$export$aa56fec1e9d629b8.create;
const $1c799876e31a42dd$export$133fc36489ac9add = $1c799876e31a42dd$export$aaac0b8b429cef5.create;
const $1c799876e31a42dd$export$fc37fe19dfda43ee = $1c799876e31a42dd$export$a60af00cc0ce2582.createWithPreprocess;
const $1c799876e31a42dd$export$43f28b24e1eb8181 = $1c799876e31a42dd$export$a3c3ef8a0e95c6da.create;
const $1c799876e31a42dd$export$3b3d07727c5b702c = ()=>$1c799876e31a42dd$export$22b082955e083ec3().optional();
const $1c799876e31a42dd$export$eb150471a61fced6 = ()=>$1c799876e31a42dd$export$98e628dec113755e().optional();
const $1c799876e31a42dd$export$269251733cdcbbf1 = ()=>$1c799876e31a42dd$export$4a21f16c33752377().optional();
const $1c799876e31a42dd$export$8c14e57e778d3873 = {
    string: (arg)=>$1c799876e31a42dd$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$1c799876e31a42dd$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$1c799876e31a42dd$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$1c799876e31a42dd$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$1c799876e31a42dd$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $1c799876e31a42dd$export$96c94437c95d7862 = $1c799876e31a42dd$export$9a105a556e65c2c0;
var $1c799876e31a42dd$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $1c799876e31a42dd$export$341b0b6e0a6f5099,
    setErrorMap: $1c799876e31a42dd$export$1097a8289cfd22d7,
    getErrorMap: $1c799876e31a42dd$export$32f27c719778d4c4,
    makeIssue: $1c799876e31a42dd$export$244a85fde9c419ed,
    EMPTY_PATH: $1c799876e31a42dd$export$1526d2e05f74572,
    addIssueToContext: $1c799876e31a42dd$export$db7caee60e5d514d,
    ParseStatus: $1c799876e31a42dd$export$5b20a5c3d05c1f6f,
    INVALID: $1c799876e31a42dd$export$9a105a556e65c2c0,
    DIRTY: $1c799876e31a42dd$export$325a211da9693fcf,
    OK: $1c799876e31a42dd$export$c6813a8d51f77eaf,
    isAborted: $1c799876e31a42dd$export$afa861e3c5730743,
    isDirty: $1c799876e31a42dd$export$910b6cdd390341b3,
    isValid: $1c799876e31a42dd$export$1ea939691cdc45b8,
    isAsync: $1c799876e31a42dd$export$aefee5ebe1dcfd9e,
    get util () {
        return $1c799876e31a42dd$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $1c799876e31a42dd$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $1c799876e31a42dd$export$5716da67bfaa244d,
    getParsedType: $1c799876e31a42dd$export$3e9057828ebd5c7a,
    ZodType: $1c799876e31a42dd$export$19342e026b58ebb7,
    datetimeRegex: $1c799876e31a42dd$export$a4b563879add27a,
    ZodString: $1c799876e31a42dd$export$1230eb29b8d3b502,
    ZodNumber: $1c799876e31a42dd$export$5b070a55c0c43e09,
    ZodBigInt: $1c799876e31a42dd$export$67d741fd70ff98f4,
    ZodBoolean: $1c799876e31a42dd$export$723d146f80596191,
    ZodDate: $1c799876e31a42dd$export$e974be33bdc55521,
    ZodSymbol: $1c799876e31a42dd$export$bcc3b40f6b638044,
    ZodUndefined: $1c799876e31a42dd$export$4e780e961c30340d,
    ZodNull: $1c799876e31a42dd$export$a96281f914484f2d,
    ZodAny: $1c799876e31a42dd$export$b9d1edb536b4e4eb,
    ZodUnknown: $1c799876e31a42dd$export$ef3b1bb1630977ae,
    ZodNever: $1c799876e31a42dd$export$1e576a20c3ce9fb5,
    ZodVoid: $1c799876e31a42dd$export$7d39f5df85f21031,
    ZodArray: $1c799876e31a42dd$export$7acfc3e64785411,
    ZodObject: $1c799876e31a42dd$export$736315c5b55efbad,
    ZodUnion: $1c799876e31a42dd$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $1c799876e31a42dd$export$5ef2424805ac76a3,
    ZodIntersection: $1c799876e31a42dd$export$c02deaf0bb5203d4,
    ZodTuple: $1c799876e31a42dd$export$e2a18bb771d8e6a3,
    ZodRecord: $1c799876e31a42dd$export$a2acc09968cb4b7f,
    ZodMap: $1c799876e31a42dd$export$163b6a2b712d9542,
    ZodSet: $1c799876e31a42dd$export$977057706f816712,
    ZodFunction: $1c799876e31a42dd$export$d4602ba55673f53c,
    ZodLazy: $1c799876e31a42dd$export$378d0cfce37406e6,
    ZodLiteral: $1c799876e31a42dd$export$7e44096782a165d3,
    ZodEnum: $1c799876e31a42dd$export$d325d1f0e1c20179,
    ZodNativeEnum: $1c799876e31a42dd$export$370b2e8d6d6f5c56,
    ZodPromise: $1c799876e31a42dd$export$3f196b0127d6e50a,
    ZodEffects: $1c799876e31a42dd$export$a60af00cc0ce2582,
    ZodTransformer: $1c799876e31a42dd$export$a60af00cc0ce2582,
    ZodOptional: $1c799876e31a42dd$export$aa56fec1e9d629b8,
    ZodNullable: $1c799876e31a42dd$export$aaac0b8b429cef5,
    ZodDefault: $1c799876e31a42dd$export$bb19b37874861e7e,
    ZodCatch: $1c799876e31a42dd$export$75a44ec6249ac76b,
    ZodNaN: $1c799876e31a42dd$export$26ccfa0145e8511f,
    BRAND: $1c799876e31a42dd$export$cf2deea74cde46b4,
    ZodBranded: $1c799876e31a42dd$export$66b0c798a395271f,
    ZodPipeline: $1c799876e31a42dd$export$a3c3ef8a0e95c6da,
    ZodReadonly: $1c799876e31a42dd$export$5d1f7ef05c4e493a,
    custom: $1c799876e31a42dd$export$4c00f665f0d4b443,
    Schema: $1c799876e31a42dd$export$19342e026b58ebb7,
    ZodSchema: $1c799876e31a42dd$export$19342e026b58ebb7,
    late: $1c799876e31a42dd$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $1c799876e31a42dd$export$558106ce543bd011;
    },
    coerce: $1c799876e31a42dd$export$8c14e57e778d3873,
    any: $1c799876e31a42dd$export$4154a199d7d90455,
    array: $1c799876e31a42dd$export$2f23118c22fb2630,
    bigint: $1c799876e31a42dd$export$a0f65b52274bcc00,
    boolean: $1c799876e31a42dd$export$4a21f16c33752377,
    date: $1c799876e31a42dd$export$324d90190a8b822a,
    discriminatedUnion: $1c799876e31a42dd$export$4b888e40c4ee26dd,
    effect: $1c799876e31a42dd$export$dc573d8a6576cdb3,
    "enum": $1c799876e31a42dd$export$78a99c8d44d72635,
    "function": $1c799876e31a42dd$export$44e51c8aac7c2deb,
    "instanceof": $1c799876e31a42dd$export$3d916e7c22dbd8b5,
    intersection: $1c799876e31a42dd$export$bc86dfbf7795668c,
    lazy: $1c799876e31a42dd$export$488013bae63b21da,
    literal: $1c799876e31a42dd$export$c8ec6e1ec9fefcb0,
    map: $1c799876e31a42dd$export$871de8747c9eaa88,
    nan: $1c799876e31a42dd$export$9e06de0973666692,
    nativeEnum: $1c799876e31a42dd$export$6fe7eca19ebe5199,
    never: $1c799876e31a42dd$export$b3e22bcfd64c1022,
    "null": $1c799876e31a42dd$export$7b1b591b262c240,
    nullable: $1c799876e31a42dd$export$133fc36489ac9add,
    number: $1c799876e31a42dd$export$98e628dec113755e,
    object: $1c799876e31a42dd$export$be5493f9613cbbe,
    oboolean: $1c799876e31a42dd$export$269251733cdcbbf1,
    onumber: $1c799876e31a42dd$export$eb150471a61fced6,
    optional: $1c799876e31a42dd$export$516e28dec6a4b6d4,
    ostring: $1c799876e31a42dd$export$3b3d07727c5b702c,
    pipeline: $1c799876e31a42dd$export$43f28b24e1eb8181,
    preprocess: $1c799876e31a42dd$export$fc37fe19dfda43ee,
    promise: $1c799876e31a42dd$export$c957ef27a0ebfd4,
    record: $1c799876e31a42dd$export$e5185e241753e543,
    set: $1c799876e31a42dd$export$adaa4cf7ef1b65be,
    strictObject: $1c799876e31a42dd$export$8fb0df5f40d0b477,
    string: $1c799876e31a42dd$export$22b082955e083ec3,
    symbol: $1c799876e31a42dd$export$8f701197936bc2a6,
    transformer: $1c799876e31a42dd$export$dc573d8a6576cdb3,
    tuple: $1c799876e31a42dd$export$65e3907585753458,
    "undefined": $1c799876e31a42dd$export$1db45310990710a5,
    union: $1c799876e31a42dd$export$971dd5b0dfd021b6,
    unknown: $1c799876e31a42dd$export$19282c40b967aec6,
    "void": $1c799876e31a42dd$export$490e536ee7389aeb,
    NEVER: $1c799876e31a42dd$export$96c94437c95d7862,
    ZodIssueCode: $1c799876e31a42dd$export$5ba560653e4a1035,
    quotelessJson: $1c799876e31a42dd$export$913eddeaf297cfea,
    ZodError: $1c799876e31a42dd$export$f98dac4b251ab333
});

});

parcelRegister("bAlFZ", function(module, exports) {

$parcel$export(module.exports, "ERROR", function () { return $956c8c3e8fadd4de$export$103bedf43ba882db; });
$parcel$export(module.exports, "Events", function () { return $956c8c3e8fadd4de$export$ada873a34909da65; });
$parcel$export(module.exports, "ErrorEvent", function () { return $956c8c3e8fadd4de$export$4c6f5e6e10fb9fd0; });
$parcel$export(module.exports, "EventFrame", function () { return $956c8c3e8fadd4de$export$f344a15bf52574b2; });
$parcel$export(module.exports, "parseEventPayload", function () { return $956c8c3e8fadd4de$export$a46bc76e895063f4; });

var $TGurO = parcelRequire("TGurO");

var $gROQ6 = parcelRequire("gROQ6");

var $kq6d3 = parcelRequire("kq6d3");

var $4pOtY = parcelRequire("4pOtY");

var $ghr9G = parcelRequire("ghr9G");
// ERROR is sent as evt but is a special case, so is excluded from Events enum
const $956c8c3e8fadd4de$export$103bedf43ba882db = "ERROR";
var $956c8c3e8fadd4de$export$ada873a34909da65;
(function(Events) {
    Events["READY"] = "READY";
    Events["VOICE_STATE_UPDATE"] = "VOICE_STATE_UPDATE";
    Events["SPEAKING_START"] = "SPEAKING_START";
    Events["SPEAKING_STOP"] = "SPEAKING_STOP";
    Events["ACTIVITY_LAYOUT_MODE_UPDATE"] = "ACTIVITY_LAYOUT_MODE_UPDATE";
    Events["ORIENTATION_UPDATE"] = "ORIENTATION_UPDATE";
    Events["CURRENT_USER_UPDATE"] = "CURRENT_USER_UPDATE";
    Events["CURRENT_GUILD_MEMBER_UPDATE"] = "CURRENT_GUILD_MEMBER_UPDATE";
    Events["ENTITLEMENT_CREATE"] = "ENTITLEMENT_CREATE";
    Events["THERMAL_STATE_UPDATE"] = "THERMAL_STATE_UPDATE";
    Events["ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE"] = "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE";
    Events["RELATIONSHIP_UPDATE"] = "RELATIONSHIP_UPDATE";
    Events["ACTIVITY_JOIN"] = "ACTIVITY_JOIN";
    Events["QUEST_ENROLLMENT_STATUS_UPDATE"] = "QUEST_ENROLLMENT_STATUS_UPDATE";
})($956c8c3e8fadd4de$export$ada873a34909da65 || ($956c8c3e8fadd4de$export$ada873a34909da65 = {}));
const $956c8c3e8fadd4de$export$326fa0fd43fb9e9c = (0, $kq6d3.ReceiveFramePayload).extend({
    evt: (0, $TGurO.nativeEnum)($956c8c3e8fadd4de$export$ada873a34909da65),
    nonce: (0, $TGurO.string)().nullable(),
    cmd: (0, $TGurO.literal)((0, $kq6d3.DISPATCH)),
    data: (0, $TGurO.object)({}).passthrough()
});
const $956c8c3e8fadd4de$export$4c6f5e6e10fb9fd0 = (0, $kq6d3.ReceiveFramePayload).extend({
    evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$103bedf43ba882db),
    data: (0, $TGurO.object)({
        code: (0, $TGurO.number)(),
        message: (0, $TGurO.string)().optional()
    }).passthrough(),
    cmd: (0, $TGurO.nativeEnum)((0, $kq6d3.Commands)),
    nonce: (0, $TGurO.string)().nullable()
});
const $956c8c3e8fadd4de$export$a242e5821d539c8e = $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
    evt: (0, $TGurO.string)()
});
const $956c8c3e8fadd4de$export$f344a15bf52574b2 = (0, $TGurO.union)([
    $956c8c3e8fadd4de$export$326fa0fd43fb9e9c,
    $956c8c3e8fadd4de$export$a242e5821d539c8e,
    $956c8c3e8fadd4de$export$4c6f5e6e10fb9fd0
]);
function $956c8c3e8fadd4de$export$a46bc76e895063f4(data) {
    const event = data.evt;
    if (!(event in $956c8c3e8fadd4de$export$ada873a34909da65)) throw new Error(`Unrecognized event type ${data.evt}`);
    const eventSchema = $956c8c3e8fadd4de$export$769a4ec051ed522c[event];
    return eventSchema.payload.parse(data);
}
const $956c8c3e8fadd4de$export$769a4ec051ed522c = {
    /**
     * @description
     * The READY event is emitted by Discord's RPC server in reply to a client
     * initiating the RPC handshake. The event includes information about
     * - the rpc server version
     * - the discord client configuration
     * - the (basic) user object
     *
     * Unlike other events, READY will only be omitted once, immediately after the
     * Embedded App SDK is initialized
     *
     * # Supported Platforms
     * | Web | iOS | Android |
     * |-----|-----|---------|
     * | ✅  | ✅  | ✅      |
     *
     * Required scopes: []
     *
     */ [$956c8c3e8fadd4de$export$ada873a34909da65.READY]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.READY),
            data: (0, $TGurO.object)({
                v: (0, $TGurO.number)(),
                config: (0, $TGurO.object)({
                    cdn_host: (0, $TGurO.string)().optional(),
                    api_endpoint: (0, $TGurO.string)(),
                    environment: (0, $TGurO.string)()
                }),
                user: (0, $TGurO.object)({
                    id: (0, $TGurO.string)(),
                    username: (0, $TGurO.string)(),
                    discriminator: (0, $TGurO.string)(),
                    avatar: (0, $TGurO.string)().optional()
                }).optional()
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.VOICE_STATE_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.VOICE_STATE_UPDATE),
            data: (0, $kq6d3.UserVoiceState)
        }),
        subscribeArgs: (0, $TGurO.object)({
            channel_id: (0, $TGurO.string)()
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.SPEAKING_START]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.SPEAKING_START),
            data: (0, $TGurO.object)({
                lobby_id: (0, $TGurO.string)().optional(),
                channel_id: (0, $TGurO.string)().optional(),
                user_id: (0, $TGurO.string)()
            })
        }),
        subscribeArgs: (0, $TGurO.object)({
            lobby_id: (0, $TGurO.string)().nullable().optional(),
            channel_id: (0, $TGurO.string)().nullable().optional()
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.SPEAKING_STOP]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.SPEAKING_STOP),
            data: (0, $TGurO.object)({
                lobby_id: (0, $TGurO.string)().optional(),
                channel_id: (0, $TGurO.string)().optional(),
                user_id: (0, $TGurO.string)()
            })
        }),
        subscribeArgs: (0, $TGurO.object)({
            lobby_id: (0, $TGurO.string)().nullable().optional(),
            channel_id: (0, $TGurO.string)().nullable().optional()
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_LAYOUT_MODE_UPDATE),
            data: (0, $TGurO.object)({
                layout_mode: (0, $4pOtY.zodCoerceUnhandledValue)((0, $kq6d3.LayoutModeTypeObject))
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.ORIENTATION_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.ORIENTATION_UPDATE),
            data: (0, $TGurO.object)({
                screen_orientation: (0, $4pOtY.zodCoerceUnhandledValue)((0, $kq6d3.OrientationTypeObject)),
                /**
                 * @deprecated use screen_orientation instead
                 */ orientation: (0, $TGurO.nativeEnum)((0, $gROQ6.Orientation))
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.CURRENT_USER_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.CURRENT_USER_UPDATE),
            data: (0, $kq6d3.User)
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.CURRENT_GUILD_MEMBER_UPDATE),
            data: (0, $kq6d3.GuildMemberRPC)
        }),
        subscribeArgs: (0, $TGurO.object)({
            guild_id: (0, $TGurO.string)()
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.ENTITLEMENT_CREATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.ENTITLEMENT_CREATE),
            data: (0, $TGurO.object)({
                entitlement: (0, $kq6d3.Entitlement)
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.THERMAL_STATE_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.THERMAL_STATE_UPDATE),
            data: (0, $TGurO.object)({
                thermal_state: (0, $kq6d3.ThermalState)
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE),
            data: (0, $TGurO.object)({
                participants: (0, $ghr9G.GetActivityInstanceConnectedParticipantsResponseSchema).shape.participants
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.RELATIONSHIP_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.RELATIONSHIP_UPDATE),
            data: (0, $kq6d3.Relationship)
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_JOIN]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.ACTIVITY_JOIN),
            data: (0, $TGurO.object)({
                applicationId: (0, $TGurO.string)(),
                secret: (0, $TGurO.string)()
            })
        })
    },
    [$956c8c3e8fadd4de$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE]: {
        payload: $956c8c3e8fadd4de$export$326fa0fd43fb9e9c.extend({
            evt: (0, $TGurO.literal)($956c8c3e8fadd4de$export$ada873a34909da65.QUEST_ENROLLMENT_STATUS_UPDATE),
            data: (0, $TGurO.object)({
                quest_id: (0, $TGurO.string)(),
                is_enrolled: (0, $TGurO.boolean)(),
                enrolled_at: (0, $TGurO.string)().date()
            })
        })
    }
};

});
parcelRegister("gROQ6", function(module, exports) {

$parcel$export(module.exports, "RPCErrorCodes", function () { return $d836a173230b3583$export$9ebb08d40ecbafd9; });
$parcel$export(module.exports, "Orientation", function () { return $d836a173230b3583$export$df54d73aa0ec5e82; });
$parcel$export(module.exports, "Platform", function () { return $d836a173230b3583$export$2dffd0b5373a4389; });
$parcel$export(module.exports, "UNKNOWN_VERSION_NUMBER", function () { return $d836a173230b3583$export$6d0e4238fc52b7e2; });
$parcel$export(module.exports, "HANDSHAKE_SDK_VERSION_MINIMUM_MOBILE_VERSION", function () { return $d836a173230b3583$export$e124ef0815aed2db; });

var $o5U3A = parcelRequire("o5U3A");
var $d836a173230b3583$export$b87f1ea3076d6f58;
(function(RPCCloseCodes) {
    RPCCloseCodes[RPCCloseCodes["CLOSE_NORMAL"] = 1000] = "CLOSE_NORMAL";
    RPCCloseCodes[RPCCloseCodes["CLOSE_UNSUPPORTED"] = 1003] = "CLOSE_UNSUPPORTED";
    RPCCloseCodes[RPCCloseCodes["CLOSE_ABNORMAL"] = 1006] = "CLOSE_ABNORMAL";
    RPCCloseCodes[RPCCloseCodes["INVALID_CLIENTID"] = 4000] = "INVALID_CLIENTID";
    RPCCloseCodes[RPCCloseCodes["INVALID_ORIGIN"] = 4001] = "INVALID_ORIGIN";
    RPCCloseCodes[RPCCloseCodes["RATELIMITED"] = 4002] = "RATELIMITED";
    RPCCloseCodes[RPCCloseCodes["TOKEN_REVOKED"] = 4003] = "TOKEN_REVOKED";
    RPCCloseCodes[RPCCloseCodes["INVALID_VERSION"] = 4004] = "INVALID_VERSION";
    RPCCloseCodes[RPCCloseCodes["INVALID_ENCODING"] = 4005] = "INVALID_ENCODING";
})($d836a173230b3583$export$b87f1ea3076d6f58 || ($d836a173230b3583$export$b87f1ea3076d6f58 = {}));
var $d836a173230b3583$export$9ebb08d40ecbafd9;
(function(RPCErrorCodes) {
    RPCErrorCodes[RPCErrorCodes["INVALID_PAYLOAD"] = 4000] = "INVALID_PAYLOAD";
    RPCErrorCodes[RPCErrorCodes["INVALID_COMMAND"] = 4002] = "INVALID_COMMAND";
    RPCErrorCodes[RPCErrorCodes["INVALID_GUILD"] = 4003] = "INVALID_GUILD";
    RPCErrorCodes[RPCErrorCodes["INVALID_EVENT"] = 4004] = "INVALID_EVENT";
    RPCErrorCodes[RPCErrorCodes["INVALID_CHANNEL"] = 4005] = "INVALID_CHANNEL";
    RPCErrorCodes[RPCErrorCodes["INVALID_PERMISSIONS"] = 4006] = "INVALID_PERMISSIONS";
    RPCErrorCodes[RPCErrorCodes["INVALID_CLIENTID"] = 4007] = "INVALID_CLIENTID";
    RPCErrorCodes[RPCErrorCodes["INVALID_ORIGIN"] = 4008] = "INVALID_ORIGIN";
    RPCErrorCodes[RPCErrorCodes["INVALID_TOKEN"] = 4009] = "INVALID_TOKEN";
    RPCErrorCodes[RPCErrorCodes["INVALID_USER"] = 4010] = "INVALID_USER";
})($d836a173230b3583$export$9ebb08d40ecbafd9 || ($d836a173230b3583$export$9ebb08d40ecbafd9 = {}));
/**
 * @deprecated use OrientationTypeObject instead
 */ var $d836a173230b3583$export$df54d73aa0ec5e82;
(function(Orientation) {
    Orientation["LANDSCAPE"] = "landscape";
    Orientation["PORTRAIT"] = "portrait";
})($d836a173230b3583$export$df54d73aa0ec5e82 || ($d836a173230b3583$export$df54d73aa0ec5e82 = {}));
var $d836a173230b3583$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["MOBILE"] = "mobile";
    Platform["DESKTOP"] = "desktop";
})($d836a173230b3583$export$2dffd0b5373a4389 || ($d836a173230b3583$export$2dffd0b5373a4389 = {}));
/** See https://discord.com/developers/docs/topics/permissions#permissions-bitwise-permission-flags for more Permissions details */ const $d836a173230b3583$export$2d41982586bbb6be = Object.freeze({
    CREATE_INSTANT_INVITE: (0, $o5U3A.default).getFlag(0),
    KICK_MEMBERS: (0, $o5U3A.default).getFlag(1),
    BAN_MEMBERS: (0, $o5U3A.default).getFlag(2),
    ADMINISTRATOR: (0, $o5U3A.default).getFlag(3),
    MANAGE_CHANNELS: (0, $o5U3A.default).getFlag(4),
    MANAGE_GUILD: (0, $o5U3A.default).getFlag(5),
    ADD_REACTIONS: (0, $o5U3A.default).getFlag(6),
    VIEW_AUDIT_LOG: (0, $o5U3A.default).getFlag(7),
    PRIORITY_SPEAKER: (0, $o5U3A.default).getFlag(8),
    STREAM: (0, $o5U3A.default).getFlag(9),
    VIEW_CHANNEL: (0, $o5U3A.default).getFlag(10),
    SEND_MESSAGES: (0, $o5U3A.default).getFlag(11),
    SEND_TTS_MESSAGES: (0, $o5U3A.default).getFlag(12),
    MANAGE_MESSAGES: (0, $o5U3A.default).getFlag(13),
    EMBED_LINKS: (0, $o5U3A.default).getFlag(14),
    ATTACH_FILES: (0, $o5U3A.default).getFlag(15),
    READ_MESSAGE_HISTORY: (0, $o5U3A.default).getFlag(16),
    MENTION_EVERYONE: (0, $o5U3A.default).getFlag(17),
    USE_EXTERNAL_EMOJIS: (0, $o5U3A.default).getFlag(18),
    VIEW_GUILD_INSIGHTS: (0, $o5U3A.default).getFlag(19),
    CONNECT: (0, $o5U3A.default).getFlag(20),
    SPEAK: (0, $o5U3A.default).getFlag(21),
    MUTE_MEMBERS: (0, $o5U3A.default).getFlag(22),
    DEAFEN_MEMBERS: (0, $o5U3A.default).getFlag(23),
    MOVE_MEMBERS: (0, $o5U3A.default).getFlag(24),
    USE_VAD: (0, $o5U3A.default).getFlag(25),
    CHANGE_NICKNAME: (0, $o5U3A.default).getFlag(26),
    MANAGE_NICKNAMES: (0, $o5U3A.default).getFlag(27),
    MANAGE_ROLES: (0, $o5U3A.default).getFlag(28),
    MANAGE_WEBHOOKS: (0, $o5U3A.default).getFlag(29),
    MANAGE_GUILD_EXPRESSIONS: (0, $o5U3A.default).getFlag(30),
    USE_APPLICATION_COMMANDS: (0, $o5U3A.default).getFlag(31),
    REQUEST_TO_SPEAK: (0, $o5U3A.default).getFlag(32),
    MANAGE_EVENTS: (0, $o5U3A.default).getFlag(33),
    MANAGE_THREADS: (0, $o5U3A.default).getFlag(34),
    CREATE_PUBLIC_THREADS: (0, $o5U3A.default).getFlag(35),
    CREATE_PRIVATE_THREADS: (0, $o5U3A.default).getFlag(36),
    USE_EXTERNAL_STICKERS: (0, $o5U3A.default).getFlag(37),
    SEND_MESSAGES_IN_THREADS: (0, $o5U3A.default).getFlag(38),
    USE_EMBEDDED_ACTIVITIES: (0, $o5U3A.default).getFlag(39),
    MODERATE_MEMBERS: (0, $o5U3A.default).getFlag(40),
    VIEW_CREATOR_MONETIZATION_ANALYTICS: (0, $o5U3A.default).getFlag(41),
    USE_SOUNDBOARD: (0, $o5U3A.default).getFlag(42),
    CREATE_GUILD_EXPRESSIONS: (0, $o5U3A.default).getFlag(43),
    CREATE_EVENTS: (0, $o5U3A.default).getFlag(44),
    USE_EXTERNAL_SOUNDS: (0, $o5U3A.default).getFlag(45),
    SEND_VOICE_MESSAGES: (0, $o5U3A.default).getFlag(46),
    SEND_POLLS: (0, $o5U3A.default).getFlag(49),
    USE_EXTERNAL_APPS: (0, $o5U3A.default).getFlag(50)
});
const $d836a173230b3583$export$6d0e4238fc52b7e2 = -1;
const $d836a173230b3583$export$e124ef0815aed2db = 250;

});
parcelRegister("o5U3A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5f823c11e88739b$export$2e2bcd8739ae039; });

var $ux1WZ = parcelRequire("ux1WZ");
/**
 * Context: Due to Discord supporting more than 32 permissions, permission calculation has become more complicated than naive
 * bit operations on `number`s. To support this generically, we have created BigFlagUtils to work with bit-flags greater
 * than 32-bits in size.
 *
 * Ideally, we would like to use BigInt, which is pretty efficient, but some JavaScript engines do not support it.
 *
 * This file is intended to be a set of lower-level operators that act directly on "BigFlags".
 *
 * If you're working with permissions, in most cases you can probably use PermissionUtils.
 */ const $d5f823c11e88739b$var$MAX_BIG_INT = 64;
const $d5f823c11e88739b$var$SMALL_INT = 16;
const $d5f823c11e88739b$var$PARTS = $d5f823c11e88739b$var$MAX_BIG_INT / $d5f823c11e88739b$var$SMALL_INT;
function $d5f823c11e88739b$var$checkBrowserSupportsBigInt() {
    try {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        BigInt;
        return true;
    } catch (_a) {
        return false;
    }
}
/**
 * Takes the sliced output of `toHexReverseArray` and converts hex to decimal.
 */ function $d5f823c11e88739b$var$fromHexReverseArray(hexValues, start, size) {
    let value = 0;
    for(let i = 0; i < size; i++){
        const byte = hexValues[start + i];
        if (byte === undefined) break;
        value += byte * 16 ** i;
    }
    return value;
}
/**
 * Converts a number string to array of hex bytes based on the implementation found at
 * https://stackoverflow.com/questions/18626844/convert-a-large-integer-to-a-hex-string-in-javascript
 *
 * To avoid extra allocations it returns the values in reverse.
 */ function $d5f823c11e88739b$var$toHexReverseArray(value) {
    const sum = [];
    for(let i = 0; i < value.length; i++){
        let s = Number(value[i]);
        for(let j = 0; s || j < sum.length; j++){
            s += (sum[j] || 0) * 10;
            sum[j] = s % 16;
            s = (s - sum[j]) / 16;
        }
    }
    return sum;
}
/**
 * Splits a big integers into array of small integers to perform fast bitwise operations.
 */ function $d5f823c11e88739b$var$splitBigInt(value) {
    const sum = $d5f823c11e88739b$var$toHexReverseArray(value);
    const parts = Array($d5f823c11e88739b$var$PARTS);
    for(let i = 0; i < $d5f823c11e88739b$var$PARTS; i++)// Highest bits to lowest bits.
    parts[$d5f823c11e88739b$var$PARTS - 1 - i] = $d5f823c11e88739b$var$fromHexReverseArray(sum, i * $d5f823c11e88739b$var$PARTS, $d5f823c11e88739b$var$PARTS);
    return parts;
}
class $d5f823c11e88739b$var$HighLow {
    static fromString(value) {
        return new $d5f823c11e88739b$var$HighLow($d5f823c11e88739b$var$splitBigInt(value), value);
    }
    static fromBit(index) {
        const parts = Array($d5f823c11e88739b$var$PARTS);
        const offset = Math.floor(index / $d5f823c11e88739b$var$SMALL_INT);
        for(let i = 0; i < $d5f823c11e88739b$var$PARTS; i++)// Highest bits to lowest bits.
        parts[$d5f823c11e88739b$var$PARTS - 1 - i] = i === offset ? 1 << index - offset * $d5f823c11e88739b$var$SMALL_INT : 0;
        return new $d5f823c11e88739b$var$HighLow(parts);
    }
    constructor(parts, str){
        this.parts = parts;
        this.str = str;
    }
    and({ parts: parts }) {
        return new $d5f823c11e88739b$var$HighLow(this.parts.map((v, i)=>v & parts[i]));
    }
    or({ parts: parts }) {
        return new $d5f823c11e88739b$var$HighLow(this.parts.map((v, i)=>v | parts[i]));
    }
    xor({ parts: parts }) {
        return new $d5f823c11e88739b$var$HighLow(this.parts.map((v, i)=>v ^ parts[i]));
    }
    not() {
        return new $d5f823c11e88739b$var$HighLow(this.parts.map((v)=>~v));
    }
    equals({ parts: parts }) {
        return this.parts.every((v, i)=>v === parts[i]);
    }
    /**
     * For the average case the string representation is provided, but
     * when we need to convert high and low to string we just let the
     * slower big-integer library do it.
     */ toString() {
        if (this.str != null) return this.str;
        const array = new Array($d5f823c11e88739b$var$MAX_BIG_INT / 4);
        this.parts.forEach((value, offset)=>{
            const hex = $d5f823c11e88739b$var$toHexReverseArray(value.toString());
            for(let i = 0; i < 4; i++)array[i + offset * 4] = hex[3 - i] || 0;
        });
        return this.str = (0, $ux1WZ.default).fromArray(array, 16).toString();
    }
    toJSON() {
        return this.toString();
    }
}
const $d5f823c11e88739b$var$SUPPORTS_BIGINT = $d5f823c11e88739b$var$checkBrowserSupportsBigInt();
// Polyfill toJSON on BigInt if necessary.
if ($d5f823c11e88739b$var$SUPPORTS_BIGINT && BigInt.prototype.toJSON == null) BigInt.prototype.toJSON = function() {
    return this.toString();
};
const $d5f823c11e88739b$var$HIGH_LOW_CACHE = {};
const $d5f823c11e88739b$var$convertToBigFlag = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function convertToBigFlagBigInt(value) {
    return BigInt(value);
} : function convertToBigFlagHighLow(value) {
    if (value instanceof $d5f823c11e88739b$var$HighLow) return value;
    if (typeof value === "number") value = value.toString();
    // These type assertions are ugly, but there doesn't seem to be a
    // runtime costless way to do a type assertion above.
    if ($d5f823c11e88739b$var$HIGH_LOW_CACHE[value] != null) return $d5f823c11e88739b$var$HIGH_LOW_CACHE[value];
    $d5f823c11e88739b$var$HIGH_LOW_CACHE[value] = $d5f823c11e88739b$var$HighLow.fromString(value);
    return $d5f823c11e88739b$var$HIGH_LOW_CACHE[value];
};
const $d5f823c11e88739b$var$EMPTY_FLAG = $d5f823c11e88739b$var$convertToBigFlag(0);
const $d5f823c11e88739b$var$flagAnd = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function flagAndBigInt(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first & second;
} : function flagAndHighLow(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first.and(second);
};
const $d5f823c11e88739b$var$flagOr = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function flagOrBigInt(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first | second;
} : function flagOrHighLow(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first.or(second);
};
const $d5f823c11e88739b$var$flagXor = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function flagXorBigInt(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first ^ second;
} : function flagXorHighLow(first = $d5f823c11e88739b$var$EMPTY_FLAG, second = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first.xor(second);
};
const $d5f823c11e88739b$var$flagNot = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function flagNotBigInt(first = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return ~first;
} : function flagNotHighLow(first = $d5f823c11e88739b$var$EMPTY_FLAG) {
    return first.not();
};
const $d5f823c11e88739b$var$flagEquals = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function flagEqualsBigInt(first, second) {
    return first === second;
} : function flagEqualsHighLow(first, second) {
    if (first == null || second == null) // eslint-disable-next-line eqeqeq
    return first == second;
    return first.equals(second);
};
function $d5f823c11e88739b$var$flagOrMultiple(...flags) {
    let result = flags[0];
    for(let i = 1; i < flags.length; i++)result = $d5f823c11e88739b$var$flagOr(result, flags[i]);
    return result;
}
function $d5f823c11e88739b$var$flagHas(base, flag) {
    return $d5f823c11e88739b$var$flagEquals($d5f823c11e88739b$var$flagAnd(base, flag), flag);
}
function $d5f823c11e88739b$var$flagHasAny(base, flag) {
    return !$d5f823c11e88739b$var$flagEquals($d5f823c11e88739b$var$flagAnd(base, flag), $d5f823c11e88739b$var$EMPTY_FLAG);
}
function $d5f823c11e88739b$var$flagAdd(base, flag) {
    return flag === $d5f823c11e88739b$var$EMPTY_FLAG ? base : $d5f823c11e88739b$var$flagOr(base, flag);
}
function $d5f823c11e88739b$var$flagRemove(base, flag) {
    return flag === $d5f823c11e88739b$var$EMPTY_FLAG ? base : $d5f823c11e88739b$var$flagXor(base, $d5f823c11e88739b$var$flagAnd(base, flag));
}
const $d5f823c11e88739b$var$getFlag = $d5f823c11e88739b$var$SUPPORTS_BIGINT ? function getFlagBigInt(index) {
    return BigInt(1) << BigInt(index);
} : function getFlagHighLow(index) {
    return $d5f823c11e88739b$var$HighLow.fromBit(index);
};
var $d5f823c11e88739b$export$2e2bcd8739ae039 = {
    combine: $d5f823c11e88739b$var$flagOrMultiple,
    add: $d5f823c11e88739b$var$flagAdd,
    remove: $d5f823c11e88739b$var$flagRemove,
    filter: $d5f823c11e88739b$var$flagAnd,
    invert: $d5f823c11e88739b$var$flagNot,
    has: $d5f823c11e88739b$var$flagHas,
    hasAny: $d5f823c11e88739b$var$flagHasAny,
    equals: $d5f823c11e88739b$var$flagEquals,
    deserialize: $d5f823c11e88739b$var$convertToBigFlag,
    getFlag: $d5f823c11e88739b$var$getFlag
};

});
parcelRegister("ux1WZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7da2c476c559337d$export$2e2bcd8739ae039; });

var $fgm47 = parcelRequire("fgm47");

var $4GIS9 = parcelRequire("4GIS9");
var $7da2c476c559337d$var$BigIntegerExports = (0, $4GIS9.__require)();
var $7da2c476c559337d$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fgm47.getDefaultExportFromCjs)($7da2c476c559337d$var$BigIntegerExports);

});
parcelRegister("4GIS9", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $7d01c43e467d77e2$export$b88c30a9414655a0; });

var $k099I = parcelRequire("k099I");
var $7d01c43e467d77e2$var$hasRequiredBigInteger;
function $7d01c43e467d77e2$export$b88c30a9414655a0() {
    if ($7d01c43e467d77e2$var$hasRequiredBigInteger) return (0, $k099I.__module).exports;
    $7d01c43e467d77e2$var$hasRequiredBigInteger = 1;
    (function(module) {
        var bigInt = function(undefined$1) {
            var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
            var supportsNativeBigInt = typeof BigInt === "function";
            function Integer(v, radix, alphabet, caseSensitive) {
                if (typeof v === "undefined") return Integer[0];
                if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
                return parseValue(v);
            }
            function BigInteger(value, sign) {
                this.value = value;
                this.sign = sign;
                this.isSmall = false;
            }
            BigInteger.prototype = Object.create(Integer.prototype);
            function SmallInteger(value) {
                this.value = value;
                this.sign = value < 0;
                this.isSmall = true;
            }
            SmallInteger.prototype = Object.create(Integer.prototype);
            function NativeBigInt(value) {
                this.value = value;
            }
            NativeBigInt.prototype = Object.create(Integer.prototype);
            function isPrecise(n) {
                return -MAX_INT < n && n < MAX_INT;
            }
            function smallToArray(n) {
                if (n < 1e7) return [
                    n
                ];
                if (n < 1e14) return [
                    n % 1e7,
                    Math.floor(n / 1e7)
                ];
                return [
                    n % 1e7,
                    Math.floor(n / 1e7) % 1e7,
                    Math.floor(n / 1e14)
                ];
            }
            function arrayToSmall(arr) {
                trim(arr);
                var length = arr.length;
                if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
                    case 0:
                        return 0;
                    case 1:
                        return arr[0];
                    case 2:
                        return arr[0] + arr[1] * BASE;
                    default:
                        return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
                }
                return arr;
            }
            function trim(v) {
                var i = v.length;
                while(v[--i] === 0);
                v.length = i + 1;
            }
            function createArray(length) {
                var x = new Array(length);
                var i = -1;
                while(++i < length)x[i] = 0;
                return x;
            }
            function truncate(n) {
                if (n > 0) return Math.floor(n);
                return Math.ceil(n);
            }
            function add(a, b) {
                var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
                for(i = 0; i < l_b; i++){
                    sum = a[i] + b[i] + carry;
                    carry = sum >= base ? 1 : 0;
                    r[i] = sum - carry * base;
                }
                while(i < l_a){
                    sum = a[i] + carry;
                    carry = sum === base ? 1 : 0;
                    r[i++] = sum - carry * base;
                }
                if (carry > 0) r.push(carry);
                return r;
            }
            function addAny(a, b) {
                if (a.length >= b.length) return add(a, b);
                return add(b, a);
            }
            function addSmall(a, carry) {
                var l = a.length, r = new Array(l), base = BASE, sum, i;
                for(i = 0; i < l; i++){
                    sum = a[i] - base + carry;
                    carry = Math.floor(sum / base);
                    r[i] = sum - carry * base;
                    carry += 1;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            BigInteger.prototype.add = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.subtract(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
                return new BigInteger(addAny(a, b), this.sign);
            };
            BigInteger.prototype.plus = BigInteger.prototype.add;
            SmallInteger.prototype.add = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.subtract(n.negate());
                var b = n.value;
                if (n.isSmall) {
                    if (isPrecise(a + b)) return new SmallInteger(a + b);
                    b = smallToArray(Math.abs(b));
                }
                return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
            };
            SmallInteger.prototype.plus = SmallInteger.prototype.add;
            NativeBigInt.prototype.add = function(v) {
                return new NativeBigInt(this.value + parseValue(v).value);
            };
            NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
            function subtract(a, b) {
                var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
                for(i = 0; i < b_l; i++){
                    difference = a[i] - borrow - b[i];
                    if (difference < 0) {
                        difference += base;
                        borrow = 1;
                    } else borrow = 0;
                    r[i] = difference;
                }
                for(i = b_l; i < a_l; i++){
                    difference = a[i] - borrow;
                    if (difference < 0) difference += base;
                    else {
                        r[i++] = difference;
                        break;
                    }
                    r[i] = difference;
                }
                for(; i < a_l; i++)r[i] = a[i];
                trim(r);
                return r;
            }
            function subtractAny(a, b, sign) {
                var value;
                if (compareAbs(a, b) >= 0) value = subtract(a, b);
                else {
                    value = subtract(b, a);
                    sign = !sign;
                }
                value = arrayToSmall(value);
                if (typeof value === "number") {
                    if (sign) value = -value;
                    return new SmallInteger(value);
                }
                return new BigInteger(value, sign);
            }
            function subtractSmall(a, b, sign) {
                var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
                for(i = 0; i < l; i++){
                    difference = a[i] + carry;
                    carry = Math.floor(difference / base);
                    difference %= base;
                    r[i] = difference < 0 ? difference + base : difference;
                }
                r = arrayToSmall(r);
                if (typeof r === "number") {
                    if (sign) r = -r;
                    return new SmallInteger(r);
                }
                return new BigInteger(r, sign);
            }
            BigInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                if (this.sign !== n.sign) return this.add(n.negate());
                var a = this.value, b = n.value;
                if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
                return subtractAny(a, b, this.sign);
            };
            BigInteger.prototype.minus = BigInteger.prototype.subtract;
            SmallInteger.prototype.subtract = function(v) {
                var n = parseValue(v);
                var a = this.value;
                if (a < 0 !== n.sign) return this.add(n.negate());
                var b = n.value;
                if (n.isSmall) return new SmallInteger(a - b);
                return subtractSmall(b, Math.abs(a), a >= 0);
            };
            SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
            NativeBigInt.prototype.subtract = function(v) {
                return new NativeBigInt(this.value - parseValue(v).value);
            };
            NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
            BigInteger.prototype.negate = function() {
                return new BigInteger(this.value, !this.sign);
            };
            SmallInteger.prototype.negate = function() {
                var sign = this.sign;
                var small = new SmallInteger(-this.value);
                small.sign = !sign;
                return small;
            };
            NativeBigInt.prototype.negate = function() {
                return new NativeBigInt(-this.value);
            };
            BigInteger.prototype.abs = function() {
                return new BigInteger(this.value, false);
            };
            SmallInteger.prototype.abs = function() {
                return new SmallInteger(Math.abs(this.value));
            };
            NativeBigInt.prototype.abs = function() {
                return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
            };
            function multiplyLong(a, b) {
                var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
                for(i = 0; i < a_l; ++i){
                    a_i = a[i];
                    for(var j = 0; j < b_l; ++j){
                        b_j = b[j];
                        product = a_i * b_j + r[i + j];
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                        r[i + j + 1] += carry;
                    }
                }
                trim(r);
                return r;
            }
            function multiplySmall(a, b) {
                var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
                for(i = 0; i < l; i++){
                    product = a[i] * b + carry;
                    carry = Math.floor(product / base);
                    r[i] = product - carry * base;
                }
                while(carry > 0){
                    r[i++] = carry % base;
                    carry = Math.floor(carry / base);
                }
                return r;
            }
            function shiftLeft(x, n) {
                var r = [];
                while(n-- > 0)r.push(0);
                return r.concat(x);
            }
            function multiplyKaratsuba(x, y) {
                var n = Math.max(x.length, y.length);
                if (n <= 30) return multiplyLong(x, y);
                n = Math.ceil(n / 2);
                var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
                var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
                var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
                trim(product);
                return product;
            }
            // The following function is derived from a surface fit of a graph plotting the performance difference
            // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
            function useKaratsuba(l1, l2) {
                return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
            }
            BigInteger.prototype.multiply = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
                if (n.isSmall) {
                    if (b === 0) return Integer[0];
                    if (b === 1) return this;
                    if (b === -1) return this.negate();
                    abs = Math.abs(b);
                    if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
                    b = smallToArray(abs);
                }
                if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
                return new BigInteger(multiplyLong(a, b), sign);
            };
            BigInteger.prototype.times = BigInteger.prototype.multiply;
            function multiplySmallAndArray(a, b, sign) {
                if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
                return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
            }
            SmallInteger.prototype._multiplyBySmall = function(a) {
                if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
                return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
            };
            BigInteger.prototype._multiplyBySmall = function(a) {
                if (a.value === 0) return Integer[0];
                if (a.value === 1) return this;
                if (a.value === -1) return this.negate();
                return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
            };
            SmallInteger.prototype.multiply = function(v) {
                return parseValue(v)._multiplyBySmall(this);
            };
            SmallInteger.prototype.times = SmallInteger.prototype.multiply;
            NativeBigInt.prototype.multiply = function(v) {
                return new NativeBigInt(this.value * parseValue(v).value);
            };
            NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
            function square(a) {
                //console.assert(2 * BASE * BASE < MAX_INT);
                var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
                for(i = 0; i < l; i++){
                    a_i = a[i];
                    carry = 0 - a_i * a_i;
                    for(var j = i; j < l; j++){
                        a_j = a[j];
                        product = 2 * (a_i * a_j) + r[i + j] + carry;
                        carry = Math.floor(product / base);
                        r[i + j] = product - carry * base;
                    }
                    r[i + l] = carry;
                }
                trim(r);
                return r;
            }
            BigInteger.prototype.square = function() {
                return new BigInteger(square(this.value), false);
            };
            SmallInteger.prototype.square = function() {
                var value = this.value * this.value;
                if (isPrecise(value)) return new SmallInteger(value);
                return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
            };
            NativeBigInt.prototype.square = function(v) {
                return new NativeBigInt(this.value * this.value);
            };
            function divMod1(a, b) {
                var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
                lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
                if (remainder.length <= a_l) remainder.push(0);
                divisor.push(0);
                divisorMostSignificantDigit = divisor[b_l - 1];
                for(shift = a_l - b_l; shift >= 0; shift--){
                    quotientDigit = base - 1;
                    if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
                    // quotientDigit <= base - 1
                    carry = 0;
                    borrow = 0;
                    l = divisor.length;
                    for(i = 0; i < l; i++){
                        carry += quotientDigit * divisor[i];
                        q = Math.floor(carry / base);
                        borrow += remainder[shift + i] - (carry - q * base);
                        carry = q;
                        if (borrow < 0) {
                            remainder[shift + i] = borrow + base;
                            borrow = -1;
                        } else {
                            remainder[shift + i] = borrow;
                            borrow = 0;
                        }
                    }
                    while(borrow !== 0){
                        quotientDigit -= 1;
                        carry = 0;
                        for(i = 0; i < l; i++){
                            carry += remainder[shift + i] - base + divisor[i];
                            if (carry < 0) {
                                remainder[shift + i] = carry + base;
                                carry = 0;
                            } else {
                                remainder[shift + i] = carry;
                                carry = 1;
                            }
                        }
                        borrow += carry;
                    }
                    result[shift] = quotientDigit;
                }
                // denormalization
                remainder = divModSmall(remainder, lambda)[0];
                return [
                    arrayToSmall(result),
                    arrayToSmall(remainder)
                ];
            }
            function divMod2(a, b) {
                // Performs faster than divMod1 on larger input sizes.
                var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
                while(a_l){
                    part.unshift(a[--a_l]);
                    trim(part);
                    if (compareAbs(part, b) < 0) {
                        result.push(0);
                        continue;
                    }
                    xlen = part.length;
                    highx = part[xlen - 1] * base + part[xlen - 2];
                    highy = b[b_l - 1] * base + b[b_l - 2];
                    if (xlen > b_l) highx = (highx + 1) * base;
                    guess = Math.ceil(highx / highy);
                    do {
                        check = multiplySmall(b, guess);
                        if (compareAbs(check, part) <= 0) break;
                        guess--;
                    }while (guess);
                    result.push(guess);
                    part = subtract(part, check);
                }
                result.reverse();
                return [
                    arrayToSmall(result),
                    arrayToSmall(part)
                ];
            }
            function divModSmall(value, lambda) {
                var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
                remainder = 0;
                for(i = length - 1; i >= 0; --i){
                    divisor = remainder * base + value[i];
                    q = truncate(divisor / lambda);
                    remainder = divisor - q * lambda;
                    quotient[i] = q | 0;
                }
                return [
                    quotient,
                    remainder | 0
                ];
            }
            function divModAny(self, v) {
                var value, n = parseValue(v);
                if (supportsNativeBigInt) return [
                    new NativeBigInt(self.value / n.value),
                    new NativeBigInt(self.value % n.value)
                ];
                var a = self.value, b = n.value;
                var quotient;
                if (b === 0) throw new Error("Cannot divide by zero");
                if (self.isSmall) {
                    if (n.isSmall) return [
                        new SmallInteger(truncate(a / b)),
                        new SmallInteger(a % b)
                    ];
                    return [
                        Integer[0],
                        self
                    ];
                }
                if (n.isSmall) {
                    if (b === 1) return [
                        self,
                        Integer[0]
                    ];
                    if (b == -1) return [
                        self.negate(),
                        Integer[0]
                    ];
                    var abs = Math.abs(b);
                    if (abs < BASE) {
                        value = divModSmall(a, abs);
                        quotient = arrayToSmall(value[0]);
                        var remainder = value[1];
                        if (self.sign) remainder = -remainder;
                        if (typeof quotient === "number") {
                            if (self.sign !== n.sign) quotient = -quotient;
                            return [
                                new SmallInteger(quotient),
                                new SmallInteger(remainder)
                            ];
                        }
                        return [
                            new BigInteger(quotient, self.sign !== n.sign),
                            new SmallInteger(remainder)
                        ];
                    }
                    b = smallToArray(abs);
                }
                var comparison = compareAbs(a, b);
                if (comparison === -1) return [
                    Integer[0],
                    self
                ];
                if (comparison === 0) return [
                    Integer[self.sign === n.sign ? 1 : -1],
                    Integer[0]
                ];
                // divMod1 is faster on smaller input sizes
                if (a.length + b.length <= 200) value = divMod1(a, b);
                else value = divMod2(a, b);
                quotient = value[0];
                var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
                if (typeof quotient === "number") {
                    if (qSign) quotient = -quotient;
                    quotient = new SmallInteger(quotient);
                } else quotient = new BigInteger(quotient, qSign);
                if (typeof mod === "number") {
                    if (mSign) mod = -mod;
                    mod = new SmallInteger(mod);
                } else mod = new BigInteger(mod, mSign);
                return [
                    quotient,
                    mod
                ];
            }
            BigInteger.prototype.divmod = function(v) {
                var result = divModAny(this, v);
                return {
                    quotient: result[0],
                    remainder: result[1]
                };
            };
            NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
            BigInteger.prototype.divide = function(v) {
                return divModAny(this, v)[0];
            };
            NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
                return new NativeBigInt(this.value / parseValue(v).value);
            };
            SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
            BigInteger.prototype.mod = function(v) {
                return divModAny(this, v)[1];
            };
            NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
                return new NativeBigInt(this.value % parseValue(v).value);
            };
            SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
            BigInteger.prototype.pow = function(v) {
                var n = parseValue(v), a = this.value, b = n.value, value, x, y;
                if (b === 0) return Integer[1];
                if (a === 0) return Integer[0];
                if (a === 1) return Integer[1];
                if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.sign) return Integer[0];
                if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
                if (this.isSmall) {
                    if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
                }
                x = this;
                y = Integer[1];
                while(true){
                    if (b & true) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === 0) break;
                    b /= 2;
                    x = x.square();
                }
                return y;
            };
            SmallInteger.prototype.pow = BigInteger.prototype.pow;
            NativeBigInt.prototype.pow = function(v) {
                var n = parseValue(v);
                var a = this.value, b = n.value;
                var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
                if (b === _0) return Integer[1];
                if (a === _0) return Integer[0];
                if (a === _1) return Integer[1];
                if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
                if (n.isNegative()) return new NativeBigInt(_0);
                var x = this;
                var y = Integer[1];
                while(true){
                    if ((b & _1) === _1) {
                        y = y.times(x);
                        --b;
                    }
                    if (b === _0) break;
                    b /= _2;
                    x = x.square();
                }
                return y;
            };
            BigInteger.prototype.modPow = function(exp, mod) {
                exp = parseValue(exp);
                mod = parseValue(mod);
                if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
                var r = Integer[1], base = this.mod(mod);
                if (exp.isNegative()) {
                    exp = exp.multiply(Integer[-1]);
                    base = base.modInv(mod);
                }
                while(exp.isPositive()){
                    if (base.isZero()) return Integer[0];
                    if (exp.isOdd()) r = r.multiply(base).mod(mod);
                    exp = exp.divide(2);
                    base = base.square().mod(mod);
                }
                return r;
            };
            NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
            function compareAbs(a, b) {
                if (a.length !== b.length) return a.length > b.length ? 1 : -1;
                for(var i = a.length - 1; i >= 0; i--){
                    if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
                }
                return 0;
            }
            BigInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return 1;
                return compareAbs(a, b);
            };
            SmallInteger.prototype.compareAbs = function(v) {
                var n = parseValue(v), a = Math.abs(this.value), b = n.value;
                if (n.isSmall) {
                    b = Math.abs(b);
                    return a === b ? 0 : a > b ? 1 : -1;
                }
                return -1;
            };
            NativeBigInt.prototype.compareAbs = function(v) {
                var a = this.value;
                var b = parseValue(v).value;
                a = a >= 0 ? a : -a;
                b = b >= 0 ? b : -b;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            BigInteger.prototype.compare = function(v) {
                // See discussion about comparison with Infinity:
                // https://github.com/peterolson/BigInteger.js/issues/61
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (this.sign !== n.sign) return n.sign ? 1 : -1;
                if (n.isSmall) return this.sign ? -1 : 1;
                return compareAbs(a, b) * (this.sign ? -1 : 1);
            };
            BigInteger.prototype.compareTo = BigInteger.prototype.compare;
            SmallInteger.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var n = parseValue(v), a = this.value, b = n.value;
                if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
                if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
                return a < 0 ? 1 : -1;
            };
            SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
            NativeBigInt.prototype.compare = function(v) {
                if (v === Infinity) return -1;
                if (v === -Infinity) return 1;
                var a = this.value;
                var b = parseValue(v).value;
                return a === b ? 0 : a > b ? 1 : -1;
            };
            NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
            BigInteger.prototype.equals = function(v) {
                return this.compare(v) === 0;
            };
            NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
            BigInteger.prototype.notEquals = function(v) {
                return this.compare(v) !== 0;
            };
            NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
            BigInteger.prototype.greater = function(v) {
                return this.compare(v) > 0;
            };
            NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
            BigInteger.prototype.lesser = function(v) {
                return this.compare(v) < 0;
            };
            NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
            BigInteger.prototype.greaterOrEquals = function(v) {
                return this.compare(v) >= 0;
            };
            NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
            BigInteger.prototype.lesserOrEquals = function(v) {
                return this.compare(v) <= 0;
            };
            NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
            BigInteger.prototype.isEven = function() {
                return (this.value[0] & 1) === 0;
            };
            SmallInteger.prototype.isEven = function() {
                return (this.value & 1) === 0;
            };
            NativeBigInt.prototype.isEven = function() {
                return (this.value & BigInt(1)) === BigInt(0);
            };
            BigInteger.prototype.isOdd = function() {
                return (this.value[0] & 1) === 1;
            };
            SmallInteger.prototype.isOdd = function() {
                return (this.value & 1) === 1;
            };
            NativeBigInt.prototype.isOdd = function() {
                return (this.value & BigInt(1)) === BigInt(1);
            };
            BigInteger.prototype.isPositive = function() {
                return !this.sign;
            };
            SmallInteger.prototype.isPositive = function() {
                return this.value > 0;
            };
            NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
            BigInteger.prototype.isNegative = function() {
                return this.sign;
            };
            SmallInteger.prototype.isNegative = function() {
                return this.value < 0;
            };
            NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
            BigInteger.prototype.isUnit = function() {
                return false;
            };
            SmallInteger.prototype.isUnit = function() {
                return Math.abs(this.value) === 1;
            };
            NativeBigInt.prototype.isUnit = function() {
                return this.abs().value === BigInt(1);
            };
            BigInteger.prototype.isZero = function() {
                return false;
            };
            SmallInteger.prototype.isZero = function() {
                return this.value === 0;
            };
            NativeBigInt.prototype.isZero = function() {
                return this.value === BigInt(0);
            };
            BigInteger.prototype.isDivisibleBy = function(v) {
                var n = parseValue(v);
                if (n.isZero()) return false;
                if (n.isUnit()) return true;
                if (n.compareAbs(2) === 0) return this.isEven();
                return this.mod(n).isZero();
            };
            NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
            function isBasicPrime(v) {
                var n = v.abs();
                if (n.isUnit()) return false;
                if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
                if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
                if (n.lesser(49)) return true;
            // we don't know if it's prime: let the other functions figure it out
            }
            function millerRabinTest(n, a) {
                var nPrev = n.prev(), b = nPrev, r = 0, d, i, x;
                while(b.isEven())b = b.divide(2), r++;
                next: for(i = 0; i < a.length; i++){
                    if (n.lesser(a[i])) continue;
                    x = bigInt(a[i]).modPow(b, n);
                    if (x.isUnit() || x.equals(nPrev)) continue;
                    for(d = r - 1; d != 0; d--){
                        x = x.square().mod(n);
                        if (x.isUnit()) return false;
                        if (x.equals(nPrev)) continue next;
                    }
                    return false;
                }
                return true;
            }
            // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
            BigInteger.prototype.isPrime = function(strict) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var bits = n.bitLength();
                if (bits <= 64) return millerRabinTest(n, [
                    2,
                    3,
                    5,
                    7,
                    11,
                    13,
                    17,
                    19,
                    23,
                    29,
                    31,
                    37
                ]);
                var logN = Math.log(2) * bits.toJSNumber();
                var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
                for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
            BigInteger.prototype.isProbablePrime = function(iterations, rng) {
                var isPrime = isBasicPrime(this);
                if (isPrime !== undefined$1) return isPrime;
                var n = this.abs();
                var t = iterations === undefined$1 ? 5 : iterations;
                for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
                return millerRabinTest(n, a);
            };
            NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
            BigInteger.prototype.modInv = function(n) {
                var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
                while(!newR.isZero()){
                    q = r.divide(newR);
                    lastT = t;
                    lastR = r;
                    t = newT;
                    r = newR;
                    newT = lastT.subtract(q.multiply(newT));
                    newR = lastR.subtract(q.multiply(newR));
                }
                if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
                if (t.compare(0) === -1) t = t.add(n);
                if (this.isNegative()) return t.negate();
                return t;
            };
            NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
            BigInteger.prototype.next = function() {
                var value = this.value;
                if (this.sign) return subtractSmall(value, 1, this.sign);
                return new BigInteger(addSmall(value, 1), this.sign);
            };
            SmallInteger.prototype.next = function() {
                var value = this.value;
                if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
                return new BigInteger(MAX_INT_ARR, false);
            };
            NativeBigInt.prototype.next = function() {
                return new NativeBigInt(this.value + BigInt(1));
            };
            BigInteger.prototype.prev = function() {
                var value = this.value;
                if (this.sign) return new BigInteger(addSmall(value, 1), true);
                return subtractSmall(value, 1, this.sign);
            };
            SmallInteger.prototype.prev = function() {
                var value = this.value;
                if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
                return new BigInteger(MAX_INT_ARR, true);
            };
            NativeBigInt.prototype.prev = function() {
                return new NativeBigInt(this.value - BigInt(1));
            };
            var powersOfTwo = [
                1
            ];
            while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
            var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
            function shift_isSmall(n) {
                return Math.abs(n) <= BASE;
            }
            BigInteger.prototype.shiftLeft = function(v) {
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftRight(-n);
                var result = this;
                if (result.isZero()) return result;
                while(n >= powers2Length){
                    result = result.multiply(highestPower2);
                    n -= powers2Length - 1;
                }
                return result.multiply(powersOfTwo[n]);
            };
            NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
            BigInteger.prototype.shiftRight = function(v) {
                var remQuo;
                var n = parseValue(v).toJSNumber();
                if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
                if (n < 0) return this.shiftLeft(-n);
                var result = this;
                while(n >= powers2Length){
                    if (result.isZero() || result.isNegative() && result.isUnit()) return result;
                    remQuo = divModAny(result, highestPower2);
                    result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
                    n -= powers2Length - 1;
                }
                remQuo = divModAny(result, powersOfTwo[n]);
                return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            };
            NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
            function bitwise(x, y, fn) {
                y = parseValue(y);
                var xSign = x.isNegative(), ySign = y.isNegative();
                var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
                var xDigit = 0, yDigit = 0;
                var xDivMod = null, yDivMod = null;
                var result = [];
                while(!xRem.isZero() || !yRem.isZero()){
                    xDivMod = divModAny(xRem, highestPower2);
                    xDigit = xDivMod[1].toJSNumber();
                    if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
                    yDivMod = divModAny(yRem, highestPower2);
                    yDigit = yDivMod[1].toJSNumber();
                    if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
                    xRem = xDivMod[0];
                    yRem = yDivMod[0];
                    result.push(fn(xDigit, yDigit));
                }
                var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
                for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
                return sum;
            }
            BigInteger.prototype.not = function() {
                return this.negate().prev();
            };
            NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
            BigInteger.prototype.and = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a & b;
                });
            };
            NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
            BigInteger.prototype.or = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a | b;
                });
            };
            NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
            BigInteger.prototype.xor = function(n) {
                return bitwise(this, n, function(a, b) {
                    return a ^ b;
                });
            };
            NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
            var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
            function roughLOB(n) {
                // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
                // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
                var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
                return x & -x;
            }
            function integerLogarithm(value, base) {
                if (base.compareTo(value) <= 0) {
                    var tmp = integerLogarithm(value, base.square(base));
                    var p = tmp.p;
                    var e = tmp.e;
                    var t = p.multiply(base);
                    return t.compareTo(value) <= 0 ? {
                        p: t,
                        e: e * 2 + 1
                    } : {
                        p: p,
                        e: e * 2
                    };
                }
                return {
                    p: bigInt(1),
                    e: 0
                };
            }
            BigInteger.prototype.bitLength = function() {
                var n = this;
                if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
                if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
                return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
            };
            NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
            function max(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.greater(b) ? a : b;
            }
            function min(a, b) {
                a = parseValue(a);
                b = parseValue(b);
                return a.lesser(b) ? a : b;
            }
            function gcd(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                if (a.equals(b)) return a;
                if (a.isZero()) return b;
                if (b.isZero()) return a;
                var c = Integer[1], d, t;
                while(a.isEven() && b.isEven()){
                    d = min(roughLOB(a), roughLOB(b));
                    a = a.divide(d);
                    b = b.divide(d);
                    c = c.multiply(d);
                }
                while(a.isEven())a = a.divide(roughLOB(a));
                do {
                    while(b.isEven())b = b.divide(roughLOB(b));
                    if (a.greater(b)) {
                        t = b;
                        b = a;
                        a = t;
                    }
                    b = b.subtract(a);
                }while (!b.isZero());
                return c.isUnit() ? a : a.multiply(c);
            }
            function lcm(a, b) {
                a = parseValue(a).abs();
                b = parseValue(b).abs();
                return a.divide(gcd(a, b)).multiply(b);
            }
            function randBetween(a, b, rng) {
                a = parseValue(a);
                b = parseValue(b);
                var usedRNG = rng || Math.random;
                var low = min(a, b), high = max(a, b);
                var range = high.subtract(low).add(1);
                if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
                var digits = toBase(range, BASE).value;
                var result = [], restricted = true;
                for(var i = 0; i < digits.length; i++){
                    var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
                    var digit = truncate(usedRNG() * top);
                    result.push(digit);
                    if (digit < digits[i]) restricted = false;
                }
                return low.add(Integer.fromArray(result, BASE, false));
            }
            var parseBase = function(text, base, alphabet, caseSensitive) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                text = String(text);
                if (!caseSensitive) {
                    text = text.toLowerCase();
                    alphabet = alphabet.toLowerCase();
                }
                var length = text.length;
                var i;
                var absBase = Math.abs(base);
                var alphabetValues = {};
                for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
                for(i = 0; i < length; i++){
                    var c = text[i];
                    if (c === "-") continue;
                    if (c in alphabetValues) {
                        if (alphabetValues[c] >= absBase) {
                            if (c === "1" && absBase === 1) continue;
                            throw new Error(c + " is not a valid digit in base " + base + ".");
                        }
                    }
                }
                base = parseValue(base);
                var digits = [];
                var isNegative = text[0] === "-";
                for(i = isNegative ? 1 : 0; i < text.length; i++){
                    var c = text[i];
                    if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
                    else if (c === "<") {
                        var start = i;
                        do i++;
                        while (text[i] !== ">" && i < text.length);
                        digits.push(parseValue(text.slice(start + 1, i)));
                    } else throw new Error(c + " is not a valid character");
                }
                return parseBaseFromArray(digits, base, isNegative);
            };
            function parseBaseFromArray(digits, base, isNegative) {
                var val = Integer[0], pow = Integer[1], i;
                for(i = digits.length - 1; i >= 0; i--){
                    val = val.add(digits[i].times(pow));
                    pow = pow.times(base);
                }
                return isNegative ? val.negate() : val;
            }
            function stringify(digit, alphabet) {
                alphabet = alphabet || DEFAULT_ALPHABET;
                if (digit < alphabet.length) return alphabet[digit];
                return "<" + digit + ">";
            }
            function toBase(n, base) {
                base = bigInt(base);
                if (base.isZero()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    throw new Error("Cannot convert nonzero numbers to base 0.");
                }
                if (base.equals(-1)) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    if (n.isNegative()) return {
                        value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                            1,
                            0
                        ])),
                        isNegative: false
                    };
                    var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                        0,
                        1
                    ]);
                    arr.unshift([
                        1
                    ]);
                    return {
                        value: [].concat.apply([], arr),
                        isNegative: false
                    };
                }
                var neg = false;
                if (n.isNegative() && base.isPositive()) {
                    neg = true;
                    n = n.abs();
                }
                if (base.isUnit()) {
                    if (n.isZero()) return {
                        value: [
                            0
                        ],
                        isNegative: false
                    };
                    return {
                        value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                        isNegative: neg
                    };
                }
                var out = [];
                var left = n, divmod;
                while(left.isNegative() || left.compareAbs(base) >= 0){
                    divmod = left.divmod(base);
                    left = divmod.quotient;
                    var digit = divmod.remainder;
                    if (digit.isNegative()) {
                        digit = base.minus(digit).abs();
                        left = left.next();
                    }
                    out.push(digit.toJSNumber());
                }
                out.push(left.toJSNumber());
                return {
                    value: out.reverse(),
                    isNegative: neg
                };
            }
            function toBaseString(n, base, alphabet) {
                var arr = toBase(n, base);
                return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
                    return stringify(x, alphabet);
                }).join("");
            }
            BigInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            SmallInteger.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            NativeBigInt.prototype.toArray = function(radix) {
                return toBase(this, radix);
            };
            BigInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
                var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
                while(--l >= 0){
                    digit = String(v[l]);
                    str += zeros.slice(digit.length) + digit;
                }
                var sign = this.sign ? "-" : "";
                return sign + str;
            };
            SmallInteger.prototype.toString = function(radix, alphabet) {
                if (radix === undefined$1) radix = 10;
                if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
                return String(this.value);
            };
            NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
            NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
                return this.toString();
            };
            BigInteger.prototype.valueOf = function() {
                return parseInt(this.toString(), 10);
            };
            BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
            SmallInteger.prototype.valueOf = function() {
                return this.value;
            };
            SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
            NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
                return parseInt(this.toString(), 10);
            };
            function parseStringValue(v) {
                if (isPrecise(+v)) {
                    var x = +v;
                    if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
                    throw new Error("Invalid integer: " + v);
                }
                var sign = v[0] === "-";
                if (sign) v = v.slice(1);
                var split = v.split(/e/i);
                if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
                if (split.length === 2) {
                    var exp = split[1];
                    if (exp[0] === "+") exp = exp.slice(1);
                    exp = +exp;
                    if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
                    var text = split[0];
                    var decimalPlace = text.indexOf(".");
                    if (decimalPlace >= 0) {
                        exp -= text.length - decimalPlace - 1;
                        text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
                    }
                    if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
                    text += new Array(exp + 1).join("0");
                    v = text;
                }
                var isValid = /^([0-9][0-9]*)$/.test(v);
                if (!isValid) throw new Error("Invalid integer: " + v);
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
                var r = [], max = v.length, l = LOG_BASE, min = max - l;
                while(max > 0){
                    r.push(+v.slice(min, max));
                    min -= l;
                    if (min < 0) min = 0;
                    max -= l;
                }
                trim(r);
                return new BigInteger(r, sign);
            }
            function parseNumberValue(v) {
                if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
                if (isPrecise(v)) {
                    if (v !== truncate(v)) throw new Error(v + " is not an integer.");
                    return new SmallInteger(v);
                }
                return parseStringValue(v.toString());
            }
            function parseValue(v) {
                if (typeof v === "number") return parseNumberValue(v);
                if (typeof v === "string") return parseStringValue(v);
                if (typeof v === "bigint") return new NativeBigInt(v);
                return v;
            }
            // Pre-define numbers in range [-999,999]
            for(var i = 0; i < 1000; i++){
                Integer[i] = parseValue(i);
                if (i > 0) Integer[-i] = parseValue(-i);
            }
            // Backwards compatibility
            Integer.one = Integer[1];
            Integer.zero = Integer[0];
            Integer.minusOne = Integer[-1];
            Integer.max = max;
            Integer.min = min;
            Integer.gcd = gcd;
            Integer.lcm = lcm;
            Integer.isInstance = function(x) {
                return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
            };
            Integer.randBetween = randBetween;
            Integer.fromArray = function(digits, base, isNegative) {
                return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
            };
            return Integer;
        }();
        // Node.js check
        if (module.hasOwnProperty("exports")) module.exports = bigInt;
    })((0, $k099I.__module));
    return (0, $k099I.__module).exports;
}

});
parcelRegister("k099I", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $26c4c9de987a01d4$export$5edeffb658f039f4; });
var $26c4c9de987a01d4$export$5edeffb658f039f4 = {
    exports: {}
};

});





parcelRegister("kq6d3", function(module, exports) {

$parcel$export(module.exports, "DISPATCH", function () { return $29f137cfebde2626$export$efd7770b5da84f9e; });
$parcel$export(module.exports, "Commands", function () { return $29f137cfebde2626$export$ba30f7724cb0e54e; });
$parcel$export(module.exports, "ReceiveFramePayload", function () { return $29f137cfebde2626$export$7a3470becaa040fa; });
$parcel$export(module.exports, "ScopesObject", function () { return $29f137cfebde2626$export$75435f4e5bc6ddd7; });
$parcel$export(module.exports, "Scopes", function () { return $29f137cfebde2626$export$8546186883d6ff3e; });
$parcel$export(module.exports, "Relationship", function () { return $29f137cfebde2626$export$69a0e7946cf616df; });
$parcel$export(module.exports, "User", function () { return $29f137cfebde2626$export$1f44aaf2ec115b54; });
$parcel$export(module.exports, "GuildMember", function () { return $29f137cfebde2626$export$6ba76af5c834ff81; });
$parcel$export(module.exports, "GuildMemberRPC", function () { return $29f137cfebde2626$export$8fbf13c8b5cc978c; });
$parcel$export(module.exports, "Emoji", function () { return $29f137cfebde2626$export$56cc48506ff790a; });
$parcel$export(module.exports, "VoiceState", function () { return $29f137cfebde2626$export$e40a3aa7b507330e; });
$parcel$export(module.exports, "UserVoiceState", function () { return $29f137cfebde2626$export$4b86a4e430ccb511; });
$parcel$export(module.exports, "StatusObject", function () { return $29f137cfebde2626$export$39054e8696850518; });
$parcel$export(module.exports, "Status", function () { return $29f137cfebde2626$export$96e9906d6d93a972; });
$parcel$export(module.exports, "Activity", function () { return $29f137cfebde2626$export$9c16c1426311996d; });
$parcel$export(module.exports, "PermissionOverwriteTypeObject", function () { return $29f137cfebde2626$export$fab33d7660c6e6d6; });
$parcel$export(module.exports, "PermissionOverwrite", function () { return $29f137cfebde2626$export$3700bd144328e1a6; });
$parcel$export(module.exports, "ChannelTypesObject", function () { return $29f137cfebde2626$export$2f4cb441f3eded01; });
$parcel$export(module.exports, "Channel", function () { return $29f137cfebde2626$export$cfdacaa37f9b4dd7; });
$parcel$export(module.exports, "PresenceUpdate", function () { return $29f137cfebde2626$export$24da275c271e8208; });
$parcel$export(module.exports, "Role", function () { return $29f137cfebde2626$export$46919bad18fb2f76; });
$parcel$export(module.exports, "Guild", function () { return $29f137cfebde2626$export$85e439e10eca0e6b; });
$parcel$export(module.exports, "ChannelMention", function () { return $29f137cfebde2626$export$8ce7ab97167fc310; });
$parcel$export(module.exports, "Attachment", function () { return $29f137cfebde2626$export$71e4db985cfcf9e3; });
$parcel$export(module.exports, "EmbedFooter", function () { return $29f137cfebde2626$export$8c9fffced316d89b; });
$parcel$export(module.exports, "Image", function () { return $29f137cfebde2626$export$3e431a229df88919; });
$parcel$export(module.exports, "Video", function () { return $29f137cfebde2626$export$ae01dedf5c052bb; });
$parcel$export(module.exports, "EmbedProvider", function () { return $29f137cfebde2626$export$e4790b418e6d5a4d; });
$parcel$export(module.exports, "EmbedAuthor", function () { return $29f137cfebde2626$export$632a034bda2c67e4; });
$parcel$export(module.exports, "EmbedField", function () { return $29f137cfebde2626$export$8f305b092204e542; });
$parcel$export(module.exports, "Embed", function () { return $29f137cfebde2626$export$a84540bc8b694b2d; });
$parcel$export(module.exports, "Reaction", function () { return $29f137cfebde2626$export$d2ae4167a30cf6bb; });
$parcel$export(module.exports, "MessageActivity", function () { return $29f137cfebde2626$export$465ad97f4d04cf9a; });
$parcel$export(module.exports, "MessageApplication", function () { return $29f137cfebde2626$export$56f5e744391a955c; });
$parcel$export(module.exports, "MessageReference", function () { return $29f137cfebde2626$export$bcebdc029e694ee6; });
$parcel$export(module.exports, "Message", function () { return $29f137cfebde2626$export$f69c19e57285b83a; });
$parcel$export(module.exports, "VoiceDevice", function () { return $29f137cfebde2626$export$624aa0dd60bb35db; });
$parcel$export(module.exports, "KeyTypesObject", function () { return $29f137cfebde2626$export$2ede097136cc13e4; });
$parcel$export(module.exports, "ShortcutKey", function () { return $29f137cfebde2626$export$f20a7ed0751474c1; });
$parcel$export(module.exports, "VoiceSettingModeTypeObject", function () { return $29f137cfebde2626$export$9d6f8c8df913ee9d; });
$parcel$export(module.exports, "VoiceSettingsMode", function () { return $29f137cfebde2626$export$c99e7704e60373e9; });
$parcel$export(module.exports, "VoiceSettingsIO", function () { return $29f137cfebde2626$export$cb1d6465ddfebcf0; });
$parcel$export(module.exports, "CertifiedDeviceTypeObject", function () { return $29f137cfebde2626$export$8320da8c452e87fc; });
$parcel$export(module.exports, "CertifiedDevice", function () { return $29f137cfebde2626$export$4f2f4bd3c787de21; });
$parcel$export(module.exports, "SkuTypeObject", function () { return $29f137cfebde2626$export$439ecd4335b15be4; });
$parcel$export(module.exports, "Sku", function () { return $29f137cfebde2626$export$ccf658062b0f9f7a; });
$parcel$export(module.exports, "EntitlementTypesObject", function () { return $29f137cfebde2626$export$6259f37857107b12; });
$parcel$export(module.exports, "Entitlement", function () { return $29f137cfebde2626$export$7b20d168ba04011b; });
$parcel$export(module.exports, "OrientationLockStateTypeObject", function () { return $29f137cfebde2626$export$7e8bb741497f2d3; });
$parcel$export(module.exports, "OrientationLockState", function () { return $29f137cfebde2626$export$76765004a89b60c4; });
$parcel$export(module.exports, "ThermalStateTypeObject", function () { return $29f137cfebde2626$export$6b5ef5fbc271f145; });
$parcel$export(module.exports, "ThermalState", function () { return $29f137cfebde2626$export$8065eea9d621a18; });
$parcel$export(module.exports, "OrientationTypeObject", function () { return $29f137cfebde2626$export$6998f50a089a6f29; });
$parcel$export(module.exports, "Orientation", function () { return $29f137cfebde2626$export$df54d73aa0ec5e82; });
$parcel$export(module.exports, "LayoutModeTypeObject", function () { return $29f137cfebde2626$export$94c8fa8df0efcb28; });
$parcel$export(module.exports, "LayoutMode", function () { return $29f137cfebde2626$export$8f9fafd62f4ed4cc; });

var $TGurO = parcelRequire("TGurO");

var $4pOtY = parcelRequire("4pOtY");

var $ghr9G = parcelRequire("ghr9G");
// DISPATCH is sent as cmd but is a special case, so is excluded from Commands enum
const $29f137cfebde2626$export$efd7770b5da84f9e = "DISPATCH";
var $29f137cfebde2626$export$ba30f7724cb0e54e;
(function(Commands) {
    Commands["AUTHORIZE"] = "AUTHORIZE";
    Commands["GET_GUILDS"] = "GET_GUILDS";
    Commands["GET_GUILD"] = "GET_GUILD";
    Commands["GET_CHANNEL"] = "GET_CHANNEL";
    Commands["GET_CHANNELS"] = "GET_CHANNELS";
    Commands["SELECT_VOICE_CHANNEL"] = "SELECT_VOICE_CHANNEL";
    Commands["SELECT_TEXT_CHANNEL"] = "SELECT_TEXT_CHANNEL";
    Commands["SUBSCRIBE"] = "SUBSCRIBE";
    Commands["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Commands["CAPTURE_SHORTCUT"] = "CAPTURE_SHORTCUT";
    Commands["SET_CERTIFIED_DEVICES"] = "SET_CERTIFIED_DEVICES";
    Commands["SET_ACTIVITY"] = "SET_ACTIVITY";
    Commands["GET_SKUS"] = "GET_SKUS";
    Commands["GET_ENTITLEMENTS"] = "GET_ENTITLEMENTS";
    Commands["GET_SKUS_EMBEDDED"] = "GET_SKUS_EMBEDDED";
    Commands["GET_ENTITLEMENTS_EMBEDDED"] = "GET_ENTITLEMENTS_EMBEDDED";
    Commands["START_PURCHASE"] = "START_PURCHASE";
    Commands["SET_CONFIG"] = "SET_CONFIG";
    Commands["SEND_ANALYTICS_EVENT"] = "SEND_ANALYTICS_EVENT";
    Commands["USER_SETTINGS_GET_LOCALE"] = "USER_SETTINGS_GET_LOCALE";
    Commands["OPEN_EXTERNAL_LINK"] = "OPEN_EXTERNAL_LINK";
    Commands["ENCOURAGE_HW_ACCELERATION"] = "ENCOURAGE_HW_ACCELERATION";
    Commands["CAPTURE_LOG"] = "CAPTURE_LOG";
    Commands["SET_ORIENTATION_LOCK_STATE"] = "SET_ORIENTATION_LOCK_STATE";
    Commands["OPEN_INVITE_DIALOG"] = "OPEN_INVITE_DIALOG";
    Commands["GET_PLATFORM_BEHAVIORS"] = "GET_PLATFORM_BEHAVIORS";
    Commands["GET_CHANNEL_PERMISSIONS"] = "GET_CHANNEL_PERMISSIONS";
    // START-GENERATED-SECTION
    Commands["AUTHENTICATE"] = "AUTHENTICATE";
    Commands["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Commands["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Commands["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Commands["GET_USER"] = "GET_USER";
    Commands["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Commands["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Commands["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Commands["QUEST_START_TIMER"] = "QUEST_START_TIMER";
    Commands["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Commands["SHARE_LINK"] = "SHARE_LINK";
// END-GENERATED-SECTION
})($29f137cfebde2626$export$ba30f7724cb0e54e || ($29f137cfebde2626$export$ba30f7724cb0e54e = {}));
const $29f137cfebde2626$export$7a3470becaa040fa = (0, $TGurO.object)({
    cmd: (0, $TGurO.string)(),
    data: (0, $TGurO.unknown)(),
    evt: (0, $TGurO.null)(),
    nonce: (0, $TGurO.string)()
}).passthrough();
// TODO afgiel -- next breaking change release
// remove Scopes and ScopesObject in favor of Types.OAuthScopes
const $29f137cfebde2626$export$75435f4e5bc6ddd7 = Object.assign(Object.assign({}, (0, $ghr9G.AuthenticateResponseSchema).shape.scopes.element.overlayType._def.innerType.options[0].Values), {
    UNHANDLED: -1
});
const $29f137cfebde2626$export$8546186883d6ff3e = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$75435f4e5bc6ddd7);
const $29f137cfebde2626$export$69a0e7946cf616df = (0, $ghr9G.GetRelationshipsResponseSchema).shape.relationships.element;
const $29f137cfebde2626$export$1f44aaf2ec115b54 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    username: (0, $TGurO.string)(),
    discriminator: (0, $TGurO.string)(),
    global_name: (0, $TGurO.string)().optional().nullable(),
    avatar: (0, $TGurO.string)().optional().nullable(),
    avatar_decoration_data: (0, $TGurO.object)({
        asset: (0, $TGurO.string)(),
        sku_id: (0, $TGurO.string)().optional()
    }).nullable(),
    bot: (0, $TGurO.boolean)(),
    flags: (0, $TGurO.number)().optional().nullable(),
    premium_type: (0, $TGurO.number)().optional().nullable()
});
const $29f137cfebde2626$export$6ba76af5c834ff81 = (0, $TGurO.object)({
    user: $29f137cfebde2626$export$1f44aaf2ec115b54,
    nick: (0, $TGurO.string)().optional().nullable(),
    roles: (0, $TGurO.array)((0, $TGurO.string)()),
    joined_at: (0, $TGurO.string)(),
    deaf: (0, $TGurO.boolean)(),
    mute: (0, $TGurO.boolean)()
});
const $29f137cfebde2626$export$8fbf13c8b5cc978c = (0, $TGurO.object)({
    user_id: (0, $TGurO.string)(),
    nick: (0, $TGurO.string)().optional().nullable(),
    guild_id: (0, $TGurO.string)(),
    avatar: (0, $TGurO.string)().optional().nullable(),
    avatar_decoration_data: (0, $TGurO.object)({
        asset: (0, $TGurO.string)(),
        sku_id: (0, $TGurO.string)().optional().nullable()
    }).optional().nullable(),
    color_string: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$56cc48506ff790a = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)().optional().nullable(),
    roles: (0, $TGurO.array)((0, $TGurO.string)()).optional().nullable(),
    user: $29f137cfebde2626$export$1f44aaf2ec115b54.optional().nullable(),
    require_colons: (0, $TGurO.boolean)().optional().nullable(),
    managed: (0, $TGurO.boolean)().optional().nullable(),
    animated: (0, $TGurO.boolean)().optional().nullable(),
    available: (0, $TGurO.boolean)().optional().nullable()
});
const $29f137cfebde2626$export$e40a3aa7b507330e = (0, $TGurO.object)({
    mute: (0, $TGurO.boolean)(),
    deaf: (0, $TGurO.boolean)(),
    self_mute: (0, $TGurO.boolean)(),
    self_deaf: (0, $TGurO.boolean)(),
    suppress: (0, $TGurO.boolean)()
});
const $29f137cfebde2626$export$4b86a4e430ccb511 = (0, $TGurO.object)({
    mute: (0, $TGurO.boolean)(),
    nick: (0, $TGurO.string)(),
    user: $29f137cfebde2626$export$1f44aaf2ec115b54,
    voice_state: $29f137cfebde2626$export$e40a3aa7b507330e,
    volume: (0, $TGurO.number)()
});
const $29f137cfebde2626$export$39054e8696850518 = {
    UNHANDLED: -1,
    IDLE: "idle",
    DND: "dnd",
    ONLINE: "online",
    OFFLINE: "offline"
};
const $29f137cfebde2626$export$96e9906d6d93a972 = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$39054e8696850518);
const $29f137cfebde2626$export$9c16c1426311996d = (0, $TGurO.object)({
    name: (0, $TGurO.string)(),
    type: (0, $TGurO.number)(),
    url: (0, $TGurO.string)().optional().nullable(),
    created_at: (0, $TGurO.number)().optional().nullable(),
    timestamps: (0, $TGurO.object)({
        start: (0, $TGurO.number)(),
        end: (0, $TGurO.number)()
    }).partial().optional().nullable(),
    application_id: (0, $TGurO.string)().optional().nullable(),
    details: (0, $TGurO.string)().optional().nullable(),
    details_url: (0, $TGurO.string)().url().optional().nullable(),
    state: (0, $TGurO.string)().optional().nullable(),
    state_url: (0, $TGurO.string)().url().optional().nullable(),
    emoji: $29f137cfebde2626$export$56cc48506ff790a.optional().nullable(),
    party: (0, $TGurO.object)({
        id: (0, $TGurO.string)().optional().nullable(),
        size: (0, $TGurO.array)((0, $TGurO.number)()).optional().nullable()
    }).optional().nullable(),
    assets: (0, $TGurO.object)({
        large_image: (0, $TGurO.string)().nullable(),
        large_text: (0, $TGurO.string)().nullable(),
        large_url: (0, $TGurO.string)().url().optional().nullable(),
        small_image: (0, $TGurO.string)().nullable(),
        small_text: (0, $TGurO.string)().nullable(),
        small_url: (0, $TGurO.string)().url().optional().nullable()
    }).partial().optional().nullable(),
    secrets: (0, $TGurO.object)({
        join: (0, $TGurO.string)(),
        match: (0, $TGurO.string)()
    }).partial().optional().nullable(),
    instance: (0, $TGurO.boolean)().optional().nullable(),
    flags: (0, $TGurO.number)().optional().nullable()
});
const $29f137cfebde2626$export$fab33d7660c6e6d6 = {
    UNHANDLED: -1,
    ROLE: 0,
    MEMBER: 1
};
const $29f137cfebde2626$export$3700bd144328e1a6 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$fab33d7660c6e6d6),
    allow: (0, $TGurO.string)(),
    deny: (0, $TGurO.string)()
});
const $29f137cfebde2626$export$2f4cb441f3eded01 = {
    UNHANDLED: -1,
    DM: 1,
    GROUP_DM: 3,
    GUILD_TEXT: 0,
    GUILD_VOICE: 2,
    GUILD_CATEGORY: 4,
    GUILD_ANNOUNCEMENT: 5,
    GUILD_STORE: 6,
    ANNOUNCEMENT_THREAD: 10,
    PUBLIC_THREAD: 11,
    PRIVATE_THREAD: 12,
    GUILD_STAGE_VOICE: 13,
    GUILD_DIRECTORY: 14,
    GUILD_FORUM: 15
};
const $29f137cfebde2626$export$cfdacaa37f9b4dd7 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$2f4cb441f3eded01),
    guild_id: (0, $TGurO.string)().optional().nullable(),
    position: (0, $TGurO.number)().optional().nullable(),
    permission_overwrites: (0, $TGurO.array)($29f137cfebde2626$export$3700bd144328e1a6).optional().nullable(),
    name: (0, $TGurO.string)().optional().nullable(),
    topic: (0, $TGurO.string)().optional().nullable(),
    nsfw: (0, $TGurO.boolean)().optional().nullable(),
    last_message_id: (0, $TGurO.string)().optional().nullable(),
    bitrate: (0, $TGurO.number)().optional().nullable(),
    user_limit: (0, $TGurO.number)().optional().nullable(),
    rate_limit_per_user: (0, $TGurO.number)().optional().nullable(),
    recipients: (0, $TGurO.array)($29f137cfebde2626$export$1f44aaf2ec115b54).optional().nullable(),
    icon: (0, $TGurO.string)().optional().nullable(),
    owner_id: (0, $TGurO.string)().optional().nullable(),
    application_id: (0, $TGurO.string)().optional().nullable(),
    parent_id: (0, $TGurO.string)().optional().nullable(),
    last_pin_timestamp: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$24da275c271e8208 = (0, $TGurO.object)({
    user: $29f137cfebde2626$export$1f44aaf2ec115b54,
    guild_id: (0, $TGurO.string)(),
    status: $29f137cfebde2626$export$96e9906d6d93a972,
    activities: (0, $TGurO.array)($29f137cfebde2626$export$9c16c1426311996d),
    client_status: (0, $TGurO.object)({
        desktop: $29f137cfebde2626$export$96e9906d6d93a972,
        mobile: $29f137cfebde2626$export$96e9906d6d93a972,
        web: $29f137cfebde2626$export$96e9906d6d93a972
    }).partial()
});
const $29f137cfebde2626$export$46919bad18fb2f76 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)(),
    color: (0, $TGurO.number)(),
    hoist: (0, $TGurO.boolean)(),
    position: (0, $TGurO.number)(),
    permissions: (0, $TGurO.string)(),
    managed: (0, $TGurO.boolean)(),
    mentionable: (0, $TGurO.boolean)()
});
const $29f137cfebde2626$export$85e439e10eca0e6b = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)(),
    owner_id: (0, $TGurO.string)(),
    icon: (0, $TGurO.string)().nullable(),
    icon_hash: (0, $TGurO.string)().optional().nullable(),
    splash: (0, $TGurO.string)().nullable(),
    discovery_splash: (0, $TGurO.string)().nullable(),
    owner: (0, $TGurO.boolean)().optional().nullable(),
    permissions: (0, $TGurO.string)().optional().nullable(),
    region: (0, $TGurO.string)(),
    afk_channel_id: (0, $TGurO.string)().nullable(),
    afk_timeout: (0, $TGurO.number)(),
    widget_enabled: (0, $TGurO.boolean)().optional().nullable(),
    widget_channel_id: (0, $TGurO.string)().optional().nullable(),
    verification_level: (0, $TGurO.number)(),
    default_message_notifications: (0, $TGurO.number)(),
    explicit_content_filter: (0, $TGurO.number)(),
    roles: (0, $TGurO.array)($29f137cfebde2626$export$46919bad18fb2f76),
    emojis: (0, $TGurO.array)($29f137cfebde2626$export$56cc48506ff790a),
    features: (0, $TGurO.array)((0, $TGurO.string)()),
    mfa_level: (0, $TGurO.number)(),
    application_id: (0, $TGurO.string)().nullable(),
    system_channel_id: (0, $TGurO.string)().nullable(),
    system_channel_flags: (0, $TGurO.number)(),
    rules_channel_id: (0, $TGurO.string)().nullable(),
    joined_at: (0, $TGurO.string)().optional().nullable(),
    large: (0, $TGurO.boolean)().optional().nullable(),
    unavailable: (0, $TGurO.boolean)().optional().nullable(),
    member_count: (0, $TGurO.number)().optional().nullable(),
    voice_states: (0, $TGurO.array)($29f137cfebde2626$export$e40a3aa7b507330e).optional().nullable(),
    members: (0, $TGurO.array)($29f137cfebde2626$export$6ba76af5c834ff81).optional().nullable(),
    channels: (0, $TGurO.array)($29f137cfebde2626$export$cfdacaa37f9b4dd7).optional().nullable(),
    presences: (0, $TGurO.array)($29f137cfebde2626$export$24da275c271e8208).optional().nullable(),
    max_presences: (0, $TGurO.number)().optional().nullable(),
    max_members: (0, $TGurO.number)().optional().nullable(),
    vanity_url_code: (0, $TGurO.string)().nullable(),
    description: (0, $TGurO.string)().nullable(),
    banner: (0, $TGurO.string)().nullable(),
    premium_tier: (0, $TGurO.number)(),
    premium_subscription_count: (0, $TGurO.number)().optional().nullable(),
    preferred_locale: (0, $TGurO.string)(),
    public_updates_channel_id: (0, $TGurO.string)().nullable(),
    max_video_channel_users: (0, $TGurO.number)().optional().nullable(),
    approximate_member_count: (0, $TGurO.number)().optional().nullable(),
    approximate_presence_count: (0, $TGurO.number)().optional().nullable()
});
const $29f137cfebde2626$export$8ce7ab97167fc310 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    guild_id: (0, $TGurO.string)(),
    type: (0, $TGurO.number)(),
    name: (0, $TGurO.string)()
});
const $29f137cfebde2626$export$71e4db985cfcf9e3 = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    filename: (0, $TGurO.string)(),
    size: (0, $TGurO.number)(),
    url: (0, $TGurO.string)(),
    proxy_url: (0, $TGurO.string)(),
    height: (0, $TGurO.number)().optional().nullable(),
    width: (0, $TGurO.number)().optional().nullable()
});
const $29f137cfebde2626$export$8c9fffced316d89b = (0, $TGurO.object)({
    text: (0, $TGurO.string)(),
    icon_url: (0, $TGurO.string)().optional().nullable(),
    proxy_icon_url: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$3e431a229df88919 = (0, $TGurO.object)({
    url: (0, $TGurO.string)().optional().nullable(),
    proxy_url: (0, $TGurO.string)().optional().nullable(),
    height: (0, $TGurO.number)().optional().nullable(),
    width: (0, $TGurO.number)().optional().nullable()
});
const $29f137cfebde2626$export$ae01dedf5c052bb = $29f137cfebde2626$export$3e431a229df88919.omit({
    proxy_url: true
});
const $29f137cfebde2626$export$e4790b418e6d5a4d = (0, $TGurO.object)({
    name: (0, $TGurO.string)().optional().nullable(),
    url: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$632a034bda2c67e4 = (0, $TGurO.object)({
    name: (0, $TGurO.string)().optional().nullable(),
    url: (0, $TGurO.string)().optional().nullable(),
    icon_url: (0, $TGurO.string)().optional().nullable(),
    proxy_icon_url: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$8f305b092204e542 = (0, $TGurO.object)({
    name: (0, $TGurO.string)(),
    value: (0, $TGurO.string)(),
    inline: (0, $TGurO.boolean)()
});
const $29f137cfebde2626$export$a84540bc8b694b2d = (0, $TGurO.object)({
    title: (0, $TGurO.string)().optional().nullable(),
    type: (0, $TGurO.string)().optional().nullable(),
    description: (0, $TGurO.string)().optional().nullable(),
    url: (0, $TGurO.string)().optional().nullable(),
    timestamp: (0, $TGurO.string)().optional().nullable(),
    color: (0, $TGurO.number)().optional().nullable(),
    footer: $29f137cfebde2626$export$8c9fffced316d89b.optional().nullable(),
    image: $29f137cfebde2626$export$3e431a229df88919.optional().nullable(),
    thumbnail: $29f137cfebde2626$export$3e431a229df88919.optional().nullable(),
    video: $29f137cfebde2626$export$ae01dedf5c052bb.optional().nullable(),
    provider: $29f137cfebde2626$export$e4790b418e6d5a4d.optional().nullable(),
    author: $29f137cfebde2626$export$632a034bda2c67e4.optional().nullable(),
    fields: (0, $TGurO.array)($29f137cfebde2626$export$8f305b092204e542).optional().nullable()
});
const $29f137cfebde2626$export$d2ae4167a30cf6bb = (0, $TGurO.object)({
    count: (0, $TGurO.number)(),
    me: (0, $TGurO.boolean)(),
    emoji: $29f137cfebde2626$export$56cc48506ff790a
});
const $29f137cfebde2626$export$465ad97f4d04cf9a = (0, $TGurO.object)({
    type: (0, $TGurO.number)(),
    party_id: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$56f5e744391a955c = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    cover_image: (0, $TGurO.string)().optional().nullable(),
    description: (0, $TGurO.string)(),
    icon: (0, $TGurO.string)().optional().nullable(),
    name: (0, $TGurO.string)()
});
const $29f137cfebde2626$export$bcebdc029e694ee6 = (0, $TGurO.object)({
    message_id: (0, $TGurO.string)().optional().nullable(),
    channel_id: (0, $TGurO.string)().optional().nullable(),
    guild_id: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$f69c19e57285b83a = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    channel_id: (0, $TGurO.string)(),
    guild_id: (0, $TGurO.string)().optional().nullable(),
    author: $29f137cfebde2626$export$1f44aaf2ec115b54.optional().nullable(),
    member: $29f137cfebde2626$export$6ba76af5c834ff81.optional().nullable(),
    content: (0, $TGurO.string)(),
    timestamp: (0, $TGurO.string)(),
    edited_timestamp: (0, $TGurO.string)().optional().nullable(),
    tts: (0, $TGurO.boolean)(),
    mention_everyone: (0, $TGurO.boolean)(),
    mentions: (0, $TGurO.array)($29f137cfebde2626$export$1f44aaf2ec115b54),
    mention_roles: (0, $TGurO.array)((0, $TGurO.string)()),
    mention_channels: (0, $TGurO.array)($29f137cfebde2626$export$8ce7ab97167fc310),
    attachments: (0, $TGurO.array)($29f137cfebde2626$export$71e4db985cfcf9e3),
    embeds: (0, $TGurO.array)($29f137cfebde2626$export$a84540bc8b694b2d),
    reactions: (0, $TGurO.array)($29f137cfebde2626$export$d2ae4167a30cf6bb).optional().nullable(),
    nonce: (0, $TGurO.union)([
        (0, $TGurO.string)(),
        (0, $TGurO.number)()
    ]).optional().nullable(),
    pinned: (0, $TGurO.boolean)(),
    webhook_id: (0, $TGurO.string)().optional().nullable(),
    type: (0, $TGurO.number)(),
    activity: $29f137cfebde2626$export$465ad97f4d04cf9a.optional().nullable(),
    application: $29f137cfebde2626$export$56f5e744391a955c.optional().nullable(),
    message_reference: $29f137cfebde2626$export$bcebdc029e694ee6.optional().nullable(),
    flags: (0, $TGurO.number)().optional().nullable(),
    stickers: (0, $TGurO.array)((0, $TGurO.unknown)()).optional().nullable(),
    // Cannot self reference, but this is possibly a Message
    referenced_message: (0, $TGurO.unknown)().optional().nullable()
});
const $29f137cfebde2626$export$624aa0dd60bb35db = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)()
});
const $29f137cfebde2626$export$2ede097136cc13e4 = {
    UNHANDLED: -1,
    KEYBOARD_KEY: 0,
    MOUSE_BUTTON: 1,
    KEYBOARD_MODIFIER_KEY: 2,
    GAMEPAD_BUTTON: 3
};
const $29f137cfebde2626$export$f20a7ed0751474c1 = (0, $TGurO.object)({
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$2ede097136cc13e4),
    code: (0, $TGurO.number)(),
    name: (0, $TGurO.string)()
});
const $29f137cfebde2626$export$9d6f8c8df913ee9d = {
    UNHANDLED: -1,
    PUSH_TO_TALK: "PUSH_TO_TALK",
    VOICE_ACTIVITY: "VOICE_ACTIVITY"
};
const $29f137cfebde2626$export$c99e7704e60373e9 = (0, $TGurO.object)({
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$9d6f8c8df913ee9d),
    auto_threshold: (0, $TGurO.boolean)(),
    threshold: (0, $TGurO.number)(),
    shortcut: (0, $TGurO.array)($29f137cfebde2626$export$f20a7ed0751474c1),
    delay: (0, $TGurO.number)()
});
const $29f137cfebde2626$export$cb1d6465ddfebcf0 = (0, $TGurO.object)({
    device_id: (0, $TGurO.string)(),
    volume: (0, $TGurO.number)(),
    available_devices: (0, $TGurO.array)($29f137cfebde2626$export$624aa0dd60bb35db)
});
const $29f137cfebde2626$export$8320da8c452e87fc = {
    UNHANDLED: -1,
    AUDIO_INPUT: "AUDIO_INPUT",
    AUDIO_OUTPUT: "AUDIO_OUTPUT",
    VIDEO_INPUT: "VIDEO_INPUT"
};
const $29f137cfebde2626$export$4f2f4bd3c787de21 = (0, $TGurO.object)({
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$8320da8c452e87fc),
    id: (0, $TGurO.string)(),
    vendor: (0, $TGurO.object)({
        name: (0, $TGurO.string)(),
        url: (0, $TGurO.string)()
    }),
    model: (0, $TGurO.object)({
        name: (0, $TGurO.string)(),
        url: (0, $TGurO.string)()
    }),
    related: (0, $TGurO.array)((0, $TGurO.string)()),
    echo_cancellation: (0, $TGurO.boolean)().optional().nullable(),
    noise_suppression: (0, $TGurO.boolean)().optional().nullable(),
    automatic_gain_control: (0, $TGurO.boolean)().optional().nullable(),
    hardware_mute: (0, $TGurO.boolean)().optional().nullable()
});
const $29f137cfebde2626$export$439ecd4335b15be4 = {
    UNHANDLED: -1,
    APPLICATION: 1,
    DLC: 2,
    CONSUMABLE: 3,
    BUNDLE: 4,
    SUBSCRIPTION: 5
};
const $29f137cfebde2626$export$ccf658062b0f9f7a = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)(),
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$439ecd4335b15be4),
    price: (0, $TGurO.object)({
        amount: (0, $TGurO.number)(),
        currency: (0, $TGurO.string)()
    }),
    application_id: (0, $TGurO.string)(),
    flags: (0, $TGurO.number)(),
    release_date: (0, $TGurO.string)().nullable()
});
const $29f137cfebde2626$export$6259f37857107b12 = {
    UNHANDLED: -1,
    PURCHASE: 1,
    PREMIUM_SUBSCRIPTION: 2,
    DEVELOPER_GIFT: 3,
    TEST_MODE_PURCHASE: 4,
    FREE_PURCHASE: 5,
    USER_GIFT: 6,
    PREMIUM_PURCHASE: 7
};
const $29f137cfebde2626$export$7b20d168ba04011b = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    sku_id: (0, $TGurO.string)(),
    application_id: (0, $TGurO.string)(),
    user_id: (0, $TGurO.string)(),
    gift_code_flags: (0, $TGurO.number)(),
    type: (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$6259f37857107b12),
    gifter_user_id: (0, $TGurO.string)().optional().nullable(),
    branches: (0, $TGurO.array)((0, $TGurO.string)()).optional().nullable(),
    starts_at: (0, $TGurO.string)().optional().nullable(),
    ends_at: (0, $TGurO.string)().optional().nullable(),
    parent_id: (0, $TGurO.string)().optional().nullable(),
    consumed: (0, $TGurO.boolean)().optional().nullable(),
    deleted: (0, $TGurO.boolean)().optional().nullable(),
    gift_code_batch_id: (0, $TGurO.string)().optional().nullable()
});
const $29f137cfebde2626$export$7e8bb741497f2d3 = {
    UNHANDLED: -1,
    UNLOCKED: 1,
    PORTRAIT: 2,
    LANDSCAPE: 3
};
const $29f137cfebde2626$export$76765004a89b60c4 = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$7e8bb741497f2d3);
const $29f137cfebde2626$export$6b5ef5fbc271f145 = {
    UNHANDLED: -1,
    NOMINAL: 0,
    FAIR: 1,
    SERIOUS: 2,
    CRITICAL: 3
};
const $29f137cfebde2626$export$8065eea9d621a18 = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$6b5ef5fbc271f145);
const $29f137cfebde2626$export$6998f50a089a6f29 = {
    UNHANDLED: -1,
    PORTRAIT: 0,
    LANDSCAPE: 1
};
const $29f137cfebde2626$export$df54d73aa0ec5e82 = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$6998f50a089a6f29);
const $29f137cfebde2626$export$94c8fa8df0efcb28 = {
    UNHANDLED: -1,
    FOCUSED: 0,
    PIP: 1,
    GRID: 2
};
const $29f137cfebde2626$export$8f9fafd62f4ed4cc = (0, $4pOtY.zodCoerceUnhandledValue)($29f137cfebde2626$export$94c8fa8df0efcb28);

});
parcelRegister("4pOtY", function(module, exports) {

$parcel$export(module.exports, "zodCoerceUnhandledValue", function () { return $b276ec6c371f92c5$export$5989705faed03747; });
$parcel$export(module.exports, "fallbackToDefault", function () { return $b276ec6c371f92c5$export$b70693e61e1d03ea; });

var $TGurO = parcelRequire("TGurO");
/**
 * This is a helper function which coerces an unsupported arg value to the key/value UNHANDLED: -1
 * This is necessary to handle a scenario where a new enum value is added in the Discord Client,
 * so that the sdk will not throw an error when given a (newly) valid enum value.
 *
 * To remove the requirement for consumers of this sdk to import an enum when parsing data,
 * we instead use an object cast as const (readonly). This maintains parity with the previous
 * schema (which used zod.enum), and behaves more like a union type, i.e. 'foo' | 'bar' | -1
 *
 * @param inputObject This object must include the key/value pair UNHANDLED = -1
 */ function $b276ec6c371f92c5$export$5989705faed03747(inputObject) {
    return (0, $TGurO.preprocess)((arg)=>{
        var _a;
        const [objectKey] = (_a = Object.entries(inputObject).find(([, value])=>value === arg)) !== null && _a !== void 0 ? _a : [];
        if (arg != null && objectKey === undefined) return inputObject.UNHANDLED;
        return arg;
    }, (0, $TGurO.string)().or((0, $TGurO.number)()));
}
/**
 * Fallback to the default zod value if parsing fails.
 */ function $b276ec6c371f92c5$export$b70693e61e1d03ea(schema) {
    const transform = (0, $TGurO.custom)().transform((data)=>{
        const res = schema.safeParse(data);
        if (res.success) return res.data;
        return schema._def.defaultValue();
    });
    // Must set this inner schema so inspection works correctly
    transform.overlayType = schema;
    // transform._def.schema = schema;
    return transform;
}

});

parcelRegister("ghr9G", function(module, exports) {

$parcel$export(module.exports, "AuthenticateResponseSchema", function () { return $2ce8fea6e420a7bd$export$abba1635e36ab43f; });
$parcel$export(module.exports, "GetActivityInstanceConnectedParticipantsResponseSchema", function () { return $2ce8fea6e420a7bd$export$55c4c3c25fd5c28e; });
$parcel$export(module.exports, "GetRelationshipsResponseSchema", function () { return $2ce8fea6e420a7bd$export$cf3ad725da54e6ab; });
$parcel$export(module.exports, "Command", function () { return $2ce8fea6e420a7bd$export$cc7e12c76513e857; });
$parcel$export(module.exports, "Schemas", function () { return $2ce8fea6e420a7bd$export$e49b768f28ad1b60; });

var $TGurO = parcelRequire("TGurO");

var $4pOtY = parcelRequire("4pOtY");
/**
 * This file is generated.
 * Run "npm run sync" to regenerate file.
 * @generated
 */ // INITIATE_IMAGE_UPLOAD
const $2ce8fea6e420a7bd$export$599108c66632c238 = (0, $TGurO.default).object({
    image_url: (0, $TGurO.default).string()
}).describe('Response for "INITIATE_IMAGE_UPLOAD" Command');
// OPEN_SHARE_MOMENT_DIALOG
const $2ce8fea6e420a7bd$export$b7048850f4d41d23 = (0, $TGurO.default).object({
    mediaUrl: (0, $TGurO.default).string().max(1024)
}).describe('Request for "OPEN_SHARE_MOMENT_DIALOG" Command');
// AUTHENTICATE
const $2ce8fea6e420a7bd$export$21449d5881a7a118 = (0, $TGurO.default).object({
    access_token: (0, $TGurO.default).union([
        (0, $TGurO.default).string(),
        (0, $TGurO.default).null()
    ]).optional()
}).describe('Request for "AUTHENTICATE" Command');
const $2ce8fea6e420a7bd$export$abba1635e36ab43f = (0, $TGurO.default).object({
    access_token: (0, $TGurO.default).string(),
    user: (0, $TGurO.default).object({
        username: (0, $TGurO.default).string(),
        discriminator: (0, $TGurO.default).string(),
        id: (0, $TGurO.default).string(),
        avatar: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        public_flags: (0, $TGurO.default).number(),
        global_name: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional()
    }),
    scopes: (0, $TGurO.default).array((0, $4pOtY.fallbackToDefault)((0, $TGurO.default).enum([
        "identify",
        "email",
        "connections",
        "guilds",
        "guilds.join",
        "guilds.members.read",
        "guilds.channels.read",
        "gdm.join",
        "bot",
        "rpc",
        "rpc.notifications.read",
        "rpc.voice.read",
        "rpc.voice.write",
        "rpc.video.read",
        "rpc.video.write",
        "rpc.screenshare.read",
        "rpc.screenshare.write",
        "rpc.activities.write",
        "webhook.incoming",
        "messages.read",
        "applications.builds.upload",
        "applications.builds.read",
        "applications.commands",
        "applications.commands.permissions.update",
        "applications.commands.update",
        "applications.store.update",
        "applications.entitlements",
        "activities.read",
        "activities.write",
        "activities.invites.write",
        "relationships.read",
        "relationships.write",
        "voice",
        "dm_channels.read",
        "role_connections.write",
        "presences.read",
        "presences.write",
        "openid",
        "dm_channels.messages.read",
        "dm_channels.messages.write",
        "gateway.connect",
        "account.global_name.update",
        "payment_sources.country_code",
        "sdk.social_layer_presence",
        "sdk.social_layer",
        "lobbies.write",
        "application_identities.write"
    ]).or((0, $TGurO.default).literal(-1)).default(-1))),
    expires: (0, $TGurO.default).string(),
    application: (0, $TGurO.default).object({
        description: (0, $TGurO.default).string(),
        icon: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        id: (0, $TGurO.default).string(),
        rpc_origins: (0, $TGurO.default).array((0, $TGurO.default).string()).optional(),
        name: (0, $TGurO.default).string()
    })
}).describe('Response for "AUTHENTICATE" Command');
// GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS
const $2ce8fea6e420a7bd$export$55c4c3c25fd5c28e = (0, $TGurO.default).object({
    participants: (0, $TGurO.default).array((0, $TGurO.default).object({
        id: (0, $TGurO.default).string(),
        username: (0, $TGurO.default).string(),
        global_name: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        discriminator: (0, $TGurO.default).string(),
        avatar: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        flags: (0, $TGurO.default).number(),
        bot: (0, $TGurO.default).boolean(),
        avatar_decoration_data: (0, $TGurO.default).union([
            (0, $TGurO.default).object({
                asset: (0, $TGurO.default).string(),
                skuId: (0, $TGurO.default).string().optional(),
                expiresAt: (0, $TGurO.default).number().optional()
            }),
            (0, $TGurO.default).null()
        ]).optional(),
        premium_type: (0, $TGurO.default).union([
            (0, $TGurO.default).number(),
            (0, $TGurO.default).null()
        ]).optional(),
        nickname: (0, $TGurO.default).string().optional()
    }))
}).describe('Response for "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS" Command');
// SHARE_INTERACTION
const $2ce8fea6e420a7bd$export$34bdde5b85891d77 = (0, $TGurO.default).object({
    command: (0, $TGurO.default).string(),
    options: (0, $TGurO.default).array((0, $TGurO.default).object({
        name: (0, $TGurO.default).string(),
        value: (0, $TGurO.default).string()
    })).optional(),
    content: (0, $TGurO.default).string().max(2000).optional(),
    require_launch_channel: (0, $TGurO.default).boolean().optional(),
    preview_image: (0, $TGurO.default).object({
        height: (0, $TGurO.default).number(),
        url: (0, $TGurO.default).string(),
        width: (0, $TGurO.default).number()
    }).optional(),
    components: (0, $TGurO.default).array((0, $TGurO.default).object({
        type: (0, $TGurO.default).literal(1),
        components: (0, $TGurO.default).array((0, $TGurO.default).object({
            type: (0, $TGurO.default).literal(2),
            style: (0, $TGurO.default).number().gte(1).lte(5),
            label: (0, $TGurO.default).string().max(80).optional(),
            custom_id: (0, $TGurO.default).string().max(100).describe("Developer-defined identifier for the button; max 100 characters").optional()
        })).max(5).optional()
    })).optional(),
    pid: (0, $TGurO.default).number().optional()
}).describe('Request for "SHARE_INTERACTION" Command');
const $2ce8fea6e420a7bd$export$81e529541e4eaa5a = (0, $TGurO.default).object({
    success: (0, $TGurO.default).boolean()
}).describe('Response for "SHARE_INTERACTION" Command');
// SHARE_LINK
const $2ce8fea6e420a7bd$export$3c9e2aaf9c667aad = (0, $TGurO.default).object({
    custom_id: (0, $TGurO.default).string().max(64).optional(),
    message: (0, $TGurO.default).string().max(1000),
    link_id: (0, $TGurO.default).string().max(64).optional()
}).describe('Request for "SHARE_LINK" Command');
const $2ce8fea6e420a7bd$export$8b31f86466a5b2c7 = (0, $TGurO.default).object({
    success: (0, $TGurO.default).boolean(),
    didCopyLink: (0, $TGurO.default).boolean(),
    didSendMessage: (0, $TGurO.default).boolean()
}).describe('Response for "SHARE_LINK" Command');
// GET_RELATIONSHIPS
const $2ce8fea6e420a7bd$export$cf3ad725da54e6ab = (0, $TGurO.default).object({
    relationships: (0, $TGurO.default).array((0, $TGurO.default).object({
        type: (0, $TGurO.default).number(),
        user: (0, $TGurO.default).object({
            id: (0, $TGurO.default).string(),
            username: (0, $TGurO.default).string(),
            global_name: (0, $TGurO.default).union([
                (0, $TGurO.default).string(),
                (0, $TGurO.default).null()
            ]).optional(),
            discriminator: (0, $TGurO.default).string(),
            avatar: (0, $TGurO.default).union([
                (0, $TGurO.default).string(),
                (0, $TGurO.default).null()
            ]).optional(),
            flags: (0, $TGurO.default).number(),
            bot: (0, $TGurO.default).boolean(),
            avatar_decoration_data: (0, $TGurO.default).union([
                (0, $TGurO.default).object({
                    asset: (0, $TGurO.default).string(),
                    skuId: (0, $TGurO.default).string().optional(),
                    expiresAt: (0, $TGurO.default).number().optional()
                }),
                (0, $TGurO.default).null()
            ]).optional(),
            premium_type: (0, $TGurO.default).union([
                (0, $TGurO.default).number(),
                (0, $TGurO.default).null()
            ]).optional()
        }),
        presence: (0, $TGurO.default).object({
            status: (0, $TGurO.default).string(),
            activity: (0, $TGurO.default).union([
                (0, $TGurO.default).object({
                    session_id: (0, $TGurO.default).string().optional(),
                    type: (0, $TGurO.default).number().optional(),
                    name: (0, $TGurO.default).string(),
                    url: (0, $TGurO.default).union([
                        (0, $TGurO.default).string(),
                        (0, $TGurO.default).null()
                    ]).optional(),
                    application_id: (0, $TGurO.default).string().optional(),
                    status_display_type: (0, $TGurO.default).number().optional(),
                    state: (0, $TGurO.default).string().optional(),
                    state_url: (0, $TGurO.default).string().optional(),
                    details: (0, $TGurO.default).string().optional(),
                    details_url: (0, $TGurO.default).string().optional(),
                    emoji: (0, $TGurO.default).union([
                        (0, $TGurO.default).object({
                            name: (0, $TGurO.default).string(),
                            id: (0, $TGurO.default).union([
                                (0, $TGurO.default).string(),
                                (0, $TGurO.default).null()
                            ]).optional(),
                            animated: (0, $TGurO.default).union([
                                (0, $TGurO.default).boolean(),
                                (0, $TGurO.default).null()
                            ]).optional()
                        }),
                        (0, $TGurO.default).null()
                    ]).optional(),
                    assets: (0, $TGurO.default).object({
                        large_image: (0, $TGurO.default).string().optional(),
                        large_text: (0, $TGurO.default).string().optional(),
                        large_url: (0, $TGurO.default).string().optional(),
                        small_image: (0, $TGurO.default).string().optional(),
                        small_text: (0, $TGurO.default).string().optional(),
                        small_url: (0, $TGurO.default).string().optional()
                    }).optional(),
                    timestamps: (0, $TGurO.default).object({
                        start: (0, $TGurO.default).number().optional(),
                        end: (0, $TGurO.default).number().optional()
                    }).optional(),
                    party: (0, $TGurO.default).object({
                        id: (0, $TGurO.default).string().optional(),
                        size: (0, $TGurO.default).array((0, $TGurO.default).number()).min(2).max(2).optional(),
                        privacy: (0, $TGurO.default).number().optional()
                    }).optional(),
                    secrets: (0, $TGurO.default).object({
                        match: (0, $TGurO.default).string().optional(),
                        join: (0, $TGurO.default).string().optional()
                    }).optional(),
                    sync_id: (0, $TGurO.default).string().optional(),
                    created_at: (0, $TGurO.default).number().optional(),
                    instance: (0, $TGurO.default).boolean().optional(),
                    flags: (0, $TGurO.default).number().optional(),
                    metadata: (0, $TGurO.default).object({}).optional(),
                    platform: (0, $TGurO.default).string().optional(),
                    supported_platforms: (0, $TGurO.default).array((0, $TGurO.default).string()).optional(),
                    buttons: (0, $TGurO.default).array((0, $TGurO.default).string()).optional(),
                    hangStatus: (0, $TGurO.default).string().optional()
                }),
                (0, $TGurO.default).null()
            ]).optional()
        }).optional()
    }))
}).describe('Response for "GET_RELATIONSHIPS" Command');
// INVITE_USER_EMBEDDED
const $2ce8fea6e420a7bd$export$b4435c365c69d3f9 = (0, $TGurO.default).object({
    user_id: (0, $TGurO.default).string(),
    content: (0, $TGurO.default).string().min(0).max(1024).optional()
}).describe('Request for "INVITE_USER_EMBEDDED" Command');
// GET_USER
const $2ce8fea6e420a7bd$export$af08b40b856b65e9 = (0, $TGurO.default).object({
    id: (0, $TGurO.default).string().max(64)
}).describe('Request for "GET_USER" Command');
const $2ce8fea6e420a7bd$export$efae7d0364e4f628 = (0, $TGurO.default).union([
    (0, $TGurO.default).object({
        id: (0, $TGurO.default).string(),
        username: (0, $TGurO.default).string(),
        global_name: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        discriminator: (0, $TGurO.default).string(),
        avatar: (0, $TGurO.default).union([
            (0, $TGurO.default).string(),
            (0, $TGurO.default).null()
        ]).optional(),
        flags: (0, $TGurO.default).number(),
        bot: (0, $TGurO.default).boolean(),
        avatar_decoration_data: (0, $TGurO.default).union([
            (0, $TGurO.default).object({
                asset: (0, $TGurO.default).string(),
                skuId: (0, $TGurO.default).string().optional(),
                expiresAt: (0, $TGurO.default).number().optional()
            }),
            (0, $TGurO.default).null()
        ]).optional(),
        premium_type: (0, $TGurO.default).union([
            (0, $TGurO.default).number(),
            (0, $TGurO.default).null()
        ]).optional()
    }),
    (0, $TGurO.default).null()
]);
// GET_QUEST_ENROLLMENT_STATUS
const $2ce8fea6e420a7bd$export$1576667503dc7922 = (0, $TGurO.default).object({
    quest_id: (0, $TGurO.default).string()
}).describe('Request for "GET_QUEST_ENROLLMENT_STATUS" Command');
const $2ce8fea6e420a7bd$export$d0f6ddcb78f2b9e6 = (0, $TGurO.default).object({
    quest_id: (0, $TGurO.default).string(),
    is_enrolled: (0, $TGurO.default).boolean(),
    enrolled_at: (0, $TGurO.default).union([
        (0, $TGurO.default).string(),
        (0, $TGurO.default).null()
    ]).optional()
}).describe('Response for "GET_QUEST_ENROLLMENT_STATUS" Command');
// QUEST_START_TIMER
const $2ce8fea6e420a7bd$export$781354905a4676b4 = (0, $TGurO.default).object({
    quest_id: (0, $TGurO.default).string()
}).describe('Request for "QUEST_START_TIMER" Command');
const $2ce8fea6e420a7bd$export$b20fb8e5626c7518 = (0, $TGurO.default).object({
    success: (0, $TGurO.default).boolean()
}).describe('Response for "QUEST_START_TIMER" Command');
/**
 * RPC Commands which support schemas.
 */ var $2ce8fea6e420a7bd$export$cc7e12c76513e857;
(function(Command) {
    Command["INITIATE_IMAGE_UPLOAD"] = "INITIATE_IMAGE_UPLOAD";
    Command["OPEN_SHARE_MOMENT_DIALOG"] = "OPEN_SHARE_MOMENT_DIALOG";
    Command["AUTHENTICATE"] = "AUTHENTICATE";
    Command["GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS"] = "GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS";
    Command["SHARE_INTERACTION"] = "SHARE_INTERACTION";
    Command["SHARE_LINK"] = "SHARE_LINK";
    Command["GET_RELATIONSHIPS"] = "GET_RELATIONSHIPS";
    Command["INVITE_USER_EMBEDDED"] = "INVITE_USER_EMBEDDED";
    Command["GET_USER"] = "GET_USER";
    Command["GET_QUEST_ENROLLMENT_STATUS"] = "GET_QUEST_ENROLLMENT_STATUS";
    Command["QUEST_START_TIMER"] = "QUEST_START_TIMER";
})($2ce8fea6e420a7bd$export$cc7e12c76513e857 || ($2ce8fea6e420a7bd$export$cc7e12c76513e857 = {}));
const $2ce8fea6e420a7bd$var$emptyResponseSchema = (0, $TGurO.default).object({}).optional().nullable();
const $2ce8fea6e420a7bd$var$emptyRequestSchema = (0, $TGurO.default).void();
/**
 * Request & Response schemas for each supported RPC Command.
 */ const $2ce8fea6e420a7bd$export$e49b768f28ad1b60 = {
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.INITIATE_IMAGE_UPLOAD]: {
        request: $2ce8fea6e420a7bd$var$emptyRequestSchema,
        response: $2ce8fea6e420a7bd$export$599108c66632c238
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.OPEN_SHARE_MOMENT_DIALOG]: {
        request: $2ce8fea6e420a7bd$export$b7048850f4d41d23,
        response: $2ce8fea6e420a7bd$var$emptyResponseSchema
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.AUTHENTICATE]: {
        request: $2ce8fea6e420a7bd$export$21449d5881a7a118,
        response: $2ce8fea6e420a7bd$export$abba1635e36ab43f
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS]: {
        request: $2ce8fea6e420a7bd$var$emptyRequestSchema,
        response: $2ce8fea6e420a7bd$export$55c4c3c25fd5c28e
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.SHARE_INTERACTION]: {
        request: $2ce8fea6e420a7bd$export$34bdde5b85891d77,
        response: $2ce8fea6e420a7bd$export$81e529541e4eaa5a
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.SHARE_LINK]: {
        request: $2ce8fea6e420a7bd$export$3c9e2aaf9c667aad,
        response: $2ce8fea6e420a7bd$export$8b31f86466a5b2c7
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.GET_RELATIONSHIPS]: {
        request: $2ce8fea6e420a7bd$var$emptyRequestSchema,
        response: $2ce8fea6e420a7bd$export$cf3ad725da54e6ab
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.INVITE_USER_EMBEDDED]: {
        request: $2ce8fea6e420a7bd$export$b4435c365c69d3f9,
        response: $2ce8fea6e420a7bd$var$emptyResponseSchema
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.GET_USER]: {
        request: $2ce8fea6e420a7bd$export$af08b40b856b65e9,
        response: $2ce8fea6e420a7bd$export$efae7d0364e4f628
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.GET_QUEST_ENROLLMENT_STATUS]: {
        request: $2ce8fea6e420a7bd$export$1576667503dc7922,
        response: $2ce8fea6e420a7bd$export$d0f6ddcb78f2b9e6
    },
    [$2ce8fea6e420a7bd$export$cc7e12c76513e857.QUEST_START_TIMER]: {
        request: $2ce8fea6e420a7bd$export$781354905a4676b4,
        response: $2ce8fea6e420a7bd$export$b20fb8e5626c7518
    }
};

});



parcelRegister("f7w82", function(module, exports) {

$parcel$export(module.exports, "EmptyResponse", function () { return $090da343bbaa6977$export$2663ce359599a39a; });
$parcel$export(module.exports, "AuthorizeResponse", function () { return $090da343bbaa6977$export$a20dff0010f153a4; });
$parcel$export(module.exports, "GetChannelResponse", function () { return $090da343bbaa6977$export$116d844d40ad5f3c; });
$parcel$export(module.exports, "SetActivityResponse", function () { return $090da343bbaa6977$export$6441b328b684708a; });
$parcel$export(module.exports, "GetSkusResponse", function () { return $090da343bbaa6977$export$c5585ad29c8f7bd0; });
$parcel$export(module.exports, "GetEntitlementsResponse", function () { return $090da343bbaa6977$export$4232197b78e8b524; });
$parcel$export(module.exports, "StartPurchaseResponse", function () { return $090da343bbaa6977$export$17177c7243ab05e; });
$parcel$export(module.exports, "SetConfigResponse", function () { return $090da343bbaa6977$export$d92a181530f7d8d5; });
$parcel$export(module.exports, "UserSettingsGetLocaleResponse", function () { return $090da343bbaa6977$export$b462b396db5f92a0; });
$parcel$export(module.exports, "EncourageHardwareAccelerationResponse", function () { return $090da343bbaa6977$export$15549cbd10945eeb; });
$parcel$export(module.exports, "GetChannelPermissionsResponse", function () { return $090da343bbaa6977$export$67379dca9f34c2b9; });
$parcel$export(module.exports, "OpenExternalLinkResponse", function () { return $090da343bbaa6977$export$5e5d1b8668e0d4d5; });
$parcel$export(module.exports, "GetPlatformBehaviorsResponse", function () { return $090da343bbaa6977$export$ea78864ca3ab3f3c; });
$parcel$export(module.exports, "ResponseFrame", function () { return $090da343bbaa6977$export$8ffc8c4280411e44; });
$parcel$export(module.exports, "parseResponsePayload", function () { return $090da343bbaa6977$export$4890fc55aa463c4c; });

var $TGurO = parcelRequire("TGurO");

var $kq6d3 = parcelRequire("kq6d3");

var $4pOtY = parcelRequire("4pOtY");

var $ghr9G = parcelRequire("ghr9G");

var $fVfYm = parcelRequire("fVfYm");
const $090da343bbaa6977$export$2663ce359599a39a = (0, $TGurO.object)({}).nullable();
const $090da343bbaa6977$export$a20dff0010f153a4 = (0, $TGurO.object)({
    code: (0, $TGurO.string)()
});
const $090da343bbaa6977$export$c72c401de381626f = (0, $TGurO.object)({
    guilds: (0, $TGurO.array)((0, $TGurO.object)({
        id: (0, $TGurO.string)(),
        name: (0, $TGurO.string)()
    }))
});
const $090da343bbaa6977$export$5845be03a3ebb99a = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    name: (0, $TGurO.string)(),
    icon_url: (0, $TGurO.string)().optional(),
    members: (0, $TGurO.array)((0, $kq6d3.GuildMember))
});
const $090da343bbaa6977$export$116d844d40ad5f3c = (0, $TGurO.object)({
    id: (0, $TGurO.string)(),
    type: (0, $4pOtY.zodCoerceUnhandledValue)((0, $kq6d3.ChannelTypesObject)),
    guild_id: (0, $TGurO.string)().optional().nullable(),
    name: (0, $TGurO.string)().optional().nullable(),
    topic: (0, $TGurO.string)().optional().nullable(),
    bitrate: (0, $TGurO.number)().optional().nullable(),
    user_limit: (0, $TGurO.number)().optional().nullable(),
    position: (0, $TGurO.number)().optional().nullable(),
    voice_states: (0, $TGurO.array)((0, $kq6d3.UserVoiceState)),
    messages: (0, $TGurO.array)((0, $kq6d3.Message))
});
const $090da343bbaa6977$export$1f3b23c28c30c42c = (0, $TGurO.object)({
    channels: (0, $TGurO.array)((0, $kq6d3.Channel))
});
const $090da343bbaa6977$export$8ff9fe3ffde6290d = $090da343bbaa6977$export$116d844d40ad5f3c.nullable();
const $090da343bbaa6977$export$c74d4aa0f66fc05e = $090da343bbaa6977$export$116d844d40ad5f3c.nullable();
const $090da343bbaa6977$export$e114312640cd43d8 = $090da343bbaa6977$export$116d844d40ad5f3c.nullable();
const $090da343bbaa6977$export$f3dffed82766df8f = (0, $TGurO.object)({
    input: (0, $kq6d3.VoiceSettingsIO),
    output: (0, $kq6d3.VoiceSettingsIO),
    mode: (0, $kq6d3.VoiceSettingsMode),
    automatic_gain_control: (0, $TGurO.boolean)(),
    echo_cancellation: (0, $TGurO.boolean)(),
    noise_suppression: (0, $TGurO.boolean)(),
    qos: (0, $TGurO.boolean)(),
    silence_warning: (0, $TGurO.boolean)(),
    deaf: (0, $TGurO.boolean)(),
    mute: (0, $TGurO.boolean)()
});
const $090da343bbaa6977$export$89425a92d6d4fba3 = (0, $TGurO.object)({
    evt: (0, $TGurO.string)()
});
const $090da343bbaa6977$export$49ab8a39ea910965 = (0, $TGurO.object)({
    shortcut: (0, $kq6d3.ShortcutKey)
});
const $090da343bbaa6977$export$6441b328b684708a = (0, $kq6d3.Activity);
const $090da343bbaa6977$export$c5585ad29c8f7bd0 = (0, $TGurO.object)({
    skus: (0, $TGurO.array)((0, $kq6d3.Sku))
});
const $090da343bbaa6977$export$4232197b78e8b524 = (0, $TGurO.object)({
    entitlements: (0, $TGurO.array)((0, $kq6d3.Entitlement))
});
const $090da343bbaa6977$export$17177c7243ab05e = (0, $TGurO.array)((0, $kq6d3.Entitlement)).nullable();
const $090da343bbaa6977$export$d92a181530f7d8d5 = (0, $TGurO.object)({
    use_interactive_pip: (0, $TGurO.boolean)()
});
const $090da343bbaa6977$export$b462b396db5f92a0 = (0, $TGurO.object)({
    locale: (0, $TGurO.string)()
});
const $090da343bbaa6977$export$15549cbd10945eeb = (0, $TGurO.object)({
    enabled: (0, $TGurO.boolean)()
});
const $090da343bbaa6977$export$67379dca9f34c2b9 = (0, $TGurO.object)({
    permissions: (0, $TGurO.bigint)().or((0, $TGurO.string)())
});
const $090da343bbaa6977$export$5e5d1b8668e0d4d5 = (0, $4pOtY.fallbackToDefault)((0, $TGurO.object)({
    opened: (0, $TGurO.boolean)().or((0, $TGurO.null)())
}).default({
    opened: null
}));
/**
 * Because of the nature of Platform Behavior changes
 * every key/value is optional and may eventually be removed
 */ const $090da343bbaa6977$export$ea78864ca3ab3f3c = (0, $TGurO.object)({
    iosKeyboardResizesView: (0, $TGurO.optional)((0, $TGurO.boolean)())
});
const $090da343bbaa6977$export$8ffc8c4280411e44 = (0, $kq6d3.ReceiveFramePayload).extend({
    cmd: (0, $TGurO.nativeEnum)((0, $kq6d3.Commands)),
    evt: (0, $TGurO.null)()
});
function $090da343bbaa6977$var$parseResponseData({ cmd: cmd, data: data }) {
    switch(cmd){
        case (0, $kq6d3.Commands).AUTHORIZE:
            return $090da343bbaa6977$export$a20dff0010f153a4.parse(data);
        case (0, $kq6d3.Commands).CAPTURE_SHORTCUT:
            return $090da343bbaa6977$export$49ab8a39ea910965.parse(data);
        case (0, $kq6d3.Commands).ENCOURAGE_HW_ACCELERATION:
            return $090da343bbaa6977$export$15549cbd10945eeb.parse(data);
        case (0, $kq6d3.Commands).GET_CHANNEL:
            return $090da343bbaa6977$export$116d844d40ad5f3c.parse(data);
        case (0, $kq6d3.Commands).GET_CHANNELS:
            return $090da343bbaa6977$export$1f3b23c28c30c42c.parse(data);
        case (0, $kq6d3.Commands).GET_CHANNEL_PERMISSIONS:
            return $090da343bbaa6977$export$67379dca9f34c2b9.parse(data);
        case (0, $kq6d3.Commands).GET_GUILD:
            return $090da343bbaa6977$export$5845be03a3ebb99a.parse(data);
        case (0, $kq6d3.Commands).GET_GUILDS:
            return $090da343bbaa6977$export$c72c401de381626f.parse(data);
        case (0, $kq6d3.Commands).GET_PLATFORM_BEHAVIORS:
            return $090da343bbaa6977$export$ea78864ca3ab3f3c.parse(data);
        case (0, $kq6d3.Commands).GET_CHANNEL:
            return $090da343bbaa6977$export$116d844d40ad5f3c.parse(data);
        case (0, $kq6d3.Commands).SELECT_TEXT_CHANNEL:
            return $090da343bbaa6977$export$e114312640cd43d8.parse(data);
        case (0, $kq6d3.Commands).SELECT_VOICE_CHANNEL:
            return $090da343bbaa6977$export$c74d4aa0f66fc05e.parse(data);
        case (0, $kq6d3.Commands).SET_ACTIVITY:
            return $090da343bbaa6977$export$6441b328b684708a.parse(data);
        case (0, $kq6d3.Commands).GET_SKUS_EMBEDDED:
            return $090da343bbaa6977$export$c5585ad29c8f7bd0.parse(data);
        case (0, $kq6d3.Commands).GET_ENTITLEMENTS_EMBEDDED:
            return $090da343bbaa6977$export$4232197b78e8b524.parse(data);
        case (0, $kq6d3.Commands).SET_CONFIG:
            return $090da343bbaa6977$export$d92a181530f7d8d5.parse(data);
        case (0, $kq6d3.Commands).START_PURCHASE:
            return $090da343bbaa6977$export$17177c7243ab05e.parse(data);
        case (0, $kq6d3.Commands).SUBSCRIBE:
        case (0, $kq6d3.Commands).UNSUBSCRIBE:
            return $090da343bbaa6977$export$89425a92d6d4fba3.parse(data);
        case (0, $kq6d3.Commands).USER_SETTINGS_GET_LOCALE:
            return $090da343bbaa6977$export$b462b396db5f92a0.parse(data);
        case (0, $kq6d3.Commands).OPEN_EXTERNAL_LINK:
            return $090da343bbaa6977$export$5e5d1b8668e0d4d5.parse(data);
        // Empty Responses
        case (0, $kq6d3.Commands).SET_ORIENTATION_LOCK_STATE:
        case (0, $kq6d3.Commands).SET_CERTIFIED_DEVICES:
        case (0, $kq6d3.Commands).SEND_ANALYTICS_EVENT:
        case (0, $kq6d3.Commands).OPEN_INVITE_DIALOG:
        case (0, $kq6d3.Commands).CAPTURE_LOG:
        case (0, $kq6d3.Commands).GET_SKUS:
        case (0, $kq6d3.Commands).GET_ENTITLEMENTS:
            return $090da343bbaa6977$export$2663ce359599a39a.parse(data);
        // START-GENERATED-SECTION
        case (0, $kq6d3.Commands).AUTHENTICATE:
        case (0, $kq6d3.Commands).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS:
        case (0, $kq6d3.Commands).GET_QUEST_ENROLLMENT_STATUS:
        case (0, $kq6d3.Commands).GET_RELATIONSHIPS:
        case (0, $kq6d3.Commands).GET_USER:
        case (0, $kq6d3.Commands).INITIATE_IMAGE_UPLOAD:
        case (0, $kq6d3.Commands).INVITE_USER_EMBEDDED:
        case (0, $kq6d3.Commands).OPEN_SHARE_MOMENT_DIALOG:
        case (0, $kq6d3.Commands).QUEST_START_TIMER:
        case (0, $kq6d3.Commands).SHARE_INTERACTION:
        case (0, $kq6d3.Commands).SHARE_LINK:
            // END-GENERATED-SECTION
            const { response: response } = (0, $ghr9G.Schemas)[cmd];
            return response.parse(data);
        default:
            (0, $fVfYm.default)(cmd, new Error(`Unrecognized command ${cmd}`));
    }
}
function $090da343bbaa6977$export$4890fc55aa463c4c(payload) {
    return Object.assign(Object.assign({}, payload), {
        data: $090da343bbaa6977$var$parseResponseData(payload)
    });
}

});
parcelRegister("fVfYm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23e3d9b6c9bf3a30$export$2e2bcd8739ae039; });
/**
 * Assets x is statically unreachable at build-time,
 * and throws at runtime if data is dynamic.
 */ function $23e3d9b6c9bf3a30$export$2e2bcd8739ae039(_x, runtimeError) {
    throw runtimeError;
}

});



parcelRegister("6nXjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0445b1c6e378c64b$export$2e2bcd8739ae039; });

var $kq6d3 = parcelRequire("kq6d3");

var $5f8vK = parcelRequire("5f8vK");

var $fHbMU = parcelRequire("fHbMU");

var $598jQ = parcelRequire("598jQ");

var $3Eitz = parcelRequire("3Eitz");

var $17aCQ = parcelRequire("17aCQ");

var $hPjOU = parcelRequire("hPjOU");

var $byNiD = parcelRequire("byNiD");

var $7Lj8j = parcelRequire("7Lj8j");

var $a2Pny = parcelRequire("a2Pny");

var $4sr25 = parcelRequire("4sr25");

var $9QygQ = parcelRequire("9QygQ");

var $lB6Kr = parcelRequire("lB6Kr");

var $6LH3f = parcelRequire("6LH3f");

var $bjt74 = parcelRequire("bjt74");

var $gbyPG = parcelRequire("gbyPG");

var $cAy4B = parcelRequire("cAy4B");

var $ev46g = parcelRequire("ev46g");

var $0nB7t = parcelRequire("0nB7t");

var $dlQdX = parcelRequire("dlQdX");

var $aI0l0 = parcelRequire("aI0l0");

var $h5jYD = parcelRequire("h5jYD");

var $11OdO = parcelRequire("11OdO");

var $lo2PV = parcelRequire("lo2PV");

var $4JlxL = parcelRequire("4JlxL");

var $in7bf = parcelRequire("in7bf");

var $hNsVI = parcelRequire("hNsVI");
function $0445b1c6e378c64b$export$2e2bcd8739ae039(sendCommand) {
    return {
        authorize: (0, $5f8vK.authorize)(sendCommand),
        captureLog: (0, $fHbMU.captureLog)(sendCommand),
        encourageHardwareAcceleration: (0, $598jQ.encourageHardwareAcceleration)(sendCommand),
        getChannel: (0, $3Eitz.getChannel)(sendCommand),
        getChannelPermissions: (0, $byNiD.getChannelPermissions)(sendCommand),
        getEntitlements: (0, $17aCQ.getEntitlements)(sendCommand),
        getPlatformBehaviors: (0, $7Lj8j.getPlatformBehaviors)(sendCommand),
        getSkus: (0, $hPjOU.getSkus)(sendCommand),
        openExternalLink: (0, $a2Pny.openExternalLink)(sendCommand),
        openInviteDialog: (0, $4sr25.openInviteDialog)(sendCommand),
        setActivity: (0, $9QygQ.setActivity)(sendCommand),
        setConfig: (0, $lB6Kr.setConfig)(sendCommand),
        setOrientationLockState: (0, $6LH3f.setOrientationLockState)(sendCommand),
        startPurchase: (0, $bjt74.startPurchase)(sendCommand),
        userSettingsGetLocale: (0, $gbyPG.userSettingsGetLocale)(sendCommand),
        // Backward compatibility - getInstanceConnectedParticipants is an alias for getActivityInstanceConnectedParticipants
        getInstanceConnectedParticipants: (0, $ev46g.getActivityInstanceConnectedParticipants)(sendCommand),
        // START-GENERATED-SECTION
        authenticate: (0, $cAy4B.authenticate)(sendCommand),
        getActivityInstanceConnectedParticipants: (0, $ev46g.getActivityInstanceConnectedParticipants)(sendCommand),
        getQuestEnrollmentStatus: (0, $0nB7t.getQuestEnrollmentStatus)(sendCommand),
        getRelationships: (0, $dlQdX.getRelationships)(sendCommand),
        getUser: (0, $aI0l0.getUser)(sendCommand),
        initiateImageUpload: (0, $h5jYD.initiateImageUpload)(sendCommand),
        inviteUserEmbedded: (0, $11OdO.inviteUserEmbedded)(sendCommand),
        openShareMomentDialog: (0, $lo2PV.openShareMomentDialog)(sendCommand),
        questStartTimer: (0, $4JlxL.questStartTimer)(sendCommand),
        shareInteraction: (0, $in7bf.shareInteraction)(sendCommand),
        shareLink: (0, $hNsVI.shareLink)(sendCommand)
    };
}

});
parcelRegister("5f8vK", function(module, exports) {

$parcel$export(module.exports, "authorize", function () { return $ea3a375f9450f121$export$be1f35f80d3e29cc; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Should be called directly after a `ready` payload is received from the
 * Discord client. It includes a list of all scopes that your activity would
 * like to be authorized to use. If the user does not yet have a valid token
 * for all scopes requested, this command will open an OAuth modal. Once an
 * authorized token is available, it will be returned in the command response.
 */ const $ea3a375f9450f121$export$be1f35f80d3e29cc = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).AUTHORIZE, (0, $f7w82.AuthorizeResponse));

});
parcelRegister("1gLKr", function(module, exports) {

$parcel$export(module.exports, "commandFactory", function () { return $f3bb168b13d5327e$export$df09d935d625c3d3; });
$parcel$export(module.exports, "schemaCommandFactory", function () { return $f3bb168b13d5327e$export$3c2dac6e8a4c05f8; });

var $TGurO = parcelRequire("TGurO");

var $kq6d3 = parcelRequire("kq6d3");

var $ghr9G = parcelRequire("ghr9G");
function $f3bb168b13d5327e$export$df09d935d625c3d3(sendCommand, cmd, response, transferTransform = ()=>undefined) {
    const payload = (0, $kq6d3.ReceiveFramePayload).extend({
        cmd: (0, $TGurO.literal)(cmd),
        data: response
    });
    return async (args)=>{
        const reply = await sendCommand({
            cmd: cmd,
            args: args,
            transfer: transferTransform(args)
        });
        const parsed = payload.parse(reply);
        return parsed.data;
    };
}
function $f3bb168b13d5327e$export$3c2dac6e8a4c05f8(cmd, transferTransform = ()=>undefined) {
    const response = (0, $ghr9G.Schemas)[cmd].response;
    const payload = (0, $kq6d3.ReceiveFramePayload).extend({
        cmd: (0, $TGurO.literal)(cmd),
        data: response
    });
    return (sendCommand)=>async (args)=>{
            const reply = await sendCommand({
                // @ts-expect-error - Merge commands
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        };
}

});


parcelRegister("fHbMU", function(module, exports) {

$parcel$export(module.exports, "captureLog", function () { return $b5487c0710fbdd66$export$bd13a7db1bc707cf; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $b5487c0710fbdd66$export$bd13a7db1bc707cf = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).CAPTURE_LOG, (0, $f7w82.EmptyResponse));

});

parcelRegister("598jQ", function(module, exports) {

$parcel$export(module.exports, "encourageHardwareAcceleration", function () { return $6d063105a9c1b960$export$18896ba25f701706; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $6d063105a9c1b960$export$18896ba25f701706 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).ENCOURAGE_HW_ACCELERATION, (0, $f7w82.EncourageHardwareAccelerationResponse));

});

parcelRegister("3Eitz", function(module, exports) {

$parcel$export(module.exports, "getChannel", function () { return $4ba416f82e5a361f$export$98c37618398a9832; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#getchannel
 * Calling getChannel gets info about the requested channel such as the channel name.
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes:
 * - [guilds] for guild channels
 * - [guilds, dm_channels.read] for GDM channels. dm_channels.read requires approval from Discord.
 *
 * @example
 * await discordSdk.commands.getActivity({
 *   channel_id: discordSdk.channelId,
 * });
 */ const $4ba416f82e5a361f$export$98c37618398a9832 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).GET_CHANNEL, (0, $f7w82.GetChannelResponse));

});

parcelRegister("17aCQ", function(module, exports) {

$parcel$export(module.exports, "getEntitlements", function () { return $74abddde1d0223b0$export$6fb7719f7ba7d022; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $74abddde1d0223b0$export$6fb7719f7ba7d022 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).GET_ENTITLEMENTS_EMBEDDED, (0, $f7w82.GetEntitlementsResponse));

});

parcelRegister("hPjOU", function(module, exports) {

$parcel$export(module.exports, "getSkus", function () { return $c8d8fded61a52dfb$export$dcbcde0b5cdb27ed; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/*
 *
 */ const $c8d8fded61a52dfb$export$dcbcde0b5cdb27ed = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).GET_SKUS_EMBEDDED, (0, $f7w82.GetSkusResponse));

});

parcelRegister("byNiD", function(module, exports) {

$parcel$export(module.exports, "getChannelPermissions", function () { return $843327e991a3841d$export$e660ed046f465777; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Returns a bigint representing Permissions for the current user in the currently connected channel. Use PermissionsUtils to calculate if a user has a particular permission.
 * Always returns `0n` (no valid permissions) in a (G)DM context, so is unnecessary to call when discordSdk.guildId == null.
 */ const $843327e991a3841d$export$e660ed046f465777 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).GET_CHANNEL_PERMISSIONS, (0, $f7w82.GetChannelPermissionsResponse));

});

parcelRegister("7Lj8j", function(module, exports) {

$parcel$export(module.exports, "getPlatformBehaviors", function () { return $f3b0b0f6068efb5e$export$efbfaabbffdc43d1; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Returns an object with information about platform behaviors
 * This command can be utilized to inform and react to a breaking change in platform behavior
 *
 * @returns {GetPlatformBehaviorsPayload} payload - The command return value
 * @returns {boolean} payload.data.iosKeyboardResizesView - If on iOS the webview is resized when the keyboard is opened
 */ const $f3b0b0f6068efb5e$export$efbfaabbffdc43d1 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).GET_PLATFORM_BEHAVIORS, (0, $f7w82.GetPlatformBehaviorsResponse));

});

parcelRegister("a2Pny", function(module, exports) {

$parcel$export(module.exports, "openExternalLink", function () { return $b84ce05f31b3c752$export$ade3ab3891e57f44; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $b84ce05f31b3c752$export$ade3ab3891e57f44 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).OPEN_EXTERNAL_LINK, (0, $f7w82.OpenExternalLinkResponse));

});

parcelRegister("4sr25", function(module, exports) {

$parcel$export(module.exports, "openInviteDialog", function () { return $60a0d0b6c8555213$export$d02b38bee2b2489b; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Opens the invite dialog within the discord client, allowing users to share invite links to friends.
 * Does not work in (G)DM contexts (throws RPCError.INVALID_CHANNEL), so should not be called if discordSdk.guildId == null
 * Similarly, if the user does not have Permissions.CREATE_INSTANT_INVITE this command throws RPCErrors.INVALID_PERMISSIONS, so checking the user's permissions via getChannelPermissions is highly recommended.
 */ const $60a0d0b6c8555213$export$d02b38bee2b2489b = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).OPEN_INVITE_DIALOG, (0, $f7w82.EmptyResponse));

});

parcelRegister("9QygQ", function(module, exports) {

$parcel$export(module.exports, "setActivity", function () { return $881a7607582b1109$export$5e61ed4454e4dc1b; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
(0, $kq6d3.Activity).pick({
    state: true,
    state_url: true,
    details: true,
    details_url: true,
    timestamps: true,
    assets: true,
    party: true,
    secrets: true,
    instance: true,
    type: true
}).extend({
    type: (0, $kq6d3.Activity).shape.type.optional(),
    instance: (0, $kq6d3.Activity).shape.instance.optional()
}).nullable();
/**
 *
 * @description
 * RPC documentation here: https://discord.com/developers/docs/topics/rpc#setactivity
 * Calling setActivity allows modifying how your activity's rich presence is displayed in the Discord App
 *
 * Supported Platforms
 * | Web | iOS | Android |
 * |-----|-----|---------|
 * | ✅  | ✅  | ✅      |
 *
 * Required scopes: [rpc.activities.write]
 *
 * @example
 * await discordSdk.commands.setActivity({
 *   activity: {
 *     type: 0,
 *     details: 'Details',
 *     state: 'Playing',
 *   },
 * });
 */ const $881a7607582b1109$export$5e61ed4454e4dc1b = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).SET_ACTIVITY, (0, $f7w82.SetActivityResponse));

});

parcelRegister("lB6Kr", function(module, exports) {

$parcel$export(module.exports, "setConfig", function () { return $12fcf86276d6e418$export$940a7873bb071df8; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $12fcf86276d6e418$export$940a7873bb071df8 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).SET_CONFIG, (0, $f7w82.SetConfigResponse));

});

parcelRegister("6LH3f", function(module, exports) {

$parcel$export(module.exports, "setOrientationLockState", function () { return $e3485f3d8562e470$export$970bc058b4f43d8a; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $2oMrX = parcelRequire("2oMrX");
const $e3485f3d8562e470$var$fallbackTransform = (args)=>{
    return {
        lock_state: args.lock_state,
        picture_in_picture_lock_state: args.picture_in_picture_lock_state
    };
};
const $e3485f3d8562e470$export$970bc058b4f43d8a = (sendCommand)=>(0, $2oMrX.default)({
        sendCommand: sendCommand,
        cmd: (0, $kq6d3.Commands).SET_ORIENTATION_LOCK_STATE,
        response: (0, $f7w82.EmptyResponse),
        fallbackTransform: $e3485f3d8562e470$var$fallbackTransform
    });

});
parcelRegister("2oMrX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d777cc3c1a01bf$export$2e2bcd8739ae039; });

var $TGurO = parcelRequire("TGurO");

var $gROQ6 = parcelRequire("gROQ6");

var $kq6d3 = parcelRequire("kq6d3");
/**
 * @args - the primary args to send with the command.
 * @fallbackArgs - the args to try the command with in the case where an old Discord
 *  client doesn't support one of the new args.
 */ function $48d777cc3c1a01bf$export$2e2bcd8739ae039({ sendCommand: sendCommand, cmd: cmd, response: response, fallbackTransform: fallbackTransform, transferTransform: transferTransform = ()=>undefined }) {
    const payload = (0, $kq6d3.ReceiveFramePayload).extend({
        cmd: (0, $TGurO.literal)(cmd),
        data: response
    });
    return async (args)=>{
        try {
            const reply = await sendCommand({
                cmd: cmd,
                args: args,
                transfer: transferTransform(args)
            });
            const parsed = payload.parse(reply);
            return parsed.data;
        } catch (error) {
            if (error.code === (0, $gROQ6.RPCErrorCodes).INVALID_PAYLOAD) {
                const fallbackArgs = fallbackTransform(args);
                const reply = await sendCommand({
                    cmd: cmd,
                    args: fallbackArgs,
                    transfer: transferTransform(fallbackArgs)
                });
                const parsed = payload.parse(reply);
                return parsed.data;
            } else throw error;
        }
    };
}

});


parcelRegister("bjt74", function(module, exports) {

$parcel$export(module.exports, "startPurchase", function () { return $fa84df4f64f79be4$export$fb512c02b6232086; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $fa84df4f64f79be4$export$fb512c02b6232086 = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).START_PURCHASE, (0, $f7w82.StartPurchaseResponse));

});

parcelRegister("gbyPG", function(module, exports) {

$parcel$export(module.exports, "userSettingsGetLocale", function () { return $a4043b1ecb2ad145$export$8358d3ac583ae3cc; });

var $kq6d3 = parcelRequire("kq6d3");

var $f7w82 = parcelRequire("f7w82");

var $1gLKr = parcelRequire("1gLKr");
/**
 *
 */ const $a4043b1ecb2ad145$export$8358d3ac583ae3cc = (sendCommand)=>(0, $1gLKr.commandFactory)(sendCommand, (0, $kq6d3.Commands).USER_SETTINGS_GET_LOCALE, (0, $f7w82.UserSettingsGetLocaleResponse));

});

parcelRegister("cAy4B", function(module, exports) {

$parcel$export(module.exports, "authenticate", function () { return $cacd7ebeac887070$export$61bb00ddedae72e4; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Authenticate Activity
 */ const $cacd7ebeac887070$export$61bb00ddedae72e4 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).AUTHENTICATE);

});

parcelRegister("ev46g", function(module, exports) {

$parcel$export(module.exports, "getActivityInstanceConnectedParticipants", function () { return $1a282825ba754951$export$b446055c1c3a2811; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $1a282825ba754951$export$b446055c1c3a2811 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).GET_ACTIVITY_INSTANCE_CONNECTED_PARTICIPANTS);

});

parcelRegister("0nB7t", function(module, exports) {

$parcel$export(module.exports, "getQuestEnrollmentStatus", function () { return $0a8efd8edf1c9f24$export$12ffbf39da29c43e; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $0a8efd8edf1c9f24$export$12ffbf39da29c43e = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).GET_QUEST_ENROLLMENT_STATUS);

});

parcelRegister("dlQdX", function(module, exports) {

$parcel$export(module.exports, "getRelationships", function () { return $17596c62ea5bac5a$export$ece9beb28e4eb24; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $17596c62ea5bac5a$export$ece9beb28e4eb24 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).GET_RELATIONSHIPS);

});

parcelRegister("aI0l0", function(module, exports) {

$parcel$export(module.exports, "getUser", function () { return $cff858e546ea1a69$export$7cbf767827cd68ba; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $cff858e546ea1a69$export$7cbf767827cd68ba = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).GET_USER);

});

parcelRegister("h5jYD", function(module, exports) {

$parcel$export(module.exports, "initiateImageUpload", function () { return $2539cdd5bdf2419e$export$1870764d8cf96241; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Triggers the file upload flow in the Discord app. The user will be prompted to select a valid image file
 * and then it will be uploaded on the app side to the Discord CDN.
 *
 * NOTE: The URL provided by the API is an ephemeral attachment URL, so the image will not be permanently
 * accessible at the link provided.
 *
 * @returns {Promise<{image_url: string}>}
 */ const $2539cdd5bdf2419e$export$1870764d8cf96241 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).INITIATE_IMAGE_UPLOAD);

});

parcelRegister("11OdO", function(module, exports) {

$parcel$export(module.exports, "inviteUserEmbedded", function () { return $0e5c15163e84202c$export$6ebf76884107f3b0; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $0e5c15163e84202c$export$6ebf76884107f3b0 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).INVITE_USER_EMBEDDED);

});

parcelRegister("lo2PV", function(module, exports) {

$parcel$export(module.exports, "openShareMomentDialog", function () { return $f7782785e28d002c$export$de3eb37c8ceccf16; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Opens the Share Moment Dialog in the user's client, allowing them to share the media at mediaUrl as a message.
 *
 * @param {string} mediaUrl - a Discord CDN URL for the piece of media to be shared.
 * @returns {Promise<void>}
 */ const $f7782785e28d002c$export$de3eb37c8ceccf16 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).OPEN_SHARE_MOMENT_DIALOG);

});

parcelRegister("4JlxL", function(module, exports) {

$parcel$export(module.exports, "questStartTimer", function () { return $d9eb323b94a4062c$export$128e47a361e01b46; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $d9eb323b94a4062c$export$128e47a361e01b46 = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).QUEST_START_TIMER);

});

parcelRegister("in7bf", function(module, exports) {

$parcel$export(module.exports, "shareInteraction", function () { return $a78e055792dbda46$export$c69b0fe8e5e669dc; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
const $a78e055792dbda46$export$c69b0fe8e5e669dc = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).SHARE_INTERACTION);

});

parcelRegister("hNsVI", function(module, exports) {

$parcel$export(module.exports, "shareLink", function () { return $8a6ae097a9eae226$export$125499b12b97cddb; });

var $ghr9G = parcelRequire("ghr9G");

var $1gLKr = parcelRequire("1gLKr");
/**
 * Opens a modal in the user's client to share the Activity link.
 *
 * @param {string} referrer_id
 * @param {string} custom_id
 * @param {string} message - message sent alongside link when shared.
 * @returns {Promise<{success: boolean>} whether or not the user shared the link to someone
 */ const $8a6ae097a9eae226$export$125499b12b97cddb = (0, $1gLKr.schemaCommandFactory)((0, $ghr9G.Command).SHARE_LINK);

});


parcelRegister("fZxXb", function(module, exports) {

$parcel$export(module.exports, "SDKError", function () { return $3a59852b9e17e949$export$e1d52e4f0c7557a1; });
class $3a59852b9e17e949$export$e1d52e4f0c7557a1 extends Error {
    constructor(code, message = ""){
        super(message);
        this.code = code;
        this.message = message;
        this.name = "Discord SDK Error";
    }
}

});

parcelRegister("8jr1s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c39ac6e674a3e5a4$export$2e2bcd8739ae039; });
function $c39ac6e674a3e5a4$export$2e2bcd8739ae039() {
    return {
        disableConsoleLogOverride: false
    };
}

});

parcelRegister("4P8oU", function(module, exports) {

$parcel$export(module.exports, "consoleLevels", function () { return $29068aa158dba8f2$export$a3647e951d1937a9; });
$parcel$export(module.exports, "wrapConsoleMethod", function () { return $29068aa158dba8f2$export$46a03bf5755ffc4c; });
const $29068aa158dba8f2$export$a3647e951d1937a9 = [
    "log",
    "warn",
    "debug",
    "info",
    "error"
];
function $29068aa158dba8f2$export$46a03bf5755ffc4c(console, level, callback) {
    const _consoleMethod = console[level];
    const _console = console;
    if (!_consoleMethod) return;
    console[level] = function() {
        const args = [].slice.call(arguments);
        const message = "" + args.join(" ");
        callback(level, message);
        _consoleMethod.apply(_console, args);
    };
}

});

parcelRegister("16B0t", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $46de55ac7fa5ddfd$export$83d89fbfd8236492; });
var $46de55ac7fa5ddfd$export$83d89fbfd8236492 = "2.4.0";

});

parcelRegister("iMbuh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d24ec4eaa1055f75$export$2e2bcd8739ae039; });

var $4ciy1 = parcelRequire("4ciy1");

var $5OaUh = parcelRequire("5OaUh");

var $e60yx = parcelRequire("e60yx");
function $d24ec4eaa1055f75$export$2e2bcd8739ae039(options, buf, offset) {
    if ((0, $4ciy1.default).randomUUID && !buf && !options) return (0, $4ciy1.default).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $5OaUh.default)();
    if (rnds.length < 16) throw new Error("Random bytes length must be >= 16");
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    return (0, $e60yx.unsafeStringify)(rnds);
}

});
parcelRegister("4ciy1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d6837f680c2c80$export$2e2bcd8739ae039; });
const $27d6837f680c2c80$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $27d6837f680c2c80$export$2e2bcd8739ae039 = {
    randomUUID: $27d6837f680c2c80$var$randomUUID
};

});

parcelRegister("5OaUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca7e5c475fb999f$export$2e2bcd8739ae039; });
let $7ca7e5c475fb999f$var$getRandomValues;
const $7ca7e5c475fb999f$var$rnds8 = new Uint8Array(16);
function $7ca7e5c475fb999f$export$2e2bcd8739ae039() {
    if (!$7ca7e5c475fb999f$var$getRandomValues) {
        if (typeof crypto === "undefined" || !crypto.getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
        $7ca7e5c475fb999f$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $7ca7e5c475fb999f$var$getRandomValues($7ca7e5c475fb999f$var$rnds8);
}

});

parcelRegister("e60yx", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", function () { return $14a4e057f275a18e$export$8fb373d660548968; });
const $14a4e057f275a18e$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$14a4e057f275a18e$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $14a4e057f275a18e$export$8fb373d660548968(arr, offset = 0) {
    return ($14a4e057f275a18e$var$byteToHex[arr[offset + 0]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 1]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 2]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 3]] + "-" + $14a4e057f275a18e$var$byteToHex[arr[offset + 4]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 5]] + "-" + $14a4e057f275a18e$var$byteToHex[arr[offset + 6]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 7]] + "-" + $14a4e057f275a18e$var$byteToHex[arr[offset + 8]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 9]] + "-" + $14a4e057f275a18e$var$byteToHex[arr[offset + 10]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 11]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 12]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 13]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 14]] + $14a4e057f275a18e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}

});



parcelRegister("8hKTE", function(module, exports) {

var $o5U3A = parcelRequire("o5U3A");
function $7530d35e34df6928$var$can(permission, permissions) {
    return (0, $o5U3A.default).has((0, $o5U3A.default).deserialize(permissions), permission);
}
var $7530d35e34df6928$export$2e2bcd8739ae039 = {
    can: $7530d35e34df6928$var$can
};

});

parcelRegister("7dLbJ", function(module, exports) {

var $bTwln = parcelRequire("bTwln");

var $Vs2Xf = parcelRequire("Vs2Xf");
function $2d5796391f963aec$var$formatPrice(price, locale = "en-US") {
    const { amount: amount, currency: currency } = price;
    const formatter = Intl.NumberFormat(locale, {
        style: "currency",
        currency: currency
    });
    return formatter.format($2d5796391f963aec$var$convertToMajorCurrencyUnits(amount, currency));
}
function $2d5796391f963aec$var$convertToMajorCurrencyUnits(minorUnitValue, currency) {
    const exponent = (0, $Vs2Xf.CurrencyExponents)[currency];
    if (exponent == null) {
        console.warn(`Unexpected currency ${currency}`);
        return minorUnitValue;
    }
    const minorUnit = new (0, $bTwln.default)(minorUnitValue);
    return minorUnit.dividedBy(10 ** exponent).toNumber();
}
var $2d5796391f963aec$export$2e2bcd8739ae039 = {
    formatPrice: $2d5796391f963aec$var$formatPrice
};

});
parcelRegister("bTwln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57b20a38792d05b$export$2e2bcd8739ae039; });
/*
 *  decimal.js-light v2.5.1
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js-light
 *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Expat Licence
 */ // ------------------------------------  EDITABLE DEFAULTS  ------------------------------------- //
// The limit on the value of `precision`, and on the value of the first argument to
// `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
var $e57b20a38792d05b$var$MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
$e57b20a38792d05b$var$defaults = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // The natural logarithm of 10.
    // 115 digits
    LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, // ------------------------------------ END OF EDITABLE DEFAULTS -------------------------------- //
$e57b20a38792d05b$export$95c991896bef8714, $e57b20a38792d05b$var$external = true, $e57b20a38792d05b$var$decimalError = "[DecimalError] ", $e57b20a38792d05b$var$invalidArgument = $e57b20a38792d05b$var$decimalError + "Invalid argument: ", $e57b20a38792d05b$var$exponentOutOfRange = $e57b20a38792d05b$var$decimalError + "Exponent out of range: ", $e57b20a38792d05b$var$mathfloor = Math.floor, $e57b20a38792d05b$var$mathpow = Math.pow, $e57b20a38792d05b$var$isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $e57b20a38792d05b$var$ONE, $e57b20a38792d05b$var$BASE = 1e7, $e57b20a38792d05b$var$LOG_BASE = 7, $e57b20a38792d05b$var$MAX_SAFE_INTEGER = 9007199254740991, $e57b20a38792d05b$var$MAX_E = $e57b20a38792d05b$var$mathfloor($e57b20a38792d05b$var$MAX_SAFE_INTEGER / $e57b20a38792d05b$var$LOG_BASE), // Decimal.prototype object
$e57b20a38792d05b$var$P = {};
// Decimal prototype methods
/*
 *  absoluteValue                       abs
 *  comparedTo                          cmp
 *  decimalPlaces                       dp
 *  dividedBy                           div
 *  dividedToIntegerBy                  idiv
 *  equals                              eq
 *  exponent
 *  greaterThan                         gt
 *  greaterThanOrEqualTo                gte
 *  isInteger                           isint
 *  isNegative                          isneg
 *  isPositive                          ispos
 *  isZero
 *  lessThan                            lt
 *  lessThanOrEqualTo                   lte
 *  logarithm                           log
 *  minus                               sub
 *  modulo                              mod
 *  naturalExponential                  exp
 *  naturalLogarithm                    ln
 *  negated                             neg
 *  plus                                add
 *  precision                           sd
 *  squareRoot                          sqrt
 *  times                               mul
 *  toDecimalPlaces                     todp
 *  toExponential
 *  toFixed
 *  toInteger                           toint
 *  toNumber
 *  toPower                             pow
 *  toPrecision
 *  toSignificantDigits                 tosd
 *  toString
 *  valueOf                             val
 */ /*
 * Return a new Decimal whose value is the absolute value of this Decimal.
 *
 */ $e57b20a38792d05b$var$P.absoluteValue = $e57b20a38792d05b$var$P.abs = function() {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
};
/*
 * Return
 *   1    if the value of this Decimal is greater than the value of `y`,
 *  -1    if the value of this Decimal is less than the value of `y`,
 *   0    if they have the same value
 *
 */ $e57b20a38792d05b$var$P.comparedTo = $e57b20a38792d05b$var$P.cmp = function(y) {
    var i, j, xdL, ydL, x = this;
    y = new x.constructor(y);
    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;
    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
    xdL = x.d.length;
    ydL = y.d.length;
    // Compare digit by digit.
    for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
        if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }
    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
};
/*
 * Return the number of decimal places of the value of this Decimal.
 *
 */ $e57b20a38792d05b$var$P.decimalPlaces = $e57b20a38792d05b$var$P.dp = function() {
    var x = this, w = x.d.length - 1, dp = (w - x.e) * $e57b20a38792d05b$var$LOG_BASE;
    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for(; w % 10 == 0; w /= 10)dp--;
    return dp < 0 ? 0 : dp;
};
/*
 * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
 * `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.dividedBy = $e57b20a38792d05b$var$P.div = function(y) {
    return $e57b20a38792d05b$var$divide(this, new this.constructor(y));
};
/*
 * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
 * by the value of `y`, truncated to `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.dividedToIntegerBy = $e57b20a38792d05b$var$P.idiv = function(y) {
    var x = this, Ctor = x.constructor;
    return $e57b20a38792d05b$var$round($e57b20a38792d05b$var$divide(x, new Ctor(y), 0, 1), Ctor.precision);
};
/*
 * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.equals = $e57b20a38792d05b$var$P.eq = function(y) {
    return !this.cmp(y);
};
/*
 * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
 *
 */ $e57b20a38792d05b$var$P.exponent = function() {
    return $e57b20a38792d05b$var$getBase10Exponent(this);
};
/*
 * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
 * false.
 *
 */ $e57b20a38792d05b$var$P.greaterThan = $e57b20a38792d05b$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Decimal is greater than or equal to the value of `y`,
 * otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.greaterThanOrEqualTo = $e57b20a38792d05b$var$P.gte = function(y) {
    return this.cmp(y) >= 0;
};
/*
 * Return true if the value of this Decimal is an integer, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.isInteger = $e57b20a38792d05b$var$P.isint = function() {
    return this.e > this.d.length - 2;
};
/*
 * Return true if the value of this Decimal is negative, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.isNegative = $e57b20a38792d05b$var$P.isneg = function() {
    return this.s < 0;
};
/*
 * Return true if the value of this Decimal is positive, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.isPositive = $e57b20a38792d05b$var$P.ispos = function() {
    return this.s > 0;
};
/*
 * Return true if the value of this Decimal is 0, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.isZero = function() {
    return this.s === 0;
};
/*
 * Return true if the value of this Decimal is less than `y`, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.lessThan = $e57b20a38792d05b$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
 *
 */ $e57b20a38792d05b$var$P.lessThanOrEqualTo = $e57b20a38792d05b$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return the logarithm of the value of this Decimal to the specified base, truncated to
 * `precision` significant digits.
 *
 * If no base is specified, return log[10](x).
 *
 * log[base](x) = ln(x) / ln(base)
 *
 * The maximum error of the result is 1 ulp (unit in the last place).
 *
 * [base] {number|string|Decimal} The base of the logarithm.
 *
 */ $e57b20a38792d05b$var$P.logarithm = $e57b20a38792d05b$var$P.log = function(base) {
    var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
    // Default base is 10.
    if (base === void 0) base = new Ctor(10);
    else {
        base = new Ctor(base);
        // log[-b](x) = NaN
        // log[0](x)  = NaN
        // log[1](x)  = NaN
        if (base.s < 1 || base.eq($e57b20a38792d05b$var$ONE)) throw Error($e57b20a38792d05b$var$decimalError + "NaN");
    }
    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error($e57b20a38792d05b$var$decimalError + (x.s ? "NaN" : "-Infinity"));
    // log[b](1) = 0
    if (x.eq($e57b20a38792d05b$var$ONE)) return new Ctor(0);
    $e57b20a38792d05b$var$external = false;
    r = $e57b20a38792d05b$var$divide($e57b20a38792d05b$var$ln(x, wpr), $e57b20a38792d05b$var$ln(base, wpr), wpr);
    $e57b20a38792d05b$var$external = true;
    return $e57b20a38792d05b$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
 * `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.minus = $e57b20a38792d05b$var$P.sub = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $e57b20a38792d05b$var$subtract(x, y) : $e57b20a38792d05b$var$add(x, (y.s = -y.s, y));
};
/*
 * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
 * `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.modulo = $e57b20a38792d05b$var$P.mod = function(y) {
    var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
    y = new Ctor(y);
    // x % 0 = NaN
    if (!y.s) throw Error($e57b20a38792d05b$var$decimalError + "NaN");
    // Return x if x is 0.
    if (!x.s) return $e57b20a38792d05b$var$round(new Ctor(x), pr);
    // Prevent rounding of intermediate calculations.
    $e57b20a38792d05b$var$external = false;
    q = $e57b20a38792d05b$var$divide(x, y, 0, 1).times(y);
    $e57b20a38792d05b$var$external = true;
    return x.minus(q);
};
/*
 * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
 * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $e57b20a38792d05b$var$P.naturalExponential = $e57b20a38792d05b$var$P.exp = function() {
    return $e57b20a38792d05b$var$exp(this);
};
/*
 * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
 * truncated to `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.naturalLogarithm = $e57b20a38792d05b$var$P.ln = function() {
    return $e57b20a38792d05b$var$ln(this);
};
/*
 * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
 * -1.
 *
 */ $e57b20a38792d05b$var$P.negated = $e57b20a38792d05b$var$P.neg = function() {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
};
/*
 * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
 * `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.plus = $e57b20a38792d05b$var$P.add = function(y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? $e57b20a38792d05b$var$add(x, y) : $e57b20a38792d05b$var$subtract(x, (y.s = -y.s, y));
};
/*
 * Return the number of significant digits of the value of this Decimal.
 *
 * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
 *
 */ $e57b20a38792d05b$var$P.precision = $e57b20a38792d05b$var$P.sd = function(z) {
    var e, sd, w, x = this;
    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error($e57b20a38792d05b$var$invalidArgument + z);
    e = $e57b20a38792d05b$var$getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * $e57b20a38792d05b$var$LOG_BASE + 1;
    w = x.d[w];
    // If non-zero...
    if (w) {
        // Subtract the number of trailing zeros of the last word.
        for(; w % 10 == 0; w /= 10)sd--;
        // Add the number of digits of the first word.
        for(w = x.d[0]; w >= 10; w /= 10)sd++;
    }
    return z && e > sd ? e : sd;
};
/*
 * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
 * significant digits.
 *
 */ $e57b20a38792d05b$var$P.squareRoot = $e57b20a38792d05b$var$P.sqrt = function() {
    var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
    // Negative or zero?
    if (x.s < 1) {
        if (!x.s) return new Ctor(0);
        // sqrt(-x) = NaN
        throw Error($e57b20a38792d05b$var$decimalError + "NaN");
    }
    e = $e57b20a38792d05b$var$getBase10Exponent(x);
    $e57b20a38792d05b$var$external = false;
    // Initial estimate.
    s = Math.sqrt(+x);
    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
        n = $e57b20a38792d05b$var$digitsToString(x.d);
        if ((n.length + e) % 2 == 0) n += "0";
        s = Math.sqrt(n);
        e = $e57b20a38792d05b$var$mathfloor((e + 1) / 2) - (e < 0 || e % 2);
        if (s == 1 / 0) n = "5e" + e;
        else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf("e") + 1) + e;
        }
        r = new Ctor(n);
    } else r = new Ctor(s.toString());
    pr = Ctor.precision;
    s = wpr = pr + 3;
    // Newton-Raphson iteration.
    for(;;){
        t = r;
        r = t.plus($e57b20a38792d05b$var$divide(x, t, wpr + 2)).times(0.5);
        if ($e57b20a38792d05b$var$digitsToString(t.d).slice(0, wpr) === (n = $e57b20a38792d05b$var$digitsToString(r.d)).slice(0, wpr)) {
            n = n.slice(wpr - 3, wpr + 1);
            // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
            // 4999, i.e. approaching a rounding boundary, continue the iteration.
            if (s == wpr && n == "4999") {
                // On the first iteration only, check to see if rounding up gives the exact result as the
                // nines may infinitely repeat.
                $e57b20a38792d05b$var$round(t, pr + 1, 0);
                if (t.times(t).eq(x)) {
                    r = t;
                    break;
                }
            } else if (n != "9999") break;
            wpr += 4;
        }
    }
    $e57b20a38792d05b$var$external = true;
    return $e57b20a38792d05b$var$round(r, pr);
};
/*
 * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
 * `precision` significant digits.
 *
 */ $e57b20a38792d05b$var$P.times = $e57b20a38792d05b$var$P.mul = function(y) {
    var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);
    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;
    // Ensure xd points to the longer array.
    if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
    }
    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for(i = rL; i--;)r.push(0);
    // Multiply!
    for(i = ydL; --i >= 0;){
        carry = 0;
        for(k = xdL + i; k > i;){
            t = r[k] + yd[i] * xd[k - i - 1] + carry;
            r[k--] = t % $e57b20a38792d05b$var$BASE | 0;
            carry = t / $e57b20a38792d05b$var$BASE | 0;
        }
        r[k] = (r[k] + carry) % $e57b20a38792d05b$var$BASE | 0;
    }
    // Remove trailing zeros.
    for(; !r[--rL];)r.pop();
    if (carry) ++e;
    else r.shift();
    y.d = r;
    y.e = e;
    return $e57b20a38792d05b$var$external ? $e57b20a38792d05b$var$round(y, Ctor.precision) : y;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
 * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
 *
 * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $e57b20a38792d05b$var$P.toDecimalPlaces = $e57b20a38792d05b$var$P.todp = function(dp, rm) {
    var x = this, Ctor = x.constructor;
    x = new Ctor(x);
    if (dp === void 0) return x;
    $e57b20a38792d05b$var$checkInt32(dp, 0, $e57b20a38792d05b$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $e57b20a38792d05b$var$checkInt32(rm, 0, 8);
    return $e57b20a38792d05b$var$round(x, dp + $e57b20a38792d05b$var$getBase10Exponent(x) + 1, rm);
};
/*
 * Return a string representing the value of this Decimal in exponential notation rounded to
 * `dp` fixed decimal places using rounding mode `rounding`.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $e57b20a38792d05b$var$P.toExponential = function(dp, rm) {
    var str, x = this, Ctor = x.constructor;
    if (dp === void 0) str = $e57b20a38792d05b$var$toString(x, true);
    else {
        $e57b20a38792d05b$var$checkInt32(dp, 0, $e57b20a38792d05b$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $e57b20a38792d05b$var$checkInt32(rm, 0, 8);
        x = $e57b20a38792d05b$var$round(new Ctor(x), dp + 1, rm);
        str = $e57b20a38792d05b$var$toString(x, true, dp + 1);
    }
    return str;
};
/*
 * Return a string representing the value of this Decimal in normal (fixed-point) notation to
 * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
 * omitted.
 *
 * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
 *
 * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 * (-0).toFixed(3) is '0.000'.
 * (-0.5).toFixed(0) is '-0'.
 *
 */ $e57b20a38792d05b$var$P.toFixed = function(dp, rm) {
    var str, y, x = this, Ctor = x.constructor;
    if (dp === void 0) return $e57b20a38792d05b$var$toString(x);
    $e57b20a38792d05b$var$checkInt32(dp, 0, $e57b20a38792d05b$var$MAX_DIGITS);
    if (rm === void 0) rm = Ctor.rounding;
    else $e57b20a38792d05b$var$checkInt32(rm, 0, 8);
    y = $e57b20a38792d05b$var$round(new Ctor(x), dp + $e57b20a38792d05b$var$getBase10Exponent(x) + 1, rm);
    str = $e57b20a38792d05b$var$toString(y.abs(), false, dp + $e57b20a38792d05b$var$getBase10Exponent(y) + 1);
    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? "-" + str : str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
 * rounding mode `rounding`.
 *
 */ $e57b20a38792d05b$var$P.toInteger = $e57b20a38792d05b$var$P.toint = function() {
    var x = this, Ctor = x.constructor;
    return $e57b20a38792d05b$var$round(new Ctor(x), $e57b20a38792d05b$var$getBase10Exponent(x) + 1, Ctor.rounding);
};
/*
 * Return the value of this Decimal converted to a number primitive.
 *
 */ $e57b20a38792d05b$var$P.toNumber = function() {
    return +this;
};
/*
 * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
 * truncated to `precision` significant digits.
 *
 * For non-integer or very large exponents pow(x, y) is calculated using
 *
 *   x^y = exp(y*ln(x))
 *
 * The maximum error is 1 ulp (unit in last place).
 *
 * y {number|string|Decimal} The power to which to raise this Decimal.
 *
 */ $e57b20a38792d05b$var$P.toPower = $e57b20a38792d05b$var$P.pow = function(y) {
    var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
    // pow(x, 0) = 1
    if (!y.s) return new Ctor($e57b20a38792d05b$var$ONE);
    x = new Ctor(x);
    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
        if (y.s < 1) throw Error($e57b20a38792d05b$var$decimalError + "Infinity");
        return x;
    }
    // pow(1, y) = 1
    if (x.eq($e57b20a38792d05b$var$ONE)) return x;
    pr = Ctor.precision;
    // pow(x, 1) = x
    if (y.eq($e57b20a38792d05b$var$ONE)) return $e57b20a38792d05b$var$round(x, pr);
    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;
    if (!yIsInt) {
        // pow(x < 0, y non-integer) = NaN
        if (sign < 0) throw Error($e57b20a38792d05b$var$decimalError + "NaN");
    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= $e57b20a38792d05b$var$MAX_SAFE_INTEGER) {
        r = new Ctor($e57b20a38792d05b$var$ONE);
        // Max k of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        e = Math.ceil(pr / $e57b20a38792d05b$var$LOG_BASE + 4);
        $e57b20a38792d05b$var$external = false;
        for(;;){
            if (k % 2) {
                r = r.times(x);
                $e57b20a38792d05b$var$truncate(r.d, e);
            }
            k = $e57b20a38792d05b$var$mathfloor(k / 2);
            if (k === 0) break;
            x = x.times(x);
            $e57b20a38792d05b$var$truncate(x.d, e);
        }
        $e57b20a38792d05b$var$external = true;
        return y.s < 0 ? new Ctor($e57b20a38792d05b$var$ONE).div(r) : $e57b20a38792d05b$var$round(r, pr);
    }
    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
    x.s = 1;
    $e57b20a38792d05b$var$external = false;
    r = y.times($e57b20a38792d05b$var$ln(x, pr + guard));
    $e57b20a38792d05b$var$external = true;
    r = $e57b20a38792d05b$var$exp(r);
    r.s = sign;
    return r;
};
/*
 * Return a string representing the value of this Decimal rounded to `sd` significant digits
 * using rounding mode `rounding`.
 *
 * Return exponential notation if `sd` is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $e57b20a38792d05b$var$P.toPrecision = function(sd, rm) {
    var e, str, x = this, Ctor = x.constructor;
    if (sd === void 0) {
        e = $e57b20a38792d05b$var$getBase10Exponent(x);
        str = $e57b20a38792d05b$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
        $e57b20a38792d05b$var$checkInt32(sd, 1, $e57b20a38792d05b$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $e57b20a38792d05b$var$checkInt32(rm, 0, 8);
        x = $e57b20a38792d05b$var$round(new Ctor(x), sd, rm);
        e = $e57b20a38792d05b$var$getBase10Exponent(x);
        str = $e57b20a38792d05b$var$toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }
    return str;
};
/*
 * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
 * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
 * omitted.
 *
 * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
 * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
 *
 */ $e57b20a38792d05b$var$P.toSignificantDigits = $e57b20a38792d05b$var$P.tosd = function(sd, rm) {
    var x = this, Ctor = x.constructor;
    if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
    } else {
        $e57b20a38792d05b$var$checkInt32(sd, 1, $e57b20a38792d05b$var$MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else $e57b20a38792d05b$var$checkInt32(rm, 0, 8);
    }
    return $e57b20a38792d05b$var$round(new Ctor(x), sd, rm);
};
/*
 * Return a string representing the value of this Decimal.
 *
 * Return exponential notation if this Decimal has a positive exponent equal to or greater than
 * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
 *
 */ $e57b20a38792d05b$var$P.toString = $e57b20a38792d05b$var$P.valueOf = $e57b20a38792d05b$var$P.val = $e57b20a38792d05b$var$P.toJSON = $e57b20a38792d05b$var$P[Symbol.for("nodejs.util.inspect.custom")] = function() {
    var x = this, e = $e57b20a38792d05b$var$getBase10Exponent(x), Ctor = x.constructor;
    return $e57b20a38792d05b$var$toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
};
// Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
/*
 *  add                 P.minus, P.plus
 *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
 *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
 *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
 *  exp                 P.exp, P.pow
 *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
 *                      P.toString, divide, round, toString, exp, ln
 *  getLn10             P.log, ln
 *  getZeroString       digitsToString, toString
 *  ln                  P.log, P.ln, P.pow, exp
 *  parseDecimal        Decimal
 *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
 *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
 *                      divide, getLn10, exp, ln
 *  subtract            P.minus, P.plus
 *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
 *  truncate            P.pow
 *
 *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
 *                      getLn10, exp, ln, parseDecimal, Decimal, config
 */ function $e57b20a38792d05b$var$add(x, y) {
    var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
    // If either is zero...
    if (!x.s || !y.s) {
        // Return x if y is zero.
        // Return y if y is non-zero.
        if (!y.s) y = new Ctor(x);
        return $e57b20a38792d05b$var$external ? $e57b20a38792d05b$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are finite, non-zero numbers with the same sign.
    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;
    // If base 1e7 exponents differ...
    if (i) {
        if (i < 0) {
            d = xd;
            i = -i;
            len = yd.length;
        } else {
            d = yd;
            e = k;
            len = xd.length;
        }
        // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
        k = Math.ceil(pr / $e57b20a38792d05b$var$LOG_BASE);
        len = k > len ? k + 1 : len + 1;
        if (i > len) {
            i = len;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
        d.reverse();
        for(; i--;)d.push(0);
        d.reverse();
    }
    len = xd.length;
    i = yd.length;
    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
        i = len;
        d = yd;
        yd = xd;
        xd = d;
    }
    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for(carry = 0; i;){
        carry = (xd[--i] = xd[i] + yd[i] + carry) / $e57b20a38792d05b$var$BASE | 0;
        xd[i] %= $e57b20a38792d05b$var$BASE;
    }
    if (carry) {
        xd.unshift(carry);
        ++e;
    }
    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for(len = xd.length; xd[--len] == 0;)xd.pop();
    y.d = xd;
    y.e = e;
    return $e57b20a38792d05b$var$external ? $e57b20a38792d05b$var$round(y, pr) : y;
}
function $e57b20a38792d05b$var$checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) throw Error($e57b20a38792d05b$var$invalidArgument + i);
}
function $e57b20a38792d05b$var$digitsToString(d) {
    var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
    if (indexOfLastWord > 0) {
        str += w;
        for(i = 1; i < indexOfLastWord; i++){
            ws = d[i] + "";
            k = $e57b20a38792d05b$var$LOG_BASE - ws.length;
            if (k) str += $e57b20a38792d05b$var$getZeroString(k);
            str += ws;
        }
        w = d[i];
        ws = w + "";
        k = $e57b20a38792d05b$var$LOG_BASE - ws.length;
        if (k) str += $e57b20a38792d05b$var$getZeroString(k);
    } else if (w === 0) return "0";
    // Remove trailing zeros of last w.
    for(; w % 10 === 0;)w /= 10;
    return str + w;
}
var $e57b20a38792d05b$var$divide = function() {
    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
        var temp, carry = 0, i = x.length;
        for(x = x.slice(); i--;){
            temp = x[i] * k + carry;
            x[i] = temp % $e57b20a38792d05b$var$BASE | 0;
            carry = temp / $e57b20a38792d05b$var$BASE | 0;
        }
        if (carry) x.unshift(carry);
        return x;
    }
    function compare(a, b, aL, bL) {
        var i, r;
        if (aL != bL) r = aL > bL ? 1 : -1;
        else {
            for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                r = a[i] > b[i] ? 1 : -1;
                break;
            }
        }
        return r;
    }
    function subtract(a, b, aL) {
        var i = 0;
        // Subtract b from a.
        for(; aL--;){
            a[aL] -= i;
            i = a[aL] < b[aL] ? 1 : 0;
            a[aL] = i * $e57b20a38792d05b$var$BASE + a[aL] - b[aL];
        }
        // Remove leading zeros.
        for(; !a[0] && a.length > 1;)a.shift();
    }
    return function(x, y, pr, dp) {
        var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
        // Either 0?
        if (!x.s) return new Ctor(x);
        if (!y.s) throw Error($e57b20a38792d05b$var$decimalError + "Division by zero");
        e = x.e - y.e;
        yL = yd.length;
        xL = xd.length;
        q = new Ctor(sign);
        qd = q.d = [];
        // Result exponent may be one less than e.
        for(i = 0; yd[i] == (xd[i] || 0);)++i;
        if (yd[i] > (xd[i] || 0)) --e;
        if (pr == null) sd = pr = Ctor.precision;
        else if (dp) sd = pr + ($e57b20a38792d05b$var$getBase10Exponent(x) - $e57b20a38792d05b$var$getBase10Exponent(y)) + 1;
        else sd = pr;
        if (sd < 0) return new Ctor(0);
        // Convert precision in number of base 10 digits to base 1e7 digits.
        sd = sd / $e57b20a38792d05b$var$LOG_BASE + 2 | 0;
        i = 0;
        // divisor < 1e7
        if (yL == 1) {
            k = 0;
            yd = yd[0];
            sd++;
            // k is the carry.
            for(; (i < xL || k) && sd--; i++){
                t = k * $e57b20a38792d05b$var$BASE + (xd[i] || 0);
                qd[i] = t / yd | 0;
                k = t % yd | 0;
            }
        // divisor >= 1e7
        } else {
            // Normalise xd and yd so highest order digit of yd is >= BASE/2
            k = $e57b20a38792d05b$var$BASE / (yd[0] + 1) | 0;
            if (k > 1) {
                yd = multiplyInteger(yd, k);
                xd = multiplyInteger(xd, k);
                yL = yd.length;
                xL = xd.length;
            }
            xi = yL;
            rem = xd.slice(0, yL);
            remL = rem.length;
            // Add zeros to make remainder as long as divisor.
            for(; remL < yL;)rem[remL++] = 0;
            yz = yd.slice();
            yz.unshift(0);
            yd0 = yd[0];
            if (yd[1] >= $e57b20a38792d05b$var$BASE / 2) ++yd0;
            do {
                k = 0;
                // Compare divisor and remainder.
                cmp = compare(yd, rem, yL, remL);
                // If divisor < remainder.
                if (cmp < 0) {
                    // Calculate trial digit, k.
                    rem0 = rem[0];
                    if (yL != remL) rem0 = rem0 * $e57b20a38792d05b$var$BASE + (rem[1] || 0);
                    // k will be how many times the divisor goes into the current remainder.
                    k = rem0 / yd0 | 0;
                    //  Algorithm:
                    //  1. product = divisor * trial digit (k)
                    //  2. if product > remainder: product -= divisor, k--
                    //  3. remainder -= product
                    //  4. if product was < remainder at 2:
                    //    5. compare new remainder and divisor
                    //    6. If remainder > divisor: remainder -= divisor, k++
                    if (k > 1) {
                        if (k >= $e57b20a38792d05b$var$BASE) k = $e57b20a38792d05b$var$BASE - 1;
                        // product = divisor * trial digit.
                        prod = multiplyInteger(yd, k);
                        prodL = prod.length;
                        remL = rem.length;
                        // Compare product and remainder.
                        cmp = compare(prod, rem, prodL, remL);
                        // product > remainder.
                        if (cmp == 1) {
                            k--;
                            // Subtract divisor from product.
                            subtract(prod, yL < prodL ? yz : yd, prodL);
                        }
                    } else {
                        // cmp is -1.
                        // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                        // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                        if (k == 0) cmp = k = 1;
                        prod = yd.slice();
                    }
                    prodL = prod.length;
                    if (prodL < remL) prod.unshift(0);
                    // Subtract product from remainder.
                    subtract(rem, prod, remL);
                    // If product was < previous remainder.
                    if (cmp == -1) {
                        remL = rem.length;
                        // Compare divisor and new remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < new remainder, subtract divisor from remainder.
                        if (cmp < 1) {
                            k++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yd, remL);
                        }
                    }
                    remL = rem.length;
                } else if (cmp === 0) {
                    k++;
                    rem = [
                        0
                    ];
                } // if cmp === 1, k will be 0
                // Add the next digit, k, to the result array.
                qd[i++] = k;
                // Update the remainder.
                if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                else {
                    rem = [
                        xd[xi]
                    ];
                    remL = 1;
                }
            }while ((xi++ < xL || rem[0] !== void 0) && sd--);
        }
        // Leading zero?
        if (!qd[0]) qd.shift();
        q.e = e;
        return $e57b20a38792d05b$var$round(q, dp ? pr + $e57b20a38792d05b$var$getBase10Exponent(q) + 1 : pr);
    };
}();
/*
 * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
 * significant digits.
 *
 * Taylor/Maclaurin series.
 *
 * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
 *
 * Argument reduction:
 *   Repeat x = x / 32, k += 5, until |x| < 0.1
 *   exp(x) = exp(x / 2^k)^(2^k)
 *
 * Previously, the argument was initially reduced by
 * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
 * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
 * found to be slower than just dividing repeatedly by 32 as above.
 *
 * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
 *
 *  exp(x) is non-terminating for any finite, non-zero x.
 *
 */ function $e57b20a38792d05b$var$exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
    if ($e57b20a38792d05b$var$getBase10Exponent(x) > 16) throw Error($e57b20a38792d05b$var$exponentOutOfRange + $e57b20a38792d05b$var$getBase10Exponent(x));
    // exp(0) = 1
    if (!x.s) return new Ctor($e57b20a38792d05b$var$ONE);
    if (sd == null) {
        $e57b20a38792d05b$var$external = false;
        wpr = pr;
    } else wpr = sd;
    t = new Ctor(0.03125);
    while(x.abs().gte(0.1)){
        x = x.times(t); // x = x / 2^5
        k += 5;
    }
    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log($e57b20a38792d05b$var$mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor($e57b20a38792d05b$var$ONE);
    Ctor.precision = wpr;
    for(;;){
        pow = $e57b20a38792d05b$var$round(pow.times(x), wpr);
        denominator = denominator.times(++i);
        t = sum.plus($e57b20a38792d05b$var$divide(pow, denominator, wpr));
        if ($e57b20a38792d05b$var$digitsToString(t.d).slice(0, wpr) === $e57b20a38792d05b$var$digitsToString(sum.d).slice(0, wpr)) {
            while(k--)sum = $e57b20a38792d05b$var$round(sum.times(sum), wpr);
            Ctor.precision = pr;
            return sd == null ? ($e57b20a38792d05b$var$external = true, $e57b20a38792d05b$var$round(sum, pr)) : sum;
        }
        sum = t;
    }
}
// Calculate the base 10 exponent from the base 1e7 exponent.
function $e57b20a38792d05b$var$getBase10Exponent(x) {
    var e = x.e * $e57b20a38792d05b$var$LOG_BASE, w = x.d[0];
    // Add the number of digits of the first word of the digits array.
    for(; w >= 10; w /= 10)e++;
    return e;
}
function $e57b20a38792d05b$var$getLn10(Ctor, sd, pr) {
    if (sd > Ctor.LN10.sd()) {
        // Reset global state in case the exception is caught.
        $e57b20a38792d05b$var$external = true;
        if (pr) Ctor.precision = pr;
        throw Error($e57b20a38792d05b$var$decimalError + "LN10 precision limit exceeded");
    }
    return $e57b20a38792d05b$var$round(new Ctor(Ctor.LN10), sd);
}
function $e57b20a38792d05b$var$getZeroString(k) {
    var zs = "";
    for(; k--;)zs += "0";
    return zs;
}
/*
 * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
 * digits.
 *
 *  ln(n) is non-terminating (n != 1)
 *
 */ function $e57b20a38792d05b$var$ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error($e57b20a38792d05b$var$decimalError + (x.s ? "NaN" : "-Infinity"));
    // ln(1) = 0
    if (x.eq($e57b20a38792d05b$var$ONE)) return new Ctor(0);
    if (sd == null) {
        $e57b20a38792d05b$var$external = false;
        wpr = pr;
    } else wpr = sd;
    if (x.eq(10)) {
        if (sd == null) $e57b20a38792d05b$var$external = true;
        return $e57b20a38792d05b$var$getLn10(Ctor, wpr);
    }
    wpr += guard;
    Ctor.precision = wpr;
    c = $e57b20a38792d05b$var$digitsToString(xd);
    c0 = c.charAt(0);
    e = $e57b20a38792d05b$var$getBase10Exponent(x);
    if (Math.abs(e) < 1.5e15) {
        // Argument reduction.
        // The series converges faster the closer the argument is to 1, so using
        // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
        // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
        // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
        // later be divided by this number, then separate out the power of 10 using
        // ln(a*10^b) = ln(a) + b*ln(10).
        // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
        //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
        // max n is 6 (gives 0.7 - 1.3)
        while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
            x = x.times(y);
            c = $e57b20a38792d05b$var$digitsToString(x.d);
            c0 = c.charAt(0);
            n++;
        }
        e = $e57b20a38792d05b$var$getBase10Exponent(x);
        if (c0 > 1) {
            x = new Ctor("0." + c);
            e++;
        } else x = new Ctor(c0 + "." + c.slice(1));
    } else {
        // The argument reduction method above may result in overflow if the argument y is a massive
        // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
        // function using ln(x*10^e) = ln(x) + e*ln(10).
        t = $e57b20a38792d05b$var$getLn10(Ctor, wpr + 2, pr).times(e + "");
        x = $e57b20a38792d05b$var$ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
        Ctor.precision = pr;
        return sd == null ? ($e57b20a38792d05b$var$external = true, $e57b20a38792d05b$var$round(x, pr)) : x;
    }
    // x is reduced to a value near 1.
    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = $e57b20a38792d05b$var$divide(x.minus($e57b20a38792d05b$var$ONE), x.plus($e57b20a38792d05b$var$ONE), wpr);
    x2 = $e57b20a38792d05b$var$round(x.times(x), wpr);
    denominator = 3;
    for(;;){
        numerator = $e57b20a38792d05b$var$round(numerator.times(x2), wpr);
        t = sum.plus($e57b20a38792d05b$var$divide(numerator, new Ctor(denominator), wpr));
        if ($e57b20a38792d05b$var$digitsToString(t.d).slice(0, wpr) === $e57b20a38792d05b$var$digitsToString(sum.d).slice(0, wpr)) {
            sum = sum.times(2);
            // Reverse the argument reduction.
            if (e !== 0) sum = sum.plus($e57b20a38792d05b$var$getLn10(Ctor, wpr + 2, pr).times(e + ""));
            sum = $e57b20a38792d05b$var$divide(sum, new Ctor(n), wpr);
            Ctor.precision = pr;
            return sd == null ? ($e57b20a38792d05b$var$external = true, $e57b20a38792d05b$var$round(sum, pr)) : sum;
        }
        sum = t;
        denominator += 2;
    }
}
/*
 * Parse the value of a new Decimal `x` from string `str`.
 */ function $e57b20a38792d05b$var$parseDecimal(x, str) {
    var e, i, len;
    // Decimal point?
    if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
    } else if (e < 0) // Integer.
    e = str.length;
    // Determine leading zeros.
    for(i = 0; str.charCodeAt(i) === 48;)++i;
    // Determine trailing zeros.
    for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
    str = str.slice(i, len);
    if (str) {
        len -= i;
        e = e - i - 1;
        x.e = $e57b20a38792d05b$var$mathfloor(e / $e57b20a38792d05b$var$LOG_BASE);
        x.d = [];
        // Transform base
        // e is the base 10 exponent.
        // i is where to slice str to get the first word of the digits array.
        i = (e + 1) % $e57b20a38792d05b$var$LOG_BASE;
        if (e < 0) i += $e57b20a38792d05b$var$LOG_BASE;
        if (i < len) {
            if (i) x.d.push(+str.slice(0, i));
            for(len -= $e57b20a38792d05b$var$LOG_BASE; i < len;)x.d.push(+str.slice(i, i += $e57b20a38792d05b$var$LOG_BASE));
            str = str.slice(i);
            i = $e57b20a38792d05b$var$LOG_BASE - str.length;
        } else i -= len;
        for(; i--;)str += "0";
        x.d.push(+str);
        if ($e57b20a38792d05b$var$external && (x.e > $e57b20a38792d05b$var$MAX_E || x.e < -$e57b20a38792d05b$var$MAX_E)) throw Error($e57b20a38792d05b$var$exponentOutOfRange + e);
    } else {
        // Zero.
        x.s = 0;
        x.e = 0;
        x.d = [
            0
        ];
    }
    return x;
}
/*
 * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
 */ function $e57b20a38792d05b$var$round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
    // Get the length of the first word of the digits array xd.
    for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
    i = sd - n;
    // Is the rounding digit in the first word of xd?
    if (i < 0) {
        i += $e57b20a38792d05b$var$LOG_BASE;
        j = sd;
        w = xd[xdi = 0];
    } else {
        xdi = Math.ceil((i + 1) / $e57b20a38792d05b$var$LOG_BASE);
        k = xd.length;
        if (xdi >= k) return x;
        w = k = xd[xdi];
        // Get the number of digits of w.
        for(n = 1; k >= 10; k /= 10)n++;
        // Get the index of rd within w.
        i %= $e57b20a38792d05b$var$LOG_BASE;
        // Get the index of rd within w, adjusted for leading zeros.
        // The number of leading zeros of w is given by LOG_BASE - n.
        j = i - $e57b20a38792d05b$var$LOG_BASE + n;
    }
    if (rm !== void 0) {
        k = $e57b20a38792d05b$var$mathpow(10, n - j - 1);
        // Get the rounding digit at index j of w.
        rd = w / k % 10 | 0;
        // Are there any non-zero digits after the rounding digit?
        doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
        // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
        // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
        // 714.
        doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / $e57b20a38792d05b$var$mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
    }
    if (sd < 1 || !xd[0]) {
        if (doRound) {
            k = $e57b20a38792d05b$var$getBase10Exponent(x);
            xd.length = 1;
            // Convert sd to decimal places.
            sd = sd - k - 1;
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xd[0] = $e57b20a38792d05b$var$mathpow(10, ($e57b20a38792d05b$var$LOG_BASE - sd % $e57b20a38792d05b$var$LOG_BASE) % $e57b20a38792d05b$var$LOG_BASE);
            x.e = $e57b20a38792d05b$var$mathfloor(-sd / $e57b20a38792d05b$var$LOG_BASE) || 0;
        } else {
            xd.length = 1;
            // Zero.
            xd[0] = x.e = x.s = 0;
        }
        return x;
    }
    // Remove excess digits.
    if (i == 0) {
        xd.length = xdi;
        k = 1;
        xdi--;
    } else {
        xd.length = xdi + 1;
        k = $e57b20a38792d05b$var$mathpow(10, $e57b20a38792d05b$var$LOG_BASE - i);
        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
        // j > 0 means i > number of leading zeros of w.
        xd[xdi] = j > 0 ? (w / $e57b20a38792d05b$var$mathpow(10, n - j) % $e57b20a38792d05b$var$mathpow(10, j) | 0) * k : 0;
    }
    if (doRound) {
        for(;;)// Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
            if ((xd[0] += k) == $e57b20a38792d05b$var$BASE) {
                xd[0] = 1;
                ++x.e;
            }
            break;
        } else {
            xd[xdi] += k;
            if (xd[xdi] != $e57b20a38792d05b$var$BASE) break;
            xd[xdi--] = 0;
            k = 1;
        }
    }
    // Remove trailing zeros.
    for(i = xd.length; xd[--i] === 0;)xd.pop();
    if ($e57b20a38792d05b$var$external && (x.e > $e57b20a38792d05b$var$MAX_E || x.e < -$e57b20a38792d05b$var$MAX_E)) throw Error($e57b20a38792d05b$var$exponentOutOfRange + $e57b20a38792d05b$var$getBase10Exponent(x));
    return x;
}
function $e57b20a38792d05b$var$subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
        if (y.s) y.s = -y.s;
        else y = new Ctor(x);
        return $e57b20a38792d05b$var$external ? $e57b20a38792d05b$var$round(y, pr) : y;
    }
    xd = x.d;
    yd = y.d;
    // x and y are non-zero numbers with the same sign.
    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;
    // If exponents differ...
    if (k) {
        xLTy = k < 0;
        if (xLTy) {
            d = xd;
            k = -k;
            len = yd.length;
        } else {
            d = yd;
            e = xe;
            len = xd.length;
        }
        // Numbers with massively different exponents would result in a very high number of zeros
        // needing to be prepended, but this can be avoided while still ensuring correct rounding by
        // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
        i = Math.max(Math.ceil(pr / $e57b20a38792d05b$var$LOG_BASE), len) + 2;
        if (k > i) {
            k = i;
            d.length = 1;
        }
        // Prepend zeros to equalise exponents.
        d.reverse();
        for(i = k; i--;)d.push(0);
        d.reverse();
    // Base 1e7 exponents equal.
    } else {
        // Check digits to determine which is the bigger number.
        i = xd.length;
        len = yd.length;
        xLTy = i < len;
        if (xLTy) len = i;
        for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
            xLTy = xd[i] < yd[i];
            break;
        }
        k = 0;
    }
    if (xLTy) {
        d = xd;
        xd = yd;
        yd = d;
        y.s = -y.s;
    }
    len = xd.length;
    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
    // Subtract yd from xd.
    for(i = yd.length; i > k;){
        if (xd[--i] < yd[i]) {
            for(j = i; j && xd[--j] === 0;)xd[j] = $e57b20a38792d05b$var$BASE - 1;
            --xd[j];
            xd[i] += $e57b20a38792d05b$var$BASE;
        }
        xd[i] -= yd[i];
    }
    // Remove trailing zeros.
    for(; xd[--len] === 0;)xd.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xd[0] === 0; xd.shift())--e;
    // Zero?
    if (!xd[0]) return new Ctor(0);
    y.d = xd;
    y.e = e;
    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return $e57b20a38792d05b$var$external ? $e57b20a38792d05b$var$round(y, pr) : y;
}
function $e57b20a38792d05b$var$toString(x, isExp, sd) {
    var k, e = $e57b20a38792d05b$var$getBase10Exponent(x), str = $e57b20a38792d05b$var$digitsToString(x.d), len = str.length;
    if (isExp) {
        if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + $e57b20a38792d05b$var$getZeroString(k);
        else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
        str = str + (e < 0 ? "e" : "e+") + e;
    } else if (e < 0) {
        str = "0." + $e57b20a38792d05b$var$getZeroString(-e - 1) + str;
        if (sd && (k = sd - len) > 0) str += $e57b20a38792d05b$var$getZeroString(k);
    } else if (e >= len) {
        str += $e57b20a38792d05b$var$getZeroString(e + 1 - len);
        if (sd && (k = sd - e - 1) > 0) str = str + "." + $e57b20a38792d05b$var$getZeroString(k);
    } else {
        if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
        if (sd && (k = sd - len) > 0) {
            if (e + 1 === len) str += ".";
            str += $e57b20a38792d05b$var$getZeroString(k);
        }
    }
    return x.s < 0 ? "-" + str : str;
}
// Does not strip trailing zeros.
function $e57b20a38792d05b$var$truncate(arr, len) {
    if (arr.length > len) {
        arr.length = len;
        return true;
    }
}
// Decimal methods
/*
 *  clone
 *  config/set
 */ /*
 * Create and return a Decimal constructor with the same configuration properties as this Decimal
 * constructor.
 *
 */ function $e57b20a38792d05b$var$clone(obj) {
    var i, p, ps;
    /*
   * The Decimal constructor and exported function.
   * Return a new Decimal instance.
   *
   * value {number|string|Decimal} A numeric value.
   *
   */ function Decimal(value) {
        var x = this;
        // Decimal called without new.
        if (!(x instanceof Decimal)) return new Decimal(value);
        // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
        // which points to Object.
        x.constructor = Decimal;
        // Duplicate.
        if (value instanceof Decimal) {
            x.s = value.s;
            x.e = value.e;
            x.d = (value = value.d) ? value.slice() : value;
            return;
        }
        if (typeof value === "number") {
            // Reject Infinity/NaN.
            if (value * 0 !== 0) throw Error($e57b20a38792d05b$var$invalidArgument + value);
            if (value > 0) x.s = 1;
            else if (value < 0) {
                value = -value;
                x.s = -1;
            } else {
                x.s = 0;
                x.e = 0;
                x.d = [
                    0
                ];
                return;
            }
            // Fast path for small integers.
            if (value === ~~value && value < 1e7) {
                x.e = 0;
                x.d = [
                    value
                ];
                return;
            }
            return $e57b20a38792d05b$var$parseDecimal(x, value.toString());
        } else if (typeof value !== "string") throw Error($e57b20a38792d05b$var$invalidArgument + value);
        // Minus sign?
        if (value.charCodeAt(0) === 45) {
            value = value.slice(1);
            x.s = -1;
        } else x.s = 1;
        if ($e57b20a38792d05b$var$isDecimal.test(value)) $e57b20a38792d05b$var$parseDecimal(x, value);
        else throw Error($e57b20a38792d05b$var$invalidArgument + value);
    }
    Decimal.prototype = $e57b20a38792d05b$var$P;
    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;
    Decimal.clone = $e57b20a38792d05b$var$clone;
    Decimal.config = Decimal.set = $e57b20a38792d05b$var$config;
    if (obj === void 0) obj = {};
    if (obj) {
        ps = [
            "precision",
            "rounding",
            "toExpNeg",
            "toExpPos",
            "LN10"
        ];
        for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }
    Decimal.config(obj);
    return Decimal;
}
/*
 * Configure global settings for a Decimal constructor.
 *
 * `obj` is an object with one or more of the following properties,
 *
 *   precision  {number}
 *   rounding   {number}
 *   toExpNeg   {number}
 *   toExpPos   {number}
 *
 * E.g. Decimal.config({ precision: 20, rounding: 4 })
 *
 */ function $e57b20a38792d05b$var$config(obj) {
    if (!obj || typeof obj !== "object") throw Error($e57b20a38792d05b$var$decimalError + "Object expected");
    var i, p, v, ps = [
        "precision",
        1,
        $e57b20a38792d05b$var$MAX_DIGITS,
        "rounding",
        0,
        8,
        "toExpNeg",
        -1 / 0,
        0,
        "toExpPos",
        0,
        1 / 0
    ];
    for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
        if ($e57b20a38792d05b$var$mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error($e57b20a38792d05b$var$invalidArgument + p + ": " + v);
    }
    if ((v = obj[p = "LN10"]) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error($e57b20a38792d05b$var$invalidArgument + p + ": " + v);
    }
    return this;
}
// Create and configure initial Decimal constructor.
var $e57b20a38792d05b$export$95c991896bef8714 = $e57b20a38792d05b$var$clone($e57b20a38792d05b$var$defaults);
// Internal constant.
$e57b20a38792d05b$var$ONE = new $e57b20a38792d05b$export$95c991896bef8714(1);
var $e57b20a38792d05b$export$2e2bcd8739ae039 = $e57b20a38792d05b$export$95c991896bef8714;

});

parcelRegister("Vs2Xf", function(module, exports) {

$parcel$export(module.exports, "CurrencyExponents", function () { return $d72cb29631f05cec$export$610339706cd0bc07; });
var $d72cb29631f05cec$export$82cf6e3d4c009fa7;
(function(CurrencyCodes) {
    CurrencyCodes["AED"] = "aed";
    CurrencyCodes["AFN"] = "afn";
    CurrencyCodes["ALL"] = "all";
    CurrencyCodes["AMD"] = "amd";
    CurrencyCodes["ANG"] = "ang";
    CurrencyCodes["AOA"] = "aoa";
    CurrencyCodes["ARS"] = "ars";
    CurrencyCodes["AUD"] = "aud";
    CurrencyCodes["AWG"] = "awg";
    CurrencyCodes["AZN"] = "azn";
    CurrencyCodes["BAM"] = "bam";
    CurrencyCodes["BBD"] = "bbd";
    CurrencyCodes["BDT"] = "bdt";
    CurrencyCodes["BGN"] = "bgn";
    CurrencyCodes["BHD"] = "bhd";
    CurrencyCodes["BIF"] = "bif";
    CurrencyCodes["BMD"] = "bmd";
    CurrencyCodes["BND"] = "bnd";
    CurrencyCodes["BOB"] = "bob";
    CurrencyCodes["BOV"] = "bov";
    CurrencyCodes["BRL"] = "brl";
    CurrencyCodes["BSD"] = "bsd";
    CurrencyCodes["BTN"] = "btn";
    CurrencyCodes["BWP"] = "bwp";
    CurrencyCodes["BYN"] = "byn";
    CurrencyCodes["BYR"] = "byr";
    CurrencyCodes["BZD"] = "bzd";
    CurrencyCodes["CAD"] = "cad";
    CurrencyCodes["CDF"] = "cdf";
    CurrencyCodes["CHE"] = "che";
    CurrencyCodes["CHF"] = "chf";
    CurrencyCodes["CHW"] = "chw";
    CurrencyCodes["CLF"] = "clf";
    CurrencyCodes["CLP"] = "clp";
    CurrencyCodes["CNY"] = "cny";
    CurrencyCodes["COP"] = "cop";
    CurrencyCodes["COU"] = "cou";
    CurrencyCodes["CRC"] = "crc";
    CurrencyCodes["CUC"] = "cuc";
    CurrencyCodes["CUP"] = "cup";
    CurrencyCodes["CVE"] = "cve";
    CurrencyCodes["CZK"] = "czk";
    CurrencyCodes["DJF"] = "djf";
    CurrencyCodes["DKK"] = "dkk";
    CurrencyCodes["DOP"] = "dop";
    CurrencyCodes["DZD"] = "dzd";
    CurrencyCodes["EGP"] = "egp";
    CurrencyCodes["ERN"] = "ern";
    CurrencyCodes["ETB"] = "etb";
    CurrencyCodes["EUR"] = "eur";
    CurrencyCodes["FJD"] = "fjd";
    CurrencyCodes["FKP"] = "fkp";
    CurrencyCodes["GBP"] = "gbp";
    CurrencyCodes["GEL"] = "gel";
    CurrencyCodes["GHS"] = "ghs";
    CurrencyCodes["GIP"] = "gip";
    CurrencyCodes["GMD"] = "gmd";
    CurrencyCodes["GNF"] = "gnf";
    CurrencyCodes["GTQ"] = "gtq";
    CurrencyCodes["GYD"] = "gyd";
    CurrencyCodes["HKD"] = "hkd";
    CurrencyCodes["HNL"] = "hnl";
    CurrencyCodes["HRK"] = "hrk";
    CurrencyCodes["HTG"] = "htg";
    CurrencyCodes["HUF"] = "huf";
    CurrencyCodes["IDR"] = "idr";
    CurrencyCodes["ILS"] = "ils";
    CurrencyCodes["INR"] = "inr";
    CurrencyCodes["IQD"] = "iqd";
    CurrencyCodes["IRR"] = "irr";
    CurrencyCodes["ISK"] = "isk";
    CurrencyCodes["JMD"] = "jmd";
    CurrencyCodes["JOD"] = "jod";
    CurrencyCodes["JPY"] = "jpy";
    CurrencyCodes["KES"] = "kes";
    CurrencyCodes["KGS"] = "kgs";
    CurrencyCodes["KHR"] = "khr";
    CurrencyCodes["KMF"] = "kmf";
    CurrencyCodes["KPW"] = "kpw";
    CurrencyCodes["KRW"] = "krw";
    CurrencyCodes["KWD"] = "kwd";
    CurrencyCodes["KYD"] = "kyd";
    CurrencyCodes["KZT"] = "kzt";
    CurrencyCodes["LAK"] = "lak";
    CurrencyCodes["LBP"] = "lbp";
    CurrencyCodes["LKR"] = "lkr";
    CurrencyCodes["LRD"] = "lrd";
    CurrencyCodes["LSL"] = "lsl";
    CurrencyCodes["LTL"] = "ltl";
    CurrencyCodes["LVL"] = "lvl";
    CurrencyCodes["LYD"] = "lyd";
    CurrencyCodes["MAD"] = "mad";
    CurrencyCodes["MDL"] = "mdl";
    CurrencyCodes["MGA"] = "mga";
    CurrencyCodes["MKD"] = "mkd";
    CurrencyCodes["MMK"] = "mmk";
    CurrencyCodes["MNT"] = "mnt";
    CurrencyCodes["MOP"] = "mop";
    CurrencyCodes["MRO"] = "mro";
    CurrencyCodes["MUR"] = "mur";
    CurrencyCodes["MVR"] = "mvr";
    CurrencyCodes["MWK"] = "mwk";
    CurrencyCodes["MXN"] = "mxn";
    CurrencyCodes["MXV"] = "mxv";
    CurrencyCodes["MYR"] = "myr";
    CurrencyCodes["MZN"] = "mzn";
    CurrencyCodes["NAD"] = "nad";
    CurrencyCodes["NGN"] = "ngn";
    CurrencyCodes["NIO"] = "nio";
    CurrencyCodes["NOK"] = "nok";
    CurrencyCodes["NPR"] = "npr";
    CurrencyCodes["NZD"] = "nzd";
    CurrencyCodes["OMR"] = "omr";
    CurrencyCodes["PAB"] = "pab";
    CurrencyCodes["PEN"] = "pen";
    CurrencyCodes["PGK"] = "pgk";
    CurrencyCodes["PHP"] = "php";
    CurrencyCodes["PKR"] = "pkr";
    CurrencyCodes["PLN"] = "pln";
    CurrencyCodes["PYG"] = "pyg";
    CurrencyCodes["QAR"] = "qar";
    CurrencyCodes["RON"] = "ron";
    CurrencyCodes["RSD"] = "rsd";
    CurrencyCodes["RUB"] = "rub";
    CurrencyCodes["RWF"] = "rwf";
    CurrencyCodes["SAR"] = "sar";
    CurrencyCodes["SBD"] = "sbd";
    CurrencyCodes["SCR"] = "scr";
    CurrencyCodes["SDG"] = "sdg";
    CurrencyCodes["SEK"] = "sek";
    CurrencyCodes["SGD"] = "sgd";
    CurrencyCodes["SHP"] = "shp";
    CurrencyCodes["SLL"] = "sll";
    CurrencyCodes["SOS"] = "sos";
    CurrencyCodes["SRD"] = "srd";
    CurrencyCodes["SSP"] = "ssp";
    CurrencyCodes["STD"] = "std";
    CurrencyCodes["SVC"] = "svc";
    CurrencyCodes["SYP"] = "syp";
    CurrencyCodes["SZL"] = "szl";
    CurrencyCodes["THB"] = "thb";
    CurrencyCodes["TJS"] = "tjs";
    CurrencyCodes["TMT"] = "tmt";
    CurrencyCodes["TND"] = "tnd";
    CurrencyCodes["TOP"] = "top";
    CurrencyCodes["TRY"] = "try";
    CurrencyCodes["TTD"] = "ttd";
    CurrencyCodes["TWD"] = "twd";
    CurrencyCodes["TZS"] = "tzs";
    CurrencyCodes["UAH"] = "uah";
    CurrencyCodes["UGX"] = "ugx";
    CurrencyCodes["USD"] = "usd";
    CurrencyCodes["USN"] = "usn";
    CurrencyCodes["USS"] = "uss";
    CurrencyCodes["UYI"] = "uyi";
    CurrencyCodes["UYU"] = "uyu";
    CurrencyCodes["UZS"] = "uzs";
    CurrencyCodes["VEF"] = "vef";
    CurrencyCodes["VND"] = "vnd";
    CurrencyCodes["VUV"] = "vuv";
    CurrencyCodes["WST"] = "wst";
    CurrencyCodes["XAF"] = "xaf";
    CurrencyCodes["XAG"] = "xag";
    CurrencyCodes["XAU"] = "xau";
    CurrencyCodes["XBA"] = "xba";
    CurrencyCodes["XBB"] = "xbb";
    CurrencyCodes["XBC"] = "xbc";
    CurrencyCodes["XBD"] = "xbd";
    CurrencyCodes["XCD"] = "xcd";
    CurrencyCodes["XDR"] = "xdr";
    CurrencyCodes["XFU"] = "xfu";
    CurrencyCodes["XOF"] = "xof";
    CurrencyCodes["XPD"] = "xpd";
    CurrencyCodes["XPF"] = "xpf";
    CurrencyCodes["XPT"] = "xpt";
    CurrencyCodes["XSU"] = "xsu";
    CurrencyCodes["XTS"] = "xts";
    CurrencyCodes["XUA"] = "xua";
    CurrencyCodes["YER"] = "yer";
    CurrencyCodes["ZAR"] = "zar";
    CurrencyCodes["ZMW"] = "zmw";
    CurrencyCodes["ZWL"] = "zwl";
})($d72cb29631f05cec$export$82cf6e3d4c009fa7 || ($d72cb29631f05cec$export$82cf6e3d4c009fa7 = {}));
const $d72cb29631f05cec$export$610339706cd0bc07 = {
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AED]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AFN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ALL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AMD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ANG]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AOA]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ARS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AUD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AWG]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.AZN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BAM]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BBD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BDT]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BGN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BHD]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BIF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BMD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BND]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BOB]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BOV]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BRL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BSD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BTN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BWP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BYR]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BYN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.BZD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CAD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CDF]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CHE]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CHF]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CHW]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CLF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CLP]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CNY]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.COP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.COU]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CRC]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CUC]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CUP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CVE]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.CZK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.DJF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.DKK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.DOP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.DZD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.EGP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ERN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ETB]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.EUR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.FJD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.FKP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GBP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GEL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GHS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GIP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GMD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GNF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GTQ]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.GYD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.HKD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.HNL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.HRK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.HTG]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.HUF]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.IDR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ILS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.INR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.IQD]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.IRR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ISK]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.JMD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.JOD]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.JPY]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KES]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KGS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KHR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KMF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KPW]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KRW]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KWD]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KYD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.KZT]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LAK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LBP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LKR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LRD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LSL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LTL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LVL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.LYD]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MAD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MDL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MGA]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MKD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MMK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MNT]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MOP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MRO]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MUR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MVR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MWK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MXN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MXV]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MYR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.MZN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NAD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NGN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NIO]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NOK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NPR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.NZD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.OMR]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PAB]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PEN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PGK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PHP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PKR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PLN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.PYG]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.QAR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.RON]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.RSD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.RUB]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.RWF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SAR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SBD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SCR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SDG]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SEK]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SGD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SHP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SLL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SOS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SRD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SSP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.STD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SVC]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SYP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.SZL]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.THB]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TJS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TMT]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TND]: 3,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TOP]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TRY]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TTD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TWD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.TZS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.UAH]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.UGX]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.USD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.USN]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.USS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.UYI]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.UYU]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.UZS]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.VEF]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.VND]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.VUV]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.WST]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XAF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XAG]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XAU]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XBA]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XBB]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XBC]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XBD]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XCD]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XDR]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XFU]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XOF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XPD]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XPF]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XPT]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XSU]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XTS]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.XUA]: 0,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.YER]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ZAR]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ZMW]: 2,
    [$d72cb29631f05cec$export$82cf6e3d4c009fa7.ZWL]: 2
};

});


parcelRegister("02mKu", function(module, exports) {

var $eph6D = parcelRequire("eph6D");

var $ux1WZ = parcelRequire("ux1WZ");

var $Ua2ql = parcelRequire("Ua2ql");

var $gROQ6 = parcelRequire("gROQ6");

var $8jr1s = parcelRequire("8jr1s");

var $kq6d3 = parcelRequire("kq6d3");
class $00524e5723c3b7da$export$112ebc686c39e9ae {
    constructor(clientId, guildId, channelId, locationId){
        this.platform = (0, $gROQ6.Platform).DESKTOP;
        this.instanceId = "123456789012345678";
        this.configuration = (0, $8jr1s.default)();
        this.source = null;
        this.sourceOrigin = "";
        this.sdkVersion = "mock";
        this.mobileAppVersion = "unknown";
        this.frameId = "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa";
        this.eventBus = new (0, $eph6D.default)();
        this.clientId = clientId;
        this.commands = this._updateCommandMocks({});
        this.guildId = guildId;
        this.channelId = channelId;
        this.locationId = locationId;
        this.customId = null;
        this.referrerId = null;
    }
    _updateCommandMocks(newCommands) {
        // Wrap all the command functions with logging
        this.commands = (0, $Ua2ql.default)(Object.assign({}, $00524e5723c3b7da$export$df10d8e5927d39a4, newCommands), (mock, func, name)=>{
            mock[name] = async (...args)=>{
                console.info(`DiscordSDKMock: ${String(name)}(${JSON.stringify(args)})`);
                return await func(...args);
            };
        });
        // redundant return here to satisfy the constructor defining commands
        return this.commands;
    }
    emitReady() {
        this.emitEvent("READY", undefined);
    }
    close(...args) {
        console.info(`DiscordSDKMock: close(${JSON.stringify(args)})`);
    }
    ready() {
        return Promise.resolve();
    }
    async subscribe(event, listener, ..._subscribeArgs) {
        return await this.eventBus.on(event, listener);
    }
    async unsubscribe(event, listener, ..._unsubscribeArgs) {
        return await this.eventBus.off(event, listener);
    }
    emitEvent(event, data) {
        this.eventBus.emit(event, data);
    }
}
/** Default return values for all discord SDK commands */ const $00524e5723c3b7da$export$df10d8e5927d39a4 = {
    authorize: ()=>Promise.resolve({
            code: "mock_code"
        }),
    setActivity: ()=>Promise.resolve({
            name: "mock_activity_name",
            type: 0
        }),
    getChannel: ()=>Promise.resolve({
            id: "mock_channel_id",
            name: "mock_channel_name",
            type: (0, $kq6d3.ChannelTypesObject).GUILD_TEXT,
            voice_states: [],
            messages: []
        }),
    getSkus: ()=>Promise.resolve({
            skus: []
        }),
    getEntitlements: ()=>Promise.resolve({
            entitlements: []
        }),
    startPurchase: ()=>Promise.resolve([]),
    setConfig: ()=>Promise.resolve({
            use_interactive_pip: false
        }),
    userSettingsGetLocale: ()=>Promise.resolve({
            locale: ""
        }),
    openExternalLink: ()=>Promise.resolve({
            opened: false
        }),
    encourageHardwareAcceleration: ()=>Promise.resolve({
            enabled: true
        }),
    captureLog: ()=>Promise.resolve(null),
    setOrientationLockState: ()=>Promise.resolve(null),
    openInviteDialog: ()=>Promise.resolve(null),
    getPlatformBehaviors: ()=>Promise.resolve({
            iosKeyboardResizesView: true
        }),
    getChannelPermissions: ()=>Promise.resolve({
            permissions: (0, $ux1WZ.default)(1234567890)
        }),
    getInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    // START-GENERATED-SECTION
    openShareMomentDialog: ()=>Promise.resolve(null),
    authenticate: ()=>Promise.resolve({
            access_token: "mock_token",
            user: {
                username: "mock_user_username",
                discriminator: "mock_user_discriminator",
                id: "mock_user_id",
                avatar: null,
                public_flags: 1
            },
            scopes: [],
            expires: new Date(2121, 1, 1).toString(),
            application: {
                description: "mock_app_description",
                icon: "mock_app_icon",
                id: "mock_app_id",
                name: "mock_app_name"
            }
        }),
    shareLink: ()=>Promise.resolve({
            success: false,
            didSendMessage: false,
            didCopyLink: false
        }),
    initiateImageUpload: ()=>Promise.resolve({
            image_url: "https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0b52aa9e99b832574a53_full_logo_blurple_RGB.png"
        }),
    getRelationships: ()=>Promise.resolve({
            relationships: [
                {
                    type: 1,
                    user: {
                        username: "mock_friend_username",
                        flags: 0,
                        bot: false,
                        discriminator: "mock_friend_discriminator",
                        id: "mock_friend_id_1",
                        avatar: null
                    }
                },
                {
                    type: 1,
                    user: {
                        username: "mock_friend_username_with_nickname",
                        flags: 0,
                        bot: false,
                        discriminator: "mock_friend_discriminator_with_nickname",
                        id: "mock_friend_id_2",
                        avatar: null
                    },
                    nickname: "mock_friend_nickname_for_user"
                },
                {
                    type: 1,
                    user: {
                        username: "mock_friend_username_with_since",
                        flags: 0,
                        bot: false,
                        discriminator: "mock_friend_discriminator_with_since",
                        id: "mock_friend_id_3",
                        avatar: null
                    },
                    since: "2021-06-29T00:32:37.180813+00:00"
                }
            ]
        }),
    inviteUserEmbedded: ()=>Promise.resolve(null),
    getUser: ()=>{
        return Promise.resolve({
            username: "mock_friend_username",
            flags: 0,
            bot: false,
            discriminator: "mock_friend_discriminator",
            id: "mock_friend_id_1",
            avatar: null
        });
    },
    getQuestEnrollmentStatus: ()=>Promise.resolve({
            quest_id: "mock_quest_id",
            is_enrolled: false,
            enrolled_at: null
        }),
    questStartTimer: ()=>Promise.resolve({
            success: true
        }),
    getActivityInstanceConnectedParticipants: ()=>Promise.resolve({
            participants: []
        }),
    shareInteraction: ()=>Promise.resolve({
            success: false
        })
};

});
parcelRegister("Ua2ql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2476da239b1fdd57$export$2e2bcd8739ae039; });

var $fgm47 = parcelRequire("fgm47");

var $4Olgy = parcelRequire("4Olgy");
var $2476da239b1fdd57$var$lodash_transformExports = (0, $4Olgy.__require)();
var $2476da239b1fdd57$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fgm47.getDefaultExportFromCjs)($2476da239b1fdd57$var$lodash_transformExports);

});
parcelRegister("4Olgy", function(module, exports) {

$parcel$export(module.exports, "__require", function () { return $b6d885f9736f7c8e$export$b88c30a9414655a0; });

var $fgm47 = parcelRequire("fgm47");

var $bKKEx = parcelRequire("bKKEx");
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (0, $bKKEx.__module).exports;
var $b6d885f9736f7c8e$var$hasRequiredLodash_transform;
function $b6d885f9736f7c8e$export$b88c30a9414655a0() {
    if ($b6d885f9736f7c8e$var$hasRequiredLodash_transform) return (0, $bKKEx.__module).exports;
    $b6d885f9736f7c8e$var$hasRequiredLodash_transform = 1;
    (function(module, exports) {
        /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
        /** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
        /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
        /** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
        /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
        /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
        var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
        /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        /**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
        /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
        /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
        /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
        /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof (0, $fgm47.commonjsGlobal) == "object" && (0, $fgm47.commonjsGlobal) && (0, $fgm47.commonjsGlobal).Object === Object && (0, $fgm47.commonjsGlobal);
        /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
        /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
        /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
        /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
        /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
        /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
        /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
            try {
                return freeProcess && freeProcess.binding("util");
            } catch (e) {}
        }();
        /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        /**
		 * A specialized version of `_.forEach` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns `array`.
		 */ function arrayEach(array, iteratee) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        /**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */ function arraySome(array, predicate) {
            var index = -1, length = array ? array.length : 0;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        /**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        /**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */ function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        /**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */ function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        /**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */ function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        /**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */ function isHostObject(value) {
            // Many host objects are `Object` objects that can coerce to strings
            // despite having improperly defined `toString` methods.
            var result = false;
            if (value != null && typeof value.toString != "function") try {
                result = !!(value + "");
            } catch (e) {}
            return result;
        }
        /**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */ function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        /**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */ function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        /**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */ function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */ var objectToString = objectProto.toString;
        /** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
        /* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Hash(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
        }
        /**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function hashDelete(key) {
            return this.has(key) && delete this.__data__[key];
        }
        /**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */ function hashSet(key, value) {
            var data = this.__data__;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function ListCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */ function listCacheClear() {
            this.__data__ = [];
        }
        /**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            return true;
        }
        /**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) data.push([
                key,
                value
            ]);
            else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function MapCache(entries) {
            var index = -1, length = entries ? entries.length : 0;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */ function mapCacheClear() {
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function mapCacheDelete(key) {
            return getMapData(this, key)["delete"](key);
        }
        /**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */ function mapCacheSet(key, value) {
            getMapData(this, key).set(key, value);
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */ function SetCache(values) {
            var index = -1, length = values ? values.length : 0;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */ function Stack(entries) {
            this.__data__ = new ListCache(entries);
        }
        /**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */ function stackClear() {
            this.__data__ = new ListCache;
        }
        /**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */ function stackDelete(key) {
            return this.__data__["delete"](key);
        }
        /**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */ function stackSet(key, value) {
            var cache = this.__data__;
            if (cache instanceof ListCache) {
                var pairs = cache.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    return this;
                }
                cache = this.__data__ = new MapCache(pairs);
            }
            cache.set(key, value);
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */ function arrayLikeKeys(value, inherited) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            // Safari 9 makes `arguments.length` enumerable in strict mode.
            var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
            var length = result.length, skipIndexes = !!length;
            for(var key in value)if (hasOwnProperty.call(value, key) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
		 * The base implementation of `_.create` without support for assigning
		 * properties to the created object.
		 *
		 * @private
		 * @param {Object} prototype The object to inherit from.
		 * @returns {Object} Returns the new object.
		 */ function baseCreate(proto) {
            return isObject(proto) ? objectCreate(proto) : {};
        }
        /**
		 * The base implementation of `baseForOwn` which iterates over `object`
		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @returns {Object} Returns `object`.
		 */ var baseFor = createBaseFor();
        /**
		 * The base implementation of `_.forOwn` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to iterate over.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Object} Returns `object`.
		 */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
		 * The base implementation of `_.get` without support for default values.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @returns {*} Returns the resolved value.
		 */ function baseGet(object, path) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
		 * The base implementation of `getTag`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ function baseGetTag(value) {
            return objectToString.call(value);
        }
        /**
		 * The base implementation of `_.hasIn` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */ function baseHasIn(object, key) {
            return object != null && key in Object(object);
        }
        /**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {boolean} [bitmask] The bitmask of comparison flags.
		 *  The bitmask may be composed of the following flags:
		 *     1 - Unordered comparison
		 *     2 - Partial comparison
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
        }
        /**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
            if (!objIsArr) {
                objTag = getTag(object);
                objTag = objTag == argsTag ? objectTag : objTag;
            }
            if (!othIsArr) {
                othTag = getTag(other);
                othTag = othTag == argsTag ? objectTag : othTag;
            }
            var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
            }
            if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
        }
        /**
		 * The base implementation of `_.isMatch` without support for iteratee shorthands.
		 *
		 * @private
		 * @param {Object} object The object to inspect.
		 * @param {Object} source The object of property values to match.
		 * @param {Array} matchData The property names, values, and compare flags to match.
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
		 */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index;
            if (object == null) return !length;
            object = Object(object);
            while(index--){
                var data = matchData[index];
                if (data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    var result;
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
        }
        /**
		 * The base implementation of `_.iteratee`.
		 *
		 * @private
		 * @param {*} [value=_.identity] The value to convert to an iteratee.
		 * @returns {Function} Returns the iteratee.
		 */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
		 * The base implementation of `_.matches` which doesn't clone `source`.
		 *
		 * @private
		 * @param {Object} source The object of property values to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
		 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
		 *
		 * @private
		 * @param {string} path The path of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
            };
        }
        /**
		 * A specialized version of `baseProperty` which supports deep paths.
		 *
		 * @private
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
		 * The base implementation of `_.toString` which doesn't convert nullish
		 * values to empty strings.
		 *
		 * @private
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
		 * Casts `value` to a path array if it's not one.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {Array} Returns the cast property path array.
		 */ function castPath(value) {
            return isArray(value) ? value : stringToPath(value);
        }
        /**
		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
		 *
		 * @private
		 * @param {boolean} [fromRight] Specify iterating from right to left.
		 * @returns {Function} Returns the new base function.
		 */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) return stacked == other;
            var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= UNORDERED_COMPARE_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
		 *  for more details.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) return stacked == other;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
		 * Gets the property names, values, and compare flags of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the match data of `object`.
		 */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11,
        // for data views in Edge < 14, and promises in Node.js.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
		 * Checks if `path` exists on `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @param {Function} hasFunc The function to check properties.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 */ function hasPath(object, path, hasFunc) {
            path = isKey(path, object) ? [
                path
            ] : castPath(path);
            var result, index = -1, length = path.length;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result) return result;
            var length = object ? object.length : 0;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */ function isIndex(value, length) {
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
		 * Checks if `value` is a property name and not a property path.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {Object} [object] The object to query keys on.
		 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
		 */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
        }
        /**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
		 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` if suitable for strict
		 *  equality comparisons, else `false`.
		 */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
		 * A specialized version of `matchesProperty` for source values suitable
		 * for strict equality comparisons, i.e. `===`.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @param {*} srcValue The value to match.
		 * @returns {Function} Returns the new spec function.
		 */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
            };
        }
        /**
		 * Converts `string` to a property path array.
		 *
		 * @private
		 * @param {string} string The string to convert.
		 * @returns {Array} Returns the property path array.
		 */ var stringToPath = memoize(function(string) {
            string = toString(string);
            var result = [];
            if (reLeadingDot.test(string)) result.push("");
            string.replace(rePropName, function(match, number, quote, string) {
                result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
		 * Converts `value` to a string key if it's not a string or symbol.
		 *
		 * @private
		 * @param {*} value The value to inspect.
		 * @returns {string|symbol} Returns the key.
		 */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
		 * Creates a function that memoizes the result of `func`. If `resolver` is
		 * provided, it determines the cache key for storing the result based on the
		 * arguments provided to the memoized function. By default, the first argument
		 * provided to the memoized function is used as the map cache key. The `func`
		 * is invoked with the `this` binding of the memoized function.
		 *
		 * **Note:** The cache is exposed as the `cache` property on the memoized
		 * function. Its creation may be customized by replacing the `_.memoize.Cache`
		 * constructor with one whose instances implement the
		 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
		 * method interface of `delete`, `get`, `has`, and `set`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to have its output memoized.
		 * @param {Function} [resolver] The function to resolve the cache key.
		 * @returns {Function} Returns the new memoized function.
		 * @example
		 *
		 * var object = { 'a': 1, 'b': 2 };
		 * var other = { 'c': 3, 'd': 4 };
		 *
		 * var values = _.memoize(_.values);
		 * values(object);
		 * // => [1, 2]
		 *
		 * values(other);
		 * // => [3, 4]
		 *
		 * object.a = 2;
		 * values(object);
		 * // => [1, 2]
		 *
		 * // Modify the result cache.
		 * values.cache.set(object, ['a', 'b']);
		 * values(object);
		 * // => ['a', 'b']
		 *
		 * // Replace `_.memoize.Cache`.
		 * _.memoize.Cache = WeakMap;
		 */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result);
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Assign cache to `_.memoize`.
        memoize.Cache = MapCache;
        /**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */ function isArguments(value) {
            // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
            return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
        }
        /**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */ var isArray = Array.isArray;
        /**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */ function isFunction(value) {
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 8-9 which returns 'object' for typed array and other constructors.
            var tag = isObject(value) ? objectToString.call(value) : "";
            return tag == funcTag || tag == genTag;
        }
        /**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */ function isObject(value) {
            var type = typeof value;
            return !!value && (type == "object" || type == "function");
        }
        /**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */ function isObjectLike(value) {
            return !!value && typeof value == "object";
        }
        /**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
        }
        /**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
		 * Converts `value` to a string. An empty string is returned for `null`
		 * and `undefined` values. The sign of `-0` is preserved.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {string} Returns the string.
		 * @example
		 *
		 * _.toString(null);
		 * // => ''
		 *
		 * _.toString(-0);
		 * // => '-0'
		 *
		 * _.toString([1, 2, 3]);
		 * // => '1,2,3'
		 */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /**
		 * Gets the value at `path` of `object`. If the resolved value is
		 * `undefined`, the `defaultValue` is returned in its place.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.7.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path of the property to get.
		 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
		 * @returns {*} Returns the resolved value.
		 * @example
		 *
		 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
		 *
		 * _.get(object, 'a[0].b.c');
		 * // => 3
		 *
		 * _.get(object, ['a', '0', 'b', 'c']);
		 * // => 3
		 *
		 * _.get(object, 'a.b.c', 'default');
		 * // => 'default'
		 */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
		 * Checks if `path` is a direct or inherited property of `object`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Object
		 * @param {Object} object The object to query.
		 * @param {Array|string} path The path to check.
		 * @returns {boolean} Returns `true` if `path` exists, else `false`.
		 * @example
		 *
		 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
		 *
		 * _.hasIn(object, 'a');
		 * // => true
		 *
		 * _.hasIn(object, 'a.b');
		 * // => true
		 *
		 * _.hasIn(object, ['a', 'b']);
		 * // => true
		 *
		 * _.hasIn(object, 'b');
		 * // => false
		 */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
		 * An alternative to `_.reduce`; this method transforms `object` to a new
		 * `accumulator` object which is the result of running each of its own
		 * enumerable string keyed properties thru `iteratee`, with each invocation
		 * potentially mutating the `accumulator` object. If `accumulator` is not
		 * provided, a new object with the same `[[Prototype]]` will be used. The
		 * iteratee is invoked with four arguments: (accumulator, value, key, object).
		 * Iteratee functions may exit iteration early by explicitly returning `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 1.3.0
		 * @category Object
		 * @param {Object} object The object to iterate over.
		 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
		 * @param {*} [accumulator] The custom accumulator value.
		 * @returns {*} Returns the accumulated value.
		 * @example
		 *
		 * _.transform([2, 3, 4], function(result, n) {
		 *   result.push(n *= n);
		 *   return n % 2 == 0;
		 * }, []);
		 * // => [4, 9]
		 *
		 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
		 *   (result[value] || (result[value] = [])).push(key);
		 * }, {});
		 * // => { '1': ['a', 'c'], '2': ['b'] }
		 */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object) || isTypedArray(object);
            iteratee = baseIteratee(iteratee);
            if (accumulator == null) {
                if (isArr || isObject(object)) {
                    var Ctor = object.constructor;
                    if (isArr) accumulator = isArray(object) ? new Ctor : [];
                    else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                } else accumulator = {};
            }
            (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
		 * This method returns the first argument it receives.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Util
		 * @param {*} value Any value.
		 * @returns {*} Returns `value`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 *
		 * console.log(_.identity(object) === object);
		 * // => true
		 */ function identity(value) {
            return value;
        }
        /**
		 * Creates a function that returns the value at `path` of a given object.
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Util
		 * @param {Array|string} path The path of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 * @example
		 *
		 * var objects = [
		 *   { 'a': { 'b': 2 } },
		 *   { 'a': { 'b': 1 } }
		 * ];
		 *
		 * _.map(objects, _.property('a.b'));
		 * // => [2, 1]
		 *
		 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
		 * // => [1, 2]
		 */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        module.exports = transform;
    })((0, $bKKEx.__module), (0, $bKKEx.__module).exports);
    return (0, $bKKEx.__module).exports;
}

});
parcelRegister("bKKEx", function(module, exports) {

$parcel$export(module.exports, "__module", function () { return $6adad26c326d7b89$export$5edeffb658f039f4; });
var $6adad26c326d7b89$export$5edeffb658f039f4 = {
    exports: {}
};

});




parcelRegister("WjFKr", function(module, exports) {

var $3aRz0 = parcelRequire("3aRz0");

var $a0Bx7 = parcelRequire("a0Bx7");
function $7705793eefc657aa$export$8cf746fdd009b78f(mappings, { patchFetch: patchFetch = true, patchWebSocket: patchWebSocket = true, patchXhr: patchXhr = true, patchSrcAttributes: patchSrcAttributes = false } = {}) {
    // Bail out if we're not in a browser
    if (typeof window === "undefined") return;
    if (patchFetch) {
        const fetchImpl = window.fetch;
        // fetch is a duplex, but this is consistent
        window.fetch = function(input, init) {
            // If fetch has Request as input, we need to resolve any stream
            // before we create a new request with the mapped url
            if (input instanceof Request) {
                const newUrl = $7705793eefc657aa$export$e84bab733853880b({
                    url: (0, $a0Bx7.absoluteURL)(input.url),
                    mappings: mappings
                });
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _a = init !== null && init !== void 0 ? init : {}, newInit = (0, $3aRz0.__rest)(_a, [
                    "url"
                ]);
                Object.keys(Request.prototype).forEach((value)=>{
                    if (value === "url") return;
                    try {
                        // @ts-expect-error
                        newInit[value] = input[value];
                    } catch (ex) {
                        console.warn(`Remapping fetch request key "${value}" failed`, ex);
                    }
                });
                return new Promise((resolve, reject)=>{
                    try {
                        input.blob().then((blob)=>{
                            if (input.method.toUpperCase() !== "HEAD" && input.method.toUpperCase() !== "GET" && blob.size > 0) newInit.body = blob;
                            resolve(fetchImpl(new Request(newUrl, newInit)));
                        });
                    } catch (ex) {
                        reject(ex);
                    }
                });
            }
            // Assuming a generic url or string
            const remapped = $7705793eefc657aa$export$e84bab733853880b({
                url: input instanceof URL ? input : (0, $a0Bx7.absoluteURL)(input),
                mappings: mappings
            });
            return fetchImpl(remapped, init);
        };
    }
    if (patchWebSocket) {
        class WebSocketProxy extends WebSocket {
            constructor(url, protocols){
                const remapped = $7705793eefc657aa$export$e84bab733853880b({
                    url: url instanceof URL ? url : (0, $a0Bx7.absoluteURL)(url),
                    mappings: mappings
                });
                super(remapped, protocols);
            }
        }
        window.WebSocket = WebSocketProxy;
    }
    if (patchXhr) {
        const openImpl = XMLHttpRequest.prototype.open;
        // @ts-expect-error - the ts interface exports two 'open' methods
        XMLHttpRequest.prototype.open = function(method, url, async, username, password) {
            const remapped = $7705793eefc657aa$export$e84bab733853880b({
                url: (0, $a0Bx7.absoluteURL)(url),
                mappings: mappings
            });
            openImpl.apply(this, [
                method,
                remapped,
                async,
                username,
                password
            ]);
        };
    }
    if (patchSrcAttributes) {
        const callback = function(mutationsList) {
            for (const mutation of mutationsList){
                if (mutation.type === "attributes" && mutation.attributeName === "src") $7705793eefc657aa$var$attemptSetNodeSrc(mutation.target, mappings);
                else if (mutation.type === "childList") mutation.addedNodes.forEach((node)=>{
                    $7705793eefc657aa$var$attemptSetNodeSrc(node, mappings);
                    $7705793eefc657aa$var$recursivelyRemapChildNodes(node, mappings);
                });
            }
        };
        const observer = new MutationObserver(callback);
        const config = {
            attributeFilter: [
                "src"
            ],
            childList: true,
            subtree: true
        };
        observer.observe(window.document, config);
        window.document.querySelectorAll("[src]").forEach((node)=>{
            $7705793eefc657aa$var$attemptSetNodeSrc(node, mappings);
        });
    }
}
function $7705793eefc657aa$var$recursivelyRemapChildNodes(node, mappings) {
    if (node.hasChildNodes()) node.childNodes.forEach((child)=>{
        $7705793eefc657aa$var$attemptSetNodeSrc(child, mappings);
        $7705793eefc657aa$var$recursivelyRemapChildNodes(child, mappings);
    });
}
function $7705793eefc657aa$var$attemptSetNodeSrc(node, mappings) {
    if (node instanceof HTMLElement && node.hasAttribute("src")) {
        const rawSrc = node.getAttribute("src");
        const url = (0, $a0Bx7.absoluteURL)(rawSrc !== null && rawSrc !== void 0 ? rawSrc : "");
        if (url.host === window.location.host) return;
        if (node.tagName.toLowerCase() === "script") // Scripts are a special case, and need to be wholly recreated since
        // modifying a script tag doesn't refetch.
        $7705793eefc657aa$var$attemptRecreateScriptNode(node, {
            url: url,
            mappings: mappings
        });
        else {
            const newSrc = $7705793eefc657aa$export$e84bab733853880b({
                url: url,
                mappings: mappings
            }).toString();
            // Only apply the remapping if we actually remapped the value
            if (newSrc !== rawSrc) node.setAttribute("src", newSrc);
        }
    }
}
function $7705793eefc657aa$var$attemptRecreateScriptNode(node, { url: url, mappings: mappings }) {
    const newUrl = $7705793eefc657aa$export$e84bab733853880b({
        url: url,
        mappings: mappings
    });
    if (url.toString() !== newUrl.toString()) {
        // Note: Script tags cannot be duplicated via `node.clone()` because their internal 'already started'
        // state prevents the new one from being fetched. We must manually recreate the duplicate tag instead.
        const newNode = document.createElement(node.tagName);
        newNode.innerHTML = node.innerHTML;
        for (const attr of node.attributes)newNode.setAttribute(attr.name, attr.value);
        newNode.setAttribute("src", $7705793eefc657aa$export$e84bab733853880b({
            url: url,
            mappings: mappings
        }).toString());
        node.after(newNode);
        node.remove();
    }
}
function $7705793eefc657aa$export$e84bab733853880b({ url: url, mappings: mappings }) {
    const newURL = new URL(url.toString());
    for (const mapping of mappings){
        const mapped = (0, $a0Bx7.matchAndRewriteURL)({
            originalURL: newURL,
            prefix: mapping.prefix,
            target: mapping.target,
            prefixHost: window.location.host
        });
        if (mapped != null && (mapped === null || mapped === void 0 ? void 0 : mapped.toString()) !== url.toString()) return mapped;
    }
    return newURL;
}

});
parcelRegister("3aRz0", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $91b188554f6d8091$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $91b188554f6d8091$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;

});

parcelRegister("a0Bx7", function(module, exports) {

$parcel$export(module.exports, "matchAndRewriteURL", function () { return $9f43bb499e5c7f06$export$a79199ba3137e3aa; });
$parcel$export(module.exports, "absoluteURL", function () { return $9f43bb499e5c7f06$export$11fe587afbb5d544; });
/**
 * Creates a regular expression from a target string. The target string
 * may contain `{name}` tokens which will end up being translated to
 * a named group match for a series of word characters with the group named `name`
 * The substitution pattern is {a-z} because the named groups must be valid JS identifiers,
 * making items like {0} invalid.
 *
 * @returns a RegExp object
 **/ const $9f43bb499e5c7f06$var$SUBSTITUTION_REGEX = /\{([a-z]+)\}/g;
function $9f43bb499e5c7f06$var$regexFromTarget(target) {
    const regexString = target.replace($9f43bb499e5c7f06$var$SUBSTITUTION_REGEX, (match, name)=>`(?<${name}>[\\w-]+)`);
    return new RegExp(`${regexString}(/|$)`);
}
/**
 *
 * Attempts to map the actual url (i.e. google.com) to a url path, per the url
 * mappings set up in the embedded application. If the target contains `{foo}`
 * tokens, they will be replace with the values contained in the original URL,
 * via the pattern described in the prefix
 *
 * @returns  null if URL doesn't match prefix, otherwise return rewritten URL
 */ function $9f43bb499e5c7f06$export$a79199ba3137e3aa({ originalURL: originalURL, prefix: prefix, prefixHost: prefixHost, target: target }) {
    // coerce url with filler https protocol so we can retrieve host and pathname from target
    const targetURL = new URL(`https://${target}`);
    // Depending on the environment, the URL constructor may turn `{` and `}` into `%7B` and `%7D`, respectively
    const targetRegEx = $9f43bb499e5c7f06$var$regexFromTarget(targetURL.host.replace(/%7B/g, "{").replace(/%7D/g, "}"));
    const match = originalURL.toString().match(targetRegEx);
    // Null match indicates that this target is not relevant
    if (match == null) return originalURL;
    const newURL = new URL(originalURL.toString());
    newURL.host = prefixHost;
    newURL.pathname = prefix.replace($9f43bb499e5c7f06$var$SUBSTITUTION_REGEX, (_, matchName)=>{
        var _a;
        const replaceValue = (_a = match.groups) === null || _a === void 0 ? void 0 : _a[matchName];
        if (replaceValue == null) throw new Error("Misconfigured route.");
        return replaceValue;
    });
    // Append the original path
    const pathToAppend = originalURL.pathname.startsWith("/") ? originalURL.pathname.slice(1) : originalURL.pathname;
    newURL.pathname += newURL.pathname.endsWith("/") ? pathToAppend : "/" + pathToAppend;
    // Remove the target's path from the new url path
    newURL.pathname = newURL.pathname.replace(targetURL.pathname, "");
    // Add a trailing slash if original url had it, and if it doesn't already have one or if matches filename regex
    if (originalURL.pathname.endsWith("/") && !newURL.pathname.endsWith("/")) newURL.pathname += "/";
    return newURL;
}
function $9f43bb499e5c7f06$export$11fe587afbb5d544(url, protocol = window.location.protocol, host = window.location.host) {
    // If the first arg is a complete url, it will ignore the second arg
    // This call structure lets us set relative urls to have a full url with the proper protocol and host
    return new URL(url, `${protocol}//${host}`);
}

});



parcelRegister("6YzEC", function(module, exports) {

$parcel$export(module.exports, "setAuthToken", function () { return $63f56bfef132b67e$export$3c4602e16d9ace38; });
$parcel$export(module.exports, "authorize", function () { return $63f56bfef132b67e$export$be1f35f80d3e29cc; });
$parcel$export(module.exports, "register", function () { return $63f56bfef132b67e$export$6503ec6e8aabbaf; });
$parcel$export(module.exports, "checkQuest", function () { return $63f56bfef132b67e$export$67771538c8648e68; });
$parcel$export(module.exports, "questProgress", function () { return $63f56bfef132b67e$export$209f6b8fdd3e9ee1; });
const $63f56bfef132b67e$var$API_BASE = "/.proxy/acf";
let $63f56bfef132b67e$var$auth_token = "";
function $63f56bfef132b67e$export$3c4602e16d9ace38(token) {
    $63f56bfef132b67e$var$auth_token = token;
}
async function $63f56bfef132b67e$export$be1f35f80d3e29cc(code) {
    const data = await $63f56bfef132b67e$var$call("POST", "/authorize", {
        code: code
    });
    return data;
}
async function $63f56bfef132b67e$export$6503ec6e8aabbaf() {
    return await $63f56bfef132b67e$var$call("POST", "/arise/register");
}
async function $63f56bfef132b67e$export$67771538c8648e68() {
    if (!$63f56bfef132b67e$var$auth_token) throw new Error("No auth token set");
    const data = await $63f56bfef132b67e$var$call("GET", "/quest/status");
    return data;
}
async function $63f56bfef132b67e$export$209f6b8fdd3e9ee1(progress) {
    console.log("Quest progress disabled as flight ended");
// await call('POST', '/quest/progress', {
//     progress
// });
}
async function $63f56bfef132b67e$var$call(method, endpoint, body, timeout = 10000) {
    const abort = new AbortController();
    setTimeout(()=>abort.abort(), timeout);
    const res = await fetch($63f56bfef132b67e$var$API_BASE + endpoint, {
        method: method,
        headers: {
            "Content-Type": "application/json",
            "X-Auth-Token": $63f56bfef132b67e$var$auth_token,
            "X-Universe-ID": "718b65bf-9225-48da-93f2-6a7255127896"
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: abort.signal
    });
    return res.json();
}

});

parcelRegister("aooMk", function(module, exports) {

$parcel$export(module.exports, "useUITranslatedText", function () { return $f0a473e58a79e44f$export$5392ebda159e4fc8; });
$parcel$export(module.exports, "useLang", function () { return $f0a473e58a79e44f$export$b24a004ee43dce44; });

var $2PPWI = parcelRequire("2PPWI");

var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");
parcelRequire("8FY87");
function $f0a473e58a79e44f$var$TranslatedText({ translationKey: translationKey, fallback: fallback }) {
    // Implementation will be added later
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: fallback || translationKey
    });
}
function $f0a473e58a79e44f$export$840b86506f72c041({ translationKey: translationKey, fallback: fallback }) {
    const translation = $f0a473e58a79e44f$export$5392ebda159e4fc8(translationKey, fallback);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: translation
    });
}
var $f0a473e58a79e44f$export$2e2bcd8739ae039 = $f0a473e58a79e44f$var$TranslatedText;
function $f0a473e58a79e44f$export$af1b123c30a7b260(translationKey, fallback) {
    const langIso = (0, $6lYLL.useAppSelector)((state)=>state.app.langIso);
    const translations = (0, $6lYLL.useAppSelector)((state)=>state.app.translations);
    const translation = translations?.[langIso]?.[translationKey];
    if (translation) return translation;
    return fallback || "";
}
function $f0a473e58a79e44f$export$5392ebda159e4fc8(key, fallback) {
    const universeId = (0, $6lYLL.useAppSelector)((state)=>state.app.universeId);
    const fullKey = `ui-${universeId}__${key}`;
    return $f0a473e58a79e44f$export$af1b123c30a7b260(fullKey, fallback);
}
function $f0a473e58a79e44f$export$15d0e735cfac7a07(key, fallback) {
    const universeId = (0, $6lYLL.useAppSelector)((state)=>state.app.universeId);
    const fullKey = `cf-${universeId}__${key}`;
    return $f0a473e58a79e44f$export$af1b123c30a7b260(fullKey, fallback);
}
function $f0a473e58a79e44f$export$b24a004ee43dce44() {
    const translations = (0, $6lYLL.useAppSelector)((state)=>state.app.translations);
    const current = (0, $6lYLL.useAppSelector)((state)=>state.app.langIso);
    let langs = (0, $6lYLL.useAppSelector)((state)=>state.app.availableLangs);
    if (!langs) langs = [];
    else langs = [
        ...langs
    ];
    langs.unshift({
        langISO: "en-US",
        displayName: "English"
    }); // Ensure 'en' is always the first option
    const dispatch = (0, $6lYLL.useAppDispatch)();
    function setLang(langIso) {
        dispatch((0, $baXkz.setLangIso)(langIso));
    }
    return {
        current: current,
        langs: langs,
        setLang: setLang
    };
}

});



parcelRegister("4MZsN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72f31734bcc3e493$export$2e2bcd8739ae039; });

var $2PPWI = parcelRequire("2PPWI");

var $5YM0g = parcelRequire("5YM0g");
const $72f31734bcc3e493$export$6b94091403a35c61 = [
    "animated-spinner",
    "sound",
    "chat",
    "close",
    "send",
    "locked",
    "padlock",
    "play",
    "world",
    "inventory",
    "emoji",
    "arrow-downward",
    "arrow-left",
    "arrow-back",
    "menu",
    "settings",
    "profile",
    "challenge",
    "crown",
    "character",
    "backdrop",
    "faction",
    "avatar",
    "priority",
    "edit",
    "info",
    "shop",
    "box",
    "supplies",
    "bolt",
    "help",
    "pin",
    "action",
    "support",
    "life",
    "lock_open",
    "grade",
    "hand",
    "inspect",
    "fire",
    "share",
    "discord",
    "wreath",
    "shield",
    "checked-box",
    "leaderboard"
];
function $72f31734bcc3e493$export$2e2bcd8739ae039({ type: type, size: size, style: style, ...props }) {
    const lowerCaseType = typeof type === "string" ? type.toLowerCase() : "";
    function getIcon() {
        switch(lowerCaseType){
            case "animated-spinner":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                    className: $5YM0g.spinner,
                    cx: "12",
                    cy: "12",
                    r: "9",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeDasharray: "42 14"
                });
            case "sound":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M14 20.7246V18.6746C15.5 18.2413 16.7083 17.4079 17.625 16.1746C18.5417 14.9413 19 13.5413 19 11.9746C19 10.4079 18.5417 9.00794 17.625 7.77461C16.7083 6.54128 15.5 5.70794 14 5.27461V3.22461C16.0667 3.69128 17.75 4.73711 19.05 6.36211C20.35 7.98711 21 9.85794 21 11.9746C21 14.0913 20.35 15.9621 19.05 17.5871C17.75 19.2121 16.0667 20.2579 14 20.7246ZM3 14.9996V8.99961H7L12 3.99961V19.9996L7 14.9996H3ZM14 15.9996V7.94961C14.7833 8.31628 15.3958 8.86628 15.8375 9.59961C16.2792 10.3329 16.5 11.1329 16.5 11.9996C16.5 12.8496 16.2792 13.6371 15.8375 14.3621C15.3958 15.0871 14.7833 15.6329 14 15.9996ZM10 8.84961L7.85 10.9996H5V12.9996H7.85L10 15.1496V8.84961Z"
                });
            case "chat":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M12 1.5C6.1993 1.5 1.5 5.16836 1.5 9.69165C1.5 12.1631 2.90979 14.3781 5.13462 15.8781C5.13462 17.5491 5.03182 19.632 4.62063 21.575C4.48846 22.2045 5.12727 22.7175 5.67063 22.4066C7.82937 21.1708 9.89266 19.6009 11.6182 17.8677C11.7503 17.8677 11.8752 17.8833 12 17.8833C17.8007 17.8833 22.5 14.2149 22.5 9.69165C22.5 5.16836 17.7934 1.5 12 1.5ZM8.16713 8.33155C8.87937 8.33155 9.45944 8.94554 9.45944 9.69942C9.45944 10.4533 8.87937 11.0673 8.16713 11.0673C7.4549 11.0673 6.87483 10.4533 6.87483 9.69942C6.87483 8.94554 7.4549 8.33155 8.16713 8.33155ZM12 11.0595C11.2878 11.0595 10.7077 10.4455 10.7077 9.69165C10.7077 8.93777 11.2878 8.32378 12 8.32378C12.7122 8.32378 13.2923 8.93777 13.2923 9.69165C13.2923 10.4455 12.7122 11.0595 12 11.0595ZM15.8329 11.0595C15.1206 11.0595 14.5406 10.4455 14.5406 9.69165C14.5406 8.93777 15.1206 8.32378 15.8329 8.32378C16.5451 8.32378 17.1252 8.93777 17.1252 9.69165C17.1252 10.4455 16.5451 11.0595 15.8329 11.0595Z"
                });
            case "close":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M6.39984 19.1911L4.80859 17.5998L10.4086 11.9998L4.80859 6.39984L6.39984 4.80859L11.9998 10.4086L17.5998 4.80859L19.1911 6.39984L13.5911 11.9998L19.1911 17.5998L17.5998 19.1911L11.9998 13.5911L6.39984 19.1911Z"
                });
            case "send":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 20V14L11 12L3 10V4L22 12L3 20Z"
                });
            case "locked":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M5.49862 2.92828L6.55104 2L8.71794 5.49104L5.49862 2.92828ZM19.4766 11.2814L19.5262 12.4717H19.5235L19.5869 14.291L17.9511 15.5007L17.5938 16.9021L17.2324 18.2759L17.5207 18.8262L17.1718 20.2883L15.6559 20.6938L14.1649 21.1821L12.6393 21.5407L11.14 22L10.0614 21.6869L9.8007 21.6083L8.73449 21.2841L7.68346 20.1241L6.65173 18.9448L5.60207 17.7834L4.5 16.6607L4.98276 15.2289L5.56483 14.9421L5.95242 13.5627L6.39932 12.182L5.61587 10.2882L6.69863 8.80824L7.33173 7.7972C7.6807 7.66341 7.92484 7.56962 8.2738 7.43444L8.80898 7.58617L11.5083 8.411L13.4517 8.88824L13.7042 8.99583L15.6145 9.59307L15.9318 9.68273L16.2821 8.46479C16.3538 8.21376 16.3759 7.95169 16.3456 7.69238L16.238 6.77375C16.1966 6.41375 16.009 6.08823 15.7193 5.8703L15.1097 5.41237C14.8352 5.20547 14.4918 5.11306 14.1511 5.15444L13.4049 5.24409C13.0545 5.28547 12.7359 5.46616 12.5193 5.7434L11.9648 6.45513C11.9627 6.45831 11.9608 6.46149 11.9589 6.46459C11.9559 6.46956 11.9531 6.47433 11.9497 6.47858L9.86553 5.88134L10.5676 4.66064L11.8862 3.55857L13.518 3.01374L15.2297 3.18202L16.7621 3.95443L17.918 5.24271L18.4407 6.90065L18.3069 8.63445L17.8587 10.04L17.8035 10.211L18.8628 10.5062L19.17 10.8941L19.4766 11.2814ZM12.6283 17.7614L13.0352 14.502L14.4655 13.7089L12.9773 11.0234L10.2917 12.5117L11.0848 13.942L9.70277 16.9227L12.6283 17.7614ZM7.74138 6.2041L5.10965 6.01375L5.18413 7.04548L7.74138 6.2041ZM8.96348 3.15455L9.83244 2.99179L9.70279 4.54351L8.96348 3.15455Z"
                });
            case "padlock":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8H7V6C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                });
            case "play":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M9.5 16.5L16.5 12L9.5 7.5V16.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                });
            case "world":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M19.2677 4.39586C19.2221 4.34094 19.1866 4.28602 19.141 4.2311L19.1157 4.26106C17.2411 2.55349 14.7434 1.5 11.9975 1.5C6.2117 1.5 1.5 6.14337 1.5 11.8452C1.5 17.5471 6.20157 22.5 11.9772 22.5C17.7782 22.5 22.5 17.7218 22.5 11.8452C22.5 8.9194 21.2587 6.27817 19.2677 4.39586ZM11.9721 20.413C10.0013 20.413 8.19771 19.704 6.769 18.5307L6.59168 17.4422L6.80953 15.2454L7.04258 13.3281L5.93305 13.1933L4.53981 12.9037L3.73426 13.1534C3.68359 12.8238 3.6532 12.4843 3.638 12.1448C3.82545 12.5442 3.98251 12.8638 3.98251 12.8638L4.29662 11.5007L5.37575 11.3609L7.42256 11.2011L8.63848 10.9615L9.00832 8.75464L8.16731 6.34807L7.62015 5.30956C7.29083 5.3495 6.97165 5.40942 6.64741 5.47932C8.09638 4.29601 9.9608 3.58203 11.9873 3.58203C14.0139 3.58203 15.8428 4.28602 17.2867 5.44936L13.4414 6.22825L13.0969 7.2418L13.9075 7.65621L13.8112 8.07061L11.0602 9.30884L11.4098 10.0728L11.9975 9.87803L12.9449 9.60342L13.8366 10.2126L14.5965 10.0877L15.8226 10.5621L14.1 11.9151L12.4889 11.1512L11.1615 11.6755L10.3104 13.2981L11.0703 14.6812L12.7372 15.0806L13.8112 17.3074L15.5034 18.2261L16.2329 16.913L16.5268 15.6198L17.003 13.7325C17.4489 13.6476 18.4571 13.4629 18.4571 13.418C18.4571 13.383 18.0112 12.5742 17.7072 12.0349L19.369 12.5442L20.2049 13.5278C19.4399 17.4572 16.0404 20.428 11.9721 20.428V20.413Z"
                });
            case "inventory":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M21.969 14.2711C21.6312 13.2773 20.5632 13.0609 19.5797 13.115C19.4555 12.6181 19.3065 12.1311 19.1127 11.6686C19.1028 11.649 18.7253 10.7881 18.3825 10.2075C19.1724 8.67758 19.4456 6.04564 19.1227 5.67667C18.77 5.36182 18.1193 4.78132 15.417 4.51567C15.4269 4.47139 15.4319 4.42711 15.4418 4.38776C15.5462 3.82693 15.6852 3.05457 15.1438 2.41011C14.6222 1.79025 13.6089 1.5 11.9547 1.5C10.3006 1.5 9.31208 1.79517 8.81534 2.42487C8.28879 3.09392 8.48252 3.87121 8.62161 4.44187C8.62657 4.46155 8.63154 4.48615 8.63651 4.51075C5.88954 4.7764 5.23384 5.3569 4.87619 5.67667C4.55828 6.0358 4.81658 8.59887 5.58156 10.1338C5.23384 10.6995 4.81658 11.6391 4.80665 11.6637C4.61292 12.1262 4.4639 12.6132 4.34468 13.1051C3.381 13.0658 2.35772 13.3019 2.02987 14.2662C1.58281 15.5797 1.27979 17.272 1.70202 18.8511C1.92059 19.6629 2.924 20.0909 4.01186 20.3024C4.61789 22.7572 7.85166 22.4916 11.9597 22.4916C16.0677 22.4916 19.3512 22.7523 19.987 20.3024C21.0749 20.0909 22.0783 19.6629 22.2969 18.8511C22.7191 17.272 22.421 15.5797 21.969 14.2662V14.2711ZM9.85352 3.24151C9.933 3.14312 10.3155 2.82335 11.9498 2.82335C13.584 2.82335 14.0063 3.12836 14.1205 3.26119C14.2546 3.41861 14.2099 3.7187 14.1305 4.16146C14.1155 4.25001 14.0957 4.34348 14.0857 4.43203C13.4698 4.40252 12.7843 4.38284 12.0044 4.38284C11.2245 4.38284 10.5788 4.3976 9.98267 4.42711C9.96281 4.32872 9.93797 4.23033 9.91313 4.13686C9.82372 3.77774 9.7343 3.40877 9.85849 3.24151H9.85352ZM10.6831 13.4397C10.3552 13.4397 10.1118 13.1986 10.1118 12.9034V11.1275C10.1118 10.9455 10.2608 10.7979 10.4446 10.7979C10.6284 10.7979 10.7775 10.9455 10.7775 11.1275V12.4804H11.6666V12.2393C11.6666 12.0573 11.8156 11.9097 11.9994 11.9097C12.1832 11.9097 12.3323 12.0573 12.3323 12.2393V12.4804H13.2214V11.1275C13.2214 10.9455 13.3704 10.7979 13.5542 10.7979C13.738 10.7979 13.887 10.9455 13.887 11.1275V12.9034C13.887 13.1986 13.6436 13.4397 13.3158 13.4397H12.3323V13.5823C12.3323 13.7644 12.1832 13.9119 11.9994 13.9119C11.8156 13.9119 11.6666 13.7644 11.6666 13.5823V13.4397H10.6831ZM17.9752 18.5166C17.9752 19.5989 17.0861 20.4795 15.9932 20.4795H8.00565C6.91282 20.4795 6.02366 19.5989 6.02366 18.5166V12.3525H7.10655V18.5166C7.10655 19.0086 7.50891 19.407 8.00565 19.407H15.9932C16.49 19.407 16.8923 19.0086 16.8923 18.5166V12.3525H17.9752V18.5166Z"
                });
            case "emoji":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M20 7V5H18V3H20V1H22V3H24V5H22V7H20ZM15.5 11C15.9167 11 16.2708 10.8542 16.5625 10.5625C16.8542 10.2708 17 9.91667 17 9.5C17 9.08333 16.8542 8.72917 16.5625 8.4375C16.2708 8.14583 15.9167 8 15.5 8C15.0833 8 14.7292 8.14583 14.4375 8.4375C14.1458 8.72917 14 9.08333 14 9.5C14 9.91667 14.1458 10.2708 14.4375 10.5625C14.7292 10.8542 15.0833 11 15.5 11ZM8.5 11C8.91667 11 9.27083 10.8542 9.5625 10.5625C9.85417 10.2708 10 9.91667 10 9.5C10 9.08333 9.85417 8.72917 9.5625 8.4375C9.27083 8.14583 8.91667 8 8.5 8C8.08333 8 7.72917 8.14583 7.4375 8.4375C7.14583 8.72917 7 9.08333 7 9.5C7 9.91667 7.14583 10.2708 7.4375 10.5625C7.72917 10.8542 8.08333 11 8.5 11ZM12 17.5C13.1333 17.5 14.1625 17.1792 15.0875 16.5375C16.0125 15.8958 16.6833 15.05 17.1 14H6.9C7.31667 15.05 7.9875 15.8958 8.9125 16.5375C9.8375 17.1792 10.8667 17.5 12 17.5ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C12.7167 2 13.4083 2.07083 14.075 2.2125C14.7417 2.35417 15.3833 2.55833 16 2.825V7H18V9H21.55C21.7 9.48333 21.8125 9.97083 21.8875 10.4625C21.9625 10.9542 22 11.4667 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                });
            case "arrow-downward":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M11 4V16.175L5.4 10.575L4 12L12 20L20 12L18.6 10.575L13 16.175V4H11Z"
                });
            case "arrow-left":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M14 17L9 12L14 7V17Z"
                });
            case "arrow-back":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                });
            case "menu":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z"
                });
            case "settings":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M9.25 22L8.85 18.8C8.63333 18.7167 8.42916 18.6167 8.2375 18.5C8.04583 18.3833 7.85833 18.2583 7.675 18.125L4.7 19.375L1.95 14.625L4.525 12.675C4.50833 12.5583 4.5 12.4458 4.5 12.3375V11.6625C4.5 11.5542 4.50833 11.4417 4.525 11.325L1.95 9.375L4.7 4.625L7.675 5.875C7.85833 5.74167 8.05 5.61667 8.25 5.5C8.45 5.38333 8.65 5.28333 8.85 5.2L9.25 2H14.75L15.15 5.2C15.3667 5.28333 15.5708 5.38333 15.7625 5.5C15.9542 5.61667 16.1417 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4917 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1417 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.25ZM12.05 15.5C13.0167 15.5 13.8417 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8417 8.84167 13.0167 8.5 12.05 8.5C11.0667 8.5 10.2375 8.84167 9.5625 9.525C8.8875 10.2083 8.55 11.0333 8.55 12C8.55 12.9667 8.8875 13.7917 9.5625 14.475C10.2375 15.1583 11.0667 15.5 12.05 15.5Z"
                });
            case "profile":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M16.2152 15.791C16.2152 15.791 16.1097 15.8112 15.9761 15.8985C15.9129 15.5022 15.8285 14.4344 15.8004 14.1591C15.9269 14.0449 16.1238 13.83 16.2503 13.6487C16.3768 13.4674 16.7564 12.2787 16.8619 11.7616C16.9252 11.775 17.0658 11.8892 17.2274 11.7952C17.3821 11.7079 17.5157 11.3251 17.6211 11.0699C17.7055 10.855 17.9375 10.0357 17.9867 9.7133C18.0359 9.38423 18.1554 8.96114 18.0218 8.83355C17.9234 8.74624 17.7547 8.53134 17.3329 8.71938C17.4102 8.11497 17.4032 6.2883 17.2204 5.12648C17.0376 3.97138 16.2784 3.27966 15.4419 2.55437C14.5983 1.82235 13.0236 1.5 12.2293 1.5C11.4349 1.5 9.86021 1.82907 9.01663 2.55437C8.17305 3.28638 7.42086 3.97138 7.23809 5.12648C7.05531 6.28158 7.04828 8.11497 7.12561 8.71938C6.70382 8.53134 6.53511 8.73953 6.43669 8.83355C6.30313 8.96114 6.42263 9.38423 6.47184 9.7133C6.52105 10.0424 6.75303 10.855 6.83739 11.0699C6.94284 11.3251 7.06937 11.7079 7.23106 11.7952C7.38572 11.8825 7.52631 11.7683 7.59661 11.7616C7.70206 12.2787 8.08167 13.4674 8.2082 13.6487C8.33474 13.83 8.53157 14.0516 8.65811 14.1591C8.62999 14.4344 8.54563 15.5022 8.48237 15.8985C8.3488 15.8112 8.23632 15.791 8.23632 15.791C8.23632 15.791 3.35061 17.5774 2.5 18.1079C4.80578 20.7875 8.30662 22.5 12.2222 22.5C16.1378 22.5 19.6387 20.7875 21.9444 18.1079C21.0938 17.5707 16.2081 15.791 16.2081 15.791H16.2152Z"
                });
            case "challenge":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M19.723 12.3077L19.7263 12.3019L19.718 12.2991L19.723 12.3077ZM18.7885 13.9452L19.723 12.3077L20.0002 12.7888L19.9393 14.3464L18.0332 18.593L14.7853 14.706L14.1988 14.4127L12.9843 14.2827L12.7879 13.5026L12.3065 13.5662L11.9773 13.4472L12.7464 13.2453L13.2665 12.9742L13.676 11.6379L13.6013 10.6475C13.5819 10.3792 13.4657 10.1274 13.2776 9.93653L12.8571 9.51048L12.3342 9.33066C12.052 9.23383 11.7422 9.25597 11.4738 9.38876L10.8679 9.69031L10.6356 9.89226C10.3838 10.1081 10.2399 10.4234 10.2455 10.7554V11.6379L10.5858 12.9216L11.0616 13.2453L11.1363 13.2951L10.926 14.2606L10.7047 14.3685L9.74197 14.3242L9.03927 14.7198L7.08335 17.1073L6.05697 18.261L4.70138 16.6094L4.13978 14.8526L3.91016 11.1815L4.3113 9.36663L6.25616 6.57798L6.64901 6.37326L6.84266 9.47452L7.9133 10.5562L8.18995 10.5286L7.84691 8.76076L7.89947 6.96529L8.4832 5.29708L9.42382 3.78103L12.0437 1.24414L12.1405 1.43503L12.7464 4.39243L13.6234 5.57927L15.867 7.60989L17.621 10.1219L18.2186 13.1706L17.9917 14.7281L18.7885 13.9452ZM19.682 8.65296L19.5547 10.2326L18.7801 10.0667L18.2683 8.11626L18.3236 7.25034L19.682 8.65296ZM15.5295 17.8849L16.3788 18.6761L17.0815 19.2709L17.289 19.5282L14.2514 22.0983L12.052 23.2547L12.0714 22.765L14.0245 21.296L14.3067 17.3703L13.9886 16.5957L15.5295 17.8849ZM8.37254 18.0258L6.92565 19.1241L8.89817 21.08L9.77239 22.5877L9.65896 20.1643L9.50404 17.3812L9.82219 16.6536L8.37254 18.0258Z"
                });
            case "crown":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M19.6458 8.94063L20.2658 8.06277L20.2629 8.07147L20.9003 7.2052L21.5 6.39397L21.4363 7.41669L21.2016 8.48287L21.1407 9.57223L20.8742 10.6326L20.7438 11.7104L20.6859 12.7997L20.512 13.8746L20.3585 14.9524L20.1586 15.9983L19.753 16.9978L19.0432 17.8206L18.116 18.3769L17.2324 18.9853L16.2531 19.4315L15.2101 19.7038L14.1526 19.8777L13.0923 20.0167L12.5765 19.8863L12.0956 20.1326L10.9512 20.0051L9.88792 19.8892L8.84202 19.6604L7.80192 19.3967L6.83715 18.9303L5.87816 18.4493L5.03507 17.783L4.35712 16.9515L3.89646 15.9925L3.70235 14.9466L3.55459 13.8688L3.3402 12.7997L3.31702 11.7046L3.1316 10.6326L2.9172 9.56354L2.83318 8.47708L2.64486 7.4051L2.5 6.29257L3.16926 7.17622L3.73422 8.09464L4.36871 8.96091L5.0032 9.80111L4.82357 11.102L4.76273 12.4318L4.80909 12.4057L5.24947 13.4458L5.9419 14.344L6.73864 15.1581L7.7208 15.7549L7.76715 14.2368L8.67978 13.9123L9.57213 13.4139L10.3022 12.6867L10.4819 11.693L10.3109 10.7224L9.63007 10.0184L8.69137 9.75765L7.76136 9.79821L8.35819 8.89718L8.91735 7.94978L9.61558 7.0951C9.61558 7.0951 10.1574 6.96183 10.2472 6.81407C10.3312 6.675 10.2008 6.16509 10.2008 6.16509L10.7745 5.22929L11.3684 4.30507L12.0145 3.40693V3.38955L12.0203 3.39824L12.0319 3.38086V3.41852L12.6171 4.34564L13.211 5.26985L13.8658 6.1535L14.4279 7.098L15.0826 7.98165L15.6534 8.92035L16.2647 9.80401L15.3521 9.78083L14.3931 9.98363L13.7036 10.7108L13.6572 11.0469C13.6572 11.0469 13.3327 11.1164 13.3009 11.2092C13.2574 11.3395 13.5703 11.6959 13.5703 11.6959L13.7992 12.6549L14.5148 13.3589L15.384 13.8688L16.3893 14.2078L16.3169 15.7578L17.299 15.1465L18.1334 14.37L18.8403 13.4719C18.8403 13.4719 19.0866 13.0373 19.133 12.9301C19.1434 12.9054 19.1922 12.9174 19.2437 12.9301C19.307 12.9457 19.3744 12.9623 19.3792 12.9127C19.3937 12.7099 19.2489 12.4347 19.2489 12.4347L19.1909 11.1049L18.962 9.78373L19.6458 8.94063ZM10.7455 16.2387L12.0753 18.5304L13.4023 16.2387L12.0753 13.7587L11.548 14.7438C11.522 14.793 11.5104 14.8452 11.5162 14.9002C11.5278 14.9987 11.5364 15.1668 11.5017 15.2247C11.4785 15.2624 11.4061 15.3029 11.3365 15.3348C11.2438 15.3783 11.1685 15.4478 11.1221 15.5376C11.1221 15.5376 11.1656 15.7607 11.1134 15.8013C11.0874 15.8186 10.9918 15.7781 10.9918 15.7781L10.7455 16.2387ZM7.58174 6.90981L6.165 4.9368L5.47256 7.50374L6.53874 8.62787L7.58174 6.90981ZM18.6231 7.54722L17.8147 5.00925L16.2328 6.90404L17.5018 8.6105L18.6231 7.54722Z"
                });
            case "character":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M20.9792 18.246L19.9635 16.8458L18.1602 16.6116L15.225 16.8954L14.8864 16.79L17.2363 16.3232L14.8133 15.5696L14.5407 13.5289L12.6958 14.3647H11.9699V14.264L12.6958 14.1957L14.5106 13.2142L14.5192 13.2049L14.7243 13.0482C14.8664 12.9397 14.9596 12.7722 14.9826 12.5861L15.0156 12.3117L15.1461 11.6108L15.2853 11.2324L15.4029 10.6881L15.4201 10.1222L15.423 9.51895L15.5134 10.1004L15.6167 10.6525L15.7329 10.623C15.895 10.5827 16.0255 10.454 16.0786 10.2834L16.1733 9.98105L16.3483 9.39645L16.5865 8.83046L16.4401 8.33425C16.4401 8.33425 16.3397 7.95589 16.2393 7.90472C16.1245 7.8458 15.7429 8.02567 15.7429 8.02567L15.7486 7.53877L15.7458 7.03635L15.7372 6.37578L15.7271 5.87026L15.6497 5.37095L15.5234 4.8856L15.3269 4.43746L14.984 4.06685L14.5536 3.81875L14.1089 3.60476L13.6685 3.37991L13.2165 3.17833L12.7374 3.08374L12.2582 3.04342L11.7733 3L11.2827 3.01396L10.8294 3.22174L10.3631 3.37526L9.91551 3.58305L9.44783 3.75362L9.05618 4.0746L8.72191 4.44831L8.4852 4.87629L8.44216 5.38026L8.34604 5.87181L8.28435 6.37267L8.25423 7.03325L8.29009 7.53722V8.01482C8.29009 8.01482 7.89127 7.79307 7.7765 7.8644C7.67321 7.92643 7.64739 8.35596 7.64739 8.35596L7.45945 8.82891L7.64595 9.40886L7.88266 9.97019L7.93574 10.2307C7.98022 10.4431 8.14233 10.6044 8.34317 10.6308L8.45364 10.6463L8.48664 10.1454L8.5555 9.61975L8.58849 10.1702L8.71474 10.6726L8.75921 11.2278L8.92132 11.5999L8.99736 12.3148L9.10495 12.69C9.13221 12.7877 9.18099 12.8777 9.24554 12.9521L9.48799 13.2312L10.3086 13.9647L10.1766 14.0438L9.45787 13.5367L9.18673 15.5696L6.89565 16.2829L9.21111 16.79L8.91558 16.8815L5.83978 16.6116L4.03647 16.8458L3.02076 18.246L2.5 20.1688L11.9397 20.9891V21L12 20.9953L12.0603 21V20.9891L21.5 20.1688L20.9792 18.246Z"
                });
            case "backdrop":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M18.5472 5.40563L15.0007 3.81341C15.0007 3.81341 10.6842 5.05517 9.46405 4.32829C9.42509 4.30524 9.21221 4.31539 8.97619 4.32664C8.59189 4.34497 8.14623 4.36621 8.29008 4.25185C8.9737 3.70669 10.4419 3.42257 10.4419 3.42257L10.7072 3.0101L9.33281 3C9.33281 3 7.34976 3.5293 6.48154 4.02542C6.16858 4.20425 5.43737 5.03497 5.43737 5.03497L4.33119 6.87958L3.35913 11.1385L3.75286 12.4869C3.75286 12.4869 4.01534 11.2697 4.26917 10.9639C4.35571 10.8587 4.77251 10.2962 4.77251 10.2962C4.77251 10.2962 4.07015 12.2893 4.54608 14.0287C4.56771 14.1065 4.39465 14.2969 4.39465 14.2969L4.10332 14.1859C4.10332 14.1859 3.00723 13.4431 2.81253 12.9138C2.64523 12.4595 2.28323 11.0303 2.28323 11.0303L1.78711 10.1967L1.81307 12.7566C1.81307 12.7566 2.47649 14.3935 2.95964 14.6459L5.3018 16.6564L5.61044 17.3357L7.89492 14.5464L8.91601 13.9695L10.3193 14.033L10.6423 13.8772L10.9481 12.4725L10.8399 12.4004L10.1477 11.9288L9.65443 10.0611L9.64866 8.77465C9.64722 8.29295 9.85634 7.83433 10.2212 7.51848L10.5616 7.22571L11.4428 6.78583C11.8322 6.59113 12.285 6.56084 12.6961 6.70362L13.4561 6.96467L14.0691 7.58482C14.3445 7.86317 14.5118 8.22949 14.5407 8.61889L14.6503 10.0611L14.0532 12.0052L13.2989 12.4004L12.1783 12.6932L12.6557 12.8648L13.3566 12.7725L13.6436 13.9104L15.4132 14.1022L16.267 14.5306L19.2394 18.0871L19.9879 16.3694C19.9879 16.3694 19.5279 15.3267 19.6476 14.9228C19.7666 14.5202 20.1692 14.1365 20.5317 13.7909C20.7536 13.5794 20.9605 13.3822 21.0783 13.2037C21.4446 12.6456 21.8787 10.6394 21.8787 10.6394L18.5486 5.4013L18.5472 5.40563ZM6.59548 7.82711L4.93548 9.8693L4.91961 9.8794L5.51381 8.24247L6.04599 6.80025L7.36129 5.92771L6.59692 7.82856L6.59548 7.82711ZM19.7456 12.1451L19.5654 11.9201L19.2986 10.9308C19.2986 10.9308 19.2207 10.5572 19.1731 10.4404C18.6827 9.26212 16.5252 6.0027 16.5252 6.0027L17.3155 6.23058L19.6692 8.35208L20.6398 9.98179L19.7485 12.1451H19.7456ZM15.0959 17.2838L15.5618 18.4087L15.4724 20.7321L16.668 20.4206L17.7756 19.5654L17.3386 19.1601L15.0959 17.2838ZM6.74402 19.5005L6.92286 19.3635L9.02994 17.3674L8.56699 18.4275L8.70256 20.8403L6.74402 19.5005Z"
                });
            case "faction":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M20.5 6.34303L19.8069 5.47262L19.0069 5.48276L18.2435 5.25972L17.471 5.08883L16.7275 4.82669L16.0221 4.482L15.329 4.11848L14.6924 3.67097L14.0405 3.23938L13.5076 2.6789L12.929 2.16041L12.4802 1.5L11.6618 1.59993L11.1382 2.13579L10.6695 2.74986L10.0908 3.27124L9.45267 3.726L8.75649 4.09241L8.10458 4.524L7.38397 4.84262L6.62366 5.06131L5.87099 5.30317L5.08931 5.43786L4.29695 5.4929L3.5 6.34738L3.52748 7.13669L3.62824 7.92166L3.72595 8.70662L3.7 9.49738L3.70305 10.2867L3.84809 11.0702L3.88168 11.8581L3.92748 12.6459L3.97786 13.4338L4.0145 14.2231L4.10763 14.9661L4.24656 15.7047L4.45725 16.4332L4.83893 17.095L5.24504 17.741L5.77176 18.3014L6.27863 18.888L6.96565 19.2747L7.58092 19.7034L8.19313 20.1379L8.86794 20.4811L9.51069 20.8707L10.1626 21.2458L10.7687 21.6875L11.3931 22.1046L12.0511 22.5L12.6878 22.0742L13.3092 21.6557L13.9611 21.2791L14.5901 20.8692L15.2328 20.4811L15.9046 20.1335L16.5244 19.7092L17.1412 19.2819L17.7672 18.8257L18.3427 18.313L18.9061 17.7743L19.3305 17.1298L19.5962 16.4143L19.8496 15.7032L20.0802 14.9791L20.1748 14.2274L20.1244 13.4352L20.2435 12.6503L20.3015 11.8639L20.3458 11.076L20.3977 10.2881L20.4466 9.50028L20.4588 8.71097L20.4969 7.9231L20.4756 7.13234L20.4969 6.34303H20.5ZM5.82366 15.8032L5.74885 15.6743L5.57328 15.0718L5.45878 14.4592L5.38244 13.8437L5.35191 13.1905L5.31069 12.5373L5.27252 11.8841L5.24504 11.231L5.12443 10.5821V9.92752L5.14427 9.27145L5.06336 8.62117L4.97939 7.9709L4.95649 7.31772L5.61756 6.60952L6.27405 6.56462L6.92137 6.4531L7.54427 6.25179L8.17481 6.07076L8.77176 5.80572L9.31221 5.448L9.88931 5.14386L10.4176 4.76731L10.8969 4.33572L11.1473 4.00841V5.63048L11.0832 5.71448L10.6847 6.07366L10.245 6.38648L9.76565 6.63848L9.31679 6.93683L8.82061 7.15697L8.29695 7.30759L7.77939 7.47414L7.24046 7.56683L6.69542 7.60448L6.14733 8.19248L6.16565 8.73559L6.23435 9.27579L6.30153 9.816L6.28321 10.3606V10.9037L6.3855 11.4424L6.4084 11.9855L6.44046 12.5286L6.47557 13.0717L6.50153 13.6148L6.56565 14.1261L6.66183 14.6344L6.80687 15.1355L5.82519 15.8046L5.82366 15.8032ZM16.7779 17.657L16.2588 18.035L15.7473 18.3898L15.2344 18.7417L14.6771 19.0299L14.1443 19.3514L13.6237 19.6903L13.0832 20.0017L12.5672 20.3493L12.0405 20.7027L11.4939 20.3754L10.9763 20.0292L10.474 19.6628L9.93359 19.3514L9.40229 19.0285L8.84351 18.7446L8.33664 18.3854L7.82672 18.0292L7.25725 17.7091L6.8374 17.2239L6.7687 17.1501L7.75649 16.4781L8.05878 16.8271L8.53206 17.0936L8.95496 17.389L9.37634 17.6874L9.84046 17.9234L10.2832 18.1914L10.7321 18.4492L11.1504 18.7533L11.5809 19.0401L12.0344 19.3123L12.4725 19.0183L12.9 18.7301L13.3489 18.4709L13.7824 18.1885L14.2252 17.922L14.6878 17.683L15.1137 17.3905L15.5382 17.0965L15.9687 16.7822L16.1901 16.5852L17.2038 17.2746L16.7763 17.6555L16.7779 17.657ZM19.042 8.62407L19.0099 9.27724L19.0008 9.93186L18.9595 10.585L18.9168 11.2368L18.8802 11.8899L18.8313 12.5417L18.7321 13.1919L18.7733 13.848L18.6939 14.4708L18.5031 15.0703L18.2924 15.6598L18.184 15.9538L17.1763 15.2673L17.2298 15.1239L17.4038 14.6344L17.5626 14.1362L17.6282 13.6177L17.5931 13.0717L17.6756 12.5315L17.7153 11.9899L17.7458 11.4468L17.7824 10.9051L17.816 10.3634L17.8237 9.82035L17.8496 9.27724L17.8359 8.73269L17.8511 8.18814L17.3733 7.58855L16.8221 7.59579L16.2954 7.44228L15.7641 7.32497L15.2511 7.14393L14.7656 6.90641L14.2893 6.65586L13.8511 6.34738L13.4023 6.05048L13.0359 5.66379L12.8496 5.49724V3.92007L13.2466 4.27634L13.6878 4.74124L14.2282 5.09897L14.755 5.46972L15.329 5.77097L15.9137 6.05628L16.5305 6.27352L17.1702 6.414L17.8038 6.59793L18.4664 6.58924L19.0405 7.31048L19.0221 7.9651L19.0389 8.62117L19.042 8.62407Z"
                });
            case "avatar":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3.14639 10.8991L3.31817 10.2518L3.37646 9.99259L3.47769 9.74718L3.54671 9.48951L3.66175 9.25023L3.79212 9.02016L3.92709 8.79316L4.25993 8.3591L4.00225 9.00636L3.87801 9.6751L3.76758 10.3438L3.68782 10.9267L4.58356 10.9865L4.73694 10.261L4.99922 9.58307L5.2891 8.91587L5.67102 8.29775L6.10201 7.71491L6.56062 7.15047L7.12199 6.68726L7.68029 6.21945L8.31835 5.86821L8.97175 5.54919L9.64508 5.27157L10.3522 5.09211L11.0746 4.99395L11.8031 4.98782L12.5302 4.99395L13.2526 5.09211L13.9489 5.30838C13.9489 5.30838 14.6483 5.26543 14.8723 5.35746C15.0855 5.44642 15.3017 5.83907 15.3017 5.83907L15.9168 6.22866L16.4827 6.68419L17.0318 7.15967L17.5242 7.69497L17.9598 8.27934L18.3279 8.9082L18.6362 9.56773L18.8693 10.2579L19.0273 10.9727L19.9246 10.9359L19.8786 10.3377L19.7175 9.67663L19.5733 9.01403L19.3724 8.36984L19.6623 8.80237L19.8233 9.0125L19.9415 9.25023L20.0534 9.49104L20.1454 9.73952L20.2175 9.99566L20.3203 10.2426L20.4583 10.9006L21.0826 10.8699L21.7268 10.8592L21.5703 10.1812L21.443 9.50791L21.2007 8.86679L20.9584 8.22566L20.6654 7.60601L20.2896 7.03237L19.9215 6.45566L19.5151 5.90503C19.5151 5.90503 18.6837 5.95104 18.5227 5.75932C18.3908 5.60133 18.5488 4.9372 18.5488 4.9372L18.0426 4.47553L17.4828 4.08134L16.9137 3.70096L16.3079 3.38193L15.6867 3.09511L15.0502 2.84357L14.4014 2.62117L13.7219 2.5L9.8322 2.50307L9.12513 2.65645L8.43492 2.87425L7.76618 3.44175L7.11892 3.46936L6.487 3.81753L5.89802 4.23472L5.32745 4.67646L4.77988 5.14887L4.30901 5.69796L3.85194 6.25473L3.4056 6.82224L3.03442 7.44342L2.70466 8.08608L2.44698 8.76095L2.18163 9.43276L1.99911 10.1322L1.89941 10.8377L2.51907 10.9006L3.14332 10.896L3.14639 10.8991ZM20.4891 13.571L20.3173 14.2183L20.259 14.4775L20.1578 14.7229L20.0887 14.9805L19.9737 15.2198L19.8433 15.4499L19.7084 15.6769L19.3755 16.111L19.6332 15.4637L19.7574 14.795L19.8679 14.1262L19.9476 13.5434L19.0519 13.4836L18.8985 14.209L18.6362 14.887L18.3463 15.5542L17.9644 16.1723L17.5334 16.7552L17.0748 17.3196L16.5135 17.7828L15.9552 18.2506L15.3171 18.6018L14.6637 18.9209L13.9904 19.1985L13.2833 19.3779L12.5609 19.4761L11.8323 19.4822L11.1053 19.4761L10.3829 19.3779L9.68653 19.1617C9.68653 19.1617 8.98712 19.2046 8.76319 19.1126C8.54999 19.0236 8.33372 18.631 8.33372 18.631L7.71867 18.2414L7.1527 17.7859L6.6036 17.3104L6.11125 16.7751L5.67565 16.1907L5.30754 15.5619L4.99925 14.9023L4.76611 14.2121L4.60813 13.4974L3.71086 13.5342L3.75688 14.1324L3.91792 14.7934L4.0621 15.456L4.26303 16.1002L3.97314 15.6677L3.81209 15.4576L3.69399 15.2198L3.58202 14.979L3.49 14.7305L3.41791 14.4744L3.31514 14.2275L3.1771 13.5695L2.55285 13.6001L1.90865 13.6109L2.0651 14.2888L2.1924 14.9621L2.43474 15.6033L2.67708 16.2444L2.97004 16.864L3.34582 17.4377L3.71393 18.0144L4.12039 18.565C4.12039 18.565 4.9517 18.519 5.11275 18.7107C5.24466 18.8687 5.08668 19.5329 5.08668 19.5329L5.59283 19.9945L6.15266 20.3887L6.7217 20.7691L7.32755 21.0881L7.94874 21.3749L8.58527 21.6265L9.23406 21.8489L9.91353 21.9701L13.8032 21.967L14.5103 21.8136L15.2005 21.5958L15.8693 21.0283L16.5165 21.0007L17.1484 20.6525L17.7374 20.2353L18.308 19.7936L18.8556 19.3212L19.3264 18.7721L19.7835 18.2153L20.2298 17.6478L20.601 17.0266L20.9308 16.384L21.1885 15.7091L21.4538 15.0373L21.6363 14.3379L21.736 13.6323L21.1164 13.5695L20.4921 13.5741L20.4891 13.571ZM16.2487 15.1524L16.2496 15.1523H16.2481L16.2487 15.1524ZM14.1376 15.341L16.2487 15.1524L17.2788 15.2765C16.6607 16.3855 15.7143 17.2858 14.5716 17.8487C13.7403 18.2582 12.8062 18.4883 11.8169 18.4883C10.8276 18.4883 9.89356 18.2567 9.06225 17.8487C7.91957 17.2858 6.97322 16.3855 6.3551 15.2765L7.38581 15.1523L9.59907 15.3318L9.81227 15.2704L8.14657 14.933L9.7954 14.459L9.99019 13.1062L10.5071 13.4437L10.6022 13.3915L10.0117 12.9038L9.83681 12.7182C9.7908 12.6676 9.75552 12.6077 9.73558 12.5433L9.65889 12.2933L9.60368 11.8178L9.48711 11.5709L9.4549 11.2013L9.3644 10.8669L9.33986 10.5003L9.28925 10.85L9.26471 11.1844L9.18495 11.1752C9.04077 11.1568 8.92421 11.0494 8.892 10.9083L8.85365 10.735L8.6834 10.3623L8.54996 9.97575L8.68493 9.66132C8.68493 9.66132 8.70334 9.37604 8.77696 9.33462C8.85979 9.28708 9.14661 9.43432 9.14661 9.43432V9.11682L9.12053 8.78092L9.142 8.34072L9.18648 8.00789L9.25551 7.67966L9.28618 7.34529L9.45643 7.06L9.6957 6.81153L9.97792 6.5968L10.3138 6.4833L10.6359 6.34526L10.9703 6.24402L11.297 6.10598L11.6498 6.09678L11.9995 6.12592L12.3446 6.152L12.6897 6.21488L13.0148 6.34832L13.3323 6.4971L13.6514 6.63974L13.9612 6.80539L14.2081 7.05234L14.3492 7.35143L14.4397 7.67506L14.4949 8.00636L14.5026 8.34226L14.5088 8.78246L14.5118 9.11682L14.5088 9.44199C14.5088 9.44199 14.7833 9.32235 14.8661 9.3607C14.9382 9.39444 15.0103 9.64598 15.0103 9.64598L15.1161 9.97575L14.9444 10.3531L14.8186 10.7426L14.7511 10.9436C14.7143 11.0571 14.6192 11.143 14.5026 11.169L14.4183 11.189L14.3446 10.8209L14.2802 10.4344L14.2772 10.8362L14.2649 11.212L14.1805 11.574L14.0808 11.8255L13.9873 12.2918L13.9627 12.4743C13.9459 12.5985 13.8799 12.7105 13.7771 12.7826L13.6299 12.8869L13.6238 12.893L12.317 13.5464L11.7955 13.5924V13.6584H12.317L13.6452 13.1016L13.8416 14.459L15.5839 14.9606L13.8937 15.2704L14.1376 15.341Z"
                });
            case "priority":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M9 21C7.33333 21 5.91667 20.4167 4.75 19.25C3.58333 18.0833 3 16.6667 3 15V9C3 7.33333 3.58333 5.91667 4.75 4.75C5.91667 3.58333 7.33333 3 9 3H15C16.6667 3 18.0833 3.58333 19.25 4.75C20.4167 5.91667 21 7.33333 21 9V15C21 16.6667 20.4167 18.0833 19.25 19.25C18.0833 20.4167 16.6667 21 15 21H9ZM11 16L17 10L15.6 8.6L11 13.2L8.8 11L7.4 12.4L11 16Z"
                });
            case "edit":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z"
                });
            case "info":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                });
            case "shop":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M19.8247 7.82562L20.4112 8.9925L20.5 10.1151L20.072 11.1112L19.4125 12.0504L18.3409 12.5248L17.2091 12.3224L16.1501 11.9714L15.4368 11.1239L14.8915 10.1404V9.93486L14.3683 11.1903L13.3189 12.0061L12.0539 12.3793L10.7921 12.022L9.73629 11.2093L9.32096 9.92853L9.26389 10.1689L8.62663 11.3168L7.62477 12.1168L6.36292 12.6133L5.03767 12.2149L4.1658 11.1998L3.5 10.0297L3.69023 9.37197L4.35285 8.09442L4.76818 6.70934L5.52592 5.47289L6.0649 4.14158L7.60257 3.00632L8.88344 3.25931L10.1675 3.06957L11.4483 3.06008L12.7292 3L14.0132 3.23085L15.2656 3.07589L16.5211 3.10435L17.4595 3.54707L18.2712 4.2238L18.585 5.51084L19.2635 6.64293L19.8247 7.82562ZM19.5964 14.5867L19.644 15.8832L19.8405 17.1766L19.5869 18.4731L19.7771 19.7696L19.1272 20.44L17.7036 20.5001L16.2801 20.2724L14.8597 20.4274L14.5681 20.38L14.7456 20.0701L14.5205 18.802L14.7393 17.5371L14.5649 16.269L14.5205 15.0041L14.0513 14.574L12.7292 14.457L11.4071 14.4064L10.085 14.5804L9.68555 14.9883L9.46679 16.2564L9.53654 17.5213L9.43826 18.7893L9.58093 20.0574L9.54288 20.3515L9.29876 20.1966L7.86254 20.4274L6.42632 20.4748L4.98693 20.2977L4.45747 19.8266L4.5399 18.5111L4.2926 17.1924L4.29577 15.8769L4.47966 14.5582L4.58111 13.2427L4.44478 13.1194L5.67175 13.6095L7.00017 13.5463L8.26202 13.17L9.27022 12.2466L10.5004 13.3028L12.0634 13.6443L13.5408 13.1067L14.8629 12.1865L15.8775 13.1763L17.1678 13.4198L18.4455 13.4609L19.7074 13.1099L19.7961 13.2902L19.5964 14.5867Z"
                });
            case "box":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M11 21.9581V12.5448L2.79675 7.82434V15.9331C2.79675 16.3476 2.89717 16.7268 3.098 17.0706C3.299 17.4144 3.57775 17.6899 3.93425 17.8971L11 21.9581ZM13 21.9581L20.0658 17.8971C20.4223 17.6899 20.701 17.4144 20.902 17.0706C21.1028 16.7268 21.2032 16.3476 21.2032 15.9331V7.81234L13 12.5391V21.9581ZM17.0647 7.89709L20.1102 6.12434L13.1375 2.11935C12.781 1.91218 12.4018 1.80859 12 1.80859C11.5982 1.80859 11.219 1.91218 10.8625 2.11935L8.93525 3.22059L17.0647 7.89709ZM11.994 10.8198L15.0527 9.07209L6.94825 4.37059L3.85875 6.14934L11.994 10.8198Z"
                });
            case "supplies":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M17.9951 3.02625L17.9973 3.02628L17.9885 3.01752L17.9951 3.02625ZM17.9951 3.02625L17.1563 3.0146L16.3211 3.02628L15.4859 3.04088L14.6507 3.04672L13.8156 3.03796L12.9804 3.0438L12.1452 3.05256L11.3071 3L10.472 3.04088L10.0865 3.74173L9.67475 4.43381L9.32141 5.15801L8.91842 5.8647L8.2497 6.28228L7.62186 6.74659L7.00862 7.22842L6.3399 7.63433L5.71498 8.10448L5.06086 8.56003L5.07838 9.40688L5.07254 10.2391V11.0714L5.07838 11.9036L5.1105 12.7359L5.07254 13.5681L5.06086 14.4004L5.1105 15.2326L5.0959 16.0649L5.0667 16.8971L5.0959 17.7294V18.5646L5.07838 19.4027L5.62154 19.9429L6.17637 20.4656L6.75749 20.9416L7.5839 20.9708H8.42199L9.26008 20.9679L10.0982 20.9737L10.9363 20.9971L11.7744 20.9912L12.6125 20.9737L13.4535 21L14.2916 20.9883L15.1296 20.9591L15.9707 20.9445L16.8117 20.9883L17.6556 20.9825L18.1871 20.4276L18.774 19.9341L19.3172 19.3997L19.2909 18.5792L19.3201 17.7557L19.3464 16.9322L19.3522 16.1087L19.3084 15.2852L19.3347 14.4617L19.3055 13.6382L19.2938 12.8147L19.323 11.9912L19.3435 11.1677L19.3259 10.3443L19.2938 9.52077L19.3552 8.69727L19.3318 7.87378L19.2938 7.05029L19.3084 6.2268L19.3201 5.40039L19.2938 4.58566L18.8821 4.05711L18.4032 3.56944L17.9951 3.02625ZM16.1137 13.6177L16.105 14.3595L15.7925 14.6836L15.1676 14.6982L14.5427 14.7041L13.7309 14.9143L13.141 15.513L12.9337 16.3219L12.8811 16.9468L12.922 17.5717L12.5803 17.9192L11.8357 17.8988L11.4648 17.5717L11.4707 16.9468L11.5203 16.3219L11.2896 15.5042L10.6734 14.9348L9.87332 14.6632L9.2484 14.6807L8.62348 14.6661L8.29934 14.3624L8.30518 13.6178L8.62348 13.2995L9.2484 13.2907L9.87332 13.2586L10.6939 13.0775L11.3071 12.4818L11.4794 11.6554L11.494 11.0305L11.5232 10.4056L11.8386 10.061H12.5832L12.9074 10.4056L12.8899 11.0305V11.6554L13.1644 12.4526L13.7309 13.0629L14.5427 13.279H15.1676L15.7925 13.282L16.1137 13.6177ZM15.3049 6.43121L16.0641 6.44289L16.0699 6.43997L16.4963 5.65737L16.9343 4.87184L17.349 4.10383L16.6073 4.10967L15.8363 4.12719L15.0654 4.06879L14.2945 4.10091L13.5235 4.11259L12.7526 4.06295L11.9817 4.05711L11.2166 4.10091L10.7727 4.87476L10.3493 5.66321L9.96093 6.43705L10.6968 6.46918L11.4648 6.46042L12.2328 6.45458L13.0008 6.46334L13.7688 6.4575L14.5369 6.44289L15.3049 6.43121ZM7.44665 5.0993L7.99272 5.87899L7.32984 6.33454L6.66696 6.79593L6.00408 7.2544L5.34412 7.71287L4.80097 6.93026L4.25781 6.15057L4.92069 5.68626L5.5865 5.22779L6.24938 4.77516L6.90934 4.31961L7.44665 5.0993Z"
                });
            case "bolt":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M18.3539 11.6461L18.1038 11.3233L17.5603 10.3523L17.0577 9.3566L16.5864 8.22785L16.2641 9.2802L16.1391 10.2931L15.1627 11.0547L14.4701 12.0676L13.5395 12.9918L13.8473 11.6634L14.4268 10.5272L14.7178 9.29992L15.004 8.07258L15.2974 6.84525L15.7399 5.66475L16.0693 4.44974L16.4252 3.24212L16.9327 2L15.7375 2.52987L14.7275 3.26923L13.5178 3.57976L12.4285 4.14906L11.3367 4.71098L10.2569 5.30493L9.20361 5.95309L8.09499 6.48543L7.72705 6.62344C7.22685 6.81075 6.83727 7.21986 6.66894 7.73741L6.58236 8.00111L6.18798 9.06332L5.82485 10.1354L5.49299 11.2173L5.17074 12.3042L5 13.4305L5.81283 14.4853L6.8012 15.4538L8.47976 15.3996L9.23246 14.5346L9.85771 13.5956L10.3146 12.5334L10.9471 11.5969L11.6156 10.8575L11.3367 11.8901L10.9014 13.009L10.6874 14.1994L10.2545 15.3183L9.98757 16.4914L9.61723 17.6325L9.14108 18.739L8.79719 19.8875L8.46773 21.0409L8.31142 21.8246C8.28497 21.9552 8.43166 22.0514 8.53747 21.97L9.17956 21.4771L10.0068 20.5924L10.8749 19.752L11.6974 18.8623L14.309 16.3509L15.2757 15.6214L16.0717 14.7022L17.7647 12.9721L18.1856 12.6886C18.527 12.4594 18.604 11.9789 18.3491 11.6486L18.3539 11.6461Z"
                });
            case "help":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M11.9321 18.0001C12.2981 18.0001 12.609 17.8723 12.8646 17.6166C13.1201 17.3611 13.2479 17.0501 13.2479 16.6836C13.2479 16.3171 13.1201 16.0073 12.8646 15.7541C12.609 15.5011 12.2981 15.3746 11.9321 15.3746C11.5663 15.3746 11.2555 15.5011 10.9999 15.7541C10.7442 16.0073 10.6164 16.3171 10.6164 16.6836C10.6164 17.0501 10.7442 17.3611 10.9999 17.6166C11.2555 17.8723 11.5663 18.0001 11.9321 18.0001ZM10.9664 14.1501H12.9359C12.9359 13.6161 12.9994 13.1888 13.1264 12.8681C13.2534 12.5475 13.5986 12.12 14.1621 11.5859C14.5835 11.1685 14.9181 10.761 15.1661 10.3631C15.4141 9.96529 15.5381 9.48704 15.5381 8.92838C15.5381 7.98021 15.2005 7.25313 14.5251 6.74713C13.8498 6.24113 13.0455 5.98813 12.1121 5.98813C11.1461 5.98813 10.3574 6.24812 9.74587 6.76812C9.13421 7.28796 8.70771 7.90987 8.46637 8.63387L10.2479 9.32563C10.3392 9.01763 10.5257 8.69063 10.8074 8.34463C11.0892 7.99863 11.5141 7.82563 12.0821 7.82563C12.5676 7.82563 12.9338 7.96154 13.1806 8.23338C13.4273 8.50504 13.5506 8.80396 13.5506 9.13013C13.5506 9.44346 13.4536 9.74296 13.2596 10.0286C13.0656 10.3143 12.8325 10.5702 12.5604 10.7964C11.843 11.4384 11.398 11.933 11.2254 12.2804C11.0527 12.6275 10.9664 13.2508 10.9664 14.1501ZM12.0001 22.2034C10.585 22.2034 9.25713 21.9357 8.01663 21.4004C6.77596 20.865 5.69679 20.1386 4.77912 19.2211C3.86162 18.3035 3.13521 17.2243 2.59987 15.9836C2.06454 14.7431 1.79688 13.4153 1.79688 12.0001C1.79688 10.585 2.06454 9.25712 2.59987 8.01662C3.13521 6.77596 3.86162 5.69679 4.77912 4.77912C5.69679 3.86162 6.77596 3.13521 8.01663 2.59987C9.25713 2.06454 10.585 1.79688 12.0001 1.79688C13.4153 1.79688 14.7431 2.06454 15.9836 2.59987C17.2243 3.13521 18.3035 3.86162 19.2211 4.77912C20.1386 5.69679 20.865 6.77596 21.4004 8.01662C21.9357 9.25712 22.2034 10.585 22.2034 12.0001C22.2034 13.4153 21.9357 14.7431 21.4004 15.9836C20.865 17.2243 20.1386 18.3035 19.2211 19.2211C18.3035 20.1386 17.2243 20.865 15.9836 21.4004C14.7431 21.9357 13.4153 22.2034 12.0001 22.2034Z"
                });
            case "pin":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M16 12L18 14V16H13V22L12 23L11 22V16H6V14L8 12V5H7V3H17V5H16V12Z"
                });
            case "action":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M16.8367 13.2808L18.0772 13.1784L18.0717 13.1811C18.1217 13.2016 18.168 13.2184 18.2167 13.236L18.2489 13.2476L19.9131 14.9256C19.8475 15.0673 19.8304 15.1056 19.789 15.1984L19.7889 15.1986L19.7888 15.1987L19.7888 15.1988L19.7887 15.1991L19.7414 15.305L15.8066 15.0779C15.7685 15.1227 15.739 15.1566 15.7112 15.1887L15.7111 15.1888L15.7111 15.1888C15.6702 15.2359 15.6328 15.279 15.5768 15.3465L16.1167 17.894C15.9967 17.9679 15.8767 18.0408 15.7568 18.1128L14.5605 17.1187C14.4923 17.1517 14.4482 17.1733 14.4088 17.1926C14.349 17.2219 14.3002 17.2458 14.195 17.2959L14.2975 22.1832C14.1089 22.2196 14.1011 22.2213 13.9943 22.2432L13.9943 22.2432L13.9942 22.2432L13.994 22.2433L13.9939 22.2433L13.8683 22.2691L11.4316 16.1634C11.3165 16.1859 11.269 16.1957 11.2243 16.205C11.1753 16.2151 11.1297 16.2246 11.0024 16.2492L11.019 17.3291C10.9968 17.3873 10.9774 17.4371 10.9525 17.4925L9.62338 18.7967L9.54842 18.7667L9.54841 18.7667C9.43317 18.7205 9.39539 18.7054 9.24403 18.6472L9.14988 16.5704C9.09034 16.5289 9.04811 16.4991 9.00588 16.4693C8.96366 16.4396 8.92143 16.4098 8.8619 16.3683L5.7606 17.3264C5.69831 17.2364 5.66923 17.1935 5.64016 17.1505C5.61108 17.1076 5.58201 17.0647 5.5197 16.9747L7.2531 14.7678C7.22107 14.7026 7.19932 14.6589 7.1801 14.6202L7.17998 14.62C7.14941 14.5585 7.12516 14.5098 7.07589 14.4078L0.203188 14.3967C0.172704 14.231 0.167128 14.2029 0.151282 14.123L0.151258 14.1229C0.144077 14.0867 0.134786 14.0398 0.120117 13.9648L5.65538 11.7717L5.69553 11.7634L5.73568 11.7551H7.30849C7.3335 11.6586 7.34622 11.6088 7.35722 11.5656L7.35723 11.5656L7.35727 11.5654C7.37181 11.5084 7.38338 11.4631 7.41648 11.337L5.44217 10.246C5.47726 10.1056 5.48789 10.0653 5.50577 9.99754L5.50578 9.99749L5.50579 9.99747C5.51612 9.95831 5.52887 9.90997 5.55016 9.82786H7.38048C7.42201 9.74758 7.44693 9.69981 7.47184 9.65206C7.49677 9.60428 7.52169 9.55651 7.56323 9.4762L4.28472 4.76056C4.39711 4.64264 4.42001 4.61913 4.47251 4.56519L4.47252 4.56518L4.47259 4.56511L4.47287 4.56482L4.4731 4.56459C4.49941 4.53755 4.53322 4.50283 4.58931 4.4449L8.68469 7.04777C8.69207 7.05516 8.69915 7.06254 8.70622 7.06993C8.72038 7.08469 8.73453 7.09946 8.75114 7.11423L9.44063 8.17476C9.56242 8.12872 9.60614 8.11136 9.65511 8.09191L9.65513 8.0919C9.69745 8.07509 9.7437 8.05672 9.84767 8.01693L9.54308 6.19491L9.57914 6.17558C9.73429 6.09237 9.74148 6.08852 9.91967 5.99555L10.9331 6.98132L11.0346 6.94416L11.0346 6.94416C11.1284 6.90979 11.1758 6.8924 11.3097 6.84563L11.8718 1.77279C12.0593 1.76681 12.0715 1.76657 12.161 1.76484L12.3149 1.76172L13.1068 6.9287C13.2093 6.964 13.2629 6.98297 13.3263 7.00543L13.3263 7.00545C13.3674 7.01999 13.4126 7.036 13.4779 7.05885L15.9506 4.82702C16.0326 4.88209 16.0755 4.91039 16.1121 4.93457L16.1122 4.93464L16.1122 4.93467L16.1122 4.93468L16.1123 4.93471C16.1621 4.9676 16.2005 4.99296 16.3106 5.06792L14.7433 9.3599C14.8291 9.42632 14.8699 9.45816 14.9107 9.48998L14.9109 9.49008L14.9109 9.49013L14.911 9.49017C14.9518 9.52197 14.9926 9.55382 15.0783 9.62019L18.1215 7.57389C18.2311 7.69411 18.2527 7.71725 18.2986 7.76657L18.2986 7.76658L18.2987 7.76665C18.3247 7.79456 18.3585 7.83086 18.4205 7.89786L16.8505 9.9137L16.8998 10.0037L16.8999 10.0038C16.952 10.0991 16.9732 10.1379 17.0499 10.2737L23.8921 9.53989C23.9165 9.63615 23.9291 9.68473 23.9388 9.72205L23.9388 9.72225L23.9388 9.72234C23.9545 9.78253 23.9625 9.81361 24.0001 9.96908L16.7342 12.8516L16.7694 12.9966C16.7916 13.0881 16.7941 13.0982 16.8367 13.2808ZM13.4585 13.2421C13.4779 13.2116 13.4972 13.1811 13.5166 13.1479H13.5139L14.9814 11.7856C14.9554 11.6903 14.9436 11.6416 14.9288 11.5812L14.9287 11.581C14.9199 11.5449 14.9101 11.5046 14.8956 11.4477L12.9545 10.9493C12.9393 10.941 12.9234 10.9313 12.9074 10.9216C12.8915 10.9119 12.8756 10.9022 12.8604 10.8939L11.498 9.42636C11.4388 9.44143 11.3971 9.4519 11.3596 9.46135C11.3005 9.47619 11.2516 9.48851 11.1602 9.5122L10.6618 11.4505C10.6521 11.4671 10.6424 11.483 10.6327 11.4989L10.6327 11.499C10.623 11.5149 10.6133 11.5308 10.6036 11.5474L9.13881 12.9098L9.22464 13.2476L11.163 13.746C11.1962 13.7626 11.2266 13.782 11.2571 13.8014L12.6222 15.269L12.96 15.1831L13.4585 13.2421ZM3.12451 15.6816L3.9469 15.6428L3.94967 15.6401L4.11858 16.0194L3.57586 16.576L3.45679 16.6397L1.80368 16.9498L1.64862 16.54L3.01928 15.7121L3.12451 15.6816ZM17.4874 6.30018L17.8141 5.5387L17.8834 5.45009L19.9269 3.88283L20.2426 4.19296L19.0713 5.78514L19.0076 5.84329L17.8086 6.57985L17.4874 6.30295V6.30018ZM10.3433 21.4217L10.4762 21.6847H10.479L10.8999 21.5934L10.9276 20.807L10.4901 20.7322L10.3295 21.2555L10.3433 21.4217ZM18.5978 16.3212H19.1156L19.2485 16.3655L19.9214 16.8667C19.8469 17.0428 19.8423 17.0533 19.7921 17.1681L19.7497 17.2655L18.7085 17.0882L18.5424 16.9609L18.3929 16.6369L18.595 16.3212H18.5978ZM8.13088 3.63347L7.7626 2.18804L8.1558 1.99698L9.08065 3.18765L9.12495 3.34826L9.05573 3.97406L8.69852 4.12635L8.21118 3.7553L8.13088 3.63347Z"
                });
            case "support":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M15.6222 4.11252L15.982 5.29622L14.6143 8.05635L12.1178 10.6819L8.17948 7.10884L6.9848 4.03562L7.45992 2.39602L8.59419 1.87695L9.8026 2.00329L11.7525 4.0933L13.7684 3.00298L15.6222 4.11252ZM11.1374 15.7135L10.6788 14.6946L10.5579 14.1371L10.2586 13.6509L8.86342 9.97077L8.59153 9.72359L8.01753 9.79225L7.89669 10.4431L8.05872 10.9787L8.17957 12.0827L8.07795 13.1841L7.76486 13.5356L5.99618 12.4837L4.92508 11.3742L4.70812 10.9018L4.39228 10.4843L3.68646 8.53989L3.35689 8.05653L2.80761 8.16638L2.71973 8.74313L3.81005 12.5414L5.13106 14.2826L5.53478 14.6506L7.81429 17.7074L7.99281 18.7565L7.43804 21.6622L7.75387 22.1758L10.1103 22.4971L11.0056 21.643L11.1676 17.9051L11.0935 17.3558L11.2088 16.2628L11.1374 15.7135ZM20.824 8.21296L20.412 8.13881L20.1017 8.57548L18.4978 11.8107L18.1435 12.1897L17.6903 12.4589L17.3003 12.7967L15.9573 13.5657L15.5454 13.2004L15.669 10.9813L15.8035 10.443L15.625 9.83333L15.1224 9.72897L14.8341 9.96516L13.7657 12.566L13.6504 13.1263L12.799 15.2135L12.4914 16.8119L12.5985 17.3557L12.6507 21.6428L13.5048 22.3899L16.0178 21.9092L16.2045 21.4616L16.1331 21.2776L16.0974 20.7613L15.7926 19.7808L15.7239 19.27L15.9271 17.721L16.7593 16.3121L19.5826 12.9917L20.4861 10.9511L20.9997 8.74301L20.824 8.21296Z"
                });
            case "life":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M20.8045 7.81774C20.6924 7.38043 20.3879 7.00607 20.1764 6.62177C19.9585 6.23416 19.6573 5.91943 19.3529 5.6047C19.0485 5.28997 18.8113 4.85597 18.4364 4.63069C18.0679 4.40872 17.6385 4.20663 17.2155 4.09068C16.8085 3.97804 15.9305 4.86591 15.5139 4.90567C15.3024 4.92554 16.0875 4.3259 15.8792 4.28283C15.187 4.13706 15.1133 4.29277 14.716 4.39547C14.3154 4.49817 13.8155 4.33253 13.4502 4.5313C13.0881 4.72677 12.8381 5.13426 12.5273 5.41917C12.4536 5.48543 12.3991 5.53512 12.3575 5.57157C12.2966 5.62457 12.2902 5.71734 12.3414 5.78028C12.8574 6.38986 12.8125 7.20485 12.4824 6.84374C11.7005 5.98568 11.3096 5.63783 10.9923 5.3496C10.6815 5.068 10.2842 4.90898 9.91884 4.71351C9.55353 4.51805 9.21385 4.20995 8.81329 4.10725C8.41914 4.00786 7.56354 4.00454 7.56354 4.00454C7.12131 4.00454 6.65025 3.97142 6.24328 4.08406C5.82029 4.20001 5.471 4.54455 5.09928 4.76652C4.72435 4.9918 4.29815 5.17401 3.99372 5.48543C3.6893 5.80016 3.4778 6.2209 3.25989 6.60852C3.04519 6.98951 3.07724 7.46657 2.96508 7.90388C2.85613 8.32462 2.9779 8.91433 3.0484 9.3682C3.1958 10.3157 2.78242 9.68293 2.58695 9.34832C2.56131 9.30525 2.49402 9.32844 2.50043 9.37814C2.53888 9.84858 2.70552 10.319 2.87535 10.7464C3.07083 11.2334 3.28873 11.78 3.65405 12.1577C4.1187 12.6381 4.28854 12.4625 4.75319 12.9429C5.21784 13.4232 5.07364 13.5723 5.53829 14.0527C6.00294 14.5331 6.12792 14.4039 6.59257 14.8842C7.05723 15.3646 6.90982 15.517 7.37447 15.9974C7.83912 16.4778 7.92244 16.3916 8.38709 16.872C8.88058 17.3855 9.78105 18.5583 10.4444 19.1016C10.6815 19.2938 10.877 19.529 11.0628 19.7742C11.3416 20.1419 11.9217 20.0193 12.2293 19.7013C12.6939 19.2209 12.742 19.2706 13.2067 18.7902C13.6713 18.3098 13.7803 18.4225 14.2417 17.9388C14.7064 17.4584 14.5686 17.316 15.0332 16.8356C15.4979 16.3552 15.3889 16.2426 15.8536 15.7622C15.9433 15.6694 16.0138 15.5932 16.0747 15.5303C16.1804 15.4176 15.86 14.7319 15.9369 14.6523C16.0074 14.5761 16.4785 15.1029 16.581 14.9936C16.6355 14.9373 16.6996 14.871 16.7733 14.7915C17.0969 14.4536 17.0264 14.5695 17.2443 14.4039C17.3373 14.3343 16.3086 12.9263 16.4464 12.7838C16.5874 12.6381 18.0326 13.675 18.1063 13.5823C18.2698 13.3669 18.3339 13.2278 18.6543 12.8932C19.119 12.4128 19.2888 12.5884 19.7534 12.108C20.1188 11.727 20.2341 11.1638 20.4296 10.6768C20.6251 10.1898 21 9.70943 21 9.17274H20.9808C20.9808 8.71555 20.9103 8.23517 20.8013 7.81443L20.8045 7.81774Z"
                });
            case "lock_open":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M6 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6H7C7 4.61667 7.4875 3.4375 8.4625 2.4625C9.4375 1.4875 10.6167 1 12 1C13.3833 1 14.5625 1.4875 15.5375 2.4625C16.5125 3.4375 17 4.61667 17 6V8H18C18.55 8 19.0208 8.19583 19.4125 8.5875C19.8042 8.97917 20 9.45 20 10V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V10C4 9.45 4.19583 8.97917 4.5875 8.5875C4.97917 8.19583 5.45 8 6 8ZM12 17C12.55 17 13.0208 16.8042 13.4125 16.4125C13.8042 16.0208 14 15.55 14 15C14 14.45 13.8042 13.9792 13.4125 13.5875C13.0208 13.1958 12.55 13 12 13C11.45 13 10.9792 13.1958 10.5875 13.5875C10.1958 13.9792 10 14.45 10 15C10 15.55 10.1958 16.0208 10.5875 16.4125C10.9792 16.8042 11.45 17 12 17Z"
                });
            case "grade":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M5.825 21L7.45 13.975L2 9.25L9.2 8.625L12 2L14.8 8.625L22 9.25L16.55 13.975L18.175 21L12 17.275L5.825 21Z"
                });
            case "hand":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M14.7853 6.75878C13.9818 8.88838 13.1583 11.0707 14.4257 13.1882H14.423C14.7081 13.4849 15.08 13.7327 15.4542 13.9821C16.2027 14.4809 16.9607 14.986 17.053 15.9008C16.9278 17.3318 15.806 19.9618 14.7214 20.8891C13.1306 22.3467 10.4606 20.9797 12.4085 19.0585C12.4538 16.8921 11.1454 17.8221 10.8603 18.0939C10.7341 18.2153 10.7698 18.3998 10.8065 18.5902C10.831 18.7174 10.8561 18.8473 10.8337 18.9626C10.1622 21.4008 7.7 20.8012 6.55418 19.0745C6.41562 18.872 6.1225 18.4243 5.89867 17.7368C5.25491 16.8973 6.0685 16.759 6.76315 16.6409C6.91959 16.6143 7.07 16.5887 7.19637 16.5564C8.29879 16.4488 8.38377 15.2692 8.45261 14.3134C8.46564 14.1326 8.47808 13.9598 8.49674 13.8037C8.62324 13.4936 8.66368 13.1728 8.70373 12.8553C8.75141 12.4771 8.79853 12.1034 8.98971 11.7573C8.9317 11.2717 8.91286 10.7768 8.89409 10.2835C8.88268 9.98371 8.87129 9.6845 8.85114 9.38835C8.84312 9.26535 8.93036 9.30133 9.01625 9.33675C9.10154 9.37194 9.18552 9.40657 9.17357 9.28442C8.75326 8.64642 8.73221 8.2682 8.69862 7.66462C8.69069 7.52201 8.68205 7.36682 8.66728 7.19265C8.52605 6.72366 8.45677 6.25468 8.48608 5.76437C8.31288 5.26608 8.30488 4.82907 8.51006 4.33877C8.41147 2.43085 10.4793 2.0578 10.4686 4.14957C10.4398 4.60723 10.4214 5.08125 10.403 5.55401C10.389 5.91255 10.3751 6.27036 10.3567 6.61974C10.3487 6.74402 10.2924 6.74096 10.237 6.73796C10.1818 6.73497 10.1275 6.73202 10.1222 6.85423C10.1167 6.98173 10.1825 7.11417 10.248 7.2461C10.3098 7.3706 10.3714 7.49465 10.3727 7.61367C10.3434 8.63424 11.0282 12.7912 12.0274 9.90263C12.1446 9.47517 12.2053 9.038 12.2656 8.60261C12.3536 7.96864 12.441 7.33848 12.7016 6.74764C12.7679 6.44288 12.812 6.0937 12.858 5.72926C13.0191 4.45264 13.2038 2.98873 14.4496 2.59073C15.6328 2.10842 15.9046 3.66727 15.5475 4.48266C15.3619 5.23086 15.0749 5.9914 14.7853 6.75878ZM16.8307 11.4678C16.6122 11.7935 16.3917 12.1222 16.0512 12.4021L16.0539 12.4048C15.4516 12.9058 14.8414 12.3409 15.2704 11.5255C15.3996 11.0821 15.6445 10.7059 15.8833 10.3389L15.8833 10.3389C16.078 10.0397 16.2688 9.74666 16.3896 9.42836C16.5642 9.04272 16.7701 8.68019 16.9752 8.31894C17.2959 7.75413 17.6149 7.19246 17.8099 6.5505C17.8677 6.43615 17.9385 6.41581 18.0104 6.39513C18.0843 6.37389 18.1594 6.35231 18.2229 6.22807C18.2694 6.13516 18.2706 6.03959 18.2717 5.94682C18.2732 5.83208 18.2745 5.72163 18.3615 5.62585C19.6272 3.91779 20.4346 5.69513 19.7498 7.00616C19.4506 7.73458 19.0099 8.37816 18.5698 9.02097C18.2339 9.51159 17.8982 10.0018 17.626 10.5289C17.2777 10.8016 17.0552 11.1332 16.8307 11.4678ZM18.8135 11.395C19.4655 10.5435 20.1994 9.58495 20.9862 10.1239H20.9888C21.3202 10.5611 20.9203 11.1075 20.6163 11.5231C20.5682 11.5888 20.5225 11.6512 20.4825 11.7094C20.3773 11.8161 20.3338 11.7175 20.2944 11.6284C20.262 11.555 20.2324 11.4879 20.1734 11.5468C20.0003 12.3108 19.3525 12.9307 18.7584 13.4992L18.7583 13.4992L18.7583 13.4993C18.621 13.6307 18.4865 13.7594 18.3614 13.8864C16.6933 14.8804 16.9785 13.175 17.9457 12.3622C18.2146 12.1773 18.5049 11.7982 18.8135 11.395ZM6.3277 14.3232C6.25576 13.9288 6.06124 13.5744 5.76812 13.2653C5.70439 12.7027 5.45402 12.4088 5.16751 12.0725C5.03473 11.9166 4.89419 11.7517 4.76087 11.5466C4.68524 11.5126 4.60156 11.4707 4.51289 11.4264C3.98305 11.1612 3.27536 10.807 3.04481 11.5146C2.85562 11.9197 3.00218 12.4659 3.16472 12.8656C3.27792 13.1765 3.45861 13.2121 3.59675 13.2393C3.67648 13.255 3.74204 13.2679 3.77227 13.3293C3.8138 13.4148 3.76407 13.4404 3.70956 13.4684C3.64516 13.5016 3.57409 13.5382 3.63904 13.681C3.8229 14.3818 4.2306 15.3918 4.94473 15.6263C5.57093 15.6716 6.54354 15.0427 6.3277 14.3232Z"
                });
            case "inspect":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M12.92 13.9287L12.9955 13.4848L13.0504 13.1646C13.103 12.858 13.3204 12.6087 13.6155 12.5149L13.8374 12.444L14.471 12.2404C14.757 12.1489 15.0727 12.2175 15.2946 12.4257L15.4021 12.5263L16.292 9.02853C16.4476 8.41544 15.9145 7.03371 15.4204 6.63566C15.3655 6.57847 15.3083 6.52357 15.2443 6.47095L12.3275 4.11926C11.8975 3.77383 11.2592 3.66173 10.6438 3.82415L6.65648 4.86961C6.33621 4.95425 6.03424 5.10294 5.77802 5.29968C5.51952 5.49871 5.30677 5.74577 5.16723 6.02029L3.22273 9.84522C3.04201 10.2021 2.96881 10.5727 3.00083 10.9135V10.9181C2.93907 11.3619 3.54758 12.3136 3.81752 12.6384L6.60157 15.9784C7.07969 16.5503 7.87808 16.7539 8.68561 16.5L13.4874 14.9924L13.1534 14.6584C12.9635 14.4685 12.8766 14.194 12.9223 13.9287H12.92ZM4.56329 10.1426L6.41628 6.26506C6.45059 6.19186 6.50549 6.12552 6.57641 6.06833C6.64504 6.01342 6.72739 5.97225 6.81204 5.94937L10.9 4.85588C11.067 4.81013 11.2409 4.84215 11.3553 4.93823L14.2697 7.38601C14.4001 7.49581 14.4505 7.66281 14.4047 7.82295L13.19 12.0574C13.1625 12.1534 13.1099 12.2404 13.039 12.3136C12.9681 12.3868 12.8789 12.4394 12.7828 12.4691L7.95814 13.947C7.75226 14.011 7.54637 13.9607 7.42055 13.8166L4.60447 10.6276C4.49466 10.5041 4.48093 10.3165 4.56558 10.1403L4.56329 10.1426ZM11.4491 5.48046L7.68138 6.40009C7.30163 6.49159 6.99052 6.7501 6.83038 7.10468L5.20845 10.662C5.22598 10.678 5.24378 10.6937 5.26157 10.7095C5.29715 10.741 5.33274 10.7725 5.36629 10.8061L7.01568 7.18932C7.15294 6.89193 7.41144 6.67461 7.73171 6.59683L8.63874 6.37513L8.09768 13.5509L9.29183 13.1872L9.65248 6.12735L10.7388 5.86183L10.4952 12.8557L10.8909 12.7573L11.14 5.76378L11.6253 5.64517C11.5658 5.59255 11.5086 5.53536 11.4514 5.47817L11.4491 5.48046ZM18.5796 15.7522L20.5722 17.6052L20.5699 17.6097L20.9999 18.9228L20.1672 20.0072H18.7215L16.6809 17.9506L16.6489 17.5869L14.1187 15.0544L13.4118 14.3453C13.3112 14.2446 13.2677 14.1005 13.2952 13.961L13.4462 13.2243C13.4759 13.0733 13.5857 12.9521 13.7321 12.9041L14.5968 12.625C14.7433 12.5769 14.9057 12.6135 15.0178 12.7188L15.5485 13.2152L18.2182 15.7133L18.5796 15.7522Z"
                });
            case "fire":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M16.3337 5.91796L17.7969 4.73808L18.2647 3.03843L16.5702 1.61426L16.3337 5.91796ZM17.1678 19.2681L19 11.9601L14.3117 7.37833L14.3715 3.70875L9.59477 8.119L9.65974 14.4134L6.84778 11.3598L4.57898 15.3308L6.44756 19.3019L8.85669 20.1387L11.3386 22.3867L10.954 17.9479L13.4281 16.7472L13.4697 12.6488L15.6423 14.7227L15.1303 20.6481L17.1678 19.2681Z"
                });
            case "share":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M6.07175 23.2392C5.44209 23.2392 4.9055 23.0175 4.462 22.574C4.0185 22.1305 3.79675 21.5939 3.79675 20.9642V10.3707C3.79675 9.74091 4.0185 9.20424 4.462 8.76074C4.9055 8.31741 5.44209 8.09574 6.07175 8.09574H8.8625V10.3707H6.07175V20.9642H17.9283V10.3707H15.1375V8.09574H17.9283C18.5579 8.09574 19.0945 8.31741 19.538 8.76074C19.9815 9.20424 20.2033 9.74091 20.2033 10.3707V20.9642C20.2033 21.5939 19.9815 22.1305 19.538 22.574C19.0945 23.0175 18.5579 23.2392 17.9283 23.2392H6.07175ZM10.8625 16.2092V5.10599L9.2625 6.70599L7.67125 5.09574L12 0.760742L16.3288 5.09574L14.7375 6.70599L13.1375 5.10599V16.2092H10.8625Z"
                });
            case "discord":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "m15.07532,4c-0.208,0.36667 -0.3986,0.75 -0.5892,1.13333c-1.6637,-0.23333 -3.362,-0.23333 -5.02565,0c-0.17329,-0.38333 -0.36392,-0.76666 -0.58921,-1.13333c-1.55968,0.25 -3.0847,0.7 -4.52307,1.35c-2.85941,4.06667 -3.63925,8.05 -3.25799,11.9667c1.68098,1.1833 3.5526,2.1 5.56285,2.6833c0.45057,-0.5833 0.84916,-1.2 1.19575,-1.85c-0.6412,-0.2333 -1.26507,-0.5167 -1.87161,-0.8667c0.15597,-0.1166 0.31194,-0.2166 0.4679,-0.3333c3.51795,1.5833 7.59043,1.5833 11.10843,0c0.1559,0.1167 0.2946,0.2333 0.4679,0.3333c-0.6066,0.3334 -1.2305,0.6334 -1.8717,0.8667c0.3466,0.65 0.7452,1.2667 1.1958,1.85c1.9929,-0.5833 3.8819,-1.4833 5.5628,-2.6833c0.4506,-4.55003 -0.7798,-8.48337 -3.2579,-11.98337c-1.4904,-0.61666 -3.0154,-1.06666 -4.5751,-1.33333zm-6.74128,10.9c-1.07445,0 -1.97559,-0.95 -1.97559,-2.11667c0,-1.16666 0.86648,-2.11666 1.97559,-2.11666c1.1091,0 1.99292,0.95 1.97559,2.11666c-0.01733,1.16667 -0.88382,2.11667 -1.97559,2.11667zm7.29578,0c-1.0917,0 -1.9755,-0.95 -1.9755,-2.11667c0,-1.16666 0.8664,-2.11666 1.9755,-2.11666c1.1092,0 1.993,0.95 1.9756,2.11666c-0.0346,1.16667 -0.8838,2.11667 -1.9756,2.11667z"
                });
            case "wreath":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "m4.14426,10.22003c-0.47333,-0.03567 -0.83993,-0.08636 -1.20653,-0.08546c-0.58749,0.00192 -0.85479,0.31074 -0.80745,0.91425c0.0956,1.20518 0.61997,2.16725 1.61675,2.85437c0.21903,0.15112 0.4325,0.30972 0.65432,0.46838c-0.53552,0.22431 -1.03855,0.37352 -1.47754,0.63356c-0.5745,0.33976 -0.58192,0.60537 -0.27194,1.19111c0.65895,1.24366 2.59404,2.17383 3.85625,1.62101c0.98101,-0.42989 1.5323,0.10324 2.20426,0.75278c-0.40745,0.20085 -0.76385,0.3576 -1.10167,0.54816c-0.23666,0.13328 -0.47425,0.28721 -0.66452,0.47963c-0.25986,0.26094 -0.24038,0.60447 -0.10673,0.92173c0.12251,0.29003 0.38795,0.40452 0.6803,0.36322c0.29143,-0.04034 0.59492,-0.09666 0.85759,-0.22342c2.43717,-1.17232 4.8632,-1.20799 7.29115,0.02161c0.20043,0.10138 0.41116,0.18775 0.62644,0.25154c0.4427,0.13239 0.81023,-0.03375 0.99589,-0.42798c0.17727,-0.37639 0.10114,-0.70586 -0.29607,-0.98278c-0.32671,-0.22808 -0.69054,-0.40266 -1.04323,-0.59226c-0.21713,-0.11635 -0.4427,-0.21683 -0.76379,-0.37166c0.4594,-0.31726 0.82412,-0.62045 1.23624,-0.8307c0.18745,-0.09576 0.48166,-0.05913 0.70071,0.00754c0.65618,0.19894 1.29375,0.30876 1.98519,0.12856c1.06178,-0.27686 1.82,-0.90198 2.35457,-1.84718c0.18194,-0.32103 0.12251,-0.60639 -0.1568,-0.80066c-0.30535,-0.21216 -0.64505,-0.3783 -0.98194,-0.5369c-0.21623,-0.10138 -0.45569,-0.15297 -0.70999,-0.23562c0.47143,-0.40637 0.91605,-0.76026 1.32715,-1.15071c0.68216,-0.6505 0.85201,-1.52339 0.92903,-2.41323c0.03621,-0.41954 -0.24131,-0.70209 -0.6979,-0.72651c-0.39165,-0.02155 -0.78707,0.03663 -1.26874,0.06482c0.1346,-0.21312 0.23946,-0.39141 0.3564,-0.56228c0.7304,-1.0747 0.9188,-2.21701 0.43157,-3.44661c-0.03711,-0.09386 -0.0696,-0.19054 -0.11509,-0.27971c-0.43253,-0.84757 -0.81676,-0.95646 -1.5824,-0.38859c-0.37495,0.27783 -0.69425,0.63169 -1.10631,1.01465c-0.06775,-0.2309 -0.14388,-0.42989 -0.18469,-0.63639c-0.33599,-1.71862 -1.59354,-2.722 -3.39684,-2.8919c-0.24041,-0.02253 -0.49375,0.06195 -0.73692,0.11639c-0.46868,0.10606 -0.66821,0.3839 -0.61441,0.87386c0.20696,1.87255 1.27987,3.06367 2.86131,3.34619c0.30164,0.05444 0.4752,0.2018 0.63392,0.45993c1.37449,2.24615 1.48311,5.6364 -0.51231,7.93514c-0.93831,1.08129 -2.14947,1.70264 -3.59548,1.81623c-2.50958,0.19804 -4.53097,-1.35258 -5.39596,-3.74139c-0.74805,-2.06682 -0.47333,-4.08301 0.56336,-5.99215c0.11323,-0.20932 0.39815,-0.40549 0.63295,-0.45054c1.33463,-0.25343 2.1922,-1.0522 2.64418,-2.30432c0.15034,-0.41862 0.2051,-0.88418 0.23018,-1.33285c0.01855,-0.3304 -0.20325,-0.51249 -0.54295,-0.61668c-1.35504,-0.41111 -3.00335,0.45523 -3.5203,1.30563c-0.25801,0.42426 -0.43621,0.90014 -0.63018,1.361c-0.09466,0.22527 -0.14293,0.47025 -0.21903,0.73025c-0.38424,-0.35949 -0.69793,-0.71898 -1.07381,-0.98931c-0.83158,-0.59884 -1.26593,-0.45711 -1.65851,0.50686c-0.49932,1.22678 -0.46962,2.41226 0.32669,3.5217c0.12994,0.18212 0.25338,0.36891 0.44364,0.64673l0,0.00096z"
                });
            case "shield":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "m10.89177,2.04575c-0.01437,0.02058 -1.41581,2.02268 -2.13491,2.23376c-0.87453,0.25764 -4.5557,-0.76873 -4.59351,-0.77929c-1.056,0.75822 -1.56822,1.12567 -1.65062,1.18515l-0.0347,0.67292l-0.13428,1.84827c0,0 2.04434,1.18094 2.31448,1.84903c0.17509,0.43167 -0.26413,1.82472 -0.27158,1.84828l0.14711,1.84898c0,0 0.45892,0.19282 0.46622,0.35535c0.00711,0.16014 -0.40166,0.75883 -0.40738,0.76725l0.03772,0.72723l-0.04979,0.76192c-0.04375,0.68042 0.27479,1.34315 0.86906,1.79768l0.51374,0.39382l1.59629,0.98447l1.52765,1.05315l1.37073,1.21082l1.50274,1.14971l1.49672,-1.15805l1.56686,-1.01537l1.46883,-1.11201l1.5314,-1.04936l0.29502,-0.23306c0.71101,-0.5606 1.08529,-1.36879 1.01236,-2.19382l-0.05276,-0.59143l0.16215,-1.84828l-0.10637,-1.84898c-0.00147,-0.02202 -0.09641,-1.43955 0.12522,-1.84828c0.31248,-0.57723 2.11518,-1.64297 2.13195,-1.65288c0.00587,-0.1102 -0.10104,-0.20822 -0.25724,-0.2399c-0.1898,-0.03858 -0.41313,-0.10199 -0.42627,-0.1901c-0.02881,-0.1948 0.71595,-0.75685 0.72275,-0.76194l0.02487,-0.85398l-0.02039,-0.6269c-0.77667,-0.47515 -1.19135,-0.7287 -1.96671,-1.2025c0,0 -3.63222,1.10172 -4.50445,0.84718c-0.71263,-0.20854 -2.12515,-2.16597 -2.13643,-2.1817l-2.1365,-0.14711zm1.30815,3.57583l0.32136,0.32741l0.28892,0.37645l0.35682,0.31986l0.39235,0.27761l0.4292,0.22481l0.40209,0.26479l0.44357,0.19539l0.46852,0.13353l0.46319,0.14862l0.48204,0.08298l0.48737,0.03319l0.49108,0.52279l-0.01808,0.48281l-0.0611,0.48053l-0.05964,0.48057l0.01437,0.48505l0,0.48359l-0.08899,0.47903l-0.02039,0.48204l-0.02789,0.48212l-0.03098,0.48204l-0.02263,0.48359l-0.05732,0.45485l-0.08598,0.45191l-0.12978,0.44511l-0.23538,0.40433l-0.24967,0.39529l-0.32437,0.3433l-0.31232,0.35829l-0.42325,0.23693l-0.37868,0.26327l-0.37644,0.26551l-0.41491,0.20973l-0.39537,0.23839l-0.40209,0.22936l-0.37343,0.27007l-0.38393,0.255l-0.40587,0.24141l-0.39158,-0.2618l-0.38246,-0.25647l-0.40131,-0.23013l-0.38702,-0.25044l-0.39605,-0.23685l-0.41341,-0.21197l-0.38097,-0.26103l-0.37947,-0.26103l-0.38549,-0.27988l-0.35532,-0.31387l-0.34702,-0.32963l-0.26178,-0.39382l-0.16294,-0.43832l-0.15692,-0.4353l-0.14107,-0.44357l-0.05884,-0.46018l0.03093,-0.48428l-0.07469,-0.48134l-0.03621,-0.48204l-0.0264,-0.48204l-0.03244,-0.48212l-0.03018,-0.48204l-0.00754,-0.48359l-0.02339,-0.47671l0.01283,-0.48436l-0.01283,-0.48357l0.42623,-0.53335l0.49262,0.00678l0.46998,-0.13654l0.47603,-0.10411l0.45867,-0.16144l0.43377,-0.21048l0.42623,-0.22331l0.39075,-0.27384l0.40209,-0.26479l0.32669,-0.34325l0.35682,-0.31684l0.27532,-0.40511l0.50398,0.0611zm-1.88675,6.48631l1.67625,2.73009l1.67625,-2.73009l-0.31078,-0.5477c-0.00626,0.00263 -0.12175,0.0499 -0.15164,0.02711c-0.06311,-0.04867 -0.01244,-0.3046 -0.01058,-0.31379c-0.05987,-0.10606 -0.15465,-0.19042 -0.27007,-0.24141c-0.08752,-0.03855 -0.17968,-0.08783 -0.20742,-0.13055c-0.0438,-0.07014 -0.03198,-0.26844 -0.01885,-0.38695c0.00726,-0.06335 -0.00711,-0.12839 -0.03924,-0.18486l-0.00155,-0.00301l-0.66613,-1.17233l-1.67625,2.95348z"
                });
            case "checked-box":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "m10.53681,16.38958l7.36823,-7.36823l-1.46319,-1.46319l-5.90503,5.90503l-2.97865,-2.97865l-1.46319,1.46319l4.44184,4.44184zm-5.85278,5.01667c-0.57483,0 -1.06691,-0.20464 -1.47626,-0.61402c-0.40935,-0.40938 -0.61402,-0.90143 -0.61402,-1.47626l0,-14.63194c0,-0.57483 0.20467,-1.06691 0.61402,-1.47626c0.40935,-0.40935 0.90143,-0.61402 1.47626,-0.61402l14.63194,0c0.57483,0 1.06688,0.20467 1.47626,0.61402c0.40938,0.40935 0.61402,0.90143 0.61402,1.47626l0,14.63194c0,0.57483 -0.20464,1.06688 -0.61402,1.47626c-0.40938,0.40938 -0.90143,0.61402 -1.47626,0.61402l-14.63194,0z"
                });
            case "leaderboard":
                return /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "m19.40725,2.81635l-2.14509,4.49127c-1.34068,-1.13958 -3.08356,-1.87695 -4.82644,-2.01102l1.40771,-2.94949c0.06703,-0.26814 0.26814,-0.4022 0.53627,-0.4022l4.62534,0c0.13407,0 0.26814,0.06703 0.4022,0.13407c0.06703,0.13407 0.13407,0.26814 0.13407,0.4022c0,0.13407 -0.06703,0.26814 -0.13407,0.33517zm0.13407,11.73094c0,4.1561 -3.3517,7.5078 -7.5078,7.5078c-4.1561,0 -7.5078,-3.3517 -7.5078,-7.5078s3.3517,-7.5078 7.5078,-7.5078c4.1561,-0.06703 7.5078,3.3517 7.5078,7.5078zm-4.02204,-2.07805l-2.01102,-0.33517l-0.87144,-1.94398c-0.33517,-0.67034 -0.80441,-0.67034 -1.07254,0l-0.87144,1.94398l-2.01102,0.33517c-0.67034,0.13407 -0.80441,0.60331 -0.33517,1.13958l1.47475,1.47475l-0.33517,2.14509c-0.13407,0.73737 0.26814,1.00551 0.87144,0.67034l1.80992,-1.00551l1.80992,1.00551c0.60331,0.33517 1.00551,0 0.87144,-0.67034l-0.33517,-2.14509l1.54178,-1.47475c0.33517,-0.53627 0.13407,-1.07254 -0.53627,-1.13958zm-10.92653,-9.65289c-0.06703,-0.06703 -0.13407,-0.2011 -0.13407,-0.33517s0.06703,-0.26814 0.13407,-0.4022c0.06703,-0.13407 0.26814,-0.13407 0.4022,-0.13407l4.62534,0c0.26814,0 0.46924,0.2011 0.53627,0.4022l1.40771,2.94949c-1.80992,0.13407 -3.48576,0.87144 -4.82644,2.01102l-2.14509,-4.49127zm0,0"
                });
            default:
                return null;
        }
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        className: $5YM0g.Icon,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "inline-block",
            ...style
        },
        ...props,
        children: getIcon()
    });
}

});
parcelRegister("5YM0g", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $45a7cacb8222cbfc$export$f04a61298a47a40f; }, function (v) { return $45a7cacb8222cbfc$export$f04a61298a47a40f = v; });
$parcel$export(module.exports, "spin", function () { return $45a7cacb8222cbfc$export$c82e186cf428d56d; }, function (v) { return $45a7cacb8222cbfc$export$c82e186cf428d56d = v; });
$parcel$export(module.exports, "spinner", function () { return $45a7cacb8222cbfc$export$641374ffb95bc399; }, function (v) { return $45a7cacb8222cbfc$export$641374ffb95bc399 = v; });
var $45a7cacb8222cbfc$export$f04a61298a47a40f;
var $45a7cacb8222cbfc$export$17fa98cb055e8fa7;
var $45a7cacb8222cbfc$export$a5833c2b43ca4340;
var $45a7cacb8222cbfc$export$47511f9a6581d1d6;
var $45a7cacb8222cbfc$export$dd1c05b92185401c;
var $45a7cacb8222cbfc$export$8b28cf6cd00fe080;
var $45a7cacb8222cbfc$export$186c650311ff0789;
var $45a7cacb8222cbfc$export$6746fe0d9c9fab54;
var $45a7cacb8222cbfc$export$2bcf359f0c20e94f;
var $45a7cacb8222cbfc$export$2903d10d531d0ac0;
var $45a7cacb8222cbfc$export$c82e186cf428d56d;
var $45a7cacb8222cbfc$export$641374ffb95bc399;
$45a7cacb8222cbfc$export$f04a61298a47a40f = `q4ybRG_Icon`;
$45a7cacb8222cbfc$export$17fa98cb055e8fa7 = `q4ybRG_fontSizeH1`;
$45a7cacb8222cbfc$export$a5833c2b43ca4340 = `q4ybRG_fontSizeH2`;
$45a7cacb8222cbfc$export$47511f9a6581d1d6 = `q4ybRG_fontSizeH3`;
$45a7cacb8222cbfc$export$dd1c05b92185401c = `q4ybRG_fontSizeH4`;
$45a7cacb8222cbfc$export$8b28cf6cd00fe080 = `q4ybRG_fontSizeH5`;
$45a7cacb8222cbfc$export$186c650311ff0789 = `q4ybRG_fontSizeH6`;
$45a7cacb8222cbfc$export$6746fe0d9c9fab54 = `q4ybRG_fontSizeSmall`;
$45a7cacb8222cbfc$export$2bcf359f0c20e94f = `q4ybRG_fontSizeTiny`;
$45a7cacb8222cbfc$export$2903d10d531d0ac0 = `q4ybRG_fontSizep`;
$45a7cacb8222cbfc$export$c82e186cf428d56d = `q4ybRG_spin`;
$45a7cacb8222cbfc$export$c82e186cf428d56d;
$45a7cacb8222cbfc$export$641374ffb95bc399 = `q4ybRG_spinner`;

});


parcelRegister("625rg", function(module, exports) {
(function() {
    "use strict";
    /** Used to determine if values are of the language type `Object`. */ var objectTypes = {
        "function": true,
        "object": true
    };
    /** Used as a reference to the global object. */ var root = objectTypes[typeof window] && window || this;
    /** Backup possible global object. */ var oldRoot = root;
    /** Detect free variable `exports`. */ var freeExports = objectTypes["object"] && exports;
    /** Detect free variable `module`. */ var freeModule = objectTypes["object"] && module && !module.nodeType && module;
    /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */ var freeGlobal = freeExports && freeModule && typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) root = freeGlobal;
    /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */ var maxSafeInteger = Math.pow(2, 53) - 1;
    /** Regular expression to detect Opera. */ var reOpera = /\bOpera/;
    /** Possible global object. */ var thisBinding = this;
    /** Used for native method references. */ var objectProto = Object.prototype;
    /** Used to check for own properties of an object. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to resolve the internal `[[Class]]` of values. */ var toString = objectProto.toString;
    /*--------------------------------------------------------------------------*/ /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */ function capitalize(string) {
        string = String(string);
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */ function cleanupOS(os, pattern, label) {
        // Platform tokens are defined at:
        // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
        var data = {
            "10.0": "10",
            "6.4": "10 Technical Preview",
            "6.3": "8.1",
            "6.2": "8",
            "6.1": "Server 2008 R2 / 7",
            "6.0": "Server 2008 / Vista",
            "5.2": "Server 2003 / XP 64-bit",
            "5.1": "XP",
            "5.01": "2000 SP1",
            "5.0": "2000",
            "4.0": "NT",
            "4.90": "ME"
        };
        // Detect Windows version from platform tokens.
        if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) os = "Windows " + data;
        // Correct character case and cleanup string.
        os = String(os);
        if (pattern && label) os = os.replace(RegExp(pattern, "i"), label);
        os = format(os.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]);
        return os;
    }
    /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */ function each(object, callback) {
        var index = -1, length = object ? object.length : 0;
        if (typeof length == "number" && length > -1 && length <= maxSafeInteger) while(++index < length)callback(object[index], index, object);
        else forOwn(object, callback);
    }
    /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */ function format(string) {
        string = trim(string);
        return /^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string);
    }
    /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */ function forOwn(object, callback) {
        for(var key in object)if (hasOwnProperty.call(object, key)) callback(object[key], key, object);
    }
    /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */ function getClassOf(value) {
        return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
    }
    /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */ function isHostType(object, property) {
        var type = object != null ? typeof object[property] : "number";
        return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == "object" ? !!object[property] : true);
    }
    /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */ function qualify(string) {
        return String(string).replace(/([ -])(?!$)/g, "$1?");
    }
    /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */ function reduce(array, callback) {
        var accumulator = null;
        each(array, function(value, index) {
            accumulator = callback(accumulator, value, index, array);
        });
        return accumulator;
    }
    /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */ function trim(string) {
        return String(string).replace(/^ +| +$/g, "");
    }
    /*--------------------------------------------------------------------------*/ /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */ function parse(ua) {
        /** The environment context object. */ var context = root;
        /** Used to flag when a custom context is provided. */ var isCustomContext = ua && typeof ua == "object" && getClassOf(ua) != "String";
        // Juggle arguments.
        if (isCustomContext) {
            context = ua;
            ua = null;
        }
        /** Browser navigator object. */ var nav = context.navigator || {};
        /** Browser user agent string. */ var userAgent = nav.userAgent || "";
        ua || (ua = userAgent);
        /** Used to flag when `thisBinding` is the [ModuleScope]. */ var isModuleScope = isCustomContext || thisBinding == oldRoot;
        /** Used to detect if browser is like Chrome. */ var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
        /** Internal `[[Class]]` value shortcuts. */ var objectClass = "Object", airRuntimeClass = isCustomContext ? objectClass : "ScriptBridgingProxyObject", enviroClass = isCustomContext ? objectClass : "Environment", javaClass = isCustomContext && context.java ? "JavaPackage" : getClassOf(context.java), phantomClass = isCustomContext ? objectClass : "RuntimeObject";
        /** Detect Java environments. */ var java = /\bJava/.test(javaClass) && context.java;
        /** Detect Rhino. */ var rhino = java && getClassOf(context.environment) == enviroClass;
        /** A character to represent alpha. */ var alpha = java ? "a" : "\u03B1";
        /** A character to represent beta. */ var beta = java ? "b" : "\u03B2";
        /** Browser document object. */ var doc = context.document || {};
        /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */ var opera = context.operamini || context.opera;
        /** Opera `[[Class]]`. */ var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera["[[Class]]"] : getClassOf(opera)) ? operaClass : opera = null;
        /*------------------------------------------------------------------------*/ /** Temporary variable used over the script's lifetime. */ var data;
        /** The CPU architecture. */ var arch = ua;
        /** Platform description array. */ var description = [];
        /** Platform alpha/beta indicator. */ var prerelease = null;
        /** A flag to indicate that environment features should be used to resolve the platform. */ var useFeatures = ua == userAgent;
        /** The browser/environment version. */ var version = useFeatures && opera && typeof opera.version == "function" && opera.version();
        /** A flag to indicate if the OS ends with "/ Version" */ var isSpecialCasedOS;
        /* Detectable layout engines (order is important). */ var layout = getLayout([
            {
                "label": "EdgeHTML",
                "pattern": "Edge"
            },
            "Trident",
            {
                "label": "WebKit",
                "pattern": "AppleWebKit"
            },
            "iCab",
            "Presto",
            "NetFront",
            "Tasman",
            "KHTML",
            "Gecko"
        ]);
        /* Detectable browser names (order is important). */ var name = getName([
            "Adobe AIR",
            "Arora",
            "Avant Browser",
            "Breach",
            "Camino",
            "Electron",
            "Epiphany",
            "Fennec",
            "Flock",
            "Galeon",
            "GreenBrowser",
            "iCab",
            "Iceweasel",
            "K-Meleon",
            "Konqueror",
            "Lunascape",
            "Maxthon",
            {
                "label": "Microsoft Edge",
                "pattern": "(?:Edge|Edg|EdgA|EdgiOS)"
            },
            "Midori",
            "Nook Browser",
            "PaleMoon",
            "PhantomJS",
            "Raven",
            "Rekonq",
            "RockMelt",
            {
                "label": "Samsung Internet",
                "pattern": "SamsungBrowser"
            },
            "SeaMonkey",
            {
                "label": "Silk",
                "pattern": "(?:Cloud9|Silk-Accelerated)"
            },
            "Sleipnir",
            "SlimBrowser",
            {
                "label": "SRWare Iron",
                "pattern": "Iron"
            },
            "Sunrise",
            "Swiftfox",
            "Vivaldi",
            "Waterfox",
            "WebPositive",
            {
                "label": "Yandex Browser",
                "pattern": "YaBrowser"
            },
            {
                "label": "UC Browser",
                "pattern": "UCBrowser"
            },
            "Opera Mini",
            {
                "label": "Opera Mini",
                "pattern": "OPiOS"
            },
            "Opera",
            {
                "label": "Opera",
                "pattern": "OPR"
            },
            "Chromium",
            "Chrome",
            {
                "label": "Chrome",
                "pattern": "(?:HeadlessChrome)"
            },
            {
                "label": "Chrome Mobile",
                "pattern": "(?:CriOS|CrMo)"
            },
            {
                "label": "Firefox",
                "pattern": "(?:Firefox|Minefield)"
            },
            {
                "label": "Firefox for iOS",
                "pattern": "FxiOS"
            },
            {
                "label": "IE",
                "pattern": "IEMobile"
            },
            {
                "label": "IE",
                "pattern": "MSIE"
            },
            "Safari"
        ]);
        /* Detectable products (order is important). */ var product = getProduct([
            {
                "label": "BlackBerry",
                "pattern": "BB10"
            },
            "BlackBerry",
            {
                "label": "Galaxy S",
                "pattern": "GT-I9000"
            },
            {
                "label": "Galaxy S2",
                "pattern": "GT-I9100"
            },
            {
                "label": "Galaxy S3",
                "pattern": "GT-I9300"
            },
            {
                "label": "Galaxy S4",
                "pattern": "GT-I9500"
            },
            {
                "label": "Galaxy S5",
                "pattern": "SM-G900"
            },
            {
                "label": "Galaxy S6",
                "pattern": "SM-G920"
            },
            {
                "label": "Galaxy S6 Edge",
                "pattern": "SM-G925"
            },
            {
                "label": "Galaxy S7",
                "pattern": "SM-G930"
            },
            {
                "label": "Galaxy S7 Edge",
                "pattern": "SM-G935"
            },
            "Google TV",
            "Lumia",
            "iPad",
            "iPod",
            "iPhone",
            "Kindle",
            {
                "label": "Kindle Fire",
                "pattern": "(?:Cloud9|Silk-Accelerated)"
            },
            "Nexus",
            "Nook",
            "PlayBook",
            "PlayStation Vita",
            "PlayStation",
            "TouchPad",
            "Transformer",
            {
                "label": "Wii U",
                "pattern": "WiiU"
            },
            "Wii",
            "Xbox One",
            {
                "label": "Xbox 360",
                "pattern": "Xbox"
            },
            "Xoom"
        ]);
        /* Detectable manufacturers. */ var manufacturer = getManufacturer({
            "Apple": {
                "iPad": 1,
                "iPhone": 1,
                "iPod": 1
            },
            "Alcatel": {},
            "Archos": {},
            "Amazon": {
                "Kindle": 1,
                "Kindle Fire": 1
            },
            "Asus": {
                "Transformer": 1
            },
            "Barnes & Noble": {
                "Nook": 1
            },
            "BlackBerry": {
                "PlayBook": 1
            },
            "Google": {
                "Google TV": 1,
                "Nexus": 1
            },
            "HP": {
                "TouchPad": 1
            },
            "HTC": {},
            "Huawei": {},
            "Lenovo": {},
            "LG": {},
            "Microsoft": {
                "Xbox": 1,
                "Xbox One": 1
            },
            "Motorola": {
                "Xoom": 1
            },
            "Nintendo": {
                "Wii U": 1,
                "Wii": 1
            },
            "Nokia": {
                "Lumia": 1
            },
            "Oppo": {},
            "Samsung": {
                "Galaxy S": 1,
                "Galaxy S2": 1,
                "Galaxy S3": 1,
                "Galaxy S4": 1
            },
            "Sony": {
                "PlayStation": 1,
                "PlayStation Vita": 1
            },
            "Xiaomi": {
                "Mi": 1,
                "Redmi": 1
            }
        });
        /* Detectable operating systems (order is important). */ var os = getOS([
            "Windows Phone",
            "KaiOS",
            "Android",
            "CentOS",
            {
                "label": "Chrome OS",
                "pattern": "CrOS"
            },
            "Debian",
            {
                "label": "DragonFly BSD",
                "pattern": "DragonFly"
            },
            "Fedora",
            "FreeBSD",
            "Gentoo",
            "Haiku",
            "Kubuntu",
            "Linux Mint",
            "OpenBSD",
            "Red Hat",
            "SuSE",
            "Ubuntu",
            "Xubuntu",
            "Cygwin",
            "Symbian OS",
            "hpwOS",
            "webOS ",
            "webOS",
            "Tablet OS",
            "Tizen",
            "Linux",
            "Mac OS X",
            "Macintosh",
            "Mac",
            "Windows 98;",
            "Windows "
        ]);
        /*------------------------------------------------------------------------*/ /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */ function getLayout(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */ function getManufacturer(guesses) {
            return reduce(guesses, function(result, value, key) {
                // Lookup the manufacturer by product or scan the UA for the manufacturer.
                return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp("\\b" + qualify(key) + "(?:\\b|\\w*\\d)", "i").exec(ua)) && key;
            });
        }
        /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */ function getName(guesses) {
            return reduce(guesses, function(result, guess) {
                return result || RegExp("\\b" + (guess.pattern || qualify(guess)) + "\\b", "i").exec(ua) && (guess.label || guess);
            });
        }
        /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */ function getOS(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp("\\b" + pattern + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(ua))) result = cleanupOS(result, pattern, guess.label || guess);
                return result;
            });
        }
        /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */ function getProduct(guesses) {
            return reduce(guesses, function(result, guess) {
                var pattern = guess.pattern || qualify(guess);
                if (!result && (result = RegExp("\\b" + pattern + " *\\d+[.\\w_]*", "i").exec(ua) || RegExp("\\b" + pattern + " *\\w+-[\\w]*", "i").exec(ua) || RegExp("\\b" + pattern + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(ua))) {
                    // Split by forward slash and append product version if needed.
                    if ((result = String(guess.label && !RegExp(pattern, "i").test(guess.label) ? guess.label : result).split("/"))[1] && !/[\d.]+/.test(result[0])) result[0] += " " + result[1];
                    // Correct character case and cleanup string.
                    guess = guess.label || guess;
                    result = format(result[0].replace(RegExp(pattern, "i"), guess).replace(RegExp("; *(?:" + guess + "[_-])?", "i"), " ").replace(RegExp("(" + guess + ")[-_.]?(\\w)", "i"), "$1 $2"));
                }
                return result;
            });
        }
        /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */ function getVersion(patterns) {
            return reduce(patterns, function(result, pattern) {
                return result || (RegExp(pattern + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(ua) || 0)[1] || null;
            });
        }
        /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */ function toStringPlatform() {
            return this.description || "";
        }
        /*------------------------------------------------------------------------*/ // Convert layout to an array so we can add extra details.
        layout && (layout = [
            layout
        ]);
        // Detect Android products.
        // Browsers on Android devices typically provide their product IDS after "Android;"
        // up to "Build" or ") AppleWebKit".
        // Example:
        // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
        // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
        if (/\bAndroid\b/.test(os) && !product && (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) product = trim(data[1])// Replace any language codes (eg. "en-US").
        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null;
        // Detect product names that contain their manufacturer's name.
        if (manufacturer && !product) product = getProduct([
            manufacturer
        ]);
        else if (manufacturer && product) product = product.replace(RegExp("^(" + qualify(manufacturer) + ")[-_.\\s]", "i"), manufacturer + " ").replace(RegExp("^(" + qualify(manufacturer) + ")[-_.]?(\\w)", "i"), manufacturer + " $2");
        // Clean up Google TV.
        if (data = /\bGoogle TV\b/.exec(product)) product = data[0];
        // Detect simulators.
        if (/\bSimulator\b/i.test(ua)) product = (product ? product + " " : "") + "Simulator";
        // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
        if (name == "Opera Mini" && /\bOPiOS\b/.test(ua)) description.push("running in Turbo/Uncompressed mode");
        // Detect IE Mobile 11.
        if (name == "IE" && /\blike iPhone OS\b/.test(ua)) {
            data = parse(ua.replace(/like iPhone OS/, ""));
            manufacturer = data.manufacturer;
            product = data.product;
        } else if (/^iP/.test(product)) {
            name || (name = "Safari");
            os = "iOS" + ((data = / OS ([\d_]+)/i.exec(ua)) ? " " + data[1].replace(/_/g, ".") : "");
        } else if (name == "Konqueror" && /^Linux\b/i.test(os)) os = "Kubuntu";
        else if (manufacturer && manufacturer != "Google" && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = "Android Browser";
            os = /\bAndroid\b/.test(os) ? os : "Android";
        } else if (name == "Silk") {
            if (!/\bMobi/i.test(ua)) {
                os = "Android";
                description.unshift("desktop mode");
            }
            if (/Accelerated *= *true/i.test(ua)) description.unshift("accelerated");
        } else if (name == "UC Browser" && /\bUCWEB\b/.test(ua)) description.push("speed mode");
        else if (name == "PaleMoon" && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) description.push("identifying as Firefox " + data[1]);
        else if (name == "Firefox" && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
            os || (os = "Firefox OS");
            product || (product = data[1]);
        } else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
            // Escape the `/` for Firefox 1.
            if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + "/") + 8))) // Clear name of false positives.
            name = null;
            // Reassign a generic name.
            if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + " Browser";
        } else if (name == "Electron" && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) description.push("Chromium " + data);
        // Detect non-Opera (Presto-based) versions (order is important).
        if (!version) version = getVersion([
            "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
            "Version",
            qualify(name),
            "(?:Firefox|Minefield|NetFront)"
        ]);
        // Detect stubborn layout engines.
        if (data = layout == "iCab" && parseFloat(version) > 3 && "WebKit" || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && "WebKit" || !layout && /\bMSIE\b/i.test(ua) && (os == "Mac OS" ? "Tasman" : "Trident") || layout == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(name) && "NetFront") layout = [
            data
        ];
        // Detect Windows Phone 7 desktop mode.
        if (name == "IE" && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
            name += " Mobile";
            os = "Windows Phone " + (/\+$/.test(data) ? data : data + ".x");
            description.unshift("desktop mode");
        } else if (/\bWPDesktop\b/i.test(ua)) {
            name = "IE Mobile";
            os = "Windows Phone 8.x";
            description.unshift("desktop mode");
            version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
        } else if (name != "IE" && layout == "Trident" && (data = /\brv:([\d.]+)/.exec(ua))) {
            if (name) description.push("identifying as " + name + (version ? " " + version : ""));
            name = "IE";
            version = data[1];
        }
        // Leverage environment features.
        if (useFeatures) {
            // Detect server-side environments.
            // Rhino has a global function while others have a global object.
            if (isHostType(context, "global")) {
                if (java) {
                    data = java.lang.System;
                    arch = data.getProperty("os.arch");
                    os = os || data.getProperty("os.name") + " " + data.getProperty("os.version");
                }
                if (rhino) {
                    try {
                        version = context.require("ringo/engine").version.join(".");
                        name = "RingoJS";
                    } catch (e) {
                        if ((data = context.system) && data.global.system == context.system) {
                            name = "Narwhal";
                            os || (os = data[0].os || null);
                        }
                    }
                    if (!name) name = "Rhino";
                } else if (typeof context.process == "object" && !context.process.browser && (data = context.process)) {
                    if (typeof data.versions == "object") {
                        if (typeof data.versions.electron == "string") {
                            description.push("Node " + data.versions.node);
                            name = "Electron";
                            version = data.versions.electron;
                        } else if (typeof data.versions.nw == "string") {
                            description.push("Chromium " + version, "Node " + data.versions.node);
                            name = "NW.js";
                            version = data.versions.nw;
                        }
                    }
                    if (!name) {
                        name = "Node.js";
                        arch = data.arch;
                        os = data.platform;
                        version = /[\d.]+/.exec(data.version);
                        version = version ? version[0] : null;
                    }
                }
            } else if (getClassOf(data = context.runtime) == airRuntimeClass) {
                name = "Adobe AIR";
                os = data.flash.system.Capabilities.os;
            } else if (getClassOf(data = context.phantom) == phantomClass) {
                name = "PhantomJS";
                version = (data = data.version || null) && data.major + "." + data.minor + "." + data.patch;
            } else if (typeof doc.documentMode == "number" && (data = /\bTrident\/(\d+)/i.exec(ua))) {
                // We're in compatibility mode when the Trident version + 4 doesn't
                // equal the document mode.
                version = [
                    version,
                    doc.documentMode
                ];
                if ((data = +data[1] + 4) != version[1]) {
                    description.push("IE " + version[1] + " mode");
                    layout && (layout[1] = "");
                    version[1] = data;
                }
                version = name == "IE" ? String(version[1].toFixed(1)) : version[0];
            } else if (typeof doc.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(name)) {
                description.push("masking as " + name + " " + version);
                name = "IE";
                version = "11.0";
                layout = [
                    "Trident"
                ];
                os = "Windows";
            }
            os = os && format(os);
        }
        // Detect prerelease phases.
        if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ";" + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && "a")) {
            prerelease = /b/i.test(data) ? "beta" : "alpha";
            version = version.replace(RegExp(data + "\\+?$"), "") + (prerelease == "beta" ? beta : alpha) + (/\d+\+?/.exec(data) || "");
        }
        // Detect Firefox Mobile.
        if (name == "Fennec" || name == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) name = "Firefox Mobile";
        else if (name == "Maxthon" && version) version = version.replace(/\.[\d.]+/, ".x");
        else if (/\bXbox\b/i.test(product)) {
            if (product == "Xbox 360") os = null;
            if (product == "Xbox 360" && /\bIEMobile\b/.test(ua)) description.unshift("mobile mode");
        } else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == "Windows CE" || /Mobi/i.test(ua))) name += " Mobile";
        else if (name == "IE" && useFeatures) try {
            if (context.external === null) description.unshift("platform preview");
        } catch (e) {
            description.unshift("embedded");
        }
        else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(ua) || 0)[1] || version)) {
            data = [
                data,
                /BB10/.test(ua)
            ];
            os = (data[1] ? (product = null, manufacturer = "BlackBerry") : "Device Software") + " " + data[0];
            version = null;
        } else if (this != forOwn && product != "Wii" && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(os) || name == "IE" && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, "") + ";")) && data.name) {
            // When "identifying", the UA contains both Opera and the other browser's name.
            data = "ing as " + data.name + ((data = data.version) ? " " + data : "");
            if (reOpera.test(name)) {
                if (/\bIE\b/.test(data) && os == "Mac OS") os = null;
                data = "identify" + data;
            } else {
                data = "mask" + data;
                if (operaClass) name = format(operaClass.replace(/([a-z])([A-Z])/g, "$1 $2"));
                else name = "Opera";
                if (/\bIE\b/.test(data)) os = null;
                if (!useFeatures) version = null;
            }
            layout = [
                "Presto"
            ];
            description.push(data);
        }
        // Detect WebKit Nightly and approximate Chrome/Safari versions.
        if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
            // Correct build number for numeric comparison.
            // (e.g. "532.5" becomes "532.05")
            data = [
                parseFloat(data.replace(/\.(\d)$/, ".0$1")),
                data
            ];
            // Nightly builds are postfixed with a "+".
            if (name == "Safari" && data[1].slice(-1) == "+") {
                name = "WebKit Nightly";
                prerelease = "alpha";
                version = data[1].slice(0, -1);
            } else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) version = null;
            // Use the full Chrome version when available.
            data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
            // Detect Blink layout engine.
            if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == "WebKit") layout = [
                "Blink"
            ];
            // Detect JavaScriptCore.
            // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
            if (!useFeatures || !likeChrome && !data[1]) {
                layout && (layout[1] = "like Safari");
                data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? "4+" : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : "12");
            } else {
                layout && (layout[1] = "like Chrome");
                data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? "13+" : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? "21+" : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != "Blink" ? "27" : "28");
            }
            // Add the postfix of ".x" or "+" for approximate versions.
            layout && (layout[1] += " " + (data += typeof data == "number" ? ".x" : /[.+]/.test(data) ? "" : "+"));
            // Obscure version for some Safari 1-2 releases.
            if (name == "Safari" && (!version || parseInt(version) > 45)) version = data;
            else if (name == "Chrome" && /\bHeadlessChrome/i.test(ua)) description.unshift("headless");
        }
        // Detect Opera desktop modes.
        if (name == "Opera" && (data = /\bzbov|zvav$/.exec(os))) {
            name += " ";
            description.unshift("desktop mode");
            if (data == "zvav") {
                name += "Mini";
                version = null;
            } else name += "Mobile";
            os = os.replace(RegExp(" *" + data + "$"), "");
        } else if (name == "Safari" && /\bChrome\b/.exec(layout && layout[1])) {
            description.unshift("desktop mode");
            name = "Chrome Mobile";
            version = null;
            if (/\bOS X\b/.test(os)) {
                manufacturer = "Apple";
                os = "iOS 4.3+";
            } else os = null;
        } else if (/\bSRWare Iron\b/.test(name) && !version) version = getVersion("Chrome");
        // Strip incorrect OS versions.
        if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf("/" + data + "-") > -1) os = trim(os.replace(data, ""));
        // Ensure OS does not include the browser name.
        if (os && os.indexOf(name) != -1 && !RegExp(name + " OS").test(os)) os = os.replace(RegExp(" *" + qualify(name) + " *"), "");
        // Add layout engine.
        if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != "Safari" && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) // Don't add layout details to description if they are falsey.
        (data = layout[layout.length - 1]) && description.push(data);
        // Combine contextual information.
        if (description.length) description = [
            "(" + description.join("; ") + ")"
        ];
        // Append manufacturer to description.
        if (manufacturer && product && product.indexOf(manufacturer) < 0) description.push("on " + manufacturer);
        // Append product to description.
        if (product) description.push((/^on /.test(description[description.length - 1]) ? "" : "on ") + product);
        // Parse the OS into an object.
        if (os) {
            data = / ([\d.+]+)$/.exec(os);
            isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == "/";
            os = {
                "architecture": 32,
                "family": data && !isSpecialCasedOS ? os.replace(data[0], "") : os,
                "version": data ? data[1] : null,
                "toString": function() {
                    var version = this.version;
                    return this.family + (version && !isSpecialCasedOS ? " " + version : "") + (this.architecture == 64 ? " 64-bit" : "");
                }
            };
        }
        // Add browser/OS architecture.
        if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
            if (os) {
                os.architecture = 64;
                os.family = os.family.replace(RegExp(" *" + data), "");
            }
            if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) description.unshift("32-bit");
        } else if (os && /^OS X/.test(os.family) && name == "Chrome" && parseFloat(version) >= 39) os.architecture = 64;
        ua || (ua = null);
        /*------------------------------------------------------------------------*/ /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */ var platform = {};
        /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */ platform.description = ua;
        /**
     * The name of the browser's layout engine.
     *
     * The list of common layout engines include:
     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
     *
     * @memberOf platform
     * @type string|null
     */ platform.layout = layout && layout[0];
        /**
     * The name of the product's manufacturer.
     *
     * The list of manufacturers include:
     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
     * "Nokia", "Samsung" and "Sony"
     *
     * @memberOf platform
     * @type string|null
     */ platform.manufacturer = manufacturer;
        /**
     * The name of the browser/environment.
     *
     * The list of common browser names include:
     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
     * "Opera Mini" and "Opera"
     *
     * Mobile versions of some browsers have "Mobile" appended to their name:
     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
     *
     * @memberOf platform
     * @type string|null
     */ platform.name = name;
        /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */ platform.prerelease = prerelease;
        /**
     * The name of the product hosting the browser.
     *
     * The list of common products include:
     *
     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
     *
     * @memberOf platform
     * @type string|null
     */ platform.product = product;
        /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */ platform.ua = ua;
        /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */ platform.version = name && version;
        /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */ platform.os = os || {
            /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */ "architecture": null,
            /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
       * "SuSE", "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */ "family": null,
            /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */ "version": null,
            /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */ "toString": function() {
                return "null";
            }
        };
        platform.parse = parse;
        platform.toString = toStringPlatform;
        if (platform.version) description.unshift(version);
        if (platform.name) description.unshift(name);
        if (os && name && !(os == String(os).split(" ")[0] && (os == name.split(" ")[0] || product))) description.push(product ? "(" + os + ")" : "on " + os);
        if (description.length) platform.description = description.join(" ");
        return platform;
    }
    /*--------------------------------------------------------------------------*/ // Export platform.
    var platform = parse();
    // Some AMD build optimizers, like r.js, check for condition patterns like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose platform on the global object to prevent errors when platform is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        root.platform = platform;
        // Define as an anonymous module so platform can be aliased through path mapping.
        define(function() {
            return platform;
        });
    } else if (freeExports && freeModule) // Export for CommonJS support.
    forOwn(platform, function(value, key) {
        freeExports[key] = value;
    });
    else // Export to the global object.
    root.platform = platform;
}).call(this);

});

parcelRegister("4uLFE", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("a9hsZ"))((parcelRequire("d8HMG")).resolve("2emaS")),
    (parcelRequire("a0MnV"))((parcelRequire("d8HMG")).resolve("lAfEV"))
]).then(()=>parcelRequire("3aquH"));

});
parcelRegister("a9hsZ", function(module, exports) {
"use strict";

var $ixYzc = parcelRequire("ixYzc");
module.exports = $ixYzc(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("ixYzc", function(module, exports) {
"use strict";
var $d80a4a5444370561$var$cachedBundles = {};
var $d80a4a5444370561$var$cachedPreloads = {};
var $d80a4a5444370561$var$cachedPrefetches = {};
function $d80a4a5444370561$var$getCache(type) {
    switch(type){
        case "preload":
            return $d80a4a5444370561$var$cachedPreloads;
        case "prefetch":
            return $d80a4a5444370561$var$cachedPrefetches;
        default:
            return $d80a4a5444370561$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $d80a4a5444370561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("a0MnV", function(module, exports) {
"use strict";

var $ixYzc = parcelRequire("ixYzc");
module.exports = $ixYzc(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});



var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");
var $adc227c367c2f6aa$export$882461b6382ed46c;
var $adc227c367c2f6aa$export$757ceba2d55c277e;
"use strict";

var $95gxM = parcelRequire("95gxM");
var $adc227c367c2f6aa$var$i = $95gxM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$adc227c367c2f6aa$export$882461b6382ed46c = function(c, o) {
    $adc227c367c2f6aa$var$i.usingClientEntryPoint = true;
    try {
        return $95gxM.createRoot(c, o);
    } finally{
        $adc227c367c2f6aa$var$i.usingClientEntryPoint = false;
    }
};
$adc227c367c2f6aa$export$757ceba2d55c277e = function(c, h, o) {
    $adc227c367c2f6aa$var$i.usingClientEntryPoint = true;
    try {
        return $95gxM.hydrateRoot(c, h, o);
    } finally{
        $adc227c367c2f6aa$var$i.usingClientEntryPoint = false;
    }
};


/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8FY87 = parcelRequire("8FY87");

var $95gxM = parcelRequire("95gxM");
/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $e887188a2ce2efb5$var$_extends() {
    $e887188a2ce2efb5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e887188a2ce2efb5$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $e887188a2ce2efb5$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($e887188a2ce2efb5$export$e19cd5f9376f8cee || ($e887188a2ce2efb5$export$e19cd5f9376f8cee = {}));
const $e887188a2ce2efb5$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $e887188a2ce2efb5$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $e887188a2ce2efb5$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $e887188a2ce2efb5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $e887188a2ce2efb5$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $e887188a2ce2efb5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
    }
    return $e887188a2ce2efb5$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $e887188a2ce2efb5$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $e887188a2ce2efb5$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $e887188a2ce2efb5$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $e887188a2ce2efb5$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $e887188a2ce2efb5$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $e887188a2ce2efb5$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $e887188a2ce2efb5$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $e887188a2ce2efb5$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $e887188a2ce2efb5$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $e887188a2ce2efb5$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $e887188a2ce2efb5$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $e887188a2ce2efb5$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $e887188a2ce2efb5$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $e887188a2ce2efb5$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($e887188a2ce2efb5$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        let location = $e887188a2ce2efb5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $e887188a2ce2efb5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        let location = $e887188a2ce2efb5$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $e887188a2ce2efb5$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $e887188a2ce2efb5$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $e887188a2ce2efb5$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($e887188a2ce2efb5$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($e887188a2ce2efb5$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $e887188a2ce2efb5$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($e887188a2ce2efb5$var$ResultType || ($e887188a2ce2efb5$var$ResultType = {}));
const $e887188a2ce2efb5$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $e887188a2ce2efb5$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $e887188a2ce2efb5$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $e887188a2ce2efb5$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $e887188a2ce2efb5$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($e887188a2ce2efb5$var$isIndexRoute(route)) {
            let indexRoute = $e887188a2ce2efb5$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $e887188a2ce2efb5$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $e887188a2ce2efb5$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $e887188a2ce2efb5$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $e887188a2ce2efb5$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $e887188a2ce2efb5$var$flattenRoutes(routes);
    $e887188a2ce2efb5$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $e887188a2ce2efb5$var$decodePath(pathname);
        matches = $e887188a2ce2efb5$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $e887188a2ce2efb5$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $e887188a2ce2efb5$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $e887188a2ce2efb5$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $e887188a2ce2efb5$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $e887188a2ce2efb5$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $e887188a2ce2efb5$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $e887188a2ce2efb5$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $e887188a2ce2efb5$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $e887188a2ce2efb5$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $e887188a2ce2efb5$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $e887188a2ce2efb5$var$paramRe = /^:[\w-]+$/;
const $e887188a2ce2efb5$var$dynamicSegmentValue = 3;
const $e887188a2ce2efb5$var$indexRouteValue = 2;
const $e887188a2ce2efb5$var$emptySegmentValue = 1;
const $e887188a2ce2efb5$var$staticSegmentValue = 10;
const $e887188a2ce2efb5$var$splatPenalty = -2;
const $e887188a2ce2efb5$var$isSplat = (s)=>s === "*";
function $e887188a2ce2efb5$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($e887188a2ce2efb5$var$isSplat)) initialScore += $e887188a2ce2efb5$var$splatPenalty;
    if (index) initialScore += $e887188a2ce2efb5$var$indexRouteValue;
    return segments.filter((s)=>!$e887188a2ce2efb5$var$isSplat(s)).reduce((score, segment)=>score + ($e887188a2ce2efb5$var$paramRe.test(segment) ? $e887188a2ce2efb5$var$dynamicSegmentValue : segment === "" ? $e887188a2ce2efb5$var$emptySegmentValue : $e887188a2ce2efb5$var$staticSegmentValue), initialScore);
}
function $e887188a2ce2efb5$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $e887188a2ce2efb5$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $e887188a2ce2efb5$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $e887188a2ce2efb5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $e887188a2ce2efb5$export$a5c6d149b50c1d86($e887188a2ce2efb5$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $e887188a2ce2efb5$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $e887188a2ce2efb5$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $e887188a2ce2efb5$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $e887188a2ce2efb5$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $e887188a2ce2efb5$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $e887188a2ce2efb5$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $e887188a2ce2efb5$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $e887188a2ce2efb5$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $e887188a2ce2efb5$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $e887188a2ce2efb5$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $e887188a2ce2efb5$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $e887188a2ce2efb5$var$normalizeSearch(search),
        hash: $e887188a2ce2efb5$var$normalizeHash(hash)
    };
}
function $e887188a2ce2efb5$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $e887188a2ce2efb5$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $e887188a2ce2efb5$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $e887188a2ce2efb5$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $e887188a2ce2efb5$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $e887188a2ce2efb5$export$8ccf933b0513f8d0(toArg);
    else {
        to = $e887188a2ce2efb5$var$_extends({}, toArg);
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $e887188a2ce2efb5$var$getInvalidPathError("?", "pathname", "search", to));
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $e887188a2ce2efb5$var$getInvalidPathError("#", "pathname", "hash", to));
        $e887188a2ce2efb5$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $e887188a2ce2efb5$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $e887188a2ce2efb5$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $e887188a2ce2efb5$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $e887188a2ce2efb5$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $e887188a2ce2efb5$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $e887188a2ce2efb5$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $e887188a2ce2efb5$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $e887188a2ce2efb5$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $e887188a2ce2efb5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $e887188a2ce2efb5$export$42a99a7a4bc0e76a extends Error {
}
class $e887188a2ce2efb5$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $e887188a2ce2efb5$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $e887188a2ce2efb5$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $e887188a2ce2efb5$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $e887188a2ce2efb5$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $e887188a2ce2efb5$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $e887188a2ce2efb5$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $e887188a2ce2efb5$var$unwrapTrackedPromise(value) {
    if (!$e887188a2ce2efb5$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $e887188a2ce2efb5$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $e887188a2ce2efb5$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e887188a2ce2efb5$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $e887188a2ce2efb5$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $e887188a2ce2efb5$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $e887188a2ce2efb5$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $e887188a2ce2efb5$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $e887188a2ce2efb5$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $e887188a2ce2efb5$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $e887188a2ce2efb5$var$validMutationMethods = new Set($e887188a2ce2efb5$var$validMutationMethodsArr);
const $e887188a2ce2efb5$var$validRequestMethodsArr = [
    "get",
    ...$e887188a2ce2efb5$var$validMutationMethodsArr
];
const $e887188a2ce2efb5$var$validRequestMethods = new Set($e887188a2ce2efb5$var$validRequestMethodsArr);
const $e887188a2ce2efb5$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $e887188a2ce2efb5$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $e887188a2ce2efb5$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e887188a2ce2efb5$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $e887188a2ce2efb5$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $e887188a2ce2efb5$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $e887188a2ce2efb5$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $e887188a2ce2efb5$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e887188a2ce2efb5$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $e887188a2ce2efb5$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $e887188a2ce2efb5$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $e887188a2ce2efb5$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $e887188a2ce2efb5$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $e887188a2ce2efb5$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $e887188a2ce2efb5$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$e887188a2ce2efb5$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $e887188a2ce2efb5$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $e887188a2ce2efb5$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $e887188a2ce2efb5$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $e887188a2ce2efb5$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $e887188a2ce2efb5$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($e887188a2ce2efb5$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $e887188a2ce2efb5$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $e887188a2ce2efb5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $e887188a2ce2efb5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $e887188a2ce2efb5$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $e887188a2ce2efb5$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $e887188a2ce2efb5$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $e887188a2ce2efb5$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $e887188a2ce2efb5$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $e887188a2ce2efb5$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $e887188a2ce2efb5$var$findNearestBoundary(matches).route.id,
            {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $e887188a2ce2efb5$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $e887188a2ce2efb5$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $e887188a2ce2efb5$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $e887188a2ce2efb5$var$_extends({
            matches: matches
        }, $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $e887188a2ce2efb5$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $e887188a2ce2efb5$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $e887188a2ce2efb5$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $e887188a2ce2efb5$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $e887188a2ce2efb5$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $e887188a2ce2efb5$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $e887188a2ce2efb5$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($e887188a2ce2efb5$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $e887188a2ce2efb5$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $e887188a2ce2efb5$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $e887188a2ce2efb5$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $e887188a2ce2efb5$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $e887188a2ce2efb5$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e887188a2ce2efb5$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($e887188a2ce2efb5$var$isRedirectResult(actionResult) || $e887188a2ce2efb5$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($e887188a2ce2efb5$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $e887188a2ce2efb5$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($e887188a2ce2efb5$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($e887188a2ce2efb5$var$isDeferredResult(actionResult)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $e887188a2ce2efb5$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $e887188a2ce2efb5$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $e887188a2ce2efb5$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $e887188a2ce2efb5$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $e887188a2ce2efb5$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $e887188a2ce2efb5$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $e887188a2ce2efb5$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) result = await $e887188a2ce2efb5$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $e887188a2ce2efb5$export$3e9cee6b33872309(!$e887188a2ce2efb5$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $e887188a2ce2efb5$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $e887188a2ce2efb5$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $e887188a2ce2efb5$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $e887188a2ce2efb5$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $e887188a2ce2efb5$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $e887188a2ce2efb5$export$e19cd5f9376f8cee.Replace : $e887188a2ce2efb5$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $e887188a2ce2efb5$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($e887188a2ce2efb5$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $e887188a2ce2efb5$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $e887188a2ce2efb5$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $e887188a2ce2efb5$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $e887188a2ce2efb5$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($e887188a2ce2efb5$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $e887188a2ce2efb5$var$ResultType.redirect,
                        response: $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $e887188a2ce2efb5$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $e887188a2ce2efb5$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $e887188a2ce2efb5$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $e887188a2ce2efb5$var$ResultType.error,
                    error: $e887188a2ce2efb5$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $e887188a2ce2efb5$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $e887188a2ce2efb5$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $e887188a2ce2efb5$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $e887188a2ce2efb5$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $e887188a2ce2efb5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $e887188a2ce2efb5$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $e887188a2ce2efb5$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $e887188a2ce2efb5$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $e887188a2ce2efb5$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $e887188a2ce2efb5$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $e887188a2ce2efb5$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$e887188a2ce2efb5$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $e887188a2ce2efb5$export$4d0306f8f6a4585b = Symbol("deferred");
function $e887188a2ce2efb5$export$3336b097a6fbc59a(routes, opts) {
    $e887188a2ce2efb5$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $e887188a2ce2efb5$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $e887188a2ce2efb5$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $e887188a2ce2efb5$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e887188a2ce2efb5$var$createLocation("", $e887188a2ce2efb5$export$fe53371bee54353d(url), null, "default");
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e887188a2ce2efb5$var$isValidMethod(method) && method !== "HEAD") {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $e887188a2ce2efb5$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($e887188a2ce2efb5$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $e887188a2ce2efb5$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $e887188a2ce2efb5$var$createLocation("", $e887188a2ce2efb5$export$fe53371bee54353d(url), null, "default");
        let matches = $e887188a2ce2efb5$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$e887188a2ce2efb5$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $e887188a2ce2efb5$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $e887188a2ce2efb5$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $e887188a2ce2efb5$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($e887188a2ce2efb5$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$e887188a2ce2efb5$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $e887188a2ce2efb5$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($e887188a2ce2efb5$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $e887188a2ce2efb5$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $e887188a2ce2efb5$var$isResponse(result) ? result : $e887188a2ce2efb5$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($e887188a2ce2efb5$var$isHandlerResult(e) && $e887188a2ce2efb5$var$isResponse(e.result)) {
                if (e.type === $e887188a2ce2efb5$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($e887188a2ce2efb5$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($e887188a2ce2efb5$var$isDeferredResult(result)) {
            let error = $e887188a2ce2efb5$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($e887188a2ce2efb5$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $e887188a2ce2efb5$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $e887188a2ce2efb5$var$_extends({}, context, {
                statusCode: $e887188a2ce2efb5$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $e887188a2ce2efb5$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $e887188a2ce2efb5$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $e887188a2ce2efb5$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $e887188a2ce2efb5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $e887188a2ce2efb5$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $e887188a2ce2efb5$var$callDataStrategyImpl(unstable_dataStrategy || $e887188a2ce2efb5$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($e887188a2ce2efb5$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($e887188a2ce2efb5$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $e887188a2ce2efb5$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $e887188a2ce2efb5$export$fec11da027c70692(routes, context, error) {
    let newContext = $e887188a2ce2efb5$var$_extends({}, context, {
        statusCode: $e887188a2ce2efb5$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $e887188a2ce2efb5$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $e887188a2ce2efb5$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $e887188a2ce2efb5$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $e887188a2ce2efb5$export$cae722b0cc860f13(to ? to : ".", $e887188a2ce2efb5$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $e887188a2ce2efb5$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$e887188a2ce2efb5$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $e887188a2ce2efb5$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $e887188a2ce2efb5$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $e887188a2ce2efb5$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$e887188a2ce2efb5$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$e887188a2ce2efb5$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $e887188a2ce2efb5$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $e887188a2ce2efb5$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $e887188a2ce2efb5$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$e887188a2ce2efb5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$e887188a2ce2efb5$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $e887188a2ce2efb5$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $e887188a2ce2efb5$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $e887188a2ce2efb5$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $e887188a2ce2efb5$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $e887188a2ce2efb5$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $e887188a2ce2efb5$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $e887188a2ce2efb5$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $e887188a2ce2efb5$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($e887188a2ce2efb5$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $e887188a2ce2efb5$var$shouldRevalidateLoader(match, $e887188a2ce2efb5$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $e887188a2ce2efb5$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $e887188a2ce2efb5$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $e887188a2ce2efb5$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $e887188a2ce2efb5$var$shouldRevalidateLoader(fetcherMatch, $e887188a2ce2efb5$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $e887188a2ce2efb5$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $e887188a2ce2efb5$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $e887188a2ce2efb5$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $e887188a2ce2efb5$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $e887188a2ce2efb5$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $e887188a2ce2efb5$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$e887188a2ce2efb5$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $e887188a2ce2efb5$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $e887188a2ce2efb5$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $e887188a2ce2efb5$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $e887188a2ce2efb5$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $e887188a2ce2efb5$var$ResultType.data,
                    result: undefined
                });
            };
            return $e887188a2ce2efb5$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$e887188a2ce2efb5$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $e887188a2ce2efb5$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $e887188a2ce2efb5$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $e887188a2ce2efb5$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $e887188a2ce2efb5$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $e887188a2ce2efb5$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $e887188a2ce2efb5$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $e887188a2ce2efb5$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $e887188a2ce2efb5$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($e887188a2ce2efb5$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $e887188a2ce2efb5$var$ResultType.error,
                error: e
            };
        }
        if (type === $e887188a2ce2efb5$var$ResultType.error) return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: new $e887188a2ce2efb5$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $e887188a2ce2efb5$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $e887188a2ce2efb5$var$ResultType.error) return {
        type: $e887188a2ce2efb5$var$ResultType.error,
        error: result,
        statusCode: $e887188a2ce2efb5$export$972111febbeef05b(result) ? result.status : status
    };
    if ($e887188a2ce2efb5$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $e887188a2ce2efb5$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $e887188a2ce2efb5$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $e887188a2ce2efb5$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $e887188a2ce2efb5$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $e887188a2ce2efb5$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $e887188a2ce2efb5$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($e887188a2ce2efb5$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $e887188a2ce2efb5$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $e887188a2ce2efb5$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($e887188a2ce2efb5$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $e887188a2ce2efb5$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $e887188a2ce2efb5$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $e887188a2ce2efb5$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $e887188a2ce2efb5$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $e887188a2ce2efb5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $e887188a2ce2efb5$export$3e9cee6b33872309(!$e887188a2ce2efb5$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $e887188a2ce2efb5$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($e887188a2ce2efb5$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $e887188a2ce2efb5$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $e887188a2ce2efb5$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $e887188a2ce2efb5$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($e887188a2ce2efb5$var$isErrorResult(result)) {
            let boundaryMatch = $e887188a2ce2efb5$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $e887188a2ce2efb5$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($e887188a2ce2efb5$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $e887188a2ce2efb5$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($e887188a2ce2efb5$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $e887188a2ce2efb5$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $e887188a2ce2efb5$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $e887188a2ce2efb5$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $e887188a2ce2efb5$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $e887188a2ce2efb5$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $e887188a2ce2efb5$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $e887188a2ce2efb5$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $e887188a2ce2efb5$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $e887188a2ce2efb5$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $e887188a2ce2efb5$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $e887188a2ce2efb5$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($e887188a2ce2efb5$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $e887188a2ce2efb5$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(path) : path;
    return $e887188a2ce2efb5$export$fe53371bee54353d($e887188a2ce2efb5$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $e887188a2ce2efb5$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $e887188a2ce2efb5$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $e887188a2ce2efb5$var$ResultType.data || result.type === $e887188a2ce2efb5$var$ResultType.error);
}
function $e887188a2ce2efb5$var$isRedirectHandlerResult(result) {
    return $e887188a2ce2efb5$var$isResponse(result.result) && $e887188a2ce2efb5$var$redirectStatusCodes.has(result.result.status);
}
function $e887188a2ce2efb5$var$isDeferredResult(result) {
    return result.type === $e887188a2ce2efb5$var$ResultType.deferred;
}
function $e887188a2ce2efb5$var$isErrorResult(result) {
    return result.type === $e887188a2ce2efb5$var$ResultType.error;
}
function $e887188a2ce2efb5$var$isRedirectResult(result) {
    return (result && result.type) === $e887188a2ce2efb5$var$ResultType.redirect;
}
function $e887188a2ce2efb5$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $e887188a2ce2efb5$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $e887188a2ce2efb5$var$isRedirectResponse(result) {
    if (!$e887188a2ce2efb5$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $e887188a2ce2efb5$var$isValidMethod(method) {
    return $e887188a2ce2efb5$var$validRequestMethods.has(method.toLowerCase());
}
function $e887188a2ce2efb5$var$isMutationMethod(method) {
    return $e887188a2ce2efb5$var$validMutationMethods.has(method.toLowerCase());
}
async function $e887188a2ce2efb5$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$e887188a2ce2efb5$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($e887188a2ce2efb5$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $e887188a2ce2efb5$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $e887188a2ce2efb5$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $e887188a2ce2efb5$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $e887188a2ce2efb5$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $e887188a2ce2efb5$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $e887188a2ce2efb5$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $e887188a2ce2efb5$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $e887188a2ce2efb5$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $e887188a2ce2efb5$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $e887188a2ce2efb5$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $e887188a2ce2efb5$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $e887188a2ce2efb5$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $e887188a2ce2efb5$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $e887188a2ce2efb5$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $e887188a2ce2efb5$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $e887188a2ce2efb5$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $e887188a2ce2efb5$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $e887188a2ce2efb5$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $e887188a2ce2efb5$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($e887188a2ce2efb5$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $e887188a2ce2efb5$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8FY87 = parcelRequire("8FY87");

function $d5fb2d3e42b0c581$var$_extends() {
    $d5fb2d3e42b0c581$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5fb2d3e42b0c581$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d5fb2d3e42b0c581$export$3add0d5dce533e2e = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$export$3add0d5dce533e2e.displayName = "DataRouter";
const $d5fb2d3e42b0c581$export$145dfa71566a64dc = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$export$145dfa71566a64dc.displayName = "DataRouterState";
const $d5fb2d3e42b0c581$var$AwaitContext = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d5fb2d3e42b0c581$export$26749e8557646306 = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$export$26749e8557646306.displayName = "Navigation";
const $d5fb2d3e42b0c581$export$c7914228fb69b0f5 = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$export$c7914228fb69b0f5.displayName = "Location";
const $d5fb2d3e42b0c581$export$9072aa6dd1f93057 = /*#__PURE__*/ $8FY87.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$d5fb2d3e42b0c581$export$9072aa6dd1f93057.displayName = "Route";
const $d5fb2d3e42b0c581$var$RouteErrorContext = /*#__PURE__*/ $8FY87.createContext(null);
$d5fb2d3e42b0c581$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $d5fb2d3e42b0c581$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $d5fb2d3e42b0c581$export$9c954a9d03d32f4a() {
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $d5fb2d3e42b0c581$export$45d76561a5302f2b() {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $d5fb2d3e42b0c581$export$1b3f31771c5d07c() {
    return $8FY87.useContext($d5fb2d3e42b0c581$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $d5fb2d3e42b0c581$export$6c330e8992e8a295(pattern) {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    return $8FY87.useMemo(()=>(0, $e887188a2ce2efb5$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d5fb2d3e42b0c581$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8FY87.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $d5fb2d3e42b0c581$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d5fb2d3e42b0c581$var$useNavigateStable() : $d5fb2d3e42b0c581$var$useNavigateUnstable();
}
function $d5fb2d3e42b0c581$var$useNavigateUnstable() {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8FY87.useRef(false);
    $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8FY87.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(activeRef.current, $d5fb2d3e42b0c581$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d5fb2d3e42b0c581$var$OutletContext = /*#__PURE__*/ $8FY87.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $d5fb2d3e42b0c581$export$4138103a3ae699cc() {
    return $8FY87.useContext($d5fb2d3e42b0c581$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $d5fb2d3e42b0c581$export$a3be3530d8e40d0b(context) {
    let outlet = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8FY87.useMemo(()=>(0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $d5fb2d3e42b0c581$export$5d3fca4a98652595(routes, locationArg) {
    return $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    let { matches: parentMatches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $d5fb2d3e42b0c581$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $e887188a2ce2efb5$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $e887188a2ce2efb5$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $d5fb2d3e42b0c581$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d5fb2d3e42b0c581$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $e887188a2ce2efb5$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d5fb2d3e42b0c581$var$DefaultErrorComponent() {
    let error = $d5fb2d3e42b0c581$export$ed527bf60f6e05f2();
    let message = (0, $e887188a2ce2efb5$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $8FY87.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $8FY87.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $8FY87.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8FY87.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8FY87.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d5fb2d3e42b0c581$var$defaultErrorElement = /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$DefaultErrorComponent, null);
class $d5fb2d3e42b0c581$var$RenderErrorBoundary extends $8FY87.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $d5fb2d3e42b0c581$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d5fb2d3e42b0c581$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d5fb2d3e42b0c581$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d5fb2d3e42b0c581$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8FY87.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d5fb2d3e42b0c581$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d5fb2d3e42b0c581$var$DataRouterHook || {});
var $d5fb2d3e42b0c581$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d5fb2d3e42b0c581$var$DataRouterStateHook || {});
function $d5fb2d3e42b0c581$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d5fb2d3e42b0c581$var$useDataRouterContext(hookName) {
    let ctx = $8FY87.useContext($d5fb2d3e42b0c581$export$3add0d5dce533e2e);
    !ctx && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, $d5fb2d3e42b0c581$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $d5fb2d3e42b0c581$var$useDataRouterState(hookName) {
    let state = $8FY87.useContext($d5fb2d3e42b0c581$export$145dfa71566a64dc);
    !state && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, $d5fb2d3e42b0c581$var$getDataRouterConsoleError(hookName));
    return state;
}
function $d5fb2d3e42b0c581$var$useRouteContext(hookName) {
    let route = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    !route && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, $d5fb2d3e42b0c581$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $d5fb2d3e42b0c581$var$useCurrentRouteId(hookName) {
    let route = $d5fb2d3e42b0c581$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d5fb2d3e42b0c581$export$5fc8298006ad9e58() {
    return $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d5fb2d3e42b0c581$export$d0fd4b7106de2769() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d5fb2d3e42b0c581$export$600dc272ed516c15() {
    let dataRouterContext = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseRevalidator);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRevalidator);
    return $8FY87.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d5fb2d3e42b0c581$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseMatches);
    return $8FY87.useMemo(()=>matches.map((m)=>(0, $e887188a2ce2efb5$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d5fb2d3e42b0c581$export$1448a5050d252c4d() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d5fb2d3e42b0c581$export$fd5d37484eab868d(routeId) {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d5fb2d3e42b0c581$export$fdc00f3f26066d5e() {
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseActionData);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d5fb2d3e42b0c581$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8FY87.useContext($d5fb2d3e42b0c581$var$RouteErrorContext);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteError);
    let routeId = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d5fb2d3e42b0c581$export$78a72ddb39bdd145() {
    let value = $8FY87.useContext($d5fb2d3e42b0c581$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d5fb2d3e42b0c581$export$17f53340677d5831() {
    let value = $8FY87.useContext($d5fb2d3e42b0c581$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d5fb2d3e42b0c581$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d5fb2d3e42b0c581$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseBlocker);
    let state = $d5fb2d3e42b0c581$var$useDataRouterState($d5fb2d3e42b0c581$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8FY87.useState("");
    let blockerFunction = $8FY87.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d5fb2d3e42b0c581$var$_extends({}, currentLocation, {
                pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d5fb2d3e42b0c581$var$_extends({}, nextLocation, {
                pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8FY87.useEffect(()=>{
        let key = String(++$d5fb2d3e42b0c581$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8FY87.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $e887188a2ce2efb5$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d5fb2d3e42b0c581$var$useNavigateStable() {
    let { router: router } = $d5fb2d3e42b0c581$var$useDataRouterContext($d5fb2d3e42b0c581$var$DataRouterHook.UseNavigateStable);
    let id = $d5fb2d3e42b0c581$var$useCurrentRouteId($d5fb2d3e42b0c581$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8FY87.useRef(false);
    $d5fb2d3e42b0c581$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8FY87.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(activeRef.current, $d5fb2d3e42b0c581$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d5fb2d3e42b0c581$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d5fb2d3e42b0c581$var$alreadyWarned = {};
function $d5fb2d3e42b0c581$var$warningOnce(key, cond, message) {
    if (!cond && !$d5fb2d3e42b0c581$var$alreadyWarned[key]) {
        $d5fb2d3e42b0c581$var$alreadyWarned[key] = true;
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d5fb2d3e42b0c581$var$START_TRANSITION = "startTransition";
const $d5fb2d3e42b0c581$var$startTransitionImpl = $8FY87[$d5fb2d3e42b0c581$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d5fb2d3e42b0c581$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8FY87.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        if (v7_startTransition && $d5fb2d3e42b0c581$var$startTransitionImpl) $d5fb2d3e42b0c581$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8FY87.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8FY87.useEffect(()=>{
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8FY87.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8FY87.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d5fb2d3e42b0c581$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d5fb2d3e42b0c581$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $d5fb2d3e42b0c581$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $d5fb2d3e42b0c581$var$startTransitionImpl ? $d5fb2d3e42b0c581$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $d5fb2d3e42b0c581$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $8FY87.useContext($d5fb2d3e42b0c581$export$26749e8557646306);
    (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $8FY87.useContext($d5fb2d3e42b0c581$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d5fb2d3e42b0c581$export$45d76561a5302f2b();
    let navigate = $d5fb2d3e42b0c581$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $e887188a2ce2efb5$export$cae722b0cc860f13)(to, (0, $e887188a2ce2efb5$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8FY87.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $d5fb2d3e42b0c581$export$910ae8079b2c2852(props) {
    return $d5fb2d3e42b0c581$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $d5fb2d3e42b0c581$export$e7b0ac011bb776c6(_props) {
    (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $d5fb2d3e42b0c581$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $e887188a2ce2efb5$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d5fb2d3e42b0c581$export$9c954a9d03d32f4a() && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8FY87.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d5fb2d3e42b0c581$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $e887188a2ce2efb5$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8FY87.useMemo(()=>{
        let trailingPathname = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $d5fb2d3e42b0c581$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d5fb2d3e42b0c581$export$5d3fca4a98652595($d5fb2d3e42b0c581$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d5fb2d3e42b0c581$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$ResolveAwait, null, children));
}
var $d5fb2d3e42b0c581$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d5fb2d3e42b0c581$var$AwaitRenderStatus || {});
const $d5fb2d3e42b0c581$var$neverSettledPromise = new Promise(()=>{});
class $d5fb2d3e42b0c581$var$AwaitErrorBoundary extends $8FY87.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d5fb2d3e42b0c581$var$AwaitRenderStatus.error : "_data" in promise ? $d5fb2d3e42b0c581$var$AwaitRenderStatus.success : $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d5fb2d3e42b0c581$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error && promise._error instanceof (0, $e887188a2ce2efb5$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d5fb2d3e42b0c581$var$neverSettledPromise;
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d5fb2d3e42b0c581$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8FY87.createElement($d5fb2d3e42b0c581$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d5fb2d3e42b0c581$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d5fb2d3e42b0c581$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $d5fb2d3e42b0c581$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8FY87.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8FY87.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8FY87.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d5fb2d3e42b0c581$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d5fb2d3e42b0c581$export$e7b0ac011bb776c6) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d5fb2d3e42b0c581$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d5fb2d3e42b0c581$export$daf73786167a7f72(matches) {
    return $d5fb2d3e42b0c581$var$_renderMatches(matches);
}
function $d5fb2d3e42b0c581$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $8FY87.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $8FY87.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $8FY87.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $d5fb2d3e42b0c581$export$f30f7e456d254e83(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d5fb2d3e42b0c581$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d5fb2d3e42b0c581$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $734169eef5d6795a$var$_extends() {
    $734169eef5d6795a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $734169eef5d6795a$var$_extends.apply(this, arguments);
}
function $734169eef5d6795a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $734169eef5d6795a$var$defaultMethod = "get";
const $734169eef5d6795a$var$defaultEncType = "application/x-www-form-urlencoded";
function $734169eef5d6795a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $734169eef5d6795a$var$isButtonElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $734169eef5d6795a$var$isFormElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $734169eef5d6795a$var$isInputElement(object) {
    return $734169eef5d6795a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $734169eef5d6795a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $734169eef5d6795a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$734169eef5d6795a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $734169eef5d6795a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $734169eef5d6795a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $734169eef5d6795a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $734169eef5d6795a$var$_formDataSupportsSubmitter = null;
function $734169eef5d6795a$var$isFormDataSubmitterSupported() {
    if ($734169eef5d6795a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $734169eef5d6795a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $734169eef5d6795a$var$_formDataSupportsSubmitter = true;
    }
    return $734169eef5d6795a$var$_formDataSupportsSubmitter;
}
const $734169eef5d6795a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $734169eef5d6795a$var$getFormEncType(encType) {
    if (encType != null && !$734169eef5d6795a$var$supportedFormEncTypes.has(encType)) {
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $734169eef5d6795a$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $734169eef5d6795a$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($734169eef5d6795a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $734169eef5d6795a$var$defaultMethod;
        encType = $734169eef5d6795a$var$getFormEncType(target.getAttribute("enctype")) || $734169eef5d6795a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($734169eef5d6795a$var$isButtonElement(target) || $734169eef5d6795a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $734169eef5d6795a$var$defaultMethod;
        encType = $734169eef5d6795a$var$getFormEncType(target.getAttribute("formenctype")) || $734169eef5d6795a$var$getFormEncType(form.getAttribute("enctype")) || $734169eef5d6795a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$734169eef5d6795a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($734169eef5d6795a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $734169eef5d6795a$var$defaultMethod;
        action = null;
        encType = $734169eef5d6795a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $734169eef5d6795a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $734169eef5d6795a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $734169eef5d6795a$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $734169eef5d6795a$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $734169eef5d6795a$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $734169eef5d6795a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $734169eef5d6795a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $734169eef5d6795a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d5fb2d3e42b0c581$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $734169eef5d6795a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $e887188a2ce2efb5$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $734169eef5d6795a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $e887188a2ce2efb5$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $734169eef5d6795a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d5fb2d3e42b0c581$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $734169eef5d6795a$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $734169eef5d6795a$var$_extends({}, state, {
        errors: $734169eef5d6795a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $734169eef5d6795a$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $e887188a2ce2efb5$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $734169eef5d6795a$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8FY87.createContext({
    isTransitioning: false
});
$734169eef5d6795a$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $734169eef5d6795a$export$148fd98d095596d4 = /*#__PURE__*/ $8FY87.createContext(new Map());
$734169eef5d6795a$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $734169eef5d6795a$var$START_TRANSITION = "startTransition";
const $734169eef5d6795a$var$startTransitionImpl = $8FY87[$734169eef5d6795a$var$START_TRANSITION];
const $734169eef5d6795a$var$FLUSH_SYNC = "flushSync";
const $734169eef5d6795a$var$flushSyncImpl = $95gxM[$734169eef5d6795a$var$FLUSH_SYNC];
const $734169eef5d6795a$var$USE_ID = "useId";
const $734169eef5d6795a$var$useIdImpl = $8FY87[$734169eef5d6795a$var$USE_ID];
function $734169eef5d6795a$var$startTransitionSafe(cb) {
    if ($734169eef5d6795a$var$startTransitionImpl) $734169eef5d6795a$var$startTransitionImpl(cb);
    else cb();
}
function $734169eef5d6795a$var$flushSyncSafe(cb) {
    if ($734169eef5d6795a$var$flushSyncImpl) $734169eef5d6795a$var$flushSyncImpl(cb);
    else cb();
}
class $734169eef5d6795a$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $734169eef5d6795a$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8FY87.useState(router.state);
    let [pendingState, setPendingState] = $8FY87.useState();
    let [vtContext, setVtContext] = $8FY87.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8FY87.useState();
    let [transition, setTransition] = $8FY87.useState();
    let [interruption, setInterruption] = $8FY87.useState();
    let fetcherData = $8FY87.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8FY87.useCallback((cb)=>{
        if (v7_startTransition) $734169eef5d6795a$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8FY87.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $734169eef5d6795a$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $734169eef5d6795a$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $734169eef5d6795a$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $734169eef5d6795a$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $734169eef5d6795a$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8FY87.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8FY87.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $734169eef5d6795a$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8FY87.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8FY87.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8FY87.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8FY87.useEffect(()=>{
        (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8FY87.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8FY87.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8FY87.createElement($8FY87.Fragment, null, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $734169eef5d6795a$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d5fb2d3e42b0c581$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $734169eef5d6795a$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $734169eef5d6795a$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8FY87.useRef();
    if (historyRef.current == null) historyRef.current = (0, $e887188a2ce2efb5$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $734169eef5d6795a$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8FY87.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8FY87.useCallback((newState)=>{
        v7_startTransition && $734169eef5d6795a$var$startTransitionImpl ? $734169eef5d6795a$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8FY87.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8FY87.createElement((0, $d5fb2d3e42b0c581$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$734169eef5d6795a$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $734169eef5d6795a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $734169eef5d6795a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $734169eef5d6795a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8FY87.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref7, $734169eef5d6795a$var$_excluded);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $734169eef5d6795a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($734169eef5d6795a$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d5fb2d3e42b0c581$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $734169eef5d6795a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8FY87.createElement("a", $734169eef5d6795a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$734169eef5d6795a$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $734169eef5d6795a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8FY87.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref8, $734169eef5d6795a$var$_excluded2);
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let routerState = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $734169eef5d6795a$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$a6c7ac8248d6e38a, $734169eef5d6795a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$734169eef5d6795a$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $734169eef5d6795a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8FY87.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $734169eef5d6795a$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $734169eef5d6795a$var$_objectWithoutPropertiesLoose(_ref9, $734169eef5d6795a$var$_excluded3);
    let submit = $734169eef5d6795a$export$47c85c6e3a081d3();
    let formAction = $734169eef5d6795a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8FY87.createElement("form", $734169eef5d6795a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$734169eef5d6795a$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $734169eef5d6795a$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $734169eef5d6795a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$734169eef5d6795a$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $734169eef5d6795a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($734169eef5d6795a$var$DataRouterHook || ($734169eef5d6795a$var$DataRouterHook = {}));
var $734169eef5d6795a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($734169eef5d6795a$var$DataRouterStateHook || ($734169eef5d6795a$var$DataRouterStateHook = {}));
// Internal hooks
function $734169eef5d6795a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $734169eef5d6795a$var$useDataRouterContext(hookName) {
    let ctx = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$3add0d5dce533e2e));
    !ctx && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, $734169eef5d6795a$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $734169eef5d6795a$var$useDataRouterState(hookName) {
    let state = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$145dfa71566a64dc));
    !state && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, $734169eef5d6795a$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $734169eef5d6795a$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8FY87.useCallback((event)=>{
        if ($734169eef5d6795a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $e887188a2ce2efb5$export$fe53371bee54353d)(location) === (0, $e887188a2ce2efb5$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $734169eef5d6795a$export$f1a78c17382fe22a(defaultInit) {
    (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $8FY87.useRef($734169eef5d6795a$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8FY87.useRef(false);
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let searchParams = $8FY87.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $734169eef5d6795a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    let setSearchParams = $8FY87.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $734169eef5d6795a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $734169eef5d6795a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $734169eef5d6795a$var$fetcherId = 0;
let $734169eef5d6795a$var$getUniqueFetcherId = ()=>"__" + String(++$734169eef5d6795a$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $734169eef5d6795a$export$47c85c6e3a081d3() {
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let currentRouteId = (0, $d5fb2d3e42b0c581$export$5fc8298006ad9e58)();
    return $8FY87.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $734169eef5d6795a$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $734169eef5d6795a$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $734169eef5d6795a$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $734169eef5d6795a$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let routeContext = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$9072aa6dd1f93057));
    !routeContext && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $734169eef5d6795a$var$_extends({}, (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $e887188a2ce2efb5$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $e887188a2ce2efb5$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $734169eef5d6795a$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseFetcher);
    let state = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8FY87.useContext($734169eef5d6795a$export$148fd98d095596d4);
    let route = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $734169eef5d6795a$var$useIdImpl ? $734169eef5d6795a$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8FY87.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($734169eef5d6795a$var$getUniqueFetcherId());
    // Registration/cleanup
    $8FY87.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8FY87.useCallback((href, opts)=>{
        !routeId && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $734169eef5d6795a$export$47c85c6e3a081d3();
    let submit = $8FY87.useCallback((target, opts)=>{
        submitImpl(target, $734169eef5d6795a$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8FY87.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8FY87.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8FY87.createElement($734169eef5d6795a$export$a7fed597f4b8afd8, $734169eef5d6795a$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $e887188a2ce2efb5$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8FY87.useMemo(()=>$734169eef5d6795a$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $734169eef5d6795a$export$fa996778a3a31087() {
    let state = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $734169eef5d6795a$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $734169eef5d6795a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $734169eef5d6795a$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $734169eef5d6795a$var$useDataRouterState($734169eef5d6795a$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8FY87.useContext((0, $d5fb2d3e42b0c581$export$26749e8557646306));
    let location = (0, $d5fb2d3e42b0c581$export$45d76561a5302f2b)();
    let matches = (0, $d5fb2d3e42b0c581$export$2378eb7f5ff86053)();
    let navigation = (0, $d5fb2d3e42b0c581$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8FY87.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $734169eef5d6795a$var$usePageHide($8FY87.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $734169eef5d6795a$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($734169eef5d6795a$var$savedScrollPositions));
        } catch (error) {
            (0, $e887188a2ce2efb5$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $734169eef5d6795a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $734169eef5d6795a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($734169eef5d6795a$var$_extends({}, location, {
                    pathname: (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($734169eef5d6795a$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8FY87.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $734169eef5d6795a$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8FY87.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $734169eef5d6795a$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8FY87.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $734169eef5d6795a$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d5fb2d3e42b0c581$export$b273b3273281a049)(when);
    $8FY87.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8FY87.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $734169eef5d6795a$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8FY87.useContext($734169eef5d6795a$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $e887188a2ce2efb5$export$3e9cee6b33872309)(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $734169eef5d6795a$var$useDataRouterContext($734169eef5d6795a$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d5fb2d3e42b0c581$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $e887188a2ce2efb5$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $e887188a2ce2efb5$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $e887188a2ce2efb5$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");


var $f9aoP = parcelRequire("f9aoP");

var $6lYLL = parcelRequire("6lYLL");

var $4KKbJ = parcelRequire("4KKbJ");

var $jJtwY = parcelRequire("jJtwY");

var $cEIti = parcelRequire("cEIti");
var $0d18f4b3a1d9aea0$export$f36897288fd2d497;
(function(transitionStates) {
    transitionStates["preVisible"] = "page-transition-preVisible";
    transitionStates["visible"] = "page-transition-visible";
    transitionStates["postVisible"] = "page-transition-postVisible";
})($0d18f4b3a1d9aea0$export$f36897288fd2d497 || ($0d18f4b3a1d9aea0$export$f36897288fd2d497 = {}));
const $0d18f4b3a1d9aea0$export$b88b8034d859c8af = 1000;



var $aTKgi = parcelRequire("aTKgi");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $2e0203b9981da26a$export$353f5b6fc5456de1;
var $2e0203b9981da26a$export$17fa98cb055e8fa7;
var $2e0203b9981da26a$export$a5833c2b43ca4340;
var $2e0203b9981da26a$export$47511f9a6581d1d6;
var $2e0203b9981da26a$export$dd1c05b92185401c;
var $2e0203b9981da26a$export$8b28cf6cd00fe080;
var $2e0203b9981da26a$export$186c650311ff0789;
var $2e0203b9981da26a$export$6746fe0d9c9fab54;
var $2e0203b9981da26a$export$2bcf359f0c20e94f;
var $2e0203b9981da26a$export$2903d10d531d0ac0;
var $2e0203b9981da26a$export$745c6f71a1e0e6f7;
$2e0203b9981da26a$export$353f5b6fc5456de1 = `_1Yw81G_Button`;
$2e0203b9981da26a$export$17fa98cb055e8fa7 = `_1Yw81G_fontSizeH1`;
$2e0203b9981da26a$export$a5833c2b43ca4340 = `_1Yw81G_fontSizeH2`;
$2e0203b9981da26a$export$47511f9a6581d1d6 = `_1Yw81G_fontSizeH3`;
$2e0203b9981da26a$export$dd1c05b92185401c = `_1Yw81G_fontSizeH4`;
$2e0203b9981da26a$export$8b28cf6cd00fe080 = `_1Yw81G_fontSizeH5`;
$2e0203b9981da26a$export$186c650311ff0789 = `_1Yw81G_fontSizeH6`;
$2e0203b9981da26a$export$6746fe0d9c9fab54 = `_1Yw81G_fontSizeSmall`;
$2e0203b9981da26a$export$2bcf359f0c20e94f = `_1Yw81G_fontSizeTiny`;
$2e0203b9981da26a$export$2903d10d531d0ac0 = `_1Yw81G_fontSizep`;
$2e0203b9981da26a$export$745c6f71a1e0e6f7 = `_1Yw81G_secondary`;


function $99c71e3b0a0dc87b$export$2e2bcd8739ae039({ children: children, onClick: onClick, style: style, className: className, isSecondary: isSecondary, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(className, $2e0203b9981da26a$export$353f5b6fc5456de1, {
            [$2e0203b9981da26a$export$745c6f71a1e0e6f7]: isSecondary
        }),
        style: style,
        onClick: onClick,
        ...props,
        children: children
    });
}
function $99c71e3b0a0dc87b$export$29d11c0fe2fc51d8({ children: children, style: style, className: className, href: href, isSecondary: isSecondary, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $734169eef5d6795a$export$a6c7ac8248d6e38a), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(className, $2e0203b9981da26a$export$353f5b6fc5456de1, {
            [$2e0203b9981da26a$export$745c6f71a1e0e6f7]: isSecondary
        }),
        style: style,
        to: href,
        ...props,
        children: children
    });
}



var $2PPWI = parcelRequire("2PPWI");
var $26c631e59d69ac76$exports = {};

$parcel$export($26c631e59d69ac76$exports, "FactionPicker", function () { return $26c631e59d69ac76$export$a91b66465f43df99; }, function (v) { return $26c631e59d69ac76$export$a91b66465f43df99 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction", function () { return $26c631e59d69ac76$export$ac79a59df2833a40; }, function (v) { return $26c631e59d69ac76$export$ac79a59df2833a40 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__BackgroundContainer", function () { return $26c631e59d69ac76$export$3cf33c27d73c3bbc; }, function (v) { return $26c631e59d69ac76$export$3cf33c27d73c3bbc = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Border", function () { return $26c631e59d69ac76$export$da97f03000bb123f; }, function (v) { return $26c631e59d69ac76$export$da97f03000bb123f = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Button", function () { return $26c631e59d69ac76$export$4f5a5b7dfbf8564d; }, function (v) { return $26c631e59d69ac76$export$4f5a5b7dfbf8564d = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Button--selected", function () { return $26c631e59d69ac76$export$9f5564532def7cd4; }, function (v) { return $26c631e59d69ac76$export$9f5564532def7cd4 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__HighlightImage", function () { return $26c631e59d69ac76$export$5b6e9e886522f398; }, function (v) { return $26c631e59d69ac76$export$5b6e9e886522f398 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Image", function () { return $26c631e59d69ac76$export$50cf43a25317801e; }, function (v) { return $26c631e59d69ac76$export$50cf43a25317801e = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Subtitle", function () { return $26c631e59d69ac76$export$3a11177fc3010a17; }, function (v) { return $26c631e59d69ac76$export$3a11177fc3010a17 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Text", function () { return $26c631e59d69ac76$export$63ec812f7d2c0793; }, function (v) { return $26c631e59d69ac76$export$63ec812f7d2c0793 = v; });
$parcel$export($26c631e59d69ac76$exports, "FactionPickerFaction__Title", function () { return $26c631e59d69ac76$export$958b7e4b6a3d1c9; }, function (v) { return $26c631e59d69ac76$export$958b7e4b6a3d1c9 = v; });
$parcel$export($26c631e59d69ac76$exports, "fade-in", function () { return $26c631e59d69ac76$export$c95979b960f4acea; }, function (v) { return $26c631e59d69ac76$export$c95979b960f4acea = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH1", function () { return $26c631e59d69ac76$export$17fa98cb055e8fa7; }, function (v) { return $26c631e59d69ac76$export$17fa98cb055e8fa7 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH2", function () { return $26c631e59d69ac76$export$a5833c2b43ca4340; }, function (v) { return $26c631e59d69ac76$export$a5833c2b43ca4340 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH3", function () { return $26c631e59d69ac76$export$47511f9a6581d1d6; }, function (v) { return $26c631e59d69ac76$export$47511f9a6581d1d6 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH4", function () { return $26c631e59d69ac76$export$dd1c05b92185401c; }, function (v) { return $26c631e59d69ac76$export$dd1c05b92185401c = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH5", function () { return $26c631e59d69ac76$export$8b28cf6cd00fe080; }, function (v) { return $26c631e59d69ac76$export$8b28cf6cd00fe080 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeH6", function () { return $26c631e59d69ac76$export$186c650311ff0789; }, function (v) { return $26c631e59d69ac76$export$186c650311ff0789 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeSmall", function () { return $26c631e59d69ac76$export$6746fe0d9c9fab54; }, function (v) { return $26c631e59d69ac76$export$6746fe0d9c9fab54 = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizeTiny", function () { return $26c631e59d69ac76$export$2bcf359f0c20e94f; }, function (v) { return $26c631e59d69ac76$export$2bcf359f0c20e94f = v; });
$parcel$export($26c631e59d69ac76$exports, "fontSizep", function () { return $26c631e59d69ac76$export$2903d10d531d0ac0; }, function (v) { return $26c631e59d69ac76$export$2903d10d531d0ac0 = v; });
$parcel$export($26c631e59d69ac76$exports, "page-transition-postVisible", function () { return $26c631e59d69ac76$export$635eb3172be88cc1; }, function (v) { return $26c631e59d69ac76$export$635eb3172be88cc1 = v; });
$parcel$export($26c631e59d69ac76$exports, "page-transition-preVisible", function () { return $26c631e59d69ac76$export$d0da582c244d7927; }, function (v) { return $26c631e59d69ac76$export$d0da582c244d7927 = v; });
$parcel$export($26c631e59d69ac76$exports, "page-transition-visible", function () { return $26c631e59d69ac76$export$110dabf6daad8b9a; }, function (v) { return $26c631e59d69ac76$export$110dabf6daad8b9a = v; });
$parcel$export($26c631e59d69ac76$exports, "slide-in", function () { return $26c631e59d69ac76$export$1c220dee9e4dbe34; }, function (v) { return $26c631e59d69ac76$export$1c220dee9e4dbe34 = v; });
$parcel$export($26c631e59d69ac76$exports, "slide-out", function () { return $26c631e59d69ac76$export$ec7246eb5d3e2aa3; }, function (v) { return $26c631e59d69ac76$export$ec7246eb5d3e2aa3 = v; });
var $26c631e59d69ac76$export$a91b66465f43df99;
var $26c631e59d69ac76$export$ac79a59df2833a40;
var $26c631e59d69ac76$export$3cf33c27d73c3bbc;
var $26c631e59d69ac76$export$da97f03000bb123f;
var $26c631e59d69ac76$export$4f5a5b7dfbf8564d;
var $26c631e59d69ac76$export$9f5564532def7cd4;
var $26c631e59d69ac76$export$5b6e9e886522f398;
var $26c631e59d69ac76$export$50cf43a25317801e;
var $26c631e59d69ac76$export$3a11177fc3010a17;
var $26c631e59d69ac76$export$63ec812f7d2c0793;
var $26c631e59d69ac76$export$958b7e4b6a3d1c9;
var $26c631e59d69ac76$export$c95979b960f4acea;
var $26c631e59d69ac76$export$17fa98cb055e8fa7;
var $26c631e59d69ac76$export$a5833c2b43ca4340;
var $26c631e59d69ac76$export$47511f9a6581d1d6;
var $26c631e59d69ac76$export$dd1c05b92185401c;
var $26c631e59d69ac76$export$8b28cf6cd00fe080;
var $26c631e59d69ac76$export$186c650311ff0789;
var $26c631e59d69ac76$export$6746fe0d9c9fab54;
var $26c631e59d69ac76$export$2bcf359f0c20e94f;
var $26c631e59d69ac76$export$2903d10d531d0ac0;
var $26c631e59d69ac76$export$635eb3172be88cc1;
var $26c631e59d69ac76$export$d0da582c244d7927;
var $26c631e59d69ac76$export$110dabf6daad8b9a;
var $26c631e59d69ac76$export$1c220dee9e4dbe34;
var $26c631e59d69ac76$export$ec7246eb5d3e2aa3;
$26c631e59d69ac76$export$a91b66465f43df99 = `_2j5PMq_FactionPicker`;
$26c631e59d69ac76$export$ac79a59df2833a40 = `_2j5PMq_FactionPickerFaction`;
$26c631e59d69ac76$export$3cf33c27d73c3bbc = `_2j5PMq_FactionPickerFaction__BackgroundContainer`;
$26c631e59d69ac76$export$da97f03000bb123f = `_2j5PMq_FactionPickerFaction__Border`;
$26c631e59d69ac76$export$4f5a5b7dfbf8564d = `_2j5PMq_FactionPickerFaction__Button`;
$26c631e59d69ac76$export$9f5564532def7cd4 = `_2j5PMq_FactionPickerFaction__Button--selected`;
$26c631e59d69ac76$export$5b6e9e886522f398 = `_2j5PMq_FactionPickerFaction__HighlightImage`;
$26c631e59d69ac76$export$50cf43a25317801e = `_2j5PMq_FactionPickerFaction__Image`;
$26c631e59d69ac76$export$3a11177fc3010a17 = `_2j5PMq_FactionPickerFaction__Subtitle`;
$26c631e59d69ac76$export$63ec812f7d2c0793 = `_2j5PMq_FactionPickerFaction__Text`;
$26c631e59d69ac76$export$958b7e4b6a3d1c9 = `_2j5PMq_FactionPickerFaction__Title`;
$26c631e59d69ac76$export$c95979b960f4acea = `_2j5PMq_fade-in`;
$26c631e59d69ac76$export$c95979b960f4acea;
$26c631e59d69ac76$export$17fa98cb055e8fa7 = `_2j5PMq_fontSizeH1`;
$26c631e59d69ac76$export$a5833c2b43ca4340 = `_2j5PMq_fontSizeH2`;
$26c631e59d69ac76$export$47511f9a6581d1d6 = `_2j5PMq_fontSizeH3`;
$26c631e59d69ac76$export$dd1c05b92185401c = `_2j5PMq_fontSizeH4`;
$26c631e59d69ac76$export$8b28cf6cd00fe080 = `_2j5PMq_fontSizeH5`;
$26c631e59d69ac76$export$186c650311ff0789 = `_2j5PMq_fontSizeH6`;
$26c631e59d69ac76$export$6746fe0d9c9fab54 = `_2j5PMq_fontSizeSmall`;
$26c631e59d69ac76$export$2bcf359f0c20e94f = `_2j5PMq_fontSizeTiny`;
$26c631e59d69ac76$export$2903d10d531d0ac0 = `_2j5PMq_fontSizep`;
$26c631e59d69ac76$export$635eb3172be88cc1 = `_2j5PMq_page-transition-postVisible`;
$26c631e59d69ac76$export$d0da582c244d7927 = `_2j5PMq_page-transition-preVisible`;
$26c631e59d69ac76$export$110dabf6daad8b9a = `_2j5PMq_page-transition-visible`;
$26c631e59d69ac76$export$1c220dee9e4dbe34 = `_2j5PMq_slide-in`;
$26c631e59d69ac76$export$1c220dee9e4dbe34;
$26c631e59d69ac76$export$ec7246eb5d3e2aa3 = `_2j5PMq_slide-out`;
$26c631e59d69ac76$export$ec7246eb5d3e2aa3;



var $9s93Y = parcelRequire("9s93Y");

var $aTKgi = parcelRequire("aTKgi");

function $a38f43bfc35f98e6$export$2e2bcd8739ae039({ factions: factions, factionSubtitle: factionSubtitle, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, selectedFactionId: selectedFactionId, onFactionSelected: onFactionSelected, onFactionMouseEnter: onFactionMouseEnter, transitionState: transitionState = (0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible }) {
    const renderFactions = ()=>{
        if (factions && factions.length) return factions.map((faction)=>/*#__PURE__*/ (0, $2PPWI.jsx)($a38f43bfc35f98e6$var$FactionPickerFaction, {
                imagePath: (0, $aTKgi.pathToURL)(faction.imagePath),
                backgroundImagePath: backgroundImagePath,
                textBackgroundImagePath: textBackgroundImagePath,
                highlightImagePath: highlightImagePath,
                title: faction.name,
                subtitle: factionSubtitle,
                isSelected: faction.id === selectedFactionId,
                onSelected: ()=>onFactionSelected && onFactionSelected(faction.id),
                onMouseEnter: onFactionMouseEnter,
                transitionState: transitionState
            }, faction.id));
        else return "No factions available";
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $26c631e59d69ac76$exports.FactionPicker,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
            children: renderFactions()
        })
    });
}
function $a38f43bfc35f98e6$var$FactionPickerFaction({ imagePath: imagePath, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, title: title, subtitle: subtitle, isSelected: isSelected, onSelected: onSelected, onMouseEnter: onMouseEnter, transitionState: transitionState }) {
    const factionButtonClasses = (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
        [$26c631e59d69ac76$exports.FactionPickerFaction__Button]: true,
        [$26c631e59d69ac76$exports["FactionPickerFaction__Button--selected"]]: isSelected
    });
    const titleFontSize = title.length < 12 ? "15px" : "10px"; // TODO - Update when font changes and also find a better method
    const highlightImageStyle = highlightImagePath ? {
        backgroundImage: `url(${highlightImagePath})`
    } : {};
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($26c631e59d69ac76$exports.FactionPickerFaction, $26c631e59d69ac76$exports[transitionState]),
        onMouseEnter: onMouseEnter,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                className: factionButtonClasses,
                onClick: ()=>onSelected && onSelected(),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $26c631e59d69ac76$exports.FactionPickerFaction__BackgroundContainer,
                        style: {
                            backgroundImage: `url(${backgroundImagePath})`
                        }
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $26c631e59d69ac76$exports.FactionPickerFaction__Border
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        src: imagePath,
                        className: $26c631e59d69ac76$exports.FactionPickerFaction__Image,
                        alt: "faction logo"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $26c631e59d69ac76$exports.FactionPickerFaction__Text,
                        style: {
                            backgroundImage: `url(${textBackgroundImagePath})`
                        },
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: $26c631e59d69ac76$exports.FactionPickerFaction__Title,
                                style: {
                                    fontSize: titleFontSize
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: $26c631e59d69ac76$exports.FactionPickerFaction__Subtitle,
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $26c631e59d69ac76$exports.FactionPickerFaction__HighlightImage,
                style: highlightImageStyle
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");
var $9f20338705f60702$export$ee388a16b6680f12;
var $9f20338705f60702$export$ab2a351788ae0f99;
var $9f20338705f60702$export$17fa98cb055e8fa7;
var $9f20338705f60702$export$a5833c2b43ca4340;
var $9f20338705f60702$export$47511f9a6581d1d6;
var $9f20338705f60702$export$dd1c05b92185401c;
var $9f20338705f60702$export$8b28cf6cd00fe080;
var $9f20338705f60702$export$186c650311ff0789;
var $9f20338705f60702$export$6746fe0d9c9fab54;
var $9f20338705f60702$export$2bcf359f0c20e94f;
var $9f20338705f60702$export$2903d10d531d0ac0;
var $9f20338705f60702$export$e7f5b41f28d56e7;
$9f20338705f60702$export$ee388a16b6680f12 = `PpN9jq_AuthInput`;
$9f20338705f60702$export$ab2a351788ae0f99 = `PpN9jq_AuthInput--invalid`;
$9f20338705f60702$export$17fa98cb055e8fa7 = `PpN9jq_fontSizeH1`;
$9f20338705f60702$export$a5833c2b43ca4340 = `PpN9jq_fontSizeH2`;
$9f20338705f60702$export$47511f9a6581d1d6 = `PpN9jq_fontSizeH3`;
$9f20338705f60702$export$dd1c05b92185401c = `PpN9jq_fontSizeH4`;
$9f20338705f60702$export$8b28cf6cd00fe080 = `PpN9jq_fontSizeH5`;
$9f20338705f60702$export$186c650311ff0789 = `PpN9jq_fontSizeH6`;
$9f20338705f60702$export$6746fe0d9c9fab54 = `PpN9jq_fontSizeSmall`;
$9f20338705f60702$export$2bcf359f0c20e94f = `PpN9jq_fontSizeTiny`;
$9f20338705f60702$export$2903d10d531d0ac0 = `PpN9jq_fontSizep`;
$9f20338705f60702$export$e7f5b41f28d56e7 = `PpN9jq_invalid-input-shake`;
$9f20338705f60702$export$e7f5b41f28d56e7;



var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");
var $f7be25dd25d87e61$export$f5b8910cec6cf069;
var $f7be25dd25d87e61$export$17fa98cb055e8fa7;
var $f7be25dd25d87e61$export$a5833c2b43ca4340;
var $f7be25dd25d87e61$export$47511f9a6581d1d6;
var $f7be25dd25d87e61$export$dd1c05b92185401c;
var $f7be25dd25d87e61$export$8b28cf6cd00fe080;
var $f7be25dd25d87e61$export$186c650311ff0789;
var $f7be25dd25d87e61$export$6746fe0d9c9fab54;
var $f7be25dd25d87e61$export$2bcf359f0c20e94f;
var $f7be25dd25d87e61$export$2903d10d531d0ac0;
$f7be25dd25d87e61$export$f5b8910cec6cf069 = `MsuNTa_Input`;
$f7be25dd25d87e61$export$17fa98cb055e8fa7 = `MsuNTa_fontSizeH1`;
$f7be25dd25d87e61$export$a5833c2b43ca4340 = `MsuNTa_fontSizeH2`;
$f7be25dd25d87e61$export$47511f9a6581d1d6 = `MsuNTa_fontSizeH3`;
$f7be25dd25d87e61$export$dd1c05b92185401c = `MsuNTa_fontSizeH4`;
$f7be25dd25d87e61$export$8b28cf6cd00fe080 = `MsuNTa_fontSizeH5`;
$f7be25dd25d87e61$export$186c650311ff0789 = `MsuNTa_fontSizeH6`;
$f7be25dd25d87e61$export$6746fe0d9c9fab54 = `MsuNTa_fontSizeSmall`;
$f7be25dd25d87e61$export$2bcf359f0c20e94f = `MsuNTa_fontSizeTiny`;
$f7be25dd25d87e61$export$2903d10d531d0ac0 = `MsuNTa_fontSizep`;


function $d354a0cea93b322d$export$2e2bcd8739ae039({ value: value, onChange: onChange, placeholder: placeholder, style: style, onSubmit: onSubmit, className: className, type: type = "text", tabIndex: tabIndex, passedRef: passedRef, autoComplete: autoComplete, id: id, ...props }) {
    function handleKeyDown(e) {
        if (!props.disabled) {
            if (e.key === "Enter" && onSubmit) onSubmit(e);
        }
    }
    const classname = className ? $f7be25dd25d87e61$export$f5b8910cec6cf069 + " " + className : $f7be25dd25d87e61$export$f5b8910cec6cf069;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
        type: type,
        value: value,
        onChange: onChange,
        placeholder: placeholder,
        className: classname,
        style: style,
        onKeyDown: handleKeyDown,
        tabIndex: tabIndex,
        ref: passedRef,
        autoComplete: autoComplete,
        id: id,
        ...props
    });
}


function $c65fb67a785ba6a0$export$2e2bcd8739ae039({ isInvalid: isInvalid, errorAnimationDurationMs: errorAnimationDurationMs = 500, style: style, ...props }) {
    const authInputClasses = (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
        [$9f20338705f60702$export$ee388a16b6680f12]: true,
        [$9f20338705f60702$export$ab2a351788ae0f99]: isInvalid,
        [props.className]: true
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
        ...props,
        className: authInputClasses,
        style: {
            ...style,
            animationDuration: errorAnimationDurationMs + "ms"
        }
    });
}



var $8FY87 = parcelRequire("8FY87");
var $533c8fa7d52add0f$export$c9d39ca3bcd93abb;
var $533c8fa7d52add0f$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $533c8fa7d52add0f$export$c9d39ca3bcd93abb = Howler1;
    $533c8fa7d52add0f$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


class $2f5079fe16e91641$export$2e2bcd8739ae039 {
    constructor(files){
        this.files = {};
        this.tracks = {};
        this.trackLoadedStates = {};
        this.ambientTracks = {};
        // @ts-ignore
        window.audioController = this;
        this._loadFiles(files);
    }
    _loadFiles(files) {
        files.forEach((file)=>{
            this.files[file.id] = file;
            this.trackLoadedStates[file.id] = false;
            this.tracks[file.id] = new (0, $533c8fa7d52add0f$export$b791fe48eec8032a)({
                src: [
                    file.src
                ],
                loop: file.ambient,
                volume: file.volume || 1
            });
            this.tracks[file.id].on("load", ()=>{
                this.trackLoadedStates[file.id] = true;
            });
            this.tracks[file.id].on("loaderror", ()=>{
                console.error("error loading", file);
            });
        });
    }
    addTrack(file) {
        this._loadFiles([
            file
        ]);
    }
    hasTrack(trackId) {
        return !!this.ambientTracks[trackId];
    }
    /*
     * Play a track. If it's an ambient track, it will only play if it's not already playing.
     * If it's a non-ambient track, it will play multiple instances.
     */ play(trackId) {
        const file = this.files[trackId];
        const track = this.tracks[trackId];
        if (!track) // console.error('No track found for', trackId);
        return;
        if (file.ambient) {
            if (this.ambientTracks[trackId] === undefined) this.ambientTracks[trackId] = track.play();
            else if (!track.playing(this.ambientTracks[trackId])) track.play(this.ambientTracks[trackId]);
            return;
        }
        track.play();
    }
    stop(trackId) {
        const file = this.files[trackId];
        const track = this.tracks[trackId];
        if (!track) // console.error('No track found for', trackId);
        return;
        if (file.ambient) {
            if (this.ambientTracks[trackId] !== undefined) track.stop(this.ambientTracks[trackId]);
            return;
        }
        track.stop();
    }
    fadeIn(ambientTrackId, duration = 2000) {
        const file = this.files[ambientTrackId];
        const track = this.tracks[ambientTrackId];
        track.volume(0);
        if (!track.playing()) this.ambientTracks[ambientTrackId] = track.play();
        else track.seek(0);
        track.fade(0, file.volume || 1, duration);
    }
    fadeOut(ambientTrackId, duration = 2000) {
        const track = this.tracks[ambientTrackId];
        const volume = track.volume();
        track.fade(volume, 0, duration);
    }
    /*
     * Stop all ambient tracks and play only the specified track. Non-ambient tracks are not affected since they are usully short sfx and not looped.
     */ stopAll() {
        Object.keys(this.ambientTracks).forEach((ambientTrackId)=>{
            this.stop(ambientTrackId);
        });
    }
    /*
     * Stop all ambient tracks and play only the specified track.
     */ playOnly(trackId) {
        if (!Array.isArray(trackId)) trackId = [
            trackId
        ];
        Object.keys(this.ambientTracks).forEach((ambientTrackId)=>{
            if (!trackId.includes(ambientTrackId)) this.stop(ambientTrackId);
        });
        trackId.forEach((id)=>{
            this.play(id);
        });
    }
    mute(shouldMute) {
        (0, $533c8fa7d52add0f$export$c9d39ca3bcd93abb).mute(shouldMute);
    }
    toggleMute() {
        (0, $533c8fa7d52add0f$export$c9d39ca3bcd93abb).mute(// @ts-ignore
        !(0, $533c8fa7d52add0f$export$c9d39ca3bcd93abb)._muted);
        // @ts-ignore
        return (0, $533c8fa7d52add0f$export$c9d39ca3bcd93abb)._muted;
    }
}


let $091540b7cd96f6c1$var$mutedLSKey = "ARISE_SOUNDS_MUTED";
let $091540b7cd96f6c1$var$audioController = null;
let $091540b7cd96f6c1$var$emptyAudioController = new (0, $2f5079fe16e91641$export$2e2bcd8739ae039)([]);
function $091540b7cd96f6c1$export$91047320af7bf70b(tracks) {
    const [isMuted, setIsMuted] = (0, $8FY87.useState)(localStorage.getItem($091540b7cd96f6c1$var$mutedLSKey) === "1");
    if (!$091540b7cd96f6c1$var$audioController && tracks && tracks.length > 0) {
        $091540b7cd96f6c1$var$audioController = new (0, $2f5079fe16e91641$export$2e2bcd8739ae039)(tracks);
        $091540b7cd96f6c1$var$audioController.mute(isMuted);
    }
    const toggleMute = ()=>{
        const isHowlerMuted = $091540b7cd96f6c1$var$audioController.toggleMute();
        localStorage.setItem($091540b7cd96f6c1$var$mutedLSKey, isHowlerMuted ? "1" : "0");
        setIsMuted(isHowlerMuted);
    };
    return {
        isMuted: isMuted,
        toggleMute: toggleMute,
        audio: $091540b7cd96f6c1$var$audioController || $091540b7cd96f6c1$var$emptyAudioController
    };
}



var $i7H0N = parcelRequire("i7H0N");

var $1URoE = parcelRequire("1URoE");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");


var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");
var $bd9d8435fdde73b0$export$4cea6426d1265163;
var $bd9d8435fdde73b0$export$8ce1fd94bee2f412;
var $bd9d8435fdde73b0$export$c0306caf338ac095;
var $bd9d8435fdde73b0$export$2cef06c20297c17d;
var $bd9d8435fdde73b0$export$6811ecb90b1fb169;
var $bd9d8435fdde73b0$export$f34cc12b3c5f18d0;
$bd9d8435fdde73b0$export$4cea6426d1265163 = `oUJM5a_AvatarLayered`;
$bd9d8435fdde73b0$export$8ce1fd94bee2f412 = `oUJM5a_background`;
$bd9d8435fdde73b0$export$c0306caf338ac095 = `oUJM5a_character`;
$bd9d8435fdde73b0$export$2cef06c20297c17d = `oUJM5a_frame`;
$bd9d8435fdde73b0$export$6811ecb90b1fb169 = `oUJM5a_hasHover`;
$bd9d8435fdde73b0$export$f34cc12b3c5f18d0 = `oUJM5a_masked`;


function $202cb0ceec6045cf$export$2e2bcd8739ae039({ backgroundImagePath: backgroundImagePath, characterImagePath: characterImagePath, frameImagePath: frameImagePath, onClick: onClick, onMouseEnter: onMouseEnter, title: title, classname: classname, imageHeightDimension: imageHeightDimension = 120 }) {
    const theme = (0, $cEIti.useTheme)();
    const characterImageUrl = characterImagePath ? (0, $aTKgi.pathToURL)(characterImagePath) : null;
    const backgroundImageUrl = backgroundImagePath ? (0, $aTKgi.pathToURL)(backgroundImagePath) : null;
    const characterImage = characterImageUrl ?? theme.customJSON.fallbackCharacterImageUrl;
    const backgroundImage = backgroundImageUrl ?? theme.customJSON.fallbackBackgroundImageUrl;
    const props = {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($bd9d8435fdde73b0$export$4cea6426d1265163, classname, {
            [$bd9d8435fdde73b0$export$6811ecb90b1fb169]: onClick
        }),
        title: title
    };
    const size = `?h=${imageHeightDimension}`;
    const content = /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            frameImagePath && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $bd9d8435fdde73b0$export$2cef06c20297c17d,
                src: (0, $aTKgi.pathToURL)(frameImagePath) + size,
                alt: " ",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $bd9d8435fdde73b0$export$f34cc12b3c5f18d0,
                children: [
                    backgroundImage && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        className: $bd9d8435fdde73b0$export$8ce1fd94bee2f412,
                        src: backgroundImage + size,
                        alt: " ",
                        "aria-hidden": true
                    }),
                    characterImage && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        className: $bd9d8435fdde73b0$export$c0306caf338ac095,
                        src: characterImage + size,
                        alt: " ",
                        "aria-hidden": true
                    })
                ]
            })
        ]
    });
    if (onClick) return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        ...props,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        "aria-label": title ? title : "Avatar",
        children: content
    });
    else return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        ...props,
        "aria-label": title ? title : "Avatar",
        onMouseEnter: onMouseEnter,
        children: content
    });
}


var $1eccb258d07cfb31$exports = {};

$parcel$export($1eccb258d07cfb31$exports, "AvatarPicker", function () { return $1eccb258d07cfb31$export$6278dd89819af78; }, function (v) { return $1eccb258d07cfb31$export$6278dd89819af78 = v; });
$parcel$export($1eccb258d07cfb31$exports, "AvatarPickerAvatar", function () { return $1eccb258d07cfb31$export$6f8e3f8185b51c88; }, function (v) { return $1eccb258d07cfb31$export$6f8e3f8185b51c88 = v; });
$parcel$export($1eccb258d07cfb31$exports, "AvatarPickerAvatar--selected", function () { return $1eccb258d07cfb31$export$22ff2ab6c1ebf4b0; }, function (v) { return $1eccb258d07cfb31$export$22ff2ab6c1ebf4b0 = v; });
$parcel$export($1eccb258d07cfb31$exports, "AvatarPickerAvatar__Button", function () { return $1eccb258d07cfb31$export$4d15aea4ffa404a9; }, function (v) { return $1eccb258d07cfb31$export$4d15aea4ffa404a9 = v; });
$parcel$export($1eccb258d07cfb31$exports, "AvatarPickerAvatar__Image", function () { return $1eccb258d07cfb31$export$960c50e14a2ded22; }, function (v) { return $1eccb258d07cfb31$export$960c50e14a2ded22 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH1", function () { return $1eccb258d07cfb31$export$17fa98cb055e8fa7; }, function (v) { return $1eccb258d07cfb31$export$17fa98cb055e8fa7 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH2", function () { return $1eccb258d07cfb31$export$a5833c2b43ca4340; }, function (v) { return $1eccb258d07cfb31$export$a5833c2b43ca4340 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH3", function () { return $1eccb258d07cfb31$export$47511f9a6581d1d6; }, function (v) { return $1eccb258d07cfb31$export$47511f9a6581d1d6 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH4", function () { return $1eccb258d07cfb31$export$dd1c05b92185401c; }, function (v) { return $1eccb258d07cfb31$export$dd1c05b92185401c = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH5", function () { return $1eccb258d07cfb31$export$8b28cf6cd00fe080; }, function (v) { return $1eccb258d07cfb31$export$8b28cf6cd00fe080 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeH6", function () { return $1eccb258d07cfb31$export$186c650311ff0789; }, function (v) { return $1eccb258d07cfb31$export$186c650311ff0789 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeSmall", function () { return $1eccb258d07cfb31$export$6746fe0d9c9fab54; }, function (v) { return $1eccb258d07cfb31$export$6746fe0d9c9fab54 = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizeTiny", function () { return $1eccb258d07cfb31$export$2bcf359f0c20e94f; }, function (v) { return $1eccb258d07cfb31$export$2bcf359f0c20e94f = v; });
$parcel$export($1eccb258d07cfb31$exports, "fontSizep", function () { return $1eccb258d07cfb31$export$2903d10d531d0ac0; }, function (v) { return $1eccb258d07cfb31$export$2903d10d531d0ac0 = v; });
$parcel$export($1eccb258d07cfb31$exports, "page-transition-postVisible", function () { return $1eccb258d07cfb31$export$635eb3172be88cc1; }, function (v) { return $1eccb258d07cfb31$export$635eb3172be88cc1 = v; });
$parcel$export($1eccb258d07cfb31$exports, "page-transition-preVisible", function () { return $1eccb258d07cfb31$export$d0da582c244d7927; }, function (v) { return $1eccb258d07cfb31$export$d0da582c244d7927 = v; });
$parcel$export($1eccb258d07cfb31$exports, "page-transition-visible", function () { return $1eccb258d07cfb31$export$110dabf6daad8b9a; }, function (v) { return $1eccb258d07cfb31$export$110dabf6daad8b9a = v; });
$parcel$export($1eccb258d07cfb31$exports, "slide-in", function () { return $1eccb258d07cfb31$export$1c220dee9e4dbe34; }, function (v) { return $1eccb258d07cfb31$export$1c220dee9e4dbe34 = v; });
$parcel$export($1eccb258d07cfb31$exports, "slide-out", function () { return $1eccb258d07cfb31$export$ec7246eb5d3e2aa3; }, function (v) { return $1eccb258d07cfb31$export$ec7246eb5d3e2aa3 = v; });
var $1eccb258d07cfb31$export$6278dd89819af78;
var $1eccb258d07cfb31$export$6f8e3f8185b51c88;
var $1eccb258d07cfb31$export$22ff2ab6c1ebf4b0;
var $1eccb258d07cfb31$export$4d15aea4ffa404a9;
var $1eccb258d07cfb31$export$960c50e14a2ded22;
var $1eccb258d07cfb31$export$17fa98cb055e8fa7;
var $1eccb258d07cfb31$export$a5833c2b43ca4340;
var $1eccb258d07cfb31$export$47511f9a6581d1d6;
var $1eccb258d07cfb31$export$dd1c05b92185401c;
var $1eccb258d07cfb31$export$8b28cf6cd00fe080;
var $1eccb258d07cfb31$export$186c650311ff0789;
var $1eccb258d07cfb31$export$6746fe0d9c9fab54;
var $1eccb258d07cfb31$export$2bcf359f0c20e94f;
var $1eccb258d07cfb31$export$2903d10d531d0ac0;
var $1eccb258d07cfb31$export$635eb3172be88cc1;
var $1eccb258d07cfb31$export$d0da582c244d7927;
var $1eccb258d07cfb31$export$110dabf6daad8b9a;
var $1eccb258d07cfb31$export$1c220dee9e4dbe34;
var $1eccb258d07cfb31$export$ec7246eb5d3e2aa3;
$1eccb258d07cfb31$export$6278dd89819af78 = `v1I5QG_AvatarPicker`;
$1eccb258d07cfb31$export$6f8e3f8185b51c88 = `v1I5QG_AvatarPickerAvatar`;
$1eccb258d07cfb31$export$22ff2ab6c1ebf4b0 = `v1I5QG_AvatarPickerAvatar--selected`;
$1eccb258d07cfb31$export$4d15aea4ffa404a9 = `v1I5QG_AvatarPickerAvatar__Button`;
$1eccb258d07cfb31$export$960c50e14a2ded22 = `v1I5QG_AvatarPickerAvatar__Image`;
$1eccb258d07cfb31$export$17fa98cb055e8fa7 = `v1I5QG_fontSizeH1`;
$1eccb258d07cfb31$export$a5833c2b43ca4340 = `v1I5QG_fontSizeH2`;
$1eccb258d07cfb31$export$47511f9a6581d1d6 = `v1I5QG_fontSizeH3`;
$1eccb258d07cfb31$export$dd1c05b92185401c = `v1I5QG_fontSizeH4`;
$1eccb258d07cfb31$export$8b28cf6cd00fe080 = `v1I5QG_fontSizeH5`;
$1eccb258d07cfb31$export$186c650311ff0789 = `v1I5QG_fontSizeH6`;
$1eccb258d07cfb31$export$6746fe0d9c9fab54 = `v1I5QG_fontSizeSmall`;
$1eccb258d07cfb31$export$2bcf359f0c20e94f = `v1I5QG_fontSizeTiny`;
$1eccb258d07cfb31$export$2903d10d531d0ac0 = `v1I5QG_fontSizep`;
$1eccb258d07cfb31$export$635eb3172be88cc1 = `v1I5QG_page-transition-postVisible`;
$1eccb258d07cfb31$export$d0da582c244d7927 = `v1I5QG_page-transition-preVisible`;
$1eccb258d07cfb31$export$110dabf6daad8b9a = `v1I5QG_page-transition-visible`;
$1eccb258d07cfb31$export$1c220dee9e4dbe34 = `v1I5QG_slide-in`;
$1eccb258d07cfb31$export$1c220dee9e4dbe34;
$1eccb258d07cfb31$export$ec7246eb5d3e2aa3 = `v1I5QG_slide-out`;
$1eccb258d07cfb31$export$ec7246eb5d3e2aa3;


function $a7d73b98f3c41a4e$export$2e2bcd8739ae039({ backgrounds: backgrounds, characters: characters, selectedCharacterId: selectedCharacterId, selectedBackgroundId: selectedBackgroundId, onBackgroundSelected: onBackgroundSelected, onCharacterSelected: onCharacterSelected, onAvatarMouseEnter: onAvatarMouseEnter, transitionState: transitionState = (0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible }) {
    const renderAvatars = ()=>{
        if (!backgrounds?.length || !characters?.length) {
            console.warn("Not enough backgrounds or characters provided for onboarding");
            return "No avatars available";
        }
        const NUMBER_OF_CHARACTERS = 2;
        const NUMBER_OF_BACKGROUNDS = 4;
        return characters.slice(0, NUMBER_OF_CHARACTERS).flatMap((character)=>backgrounds.slice(0, NUMBER_OF_BACKGROUNDS).map((background)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1eccb258d07cfb31$exports.AvatarPickerAvatar, $1eccb258d07cfb31$exports[transitionState], {
                        [$1eccb258d07cfb31$exports["AvatarPickerAvatar--selected"]]: selectedCharacterId === character.id && selectedBackgroundId === background.id
                    }),
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                        classname: $1eccb258d07cfb31$exports.AvatarPickerAvatar__Button,
                        title: `Avatar with ${character.name} and ${background.name}`,
                        onClick: ()=>{
                            onBackgroundSelected && onBackgroundSelected(background.id);
                            onCharacterSelected && onCharacterSelected(character.id);
                        },
                        onMouseEnter: onAvatarMouseEnter && onAvatarMouseEnter,
                        characterImagePath: character.thumbnailPath,
                        backgroundImagePath: background.imagePath,
                        imageHeightDimension: 200
                    })
                }, `${character.id}-${background.id}`)));
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
        className: $1eccb258d07cfb31$exports.AvatarPicker,
        children: renderAvatars()
    });
}



var $6lYLL = parcelRequire("6lYLL");
function $bcb49290e039a826$export$c8308480b6dfe6db(userId) {
    const profile = (0, $6lYLL.useAppSelector)((state)=>state.profile.profileByUserId[userId]);
    return profile;
}
function $bcb49290e039a826$export$c3ab02d49994a165() {
    const role = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile?.role);
    return role === "guest";
}


// Each rule string should match each function, and the rule in the backend
const $5e60b378ec730cd4$export$aa8c7e6540925da0 = "Please enter a valid email address.";
function $5e60b378ec730cd4$export$371e338370561054(email) {
    return email && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
}
const $5e60b378ec730cd4$export$22f782bed1cafd3f = "Your password must be at least 8 characters long.";
function $5e60b378ec730cd4$export$1cf356d314abea16(password) {
    return password.length >= 8;
}
const $5e60b378ec730cd4$export$45024f2ca55f9de6 = "Your display name must be between 2 and 32 characters, start with a letter or number, and can only contain letters, numbers, underscores, and periods.";
function $5e60b378ec730cd4$export$13abd87bc9b14090(name) {
    const displayNameRegex = /^[a-zA-Z0-9][a-zA-Z0-9_.]{1,31}$/;
    return displayNameRegex.test(name);
}


var $ced5d801dca44162$exports = {};

$parcel$export($ced5d801dca44162$exports, "authNextStepButton", function () { return $ced5d801dca44162$export$a031258490b3ecf8; }, function (v) { return $ced5d801dca44162$export$a031258490b3ecf8 = v; });
$parcel$export($ced5d801dca44162$exports, "catastrophicError", function () { return $ced5d801dca44162$export$5e5c4219124c8653; }, function (v) { return $ced5d801dca44162$export$5e5c4219124c8653 = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage", function () { return $ced5d801dca44162$export$eef05664aefcecd; }, function (v) { return $ced5d801dca44162$export$eef05664aefcecd = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__bottom", function () { return $ced5d801dca44162$export$e023265c9eb0c587; }, function (v) { return $ced5d801dca44162$export$e023265c9eb0c587 = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__content", function () { return $ced5d801dca44162$export$ba8f9cc34e4a8b1d; }, function (v) { return $ced5d801dca44162$export$ba8f9cc34e4a8b1d = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__errorMessage", function () { return $ced5d801dca44162$export$6dfa81abbfc506c9; }, function (v) { return $ced5d801dca44162$export$6dfa81abbfc506c9 = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__formContent", function () { return $ced5d801dca44162$export$eb7a272dc28528b2; }, function (v) { return $ced5d801dca44162$export$eb7a272dc28528b2 = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__pickerContainer", function () { return $ced5d801dca44162$export$552081e1013dd9ae; }, function (v) { return $ced5d801dca44162$export$552081e1013dd9ae = v; });
$parcel$export($ced5d801dca44162$exports, "editProfilePage__pickerContainerTitle", function () { return $ced5d801dca44162$export$7cd1476e0c0afdaf; }, function (v) { return $ced5d801dca44162$export$7cd1476e0c0afdaf = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH1", function () { return $ced5d801dca44162$export$17fa98cb055e8fa7; }, function (v) { return $ced5d801dca44162$export$17fa98cb055e8fa7 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH2", function () { return $ced5d801dca44162$export$a5833c2b43ca4340; }, function (v) { return $ced5d801dca44162$export$a5833c2b43ca4340 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH3", function () { return $ced5d801dca44162$export$47511f9a6581d1d6; }, function (v) { return $ced5d801dca44162$export$47511f9a6581d1d6 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH4", function () { return $ced5d801dca44162$export$dd1c05b92185401c; }, function (v) { return $ced5d801dca44162$export$dd1c05b92185401c = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH5", function () { return $ced5d801dca44162$export$8b28cf6cd00fe080; }, function (v) { return $ced5d801dca44162$export$8b28cf6cd00fe080 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeH6", function () { return $ced5d801dca44162$export$186c650311ff0789; }, function (v) { return $ced5d801dca44162$export$186c650311ff0789 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeSmall", function () { return $ced5d801dca44162$export$6746fe0d9c9fab54; }, function (v) { return $ced5d801dca44162$export$6746fe0d9c9fab54 = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizeTiny", function () { return $ced5d801dca44162$export$2bcf359f0c20e94f; }, function (v) { return $ced5d801dca44162$export$2bcf359f0c20e94f = v; });
$parcel$export($ced5d801dca44162$exports, "fontSizep", function () { return $ced5d801dca44162$export$2903d10d531d0ac0; }, function (v) { return $ced5d801dca44162$export$2903d10d531d0ac0 = v; });
$parcel$export($ced5d801dca44162$exports, "loaded", function () { return $ced5d801dca44162$export$b40fc69c4a2927a1; }, function (v) { return $ced5d801dca44162$export$b40fc69c4a2927a1 = v; });
$parcel$export($ced5d801dca44162$exports, "page-transition-postVisible", function () { return $ced5d801dca44162$export$635eb3172be88cc1; }, function (v) { return $ced5d801dca44162$export$635eb3172be88cc1 = v; });
$parcel$export($ced5d801dca44162$exports, "page-transition-preVisible", function () { return $ced5d801dca44162$export$d0da582c244d7927; }, function (v) { return $ced5d801dca44162$export$d0da582c244d7927 = v; });
$parcel$export($ced5d801dca44162$exports, "page-transition-visible", function () { return $ced5d801dca44162$export$110dabf6daad8b9a; }, function (v) { return $ced5d801dca44162$export$110dabf6daad8b9a = v; });
$parcel$export($ced5d801dca44162$exports, "step1", function () { return $ced5d801dca44162$export$1788037590f456a4; }, function (v) { return $ced5d801dca44162$export$1788037590f456a4 = v; });
$parcel$export($ced5d801dca44162$exports, "step2", function () { return $ced5d801dca44162$export$30c608c84dc34af7; }, function (v) { return $ced5d801dca44162$export$30c608c84dc34af7 = v; });
var $ced5d801dca44162$export$a031258490b3ecf8;
var $ced5d801dca44162$export$5e5c4219124c8653;
var $ced5d801dca44162$export$eef05664aefcecd;
var $ced5d801dca44162$export$e023265c9eb0c587;
var $ced5d801dca44162$export$ba8f9cc34e4a8b1d;
var $ced5d801dca44162$export$6dfa81abbfc506c9;
var $ced5d801dca44162$export$eb7a272dc28528b2;
var $ced5d801dca44162$export$552081e1013dd9ae;
var $ced5d801dca44162$export$7cd1476e0c0afdaf;
var $ced5d801dca44162$export$17fa98cb055e8fa7;
var $ced5d801dca44162$export$a5833c2b43ca4340;
var $ced5d801dca44162$export$47511f9a6581d1d6;
var $ced5d801dca44162$export$dd1c05b92185401c;
var $ced5d801dca44162$export$8b28cf6cd00fe080;
var $ced5d801dca44162$export$186c650311ff0789;
var $ced5d801dca44162$export$6746fe0d9c9fab54;
var $ced5d801dca44162$export$2bcf359f0c20e94f;
var $ced5d801dca44162$export$2903d10d531d0ac0;
var $ced5d801dca44162$export$b40fc69c4a2927a1;
var $ced5d801dca44162$export$635eb3172be88cc1;
var $ced5d801dca44162$export$d0da582c244d7927;
var $ced5d801dca44162$export$110dabf6daad8b9a;
var $ced5d801dca44162$export$1788037590f456a4;
var $ced5d801dca44162$export$30c608c84dc34af7;
$ced5d801dca44162$export$a031258490b3ecf8 = `nhLJVW_authNextStepButton`;
$ced5d801dca44162$export$5e5c4219124c8653 = `nhLJVW_catastrophicError`;
$ced5d801dca44162$export$eef05664aefcecd = `nhLJVW_editProfilePage`;
$ced5d801dca44162$export$e023265c9eb0c587 = `nhLJVW_editProfilePage__bottom`;
$ced5d801dca44162$export$ba8f9cc34e4a8b1d = `nhLJVW_editProfilePage__content`;
$ced5d801dca44162$export$6dfa81abbfc506c9 = `nhLJVW_editProfilePage__errorMessage`;
$ced5d801dca44162$export$eb7a272dc28528b2 = `nhLJVW_editProfilePage__formContent`;
$ced5d801dca44162$export$552081e1013dd9ae = `nhLJVW_editProfilePage__pickerContainer`;
$ced5d801dca44162$export$7cd1476e0c0afdaf = `nhLJVW_editProfilePage__pickerContainerTitle`;
$ced5d801dca44162$export$17fa98cb055e8fa7 = `nhLJVW_fontSizeH1`;
$ced5d801dca44162$export$a5833c2b43ca4340 = `nhLJVW_fontSizeH2`;
$ced5d801dca44162$export$47511f9a6581d1d6 = `nhLJVW_fontSizeH3`;
$ced5d801dca44162$export$dd1c05b92185401c = `nhLJVW_fontSizeH4`;
$ced5d801dca44162$export$8b28cf6cd00fe080 = `nhLJVW_fontSizeH5`;
$ced5d801dca44162$export$186c650311ff0789 = `nhLJVW_fontSizeH6`;
$ced5d801dca44162$export$6746fe0d9c9fab54 = `nhLJVW_fontSizeSmall`;
$ced5d801dca44162$export$2bcf359f0c20e94f = `nhLJVW_fontSizeTiny`;
$ced5d801dca44162$export$2903d10d531d0ac0 = `nhLJVW_fontSizep`;
$ced5d801dca44162$export$b40fc69c4a2927a1 = `nhLJVW_loaded`;
$ced5d801dca44162$export$635eb3172be88cc1 = `nhLJVW_page-transition-postVisible`;
$ced5d801dca44162$export$d0da582c244d7927 = `nhLJVW_page-transition-preVisible`;
$ced5d801dca44162$export$110dabf6daad8b9a = `nhLJVW_page-transition-visible`;
$ced5d801dca44162$export$1788037590f456a4 = `nhLJVW_step1`;
$ced5d801dca44162$export$30c608c84dc34af7 = `nhLJVW_step2`;


function $1f7f5122cbc52b81$export$2e2bcd8739ae039() {
    const [selectedFactionId, setSelectedFactionId] = (0, $8FY87.useState)("");
    const [selectedBackgroundId, setSelectedBackgroundId] = (0, $8FY87.useState)("");
    const [selectedCharacterId, setSelectedCharacterId] = (0, $8FY87.useState)("");
    const [displayName, setDisplayName] = (0, $8FY87.useState)("");
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    const [currentStep, setCurrentStep] = (0, $8FY87.useState)(0);
    const [pageTransitionState, setPageTransitionState] = (0, $8FY87.useState)((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible);
    const [factionPickerTransitionState, setFactionPickerTransitionState] = (0, $8FY87.useState)((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible);
    const [avatarPickerTransitionState, setAvatarPickerTransitionState] = (0, $8FY87.useState)((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible);
    const [assetsAreLoaded, setAssetsAreLoaded] = (0, $8FY87.useState)(false);
    const [isSendingData, setIsSendingData] = (0, $8FY87.useState)(false);
    const [isProfileCreationComplete, setIsProfileCreationComplete] = (0, $8FY87.useState)(false);
    const [isLoaded, setIsLoaded] = (0, $8FY87.useState)(false);
    const [hasCatastrophicError, setHasCatastrophicError] = (0, $8FY87.useState)(false);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const theme = (0, $cEIti.useTheme)();
    const profile = (0, $6lYLL.useAppSelector)((state)=>state.profile);
    const { user: user, loggedIn: loggedIn } = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    const allowUserToSetDisplayName = !(0, $1URoE.isInsidersInstance);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    (0, $8FY87.useEffect)(()=>{
        if (isGuest) navigate((0, $1URoE.homePath));
    }, [
        isGuest
    ]);
    (0, $8FY87.useEffect)(()=>{
        audio.playOnly([
            "faction-selector-bg",
            "drone-bg"
        ]);
    }, []);
    const [factions, setFactions] = (0, $8FY87.useState)();
    const [factionSettings, setFactionSettings] = (0, $8FY87.useState)();
    const [characters, setCharacters] = (0, $8FY87.useState)([]);
    const [backgrounds, setBackgrounds] = (0, $8FY87.useState)();
    const loadElements = ()=>{
        const promises = [
            $f9aoP.getFactions(),
            $f9aoP.getFactionSettings(),
            $f9aoP.getBackgrounds(),
            $f9aoP.getCharacters()
        ];
        const assetIsDefault = (asset)=>asset.price === 0;
        Promise.all(promises).then(([factionsData, factionSettingsData, backgroundData, characterData])=>{
            const defaultBackgrounds = backgroundData.filter(assetIsDefault);
            const defaultCharacters = characterData.filter(assetIsDefault);
            if (!factionsData || !factionSettingsData) {
                setHasCatastrophicError(true);
                console.error("Onboarding - Factions data or factions settings not available");
            }
            if (!defaultBackgrounds?.length || !defaultCharacters?.length) {
                setHasCatastrophicError(true);
                console.error("Onboarding - Not enough default backgrounds or characters provided");
            }
            setFactions(factionsData);
            setFactionSettings(factionSettingsData);
            setBackgrounds(defaultBackgrounds);
            setCharacters(defaultCharacters);
            setAssetsAreLoaded(true);
        }).catch((error)=>{
            setAssetsAreLoaded(true);
            setHasCatastrophicError(true);
            console.error("Onboarding - Error loading onboarding data", error);
        });
    };
    function playRandomDrum() {
        const random = Math.random();
        if (random < 0.5) audio?.play("drum");
        else audio?.play("drum2");
    }
    function goToFactionPicker() {
        setCurrentStep(1);
        setTimeout(()=>{
            setFactionPickerTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible);
        }, 10);
    }
    function goToAvatarPicker() {
        setCurrentStep(2);
        setTimeout(()=>{
            setAvatarPickerTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible);
        }, 10);
    }
    function onContinue() {
        audio?.play("button-click");
        audio?.play("gust-open");
        setErrorCode(null);
        setFactionPickerTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible);
        setTimeout(goToAvatarPicker, 1200);
    }
    function onSubmit() {
        audio?.play("button-click");
        if (!user || !selectedBackgroundId || !selectedCharacterId || !selectedFactionId) return;
        if (allowUserToSetDisplayName && !displayName) return;
        audio?.play("slam");
        submitData();
    }
    (0, $8FY87.useEffect)(()=>{
        if (currentStep !== 2 || !allowUserToSetDisplayName) return;
        const DEBOUNCE_DELAY = 500;
        // Check display name validity locally once user stops typing for DEBOUNCE_DELAY
        const handler = setTimeout(()=>{
            if (!displayName || (0, $5e60b378ec730cd4$export$13abd87bc9b14090)(displayName)) {
                if (errorCode === "DISPLAYNAME_INVALID") setErrorCode(null);
            } else setErrorCode("DISPLAYNAME_INVALID");
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(handler);
    }, [
        displayName,
        currentStep
    ]);
    async function submitData() {
        setIsSendingData(true);
        setErrorCode(null);
        if (profile.currentUserProfile) {
            (0, $i7H0N.sendEvent)("profile_update", {
                faction: selectedFactionId
            });
            try {
                const body = {
                    factionID: selectedFactionId,
                    backgroundID: selectedBackgroundId,
                    characterID: selectedCharacterId,
                    ...allowUserToSetDisplayName && {
                        displayName: displayName
                    }
                };
                const updatedUser = await $f9aoP.editProfile(profile.currentUserProfile.id, body);
                dispatch((0, $jJtwY.updateUser)(updatedUser));
                navigateToHome();
            } catch (error) {
                setErrorCode(error?.message ?? "UNKNOWN_ERROR");
                setIsSendingData(false);
            }
        } else {
            (0, $i7H0N.sendEvent)("profile_create", {
                faction: selectedFactionId
            });
            try {
                const body = {
                    displayName: allowUserToSetDisplayName ? displayName : user.username,
                    factionID: selectedFactionId,
                    backgroundID: selectedBackgroundId,
                    characterID: selectedCharacterId
                };
                const updatedUser = await $f9aoP.createProfile(body);
                setIsProfileCreationComplete(true);
                dispatch((0, $jJtwY.updateUser)(updatedUser));
                dispatch((0, $4KKbJ.updateProfile)(updatedUser.profile));
            } catch (error) {
                setErrorCode(error?.message ?? "UNKNOWN_ERROR");
                setIsSendingData(false);
            }
        }
    }
    (0, $8FY87.useEffect)(()=>{
        if (isProfileCreationComplete && profile.currentUserProfile) navigateToHome();
    }, [
        isProfileCreationComplete,
        profile.currentUserProfile
    ]);
    function onHover() {
        audio?.play("hover");
    }
    function navigateToHome() {
        setAvatarPickerTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible);
        setPageTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible);
        setTimeout(()=>{
            navigate((0, $1URoE.homePath));
            audio.play("wipe-dark1");
        }, 1200);
    }
    (0, $8FY87.useEffect)(()=>{
        loadElements();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!isLoaded && loggedIn && user && assetsAreLoaded) {
            setIsLoaded(true);
            setTimeout(()=>{
                if (factions?.length === 1) {
                    // Only 1 faction to pick from, so skip this step
                    goToAvatarPicker();
                    setSelectedFactionId(factions[0].id);
                } else goToFactionPicker();
                setPageTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible);
            }, 100);
        }
    }, [
        loggedIn,
        user,
        profile,
        assetsAreLoaded
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (user && !profile.currentUserProfileCheckInProgress) dispatch((0, $4KKbJ.loadCurrentUserProfile)([
            user.id
        ]));
    }, [
        user
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (profile.currentUserProfile) {
            setSelectedFactionId(profile.currentUserProfile.factionID);
            setDisplayName(profile.currentUserProfile.displayName);
        }
    }, [
        profile.currentUserProfile
    ]);
    // TODO: loading
    if (!isLoaded) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {});
    function renderPicker() {
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a38f43bfc35f98e6$export$2e2bcd8739ae039), {
                    factions: factions,
                    factionSubtitle: factionSettings.factionCardSubtitle,
                    backgroundImagePath: (0, $aTKgi.pathToURL)(factionSettings.factionCardBackgroundImagePath),
                    textBackgroundImagePath: (0, $aTKgi.pathToURL)(factionSettings.factionCardTextBackgroundImagePath),
                    highlightImagePath: (0, $aTKgi.pathToURL)(factionSettings.factionCardHighlightImagePath),
                    selectedFactionId: selectedFactionId,
                    onFactionSelected: (factionId)=>{
                        playRandomDrum();
                        setSelectedFactionId(factionId);
                        setErrorCode(null);
                    },
                    onFactionMouseEnter: onHover,
                    transitionState: factionPickerTransitionState
                });
            case 2:
                return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        allowUserToSetDisplayName && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c65fb67a785ba6a0$export$2e2bcd8739ae039), {
                            value: displayName,
                            onChange: (e)=>setDisplayName(e.target.value),
                            placeholder: "Display Name",
                            type: "text",
                            id: "displayName",
                            name: "Display Name",
                            style: {
                                width: 350
                            }
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a7d73b98f3c41a4e$export$2e2bcd8739ae039), {
                                characters: characters,
                                backgrounds: backgrounds,
                                selectedCharacterId: selectedCharacterId,
                                selectedBackgroundId: selectedBackgroundId,
                                onBackgroundSelected: (id)=>{
                                    playRandomDrum();
                                    setSelectedBackgroundId(id);
                                },
                                onCharacterSelected: (id)=>{
                                    setSelectedCharacterId(id);
                                },
                                onAvatarMouseEnter: onHover,
                                transitionState: avatarPickerTransitionState
                            })
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
        }
    }
    function renderButton() {
        switch(currentStep){
            case 1:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                    className: $ced5d801dca44162$exports.authNextStepButton,
                    onClick: onContinue,
                    onSubmit: onContinue,
                    disabled: !selectedFactionId,
                    children: "Continue"
                });
            case 2:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                    className: $ced5d801dca44162$exports.authNextStepButton,
                    onClick: onSubmit,
                    onSubmit: onSubmit,
                    disabled: !selectedCharacterId || !selectedBackgroundId || allowUserToSetDisplayName && (!displayName || !(0, $5e60b378ec730cd4$export$13abd87bc9b14090)(displayName)) || isSendingData,
                    children: "Continue"
                });
            default:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
        }
    }
    const step2Title = allowUserToSetDisplayName ? "Choose your avatar and display name" : "Choose your avatar";
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ced5d801dca44162$exports.editProfilePage, $ced5d801dca44162$exports["step" + currentStep], $ced5d801dca44162$exports[pageTransitionState], {
            [$ced5d801dca44162$exports.loaded]: isLoaded
        }),
        style: {
            backgroundImage: `url(${theme.customJSON.editProfileBackgroundImage})`
        },
        children: [
            hasCatastrophicError && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $ced5d801dca44162$exports.catastrophicError,
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                    children: [
                        "Something has gone wrong. ",
                        /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                        "Please try again later."
                    ]
                })
            }),
            !hasCatastrophicError && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $ced5d801dca44162$exports.editProfilePage__pickerContainer,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        className: $ced5d801dca44162$exports.editProfilePage__pickerContainerTitle,
                        children: currentStep === 1 ? factionSettings.factionPickerTitle : step2Title
                    }),
                    renderPicker(),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $ced5d801dca44162$exports.editProfilePage__bottom,
                        children: [
                            renderButton(),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: $ced5d801dca44162$exports.editProfilePage__errorMessage,
                                children: $1f7f5122cbc52b81$var$getEditProfileErrorMessage(errorCode)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $1f7f5122cbc52b81$var$getEditProfileErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "DISPLAYNAME_INVALID":
            return 0, $5e60b378ec730cd4$export$45024f2ca55f9de6;
        case "DISPLAYNAME_VIOLATES_POLICY":
            return "Your display name contains inappropriate content.";
        default:
            return `Could not edit your profile, please try again or contact ${0, $1URoE.SUPPORT_EMAIL}`;
    }
}



var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");
function $2e3540a01ec72769$export$2e2bcd8739ae039({ children: children }) {
    const theme = (0, $cEIti.useTheme)();
    if (!theme.loaded) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: "absolute top-0 left-0 w-full h-full overflow-hidden",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: children
            })
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $f9aoP = parcelRequire("f9aoP");


var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $4MZsN = parcelRequire("4MZsN");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $f036a31d3f29ec78$export$28c660c63b792dea;
var $f036a31d3f29ec78$export$a499844466ba329d;
var $f036a31d3f29ec78$export$17fa98cb055e8fa7;
var $f036a31d3f29ec78$export$a5833c2b43ca4340;
var $f036a31d3f29ec78$export$47511f9a6581d1d6;
var $f036a31d3f29ec78$export$dd1c05b92185401c;
var $f036a31d3f29ec78$export$8b28cf6cd00fe080;
var $f036a31d3f29ec78$export$186c650311ff0789;
var $f036a31d3f29ec78$export$6746fe0d9c9fab54;
var $f036a31d3f29ec78$export$2bcf359f0c20e94f;
var $f036a31d3f29ec78$export$2903d10d531d0ac0;
var $f036a31d3f29ec78$export$795910f5f15a9633;
$f036a31d3f29ec78$export$28c660c63b792dea = `PrFOVW_Tooltip`;
$f036a31d3f29ec78$export$a499844466ba329d = `PrFOVW_autoPosition`;
$f036a31d3f29ec78$export$17fa98cb055e8fa7 = `PrFOVW_fontSizeH1`;
$f036a31d3f29ec78$export$a5833c2b43ca4340 = `PrFOVW_fontSizeH2`;
$f036a31d3f29ec78$export$47511f9a6581d1d6 = `PrFOVW_fontSizeH3`;
$f036a31d3f29ec78$export$dd1c05b92185401c = `PrFOVW_fontSizeH4`;
$f036a31d3f29ec78$export$8b28cf6cd00fe080 = `PrFOVW_fontSizeH5`;
$f036a31d3f29ec78$export$186c650311ff0789 = `PrFOVW_fontSizeH6`;
$f036a31d3f29ec78$export$6746fe0d9c9fab54 = `PrFOVW_fontSizeSmall`;
$f036a31d3f29ec78$export$2bcf359f0c20e94f = `PrFOVW_fontSizeTiny`;
$f036a31d3f29ec78$export$2903d10d531d0ac0 = `PrFOVW_fontSizep`;
$f036a31d3f29ec78$export$795910f5f15a9633 = `PrFOVW_isVisible`;


function $b81d3c408fcda381$export$2e2bcd8739ae039({ children: children, isVisible: isVisible, classname: classname, autoPosition: autoPosition = true }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($f036a31d3f29ec78$export$28c660c63b792dea, classname, {
            [$f036a31d3f29ec78$export$795910f5f15a9633]: isVisible,
            [$f036a31d3f29ec78$export$a499844466ba329d]: autoPosition
        }),
        children: children
    });
}


var $ffc0b8f2523eb0fb$export$c25acd513dcc8062;
var $ffc0b8f2523eb0fb$export$17fa98cb055e8fa7;
var $ffc0b8f2523eb0fb$export$a5833c2b43ca4340;
var $ffc0b8f2523eb0fb$export$47511f9a6581d1d6;
var $ffc0b8f2523eb0fb$export$dd1c05b92185401c;
var $ffc0b8f2523eb0fb$export$8b28cf6cd00fe080;
var $ffc0b8f2523eb0fb$export$186c650311ff0789;
var $ffc0b8f2523eb0fb$export$6746fe0d9c9fab54;
var $ffc0b8f2523eb0fb$export$2bcf359f0c20e94f;
var $ffc0b8f2523eb0fb$export$2903d10d531d0ac0;
var $ffc0b8f2523eb0fb$export$2a2d9e1569525b99;
var $ffc0b8f2523eb0fb$export$f62cea146a68a217;
var $ffc0b8f2523eb0fb$export$a9b0f2aa57c57690;
var $ffc0b8f2523eb0fb$export$e6515df4abc5dad;
$ffc0b8f2523eb0fb$export$c25acd513dcc8062 = `sBhBqW_IconButton`;
$ffc0b8f2523eb0fb$export$17fa98cb055e8fa7 = `sBhBqW_fontSizeH1`;
$ffc0b8f2523eb0fb$export$a5833c2b43ca4340 = `sBhBqW_fontSizeH2`;
$ffc0b8f2523eb0fb$export$47511f9a6581d1d6 = `sBhBqW_fontSizeH3`;
$ffc0b8f2523eb0fb$export$dd1c05b92185401c = `sBhBqW_fontSizeH4`;
$ffc0b8f2523eb0fb$export$8b28cf6cd00fe080 = `sBhBqW_fontSizeH5`;
$ffc0b8f2523eb0fb$export$186c650311ff0789 = `sBhBqW_fontSizeH6`;
$ffc0b8f2523eb0fb$export$6746fe0d9c9fab54 = `sBhBqW_fontSizeSmall`;
$ffc0b8f2523eb0fb$export$2bcf359f0c20e94f = `sBhBqW_fontSizeTiny`;
$ffc0b8f2523eb0fb$export$2903d10d531d0ac0 = `sBhBqW_fontSizep`;
$ffc0b8f2523eb0fb$export$2a2d9e1569525b99 = `sBhBqW_hasDot`;
$ffc0b8f2523eb0fb$export$f62cea146a68a217 = `sBhBqW_isDiamondStyle`;
$ffc0b8f2523eb0fb$export$a9b0f2aa57c57690 = `sBhBqW_isIconStyle`;
$ffc0b8f2523eb0fb$export$e6515df4abc5dad = `sBhBqW_isRoundStyle`;


function $27b023d5f3a79a4c$export$2e2bcd8739ae039({ iconType: iconType, ariaLabel: ariaLabel, buttonStyle: buttonStyle = "round", className: className, buttonRef: buttonRef, tooltipContent: tooltipContent, tooltipIsVisible: tooltipIsVisible, hasDot: hasDot, ...props }) {
    const theme = (0, $cEIti.useTheme)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ffc0b8f2523eb0fb$export$c25acd513dcc8062, className, {
            [$ffc0b8f2523eb0fb$export$e6515df4abc5dad]: buttonStyle === "round",
            [$ffc0b8f2523eb0fb$export$a9b0f2aa57c57690]: buttonStyle === "icon",
            [$ffc0b8f2523eb0fb$export$f62cea146a68a217]: buttonStyle === "diamond",
            [$ffc0b8f2523eb0fb$export$2a2d9e1569525b99]: hasDot
        }),
        "aria-label": ariaLabel,
        ref: buttonRef,
        ...props,
        style: buttonStyle === "diamond" && theme.customJSON.diamondButtonMask ? {
            maskImage: `url("${theme.customJSON.diamondButtonMask}")`
        } : {},
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                type: iconType,
                size: 24
            }),
            tooltipContent && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b81d3c408fcda381$export$2e2bcd8739ae039), {
                isVisible: tooltipIsVisible,
                children: tooltipContent
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");
var $1e9eaa8a76979fdc$export$586b24dc092f3131;
var $1e9eaa8a76979fdc$export$c95979b960f4acea;
var $1e9eaa8a76979fdc$export$e239d3a0f2b98af4;
var $1e9eaa8a76979fdc$export$17fa98cb055e8fa7;
var $1e9eaa8a76979fdc$export$a5833c2b43ca4340;
var $1e9eaa8a76979fdc$export$47511f9a6581d1d6;
var $1e9eaa8a76979fdc$export$dd1c05b92185401c;
var $1e9eaa8a76979fdc$export$8b28cf6cd00fe080;
var $1e9eaa8a76979fdc$export$186c650311ff0789;
var $1e9eaa8a76979fdc$export$6746fe0d9c9fab54;
var $1e9eaa8a76979fdc$export$2bcf359f0c20e94f;
var $1e9eaa8a76979fdc$export$2903d10d531d0ac0;
var $1e9eaa8a76979fdc$export$73920f18ca706874;
var $1e9eaa8a76979fdc$export$337c2b438c93a763;
var $1e9eaa8a76979fdc$export$deaa9e6d912ce6c6;
var $1e9eaa8a76979fdc$export$5f3730550ffb2e4;
var $1e9eaa8a76979fdc$export$c96745152eb2740f;
var $1e9eaa8a76979fdc$export$6f093cfa640b7166;
var $1e9eaa8a76979fdc$export$a3457c10a8789d73;
var $1e9eaa8a76979fdc$export$fb184b623420d9be;
$1e9eaa8a76979fdc$export$586b24dc092f3131 = `eE_5DW_backgroundImage`;
$1e9eaa8a76979fdc$export$c95979b960f4acea = `eE_5DW_fade-in`;
$1e9eaa8a76979fdc$export$e239d3a0f2b98af4 = `eE_5DW_fade-in-out`;
$1e9eaa8a76979fdc$export$e239d3a0f2b98af4;
$1e9eaa8a76979fdc$export$17fa98cb055e8fa7 = `eE_5DW_fontSizeH1`;
$1e9eaa8a76979fdc$export$a5833c2b43ca4340 = `eE_5DW_fontSizeH2`;
$1e9eaa8a76979fdc$export$47511f9a6581d1d6 = `eE_5DW_fontSizeH3`;
$1e9eaa8a76979fdc$export$dd1c05b92185401c = `eE_5DW_fontSizeH4`;
$1e9eaa8a76979fdc$export$8b28cf6cd00fe080 = `eE_5DW_fontSizeH5`;
$1e9eaa8a76979fdc$export$186c650311ff0789 = `eE_5DW_fontSizeH6`;
$1e9eaa8a76979fdc$export$6746fe0d9c9fab54 = `eE_5DW_fontSizeSmall`;
$1e9eaa8a76979fdc$export$2bcf359f0c20e94f = `eE_5DW_fontSizeTiny`;
$1e9eaa8a76979fdc$export$2903d10d531d0ac0 = `eE_5DW_fontSizep`;
$1e9eaa8a76979fdc$export$73920f18ca706874 = `eE_5DW_hidden`;
$1e9eaa8a76979fdc$export$337c2b438c93a763 = `eE_5DW_loadingScreen`;
$1e9eaa8a76979fdc$export$deaa9e6d912ce6c6 = `eE_5DW_loadingSpinner`;
$1e9eaa8a76979fdc$export$5f3730550ffb2e4 = `eE_5DW_rotate-and-back`;
$1e9eaa8a76979fdc$export$5f3730550ffb2e4;
$1e9eaa8a76979fdc$export$c96745152eb2740f = `eE_5DW_subtitle`;
$1e9eaa8a76979fdc$export$6f093cfa640b7166 = `eE_5DW_text`;
$1e9eaa8a76979fdc$export$a3457c10a8789d73 = `eE_5DW_textItem`;
$1e9eaa8a76979fdc$export$fb184b623420d9be = `eE_5DW_title`;


function $e3c473a9e2ed9ab7$export$2e2bcd8739ae039({ show: show, classname: classname = "", hasBackground: hasBackground = true, backgroundImage: backgroundImage, loadingText: loadingText, style: style }) {
    const theme = (0, $cEIti.useTheme)();
    const backgroundImageStyle = backgroundImage ? {
        backgroundImage: `url("${backgroundImage}")`
    } : {};
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        "aria-label": "Loading",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))("absolute left-0 w-full h-full", $1e9eaa8a76979fdc$export$337c2b438c93a763, classname, {
            [$1e9eaa8a76979fdc$export$73920f18ca706874]: !show
        }),
        style: style,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))("absolute top-0 left-0 w-full h-full", $1e9eaa8a76979fdc$export$586b24dc092f3131, {
                    "bg-black bg-opacity-50 backdrop-blur-md": hasBackground
                }),
                style: backgroundImageStyle
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full flex items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "relative w-[150px] h-[150px]",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUyIiBoZWlnaHQ9IjE1MiIgdmlld0JveD0iMCAwIDE1MiAxNTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBpZD0iTG9hZGVyQW5pbWF0aW9uIj4KICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlIDMiIGN4PSI3NiIgY3k9Ijc2IiByPSI3NSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfNDE5XzEzNTIpIiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQxOV8xMzUyIiB4MT0iNzYiIHkxPSIxIiB4Mj0iNzYiIHkyPSI3NiIKICAgICAgICAgICAgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSJ3aGl0ZSIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwIiAvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPg==",
                                alt: " ",
                                className: "absolute top-0 left-0 w-full h-full " + $1e9eaa8a76979fdc$export$deaa9e6d912ce6c6
                            }),
                            theme.metadata?.loadingLogoImagePath && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                src: (0, $aTKgi.pathToURL)(theme.metadata?.loadingLogoImagePath),
                                alt: " ",
                                className: "absolute top-0 left-0 w-full h-full scale-[.6]"
                            })
                        ]
                    }),
                    loadingText && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $1e9eaa8a76979fdc$export$6f093cfa640b7166,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $1e9eaa8a76979fdc$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$fb184b623420d9be,
                                        children: loadingText[0]?.title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$c96745152eb2740f,
                                        children: loadingText[0]?.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $1e9eaa8a76979fdc$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$fb184b623420d9be,
                                        children: loadingText[1]?.title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$c96745152eb2740f,
                                        children: loadingText[1]?.subtitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $1e9eaa8a76979fdc$export$a3457c10a8789d73,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$fb184b623420d9be,
                                        children: loadingText[2]?.title
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $1e9eaa8a76979fdc$export$c96745152eb2740f,
                                        children: loadingText[2]?.subtitle
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $b83b84096b4f5112$export$2b77a92f1a5ad772;
var $b83b84096b4f5112$export$2cc7ff91bcacba5e;
var $b83b84096b4f5112$export$49f2cecc68ed63a1;
var $b83b84096b4f5112$export$efe229eab43a9869;
var $b83b84096b4f5112$export$8f981dffec84ba52;
var $b83b84096b4f5112$export$17fa98cb055e8fa7;
var $b83b84096b4f5112$export$a5833c2b43ca4340;
var $b83b84096b4f5112$export$47511f9a6581d1d6;
var $b83b84096b4f5112$export$dd1c05b92185401c;
var $b83b84096b4f5112$export$8b28cf6cd00fe080;
var $b83b84096b4f5112$export$186c650311ff0789;
var $b83b84096b4f5112$export$6746fe0d9c9fab54;
var $b83b84096b4f5112$export$2bcf359f0c20e94f;
var $b83b84096b4f5112$export$2903d10d531d0ac0;
var $b83b84096b4f5112$export$1ca1ec8b29a4ce27;
var $b83b84096b4f5112$export$e5e9dfb795e86842;
var $b83b84096b4f5112$export$48c6aa3abf943eb9;
var $b83b84096b4f5112$export$4f081f07c0fd24b0;
var $b83b84096b4f5112$export$c80d57c51a11eb0a;
var $b83b84096b4f5112$export$2077e0241d6afd3c;
var $b83b84096b4f5112$export$664c6d24e3175067;
$b83b84096b4f5112$export$2b77a92f1a5ad772 = `kdx_FG_Modal`;
$b83b84096b4f5112$export$2cc7ff91bcacba5e = `kdx_FG_blur`;
$b83b84096b4f5112$export$49f2cecc68ed63a1 = `kdx_FG_canScroll`;
$b83b84096b4f5112$export$efe229eab43a9869 = `kdx_FG_closeButton`;
$b83b84096b4f5112$export$8f981dffec84ba52 = `kdx_FG_contentContainer`;
$b83b84096b4f5112$export$17fa98cb055e8fa7 = `kdx_FG_fontSizeH1`;
$b83b84096b4f5112$export$a5833c2b43ca4340 = `kdx_FG_fontSizeH2`;
$b83b84096b4f5112$export$47511f9a6581d1d6 = `kdx_FG_fontSizeH3`;
$b83b84096b4f5112$export$dd1c05b92185401c = `kdx_FG_fontSizeH4`;
$b83b84096b4f5112$export$8b28cf6cd00fe080 = `kdx_FG_fontSizeH5`;
$b83b84096b4f5112$export$186c650311ff0789 = `kdx_FG_fontSizeH6`;
$b83b84096b4f5112$export$6746fe0d9c9fab54 = `kdx_FG_fontSizeSmall`;
$b83b84096b4f5112$export$2bcf359f0c20e94f = `kdx_FG_fontSizeTiny`;
$b83b84096b4f5112$export$2903d10d531d0ac0 = `kdx_FG_fontSizep`;
$b83b84096b4f5112$export$1ca1ec8b29a4ce27 = `kdx_FG_icon`;
$b83b84096b4f5112$export$e5e9dfb795e86842 = `kdx_FG_leaveSpaceAboveAndBelow`;
$b83b84096b4f5112$export$48c6aa3abf943eb9 = `kdx_FG_modalDrawer`;
$b83b84096b4f5112$export$4f081f07c0fd24b0 = `kdx_FG_modalTitle`;
$b83b84096b4f5112$export$c80d57c51a11eb0a = `kdx_FG_noBackgroundImage`;
$b83b84096b4f5112$export$2077e0241d6afd3c = `kdx_FG_round`;
$b83b84096b4f5112$export$664c6d24e3175067 = `kdx_FG_visible`;


function $c025c3ad15b82d88$export$2e2bcd8739ae039({ title: title, onClose: onClose, isVisible: isVisible, modalClassname: modalClassname, contentClassname: contentClassname, closeButtonClassname: closeButtonClassname, classname: classname, canScroll: canScroll, isLoading: isLoading, children: children, zIndex: zIndex = "auto", leaveSpaceAboveAndBelow: leaveSpaceAboveAndBelow = true, backgroundImageOverride: backgroundImageOverride, closeButtonStyle: closeButtonStyle = "round", shouldCloseOnExternalClick: shouldCloseOnExternalClick = true, hasCloseButton: hasCloseButton = true }) {
    const theme = (0, $cEIti.useTheme)();
    const backgroundImage = backgroundImageOverride ?? theme.customJSON.modalBackgroundImage;
    const containerRef = (0, $8FY87.useRef)(null);
    const modalContentRef = (0, $8FY87.useRef)(null);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    function close() {
        if (onClose) onClose();
    }
    // Close modal when user presses escape
    function onKeyUp(e) {
        if (e.key === "Escape") close();
    }
    // Hide modal when the user clicks outside of it
    function clickHandler(e) {
        if (shouldCloseOnExternalClick && modalContentRef.current && !modalContentRef.current.contains(e.target)) close();
    }
    // Move focus to modal when opened
    function onTransitionEnd(e) {
        if (isVisible && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        onClick: clickHandler,
        onKeyUp: onKeyUp,
        inert: isVisible ? undefined : "",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(classname, "overflow-hidden"),
        ref: containerRef,
        onScroll: ()=>{
            // Stop scroll jumping to items which become focussed off screen
            containerRef.current?.scrollTo(0, 0);
        },
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))("absolute top-0 left-0 w-full h-full", $b83b84096b4f5112$export$2cc7ff91bcacba5e, {
                    [$b83b84096b4f5112$export$664c6d24e3175067]: isVisible
                }),
                style: {
                    transition: "backdrop-filter 300ms, visibility 300ms",
                    visibility: isVisible ? "visible" : "hidden",
                    backdropFilter: isVisible ? "blur(10px)" : "blur(0px)",
                    zIndex: zIndex
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                onTransitionEnd: onTransitionEnd,
                "aria-modal": isVisible,
                "aria-hidden": !isVisible,
                ...title && {
                    "aria-labelledby": "modalTitle"
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($b83b84096b4f5112$export$48c6aa3abf943eb9, {
                    [$b83b84096b4f5112$export$664c6d24e3175067]: isVisible
                }),
                style: {
                    zIndex: zIndex
                },
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        onClick: clickHandler,
                        ref: modalContentRef,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($b83b84096b4f5112$export$2b77a92f1a5ad772, modalClassname, {
                            [$b83b84096b4f5112$export$c80d57c51a11eb0a]: !backgroundImage,
                            [$b83b84096b4f5112$export$49f2cecc68ed63a1]: canScroll,
                            [$b83b84096b4f5112$export$e5e9dfb795e86842]: leaveSpaceAboveAndBelow
                        }),
                        style: backgroundImage ? {
                            backgroundImage: `url("${backgroundImage}")`
                        } : {},
                        children: [
                            hasCloseButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                iconType: "close",
                                buttonStyle: closeButtonStyle,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($b83b84096b4f5112$export$efe229eab43a9869, closeButtonClassname, {
                                    [$b83b84096b4f5112$export$2077e0241d6afd3c]: closeButtonStyle === "round",
                                    [$b83b84096b4f5112$export$1ca1ec8b29a4ce27]: closeButtonStyle === "icon"
                                }),
                                ariaLabel: "Close modal",
                                onClick: close,
                                disabled: !isVisible,
                                buttonRef: closeButtonRef
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($b83b84096b4f5112$export$8f981dffec84ba52, contentClassname),
                                children: [
                                    title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                        id: "modalTitle",
                                        className: $b83b84096b4f5112$export$4f081f07c0fd24b0,
                                        children: title
                                    }),
                                    children
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                        show: isLoading,
                        hasBackground: false
                    })
                ]
            })
        ]
    });
}



var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");

var $1URoE = parcelRequire("1URoE");

var $jJtwY = parcelRequire("jJtwY");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $67e0116949357e94$export$c43bfb5198aa7b21;
var $67e0116949357e94$export$cb4d80803776d6ac;
var $67e0116949357e94$export$17fa98cb055e8fa7;
var $67e0116949357e94$export$a5833c2b43ca4340;
var $67e0116949357e94$export$47511f9a6581d1d6;
var $67e0116949357e94$export$dd1c05b92185401c;
var $67e0116949357e94$export$8b28cf6cd00fe080;
var $67e0116949357e94$export$186c650311ff0789;
var $67e0116949357e94$export$6746fe0d9c9fab54;
var $67e0116949357e94$export$2bcf359f0c20e94f;
var $67e0116949357e94$export$2903d10d531d0ac0;
var $67e0116949357e94$export$972cea82bfe1355a;
var $67e0116949357e94$export$879158938acd5cc;
var $67e0116949357e94$export$ec85da0fcf356258;
var $67e0116949357e94$export$db7bc7284c4dde8f;
var $67e0116949357e94$export$24c09d9bceb0c15d;
var $67e0116949357e94$export$3b2eaf4f83e09fef;
$67e0116949357e94$export$c43bfb5198aa7b21 = `savgpW_AuthButton`;
$67e0116949357e94$export$cb4d80803776d6ac = `savgpW_externalLoginButtons`;
$67e0116949357e94$export$17fa98cb055e8fa7 = `savgpW_fontSizeH1`;
$67e0116949357e94$export$a5833c2b43ca4340 = `savgpW_fontSizeH2`;
$67e0116949357e94$export$47511f9a6581d1d6 = `savgpW_fontSizeH3`;
$67e0116949357e94$export$dd1c05b92185401c = `savgpW_fontSizeH4`;
$67e0116949357e94$export$8b28cf6cd00fe080 = `savgpW_fontSizeH5`;
$67e0116949357e94$export$186c650311ff0789 = `savgpW_fontSizeH6`;
$67e0116949357e94$export$6746fe0d9c9fab54 = `savgpW_fontSizeSmall`;
$67e0116949357e94$export$2bcf359f0c20e94f = `savgpW_fontSizeTiny`;
$67e0116949357e94$export$2903d10d531d0ac0 = `savgpW_fontSizep`;
$67e0116949357e94$export$972cea82bfe1355a = `savgpW_gsi-material-button`;
$67e0116949357e94$export$879158938acd5cc = `savgpW_gsi-material-button-content-wrapper`;
$67e0116949357e94$export$ec85da0fcf356258 = `savgpW_gsi-material-button-contents`;
$67e0116949357e94$export$db7bc7284c4dde8f = `savgpW_gsi-material-button-icon`;
$67e0116949357e94$export$24c09d9bceb0c15d = `savgpW_gsi-material-button-state`;
$67e0116949357e94$export$3b2eaf4f83e09fef = `savgpW_isHighlighted`;


const $eb3e3f19617c14ef$var$icons = {
    google: /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        style: {
            display: "block"
        },
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "#EA4335",
                d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "#4285F4",
                d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "#FBBC05",
                d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "#34A853",
                d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                fill: "none",
                d: "M0 0h48v48H0z"
            })
        ]
    }),
    apple: /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        width: "18",
        height: "21",
        viewBox: "0 0 18 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M8.84024 4.84615C9.7832 4.84615 10.9652 4.20534 11.6691 3.35092C12.3066 2.57661 12.7715 1.49523 12.7715 0.413859C12.7715 0.267006 12.7582 0.120153 12.7316 0C11.6824 0.0400509 10.4207 0.707566 9.66367 1.60203C9.06602 2.2829 8.52148 3.35092 8.52148 4.44565C8.52148 4.60585 8.54805 4.76605 8.56133 4.81945C8.62774 4.8328 8.73398 4.84615 8.84024 4.84615ZM5.51992 21C6.8082 21 7.3793 20.1322 8.98633 20.1322C10.6199 20.1322 10.9785 20.9733 12.4129 20.9733C13.8207 20.9733 14.7637 19.665 15.6535 18.3833C16.6496 16.9148 17.0613 15.473 17.0879 15.4062C16.9949 15.3795 14.2988 14.2715 14.2988 11.1608C14.2988 8.46408 16.4238 7.24921 16.5434 7.15575C15.1355 5.12651 12.9973 5.07311 12.4129 5.07311C10.8324 5.07311 9.54414 6.03433 8.73398 6.03433C7.85742 6.03433 6.70195 5.12651 5.33398 5.12651C2.73086 5.12651 0.0878906 7.28926 0.0878906 11.3744C0.0878906 13.911 1.0707 16.5944 2.2793 18.3299C3.31523 19.7985 4.21836 21 5.51992 21Z",
            fill: "black"
        })
    })
};
function $eb3e3f19617c14ef$var$ExternalLoginButton({ provider: provider, text: text }) {
    const PROVIDER_URLS = {
        google: "https://api.ariseworlds.com/auth/oauth/google/begin?state=",
        apple: "https://api.ariseworlds.com/auth/oauth/apple/begin?state="
    };
    function getUrl() {
        if (!crypto?.randomUUID) return;
        const key = crypto.randomUUID();
        const state = encodeURIComponent(btoa(window.location.origin + "?key=" + key));
        return PROVIDER_URLS[provider] + state;
    }
    const onClick = ()=>{
        window.location.href = getUrl();
    };
    if (!PROVIDER_URLS[provider]) {
        console.warn(`oAuth provider not supported: ${provider}`);
        return null;
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        className: $67e0116949357e94$export$972cea82bfe1355a,
        onClick: onClick,
        disabled: !crypto?.randomUUID,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $67e0116949357e94$export$24c09d9bceb0c15d
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $67e0116949357e94$export$879158938acd5cc,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $67e0116949357e94$export$db7bc7284c4dde8f,
                        children: $eb3e3f19617c14ef$var$icons[provider]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: $67e0116949357e94$export$ec85da0fcf356258,
                        children: text
                    })
                ]
            })
        ]
    });
}
function $eb3e3f19617c14ef$export$b109b9c2518624d5({ authProviders: authProviders }) {
    if (!authProviders || !authProviders.length) return null;
    const getButton = (provider, key)=>{
        switch(provider){
            case "google":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($eb3e3f19617c14ef$var$ExternalLoginButton, {
                    provider: "google",
                    text: "Continue with Google"
                }, key);
            case "apple":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($eb3e3f19617c14ef$var$ExternalLoginButton, {
                    provider: "apple",
                    text: "Continue with Apple"
                }, key);
            default:
                console.warn("Unsupported oAuth:", provider);
                break;
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $67e0116949357e94$export$cb4d80803776d6ac,
        children: authProviders.map((provider, index)=>getButton(provider, index))
    });
}
function $eb3e3f19617c14ef$export$c43bfb5198aa7b21({ text: text, onClick: onClick, isHighlighted: isHighlighted = true, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($67e0116949357e94$export$c43bfb5198aa7b21, {
            [$67e0116949357e94$export$3b2eaf4f83e09fef]: isHighlighted
        }),
        onClick: onClick,
        children: text
    });
}


var $f84adfbb9c6e021a$export$4adafe2b4f22b75f;
var $f84adfbb9c6e021a$export$8d6d009d1f06226e;
var $f84adfbb9c6e021a$export$5cfd5c18b591b2db;
var $f84adfbb9c6e021a$export$be69ea624d82a314;
var $f84adfbb9c6e021a$export$efe229eab43a9869;
var $f84adfbb9c6e021a$export$4f70dd1570ce06b2;
var $f84adfbb9c6e021a$export$493b5823483d2c4e;
var $f84adfbb9c6e021a$export$17fa98cb055e8fa7;
var $f84adfbb9c6e021a$export$a5833c2b43ca4340;
var $f84adfbb9c6e021a$export$47511f9a6581d1d6;
var $f84adfbb9c6e021a$export$dd1c05b92185401c;
var $f84adfbb9c6e021a$export$8b28cf6cd00fe080;
var $f84adfbb9c6e021a$export$186c650311ff0789;
var $f84adfbb9c6e021a$export$6746fe0d9c9fab54;
var $f84adfbb9c6e021a$export$2bcf359f0c20e94f;
var $f84adfbb9c6e021a$export$2903d10d531d0ac0;
var $f84adfbb9c6e021a$export$66791fb2cfeec3e;
var $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e;
var $f84adfbb9c6e021a$export$affaf52642033041;
var $f84adfbb9c6e021a$export$56f1fed55afb58d9;
var $f84adfbb9c6e021a$export$db3c28d99448dcff;
var $f84adfbb9c6e021a$export$3e523c77c1f23f8c;
var $f84adfbb9c6e021a$export$60877daf335d779;
var $f84adfbb9c6e021a$export$457806cff9fed328;
$f84adfbb9c6e021a$export$4adafe2b4f22b75f = `XwDFiW_AriseLoginModal`;
$f84adfbb9c6e021a$export$8d6d009d1f06226e = `XwDFiW_backButton`;
$f84adfbb9c6e021a$export$5cfd5c18b591b2db = `XwDFiW_bottomText`;
$f84adfbb9c6e021a$export$be69ea624d82a314 = `XwDFiW_checkboxContainer`;
$f84adfbb9c6e021a$export$efe229eab43a9869 = `XwDFiW_closeButton`;
$f84adfbb9c6e021a$export$4f70dd1570ce06b2 = `XwDFiW_emailInfo`;
$f84adfbb9c6e021a$export$493b5823483d2c4e = `XwDFiW_errorMessage`;
$f84adfbb9c6e021a$export$17fa98cb055e8fa7 = `XwDFiW_fontSizeH1`;
$f84adfbb9c6e021a$export$a5833c2b43ca4340 = `XwDFiW_fontSizeH2`;
$f84adfbb9c6e021a$export$47511f9a6581d1d6 = `XwDFiW_fontSizeH3`;
$f84adfbb9c6e021a$export$dd1c05b92185401c = `XwDFiW_fontSizeH4`;
$f84adfbb9c6e021a$export$8b28cf6cd00fe080 = `XwDFiW_fontSizeH5`;
$f84adfbb9c6e021a$export$186c650311ff0789 = `XwDFiW_fontSizeH6`;
$f84adfbb9c6e021a$export$6746fe0d9c9fab54 = `XwDFiW_fontSizeSmall`;
$f84adfbb9c6e021a$export$2bcf359f0c20e94f = `XwDFiW_fontSizeTiny`;
$f84adfbb9c6e021a$export$2903d10d531d0ac0 = `XwDFiW_fontSizep`;
$f84adfbb9c6e021a$export$66791fb2cfeec3e = `XwDFiW_forgotPassword`;
$f84adfbb9c6e021a$export$b7e3ae3d7c15e42e = `XwDFiW_input`;
$f84adfbb9c6e021a$export$affaf52642033041 = `XwDFiW_intro`;
$f84adfbb9c6e021a$export$56f1fed55afb58d9 = `XwDFiW_loginLink`;
$f84adfbb9c6e021a$export$db3c28d99448dcff = `XwDFiW_logo`;
$f84adfbb9c6e021a$export$3e523c77c1f23f8c = `XwDFiW_separator`;
$f84adfbb9c6e021a$export$60877daf335d779 = `XwDFiW_smallText`;
$f84adfbb9c6e021a$export$457806cff9fed328 = `XwDFiW_turnStyle`;


function $55cb026eaba9c471$export$2e2bcd8739ae039() {
    const [displayName, setDisplayName] = (0, $8FY87.useState)("");
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    const [isSendingData, setIsSendingData] = (0, $8FY87.useState)(false);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    (0, $8FY87.useEffect)(()=>{
        if (isGuest || (0, $1URoE.isInsidersInstance)) navigate((0, $1URoE.homePath));
    }, [
        isGuest,
        (0, $1URoE.isInsidersInstance)
    ]);
    (0, $8FY87.useEffect)(()=>{
        const DEBOUNCE_DELAY = 500;
        // Check display name validity locally once user stops typing for DEBOUNCE_DELAY
        const handler = setTimeout(()=>{
            if (!displayName || (0, $5e60b378ec730cd4$export$13abd87bc9b14090)(displayName)) {
                if (errorCode === "DISPLAYNAME_INVALID") setErrorCode(null);
            } else setErrorCode("DISPLAYNAME_INVALID");
        }, DEBOUNCE_DELAY);
        return ()=>clearTimeout(handler);
    }, [
        displayName
    ]);
    async function onSubmit() {
        if (!(0, $5e60b378ec730cd4$export$13abd87bc9b14090)(displayName)) {
            setErrorCode("DISPLAYNAME_INVALID");
            return;
        }
        if (isSendingData) return;
        setIsSendingData(true);
        try {
            const body = {
                displayName: displayName
            };
            const updatedUser = await $f9aoP.editProfile(currentUserProfile.id, body);
            (0, $i7H0N.sendEvent)("set_display_name_fullscreen", displayName);
            dispatch((0, $jJtwY.updateUser)(updatedUser));
            setTimeout(()=>navigate((0, $1URoE.homePath)), 500);
        } catch (error) {
            setErrorCode(error.message ?? "UNKNOWN_ERROR");
            console.error("Could not update display name", error);
            setIsSendingData(false);
        }
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        canScroll: true,
        isVisible: true,
        modalClassname: $f84adfbb9c6e021a$export$4adafe2b4f22b75f,
        shouldCloseOnExternalClick: false,
        zIndex: 1000,
        hasCloseButton: false,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $f84adfbb9c6e021a$export$db3c28d99448dcff,
                alt: "Those Beyond Logo",
                src: "/assets/global/those-beyond-icon.svg"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Choose your display name"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-set-display-name",
                children: "Display Name"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-set-display-name",
                value: displayName,
                onChange: (e)=>setDisplayName(e.target.value)
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "This is how others see you in the chat."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                disabled: !displayName || isSendingData || !currentUserProfile || !(0, $5e60b378ec730cd4$export$13abd87bc9b14090)(displayName),
                text: "Continue",
                onClick: onSubmit,
                style: {
                    marginTop: 20
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$493b5823483d2c4e,
                children: $55cb026eaba9c471$var$getEditProfileErrorMessage(errorCode)
            })
        ]
    });
}
function $55cb026eaba9c471$var$getEditProfileErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "DISPLAYNAME_INVALID":
            return 0, $5e60b378ec730cd4$export$45024f2ca55f9de6;
        case "DISPLAYNAME_VIOLATES_POLICY":
            return "Your display name contains inappropriate content.";
        default:
            return `Could not set your display name, please try again or contact ${0, $1URoE.SUPPORT_EMAIL}`;
    }
}


function $439070a6692e5164$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $55cb026eaba9c471$export$2e2bcd8739ae039), {});
}



var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");

var $6lYLL = parcelRequire("6lYLL");

var $2PPWI = parcelRequire("2PPWI");


var $6lYLL = parcelRequire("6lYLL");

var $cpVbU = parcelRequire("cpVbU");

var $aTKgi = parcelRequire("aTKgi");
const $298cd7185b675591$var$defaultAudio = [
    {
        id: "button-click",
        src: "/assets/global/audio/ui/[UI-Tap-01].mp3"
    },
    {
        id: "hover",
        src: "/assets/global/audio/ui/[UI-Hover-01].mp3"
    },
    {
        id: "gust-open",
        src: "/assets/global/audio/ui/[SCENE-Gust-01].mp3",
        volume: 0.05
    },
    {
        id: "gust-close",
        src: "/assets/global/audio/ui/[SCENE-Gust-02].mp3",
        volume: 0.05
    },
    {
        id: "drum",
        src: "/assets/global/audio/ui/[UI-Drum-01].mp3"
    },
    {
        id: "drum2",
        src: "/assets/global/audio/ui/[UI-Drum-02].mp3"
    },
    {
        id: "inventory-open",
        src: "/assets/global/audio/ui/[UI-Inventory-Open].mp3",
        volume: 0.4
    },
    {
        id: "inventory-close",
        src: "/assets/global/audio/ui/[UI-Inventory-Close].mp3",
        volume: 0.4
    },
    {
        id: "positive-achievement",
        src: "/assets/global/audio/ui/[UI-Positive-Achievement-01].mp3",
        volume: 0.5
    },
    {
        id: "negative-achievement",
        src: "/assets/global/audio/ui/[UI-Negative-Achievement-01].mp3",
        volume: 0.5
    },
    {
        id: "slam",
        src: "/assets/global/audio/ui/[SCENE-Slam-01].mp3",
        volume: 0.5
    },
    {
        id: "wipe-dark1",
        src: "/assets/global/audio/ui/[SCENE-WipeDark-01].mp3",
        volume: 0.5
    }
];
const $298cd7185b675591$var$customAudio = {
    [(0, $cpVbU.ThemeIds).Titan]: [
        ...$298cd7185b675591$var$defaultAudio,
        {
            id: "event__start",
            src: "/assets/themes/titan/audio/events/[EVENT-Start].mp3",
            volume: 0.4
        },
        {
            id: "event__success",
            src: "/assets/themes/titan/audio/events/[EVENT-Success].mp3",
            volume: 0.4
        },
        {
            id: "event__fail",
            src: "/assets/themes/titan/audio/events/[EVENT-Fail].mp3",
            volume: 0.4
        },
        {
            id: "event__countdown",
            src: "/assets/themes/titan/audio/events/[EVENT-Countdown-3s].mp3",
            volume: 0.4
        },
        {
            id: "faction-selector-bg",
            src: "/assets/themes/titan/audio/music/[MUSIC-STEM-01].mp3",
            ambient: true,
            volume: 0.5
        },
        {
            id: "drone-bg",
            src: "/assets/themes/titan/audio/ui/[SCENE-DroneDark-01].mp3",
            ambient: true,
            volume: 0.5
        }
    ],
    [(0, $cpVbU.ThemeIds).Hyperion]: [
        ...$298cd7185b675591$var$defaultAudio,
        {
            id: "event__start",
            src: "/assets/themes/hyperion/audio/events/[EVENT-Start].mp3",
            volume: 0.4
        },
        {
            id: "event__success",
            src: "/assets/themes/hyperion/audio/events/[EVENT-Success].mp3",
            volume: 0.4
        },
        {
            id: "event__fail",
            src: "/assets/themes/hyperion/audio/events/[EVENT-Fail].mp3",
            volume: 0.4
        },
        {
            id: "event__countdown",
            src: "/assets/themes/hyperion/audio/events/[EVENT-Countdown-3s].mp3",
            volume: 0.4
        }
    ],
    [(0, $cpVbU.ThemeIds).Deimos]: []
};
function $298cd7185b675591$export$2e2bcd8739ae039(themeId) {
    return $298cd7185b675591$var$customAudio[themeId] ? (0, $aTKgi.parsePayloadURLS)($298cd7185b675591$var$customAudio[themeId]) : (0, $aTKgi.parsePayloadURLS)($298cd7185b675591$var$defaultAudio);
}


const $d53970ea06cba05b$export$93d4e7f90805808f = ()=>{
    const theme = (0, $6lYLL.useAppSelector)((state)=>state.app.theme);
    return theme;
};
function $d53970ea06cba05b$export$82270779c4a788ac() {
    const theme = $d53970ea06cba05b$export$93d4e7f90805808f();
    (0, $091540b7cd96f6c1$export$91047320af7bf70b)((0, $298cd7185b675591$export$2e2bcd8739ae039)(theme.themeId));
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
var $46391e220d720c46$exports = {};
/*!
 * Pusher JavaScript Library v8.3.0
 * https://pusher.com/
 *
 * Copyright 2020, Pusher
 * Released under the MIT licence.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $46391e220d720c46$exports = factory();
})(window, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 2);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            var __extends = this && this.__extends || function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package base64 implements Base64 encoding and decoding.
 */ // Invalid character used in decoding to indicate
            // that the character to decode is out of range of
            // alphabet and cannot be decoded.
            var INVALID_BYTE = 256;
            /**
 * Implements standard Base64 encoding.
 *
 * Operates in constant time.
 */ var Coder = /** @class */ function() {
                // TODO(dchest): methods to encode chunk-by-chunk.
                function Coder(_paddingCharacter) {
                    if (_paddingCharacter === void 0) _paddingCharacter = "=";
                    this._paddingCharacter = _paddingCharacter;
                }
                Coder.prototype.encodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 8 + 5) / 6 | 0;
                    return (length + 2) / 3 * 4 | 0;
                };
                Coder.prototype.encode = function(data) {
                    var out = "";
                    var i = 0;
                    for(; i < data.length - 2; i += 3){
                        var c = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        out += this._encodeByte(c >>> 6 & 63);
                        out += this._encodeByte(c >>> 0 & 63);
                    }
                    var left = data.length - i;
                    if (left > 0) {
                        var c = data[i] << 16 | (left === 2 ? data[i + 1] << 8 : 0);
                        out += this._encodeByte(c >>> 18 & 63);
                        out += this._encodeByte(c >>> 12 & 63);
                        if (left === 2) out += this._encodeByte(c >>> 6 & 63);
                        else out += this._paddingCharacter || "";
                        out += this._paddingCharacter || "";
                    }
                    return out;
                };
                Coder.prototype.maxDecodedLength = function(length) {
                    if (!this._paddingCharacter) return (length * 6 + 7) / 8 | 0;
                    return length / 4 * 3 | 0;
                };
                Coder.prototype.decodedLength = function(s) {
                    return this.maxDecodedLength(s.length - this._getPaddingLength(s));
                };
                Coder.prototype.decode = function(s) {
                    if (s.length === 0) return new Uint8Array(0);
                    var paddingLength = this._getPaddingLength(s);
                    var length = s.length - paddingLength;
                    var out = new Uint8Array(this.maxDecodedLength(length));
                    var op = 0;
                    var i = 0;
                    var haveBad = 0;
                    var v0 = 0, v1 = 0, v2 = 0, v3 = 0;
                    for(; i < length - 4; i += 4){
                        v0 = this._decodeChar(s.charCodeAt(i + 0));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        out[op++] = v1 << 4 | v2 >>> 2;
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                        haveBad |= v2 & INVALID_BYTE;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (i < length - 1) {
                        v0 = this._decodeChar(s.charCodeAt(i));
                        v1 = this._decodeChar(s.charCodeAt(i + 1));
                        out[op++] = v0 << 2 | v1 >>> 4;
                        haveBad |= v0 & INVALID_BYTE;
                        haveBad |= v1 & INVALID_BYTE;
                    }
                    if (i < length - 2) {
                        v2 = this._decodeChar(s.charCodeAt(i + 2));
                        out[op++] = v1 << 4 | v2 >>> 2;
                        haveBad |= v2 & INVALID_BYTE;
                    }
                    if (i < length - 3) {
                        v3 = this._decodeChar(s.charCodeAt(i + 3));
                        out[op++] = v2 << 6 | v3;
                        haveBad |= v3 & INVALID_BYTE;
                    }
                    if (haveBad !== 0) throw new Error("Base64Coder: incorrect characters for decoding");
                    return out;
                };
                // Standard encoding have the following encoded/decoded ranges,
                // which we need to convert between.
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  +   /
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   43  47
                //
                // Encode 6 bits in b into a new character.
                Coder.prototype._encodeByte = function(b) {
                    // Encoding uses constant time operations as follows:
                    //
                    // 1. Define comparison of A with B using (A - B) >>> 8:
                    //          if A > B, then result is positive integer
                    //          if A <= B, then result is 0
                    //
                    // 2. Define selection of C or 0 using bitwise AND: X & C:
                    //          if X == 0, then result is 0
                    //          if X != 0, then result is C
                    //
                    // 3. Start with the smallest comparison (b >= 0), which is always
                    //    true, so set the result to the starting ASCII value (65).
                    //
                    // 4. Continue comparing b to higher ASCII values, and selecting
                    //    zero if comparison isn't true, otherwise selecting a value
                    //    to add to result, which:
                    //
                    //          a) undoes the previous addition
                    //          b) provides new value to add
                    //
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -15;
                    // b > 62
                    result += 62 - b >>> 8 & 3;
                    return String.fromCharCode(result);
                };
                // Decode a character code into a byte.
                // Must return 256 if character is out of alphabet range.
                Coder.prototype._decodeChar = function(c) {
                    // Decoding works similar to encoding: using the same comparison
                    // function, but now it works on ranges: result is always incremented
                    // by value, but this value becomes zero if the range is not
                    // satisfied.
                    //
                    // Decoding starts with invalid value, 256, which is then
                    // subtracted when the range is satisfied. If none of the ranges
                    // apply, the function returns 256, which is then checked by
                    // the caller to throw error.
                    var result = INVALID_BYTE; // start with invalid character
                    // c == 43 (c > 42 and c < 44)
                    result += (42 - c & c - 44) >>> 8 & -INVALID_BYTE + c - 43 + 62;
                    // c == 47 (c > 46 and c < 48)
                    result += (46 - c & c - 48) >>> 8 & -INVALID_BYTE + c - 47 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                Coder.prototype._getPaddingLength = function(s) {
                    var paddingLength = 0;
                    if (this._paddingCharacter) {
                        for(var i = s.length - 1; i >= 0; i--){
                            if (s[i] !== this._paddingCharacter) break;
                            paddingLength++;
                        }
                        if (s.length < 4 || paddingLength > 2) throw new Error("Base64Coder: incorrect padding");
                    }
                    return paddingLength;
                };
                return Coder;
            }();
            exports.Coder = Coder;
            var stdCoder = new Coder();
            function encode(data) {
                return stdCoder.encode(data);
            }
            exports.encode = encode;
            function decode(s) {
                return stdCoder.decode(s);
            }
            exports.decode = decode;
            /**
 * Implements URL-safe Base64 encoding.
 * (Same as Base64, but '+' is replaced with '-', and '/' with '_').
 *
 * Operates in constant time.
 */ var URLSafeCoder = /** @class */ function(_super) {
                __extends(URLSafeCoder, _super);
                function URLSafeCoder() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                // URL-safe encoding have the following encoded/decoded ranges:
                //
                // ABCDEFGHIJKLMNOPQRSTUVWXYZ abcdefghijklmnopqrstuvwxyz 0123456789  -   _
                // Index:   0 - 25                    26 - 51              52 - 61   62  63
                // ASCII:  65 - 90                    97 - 122             48 - 57   45  95
                //
                URLSafeCoder.prototype._encodeByte = function(b) {
                    var result = b;
                    // b >= 0
                    result += 65;
                    // b > 25
                    result += 25 - b >>> 8 & 6;
                    // b > 51
                    result += 51 - b >>> 8 & -75;
                    // b > 61
                    result += 61 - b >>> 8 & -13;
                    // b > 62
                    result += 62 - b >>> 8 & 49;
                    return String.fromCharCode(result);
                };
                URLSafeCoder.prototype._decodeChar = function(c) {
                    var result = INVALID_BYTE;
                    // c == 45 (c > 44 and c < 46)
                    result += (44 - c & c - 46) >>> 8 & -INVALID_BYTE + c - 45 + 62;
                    // c == 95 (c > 94 and c < 96)
                    result += (94 - c & c - 96) >>> 8 & -INVALID_BYTE + c - 95 + 63;
                    // c > 47 and c < 58
                    result += (47 - c & c - 58) >>> 8 & -INVALID_BYTE + c - 48 + 52;
                    // c > 64 and c < 91
                    result += (64 - c & c - 91) >>> 8 & -INVALID_BYTE + c - 65 + 0;
                    // c > 96 and c < 123
                    result += (96 - c & c - 123) >>> 8 & -INVALID_BYTE + c - 97 + 26;
                    return result;
                };
                return URLSafeCoder;
            }(Coder);
            exports.URLSafeCoder = URLSafeCoder;
            var urlSafeCoder = new URLSafeCoder();
            function encodeURLSafe(data) {
                return urlSafeCoder.encode(data);
            }
            exports.encodeURLSafe = encodeURLSafe;
            function decodeURLSafe(s) {
                return urlSafeCoder.decode(s);
            }
            exports.decodeURLSafe = decodeURLSafe;
            exports.encodedLength = function(length) {
                return stdCoder.encodedLength(length);
            };
            exports.maxDecodedLength = function(length) {
                return stdCoder.maxDecodedLength(length);
            };
            exports.decodedLength = function(s) {
                return stdCoder.decodedLength(s);
            };
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            // Copyright (C) 2016 Dmitry Chestnykh
            // MIT License. See LICENSE file for details.
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Package utf8 implements UTF-8 encoding and decoding.
 */ var INVALID_UTF16 = "utf8: invalid string";
            var INVALID_UTF8 = "utf8: invalid source encoding";
            /**
 * Encodes the given string into UTF-8 byte array.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encode(s) {
                // Calculate result length and allocate output array.
                // encodedLength() also validates string and throws errors,
                // so we don't need repeat validation here.
                var arr = new Uint8Array(encodedLength(s));
                var pos = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) arr[pos++] = c;
                    else if (c < 0x800) {
                        arr[pos++] = 0xc0 | c >> 6;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else if (c < 0xd800) {
                        arr[pos++] = 0xe0 | c >> 12;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    } else {
                        i++; // get one more character
                        c = (c & 0x3ff) << 10;
                        c |= s.charCodeAt(i) & 0x3ff;
                        c += 0x10000;
                        arr[pos++] = 0xf0 | c >> 18;
                        arr[pos++] = 0x80 | c >> 12 & 0x3f;
                        arr[pos++] = 0x80 | c >> 6 & 0x3f;
                        arr[pos++] = 0x80 | c & 0x3f;
                    }
                }
                return arr;
            }
            exports.encode = encode;
            /**
 * Returns the number of bytes required to encode the given string into UTF-8.
 * Throws if the source string has invalid UTF-16 encoding.
 */ function encodedLength(s) {
                var result = 0;
                for(var i = 0; i < s.length; i++){
                    var c = s.charCodeAt(i);
                    if (c < 0x80) result += 1;
                    else if (c < 0x800) result += 2;
                    else if (c < 0xd800) result += 3;
                    else if (c <= 0xdfff) {
                        if (i >= s.length - 1) throw new Error(INVALID_UTF16);
                        i++; // "eat" next character
                        result += 4;
                    } else throw new Error(INVALID_UTF16);
                }
                return result;
            }
            exports.encodedLength = encodedLength;
            /**
 * Decodes the given byte array from UTF-8 into a string.
 * Throws if encoding is invalid.
 */ function decode(arr) {
                var chars = [];
                for(var i = 0; i < arr.length; i++){
                    var b = arr[i];
                    if (b & 0x80) {
                        var min = void 0;
                        if (b < 0xe0) {
                            // Need 1 more byte.
                            if (i >= arr.length) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x1f) << 6 | n1 & 0x3f;
                            min = 0x80;
                        } else if (b < 0xf0) {
                            // Need 2 more bytes.
                            if (i >= arr.length - 1) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 12 | (n1 & 0x3f) << 6 | n2 & 0x3f;
                            min = 0x800;
                        } else if (b < 0xf8) {
                            // Need 3 more bytes.
                            if (i >= arr.length - 2) throw new Error(INVALID_UTF8);
                            var n1 = arr[++i];
                            var n2 = arr[++i];
                            var n3 = arr[++i];
                            if ((n1 & 0xc0) !== 0x80 || (n2 & 0xc0) !== 0x80 || (n3 & 0xc0) !== 0x80) throw new Error(INVALID_UTF8);
                            b = (b & 0x0f) << 18 | (n1 & 0x3f) << 12 | (n2 & 0x3f) << 6 | n3 & 0x3f;
                            min = 0x10000;
                        } else throw new Error(INVALID_UTF8);
                        if (b < min || b >= 0xd800 && b <= 0xdfff) throw new Error(INVALID_UTF8);
                        if (b >= 0x10000) {
                            // Surrogate pair.
                            if (b > 0x10ffff) throw new Error(INVALID_UTF8);
                            b -= 0x10000;
                            chars.push(String.fromCharCode(0xd800 | b >> 10));
                            b = 0xdc00 | b & 0x3ff;
                        }
                    }
                    chars.push(String.fromCharCode(b));
                }
                return chars.join("");
            }
            exports.decode = decode;
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            // required so we don't have to do require('pusher').default etc.
            module1.exports = __webpack_require__(3).default;
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            // ESM COMPAT FLAG
            __webpack_require__.r(__webpack_exports__);
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_receiver_factory.ts
            class ScriptReceiverFactory {
                constructor(prefix, name){
                    this.lastId = 0;
                    this.prefix = prefix;
                    this.name = name;
                }
                create(callback) {
                    this.lastId++;
                    var number = this.lastId;
                    var id = this.prefix + number;
                    var name = this.name + "[" + number + "]";
                    var called = false;
                    var callbackWrapper = function() {
                        if (!called) {
                            callback.apply(null, arguments);
                            called = true;
                        }
                    };
                    this[number] = callbackWrapper;
                    return {
                        number: number,
                        id: id,
                        name: name,
                        callback: callbackWrapper
                    };
                }
                remove(receiver) {
                    delete this[receiver.number];
                }
            }
            var ScriptReceivers = new ScriptReceiverFactory("_pusher_script_", "Pusher.ScriptReceivers");
            // CONCATENATED MODULE: ./src/core/defaults.ts
            var Defaults = {
                VERSION: "8.3.0",
                PROTOCOL: 7,
                wsPort: 80,
                wssPort: 443,
                wsPath: "",
                httpHost: "sockjs.pusher.com",
                httpPort: 80,
                httpsPort: 443,
                httpPath: "/pusher",
                stats_host: "stats.pusher.com",
                authEndpoint: "/pusher/auth",
                authTransport: "ajax",
                activityTimeout: 120000,
                pongTimeout: 30000,
                unavailableTimeout: 10000,
                userAuthentication: {
                    endpoint: "/pusher/user-auth",
                    transport: "ajax"
                },
                channelAuthorization: {
                    endpoint: "/pusher/auth",
                    transport: "ajax"
                },
                cdn_http: "http://js.pusher.com",
                cdn_https: "https://js.pusher.com",
                dependency_suffix: ""
            };
            /* harmony default export */ var defaults = Defaults;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependency_loader.ts
            class dependency_loader_DependencyLoader {
                constructor(options){
                    this.options = options;
                    this.receivers = options.receivers || ScriptReceivers;
                    this.loading = {};
                }
                load(name, options, callback) {
                    var self = this;
                    if (self.loading[name] && self.loading[name].length > 0) self.loading[name].push(callback);
                    else {
                        self.loading[name] = [
                            callback
                        ];
                        var request = runtime.createScriptRequest(self.getPath(name, options));
                        var receiver = self.receivers.create(function(error) {
                            self.receivers.remove(receiver);
                            if (self.loading[name]) {
                                var callbacks = self.loading[name];
                                delete self.loading[name];
                                var successCallback = function(wasSuccessful) {
                                    if (!wasSuccessful) request.cleanup();
                                };
                                for(var i = 0; i < callbacks.length; i++)callbacks[i](error, successCallback);
                            }
                        });
                        request.send(receiver);
                    }
                }
                getRoot(options) {
                    var cdn;
                    var protocol = runtime.getDocument().location.protocol;
                    if (options && options.useTLS || protocol === "https:") cdn = this.options.cdn_https;
                    else cdn = this.options.cdn_http;
                    return cdn.replace(/\/*$/, "") + "/" + this.options.version;
                }
                getPath(name, options) {
                    return this.getRoot(options) + "/" + name + this.options.suffix + ".js";
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/dom/dependencies.ts
            var DependenciesReceivers = new ScriptReceiverFactory("_pusher_dependencies", "Pusher.DependenciesReceivers");
            var Dependencies = new dependency_loader_DependencyLoader({
                cdn_http: defaults.cdn_http,
                cdn_https: defaults.cdn_https,
                version: defaults.VERSION,
                suffix: defaults.dependency_suffix,
                receivers: DependenciesReceivers
            });
            // CONCATENATED MODULE: ./src/core/utils/url_store.ts
            const urlStore = {
                baseUrl: "https://pusher.com",
                urls: {
                    authenticationEndpoint: {
                        path: "/docs/channels/server_api/authenticating_users"
                    },
                    authorizationEndpoint: {
                        path: "/docs/channels/server_api/authorizing-users/"
                    },
                    javascriptQuickStart: {
                        path: "/docs/javascript_quick_start"
                    },
                    triggeringClientEvents: {
                        path: "/docs/client_api_guide/client_events#trigger-events"
                    },
                    encryptedChannelSupport: {
                        fullUrl: "https://github.com/pusher/pusher-js/tree/cc491015371a4bde5743d1c87a0fbac0feb53195#encrypted-channel-support"
                    }
                }
            };
            const buildLogSuffix = function(key) {
                const urlPrefix = "See:";
                const urlObj = urlStore.urls[key];
                if (!urlObj) return "";
                let url;
                if (urlObj.fullUrl) url = urlObj.fullUrl;
                else if (urlObj.path) url = urlStore.baseUrl + urlObj.path;
                if (!url) return "";
                return `${urlPrefix} ${url}`;
            };
            /* harmony default export */ var url_store = {
                buildLogSuffix: buildLogSuffix
            };
            // CONCATENATED MODULE: ./src/core/auth/options.ts
            var AuthRequestType;
            (function(AuthRequestType) {
                AuthRequestType["UserAuthentication"] = "user-authentication";
                AuthRequestType["ChannelAuthorization"] = "channel-authorization";
            })(AuthRequestType || (AuthRequestType = {}));
            // CONCATENATED MODULE: ./src/core/errors.ts
            class BadEventName extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class BadChannelName extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class RequestTimedOut extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class TransportPriorityTooLow extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class TransportClosed extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedFeature extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedTransport extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class UnsupportedStrategy extends Error {
                constructor(msg){
                    super(msg);
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            class HTTPAuthError extends Error {
                constructor(status, msg){
                    super(msg);
                    this.status = status;
                    Object.setPrototypeOf(this, new.target.prototype);
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/auth/xhr_auth.ts
            const ajax = function(context, query, authOptions, authRequestType, callback) {
                const xhr = runtime.createXHR();
                xhr.open("POST", authOptions.endpoint, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                for(var headerName in authOptions.headers)xhr.setRequestHeader(headerName, authOptions.headers[headerName]);
                if (authOptions.headersProvider != null) {
                    let dynamicHeaders = authOptions.headersProvider();
                    for(var headerName in dynamicHeaders)xhr.setRequestHeader(headerName, dynamicHeaders[headerName]);
                }
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let data;
                            let parsed = false;
                            try {
                                data = JSON.parse(xhr.responseText);
                                parsed = true;
                            } catch (e) {
                                callback(new HTTPAuthError(200, `JSON returned from ${authRequestType.toString()} endpoint was invalid, yet status code was 200. Data was: ${xhr.responseText}`), null);
                            }
                            if (parsed) callback(null, data);
                        } else {
                            let suffix = "";
                            switch(authRequestType){
                                case AuthRequestType.UserAuthentication:
                                    suffix = url_store.buildLogSuffix("authenticationEndpoint");
                                    break;
                                case AuthRequestType.ChannelAuthorization:
                                    suffix = `Clients must be authorized to join private or presence channels. ${url_store.buildLogSuffix("authorizationEndpoint")}`;
                                    break;
                            }
                            callback(new HTTPAuthError(xhr.status, `Unable to retrieve auth string from ${authRequestType.toString()} endpoint - ` + `received status: ${xhr.status} from ${authOptions.endpoint}. ${suffix}`), null);
                        }
                    }
                };
                xhr.send(query);
                return xhr;
            };
            /* harmony default export */ var xhr_auth = ajax;
            // CONCATENATED MODULE: ./src/core/base64.ts
            function encode(s) {
                return btoa(utob(s));
            }
            var fromCharCode = String.fromCharCode;
            var b64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var b64tab = {};
            for(var base64_i = 0, l = b64chars.length; base64_i < l; base64_i++)b64tab[b64chars.charAt(base64_i)] = base64_i;
            var cb_utob = function(c) {
                var cc = c.charCodeAt(0);
                return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
            };
            var utob = function(u) {
                return u.replace(/[^\x00-\x7F]/g, cb_utob);
            };
            var cb_encode = function(ccc) {
                var padlen = [
                    0,
                    2,
                    1
                ][ccc.length % 3];
                var ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0);
                var chars = [
                    b64chars.charAt(ord >>> 18),
                    b64chars.charAt(ord >>> 12 & 63),
                    padlen >= 2 ? "=" : b64chars.charAt(ord >>> 6 & 63),
                    padlen >= 1 ? "=" : b64chars.charAt(ord & 63)
                ];
                return chars.join("");
            };
            var btoa = window.btoa || function(b) {
                return b.replace(/[\s\S]{1,3}/g, cb_encode);
            };
            // CONCATENATED MODULE: ./src/core/utils/timers/abstract_timer.ts
            class Timer {
                constructor(set, clear, delay, callback){
                    this.clear = clear;
                    this.timer = set(()=>{
                        if (this.timer) this.timer = callback(this.timer);
                    }, delay);
                }
                isRunning() {
                    return this.timer !== null;
                }
                ensureAborted() {
                    if (this.timer) {
                        this.clear(this.timer);
                        this.timer = null;
                    }
                }
            }
            /* harmony default export */ var abstract_timer = Timer;
            // CONCATENATED MODULE: ./src/core/utils/timers/index.ts
            function timers_clearTimeout(timer) {
                window.clearTimeout(timer);
            }
            function timers_clearInterval(timer) {
                window.clearInterval(timer);
            }
            class timers_OneOffTimer extends abstract_timer {
                constructor(delay, callback){
                    super(setTimeout, timers_clearTimeout, delay, function(timer) {
                        callback();
                        return null;
                    });
                }
            }
            class timers_PeriodicTimer extends abstract_timer {
                constructor(delay, callback){
                    super(setInterval, timers_clearInterval, delay, function(timer) {
                        callback();
                        return timer;
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/util.ts
            var Util = {
                now () {
                    if (Date.now) return Date.now();
                    else return new Date().valueOf();
                },
                defer (callback) {
                    return new timers_OneOffTimer(0, callback);
                },
                method (name, ...args) {
                    var boundArguments = Array.prototype.slice.call(arguments, 1);
                    return function(object) {
                        return object[name].apply(object, boundArguments.concat(arguments));
                    };
                }
            };
            /* harmony default export */ var util = Util;
            // CONCATENATED MODULE: ./src/core/utils/collections.ts
            function extend(target, ...sources) {
                for(var i = 0; i < sources.length; i++){
                    var extensions = sources[i];
                    for(var property in extensions)if (extensions[property] && extensions[property].constructor && extensions[property].constructor === Object) target[property] = extend(target[property] || {}, extensions[property]);
                    else target[property] = extensions[property];
                }
                return target;
            }
            function stringify() {
                var m = [
                    "Pusher"
                ];
                for(var i = 0; i < arguments.length; i++)if (typeof arguments[i] === "string") m.push(arguments[i]);
                else m.push(safeJSONStringify(arguments[i]));
                return m.join(" : ");
            }
            function arrayIndexOf(array, item) {
                var nativeIndexOf = Array.prototype.indexOf;
                if (array === null) return -1;
                if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item);
                for(var i = 0, l = array.length; i < l; i++){
                    if (array[i] === item) return i;
                }
                return -1;
            }
            function objectApply(object, f) {
                for(var key in object)if (Object.prototype.hasOwnProperty.call(object, key)) f(object[key], key, object);
            }
            function keys(object) {
                var keys = [];
                objectApply(object, function(_, key) {
                    keys.push(key);
                });
                return keys;
            }
            function values(object) {
                var values = [];
                objectApply(object, function(value) {
                    values.push(value);
                });
                return values;
            }
            function apply(array, f, context) {
                for(var i = 0; i < array.length; i++)f.call(context || window, array[i], i, array);
            }
            function map(array, f) {
                var result = [];
                for(var i = 0; i < array.length; i++)result.push(f(array[i], i, array, result));
                return result;
            }
            function mapObject(object, f) {
                var result = {};
                objectApply(object, function(value, key) {
                    result[key] = f(value);
                });
                return result;
            }
            function filter(array, test) {
                test = test || function(value) {
                    return !!value;
                };
                var result = [];
                for(var i = 0; i < array.length; i++)if (test(array[i], i, array, result)) result.push(array[i]);
                return result;
            }
            function filterObject(object, test) {
                var result = {};
                objectApply(object, function(value, key) {
                    if (test && test(value, key, object, result) || Boolean(value)) result[key] = value;
                });
                return result;
            }
            function flatten(object) {
                var result = [];
                objectApply(object, function(value, key) {
                    result.push([
                        key,
                        value
                    ]);
                });
                return result;
            }
            function any(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (test(array[i], i, array)) return true;
                }
                return false;
            }
            function collections_all(array, test) {
                for(var i = 0; i < array.length; i++){
                    if (!test(array[i], i, array)) return false;
                }
                return true;
            }
            function encodeParamsObject(data) {
                return mapObject(data, function(value) {
                    if (typeof value === "object") value = safeJSONStringify(value);
                    return encodeURIComponent(encode(value.toString()));
                });
            }
            function buildQueryString(data) {
                var params = filterObject(data, function(value) {
                    return value !== undefined;
                });
                var query = map(flatten(encodeParamsObject(params)), util.method("join", "=")).join("&");
                return query;
            }
            function decycleObject(object) {
                var objects = [], paths = [];
                return function derez(value, path) {
                    var i, name, nu;
                    switch(typeof value){
                        case "object":
                            if (!value) return null;
                            for(i = 0; i < objects.length; i += 1){
                                if (objects[i] === value) return {
                                    $ref: paths[i]
                                };
                            }
                            objects.push(value);
                            paths.push(path);
                            if (Object.prototype.toString.apply(value) === "[object Array]") {
                                nu = [];
                                for(i = 0; i < value.length; i += 1)nu[i] = derez(value[i], path + "[" + i + "]");
                            } else {
                                nu = {};
                                for(name in value)if (Object.prototype.hasOwnProperty.call(value, name)) nu[name] = derez(value[name], path + "[" + JSON.stringify(name) + "]");
                            }
                            return nu;
                        case "number":
                        case "string":
                        case "boolean":
                            return value;
                    }
                }(object, "$");
            }
            function safeJSONStringify(source) {
                try {
                    return JSON.stringify(source);
                } catch (e) {
                    return JSON.stringify(decycleObject(source));
                }
            }
            // CONCATENATED MODULE: ./src/core/logger.ts
            class logger_Logger {
                constructor(){
                    this.globalLog = (message)=>{
                        if (window.console && window.console.log) window.console.log(message);
                    };
                }
                debug(...args) {
                    this.log(this.globalLog, args);
                }
                warn(...args) {
                    this.log(this.globalLogWarn, args);
                }
                error(...args) {
                    this.log(this.globalLogError, args);
                }
                globalLogWarn(message) {
                    if (window.console && window.console.warn) window.console.warn(message);
                    else this.globalLog(message);
                }
                globalLogError(message) {
                    if (window.console && window.console.error) window.console.error(message);
                    else this.globalLogWarn(message);
                }
                log(defaultLoggingFunction, ...args) {
                    var message = stringify.apply(this, arguments);
                    if (core_pusher.log) core_pusher.log(message);
                    else if (core_pusher.logToConsole) {
                        const log = defaultLoggingFunction.bind(this);
                        log(message);
                    }
                }
            }
            /* harmony default export */ var logger = new logger_Logger();
            // CONCATENATED MODULE: ./src/runtimes/web/auth/jsonp_auth.ts
            var jsonp = function(context, query, authOptions, authRequestType, callback) {
                if (authOptions.headers !== undefined || authOptions.headersProvider != null) logger.warn(`To send headers with the ${authRequestType.toString()} request, you must use AJAX, rather than JSONP.`);
                var callbackName = context.nextAuthCallbackID.toString();
                context.nextAuthCallbackID++;
                var document1 = context.getDocument();
                var script = document1.createElement("script");
                context.auth_callbacks[callbackName] = function(data) {
                    callback(null, data);
                };
                var callback_name = "Pusher.auth_callbacks['" + callbackName + "']";
                script.src = authOptions.endpoint + "?callback=" + encodeURIComponent(callback_name) + "&" + query;
                var head = document1.getElementsByTagName("head")[0] || document1.documentElement;
                head.insertBefore(script, head.firstChild);
            };
            /* harmony default export */ var jsonp_auth = jsonp;
            // CONCATENATED MODULE: ./src/runtimes/web/dom/script_request.ts
            class ScriptRequest {
                constructor(src){
                    this.src = src;
                }
                send(receiver) {
                    var self = this;
                    var errorString = "Error loading " + self.src;
                    self.script = document.createElement("script");
                    self.script.id = receiver.id;
                    self.script.src = self.src;
                    self.script.type = "text/javascript";
                    self.script.charset = "UTF-8";
                    if (self.script.addEventListener) {
                        self.script.onerror = function() {
                            receiver.callback(errorString);
                        };
                        self.script.onload = function() {
                            receiver.callback(null);
                        };
                    } else self.script.onreadystatechange = function() {
                        if (self.script.readyState === "loaded" || self.script.readyState === "complete") receiver.callback(null);
                    };
                    if (self.script.async === undefined && document.attachEvent && /opera/i.test(navigator.userAgent)) {
                        self.errorScript = document.createElement("script");
                        self.errorScript.id = receiver.id + "_error";
                        self.errorScript.text = receiver.name + "('" + errorString + "');";
                        self.script.async = self.errorScript.async = false;
                    } else self.script.async = true;
                    var head = document.getElementsByTagName("head")[0];
                    head.insertBefore(self.script, head.firstChild);
                    if (self.errorScript) head.insertBefore(self.errorScript, self.script.nextSibling);
                }
                cleanup() {
                    if (this.script) {
                        this.script.onload = this.script.onerror = null;
                        this.script.onreadystatechange = null;
                    }
                    if (this.script && this.script.parentNode) this.script.parentNode.removeChild(this.script);
                    if (this.errorScript && this.errorScript.parentNode) this.errorScript.parentNode.removeChild(this.errorScript);
                    this.script = null;
                    this.errorScript = null;
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/dom/jsonp_request.ts
            class jsonp_request_JSONPRequest {
                constructor(url, data){
                    this.url = url;
                    this.data = data;
                }
                send(receiver) {
                    if (this.request) return;
                    var query = buildQueryString(this.data);
                    var url = this.url + "/" + receiver.number + "?" + query;
                    this.request = runtime.createScriptRequest(url);
                    this.request.send(receiver);
                }
                cleanup() {
                    if (this.request) this.request.cleanup();
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/timeline/jsonp_timeline.ts
            var getAgent = function(sender, useTLS) {
                return function(data, callback) {
                    var scheme = "http" + (useTLS ? "s" : "") + "://";
                    var url = scheme + (sender.host || sender.options.host) + sender.options.path;
                    var request = runtime.createJSONPRequest(url, data);
                    var receiver = runtime.ScriptReceivers.create(function(error, result) {
                        ScriptReceivers.remove(receiver);
                        request.cleanup();
                        if (result && result.host) sender.host = result.host;
                        if (callback) callback(error, result);
                    });
                    request.send(receiver);
                };
            };
            var jsonp_timeline_jsonp = {
                name: "jsonp",
                getAgent: getAgent
            };
            /* harmony default export */ var jsonp_timeline = jsonp_timeline_jsonp;
            // CONCATENATED MODULE: ./src/core/transports/url_schemes.ts
            function getGenericURL(baseScheme, params, path) {
                var scheme = baseScheme + (params.useTLS ? "s" : "");
                var host = params.useTLS ? params.hostTLS : params.hostNonTLS;
                return scheme + "://" + host + path;
            }
            function getGenericPath(key, queryString) {
                var path = "/app/" + key;
                var query = "?protocol=" + defaults.PROTOCOL + "&client=js" + "&version=" + defaults.VERSION + (queryString ? "&" + queryString : "");
                return path + query;
            }
            var ws = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "") + getGenericPath(key, "flash=false");
                    return getGenericURL("ws", params, path);
                }
            };
            var http = {
                getInitial: function(key, params) {
                    var path = (params.httpPath || "/pusher") + getGenericPath(key);
                    return getGenericURL("http", params, path);
                }
            };
            var sockjs = {
                getInitial: function(key, params) {
                    return getGenericURL("http", params, params.httpPath || "/pusher");
                },
                getPath: function(key, params) {
                    return getGenericPath(key);
                }
            };
            // CONCATENATED MODULE: ./src/core/events/callback_registry.ts
            class callback_registry_CallbackRegistry {
                constructor(){
                    this._callbacks = {};
                }
                get(name) {
                    return this._callbacks[prefix(name)];
                }
                add(name, callback, context) {
                    var prefixedEventName = prefix(name);
                    this._callbacks[prefixedEventName] = this._callbacks[prefixedEventName] || [];
                    this._callbacks[prefixedEventName].push({
                        fn: callback,
                        context: context
                    });
                }
                remove(name, callback, context) {
                    if (!name && !callback && !context) {
                        this._callbacks = {};
                        return;
                    }
                    var names = name ? [
                        prefix(name)
                    ] : keys(this._callbacks);
                    if (callback || context) this.removeCallback(names, callback, context);
                    else this.removeAllCallbacks(names);
                }
                removeCallback(names, callback, context) {
                    apply(names, function(name) {
                        this._callbacks[name] = filter(this._callbacks[name] || [], function(binding) {
                            return callback && callback !== binding.fn || context && context !== binding.context;
                        });
                        if (this._callbacks[name].length === 0) delete this._callbacks[name];
                    }, this);
                }
                removeAllCallbacks(names) {
                    apply(names, function(name) {
                        delete this._callbacks[name];
                    }, this);
                }
            }
            function prefix(name) {
                return "_" + name;
            }
            // CONCATENATED MODULE: ./src/core/events/dispatcher.ts
            class dispatcher_Dispatcher {
                constructor(failThrough){
                    this.callbacks = new callback_registry_CallbackRegistry();
                    this.global_callbacks = [];
                    this.failThrough = failThrough;
                }
                bind(eventName, callback, context) {
                    this.callbacks.add(eventName, callback, context);
                    return this;
                }
                bind_global(callback) {
                    this.global_callbacks.push(callback);
                    return this;
                }
                unbind(eventName, callback, context) {
                    this.callbacks.remove(eventName, callback, context);
                    return this;
                }
                unbind_global(callback) {
                    if (!callback) {
                        this.global_callbacks = [];
                        return this;
                    }
                    this.global_callbacks = filter(this.global_callbacks || [], (c)=>c !== callback);
                    return this;
                }
                unbind_all() {
                    this.unbind();
                    this.unbind_global();
                    return this;
                }
                emit(eventName, data, metadata) {
                    for(var i = 0; i < this.global_callbacks.length; i++)this.global_callbacks[i](eventName, data);
                    var callbacks = this.callbacks.get(eventName);
                    var args = [];
                    if (metadata) args.push(data, metadata);
                    else if (data) args.push(data);
                    if (callbacks && callbacks.length > 0) for(var i = 0; i < callbacks.length; i++)callbacks[i].fn.apply(callbacks[i].context || window, args);
                    else if (this.failThrough) this.failThrough(eventName, data);
                    return this;
                }
            }
            // CONCATENATED MODULE: ./src/core/transports/transport_connection.ts
            class transport_connection_TransportConnection extends dispatcher_Dispatcher {
                constructor(hooks, name, priority, key, options){
                    super();
                    this.initialize = runtime.transportConnectionInitializer;
                    this.hooks = hooks;
                    this.name = name;
                    this.priority = priority;
                    this.key = key;
                    this.options = options;
                    this.state = "new";
                    this.timeline = options.timeline;
                    this.activityTimeout = options.activityTimeout;
                    this.id = this.timeline.generateUniqueID();
                }
                handlesActivityChecks() {
                    return Boolean(this.hooks.handlesActivityChecks);
                }
                supportsPing() {
                    return Boolean(this.hooks.supportsPing);
                }
                connect() {
                    if (this.socket || this.state !== "initialized") return false;
                    var url = this.hooks.urls.getInitial(this.key, this.options);
                    try {
                        this.socket = this.hooks.getSocket(url, this.options);
                    } catch (e) {
                        util.defer(()=>{
                            this.onError(e);
                            this.changeState("closed");
                        });
                        return false;
                    }
                    this.bindListeners();
                    logger.debug("Connecting", {
                        transport: this.name,
                        url: url
                    });
                    this.changeState("connecting");
                    return true;
                }
                close() {
                    if (this.socket) {
                        this.socket.close();
                        return true;
                    } else return false;
                }
                send(data) {
                    if (this.state === "open") {
                        util.defer(()=>{
                            if (this.socket) this.socket.send(data);
                        });
                        return true;
                    } else return false;
                }
                ping() {
                    if (this.state === "open" && this.supportsPing()) this.socket.ping();
                }
                onOpen() {
                    if (this.hooks.beforeOpen) this.hooks.beforeOpen(this.socket, this.hooks.urls.getPath(this.key, this.options));
                    this.changeState("open");
                    this.socket.onopen = undefined;
                }
                onError(error) {
                    this.emit("error", {
                        type: "WebSocketError",
                        error: error
                    });
                    this.timeline.error(this.buildTimelineMessage({
                        error: error.toString()
                    }));
                }
                onClose(closeEvent) {
                    if (closeEvent) this.changeState("closed", {
                        code: closeEvent.code,
                        reason: closeEvent.reason,
                        wasClean: closeEvent.wasClean
                    });
                    else this.changeState("closed");
                    this.unbindListeners();
                    this.socket = undefined;
                }
                onMessage(message) {
                    this.emit("message", message);
                }
                onActivity() {
                    this.emit("activity");
                }
                bindListeners() {
                    this.socket.onopen = ()=>{
                        this.onOpen();
                    };
                    this.socket.onerror = (error)=>{
                        this.onError(error);
                    };
                    this.socket.onclose = (closeEvent)=>{
                        this.onClose(closeEvent);
                    };
                    this.socket.onmessage = (message)=>{
                        this.onMessage(message);
                    };
                    if (this.supportsPing()) this.socket.onactivity = ()=>{
                        this.onActivity();
                    };
                }
                unbindListeners() {
                    if (this.socket) {
                        this.socket.onopen = undefined;
                        this.socket.onerror = undefined;
                        this.socket.onclose = undefined;
                        this.socket.onmessage = undefined;
                        if (this.supportsPing()) this.socket.onactivity = undefined;
                    }
                }
                changeState(state, params) {
                    this.state = state;
                    this.timeline.info(this.buildTimelineMessage({
                        state: state,
                        params: params
                    }));
                    this.emit(state, params);
                }
                buildTimelineMessage(message) {
                    return extend({
                        cid: this.id
                    }, message);
                }
            }
            // CONCATENATED MODULE: ./src/core/transports/transport.ts
            class transport_Transport {
                constructor(hooks){
                    this.hooks = hooks;
                }
                isSupported(environment) {
                    return this.hooks.isSupported(environment);
                }
                createConnection(name, priority, key, options) {
                    return new transport_connection_TransportConnection(this.hooks, name, priority, key, options);
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/transports/transports.ts
            var WSTransport = new transport_Transport({
                urls: ws,
                handlesActivityChecks: false,
                supportsPing: false,
                isInitialized: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                isSupported: function() {
                    return Boolean(runtime.getWebSocketAPI());
                },
                getSocket: function(url) {
                    return runtime.createWebSocket(url);
                }
            });
            var httpConfiguration = {
                urls: http,
                handlesActivityChecks: false,
                supportsPing: true,
                isInitialized: function() {
                    return true;
                }
            };
            var streamingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createStreamingSocket(url);
                }
            }, httpConfiguration);
            var pollingConfiguration = extend({
                getSocket: function(url) {
                    return runtime.HTTPFactory.createPollingSocket(url);
                }
            }, httpConfiguration);
            var xhrConfiguration = {
                isSupported: function() {
                    return runtime.isXHRSupported();
                }
            };
            var XHRStreamingTransport = new transport_Transport(extend({}, streamingConfiguration, xhrConfiguration));
            var XHRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xhrConfiguration));
            var Transports = {
                ws: WSTransport,
                xhr_streaming: XHRStreamingTransport,
                xhr_polling: XHRPollingTransport
            };
            /* harmony default export */ var transports = Transports;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transports.ts
            var SockJSTransport = new transport_Transport({
                file: "sockjs",
                urls: sockjs,
                handlesActivityChecks: true,
                supportsPing: false,
                isSupported: function() {
                    return true;
                },
                isInitialized: function() {
                    return window.SockJS !== undefined;
                },
                getSocket: function(url, options) {
                    return new window.SockJS(url, null, {
                        js_path: Dependencies.getPath("sockjs", {
                            useTLS: options.useTLS
                        }),
                        ignore_null_origin: options.ignoreNullOrigin
                    });
                },
                beforeOpen: function(socket, path) {
                    socket.send(JSON.stringify({
                        path: path
                    }));
                }
            });
            var xdrConfiguration = {
                isSupported: function(environment) {
                    var yes = runtime.isXDRSupported(environment.useTLS);
                    return yes;
                }
            };
            var XDRStreamingTransport = new transport_Transport(extend({}, streamingConfiguration, xdrConfiguration));
            var XDRPollingTransport = new transport_Transport(extend({}, pollingConfiguration, xdrConfiguration));
            transports.xdr_streaming = XDRStreamingTransport;
            transports.xdr_polling = XDRPollingTransport;
            transports.sockjs = SockJSTransport;
            /* harmony default export */ var transports_transports = transports;
            // CONCATENATED MODULE: ./src/runtimes/web/net_info.ts
            class net_info_NetInfo extends dispatcher_Dispatcher {
                constructor(){
                    super();
                    var self = this;
                    if (window.addEventListener !== undefined) {
                        window.addEventListener("online", function() {
                            self.emit("online");
                        }, false);
                        window.addEventListener("offline", function() {
                            self.emit("offline");
                        }, false);
                    }
                }
                isOnline() {
                    if (window.navigator.onLine === undefined) return true;
                    else return window.navigator.onLine;
                }
            }
            var net_info_Network = new net_info_NetInfo();
            // CONCATENATED MODULE: ./src/core/transports/assistant_to_the_transport_manager.ts
            class assistant_to_the_transport_manager_AssistantToTheTransportManager {
                constructor(manager, transport, options){
                    this.manager = manager;
                    this.transport = transport;
                    this.minPingDelay = options.minPingDelay;
                    this.maxPingDelay = options.maxPingDelay;
                    this.pingDelay = undefined;
                }
                createConnection(name, priority, key, options) {
                    options = extend({}, options, {
                        activityTimeout: this.pingDelay
                    });
                    var connection = this.transport.createConnection(name, priority, key, options);
                    var openTimestamp = null;
                    var onOpen = function() {
                        connection.unbind("open", onOpen);
                        connection.bind("closed", onClosed);
                        openTimestamp = util.now();
                    };
                    var onClosed = (closeEvent)=>{
                        connection.unbind("closed", onClosed);
                        if (closeEvent.code === 1002 || closeEvent.code === 1003) this.manager.reportDeath();
                        else if (!closeEvent.wasClean && openTimestamp) {
                            var lifespan = util.now() - openTimestamp;
                            if (lifespan < 2 * this.maxPingDelay) {
                                this.manager.reportDeath();
                                this.pingDelay = Math.max(lifespan / 2, this.minPingDelay);
                            }
                        }
                    };
                    connection.bind("open", onOpen);
                    return connection;
                }
                isSupported(environment) {
                    return this.manager.isAlive() && this.transport.isSupported(environment);
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/protocol/protocol.ts
            const Protocol = {
                decodeMessage: function(messageEvent) {
                    try {
                        var messageData = JSON.parse(messageEvent.data);
                        var pusherEventData = messageData.data;
                        if (typeof pusherEventData === "string") try {
                            pusherEventData = JSON.parse(messageData.data);
                        } catch (e) {}
                        var pusherEvent = {
                            event: messageData.event,
                            channel: messageData.channel,
                            data: pusherEventData
                        };
                        if (messageData.user_id) pusherEvent.user_id = messageData.user_id;
                        return pusherEvent;
                    } catch (e) {
                        throw {
                            type: "MessageParseError",
                            error: e,
                            data: messageEvent.data
                        };
                    }
                },
                encodeMessage: function(event) {
                    return JSON.stringify(event);
                },
                processHandshake: function(messageEvent) {
                    var message = Protocol.decodeMessage(messageEvent);
                    if (message.event === "pusher:connection_established") {
                        if (!message.data.activity_timeout) throw "No activity timeout specified in handshake";
                        return {
                            action: "connected",
                            id: message.data.socket_id,
                            activityTimeout: message.data.activity_timeout * 1000
                        };
                    } else if (message.event === "pusher:error") return {
                        action: this.getCloseAction(message.data),
                        error: this.getCloseError(message.data)
                    };
                    else throw "Invalid handshake";
                },
                getCloseAction: function(closeEvent) {
                    if (closeEvent.code < 4000) {
                        if (closeEvent.code >= 1002 && closeEvent.code <= 1004) return "backoff";
                        else return null;
                    } else if (closeEvent.code === 4000) return "tls_only";
                    else if (closeEvent.code < 4100) return "refused";
                    else if (closeEvent.code < 4200) return "backoff";
                    else if (closeEvent.code < 4300) return "retry";
                    else return "refused";
                },
                getCloseError: function(closeEvent) {
                    if (closeEvent.code !== 1000 && closeEvent.code !== 1001) return {
                        type: "PusherError",
                        data: {
                            code: closeEvent.code,
                            message: closeEvent.reason || closeEvent.message
                        }
                    };
                    else return null;
                }
            };
            /* harmony default export */ var protocol_protocol = Protocol;
            // CONCATENATED MODULE: ./src/core/connection/connection.ts
            class connection_Connection extends dispatcher_Dispatcher {
                constructor(id, transport){
                    super();
                    this.id = id;
                    this.transport = transport;
                    this.activityTimeout = transport.activityTimeout;
                    this.bindListeners();
                }
                handlesActivityChecks() {
                    return this.transport.handlesActivityChecks();
                }
                send(data) {
                    return this.transport.send(data);
                }
                send_event(name, data, channel) {
                    var event = {
                        event: name,
                        data: data
                    };
                    if (channel) event.channel = channel;
                    logger.debug("Event sent", event);
                    return this.send(protocol_protocol.encodeMessage(event));
                }
                ping() {
                    if (this.transport.supportsPing()) this.transport.ping();
                    else this.send_event("pusher:ping", {});
                }
                close() {
                    this.transport.close();
                }
                bindListeners() {
                    var listeners = {
                        message: (messageEvent)=>{
                            var pusherEvent;
                            try {
                                pusherEvent = protocol_protocol.decodeMessage(messageEvent);
                            } catch (e) {
                                this.emit("error", {
                                    type: "MessageParseError",
                                    error: e,
                                    data: messageEvent.data
                                });
                            }
                            if (pusherEvent !== undefined) {
                                logger.debug("Event recd", pusherEvent);
                                switch(pusherEvent.event){
                                    case "pusher:error":
                                        this.emit("error", {
                                            type: "PusherError",
                                            data: pusherEvent.data
                                        });
                                        break;
                                    case "pusher:ping":
                                        this.emit("ping");
                                        break;
                                    case "pusher:pong":
                                        this.emit("pong");
                                        break;
                                }
                                this.emit("message", pusherEvent);
                            }
                        },
                        activity: ()=>{
                            this.emit("activity");
                        },
                        error: (error)=>{
                            this.emit("error", error);
                        },
                        closed: (closeEvent)=>{
                            unbindListeners();
                            if (closeEvent && closeEvent.code) this.handleCloseEvent(closeEvent);
                            this.transport = null;
                            this.emit("closed");
                        }
                    };
                    var unbindListeners = ()=>{
                        objectApply(listeners, (listener, event)=>{
                            this.transport.unbind(event, listener);
                        });
                    };
                    objectApply(listeners, (listener, event)=>{
                        this.transport.bind(event, listener);
                    });
                }
                handleCloseEvent(closeEvent) {
                    var action = protocol_protocol.getCloseAction(closeEvent);
                    var error = protocol_protocol.getCloseError(closeEvent);
                    if (error) this.emit("error", error);
                    if (action) this.emit(action, {
                        action: action,
                        error: error
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/handshake/index.ts
            class handshake_Handshake {
                constructor(transport, callback){
                    this.transport = transport;
                    this.callback = callback;
                    this.bindListeners();
                }
                close() {
                    this.unbindListeners();
                    this.transport.close();
                }
                bindListeners() {
                    this.onMessage = (m)=>{
                        this.unbindListeners();
                        var result;
                        try {
                            result = protocol_protocol.processHandshake(m);
                        } catch (e) {
                            this.finish("error", {
                                error: e
                            });
                            this.transport.close();
                            return;
                        }
                        if (result.action === "connected") this.finish("connected", {
                            connection: new connection_Connection(result.id, this.transport),
                            activityTimeout: result.activityTimeout
                        });
                        else {
                            this.finish(result.action, {
                                error: result.error
                            });
                            this.transport.close();
                        }
                    };
                    this.onClosed = (closeEvent)=>{
                        this.unbindListeners();
                        var action = protocol_protocol.getCloseAction(closeEvent) || "backoff";
                        var error = protocol_protocol.getCloseError(closeEvent);
                        this.finish(action, {
                            error: error
                        });
                    };
                    this.transport.bind("message", this.onMessage);
                    this.transport.bind("closed", this.onClosed);
                }
                unbindListeners() {
                    this.transport.unbind("message", this.onMessage);
                    this.transport.unbind("closed", this.onClosed);
                }
                finish(action, params) {
                    this.callback(extend({
                        transport: this.transport,
                        action: action
                    }, params));
                }
            }
            // CONCATENATED MODULE: ./src/core/timeline/timeline_sender.ts
            class timeline_sender_TimelineSender {
                constructor(timeline, options){
                    this.timeline = timeline;
                    this.options = options || {};
                }
                send(useTLS, callback) {
                    if (this.timeline.isEmpty()) return;
                    this.timeline.send(runtime.TimelineTransport.getAgent(this, useTLS), callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/channel.ts
            class channel_Channel extends dispatcher_Dispatcher {
                constructor(name, pusher){
                    super(function(event, data) {
                        logger.debug("No callbacks on " + name + " for " + event);
                    });
                    this.name = name;
                    this.pusher = pusher;
                    this.subscribed = false;
                    this.subscriptionPending = false;
                    this.subscriptionCancelled = false;
                }
                authorize(socketId, callback) {
                    return callback(null, {
                        auth: ""
                    });
                }
                trigger(event, data) {
                    if (event.indexOf("client-") !== 0) throw new BadEventName("Event '" + event + "' does not start with 'client-'");
                    if (!this.subscribed) {
                        var suffix = url_store.buildLogSuffix("triggeringClientEvents");
                        logger.warn(`Client event triggered before channel 'subscription_succeeded' event . ${suffix}`);
                    }
                    return this.pusher.send_event(event, data, this.name);
                }
                disconnect() {
                    this.subscribed = false;
                    this.subscriptionPending = false;
                }
                handleEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName === "pusher_internal:subscription_succeeded") this.handleSubscriptionSucceededEvent(event);
                    else if (eventName === "pusher_internal:subscription_count") this.handleSubscriptionCountEvent(event);
                    else if (eventName.indexOf("pusher_internal:") !== 0) {
                        var metadata = {};
                        this.emit(eventName, data, metadata);
                    }
                }
                handleSubscriptionSucceededEvent(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else this.emit("pusher:subscription_succeeded", event.data);
                }
                handleSubscriptionCountEvent(event) {
                    if (event.data.subscription_count) this.subscriptionCount = event.data.subscription_count;
                    this.emit("pusher:subscription_count", event.data);
                }
                subscribe() {
                    if (this.subscribed) return;
                    this.subscriptionPending = true;
                    this.subscriptionCancelled = false;
                    this.authorize(this.pusher.connection.socket_id, (error, data)=>{
                        if (error) {
                            this.subscriptionPending = false;
                            logger.error(error.toString());
                            this.emit("pusher:subscription_error", Object.assign({}, {
                                type: "AuthError",
                                error: error.message
                            }, error instanceof HTTPAuthError ? {
                                status: error.status
                            } : {}));
                        } else this.pusher.send_event("pusher:subscribe", {
                            auth: data.auth,
                            channel_data: data.channel_data,
                            channel: this.name
                        });
                    });
                }
                unsubscribe() {
                    this.subscribed = false;
                    this.pusher.send_event("pusher:unsubscribe", {
                        channel: this.name
                    });
                }
                cancelSubscription() {
                    this.subscriptionCancelled = true;
                }
                reinstateSubscription() {
                    this.subscriptionCancelled = false;
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/private_channel.ts
            class private_channel_PrivateChannel extends channel_Channel {
                authorize(socketId, callback) {
                    return this.pusher.config.channelAuthorizer({
                        channelName: this.name,
                        socketId: socketId
                    }, callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/members.ts
            class members_Members {
                constructor(){
                    this.reset();
                }
                get(id) {
                    if (Object.prototype.hasOwnProperty.call(this.members, id)) return {
                        id: id,
                        info: this.members[id]
                    };
                    else return null;
                }
                each(callback) {
                    objectApply(this.members, (member, id)=>{
                        callback(this.get(id));
                    });
                }
                setMyID(id) {
                    this.myID = id;
                }
                onSubscription(subscriptionData) {
                    this.members = subscriptionData.presence.hash;
                    this.count = subscriptionData.presence.count;
                    this.me = this.get(this.myID);
                }
                addMember(memberData) {
                    if (this.get(memberData.user_id) === null) this.count++;
                    this.members[memberData.user_id] = memberData.user_info;
                    return this.get(memberData.user_id);
                }
                removeMember(memberData) {
                    var member = this.get(memberData.user_id);
                    if (member) {
                        delete this.members[memberData.user_id];
                        this.count--;
                    }
                    return member;
                }
                reset() {
                    this.members = {};
                    this.count = 0;
                    this.myID = null;
                    this.me = null;
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/presence_channel.ts
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            class presence_channel_PresenceChannel extends private_channel_PrivateChannel {
                constructor(name, pusher){
                    super(name, pusher);
                    this.members = new members_Members();
                }
                authorize(socketId, callback) {
                    super.authorize(socketId, (error, authData)=>__awaiter(this, void 0, void 0, function*() {
                            if (!error) {
                                authData;
                                if (authData.channel_data != null) {
                                    var channelData = JSON.parse(authData.channel_data);
                                    this.members.setMyID(channelData.user_id);
                                } else {
                                    yield this.pusher.user.signinDonePromise;
                                    if (this.pusher.user.user_data != null) this.members.setMyID(this.pusher.user.user_data.id);
                                    else {
                                        let suffix = url_store.buildLogSuffix("authorizationEndpoint");
                                        logger.error(`Invalid auth response for channel '${this.name}', ` + `expected 'channel_data' field. ${suffix}, ` + `or the user should be signed in.`);
                                        callback("Invalid auth response");
                                        return;
                                    }
                                }
                            }
                            callback(error, authData);
                        }));
                }
                handleEvent(event) {
                    var eventName = event.event;
                    if (eventName.indexOf("pusher_internal:") === 0) this.handleInternalEvent(event);
                    else {
                        var data = event.data;
                        var metadata = {};
                        if (event.user_id) metadata.user_id = event.user_id;
                        this.emit(eventName, data, metadata);
                    }
                }
                handleInternalEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    switch(eventName){
                        case "pusher_internal:subscription_succeeded":
                            this.handleSubscriptionSucceededEvent(event);
                            break;
                        case "pusher_internal:subscription_count":
                            this.handleSubscriptionCountEvent(event);
                            break;
                        case "pusher_internal:member_added":
                            var addedMember = this.members.addMember(data);
                            this.emit("pusher:member_added", addedMember);
                            break;
                        case "pusher_internal:member_removed":
                            var removedMember = this.members.removeMember(data);
                            if (removedMember) this.emit("pusher:member_removed", removedMember);
                            break;
                    }
                }
                handleSubscriptionSucceededEvent(event) {
                    this.subscriptionPending = false;
                    this.subscribed = true;
                    if (this.subscriptionCancelled) this.pusher.unsubscribe(this.name);
                    else {
                        this.members.onSubscription(event.data);
                        this.emit("pusher:subscription_succeeded", this.members);
                    }
                }
                disconnect() {
                    this.members.reset();
                    super.disconnect();
                }
            }
            // EXTERNAL MODULE: ./node_modules/@stablelib/utf8/lib/utf8.js
            var utf8 = __webpack_require__(1);
            // EXTERNAL MODULE: ./node_modules/@stablelib/base64/lib/base64.js
            var base64 = __webpack_require__(0);
            // CONCATENATED MODULE: ./src/core/channels/encrypted_channel.ts
            class encrypted_channel_EncryptedChannel extends private_channel_PrivateChannel {
                constructor(name, pusher, nacl){
                    super(name, pusher);
                    this.key = null;
                    this.nacl = nacl;
                }
                authorize(socketId, callback) {
                    super.authorize(socketId, (error, authData)=>{
                        if (error) {
                            callback(error, authData);
                            return;
                        }
                        let sharedSecret = authData["shared_secret"];
                        if (!sharedSecret) {
                            callback(new Error(`No shared_secret key in auth payload for encrypted channel: ${this.name}`), null);
                            return;
                        }
                        this.key = Object(base64["decode"])(sharedSecret);
                        delete authData["shared_secret"];
                        callback(null, authData);
                    });
                }
                trigger(event, data) {
                    throw new UnsupportedFeature("Client events are not currently supported for encrypted channels");
                }
                handleEvent(event) {
                    var eventName = event.event;
                    var data = event.data;
                    if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) {
                        super.handleEvent(event);
                        return;
                    }
                    this.handleEncryptedEvent(eventName, data);
                }
                handleEncryptedEvent(event, data) {
                    if (!this.key) {
                        logger.debug("Received encrypted event before key has been retrieved from the authEndpoint");
                        return;
                    }
                    if (!data.ciphertext || !data.nonce) {
                        logger.error("Unexpected format for encrypted event, expected object with `ciphertext` and `nonce` fields, got: " + data);
                        return;
                    }
                    let cipherText = Object(base64["decode"])(data.ciphertext);
                    if (cipherText.length < this.nacl.secretbox.overheadLength) {
                        logger.error(`Expected encrypted event ciphertext length to be ${this.nacl.secretbox.overheadLength}, got: ${cipherText.length}`);
                        return;
                    }
                    let nonce = Object(base64["decode"])(data.nonce);
                    if (nonce.length < this.nacl.secretbox.nonceLength) {
                        logger.error(`Expected encrypted event nonce length to be ${this.nacl.secretbox.nonceLength}, got: ${nonce.length}`);
                        return;
                    }
                    let bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                    if (bytes === null) {
                        logger.debug("Failed to decrypt an event, probably because it was encrypted with a different key. Fetching a new key from the authEndpoint...");
                        this.authorize(this.pusher.connection.socket_id, (error, authData)=>{
                            if (error) {
                                logger.error(`Failed to make a request to the authEndpoint: ${authData}. Unable to fetch new key, so dropping encrypted event`);
                                return;
                            }
                            bytes = this.nacl.secretbox.open(cipherText, nonce, this.key);
                            if (bytes === null) {
                                logger.error(`Failed to decrypt event with new key. Dropping encrypted event`);
                                return;
                            }
                            this.emit(event, this.getDataToEmit(bytes));
                            return;
                        });
                        return;
                    }
                    this.emit(event, this.getDataToEmit(bytes));
                }
                getDataToEmit(bytes) {
                    let raw = Object(utf8["decode"])(bytes);
                    try {
                        return JSON.parse(raw);
                    } catch (_a) {
                        return raw;
                    }
                }
            }
            // CONCATENATED MODULE: ./src/core/connection/connection_manager.ts
            class connection_manager_ConnectionManager extends dispatcher_Dispatcher {
                constructor(key, options){
                    super();
                    this.state = "initialized";
                    this.connection = null;
                    this.key = key;
                    this.options = options;
                    this.timeline = this.options.timeline;
                    this.usingTLS = this.options.useTLS;
                    this.errorCallbacks = this.buildErrorCallbacks();
                    this.connectionCallbacks = this.buildConnectionCallbacks(this.errorCallbacks);
                    this.handshakeCallbacks = this.buildHandshakeCallbacks(this.errorCallbacks);
                    var Network = runtime.getNetwork();
                    Network.bind("online", ()=>{
                        this.timeline.info({
                            netinfo: "online"
                        });
                        if (this.state === "connecting" || this.state === "unavailable") this.retryIn(0);
                    });
                    Network.bind("offline", ()=>{
                        this.timeline.info({
                            netinfo: "offline"
                        });
                        if (this.connection) this.sendActivityCheck();
                    });
                    this.updateStrategy();
                }
                connect() {
                    if (this.connection || this.runner) return;
                    if (!this.strategy.isSupported()) {
                        this.updateState("failed");
                        return;
                    }
                    this.updateState("connecting");
                    this.startConnecting();
                    this.setUnavailableTimer();
                }
                send(data) {
                    if (this.connection) return this.connection.send(data);
                    else return false;
                }
                send_event(name, data, channel) {
                    if (this.connection) return this.connection.send_event(name, data, channel);
                    else return false;
                }
                disconnect() {
                    this.disconnectInternally();
                    this.updateState("disconnected");
                }
                isUsingTLS() {
                    return this.usingTLS;
                }
                startConnecting() {
                    var callback = (error, handshake)=>{
                        if (error) this.runner = this.strategy.connect(0, callback);
                        else if (handshake.action === "error") {
                            this.emit("error", {
                                type: "HandshakeError",
                                error: handshake.error
                            });
                            this.timeline.error({
                                handshakeError: handshake.error
                            });
                        } else {
                            this.abortConnecting();
                            this.handshakeCallbacks[handshake.action](handshake);
                        }
                    };
                    this.runner = this.strategy.connect(0, callback);
                }
                abortConnecting() {
                    if (this.runner) {
                        this.runner.abort();
                        this.runner = null;
                    }
                }
                disconnectInternally() {
                    this.abortConnecting();
                    this.clearRetryTimer();
                    this.clearUnavailableTimer();
                    if (this.connection) {
                        var connection = this.abandonConnection();
                        connection.close();
                    }
                }
                updateStrategy() {
                    this.strategy = this.options.getStrategy({
                        key: this.key,
                        timeline: this.timeline,
                        useTLS: this.usingTLS
                    });
                }
                retryIn(delay) {
                    this.timeline.info({
                        action: "retry",
                        delay: delay
                    });
                    if (delay > 0) this.emit("connecting_in", Math.round(delay / 1000));
                    this.retryTimer = new timers_OneOffTimer(delay || 0, ()=>{
                        this.disconnectInternally();
                        this.connect();
                    });
                }
                clearRetryTimer() {
                    if (this.retryTimer) {
                        this.retryTimer.ensureAborted();
                        this.retryTimer = null;
                    }
                }
                setUnavailableTimer() {
                    this.unavailableTimer = new timers_OneOffTimer(this.options.unavailableTimeout, ()=>{
                        this.updateState("unavailable");
                    });
                }
                clearUnavailableTimer() {
                    if (this.unavailableTimer) this.unavailableTimer.ensureAborted();
                }
                sendActivityCheck() {
                    this.stopActivityCheck();
                    this.connection.ping();
                    this.activityTimer = new timers_OneOffTimer(this.options.pongTimeout, ()=>{
                        this.timeline.error({
                            pong_timed_out: this.options.pongTimeout
                        });
                        this.retryIn(0);
                    });
                }
                resetActivityCheck() {
                    this.stopActivityCheck();
                    if (this.connection && !this.connection.handlesActivityChecks()) this.activityTimer = new timers_OneOffTimer(this.activityTimeout, ()=>{
                        this.sendActivityCheck();
                    });
                }
                stopActivityCheck() {
                    if (this.activityTimer) this.activityTimer.ensureAborted();
                }
                buildConnectionCallbacks(errorCallbacks) {
                    return extend({}, errorCallbacks, {
                        message: (message)=>{
                            this.resetActivityCheck();
                            this.emit("message", message);
                        },
                        ping: ()=>{
                            this.send_event("pusher:pong", {});
                        },
                        activity: ()=>{
                            this.resetActivityCheck();
                        },
                        error: (error)=>{
                            this.emit("error", error);
                        },
                        closed: ()=>{
                            this.abandonConnection();
                            if (this.shouldRetry()) this.retryIn(1000);
                        }
                    });
                }
                buildHandshakeCallbacks(errorCallbacks) {
                    return extend({}, errorCallbacks, {
                        connected: (handshake)=>{
                            this.activityTimeout = Math.min(this.options.activityTimeout, handshake.activityTimeout, handshake.connection.activityTimeout || Infinity);
                            this.clearUnavailableTimer();
                            this.setConnection(handshake.connection);
                            this.socket_id = this.connection.id;
                            this.updateState("connected", {
                                socket_id: this.socket_id
                            });
                        }
                    });
                }
                buildErrorCallbacks() {
                    let withErrorEmitted = (callback)=>{
                        return (result)=>{
                            if (result.error) this.emit("error", {
                                type: "WebSocketError",
                                error: result.error
                            });
                            callback(result);
                        };
                    };
                    return {
                        tls_only: withErrorEmitted(()=>{
                            this.usingTLS = true;
                            this.updateStrategy();
                            this.retryIn(0);
                        }),
                        refused: withErrorEmitted(()=>{
                            this.disconnect();
                        }),
                        backoff: withErrorEmitted(()=>{
                            this.retryIn(1000);
                        }),
                        retry: withErrorEmitted(()=>{
                            this.retryIn(0);
                        })
                    };
                }
                setConnection(connection) {
                    this.connection = connection;
                    for(var event in this.connectionCallbacks)this.connection.bind(event, this.connectionCallbacks[event]);
                    this.resetActivityCheck();
                }
                abandonConnection() {
                    if (!this.connection) return;
                    this.stopActivityCheck();
                    for(var event in this.connectionCallbacks)this.connection.unbind(event, this.connectionCallbacks[event]);
                    var connection = this.connection;
                    this.connection = null;
                    return connection;
                }
                updateState(newState, data) {
                    var previousState = this.state;
                    this.state = newState;
                    if (previousState !== newState) {
                        var newStateDescription = newState;
                        if (newStateDescription === "connected") newStateDescription += " with new socket ID " + data.socket_id;
                        logger.debug("State changed", previousState + " -> " + newStateDescription);
                        this.timeline.info({
                            state: newState,
                            params: data
                        });
                        this.emit("state_change", {
                            previous: previousState,
                            current: newState
                        });
                        this.emit(newState, data);
                    }
                }
                shouldRetry() {
                    return this.state === "connecting" || this.state === "connected";
                }
            }
            // CONCATENATED MODULE: ./src/core/channels/channels.ts
            class channels_Channels {
                constructor(){
                    this.channels = {};
                }
                add(name, pusher) {
                    if (!this.channels[name]) this.channels[name] = createChannel(name, pusher);
                    return this.channels[name];
                }
                all() {
                    return values(this.channels);
                }
                find(name) {
                    return this.channels[name];
                }
                remove(name) {
                    var channel = this.channels[name];
                    delete this.channels[name];
                    return channel;
                }
                disconnect() {
                    objectApply(this.channels, function(channel) {
                        channel.disconnect();
                    });
                }
            }
            function createChannel(name, pusher) {
                if (name.indexOf("private-encrypted-") === 0) {
                    if (pusher.config.nacl) return factory.createEncryptedChannel(name, pusher, pusher.config.nacl);
                    let errMsg = "Tried to subscribe to a private-encrypted- channel but no nacl implementation available";
                    let suffix = url_store.buildLogSuffix("encryptedChannelSupport");
                    throw new UnsupportedFeature(`${errMsg}. ${suffix}`);
                } else if (name.indexOf("private-") === 0) return factory.createPrivateChannel(name, pusher);
                else if (name.indexOf("presence-") === 0) return factory.createPresenceChannel(name, pusher);
                else if (name.indexOf("#") === 0) throw new BadChannelName('Cannot create a channel with name "' + name + '".');
                else return factory.createChannel(name, pusher);
            }
            // CONCATENATED MODULE: ./src/core/utils/factory.ts
            var Factory = {
                createChannels () {
                    return new channels_Channels();
                },
                createConnectionManager (key, options) {
                    return new connection_manager_ConnectionManager(key, options);
                },
                createChannel (name, pusher) {
                    return new channel_Channel(name, pusher);
                },
                createPrivateChannel (name, pusher) {
                    return new private_channel_PrivateChannel(name, pusher);
                },
                createPresenceChannel (name, pusher) {
                    return new presence_channel_PresenceChannel(name, pusher);
                },
                createEncryptedChannel (name, pusher, nacl) {
                    return new encrypted_channel_EncryptedChannel(name, pusher, nacl);
                },
                createTimelineSender (timeline, options) {
                    return new timeline_sender_TimelineSender(timeline, options);
                },
                createHandshake (transport, callback) {
                    return new handshake_Handshake(transport, callback);
                },
                createAssistantToTheTransportManager (manager, transport, options) {
                    return new assistant_to_the_transport_manager_AssistantToTheTransportManager(manager, transport, options);
                }
            };
            /* harmony default export */ var factory = Factory;
            // CONCATENATED MODULE: ./src/core/transports/transport_manager.ts
            class transport_manager_TransportManager {
                constructor(options){
                    this.options = options || {};
                    this.livesLeft = this.options.lives || Infinity;
                }
                getAssistant(transport) {
                    return factory.createAssistantToTheTransportManager(this, transport, {
                        minPingDelay: this.options.minPingDelay,
                        maxPingDelay: this.options.maxPingDelay
                    });
                }
                isAlive() {
                    return this.livesLeft > 0;
                }
                reportDeath() {
                    this.livesLeft -= 1;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/sequential_strategy.ts
            class sequential_strategy_SequentialStrategy {
                constructor(strategies, options){
                    this.strategies = strategies;
                    this.loop = Boolean(options.loop);
                    this.failFast = Boolean(options.failFast);
                    this.timeout = options.timeout;
                    this.timeoutLimit = options.timeoutLimit;
                }
                isSupported() {
                    return any(this.strategies, util.method("isSupported"));
                }
                connect(minPriority, callback) {
                    var strategies = this.strategies;
                    var current = 0;
                    var timeout = this.timeout;
                    var runner = null;
                    var tryNextStrategy = (error, handshake)=>{
                        if (handshake) callback(null, handshake);
                        else {
                            current = current + 1;
                            if (this.loop) current = current % strategies.length;
                            if (current < strategies.length) {
                                if (timeout) {
                                    timeout = timeout * 2;
                                    if (this.timeoutLimit) timeout = Math.min(timeout, this.timeoutLimit);
                                }
                                runner = this.tryStrategy(strategies[current], minPriority, {
                                    timeout: timeout,
                                    failFast: this.failFast
                                }, tryNextStrategy);
                            } else callback(true);
                        }
                    };
                    runner = this.tryStrategy(strategies[current], minPriority, {
                        timeout: timeout,
                        failFast: this.failFast
                    }, tryNextStrategy);
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
                tryStrategy(strategy, minPriority, options, callback) {
                    var timer = null;
                    var runner = null;
                    if (options.timeout > 0) timer = new timers_OneOffTimer(options.timeout, function() {
                        runner.abort();
                        callback(true);
                    });
                    runner = strategy.connect(minPriority, function(error, handshake) {
                        if (error && timer && timer.isRunning() && !options.failFast) return;
                        if (timer) timer.ensureAborted();
                        callback(error, handshake);
                    });
                    return {
                        abort: function() {
                            if (timer) timer.ensureAborted();
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            runner.forceMinPriority(p);
                        }
                    };
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/best_connected_ever_strategy.ts
            class best_connected_ever_strategy_BestConnectedEverStrategy {
                constructor(strategies){
                    this.strategies = strategies;
                }
                isSupported() {
                    return any(this.strategies, util.method("isSupported"));
                }
                connect(minPriority, callback) {
                    return connect(this.strategies, minPriority, function(i, runners) {
                        return function(error, handshake) {
                            runners[i].error = error;
                            if (error) {
                                if (allRunnersFailed(runners)) callback(true);
                                return;
                            }
                            apply(runners, function(runner) {
                                runner.forceMinPriority(handshake.transport.priority);
                            });
                            callback(null, handshake);
                        };
                    });
                }
            }
            function connect(strategies, minPriority, callbackBuilder) {
                var runners = map(strategies, function(strategy, i, _, rs) {
                    return strategy.connect(minPriority, callbackBuilder(i, rs));
                });
                return {
                    abort: function() {
                        apply(runners, abortRunner);
                    },
                    forceMinPriority: function(p) {
                        apply(runners, function(runner) {
                            runner.forceMinPriority(p);
                        });
                    }
                };
            }
            function allRunnersFailed(runners) {
                return collections_all(runners, function(runner) {
                    return Boolean(runner.error);
                });
            }
            function abortRunner(runner) {
                if (!runner.error && !runner.aborted) {
                    runner.abort();
                    runner.aborted = true;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/websocket_prioritized_cached_strategy.ts
            class websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy {
                constructor(strategy, transports, options){
                    this.strategy = strategy;
                    this.transports = transports;
                    this.ttl = options.ttl || 1800000;
                    this.usingTLS = options.useTLS;
                    this.timeline = options.timeline;
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var usingTLS = this.usingTLS;
                    var info = fetchTransportCache(usingTLS);
                    var cacheSkipCount = info && info.cacheSkipCount ? info.cacheSkipCount : 0;
                    var strategies = [
                        this.strategy
                    ];
                    if (info && info.timestamp + this.ttl >= util.now()) {
                        var transport = this.transports[info.transport];
                        if (transport) {
                            if ([
                                "ws",
                                "wss"
                            ].includes(info.transport) || cacheSkipCount > 3) {
                                this.timeline.info({
                                    cached: true,
                                    transport: info.transport,
                                    latency: info.latency
                                });
                                strategies.push(new sequential_strategy_SequentialStrategy([
                                    transport
                                ], {
                                    timeout: info.latency * 2 + 1000,
                                    failFast: true
                                }));
                            } else cacheSkipCount++;
                        }
                    }
                    var startTimestamp = util.now();
                    var runner = strategies.pop().connect(minPriority, function cb(error, handshake) {
                        if (error) {
                            flushTransportCache(usingTLS);
                            if (strategies.length > 0) {
                                startTimestamp = util.now();
                                runner = strategies.pop().connect(minPriority, cb);
                            } else callback(error);
                        } else {
                            storeTransportCache(usingTLS, handshake.transport.name, util.now() - startTimestamp, cacheSkipCount);
                            callback(null, handshake);
                        }
                    });
                    return {
                        abort: function() {
                            runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
            }
            function getTransportCacheKey(usingTLS) {
                return "pusherTransport" + (usingTLS ? "TLS" : "NonTLS");
            }
            function fetchTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    var serializedCache = storage[getTransportCacheKey(usingTLS)];
                    if (serializedCache) return JSON.parse(serializedCache);
                } catch (e) {
                    flushTransportCache(usingTLS);
                }
                return null;
            }
            function storeTransportCache(usingTLS, transport, latency, cacheSkipCount) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    storage[getTransportCacheKey(usingTLS)] = safeJSONStringify({
                        timestamp: util.now(),
                        transport: transport,
                        latency: latency,
                        cacheSkipCount: cacheSkipCount
                    });
                } catch (e) {}
            }
            function flushTransportCache(usingTLS) {
                var storage = runtime.getLocalStorage();
                if (storage) try {
                    delete storage[getTransportCacheKey(usingTLS)];
                } catch (e) {}
            }
            // CONCATENATED MODULE: ./src/core/strategies/delayed_strategy.ts
            class delayed_strategy_DelayedStrategy {
                constructor(strategy, { delay: number }){
                    this.strategy = strategy;
                    this.options = {
                        delay: number
                    };
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var strategy = this.strategy;
                    var runner;
                    var timer = new timers_OneOffTimer(this.options.delay, function() {
                        runner = strategy.connect(minPriority, callback);
                    });
                    return {
                        abort: function() {
                            timer.ensureAborted();
                            if (runner) runner.abort();
                        },
                        forceMinPriority: function(p) {
                            minPriority = p;
                            if (runner) runner.forceMinPriority(p);
                        }
                    };
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/if_strategy.ts
            class IfStrategy {
                constructor(test, trueBranch, falseBranch){
                    this.test = test;
                    this.trueBranch = trueBranch;
                    this.falseBranch = falseBranch;
                }
                isSupported() {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.isSupported();
                }
                connect(minPriority, callback) {
                    var branch = this.test() ? this.trueBranch : this.falseBranch;
                    return branch.connect(minPriority, callback);
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/first_connected_strategy.ts
            class FirstConnectedStrategy {
                constructor(strategy){
                    this.strategy = strategy;
                }
                isSupported() {
                    return this.strategy.isSupported();
                }
                connect(minPriority, callback) {
                    var runner = this.strategy.connect(minPriority, function(error, handshake) {
                        if (handshake) runner.abort();
                        callback(error, handshake);
                    });
                    return runner;
                }
            }
            // CONCATENATED MODULE: ./src/runtimes/web/default_strategy.ts
            function testSupportsStrategy(strategy) {
                return function() {
                    return strategy.isSupported();
                };
            }
            var getDefaultStrategy = function(config, baseOptions, defineTransport) {
                var definedTransports = {};
                function defineTransportStrategy(name, type, priority, options, manager) {
                    var transport = defineTransport(config, name, type, priority, options, manager);
                    definedTransports[name] = transport;
                    return transport;
                }
                var ws_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.wsHost + ":" + config.wsPort,
                    hostTLS: config.wsHost + ":" + config.wssPort,
                    httpPath: config.wsPath
                });
                var wss_options = Object.assign({}, ws_options, {
                    useTLS: true
                });
                var sockjs_options = Object.assign({}, baseOptions, {
                    hostNonTLS: config.httpHost + ":" + config.httpPort,
                    hostTLS: config.httpHost + ":" + config.httpsPort,
                    httpPath: config.httpPath
                });
                var timeouts = {
                    loop: true,
                    timeout: 15000,
                    timeoutLimit: 60000
                };
                var ws_manager = new transport_manager_TransportManager({
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var streaming_manager = new transport_manager_TransportManager({
                    lives: 2,
                    minPingDelay: 10000,
                    maxPingDelay: config.activityTimeout
                });
                var ws_transport = defineTransportStrategy("ws", "ws", 3, ws_options, ws_manager);
                var wss_transport = defineTransportStrategy("wss", "ws", 3, wss_options, ws_manager);
                var sockjs_transport = defineTransportStrategy("sockjs", "sockjs", 1, sockjs_options);
                var xhr_streaming_transport = defineTransportStrategy("xhr_streaming", "xhr_streaming", 1, sockjs_options, streaming_manager);
                var xdr_streaming_transport = defineTransportStrategy("xdr_streaming", "xdr_streaming", 1, sockjs_options, streaming_manager);
                var xhr_polling_transport = defineTransportStrategy("xhr_polling", "xhr_polling", 1, sockjs_options);
                var xdr_polling_transport = defineTransportStrategy("xdr_polling", "xdr_polling", 1, sockjs_options);
                var ws_loop = new sequential_strategy_SequentialStrategy([
                    ws_transport
                ], timeouts);
                var wss_loop = new sequential_strategy_SequentialStrategy([
                    wss_transport
                ], timeouts);
                var sockjs_loop = new sequential_strategy_SequentialStrategy([
                    sockjs_transport
                ], timeouts);
                var streaming_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(xhr_streaming_transport), xhr_streaming_transport, xdr_streaming_transport)
                ], timeouts);
                var polling_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(xhr_polling_transport), xhr_polling_transport, xdr_polling_transport)
                ], timeouts);
                var http_loop = new sequential_strategy_SequentialStrategy([
                    new IfStrategy(testSupportsStrategy(streaming_loop), new best_connected_ever_strategy_BestConnectedEverStrategy([
                        streaming_loop,
                        new delayed_strategy_DelayedStrategy(polling_loop, {
                            delay: 4000
                        })
                    ]), polling_loop)
                ], timeouts);
                var http_fallback_loop = new IfStrategy(testSupportsStrategy(http_loop), http_loop, sockjs_loop);
                var wsStrategy;
                if (baseOptions.useTLS) wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
                    ws_loop,
                    new delayed_strategy_DelayedStrategy(http_fallback_loop, {
                        delay: 2000
                    })
                ]);
                else wsStrategy = new best_connected_ever_strategy_BestConnectedEverStrategy([
                    ws_loop,
                    new delayed_strategy_DelayedStrategy(wss_loop, {
                        delay: 2000
                    }),
                    new delayed_strategy_DelayedStrategy(http_fallback_loop, {
                        delay: 5000
                    })
                ]);
                return new websocket_prioritized_cached_strategy_WebSocketPrioritizedCachedStrategy(new FirstConnectedStrategy(new IfStrategy(testSupportsStrategy(ws_transport), wsStrategy, http_fallback_loop)), definedTransports, {
                    ttl: 1800000,
                    timeline: baseOptions.timeline,
                    useTLS: baseOptions.useTLS
                });
            };
            /* harmony default export */ var default_strategy = getDefaultStrategy;
            // CONCATENATED MODULE: ./src/runtimes/web/transports/transport_connection_initializer.ts
            /* harmony default export */ var transport_connection_initializer = function() {
                var self = this;
                self.timeline.info(self.buildTimelineMessage({
                    transport: self.name + (self.options.useTLS ? "s" : "")
                }));
                if (self.hooks.isInitialized()) self.changeState("initialized");
                else if (self.hooks.file) {
                    self.changeState("initializing");
                    Dependencies.load(self.hooks.file, {
                        useTLS: self.options.useTLS
                    }, function(error, callback) {
                        if (self.hooks.isInitialized()) {
                            self.changeState("initialized");
                            callback(true);
                        } else {
                            if (error) self.onError(error);
                            self.onClose();
                            callback(false);
                        }
                    });
                } else self.onClose();
            };
            // CONCATENATED MODULE: ./src/runtimes/web/http/http_xdomain_request.ts
            var http_xdomain_request_hooks = {
                getRequest: function(socket) {
                    var xdr = new window.XDomainRequest();
                    xdr.ontimeout = function() {
                        socket.emit("error", new RequestTimedOut());
                        socket.close();
                    };
                    xdr.onerror = function(e) {
                        socket.emit("error", e);
                        socket.close();
                    };
                    xdr.onprogress = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                    };
                    xdr.onload = function() {
                        if (xdr.responseText && xdr.responseText.length > 0) socket.onChunk(200, xdr.responseText);
                        socket.emit("finished", 200);
                        socket.close();
                    };
                    return xdr;
                },
                abortRequest: function(xdr) {
                    xdr.ontimeout = xdr.onerror = xdr.onprogress = xdr.onload = null;
                    xdr.abort();
                }
            };
            /* harmony default export */ var http_xdomain_request = http_xdomain_request_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_request.ts
            const MAX_BUFFER_LENGTH = 262144;
            class http_request_HTTPRequest extends dispatcher_Dispatcher {
                constructor(hooks, method, url){
                    super();
                    this.hooks = hooks;
                    this.method = method;
                    this.url = url;
                }
                start(payload) {
                    this.position = 0;
                    this.xhr = this.hooks.getRequest(this);
                    this.unloader = ()=>{
                        this.close();
                    };
                    runtime.addUnloadListener(this.unloader);
                    this.xhr.open(this.method, this.url, true);
                    if (this.xhr.setRequestHeader) this.xhr.setRequestHeader("Content-Type", "application/json");
                    this.xhr.send(payload);
                }
                close() {
                    if (this.unloader) {
                        runtime.removeUnloadListener(this.unloader);
                        this.unloader = null;
                    }
                    if (this.xhr) {
                        this.hooks.abortRequest(this.xhr);
                        this.xhr = null;
                    }
                }
                onChunk(status, data) {
                    while(true){
                        var chunk = this.advanceBuffer(data);
                        if (chunk) this.emit("chunk", {
                            status: status,
                            data: chunk
                        });
                        else break;
                    }
                    if (this.isBufferTooLong(data)) this.emit("buffer_too_long");
                }
                advanceBuffer(buffer) {
                    var unreadData = buffer.slice(this.position);
                    var endOfLinePosition = unreadData.indexOf("\n");
                    if (endOfLinePosition !== -1) {
                        this.position += endOfLinePosition + 1;
                        return unreadData.slice(0, endOfLinePosition);
                    } else return null;
                }
                isBufferTooLong(buffer) {
                    return this.position === buffer.length && buffer.length > MAX_BUFFER_LENGTH;
                }
            }
            // CONCATENATED MODULE: ./src/core/http/state.ts
            var State;
            (function(State) {
                State[State["CONNECTING"] = 0] = "CONNECTING";
                State[State["OPEN"] = 1] = "OPEN";
                State[State["CLOSED"] = 3] = "CLOSED";
            })(State || (State = {}));
            /* harmony default export */ var state = State;
            // CONCATENATED MODULE: ./src/core/http/http_socket.ts
            var autoIncrement = 1;
            class http_socket_HTTPSocket {
                constructor(hooks, url){
                    this.hooks = hooks;
                    this.session = randomNumber(1000) + "/" + randomString(8);
                    this.location = getLocation(url);
                    this.readyState = state.CONNECTING;
                    this.openStream();
                }
                send(payload) {
                    return this.sendRaw(JSON.stringify([
                        payload
                    ]));
                }
                ping() {
                    this.hooks.sendHeartbeat(this);
                }
                close(code, reason) {
                    this.onClose(code, reason, true);
                }
                sendRaw(payload) {
                    if (this.readyState === state.OPEN) try {
                        runtime.createSocketRequest("POST", getUniqueURL(getSendURL(this.location, this.session))).start(payload);
                        return true;
                    } catch (e) {
                        return false;
                    }
                    else return false;
                }
                reconnect() {
                    this.closeStream();
                    this.openStream();
                }
                onClose(code, reason, wasClean) {
                    this.closeStream();
                    this.readyState = state.CLOSED;
                    if (this.onclose) this.onclose({
                        code: code,
                        reason: reason,
                        wasClean: wasClean
                    });
                }
                onChunk(chunk) {
                    if (chunk.status !== 200) return;
                    if (this.readyState === state.OPEN) this.onActivity();
                    var payload;
                    var type = chunk.data.slice(0, 1);
                    switch(type){
                        case "o":
                            payload = JSON.parse(chunk.data.slice(1) || "{}");
                            this.onOpen(payload);
                            break;
                        case "a":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            for(var i = 0; i < payload.length; i++)this.onEvent(payload[i]);
                            break;
                        case "m":
                            payload = JSON.parse(chunk.data.slice(1) || "null");
                            this.onEvent(payload);
                            break;
                        case "h":
                            this.hooks.onHeartbeat(this);
                            break;
                        case "c":
                            payload = JSON.parse(chunk.data.slice(1) || "[]");
                            this.onClose(payload[0], payload[1], true);
                            break;
                    }
                }
                onOpen(options) {
                    if (this.readyState === state.CONNECTING) {
                        if (options && options.hostname) this.location.base = replaceHost(this.location.base, options.hostname);
                        this.readyState = state.OPEN;
                        if (this.onopen) this.onopen();
                    } else this.onClose(1006, "Server lost session", true);
                }
                onEvent(event) {
                    if (this.readyState === state.OPEN && this.onmessage) this.onmessage({
                        data: event
                    });
                }
                onActivity() {
                    if (this.onactivity) this.onactivity();
                }
                onError(error) {
                    if (this.onerror) this.onerror(error);
                }
                openStream() {
                    this.stream = runtime.createSocketRequest("POST", getUniqueURL(this.hooks.getReceiveURL(this.location, this.session)));
                    this.stream.bind("chunk", (chunk)=>{
                        this.onChunk(chunk);
                    });
                    this.stream.bind("finished", (status)=>{
                        this.hooks.onFinished(this, status);
                    });
                    this.stream.bind("buffer_too_long", ()=>{
                        this.reconnect();
                    });
                    try {
                        this.stream.start();
                    } catch (error) {
                        util.defer(()=>{
                            this.onError(error);
                            this.onClose(1006, "Could not start streaming", false);
                        });
                    }
                }
                closeStream() {
                    if (this.stream) {
                        this.stream.unbind_all();
                        this.stream.close();
                        this.stream = null;
                    }
                }
            }
            function getLocation(url) {
                var parts = /([^\?]*)\/*(\??.*)/.exec(url);
                return {
                    base: parts[1],
                    queryString: parts[2]
                };
            }
            function getSendURL(url, session) {
                return url.base + "/" + session + "/xhr_send";
            }
            function getUniqueURL(url) {
                var separator = url.indexOf("?") === -1 ? "?" : "&";
                return url + separator + "t=" + +new Date() + "&n=" + autoIncrement++;
            }
            function replaceHost(url, hostname) {
                var urlParts = /(https?:\/\/)([^\/:]+)((\/|:)?.*)/.exec(url);
                return urlParts[1] + hostname + urlParts[3];
            }
            function randomNumber(max) {
                return runtime.randomInt(max);
            }
            function randomString(length) {
                var result = [];
                for(var i = 0; i < length; i++)result.push(randomNumber(32).toString(32));
                return result.join("");
            }
            /* harmony default export */ var http_socket = http_socket_HTTPSocket;
            // CONCATENATED MODULE: ./src/core/http/http_streaming_socket.ts
            var http_streaming_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr_streaming" + url.queryString;
                },
                onHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_streaming_socket = http_streaming_socket_hooks;
            // CONCATENATED MODULE: ./src/core/http/http_polling_socket.ts
            var http_polling_socket_hooks = {
                getReceiveURL: function(url, session) {
                    return url.base + "/" + session + "/xhr" + url.queryString;
                },
                onHeartbeat: function() {},
                sendHeartbeat: function(socket) {
                    socket.sendRaw("[]");
                },
                onFinished: function(socket, status) {
                    if (status === 200) socket.reconnect();
                    else socket.onClose(1006, "Connection interrupted (" + status + ")", false);
                }
            };
            /* harmony default export */ var http_polling_socket = http_polling_socket_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http_xhr_request.ts
            var http_xhr_request_hooks = {
                getRequest: function(socket) {
                    var Constructor = runtime.getXHRAPI();
                    var xhr = new Constructor();
                    xhr.onreadystatechange = xhr.onprogress = function() {
                        switch(xhr.readyState){
                            case 3:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                break;
                            case 4:
                                if (xhr.responseText && xhr.responseText.length > 0) socket.onChunk(xhr.status, xhr.responseText);
                                socket.emit("finished", xhr.status);
                                socket.close();
                                break;
                        }
                    };
                    return xhr;
                },
                abortRequest: function(xhr) {
                    xhr.onreadystatechange = null;
                    xhr.abort();
                }
            };
            /* harmony default export */ var http_xhr_request = http_xhr_request_hooks;
            // CONCATENATED MODULE: ./src/runtimes/isomorphic/http/http.ts
            var HTTP = {
                createStreamingSocket (url) {
                    return this.createSocket(http_streaming_socket, url);
                },
                createPollingSocket (url) {
                    return this.createSocket(http_polling_socket, url);
                },
                createSocket (hooks, url) {
                    return new http_socket(hooks, url);
                },
                createXHR (method, url) {
                    return this.createRequest(http_xhr_request, method, url);
                },
                createRequest (hooks, method, url) {
                    return new http_request_HTTPRequest(hooks, method, url);
                }
            };
            /* harmony default export */ var http_http = HTTP;
            // CONCATENATED MODULE: ./src/runtimes/web/http/http.ts
            http_http.createXDR = function(method, url) {
                return this.createRequest(http_xdomain_request, method, url);
            };
            /* harmony default export */ var web_http_http = http_http;
            // CONCATENATED MODULE: ./src/runtimes/web/runtime.ts
            var Runtime = {
                nextAuthCallbackID: 1,
                auth_callbacks: {},
                ScriptReceivers: ScriptReceivers,
                DependenciesReceivers: DependenciesReceivers,
                getDefaultStrategy: default_strategy,
                Transports: transports_transports,
                transportConnectionInitializer: transport_connection_initializer,
                HTTPFactory: web_http_http,
                TimelineTransport: jsonp_timeline,
                getXHRAPI () {
                    return window.XMLHttpRequest;
                },
                getWebSocketAPI () {
                    return window.WebSocket || window.MozWebSocket;
                },
                setup (PusherClass) {
                    window.Pusher = PusherClass;
                    var initializeOnDocumentBody = ()=>{
                        this.onDocumentBody(PusherClass.ready);
                    };
                    if (!window.JSON) Dependencies.load("json2", {}, initializeOnDocumentBody);
                    else initializeOnDocumentBody();
                },
                getDocument () {
                    return document;
                },
                getProtocol () {
                    return this.getDocument().location.protocol;
                },
                getAuthorizers () {
                    return {
                        ajax: xhr_auth,
                        jsonp: jsonp_auth
                    };
                },
                onDocumentBody (callback) {
                    if (document.body) callback();
                    else setTimeout(()=>{
                        this.onDocumentBody(callback);
                    }, 0);
                },
                createJSONPRequest (url, data) {
                    return new jsonp_request_JSONPRequest(url, data);
                },
                createScriptRequest (src) {
                    return new ScriptRequest(src);
                },
                getLocalStorage () {
                    try {
                        return window.localStorage;
                    } catch (e) {
                        return undefined;
                    }
                },
                createXHR () {
                    if (this.getXHRAPI()) return this.createXMLHttpRequest();
                    else return this.createMicrosoftXHR();
                },
                createXMLHttpRequest () {
                    var Constructor = this.getXHRAPI();
                    return new Constructor();
                },
                createMicrosoftXHR () {
                    return new ActiveXObject("Microsoft.XMLHTTP");
                },
                getNetwork () {
                    return net_info_Network;
                },
                createWebSocket (url) {
                    var Constructor = this.getWebSocketAPI();
                    return new Constructor(url);
                },
                createSocketRequest (method, url) {
                    if (this.isXHRSupported()) return this.HTTPFactory.createXHR(method, url);
                    else if (this.isXDRSupported(url.indexOf("https:") === 0)) return this.HTTPFactory.createXDR(method, url);
                    else throw "Cross-origin HTTP requests are not supported";
                },
                isXHRSupported () {
                    var Constructor = this.getXHRAPI();
                    return Boolean(Constructor) && new Constructor().withCredentials !== undefined;
                },
                isXDRSupported (useTLS) {
                    var protocol = useTLS ? "https:" : "http:";
                    var documentProtocol = this.getProtocol();
                    return Boolean(window["XDomainRequest"]) && documentProtocol === protocol;
                },
                addUnloadListener (listener) {
                    if (window.addEventListener !== undefined) window.addEventListener("unload", listener, false);
                    else if (window.attachEvent !== undefined) window.attachEvent("onunload", listener);
                },
                removeUnloadListener (listener) {
                    if (window.addEventListener !== undefined) window.removeEventListener("unload", listener, false);
                    else if (window.detachEvent !== undefined) window.detachEvent("onunload", listener);
                },
                randomInt (max) {
                    const random = function() {
                        const crypto = window.crypto || window["msCrypto"];
                        const random = crypto.getRandomValues(new Uint32Array(1))[0];
                        return random / Math.pow(2, 32);
                    };
                    return Math.floor(random() * max);
                }
            };
            /* harmony default export */ var runtime = Runtime;
            // CONCATENATED MODULE: ./src/core/timeline/level.ts
            var TimelineLevel;
            (function(TimelineLevel) {
                TimelineLevel[TimelineLevel["ERROR"] = 3] = "ERROR";
                TimelineLevel[TimelineLevel["INFO"] = 6] = "INFO";
                TimelineLevel[TimelineLevel["DEBUG"] = 7] = "DEBUG";
            })(TimelineLevel || (TimelineLevel = {}));
            /* harmony default export */ var timeline_level = TimelineLevel;
            // CONCATENATED MODULE: ./src/core/timeline/timeline.ts
            class timeline_Timeline {
                constructor(key, session, options){
                    this.key = key;
                    this.session = session;
                    this.events = [];
                    this.options = options || {};
                    this.sent = 0;
                    this.uniqueID = 0;
                }
                log(level, event) {
                    if (level <= this.options.level) {
                        this.events.push(extend({}, event, {
                            timestamp: util.now()
                        }));
                        if (this.options.limit && this.events.length > this.options.limit) this.events.shift();
                    }
                }
                error(event) {
                    this.log(timeline_level.ERROR, event);
                }
                info(event) {
                    this.log(timeline_level.INFO, event);
                }
                debug(event) {
                    this.log(timeline_level.DEBUG, event);
                }
                isEmpty() {
                    return this.events.length === 0;
                }
                send(sendfn, callback) {
                    var data = extend({
                        session: this.session,
                        bundle: this.sent + 1,
                        key: this.key,
                        lib: "js",
                        version: this.options.version,
                        cluster: this.options.cluster,
                        features: this.options.features,
                        timeline: this.events
                    }, this.options.params);
                    this.events = [];
                    sendfn(data, (error, result)=>{
                        if (!error) this.sent++;
                        if (callback) callback(error, result);
                    });
                    return true;
                }
                generateUniqueID() {
                    this.uniqueID++;
                    return this.uniqueID;
                }
            }
            // CONCATENATED MODULE: ./src/core/strategies/transport_strategy.ts
            class transport_strategy_TransportStrategy {
                constructor(name, priority, transport, options){
                    this.name = name;
                    this.priority = priority;
                    this.transport = transport;
                    this.options = options || {};
                }
                isSupported() {
                    return this.transport.isSupported({
                        useTLS: this.options.useTLS
                    });
                }
                connect(minPriority, callback) {
                    if (!this.isSupported()) return failAttempt(new UnsupportedStrategy(), callback);
                    else if (this.priority < minPriority) return failAttempt(new TransportPriorityTooLow(), callback);
                    var connected = false;
                    var transport = this.transport.createConnection(this.name, this.priority, this.options.key, this.options);
                    var handshake = null;
                    var onInitialized = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.connect();
                    };
                    var onOpen = function() {
                        handshake = factory.createHandshake(transport, function(result) {
                            connected = true;
                            unbindListeners();
                            callback(null, result);
                        });
                    };
                    var onError = function(error) {
                        unbindListeners();
                        callback(error);
                    };
                    var onClosed = function() {
                        unbindListeners();
                        var serializedTransport;
                        serializedTransport = safeJSONStringify(transport);
                        callback(new TransportClosed(serializedTransport));
                    };
                    var unbindListeners = function() {
                        transport.unbind("initialized", onInitialized);
                        transport.unbind("open", onOpen);
                        transport.unbind("error", onError);
                        transport.unbind("closed", onClosed);
                    };
                    transport.bind("initialized", onInitialized);
                    transport.bind("open", onOpen);
                    transport.bind("error", onError);
                    transport.bind("closed", onClosed);
                    transport.initialize();
                    return {
                        abort: ()=>{
                            if (connected) return;
                            unbindListeners();
                            if (handshake) handshake.close();
                            else transport.close();
                        },
                        forceMinPriority: (p)=>{
                            if (connected) return;
                            if (this.priority < p) {
                                if (handshake) handshake.close();
                                else transport.close();
                            }
                        }
                    };
                }
            }
            function failAttempt(error, callback) {
                util.defer(function() {
                    callback(error);
                });
                return {
                    abort: function() {},
                    forceMinPriority: function() {}
                };
            }
            // CONCATENATED MODULE: ./src/core/strategies/strategy_builder.ts
            const { Transports: strategy_builder_Transports } = runtime;
            var strategy_builder_defineTransport = function(config, name, type, priority, options, manager) {
                var transportClass = strategy_builder_Transports[type];
                if (!transportClass) throw new UnsupportedTransport(type);
                var enabled = (!config.enabledTransports || arrayIndexOf(config.enabledTransports, name) !== -1) && (!config.disabledTransports || arrayIndexOf(config.disabledTransports, name) === -1);
                var transport;
                if (enabled) {
                    options = Object.assign({
                        ignoreNullOrigin: config.ignoreNullOrigin
                    }, options);
                    transport = new transport_strategy_TransportStrategy(name, priority, manager ? manager.getAssistant(transportClass) : transportClass, options);
                } else transport = strategy_builder_UnsupportedStrategy;
                return transport;
            };
            var strategy_builder_UnsupportedStrategy = {
                isSupported: function() {
                    return false;
                },
                connect: function(_, callback) {
                    var deferred = util.defer(function() {
                        callback(new UnsupportedStrategy());
                    });
                    return {
                        abort: function() {
                            deferred.ensureAborted();
                        },
                        forceMinPriority: function() {}
                    };
                }
            };
            // CONCATENATED MODULE: ./src/core/options.ts
            function validateOptions(options) {
                if (options == null) throw "You must pass an options object";
                if (options.cluster == null) throw "Options object must provide a cluster";
                if ("disableStats" in options) logger.warn("The disableStats option is deprecated in favor of enableStats");
            }
            // CONCATENATED MODULE: ./src/core/auth/user_authenticator.ts
            const composeChannelQuery = (params, authOptions)=>{
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    let dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            const UserAuthenticator = (authOptions)=>{
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw `'${authOptions.transport}' is not a recognized auth transport`;
                return (params, callback)=>{
                    const query = composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.UserAuthentication, callback);
                };
            };
            /* harmony default export */ var user_authenticator = UserAuthenticator;
            // CONCATENATED MODULE: ./src/core/auth/channel_authorizer.ts
            const channel_authorizer_composeChannelQuery = (params, authOptions)=>{
                var query = "socket_id=" + encodeURIComponent(params.socketId);
                query += "&channel_name=" + encodeURIComponent(params.channelName);
                for(var key in authOptions.params)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(authOptions.params[key]);
                if (authOptions.paramsProvider != null) {
                    let dynamicParams = authOptions.paramsProvider();
                    for(var key in dynamicParams)query += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dynamicParams[key]);
                }
                return query;
            };
            const ChannelAuthorizer = (authOptions)=>{
                if (typeof runtime.getAuthorizers()[authOptions.transport] === "undefined") throw `'${authOptions.transport}' is not a recognized auth transport`;
                return (params, callback)=>{
                    const query = channel_authorizer_composeChannelQuery(params, authOptions);
                    runtime.getAuthorizers()[authOptions.transport](runtime, query, authOptions, AuthRequestType.ChannelAuthorization, callback);
                };
            };
            /* harmony default export */ var channel_authorizer = ChannelAuthorizer;
            // CONCATENATED MODULE: ./src/core/auth/deprecated_channel_authorizer.ts
            const ChannelAuthorizerProxy = (pusher, authOptions, channelAuthorizerGenerator)=>{
                const deprecatedAuthorizerOptions = {
                    authTransport: authOptions.transport,
                    authEndpoint: authOptions.endpoint,
                    auth: {
                        params: authOptions.params,
                        headers: authOptions.headers
                    }
                };
                return (params, callback)=>{
                    const channel = pusher.channel(params.channelName);
                    const channelAuthorizer = channelAuthorizerGenerator(channel, deprecatedAuthorizerOptions);
                    channelAuthorizer.authorize(params.socketId, callback);
                };
            };
            // CONCATENATED MODULE: ./src/core/config.ts
            function getConfig(opts, pusher) {
                let config = {
                    activityTimeout: opts.activityTimeout || defaults.activityTimeout,
                    cluster: opts.cluster,
                    httpPath: opts.httpPath || defaults.httpPath,
                    httpPort: opts.httpPort || defaults.httpPort,
                    httpsPort: opts.httpsPort || defaults.httpsPort,
                    pongTimeout: opts.pongTimeout || defaults.pongTimeout,
                    statsHost: opts.statsHost || defaults.stats_host,
                    unavailableTimeout: opts.unavailableTimeout || defaults.unavailableTimeout,
                    wsPath: opts.wsPath || defaults.wsPath,
                    wsPort: opts.wsPort || defaults.wsPort,
                    wssPort: opts.wssPort || defaults.wssPort,
                    enableStats: getEnableStatsConfig(opts),
                    httpHost: getHttpHost(opts),
                    useTLS: shouldUseTLS(opts),
                    wsHost: getWebsocketHost(opts),
                    userAuthenticator: buildUserAuthenticator(opts),
                    channelAuthorizer: buildChannelAuthorizer(opts, pusher)
                };
                if ("disabledTransports" in opts) config.disabledTransports = opts.disabledTransports;
                if ("enabledTransports" in opts) config.enabledTransports = opts.enabledTransports;
                if ("ignoreNullOrigin" in opts) config.ignoreNullOrigin = opts.ignoreNullOrigin;
                if ("timelineParams" in opts) config.timelineParams = opts.timelineParams;
                if ("nacl" in opts) config.nacl = opts.nacl;
                return config;
            }
            function getHttpHost(opts) {
                if (opts.httpHost) return opts.httpHost;
                if (opts.cluster) return `sockjs-${opts.cluster}.pusher.com`;
                return defaults.httpHost;
            }
            function getWebsocketHost(opts) {
                if (opts.wsHost) return opts.wsHost;
                return getWebsocketHostFromCluster(opts.cluster);
            }
            function getWebsocketHostFromCluster(cluster) {
                return `ws-${cluster}.pusher.com`;
            }
            function shouldUseTLS(opts) {
                if (runtime.getProtocol() === "https:") return true;
                else if (opts.forceTLS === false) return false;
                return true;
            }
            function getEnableStatsConfig(opts) {
                if ("enableStats" in opts) return opts.enableStats;
                if ("disableStats" in opts) return !opts.disableStats;
                return false;
            }
            function buildUserAuthenticator(opts) {
                const userAuthentication = Object.assign(Object.assign({}, defaults.userAuthentication), opts.userAuthentication);
                if ("customHandler" in userAuthentication && userAuthentication["customHandler"] != null) return userAuthentication["customHandler"];
                return user_authenticator(userAuthentication);
            }
            function buildChannelAuth(opts, pusher) {
                let channelAuthorization;
                if ("channelAuthorization" in opts) channelAuthorization = Object.assign(Object.assign({}, defaults.channelAuthorization), opts.channelAuthorization);
                else {
                    channelAuthorization = {
                        transport: opts.authTransport || defaults.authTransport,
                        endpoint: opts.authEndpoint || defaults.authEndpoint
                    };
                    if ("auth" in opts) {
                        if ("params" in opts.auth) channelAuthorization.params = opts.auth.params;
                        if ("headers" in opts.auth) channelAuthorization.headers = opts.auth.headers;
                    }
                    if ("authorizer" in opts) channelAuthorization.customHandler = ChannelAuthorizerProxy(pusher, channelAuthorization, opts.authorizer);
                }
                return channelAuthorization;
            }
            function buildChannelAuthorizer(opts, pusher) {
                const channelAuthorization = buildChannelAuth(opts, pusher);
                if ("customHandler" in channelAuthorization && channelAuthorization["customHandler"] != null) return channelAuthorization["customHandler"];
                return channel_authorizer(channelAuthorization);
            }
            // CONCATENATED MODULE: ./src/core/watchlist.ts
            class watchlist_WatchlistFacade extends dispatcher_Dispatcher {
                constructor(pusher){
                    super(function(eventName, data) {
                        logger.debug(`No callbacks on watchlist events for ${eventName}`);
                    });
                    this.pusher = pusher;
                    this.bindWatchlistInternalEvent();
                }
                handleEvent(pusherEvent) {
                    pusherEvent.data.events.forEach((watchlistEvent)=>{
                        this.emit(watchlistEvent.name, watchlistEvent);
                    });
                }
                bindWatchlistInternalEvent() {
                    this.pusher.connection.bind("message", (pusherEvent)=>{
                        var eventName = pusherEvent.event;
                        if (eventName === "pusher_internal:watchlist_events") this.handleEvent(pusherEvent);
                    });
                }
            }
            // CONCATENATED MODULE: ./src/core/utils/flat_promise.ts
            function flatPromise() {
                let resolve, reject;
                const promise = new Promise((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                return {
                    promise: promise,
                    resolve: resolve,
                    reject: reject
                };
            }
            /* harmony default export */ var flat_promise = flatPromise;
            // CONCATENATED MODULE: ./src/core/user.ts
            class user_UserFacade extends dispatcher_Dispatcher {
                constructor(pusher){
                    super(function(eventName, data) {
                        logger.debug("No callbacks on user for " + eventName);
                    });
                    this.signin_requested = false;
                    this.user_data = null;
                    this.serverToUserChannel = null;
                    this.signinDonePromise = null;
                    this._signinDoneResolve = null;
                    this._onAuthorize = (err, authData)=>{
                        if (err) {
                            logger.warn(`Error during signin: ${err}`);
                            this._cleanup();
                            return;
                        }
                        this.pusher.send_event("pusher:signin", {
                            auth: authData.auth,
                            user_data: authData.user_data
                        });
                    };
                    this.pusher = pusher;
                    this.pusher.connection.bind("state_change", ({ previous: previous, current: current })=>{
                        if (previous !== "connected" && current === "connected") this._signin();
                        if (previous === "connected" && current !== "connected") {
                            this._cleanup();
                            this._newSigninPromiseIfNeeded();
                        }
                    });
                    this.watchlist = new watchlist_WatchlistFacade(pusher);
                    this.pusher.connection.bind("message", (event)=>{
                        var eventName = event.event;
                        if (eventName === "pusher:signin_success") this._onSigninSuccess(event.data);
                        if (this.serverToUserChannel && this.serverToUserChannel.name === event.channel) this.serverToUserChannel.handleEvent(event);
                    });
                }
                signin() {
                    if (this.signin_requested) return;
                    this.signin_requested = true;
                    this._signin();
                }
                _signin() {
                    if (!this.signin_requested) return;
                    this._newSigninPromiseIfNeeded();
                    if (this.pusher.connection.state !== "connected") return;
                    this.pusher.config.userAuthenticator({
                        socketId: this.pusher.connection.socket_id
                    }, this._onAuthorize);
                }
                _onSigninSuccess(data) {
                    try {
                        this.user_data = JSON.parse(data.user_data);
                    } catch (e) {
                        logger.error(`Failed parsing user data after signin: ${data.user_data}`);
                        this._cleanup();
                        return;
                    }
                    if (typeof this.user_data.id !== "string" || this.user_data.id === "") {
                        logger.error(`user_data doesn't contain an id. user_data: ${this.user_data}`);
                        this._cleanup();
                        return;
                    }
                    this._signinDoneResolve();
                    this._subscribeChannels();
                }
                _subscribeChannels() {
                    const ensure_subscribed = (channel)=>{
                        if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                        else if (!channel.subscriptionPending && this.pusher.connection.state === "connected") channel.subscribe();
                    };
                    this.serverToUserChannel = new channel_Channel(`#server-to-user-${this.user_data.id}`, this.pusher);
                    this.serverToUserChannel.bind_global((eventName, data)=>{
                        if (eventName.indexOf("pusher_internal:") === 0 || eventName.indexOf("pusher:") === 0) return;
                        this.emit(eventName, data);
                    });
                    ensure_subscribed(this.serverToUserChannel);
                }
                _cleanup() {
                    this.user_data = null;
                    if (this.serverToUserChannel) {
                        this.serverToUserChannel.unbind_all();
                        this.serverToUserChannel.disconnect();
                        this.serverToUserChannel = null;
                    }
                    if (this.signin_requested) this._signinDoneResolve();
                }
                _newSigninPromiseIfNeeded() {
                    if (!this.signin_requested) return;
                    if (this.signinDonePromise && !this.signinDonePromise.done) return;
                    const { promise: promise, resolve: resolve, reject: _ } = flat_promise();
                    promise.done = false;
                    const setDone = ()=>{
                        promise.done = true;
                    };
                    promise.then(setDone).catch(setDone);
                    this.signinDonePromise = promise;
                    this._signinDoneResolve = resolve;
                }
            }
            // CONCATENATED MODULE: ./src/core/pusher.ts
            class pusher_Pusher {
                static ready() {
                    pusher_Pusher.isReady = true;
                    for(var i = 0, l = pusher_Pusher.instances.length; i < l; i++)pusher_Pusher.instances[i].connect();
                }
                static getClientFeatures() {
                    return keys(filterObject({
                        ws: runtime.Transports.ws
                    }, function(t) {
                        return t.isSupported({});
                    }));
                }
                constructor(app_key, options){
                    checkAppKey(app_key);
                    validateOptions(options);
                    this.key = app_key;
                    this.config = getConfig(options, this);
                    this.channels = factory.createChannels();
                    this.global_emitter = new dispatcher_Dispatcher();
                    this.sessionID = runtime.randomInt(1000000000);
                    this.timeline = new timeline_Timeline(this.key, this.sessionID, {
                        cluster: this.config.cluster,
                        features: pusher_Pusher.getClientFeatures(),
                        params: this.config.timelineParams || {},
                        limit: 50,
                        level: timeline_level.INFO,
                        version: defaults.VERSION
                    });
                    if (this.config.enableStats) this.timelineSender = factory.createTimelineSender(this.timeline, {
                        host: this.config.statsHost,
                        path: "/timeline/v2/" + runtime.TimelineTransport.name
                    });
                    var getStrategy = (options)=>{
                        return runtime.getDefaultStrategy(this.config, options, strategy_builder_defineTransport);
                    };
                    this.connection = factory.createConnectionManager(this.key, {
                        getStrategy: getStrategy,
                        timeline: this.timeline,
                        activityTimeout: this.config.activityTimeout,
                        pongTimeout: this.config.pongTimeout,
                        unavailableTimeout: this.config.unavailableTimeout,
                        useTLS: Boolean(this.config.useTLS)
                    });
                    this.connection.bind("connected", ()=>{
                        this.subscribeAll();
                        if (this.timelineSender) this.timelineSender.send(this.connection.isUsingTLS());
                    });
                    this.connection.bind("message", (event)=>{
                        var eventName = event.event;
                        var internal = eventName.indexOf("pusher_internal:") === 0;
                        if (event.channel) {
                            var channel = this.channel(event.channel);
                            if (channel) channel.handleEvent(event);
                        }
                        if (!internal) this.global_emitter.emit(event.event, event.data);
                    });
                    this.connection.bind("connecting", ()=>{
                        this.channels.disconnect();
                    });
                    this.connection.bind("disconnected", ()=>{
                        this.channels.disconnect();
                    });
                    this.connection.bind("error", (err)=>{
                        logger.warn(err);
                    });
                    pusher_Pusher.instances.push(this);
                    this.timeline.info({
                        instances: pusher_Pusher.instances.length
                    });
                    this.user = new user_UserFacade(this);
                    if (pusher_Pusher.isReady) this.connect();
                }
                channel(name) {
                    return this.channels.find(name);
                }
                allChannels() {
                    return this.channels.all();
                }
                connect() {
                    this.connection.connect();
                    if (this.timelineSender) {
                        if (!this.timelineSenderTimer) {
                            var usingTLS = this.connection.isUsingTLS();
                            var timelineSender = this.timelineSender;
                            this.timelineSenderTimer = new timers_PeriodicTimer(60000, function() {
                                timelineSender.send(usingTLS);
                            });
                        }
                    }
                }
                disconnect() {
                    this.connection.disconnect();
                    if (this.timelineSenderTimer) {
                        this.timelineSenderTimer.ensureAborted();
                        this.timelineSenderTimer = null;
                    }
                }
                bind(event_name, callback, context) {
                    this.global_emitter.bind(event_name, callback, context);
                    return this;
                }
                unbind(event_name, callback, context) {
                    this.global_emitter.unbind(event_name, callback, context);
                    return this;
                }
                bind_global(callback) {
                    this.global_emitter.bind_global(callback);
                    return this;
                }
                unbind_global(callback) {
                    this.global_emitter.unbind_global(callback);
                    return this;
                }
                unbind_all(callback) {
                    this.global_emitter.unbind_all();
                    return this;
                }
                subscribeAll() {
                    var channelName;
                    for(channelName in this.channels.channels)if (this.channels.channels.hasOwnProperty(channelName)) this.subscribe(channelName);
                }
                subscribe(channel_name) {
                    var channel = this.channels.add(channel_name, this);
                    if (channel.subscriptionPending && channel.subscriptionCancelled) channel.reinstateSubscription();
                    else if (!channel.subscriptionPending && this.connection.state === "connected") channel.subscribe();
                    return channel;
                }
                unsubscribe(channel_name) {
                    var channel = this.channels.find(channel_name);
                    if (channel && channel.subscriptionPending) channel.cancelSubscription();
                    else {
                        channel = this.channels.remove(channel_name);
                        if (channel && channel.subscribed) channel.unsubscribe();
                    }
                }
                send_event(event_name, data, channel) {
                    return this.connection.send_event(event_name, data, channel);
                }
                shouldUseTLS() {
                    return this.config.useTLS;
                }
                signin() {
                    this.user.signin();
                }
            }
            pusher_Pusher.instances = [];
            pusher_Pusher.isReady = false;
            pusher_Pusher.logToConsole = false;
            pusher_Pusher.Runtime = runtime;
            pusher_Pusher.ScriptReceivers = runtime.ScriptReceivers;
            pusher_Pusher.DependenciesReceivers = runtime.DependenciesReceivers;
            pusher_Pusher.auth_callbacks = runtime.auth_callbacks;
            /* harmony default export */ var core_pusher = __webpack_exports__["default"] = pusher_Pusher;
            function checkAppKey(key) {
                if (key === null || key === undefined) throw "You must pass your app key when you instantiate Pusher.";
            }
            runtime.setup(pusher_Pusher);
        /***/ }
    ]);
});



var $f9aoP = parcelRequire("f9aoP");

var $aTRs6 = parcelRequire("aTRs6");
const $1be2adfe4fbf6545$var$PUSHER_KEY = undefined;
const $1be2adfe4fbf6545$var$PUSHER_CLUSTER = undefined;
const $1be2adfe4fbf6545$var$PUSHER_USERAUTH_ENDPOINT = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? "/.proxy/api/pusher/userAuth" : "https://api.ariseworlds.com/pusher/userAuth";
const $1be2adfe4fbf6545$var$PUSHER_CHANNELAUTH_ENDPOINT = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? "/.proxy/api/pusher/channelAuth" : "https://api.ariseworlds.com/pusher/channelAuth";
// Custom endpoints when using Discord Activity
const $1be2adfe4fbf6545$var$ADDITIONAL_CONFIG = (0, $aTRs6.IS_DISCORD_ACTIVITY) ? {
    wsHost: window.location.host,
    wsPath: "/.proxy/pusher-ws",
    httpHost: window.location.host,
    httpPath: "/.proxy/pusher-http/pusher"
} : {};
class $1be2adfe4fbf6545$export$573489cd3cea23b5 {
    constructor(){
        this.subscribedChannels = {};
        this.pusher = new (0, (/*@__PURE__*/$parcel$interopDefault($46391e220d720c46$exports)))($1be2adfe4fbf6545$var$PUSHER_KEY, {
            ...$1be2adfe4fbf6545$var$ADDITIONAL_CONFIG,
            cluster: $1be2adfe4fbf6545$var$PUSHER_CLUSTER,
            userAuthentication: {
                endpoint: $1be2adfe4fbf6545$var$PUSHER_USERAUTH_ENDPOINT,
                transport: "ajax",
                params: {},
                headers: {
                    "X-Auth-Token": (0, $f9aoP.getAuthToken)()
                }
            },
            channelAuthorization: {
                endpoint: $1be2adfe4fbf6545$var$PUSHER_CHANNELAUTH_ENDPOINT,
                transport: "ajax",
                headers: {
                    "X-Auth-Token": (0, $f9aoP.getAuthToken)()
                }
            }
        });
    }
    static getInstance() {
        if (!this.instance) this.instance = new $1be2adfe4fbf6545$export$573489cd3cea23b5();
        return this.instance;
    }
    static subscribe(channelName) {
        if (!(0, $f9aoP.getAuthToken)()) return;
        const instance = this.getInstance();
        if (instance.subscribedChannels[channelName]) return instance.subscribedChannels[channelName];
        const p = instance.pusher;
        instance.subscribedChannels[channelName] = p.subscribe(channelName);
        return instance.subscribedChannels[channelName];
    }
    static unsubscribe(channelName) {
        if (!(0, $f9aoP.getAuthToken)()) return;
        const instance = this.getInstance();
        if (!instance.subscribedChannels[channelName]) return;
        const p = instance.pusher;
        p.unsubscribe(channelName);
        delete instance.subscribedChannels[channelName];
    }
}



var $baXkz = parcelRequire("baXkz");

var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");
const $e414871eb35bf480$var$pusherEventUpdateEvent = "client-event-update";
function $e414871eb35bf480$export$39bd6383ffe24524() {
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const channelName = `private-user-${currentUserProfile?.userID}`;
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const channelRef = (0, $8FY87.useRef)();
    (0, $8FY87.useEffect)(()=>{
        if (!currentUserProfile?.userID) return;
        function handleEventUpdate(data) {
            dispatch((0, $kyBxf.updateEventParticipant)(data));
        }
        channelRef.current = (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).subscribe(channelName);
        channelRef.current?.bind($e414871eb35bf480$var$pusherEventUpdateEvent, handleEventUpdate);
        return ()=>{
            channelRef.current?.unbind($e414871eb35bf480$var$pusherEventUpdateEvent, handleEventUpdate);
            (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).unsubscribe(channelName);
        };
    }, [
        channelName
    ]);
    return {
        channelRef: channelRef
    };
}



var $6lYLL = parcelRequire("6lYLL");

var $1bTT8 = parcelRequire("1bTT8");

var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");

var $4KKbJ = parcelRequire("4KKbJ");

var $8FY87 = parcelRequire("8FY87");


var $jJtwY = parcelRequire("jJtwY");

var $4KKbJ = parcelRequire("4KKbJ");

var $6lYLL = parcelRequire("6lYLL");

var $fL4mk = parcelRequire("fL4mk");


var $1URoE = parcelRequire("1URoE");

var $baXkz = parcelRequire("baXkz");
const $dbacf51e5486f7e0$var$loginpath = "/auth/landing";
function $dbacf51e5486f7e0$export$c39969323984c2e2() {
    const auth = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    (0, $8FY87.useEffect)(()=>{
        if (!auth.loggedIn) navigate($dbacf51e5486f7e0$var$loginpath);
    }, []);
}
function $dbacf51e5486f7e0$export$78b61f95a37eeb97({ loggedInRedirect: loggedInRedirect, loggedOutRedirect: loggedOutRedirect = $dbacf51e5486f7e0$var$loginpath } = {}) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    (0, $8FY87.useEffect)(()=>{
        dispatch((0, $jJtwY.initialAuthFlow)());
    }, []);
}
function $dbacf51e5486f7e0$export$1e4259488407aa44({ loggedInRedirect: loggedInRedirect, loggedOutRedirect: loggedOutRedirect = $dbacf51e5486f7e0$var$loginpath } = {}) {
    const { intialAuthCheckComplete: intialAuthCheckComplete, isInitialAuthCheckInProgress: isInitialAuthCheckInProgress, loggedIn: loggedIn, user: user, hasLoggedOut: hasLoggedOut } = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    const { currentUserProfileCheckComplete: currentUserProfileCheckComplete, currentUserProfileCheckInProgress: currentUserProfileCheckInProgress, currentUserProfile: currentUserProfile } = (0, $6lYLL.useAppSelector)((state)=>state.profile);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    (0, $8FY87.useEffect)(()=>{
        if (intialAuthCheckComplete || isInitialAuthCheckInProgress) return;
        dispatch((0, $jJtwY.initialAuthCheck)());
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!user || currentUserProfileCheckComplete || currentUserProfileCheckInProgress) return;
        dispatch((0, $4KKbJ.loadCurrentUserProfile)([
            user.id
        ]));
    }, [
        user
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!intialAuthCheckComplete) return;
        if (loggedIn) {
            if (!currentUserProfileCheckComplete) return;
            // Send to either edit profile page, edit display name page, or just log them in depending on their data
            if (isGuest) {
                if (loggedInRedirect) navigate(loggedInRedirect);
                return;
            }
            if ((0, $fL4mk.profileHasOnboarded)(currentUserProfile)) {
                if (user.hasSetUsername) {
                    if (loggedInRedirect) navigate(loggedInRedirect);
                    return;
                } else {
                    navigate("/edit-display-name");
                    return;
                }
            } else {
                navigate("/edit-profile");
                return;
            }
        } else // Not logged in
        if (hasLoggedOut) navigate(loggedOutRedirect);
        else // Arriving at site, and we could not or did not log you in automatically
        // Do nothing
        console.info("Logged out mode");
    }, [
        intialAuthCheckComplete,
        loggedIn,
        currentUserProfileCheckComplete,
        currentUserProfile
    ]);
    return {
        isInProgress: isInitialAuthCheckInProgress
    };
}
function $dbacf51e5486f7e0$export$23bbbc4533528f03() {
    const user = (0, $6lYLL.useAppSelector)((state)=>state.auth.user);
    return user;
}
function $dbacf51e5486f7e0$export$c9c1802ef9b13040() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    return ()=>{
        if (0, $1URoE.isInsidersInstance) window.location.href = (0, $1URoE.getInsidersRegisterUrl)();
        else dispatch((0, $baXkz.setAuthModalScreen)("signupLanding"));
    };
}
function $dbacf51e5486f7e0$export$932dac77da3ee9c3() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    return ()=>{
        if (0, $1URoE.isInsidersInstance) window.location.href = (0, $1URoE.getInsidersLoginUrl)();
        else dispatch((0, $baXkz.setAuthModalScreen)("login"));
    };
}



var $1bTT8 = parcelRequire("1bTT8");

var $fL4mk = parcelRequire("fL4mk");

var $kyBxf = parcelRequire("kyBxf");

var $baXkz = parcelRequire("baXkz");
const $661a4888e7a381a7$var$channelName = "private-profile-update";
const $661a4888e7a381a7$var$pusherMessageUpdateProfileEvent = "client-profile-update";
function $661a4888e7a381a7$export$cb7e5c1793b4318c() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const channelRef = (0, $8FY87.useRef)();
    const user = (0, $dbacf51e5486f7e0$export$23bbbc4533528f03)();
    (0, $8FY87.useEffect)(()=>{
        function handleUpdateProfile({ data: data }) {
            const profile = (0, $fL4mk.processProfileData)(data);
            dispatch((0, $kyBxf.updateFeedProfile)(profile));
            dispatch((0, $4KKbJ.updateProfile)(profile));
            dispatch((0, $baXkz.updateCurrentlyViewingProfileIfMatches)(profile));
        }
        channelRef.current = (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).subscribe($661a4888e7a381a7$var$channelName);
        channelRef.current?.bind($661a4888e7a381a7$var$pusherMessageUpdateProfileEvent, handleUpdateProfile);
        return ()=>{
            channelRef.current?.unbind($661a4888e7a381a7$var$pusherMessageUpdateProfileEvent, handleUpdateProfile);
            (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).unsubscribe($661a4888e7a381a7$var$channelName);
        };
    }, [
        user
    ]);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    (0, $8FY87.useEffect)(()=>{
        if (currentUserProfile) {
            const timeUntilUnbanned = (0, $1bTT8.msTimeDifferenceFromNow)(currentUserProfile.bannedUntil);
            if (currentUserProfile.bannedUntil && timeUntilUnbanned >= 0) {
                const timeout = setTimeout(()=>{
                    dispatch((0, $4KKbJ.updateProfile)({
                        ...currentUserProfile,
                        isBanned: false
                    }));
                }, timeUntilUnbanned);
                return ()=>clearTimeout(timeout);
            }
        }
    }, [
        currentUserProfile
    ]);
    return {
        channelRef: channelRef
    };
}



// Global is subscribed to at all times, rather than in a specific location
const $83e66c7ca3b599bc$var$channelName = "private-arise-global";
const $83e66c7ca3b599bc$var$pusherMessageUpdateLocationEvent = "client-location-update";
function $83e66c7ca3b599bc$export$94a30c606f8250e8() {
    const user = (0, $dbacf51e5486f7e0$export$23bbbc4533528f03)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const channelRef = (0, $8FY87.useRef)();
    (0, $8FY87.useEffect)(()=>{
        function handleLocationUpdate({ data: data }) {
            dispatch((0, $baXkz.updateLocation)(data));
        }
        channelRef.current = (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).subscribe($83e66c7ca3b599bc$var$channelName);
        channelRef.current?.bind($83e66c7ca3b599bc$var$pusherMessageUpdateLocationEvent, handleLocationUpdate);
        return ()=>{
            channelRef.current?.unbind($83e66c7ca3b599bc$var$pusherMessageUpdateLocationEvent, handleLocationUpdate);
            (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).unsubscribe($83e66c7ca3b599bc$var$channelName);
        };
    }, [
        user
    ]);
    return {
        channelRef: channelRef
    };
}
function $83e66c7ca3b599bc$var$setOpenAndCloseTimeLocationTimeouts() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const locations = (0, $6lYLL.useAppSelector)((state)=>state.app.locations);
    (0, $8FY87.useEffect)(()=>{
        let timeouts = [];
        if (locations) Object.values(locations).forEach((location)=>{
            // Locations
            const locationTimeUntilOpen = (0, $1bTT8.msTimeDifferenceFromNow)(location.opensTime);
            const locationTimeUntilClose = (0, $1bTT8.msTimeDifferenceFromNow)(location.closesTime);
            if (location.opensTime && locationTimeUntilOpen > 0 && locationTimeUntilOpen < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    // Re-request location data, as closed location response contains less information
                    // New location data will then get re-processed and have isOpen set as true
                    dispatch((0, $baXkz.loadLocations)());
                }, locationTimeUntilOpen);
                timeouts.push(timeout);
            }
            if (location.closesTime && locationTimeUntilClose > 0 && locationTimeUntilClose < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    dispatch((0, $baXkz.loadLocations)());
                }, locationTimeUntilClose);
                timeouts.push(timeout);
            }
            // Feeds
            const feedTimeUntilOpen = (0, $1bTT8.msTimeDifferenceFromNow)(location.feedOpensTime);
            const feedTimeUntilClose = (0, $1bTT8.msTimeDifferenceFromNow)(location.feedClosesTime);
            if (location.feedOpensTime && feedTimeUntilOpen > 0 && feedTimeUntilOpen < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    dispatch((0, $baXkz.reevaluateIfFeedsAreOpen)());
                }, feedTimeUntilOpen);
                timeouts.push(timeout);
            }
            if (location.feedClosesTime && feedTimeUntilClose > 0 && feedTimeUntilClose < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    dispatch((0, $baXkz.reevaluateIfFeedsAreOpen)());
                }, feedTimeUntilClose);
                timeouts.push(timeout);
            }
        });
        return ()=>{
            timeouts.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        locations
    ]);
}
function $83e66c7ca3b599bc$export$a8bda58cefcd19af() {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $i7H0N = parcelRequire("i7H0N");

var $cEIti = parcelRequire("cEIti");
function $2a59f39dad729c15$export$2e2bcd8739ae039() {
    const theme = (0, $cEIti.useTheme)();
    function initAnalytics() {
        (0, $i7H0N.init)(theme.customJSON.googleAnalyticsId, theme.customJSON.amplitudeKey);
    }
    (0, $8FY87.useEffect)(()=>{
        try {
            window["ariseInitAnalytics"] = initAnalytics;
            initAnalytics();
            // Listen for analytics consent changes
            window["cbsoptanon"]?.ot?.addOnConsentChangedHandler(initAnalytics);
        } catch  {}
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
}



var $2PPWI = parcelRequire("2PPWI");

var $cpVbU = parcelRequire("cpVbU");

var $8FY87 = parcelRequire("8FY87");
const $751064cf868cb340$var$fonts = {
    [(0, $cpVbU.ThemeIds).Titan]: [
        {
            family: "Inter",
            source: `url('/assets/themes/titan/typography/inter/Inter-Regular.ttf') format('truetype')`,
            descriptors: {
                weight: "400",
                style: "normal"
            }
        },
        {
            family: "Inter",
            source: `url('/assets/themes/titan/typography/inter/Inter-SemiBold.ttf') format('truetype')`,
            descriptors: {
                weight: "500",
                style: "normal"
            }
        },
        {
            family: "Inter",
            source: `url('/assets/themes/titan/typography/inter/Inter-Bold.ttf') format('truetype')`,
            descriptors: {
                weight: "bold",
                style: "normal"
            }
        },
        {
            family: "CheapSignage",
            source: `url('/assets/themes/titan/typography/cheapSignage/CheapSignage-Standard.ttf')`,
            descriptors: {
                weight: "400",
                style: "normal"
            }
        },
        {
            family: "Alexandria",
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Regular.ttf') format('truetype')`,
            descriptors: {
                weight: "300",
                style: "normal"
            }
        },
        {
            family: "Alexandria",
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Medium.ttf') format('truetype')`,
            descriptors: {
                weight: "400",
                style: "normal"
            }
        },
        {
            family: "Alexandria",
            source: `url('/assets/themes/titan/typography/alexandria/Alexandria-Bold.ttf') format('truetype')`,
            descriptors: {
                weight: "bold",
                style: "normal"
            }
        },
        {
            family: "Oswald",
            source: `url('/assets/themes/titan/typography/oswald/Oswald-Medium.ttf') format('truetype')`,
            descriptors: {
                weight: "500",
                style: "normal"
            }
        },
        {
            family: "Oswald",
            source: `url('/assets/themes/titan/typography/oswald/Oswald-SemiBold.ttf') format('truetype')`,
            descriptors: {
                weight: "600",
                style: "normal"
            }
        }
    ],
    [(0, $cpVbU.ThemeIds).Hyperion]: [
        {
            family: "HomePlanetBB",
            source: `url('/assets/themes/hyperion/typography/HomePlanetBB/HomePlanetBB-Bold.otf') format('opentype')`,
            descriptors: {
                weight: "500",
                style: "normal"
            }
        }
    ]
};
const $751064cf868cb340$var$globalFonts = [
    {
        family: "ChakraPetchTitle",
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: "bold",
            style: "normal"
        }
    },
    {
        family: "ChakraPetch",
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Light.ttf') format('truetype')`,
        descriptors: {
            weight: "300",
            style: "normal"
        }
    },
    {
        family: "ChakraPetch",
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: "normal",
            style: "normal"
        }
    },
    {
        family: "ChakraPetch",
        source: `url('/assets/global/typography/chakraPetch/ChakraPetch-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: "500",
            style: "normal"
        }
    },
    {
        family: "Inter",
        source: `url('/assets/global/typography/inter/Inter-Regular.ttf') format('truetype')`,
        descriptors: {
            weight: "400",
            style: "normal"
        }
    },
    {
        family: "Inter",
        source: `url('/assets/global/typography/inter/Inter-SemiBold.ttf') format('truetype')`,
        descriptors: {
            weight: "500",
            style: "normal"
        }
    },
    {
        family: "Inter",
        source: `url('/assets/global/typography/inter/Inter-Bold.ttf') format('truetype')`,
        descriptors: {
            weight: "bold",
            style: "normal"
        }
    }
];
function $751064cf868cb340$export$2e2bcd8739ae039() {
    const [ready, setReady] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        const fontlist = [
            ...$751064cf868cb340$var$fonts["brickhouse"] || [],
            ...$751064cf868cb340$var$globalFonts
        ];
        if (!fontlist) {
            console.error("No fonts found for instance");
            setReady(true);
            return;
        }
        const fontPromises = fontlist.map((font)=>{
            return new Promise((resolve)=>{
                const newFont = new FontFace(font.family, font.source, font.descriptors);
                newFont.load().then((loadedFont)=>{
                    document.fonts.add(loadedFont);
                    resolve();
                }).catch((error)=>{
                    console.error("Failed to load font", error);
                    resolve();
                });
            });
        });
        Promise.all(fontPromises).then(()=>{
            setReady(true);
        });
    }, []);
    return {
        ready: ready
    };
}



var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");

var $cEIti = parcelRequire("cEIti");

var $8FY87 = parcelRequire("8FY87");
function $73bd272a99e2a340$export$2e2bcd8739ae039() {
    const [themeLoaded, setThemeLoaded] = (0, $8FY87.useState)(false);
    const [imagesLoaded, setImagesLoaded] = (0, $8FY87.useState)(false);
    const [imageProgress, setImageProgress] = (0, $8FY87.useState)({
        loaded: 0,
        total: 0
    });
    const [error, setError] = (0, $8FY87.useState)(false);
    const theme = (0, $cEIti.useTheme)();
    const hasInitiatedLoad = (0, $8FY87.useRef)(false);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isInstanceLoading = (0, $6lYLL.useAppSelector)((state)=>state.app.isInstanceLoading);
    const instanceLoaded = (0, $6lYLL.useAppSelector)((state)=>state.app.instanceLoaded);
    async function loadImages(theme) {
        const images = [
            theme.files.logo,
            // theme.files.splash_bg,
            theme.files.inventory_backdrop,
            theme.files.instance_mark
        ];
        setImageProgress({
            loaded: 0,
            total: images.length
        });
        await Promise.all(images.map(async (url)=>{
            try {
                await $73bd272a99e2a340$var$loadImage(url);
            } catch (error) {
                setError(true);
            }
            setImageProgress((prev)=>({
                    loaded: prev.loaded + 1,
                    total: prev.total
                }));
        }));
        setImagesLoaded(true);
    }
    (0, $8FY87.useEffect)(()=>{
        // Only initiate loading if it hasn't been started yet and isn't already in progress
        if (!hasInitiatedLoad.current && !isInstanceLoading && !instanceLoaded) {
            hasInitiatedLoad.current = true;
            const universeId = "718b65bf-9225-48da-93f2-6a7255127896";
            dispatch((0, $baXkz.setInstanceLoadTimestamp)()); // Update timestamp before loading
            dispatch((0, $baXkz.loadInstance)(universeId));
        }
    }, [
        dispatch,
        isInstanceLoading,
        instanceLoaded
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (theme.loaded) loadImages(theme).then(()=>{
            setThemeLoaded(true);
        });
    }, [
        theme
    ]);
    return {
        themeLoaded: themeLoaded,
        imagesLoaded: imagesLoaded,
        imageProgress: imageProgress,
        ready: themeLoaded && imagesLoaded,
        error: error
    };
}
async function $73bd272a99e2a340$var$loadImage(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            resolve();
        };
        img.onerror = ()=>{
            // console.error('Failed to load image', url);
            reject();
        };
        img.src = url;
    });
}



var $8FY87 = parcelRequire("8FY87");
const $78abed24600f4ea8$var$startTime = Date.now();
function $78abed24600f4ea8$export$2e2bcd8739ae039({ children: children }) {
    const [ready, setReady] = (0, $8FY87.useState)(false);
    const fonts = (0, $751064cf868cb340$export$2e2bcd8739ae039)();
    const { ready: themeReady, error: error } = (0, $73bd272a99e2a340$export$2e2bcd8739ae039)();
    (0, $8FY87.useEffect)(()=>{
        if (fonts.ready && themeReady) {
            const endTime = Date.now();
            const loadTime = endTime - $78abed24600f4ea8$var$startTime;
            console.log(`Asset load time: ${loadTime / 1000}s`);
            setReady(true);
        }
    }, [
        fonts.ready,
        themeReady
    ]);
    // TODO: handle error state
    if (!ready) // Loading screen is inside index.html
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: children
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");


var $f9aoP = parcelRequire("f9aoP");
async function $882c398467ff90b2$export$b96d1a6f7d456e0f(itemID) {
    // Returns if is successful or not
    try {
        const response = await (0, $f9aoP.checkoutShopItem)(itemID, "asset_pack");
        if (response.stripeURL) {
            window.location.href = response.stripeURL;
            return true;
        }
    } catch (error) {
        console.warn("Error calling checkout for item ID:", itemID, error);
        return false;
    }
}
async function $882c398467ff90b2$export$89c78e966bf89d69(sessionId, timeoutMs = 60000) {
    const startTime = Date.now();
    try {
        let response;
        do {
            console.log("Polling for session status");
            response = await (0, $f9aoP.getSessionStatus)(sessionId);
            if (response.status === "confirmed") return response;
            if (response.status !== "pending") throw new Error("Unrecognised session status");
            // Check if the timeout has been exceeded
            if (Date.now() - startTime >= timeoutMs) {
                console.warn("Polling timed out");
                return null;
            }
            await new Promise((resolve)=>setTimeout(resolve, 2000)); // Wait 2 seconds before retrying
        }while (response.status === "pending");
    } catch (error) {
        console.error("Could not get session status ", error?.message);
        throw error;
    }
}
async function $882c398467ff90b2$export$e1f5ba8d130868e2(id) {
    try {
        const packs = await (0, $f9aoP.getAssetPacks)();
        return packs.find((pack)=>pack.id === id);
    } catch (error) {
        console.error("Could not load packs");
    }
}



var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $cEIti = parcelRequire("cEIti");

var $1URoE = parcelRequire("1URoE");




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $5086f3773d25c2f6$exports = {};
Object.defineProperty($5086f3773d25c2f6$exports, "__esModule", {
    value: !0
});

var $8FY87 = parcelRequire("8FY87");
var $c9636b043a129d7c$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $c9636b043a129d7c$exports = factory();
})($c9636b043a129d7c$exports, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                var Rive = (()=>{
                    var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : undefined;
                    return function(moduleArg = {}) {
                        var m = moduleArg, aa, ea;
                        m.ready = new Promise((a, b)=>{
                            aa = a;
                            ea = b;
                        });
                        function fa() {
                            function a(g) {
                                const n = d;
                                c = b = 0;
                                d = new Map();
                                n.forEach((p)=>{
                                    try {
                                        p(g);
                                    } catch (l) {
                                        console.error(l);
                                    }
                                });
                                this.ob();
                                e && e.Tb();
                            }
                            let b = 0, c = 0, d = new Map(), e = null, f = null;
                            this.requestAnimationFrame = function(g) {
                                b || (b = requestAnimationFrame(a.bind(this)));
                                const n = ++c;
                                d.set(n, g);
                                return n;
                            };
                            this.cancelAnimationFrame = function(g) {
                                d.delete(g);
                                b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
                            };
                            this.Rb = function(g) {
                                f && (document.body.remove(f), f = null);
                                g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(n) {
                                    f.innerHTML = "RIVE FPS " + n.toFixed(1);
                                }, document.body.appendChild(f));
                                e = new function() {
                                    let n = 0, p = 0;
                                    this.Tb = function() {
                                        var l = performance.now();
                                        p ? (++n, l -= p, 1000 < l && (g(1000 * n / l), n = p = 0)) : (p = l, n = 0);
                                    };
                                }();
                            };
                            this.Ob = function() {
                                f && (document.body.remove(f), f = null);
                                e = null;
                            };
                            this.ob = function() {};
                        }
                        function ha(a) {
                            console.assert(!0);
                            const b = new Map();
                            let c = -Infinity;
                            this.push = function(d) {
                                d = d + ((1 << a) - 1) >> a;
                                b.has(d) && clearTimeout(b.get(d));
                                b.set(d, setTimeout(function() {
                                    b.delete(d);
                                    0 == b.length ? c = -Infinity : d == c && (c = Math.max(...b.keys()), console.assert(c < d));
                                }, 1000));
                                c = Math.max(d, c);
                                return c << a;
                            };
                        }
                        const ia = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            ia && ia();
                            let a = m.decodeAudio;
                            m.decodeAudio = function(d, e) {
                                d = a(d);
                                e(d);
                            };
                            let b = m.decodeFont;
                            m.decodeFont = function(d, e) {
                                d = b(d);
                                e(d);
                            };
                            const c = m.FileAssetLoader;
                            m.ptrToAsset = (d)=>{
                                let e = m.ptrToFileAsset(d);
                                return e.isImage ? m.ptrToImageAsset(d) : e.isFont ? m.ptrToFontAsset(d) : e.isAudio ? m.ptrToAudioAsset(d) : e;
                            };
                            m.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {
                                __construct: function({ loadContents: d }) {
                                    this.__parent.__construct.call(this);
                                    this.Gb = d;
                                },
                                loadContents: function(d, e) {
                                    d = m.ptrToAsset(d);
                                    return this.Gb(d, e);
                                }
                            });
                            m.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function(d) {
                                    let e = m.ptrToAsset(d);
                                    d = e.cdnUuid;
                                    if ("" === d) return !1;
                                    (function(f, g) {
                                        var n = new XMLHttpRequest();
                                        n.responseType = "arraybuffer";
                                        n.onreadystatechange = function() {
                                            4 == n.readyState && 200 == n.status && g(n);
                                        };
                                        n.open("GET", f, !0);
                                        n.send(null);
                                    })(e.cdnBaseUrl + "/" + d, (f)=>{
                                        e.decode(new Uint8Array(f.response));
                                    });
                                    return !0;
                                }
                            });
                            m.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.kb = [];
                                },
                                addLoader: function(d) {
                                    this.kb.push(d);
                                },
                                loadContents: function(d, e) {
                                    for (let f of this.kb){
                                        if (f.loadContents(d, e)) return !0;
                                    }
                                    return !1;
                                }
                            });
                        };
                        const ja = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), ka = new function() {
                            function a() {
                                if (!b) {
                                    var k = document.createElement("canvas"), t = {
                                        alpha: 1,
                                        depth: 0,
                                        stencil: 0,
                                        antialias: 0,
                                        premultipliedAlpha: 1,
                                        preserveDrawingBuffer: 0,
                                        preferLowPowerToHighPerformance: 0,
                                        failIfMajorPerformanceCaveat: 0,
                                        enableExtensionsByDefault: 1,
                                        explicitSwapControl: 1,
                                        renderViaOffscreenBackBuffer: 1
                                    };
                                    let r;
                                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                        if (r = k.getContext("webgl", t), c = 1, !r) return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    } else if (r = k.getContext("webgl2", t)) c = 2;
                                    else {
                                        if (r = k.getContext("webgl", t)) c = 1;
                                        else return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    }
                                    r = new Proxy(r, {
                                        get (D, w) {
                                            if (D.isContextLost()) {
                                                if (p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", w), p = !0), "function" === typeof D[w]) return function() {};
                                            } else return "function" === typeof D[w] ? function(...M) {
                                                return D[w].apply(D, M);
                                            } : D[w];
                                        },
                                        set (D, w, M) {
                                            if (D.isContextLost()) p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + w), p = !0);
                                            else return D[w] = M, !0;
                                        }
                                    });
                                    d = Math.min(r.getParameter(r.MAX_RENDERBUFFER_SIZE), r.getParameter(r.MAX_TEXTURE_SIZE));
                                    function A(D, w, M) {
                                        w = r.createShader(w);
                                        r.shaderSource(w, M);
                                        r.compileShader(w);
                                        M = r.getShaderInfoLog(w);
                                        if (0 < (M || "").length) throw M;
                                        r.attachShader(D, w);
                                    }
                                    k = r.createProgram();
                                    A(k, r.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
                                    A(k, r.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
                                    r.bindAttribLocation(k, 0, "vertex");
                                    r.bindAttribLocation(k, 1, "uv");
                                    r.linkProgram(k);
                                    t = r.getProgramInfoLog(k);
                                    if (0 < (t || "").trim().length) throw t;
                                    e = r.getUniformLocation(k, "mat");
                                    f = r.getUniformLocation(k, "translate");
                                    r.useProgram(k);
                                    r.bindBuffer(r.ARRAY_BUFFER, r.createBuffer());
                                    r.enableVertexAttribArray(0);
                                    r.enableVertexAttribArray(1);
                                    r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, r.createBuffer());
                                    r.uniform1i(r.getUniformLocation(k, "image"), 0);
                                    r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
                                    b = r;
                                }
                                return !0;
                            }
                            let b = null, c = 0, d = 0, e = null, f = null, g = 0, n = 0, p = !1;
                            a();
                            this.hc = function() {
                                a();
                                return d;
                            };
                            this.Mb = function(k) {
                                b.deleteTexture && b.deleteTexture(k);
                            };
                            this.Lb = function(k) {
                                if (!a()) return null;
                                const t = b.createTexture();
                                if (!t) return null;
                                b.bindTexture(b.TEXTURE_2D, t);
                                b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, k);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.LINEAR);
                                2 == c ? (b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR_MIPMAP_LINEAR), b.generateMipmap(b.TEXTURE_2D)) : b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR);
                                return t;
                            };
                            const l = new ha(8), u = new ha(8), v = new ha(10), x = new ha(10);
                            this.Qb = function(k, t, r, A, D) {
                                if (a()) {
                                    var w = l.push(k), M = u.push(t);
                                    if (b.canvas) {
                                        if (b.canvas.width != w || b.canvas.height != M) b.canvas.width = w, b.canvas.height = M;
                                        b.viewport(0, M - t, k, t);
                                        b.disable(b.SCISSOR_TEST);
                                        b.clearColor(0, 0, 0, 0);
                                        b.clear(b.COLOR_BUFFER_BIT);
                                        b.enable(b.SCISSOR_TEST);
                                        r.sort((F, ba)=>ba.wb - F.wb);
                                        w = v.push(A);
                                        g != w && (b.bufferData(b.ARRAY_BUFFER, 8 * w, b.DYNAMIC_DRAW), g = w);
                                        w = 0;
                                        for (var T of r)b.bufferSubData(b.ARRAY_BUFFER, w, T.Ta), w += 4 * T.Ta.length;
                                        console.assert(w == 4 * A);
                                        for (var ca of r)b.bufferSubData(b.ARRAY_BUFFER, w, ca.Db), w += 4 * ca.Db.length;
                                        console.assert(w == 8 * A);
                                        w = x.push(D);
                                        n != w && (b.bufferData(b.ELEMENT_ARRAY_BUFFER, 2 * w, b.DYNAMIC_DRAW), n = w);
                                        T = 0;
                                        for (var ra of r)b.bufferSubData(b.ELEMENT_ARRAY_BUFFER, T, ra.indices), T += 2 * ra.indices.length;
                                        console.assert(T == 2 * D);
                                        ra = 0;
                                        ca = !0;
                                        w = T = 0;
                                        for (const F of r){
                                            F.image.Ka != ra && (b.bindTexture(b.TEXTURE_2D, F.image.Ja || null), ra = F.image.Ka);
                                            F.mc ? (b.scissor(F.Ya, M - F.Za - F.jb, F.Ac, F.jb), ca = !0) : ca && (b.scissor(0, M - t, k, t), ca = !1);
                                            r = 2 / k;
                                            const ba = -2 / t;
                                            b.uniform4f(e, F.ha[0] * r * F.Ba, F.ha[1] * ba * F.Ca, F.ha[2] * r * F.Ba, F.ha[3] * ba * F.Ca);
                                            b.uniform2f(f, F.ha[4] * r * F.Ba + r * (F.Ya - F.ic * F.Ba) - 1, F.ha[5] * ba * F.Ca + ba * (F.Za - F.jc * F.Ca) + 1);
                                            b.vertexAttribPointer(0, 2, b.FLOAT, !1, 0, w);
                                            b.vertexAttribPointer(1, 2, b.FLOAT, !1, 0, w + 4 * A);
                                            b.drawElements(b.TRIANGLES, F.indices.length, b.UNSIGNED_SHORT, T);
                                            w += 4 * F.Ta.length;
                                            T += 2 * F.indices.length;
                                        }
                                        console.assert(w == 4 * A);
                                        console.assert(T == 2 * D);
                                    }
                                }
                            };
                            this.canvas = function() {
                                return a() && b.canvas;
                            };
                        }(), la = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            function a(q) {
                                switch(q){
                                    case l.srcOver:
                                        return "source-over";
                                    case l.screen:
                                        return "screen";
                                    case l.overlay:
                                        return "overlay";
                                    case l.darken:
                                        return "darken";
                                    case l.lighten:
                                        return "lighten";
                                    case l.colorDodge:
                                        return "color-dodge";
                                    case l.colorBurn:
                                        return "color-burn";
                                    case l.hardLight:
                                        return "hard-light";
                                    case l.softLight:
                                        return "soft-light";
                                    case l.difference:
                                        return "difference";
                                    case l.exclusion:
                                        return "exclusion";
                                    case l.multiply:
                                        return "multiply";
                                    case l.hue:
                                        return "hue";
                                    case l.saturation:
                                        return "saturation";
                                    case l.color:
                                        return "color";
                                    case l.luminosity:
                                        return "luminosity";
                                }
                            }
                            function b(q) {
                                return "rgba(" + ((16711680 & q) >>> 16) + "," + ((65280 & q) >>> 8) + "," + ((255 & q) >>> 0) + "," + ((4278190080 & q) >>> 24) / 255 + ")";
                            }
                            function c() {
                                0 < M.length && (ka.Qb(w.drawWidth(), w.drawHeight(), M, T, ca), M = [], ca = T = 0, w.reset(512, 512));
                                for (const q of D){
                                    for (const z of q.H)z();
                                    q.H = [];
                                }
                                D.clear();
                            }
                            la && la();
                            var d = m.RenderPaintStyle;
                            const e = m.RenderPath, f = m.RenderPaint, g = m.Renderer, n = m.StrokeCap, p = m.StrokeJoin, l = m.BlendMode, u = d.fill, v = d.stroke, x = m.FillRule.evenOdd;
                            let k = 1;
                            var t = m.RenderImage.extend("CanvasRenderImage", {
                                __construct: function({ la: q, xa: z } = {}) {
                                    this.__parent.__construct.call(this);
                                    this.Ka = k;
                                    k = k + 1 & 2147483647 || 1;
                                    this.la = q;
                                    this.xa = z;
                                },
                                __destruct: function() {
                                    this.Ja && (ka.Mb(this.Ja), URL.revokeObjectURL(this.Wa));
                                    this.__parent.__destruct.call(this);
                                },
                                decode: function(q) {
                                    var z = this;
                                    z.xa && z.xa(z);
                                    var G = new Image();
                                    z.Wa = URL.createObjectURL(new Blob([
                                        q
                                    ], {
                                        type: "image/png"
                                    }));
                                    G.onload = function() {
                                        z.Fb = G;
                                        z.Ja = ka.Lb(G);
                                        z.size(G.width, G.height);
                                        z.la && z.la(z);
                                    };
                                    G.src = z.Wa;
                                }
                            }), r = e.extend("CanvasRenderPath", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.T = new Path2D();
                                },
                                rewind: function() {
                                    this.T = new Path2D();
                                },
                                addPath: function(q, z, G, H, C, I, J) {
                                    var K = this.T, X = K.addPath;
                                    q = q.T;
                                    const Q = new DOMMatrix();
                                    Q.a = z;
                                    Q.b = G;
                                    Q.c = H;
                                    Q.d = C;
                                    Q.e = I;
                                    Q.f = J;
                                    X.call(K, q, Q);
                                },
                                fillRule: function(q) {
                                    this.Va = q;
                                },
                                moveTo: function(q, z) {
                                    this.T.moveTo(q, z);
                                },
                                lineTo: function(q, z) {
                                    this.T.lineTo(q, z);
                                },
                                cubicTo: function(q, z, G, H, C, I) {
                                    this.T.bezierCurveTo(q, z, G, H, C, I);
                                },
                                close: function() {
                                    this.T.closePath();
                                }
                            }), A = f.extend("CanvasRenderPaint", {
                                color: function(q) {
                                    this.Xa = b(q);
                                },
                                thickness: function(q) {
                                    this.Ib = q;
                                },
                                join: function(q) {
                                    switch(q){
                                        case p.miter:
                                            this.Ia = "miter";
                                            break;
                                        case p.round:
                                            this.Ia = "round";
                                            break;
                                        case p.bevel:
                                            this.Ia = "bevel";
                                    }
                                },
                                cap: function(q) {
                                    switch(q){
                                        case n.butt:
                                            this.Ha = "butt";
                                            break;
                                        case n.round:
                                            this.Ha = "round";
                                            break;
                                        case n.square:
                                            this.Ha = "square";
                                    }
                                },
                                style: function(q) {
                                    this.Hb = q;
                                },
                                blendMode: function(q) {
                                    this.Eb = a(q);
                                },
                                clearGradient: function() {
                                    this.ja = null;
                                },
                                linearGradient: function(q, z, G, H) {
                                    this.ja = {
                                        yb: q,
                                        zb: z,
                                        bb: G,
                                        cb: H,
                                        Ra: []
                                    };
                                },
                                radialGradient: function(q, z, G, H) {
                                    this.ja = {
                                        yb: q,
                                        zb: z,
                                        bb: G,
                                        cb: H,
                                        Ra: [],
                                        ec: !0
                                    };
                                },
                                addStop: function(q, z) {
                                    this.ja.Ra.push({
                                        color: q,
                                        stop: z
                                    });
                                },
                                completeGradient: function() {},
                                draw: function(q, z, G) {
                                    let H = this.Hb;
                                    var C = this.Xa, I = this.ja;
                                    q.globalCompositeOperation = this.Eb;
                                    if (null != I) {
                                        C = I.yb;
                                        var J = I.zb;
                                        const X = I.bb;
                                        var K = I.cb;
                                        const Q = I.Ra;
                                        I.ec ? (I = X - C, K -= J, C = q.createRadialGradient(C, J, 0, C, J, Math.sqrt(I * I + K * K))) : C = q.createLinearGradient(C, J, X, K);
                                        for(let da = 0, R = Q.length; da < R; da++)J = Q[da], C.addColorStop(J.stop, b(J.color));
                                        this.Xa = C;
                                        this.ja = null;
                                    }
                                    switch(H){
                                        case v:
                                            q.strokeStyle = C;
                                            q.lineWidth = this.Ib;
                                            q.lineCap = this.Ha;
                                            q.lineJoin = this.Ia;
                                            q.stroke(z);
                                            break;
                                        case u:
                                            q.fillStyle = C, q.fill(z, G);
                                    }
                                }
                            });
                            const D = new Set();
                            let w = null, M = [], T = 0, ca = 0;
                            var ra = m.CanvasRenderer = g.extend("Renderer", {
                                __construct: function(q) {
                                    this.__parent.__construct.call(this);
                                    this.S = [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0
                                    ];
                                    this.C = q.getContext("2d");
                                    this.Ua = q;
                                    this.H = [];
                                },
                                save: function() {
                                    this.S.push(...this.S.slice(this.S.length - 6));
                                    this.H.push(this.C.save.bind(this.C));
                                },
                                restore: function() {
                                    const q = this.S.length - 6;
                                    if (6 > q) throw "restore() called without matching save().";
                                    this.S.splice(q);
                                    this.H.push(this.C.restore.bind(this.C));
                                },
                                transform: function(q, z, G, H, C, I) {
                                    const J = this.S, K = J.length - 6;
                                    J.splice(K, 6, J[K] * q + J[K + 2] * z, J[K + 1] * q + J[K + 3] * z, J[K] * G + J[K + 2] * H, J[K + 1] * G + J[K + 3] * H, J[K] * C + J[K + 2] * I + J[K + 4], J[K + 1] * C + J[K + 3] * I + J[K + 5]);
                                    this.H.push(this.C.transform.bind(this.C, q, z, G, H, C, I));
                                },
                                rotate: function(q) {
                                    const z = Math.sin(q);
                                    q = Math.cos(q);
                                    this.transform(q, z, -z, q, 0, 0);
                                },
                                _drawPath: function(q, z) {
                                    this.H.push(z.draw.bind(z, this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                _drawRiveImage: function(q, z, G) {
                                    var H = q.Fb;
                                    if (H) {
                                        var C = this.C, I = a(z);
                                        this.H.push(function() {
                                            C.globalCompositeOperation = I;
                                            C.globalAlpha = G;
                                            C.drawImage(H, 0, 0);
                                            C.globalAlpha = 1;
                                        });
                                    }
                                },
                                _getMatrix: function(q) {
                                    const z = this.S, G = z.length - 6;
                                    for(let H = 0; 6 > H; ++H)q[H] = z[G + H];
                                },
                                _drawImageMesh: function(q, z, G, H, C, I, J, K, X, Q) {
                                    var da = this.C.canvas.width, R = this.C.canvas.height;
                                    const Yb = X - J, Zb = Q - K;
                                    J = Math.max(J, 0);
                                    K = Math.max(K, 0);
                                    X = Math.min(X, da);
                                    Q = Math.min(Q, R);
                                    const Ga = X - J, Ha = Q - K;
                                    console.assert(Ga <= Math.min(Yb, da));
                                    console.assert(Ha <= Math.min(Zb, R));
                                    if (!(0 >= Ga || 0 >= Ha)) {
                                        X = Ga < Yb || Ha < Zb;
                                        da = Q = 1;
                                        var sa = Math.ceil(Ga * Q), ta = Math.ceil(Ha * da);
                                        R = ka.hc();
                                        sa > R && (Q *= R / sa, sa = R);
                                        ta > R && (da *= R / ta, ta = R);
                                        w || (w = new m.DynamicRectanizer(R), w.reset(512, 512));
                                        R = w.addRect(sa, ta);
                                        0 > R && (c(), D.add(this), R = w.addRect(sa, ta), console.assert(0 <= R));
                                        var $b = R & 65535, ac = R >> 16;
                                        M.push({
                                            ha: this.S.slice(this.S.length - 6),
                                            image: q,
                                            Ya: $b,
                                            Za: ac,
                                            ic: J,
                                            jc: K,
                                            Ac: sa,
                                            jb: ta,
                                            Ba: Q,
                                            Ca: da,
                                            Ta: new Float32Array(H),
                                            Db: new Float32Array(C),
                                            indices: new Uint16Array(I),
                                            mc: X,
                                            wb: q.Ka << 1 | (X ? 1 : 0)
                                        });
                                        T += H.length;
                                        ca += I.length;
                                        var za = this.C, qd = a(z);
                                        this.H.push(function() {
                                            za.save();
                                            za.resetTransform();
                                            za.globalCompositeOperation = qd;
                                            za.globalAlpha = G;
                                            const bc = ka.canvas();
                                            bc && za.drawImage(bc, $b, ac, sa, ta, J, K, Ga, Ha);
                                            za.restore();
                                        });
                                    }
                                },
                                _clipPath: function(q) {
                                    this.H.push(this.C.clip.bind(this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                clear: function() {
                                    D.add(this);
                                    this.H.push(this.C.clearRect.bind(this.C, 0, 0, this.Ua.width, this.Ua.height));
                                },
                                flush: function() {},
                                translate: function(q, z) {
                                    this.transform(1, 0, 0, 1, q, z);
                                }
                            });
                            m.makeRenderer = function(q) {
                                const z = new ra(q), G = z.C;
                                return new Proxy(z, {
                                    get (H, C) {
                                        if ("function" === typeof H[C]) return function(...I) {
                                            return H[C].apply(H, I);
                                        };
                                        if ("function" === typeof G[C]) {
                                            if (-1 < ja.indexOf(C)) throw Error("RiveException: Method call to '" + C + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
                                            return function(...I) {
                                                z.H.push(G[C].bind(G, ...I));
                                            };
                                        }
                                        return H[C];
                                    },
                                    set (H, C, I) {
                                        if (C in G) return z.H.push(()=>{
                                            G[C] = I;
                                        }), !0;
                                    }
                                });
                            };
                            m.decodeImage = function(q, z) {
                                new t({
                                    la: z
                                }).decode(q);
                            };
                            m.renderFactory = {
                                makeRenderPaint: function() {
                                    return new A();
                                },
                                makeRenderPath: function() {
                                    return new r();
                                },
                                makeRenderImage: function() {
                                    let q = ba;
                                    return new t({
                                        xa: ()=>{
                                            q.total++;
                                        },
                                        la: ()=>{
                                            q.loaded++;
                                            if (q.loaded === q.total) {
                                                const z = q.ready;
                                                z && (z(), q.ready = null);
                                            }
                                        }
                                    });
                                }
                            };
                            let F = m.load, ba = null;
                            m.load = function(q, z, G = !0) {
                                const H = new m.FallbackFileAssetLoader();
                                void 0 !== z && H.addLoader(z);
                                G && (z = new m.CDNFileAssetLoader(), H.addLoader(z));
                                return new Promise(function(C) {
                                    let I = null;
                                    ba = {
                                        total: 0,
                                        loaded: 0,
                                        ready: function() {
                                            C(I);
                                        }
                                    };
                                    I = F(q, H);
                                    0 == ba.total && C(I);
                                });
                            };
                            d = new fa();
                            m.requestAnimationFrame = d.requestAnimationFrame.bind(d);
                            m.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
                            m.enableFPSCounter = d.Rb.bind(d);
                            m.disableFPSCounter = d.Ob;
                            d.ob = c;
                            m.resolveAnimationFrame = c;
                            m.cleanup = function() {
                                w && w.delete();
                            };
                        };
                        var ma = Object.assign({}, m), na = "./this.program", oa = "object" == typeof window, pa = "function" == typeof importScripts, qa = "", ua, va;
                        if (oa || pa) pa ? qa = self.location.href : "undefined" != typeof document && document.currentScript && (qa = document.currentScript.src), _scriptDir && (qa = _scriptDir), 0 !== qa.indexOf("blob:") ? qa = qa.substr(0, qa.replace(/[?#].*/, "").lastIndexOf("/") + 1) : qa = "", pa && (va = (a)=>{
                            var b = new XMLHttpRequest();
                            b.open("GET", a, !1);
                            b.responseType = "arraybuffer";
                            b.send(null);
                            return new Uint8Array(b.response);
                        }), ua = (a, b, c)=>{
                            var d = new XMLHttpRequest();
                            d.open("GET", a, !0);
                            d.responseType = "arraybuffer";
                            d.onload = ()=>{
                                200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
                            };
                            d.onerror = c;
                            d.send(null);
                        };
                        var wa = m.print || console.log.bind(console), xa = m.printErr || console.error.bind(console);
                        Object.assign(m, ma);
                        ma = null;
                        m.thisProgram && (na = m.thisProgram);
                        var ya;
                        m.wasmBinary && (ya = m.wasmBinary);
                        var noExitRuntime = m.noExitRuntime || !0;
                        "object" != typeof WebAssembly && Aa("no native wasm support detected");
                        var Ba, y, Ca = !1, B, E, Da, Ea, L, N, Fa, Ia;
                        function Ja() {
                            var a = Ba.buffer;
                            m.HEAP8 = B = new Int8Array(a);
                            m.HEAP16 = Da = new Int16Array(a);
                            m.HEAP32 = L = new Int32Array(a);
                            m.HEAPU8 = E = new Uint8Array(a);
                            m.HEAPU16 = Ea = new Uint16Array(a);
                            m.HEAPU32 = N = new Uint32Array(a);
                            m.HEAPF32 = Fa = new Float32Array(a);
                            m.HEAPF64 = Ia = new Float64Array(a);
                        }
                        var Ka, La = [], Ma = [], Na = [];
                        function Oa() {
                            var a = m.preRun.shift();
                            La.unshift(a);
                        }
                        var Pa = 0, Qa = null, Ra = null;
                        function Aa(a) {
                            if (m.onAbort) m.onAbort(a);
                            a = "Aborted(" + a + ")";
                            xa(a);
                            Ca = !0;
                            a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
                            ea(a);
                            throw a;
                        }
                        function Sa(a) {
                            return a.startsWith("data:application/octet-stream;base64,");
                        }
                        var Ta;
                        Ta = "canvas_advanced.wasm";
                        if (!Sa(Ta)) {
                            var Ua = Ta;
                            Ta = m.locateFile ? m.locateFile(Ua, qa) : qa + Ua;
                        }
                        function Va(a) {
                            if (a == Ta && ya) return new Uint8Array(ya);
                            if (va) return va(a);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function Wa(a) {
                            if (!ya && (oa || pa)) {
                                if ("function" == typeof fetch && !a.startsWith("file://")) return fetch(a, {
                                    credentials: "same-origin"
                                }).then((b)=>{
                                    if (!b.ok) throw "failed to load wasm binary file at '" + a + "'";
                                    return b.arrayBuffer();
                                }).catch(()=>Va(a));
                                if (ua) return new Promise((b, c)=>{
                                    ua(a, (d)=>b(new Uint8Array(d)), c);
                                });
                            }
                            return Promise.resolve().then(()=>Va(a));
                        }
                        function Xa(a, b, c) {
                            return Wa(a).then((d)=>WebAssembly.instantiate(d, b)).then((d)=>d).then(c, (d)=>{
                                xa("failed to asynchronously prepare wasm: " + d);
                                Aa(d);
                            });
                        }
                        function Ya(a, b) {
                            var c = Ta;
                            return ya || "function" != typeof WebAssembly.instantiateStreaming || Sa(c) || c.startsWith("file://") || "function" != typeof fetch ? Xa(c, a, b) : fetch(c, {
                                credentials: "same-origin"
                            }).then((d)=>WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
                                    xa("wasm streaming compile failed: " + e);
                                    xa("falling back to ArrayBuffer instantiation");
                                    return Xa(c, a, b);
                                }));
                        }
                        var Za, $a, db = {
                            436604: (a, b, c, d, e)=>{
                                if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) return 0;
                                if ("undefined" === typeof window.h) {
                                    window.h = {
                                        Aa: 0
                                    };
                                    window.h.I = {};
                                    window.h.I.ya = a;
                                    window.h.I.capture = b;
                                    window.h.I.La = c;
                                    window.h.ga = {};
                                    window.h.ga.stopped = d;
                                    window.h.ga.xb = e;
                                    let f = window.h;
                                    f.D = [];
                                    f.yc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (null == f.D[n]) return f.D[n] = g, n;
                                        }
                                        f.D.push(g);
                                        return f.D.length - 1;
                                    };
                                    f.Cb = function(g) {
                                        for(f.D[g] = null; 0 < f.D.length;){
                                            if (null == f.D[f.D.length - 1]) f.D.pop();
                                            else break;
                                        }
                                    };
                                    f.Sc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (f.D[n] == g) return f.Cb(n);
                                        }
                                    };
                                    f.ra = function(g) {
                                        return f.D[g];
                                    };
                                    f.Bb = [
                                        "touchend",
                                        "click"
                                    ];
                                    f.unlock = function() {
                                        for(var g = 0; g < f.D.length; ++g){
                                            var n = f.D[g];
                                            null != n && null != n.J && n.state === f.ga.xb && n.J.resume().then(()=>{
                                                ab(n.pb);
                                            }, (p)=>{
                                                console.error("Failed to resume audiocontext", p);
                                            });
                                        }
                                        f.Bb.map(function(p) {
                                            document.removeEventListener(p, f.unlock, !0);
                                        });
                                    };
                                    f.Bb.map(function(g) {
                                        document.addEventListener(g, f.unlock, !0);
                                    });
                                }
                                window.h.Aa += 1;
                                return 1;
                            },
                            438782: ()=>{
                                "undefined" !== typeof window.h && (--window.h.Aa, 0 === window.h.Aa && delete window.h);
                            },
                            438946: ()=>void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia,
                            439050: ()=>{
                                try {
                                    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
                                    a.close();
                                    return b;
                                } catch (c) {
                                    return 0;
                                }
                            },
                            439221: (a, b, c, d, e, f)=>{
                                if ("undefined" === typeof window.h) return -1;
                                var g = {}, n = {};
                                a == window.h.I.ya && 0 != c && (n.sampleRate = c);
                                g.J = new (window.AudioContext || window.webkitAudioContext)(n);
                                g.J.suspend();
                                g.state = window.h.ga.stopped;
                                c = 0;
                                a != window.h.I.ya && (c = b);
                                g.Z = g.J.createScriptProcessor(d, c, b);
                                g.Z.onaudioprocess = function(p) {
                                    if (null == g.sa || 0 == g.sa.length) g.sa = new Float32Array(Fa.buffer, e, d * b);
                                    if (a == window.h.I.capture || a == window.h.I.La) {
                                        for(var l = 0; l < b; l += 1)for(var u = p.inputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)v[x * b + l] = u[x];
                                        bb(f, d, e);
                                    }
                                    if (a == window.h.I.ya || a == window.h.I.La) {
                                        for(cb(f, d, e), l = 0; l < p.outputBuffer.numberOfChannels; ++l)for(u = p.outputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)u[x] = v[x * b + l];
                                    } else for(l = 0; l < p.outputBuffer.numberOfChannels; ++l)p.outputBuffer.getChannelData(l).fill(0.0);
                                };
                                a != window.h.I.capture && a != window.h.I.La || navigator.mediaDevices.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }).then(function(p) {
                                    g.Da = g.J.createMediaStreamSource(p);
                                    g.Da.connect(g.Z);
                                    g.Z.connect(g.J.destination);
                                }).catch(function(p) {
                                    console.log("Failed to get user media: " + p);
                                });
                                a == window.h.I.ya && g.Z.connect(g.J.destination);
                                g.pb = f;
                                return window.h.yc(g);
                            },
                            442098: (a)=>window.h.ra(a).J.sampleRate,
                            442171: (a)=>{
                                a = window.h.ra(a);
                                void 0 !== a.Z && (a.Z.onaudioprocess = function() {}, a.Z.disconnect(), a.Z = void 0);
                                void 0 !== a.Da && (a.Da.disconnect(), a.Da = void 0);
                                a.J.close();
                                a.J = void 0;
                                a.pb = void 0;
                            },
                            442571: (a)=>{
                                window.h.Cb(a);
                            },
                            442621: (a)=>{
                                a = window.h.ra(a);
                                a.J.resume();
                                a.state = window.h.ga.xb;
                            },
                            442760: (a)=>{
                                a = window.h.ra(a);
                                a.J.suspend();
                                a.state = window.h.ga.stopped;
                            }
                        }, eb = (a)=>{
                            for(; 0 < a.length;)a.shift()(m);
                        }, fb = (a, b)=>{
                            for(var c = 0, d = a.length - 1; 0 <= d; d--){
                                var e = a[d];
                                "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
                            }
                            if (b) for(; c; c--)a.unshift("..");
                            return a;
                        }, gb = (a)=>{
                            var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
                            (a = fb(a.split("/").filter((d)=>!!d), !b).join("/")) || b || (a = ".");
                            a && c && (a += "/");
                            return (b ? "/" : "") + a;
                        }, hb = (a)=>{
                            var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
                            a = b[0];
                            b = b[1];
                            if (!a && !b) return ".";
                            b && (b = b.substr(0, b.length - 1));
                            return a + b;
                        }, ib = (a)=>{
                            if ("/" === a) return "/";
                            a = gb(a);
                            a = a.replace(/\/$/, "");
                            var b = a.lastIndexOf("/");
                            return -1 === b ? a : a.substr(b + 1);
                        }, jb = ()=>{
                            if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) return (a)=>crypto.getRandomValues(a);
                            Aa("initRandomDevice");
                        }, kb = (a)=>(kb = jb())(a);
                        function lb() {
                            for(var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--){
                                b = 0 <= c ? arguments[c] : "/";
                                if ("string" != typeof b) throw new TypeError("Arguments to path.resolve must be strings");
                                if (!b) return "";
                                a = b + "/" + a;
                                b = "/" === b.charAt(0);
                            }
                            a = fb(a.split("/").filter((d)=>!!d), !b).join("/");
                            return (b ? "/" : "") + a || ".";
                        }
                        var mb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, nb = (a, b, c)=>{
                            var d = b + c;
                            for(c = b; a[c] && !(c >= d);)++c;
                            if (16 < c - b && a.buffer && mb) return mb.decode(a.subarray(b, c));
                            for(d = ""; b < c;){
                                var e = a[b++];
                                if (e & 128) {
                                    var f = a[b++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | f);
                                    else {
                                        var g = a[b++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, ob = [], pb = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
                            }
                            return b;
                        }, qb = (a, b, c, d)=>{
                            if (!(0 < d)) return 0;
                            var e = c;
                            d = c + d - 1;
                            for(var f = 0; f < a.length; ++f){
                                var g = a.charCodeAt(f);
                                if (55296 <= g && 57343 >= g) {
                                    var n = a.charCodeAt(++f);
                                    g = 65536 + ((g & 1023) << 10) | n & 1023;
                                }
                                if (127 >= g) {
                                    if (c >= d) break;
                                    b[c++] = g;
                                } else {
                                    if (2047 >= g) {
                                        if (c + 1 >= d) break;
                                        b[c++] = 192 | g >> 6;
                                    } else {
                                        if (65535 >= g) {
                                            if (c + 2 >= d) break;
                                            b[c++] = 224 | g >> 12;
                                        } else {
                                            if (c + 3 >= d) break;
                                            b[c++] = 240 | g >> 18;
                                            b[c++] = 128 | g >> 12 & 63;
                                        }
                                        b[c++] = 128 | g >> 6 & 63;
                                    }
                                    b[c++] = 128 | g & 63;
                                }
                            }
                            b[c] = 0;
                            return c - e;
                        };
                        function rb(a, b) {
                            var c = Array(pb(a) + 1);
                            a = qb(a, c, 0, c.length);
                            b && (c.length = a);
                            return c;
                        }
                        var sb = [];
                        function tb(a, b) {
                            sb[a] = {
                                input: [],
                                F: [],
                                V: b
                            };
                            ub(a, vb);
                        }
                        var vb = {
                            open: function(a) {
                                var b = sb[a.node.za];
                                if (!b) throw new O(43);
                                a.s = b;
                                a.seekable = !1;
                            },
                            close: function(a) {
                                a.s.V.qa(a.s);
                            },
                            qa: function(a) {
                                a.s.V.qa(a.s);
                            },
                            read: function(a, b, c, d) {
                                if (!a.s || !a.s.V.ib) throw new O(60);
                                for(var e = 0, f = 0; f < d; f++){
                                    try {
                                        var g = a.s.V.ib(a.s);
                                    } catch (n) {
                                        throw new O(29);
                                    }
                                    if (void 0 === g && 0 === e) throw new O(6);
                                    if (null === g || void 0 === g) break;
                                    e++;
                                    b[c + f] = g;
                                }
                                e && (a.node.timestamp = Date.now());
                                return e;
                            },
                            write: function(a, b, c, d) {
                                if (!a.s || !a.s.V.Oa) throw new O(60);
                                try {
                                    for(var e = 0; e < d; e++)a.s.V.Oa(a.s, b[c + e]);
                                } catch (f) {
                                    throw new O(29);
                                }
                                d && (a.node.timestamp = Date.now());
                                return e;
                            }
                        }, wb = {
                            ib: function() {
                                a: {
                                    if (!ob.length) {
                                        var a = null;
                                        "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
                                        if (!a) {
                                            a = null;
                                            break a;
                                        }
                                        ob = rb(a, !0);
                                    }
                                    a = ob.shift();
                                }
                                return a;
                            },
                            Oa: function(a, b) {
                                null === b || 10 === b ? (wa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (wa(nb(a.F, 0)), a.F = []);
                            },
                            bc: function() {
                                return {
                                    Fc: 25856,
                                    Hc: 5,
                                    Ec: 191,
                                    Gc: 35387,
                                    Dc: [
                                        3,
                                        28,
                                        127,
                                        21,
                                        4,
                                        0,
                                        1,
                                        0,
                                        17,
                                        19,
                                        26,
                                        0,
                                        18,
                                        15,
                                        23,
                                        22,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ]
                                };
                            },
                            cc: function() {
                                return 0;
                            },
                            dc: function() {
                                return [
                                    24,
                                    80
                                ];
                            }
                        }, xb = {
                            Oa: function(a, b) {
                                null === b || 10 === b ? (xa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (xa(nb(a.F, 0)), a.F = []);
                            }
                        };
                        function yb(a, b) {
                            var c = a.j ? a.j.length : 0;
                            c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
                        }
                        var P = {
                            O: null,
                            U () {
                                return P.createNode(null, "/", 16895, 0);
                            },
                            createNode (a, b, c, d) {
                                if (24576 === (c & 61440) || 4096 === (c & 61440)) throw new O(63);
                                P.O || (P.O = {
                                    dir: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ka: P.l.ka,
                                            va: P.l.va,
                                            ub: P.l.ub,
                                            Ab: P.l.Ab,
                                            vb: P.l.vb,
                                            sb: P.l.sb,
                                            Ea: P.l.Ea
                                        },
                                        stream: {
                                            ba: P.m.ba
                                        }
                                    },
                                    file: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: {
                                            ba: P.m.ba,
                                            read: P.m.read,
                                            write: P.m.write,
                                            pa: P.m.pa,
                                            lb: P.m.lb,
                                            nb: P.m.nb
                                        }
                                    },
                                    link: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ma: P.l.ma
                                        },
                                        stream: {}
                                    },
                                    $a: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: zb
                                    }
                                });
                                c = Ab(a, b, c, d);
                                16384 === (c.mode & 61440) ? (c.l = P.O.dir.node, c.m = P.O.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = P.O.file.node, c.m = P.O.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = P.O.link.node, c.m = P.O.link.stream) : 8192 === (c.mode & 61440) && (c.l = P.O.$a.node, c.m = P.O.$a.stream);
                                c.timestamp = Date.now();
                                a && (a.j[b] = c, a.timestamp = c.timestamp);
                                return c;
                            },
                            Kc (a) {
                                return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
                            },
                            l: {
                                Y (a) {
                                    var b = {};
                                    b.Jc = 8192 === (a.mode & 61440) ? a.id : 1;
                                    b.Mc = a.id;
                                    b.mode = a.mode;
                                    b.Oc = 1;
                                    b.uid = 0;
                                    b.Lc = 0;
                                    b.za = a.za;
                                    16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
                                    b.Bc = new Date(a.timestamp);
                                    b.Nc = new Date(a.timestamp);
                                    b.Ic = new Date(a.timestamp);
                                    b.Jb = 4096;
                                    b.Cc = Math.ceil(b.size / b.Jb);
                                    return b;
                                },
                                P (a, b) {
                                    void 0 !== b.mode && (a.mode = b.mode);
                                    void 0 !== b.timestamp && (a.timestamp = b.timestamp);
                                    if (void 0 !== b.size && (b = b.size, a.v != b)) {
                                        if (0 == b) a.j = null, a.v = 0;
                                        else {
                                            var c = a.j;
                                            a.j = new Uint8Array(b);
                                            c && a.j.set(c.subarray(0, Math.min(b, a.v)));
                                            a.v = b;
                                        }
                                    }
                                },
                                ka () {
                                    throw Bb[44];
                                },
                                va (a, b, c, d) {
                                    return P.createNode(a, b, c, d);
                                },
                                ub (a, b, c) {
                                    if (16384 === (a.mode & 61440)) {
                                        try {
                                            var d = Cb(b, c);
                                        } catch (f) {}
                                        if (d) {
                                            for(var e in d.j)throw new O(55);
                                        }
                                    }
                                    delete a.parent.j[a.name];
                                    a.parent.timestamp = Date.now();
                                    a.name = c;
                                    b.j[c] = a;
                                    b.timestamp = a.parent.timestamp;
                                    a.parent = b;
                                },
                                Ab (a, b) {
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                vb (a, b) {
                                    var c = Cb(a, b), d;
                                    for(d in c.j)throw new O(55);
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                sb (a) {
                                    var b = [
                                        ".",
                                        ".."
                                    ], c;
                                    for(c in a.j)a.j.hasOwnProperty(c) && b.push(c);
                                    return b;
                                },
                                Ea (a, b, c) {
                                    a = P.createNode(a, b, 41471, 0);
                                    a.link = c;
                                    return a;
                                },
                                ma (a) {
                                    if (40960 !== (a.mode & 61440)) throw new O(28);
                                    return a.link;
                                }
                            },
                            m: {
                                read (a, b, c, d, e) {
                                    var f = a.node.j;
                                    if (e >= a.node.v) return 0;
                                    a = Math.min(a.node.v - e, d);
                                    if (8 < a && f.subarray) b.set(f.subarray(e, e + a), c);
                                    else for(d = 0; d < a; d++)b[c + d] = f[e + d];
                                    return a;
                                },
                                write (a, b, c, d, e, f) {
                                    b.buffer === B.buffer && (f = !1);
                                    if (!d) return 0;
                                    a = a.node;
                                    a.timestamp = Date.now();
                                    if (b.subarray && (!a.j || a.j.subarray)) {
                                        if (f) return a.j = b.subarray(c, c + d), a.v = d;
                                        if (0 === a.v && 0 === e) return a.j = b.slice(c, c + d), a.v = d;
                                        if (e + d <= a.v) return a.j.set(b.subarray(c, c + d), e), d;
                                    }
                                    yb(a, e + d);
                                    if (a.j.subarray && b.subarray) a.j.set(b.subarray(c, c + d), e);
                                    else for(f = 0; f < d; f++)a.j[e + f] = b[c + f];
                                    a.v = Math.max(a.v, e + d);
                                    return d;
                                },
                                ba (a, b, c) {
                                    1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
                                    if (0 > b) throw new O(28);
                                    return b;
                                },
                                pa (a, b, c) {
                                    yb(a.node, b + c);
                                    a.node.v = Math.max(a.node.v, b + c);
                                },
                                lb (a, b, c, d, e) {
                                    if (32768 !== (a.node.mode & 61440)) throw new O(43);
                                    a = a.node.j;
                                    if (e & 2 || a.buffer !== B.buffer) {
                                        if (0 < c || c + b < a.length) a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
                                        c = !0;
                                        Aa();
                                        b = void 0;
                                        if (!b) throw new O(48);
                                        B.set(a, b);
                                    } else c = !1, b = a.byteOffset;
                                    return {
                                        o: b,
                                        M: c
                                    };
                                },
                                nb (a, b, c, d) {
                                    P.m.write(a, b, 0, d, c, !1);
                                    return 0;
                                }
                            }
                        };
                        function Db(a, b) {
                            var c = 0;
                            a && (c |= 365);
                            b && (c |= 146);
                            return c;
                        }
                        var Eb = null, Fb = {}, Gb = [], Hb = 1, Ib = null, Jb = !0, O = null, Bb = {}, Lb = (a, b = {})=>{
                            a = lb(a);
                            if (!a) return {
                                path: "",
                                node: null
                            };
                            b = Object.assign({
                                gb: !0,
                                Qa: 0
                            }, b);
                            if (8 < b.Qa) throw new O(32);
                            a = a.split("/").filter((g)=>!!g);
                            for(var c = Eb, d = "/", e = 0; e < a.length; e++){
                                var f = e === a.length - 1;
                                if (f && b.parent) break;
                                c = Cb(c, a[e]);
                                d = gb(d + "/" + a[e]);
                                c.wa && (!f || f && b.gb) && (c = c.wa.root);
                                if (!f || b.fb) for(f = 0; 40960 === (c.mode & 61440);){
                                    if (c = Kb(d), d = lb(hb(d), c), c = Lb(d, {
                                        Qa: b.Qa + 1
                                    }).node, 40 < f++) throw new O(32);
                                }
                            }
                            return {
                                path: d,
                                node: c
                            };
                        }, Mb = (a)=>{
                            for(var b;;){
                                if (a === a.parent) return a = a.U.mb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
                                b = b ? `${a.name}/${b}` : a.name;
                                a = a.parent;
                            }
                        }, Nb = (a, b)=>{
                            for(var c = 0, d = 0; d < b.length; d++)c = (c << 5) - c + b.charCodeAt(d) | 0;
                            return (a + c >>> 0) % Ib.length;
                        }, Cb = (a, b)=>{
                            var c;
                            if (c = (c = Ob(a, "x")) ? c : a.l.ka ? 0 : 2) throw new O(c, a);
                            for(c = Ib[Nb(a.id, b)]; c; c = c.lc){
                                var d = c.name;
                                if (c.parent.id === a.id && d === b) return c;
                            }
                            return a.l.ka(a, b);
                        }, Ab = (a, b, c, d)=>{
                            a = new Pb(a, b, c, d);
                            b = Nb(a.parent.id, a.name);
                            a.lc = Ib[b];
                            return Ib[b] = a;
                        }, Qb = (a)=>{
                            var b = [
                                "r",
                                "w",
                                "rw"
                            ][a & 3];
                            a & 512 && (b += "w");
                            return b;
                        }, Ob = (a, b)=>{
                            if (Jb) return 0;
                            if (!b.includes("r") || a.mode & 292) {
                                if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) return 2;
                            } else return 2;
                            return 0;
                        }, Rb = (a, b)=>{
                            try {
                                return Cb(a, b), 20;
                            } catch (c) {}
                            return Ob(a, "wx");
                        }, Sb = ()=>{
                            for(var a = 0; 4096 >= a; a++){
                                if (!Gb[a]) return a;
                            }
                            throw new O(33);
                        }, Tb = (a)=>{
                            a = Gb[a];
                            if (!a) throw new O(8);
                            return a;
                        }, Vb = (a, b = -1)=>{
                            Ub || (Ub = function() {
                                this.h = {};
                            }, Ub.prototype = {}, Object.defineProperties(Ub.prototype, {
                                object: {
                                    get () {
                                        return this.node;
                                    },
                                    set (c) {
                                        this.node = c;
                                    }
                                },
                                flags: {
                                    get () {
                                        return this.h.flags;
                                    },
                                    set (c) {
                                        this.h.flags = c;
                                    }
                                },
                                position: {
                                    get () {
                                        return this.h.position;
                                    },
                                    set (c) {
                                        this.h.position = c;
                                    }
                                }
                            }));
                            a = Object.assign(new Ub(), a);
                            -1 == b && (b = Sb());
                            a.X = b;
                            return Gb[b] = a;
                        }, zb = {
                            open: (a)=>{
                                a.m = Fb[a.node.za].m;
                                a.m.open && a.m.open(a);
                            },
                            ba: ()=>{
                                throw new O(70);
                            }
                        }, ub = (a, b)=>{
                            Fb[a] = {
                                m: b
                            };
                        }, Wb = (a, b)=>{
                            var c = "/" === b, d = !b;
                            if (c && Eb) throw new O(10);
                            if (!c && !d) {
                                var e = Lb(b, {
                                    gb: !1
                                });
                                b = e.path;
                                e = e.node;
                                if (e.wa) throw new O(10);
                                if (16384 !== (e.mode & 61440)) throw new O(54);
                            }
                            b = {
                                type: a,
                                Qc: {},
                                mb: b,
                                kc: []
                            };
                            a = a.U(b);
                            a.U = b;
                            b.root = a;
                            c ? Eb = a : e && (e.wa = b, e.U && e.U.kc.push(b));
                        }, S = (a, b, c)=>{
                            var d = Lb(a, {
                                parent: !0
                            }).node;
                            a = ib(a);
                            if (!a || "." === a || ".." === a) throw new O(28);
                            var e = Rb(d, a);
                            if (e) throw new O(e);
                            if (!d.l.va) throw new O(63);
                            return d.l.va(d, a, b, c);
                        }, Xb = (a, b, c)=>{
                            "undefined" == typeof c && (c = b, b = 438);
                            S(a, b | 8192, c);
                        }, cc = (a, b)=>{
                            if (!lb(a)) throw new O(44);
                            var c = Lb(b, {
                                parent: !0
                            }).node;
                            if (!c) throw new O(44);
                            b = ib(b);
                            var d = Rb(c, b);
                            if (d) throw new O(d);
                            if (!c.l.Ea) throw new O(63);
                            c.l.Ea(c, b, a);
                        }, Kb = (a)=>{
                            a = Lb(a).node;
                            if (!a) throw new O(44);
                            if (!a.l.ma) throw new O(28);
                            return lb(Mb(a.parent), a.l.ma(a));
                        }, ec = (a, b, c)=>{
                            if ("" === a) throw new O(44);
                            if ("string" == typeof b) {
                                var d = {
                                    r: 0,
                                    "r+": 2,
                                    w: 577,
                                    "w+": 578,
                                    a: 1089,
                                    "a+": 1090
                                }[b];
                                if ("undefined" == typeof d) throw Error(`Unknown file open mode: ${b}`);
                                b = d;
                            }
                            c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
                            if ("object" == typeof a) var e = a;
                            else {
                                a = gb(a);
                                try {
                                    e = Lb(a, {
                                        fb: !(b & 131072)
                                    }).node;
                                } catch (f) {}
                            }
                            d = !1;
                            if (b & 64) {
                                if (e) {
                                    if (b & 128) throw new O(20);
                                } else e = S(a, c, 0), d = !0;
                            }
                            if (!e) throw new O(44);
                            8192 === (e.mode & 61440) && (b &= -513);
                            if (b & 65536 && 16384 !== (e.mode & 61440)) throw new O(54);
                            if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Qb(b) || b & 512) ? 31 : Ob(e, Qb(b)) : 44)) throw new O(c);
                            if (b & 512 && !d) {
                                c = e;
                                c = "string" == typeof c ? Lb(c, {
                                    fb: !0
                                }).node : c;
                                if (!c.l.P) throw new O(63);
                                if (16384 === (c.mode & 61440)) throw new O(31);
                                if (32768 !== (c.mode & 61440)) throw new O(28);
                                if (d = Ob(c, "w")) throw new O(d);
                                c.l.P(c, {
                                    size: 0,
                                    timestamp: Date.now()
                                });
                            }
                            b &= -131713;
                            e = Vb({
                                node: e,
                                path: Mb(e),
                                flags: b,
                                seekable: !0,
                                position: 0,
                                m: e.m,
                                zc: [],
                                error: !1
                            });
                            e.m.open && e.m.open(e);
                            !m.logReadFiles || b & 1 || (dc || (dc = {}), a in dc || (dc[a] = 1));
                            return e;
                        }, fc = (a, b, c)=>{
                            if (null === a.X) throw new O(8);
                            if (!a.seekable || !a.m.ba) throw new O(70);
                            if (0 != c && 1 != c && 2 != c) throw new O(28);
                            a.position = a.m.ba(a, b, c);
                            a.zc = [];
                        }, gc = ()=>{
                            O || (O = function(a, b) {
                                this.name = "ErrnoError";
                                this.node = b;
                                this.pc = function(c) {
                                    this.aa = c;
                                };
                                this.pc(a);
                                this.message = "FS error";
                            }, O.prototype = Error(), O.prototype.constructor = O, [
                                44
                            ].forEach((a)=>{
                                Bb[a] = new O(a);
                                Bb[a].stack = "<generic error, no stack>";
                            }));
                        }, hc, jc = (a, b, c)=>{
                            a = gb("/dev/" + a);
                            var d = Db(!!b, !!c);
                            ic || (ic = 64);
                            var e = ic++ << 8 | 0;
                            ub(e, {
                                open: (f)=>{
                                    f.seekable = !1;
                                },
                                close: ()=>{
                                    c && c.buffer && c.buffer.length && c(10);
                                },
                                read: (f, g, n, p)=>{
                                    for(var l = 0, u = 0; u < p; u++){
                                        try {
                                            var v = b();
                                        } catch (x) {
                                            throw new O(29);
                                        }
                                        if (void 0 === v && 0 === l) throw new O(6);
                                        if (null === v || void 0 === v) break;
                                        l++;
                                        g[n + u] = v;
                                    }
                                    l && (f.node.timestamp = Date.now());
                                    return l;
                                },
                                write: (f, g, n, p)=>{
                                    for(var l = 0; l < p; l++)try {
                                        c(g[n + l]);
                                    } catch (u) {
                                        throw new O(29);
                                    }
                                    p && (f.node.timestamp = Date.now());
                                    return l;
                                }
                            });
                            Xb(a, d, e);
                        }, ic, kc = {}, Ub, dc, lc = void 0;
                        function mc() {
                            lc += 4;
                            return L[lc - 4 >> 2];
                        }
                        function nc(a) {
                            if (void 0 === a) return "_unknown";
                            a = a.replace(/[^a-zA-Z0-9_]/g, "$");
                            var b = a.charCodeAt(0);
                            return 48 <= b && 57 >= b ? `_${a}` : a;
                        }
                        function oc(a, b) {
                            a = nc(a);
                            return ({
                                [a]: function() {
                                    return b.apply(this, arguments);
                                }
                            })[a];
                        }
                        function pc() {
                            this.M = [
                                void 0
                            ];
                            this.hb = [];
                        }
                        var U = new pc(), qc = void 0;
                        function V(a) {
                            throw new qc(a);
                        }
                        var rc = (a)=>{
                            a || V("Cannot use deleted val. handle = " + a);
                            return U.get(a).value;
                        }, sc = (a)=>{
                            switch(a){
                                case void 0:
                                    return 1;
                                case null:
                                    return 2;
                                case !0:
                                    return 3;
                                case !1:
                                    return 4;
                                default:
                                    return U.pa({
                                        tb: 1,
                                        value: a
                                    });
                            }
                        };
                        function tc(a) {
                            var b = Error, c = oc(a, function(d) {
                                this.name = a;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(b.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
                            };
                            return c;
                        }
                        var uc = void 0, vc = void 0;
                        function W(a) {
                            for(var b = ""; E[a];)b += vc[E[a++]];
                            return b;
                        }
                        var wc = [];
                        function xc() {
                            for(; wc.length;){
                                var a = wc.pop();
                                a.g.fa = !1;
                                a["delete"]();
                            }
                        }
                        var yc = void 0, zc = {};
                        function Ac(a, b) {
                            for(void 0 === b && V("ptr should not be undefined"); a.A;)b = a.na(b), a = a.A;
                            return b;
                        }
                        var Bc = {};
                        function Cc(a) {
                            a = Dc(a);
                            var b = W(a);
                            Ec(a);
                            return b;
                        }
                        function Fc(a, b) {
                            var c = Bc[a];
                            void 0 === c && V(b + " has unknown type " + Cc(a));
                            return c;
                        }
                        function Gc() {}
                        var Hc = !1;
                        function Ic(a) {
                            --a.count.value;
                            0 === a.count.value && (a.G ? a.L.W(a.G) : a.u.i.W(a.o));
                        }
                        function Jc(a, b, c) {
                            if (b === c) return a;
                            if (void 0 === c.A) return null;
                            a = Jc(a, b, c.A);
                            return null === a ? null : c.Pb(a);
                        }
                        var Kc = {};
                        function Lc(a, b) {
                            b = Ac(a, b);
                            return zc[b];
                        }
                        var Mc = void 0;
                        function Nc(a) {
                            throw new Mc(a);
                        }
                        function Oc(a, b) {
                            b.u && b.o || Nc("makeClassHandle requires ptr and ptrType");
                            !!b.L !== !!b.G && Nc("Both smartPtrType and smartPtr must be specified");
                            b.count = {
                                value: 1
                            };
                            return Pc(Object.create(a, {
                                g: {
                                    value: b
                                }
                            }));
                        }
                        function Pc(a) {
                            if ("undefined" === typeof FinalizationRegistry) return Pc = (b)=>b, a;
                            Hc = new FinalizationRegistry((b)=>{
                                Ic(b.g);
                            });
                            Pc = (b)=>{
                                var c = b.g;
                                c.G && Hc.register(b, {
                                    g: c
                                }, b);
                                return b;
                            };
                            Gc = (b)=>{
                                Hc.unregister(b);
                            };
                            return Pc(a);
                        }
                        var Qc = {};
                        function Rc(a) {
                            for(; a.length;){
                                var b = a.pop();
                                a.pop()(b);
                            }
                        }
                        function Sc(a) {
                            return this.fromWireType(L[a >> 2]);
                        }
                        var Tc = {}, Uc = {};
                        function Y(a, b, c) {
                            function d(n) {
                                n = c(n);
                                n.length !== a.length && Nc("Mismatched type converter count");
                                for(var p = 0; p < a.length; ++p)Vc(a[p], n[p]);
                            }
                            a.forEach(function(n) {
                                Uc[n] = b;
                            });
                            var e = Array(b.length), f = [], g = 0;
                            b.forEach((n, p)=>{
                                Bc.hasOwnProperty(n) ? e[p] = Bc[n] : (f.push(n), Tc.hasOwnProperty(n) || (Tc[n] = []), Tc[n].push(()=>{
                                    e[p] = Bc[n];
                                    ++g;
                                    g === f.length && d(e);
                                }));
                            });
                            0 === f.length && d(e);
                        }
                        function Wc(a) {
                            switch(a){
                                case 1:
                                    return 0;
                                case 2:
                                    return 1;
                                case 4:
                                    return 2;
                                case 8:
                                    return 3;
                                default:
                                    throw new TypeError(`Unknown type size: ${a}`);
                            }
                        }
                        function Xc(a, b, c = {}) {
                            var d = b.name;
                            a || V(`type "${d}" must have a positive integer typeid pointer`);
                            if (Bc.hasOwnProperty(a)) {
                                if (c.$b) return;
                                V(`Cannot register type '${d}' twice`);
                            }
                            Bc[a] = b;
                            delete Uc[a];
                            Tc.hasOwnProperty(a) && (b = Tc[a], delete Tc[a], b.forEach((e)=>e()));
                        }
                        function Vc(a, b, c = {}) {
                            if (!("argPackAdvance" in b)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            Xc(a, b, c);
                        }
                        function Yc(a) {
                            V(a.g.u.i.name + " instance already deleted");
                        }
                        function Zc() {}
                        function $c(a, b, c) {
                            if (void 0 === a[b].B) {
                                var d = a[b];
                                a[b] = function() {
                                    a[b].B.hasOwnProperty(arguments.length) || V(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
                                    return a[b].B[arguments.length].apply(this, arguments);
                                };
                                a[b].B = [];
                                a[b].B[d.ea] = d;
                            }
                        }
                        function ad(a, b, c) {
                            m.hasOwnProperty(a) ? ((void 0 === c || void 0 !== m[a].B && void 0 !== m[a].B[c]) && V(`Cannot register public name '${a}' twice`), $c(m, a, a), m.hasOwnProperty(c) && V(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), m[a].B[c] = b) : (m[a] = b, void 0 !== c && (m[a].Pc = c));
                        }
                        function bd(a, b, c, d, e, f, g, n) {
                            this.name = a;
                            this.constructor = b;
                            this.N = c;
                            this.W = d;
                            this.A = e;
                            this.Ub = f;
                            this.na = g;
                            this.Pb = n;
                            this.qb = [];
                        }
                        function cd(a, b, c) {
                            for(; b !== c;)b.na || V(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.na(a), b = b.A;
                            return a;
                        }
                        function dd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function fd(a, b) {
                            if (null === b) {
                                this.Na && V(`null is not a valid ${this.name}`);
                                if (this.ua) {
                                    var c = this.Pa();
                                    null !== a && a.push(this.W, c);
                                    return c;
                                }
                                return 0;
                            }
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            !this.ta && b.g.u.ta && V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                            c = cd(b.g.o, b.g.u.i, this.i);
                            if (this.ua) switch(void 0 === b.g.G && V("Passing raw pointer to smart pointer is illegal"), this.tc){
                                case 0:
                                    b.g.L === this ? c = b.g.G : V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                                    break;
                                case 1:
                                    c = b.g.G;
                                    break;
                                case 2:
                                    if (b.g.L === this) c = b.g.G;
                                    else {
                                        var d = b.clone();
                                        c = this.oc(c, sc(function() {
                                            d["delete"]();
                                        }));
                                        null !== a && a.push(this.W, c);
                                    }
                                    break;
                                default:
                                    V("Unsupporting sharing policy");
                            }
                            return c;
                        }
                        function gd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            b.g.u.ta && V(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function hd(a, b, c, d) {
                            this.name = a;
                            this.i = b;
                            this.Na = c;
                            this.ta = d;
                            this.ua = !1;
                            this.W = this.oc = this.Pa = this.rb = this.tc = this.nc = void 0;
                            void 0 !== b.A ? this.toWireType = fd : (this.toWireType = d ? dd : gd, this.K = null);
                        }
                        function jd(a, b, c) {
                            m.hasOwnProperty(a) || Nc("Replacing nonexistant public symbol");
                            void 0 !== m[a].B && void 0 !== c ? m[a].B[c] = b : (m[a] = b, m[a].ea = c);
                        }
                        var kd = [], ld = (a)=>{
                            var b = kd[a];
                            b || (a >= kd.length && (kd.length = a + 1), kd[a] = b = Ka.get(a));
                            return b;
                        }, md = (a, b)=>{
                            var c = [];
                            return function() {
                                c.length = 0;
                                Object.assign(c, arguments);
                                if (a.includes("j")) {
                                    var d = m["dynCall_" + a];
                                    d = c && c.length ? d.apply(null, [
                                        b
                                    ].concat(c)) : d.call(null, b);
                                } else d = ld(b).apply(null, c);
                                return d;
                            };
                        };
                        function Z(a, b) {
                            a = W(a);
                            var c = a.includes("j") ? md(a, b) : ld(b);
                            "function" != typeof c && V(`unknown function pointer with signature ${a}: ${b}`);
                            return c;
                        }
                        var nd = void 0;
                        function od(a, b) {
                            function c(f) {
                                e[f] || Bc[f] || (Uc[f] ? Uc[f].forEach(c) : (d.push(f), e[f] = !0));
                            }
                            var d = [], e = {};
                            b.forEach(c);
                            throw new nd(`${a}: ` + d.map(Cc).join([
                                ", "
                            ]));
                        }
                        function pd(a, b, c, d, e) {
                            var f = b.length;
                            2 > f && V("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var g = null !== b[1] && null !== c, n = !1;
                            for(c = 1; c < b.length; ++c)if (null !== b[c] && void 0 === b[c].K) {
                                n = !0;
                                break;
                            }
                            var p = "void" !== b[0].name, l = f - 2, u = Array(l), v = [], x = [];
                            return function() {
                                arguments.length !== l && V(`function ${a} called with ${arguments.length} arguments, expected ${l} args!`);
                                x.length = 0;
                                v.length = g ? 2 : 1;
                                v[0] = e;
                                if (g) {
                                    var k = b[1].toWireType(x, this);
                                    v[1] = k;
                                }
                                for(var t = 0; t < l; ++t)u[t] = b[t + 2].toWireType(x, arguments[t]), v.push(u[t]);
                                t = d.apply(null, v);
                                if (n) Rc(x);
                                else for(var r = g ? 1 : 2; r < b.length; r++){
                                    var A = 1 === r ? k : u[r - 2];
                                    null !== b[r].K && b[r].K(A);
                                }
                                k = p ? b[0].fromWireType(t) : void 0;
                                return k;
                            };
                        }
                        function rd(a, b) {
                            for(var c = [], d = 0; d < a; d++)c.push(N[b + 4 * d >> 2]);
                            return c;
                        }
                        function sd(a, b, c) {
                            a instanceof Object || V(`${c} with invalid "this": ${a}`);
                            a instanceof b.i.constructor || V(`${c} incompatible with "this" of type ${a.constructor.name}`);
                            a.g.o || V(`cannot call emscripten binding method ${c} on deleted object`);
                            return cd(a.g.o, a.g.u.i, b.i);
                        }
                        function td(a) {
                            a >= U.h && 0 === --U.get(a).tb && U.Zb(a);
                        }
                        function ud(a, b, c) {
                            switch(b){
                                case 0:
                                    return function(d) {
                                        return this.fromWireType((c ? B : E)[d]);
                                    };
                                case 1:
                                    return function(d) {
                                        return this.fromWireType((c ? Da : Ea)[d >> 1]);
                                    };
                                case 2:
                                    return function(d) {
                                        return this.fromWireType((c ? L : N)[d >> 2]);
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        function ed(a) {
                            if (null === a) return "null";
                            var b = typeof a;
                            return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
                        }
                        function vd(a, b) {
                            switch(b){
                                case 2:
                                    return function(c) {
                                        return this.fromWireType(Fa[c >> 2]);
                                    };
                                case 3:
                                    return function(c) {
                                        return this.fromWireType(Ia[c >> 3]);
                                    };
                                default:
                                    throw new TypeError("Unknown float type: " + a);
                            }
                        }
                        function wd(a, b, c) {
                            switch(b){
                                case 0:
                                    return c ? function(d) {
                                        return B[d];
                                    } : function(d) {
                                        return E[d];
                                    };
                                case 1:
                                    return c ? function(d) {
                                        return Da[d >> 1];
                                    } : function(d) {
                                        return Ea[d >> 1];
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return L[d >> 2];
                                    } : function(d) {
                                        return N[d >> 2];
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        var xd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, yd = (a, b)=>{
                            var c = a >> 1;
                            for(var d = c + b / 2; !(c >= d) && Ea[c];)++c;
                            c <<= 1;
                            if (32 < c - a && xd) return xd.decode(E.subarray(a, c));
                            c = "";
                            for(d = 0; !(d >= b / 2); ++d){
                                var e = Da[a + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, zd = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (2 > c) return 0;
                            c -= 2;
                            var d = b;
                            c = c < 2 * a.length ? c / 2 : a.length;
                            for(var e = 0; e < c; ++e)Da[b >> 1] = a.charCodeAt(e), b += 2;
                            Da[b >> 1] = 0;
                            return b - d;
                        }, Ad = (a)=>2 * a.length, Bd = (a, b)=>{
                            for(var c = 0, d = ""; !(c >= b / 4);){
                                var e = L[a + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, Cd = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (4 > c) return 0;
                            var d = b;
                            c = d + c - 4;
                            for(var e = 0; e < a.length; ++e){
                                var f = a.charCodeAt(e);
                                if (55296 <= f && 57343 >= f) {
                                    var g = a.charCodeAt(++e);
                                    f = 65536 + ((f & 1023) << 10) | g & 1023;
                                }
                                L[b >> 2] = f;
                                b += 4;
                                if (b + 4 > c) break;
                            }
                            L[b >> 2] = 0;
                            return b - d;
                        }, Dd = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                b += 4;
                            }
                            return b;
                        }, Ed = {};
                        function Fd(a) {
                            var b = Ed[a];
                            return void 0 === b ? W(a) : b;
                        }
                        var Gd = [];
                        function Hd(a) {
                            var b = Gd.length;
                            Gd.push(a);
                            return b;
                        }
                        function Id(a, b) {
                            for(var c = Array(a), d = 0; d < a; ++d)c[d] = Fc(N[b + 4 * d >> 2], "parameter " + d);
                            return c;
                        }
                        var Jd = [], Kd = [], Ld = {}, Nd = ()=>{
                            if (!Md) {
                                var a = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: na || "./this.program"
                                }, b;
                                for(b in Ld)void 0 === Ld[b] ? delete a[b] : a[b] = Ld[b];
                                var c = [];
                                for(b in a)c.push(`${b}=${a[b]}`);
                                Md = c;
                            }
                            return Md;
                        }, Md, Od = (a)=>0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Pd = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Qd = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Rd = (a, b, c, d)=>{
                            function e(k, t, r) {
                                for(k = "number" == typeof k ? k.toString() : k || ""; k.length < t;)k = r[0] + k;
                                return k;
                            }
                            function f(k, t) {
                                return e(k, t, "0");
                            }
                            function g(k, t) {
                                function r(D) {
                                    return 0 > D ? -1 : 0 < D ? 1 : 0;
                                }
                                var A;
                                0 === (A = r(k.getFullYear() - t.getFullYear())) && 0 === (A = r(k.getMonth() - t.getMonth())) && (A = r(k.getDate() - t.getDate()));
                                return A;
                            }
                            function n(k) {
                                switch(k.getDay()){
                                    case 0:
                                        return new Date(k.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return k;
                                    case 2:
                                        return new Date(k.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(k.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(k.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(k.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(k.getFullYear() - 1, 11, 30);
                                }
                            }
                            function p(k) {
                                var t = k.ca;
                                for(k = new Date(new Date(k.da + 1900, 0, 1).getTime()); 0 < t;){
                                    var r = k.getMonth(), A = (Od(k.getFullYear()) ? Pd : Qd)[r];
                                    if (t > A - k.getDate()) t -= A - k.getDate() + 1, k.setDate(1), 11 > r ? k.setMonth(r + 1) : (k.setMonth(0), k.setFullYear(k.getFullYear() + 1));
                                    else {
                                        k.setDate(k.getDate() + t);
                                        break;
                                    }
                                }
                                r = new Date(k.getFullYear() + 1, 0, 4);
                                t = n(new Date(k.getFullYear(), 0, 4));
                                r = n(r);
                                return 0 >= g(t, k) ? 0 >= g(r, k) ? k.getFullYear() + 1 : k.getFullYear() : k.getFullYear() - 1;
                            }
                            var l = L[d + 40 >> 2];
                            d = {
                                wc: L[d >> 2],
                                vc: L[d + 4 >> 2],
                                Fa: L[d + 8 >> 2],
                                Sa: L[d + 12 >> 2],
                                Ga: L[d + 16 >> 2],
                                da: L[d + 20 >> 2],
                                R: L[d + 24 >> 2],
                                ca: L[d + 28 >> 2],
                                Rc: L[d + 32 >> 2],
                                uc: L[d + 36 >> 2],
                                xc: l ? l ? nb(E, l) : "" : ""
                            };
                            c = c ? nb(E, c) : "";
                            l = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var u in l)c = c.replace(new RegExp(u, "g"), l[u]);
                            var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
                            l = {
                                "%a": (k)=>v[k.R].substring(0, 3),
                                "%A": (k)=>v[k.R],
                                "%b": (k)=>x[k.Ga].substring(0, 3),
                                "%B": (k)=>x[k.Ga],
                                "%C": (k)=>f((k.da + 1900) / 100 | 0, 2),
                                "%d": (k)=>f(k.Sa, 2),
                                "%e": (k)=>e(k.Sa, 2, " "),
                                "%g": (k)=>p(k).toString().substring(2),
                                "%G": (k)=>p(k),
                                "%H": (k)=>f(k.Fa, 2),
                                "%I": (k)=>{
                                    k = k.Fa;
                                    0 == k ? k = 12 : 12 < k && (k -= 12);
                                    return f(k, 2);
                                },
                                "%j": (k)=>{
                                    for(var t = 0, r = 0; r <= k.Ga - 1; t += (Od(k.da + 1900) ? Pd : Qd)[r++]);
                                    return f(k.Sa + t, 3);
                                },
                                "%m": (k)=>f(k.Ga + 1, 2),
                                "%M": (k)=>f(k.vc, 2),
                                "%n": ()=>"\n",
                                "%p": (k)=>0 <= k.Fa && 12 > k.Fa ? "AM" : "PM",
                                "%S": (k)=>f(k.wc, 2),
                                "%t": ()=>"	",
                                "%u": (k)=>k.R || 7,
                                "%U": (k)=>f(Math.floor((k.ca + 7 - k.R) / 7), 2),
                                "%V": (k)=>{
                                    var t = Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7);
                                    2 >= (k.R + 371 - k.ca - 2) % 7 && t++;
                                    if (t) 53 == t && (r = (k.R + 371 - k.ca) % 7, 4 == r || 3 == r && Od(k.da) || (t = 1));
                                    else {
                                        t = 52;
                                        var r = (k.R + 7 - k.ca - 1) % 7;
                                        (4 == r || 5 == r && Od(k.da % 400 - 1)) && t++;
                                    }
                                    return f(t, 2);
                                },
                                "%w": (k)=>k.R,
                                "%W": (k)=>f(Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7), 2),
                                "%y": (k)=>(k.da + 1900).toString().substring(2),
                                "%Y": (k)=>k.da + 1900,
                                "%z": (k)=>{
                                    k = k.uc;
                                    var t = 0 <= k;
                                    k = Math.abs(k) / 60;
                                    return (t ? "+" : "-") + String("0000" + (k / 60 * 100 + k % 60)).slice(-4);
                                },
                                "%Z": (k)=>k.xc,
                                "%%": ()=>"%"
                            };
                            c = c.replace(/%%/g, "\0\0");
                            for(u in l)c.includes(u) && (c = c.replace(new RegExp(u, "g"), l[u](d)));
                            c = c.replace(/\0\0/g, "%");
                            u = rb(c, !1);
                            if (u.length > b) return 0;
                            B.set(u, a);
                            return u.length - 1;
                        };
                        function Pb(a, b, c, d) {
                            a || (a = this);
                            this.parent = a;
                            this.U = a.U;
                            this.wa = null;
                            this.id = Hb++;
                            this.name = b;
                            this.mode = c;
                            this.l = {};
                            this.m = {};
                            this.za = d;
                        }
                        Object.defineProperties(Pb.prototype, {
                            read: {
                                get: function() {
                                    return 365 === (this.mode & 365);
                                },
                                set: function(a) {
                                    a ? this.mode |= 365 : this.mode &= -366;
                                }
                            },
                            write: {
                                get: function() {
                                    return 146 === (this.mode & 146);
                                },
                                set: function(a) {
                                    a ? this.mode |= 146 : this.mode &= -147;
                                }
                            }
                        });
                        gc();
                        Ib = Array(4096);
                        Wb(P, "/");
                        S("/tmp", 16895, 0);
                        S("/home", 16895, 0);
                        S("/home/web_user", 16895, 0);
                        (()=>{
                            S("/dev", 16895, 0);
                            ub(259, {
                                read: ()=>0,
                                write: (d, e, f, g)=>g
                            });
                            Xb("/dev/null", 259);
                            tb(1280, wb);
                            tb(1536, xb);
                            Xb("/dev/tty", 1280);
                            Xb("/dev/tty1", 1536);
                            var a = new Uint8Array(1024), b = 0, c = ()=>{
                                0 === b && (b = kb(a).byteLength);
                                return a[--b];
                            };
                            jc("random", c);
                            jc("urandom", c);
                            S("/dev/shm", 16895, 0);
                            S("/dev/shm/tmp", 16895, 0);
                        })();
                        (()=>{
                            S("/proc", 16895, 0);
                            var a = S("/proc/self", 16895, 0);
                            S("/proc/self/fd", 16895, 0);
                            Wb({
                                U: ()=>{
                                    var b = Ab(a, "fd", 16895, 73);
                                    b.l = {
                                        ka: (c, d)=>{
                                            var e = Tb(+d);
                                            c = {
                                                parent: null,
                                                U: {
                                                    mb: "fake"
                                                },
                                                l: {
                                                    ma: ()=>e.path
                                                }
                                            };
                                            return c.parent = c;
                                        }
                                    };
                                    return b;
                                }
                            }, "/proc/self/fd");
                        })();
                        Object.assign(pc.prototype, {
                            get (a) {
                                return this.M[a];
                            },
                            has (a) {
                                return void 0 !== this.M[a];
                            },
                            pa (a) {
                                var b = this.hb.pop() || this.M.length;
                                this.M[b] = a;
                                return b;
                            },
                            Zb (a) {
                                this.M[a] = void 0;
                                this.hb.push(a);
                            }
                        });
                        qc = m.BindingError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "BindingError";
                            }
                        };
                        U.M.push({
                            value: void 0
                        }, {
                            value: null
                        }, {
                            value: !0
                        }, {
                            value: !1
                        });
                        U.h = U.M.length;
                        m.count_emval_handles = function() {
                            for(var a = 0, b = U.h; b < U.M.length; ++b)void 0 !== U.M[b] && ++a;
                            return a;
                        };
                        uc = m.PureVirtualError = tc("PureVirtualError");
                        for(var Sd = Array(256), Td = 0; 256 > Td; ++Td)Sd[Td] = String.fromCharCode(Td);
                        vc = Sd;
                        m.getInheritedInstanceCount = function() {
                            return Object.keys(zc).length;
                        };
                        m.getLiveInheritedInstances = function() {
                            var a = [], b;
                            for(b in zc)zc.hasOwnProperty(b) && a.push(zc[b]);
                            return a;
                        };
                        m.flushPendingDeletes = xc;
                        m.setDelayFunction = function(a) {
                            yc = a;
                            wc.length && yc && yc(xc);
                        };
                        Mc = m.InternalError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "InternalError";
                            }
                        };
                        Zc.prototype.isAliasOf = function(a) {
                            if (!(this instanceof Zc && a instanceof Zc)) return !1;
                            var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
                            for(a = a.g.o; b.A;)c = b.na(c), b = b.A;
                            for(; d.A;)a = d.na(a), d = d.A;
                            return b === d && c === a;
                        };
                        Zc.prototype.clone = function() {
                            this.g.o || Yc(this);
                            if (this.g.ia) return this.g.count.value += 1, this;
                            var a = Pc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
                            a = a(c.call(b, d, {
                                g: {
                                    value: {
                                        count: e.count,
                                        fa: e.fa,
                                        ia: e.ia,
                                        o: e.o,
                                        u: e.u,
                                        G: e.G,
                                        L: e.L
                                    }
                                }
                            }));
                            a.g.count.value += 1;
                            a.g.fa = !1;
                            return a;
                        };
                        Zc.prototype["delete"] = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            Gc(this);
                            Ic(this.g);
                            this.g.ia || (this.g.G = void 0, this.g.o = void 0);
                        };
                        Zc.prototype.isDeleted = function() {
                            return !this.g.o;
                        };
                        Zc.prototype.deleteLater = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            wc.push(this);
                            1 === wc.length && yc && yc(xc);
                            this.g.fa = !0;
                            return this;
                        };
                        hd.prototype.Vb = function(a) {
                            this.rb && (a = this.rb(a));
                            return a;
                        };
                        hd.prototype.ab = function(a) {
                            this.W && this.W(a);
                        };
                        hd.prototype.argPackAdvance = 8;
                        hd.prototype.readValueFromPointer = Sc;
                        hd.prototype.deleteObject = function(a) {
                            if (null !== a) a["delete"]();
                        };
                        hd.prototype.fromWireType = function(a) {
                            function b() {
                                return this.ua ? Oc(this.i.N, {
                                    u: this.nc,
                                    o: c,
                                    L: this,
                                    G: a
                                }) : Oc(this.i.N, {
                                    u: this,
                                    o: a
                                });
                            }
                            var c = this.Vb(a);
                            if (!c) return this.ab(a), null;
                            var d = Lc(this.i, c);
                            if (void 0 !== d) {
                                if (0 === d.g.count.value) return d.g.o = c, d.g.G = a, d.clone();
                                d = d.clone();
                                this.ab(a);
                                return d;
                            }
                            d = this.i.Ub(c);
                            d = Kc[d];
                            if (!d) return b.call(this);
                            d = this.ta ? d.Kb : d.pointerType;
                            var e = Jc(c, this.i, d.i);
                            return null === e ? b.call(this) : this.ua ? Oc(d.i.N, {
                                u: d,
                                o: e,
                                L: this,
                                G: a
                            }) : Oc(d.i.N, {
                                u: d,
                                o: e
                            });
                        };
                        nd = m.UnboundTypeError = tc("UnboundTypeError");
                        var Wd = {
                            __syscall_fcntl64: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 0:
                                            var e = mc();
                                            return 0 > e ? -28 : Vb(d, e).X;
                                        case 1:
                                        case 2:
                                            return 0;
                                        case 3:
                                            return d.flags;
                                        case 4:
                                            return e = mc(), d.flags |= e, 0;
                                        case 5:
                                            return e = mc(), Da[e + 0 >> 1] = 2, 0;
                                        case 6:
                                        case 7:
                                            return 0;
                                        case 16:
                                        case 8:
                                            return -28;
                                        case 9:
                                            return L[Ud() >> 2] = 28, -1;
                                        default:
                                            return -28;
                                    }
                                } catch (f) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== f.name) throw f;
                                    return -f.aa;
                                }
                            },
                            __syscall_ioctl: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 21509:
                                            return d.s ? 0 : -59;
                                        case 21505:
                                            if (!d.s) return -59;
                                            if (d.s.V.bc) {
                                                b = [
                                                    3,
                                                    28,
                                                    127,
                                                    21,
                                                    4,
                                                    0,
                                                    1,
                                                    0,
                                                    17,
                                                    19,
                                                    26,
                                                    0,
                                                    18,
                                                    15,
                                                    23,
                                                    22,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                var e = mc();
                                                L[e >> 2] = 25856;
                                                L[e + 4 >> 2] = 5;
                                                L[e + 8 >> 2] = 191;
                                                L[e + 12 >> 2] = 35387;
                                                for(var f = 0; 32 > f; f++)B[e + f + 17 >> 0] = b[f] || 0;
                                            }
                                            return 0;
                                        case 21510:
                                        case 21511:
                                        case 21512:
                                            return d.s ? 0 : -59;
                                        case 21506:
                                        case 21507:
                                        case 21508:
                                            if (!d.s) return -59;
                                            if (d.s.V.cc) for(e = mc(), b = [], f = 0; 32 > f; f++)b.push(B[e + f + 17 >> 0]);
                                            return 0;
                                        case 21519:
                                            if (!d.s) return -59;
                                            e = mc();
                                            return L[e >> 2] = 0;
                                        case 21520:
                                            return d.s ? -28 : -59;
                                        case 21531:
                                            e = mc();
                                            if (!d.m.ac) throw new O(59);
                                            return d.m.ac(d, b, e);
                                        case 21523:
                                            if (!d.s) return -59;
                                            d.s.V.dc && (f = [
                                                24,
                                                80
                                            ], e = mc(), Da[e >> 1] = f[0], Da[e + 2 >> 1] = f[1]);
                                            return 0;
                                        case 21524:
                                            return d.s ? 0 : -59;
                                        case 21515:
                                            return d.s ? 0 : -59;
                                        default:
                                            return -28;
                                    }
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return -g.aa;
                                }
                            },
                            __syscall_openat: function(a, b, c, d) {
                                lc = d;
                                try {
                                    b = b ? nb(E, b) : "";
                                    var e = b;
                                    if ("/" === e.charAt(0)) b = e;
                                    else {
                                        var f = -100 === a ? "/" : Tb(a).path;
                                        if (0 == e.length) throw new O(44);
                                        b = gb(f + "/" + e);
                                    }
                                    var g = d ? mc() : 0;
                                    return ec(b, c, g).X;
                                } catch (n) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== n.name) throw n;
                                    return -n.aa;
                                }
                            },
                            _embind_create_inheriting_constructor: function(a, b, c) {
                                a = W(a);
                                b = Fc(b, "wrapper");
                                c = rc(c);
                                var d = [].slice, e = b.i, f = e.N, g = e.A.N, n = e.A.constructor;
                                a = oc(a, function() {
                                    e.A.qb.forEach((function(l) {
                                        if (this[l] === g[l]) throw new uc(`Pure virtual function ${l} must be implemented in JavaScript`);
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: f
                                    });
                                    this.__construct.apply(this, d.call(arguments));
                                });
                                f.__construct = function() {
                                    this === f && V("Pass correct 'this' to __construct");
                                    var l = n.implement.apply(void 0, [
                                        this
                                    ].concat(d.call(arguments)));
                                    Gc(l);
                                    var u = l.g;
                                    l.notifyOnDestruction();
                                    u.ia = !0;
                                    Object.defineProperties(this, {
                                        g: {
                                            value: u
                                        }
                                    });
                                    Pc(this);
                                    l = u.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? V(`Tried to register registered instance: ${l}`) : zc[l] = this;
                                };
                                f.__destruct = function() {
                                    this === f && V("Pass correct 'this' to __destruct");
                                    Gc(this);
                                    var l = this.g.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? delete zc[l] : V(`Tried to unregister unregistered instance: ${l}`);
                                };
                                a.prototype = Object.create(f);
                                for(var p in c)a.prototype[p] = c[p];
                                return sc(a);
                            },
                            _embind_finalize_value_object: function(a) {
                                var b = Qc[a];
                                delete Qc[a];
                                var c = b.Pa, d = b.W, e = b.eb, f = e.map((g)=>g.Yb).concat(e.map((g)=>g.rc));
                                Y([
                                    a
                                ], f, (g)=>{
                                    var n = {};
                                    e.forEach((p, l)=>{
                                        var u = g[l], v = p.Wb, x = p.Xb, k = g[l + e.length], t = p.qc, r = p.sc;
                                        n[p.Sb] = {
                                            read: (A)=>u.fromWireType(v(x, A)),
                                            write: (A, D)=>{
                                                var w = [];
                                                t(r, A, k.toWireType(w, D));
                                                Rc(w);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: b.name,
                                            fromWireType: function(p) {
                                                var l = {}, u;
                                                for(u in n)l[u] = n[u].read(p);
                                                d(p);
                                                return l;
                                            },
                                            toWireType: function(p, l) {
                                                for(var u in n){
                                                    if (!(u in l)) throw new TypeError(`Missing field: "${u}"`);
                                                }
                                                var v = c();
                                                for(u in n)n[u].write(v, l[u]);
                                                null !== p && p.push(d, v);
                                                return v;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: Sc,
                                            K: d
                                        }
                                    ];
                                });
                            },
                            _embind_register_bigint: function() {},
                            _embind_register_bool: function(a, b, c, d, e) {
                                var f = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(g) {
                                        return !!g;
                                    },
                                    toWireType: function(g, n) {
                                        return n ? d : e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function(g) {
                                        if (1 === c) var n = B;
                                        else if (2 === c) n = Da;
                                        else if (4 === c) n = L;
                                        else throw new TypeError("Unknown boolean type size: " + b);
                                        return this.fromWireType(n[g >> f]);
                                    },
                                    K: null
                                });
                            },
                            _embind_register_class: function(a, b, c, d, e, f, g, n, p, l, u, v, x) {
                                u = W(u);
                                f = Z(e, f);
                                n && (n = Z(g, n));
                                l && (l = Z(p, l));
                                x = Z(v, x);
                                var k = nc(u);
                                ad(k, function() {
                                    od(`Cannot construct ${u} due to unbound types`, [
                                        d
                                    ]);
                                });
                                Y([
                                    a,
                                    b,
                                    c
                                ], d ? [
                                    d
                                ] : [], function(t) {
                                    t = t[0];
                                    if (d) {
                                        var r = t.i;
                                        var A = r.N;
                                    } else A = Zc.prototype;
                                    t = oc(k, function() {
                                        if (Object.getPrototypeOf(this) !== D) throw new qc("Use 'new' to construct " + u);
                                        if (void 0 === w.$) throw new qc(u + " has no accessible constructor");
                                        var T = w.$[arguments.length];
                                        if (void 0 === T) throw new qc(`Tried to invoke ctor of ${u} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(w.$).toString()}) parameters instead!`);
                                        return T.apply(this, arguments);
                                    });
                                    var D = Object.create(A, {
                                        constructor: {
                                            value: t
                                        }
                                    });
                                    t.prototype = D;
                                    var w = new bd(u, t, D, x, r, f, n, l);
                                    w.A && (void 0 === w.A.oa && (w.A.oa = []), w.A.oa.push(w));
                                    r = new hd(u, w, !0, !1);
                                    A = new hd(u + "*", w, !1, !1);
                                    var M = new hd(u + " const*", w, !1, !0);
                                    Kc[a] = {
                                        pointerType: A,
                                        Kb: M
                                    };
                                    jd(k, t);
                                    return [
                                        r,
                                        A,
                                        M
                                    ];
                                });
                            },
                            _embind_register_class_class_function: function(a, b, c, d, e, f, g) {
                                var n = rd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    function l() {
                                        od(`Cannot call ${u} due to unbound types`, n);
                                    }
                                    p = p[0];
                                    var u = `${p.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    var v = p.i.constructor;
                                    void 0 === v[b] ? (l.ea = c - 1, v[b] = l) : ($c(v, b, u), v[b].B[c - 1] = l);
                                    Y([], n, function(x) {
                                        x = pd(u, [
                                            x[0],
                                            null
                                        ].concat(x.slice(1)), null, f, g);
                                        void 0 === v[b].B ? (x.ea = c - 1, v[b] = x) : v[b].B[c - 1] = x;
                                        if (p.i.oa) for (const k of p.i.oa)k.constructor.hasOwnProperty(b) || (k.constructor[b] = x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_class_property: function(a, b, c, d, e, f, g, n) {
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    p = p[0];
                                    var l = `${p.name}.${b}`, u = {
                                        get () {
                                            od(`Cannot access ${l} due to unbound types`, [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    u.set = n ? ()=>{
                                        od(`Cannot access ${l} due to unbound types`, [
                                            c
                                        ]);
                                    } : ()=>{
                                        V(`${l} is a read-only property`);
                                    };
                                    Object.defineProperty(p.i.constructor, b, u);
                                    Y([], [
                                        c
                                    ], function(v) {
                                        v = v[0];
                                        var x = {
                                            get () {
                                                return v.fromWireType(f(d));
                                            },
                                            enumerable: !0
                                        };
                                        n && (n = Z(g, n), x.set = (k)=>{
                                            var t = [];
                                            n(d, v.toWireType(t, k));
                                            Rc(t);
                                        });
                                        Object.defineProperty(p.i.constructor, b, x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_constructor: function(a, b, c, d, e, f) {
                                var g = rd(b, c);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(n) {
                                    n = n[0];
                                    var p = `constructor ${n.name}`;
                                    void 0 === n.i.$ && (n.i.$ = []);
                                    if (void 0 !== n.i.$[b - 1]) throw new qc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${n.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                                    n.i.$[b - 1] = ()=>{
                                        od(`Cannot construct ${n.name} due to unbound types`, g);
                                    };
                                    Y([], g, function(l) {
                                        l.splice(1, 0, null);
                                        n.i.$[b - 1] = pd(p, l, null, e, f);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_function: function(a, b, c, d, e, f, g, n) {
                                var p = rd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(l) {
                                    function u() {
                                        od(`Cannot call ${v} due to unbound types`, p);
                                    }
                                    l = l[0];
                                    var v = `${l.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    n && l.i.qb.push(b);
                                    var x = l.i.N, k = x[b];
                                    void 0 === k || void 0 === k.B && k.className !== l.name && k.ea === c - 2 ? (u.ea = c - 2, u.className = l.name, x[b] = u) : ($c(x, b, v), x[b].B[c - 2] = u);
                                    Y([], p, function(t) {
                                        t = pd(v, t, l, f, g);
                                        void 0 === x[b].B ? (t.ea = c - 2, x[b] = t) : x[b].B[c - 2] = t;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_property: function(a, b, c, d, e, f, g, n, p, l) {
                                b = W(b);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(u) {
                                    u = u[0];
                                    var v = `${u.name}.${b}`, x = {
                                        get () {
                                            od(`Cannot access ${v} due to unbound types`, [
                                                c,
                                                g
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    x.set = p ? ()=>{
                                        od(`Cannot access ${v} due to unbound types`, [
                                            c,
                                            g
                                        ]);
                                    } : ()=>{
                                        V(v + " is a read-only property");
                                    };
                                    Object.defineProperty(u.i.N, b, x);
                                    Y([], p ? [
                                        c,
                                        g
                                    ] : [
                                        c
                                    ], function(k) {
                                        var t = k[0], r = {
                                            get () {
                                                var D = sd(this, u, v + " getter");
                                                return t.fromWireType(e(f, D));
                                            },
                                            enumerable: !0
                                        };
                                        if (p) {
                                            p = Z(n, p);
                                            var A = k[1];
                                            r.set = function(D) {
                                                var w = sd(this, u, v + " setter"), M = [];
                                                p(l, w, A.toWireType(M, D));
                                                Rc(M);
                                            };
                                        }
                                        Object.defineProperty(u.i.N, b, r);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_emval: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(c) {
                                        var d = rc(c);
                                        td(c);
                                        return d;
                                    },
                                    toWireType: function(c, d) {
                                        return sc(d);
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: null
                                });
                            },
                            _embind_register_enum: function(a, b, c, d) {
                                function e() {}
                                c = Wc(c);
                                b = W(b);
                                e.values = {};
                                Vc(a, {
                                    name: b,
                                    constructor: e,
                                    fromWireType: function(f) {
                                        return this.constructor.values[f];
                                    },
                                    toWireType: function(f, g) {
                                        return g.value;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: ud(b, c, d),
                                    K: null
                                });
                                ad(b, e);
                            },
                            _embind_register_enum_value: function(a, b, c) {
                                var d = Fc(a, "enum");
                                b = W(b);
                                a = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: oc(`${d.name}_${b}`, function() {})
                                    }
                                });
                                a.values[c] = d;
                                a[b] = d;
                            },
                            _embind_register_float: function(a, b, c) {
                                c = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        return d;
                                    },
                                    toWireType: function(d, e) {
                                        return e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: vd(b, c),
                                    K: null
                                });
                            },
                            _embind_register_function: function(a, b, c, d, e, f) {
                                var g = rd(b, c);
                                a = W(a);
                                e = Z(d, e);
                                ad(a, function() {
                                    od(`Cannot call ${a} due to unbound types`, g);
                                }, b - 1);
                                Y([], g, function(n) {
                                    jd(a, pd(a, [
                                        n[0],
                                        null
                                    ].concat(n.slice(1)), null, e, f), b - 1);
                                    return [];
                                });
                            },
                            _embind_register_integer: function(a, b, c, d, e) {
                                b = W(b);
                                -1 === e && (e = 4294967295);
                                e = Wc(c);
                                var f = (n)=>n;
                                if (0 === d) {
                                    var g = 32 - 8 * c;
                                    f = (n)=>n << g >>> g;
                                }
                                c = b.includes("unsigned") ? function(n, p) {
                                    return p >>> 0;
                                } : function(n, p) {
                                    return p;
                                };
                                Vc(a, {
                                    name: b,
                                    fromWireType: f,
                                    toWireType: c,
                                    argPackAdvance: 8,
                                    readValueFromPointer: wd(b, e, 0 !== d),
                                    K: null
                                });
                            },
                            _embind_register_memory_view: function(a, b, c) {
                                function d(f) {
                                    f >>= 2;
                                    var g = N;
                                    return new e(g.buffer, g[f + 1], g[f]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][b];
                                c = W(c);
                                Vc(a, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    $b: !0
                                });
                            },
                            _embind_register_std_string: function(a, b) {
                                b = W(b);
                                var c = "std::string" === b;
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        var e = N[d >> 2], f = d + 4;
                                        if (c) for(var g = f, n = 0; n <= e; ++n){
                                            var p = f + n;
                                            if (n == e || 0 == E[p]) {
                                                g = g ? nb(E, g, p - g) : "";
                                                if (void 0 === l) var l = g;
                                                else l += String.fromCharCode(0), l += g;
                                                g = p + 1;
                                            }
                                        }
                                        else {
                                            l = Array(e);
                                            for(n = 0; n < e; ++n)l[n] = String.fromCharCode(E[f + n]);
                                            l = l.join("");
                                        }
                                        Ec(d);
                                        return l;
                                    },
                                    toWireType: function(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var f = "string" == typeof e;
                                        f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || V("Cannot pass non-string to std::string");
                                        var g = c && f ? pb(e) : e.length;
                                        var n = Vd(4 + g + 1), p = n + 4;
                                        N[n >> 2] = g;
                                        if (c && f) qb(e, E, p, g + 1);
                                        else {
                                            if (f) for(f = 0; f < g; ++f){
                                                var l = e.charCodeAt(f);
                                                255 < l && (Ec(p), V("String has UTF-16 code units that do not fit in 8 bits"));
                                                E[p + f] = l;
                                            }
                                            else for(f = 0; f < g; ++f)E[p + f] = e[f];
                                        }
                                        null !== d && d.push(Ec, n);
                                        return n;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(d) {
                                        Ec(d);
                                    }
                                });
                            },
                            _embind_register_std_wstring: function(a, b, c) {
                                c = W(c);
                                if (2 === b) {
                                    var d = yd;
                                    var e = zd;
                                    var f = Ad;
                                    var g = ()=>Ea;
                                    var n = 1;
                                } else 4 === b && (d = Bd, e = Cd, f = Dd, g = ()=>N, n = 2);
                                Vc(a, {
                                    name: c,
                                    fromWireType: function(p) {
                                        for(var l = N[p >> 2], u = g(), v, x = p + 4, k = 0; k <= l; ++k){
                                            var t = p + 4 + k * b;
                                            if (k == l || 0 == u[t >> n]) x = d(x, t - x), void 0 === v ? v = x : (v += String.fromCharCode(0), v += x), x = t + b;
                                        }
                                        Ec(p);
                                        return v;
                                    },
                                    toWireType: function(p, l) {
                                        "string" != typeof l && V(`Cannot pass non-string to C++ string type ${c}`);
                                        var u = f(l), v = Vd(4 + u + b);
                                        N[v >> 2] = u >> n;
                                        e(l, v + 4, u + b);
                                        null !== p && p.push(Ec, v);
                                        return v;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(p) {
                                        Ec(p);
                                    }
                                });
                            },
                            _embind_register_value_object: function(a, b, c, d, e, f) {
                                Qc[a] = {
                                    name: W(b),
                                    Pa: Z(c, d),
                                    W: Z(e, f),
                                    eb: []
                                };
                            },
                            _embind_register_value_object_field: function(a, b, c, d, e, f, g, n, p, l) {
                                Qc[a].eb.push({
                                    Sb: W(b),
                                    Yb: c,
                                    Wb: Z(d, e),
                                    Xb: f,
                                    rc: g,
                                    qc: Z(n, p),
                                    sc: l
                                });
                            },
                            _embind_register_void: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    fc: !0,
                                    name: b,
                                    argPackAdvance: 0,
                                    fromWireType: function() {},
                                    toWireType: function() {}
                                });
                            },
                            _emscripten_get_now_is_monotonic: ()=>!0,
                            _emval_as: function(a, b, c) {
                                a = rc(a);
                                b = Fc(b, "emval::as");
                                var d = [], e = sc(d);
                                N[c >> 2] = e;
                                return b.toWireType(d, a);
                            },
                            _emval_call_method: function(a, b, c, d, e) {
                                a = Gd[a];
                                b = rc(b);
                                c = Fd(c);
                                var f = [];
                                N[d >> 2] = sc(f);
                                return a(b, c, f, e);
                            },
                            _emval_call_void_method: function(a, b, c, d) {
                                a = Gd[a];
                                b = rc(b);
                                c = Fd(c);
                                a(b, c, null, d);
                            },
                            _emval_decref: td,
                            _emval_get_method_caller: function(a, b) {
                                var c = Id(a, b), d = c[0];
                                b = d.name + "_$" + c.slice(1).map(function(g) {
                                    return g.name;
                                }).join("_") + "$";
                                var e = Jd[b];
                                if (void 0 !== e) return e;
                                var f = Array(a - 1);
                                e = Hd((g, n, p, l)=>{
                                    for(var u = 0, v = 0; v < a - 1; ++v)f[v] = c[v + 1].readValueFromPointer(l + u), u += c[v + 1].argPackAdvance;
                                    g = g[n].apply(g, f);
                                    for(v = 0; v < a - 1; ++v)c[v + 1].Nb && c[v + 1].Nb(f[v]);
                                    if (!d.fc) return d.toWireType(p, g);
                                });
                                return Jd[b] = e;
                            },
                            _emval_get_module_property: function(a) {
                                a = Fd(a);
                                return sc(m[a]);
                            },
                            _emval_get_property: function(a, b) {
                                a = rc(a);
                                b = rc(b);
                                return sc(a[b]);
                            },
                            _emval_incref: function(a) {
                                4 < a && (U.get(a).tb += 1);
                            },
                            _emval_new_cstring: function(a) {
                                return sc(Fd(a));
                            },
                            _emval_new_object: function() {
                                return sc({});
                            },
                            _emval_run_destructors: function(a) {
                                var b = rc(a);
                                Rc(b);
                                td(a);
                            },
                            _emval_set_property: function(a, b, c) {
                                a = rc(a);
                                b = rc(b);
                                c = rc(c);
                                a[b] = c;
                            },
                            _emval_take_value: function(a, b) {
                                a = Fc(a, "_emval_take_value");
                                a = a.readValueFromPointer(b);
                                return sc(a);
                            },
                            abort: ()=>{
                                Aa("");
                            },
                            emscripten_asm_const_int: (a, b, c)=>{
                                Kd.length = 0;
                                var d;
                                for(c >>= 2; d = E[b++];)c += 105 != d & c, Kd.push(105 == d ? L[c] : Ia[c++ >> 1]), ++c;
                                return db[a].apply(null, Kd);
                            },
                            emscripten_date_now: function() {
                                return Date.now();
                            },
                            emscripten_get_now: ()=>performance.now(),
                            emscripten_memcpy_big: (a, b, c)=>E.copyWithin(a, b, b + c),
                            emscripten_resize_heap: (a)=>{
                                var b = E.length;
                                a >>>= 0;
                                if (2147483648 < a) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = b * (1 + 0.2 / c);
                                    d = Math.min(d, a + 100663296);
                                    var e = Math;
                                    d = Math.max(a, d);
                                    a: {
                                        e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Ba.buffer.byteLength + 65535 >>> 16;
                                        try {
                                            Ba.grow(e);
                                            Ja();
                                            var f = 1;
                                            break a;
                                        } catch (g) {}
                                        f = void 0;
                                    }
                                    if (f) return !0;
                                }
                                return !1;
                            },
                            environ_get: (a, b)=>{
                                var c = 0;
                                Nd().forEach(function(d, e) {
                                    var f = b + c;
                                    e = N[a + 4 * e >> 2] = f;
                                    for(f = 0; f < d.length; ++f)B[e++ >> 0] = d.charCodeAt(f);
                                    B[e >> 0] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            environ_sizes_get: (a, b)=>{
                                var c = Nd();
                                N[a >> 2] = c.length;
                                var d = 0;
                                c.forEach(function(e) {
                                    d += e.length + 1;
                                });
                                N[b >> 2] = d;
                                return 0;
                            },
                            fd_close: function(a) {
                                try {
                                    var b = Tb(a);
                                    if (null === b.X) throw new O(8);
                                    b.Ma && (b.Ma = null);
                                    try {
                                        b.m.close && b.m.close(b);
                                    } catch (c) {
                                        throw c;
                                    } finally{
                                        Gb[b.X] = null;
                                    }
                                    b.X = null;
                                    return 0;
                                } catch (c) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== c.name) throw c;
                                    return c.aa;
                                }
                            },
                            fd_read: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = B;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (1 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.read) throw new O(28);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.read(l, k, u, v, x);
                                            t || (l.position += r);
                                            var A = r;
                                            if (0 > A) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += A;
                                            if (A < p) break;
                                            "undefined" !== typeof f && (f += A);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            fd_seek: function(a, b, c, d, e) {
                                b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
                                try {
                                    if (isNaN(b)) return 61;
                                    var f = Tb(a);
                                    fc(f, b, d);
                                    $a = [
                                        f.position >>> 0,
                                        (Za = f.position, 1.0 <= +Math.abs(Za) ? 0.0 < Za ? +Math.floor(Za / 4294967296.0) >>> 0 : ~~+Math.ceil((Za - +(~~Za >>> 0)) / 4294967296.0) >>> 0 : 0)
                                    ];
                                    L[e >> 2] = $a[0];
                                    L[e + 4 >> 2] = $a[1];
                                    f.Ma && 0 === b && 0 === d && (f.Ma = null);
                                    return 0;
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return g.aa;
                                }
                            },
                            fd_write: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = B;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (0 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.write) throw new O(28);
                                            l.seekable && l.flags & 1024 && fc(l, 0, 2);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.write(l, k, u, v, x, void 0);
                                            t || (l.position += r);
                                            var A = r;
                                            if (0 > A) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += A;
                                            "undefined" !== typeof f && (f += A);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            strftime_l: (a, b, c, d)=>Rd(a, b, c, d)
                        };
                        (function() {
                            function a(c) {
                                y = c = c.exports;
                                Ba = y.memory;
                                Ja();
                                Ka = y.__indirect_function_table;
                                Ma.unshift(y.__wasm_call_ctors);
                                Pa--;
                                m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                                if (0 == Pa && (null !== Qa && (clearInterval(Qa), Qa = null), Ra)) {
                                    var d = Ra;
                                    Ra = null;
                                    d();
                                }
                                return c;
                            }
                            var b = {
                                env: Wd,
                                wasi_snapshot_preview1: Wd
                            };
                            Pa++;
                            m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                            if (m.instantiateWasm) try {
                                return m.instantiateWasm(b, a);
                            } catch (c) {
                                xa("Module.instantiateWasm callback failed with error: " + c), ea(c);
                            }
                            Ya(b, function(c) {
                                a(c.instance);
                            }).catch(ea);
                            return {};
                        })();
                        var Ec = (a)=>(Ec = y.free)(a), Vd = (a)=>(Vd = y.malloc)(a), ab = m._ma_device__on_notification_unlocked = (a)=>(ab = m._ma_device__on_notification_unlocked = y.ma_device__on_notification_unlocked)(a);
                        m._ma_malloc_emscripten = (a, b)=>(m._ma_malloc_emscripten = y.ma_malloc_emscripten)(a, b);
                        m._ma_free_emscripten = (a, b)=>(m._ma_free_emscripten = y.ma_free_emscripten)(a, b);
                        var bb = m._ma_device_process_pcm_frames_capture__webaudio = (a, b, c)=>(bb = m._ma_device_process_pcm_frames_capture__webaudio = y.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), cb = m._ma_device_process_pcm_frames_playback__webaudio = (a, b, c)=>(cb = m._ma_device_process_pcm_frames_playback__webaudio = y.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), Ud = ()=>(Ud = y.__errno_location)(), Dc = (a)=>(Dc = y.__getTypeName)(a);
                        m.__embind_initialize_bindings = ()=>(m.__embind_initialize_bindings = y._embind_initialize_bindings)();
                        m.dynCall_iiji = (a, b, c, d, e)=>(m.dynCall_iiji = y.dynCall_iiji)(a, b, c, d, e);
                        m.dynCall_jiji = (a, b, c, d, e)=>(m.dynCall_jiji = y.dynCall_jiji)(a, b, c, d, e);
                        m.dynCall_iiiji = (a, b, c, d, e, f)=>(m.dynCall_iiiji = y.dynCall_iiiji)(a, b, c, d, e, f);
                        m.dynCall_iij = (a, b, c, d)=>(m.dynCall_iij = y.dynCall_iij)(a, b, c, d);
                        m.dynCall_jii = (a, b, c)=>(m.dynCall_jii = y.dynCall_jii)(a, b, c);
                        m.dynCall_viijii = (a, b, c, d, e, f, g)=>(m.dynCall_viijii = y.dynCall_viijii)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiij = (a, b, c, d, e, f, g)=>(m.dynCall_iiiiij = y.dynCall_iiiiij)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiijj = (a, b, c, d, e, f, g, n, p)=>(m.dynCall_iiiiijj = y.dynCall_iiiiijj)(a, b, c, d, e, f, g, n, p);
                        m.dynCall_iiiiiijj = (a, b, c, d, e, f, g, n, p, l)=>(m.dynCall_iiiiiijj = y.dynCall_iiiiiijj)(a, b, c, d, e, f, g, n, p, l);
                        var Xd;
                        Ra = function Yd() {
                            Xd || Zd();
                            Xd || (Ra = Yd);
                        };
                        function Zd() {
                            function a() {
                                if (!Xd && (Xd = !0, m.calledRun = !0, !Ca)) {
                                    m.noFSInit || hc || (hc = !0, gc(), m.stdin = m.stdin, m.stdout = m.stdout, m.stderr = m.stderr, m.stdin ? jc("stdin", m.stdin) : cc("/dev/tty", "/dev/stdin"), m.stdout ? jc("stdout", null, m.stdout) : cc("/dev/tty", "/dev/stdout"), m.stderr ? jc("stderr", null, m.stderr) : cc("/dev/tty1", "/dev/stderr"), ec("/dev/stdin", 0), ec("/dev/stdout", 1), ec("/dev/stderr", 1));
                                    Jb = !1;
                                    eb(Ma);
                                    aa(m);
                                    if (m.onRuntimeInitialized) m.onRuntimeInitialized();
                                    if (m.postRun) for("function" == typeof m.postRun && (m.postRun = [
                                        m.postRun
                                    ]); m.postRun.length;){
                                        var b = m.postRun.shift();
                                        Na.unshift(b);
                                    }
                                    eb(Na);
                                }
                            }
                            if (!(0 < Pa)) {
                                if (m.preRun) for("function" == typeof m.preRun && (m.preRun = [
                                    m.preRun
                                ]); m.preRun.length;)Oa();
                                eb(La);
                                0 < Pa || (m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        m.setStatus("");
                                    }, 1);
                                    a();
                                }, 1)) : a());
                            }
                        }
                        if (m.preInit) for("function" == typeof m.preInit && (m.preInit = [
                            m.preInit
                        ]); 0 < m.preInit.length;)m.preInit.pop()();
                        Zd();
                        return moduleArg.ready;
                    };
                })();
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ (module1)=>{
                module1.exports = JSON.parse('{"name":"@rive-app/canvas","version":"2.20.0","description":"Rive\'s canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive_fallback.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* reexport safe */ _Animation__WEBPACK_IMPORTED_MODULE_0__.Animation
                });
                /* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* binding */ Animation
                });
                /**
 * Represents an animation that can be played on an Artboard.
 * Wraps animations and instances from the runtime and keeps track of playback state.
 *
 * The `Animation` class manages the state and behavior of a single animation instance,
 * including its current time, loop count, and ability to scrub to a specific time.
 *
 * The class provides methods to advance the animation, apply its interpolated keyframe
 * values to the Artboard, and clean up the underlying animation instance when the
 * animation is no longer needed.
 */ var Animation = /** @class */ function() {
                    /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                        this.animation = animation;
                        this.artboard = artboard;
                        this.playing = playing;
                        this.loopCount = 0;
                        /**
         * The time to which the animation should move to on the next render.
         * If not null, the animation will scrub to this time instead of advancing by the given time.
         */ this.scrubTo = null;
                        this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                    }
                    Object.defineProperty(Animation.prototype, "name", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.animation.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "time", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.instance.time;
                        },
                        /**
         * Sets the animation's current time
         */ set: function(value) {
                            this.instance.time = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "loopValue", {
                        /**
         * Returns the animation's loop type
         */ get: function() {
                            return this.animation.loopValue;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "needsScrub", {
                        /**
         * Indicates whether the animation needs to be scrubbed.
         * @returns `true` if the animation needs to be scrubbed, `false` otherwise.
         */ get: function() {
                            return this.scrubTo !== null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                        if (this.scrubTo === null) this.instance.advance(time);
                        else {
                            this.instance.time = 0;
                            this.instance.advance(this.scrubTo);
                            this.scrubTo = null;
                        }
                    };
                    /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                        this.instance.apply(mix);
                    };
                    /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                        this.instance.delete();
                    };
                    return Animation;
                }();
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL,
                    /* harmony export */ registerTouchInteractions: ()=>/* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions,
                    /* harmony export */ sanitizeUrl: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: ()=>/* binding */ registerTouchInteractions
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function(event, isTouchScrollEnabled) {
                    var _a, _b;
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.touches) === null || _a === void 0 ? void 0 : _a.length)) {
                        // This flag, if false, prevents touch events on the canvas default behavior
                        // which may prevent scrolling if a drag motion on the canvas is performed
                        if (!isTouchScrollEnabled) event.preventDefault();
                        return {
                            clientX: event.touches[0].clientX,
                            clientY: event.touches[0].clientY
                        };
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) return {
                        clientX: event.changedTouches[0].clientX,
                        clientY: event.changedTouches[0].clientY
                    };
                    else return {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment, _c = _a.isTouchScrollEnabled, isTouchScrollEnabled = _c === void 0 ? false : _c;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    /**
     * After a touchend event, some browsers may fire synthetic mouse events
     * (mouseover, mousedown, mousemove, mouseup) if the touch interaction did not cause
     * any default action (such as scrolling).
     *
     * This is done to simulate the behavior of a mouse for applications that do not support
     * touch events.
     *
     * We're keeping track of the previous event to not send the synthetic mouse events if the
     * touch event was a click (touchstart -> touchend).
     *
     * This is only needed when `isTouchScrollEnabled` is false
     * When true, `preventDefault()` is called which prevents this behaviour.
     **/ var _prevEventType = null;
                    var _syntheticEventsActive = false;
                    var processEventCallback = function(event) {
                        // Exit early out of all synthetic mouse events
                        // https://stackoverflow.com/questions/9656990/how-to-prevent-simulated-mouse-events-in-mobile-browsers
                        // https://stackoverflow.com/questions/25572070/javascript-touchend-versus-click-dilemma
                        if (_syntheticEventsActive && event instanceof MouseEvent) {
                            // Synthetic event finished
                            if (event.type == "mouseup") _syntheticEventsActive = false;
                            return;
                        }
                        // Test if it's a "touch click". This could cause the browser to send
                        // synthetic mouse events.
                        _syntheticEventsActive = isTouchScrollEnabled && event.type === "touchend" && _prevEventType === "touchstart";
                        _prevEventType = event.type;
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var _a = getClientCoordinates(event, isTouchScrollEnabled), clientX = _a.clientX, clientY = _a.clientY;
                        if (!clientX && !clientY) return;
                        var canvasX = clientX - boundingRect.left;
                        var canvasY = clientY - boundingRect.top;
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                        var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                        var transformedX = transformedVector.x();
                        var transformedY = transformedVector.y();
                        transformedVector.delete();
                        invertedMatrix.delete();
                        canvasCoordinatesVector.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             * We add/subtract 10000 to account for when the graphic goes beyond the canvas bound
             * due to for example, a fit: 'cover'. Not perfect, but helps reliably (for now) ensure
             * we report going out of bounds when the mouse is out of the canvas
             */ case "mouseout":
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    stateMachine.pointerMove(transformedX < 0 ? transformedX - 10000 : transformedX + 10000, transformedY < 0 ? transformedY - 10000 : transformedY + 10000);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                for(var _b = 0, stateMachines_2 = stateMachines; _b < stateMachines_2.length; _b++){
                                    var stateMachine = stateMachines_2[_b];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                for(var _c = 0, stateMachines_3 = stateMachines; _c < stateMachines_3.length; _c++){
                                    var stateMachine = stateMachines_3[_c];
                                    stateMachine.pointerDown(transformedX, transformedY);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                            case "mouseup":
                                for(var _d = 0, stateMachines_4 = stateMachines; _d < stateMachines_4.length; _d++){
                                    var stateMachine = stateMachines_4[_d];
                                    stateMachine.pointerUp(transformedX, transformedY);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchstart", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* binding */ BLANK_URL,
                    /* harmony export */ sanitizeUrl: ()=>/* binding */ sanitizeUrl
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
                function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                }
                // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                }
                function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: ()=>/* binding */ Alignment,
                /* harmony export */ EventType: ()=>/* binding */ EventType,
                /* harmony export */ Fit: ()=>/* binding */ Fit,
                /* harmony export */ Layout: ()=>/* binding */ Layout,
                /* harmony export */ LoopType: ()=>/* binding */ LoopType,
                /* harmony export */ Rive: ()=>/* binding */ Rive,
                /* harmony export */ RiveEventType: ()=>/* binding */ RiveEventType,
                /* harmony export */ RiveFile: ()=>/* binding */ RiveFile,
                /* harmony export */ RuntimeLoader: ()=>/* binding */ RuntimeLoader,
                /* harmony export */ StateMachineInput: ()=>/* binding */ StateMachineInput,
                /* harmony export */ StateMachineInputType: ()=>/* binding */ StateMachineInputType,
                /* harmony export */ Testing: ()=>/* binding */ Testing,
                /* harmony export */ decodeAudio: ()=>/* binding */ decodeAudio,
                /* harmony export */ decodeFont: ()=>/* binding */ decodeFont,
                /* harmony export */ decodeImage: ()=>/* binding */ decodeImage
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g;
                return g = {
                    next: verb(0),
                    "throw": verb(1),
                    "return": verb(2)
                }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.minX = (_c = params === null || params === void 0 ? void 0 : params.minX) !== null && _c !== void 0 ? _c : 0;
                    this.minY = (_d = params === null || params === void 0 ? void 0 : params.minY) !== null && _d !== void 0 ? _d : 0;
                    this.maxX = (_e = params === null || params === void 0 ? void 0 : params.maxX) !== null && _e !== void 0 ? _e : 0;
                    this.maxY = (_f = params === null || params === void 0 ? void 0 : params.maxY) !== null && _f !== void 0 ? _f : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function() {
                        // In case unpkg fails, or the wasm was not supported, we try to load the fallback module from jsdelivr.
                        // This `rive_fallback.wasm` is compiled to support older architecture.
                        // TODO: (Gordon): preemptively test browser support and load the correct wasm file. Then use jsdelvr only if unpkg fails.
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive_fallback.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, ", trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else console.error("Could not load Rive WASM file from unpkg or jsdelivr, network connection may be down, or         you may need to call set a new WASM source via RuntimeLoader.setWasmUrl() and call         RuntimeLoader.loadRuntime() again");
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.instance.delete();
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            }
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else // In order to maintain compatibility with current behavior, if a state machine is not found
                            // we look for an animation with the same name
                            this.initLinearAnimations([
                                animatables[i]
                            ], playing);
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
                EventType["AudioStatusChange"] = "audiostatuschange";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            // #endregion
            // #region Audio
            var SystemAudioStatus;
            (function(SystemAudioStatus) {
                SystemAudioStatus[SystemAudioStatus["AVAILABLE"] = 0] = "AVAILABLE";
                SystemAudioStatus[SystemAudioStatus["UNAVAILABLE"] = 1] = "UNAVAILABLE";
            })(SystemAudioStatus || (SystemAudioStatus = {}));
            // Class to handle audio context availability and status changes
            var AudioManager = /** @class */ function(_super) {
                __extends(AudioManager, _super);
                function AudioManager() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this._started = false;
                    _this._enabled = false;
                    _this._status = SystemAudioStatus.UNAVAILABLE;
                    return _this;
                }
                AudioManager.prototype.delay = function(time) {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, time);
                                })
                            ];
                        });
                    });
                };
                AudioManager.prototype.timeout = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(_, reject) {
                                    return setTimeout(reject, 50);
                                })
                            ];
                        });
                    });
                };
                // Alerts animations on status changes and removes the listeners to avoid alerting twice.
                AudioManager.prototype.reportToListeners = function() {
                    this.fire({
                        type: EventType.AudioStatusChange
                    });
                    this.removeAll();
                };
                /**
     * The audio context has been resolved.
     * Alert any listeners that we can now play audio.
     * Rive will now play audio at the configured volume.
     */ AudioManager.prototype.enableAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            if (!this._enabled) {
                                this._enabled = true;
                                this._status = SystemAudioStatus.AVAILABLE;
                                this.reportToListeners();
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                /**
     * Check if we are able to play audio.
     *
     * We currently check the audio context, when resume() returns before a timeout we know that the
     * audio context is running and we can enable audio.
     */ AudioManager.prototype.testAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE && this._audioContext !== null)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            this._audioContext.resume(),
                                            this.timeout()
                                        ])
                                    ];
                                case 2:
                                    _b.sent();
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    _a = _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Establish audio for use with rive.
     * We both test if we can use audio intermittently and listen for user interaction.
     * The aim is to enable audio playback as soon as the browser allows this.
     */ AudioManager.prototype._establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!!this._started) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    this._started = true;
                                    if (!(typeof window == "undefined")) return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 1:
                                    this._audioContext = new AudioContext();
                                    this.listenForUserAction();
                                    _a.label = 2;
                                case 2:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.testAudio()
                                    ];
                                case 3:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.delay(1000)
                                    ];
                                case 4:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                AudioManager.prototype.listenForUserAction = function() {
                    var _this = this;
                    // NOTE: AudioContexts are ready immediately if requested in a ui callback
                    // we *could* re request one in this listener.
                    var _clickListener = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                // note this has "better" results than calling `await this.testAudio()`
                                // as we force audio to be enabled in the current thread, rather than chancing
                                // the thread to be passed over for some other async context
                                this.enableAudio();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    // NOTE: we should test this on mobile/pads
                    document.addEventListener("pointerdown", _clickListener, {
                        once: true
                    });
                };
                /**
     * Establish the audio context for rive, this lets rive know that we can play audio.
     */ AudioManager.prototype.establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            this._establishAudio();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                Object.defineProperty(AudioManager.prototype, "systemVolume", {
                    get: function() {
                        if (this._status === SystemAudioStatus.UNAVAILABLE) {
                            // We do an immediate test to avoid depending on the delay of the running test
                            this.testAudio();
                            return 0;
                        }
                        return 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AudioManager.prototype, "status", {
                    get: function() {
                        return this._status;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AudioManager;
            }(EventManager);
            var audioManager = new AudioManager();
            var FakeResizeObserver = /** @class */ function() {
                function FakeResizeObserver() {}
                FakeResizeObserver.prototype.observe = function() {};
                FakeResizeObserver.prototype.unobserve = function() {};
                FakeResizeObserver.prototype.disconnect = function() {};
                return FakeResizeObserver;
            }();
            var MyResizeObserver = globalThis.ResizeObserver || FakeResizeObserver;
            /**
 * This class takes care of any observers that will be attached to an animation.
 * It should be treated as a singleton because observers are much more performant
 * when used for observing multiple elements by a single instance.
 */ var ObjectObservers = /** @class */ function() {
                function ObjectObservers() {
                    var _this = this;
                    this._elementsMap = new Map();
                    /**
         * Resize observers trigger both when the element changes its size and also when the
         * element is added or removed from the document.
         */ this._onObservedEntry = function(entry) {
                        var observed = _this._elementsMap.get(entry.target);
                        if (observed !== null) observed.onResize(entry.target.clientWidth == 0 || entry.target.clientHeight == 0);
                        else _this._resizeObserver.unobserve(entry.target);
                    };
                    this._onObserved = function(entries) {
                        entries.forEach(_this._onObservedEntry);
                    };
                    this._resizeObserver = new MyResizeObserver(this._onObserved);
                }
                // Adds an observable element
                ObjectObservers.prototype.add = function(element, onResize) {
                    var observed = {
                        onResize: onResize,
                        element: element
                    };
                    this._elementsMap.set(element, observed);
                    this._resizeObserver.observe(element);
                    return observed;
                };
                // Removes an observable element
                ObjectObservers.prototype.remove = function(observed) {
                    this._resizeObserver.unobserve(observed.element);
                    this._elementsMap.delete(observed.element);
                };
                return ObjectObservers;
            }();
            var observers = new ObjectObservers();
            var RiveFile = /** @class */ function() {
                function RiveFile(params) {
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    this.referenceCount = 0;
                    this.src = params.src;
                    this.buffer = params.buffer;
                    if (params.assetLoader) this.assetLoader = params.assetLoader;
                    this.enableRiveAssetCDN = typeof params.enableRiveAssetCDN == "boolean" ? params.enableRiveAssetCDN : true;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                }
                RiveFile.prototype.initData = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, loader, _b;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _a.buffer = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (this.assetLoader) loader = new this.runtime.CustomFileAssetLoader({
                                        loadContents: this.assetLoader
                                    });
                                    // Load the Rive file
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _b.file = _c.sent();
                                    if (this.file !== null) this.eventManager.fire({
                                        type: EventType.Load,
                                        data: this
                                    });
                                    else {
                                        this.eventManager.fire({
                                            type: EventType.LoadError,
                                            data: null
                                        });
                                        throw new Error(RiveFile.fileLoadErrorMessage);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.init = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    // If no source file url specified, it's a bust
                                    if (!this.src && !this.buffer) throw new Error(RiveFile.missingErrorMessage);
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        RuntimeLoader.awaitInstance()
                                    ];
                                case 1:
                                    _a.runtime = _b.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.initData()
                                    ];
                                case 2:
                                    _b.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ RiveFile.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ RiveFile.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                RiveFile.prototype.cleanup = function() {
                    var _a;
                    this.referenceCount -= 1;
                    if (this.referenceCount <= 0) {
                        this.removeAllRiveEventListeners();
                        (_a = this.file) === null || _a === void 0 || _a.delete();
                    }
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ RiveFile.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                RiveFile.prototype.getInstance = function() {
                    if (this.file !== null) {
                        this.referenceCount += 1;
                        return this.file;
                    }
                };
                // Error message for missing source or buffer
                RiveFile.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for file load error
                RiveFile.fileLoadErrorMessage = "The file failed to load";
                return RiveFile;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _this = this;
                    var _a;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Keep a local value of the set volume to update it asynchronously
                    this._volume = 1;
                    // Whether the canvas element's size is 0
                    this._hasZeroSize = false;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    this.isTouchScrollEnabled = false;
                    this.onCanvasResize = function(hasZeroSize) {
                        _this._hasZeroSize = hasZeroSize;
                        if (!_this._layout.maxX || !_this._layout.maxY) _this.resizeToCanvas();
                    };
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this.canvas = params.canvas;
                    if (params.canvas.constructor === HTMLCanvasElement) this._observed = observers.add(this.canvas, this.onCanvasResize);
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.riveFile = params.riveFile;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.isTouchScrollEnabled = !!params.isTouchScrollEnabled;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        riveFile: this.riveFile,
                        autoplay: params.autoplay,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Event handler for when audio context becomes available
                Rive.prototype.onSystemAudioChanged = function() {
                    this.volume = this._volume;
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, riveFile = _a.riveFile, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c;
                    this.src = src;
                    this.buffer = buffer;
                    this.riveFile = riveFile;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer && !this.riveFile) throw new Error(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        _this.runtime = runtime;
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay).then(function() {
                            return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                /**
     * Setup Rive Listeners on the canvas
     * @param riveListenerOptions - Enables TouchEvent events on the canvas. Set to true to allow
     * touch scrolling on the canvas element on touch-enabled devices
     * i.e. { isTouchScrollEnabled: true }
     */ Rive.prototype.setupRiveListeners = function(riveListenerOptions) {
                    var _this = this;
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        var touchScrollEnabledOption = this.isTouchScrollEnabled;
                        if (riveListenerOptions && "isTouchScrollEnabled" in riveListenerOptions) touchScrollEnabledOption = riveListenerOptions.isTouchScrollEnabled;
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime),
                            isTouchScrollEnabled: touchScrollEnabledOption
                        });
                    }
                };
                /**
     * Remove Rive Listeners setup on the canvas
     */ Rive.prototype.removeRiveListeners = function() {
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * If the instance has audio and the system audio is not ready
     * we hook the instance to the audio manager
     */ Rive.prototype.initializeAudio = function() {
                    var _this = this;
                    var _a;
                    // Initialize audio if needed
                    if (audioManager.status == SystemAudioStatus.UNAVAILABLE) {
                        if ((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.hasAudio) {
                            audioManager.add({
                                type: EventType.AudioStatusChange,
                                callback: function() {
                                    return _this.onSystemAudioChanged();
                                }
                            });
                            audioManager.establishAudio();
                        }
                    }
                };
                // Initializes runtime with Rive data and preps for playing
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    var _a;
                    return __awaiter(this, void 0, void 0, function() {
                        var error_1, msg;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _b.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!(this.riveFile == null)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    this.riveFile = new RiveFile({
                                        src: this.src,
                                        buffer: this.buffer,
                                        enableRiveAssetCDN: this.enableRiveAssetCDN,
                                        assetLoader: this.assetLoader
                                    });
                                    return [
                                        4 /*yield*/ ,
                                        this.riveFile.init()
                                    ];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2:
                                    this.file = this.riveFile.getInstance();
                                    // Initialize and draw frame
                                    this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay);
                                    // Check for audio
                                    this.initializeAudio();
                                    // Everything's set up, emit a load event
                                    this.loaded = true;
                                    this.eventManager.fire({
                                        type: EventType.Load,
                                        data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                    });
                                    // Flag ready for playback commands and clear the task queue; this order
                                    // is important or it may infinitely recurse
                                    this.readyForPlaying = true;
                                    this.taskQueue.process();
                                    this.drawFrame();
                                    return [
                                        2 /*return*/ ,
                                        Promise.resolve()
                                    ];
                                case 3:
                                    error_1 = _b.sent();
                                    msg = "Problem loading file; may be corrupt!";
                                    console.warn(msg);
                                    this.eventManager.fire({
                                        type: EventType.LoadError,
                                        data: msg
                                    });
                                    return [
                                        2 /*return*/ ,
                                        Promise.reject(msg)
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    if (!this.file) return;
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    rootArtboard.volume = this._volume * audioManager.systemVolume;
                    // Check that the artboard has at least 1 animation
                    if (this.artboard.animationCount() < 1) {
                        var msg = "Artboard has no animations";
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        throw msg;
                    }
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    this.startRendering();
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    var before = performance.now();
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _a = 0, activeStateMachines_1 = activeStateMachines; _a < activeStateMachines_1.length; _a++){
                        var stateMachine = activeStateMachines_1[_a];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _b = event_1, url = _b.url, target = _b.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_3__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advance(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Canvas must be wiped to prevent artifacts
                    renderer.clear();
                    renderer.save();
                    // Update the renderer alignment if necessary
                    this.alignRenderer();
                    // Do not draw on 0 canvas size
                    if (!this._hasZeroSize) this.artboard.draw(renderer);
                    renderer.restore();
                    renderer.flush();
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.startRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Remove from observer
                    if (this._observed !== null) observers.remove(this._observed);
                    (_a = this.riveFile) === null || _a === void 0 || _a.cleanup();
                    this.riveFile = null;
                    this.file = null;
                };
                /**
     * Cleans up the Renderer object. Only call this API if you no longer
     * need to render Rive content in your session.
     */ Rive.prototype.deleteRiveRenderer = function() {
                    var _a;
                    (_a = this.renderer) === null || _a === void 0 || _a.delete();
                    this.renderer = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    this.file = null;
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this.startRendering();
                        this.resizeToCanvas();
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                // Returns the input with the provided name at the given path
                Rive.prototype.retrieveInputAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No input name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access input: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var input = this.artboard.inputByPath(name, path);
                    if (!input) {
                        console.warn("Could not access an input with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return input;
                };
                /**
     * Set the boolean input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setBooleanStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Boolean) input.asBool().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a boolean"));
                };
                /**
     * Set the number input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setNumberStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Number) input.asNumber().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a number"));
                };
                /**
     * Fire the trigger with the provided name at the given path
     * @param input the state machine input name
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.fireStateAtPath = function(inputName, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Trigger) input.asTrigger().fire();
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a trigger"));
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function() {
                        return this.animator.isStopped;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this.draw.bind(this));
                        else this.frameRequestId = requestAnimationFrame(this.draw.bind(this));
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "volume", {
                    /**
         * getter and setter for the volume of the artboard
         */ get: function() {
                        if (this.artboard && this.artboard.volume !== this._volume) this._volume = this.artboard.volume;
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        if (this.artboard) this.artboard.volume = value * audioManager.systemVolume;
                    },
                    enumerable: false,
                    configurable: true
                });
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                return Rive;
            }();
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an audio asset.
 *
 * Be sure to call `.unref()` on the audio once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeAudio = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeAudio(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.unref()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeImage(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.unref()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeFont(bytes, resolve);
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});


function $5086f3773d25c2f6$var$n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var $5086f3773d25c2f6$var$i = /*#__PURE__*/ $5086f3773d25c2f6$var$n($8FY87), $5086f3773d25c2f6$var$r = function() {
    return $5086f3773d25c2f6$var$r = Object.assign || function(e) {
        for(var t, n = 1, i = arguments.length; n < i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $5086f3773d25c2f6$var$r.apply(this, arguments);
};
function $5086f3773d25c2f6$var$o(e, t) {
    var n = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
    }
    return n;
}
function $5086f3773d25c2f6$var$a(e, t, n, i) {
    return new (n || (n = Promise))(function(r, o) {
        function a(e) {
            try {
                u(i.next(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            try {
                u(i.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function u(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, s);
        }
        u((i = i.apply(e, t || [])).next());
    });
}
function $5086f3773d25c2f6$var$s(e, t) {
    var n, i, r, o, a = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    };
    return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (o[Symbol.iterator] = function() {
        return this;
    }), o;
    function s(s) {
        return function(u) {
            return function(s) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; o && (o = 0, s[0] && (a = 0)), a;)try {
                    if (n = 1, i && (r = 2 & s[0] ? i.return : s[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, s[1])).done) return r;
                    switch(i = 0, r && (s = [
                        2 & s[0],
                        r.value
                    ]), s[0]){
                        case 0:
                        case 1:
                            r = s;
                            break;
                        case 4:
                            return a.label++, {
                                value: s[1],
                                done: !1
                            };
                        case 5:
                            a.label++, i = s[1], s = [
                                0
                            ];
                            continue;
                        case 7:
                            s = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === s[0] && (!r || s[1] > r[0] && s[1] < r[3])) {
                                a.label = s[1];
                                break;
                            }
                            if (6 === s[0] && a.label < r[1]) {
                                a.label = r[1], r = s;
                                break;
                            }
                            if (r && a.label < r[2]) {
                                a.label = r[2], a.ops.push(s);
                                break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    s = t.call(e, a);
                } catch (e) {
                    s = [
                        6,
                        e
                    ], i = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                };
            }([
                s,
                u
            ]);
        };
    }
}
function $5086f3773d25c2f6$var$u() {
    var e = "undefined" != typeof window && "number" == typeof window.devicePixelRatio ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, e), 3);
}
"function" == typeof SuppressedError && SuppressedError;
var $5086f3773d25c2f6$var$c = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}();
var $5086f3773d25c2f6$var$l = globalThis.ResizeObserver || $5086f3773d25c2f6$var$c, $5086f3773d25c2f6$var$f = void 0 !== globalThis.ResizeObserver, $5086f3773d25c2f6$var$d = !$5086f3773d25c2f6$var$f;
function $5086f3773d25c2f6$var$v(t, n) {
    void 0 === n && (n = !0);
    var i = $8FY87.useState({
        width: 0,
        height: 0
    }), r = i[0], o = i[1];
    $8FY87.useEffect(function() {
        if ("undefined" != typeof window && n) {
            var e = function() {
                o({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return $5086f3773d25c2f6$var$d && (e(), window.addEventListener("resize", e)), function() {
                return window.removeEventListener("resize", e);
            };
        }
    }, []);
    var a, s, u, c = $8FY87.useRef(new $5086f3773d25c2f6$var$l((a = function(e) {
        $5086f3773d25c2f6$var$f && o({
            width: e[e.length - 1].contentRect.width,
            height: e[e.length - 1].contentRect.height
        });
    }, s = 0, u = 0, function() {
        for(var e = this, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
        clearTimeout(u), u = window.setTimeout(function() {
            return a.apply(e, t);
        }, s);
    })));
    return $8FY87.useEffect(function() {
        var e = c.current;
        if (n) {
            var i = t.current;
            return t.current && $5086f3773d25c2f6$var$f && e.observe(t.current), function() {
                e.disconnect(), i && $5086f3773d25c2f6$var$f && e.unobserve(i);
            };
        }
        e.disconnect();
    }, [
        t,
        c
    ]), r;
}
var $5086f3773d25c2f6$var$h = {
    useDevicePixelRatio: !0,
    fitCanvasToArtboardHeight: !1,
    useOffscreenRenderer: !0,
    shouldResizeCanvasToContainer: !0
};
function $5086f3773d25c2f6$var$p(e) {
    return Object.assign({}, $5086f3773d25c2f6$var$h, e);
}
function $5086f3773d25c2f6$var$b(t) {
    var n = t.riveLoaded, i = void 0 !== n && n, r = t.canvasElem, o = t.containerRef, a = t.options, s = void 0 === a ? {} : a, c = t.onCanvasHasResized, l = t.artboardBounds, f = $5086f3773d25c2f6$var$p(s), d = $8FY87.useState({
        height: 0,
        width: 0
    }), h = d[0], b = h.height, w = h.width, y = d[1], g = $8FY87.useState({
        height: 0,
        width: 0
    }), m = g[0], R = m.height, C = m.width, E = g[1], O = $8FY87.useState(!0), x = O[0], T = O[1], P = f.fitCanvasToArtboardHeight, L = f.shouldResizeCanvasToContainer, S = f.useDevicePixelRatio, k = f.customDevicePixelRatio, M = $5086f3773d25c2f6$var$v(o, L), z = function(t) {
        var n = t || $5086f3773d25c2f6$var$u(), i = $8FY87.useState(n), r = i[0], o = i[1];
        return $8FY87.useEffect(function() {
            if ("undefined" != typeof window && "matchMedia" in window) {
                var e = function() {
                    var e = t || $5086f3773d25c2f6$var$u();
                    o(e);
                }, n = window.matchMedia("screen and (resolution: ".concat(r, "dppx)"));
                return n.hasOwnProperty("addEventListener") ? n.addEventListener("change", e) : n.addListener(e), function() {
                    n.hasOwnProperty("removeEventListener") ? n.removeEventListener("change", e) : n.removeListener(e);
                };
            }
        }, [
            r,
            t
        ]), r;
    }(k), H = null != l ? l : {}, j = H.maxX, I = H.maxY, D = $8FY87.useCallback(function() {
        var e, t, n, i, r = null !== (t = null === (e = o.current) || void 0 === e ? void 0 : e.clientWidth) && void 0 !== t ? t : 0, a = null !== (i = null === (n = o.current) || void 0 === n ? void 0 : n.clientHeight) && void 0 !== i ? i : 0;
        return P && l ? {
            width: r,
            height: r * (l.maxY / l.maxX)
        } : {
            width: r,
            height: a
        };
    }, [
        o,
        P,
        j,
        I
    ]);
    $8FY87.useEffect(function() {
        if (L && o.current && i) {
            var e = D(), t = e.width, n = e.height, a = !1;
            if (r) {
                var s = t !== w || n !== b;
                if (f.fitCanvasToArtboardHeight && s && (o.current.style.height = n + "px", a = !0), f.useDevicePixelRatio) {
                    if (s || t * z !== C || n * z !== R) {
                        var u = z * t, l = z * n;
                        r.width = u, r.height = l, r.style.width = t + "px", r.style.height = n + "px", E({
                            width: u,
                            height: l
                        }), a = !0;
                    }
                } else s && (r.width = t, r.height = n, E({
                    width: t,
                    height: n
                }), a = !0);
                y({
                    width: t,
                    height: n
                });
            }
            c && (x || a) && c && c(), x && T(!1);
        }
    }, [
        r,
        o,
        M,
        z,
        D,
        x,
        T,
        R,
        C,
        b,
        w,
        c,
        L,
        P,
        S,
        i
    ]), $8FY87.useEffect(function() {
        E({
            width: 0,
            height: 0
        });
    }, [
        r
    ]);
}
var $5086f3773d25c2f6$var$w, $5086f3773d25c2f6$var$y = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}(), $5086f3773d25c2f6$var$g = globalThis.IntersectionObserver || $5086f3773d25c2f6$var$y, $5086f3773d25c2f6$var$m = function() {
    function e() {
        var e = this;
        this.elementsMap = new Map, this.onObserved = function(t) {
            t.forEach(function(t) {
                var n = e.elementsMap.get(t.target);
                n && n(t);
            });
        }, this.observer = new $5086f3773d25c2f6$var$g(this.onObserved);
    }
    return e.prototype.registerCallback = function(e, t) {
        this.observer.observe(e), this.elementsMap.set(e, t);
    }, e.prototype.removeCallback = function(e) {
        this.observer.unobserve(e), this.elementsMap.delete(e);
    }, e;
}(), $5086f3773d25c2f6$var$R = function() {
    return $5086f3773d25c2f6$var$w || ($5086f3773d25c2f6$var$w = new $5086f3773d25c2f6$var$m), $5086f3773d25c2f6$var$w;
};
function $5086f3773d25c2f6$var$C(e) {
    var t = e.setContainerRef, n = e.setCanvasRef, a = e.className, s = void 0 === a ? "" : a, u = e.style, c = e.children, l = $5086f3773d25c2f6$var$o(e, [
        "setContainerRef",
        "setCanvasRef",
        "className",
        "style",
        "children"
    ]), f = $5086f3773d25c2f6$var$r({
        width: "100%",
        height: "100%"
    }, u);
    return $5086f3773d25c2f6$var$i.default.createElement("div", $5086f3773d25c2f6$var$r({
        ref: t,
        className: s
    }, !s && {
        style: f
    }), $5086f3773d25c2f6$var$i.default.createElement("canvas", $5086f3773d25c2f6$var$r({
        ref: n,
        style: {
            verticalAlign: "top",
            width: 0,
            height: 0
        }
    }, l), c));
}
function $5086f3773d25c2f6$var$E(n, o) {
    void 0 === o && (o = {});
    var a = $8FY87.useState(null), s = a[0], u = a[1], c = $8FY87.useRef(null), l = $8FY87.useState(null), f = l[0], d = l[1], v = Boolean(n), h = $5086f3773d25c2f6$var$p(o), w = $8FY87.useCallback(function() {
        f && (f.startRendering(), f.resizeToCanvas());
    }, [
        f
    ]);
    $5086f3773d25c2f6$var$b({
        riveLoaded: !!f,
        canvasElem: s,
        containerRef: c,
        options: h,
        onCanvasHasResized: w,
        artboardBounds: null == f ? void 0 : f.bounds
    });
    var y = $8FY87.useCallback(function(e) {
        null === e && s && (s.height = 0, s.width = 0), u(e);
    }, []);
    $8FY87.useEffect(function() {
        if (s && n && null == f) {
            var e = h.useOffscreenRenderer, i = new $c9636b043a129d7c$exports.Rive($5086f3773d25c2f6$var$r($5086f3773d25c2f6$var$r({
                useOffscreenRenderer: e
            }, n), {
                canvas: s
            }));
            i.on($c9636b043a129d7c$exports.EventType.Load, function() {
                s ? d(i) : i.cleanup();
            });
        }
    }, [
        s,
        v,
        f
    ]);
    var g = $8FY87.useCallback(function(e) {
        c.current = e;
    }, []), m = {
        observe: $8FY87.useCallback(function(e, t) {
            $5086f3773d25c2f6$var$R().registerCallback(e, t);
        }, []),
        unobserve: $8FY87.useCallback(function(e) {
            $5086f3773d25c2f6$var$R().removeCallback(e);
        }, [])
    }, E = m.observe, O = m.unobserve;
    $8FY87.useEffect(function() {
        var e, t = !1, n = function() {
            if (s && t) {
                var e = s.getBoundingClientRect();
                e.width > 0 && e.height > 0 && e.top < (window.innerHeight || document.documentElement.clientHeight) && e.bottom > 0 && e.left < (window.innerWidth || document.documentElement.clientWidth) && e.right > 0 && (null == f || f.startRendering(), t = !1);
            }
        };
        return s && !1 !== h.shouldUseIntersectionObserver && E(s, function(i) {
            i.isIntersecting ? f && f.startRendering() : f && f.stopRendering(), t = !i.isIntersecting, clearTimeout(e), i.isIntersecting || 0 !== i.boundingClientRect.width || (e = setTimeout(n, 10));
        }), function() {
            s && O(s);
        };
    }, [
        E,
        O,
        f,
        s,
        h.shouldUseIntersectionObserver
    ]), $8FY87.useEffect(function() {
        return function() {
            f && (f.cleanup(), d(null));
        };
    }, [
        f,
        s
    ]);
    var x = null == n ? void 0 : n.animations;
    $8FY87.useEffect(function() {
        f && x && (f.isPlaying ? (f.stop(f.animationNames), f.play(x)) : f.isPaused && (f.stop(f.animationNames), f.pause(x)));
    }, [
        x,
        f
    ]);
    var T = $8FY87.useCallback(function(e) {
        return $5086f3773d25c2f6$var$i.default.createElement($5086f3773d25c2f6$var$C, $5086f3773d25c2f6$var$r({
            setContainerRef: g,
            setCanvasRef: y
        }, e));
    }, [
        y,
        g
    ]);
    return {
        canvas: s,
        container: c.current,
        setCanvasRef: y,
        setContainerRef: g,
        rive: f,
        RiveComponent: T
    };
}
$5086f3773d25c2f6$exports.default = function(e) {
    var t = e.src, n = e.artboard, a = e.animations, s = e.stateMachines, u = e.layout, c = e.useOffscreenRenderer, l = void 0 === c || c, f = e.shouldDisableRiveListeners, d = void 0 !== f && f, v = e.shouldResizeCanvasToContainer, h = void 0 === v || v, p = e.automaticallyHandleEvents, b = void 0 !== p && p, w = e.children, y = $5086f3773d25c2f6$var$o(e, [
        "src",
        "artboard",
        "animations",
        "stateMachines",
        "layout",
        "useOffscreenRenderer",
        "shouldDisableRiveListeners",
        "shouldResizeCanvasToContainer",
        "automaticallyHandleEvents",
        "children"
    ]), g = $5086f3773d25c2f6$var$E({
        src: t,
        artboard: n,
        animations: a,
        layout: u,
        stateMachines: s,
        autoplay: !0,
        shouldDisableRiveListeners: d,
        automaticallyHandleEvents: b
    }, {
        useOffscreenRenderer: l,
        shouldResizeCanvasToContainer: h
    }).RiveComponent;
    return $5086f3773d25c2f6$var$i.default.createElement(g, $5086f3773d25c2f6$var$r({}, y), w);
}, $5086f3773d25c2f6$exports.useResizeCanvas = $5086f3773d25c2f6$var$b, $5086f3773d25c2f6$exports.useRive = $5086f3773d25c2f6$var$E, $5086f3773d25c2f6$exports.useRiveFile = function(n) {
    var i = this, r = $8FY87.useState(null), o = r[0], u = r[1], c = $8FY87.useState("idle"), l = c[0], f = c[1];
    return $8FY87.useEffect(function() {
        var e = null;
        return $5086f3773d25c2f6$var$a(i, void 0, void 0, function() {
            return $5086f3773d25c2f6$var$s(this, function(i) {
                try {
                    f("loading"), (e = new $c9636b043a129d7c$exports.RiveFile(n)).init(), e.on($c9636b043a129d7c$exports.EventType.Load, function() {
                        null == e || e.getInstance(), u(e), f("success");
                    }), e.on($c9636b043a129d7c$exports.EventType.LoadError, function() {
                        f("failed");
                    }), u(e);
                } catch (e) {
                    console.error(e), f("failed");
                }
                return [
                    2
                ];
            });
        }), function() {
            null == e || e.cleanup();
        };
    }, [
        n.src,
        n.buffer
    ]), {
        riveFile: o,
        status: l
    };
}, $5086f3773d25c2f6$exports.useStateMachineInput = function(n, i, r, o) {
    var a = $8FY87.useState(null), s = a[0], u = a[1];
    return $8FY87.useEffect(function() {
        function e() {
            if (n && i && r || u(null), n && i && r) {
                var e = n.stateMachineInputs(i);
                if (e) {
                    var t = e.find(function(e) {
                        return e.name === r;
                    });
                    void 0 !== o && t && (t.value = o), u(t || null);
                }
            } else u(null);
        }
        e(), n && n.on($c9636b043a129d7c$exports.EventType.Load, function() {
            e();
        });
    }, [
        n
    ]), s;
}, Object.keys($c9636b043a129d7c$exports).forEach(function(e) {
    "default" === e || $5086f3773d25c2f6$exports.hasOwnProperty(e) || Object.defineProperty($5086f3773d25c2f6$exports, e, {
        enumerable: !0,
        get: function() {
            return $c9636b043a129d7c$exports[e];
        }
    });
});



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");
const $11c247271cb77d32$var$BackgroundImageWithLoading = ({ onLoad: onLoad, classname: classname, imageUrl: imageUrl })=>{
    (0, $8FY87.useEffect)(()=>{
        if (!onLoad) return;
        const img = new Image();
        img.src = imageUrl;
        if (img.complete) onLoad();
        else img.onload = onLoad;
    }, [
        imageUrl,
        onLoad
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(classname),
        style: {
            backgroundImage: `url("${imageUrl}")`
        }
    });
};
var $11c247271cb77d32$export$2e2bcd8739ae039 = $11c247271cb77d32$var$BackgroundImageWithLoading;



var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");
var $3616684302e94fe0$export$6b6ccf6a1f2dfe8f;
var $3616684302e94fe0$export$17fa98cb055e8fa7;
var $3616684302e94fe0$export$a5833c2b43ca4340;
var $3616684302e94fe0$export$47511f9a6581d1d6;
var $3616684302e94fe0$export$dd1c05b92185401c;
var $3616684302e94fe0$export$8b28cf6cd00fe080;
var $3616684302e94fe0$export$186c650311ff0789;
var $3616684302e94fe0$export$6746fe0d9c9fab54;
var $3616684302e94fe0$export$2bcf359f0c20e94f;
var $3616684302e94fe0$export$2903d10d531d0ac0;
$3616684302e94fe0$export$6b6ccf6a1f2dfe8f = `Dpptja_ProfileBackground`;
$3616684302e94fe0$export$17fa98cb055e8fa7 = `Dpptja_fontSizeH1`;
$3616684302e94fe0$export$a5833c2b43ca4340 = `Dpptja_fontSizeH2`;
$3616684302e94fe0$export$47511f9a6581d1d6 = `Dpptja_fontSizeH3`;
$3616684302e94fe0$export$dd1c05b92185401c = `Dpptja_fontSizeH4`;
$3616684302e94fe0$export$8b28cf6cd00fe080 = `Dpptja_fontSizeH5`;
$3616684302e94fe0$export$186c650311ff0789 = `Dpptja_fontSizeH6`;
$3616684302e94fe0$export$6746fe0d9c9fab54 = `Dpptja_fontSizeSmall`;
$3616684302e94fe0$export$2bcf359f0c20e94f = `Dpptja_fontSizeTiny`;
$3616684302e94fe0$export$2903d10d531d0ac0 = `Dpptja_fontSizep`;


const $50fe167d1e415d38$var$ProfileBackgroundRive = ({ onLoad: onLoad, riveUrl: riveUrl })=>{
    const { RiveComponent: RiveComponent } = (0, $5086f3773d25c2f6$exports.useRive)({
        src: riveUrl,
        autoplay: true,
        layout: new (0, $5086f3773d25c2f6$exports.Layout)({
            fit: (0, $5086f3773d25c2f6$exports.Fit).Cover,
            alignment: (0, $5086f3773d25c2f6$exports.Alignment).TopCenter
        }),
        onLoad: ()=>{
            if (onLoad) onLoad();
        },
        stateMachines: "State Machine 1"
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)(RiveComponent, {}, riveUrl);
};
const $50fe167d1e415d38$var$ProfileBackground = ({ classname: classname, onLoad: onLoad, imagePath: imagePath, rivUrl: rivUrl })=>{
    // todo handle loading when changing?
    const theme = (0, $cEIti.useTheme)();
    const fallbackImage = theme.customJSON.fallbackBackgroundImageUrl;
    if (!rivUrl && !fallbackImage) setTimeout(()=>{
        onLoad();
    }, 100);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($3616684302e94fe0$export$6b6ccf6a1f2dfe8f, classname),
        children: rivUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)($50fe167d1e415d38$var$ProfileBackgroundRive, {
            onLoad: onLoad,
            riveUrl: rivUrl
        }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $11c247271cb77d32$export$2e2bcd8739ae039), {
            imageUrl: imagePath ? (0, $aTKgi.pathToURL)(imagePath) : fallbackImage,
            onLoad: onLoad
        })
    });
};
var $50fe167d1e415d38$export$2e2bcd8739ae039 = $50fe167d1e415d38$var$ProfileBackground;



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");



var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");
/* Takes an input hex colour, and creates a CSS filter which re-colours the image to the target colour.
Other colours not close to inputColour will not match targetColour.
Grey / white colours in the image will not be affected */ function $a629ea817c78e06a$export$4d446ad208c83351(inputColour, targetColour) {
    if (!targetColour) return {};
    const inputHSL = $a629ea817c78e06a$var$HexToHSL(inputColour); // Images must contain this colour
    const targetHSL = $a629ea817c78e06a$var$HexToHSL(targetColour);
    if (!inputHSL || !targetHSL) return {};
    const hueRotate = targetHSL.h - inputHSL.h;
    const saturation = 100 + (targetHSL.s - inputHSL.s);
    return {
        filter: `hue-rotate(${hueRotate}deg) saturate(${saturation}%)`
    };
}
function $a629ea817c78e06a$export$fdb59f793251d829(targetColour) {
    if (!targetColour) return {};
    const hsl = $a629ea817c78e06a$var$HexToHSL(targetColour);
    if (!hsl) return {};
    // Sepia creates a warm orange (~38° hue), so offset by that
    const sepiaBaseHue = 38;
    let hueRotate = hsl.h - sepiaBaseHue;
    // Wrap into 0–360 range
    if (hueRotate < 0) hueRotate += 360;
    // Boost saturation to ensure vivid colour
    const saturation = 100 + hsl.s * 1.2;
    // Adjust brightness according to lightness
    const brightness = 60 + hsl.l * 0.4;
    return {
        filter: `sepia(1) hue-rotate(${hueRotate}deg) saturate(${saturation}%) brightness(${brightness}%)`
    };
}
function $a629ea817c78e06a$var$HexToHSL(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) {
        console.warn("Could not parse Hex Color");
        return null;
    }
    const rHex = parseInt(result[1], 16);
    const gHex = parseInt(result[2], 16);
    const bHex = parseInt(result[3], 16);
    const r = rHex / 255;
    const g = gHex / 255;
    const b = bHex / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = (max + min) / 2;
    let s = h;
    let l = h;
    if (max === min) // Achromatic
    return {
        h: 0,
        s: 0,
        l: l
    };
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max){
        case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
        case g:
            h = (b - r) / d + 2;
            break;
        case b:
            h = (r - g) / d + 4;
            break;
    }
    h /= 6;
    s = s * 100;
    s = Math.round(s);
    l = l * 100;
    l = Math.round(l);
    h = Math.round(360 * h);
    return {
        h: h,
        s: s,
        l: l
    };
}


var $3f947d0304ec9132$export$cff8f867968cbff3;
var $3f947d0304ec9132$export$17fa98cb055e8fa7;
var $3f947d0304ec9132$export$a5833c2b43ca4340;
var $3f947d0304ec9132$export$47511f9a6581d1d6;
var $3f947d0304ec9132$export$dd1c05b92185401c;
var $3f947d0304ec9132$export$8b28cf6cd00fe080;
var $3f947d0304ec9132$export$186c650311ff0789;
var $3f947d0304ec9132$export$6746fe0d9c9fab54;
var $3f947d0304ec9132$export$2bcf359f0c20e94f;
var $3f947d0304ec9132$export$2903d10d531d0ac0;
$3f947d0304ec9132$export$cff8f867968cbff3 = `wSqWdq_ProfileCharacter`;
$3f947d0304ec9132$export$17fa98cb055e8fa7 = `wSqWdq_fontSizeH1`;
$3f947d0304ec9132$export$a5833c2b43ca4340 = `wSqWdq_fontSizeH2`;
$3f947d0304ec9132$export$47511f9a6581d1d6 = `wSqWdq_fontSizeH3`;
$3f947d0304ec9132$export$dd1c05b92185401c = `wSqWdq_fontSizeH4`;
$3f947d0304ec9132$export$8b28cf6cd00fe080 = `wSqWdq_fontSizeH5`;
$3f947d0304ec9132$export$186c650311ff0789 = `wSqWdq_fontSizeH6`;
$3f947d0304ec9132$export$6746fe0d9c9fab54 = `wSqWdq_fontSizeSmall`;
$3f947d0304ec9132$export$2bcf359f0c20e94f = `wSqWdq_fontSizeTiny`;
$3f947d0304ec9132$export$2903d10d531d0ac0 = `wSqWdq_fontSizep`;


const $a3c39d4e2d193d93$var$ProfileCharacterRive = ({ onLoad: onLoad, riveUrl: riveUrl })=>{
    const { RiveComponent: RiveComponent } = (0, $5086f3773d25c2f6$exports.useRive)({
        src: riveUrl,
        autoplay: true,
        layout: new (0, $5086f3773d25c2f6$exports.Layout)({
            // fit: Fit.Fill,
            alignment: (0, $5086f3773d25c2f6$exports.Alignment).BottomCenter
        }),
        onLoad: ()=>{
            if (onLoad) onLoad();
        },
        stateMachines: "State Machine 1"
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        style: {
            height: "100%",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsx)(RiveComponent, {}, riveUrl)
    });
};
const $a3c39d4e2d193d93$var$ProfileCharacter = ({ classname: classname, onLoad: onLoad, imagePath: imagePath, rivUrl: rivUrl, hexColour: hexColour })=>{
    // todo handle loading when changing?
    const theme = (0, $cEIti.useTheme)();
    const fallbackImage = theme.customJSON.fallbackCharacterImageUrl;
    if (!rivUrl && !fallbackImage) setTimeout(()=>{
        onLoad();
    }, 100);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($3f947d0304ec9132$export$cff8f867968cbff3, classname),
        style: (0, $a629ea817c78e06a$export$4d446ad208c83351)("#FB1B08", hexColour),
        children: rivUrl ? /*#__PURE__*/ (0, $2PPWI.jsx)($a3c39d4e2d193d93$var$ProfileCharacterRive, {
            onLoad: onLoad,
            riveUrl: rivUrl
        }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $11c247271cb77d32$export$2e2bcd8739ae039), {
            imageUrl: imagePath ? (0, $aTKgi.pathToURL)(imagePath) : fallbackImage,
            onLoad: onLoad
        })
    });
};
var $a3c39d4e2d193d93$export$2e2bcd8739ae039 = $a3c39d4e2d193d93$var$ProfileCharacter;




var $ae4e6baa69f387a3$export$11311b79209158e2;
var $ae4e6baa69f387a3$export$345c5736c8054f22;
var $ae4e6baa69f387a3$export$8ce1fd94bee2f412;
var $ae4e6baa69f387a3$export$c0306caf338ac095;
var $ae4e6baa69f387a3$export$17fa98cb055e8fa7;
var $ae4e6baa69f387a3$export$a5833c2b43ca4340;
var $ae4e6baa69f387a3$export$47511f9a6581d1d6;
var $ae4e6baa69f387a3$export$dd1c05b92185401c;
var $ae4e6baa69f387a3$export$8b28cf6cd00fe080;
var $ae4e6baa69f387a3$export$186c650311ff0789;
var $ae4e6baa69f387a3$export$6746fe0d9c9fab54;
var $ae4e6baa69f387a3$export$2bcf359f0c20e94f;
var $ae4e6baa69f387a3$export$2903d10d531d0ac0;
var $ae4e6baa69f387a3$export$337c2b438c93a763;
$ae4e6baa69f387a3$export$11311b79209158e2 = `q8btAG_ProfileAssetsContainer`;
$ae4e6baa69f387a3$export$345c5736c8054f22 = `q8btAG_avatar`;
$ae4e6baa69f387a3$export$8ce1fd94bee2f412 = `q8btAG_background`;
$ae4e6baa69f387a3$export$c0306caf338ac095 = `q8btAG_character`;
$ae4e6baa69f387a3$export$17fa98cb055e8fa7 = `q8btAG_fontSizeH1`;
$ae4e6baa69f387a3$export$a5833c2b43ca4340 = `q8btAG_fontSizeH2`;
$ae4e6baa69f387a3$export$47511f9a6581d1d6 = `q8btAG_fontSizeH3`;
$ae4e6baa69f387a3$export$dd1c05b92185401c = `q8btAG_fontSizeH4`;
$ae4e6baa69f387a3$export$8b28cf6cd00fe080 = `q8btAG_fontSizeH5`;
$ae4e6baa69f387a3$export$186c650311ff0789 = `q8btAG_fontSizeH6`;
$ae4e6baa69f387a3$export$6746fe0d9c9fab54 = `q8btAG_fontSizeSmall`;
$ae4e6baa69f387a3$export$2bcf359f0c20e94f = `q8btAG_fontSizeTiny`;
$ae4e6baa69f387a3$export$2903d10d531d0ac0 = `q8btAG_fontSizep`;
$ae4e6baa69f387a3$export$337c2b438c93a763 = `q8btAG_loadingScreen`;


const $24468f6f9311b4e7$export$11311b79209158e2 = ({ classname: classname, background: background, backgroundClassname: backgroundClassname, character: character, characterClassname: characterClassname, avatarFrame: avatarFrame, avatarClassname: avatarClassname })=>{
    const [characterIsLoaded, setCharacterIsLoaded] = (0, $8FY87.useState)(false);
    const [backgroundIsLoaded, setBackgroundIsLoaded] = (0, $8FY87.useState)(false);
    const isLoading = !(characterIsLoaded && backgroundIsLoaded);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ae4e6baa69f387a3$export$11311b79209158e2, classname),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $50fe167d1e415d38$export$2e2bcd8739ae039), {
                classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ae4e6baa69f387a3$export$8ce1fd94bee2f412, backgroundClassname),
                onLoad: ()=>setBackgroundIsLoaded(true),
                rivUrl: background?.rivFileURL,
                imagePath: background?.imagePath
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3c39d4e2d193d93$export$2e2bcd8739ae039), {
                classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ae4e6baa69f387a3$export$c0306caf338ac095, characterClassname),
                onLoad: ()=>setCharacterIsLoaded(true),
                rivUrl: character?.rivFileURL,
                imagePath: character?.imagePath,
                hexColour: background?.colour
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($ae4e6baa69f387a3$export$345c5736c8054f22, avatarClassname),
                backgroundImagePath: background?.thumbnailPath,
                characterImagePath: character?.thumbnailPath,
                frameImagePath: avatarFrame?.imagePath
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                show: isLoading,
                classname: $ae4e6baa69f387a3$export$337c2b438c93a763
            })
        ]
    });
};
var $24468f6f9311b4e7$export$2e2bcd8739ae039 = $24468f6f9311b4e7$export$11311b79209158e2;


var $7b6092c1a226c52a$exports = {};

$parcel$export($7b6092c1a226c52a$exports, "PostPurchaseScreen", function () { return $7b6092c1a226c52a$export$8a71e95513d85261; }, function (v) { return $7b6092c1a226c52a$export$8a71e95513d85261 = v; });
$parcel$export($7b6092c1a226c52a$exports, "assetsContainer", function () { return $7b6092c1a226c52a$export$3c2803902d5423fa; }, function (v) { return $7b6092c1a226c52a$export$3c2803902d5423fa = v; });
$parcel$export($7b6092c1a226c52a$exports, "background", function () { return $7b6092c1a226c52a$export$8ce1fd94bee2f412; }, function (v) { return $7b6092c1a226c52a$export$8ce1fd94bee2f412 = v; });
$parcel$export($7b6092c1a226c52a$exports, "buttons", function () { return $7b6092c1a226c52a$export$bbea856fdb3e3c5f; }, function (v) { return $7b6092c1a226c52a$export$bbea856fdb3e3c5f = v; });
$parcel$export($7b6092c1a226c52a$exports, "checkoutCancelled", function () { return $7b6092c1a226c52a$export$14ad50013ce8c09; }, function (v) { return $7b6092c1a226c52a$export$14ad50013ce8c09 = v; });
$parcel$export($7b6092c1a226c52a$exports, "closeButton", function () { return $7b6092c1a226c52a$export$efe229eab43a9869; }, function (v) { return $7b6092c1a226c52a$export$efe229eab43a9869 = v; });
$parcel$export($7b6092c1a226c52a$exports, "failed", function () { return $7b6092c1a226c52a$export$7ab64d539530aa6c; }, function (v) { return $7b6092c1a226c52a$export$7ab64d539530aa6c = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH1", function () { return $7b6092c1a226c52a$export$17fa98cb055e8fa7; }, function (v) { return $7b6092c1a226c52a$export$17fa98cb055e8fa7 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH2", function () { return $7b6092c1a226c52a$export$a5833c2b43ca4340; }, function (v) { return $7b6092c1a226c52a$export$a5833c2b43ca4340 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH3", function () { return $7b6092c1a226c52a$export$47511f9a6581d1d6; }, function (v) { return $7b6092c1a226c52a$export$47511f9a6581d1d6 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH4", function () { return $7b6092c1a226c52a$export$dd1c05b92185401c; }, function (v) { return $7b6092c1a226c52a$export$dd1c05b92185401c = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH5", function () { return $7b6092c1a226c52a$export$8b28cf6cd00fe080; }, function (v) { return $7b6092c1a226c52a$export$8b28cf6cd00fe080 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeH6", function () { return $7b6092c1a226c52a$export$186c650311ff0789; }, function (v) { return $7b6092c1a226c52a$export$186c650311ff0789 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeSmall", function () { return $7b6092c1a226c52a$export$6746fe0d9c9fab54; }, function (v) { return $7b6092c1a226c52a$export$6746fe0d9c9fab54 = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizeTiny", function () { return $7b6092c1a226c52a$export$2bcf359f0c20e94f; }, function (v) { return $7b6092c1a226c52a$export$2bcf359f0c20e94f = v; });
$parcel$export($7b6092c1a226c52a$exports, "fontSizep", function () { return $7b6092c1a226c52a$export$2903d10d531d0ac0; }, function (v) { return $7b6092c1a226c52a$export$2903d10d531d0ac0 = v; });
$parcel$export($7b6092c1a226c52a$exports, "later", function () { return $7b6092c1a226c52a$export$e9f514045a6e57f; }, function (v) { return $7b6092c1a226c52a$export$e9f514045a6e57f = v; });
$parcel$export($7b6092c1a226c52a$exports, "loadingSpinner", function () { return $7b6092c1a226c52a$export$deaa9e6d912ce6c6; }, function (v) { return $7b6092c1a226c52a$export$deaa9e6d912ce6c6 = v; });
$parcel$export($7b6092c1a226c52a$exports, "modal", function () { return $7b6092c1a226c52a$export$96e4b36520c26a2c; }, function (v) { return $7b6092c1a226c52a$export$96e4b36520c26a2c = v; });
$parcel$export($7b6092c1a226c52a$exports, "noBackgroundImage", function () { return $7b6092c1a226c52a$export$c80d57c51a11eb0a; }, function (v) { return $7b6092c1a226c52a$export$c80d57c51a11eb0a = v; });
$parcel$export($7b6092c1a226c52a$exports, "scrollContainer", function () { return $7b6092c1a226c52a$export$fad3c8302a7540c6; }, function (v) { return $7b6092c1a226c52a$export$fad3c8302a7540c6 = v; });
$parcel$export($7b6092c1a226c52a$exports, "success", function () { return $7b6092c1a226c52a$export$fe7c49d056ea1d88; }, function (v) { return $7b6092c1a226c52a$export$fe7c49d056ea1d88 = v; });
$parcel$export($7b6092c1a226c52a$exports, "successNoPack", function () { return $7b6092c1a226c52a$export$d192de76c4d779f6; }, function (v) { return $7b6092c1a226c52a$export$d192de76c4d779f6 = v; });
$parcel$export($7b6092c1a226c52a$exports, "verifying", function () { return $7b6092c1a226c52a$export$8b5b6e02b62ffb5a; }, function (v) { return $7b6092c1a226c52a$export$8b5b6e02b62ffb5a = v; });
var $7b6092c1a226c52a$export$8a71e95513d85261;
var $7b6092c1a226c52a$export$3c2803902d5423fa;
var $7b6092c1a226c52a$export$8ce1fd94bee2f412;
var $7b6092c1a226c52a$export$bbea856fdb3e3c5f;
var $7b6092c1a226c52a$export$14ad50013ce8c09;
var $7b6092c1a226c52a$export$efe229eab43a9869;
var $7b6092c1a226c52a$export$7ab64d539530aa6c;
var $7b6092c1a226c52a$export$17fa98cb055e8fa7;
var $7b6092c1a226c52a$export$a5833c2b43ca4340;
var $7b6092c1a226c52a$export$47511f9a6581d1d6;
var $7b6092c1a226c52a$export$dd1c05b92185401c;
var $7b6092c1a226c52a$export$8b28cf6cd00fe080;
var $7b6092c1a226c52a$export$186c650311ff0789;
var $7b6092c1a226c52a$export$6746fe0d9c9fab54;
var $7b6092c1a226c52a$export$2bcf359f0c20e94f;
var $7b6092c1a226c52a$export$2903d10d531d0ac0;
var $7b6092c1a226c52a$export$e9f514045a6e57f;
var $7b6092c1a226c52a$export$deaa9e6d912ce6c6;
var $7b6092c1a226c52a$export$96e4b36520c26a2c;
var $7b6092c1a226c52a$export$c80d57c51a11eb0a;
var $7b6092c1a226c52a$export$fad3c8302a7540c6;
var $7b6092c1a226c52a$export$fe7c49d056ea1d88;
var $7b6092c1a226c52a$export$d192de76c4d779f6;
var $7b6092c1a226c52a$export$8b5b6e02b62ffb5a;
$7b6092c1a226c52a$export$8a71e95513d85261 = `-HmIza_PostPurchaseScreen`;
$7b6092c1a226c52a$export$3c2803902d5423fa = `-HmIza_assetsContainer`;
$7b6092c1a226c52a$export$8ce1fd94bee2f412 = `-HmIza_background`;
$7b6092c1a226c52a$export$bbea856fdb3e3c5f = `-HmIza_buttons`;
$7b6092c1a226c52a$export$14ad50013ce8c09 = `-HmIza_checkoutCancelled`;
$7b6092c1a226c52a$export$efe229eab43a9869 = `-HmIza_closeButton`;
$7b6092c1a226c52a$export$7ab64d539530aa6c = `-HmIza_failed`;
$7b6092c1a226c52a$export$17fa98cb055e8fa7 = `-HmIza_fontSizeH1`;
$7b6092c1a226c52a$export$a5833c2b43ca4340 = `-HmIza_fontSizeH2`;
$7b6092c1a226c52a$export$47511f9a6581d1d6 = `-HmIza_fontSizeH3`;
$7b6092c1a226c52a$export$dd1c05b92185401c = `-HmIza_fontSizeH4`;
$7b6092c1a226c52a$export$8b28cf6cd00fe080 = `-HmIza_fontSizeH5`;
$7b6092c1a226c52a$export$186c650311ff0789 = `-HmIza_fontSizeH6`;
$7b6092c1a226c52a$export$6746fe0d9c9fab54 = `-HmIza_fontSizeSmall`;
$7b6092c1a226c52a$export$2bcf359f0c20e94f = `-HmIza_fontSizeTiny`;
$7b6092c1a226c52a$export$2903d10d531d0ac0 = `-HmIza_fontSizep`;
$7b6092c1a226c52a$export$e9f514045a6e57f = `-HmIza_later`;
$7b6092c1a226c52a$export$deaa9e6d912ce6c6 = `-HmIza_loadingSpinner`;
$7b6092c1a226c52a$export$96e4b36520c26a2c = `-HmIza_modal`;
$7b6092c1a226c52a$export$c80d57c51a11eb0a = `-HmIza_noBackgroundImage`;
$7b6092c1a226c52a$export$fad3c8302a7540c6 = `-HmIza_scrollContainer`;
$7b6092c1a226c52a$export$fe7c49d056ea1d88 = `-HmIza_success`;
$7b6092c1a226c52a$export$d192de76c4d779f6 = `-HmIza_successNoPack`;
$7b6092c1a226c52a$export$8b5b6e02b62ffb5a = `-HmIza_verifying`;


const $d528cc64cba566a3$var$Verifying = ()=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                show: true,
                hasBackground: false,
                classname: $7b6092c1a226c52a$exports.loadingSpinner
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Verifying Purchase"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "Please wait..."
            })
        ]
    });
const $d528cc64cba566a3$var$Failed = ({ onClose: onClose })=>{
    const emailHref = `mailto:${(0, $1URoE.SUPPORT_EMAIL)}?subject=Something went wrong`;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        className: "mb-4",
                        children: "Sorry, something went wrong."
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                        children: [
                            "Please try again, or contact Support for assistance:",
                            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                href: emailHref,
                                onClick: ()=>(0, $i7H0N.sendEvent)("shop_post_purchase_fail_support_email_click"),
                                children: (0, $1URoE.SUPPORT_EMAIL)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                onClick: onClose,
                children: "Close"
            })
        ]
    });
};
const $d528cc64cba566a3$var$SuccessNoPack = ({ onClose: onClose })=>{
    // Just in case we can't find the pack from the API, but payment was successful.
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        className: "mb-4",
                        children: "Payment Successful!"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "This pack is now part of your profile collection."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                onClick: onClose,
                children: "Close"
            })
        ]
    });
};
const $d528cc64cba566a3$var$CheckoutCancelled = ({ onClose: onClose })=>{
    // If user presses back from stripe
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: "mb-4",
                    children: "Checkout Cancelled"
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                onClick: onClose,
                children: "Close"
            })
        ]
    });
};
const $d528cc64cba566a3$var$Success = ({ pack: pack, onClose: onClose })=>{
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const successOnApplyNow = ()=>{
        (0, $fL4mk.setProfileAsset)("background", pack.assets.background.id);
        (0, $fL4mk.setProfileAsset)("character", pack.assets.character.id);
        (0, $fL4mk.setProfileAsset)("avatar_frame", pack.assets.avatarFrame.id);
        onClose();
        dispatch((0, $baXkz.openProfile)());
        (0, $i7H0N.sendEvent)("shop_post_purchase_success_apply_pack");
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                iconType: "close",
                buttonStyle: "round",
                ariaLabel: "Close",
                className: $7b6092c1a226c52a$exports.closeButton,
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $7b6092c1a226c52a$exports.scrollContainer,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $24468f6f9311b4e7$export$2e2bcd8739ae039), {
                        classname: $7b6092c1a226c52a$exports.assetsContainer,
                        background: pack.assets.background,
                        character: pack.assets.character,
                        avatarFrame: pack.assets.avatarFrame
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                        children: [
                            "You now own ",
                            pack.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "This pack is now part of your profile collection."
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $7b6092c1a226c52a$exports.buttons,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                                className: $7b6092c1a226c52a$exports.later,
                                onClick: ()=>{
                                    (0, $i7H0N.sendEvent)("shop_post_purchase_success_apply_later");
                                    onClose();
                                },
                                children: "Later"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                                onClick: successOnApplyNow,
                                children: "Apply Now"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $d528cc64cba566a3$export$8a71e95513d85261 = ({ classname: classname })=>{
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [uiStatus, setUiStatus] = (0, $8FY87.useState)("hidden");
    const [selectedPack, setSelectedPack] = (0, $8FY87.useState)();
    (0, $8FY87.useEffect)(()=>{
        const checkSessionStatus = async ()=>{
            const searchParams = new URLSearchParams(window.location.search);
            const isCheckout = searchParams.get("checkout");
            if (isCheckout) {
                dispatch((0, $baXkz.setIsPurchaseInProgress)(true));
                const urlStatus = searchParams.get("status"); // 'confirmed' or 'cancel'
                const urlSessionId = searchParams.get("session_id");
                navigate(window.location.pathname, {
                    replace: true
                }); // Clean URL
                if (urlStatus === "success" && urlSessionId) {
                    setUiStatus("verifying");
                    try {
                        const response = await (0, $882c398467ff90b2$export$89c78e966bf89d69)(urlSessionId);
                        if (response) {
                            if (response.status === "confirmed") {
                                const selectedPack = await (0, $882c398467ff90b2$export$e1f5ba8d130868e2)(response.items[0]?.id);
                                if (selectedPack?.assets) {
                                    setSelectedPack(selectedPack);
                                    setUiStatus("success");
                                    (0, $i7H0N.sendEvent)("shop_post_purchase_success");
                                } else {
                                    setUiStatus("successNoPack");
                                    (0, $i7H0N.sendEvent)("shop_post_purchase_success_nopack");
                                }
                            }
                        } else {
                            console.warn("Session verification failed or timed out");
                            setUiStatus("failed");
                            (0, $i7H0N.sendEvent)("shop_post_purchase_fail", {
                                message: "Session verification failed or timed out"
                            });
                        }
                    } catch (error) {
                        console.error("Could not verify session status");
                        setUiStatus("failed");
                        (0, $i7H0N.sendEvent)("shop_post_purchase_fail", {
                            message: "Could not verify session status"
                        });
                    }
                } else if (urlStatus === "cancel") {
                    console.warn("Checkout URL has status cancel");
                    dispatch((0, $baXkz.setIsShopOpen)(true));
                    setUiStatus("checkoutCancelled");
                    (0, $i7H0N.sendEvent)("shop_post_purchase_cancelled");
                } else {
                    console.warn("Invalid URL params:", urlStatus, urlSessionId);
                    (0, $i7H0N.sendEvent)("shop_post_purchase_invalid_url");
                    closeScreen();
                }
            }
        };
        checkSessionStatus();
    }, []);
    const closeScreen = ()=>{
        dispatch((0, $baXkz.setIsPurchaseInProgress)(false));
        setUiStatus("hidden");
    };
    const getContent = ()=>{
        switch(uiStatus){
            case "checkoutCancelled":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($d528cc64cba566a3$var$CheckoutCancelled, {
                    onClose: closeScreen
                });
            case "verifying":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($d528cc64cba566a3$var$Verifying, {});
            case "failed":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($d528cc64cba566a3$var$Failed, {
                    onClose: closeScreen
                });
            case "success":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($d528cc64cba566a3$var$Success, {
                    onClose: closeScreen,
                    pack: selectedPack
                });
            case "successNoPack":
                return /*#__PURE__*/ (0, $2PPWI.jsx)($d528cc64cba566a3$var$SuccessNoPack, {
                    onClose: closeScreen
                });
            default:
                break;
        }
    };
    if (uiStatus === "hidden") return null;
    const backgroundImage = theme.customJSON?.profileBackground;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7b6092c1a226c52a$exports.PostPurchaseScreen, classname),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $7b6092c1a226c52a$exports.background
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7b6092c1a226c52a$exports.modal, $7b6092c1a226c52a$exports[uiStatus], {
                    [$7b6092c1a226c52a$exports.noBackgroundImage]: !backgroundImage
                }),
                style: backgroundImage ? {
                    backgroundImage: `url("${theme.customJSON?.profileBackground}")`
                } : {},
                children: getContent()
            })
        ]
    });
};
var $d528cc64cba566a3$export$2e2bcd8739ae039 = $d528cc64cba566a3$export$8a71e95513d85261;



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $1URoE = parcelRequire("1URoE");

var $6lYLL = parcelRequire("6lYLL");

var $jJtwY = parcelRequire("jJtwY");

var $aTRs6 = parcelRequire("aTRs6");
function $e6117fabf1c6ed74$export$2e2bcd8739ae039({ children: children }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    // Disable login for discord activity since discord uses it's own auth mechanism.
    const disable_login = (0, $aTRs6.IS_DISCORD_ACTIVITY);
    // Do not run if autoGuestMode is disabled or on /auth routes
    const theme = (0, $cEIti.useTheme)();
    const autoGuestModeEnabled = theme.metadata?.authConfig?.autoGuestMode || (0, $1URoE.isInsidersInstance); // Insiders cannot access logged out page
    const isOnAuthRoute = window.location.pathname.startsWith("/auth");
    const checkedDefault = isOnAuthRoute || !autoGuestModeEnabled;
    const [checked, setChecked] = (0, $8FY87.useState)(checkedDefault);
    // If true, render content even if logged out
    const alwaysAllowContentRendering = true;
    (0, $8FY87.useEffect)(()=>{
        if (disable_login) {
            setChecked(true);
            return;
        }
        (async ()=>{
            if (!checked) try {
                // TODO: in theory this auth gate should redirect users to the login page if required. but since we currently don't use this type of flow, we just log them in as a guest.
                await dispatch((0, $jJtwY.initialAuthFlow)());
                setChecked(true);
            } catch (e) {
                console.error(e);
                setChecked(true);
            }
            else setChecked(true);
        })();
    }, []);
    return alwaysAllowContentRendering || checked ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: children
    }) : null;
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");


parcelRequire("1URoE");

var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");


var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $362cfbe95384ae3f$export$d5992c1fec905475;
var $362cfbe95384ae3f$export$17fa98cb055e8fa7;
var $362cfbe95384ae3f$export$a5833c2b43ca4340;
var $362cfbe95384ae3f$export$47511f9a6581d1d6;
var $362cfbe95384ae3f$export$dd1c05b92185401c;
var $362cfbe95384ae3f$export$8b28cf6cd00fe080;
var $362cfbe95384ae3f$export$186c650311ff0789;
var $362cfbe95384ae3f$export$6746fe0d9c9fab54;
var $362cfbe95384ae3f$export$2bcf359f0c20e94f;
var $362cfbe95384ae3f$export$2903d10d531d0ac0;
var $362cfbe95384ae3f$export$ba6acb6e4dfd83c2;
$362cfbe95384ae3f$export$d5992c1fec905475 = `yJ5yJW_ButtonLink`;
$362cfbe95384ae3f$export$17fa98cb055e8fa7 = `yJ5yJW_fontSizeH1`;
$362cfbe95384ae3f$export$a5833c2b43ca4340 = `yJ5yJW_fontSizeH2`;
$362cfbe95384ae3f$export$47511f9a6581d1d6 = `yJ5yJW_fontSizeH3`;
$362cfbe95384ae3f$export$dd1c05b92185401c = `yJ5yJW_fontSizeH4`;
$362cfbe95384ae3f$export$8b28cf6cd00fe080 = `yJ5yJW_fontSizeH5`;
$362cfbe95384ae3f$export$186c650311ff0789 = `yJ5yJW_fontSizeH6`;
$362cfbe95384ae3f$export$6746fe0d9c9fab54 = `yJ5yJW_fontSizeSmall`;
$362cfbe95384ae3f$export$2bcf359f0c20e94f = `yJ5yJW_fontSizeTiny`;
$362cfbe95384ae3f$export$2903d10d531d0ac0 = `yJ5yJW_fontSizep`;
$362cfbe95384ae3f$export$ba6acb6e4dfd83c2 = `yJ5yJW_highlighted`;


function $eeb4f69889bc3099$export$d5992c1fec905475({ children: children, onClick: onClick, className: className, isHighlighted: isHighlighted, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($362cfbe95384ae3f$export$d5992c1fec905475, className, {
            [$362cfbe95384ae3f$export$ba6acb6e4dfd83c2]: isHighlighted
        }),
        ...props,
        onClick: onClick,
        children: children
    });
}



function $3a42c562e655962a$export$2e2bcd8739ae039({ navigateToScreen: navigateToScreen }) {
    const theme = (0, $cEIti.useTheme)();
    const authConfig = theme.metadata?.authConfig;
    const termsUrl = theme.customJSON?.auth?.links?.terms;
    const privacyUrl = theme.customJSON?.auth?.links?.privacy;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Join Those Beyond"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "A place where fans can connect, explore, and participate together in the worlds they love."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$b109b9c2518624d5), {
                authProviders: authConfig?.authProviders
            }),
            !!authConfig?.authProviders?.length && authConfig?.enableEmailAccounts && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $f84adfbb9c6e021a$export$3e523c77c1f23f8c,
                children: "or"
            }),
            authConfig?.enableEmailAccounts && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                text: "Continue with email",
                onClick: ()=>navigateToScreen("emailSignup")
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                className: $f84adfbb9c6e021a$export$60877daf335d779,
                children: [
                    "By signing up, you agree to the",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        href: termsUrl,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Terms of Service"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: privacyUrl,
                        children: "Privacy Policy"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                children: [
                    "Have an account?",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eeb4f69889bc3099$export$d5992c1fec905475), {
                        isHighlighted: true,
                        onClick: ()=>navigateToScreen("login"),
                        children: "Log in"
                    })
                ]
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");


var $6lYLL = parcelRequire("6lYLL");


var $jJtwY = parcelRequire("jJtwY");

var $4KKbJ = parcelRequire("4KKbJ");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");
const $f0b1482053f961fa$var$SITE_KEY = "0x4AAAAAAA1aRClQo6-OwKx9";
const $f0b1482053f961fa$var$jsLib = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
function $f0b1482053f961fa$export$9370f0117bf9debc(props) {
    const ref = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        const script = document.createElement("script");
        script.src = $f0b1482053f961fa$var$jsLib;
        script.defer = true;
        script.onload = ()=>{
            // @ts-ignore
            window.onloadTurnstileCallback = ()=>{
                // @ts-ignore
                window.turnstile.render(ref.current, {
                    size: "flexible",
                    sitekey: $f0b1482053f961fa$var$SITE_KEY,
                    callback: function(token) {
                        props.onToken(token);
                    },
                    "error-callback": function(error) {
                        console.error("Turnstile error: ", error);
                        props.onError(error);
                    }
                });
            };
        };
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(props.className),
            ref: ref,
            style: {
                width: "100%"
            }
        })
    });
}



function $d0faf8cfe0ad29e4$export$2e2bcd8739ae039({ navigateToScreen: navigateToScreen, closeModal: closeModal }) {
    const theme = (0, $cEIti.useTheme)();
    const auth = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const authConfig = theme.metadata?.authConfig;
    const termsUrl = theme.customJSON?.auth?.links?.terms;
    const privacyUrl = theme.customJSON?.auth?.links?.privacy;
    const [email, setEmail] = (0, $8FY87.useState)("");
    const [password, setPassword] = (0, $8FY87.useState)("");
    const [agreementChecked, setAgreementChecked] = (0, $8FY87.useState)(false);
    const [turnstileToken, setTurnstileToken] = (0, $8FY87.useState)("");
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    function onSubmit() {
        if (auth.isRegistering) return;
        if (!(0, $5e60b378ec730cd4$export$371e338370561054)(email)) {
            setErrorCode("EMAIL_INVALID");
            return;
        }
        if (!(0, $5e60b378ec730cd4$export$1cf356d314abea16)(password)) {
            setErrorCode("PASSWORD_TOO_SHORT");
            return;
        }
        if (!email || !password || authConfig?.enableTurnstile && !turnstileToken) return;
        dispatch((0, $jJtwY.register)([
            email,
            password,
            turnstileToken
        ]));
    }
    (0, $8FY87.useEffect)(()=>{
        // Registered successfully, now log user in
        if (auth.isRegistrationSuccessful) dispatch((0, $jJtwY.login)([
            email,
            password
        ]));
    }, [
        auth.isRegistrationSuccessful
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Failed to register, show error
        if (auth.registerError) {
            window["turnstile"]?.reset?.();
            setErrorCode(auth.registerError);
        }
    }, [
        auth.registerError
    ]);
    (0, $8FY87.useEffect)(()=>{
        // User is registered and logged in, load their profile and close modal
        if (auth.user?.email === email) {
            dispatch((0, $4KKbJ.loadCurrentUserProfile)([
                auth.user.id
            ]));
            closeModal();
        }
    }, [
        auth.loggedIn,
        auth.user?.email
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Enter your details"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-registration-email",
                children: "Email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-registration-email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                placeholder: "Email Address",
                autoComplete: "email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-registration-password",
                children: "Password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-registration-password",
                value: password,
                onChange: (e)=>setPassword(e.target.value),
                placeholder: "Password",
                type: "password",
                autoComplete: "new-password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $f84adfbb9c6e021a$export$be69ea624d82a314,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                        type: "checkbox",
                        id: "arise-registration-terms-check",
                        checked: agreementChecked,
                        onChange: (e)=>setAgreementChecked(e.target.checked)
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("label", {
                        htmlFor: "arise-registration-terms-check",
                        children: [
                            "I have read and agree to",
                            " ",
                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: termsUrl,
                                children: "Those Beyond\u2019s Terms of Service"
                            }),
                            " ",
                            "and",
                            " ",
                            /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: privacyUrl,
                                children: "Privacy Policy"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            authConfig?.enableTurnstile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f0b1482053f961fa$export$9370f0117bf9debc), {
                className: $f84adfbb9c6e021a$export$457806cff9fed328,
                onToken: (token)=>setTurnstileToken(token),
                onError: ()=>setErrorCode("VERIFICATION_FAILED")
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                disabled: !(email && password && agreementChecked && (!authConfig?.enableTurnstile || turnstileToken)),
                text: "Continue",
                onClick: onSubmit
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                className: $f84adfbb9c6e021a$export$5cfd5c18b591b2db,
                children: [
                    "Have an account?",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eeb4f69889bc3099$export$d5992c1fec905475), {
                        isHighlighted: true,
                        onClick: ()=>navigateToScreen("login"),
                        children: "Log in"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$493b5823483d2c4e,
                children: $d0faf8cfe0ad29e4$var$getRegistrationErrorMessage(errorCode)
            })
        ]
    });
}
function $d0faf8cfe0ad29e4$var$getRegistrationErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "EMAIL_TAKEN":
            return "This email is already in use.";
        case "EMAIL_INVALID":
            return 0, $5e60b378ec730cd4$export$aa8c7e6540925da0;
        case "PASSWORD_TOO_SHORT":
            return 0, $5e60b378ec730cd4$export$22f782bed1cafd3f;
        case "MISSING_FIELDS":
            return "Please fill in all required fields.";
        case "VERIFICATION_FAILED":
            return "Verification failed. Please try again or refresh the page.";
        default:
            return "An unknown error occurred. Please try again.";
    }
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");


var $4KKbJ = parcelRequire("4KKbJ");

var $jJtwY = parcelRequire("jJtwY");

var $cEIti = parcelRequire("cEIti");



function $ab5ee86bec0fdc07$export$2e2bcd8739ae039({ navigateToScreen: navigateToScreen, closeModal: closeModal }) {
    const auth = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const authConfig = theme.metadata?.authConfig;
    const [email, setEmail] = (0, $8FY87.useState)("");
    const [password, setPassword] = (0, $8FY87.useState)("");
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    function onSubmit() {
        if (auth.isRegistering) return;
        if (!(0, $5e60b378ec730cd4$export$371e338370561054)(email)) {
            setErrorCode("EMAIL_INVALID");
            return;
        }
        if (!email || !password) return;
        dispatch((0, $jJtwY.login)([
            email,
            password
        ]));
    }
    (0, $8FY87.useEffect)(()=>{
        // New user has been logged in
        if (auth.user?.email === email) {
            dispatch((0, $4KKbJ.loadCurrentUserProfile)([
                auth.user.id
            ]));
            closeModal();
        }
    }, [
        auth.user
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (auth.loginError) setErrorCode(auth.loginError);
    }, [
        auth.loginError
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Log in"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$b109b9c2518624d5), {
                authProviders: authConfig?.authProviders
            }),
            !!authConfig?.authProviders?.length && authConfig?.enableEmailAccounts && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $f84adfbb9c6e021a$export$3e523c77c1f23f8c,
                children: "or"
            }),
            authConfig?.enableEmailAccounts && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        htmlFor: "arise-login-email",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                        className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                        id: "arise-login-email",
                        value: email,
                        onChange: (e)=>setEmail(e.target.value),
                        placeholder: "Email Address",
                        autoComplete: "email"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                        htmlFor: "arise-login-password",
                        children: "Password"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                        className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                        id: "arise-login-password",
                        value: password,
                        onChange: (e)=>setPassword(e.target.value),
                        placeholder: "Password",
                        type: "password",
                        autoComplete: "new-password",
                        style: {
                            marginBottom: 12
                        }
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eeb4f69889bc3099$export$d5992c1fec905475), {
                        onClick: ()=>navigateToScreen("forgottenPassword"),
                        className: $f84adfbb9c6e021a$export$66791fb2cfeec3e,
                        children: "Forgotten Password?"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                        disabled: !(email && password),
                        text: "Log in",
                        onClick: onSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                className: $f84adfbb9c6e021a$export$5cfd5c18b591b2db,
                children: [
                    "Don't have an account?",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eeb4f69889bc3099$export$d5992c1fec905475), {
                        isHighlighted: true,
                        onClick: ()=>navigateToScreen("signupLanding"),
                        children: "Sign Up"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$493b5823483d2c4e,
                children: $ab5ee86bec0fdc07$var$getLoginErrorMessage(errorCode)
            })
        ]
    });
}
function $ab5ee86bec0fdc07$var$getLoginErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "EMAIL_INVALID":
            return 0, $5e60b378ec730cd4$export$aa8c7e6540925da0;
        case "INVALID_CREDENTIALS":
            return "Invalid email or password. Please try again.";
        case "MISSING_FIELDS":
            return "Please fill in all required fields.";
        default:
            return "An unknown error occurred. Please try again.";
    }
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $f9aoP = parcelRequire("f9aoP");



var $1URoE = parcelRequire("1URoE");

var $cEIti = parcelRequire("cEIti");


function $f157db02869d3bb8$export$2e2bcd8739ae039({ navigateToScreen: navigateToScreen }) {
    const [email, setEmail] = (0, $8FY87.useState)("");
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    const theme = (0, $cEIti.useTheme)();
    const helpUrl = theme.customJSON?.auth?.links?.help;
    const [uiStatus, setUiStatus] = (0, $8FY87.useState)("enterEmail");
    async function onSubmit() {
        if (!(0, $5e60b378ec730cd4$export$371e338370561054)(email)) {
            setErrorCode("EMAIL_INVALID");
            return;
        }
        try {
            await (0, $f9aoP.passwordReset)(email);
            setUiStatus("emailSent");
        } catch (error) {
            setErrorCode(error.message ?? "UNKNOWN_ERROR");
            console.error("Could not reset password", error);
        }
    }
    const EnterEmail = /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Find your Those Beyond account"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "Enter the email associated with your account to change your password."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-forgotten-email",
                children: "Email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-forgotten-email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                placeholder: "Email Address",
                autoComplete: "email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                disabled: !email,
                text: "Continue",
                onClick: onSubmit,
                style: {
                    marginTop: 10
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$493b5823483d2c4e,
                children: $f157db02869d3bb8$var$getPasswordResetErrorMessage(errorCode)
            })
        ]
    });
    const EmailSent = /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Email Sent"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                children: [
                    "We sent an email to ",
                    email,
                    ". If this email is connected to a Those Beyond account, you'll be able to reset your password."
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                children: [
                    "Didn't get the email? Try these tips from our",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: helpUrl,
                        children: "Help Centre"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                text: "Back to Login",
                onClick: ()=>navigateToScreen("login")
            })
        ]
    });
    return uiStatus === "enterEmail" ? EnterEmail : EmailSent;
}
function $f157db02869d3bb8$var$getPasswordResetErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "EMAIL_INVALID":
            return 0, $5e60b378ec730cd4$export$aa8c7e6540925da0;
        default:
            return `Could not reset password, please contact ${0, $1URoE.SUPPORT_EMAIL}`;
    }
}



function $cc3d61eca2f2c193$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const authModalScreen = (0, $6lYLL.useAppSelector)((state)=>state.app.authModalScreen);
    const [uiStatus, setUiStatus] = (0, $8FY87.useState)(authModalScreen);
    const uiStatusHistory = (0, $8FY87.useRef)([]);
    (0, $8FY87.useEffect)(()=>{
        if (!authModalScreen) uiStatusHistory.current = [];
        setUiStatus(authModalScreen);
    }, [
        authModalScreen
    ]);
    function navigateToScreen(screen) {
        uiStatusHistory.current?.push(uiStatus);
        setUiStatus(screen);
    }
    function closeModal() {
        dispatch((0, $baXkz.setAuthModalScreen)(null));
    }
    function goBack() {
        const previousScreen = uiStatusHistory.current?.pop();
        if (previousScreen) setUiStatus(previousScreen);
    }
    const shouldShowBackButton = !!uiStatusHistory.current?.length;
    const getContent = ()=>{
        switch(uiStatus){
            case "signupLanding":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3a42c562e655962a$export$2e2bcd8739ae039), {
                    navigateToScreen: navigateToScreen,
                    closeModal: closeModal
                });
            case "emailSignup":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d0faf8cfe0ad29e4$export$2e2bcd8739ae039), {
                    navigateToScreen: navigateToScreen,
                    closeModal: closeModal
                });
            case "login":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ab5ee86bec0fdc07$export$2e2bcd8739ae039), {
                    navigateToScreen: navigateToScreen,
                    closeModal: closeModal
                });
            case "forgottenPassword":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f157db02869d3bb8$export$2e2bcd8739ae039), {
                    navigateToScreen: navigateToScreen,
                    closeModal: closeModal
                });
            default:
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3a42c562e655962a$export$2e2bcd8739ae039), {
                    navigateToScreen: navigateToScreen,
                    closeModal: closeModal
                });
        }
    };
    return null;
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $aTKgi = parcelRequire("aTKgi");


var $cc7f5f9c0d1a1873$export$85ddf6e7b752aaaa;
var $cc7f5f9c0d1a1873$export$8ce1fd94bee2f412;
var $cc7f5f9c0d1a1873$export$efe229eab43a9869;
var $cc7f5f9c0d1a1873$export$6565f9f03506010b;
var $cc7f5f9c0d1a1873$export$ee08fe7decb01058;
var $cc7f5f9c0d1a1873$export$152f516478c1ac4a;
var $cc7f5f9c0d1a1873$export$8f981dffec84ba52;
var $cc7f5f9c0d1a1873$export$9624302a33c1c6cb;
var $cc7f5f9c0d1a1873$export$6727d3534640939;
var $cc7f5f9c0d1a1873$export$17fa98cb055e8fa7;
var $cc7f5f9c0d1a1873$export$a5833c2b43ca4340;
var $cc7f5f9c0d1a1873$export$47511f9a6581d1d6;
var $cc7f5f9c0d1a1873$export$dd1c05b92185401c;
var $cc7f5f9c0d1a1873$export$8b28cf6cd00fe080;
var $cc7f5f9c0d1a1873$export$186c650311ff0789;
var $cc7f5f9c0d1a1873$export$6746fe0d9c9fab54;
var $cc7f5f9c0d1a1873$export$2bcf359f0c20e94f;
var $cc7f5f9c0d1a1873$export$2903d10d531d0ac0;
var $cc7f5f9c0d1a1873$export$e4043f67d36cbb26;
var $cc7f5f9c0d1a1873$export$f4b13d60f20dd3ed;
var $cc7f5f9c0d1a1873$export$96e4b36520c26a2c;
var $cc7f5f9c0d1a1873$export$bd1b2113911b269d;
var $cc7f5f9c0d1a1873$export$dbcba3ba19c6687e;
var $cc7f5f9c0d1a1873$export$c663339d28b2854c;
$cc7f5f9c0d1a1873$export$85ddf6e7b752aaaa = `_6TWM_W_RedeemPrizeModal`;
$cc7f5f9c0d1a1873$export$8ce1fd94bee2f412 = `_6TWM_W_background`;
$cc7f5f9c0d1a1873$export$efe229eab43a9869 = `_6TWM_W_closeButton`;
$cc7f5f9c0d1a1873$export$6565f9f03506010b = `_6TWM_W_code`;
$cc7f5f9c0d1a1873$export$ee08fe7decb01058 = `_6TWM_W_codeContainer`;
$cc7f5f9c0d1a1873$export$152f516478c1ac4a = `_6TWM_W_codeIntro`;
$cc7f5f9c0d1a1873$export$8f981dffec84ba52 = `_6TWM_W_contentContainer`;
$cc7f5f9c0d1a1873$export$9624302a33c1c6cb = `_6TWM_W_ctaButton`;
$cc7f5f9c0d1a1873$export$6727d3534640939 = `_6TWM_W_firstButton`;
$cc7f5f9c0d1a1873$export$17fa98cb055e8fa7 = `_6TWM_W_fontSizeH1`;
$cc7f5f9c0d1a1873$export$a5833c2b43ca4340 = `_6TWM_W_fontSizeH2`;
$cc7f5f9c0d1a1873$export$47511f9a6581d1d6 = `_6TWM_W_fontSizeH3`;
$cc7f5f9c0d1a1873$export$dd1c05b92185401c = `_6TWM_W_fontSizeH4`;
$cc7f5f9c0d1a1873$export$8b28cf6cd00fe080 = `_6TWM_W_fontSizeH5`;
$cc7f5f9c0d1a1873$export$186c650311ff0789 = `_6TWM_W_fontSizeH6`;
$cc7f5f9c0d1a1873$export$6746fe0d9c9fab54 = `_6TWM_W_fontSizeSmall`;
$cc7f5f9c0d1a1873$export$2bcf359f0c20e94f = `_6TWM_W_fontSizeTiny`;
$cc7f5f9c0d1a1873$export$2903d10d531d0ac0 = `_6TWM_W_fontSizep`;
$cc7f5f9c0d1a1873$export$e4043f67d36cbb26 = `_6TWM_W_highlight`;
$cc7f5f9c0d1a1873$export$f4b13d60f20dd3ed = `_6TWM_W_lowlight`;
$cc7f5f9c0d1a1873$export$96e4b36520c26a2c = `_6TWM_W_modal`;
$cc7f5f9c0d1a1873$export$bd1b2113911b269d = `_6TWM_W_prizeContainer`;
$cc7f5f9c0d1a1873$export$dbcba3ba19c6687e = `_6TWM_W_prizeImage`;
$cc7f5f9c0d1a1873$export$c663339d28b2854c = `_6TWM_W_readMoreLink`;


const $277ec422976c3951$var$INITIAL_COPY_BUTTON_TEXT = "Copy code to clipboard";
const $277ec422976c3951$var$INITIAL_PROFILE_ASSET_BUTTON_TEXT = "Apply to profile";
const $277ec422976c3951$export$85ddf6e7b752aaaa = ({ classname: classname })=>{
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const prize = (0, $6lYLL.useAppSelector)((state)=>state.app.currentlyViewingPrize);
    const [isVisible, setIsVisible] = (0, $8FY87.useState)(false);
    const [isCopied, setIsCopied] = (0, $8FY87.useState)(false);
    const [copyButtonText, setCopyButtonText] = (0, $8FY87.useState)($277ec422976c3951$var$INITIAL_COPY_BUTTON_TEXT);
    const [applyProfileAssetButtonText, setApplyProfileAssetButtonText] = (0, $8FY87.useState)($277ec422976c3951$var$INITIAL_PROFILE_ASSET_BUTTON_TEXT);
    (0, $8FY87.useEffect)(()=>{
        if (prize?.id) {
            // Reset state on open
            setIsCopied(false);
            setCopyButtonText($277ec422976c3951$var$INITIAL_COPY_BUTTON_TEXT);
            setApplyProfileAssetButtonText($277ec422976c3951$var$INITIAL_PROFILE_ASSET_BUTTON_TEXT);
            setIsVisible(true);
            (0, $i7H0N.sendEvent)("view_prize", {
                prizeID: prize?.id
            });
            if (prize.type === "profile_title" && prize.profileTitle?.id && prize.profileTitle?.title) dispatch((0, $baXkz.queueAchievement)({
                actionPrefix: "You earned the title",
                action: prize.profileTitle.title,
                type: "success",
                icon: "title"
            }));
        }
    }, [
        prize?.id
    ]);
    const closeModal = ()=>{
        setIsVisible(false);
        // To allow for close animation
        setTimeout(()=>{
            dispatch((0, $baXkz.setCurrentlyViewingPrize)(null));
        }, 300);
    };
    const copyCodeToClipboard = ()=>{
        if (prize.type !== "external_voucher") return;
        if (!prize.voucherCode?.code) {
            console.error("Could not copy voucher code, not found");
            setCopyButtonText("Failed to copy");
            return;
        }
        try {
            navigator.clipboard.writeText(prize.voucherCode.code).then(()=>{
                setCopyButtonText("Copied!");
                setIsCopied(true);
                (0, $i7H0N.sendEvent)("prize_modal_copy_code", {
                    prizeID: prize?.id
                });
            });
        } catch (error) {
            setCopyButtonText("Failed to copy");
            console.error("Failed to copy:", error);
        }
    };
    const getCtaButtons = ()=>{
        switch(prize.type){
            case "external_voucher":
                return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cc7f5f9c0d1a1873$export$9624302a33c1c6cb, $cc7f5f9c0d1a1873$export$6727d3534640939, {
                                [$cc7f5f9c0d1a1873$export$f4b13d60f20dd3ed]: isCopied,
                                [$cc7f5f9c0d1a1873$export$e4043f67d36cbb26]: !isCopied
                            }),
                            onClick: ()=>{
                                copyCodeToClipboard();
                            },
                            children: copyButtonText
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$29d11c0fe2fc51d8), {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cc7f5f9c0d1a1873$export$9624302a33c1c6cb, {
                                [$cc7f5f9c0d1a1873$export$f4b13d60f20dd3ed]: !isCopied,
                                [$cc7f5f9c0d1a1873$export$e4043f67d36cbb26]: isCopied
                            }),
                            onClick: ()=>(0, $i7H0N.sendEvent)("prize_modal_visit_store", {
                                    prizeID: prize?.id
                                }),
                            href: prize.externalUrl,
                            children: prize.ctaText
                        })
                    ]
                });
            case "profile_asset":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cc7f5f9c0d1a1873$export$e4043f67d36cbb26, $cc7f5f9c0d1a1873$export$9624302a33c1c6cb),
                        onClick: ()=>{
                            setApplyProfileAssetButtonText("Applying...");
                            (0, $fL4mk.setProfileAsset)(prize.profileAsset?.type, prize.profileAsset?.id).then((wasSuccessful)=>{
                                if (wasSuccessful) {
                                    setApplyProfileAssetButtonText("Applied!");
                                    (0, $i7H0N.sendEvent)("prize_modal_apply_asset", {
                                        prizeID: prize?.id
                                    });
                                } else setApplyProfileAssetButtonText("Failed to apply");
                            });
                        },
                        children: applyProfileAssetButtonText
                    })
                });
            case "profile_title":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cc7f5f9c0d1a1873$export$e4043f67d36cbb26, $cc7f5f9c0d1a1873$export$9624302a33c1c6cb),
                        onClick: ()=>{
                            setApplyProfileAssetButtonText("Applying...");
                            (0, $fL4mk.setProfileTitle)(prize.profileTitle?.id).then((wasSuccessful)=>{
                                if (wasSuccessful) {
                                    setApplyProfileAssetButtonText("Applied!");
                                    (0, $i7H0N.sendEvent)("prize_modal_apply_title", {
                                        prizeID: prize?.id
                                    });
                                } else setApplyProfileAssetButtonText("Failed to apply");
                            });
                        },
                        children: applyProfileAssetButtonText
                    })
                });
            default:
                console.error("Could not render prize modal buttons for type ", prize);
                return "";
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cc7f5f9c0d1a1873$export$85ddf6e7b752aaaa, classname),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
            isVisible: isVisible,
            onClose: closeModal,
            canScroll: true,
            zIndex: 1000,
            leaveSpaceAboveAndBelow: false,
            shouldCloseOnExternalClick: true,
            modalClassname: $cc7f5f9c0d1a1873$export$96e4b36520c26a2c,
            contentClassname: $cc7f5f9c0d1a1873$export$8f981dffec84ba52,
            children: prize && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                        children: "Your Prize!"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: prize.subtitle
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $cc7f5f9c0d1a1873$export$bd1b2113911b269d,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                className: $cc7f5f9c0d1a1873$export$dbcba3ba19c6687e,
                                src: (0, $aTKgi.pathToURL)(prize.secondaryImagePath),
                                alt: " ",
                                title: prize.description
                            }),
                            prize.type === "external_voucher" && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $cc7f5f9c0d1a1873$export$ee08fe7decb01058,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        className: $cc7f5f9c0d1a1873$export$152f516478c1ac4a,
                                        children: "Code:"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                        className: $cc7f5f9c0d1a1873$export$6565f9f03506010b,
                                        type: "text",
                                        value: prize.voucherCode?.code,
                                        readOnly: true,
                                        onClick: copyCodeToClipboard
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: prize.redemptionInstructions
                    }),
                    getCtaButtons(),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: $cc7f5f9c0d1a1873$export$c663339d28b2854c,
                        href: prize.readMoreUrl,
                        children: "Read more"
                    })
                ]
            })
        })
    });
};
var $277ec422976c3951$export$2e2bcd8739ae039 /* 
Examples:

arise.postMessage('view-prize', {
    id: '7cf5ab80-d2ca-4c33-9dbc-6648abfcd242',
    createdAt: '2025-01-16T09:35:00Z',
    universeId: '81bd63e9-5380-4f8a-9d6a-5a3c2bd6ef96',
    subtitle: 'Profile Asset',
    ctaText: 'Apply to profile',
    readMoreUrl: 'https://website.com/prizes',
    description: 'Cool background',
    mainImagePath: 'c44b29d8-a41f-4fc9-9e6b-ade2e117c92a/reveal-content/uxJ7vbkmpc.webp',
    secondaryImagePath: '/images/prizes/secondary-image.png',
    redemptionInstructions: 'To redeem, simply head to your profile and apply the changes.',
    sfxUrl: 'https://example.com/audio/sfx.mp3',
    externalUrl: 'https://website.com/prizes',
    type: 'profile_asset',
    profileAsset: {
        id: '89241bc0-82f1-4d65-a1b3-59ca8842cb5d',
        type: 'background',
    }
});

arise.postMessage('view-prize', {
    id: '7cf5ab80-d2ca-4c33-9dbc-6648abfcd242',
    createdAt: '2025-01-16T09:35:00Z',
    universeId: '81bd63e9-5380-4f8a-9d6a-5a3c2bd6ef96',
    subtitle: 'Physical prize',
    ctaText: 'Visit store',
    readMoreUrl: 'https://website.com/prizes',
    description: '10% off anything in store',
    mainImagePath: 'c44b29d8-a41f-4fc9-9e6b-ade2e117c92a/reveal-content/uxJ7vbkmpc.webp',
    secondaryImagePath: '/images/prizes/secondary-image.png',
    redemptionInstructions: 'Please visit website store to redeem',
    sfxUrl: 'https://example.com/audio/sfx.mp3',
    externalUrl: 'https://website.com/prizes',
    type: 'external_voucher',
    voucherCode: {
        prizeId: '7cf5ab80-d2ca-4c33-9dbc-6648abfcd242',
        code: '1234567890',
        createdAt: '2025-01-16T09:35:00Z',
    },
});

...
type: 'profile_title',
profileTitle: {
    id: 'Hustler',
    title: 'Hustler',
    rarity: 'Rare'
}
...
*/  = $277ec422976c3951$export$85ddf6e7b752aaaa;



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");


var $cEIti = parcelRequire("cEIti");

var $f9aoP = parcelRequire("f9aoP");

var $bEiLm = parcelRequire("bEiLm");
/**
 * Stores per-video progress in localStorage as:
 * {
 *   "dQw4w9WgXcQ": { "progress": 42, "completed": false },
 *   "9bZkp7q19f0": { "progress": 0, "completed": true }
 * }
 *
 * `progress` is in seconds.
 */ const $0cf842c3a6817596$export$14bdfb192272be33 = "ARISE_VIDEO_PROGRESS";
function $0cf842c3a6817596$export$e20713ec10f02e66(videoId, seconds) {
    try {
        if (!videoId || seconds < 0) return;
        const map = $0cf842c3a6817596$var$getLSMap();
        // No need to save progress if completed
        if (map[videoId]?.completed === true) return;
        map[videoId] = {
            progress: seconds,
            completed: false
        };
        localStorage.setItem($0cf842c3a6817596$export$14bdfb192272be33, JSON.stringify(map));
    } catch (error) {
        console.log("Warning: Could not save local video progress", error);
    }
}
function $0cf842c3a6817596$export$f56a20f73da3ee39(videoId) {
    try {
        if (!videoId) return;
        const map = $0cf842c3a6817596$var$getLSMap();
        map[videoId] = {
            progress: 0,
            completed: true
        };
        localStorage.setItem($0cf842c3a6817596$export$14bdfb192272be33, JSON.stringify(map));
    } catch (error) {
        console.log("Warning: Could not mark video as completed", error);
    }
}
function $0cf842c3a6817596$export$34250dbee1b3714(videoId) {
    try {
        const map = $0cf842c3a6817596$var$getLSMap();
        const entry = map[videoId];
        if (typeof entry?.progress === "number" && typeof entry?.completed === "boolean") return entry;
        return {
            progress: 0,
            completed: false
        };
    } catch (error) {
        console.log("Warning: Could not get local video progress, defaulting to 0", error);
        return {
            progress: 0,
            completed: false
        };
    }
}
function $0cf842c3a6817596$var$getLSMap() {
    const raw = localStorage.getItem($0cf842c3a6817596$export$14bdfb192272be33);
    return raw ? JSON.parse(raw) : {};
}
function $0cf842c3a6817596$export$14c90d4be2a904a9() {
    localStorage.removeItem($0cf842c3a6817596$export$14bdfb192272be33);
}


var $e9430eb787f7d34e$export$bb1d7b1055124ded;
var $e9430eb787f7d34e$export$493b5823483d2c4e;
var $e9430eb787f7d34e$export$17fa98cb055e8fa7;
var $e9430eb787f7d34e$export$a5833c2b43ca4340;
var $e9430eb787f7d34e$export$47511f9a6581d1d6;
var $e9430eb787f7d34e$export$dd1c05b92185401c;
var $e9430eb787f7d34e$export$8b28cf6cd00fe080;
var $e9430eb787f7d34e$export$186c650311ff0789;
var $e9430eb787f7d34e$export$6746fe0d9c9fab54;
var $e9430eb787f7d34e$export$2bcf359f0c20e94f;
var $e9430eb787f7d34e$export$2903d10d531d0ac0;
var $e9430eb787f7d34e$export$d2297815c52203ee;
$e9430eb787f7d34e$export$bb1d7b1055124ded = `rNEqRG_AriseDebugMenu`;
$e9430eb787f7d34e$export$493b5823483d2c4e = `rNEqRG_errorMessage`;
$e9430eb787f7d34e$export$17fa98cb055e8fa7 = `rNEqRG_fontSizeH1`;
$e9430eb787f7d34e$export$a5833c2b43ca4340 = `rNEqRG_fontSizeH2`;
$e9430eb787f7d34e$export$47511f9a6581d1d6 = `rNEqRG_fontSizeH3`;
$e9430eb787f7d34e$export$dd1c05b92185401c = `rNEqRG_fontSizeH4`;
$e9430eb787f7d34e$export$8b28cf6cd00fe080 = `rNEqRG_fontSizeH5`;
$e9430eb787f7d34e$export$186c650311ff0789 = `rNEqRG_fontSizeH6`;
$e9430eb787f7d34e$export$6746fe0d9c9fab54 = `rNEqRG_fontSizeSmall`;
$e9430eb787f7d34e$export$2bcf359f0c20e94f = `rNEqRG_fontSizeTiny`;
$e9430eb787f7d34e$export$2903d10d531d0ac0 = `rNEqRG_fontSizep`;
$e9430eb787f7d34e$export$d2297815c52203ee = `rNEqRG_formGroup`;


function $9fcdfd8a99f7979e$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isDebugMenuOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isDebugMenuOpen);
    const currentUserProfileV2 = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfileV2);
    const location = (0, $6lYLL.useAppSelector)((state)=>state.app.location);
    const theme = (0, $cEIti.useTheme)();
    const [error, setError] = (0, $8FY87.useState)();
    const [iframeEventName, setIframeEventName] = (0, $8FY87.useState)("");
    const [iframeEventPayload, setIframeEventPayload] = (0, $8FY87.useState)("");
    const handleSimulateIframeEvent = ()=>{
        setError(null);
        try {
            // Parse payload if it's JSON, otherwise use as string
            let parsedPayload = iframeEventPayload;
            try {
                parsedPayload = JSON.parse(iframeEventPayload);
            } catch  {
            // Keep as string if not valid JSON
            }
            console.log("Simulating iFrame message event:", {
                type: iframeEventName,
                payload: parsedPayload
            });
            // Simulate a message event from an iframe (handled by AriseBridgeHost)
            const messageEvent = new MessageEvent("message", {
                data: {
                    type: iframeEventName,
                    payload: parsedPayload
                },
                origin: window.location.origin
            });
            window.dispatchEvent(messageEvent);
            console.log(`MessageEvent "${iframeEventName}" dispatched with payload:`, parsedPayload);
        } catch (err) {
            setError("Failed to simulate event: " + (err instanceof Error ? err.message : String(err)));
        }
    };
    const handleSimulateIframeEventAfterDelay = ()=>{
        dispatch((0, $baXkz.toggleDebugMenu)());
        setTimeout(()=>{
            handleSimulateIframeEvent();
        }, 2000);
    };
    const handleClearLocalProfile = ()=>{
        setError(null);
        try {
            (0, $bEiLm.clearProfileV2FromLocalStorage)();
        } catch (err) {
            setError("Failed to clear local profile");
        }
    };
    const handleClearRemoteProfile = async ()=>{
        setError(null);
        try {
            await Promise.all([
                $f9aoP.resetProfileBadges(),
                $f9aoP.resetProfileTitles(),
                $f9aoP.resetProfileMissionCompleted()
            ]);
        } catch (err) {
            setError("Failed to clear remote profile");
        }
    };
    const handleClearProfile = async ()=>{
        setError(null);
        try {
            await Promise.all([
                $f9aoP.resetProfileBadges(),
                $f9aoP.resetProfileTitles(),
                $f9aoP.resetProfileMissionCompleted()
            ]);
            (0, $bEiLm.clearProfileV2FromLocalStorage)();
        } catch (err) {
            setError("Failed to clear profile");
        }
    };
    const handleClearLocalVideoData = async ()=>{
        setError(null);
        try {
            (0, $0cf842c3a6817596$export$14c90d4be2a904a9)();
        } catch (err) {
            setError("Failed to clear local video data");
        }
    };
    const handleClearLocalAuthToken = ()=>{
        setError(null);
        try {
            window.localStorage.removeItem("ARISEENGINE_AUTHTOKEN");
        } catch (err) {
            setError("Failed to clear auth token");
        }
    };
    const handleClearAllLocalStorage = ()=>{
        setError(null);
        try {
            window.localStorage.clear();
        } catch (err) {
            setError("Failed to clear local storage");
        }
    };
    if (!$9fcdfd8a99f7979e$export$69bcb768638f40fb(theme.customJSON)) return null;
    const getArisewareData = ()=>{
        if (!location?.latestArisewareBuildURL) return "No Ariseware";
        try {
            const arisewareVersionDateTime = location.latestArisewareBuildURL.match(/\/(\d+)\//)[1];
            const dateVersion = new Date(parseInt(arisewareVersionDateTime)).toLocaleString();
            return `${dateVersion} (${arisewareVersionDateTime})`;
        } catch (error) {
            return location?.latestArisewareBuildURL || "No Ariseware";
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        title: "Debug Menu",
        isVisible: isDebugMenuOpen,
        onClose: ()=>dispatch((0, $baXkz.toggleDebugMenu)()),
        hasCloseButton: true,
        modalClassname: $e9430eb787f7d34e$export$bb1d7b1055124ded,
        zIndex: 2000,
        canScroll: true,
        leaveSpaceAboveAndBelow: false,
        children: [
            error && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $e9430eb787f7d34e$export$493b5823483d2c4e,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
                        children: "Error:"
                    }),
                    " ",
                    error
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: "System Info"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
                                        children: "Arise Frontend version: "
                                    }),
                                    "brickhouse-prod-v1.0.1"
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
                                        children: "Ariseware version:"
                                    }),
                                    " ",
                                    getArisewareData()
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
                                        children: "User ID:"
                                    }),
                                    " ",
                                    currentUserProfileV2?.userId
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("strong", {
                                        children: "Auth token:"
                                    }),
                                    " ",
                                    window.localStorage.getItem("ARISEENGINE_AUTHTOKEN") || ""
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: "Profile Actions"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "Please reload after clearing"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearLocalProfile,
                        children: "Clear Local Profile"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearRemoteProfile,
                        children: "Clear Remote Profile"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearProfile,
                        children: "Clear All Profile Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: "Video"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "Please reload after clearing"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearLocalVideoData,
                        children: "Clear Local Video Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: "User"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "Please reload after clearing"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearLocalAuthToken,
                        children: "Clear Local Auth Token"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleClearAllLocalStorage,
                        children: "Clear All Local Storage Data"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                        children: "Simulate event from iFrame"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $e9430eb787f7d34e$export$d2297815c52203ee,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                children: "Event name:"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("input", {
                                type: "text",
                                placeholder: "e.g. open-url",
                                value: iframeEventName,
                                onChange: (e)=>setIframeEventName(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $e9430eb787f7d34e$export$d2297815c52203ee,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                                children: "Payload detail (JSON or string):"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("textarea", {
                                placeholder: "e.g. https://www.google.com",
                                value: iframeEventPayload,
                                onChange: (e)=>setIframeEventPayload(e.target.value),
                                rows: 3
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleSimulateIframeEvent,
                        children: "Send"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: handleSimulateIframeEventAfterDelay,
                        children: "Close Debug, wait 5 seconds and then Send"
                    })
                ]
            })
        ]
    });
}
function $9fcdfd8a99f7979e$export$69bcb768638f40fb(themeCustomJSON) {
    // Use hasDebugMenu value if exists, otherwise default to showing for non prod envs
    return typeof themeCustomJSON?.hasDebugMenu === "boolean" ? themeCustomJSON.hasDebugMenu : false;
}



function $f2c7960aa4e3ca7c$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6lYLL.Provider), {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $78abed24600f4ea8$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $e6117fabf1c6ed74$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2a59f39dad729c15$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $83e66c7ca3b599bc$export$a8bda58cefcd19af), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d53970ea06cba05b$export$82270779c4a788ac), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cEIti.ThemeStylesProvider), {}),
                    children,
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $277ec422976c3951$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d528cc64cba566a3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $cc3d61eca2f2c193$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9fcdfd8a99f7979e$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");
var $5a4c8a6e01fde2ea$export$1ba59dacbcbf90fe;
var $5a4c8a6e01fde2ea$export$17fa98cb055e8fa7;
var $5a4c8a6e01fde2ea$export$a5833c2b43ca4340;
var $5a4c8a6e01fde2ea$export$47511f9a6581d1d6;
var $5a4c8a6e01fde2ea$export$dd1c05b92185401c;
var $5a4c8a6e01fde2ea$export$8b28cf6cd00fe080;
var $5a4c8a6e01fde2ea$export$186c650311ff0789;
var $5a4c8a6e01fde2ea$export$6746fe0d9c9fab54;
var $5a4c8a6e01fde2ea$export$2bcf359f0c20e94f;
var $5a4c8a6e01fde2ea$export$2903d10d531d0ac0;
$5a4c8a6e01fde2ea$export$1ba59dacbcbf90fe = `lakUJq_Sidebar`;
$5a4c8a6e01fde2ea$export$17fa98cb055e8fa7 = `lakUJq_fontSizeH1`;
$5a4c8a6e01fde2ea$export$a5833c2b43ca4340 = `lakUJq_fontSizeH2`;
$5a4c8a6e01fde2ea$export$47511f9a6581d1d6 = `lakUJq_fontSizeH3`;
$5a4c8a6e01fde2ea$export$dd1c05b92185401c = `lakUJq_fontSizeH4`;
$5a4c8a6e01fde2ea$export$8b28cf6cd00fe080 = `lakUJq_fontSizeH5`;
$5a4c8a6e01fde2ea$export$186c650311ff0789 = `lakUJq_fontSizeH6`;
$5a4c8a6e01fde2ea$export$6746fe0d9c9fab54 = `lakUJq_fontSizeSmall`;
$5a4c8a6e01fde2ea$export$2bcf359f0c20e94f = `lakUJq_fontSizeTiny`;
$5a4c8a6e01fde2ea$export$2903d10d531d0ac0 = `lakUJq_fontSizep`;


function $35917d57cc14df8a$export$2e2bcd8739ae039({ imagePath: imagePath, className: className, blur: blur = 0, zoom: zoom = 1, onImageLoaded: onImageLoaded, style: style, translate: translate = "0,0", brightness: brightness = 1, transformOrigin: transformOrigin = "center" }) {
    const app = (0, $6lYLL.useAppSelector)((state)=>state.app);
    (0, $8FY87.useEffect)(()=>{
        const img = new Image();
        img.src = imagePath;
        img.onload = ()=>{
            if (onImageLoaded) onImageLoaded();
        };
    }, [
        imagePath,
        onImageLoaded
    ]);
    const shouldBlur = app.isInventoryOpen || app.isExitLocationModalOpen || app.isLeaderboardOpen;
    const transform = `scale(${zoom}) translate(${translate})`;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a4c8a6e01fde2ea$export$1ba59dacbcbf90fe, "w-full h-full absolute top-0 left-0 bg-center bg-cover", className),
        style: {
            ...style,
            backgroundImage: `url(${imagePath})`,
            filter: `blur(${blur}px) brightness(${brightness})`,
            transform: transform,
            transformOrigin: transformOrigin
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: "w-full h-full absolute duration-300 transition-[backdrop-filter] " + (shouldBlur && "backdrop-blur-md")
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $i7H0N = parcelRequire("i7H0N");

var $2PPWI = parcelRequire("2PPWI");
var $7bd2add0256c586d$export$142c7a4094f92438;
var $7bd2add0256c586d$export$b447b8a95c4d0112;
var $7bd2add0256c586d$export$9204605f45de783;
var $7bd2add0256c586d$export$f79a321fdeba6dd5;
var $7bd2add0256c586d$export$501bdd3f61e65a06;
var $7bd2add0256c586d$export$17fa98cb055e8fa7;
var $7bd2add0256c586d$export$a5833c2b43ca4340;
var $7bd2add0256c586d$export$47511f9a6581d1d6;
var $7bd2add0256c586d$export$dd1c05b92185401c;
var $7bd2add0256c586d$export$8b28cf6cd00fe080;
var $7bd2add0256c586d$export$186c650311ff0789;
var $7bd2add0256c586d$export$6746fe0d9c9fab54;
var $7bd2add0256c586d$export$2bcf359f0c20e94f;
var $7bd2add0256c586d$export$2903d10d531d0ac0;
$7bd2add0256c586d$export$142c7a4094f92438 = `kiTIEW_AuthDrawer`;
$7bd2add0256c586d$export$b447b8a95c4d0112 = `kiTIEW_AuthDrawer--noImage`;
$7bd2add0256c586d$export$9204605f45de783 = `kiTIEW_AuthDrawer__drawer`;
$7bd2add0256c586d$export$f79a321fdeba6dd5 = `kiTIEW_AuthDrawer__drawerLeft`;
$7bd2add0256c586d$export$501bdd3f61e65a06 = `kiTIEW_AuthDrawer__drawerRight`;
$7bd2add0256c586d$export$17fa98cb055e8fa7 = `kiTIEW_fontSizeH1`;
$7bd2add0256c586d$export$a5833c2b43ca4340 = `kiTIEW_fontSizeH2`;
$7bd2add0256c586d$export$47511f9a6581d1d6 = `kiTIEW_fontSizeH3`;
$7bd2add0256c586d$export$dd1c05b92185401c = `kiTIEW_fontSizeH4`;
$7bd2add0256c586d$export$8b28cf6cd00fe080 = `kiTIEW_fontSizeH5`;
$7bd2add0256c586d$export$186c650311ff0789 = `kiTIEW_fontSizeH6`;
$7bd2add0256c586d$export$6746fe0d9c9fab54 = `kiTIEW_fontSizeSmall`;
$7bd2add0256c586d$export$2bcf359f0c20e94f = `kiTIEW_fontSizeTiny`;
$7bd2add0256c586d$export$2903d10d531d0ac0 = `kiTIEW_fontSizep`;



var $9s93Y = parcelRequire("9s93Y");
function $e37d8a2442920999$export$142c7a4094f92438({ imagePath: imagePath, children: children, ...props }) {
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
        [$7bd2add0256c586d$export$142c7a4094f92438]: true,
        [$7bd2add0256c586d$export$b447b8a95c4d0112]: !imagePath
    });
    const drawerRightStyles = imagePath ? {
        backgroundImage: `url(${imagePath})`
    } : {};
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: classes,
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $7bd2add0256c586d$export$9204605f45de783,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $7bd2add0256c586d$export$f79a321fdeba6dd5
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $7bd2add0256c586d$export$501bdd3f61e65a06,
                    style: drawerRightStyles
                }),
                children
            ]
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");

var $2PPWI = parcelRequire("2PPWI");
var $383386482703cc14$exports = {};

$parcel$export($383386482703cc14$exports, "Badge", function () { return $383386482703cc14$export$37acb3580601e69a; }, function (v) { return $383386482703cc14$export$37acb3580601e69a = v; });
$parcel$export($383386482703cc14$exports, "common", function () { return $383386482703cc14$export$919daad019702595; }, function (v) { return $383386482703cc14$export$919daad019702595 = v; });
$parcel$export($383386482703cc14$exports, "epic", function () { return $383386482703cc14$export$8ec5145af6f76965; }, function (v) { return $383386482703cc14$export$8ec5145af6f76965 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH1", function () { return $383386482703cc14$export$17fa98cb055e8fa7; }, function (v) { return $383386482703cc14$export$17fa98cb055e8fa7 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH2", function () { return $383386482703cc14$export$a5833c2b43ca4340; }, function (v) { return $383386482703cc14$export$a5833c2b43ca4340 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH3", function () { return $383386482703cc14$export$47511f9a6581d1d6; }, function (v) { return $383386482703cc14$export$47511f9a6581d1d6 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH4", function () { return $383386482703cc14$export$dd1c05b92185401c; }, function (v) { return $383386482703cc14$export$dd1c05b92185401c = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH5", function () { return $383386482703cc14$export$8b28cf6cd00fe080; }, function (v) { return $383386482703cc14$export$8b28cf6cd00fe080 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeH6", function () { return $383386482703cc14$export$186c650311ff0789; }, function (v) { return $383386482703cc14$export$186c650311ff0789 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeSmall", function () { return $383386482703cc14$export$6746fe0d9c9fab54; }, function (v) { return $383386482703cc14$export$6746fe0d9c9fab54 = v; });
$parcel$export($383386482703cc14$exports, "fontSizeTiny", function () { return $383386482703cc14$export$2bcf359f0c20e94f; }, function (v) { return $383386482703cc14$export$2bcf359f0c20e94f = v; });
$parcel$export($383386482703cc14$exports, "fontSizep", function () { return $383386482703cc14$export$2903d10d531d0ac0; }, function (v) { return $383386482703cc14$export$2903d10d531d0ac0 = v; });
$parcel$export($383386482703cc14$exports, "icon", function () { return $383386482703cc14$export$1ca1ec8b29a4ce27; }, function (v) { return $383386482703cc14$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($383386482703cc14$exports, "legendary", function () { return $383386482703cc14$export$9738149b23403ba; }, function (v) { return $383386482703cc14$export$9738149b23403ba = v; });
$parcel$export($383386482703cc14$exports, "rare", function () { return $383386482703cc14$export$b2e68d2f08b863d2; }, function (v) { return $383386482703cc14$export$b2e68d2f08b863d2 = v; });
$parcel$export($383386482703cc14$exports, "system", function () { return $383386482703cc14$export$505f1cb98cb78c0d; }, function (v) { return $383386482703cc14$export$505f1cb98cb78c0d = v; });
$parcel$export($383386482703cc14$exports, "uncommon", function () { return $383386482703cc14$export$76bf72d8613283e6; }, function (v) { return $383386482703cc14$export$76bf72d8613283e6 = v; });
var $383386482703cc14$export$37acb3580601e69a;
var $383386482703cc14$export$919daad019702595;
var $383386482703cc14$export$8ec5145af6f76965;
var $383386482703cc14$export$17fa98cb055e8fa7;
var $383386482703cc14$export$a5833c2b43ca4340;
var $383386482703cc14$export$47511f9a6581d1d6;
var $383386482703cc14$export$dd1c05b92185401c;
var $383386482703cc14$export$8b28cf6cd00fe080;
var $383386482703cc14$export$186c650311ff0789;
var $383386482703cc14$export$6746fe0d9c9fab54;
var $383386482703cc14$export$2bcf359f0c20e94f;
var $383386482703cc14$export$2903d10d531d0ac0;
var $383386482703cc14$export$1ca1ec8b29a4ce27;
var $383386482703cc14$export$9738149b23403ba;
var $383386482703cc14$export$b2e68d2f08b863d2;
var $383386482703cc14$export$505f1cb98cb78c0d;
var $383386482703cc14$export$76bf72d8613283e6;
$383386482703cc14$export$37acb3580601e69a = `KFENNG_Badge`;
$383386482703cc14$export$919daad019702595 = `KFENNG_common`;
$383386482703cc14$export$8ec5145af6f76965 = `KFENNG_epic`;
$383386482703cc14$export$17fa98cb055e8fa7 = `KFENNG_fontSizeH1`;
$383386482703cc14$export$a5833c2b43ca4340 = `KFENNG_fontSizeH2`;
$383386482703cc14$export$47511f9a6581d1d6 = `KFENNG_fontSizeH3`;
$383386482703cc14$export$dd1c05b92185401c = `KFENNG_fontSizeH4`;
$383386482703cc14$export$8b28cf6cd00fe080 = `KFENNG_fontSizeH5`;
$383386482703cc14$export$186c650311ff0789 = `KFENNG_fontSizeH6`;
$383386482703cc14$export$6746fe0d9c9fab54 = `KFENNG_fontSizeSmall`;
$383386482703cc14$export$2bcf359f0c20e94f = `KFENNG_fontSizeTiny`;
$383386482703cc14$export$2903d10d531d0ac0 = `KFENNG_fontSizep`;
$383386482703cc14$export$1ca1ec8b29a4ce27 = `KFENNG_icon`;
$383386482703cc14$export$9738149b23403ba = `KFENNG_legendary`;
$383386482703cc14$export$b2e68d2f08b863d2 = `KFENNG_rare`;
$383386482703cc14$export$505f1cb98cb78c0d = `KFENNG_system`;
$383386482703cc14$export$76bf72d8613283e6 = `KFENNG_uncommon`;



var $9s93Y = parcelRequire("9s93Y");
function $44c6ed99993eabb1$export$2e2bcd8739ae039({ text: text, rarity: rarity, isSystemBadge: isSystemBadge, iconImageUrl: iconImageUrl, title: title, classname: classname }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($383386482703cc14$exports.Badge, $383386482703cc14$exports[isSystemBadge ? "system" : rarity?.toLowerCase()], classname),
        title: title,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: text
            }),
            iconImageUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $383386482703cc14$exports.icon,
                style: {
                    maskImage: `url(${iconImageUrl})`
                }
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");
var $128b76ba5e5c6b08$export$101fbca3a406e1fd;
var $128b76ba5e5c6b08$export$17fa98cb055e8fa7;
var $128b76ba5e5c6b08$export$a5833c2b43ca4340;
var $128b76ba5e5c6b08$export$47511f9a6581d1d6;
var $128b76ba5e5c6b08$export$dd1c05b92185401c;
var $128b76ba5e5c6b08$export$8b28cf6cd00fe080;
var $128b76ba5e5c6b08$export$186c650311ff0789;
var $128b76ba5e5c6b08$export$6746fe0d9c9fab54;
var $128b76ba5e5c6b08$export$2bcf359f0c20e94f;
var $128b76ba5e5c6b08$export$2903d10d531d0ac0;
var $128b76ba5e5c6b08$export$6811ecb90b1fb169;
$128b76ba5e5c6b08$export$101fbca3a406e1fd = `M5cyaa_DisplayName`;
$128b76ba5e5c6b08$export$17fa98cb055e8fa7 = `M5cyaa_fontSizeH1`;
$128b76ba5e5c6b08$export$a5833c2b43ca4340 = `M5cyaa_fontSizeH2`;
$128b76ba5e5c6b08$export$47511f9a6581d1d6 = `M5cyaa_fontSizeH3`;
$128b76ba5e5c6b08$export$dd1c05b92185401c = `M5cyaa_fontSizeH4`;
$128b76ba5e5c6b08$export$8b28cf6cd00fe080 = `M5cyaa_fontSizeH5`;
$128b76ba5e5c6b08$export$186c650311ff0789 = `M5cyaa_fontSizeH6`;
$128b76ba5e5c6b08$export$6746fe0d9c9fab54 = `M5cyaa_fontSizeSmall`;
$128b76ba5e5c6b08$export$2bcf359f0c20e94f = `M5cyaa_fontSizeTiny`;
$128b76ba5e5c6b08$export$2903d10d531d0ac0 = `M5cyaa_fontSizep`;
$128b76ba5e5c6b08$export$6811ecb90b1fb169 = `M5cyaa_hasHover`;


function $d758aa58b83e8f34$export$2e2bcd8739ae039({ profile: profile, shouldLinkToProfile: shouldLinkToProfile, classname: classname }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    if (shouldLinkToProfile) return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($128b76ba5e5c6b08$export$101fbca3a406e1fd, $128b76ba5e5c6b08$export$6811ecb90b1fb169, classname),
        onClick: ()=>{
            dispatch((0, $baXkz.openProfile)(profile));
            dispatch((0, $baXkz.setShowingSettingsMenu)(false));
            dispatch((0, $baXkz.setIsSidebarOpen)(true));
        },
        title: `View ${profile?.displayName}'s Profile`,
        children: profile?.displayName
    });
    else return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))(classname),
        children: profile?.displayName
    });
}


var $29f8e8b256fedbdc$export$98fbcf6b2e43950e;
var $29f8e8b256fedbdc$export$2f43fba13d2ecbe2;
var $29f8e8b256fedbdc$export$c1de35a83862cf9;
var $29f8e8b256fedbdc$export$17fa98cb055e8fa7;
var $29f8e8b256fedbdc$export$a5833c2b43ca4340;
var $29f8e8b256fedbdc$export$47511f9a6581d1d6;
var $29f8e8b256fedbdc$export$dd1c05b92185401c;
var $29f8e8b256fedbdc$export$8b28cf6cd00fe080;
var $29f8e8b256fedbdc$export$186c650311ff0789;
var $29f8e8b256fedbdc$export$6746fe0d9c9fab54;
var $29f8e8b256fedbdc$export$2bcf359f0c20e94f;
var $29f8e8b256fedbdc$export$2903d10d531d0ac0;
var $29f8e8b256fedbdc$export$52855edd83ec64c2;
var $29f8e8b256fedbdc$export$290b09573c75bfe5;
$29f8e8b256fedbdc$export$98fbcf6b2e43950e = `b9eSOq_DisplayNameWithBadges`;
$29f8e8b256fedbdc$export$2f43fba13d2ecbe2 = `b9eSOq_badgeContainer`;
$29f8e8b256fedbdc$export$c1de35a83862cf9 = `b9eSOq_displayName`;
$29f8e8b256fedbdc$export$17fa98cb055e8fa7 = `b9eSOq_fontSizeH1`;
$29f8e8b256fedbdc$export$a5833c2b43ca4340 = `b9eSOq_fontSizeH2`;
$29f8e8b256fedbdc$export$47511f9a6581d1d6 = `b9eSOq_fontSizeH3`;
$29f8e8b256fedbdc$export$dd1c05b92185401c = `b9eSOq_fontSizeH4`;
$29f8e8b256fedbdc$export$8b28cf6cd00fe080 = `b9eSOq_fontSizeH5`;
$29f8e8b256fedbdc$export$186c650311ff0789 = `b9eSOq_fontSizeH6`;
$29f8e8b256fedbdc$export$6746fe0d9c9fab54 = `b9eSOq_fontSizeSmall`;
$29f8e8b256fedbdc$export$2bcf359f0c20e94f = `b9eSOq_fontSizeTiny`;
$29f8e8b256fedbdc$export$2903d10d531d0ac0 = `b9eSOq_fontSizep`;
$29f8e8b256fedbdc$export$52855edd83ec64c2 = `b9eSOq_systemBadge`;
$29f8e8b256fedbdc$export$290b09573c75bfe5 = `b9eSOq_titleBadge`;


function $13dab9088986de0c$export$2e2bcd8739ae039({ profile: profile, shouldLinkToProfile: shouldLinkToProfile, displayNameClassname: displayNameClassname, hasFaction: hasFaction = true }) {
    const theme = (0, $cEIti.useTheme)();
    if (!profile) return null;
    const factionGloballyEnabled = theme.customJSON?.profileFeaturesEnabled?.faction !== false;
    const renderBadge = ()=>{
        let iconImage = profile?.faction.iconImageUrl;
        if (!iconImage) iconImage = (0, $aTKgi.pathToURL)(profile?.faction.iconPath);
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $29f8e8b256fedbdc$export$2f43fba13d2ecbe2,
            children: [
                profile?.role === "superadmin" && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44c6ed99993eabb1$export$2e2bcd8739ae039), {
                    text: "Moderator",
                    isSystemBadge: true,
                    classname: $29f8e8b256fedbdc$export$52855edd83ec64c2
                }),
                profile?.title?.title && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44c6ed99993eabb1$export$2e2bcd8739ae039), {
                    text: profile.title.title,
                    rarity: profile.title.rarity,
                    classname: $29f8e8b256fedbdc$export$290b09573c75bfe5,
                    title: profile.title.rarity?.toString()
                }),
                factionGloballyEnabled && hasFaction && profile?.role !== "superadmin" && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44c6ed99993eabb1$export$2e2bcd8739ae039), {
                    text: profile?.faction.name,
                    rarity: profile?.title?.rarity,
                    iconImageUrl: iconImage
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $29f8e8b256fedbdc$export$98fbcf6b2e43950e,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d758aa58b83e8f34$export$2e2bcd8739ae039), {
                profile: profile,
                shouldLinkToProfile: shouldLinkToProfile,
                classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($29f8e8b256fedbdc$export$c1de35a83862cf9, displayNameClassname)
            }),
            renderBadge()
        ]
    });
}





var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
function $6bfd1bdcc14e2920$var$r() {
    return $6bfd1bdcc14e2920$var$r = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $6bfd1bdcc14e2920$var$r.apply(this, arguments);
}
var $6bfd1bdcc14e2920$var$n, $6bfd1bdcc14e2920$var$t = [
    "children",
    "options"
], $6bfd1bdcc14e2920$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
};
!function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($6bfd1bdcc14e2920$var$n || ($6bfd1bdcc14e2920$var$n = {}));
var $6bfd1bdcc14e2920$var$a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, r) {
    return e[r.toLowerCase()] = r, e;
}, {
    for: "htmlFor"
}), $6bfd1bdcc14e2920$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $6bfd1bdcc14e2920$var$l = [
    "style",
    "script"
], $6bfd1bdcc14e2920$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $6bfd1bdcc14e2920$var$u = /mailto:/i, $6bfd1bdcc14e2920$var$s = /\n{2,}$/, $6bfd1bdcc14e2920$var$d = /^(\s*>[\s\S]*?)(?=\n{2,})/, $6bfd1bdcc14e2920$var$f = /^ *> ?/gm, $6bfd1bdcc14e2920$var$p = /^ {2,}\n/, $6bfd1bdcc14e2920$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $6bfd1bdcc14e2920$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $6bfd1bdcc14e2920$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $6bfd1bdcc14e2920$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $6bfd1bdcc14e2920$var$k = /^(?:\n *)*\n/, $6bfd1bdcc14e2920$var$v = /\r\n?/g, $6bfd1bdcc14e2920$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $6bfd1bdcc14e2920$var$b = /^\[\^([^\]]+)]/, $6bfd1bdcc14e2920$var$S = /\f/g, $6bfd1bdcc14e2920$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $6bfd1bdcc14e2920$var$w = /^\s*?\[(x|\s)\]/, $6bfd1bdcc14e2920$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $6bfd1bdcc14e2920$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $6bfd1bdcc14e2920$var$L = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $6bfd1bdcc14e2920$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $6bfd1bdcc14e2920$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $6bfd1bdcc14e2920$var$O = /^<!--[\s\S]*?(?:-->)/, $6bfd1bdcc14e2920$var$$ = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $6bfd1bdcc14e2920$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $6bfd1bdcc14e2920$var$M = /^\{.*\}$/, $6bfd1bdcc14e2920$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $6bfd1bdcc14e2920$var$I = /^<([^ >]+@[^ >]+)>/, $6bfd1bdcc14e2920$var$U = /^<([^ >]+:\/[^ >]+)>/, $6bfd1bdcc14e2920$var$D = /-([a-z])?/gi, $6bfd1bdcc14e2920$var$j = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $6bfd1bdcc14e2920$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $6bfd1bdcc14e2920$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $6bfd1bdcc14e2920$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $6bfd1bdcc14e2920$var$P = /(\[|\])/g, $6bfd1bdcc14e2920$var$_ = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $6bfd1bdcc14e2920$var$W = /\t/g, $6bfd1bdcc14e2920$var$G = /(^ *\||\| *$)/g, $6bfd1bdcc14e2920$var$Z = /^ *:-+: *$/, $6bfd1bdcc14e2920$var$q = /^ *:-+ *$/, $6bfd1bdcc14e2920$var$Q = /^ *-+: *$/, $6bfd1bdcc14e2920$var$V = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $6bfd1bdcc14e2920$var$X = new RegExp("^([*_])\\1" + $6bfd1bdcc14e2920$var$V + "\\1\\1(?!\\1)"), $6bfd1bdcc14e2920$var$J = new RegExp("^([*_])" + $6bfd1bdcc14e2920$var$V + "\\1(?!\\1|\\w)"), $6bfd1bdcc14e2920$var$K = new RegExp("^==" + $6bfd1bdcc14e2920$var$V + "=="), $6bfd1bdcc14e2920$var$Y = new RegExp("^~~" + $6bfd1bdcc14e2920$var$V + "~~"), $6bfd1bdcc14e2920$var$ee = /^\\([^0-9A-Za-z\s])/, $6bfd1bdcc14e2920$var$re = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $6bfd1bdcc14e2920$var$ne = /^\n+/, $6bfd1bdcc14e2920$var$te = /^([ \t]*)/, $6bfd1bdcc14e2920$var$ie = /\\([^\\])/g, $6bfd1bdcc14e2920$var$ae = / *\n+$/, $6bfd1bdcc14e2920$var$oe = /(?:^|\n)( *)$/, $6bfd1bdcc14e2920$var$le = "(?:\\d+\\.)", $6bfd1bdcc14e2920$var$ce = "(?:[*+-])";
function $6bfd1bdcc14e2920$var$ue(e) {
    return "( *)(" + (1 === e ? $6bfd1bdcc14e2920$var$le : $6bfd1bdcc14e2920$var$ce) + ") +";
}
var $6bfd1bdcc14e2920$var$se = $6bfd1bdcc14e2920$var$ue(1), $6bfd1bdcc14e2920$var$de = $6bfd1bdcc14e2920$var$ue(2);
function $6bfd1bdcc14e2920$var$fe(e) {
    return new RegExp("^" + (1 === e ? $6bfd1bdcc14e2920$var$se : $6bfd1bdcc14e2920$var$de));
}
var $6bfd1bdcc14e2920$var$pe = $6bfd1bdcc14e2920$var$fe(1), $6bfd1bdcc14e2920$var$he = $6bfd1bdcc14e2920$var$fe(2);
function $6bfd1bdcc14e2920$var$me(e) {
    return new RegExp("^" + (1 === e ? $6bfd1bdcc14e2920$var$se : $6bfd1bdcc14e2920$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $6bfd1bdcc14e2920$var$le : $6bfd1bdcc14e2920$var$ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
var $6bfd1bdcc14e2920$var$ge = $6bfd1bdcc14e2920$var$me(1), $6bfd1bdcc14e2920$var$ye = $6bfd1bdcc14e2920$var$me(2);
function $6bfd1bdcc14e2920$var$ke(e) {
    var r = 1 === e ? $6bfd1bdcc14e2920$var$le : $6bfd1bdcc14e2920$var$ce;
    return new RegExp("^( *)(" + r + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + r + " (?!" + r + " ))\\n*|\\s*\\n*$)");
}
var $6bfd1bdcc14e2920$var$ve = $6bfd1bdcc14e2920$var$ke(1), $6bfd1bdcc14e2920$var$xe = $6bfd1bdcc14e2920$var$ke(2);
function $6bfd1bdcc14e2920$var$be(e, r) {
    var n = 1 === r, t = n ? $6bfd1bdcc14e2920$var$ve : $6bfd1bdcc14e2920$var$xe, a = n ? $6bfd1bdcc14e2920$var$ge : $6bfd1bdcc14e2920$var$ye, o = n ? $6bfd1bdcc14e2920$var$pe : $6bfd1bdcc14e2920$var$he;
    return {
        match: function(e, r, n) {
            var i = $6bfd1bdcc14e2920$var$oe.exec(n);
            return i && (r.list || !r.inline && !r.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, r, t) {
            var i = n ? +e[2] : void 0, l = e[0].replace($6bfd1bdcc14e2920$var$s, "\n").match(a), c = !1;
            return {
                items: l.map(function(e, n) {
                    var i = o.exec(e)[0].length, a = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(a, "").replace(o, ""), s = n === l.length - 1, d = -1 !== u.indexOf("\n\n") || s && c;
                    c = d;
                    var f, p = t.inline, h = t.list;
                    t.list = !0, d ? (t.inline = !1, f = u.replace($6bfd1bdcc14e2920$var$ae, "\n\n")) : (t.inline = !0, f = u.replace($6bfd1bdcc14e2920$var$ae, ""));
                    var m = r(f, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: n,
                start: i
            };
        },
        render: function(r, n, t) {
            return e(r.ordered ? "ol" : "ul", {
                key: t.key,
                start: r.type === $6bfd1bdcc14e2920$export$e0aa44767d8750d5.orderedList ? r.start : void 0
            }, r.items.map(function(r, i) {
                return e("li", {
                    key: i
                }, n(r, t));
            }));
        }
    };
}
var $6bfd1bdcc14e2920$var$Se = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $6bfd1bdcc14e2920$var$Ee = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $6bfd1bdcc14e2920$var$we = [
    $6bfd1bdcc14e2920$var$d,
    $6bfd1bdcc14e2920$var$m,
    $6bfd1bdcc14e2920$var$g,
    $6bfd1bdcc14e2920$var$C,
    $6bfd1bdcc14e2920$var$L,
    $6bfd1bdcc14e2920$var$z,
    $6bfd1bdcc14e2920$var$O,
    $6bfd1bdcc14e2920$var$j,
    $6bfd1bdcc14e2920$var$ge,
    $6bfd1bdcc14e2920$var$ve,
    $6bfd1bdcc14e2920$var$ye,
    $6bfd1bdcc14e2920$var$xe
], $6bfd1bdcc14e2920$var$Ce = [].concat($6bfd1bdcc14e2920$var$we, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $6bfd1bdcc14e2920$var$A,
    $6bfd1bdcc14e2920$var$B
]);
function $6bfd1bdcc14e2920$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $6bfd1bdcc14e2920$var$Le(e) {
    return $6bfd1bdcc14e2920$var$Q.test(e) ? "right" : $6bfd1bdcc14e2920$var$Z.test(e) ? "center" : $6bfd1bdcc14e2920$var$q.test(e) ? "left" : null;
}
function $6bfd1bdcc14e2920$var$Ae(e, r, n, t) {
    var a = n.inTable;
    n.inTable = !0;
    var o = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce(function(e, a) {
        return "|" === a.trim() ? e.push(t ? {
            type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.tableSeparator
        } : {
            type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text,
            text: a
        }) : "" !== a && e.push.apply(e, r(a, n)), e;
    }, []);
    n.inTable = a;
    var l = [
        []
    ];
    return o.forEach(function(e, r) {
        e.type === $6bfd1bdcc14e2920$export$e0aa44767d8750d5.tableSeparator ? 0 !== r && r !== o.length - 1 && l.push([]) : (e.type !== $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text || null != o[r + 1] && o[r + 1].type !== $6bfd1bdcc14e2920$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), l[l.length - 1].push(e));
    }), l;
}
function $6bfd1bdcc14e2920$var$Te(e, r, n) {
    n.inline = !0;
    var t = e[2] ? e[2].replace($6bfd1bdcc14e2920$var$G, "").split("|").map($6bfd1bdcc14e2920$var$Le) : [], a = e[3] ? function(e, r, n) {
        return e.trim().split("\n").map(function(e) {
            return $6bfd1bdcc14e2920$var$Ae(e, r, n, !0);
        });
    }(e[3], r, n) : [], o = $6bfd1bdcc14e2920$var$Ae(e[1], r, n, !!a.length);
    return n.inline = !1, a.length ? {
        align: t,
        cells: a,
        header: o,
        type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.table
    } : {
        children: o,
        type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.paragraph
    };
}
function $6bfd1bdcc14e2920$var$Oe(e, r) {
    return null == e.align[r] ? {} : {
        textAlign: e.align[r]
    };
}
function $6bfd1bdcc14e2920$var$$e(e) {
    return function(r, n) {
        return n.inline ? e.exec(r) : null;
    };
}
function $6bfd1bdcc14e2920$var$Be(e) {
    return function(r, n) {
        return n.inline || n.simple ? e.exec(r) : null;
    };
}
function $6bfd1bdcc14e2920$var$Me(e) {
    return function(r, n) {
        return n.inline || n.simple ? null : e.exec(r);
    };
}
function $6bfd1bdcc14e2920$var$Re(e) {
    return function(r) {
        return e.exec(r);
    };
}
function $6bfd1bdcc14e2920$var$Ie(e, r, n) {
    if (r.inline || r.simple) return null;
    if (n && !n.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !$6bfd1bdcc14e2920$var$we.some(function(r) {
            return r.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function $6bfd1bdcc14e2920$export$3e2338ea76b578c9(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $6bfd1bdcc14e2920$var$De(e) {
    return e.replace($6bfd1bdcc14e2920$var$ie, "$1");
}
function $6bfd1bdcc14e2920$var$je(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !0, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $6bfd1bdcc14e2920$var$Ne(e, r, n) {
    var t = n.inline || !1, i = n.simple || !1;
    n.inline = !1, n.simple = !0;
    var a = e(r, n);
    return n.inline = t, n.simple = i, a;
}
function $6bfd1bdcc14e2920$var$He(e, r, n) {
    var t = n.inline || !1;
    n.inline = !1;
    var i = e(r, n);
    return n.inline = t, i;
}
var $6bfd1bdcc14e2920$var$Fe = function(e, r, n) {
    return {
        children: $6bfd1bdcc14e2920$var$je(r, e[1], n)
    };
};
function $6bfd1bdcc14e2920$var$Pe() {
    return {};
}
function $6bfd1bdcc14e2920$var$_e() {
    return null;
}
function $6bfd1bdcc14e2920$var$We() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function $6bfd1bdcc14e2920$var$Ge(e, r, n) {
    for(var t = e, i = r.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || n;
}
function $6bfd1bdcc14e2920$var$Ze(e, r) {
    var n = $6bfd1bdcc14e2920$var$Ge(r, e);
    return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $6bfd1bdcc14e2920$var$Ge(r, e + ".component", e) : e;
}
function $6bfd1bdcc14e2920$export$69f434acfbdb0b32(n, t) {
    var s;
    function G(e, n) {
        var i, a = $6bfd1bdcc14e2920$var$Ge(t.overrides, e + ".props", {});
        return (i = t).createElement.apply(i, [
            $6bfd1bdcc14e2920$var$Ze(e, t.overrides),
            $6bfd1bdcc14e2920$var$r({}, n, a, {
                className: $6bfd1bdcc14e2920$var$We(null == n ? void 0 : n.className, a.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function Z(r) {
        r = r.replace($6bfd1bdcc14e2920$var$E, "");
        var n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $6bfd1bdcc14e2920$var$_.test(r));
        for(var i = le(oe(n ? r : r.trimEnd().replace($6bfd1bdcc14e2920$var$ne, "") + "\n\n", {
            inline: n
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, o = t.wrapper || (n ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? G("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return $8FY87.createElement(o, {
            key: "outer"
        }, a);
    }
    function q(r, n) {
        var i = n.match($6bfd1bdcc14e2920$var$c);
        return i ? i.reduce(function(n, i, o) {
            var l = i.indexOf("=");
            if (-1 !== l) {
                var c = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($6bfd1bdcc14e2920$var$$) && (e = e.replace($6bfd1bdcc14e2920$var$D, function(e, r) {
                        return r.toUpperCase();
                    })), e;
                })(i.slice(0, l)).trim(), u = function(e) {
                    var r = e[0];
                    return ('"' === r || "'" === r) && e.length >= 2 && e[e.length - 1] === r ? e.slice(1, -1) : e;
                }(i.slice(l + 1).trim()), s = $6bfd1bdcc14e2920$var$a[c] || c, d = n[s] = function(e, r, n, t) {
                    return "style" === r ? n.split(/;\s?/).reduce(function(e, r) {
                        var n = r.slice(0, r.indexOf(":"));
                        return e[n.trim().replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = r.slice(n.length + 1).trim(), e;
                    }, {}) : "href" === r || "src" === r ? t(n, e, r) : (n.match($6bfd1bdcc14e2920$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(r, c, u, t.sanitizer);
                "string" == typeof d && ($6bfd1bdcc14e2920$var$A.test(d) || $6bfd1bdcc14e2920$var$B.test(d)) && (n[s] = $8FY87.cloneElement(Z(d.trim()), {
                    key: o
                }));
            } else "style" !== i && (n[$6bfd1bdcc14e2920$var$a[i] || i] = !0);
            return n;
        }, {}) : null;
    }
    void 0 === n && (n = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.sanitizer = t.sanitizer || $6bfd1bdcc14e2920$export$3e2338ea76b578c9, t.slugify = t.slugify || $6bfd1bdcc14e2920$export$c383cdd2a518017a, t.namedCodesToUnicode = t.namedCodesToUnicode ? $6bfd1bdcc14e2920$var$r({}, $6bfd1bdcc14e2920$var$o, t.namedCodesToUnicode) : $6bfd1bdcc14e2920$var$o, t.createElement = t.createElement || $8FY87.createElement;
    var Q = [], V = {}, ie = ((s = {})[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.blockQuote] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$d),
        order: 1,
        parse: function(e, r, n) {
            return {
                children: r(e[0].replace($6bfd1bdcc14e2920$var$f, ""), n)
            };
        },
        render: function(e, r, n) {
            return G("blockquote", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.breakLine] = {
        match: $6bfd1bdcc14e2920$var$Re($6bfd1bdcc14e2920$var$p),
        order: 1,
        parse: $6bfd1bdcc14e2920$var$Pe,
        render: function(e, r, n) {
            return G("br", {
                key: n.key
            });
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.breakThematic] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$h),
        order: 1,
        parse: $6bfd1bdcc14e2920$var$Pe,
        render: function(e, r, n) {
            return G("hr", {
                key: n.key
            });
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.codeBlock] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, n, t) {
            return G("pre", {
                key: t.key
            }, G("code", $6bfd1bdcc14e2920$var$r({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.codeFenced] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$m),
        order: 0,
        parse: function(e) {
            return {
                attrs: q("code", e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.codeBlock
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.codeInline] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, r, n) {
            return G("code", {
                key: n.key
            }, e.text);
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.footnote] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$x),
        order: 0,
        parse: function(e) {
            return Q.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: $6bfd1bdcc14e2920$var$_e
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.footnoteReference] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1], $6bfd1bdcc14e2920$export$c383cdd2a518017a),
                text: e[1]
            };
        },
        render: function(e, r, n) {
            return G("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href")
            }, G("sup", {
                key: n.key
            }, e.text));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.gfmTask] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$w),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, r, n) {
            return G("input", {
                checked: e.completed,
                key: n.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.heading] = {
        match: $6bfd1bdcc14e2920$var$Me(t.enforceAtxHeadings ? $6bfd1bdcc14e2920$var$z : $6bfd1bdcc14e2920$var$C),
        order: 1,
        parse: function(e, r, n) {
            return {
                children: $6bfd1bdcc14e2920$var$je(r, e[2], n),
                id: t.slugify(e[2], $6bfd1bdcc14e2920$export$c383cdd2a518017a),
                level: e[1].length
            };
        },
        render: function(e, r, n) {
            return G("h" + e.level, {
                id: e.id,
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.headingSetext] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$L),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: $6bfd1bdcc14e2920$var$je(r, e[1], n),
                level: "=" === e[2] ? 1 : 2,
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.heading
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.htmlBlock] = {
        match: $6bfd1bdcc14e2920$var$Re($6bfd1bdcc14e2920$var$A),
        order: 1,
        parse: function(e, r, n) {
            var t, i = e[3].match($6bfd1bdcc14e2920$var$te), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), c = (t = o, $6bfd1bdcc14e2920$var$Ce.some(function(e) {
                return e.test(t);
            }) ? $6bfd1bdcc14e2920$var$He : $6bfd1bdcc14e2920$var$je), u = e[1].toLowerCase(), s = -1 !== $6bfd1bdcc14e2920$var$l.indexOf(u), d = (s ? u : e[1]).trim(), f = {
                attrs: q(d, e[2]),
                noInnerParse: s,
                tag: d
            };
            return n.inAnchor = n.inAnchor || "a" === u, s ? f.text = e[3] : f.children = c(r, o, n), n.inAnchor = !1, f;
        },
        render: function(e, n, t) {
            return G(e.tag, $6bfd1bdcc14e2920$var$r({
                key: t.key
            }, e.attrs), e.text || n(e.children, t));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.htmlSelfClosing] = {
        match: $6bfd1bdcc14e2920$var$Re($6bfd1bdcc14e2920$var$B),
        order: 1,
        parse: function(e) {
            var r = e[1].trim();
            return {
                attrs: q(r, e[2] || ""),
                tag: r
            };
        },
        render: function(e, n, t) {
            return G(e.tag, $6bfd1bdcc14e2920$var$r({}, e.attrs, {
                key: t.key
            }));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.htmlComment] = {
        match: $6bfd1bdcc14e2920$var$Re($6bfd1bdcc14e2920$var$O),
        order: 1,
        parse: function() {
            return {};
        },
        render: $6bfd1bdcc14e2920$var$_e
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.image] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$Ee),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: $6bfd1bdcc14e2920$var$De(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return G("img", {
                key: n.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: t.sanitizer(e.target, "img", "src")
            });
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.link] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$Se),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: $6bfd1bdcc14e2920$var$Ne(r, e[1], n),
                target: $6bfd1bdcc14e2920$var$De(e[2]),
                title: e[3]
            };
        },
        render: function(e, r, n) {
            return G("a", {
                key: n.key,
                href: t.sanitizer(e.target, "a", "href"),
                title: e.title
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.linkAngleBraceStyleDetector] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$U),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.link
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.linkBareUrlDetector] = {
        match: function(e, r) {
            return r.inAnchor ? null : $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$R)(e, r);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text
                    }
                ],
                target: e[1],
                title: void 0,
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.link
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.linkMailtoDetector] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$I),
        order: 0,
        parse: function(e) {
            var r = e[1], n = e[1];
            return $6bfd1bdcc14e2920$var$u.test(n) || (n = "mailto:" + n), {
                children: [
                    {
                        text: r.replace("mailto:", ""),
                        type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text
                    }
                ],
                target: n,
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.link
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.orderedList] = $6bfd1bdcc14e2920$var$be(G, 1), s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.unorderedList] = $6bfd1bdcc14e2920$var$be(G, 2), s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.newlineCoalescer] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$k),
        order: 3,
        parse: $6bfd1bdcc14e2920$var$Pe,
        render: function() {
            return "\n";
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.paragraph] = {
        match: $6bfd1bdcc14e2920$var$Ie,
        order: 3,
        parse: $6bfd1bdcc14e2920$var$Fe,
        render: function(e, r, n) {
            return G("p", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.ref] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$N),
        order: 0,
        parse: function(e) {
            return V[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: $6bfd1bdcc14e2920$var$_e
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.refImage] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$H),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return V[e.ref] ? G("img", {
                key: n.key,
                alt: e.alt,
                src: t.sanitizer(V[e.ref].target, "img", "src"),
                title: V[e.ref].title
            }) : null;
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.refLink] = {
        match: $6bfd1bdcc14e2920$var$$e($6bfd1bdcc14e2920$var$F),
        order: 0,
        parse: function(e, r, n) {
            return {
                children: r(e[1], n),
                fallbackChildren: r(e[0].replace($6bfd1bdcc14e2920$var$P, "\\$1"), n),
                ref: e[2]
            };
        },
        render: function(e, r, n) {
            return V[e.ref] ? G("a", {
                key: n.key,
                href: t.sanitizer(V[e.ref].target, "a", "href"),
                title: V[e.ref].title
            }, r(e.children, n)) : G("span", {
                key: n.key
            }, r(e.fallbackChildren, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.table] = {
        match: $6bfd1bdcc14e2920$var$Me($6bfd1bdcc14e2920$var$j),
        order: 1,
        parse: $6bfd1bdcc14e2920$var$Te,
        render: function(e, r, n) {
            var t = e;
            return G("table", {
                key: n.key
            }, G("thead", null, G("tr", null, t.header.map(function(e, i) {
                return G("th", {
                    key: i,
                    style: $6bfd1bdcc14e2920$var$Oe(t, i)
                }, r(e, n));
            }))), G("tbody", null, t.cells.map(function(e, i) {
                return G("tr", {
                    key: i
                }, e.map(function(e, i) {
                    return G("td", {
                        key: i,
                        style: $6bfd1bdcc14e2920$var$Oe(t, i)
                    }, r(e, n));
                }));
            })));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.text] = {
        match: $6bfd1bdcc14e2920$var$Re($6bfd1bdcc14e2920$var$re),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace($6bfd1bdcc14e2920$var$T, function(e, r) {
                    return t.namedCodesToUnicode[r] ? t.namedCodesToUnicode[r] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.textBolded] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$X),
        order: 2,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return G("strong", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.textEmphasized] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$J),
        order: 3,
        parse: function(e, r, n) {
            return {
                children: r(e[2], n)
            };
        },
        render: function(e, r, n) {
            return G("em", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.textEscaped] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$ee),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: $6bfd1bdcc14e2920$export$e0aa44767d8750d5.text
            };
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.textMarked] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$K),
        order: 3,
        parse: $6bfd1bdcc14e2920$var$Fe,
        render: function(e, r, n) {
            return G("mark", {
                key: n.key
            }, r(e.children, n));
        }
    }, s[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.textStrikethroughed] = {
        match: $6bfd1bdcc14e2920$var$Be($6bfd1bdcc14e2920$var$Y),
        order: 3,
        parse: $6bfd1bdcc14e2920$var$Fe,
        render: function(e, r, n) {
            return G("del", {
                key: n.key
            }, r(e.children, n));
        }
    }, s);
    !0 === t.disableParsingRawHTML && (delete ie[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.htmlBlock], delete ie[$6bfd1bdcc14e2920$export$e0aa44767d8750d5.htmlSelfClosing]);
    var ae, oe = function(e) {
        var r = Object.keys(e);
        function n(t, i) {
            for(var a = [], o = ""; t;)for(var l = 0; l < r.length;){
                var c = r[l], u = e[c], s = u.match(t, i, o);
                if (s) {
                    var d = s[0];
                    t = t.substring(d.length);
                    var f = u.parse(s, n, i);
                    null == f.type && (f.type = c), a.push(f), o = d;
                    break;
                }
                l++;
            }
            return a;
        }
        return r.sort(function(r, n) {
            var t = e[r].order, i = e[n].order;
            return t !== i ? t - i : r < n ? -1 : 1;
        }), function(e, r) {
            return n(function(e) {
                return e.replace($6bfd1bdcc14e2920$var$v, "\n").replace($6bfd1bdcc14e2920$var$S, "").replace($6bfd1bdcc14e2920$var$W, "    ");
            }(e), r);
        };
    }(ie), le = (ae = function(e, r) {
        return function(n, t, i) {
            var a = e[n.type].render;
            return r ? r(function() {
                return a(n, t, i);
            }, n, t, i) : a(n, t, i);
        };
    }(ie, t.renderRule), function e(r, n) {
        if (void 0 === n && (n = {}), Array.isArray(r)) {
            for(var t = n.key, i = [], a = !1, o = 0; o < r.length; o++){
                n.key = o;
                var l = e(r[o], n), c = "string" == typeof l;
                c && a ? i[i.length - 1] += l : null !== l && i.push(l), a = c;
            }
            return n.key = t, i;
        }
        return ae(r, e, n);
    }), ce = Z(n);
    return Q.length ? G("div", null, ce, G("footer", {
        key: "footer"
    }, Q.map(function(e) {
        return G("div", {
            id: t.slugify(e.identifier, $6bfd1bdcc14e2920$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, le(oe(e.footnote, {
            inline: !0
        })));
    }))) : ce;
}
function $6bfd1bdcc14e2920$export$2e2bcd8739ae039(r) {
    var n = r.children, i = void 0 === n ? "" : n, a = r.options, o = function(e, r) {
        if (null == e) return {};
        var n, t, i = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)r.indexOf(n = a[t]) >= 0 || (i[n] = e[n]);
        return i;
    }(r, $6bfd1bdcc14e2920$var$t);
    return $8FY87.cloneElement($6bfd1bdcc14e2920$export$69f434acfbdb0b32(i, a), o);
}



var $9s93Y = parcelRequire("9s93Y");
/**
 * Returns number converted to an oridinal string, or fallback if not a number
 * @param number example: 2
 * @param fallback example: 'N/A'
 * @returns {string} example '2nd'
 */ function $aed6ee8c7b23660f$export$9173b52dfbd534b4(number, fallback = "-") {
    if (typeof number !== "number" || isNaN(number)) return `${fallback}`;
    let ordinalSuffix;
    if (number % 10 === 1 && number % 100 !== 11) ordinalSuffix = "st";
    else if (number % 10 === 2 && number % 100 !== 12) ordinalSuffix = "nd";
    else if (number % 10 === 3 && number % 100 !== 13) ordinalSuffix = "rd";
    else ordinalSuffix = "th";
    return `${number}${ordinalSuffix}`;
}
function $aed6ee8c7b23660f$export$a6283a56ed31c98a(number, fallback = 0) {
    if (typeof number !== "number" || isNaN(number)) return `${fallback}`;
    return number.toLocaleString("en", {
        useGrouping: true
    });
}
function $aed6ee8c7b23660f$export$64c1a95e2185bc9a(base64) {
    try {
        return atob(base64);
    } catch (error) {
        console.warn("Error safeDecodeBase64");
        return ""; // Return "" for invalid Base64 strings.
    }
}
function $aed6ee8c7b23660f$export$1aa9ac0ef1c2d437(encodedURI) {
    try {
        return decodeURIComponent(encodedURI);
    } catch (error) {
        console.warn("Error safeDecodeURIComponent");
        return ""; // Return "" for invalid URI components.
    }
}


var $1787ab5ed6683a99$export$22c2c977437cf477;
var $1787ab5ed6683a99$export$dfb5619354ba860;
var $1787ab5ed6683a99$export$51bdeede045fdf8b;
var $1787ab5ed6683a99$export$17fa98cb055e8fa7;
var $1787ab5ed6683a99$export$a5833c2b43ca4340;
var $1787ab5ed6683a99$export$47511f9a6581d1d6;
var $1787ab5ed6683a99$export$dd1c05b92185401c;
var $1787ab5ed6683a99$export$8b28cf6cd00fe080;
var $1787ab5ed6683a99$export$186c650311ff0789;
var $1787ab5ed6683a99$export$6746fe0d9c9fab54;
var $1787ab5ed6683a99$export$2bcf359f0c20e94f;
var $1787ab5ed6683a99$export$2903d10d531d0ac0;
var $1787ab5ed6683a99$export$4d906d824797a18a;
var $1787ab5ed6683a99$export$f71a106f1d1ba408;
$1787ab5ed6683a99$export$22c2c977437cf477 = `uMShka_MarkdownRenderer`;
$1787ab5ed6683a99$export$dfb5619354ba860 = `uMShka_auto`;
$1787ab5ed6683a99$export$dfb5619354ba860;
$1787ab5ed6683a99$export$51bdeede045fdf8b = `uMShka_centerAlign`;
$1787ab5ed6683a99$export$17fa98cb055e8fa7 = `uMShka_fontSizeH1`;
$1787ab5ed6683a99$export$a5833c2b43ca4340 = `uMShka_fontSizeH2`;
$1787ab5ed6683a99$export$47511f9a6581d1d6 = `uMShka_fontSizeH3`;
$1787ab5ed6683a99$export$dd1c05b92185401c = `uMShka_fontSizeH4`;
$1787ab5ed6683a99$export$8b28cf6cd00fe080 = `uMShka_fontSizeH5`;
$1787ab5ed6683a99$export$186c650311ff0789 = `uMShka_fontSizeH6`;
$1787ab5ed6683a99$export$6746fe0d9c9fab54 = `uMShka_fontSizeSmall`;
$1787ab5ed6683a99$export$2bcf359f0c20e94f = `uMShka_fontSizeTiny`;
$1787ab5ed6683a99$export$2903d10d531d0ac0 = `uMShka_fontSizep`;
$1787ab5ed6683a99$export$4d906d824797a18a = `uMShka_hasDefaultStyling`;
$1787ab5ed6683a99$export$f71a106f1d1ba408 = `uMShka_leftAlign`;


const $17855786516ea933$var$LinkRenderer = ({ href: href, children: children })=>{
    if (!href) return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
        href: href,
        target: "_blank",
        rel: "noreferrer",
        children: children
    });
};
// Renders heading with provided level
const $17855786516ea933$var$HeadingRenderer = (level)=>{
    const Tag = `h${level}`;
    return ({ children: children })=>/*#__PURE__*/ (0, $2PPWI.jsx)(Tag, {
            children: children
        });
};
/* Accepts markdown as plaintext or base64 and renders JSX. Uses a custom component to render anchors.
Comes with some default CSS, which can be stopped by setting hasDefaultStyling to false */ const $17855786516ea933$var$MarkdownRenderer = ({ markdownContent: markdownContent, base64MarkdownContent: base64MarkdownContent, hasDefaultStyling: hasDefaultStyling = true, textAlign: textAlign = "center" })=>{
    if (!base64MarkdownContent && !markdownContent) {
        console.error("No content found for markdown");
        return null;
    }
    const content = markdownContent ?? (0, $aed6ee8c7b23660f$export$1aa9ac0ef1c2d437)((0, $aed6ee8c7b23660f$export$64c1a95e2185bc9a)(base64MarkdownContent));
    if (!content) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1787ab5ed6683a99$export$22c2c977437cf477, {
            [$1787ab5ed6683a99$export$4d906d824797a18a]: hasDefaultStyling,
            [$1787ab5ed6683a99$export$51bdeede045fdf8b]: textAlign === "center",
            [$1787ab5ed6683a99$export$f71a106f1d1ba408]: textAlign === "left"
        }),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6bfd1bdcc14e2920$export$2e2bcd8739ae039), {
            options: {
                overrides: {
                    // Bump all headings down by 1, so highest heading can be h2. h1 is reserved for main website title.
                    h1: $17855786516ea933$var$HeadingRenderer(2),
                    h2: $17855786516ea933$var$HeadingRenderer(3),
                    h3: $17855786516ea933$var$HeadingRenderer(4),
                    h4: $17855786516ea933$var$HeadingRenderer(5),
                    h5: $17855786516ea933$var$HeadingRenderer(6),
                    a: $17855786516ea933$var$LinkRenderer
                },
                disableParsingRawHTML: true
            },
            children: content
        })
    });
};
var $17855786516ea933$export$2e2bcd8739ae039 = $17855786516ea933$var$MarkdownRenderer;



var $cEIti = parcelRequire("cEIti");

var $jJtwY = parcelRequire("jJtwY");

var $6lYLL = parcelRequire("6lYLL");



var $baXkz = parcelRequire("baXkz");

var $aTRs6 = parcelRequire("aTRs6");
var $d1af034c62d4fb39$export$c72f6eaae7b9adff;
var $d1af034c62d4fb39$export$f0ca0d7181ab2dcf;
var $d1af034c62d4fb39$export$40e543e69a8b3fbb;
var $d1af034c62d4fb39$export$efe229eab43a9869;
var $d1af034c62d4fb39$export$a7db06668cad9adb;
var $d1af034c62d4fb39$export$17fa98cb055e8fa7;
var $d1af034c62d4fb39$export$a5833c2b43ca4340;
var $d1af034c62d4fb39$export$47511f9a6581d1d6;
var $d1af034c62d4fb39$export$dd1c05b92185401c;
var $d1af034c62d4fb39$export$8b28cf6cd00fe080;
var $d1af034c62d4fb39$export$186c650311ff0789;
var $d1af034c62d4fb39$export$6746fe0d9c9fab54;
var $d1af034c62d4fb39$export$2bcf359f0c20e94f;
var $d1af034c62d4fb39$export$2903d10d531d0ac0;
var $d1af034c62d4fb39$export$28ad24793e431919;
var $d1af034c62d4fb39$export$a1fe6a2d7788354f;
var $d1af034c62d4fb39$export$ad200f2ca1a7d990;
var $d1af034c62d4fb39$export$1f22e2e0afc9f037;
var $d1af034c62d4fb39$export$848500358616d9e6;
var $d1af034c62d4fb39$export$1e95b668f3b82d;
var $d1af034c62d4fb39$export$664c6d24e3175067;
$d1af034c62d4fb39$export$c72f6eaae7b9adff = `_FajrW_Settings`;
$d1af034c62d4fb39$export$f0ca0d7181ab2dcf = `_FajrW_backdropBlur`;
$d1af034c62d4fb39$export$40e543e69a8b3fbb = `_FajrW_bottom`;
$d1af034c62d4fb39$export$efe229eab43a9869 = `_FajrW_closeButton`;
$d1af034c62d4fb39$export$a7db06668cad9adb = `_FajrW_content`;
$d1af034c62d4fb39$export$17fa98cb055e8fa7 = `_FajrW_fontSizeH1`;
$d1af034c62d4fb39$export$a5833c2b43ca4340 = `_FajrW_fontSizeH2`;
$d1af034c62d4fb39$export$47511f9a6581d1d6 = `_FajrW_fontSizeH3`;
$d1af034c62d4fb39$export$dd1c05b92185401c = `_FajrW_fontSizeH4`;
$d1af034c62d4fb39$export$8b28cf6cd00fe080 = `_FajrW_fontSizeH5`;
$d1af034c62d4fb39$export$186c650311ff0789 = `_FajrW_fontSizeH6`;
$d1af034c62d4fb39$export$6746fe0d9c9fab54 = `_FajrW_fontSizeSmall`;
$d1af034c62d4fb39$export$2bcf359f0c20e94f = `_FajrW_fontSizeTiny`;
$d1af034c62d4fb39$export$2903d10d531d0ac0 = `_FajrW_fontSizep`;
$d1af034c62d4fb39$export$28ad24793e431919 = `_FajrW_footerText`;
$d1af034c62d4fb39$export$a1fe6a2d7788354f = `_FajrW_logoContainer`;
$d1af034c62d4fb39$export$ad200f2ca1a7d990 = `_FajrW_logos`;
$d1af034c62d4fb39$export$1f22e2e0afc9f037 = `_FajrW_logoutButton`;
$d1af034c62d4fb39$export$848500358616d9e6 = `_FajrW_middle`;
$d1af034c62d4fb39$export$1e95b668f3b82d = `_FajrW_top`;
$d1af034c62d4fb39$export$664c6d24e3175067 = `_FajrW_visible`;


function $775534e4e3082407$export$2e2bcd8739ae039({ visible: visible, displayNameShouldLinkToProfile: displayNameShouldLinkToProfile }) {
    const theme = (0, $cEIti.useTheme)();
    const audio = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const settingsContentRef = (0, $8FY87.useRef)(null);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const loggedIn = (0, $6lYLL.useAppSelector)((state)=>state.auth.loggedIn);
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    // Close the setting menu when the user presses the escape key
    (0, $8FY87.useEffect)(()=>{
        function keyUpHandler(e) {
            if (e.key === "Escape") dispatch((0, $baXkz.setShowingSettingsMenu)(false));
        }
        if (visible) {
            window.addEventListener("keyup", keyUpHandler);
            settingsContentRef.current.focus();
        } else window.removeEventListener("keyup", keyUpHandler);
        return ()=>{
            window.removeEventListener("keyup", keyUpHandler);
        };
    }, [
        visible
    ]);
    // Hide the settings menu when the user clicks outside of it
    function clickHandler(e) {
        if (settingsContentRef.current && !settingsContentRef.current.contains(e.target)) dispatch((0, $baXkz.setShowingSettingsMenu)(false));
    }
    const Logo = ({ logo: logo })=>{
        if (!logo.imageUrl) return null;
        const image = /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
            src: logo.imageUrl,
            alt: logo.alt
        });
        if (logo.href) return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
            href: logo.href,
            className: $d1af034c62d4fb39$export$a1fe6a2d7788354f,
            target: "_blank",
            rel: "noreferrer",
            children: image
        });
        return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: $d1af034c62d4fb39$export$a1fe6a2d7788354f,
            children: image
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d1af034c62d4fb39$export$f0ca0d7181ab2dcf, {
                    [$d1af034c62d4fb39$export$664c6d24e3175067]: visible
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d1af034c62d4fb39$export$c72f6eaae7b9adff, {
                    [$d1af034c62d4fb39$export$664c6d24e3175067]: visible
                }),
                onClick: clickHandler,
                "aria-hidden": !visible,
                inert: visible ? undefined : "",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e37d8a2442920999$export$142c7a4094f92438), {
                        imagePath: theme.customJSON.settings?.backgroundImage,
                        style: {
                            minWidth: 520
                        }
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        iconType: "close",
                        ariaLabel: "Close Settings",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d1af034c62d4fb39$export$efe229eab43a9869),
                        buttonStyle: "round",
                        onClick: ()=>{
                            dispatch((0, $baXkz.setShowingSettingsMenu)(false));
                        }
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $d1af034c62d4fb39$export$a7db06668cad9adb,
                        ref: settingsContentRef,
                        tabIndex: visible ? 0 : -1,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $d1af034c62d4fb39$export$1e95b668f3b82d,
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $13dab9088986de0c$export$2e2bcd8739ae039), {
                                    profile: currentUserProfile,
                                    shouldLinkToProfile: displayNameShouldLinkToProfile
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $d1af034c62d4fb39$export$848500358616d9e6,
                                children: theme.metadata?.settingsMarkdown && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $17855786516ea933$export$2e2bcd8739ae039), {
                                    base64MarkdownContent: theme.metadata?.settingsMarkdown,
                                    textAlign: "left"
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $d1af034c62d4fb39$export$40e543e69a8b3fbb,
                                children: [
                                    !isGuest && !(0, $aTRs6.IS_DISCORD_ACTIVITY) && loggedIn && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                                        className: $d1af034c62d4fb39$export$1f22e2e0afc9f037,
                                        disabled: !visible,
                                        onClick: ()=>{
                                            dispatch((0, $jJtwY.logout)());
                                            (0, $i7H0N.sendEvent)("logout_user");
                                        },
                                        children: "Log Out"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: $d1af034c62d4fb39$export$ad200f2ca1a7d990,
                                        children: Array.isArray(theme.customJSON?.settings?.logos) && theme.customJSON?.settings?.logos.map((logo, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)(Logo, {
                                                logo: logo
                                            }, index))
                                    }),
                                    theme.customJSON?.settings?.footerText && /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                        className: $d1af034c62d4fb39$export$28ad24793e431919,
                                        children: [
                                            theme.customJSON?.settings?.footerText,
                                            " "
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");



var $1URoE = parcelRequire("1URoE");

var $i7H0N = parcelRequire("i7H0N");

var $jLk8j = parcelRequire("jLk8j");

var $cEIti = parcelRequire("cEIti");
var $2070ef352865c88b$export$66f1e6e3a37196e7;
var $2070ef352865c88b$export$bbea856fdb3e3c5f;
var $2070ef352865c88b$export$17fa98cb055e8fa7;
var $2070ef352865c88b$export$a5833c2b43ca4340;
var $2070ef352865c88b$export$47511f9a6581d1d6;
var $2070ef352865c88b$export$dd1c05b92185401c;
var $2070ef352865c88b$export$8b28cf6cd00fe080;
var $2070ef352865c88b$export$186c650311ff0789;
var $2070ef352865c88b$export$6746fe0d9c9fab54;
var $2070ef352865c88b$export$2bcf359f0c20e94f;
var $2070ef352865c88b$export$2903d10d531d0ac0;
var $2070ef352865c88b$export$7abe78e1eda562aa;
var $2070ef352865c88b$export$db3c28d99448dcff;
var $2070ef352865c88b$export$ff596a73a4aa8e05;
$2070ef352865c88b$export$66f1e6e3a37196e7 = `tWzobG_GuestBanner`;
$2070ef352865c88b$export$bbea856fdb3e3c5f = `tWzobG_buttons`;
$2070ef352865c88b$export$17fa98cb055e8fa7 = `tWzobG_fontSizeH1`;
$2070ef352865c88b$export$a5833c2b43ca4340 = `tWzobG_fontSizeH2`;
$2070ef352865c88b$export$47511f9a6581d1d6 = `tWzobG_fontSizeH3`;
$2070ef352865c88b$export$dd1c05b92185401c = `tWzobG_fontSizeH4`;
$2070ef352865c88b$export$8b28cf6cd00fe080 = `tWzobG_fontSizeH5`;
$2070ef352865c88b$export$186c650311ff0789 = `tWzobG_fontSizeH6`;
$2070ef352865c88b$export$6746fe0d9c9fab54 = `tWzobG_fontSizeSmall`;
$2070ef352865c88b$export$2bcf359f0c20e94f = `tWzobG_fontSizeTiny`;
$2070ef352865c88b$export$2903d10d531d0ac0 = `tWzobG_fontSizep`;
$2070ef352865c88b$export$7abe78e1eda562aa = `tWzobG_loginButton`;
$2070ef352865c88b$export$db3c28d99448dcff = `tWzobG_logo`;
$2070ef352865c88b$export$ff596a73a4aa8e05 = `tWzobG_thoseBeyondThemed`;


function $71422882def2b02b$export$2e2bcd8739ae039() {
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    const navigateToLogin = (0, $dbacf51e5486f7e0$export$932dac77da3ee9c3)();
    const theme = (0, $cEIti.useTheme)();
    const getLongText = ()=>{
        if (theme.customJSON?.guestBannerLongText) return theme.customJSON?.guestBannerLongText;
        if (0, $1URoE.isInsidersInstance) return "Join to chat, earn Skybound Insiders Points and experience more.";
        if (0, $1URoE.isThoseBeyondInstance) return "Join the Those Beyond community to chat and experience more.";
        return "Join the community to chat and experience more.";
    };
    const shortText = "Sign up now\u2026";
    const text = (0, $jLk8j.isMobileWidth)() ? shortText : getLongText();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2070ef352865c88b$export$66f1e6e3a37196e7, {
            [$2070ef352865c88b$export$ff596a73a4aa8e05]: (0, $1URoE.isThoseBeyondInstance)
        }),
        children: [
            (0, $1URoE.isThoseBeyondInstance) && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $2070ef352865c88b$export$db3c28d99448dcff,
                alt: "Those Beyond Logo",
                src: "/assets/global/those-beyond-icon.svg"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                children: text
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $2070ef352865c88b$export$bbea856fdb3e3c5f,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                        className: $2070ef352865c88b$export$7abe78e1eda562aa,
                        onClick: ()=>{
                            (0, $i7H0N.sendEvent)("guest_banner_log_in_click", {
                                message: text
                            });
                            navigateToLogin();
                        },
                        children: "Log In"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                        className: $2070ef352865c88b$export$7abe78e1eda562aa,
                        onClick: ()=>{
                            (0, $i7H0N.sendEvent)("guest_banner_sign_up_click", {
                                message: text
                            });
                            navigateToSignup();
                        },
                        children: "Sign Up"
                    })
                ]
            })
        ]
    });
}



var $6lYLL = parcelRequire("6lYLL");


var $aTRs6 = parcelRequire("aTRs6");
function $4eb1e267ba3c534d$export$2e2bcd8739ae039({ children: children, pageHasProfileDrawer: pageHasProfileDrawer }) {
    const isSettingsMenuShowing = (0, $6lYLL.useAppSelector)((state)=>state.app.isSettingsMenuShowing);
    const isPurchaseInProgress = (0, $6lYLL.useAppSelector)((state)=>state.app.isPurchaseInProgress);
    const container = (0, $8FY87.useRef)(null);
    const shouldBeInert = isSettingsMenuShowing || isPurchaseInProgress;
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const shouldShowGuestBanner = isGuest && !(0, $aTRs6.IS_DISCORD_ACTIVITY) && false;
    const shouldShowSettings = false;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "absolute top-0 left-0 w-full h-full overflow-hidden",
                style: {
                    touchAction: "none",
                    height: shouldShowGuestBanner ? `calc(100% - 50px)` : "100%",
                    backgroundColor: "black"
                },
                ref: container,
                onScroll: ()=>{
                    // Stop scroll jumping to items which become focussed off screen
                    container.current.scrollTo(0, 0);
                },
                children: [
                    shouldShowSettings && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $775534e4e3082407$export$2e2bcd8739ae039), {
                        visible: isSettingsMenuShowing,
                        displayNameShouldLinkToProfile: pageHasProfileDrawer
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full",
                        inert: shouldBeInert ? "" : undefined,
                        children: children
                    })
                ]
            }),
            shouldShowGuestBanner && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $71422882def2b02b$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");


var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
var $45aa3beddb37ced9$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $45aa3beddb37ced9$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $45aa3beddb37ced9$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $45aa3beddb37ced9$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $45aa3beddb37ced9$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $45aa3beddb37ced9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $45aa3beddb37ced9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $45aa3beddb37ced9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $45aa3beddb37ced9$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $45aa3beddb37ced9$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $45aa3beddb37ced9$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $45aa3beddb37ced9$var$root = $45aa3beddb37ced9$var$freeGlobal || $45aa3beddb37ced9$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $45aa3beddb37ced9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $45aa3beddb37ced9$var$objectToString = $45aa3beddb37ced9$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $45aa3beddb37ced9$var$nativeMax = Math.max, $45aa3beddb37ced9$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $45aa3beddb37ced9$var$now = function() {
    return $45aa3beddb37ced9$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $45aa3beddb37ced9$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($45aa3beddb37ced9$var$FUNC_ERROR_TEXT);
    wait = $45aa3beddb37ced9$var$toNumber(wait) || 0;
    if ($45aa3beddb37ced9$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $45aa3beddb37ced9$var$nativeMax($45aa3beddb37ced9$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $45aa3beddb37ced9$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $45aa3beddb37ced9$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($45aa3beddb37ced9$var$now());
    }
    function debounced() {
        var time = $45aa3beddb37ced9$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $45aa3beddb37ced9$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($45aa3beddb37ced9$var$FUNC_ERROR_TEXT);
    if ($45aa3beddb37ced9$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $45aa3beddb37ced9$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $45aa3beddb37ced9$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $45aa3beddb37ced9$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $45aa3beddb37ced9$var$isSymbol(value) {
    return typeof value == "symbol" || $45aa3beddb37ced9$var$isObjectLike(value) && $45aa3beddb37ced9$var$objectToString.call(value) == $45aa3beddb37ced9$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $45aa3beddb37ced9$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($45aa3beddb37ced9$var$isSymbol(value)) return $45aa3beddb37ced9$var$NAN;
    if ($45aa3beddb37ced9$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $45aa3beddb37ced9$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($45aa3beddb37ced9$var$reTrim, "");
    var isBinary = $45aa3beddb37ced9$var$reIsBinary.test(value);
    return isBinary || $45aa3beddb37ced9$var$reIsOctal.test(value) ? $45aa3beddb37ced9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $45aa3beddb37ced9$var$reIsBadHex.test(value) ? $45aa3beddb37ced9$var$NAN : +value;
}
$45aa3beddb37ced9$exports = $45aa3beddb37ced9$var$throttle;



var $9s93Y = parcelRequire("9s93Y");


var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");



var $f9aoP = parcelRequire("f9aoP");
var $0fc5711810f8f6f9$export$4a1b0a44038b9fed;
var $0fc5711810f8f6f9$export$1f5bc368d3696850;
var $0fc5711810f8f6f9$export$3971be9dca1d5a90;
var $0fc5711810f8f6f9$export$bf611240ac44546e;
var $0fc5711810f8f6f9$export$89da14300d534261;
var $0fc5711810f8f6f9$export$345c5736c8054f22;
var $0fc5711810f8f6f9$export$17fa98cb055e8fa7;
var $0fc5711810f8f6f9$export$a5833c2b43ca4340;
var $0fc5711810f8f6f9$export$47511f9a6581d1d6;
var $0fc5711810f8f6f9$export$dd1c05b92185401c;
var $0fc5711810f8f6f9$export$8b28cf6cd00fe080;
var $0fc5711810f8f6f9$export$186c650311ff0789;
var $0fc5711810f8f6f9$export$6746fe0d9c9fab54;
var $0fc5711810f8f6f9$export$2bcf359f0c20e94f;
var $0fc5711810f8f6f9$export$2903d10d531d0ac0;
var $0fc5711810f8f6f9$export$73920f18ca706874;
$0fc5711810f8f6f9$export$4a1b0a44038b9fed = `Lyqp4G_SuggestionsPicker`;
$0fc5711810f8f6f9$export$1f5bc368d3696850 = `Lyqp4G_SuggestionsPicker__closeButton`;
$0fc5711810f8f6f9$export$3971be9dca1d5a90 = `Lyqp4G_SuggestionsPicker__helpText`;
$0fc5711810f8f6f9$export$bf611240ac44546e = `Lyqp4G_SuggestionsPicker__user`;
$0fc5711810f8f6f9$export$89da14300d534261 = `Lyqp4G_active`;
$0fc5711810f8f6f9$export$345c5736c8054f22 = `Lyqp4G_avatar`;
$0fc5711810f8f6f9$export$17fa98cb055e8fa7 = `Lyqp4G_fontSizeH1`;
$0fc5711810f8f6f9$export$a5833c2b43ca4340 = `Lyqp4G_fontSizeH2`;
$0fc5711810f8f6f9$export$47511f9a6581d1d6 = `Lyqp4G_fontSizeH3`;
$0fc5711810f8f6f9$export$dd1c05b92185401c = `Lyqp4G_fontSizeH4`;
$0fc5711810f8f6f9$export$8b28cf6cd00fe080 = `Lyqp4G_fontSizeH5`;
$0fc5711810f8f6f9$export$186c650311ff0789 = `Lyqp4G_fontSizeH6`;
$0fc5711810f8f6f9$export$6746fe0d9c9fab54 = `Lyqp4G_fontSizeSmall`;
$0fc5711810f8f6f9$export$2bcf359f0c20e94f = `Lyqp4G_fontSizeTiny`;
$0fc5711810f8f6f9$export$2903d10d531d0ac0 = `Lyqp4G_fontSizep`;
$0fc5711810f8f6f9$export$73920f18ca706874 = `Lyqp4G_hidden`;


function $f49c4968276f4170$export$2e2bcd8739ae039({ query: query, currentKey: currentKey, onProfileSelected: onProfileSelected, onPickerClosed: onPickerClosed, visible: visible, closePickerOnEmptyResult: closePickerOnEmptyResult }) {
    const MIN_QUERY_LENGTH = 2;
    const MAX_QUERY_LENGTH = 19;
    const [profiles, setProfiles] = (0, $8FY87.useState)([]);
    const [activeIndex, setActiveIndex] = (0, $8FY87.useState)(0);
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $8FY87.useState)(false);
    const latestQuery = (0, $8FY87.useRef)("");
    (0, $8FY87.useEffect)(()=>{
        const trimmedQuery = query?.trim();
        latestQuery.current = trimmedQuery;
        if (trimmedQuery?.length >= MIN_QUERY_LENGTH && trimmedQuery.length <= MAX_QUERY_LENGTH) {
            const fetchResults = async ()=>{
                setIsLoadingSuggestions(true);
                try {
                    const response = await (0, $f9aoP.searchByDisplayName)(trimmedQuery);
                    // Only update results if from latest query
                    if (trimmedQuery === latestQuery.current) {
                        setIsLoadingSuggestions(false);
                        setActiveIndex(0);
                        setProfiles(response.length ? response : []);
                        if (closePickerOnEmptyResult && !response.length) onPickerClosed();
                    }
                } catch (err) {
                    console.error("Could not find profiles");
                    setActiveIndex(0);
                    setProfiles([]);
                    setIsLoadingSuggestions(false);
                }
            };
            fetchResults();
        } else {
            setActiveIndex(0);
            setProfiles([]);
        }
    }, [
        query
    ]);
    const onSelect = (e, profile)=>{
        e.preventDefault();
        setActiveIndex(0);
        onProfileSelected(profile);
    };
    (0, $8FY87.useEffect)(()=>{
        if (currentKey === "ArrowDown") {
            const newIndex = activeIndex + 1;
            if (newIndex < profiles.length) {
                setActiveIndex(newIndex);
                document.getElementById(`suggestion-${newIndex}`)?.scrollIntoView(false);
            }
        }
        if (currentKey === "ArrowUp") {
            const newIndex = activeIndex - 1;
            if (newIndex >= 0) {
                setActiveIndex(newIndex);
                document.getElementById(`suggestion-${newIndex}`)?.scrollIntoView();
            }
        }
        if (currentKey === "Enter") {
            if (profiles[activeIndex]) onProfileSelected(profiles[activeIndex]);
            else onPickerClosed();
        }
    }, [
        currentKey
    ]);
    const noResultsMessage = query?.length < MIN_QUERY_LENGTH ? "Start typing" : isLoadingSuggestions ? "Loading..." : "No results";
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($0fc5711810f8f6f9$export$4a1b0a44038b9fed, {
            [$0fc5711810f8f6f9$export$73920f18ca706874]: !visible
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                iconType: "close",
                ariaLabel: "Close picker",
                buttonStyle: "icon",
                onClick: onPickerClosed,
                className: $0fc5711810f8f6f9$export$1f5bc368d3696850,
                title: "Close picker"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                children: [
                    profiles.map((profile, index)=>{
                        return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($0fc5711810f8f6f9$export$bf611240ac44546e, {
                                    [$0fc5711810f8f6f9$export$89da14300d534261]: index === activeIndex
                                }),
                                id: `suggestion-${index}`,
                                onClick: (e)=>onSelect(e, profile),
                                onMouseDown: (e)=>e.preventDefault(),
                                onMouseMove: ()=>setActiveIndex(index),
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                                        classname: $0fc5711810f8f6f9$export$345c5736c8054f22,
                                        backgroundImagePath: profile.background?.thumbnailPath,
                                        characterImagePath: profile.character?.thumbnailPath,
                                        frameImagePath: profile.avatarFrame?.imagePath
                                    }),
                                    profile.displayName
                                ]
                            })
                        }, index);
                    }),
                    !profiles.length && /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: $0fc5711810f8f6f9$export$3971be9dca1d5a90,
                        children: noResultsMessage
                    })
                ]
            })
        ]
    });
}



var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");

var $i7H0N = parcelRequire("i7H0N");
const $f17fa7344affc18d$export$47774cf7fb07bfc4 = (element)=>{
    const selection = window.getSelection();
    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    return preCaretRange.toString().length;
};
const $f17fa7344affc18d$export$adceb8404f6ecfd5 = (element, cursorPosition)=>{
    const selection = window.getSelection();
    const range = document.createRange();
    let charCount = 0;
    const nodeStack = [
        element
    ];
    let node, foundStart = false;
    while(nodeStack.length && !foundStart){
        node = nodeStack.pop();
        if (node.nodeType === 3) {
            const nextCharCount = charCount + node.textContent.length;
            if (!foundStart && cursorPosition <= nextCharCount) {
                range.setStart(node, cursorPosition - charCount);
                foundStart = true;
            }
            charCount = nextCharCount;
        } else {
            let i = node.childNodes.length;
            while(i--)nodeStack.push(node.childNodes[i]);
        }
    }
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
};
const $f17fa7344affc18d$export$f8353bbcb38f91ed = (element)=>{
    if (!element) return;
    const selection = window.getSelection();
    if (!selection.rangeCount) return;
    const range = selection.getRangeAt(0);
    const nextNode = element.nextSibling;
    // Create a text node containing a space
    const spaceNode = document.createTextNode("\xa0");
    if (nextNode) // If there's a next sibling node, insert the space node after the element
    element.parentNode.insertBefore(spaceNode, nextNode);
    else // If there's no next sibling node, append the space node to the parent node
    element.parentNode.appendChild(spaceNode);
    // Move the cursor to the space node
    range.setStart(spaceNode, 1);
    range.collapse(true);
    // Update the selection range
    selection.removeAllRanges();
    selection.addRange(range);
};



var $baXkz = parcelRequire("baXkz");

var $kyBxf = parcelRequire("kyBxf");

var $4KKbJ = parcelRequire("4KKbJ");
function $903c15cc0eb1c8a5$export$a838521147cdf3c5(text, currentEvent) {
    // TODO check if participant
    if (currentEvent?.isActive) {
        if (text.includes(currentEvent.eventParams.winString)) return true;
    }
    return false;
}
function $903c15cc0eb1c8a5$export$18ace0bffa4e787d(locationId, dispatch) {
    dispatch((0, $kyBxf.submitMessage)([
        locationId,
        "I tried to cheat by copy and pasting"
    ]));
    dispatch((0, $baXkz.submitFeedUpdate)("paste_and_debased"));
    dispatch((0, $4KKbJ.awardTitle)("paste_and_debased"));
}



var $cEIti = parcelRequire("cEIti");
var $25cadc621823a45b$export$2b626cc5878018c6;
var $25cadc621823a45b$export$52191330222f0df5;
var $25cadc621823a45b$export$b2efbf6fb336cf70;
var $25cadc621823a45b$export$b96075eaee27c881;
var $25cadc621823a45b$export$7cfb0c8949522aac;
var $25cadc621823a45b$export$255f1df14151a441;
var $25cadc621823a45b$export$791b128f0311be7c;
var $25cadc621823a45b$export$b55e10d3ca1aad04;
var $25cadc621823a45b$export$17fa98cb055e8fa7;
var $25cadc621823a45b$export$a5833c2b43ca4340;
var $25cadc621823a45b$export$47511f9a6581d1d6;
var $25cadc621823a45b$export$dd1c05b92185401c;
var $25cadc621823a45b$export$8b28cf6cd00fe080;
var $25cadc621823a45b$export$186c650311ff0789;
var $25cadc621823a45b$export$6746fe0d9c9fab54;
var $25cadc621823a45b$export$2bcf359f0c20e94f;
var $25cadc621823a45b$export$2903d10d531d0ac0;
var $25cadc621823a45b$export$684e3421be5320ab;
var $25cadc621823a45b$export$f2c12b114d1afda;
$25cadc621823a45b$export$2b626cc5878018c6 = `Nv5JfG_ChatBarWrapper`;
$25cadc621823a45b$export$52191330222f0df5 = `Nv5JfG_Chatbar`;
$25cadc621823a45b$export$b2efbf6fb336cf70 = `Nv5JfG_Chatbar__command`;
$25cadc621823a45b$export$b96075eaee27c881 = `Nv5JfG_Chatbar__input`;
$25cadc621823a45b$export$7cfb0c8949522aac = `Nv5JfG_Chatbar__mention`;
$25cadc621823a45b$export$255f1df14151a441 = `Nv5JfG_Chatbar__mentionInProgress`;
$25cadc621823a45b$export$791b128f0311be7c = `Nv5JfG_Chatbar__richText`;
$25cadc621823a45b$export$b55e10d3ca1aad04 = `Nv5JfG_Chatbar__sendButton`;
$25cadc621823a45b$export$17fa98cb055e8fa7 = `Nv5JfG_fontSizeH1`;
$25cadc621823a45b$export$a5833c2b43ca4340 = `Nv5JfG_fontSizeH2`;
$25cadc621823a45b$export$47511f9a6581d1d6 = `Nv5JfG_fontSizeH3`;
$25cadc621823a45b$export$dd1c05b92185401c = `Nv5JfG_fontSizeH4`;
$25cadc621823a45b$export$8b28cf6cd00fe080 = `Nv5JfG_fontSizeH5`;
$25cadc621823a45b$export$186c650311ff0789 = `Nv5JfG_fontSizeH6`;
$25cadc621823a45b$export$6746fe0d9c9fab54 = `Nv5JfG_fontSizeSmall`;
$25cadc621823a45b$export$2bcf359f0c20e94f = `Nv5JfG_fontSizeTiny`;
$25cadc621823a45b$export$2903d10d531d0ac0 = `Nv5JfG_fontSizep`;
$25cadc621823a45b$export$684e3421be5320ab = `Nv5JfG_hasToolbar`;
$25cadc621823a45b$export$f2c12b114d1afda = `Nv5JfG_helpButton`;


var $97cdf55e533ea365$var$MessageNodeType;
(function(MessageNodeType) {
    MessageNodeType["Mention"] = "mention";
    MessageNodeType["Command"] = "command";
})($97cdf55e533ea365$var$MessageNodeType || ($97cdf55e533ea365$var$MessageNodeType = {}));
const $97cdf55e533ea365$var$MAX_LENGTH = 2000;
const $97cdf55e533ea365$var$HELP_COMMAND = "/hint";
const $97cdf55e533ea365$var$EVENT_COMMAND = "/event";
const $97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE = "data-arise-chat-input-node-type";
function $97cdf55e533ea365$export$2e2bcd8739ae039({ placeholder: placeholder, onResize: onResize, locationId: locationId, isLocked: isLocked, isAdmin: isAdmin }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const currentEvent = (0, $6lYLL.useAppSelector)((state)=>state.feed.currentEvent);
    const [queryValue, setQueryValue] = (0, $8FY87.useState)("");
    const [isTypingMention, setIsTypingMention] = (0, $8FY87.useState)(false);
    const [currentKey, setCurrentKey] = (0, $8FY87.useState)("");
    const hasHelpUI = theme.metadata?.hasHelpUI;
    const hasPastedEventWinString = (0, $8FY87.useRef)(false);
    const inputRef = (0, $8FY87.useRef)(null);
    const shadowInputRef = (0, $8FY87.useRef)(null);
    const containerRef = (0, $8FY87.useRef)(null);
    function shouldSendAsServerCommand(message) {
        return isAdmin && message.startsWith($97cdf55e533ea365$var$EVENT_COMMAND);
    }
    function submit() {
        const processedText = processMessageForSending(inputRef.current.innerHTML);
        if (!processedText?.length || isLocked) return;
        if (shouldSendAsServerCommand(processedText)) dispatch((0, $kyBxf.submitCommand)([
            locationId,
            processedText
        ]));
        else if (hasPastedEventWinString.current) {
            // Check for cheating in chat event
            (0, $903c15cc0eb1c8a5$export$18ace0bffa4e787d)(locationId, dispatch);
            (0, $i7H0N.sendEvent)("send_chat_message");
        } else {
            dispatch((0, $kyBxf.submitMessage)([
                locationId,
                processedText
            ]));
            (0, $i7H0N.sendEvent)("send_chat_message");
        }
        setQueryValue("");
        setIsTypingMention(false);
        clearInput();
    }
    const updateShadowInput = (0, $8FY87.useCallback)(// When the content changes, shadow input must have the same content so it can be used for measuring
    (0, (/*@__PURE__*/$parcel$interopDefault($45aa3beddb37ced9$exports)))(()=>{
        if (inputRef.current && shadowInputRef.current) {
            shadowInputRef.current.innerHTML = inputRef.current.innerHTML;
            resizeChatBox();
        }
    }, 200), []);
    (0, $8FY87.useEffect)(()=>{
        // Resize text area when window resizes
        const throttledResizeChatBox = (0, (/*@__PURE__*/$parcel$interopDefault($45aa3beddb37ced9$exports)))(resizeChatBox, 200);
        const handleResize = ()=>{
            throttledResizeChatBox();
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    function resizeChatBox() {
        const element = inputRef.current;
        const shadowElement = shadowInputRef.current;
        const container = containerRef.current;
        if (!element || !shadowElement || !container) return;
        // Resize textarea if needed
        const maxHeight = 116; // 4 lines of text
        const lastHeight = element.style.height;
        element.style.height = shadowElement.scrollHeight + "px";
        container.style.height = shadowElement.scrollHeight + "px";
        // Show/hide scrollbar based on content overflow
        if (shadowElement.scrollHeight > maxHeight) container.style.overflowY = "scroll";
        else container.style.overflowY = "hidden";
        if (lastHeight !== element.style.height && onResize) onResize();
    }
    function handleKeyDown(e) {
        if (e.key === "Enter" && !isTypingMention) {
            e.preventDefault();
            submit();
        }
        if (isTypingMention) {
            if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter") {
                e.preventDefault();
                setCurrentKey(e.key);
            }
            if (e.key === "Escape") closePicker();
        }
    }
    function convertMentionToPlainText() {
        const mention = getCurrentMention();
        if (mention) {
            moveCursorAfterMention();
            const textNode = document.createTextNode(mention.textContent);
            mention.parentNode.replaceChild(textNode, mention);
        }
    }
    function handleKeyUp(e) {
        if (isTypingMention) setCurrentKey(null);
    }
    function removeLineBreaks(value) {
        return value.replace(/(\r\n|\n|\r)/gm, " ");
    }
    function onMentionSelected(profile) {
        if (!profile) // If user presses enter while SuggestionsPicker has no suggestions, submit message
        submit();
        setIsTypingMention(false);
        const mentionElement = getCurrentMention();
        if (mentionElement && profile) {
            moveCursorAfterMention();
            mentionElement.innerText = `@${profile.displayName}`;
            mentionElement.setAttribute("data-userId", profile.userID);
            mentionElement.setAttribute("data-displayName", profile.displayName);
            mentionElement.style.backgroundColor = "";
            mentionElement.classList.remove($25cadc621823a45b$export$255f1df14151a441);
            mentionElement.classList.add($25cadc621823a45b$export$7cfb0c8949522aac);
            mentionElement.contentEditable = "true";
            setQueryValue("");
            updateShadowInput();
        }
    }
    function closePicker() {
        setQueryValue("");
        setIsTypingMention(false);
        convertMentionToPlainText();
    }
    const moveCursorAfterMention = ()=>{
        (0, $f17fa7344affc18d$export$f8353bbcb38f91ed)(getCurrentMention());
    };
    const handleBeforeInput = (e)=>{
        if (inputRef.current.textContent.length >= $97cdf55e533ea365$var$MAX_LENGTH) {
            // Enforce character limit
            e.preventDefault();
            return;
        }
        // If caret is at end of mention, and user types, make text go after the mention
        if (!isTypingMention && getCurrentMention()) {
            const range = window.getSelection().getRangeAt(0);
            const element = getCurrentMention();
            if (range.endOffset === element.innerText.length) moveCursorAfterMention();
        }
    };
    const clearInput = ()=>{
        const range = document.createRange();
        const selection = window.getSelection();
        // Set the range to cover all the text nodes within the div
        range.selectNodeContents(inputRef.current);
        // Select the range
        selection.removeAllRanges();
        selection.addRange(range);
        // Delete the selected range
        selection.deleteFromDocument();
        // As not updating the inputHtml state to preserve caret, manually update shadow input height
        shadowInputRef.current.innerHTML = "";
        resizeChatBox();
        hasPastedEventWinString.current = false;
    };
    const handleInput = (e)=>{
        const isEmpty = !e.target?.innerText?.trim()?.length;
        if (isEmpty) {
            // Remove any empty elements browser may have added
            clearInput();
            return;
        }
        // Check if user typed help command
        if (hasHelpUI && e.target?.innerText?.startsWith($97cdf55e533ea365$var$HELP_COMMAND)) {
            const existingCommandElement = getExistingCommandElement();
            if (!existingCommandElement) {
                // If input begins with command text, replace it with command element
                inputRef.current.innerHTML = inputRef.current.innerHTML.replace($97cdf55e533ea365$var$HELP_COMMAND, "");
                onHelp();
            }
        }
        const selection = window.getSelection();
        if (selection.rangeCount === 0) return;
        const range = selection.getRangeAt(0);
        // Check if cursor is in text node
        if (range.startContainer.nodeType === 3) {
            const textNode = range.startContainer;
            const textContent = textNode.textContent;
            const cursorPos = range.startOffset;
            // If inside Mention
            if (!isTypingMention && getCurrentMention()) {
                // Remove mention if edited after creation
                const mention = getCurrentMention();
                if (mention.innerText.slice(1) !== mention.getAttribute("data-displayName")) {
                    moveCursorAfterMention();
                    mention.remove();
                }
                return;
            }
            // If just typed an @
            if (!isTypingMention && textContent[cursorPos - 1] === "@") {
                // If user typed @, create new in progress mention
                setIsTypingMention(true);
                // Create a new Mention element
                const mentionElement = document.createElement("span");
                mentionElement.contentEditable = "true";
                mentionElement.classList.add($25cadc621823a45b$export$255f1df14151a441);
                mentionElement.textContent = "@";
                mentionElement.setAttribute($97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE, "mention");
                // Insert the new Mention at the cursor position
                range.setStart(textNode, cursorPos - 1);
                range.setEnd(textNode, cursorPos);
                range.deleteContents();
                range.insertNode(mentionElement);
                // Move the cursor inside the new Mention
                range.setStart(mentionElement, 1);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
        if (isTypingMention) {
            const query = getCurrentMention()?.innerText?.slice(1);
            setQueryValue(query);
            if (!query || query.match(/^\s/)) {
                // If in progress mention is empty or begins with spaces, cancel mention
                setIsTypingMention(false);
                convertMentionToPlainText();
            }
        }
        updateShadowInput();
    };
    const getCurrentMention = ()=>{
        // Returns Mention element caret is currently inside
        const node = document.getSelection()?.anchorNode?.parentNode;
        if (node?.getAttribute($97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE) === "mention") return node;
    };
    const getExistingCommandElement = ()=>{
        return inputRef.current.querySelector(`[${$97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE}="${"command"}"]`);
    };
    const onPaste = (e)=>{
        // Only allow plain text to be pasted
        e.preventDefault();
        const pastedText = e.clipboardData ? e.clipboardData.getData("text/plain") : "";
        const pastedTextFiltered = removeLineBreaks(pastedText);
        // Trim pasted text to fit within remaining character limit
        const characterLimitRemaining = $97cdf55e533ea365$var$MAX_LENGTH - inputRef.current.textContent.length;
        const pastedTextTrimmed = pastedTextFiltered.slice(0, characterLimitRemaining);
        // Manually insert the pasted text
        const selection = window.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(new Text(pastedTextTrimmed));
        range.collapse(); // select nothing
        selection.removeAllRanges(); // position caret after inserted text
        selection.addRange(range); // show carets
        hasPastedEventWinString.current = (0, $903c15cc0eb1c8a5$export$a838521147cdf3c5)(pastedTextTrimmed, currentEvent);
        updateShadowInput();
    };
    function processMessageForSending(html) {
        // Format message like: What's up <<user:215cae35-99de-48ca-999c-b3c0865082ae>> and <<user:4c5e4025-621d-4c57-9354-53c97832f280>>?
        const clonedDiv = document.createElement("div");
        clonedDiv.innerHTML = html;
        let messageString = "";
        clonedDiv.childNodes.forEach((node)=>{
            if (node instanceof Element) {
                const type = node.getAttribute($97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE);
                switch(type){
                    case "mention":
                        const userId = node.getAttribute("data-userid");
                        if (userId) messageString += `<<user:${node.getAttribute("data-userid")}>>`;
                        else messageString += node.textContent;
                        break;
                    case "command":
                        messageString += node.textContent;
                        break;
                    default:
                        messageString += node.textContent;
                        break;
                }
            } else if (node.textContent) messageString += node.textContent;
        });
        return messageString.trim();
    }
    function onBlur() {
        if (isTypingMention) closePicker();
    }
    function onHelp() {
        const inputDiv = inputRef.current;
        const existingCommandElement = getExistingCommandElement();
        const range = document.createRange();
        const selection = window.getSelection();
        if (existingCommandElement) {
            // Remove the command element (and spaces after it)
            inputDiv.removeChild(existingCommandElement);
            inputRef.current.innerHTML = inputRef.current.innerHTML.replace("&nbsp;", "");
        } else {
            // Move cursor to the start
            range.selectNodeContents(inputDiv);
            range.collapse(true); // Collapse to the start of the div
            selection.removeAllRanges();
            selection.addRange(range);
            // Insert command at the start
            const commandElement = document.createElement("span");
            commandElement.contentEditable = "false";
            commandElement.classList.add($25cadc621823a45b$export$b2efbf6fb336cf70);
            commandElement.textContent = $97cdf55e533ea365$var$HELP_COMMAND;
            commandElement.setAttribute($97cdf55e533ea365$var$TYPE_DATA_ATTRIBUTE, "command");
            range.insertNode(commandElement);
            (0, $f17fa7344affc18d$export$f8353bbcb38f91ed)(commandElement);
        }
        // Move the cursor to the end
        range.selectNodeContents(inputDiv);
        range.collapse(false); // Collapse to the end of the div
        selection.removeAllRanges();
        selection.addRange(range);
        updateShadowInput();
        hasPastedEventWinString.current = false;
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        onBlur: onBlur,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($25cadc621823a45b$export$2b626cc5878018c6, {
            [$25cadc621823a45b$export$684e3421be5320ab]: hasHelpUI
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $25cadc621823a45b$export$52191330222f0df5,
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        ref: shadowInputRef,
                        "aria-hidden": "true",
                        tabIndex: -1,
                        className: $25cadc621823a45b$export$b96075eaee27c881,
                        style: {
                            opacity: 0,
                            zIndex: -100,
                            left: "-10000px",
                            transition: "none"
                        }
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        role: "textbox",
                        contentEditable: !isLocked,
                        className: $25cadc621823a45b$export$b96075eaee27c881,
                        ref: inputRef,
                        placeholder: placeholder,
                        onKeyUp: handleKeyUp,
                        onKeyDown: handleKeyDown,
                        onBeforeInput: handleBeforeInput,
                        onInput: handleInput,
                        onPaste: onPaste
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        iconType: "send",
                        buttonStyle: "icon",
                        className: $25cadc621823a45b$export$b55e10d3ca1aad04,
                        ariaLabel: "Send",
                        onClick: submit,
                        disabled: isLocked
                    })
                ]
            }),
            hasHelpUI && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                iconType: "help",
                buttonStyle: "icon",
                className: $25cadc621823a45b$export$f2c12b114d1afda,
                ariaLabel: "Send",
                onClick: onHelp,
                title: "Need a hint?"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f49c4968276f4170$export$2e2bcd8739ae039), {
                query: queryValue,
                onProfileSelected: onMentionSelected,
                visible: isTypingMention,
                currentKey: currentKey,
                onPickerClosed: closePicker,
                closePickerOnEmptyResult: true
            })
        ]
    });
}



var $6lYLL = parcelRequire("6lYLL");

var $cEIti = parcelRequire("cEIti");


var $2PPWI = parcelRequire("2PPWI");

var $4MZsN = parcelRequire("4MZsN");
var $034acfb721fb89bb$export$d4e5c6f67aaf419c;
var $034acfb721fb89bb$export$17fa98cb055e8fa7;
var $034acfb721fb89bb$export$a5833c2b43ca4340;
var $034acfb721fb89bb$export$47511f9a6581d1d6;
var $034acfb721fb89bb$export$dd1c05b92185401c;
var $034acfb721fb89bb$export$8b28cf6cd00fe080;
var $034acfb721fb89bb$export$186c650311ff0789;
var $034acfb721fb89bb$export$6746fe0d9c9fab54;
var $034acfb721fb89bb$export$2bcf359f0c20e94f;
var $034acfb721fb89bb$export$2903d10d531d0ac0;
$034acfb721fb89bb$export$d4e5c6f67aaf419c = `gdN3qq_FeedInputOverlay`;
$034acfb721fb89bb$export$17fa98cb055e8fa7 = `gdN3qq_fontSizeH1`;
$034acfb721fb89bb$export$a5833c2b43ca4340 = `gdN3qq_fontSizeH2`;
$034acfb721fb89bb$export$47511f9a6581d1d6 = `gdN3qq_fontSizeH3`;
$034acfb721fb89bb$export$dd1c05b92185401c = `gdN3qq_fontSizeH4`;
$034acfb721fb89bb$export$8b28cf6cd00fe080 = `gdN3qq_fontSizeH5`;
$034acfb721fb89bb$export$186c650311ff0789 = `gdN3qq_fontSizeH6`;
$034acfb721fb89bb$export$6746fe0d9c9fab54 = `gdN3qq_fontSizeSmall`;
$034acfb721fb89bb$export$2bcf359f0c20e94f = `gdN3qq_fontSizeTiny`;
$034acfb721fb89bb$export$2903d10d531d0ac0 = `gdN3qq_fontSizep`;


function $8bba5d05b9c0eec1$export$2e2bcd8739ae039({ message: message }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $034acfb721fb89bb$export$d4e5c6f67aaf419c,
        children: [
            message,
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                type: "padlock",
                size: 24
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
const $7b01d1532fef6caf$export$4936fa0c1c201528 = "{time}";
const $7b01d1532fef6caf$export$55a3c46850dc5b73 = "You have been frozen for {time}.";
const $7b01d1532fef6caf$export$375d0f3db2c1dfb3 = "a few moments";
const $7b01d1532fef6caf$export$312098c5853334bd = {
    short_ban: `You have been frozen. In {time} you'll be back in!`,
    permanent_ban: `You have been banned.`,
    rate_limit_exceeded: `You are sending too many messages. In {time} you'll be back in!`
};



function $1d07a211b3430507$export$2e2bcd8739ae039({ message: message, bannedUntil: bannedUntil }) {
    const [timeLeft, setTimeLeft] = (0, $8FY87.useState)(null);
    const untilTime = (0, $8FY87.useMemo)(()=>{
        return new Date(bannedUntil);
    }, [
        bannedUntil
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!bannedUntil) return;
        function update() {
            const timeDiff = untilTime.getTime() - Date.now();
            const secondsLeft = Math.max(Math.floor(timeDiff / 1000), 0);
            setTimeLeft(secondsLeft ? $1d07a211b3430507$var$secondsToString(secondsLeft) : null);
        }
        update();
        const interval = setInterval(update, 1000);
        return ()=>clearInterval(interval);
    });
    const timeString = timeLeft ?? (0, $7b01d1532fef6caf$export$375d0f3db2c1dfb3);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8bba5d05b9c0eec1$export$2e2bcd8739ae039), {
        message: message.replace((0, $7b01d1532fef6caf$export$4936fa0c1c201528), timeString)
    });
}
function $1d07a211b3430507$var$secondsToString(secondsLeft) {
    const hours = Math.floor(secondsLeft / 3600);
    const minutes = Math.floor(secondsLeft % 3600 / 60);
    const seconds = secondsLeft % 60;
    const pluralise = (text, number)=>number === 1 ? text : text + "s";
    const values = [];
    hours && values.push(`${hours} ${pluralise("hour", hours)}`);
    minutes && values.push(`${minutes} ${pluralise("minute", minutes)}`);
    seconds && values.push(`${seconds} ${pluralise("second", seconds)}`);
    return values.join(", ");
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");


var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $f9aoP = parcelRequire("f9aoP");
// TODO: use from env variable (set at build time?)
let $31fa90eb063711bb$var$API_HOST = "https://api-partner.skybound-online.com/online/api/v1";
let $31fa90eb063711bb$var$token = localStorage.getItem("ARISE_INSIDERS_TOKEN") || "";
function $31fa90eb063711bb$export$57e714f81a2c3d86(t) {
    $31fa90eb063711bb$var$token = t;
    localStorage.setItem("ARISE_INSIDERS_TOKEN", t);
}
function $31fa90eb063711bb$export$257b2d10b709d8ef() {
    return $31fa90eb063711bb$var$token;
}
async function $31fa90eb063711bb$var$call(path, method, body) {
    let response = await fetch(`${$31fa90eb063711bb$var$API_HOST}${path}`, {
        method: method,
        body: body ? JSON.stringify(body) : undefined,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${$31fa90eb063711bb$var$token}`
        }
    });
    if (!response.ok) throw new Error(response.statusText);
    return await response.json();
}
async function $31fa90eb063711bb$export$3e32638432616b6() {
    try {
        const res = await $31fa90eb063711bb$var$call("/users/info", "GET");
        return res;
    } catch (error) {
        throw error;
    }
}


class $8f53da7c0f8a4a82$export$ddf66c513cd0060c extends EventTarget {
    constructor(iFrameElement, allowedOrigins, arisewareProjectId){
        super();
        this.internalEvents = [
            "inventory_list_request",
            "inventory_takeItem_request",
            "inventory_dropItem_request",
            "ariseware_state_request",
            "ariseware_state_update_request",
            "profile_setTitle_request",
            "insiders_token_request",
            "instance_data_request",
            "supply_run_host_request",
            "poll_data_request",
            "poll_vote_request"
        ];
        this.iframeRef = iFrameElement;
        this.allowedOrigins = allowedOrigins || [
            "*"
        ];
        this.arisewareProjectId = arisewareProjectId;
        this.initialiseEvents();
        console.log("AriseBridgeHost created");
    }
    setArisewareProjectId(id) {
        this.arisewareProjectId = id;
    }
    initialiseEvents() {
        window.addEventListener("message", this.handleReceivedMessage.bind(this));
    }
    handleReceivedMessage(event) {
        if (this.allowedOrigins[0] !== "*" && this.allowedOrigins.indexOf(event.origin) === -1) {
            console.error("[Host] received message from unknown origin", event, this.allowedOrigins);
            return;
        }
        const data = event.data;
        if (this.internalEvents.indexOf(data.type) !== -1) {
            this.handleInternalEvent(data);
            return;
        }
        this.dispatchEvent(// TODO: proper types
        new CustomEvent(data.type, {
            detail: data.payload
        }));
    }
    // TODO: proper types
    sendEvent(event, payload) {
        this.iframeRef.current.contentWindow.postMessage({
            type: event,
            payload: payload
        }, "*");
    }
    on(event, callback) {
        this.addEventListener(event, callback);
        return ()=>{
            this.removeEventListener(event, callback);
        };
    }
    off(event, callback) {
        this.removeEventListener(event, callback);
    }
    async handleInternalEvent(data) {
        try {
            const result = await this.internalEventSwitch(data);
            let payload = null;
            let event = null;
            if (result) {
                [event, payload] = result;
                this.sendEvent(event, payload);
            }
            this.dispatchEvent(new CustomEvent(data.type + "__success", {
                detail: {
                    requestData: data.payload,
                    responseData: payload
                }
            }));
        } catch (error) {
            this.dispatchEvent(new CustomEvent(data.type + "__error", {
                detail: {
                    requestData: data.payload
                }
            }));
            console.error(error);
        }
    }
    async internalEventSwitch(data) {
        let res;
        switch(data.type){
            case "inventory_list_request":
                res = await $f9aoP.getInventory();
                return [
                    "inventory_list_response",
                    res
                ];
            case "inventory_takeItem_request":
                res = await $f9aoP.takeItem(data.payload);
                return [
                    "inventory_takeItem_response",
                    res
                ];
            case "inventory_dropItem_request":
                res = await $f9aoP.dropItem(data.payload);
                return [
                    "inventory_dropItem_response",
                    res
                ];
            case "ariseware_state_request":
                if (!this.arisewareProjectId) {
                    console.error("No arisewareProjectId set");
                    return;
                }
                res = await $f9aoP.getArisewareState(this.arisewareProjectId);
                return [
                    "ariseware_state_response",
                    res
                ];
            case "ariseware_state_update_request":
                if (!this.arisewareProjectId) {
                    console.error("No arisewareProjectId set");
                    return;
                }
                res = await $f9aoP.updateArisewareState(this.arisewareProjectId, {
                    state: data.payload
                });
                return [
                    "ariseware_state_update_response",
                    res
                ];
            case "profile_setTitle_request":
                // Legacy
                const titleId = data?.payload?.id;
                res = await $f9aoP.addProfileTitle(titleId);
                return [
                    "profile_setTitle_response",
                    res
                ];
            case "insiders_token_request":
                res = $31fa90eb063711bb$export$257b2d10b709d8ef();
                return [
                    "insiders_token_response",
                    res
                ];
            case "instance_data_request":
                res = await $f9aoP.getInstanceData();
                return [
                    "instance_data_response",
                    res
                ];
            case "supply_run_host_request":
                const supplyRunHost = undefined;
                return [
                    "supply_run_host_response",
                    supplyRunHost
                ];
            case "poll_data_request":
                {
                    const { id: id, numberOfResults: numberOfResults } = data?.payload ?? {};
                    res = await $f9aoP.getPollData(id, numberOfResults);
                    return [
                        "poll_data_response",
                        res
                    ];
                }
            case "poll_vote_request":
                {
                    const { id: id, selectedOptionIds: selectedOptionIds, numberOfResults: numberOfResults } = data?.payload ?? {};
                    res = await $f9aoP.submitPollVote(id, selectedOptionIds, numberOfResults);
                    return [
                        "poll_data_response",
                        res
                    ];
                }
            default:
                console.error("Unknown internal event", data);
                return;
        }
    }
}


class $c52ffa28168ccea6$export$d5347260c4eca75c extends EventTarget {
    static{
        this.eventListeners = [];
    }
    constructor(ref, allowedOrigins, setArisewareProjectId){
        super();
        this.bridge = new (0, $8f53da7c0f8a4a82$export$ddf66c513cd0060c)(ref, allowedOrigins, setArisewareProjectId);
    }
    static initialise(ref, allowedOrigins, setArisewareProjectId) {
        if (!$c52ffa28168ccea6$export$d5347260c4eca75c.instance) {
            $c52ffa28168ccea6$export$d5347260c4eca75c.instance = new $c52ffa28168ccea6$export$d5347260c4eca75c(ref, allowedOrigins, setArisewareProjectId);
            this.applyEventListeners();
        } else {
            $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.iframeRef = ref;
            $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.setArisewareProjectId(setArisewareProjectId);
        }
        return $c52ffa28168ccea6$export$d5347260c4eca75c.instance;
    }
    static getInstance() {
        return $c52ffa28168ccea6$export$d5347260c4eca75c.instance;
    }
    getBridge() {
        return this.bridge;
    }
    static sendEvent(event, payload) {
        if ($c52ffa28168ccea6$export$d5347260c4eca75c.instance) $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.sendEvent(event, payload);
        else console.error("AriseBridgeService not initialised. Is there an iframe?");
    }
    static on(event, callback) {
        this.eventListeners.push({
            event: event,
            callback: callback
        });
        if ($c52ffa28168ccea6$export$d5347260c4eca75c.instance) $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.on(event, callback);
        // Return a function to remove the event listener
        return ()=>{
            const index = this.eventListeners.findIndex((listener)=>listener.event === event && listener.callback === callback);
            if (index > -1) this.eventListeners.splice(index, 1);
            if ($c52ffa28168ccea6$export$d5347260c4eca75c.instance) $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.removeEventListener(event, callback);
        };
    }
    static applyEventListeners() {
        if ($c52ffa28168ccea6$export$d5347260c4eca75c.instance) this.eventListeners.forEach((listener)=>{
            $c52ffa28168ccea6$export$d5347260c4eca75c.instance.bridge.on(listener.event, listener.callback);
        });
    }
}



var $f22cad1a43fe450a$export$c33819396b368a7;
var $f22cad1a43fe450a$export$664c6d24e3175067;
$f22cad1a43fe450a$export$c33819396b368a7 = `P1ilkG_FailedInputOverlay`;
$f22cad1a43fe450a$export$664c6d24e3175067 = `P1ilkG_visible`;



var $aTRs6 = parcelRequire("aTRs6");

var $6lYLL = parcelRequire("6lYLL");

var $1bTT8 = parcelRequire("1bTT8");

var $8FY87 = parcelRequire("8FY87");
function $63dd9757c13a1072$export$2e2bcd8739ae039() {
    const failedAt = (0, $6lYLL.useAppSelector)((state)=>state.app.failedAt);
    // const hasFailed = useMemo(() => Date.now() - failedAt < FAILURE_TIMEOUT_SECONDS * 1000, [failedAt]);
    return {
        hasFailed: !!failedAt,
        failedAt: failedAt
    };
}
function $63dd9757c13a1072$export$b11b2dccbc2926bc() {
    const { hasFailed: hasFailed, failedAt: failedAt } = $63dd9757c13a1072$export$2e2bcd8739ae039();
    const [secondsLeft, setSecondsLeft] = (0, $8FY87.useState)(0);
    const [canReattempt, setCanReattempt] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        function calcAndSetSecondsLeft() {
            const seconds = Math.ceil((0, $1bTT8.millisecondsLeftFromTimeAndDuration)(failedAt, (0, $aTRs6.FAILURE_TIMEOUT_SECONDS)) / 1000);
            setSecondsLeft(seconds);
            if (seconds <= 0) setCanReattempt(true);
            else setCanReattempt(false);
        }
        calcAndSetSecondsLeft();
        if (hasFailed) {
            const interval = setInterval(()=>{
                calcAndSetSecondsLeft();
            }, 1000);
            return ()=>clearInterval(interval);
        }
    }, [
        hasFailed,
        failedAt
    ]);
    return {
        secondsLeft: secondsLeft,
        hasFailed: hasFailed,
        failedAt: failedAt,
        canReattempt: canReattempt
    };
}


function $dd58069b9f89d3cc$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const { hasFailed: hasFailed, canReattempt: canReattempt } = (0, $63dd9757c13a1072$export$b11b2dccbc2926bc)();
    const isVisible = hasFailed && canReattempt;
    function onClick() {
        (0, $c52ffa28168ccea6$export$d5347260c4eca75c).sendEvent("reattempt", {});
        dispatch((0, $baXkz.clearFailed)());
        audio.play("slam");
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($f22cad1a43fe450a$export$c33819396b368a7, {
            [$f22cad1a43fe450a$export$664c6d24e3175067]: isVisible
        }),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
            onClick: onClick,
            disabled: !isVisible,
            children: "Reattempt"
        })
    });
}




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
parcelRequire("4AlPA");
var $gzuKA = parcelRequire("gzuKA");

var $2PPWI = parcelRequire("2PPWI");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
var $0131fac33b41dfee$export$423c13fd52bec8ad;
var $0131fac33b41dfee$export$97b9ccd15d05bf44;
var $0131fac33b41dfee$export$fe9de328bbcc3733;
var $0131fac33b41dfee$export$345c5736c8054f22;
var $0131fac33b41dfee$export$17fa98cb055e8fa7;
var $0131fac33b41dfee$export$a5833c2b43ca4340;
var $0131fac33b41dfee$export$47511f9a6581d1d6;
var $0131fac33b41dfee$export$dd1c05b92185401c;
var $0131fac33b41dfee$export$8b28cf6cd00fe080;
var $0131fac33b41dfee$export$186c650311ff0789;
var $0131fac33b41dfee$export$6746fe0d9c9fab54;
var $0131fac33b41dfee$export$2bcf359f0c20e94f;
var $0131fac33b41dfee$export$2903d10d531d0ac0;
var $0131fac33b41dfee$export$ba6acb6e4dfd83c2;
var $0131fac33b41dfee$export$889af0f292fa2d2;
var $0131fac33b41dfee$export$d1e98e88aabacc41;
var $0131fac33b41dfee$export$14c4c20f0909e255;
var $0131fac33b41dfee$export$db83999c14438df4;
var $0131fac33b41dfee$export$f34699e8deb52962;
var $0131fac33b41dfee$export$c43aefe7b0ad01ce;
var $0131fac33b41dfee$export$5a882f6732e0b10d;
var $0131fac33b41dfee$export$6748f514911c4e25;
var $0131fac33b41dfee$export$9df547fe976beafa;
var $0131fac33b41dfee$export$2b40abff47bc1711;
var $0131fac33b41dfee$export$664c6d24e3175067;
$0131fac33b41dfee$export$423c13fd52bec8ad = `mrKkkW_ChatMessage`;
$0131fac33b41dfee$export$97b9ccd15d05bf44 = `mrKkkW_LocationLink`;
$0131fac33b41dfee$export$fe9de328bbcc3733 = `mrKkkW_ModerationActions`;
$0131fac33b41dfee$export$345c5736c8054f22 = `mrKkkW_avatar`;
$0131fac33b41dfee$export$17fa98cb055e8fa7 = `mrKkkW_fontSizeH1`;
$0131fac33b41dfee$export$a5833c2b43ca4340 = `mrKkkW_fontSizeH2`;
$0131fac33b41dfee$export$47511f9a6581d1d6 = `mrKkkW_fontSizeH3`;
$0131fac33b41dfee$export$dd1c05b92185401c = `mrKkkW_fontSizeH4`;
$0131fac33b41dfee$export$8b28cf6cd00fe080 = `mrKkkW_fontSizeH5`;
$0131fac33b41dfee$export$186c650311ff0789 = `mrKkkW_fontSizeH6`;
$0131fac33b41dfee$export$6746fe0d9c9fab54 = `mrKkkW_fontSizeSmall`;
$0131fac33b41dfee$export$2bcf359f0c20e94f = `mrKkkW_fontSizeTiny`;
$0131fac33b41dfee$export$2903d10d531d0ac0 = `mrKkkW_fontSizep`;
$0131fac33b41dfee$export$ba6acb6e4dfd83c2 = `mrKkkW_highlighted`;
$0131fac33b41dfee$export$889af0f292fa2d2 = `mrKkkW_imagePlaceholder`;
$0131fac33b41dfee$export$d1e98e88aabacc41 = `mrKkkW_isGlobalChatMessage`;
$0131fac33b41dfee$export$14c4c20f0909e255 = `mrKkkW_isOffBottom`;
$0131fac33b41dfee$export$db83999c14438df4 = `mrKkkW_mention`;
$0131fac33b41dfee$export$f34699e8deb52962 = `mrKkkW_messagePlaceholder`;
$0131fac33b41dfee$export$c43aefe7b0ad01ce = `mrKkkW_messageText`;
$0131fac33b41dfee$export$5a882f6732e0b10d = `mrKkkW_modActionsOptions`;
$0131fac33b41dfee$export$6748f514911c4e25 = `mrKkkW_namePlaceholder`;
$0131fac33b41dfee$export$9df547fe976beafa = `mrKkkW_reactionsMenu`;
$0131fac33b41dfee$export$2b40abff47bc1711 = `mrKkkW_reactionsPlaceholder`;
$0131fac33b41dfee$export$664c6d24e3175067 = `mrKkkW_visible`;


function $35ae5f9f7769a23e$export$2e2bcd8739ae039({ message: message }) {
    const m = (0, $8FY87.useMemo)(()=>{
        const regex = /(<<user:[0-9a-fA-F-]{36}>>)/g;
        const parts = message.message.split(regex);
        return parts.map((part, index)=>{
            if (part.match(regex)) {
                const userId = part.match(/[0-9a-fA-F-]{36}/)?.[0];
                const profile = message.mentions?.find((profile)=>profile.userID === userId);
                if (profile) return /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                    className: $0131fac33b41dfee$export$db83999c14438df4,
                    children: [
                        "@",
                        profile.displayName
                    ]
                }, index);
                else {
                    console.warn("Could not find matching profile for mention:", part);
                    return part;
                }
            }
            return part;
        });
    }, [
        message
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: m
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");


var $f9aoP = parcelRequire("f9aoP");

var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");

var $1bTT8 = parcelRequire("1bTT8");
function $3a82298e3edaed1f$export$2e2bcd8739ae039({ messageId: messageId, userId: userId, userDisplayName: userDisplayName, userBannedUntil: userBannedUntil }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const moderationActionOpenOnMessageId = (0, $6lYLL.useAppSelector)((state)=>state.feed.moderationActionOpenOnMessageId);
    const modActionsRef = (0, $8FY87.useRef)(null);
    const isOpen = moderationActionOpenOnMessageId === messageId;
    const isBanned = userBannedUntil && (0, $1bTT8.msTimeDifferenceFromNow)(userBannedUntil) > 0;
    // Returns wether mod action options are obscured off the bottom of the feed
    // If so, reposition
    function isOffBottom() {
        const div = modActionsRef.current;
        const parent = document.querySelector(".vw-list-ref");
        if (!div || !parent) return false;
        return div.getBoundingClientRect().bottom > parent.getBoundingClientRect().bottom;
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $0131fac33b41dfee$export$fe9de328bbcc3733,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                onClick: ()=>{
                    if (isOpen) dispatch((0, $kyBxf.closeModerationAction)());
                    else dispatch((0, $kyBxf.openModerationAction)(messageId));
                },
                children: "..."
            }),
            isOpen && /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                ref: modActionsRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($0131fac33b41dfee$export$5a882f6732e0b10d, {
                    [$0131fac33b41dfee$export$14c4c20f0909e255]: isOffBottom()
                }),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: userDisplayName
                    }),
                    isBanned && /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                        style: {
                            backgroundColor: "red"
                        },
                        children: [
                            "Banned until ",
                            new Date(userBannedUntil).toString()
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)($3a82298e3edaed1f$export$f0c66bf51c8b67fd, {
                            label: "Remove Message",
                            onClick: async ()=>{
                                await $f9aoP.deleteMessage(messageId);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)($3a82298e3edaed1f$export$f0c66bf51c8b67fd, {
                            label: "Ban - 10 minutes",
                            onClick: async ()=>{
                                try {
                                    await $f9aoP.banUser(userId, 600, "short_ban");
                                } catch (error) {
                                    console.error("Error freezing user", error);
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)($3a82298e3edaed1f$export$f0c66bf51c8b67fd, {
                            label: "Ban - 1 year",
                            onClick: async ()=>{
                                try {
                                    await $f9aoP.banUser(userId, 31536000, "permanent_ban");
                                } catch (error) {
                                    console.error("Error banning user", error);
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
}
function $3a82298e3edaed1f$export$f0c66bf51c8b67fd({ label: label, onClick: onClick }) {
    const [active, setActive] = (0, $8FY87.useState)(false);
    async function handleClick() {
        setActive(true);
        await onClick();
        setActive(false);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        onClick: handleClick,
        disabled: active,
        children: active ? "..." : label
    });
}




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $6lYLL = parcelRequire("6lYLL");

var $4MZsN = parcelRequire("4MZsN");
var $d866a1b368a1a11b$export$89da14300d534261;
var $d866a1b368a1a11b$export$2e18ae7a5f2ffceb;
var $d866a1b368a1a11b$export$e8d7adc53dede025;
var $d866a1b368a1a11b$export$17fa98cb055e8fa7;
var $d866a1b368a1a11b$export$a5833c2b43ca4340;
var $d866a1b368a1a11b$export$47511f9a6581d1d6;
var $d866a1b368a1a11b$export$dd1c05b92185401c;
var $d866a1b368a1a11b$export$8b28cf6cd00fe080;
var $d866a1b368a1a11b$export$186c650311ff0789;
var $d866a1b368a1a11b$export$6746fe0d9c9fab54;
var $d866a1b368a1a11b$export$2bcf359f0c20e94f;
var $d866a1b368a1a11b$export$2903d10d531d0ac0;
var $d866a1b368a1a11b$export$ea0830439c7fc698;
var $d866a1b368a1a11b$export$f72c97a619496f59;
var $d866a1b368a1a11b$export$614c24fc7c92acba;
var $d866a1b368a1a11b$export$649f245ec8d4b64a;
var $d866a1b368a1a11b$export$57bf213be019eeb0;
var $d866a1b368a1a11b$export$53837bd21fbff976;
$d866a1b368a1a11b$export$89da14300d534261 = `FX5MUW_active`;
$d866a1b368a1a11b$export$2e18ae7a5f2ffceb = `FX5MUW_exisitingReaction`;
$d866a1b368a1a11b$export$e8d7adc53dede025 = `FX5MUW_existingReactions`;
$d866a1b368a1a11b$export$17fa98cb055e8fa7 = `FX5MUW_fontSizeH1`;
$d866a1b368a1a11b$export$a5833c2b43ca4340 = `FX5MUW_fontSizeH2`;
$d866a1b368a1a11b$export$47511f9a6581d1d6 = `FX5MUW_fontSizeH3`;
$d866a1b368a1a11b$export$dd1c05b92185401c = `FX5MUW_fontSizeH4`;
$d866a1b368a1a11b$export$8b28cf6cd00fe080 = `FX5MUW_fontSizeH5`;
$d866a1b368a1a11b$export$186c650311ff0789 = `FX5MUW_fontSizeH6`;
$d866a1b368a1a11b$export$6746fe0d9c9fab54 = `FX5MUW_fontSizeSmall`;
$d866a1b368a1a11b$export$2bcf359f0c20e94f = `FX5MUW_fontSizeTiny`;
$d866a1b368a1a11b$export$2903d10d531d0ac0 = `FX5MUW_fontSizep`;
$d866a1b368a1a11b$export$ea0830439c7fc698 = `FX5MUW_isOpen`;
$d866a1b368a1a11b$export$f72c97a619496f59 = `FX5MUW_reactionMenu`;
$d866a1b368a1a11b$export$614c24fc7c92acba = `FX5MUW_reactionMenuButton`;
$d866a1b368a1a11b$export$649f245ec8d4b64a = `FX5MUW_reactionMenuContainer`;
$d866a1b368a1a11b$export$57bf213be019eeb0 = `FX5MUW_show`;
$d866a1b368a1a11b$export$53837bd21fbff976 = `FX5MUW_showButton`;


// To support reactions on older messages
const $5804d2a112dd3e9c$var$LEGACY_REACTIONS = {
    like: {
        type: "like",
        imageUrl: "/assets/global/images/reactions/legacy/like.webp",
        title: "smiling"
    },
    thumbsup: {
        type: "thumbsup",
        imageUrl: "/assets/global/images/reactions/legacy/thumbsup.webp",
        title: "thumbs up"
    },
    joy: {
        type: "joy",
        imageUrl: "/assets/global/images/reactions/legacy/joy.webp",
        title: "joy"
    },
    fire: {
        type: "fire",
        imageUrl: "/assets/global/images/reactions/legacy/fire.webp",
        title: "fire"
    },
    sob: {
        type: "sob",
        imageUrl: "/assets/global/images/reactions/legacy/sob.webp",
        title: "sob"
    },
    scream: {
        type: "scream",
        imageUrl: "/assets/global/images/reactions/legacy/scream.webp",
        title: "scream"
    }
};
function $5804d2a112dd3e9c$var$getReactedByAsString(reactedBy, currentUserID) {
    if (reactedBy?.length) {
        const moveCurrentUserToStart = ()=>{
            const reorderedReactedBy = [
                ...reactedBy
            ];
            const index = reorderedReactedBy.findIndex((user)=>user.userID === currentUserID);
            if (index !== -1) {
                const [currentUser] = reorderedReactedBy.splice(index, 1);
                const renamedUser = {
                    ...currentUser,
                    displayName: "You"
                };
                return [
                    renamedUser,
                    ...reorderedReactedBy
                ];
            }
            return reorderedReactedBy;
        };
        const reactedByWithCurrentUserAtStart = moveCurrentUserToStart();
        const names = reactedByWithCurrentUserAtStart.map((user)=>user.displayName);
        if (names.length === 1) return `${names[0]} reacted`;
        if (names.length === 2) return `${names[0]} and ${names[1]} reacted`;
        if (names.length === 3) return `${names[0]}, ${names[1]} and ${names[2]} reacted`;
        if (names.length === 4) return `${names[0]}, ${names[1]}, ${names[2]} and ${names[3]} reacted`;
        if (names.length > 4) return `${names[0]}, ${names[1]}, ${names[2]} and ${names.length - 3} more reacted`;
    }
    return "";
}
function $5804d2a112dd3e9c$export$2e2bcd8739ae039(props) {
    const { reactionControls: reactionControls, existingReactions: existingReactions } = $5804d2a112dd3e9c$export$c65f3d3f4d784f6a(props);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            reactionControls,
            existingReactions
        ]
    });
}
function $5804d2a112dd3e9c$export$c65f3d3f4d784f6a({ reactions: reactions, onSubmitReaction: onSubmitReaction, controlsClassName: controlsClassName, disabled: disabled, currentUserId: currentUserId, existingReactionsClassName: existingReactionsClassName }) {
    const feed = (0, $6lYLL.useAppSelector)((state)=>state.feed);
    const [reactionMenuIsOpen, setReactionMenuIsOpen] = (0, $8FY87.useState)(false);
    const reactionsWithLegacy = {
        ...$5804d2a112dd3e9c$var$LEGACY_REACTIONS,
        ...feed.availableReactions
    };
    const orderedReactions = (0, $8FY87.useMemo)(()=>{
        const result = [];
        if (!reactions) return result;
        for(const reactionKey in reactionsWithLegacy){
            const matchingReaction = reactions?.find((reaction)=>reaction.type === reactionKey);
            if (matchingReaction) result.push(matchingReaction);
        }
        return result;
    }, [
        reactions
    ]);
    const userReactions = (0, $8FY87.useMemo)(()=>{
        return orderedReactions.filter((reaction)=>reaction.reactedBy?.some((user)=>user.userID === currentUserId)) || [];
    }, [
        orderedReactions
    ]);
    (0, $8FY87.useEffect)(()=>{
        const closeReactionMenu = ()=>{
            setReactionMenuIsOpen(false);
        };
        if (reactionMenuIsOpen) {
            document.addEventListener("mouseup", closeReactionMenu);
            document.addEventListener("touchend", closeReactionMenu);
        }
        return ()=>{
            document.removeEventListener("mouseup", closeReactionMenu);
            document.removeEventListener("touchend", closeReactionMenu);
        };
    }, [
        reactionMenuIsOpen
    ]);
    if (!Object.keys(reactionsWithLegacy).length) return null;
    const numberOfReactions = Object.keys(feed.availableReactions).length;
    const getReactionMenuWidth = ()=>{
        // Values must match CSS
        const reactionButtonWidth = 26;
        const reactionMenuMargin = 12;
        return numberOfReactions * reactionButtonWidth + reactionMenuMargin;
    };
    const reactionControls = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: !!numberOfReactions && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            inert: disabled ? "" : undefined,
            style: {
                pointerEvents: disabled ? "none" : "auto"
            },
            children: /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$53837bd21fbff976, controlsClassName, {
                            [$d866a1b368a1a11b$export$ea0830439c7fc698]: reactionMenuIsOpen
                        }),
                        onClick: ()=>setReactionMenuIsOpen(!reactionMenuIsOpen),
                        style: {
                            display: disabled ? "none" : "inline-block"
                        },
                        disabled: disabled,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                type: "emoji",
                                size: 15
                            }),
                            " ",
                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                children: "+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$649f245ec8d4b64a, controlsClassName),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$f72c97a619496f59, {
                                [$d866a1b368a1a11b$export$57bf213be019eeb0]: reactionMenuIsOpen
                            }),
                            style: {
                                maxWidth: reactionMenuIsOpen ? getReactionMenuWidth() : 0
                            },
                            children: Object.keys(feed.availableReactions).map((reactionType)=>{
                                const { imageUrl: imageUrl, title: title } = feed.availableReactions[reactionType];
                                return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                    disabled: disabled,
                                    tabIndex: reactionMenuIsOpen ? 0 : -1,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$614c24fc7c92acba, {
                                        [$d866a1b368a1a11b$export$89da14300d534261]: userReactions.some((userReaction)=>userReaction.type === reactionType)
                                    }),
                                    onClick: ()=>{
                                        setReactionMenuIsOpen(false);
                                        onSubmitReaction?.(reactionType);
                                    },
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                            src: imageUrl,
                                            alt: title
                                        })
                                    })
                                }, reactionType);
                            })
                        })
                    })
                ]
            })
        })
    });
    const existingReactions = /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: !!orderedReactions?.length && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$e8d7adc53dede025, existingReactionsClassName),
            inert: disabled ? "" : undefined,
            style: {
                pointerEvents: disabled ? "none" : "auto"
            },
            children: orderedReactions?.map((reaction)=>{
                const { imageUrl: imageUrl, title: title } = reactionsWithLegacy[reaction.type];
                if (reaction.count <= 0) return null;
                return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                    title: $5804d2a112dd3e9c$var$getReactedByAsString(reaction.reactedBy, currentUserId),
                    disabled: disabled,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($d866a1b368a1a11b$export$2e18ae7a5f2ffceb, {
                        [$d866a1b368a1a11b$export$89da14300d534261]: userReactions.some((userReaction)=>userReaction.type === reaction.type)
                    }),
                    onClick: ()=>onSubmitReaction?.(reaction.type),
                    children: [
                        reaction.count,
                        " ",
                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                            src: imageUrl,
                            alt: title
                        })
                    ]
                }, reaction.type);
            })
        })
    });
    return {
        reactionControls: reactionControls,
        existingReactions: existingReactions
    };
}



var $2PPWI = parcelRequire("2PPWI");

function $149ba5708415d2a0$export$2e2bcd8739ae039({ children: children }) {
    const user = (0, $dbacf51e5486f7e0$export$23bbbc4533528f03)();
    if (!user || !user.role || user.role !== "superadmin") return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: children
    });
}




var $2PPWI = parcelRequire("2PPWI");


var $6lYLL = parcelRequire("6lYLL");

var $i7H0N = parcelRequire("i7H0N");

function $e3ccb4c7796cb7dc$export$2e2bcd8739ae039({ locationId: locationId, style: style }) {
    const locations = (0, $6lYLL.useAppSelector)((state)=>state.app.locations);
    const currentLocationId = (0, $6lYLL.useAppSelector)((state)=>state.app.location?.id);
    const roomId = (0, $6lYLL.useAppSelector)((state)=>state.feed.roomId);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    if (locationId !== roomId) {
        const itemLocation = locations[locationId];
        if (itemLocation) return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            style: style,
            className: $0131fac33b41dfee$export$97b9ccd15d05bf44,
            onClick: ()=>{
                (0, $i7H0N.sendEvent)("global_chat_link_click", {
                    destination: itemLocation.id,
                    from: currentLocationId
                });
                navigate(`/location/${itemLocation.id}`);
            },
            title: `Go to ${itemLocation.name} to join this chat!`,
            children: [
                "#",
                itemLocation.name
            ]
        });
    }
    return null;
}



var $kyBxf = parcelRequire("kyBxf");

var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");

var $i7H0N = parcelRequire("i7H0N");


function $8fb01081114880dc$export$2e2bcd8739ae039({ message: message }) {
    const roomId = (0, $6lYLL.useAppSelector)((state)=>state.feed.roomId);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const profile = message.profile;
    const isGlobalChatMessage = message.environmentID !== roomId;
    function handleReactionSubmit(reaction) {
        dispatch((0, $kyBxf.toggleMessageReaction)([
            message.id,
            reaction,
            message.environmentID
        ]));
        (0, $i7H0N.sendEvent)("toggle_reaction", {
            reaction: reaction
        });
    }
    const humanTimestamp = (0, $8FY87.useMemo)(()=>{
        const date = new Date(message.timestamp * 1000);
        return date.toLocaleString();
    }, [
        message.timestamp
    ]);
    const isVisible = !!profile;
    const containsMentionForCurrentUser = message.mentions?.some((profile)=>profile.userID === currentUserProfile?.userID);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))("text-[14px] relative", $0131fac33b41dfee$export$423c13fd52bec8ad, {
                [$0131fac33b41dfee$export$664c6d24e3175067]: isVisible,
                [$0131fac33b41dfee$export$ba6acb6e4dfd83c2]: containsMentionForCurrentUser,
                [$0131fac33b41dfee$export$d1e98e88aabacc41]: isGlobalChatMessage
            }),
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                    classname: $0131fac33b41dfee$export$345c5736c8054f22,
                    backgroundImagePath: profile.background?.thumbnailPath,
                    characterImagePath: profile.character?.thumbnailPath,
                    frameImagePath: profile.avatarFrame?.imagePath,
                    onClick: ()=>dispatch((0, $baXkz.openProfile)(profile)),
                    title: `View ${profile.displayName}'s Profile`
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $13dab9088986de0c$export$2e2bcd8739ae039), {
                            profile: profile,
                            shouldLinkToProfile: true
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            title: humanTimestamp,
                            className: $0131fac33b41dfee$export$c43aefe7b0ad01ce,
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $35ae5f9f7769a23e$export$2e2bcd8739ae039), {
                                message: message
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3ccb4c7796cb7dc$export$2e2bcd8739ae039), {
                            locationId: message.environmentID
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5804d2a112dd3e9c$export$2e2bcd8739ae039), {
                                reactions: message.reactions,
                                onSubmitReaction: handleReactionSubmit,
                                controlsClassName: $0131fac33b41dfee$export$9df547fe976beafa,
                                disabled: currentUserProfile?.isBanned || isGuest,
                                currentUserId: currentUserProfile?.userID
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $149ba5708415d2a0$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3a82298e3edaed1f$export$2e2bcd8739ae039), {
                        messageId: message.id,
                        userId: message.senderId,
                        userDisplayName: profile?.displayName,
                        userBannedUntil: profile?.bannedUntil
                    })
                })
            ]
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");


var $i7H0N = parcelRequire("i7H0N");

var $466187d255fab208$exports = {};

$parcel$export($466187d255fab208$exports, "EventSummaryMessage", function () { return $466187d255fab208$export$7a487ba31006dc0f; }, function (v) { return $466187d255fab208$export$7a487ba31006dc0f = v; });
$parcel$export($466187d255fab208$exports, "bold", function () { return $466187d255fab208$export$73ba5813cda80a49; }, function (v) { return $466187d255fab208$export$73ba5813cda80a49 = v; });
$parcel$export($466187d255fab208$exports, "container", function () { return $466187d255fab208$export$34e0f9847d4c02dd; }, function (v) { return $466187d255fab208$export$34e0f9847d4c02dd = v; });
$parcel$export($466187d255fab208$exports, "content", function () { return $466187d255fab208$export$a7db06668cad9adb; }, function (v) { return $466187d255fab208$export$a7db06668cad9adb = v; });
$parcel$export($466187d255fab208$exports, "contentCenter", function () { return $466187d255fab208$export$48e3e3ea9222a96c; }, function (v) { return $466187d255fab208$export$48e3e3ea9222a96c = v; });
$parcel$export($466187d255fab208$exports, "existingReactions", function () { return $466187d255fab208$export$e8d7adc53dede025; }, function (v) { return $466187d255fab208$export$e8d7adc53dede025 = v; });
$parcel$export($466187d255fab208$exports, "failed", function () { return $466187d255fab208$export$7ab64d539530aa6c; }, function (v) { return $466187d255fab208$export$7ab64d539530aa6c = v; });
$parcel$export($466187d255fab208$exports, "failedHighlight", function () { return $466187d255fab208$export$1eb9693e1fb34fe1; }, function (v) { return $466187d255fab208$export$1eb9693e1fb34fe1 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH1", function () { return $466187d255fab208$export$17fa98cb055e8fa7; }, function (v) { return $466187d255fab208$export$17fa98cb055e8fa7 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH2", function () { return $466187d255fab208$export$a5833c2b43ca4340; }, function (v) { return $466187d255fab208$export$a5833c2b43ca4340 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH3", function () { return $466187d255fab208$export$47511f9a6581d1d6; }, function (v) { return $466187d255fab208$export$47511f9a6581d1d6 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH4", function () { return $466187d255fab208$export$dd1c05b92185401c; }, function (v) { return $466187d255fab208$export$dd1c05b92185401c = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH5", function () { return $466187d255fab208$export$8b28cf6cd00fe080; }, function (v) { return $466187d255fab208$export$8b28cf6cd00fe080 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeH6", function () { return $466187d255fab208$export$186c650311ff0789; }, function (v) { return $466187d255fab208$export$186c650311ff0789 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeSmall", function () { return $466187d255fab208$export$6746fe0d9c9fab54; }, function (v) { return $466187d255fab208$export$6746fe0d9c9fab54 = v; });
$parcel$export($466187d255fab208$exports, "fontSizeTiny", function () { return $466187d255fab208$export$2bcf359f0c20e94f; }, function (v) { return $466187d255fab208$export$2bcf359f0c20e94f = v; });
$parcel$export($466187d255fab208$exports, "fontSizep", function () { return $466187d255fab208$export$2903d10d531d0ac0; }, function (v) { return $466187d255fab208$export$2903d10d531d0ac0 = v; });
$parcel$export($466187d255fab208$exports, "heading", function () { return $466187d255fab208$export$46e4a324ac90507f; }, function (v) { return $466187d255fab208$export$46e4a324ac90507f = v; });
$parcel$export($466187d255fab208$exports, "image", function () { return $466187d255fab208$export$5c452ff88e35e47d; }, function (v) { return $466187d255fab208$export$5c452ff88e35e47d = v; });
$parcel$export($466187d255fab208$exports, "reactionsMenu", function () { return $466187d255fab208$export$9df547fe976beafa; }, function (v) { return $466187d255fab208$export$9df547fe976beafa = v; });
$parcel$export($466187d255fab208$exports, "success", function () { return $466187d255fab208$export$fe7c49d056ea1d88; }, function (v) { return $466187d255fab208$export$fe7c49d056ea1d88 = v; });
$parcel$export($466187d255fab208$exports, "successHighlight", function () { return $466187d255fab208$export$330e3ebce89b219f; }, function (v) { return $466187d255fab208$export$330e3ebce89b219f = v; });
$parcel$export($466187d255fab208$exports, "text", function () { return $466187d255fab208$export$6f093cfa640b7166; }, function (v) { return $466187d255fab208$export$6f093cfa640b7166 = v; });
var $466187d255fab208$export$7a487ba31006dc0f;
var $466187d255fab208$export$73ba5813cda80a49;
var $466187d255fab208$export$34e0f9847d4c02dd;
var $466187d255fab208$export$a7db06668cad9adb;
var $466187d255fab208$export$48e3e3ea9222a96c;
var $466187d255fab208$export$e8d7adc53dede025;
var $466187d255fab208$export$7ab64d539530aa6c;
var $466187d255fab208$export$1eb9693e1fb34fe1;
var $466187d255fab208$export$17fa98cb055e8fa7;
var $466187d255fab208$export$a5833c2b43ca4340;
var $466187d255fab208$export$47511f9a6581d1d6;
var $466187d255fab208$export$dd1c05b92185401c;
var $466187d255fab208$export$8b28cf6cd00fe080;
var $466187d255fab208$export$186c650311ff0789;
var $466187d255fab208$export$6746fe0d9c9fab54;
var $466187d255fab208$export$2bcf359f0c20e94f;
var $466187d255fab208$export$2903d10d531d0ac0;
var $466187d255fab208$export$46e4a324ac90507f;
var $466187d255fab208$export$5c452ff88e35e47d;
var $466187d255fab208$export$9df547fe976beafa;
var $466187d255fab208$export$fe7c49d056ea1d88;
var $466187d255fab208$export$330e3ebce89b219f;
var $466187d255fab208$export$6f093cfa640b7166;
$466187d255fab208$export$7a487ba31006dc0f = `eV16Sq_EventSummaryMessage`;
$466187d255fab208$export$73ba5813cda80a49 = `eV16Sq_bold`;
$466187d255fab208$export$34e0f9847d4c02dd = `eV16Sq_container`;
$466187d255fab208$export$a7db06668cad9adb = `eV16Sq_content`;
$466187d255fab208$export$48e3e3ea9222a96c = `eV16Sq_contentCenter`;
$466187d255fab208$export$e8d7adc53dede025 = `eV16Sq_existingReactions`;
$466187d255fab208$export$7ab64d539530aa6c = `eV16Sq_failed`;
$466187d255fab208$export$1eb9693e1fb34fe1 = `eV16Sq_failedHighlight`;
$466187d255fab208$export$17fa98cb055e8fa7 = `eV16Sq_fontSizeH1`;
$466187d255fab208$export$a5833c2b43ca4340 = `eV16Sq_fontSizeH2`;
$466187d255fab208$export$47511f9a6581d1d6 = `eV16Sq_fontSizeH3`;
$466187d255fab208$export$dd1c05b92185401c = `eV16Sq_fontSizeH4`;
$466187d255fab208$export$8b28cf6cd00fe080 = `eV16Sq_fontSizeH5`;
$466187d255fab208$export$186c650311ff0789 = `eV16Sq_fontSizeH6`;
$466187d255fab208$export$6746fe0d9c9fab54 = `eV16Sq_fontSizeSmall`;
$466187d255fab208$export$2bcf359f0c20e94f = `eV16Sq_fontSizeTiny`;
$466187d255fab208$export$2903d10d531d0ac0 = `eV16Sq_fontSizep`;
$466187d255fab208$export$46e4a324ac90507f = `eV16Sq_heading`;
$466187d255fab208$export$5c452ff88e35e47d = `eV16Sq_image`;
$466187d255fab208$export$9df547fe976beafa = `eV16Sq_reactionsMenu`;
$466187d255fab208$export$fe7c49d056ea1d88 = `eV16Sq_success`;
$466187d255fab208$export$330e3ebce89b219f = `eV16Sq_successHighlight`;
$466187d255fab208$export$6f093cfa640b7166 = `eV16Sq_text`;


function $0776941ff61af1cf$var$getUserPosition(successfulParticipants, currentUserParticipantData) {
    let completionTimes = successfulParticipants.map((participant)=>({
            id: participant.profile.userID,
            completionTime: new Date(participant.eventData.completionTime).getTime()
        }));
    // Sort participants based on completion time (earliest first)
    completionTimes.sort((a, b)=>a.completionTime - b.completionTime);
    // Find the position of the current user
    let position = completionTimes.findIndex((user)=>user.id === currentUserParticipantData.profile.userID) + 1;
    return position;
}
function $0776941ff61af1cf$var$getMostSuccessfulFaction(successfulParticipants) {
    const factionTimes = {};
    const factionCounts = {};
    // Collect completion times and count successes for each faction
    successfulParticipants.forEach((participant)=>{
        const factionName = participant.profile.faction.name;
        if (factionName) {
            const completionDate = new Date(participant.eventData.completionTime).getTime();
            if (!factionTimes[factionName]) factionTimes[factionName] = [];
            factionTimes[factionName].push(completionDate);
            if (!factionCounts[factionName]) factionCounts[factionName] = 0;
            factionCounts[factionName]++;
        }
    });
    // Find the maximum count of successful completions
    const maxCount = Math.max(...Object.values(factionCounts));
    // Find factions with the maximum count of successful completions
    const topFactions = Object.entries(factionCounts).filter(([faction, count])=>count === maxCount).map(([faction])=>faction);
    // If there's only one top faction, return it
    if (topFactions.length === 1) return topFactions[0];
    // Calculate average completion time for factions with the maximum count
    const factionAvgTimes = {};
    topFactions.forEach((faction)=>{
        const times = factionTimes[faction];
        const totalCompletionTime = times.reduce((total, time)=>total + time, 0);
        const avgCompletionTime = totalCompletionTime / times.length;
        factionAvgTimes[faction] = avgCompletionTime;
    });
    // Find the faction with the quickest average completion time
    let topFaction = topFactions[0];
    let bestAvgTime = factionAvgTimes[topFaction];
    topFactions.forEach((faction)=>{
        if (factionAvgTimes[faction] < bestAvgTime) {
            topFaction = faction;
            bestAvgTime = factionAvgTimes[faction];
        }
    });
    return topFaction;
}
function $0776941ff61af1cf$var$EventSummary({ participants: participants, reactions: reactions, handleReactionSubmit: handleReactionSubmit }) {
    const theme = (0, $cEIti.useTheme)();
    const customData = theme.customJSON.typeChallenge;
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const currentUserParticipantData = participants.find((participant)=>participant.profile.userID === currentUserProfile?.userID);
    const successfulParticipants = participants.filter((participant)=>participant.eventData.success);
    const failedParticipants = participants.filter((participant)=>!participant.eventData.success);
    const mostSuccessfulFaction = (0, $8FY87.useMemo)(()=>$0776941ff61af1cf$var$getMostSuccessfulFaction(successfulParticipants), [
        participants
    ]);
    const [userParticipated, userPosition] = (0, $8FY87.useMemo)(()=>{
        if (currentUserParticipantData?.eventData.success === true) return [
            true,
            (0, $aed6ee8c7b23660f$export$9173b52dfbd534b4)($0776941ff61af1cf$var$getUserPosition(successfulParticipants, currentUserParticipantData))
        ];
        else return [
            false,
            0
        ];
    }, [
        participants,
        currentUserParticipantData
    ]);
    const getHeading = ()=>{
        const text = customData?.text;
        if (!participants.length) return "Event ended";
        if (currentUserParticipantData?.eventData.success === true) return text?.successMessage ?? "Success!";
        if (currentUserParticipantData?.eventData.success === false) return text?.failMessage ?? "You failed!";
        return "Event Summary";
    };
    const getUserPlaced = ()=>{
        if (userParticipated) return /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
            className: $466187d255fab208$exports.bold,
            children: [
                "You placed ",
                /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                    className: $466187d255fab208$exports.successHighlight,
                    children: [
                        userPosition,
                        "."
                    ]
                })
            ]
        });
        return null;
    };
    const getStyle = ()=>{
        if (currentUserParticipantData?.eventData.success === true) return "success";
        if (currentUserParticipantData?.eventData.success === false) return "failed";
        return "default";
    };
    const { reactionControls: reactionControls, existingReactions: existingReactions } = (0, $5804d2a112dd3e9c$export$c65f3d3f4d784f6a)({
        reactions: reactions,
        onSubmitReaction: handleReactionSubmit,
        disabled: currentUserProfile?.isBanned,
        currentUserId: currentUserProfile?.userID,
        existingReactionsClassName: $466187d255fab208$exports.existingReactions,
        controlsClassName: $466187d255fab208$exports.reactionsMenu
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $466187d255fab208$exports.EventSummaryMessage,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($466187d255fab208$exports.container, $466187d255fab208$exports[getStyle()]),
                style: customData?.rectangleMask ? {
                    maskImage: `url("${customData.rectangleMask}")`
                } : {},
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $466187d255fab208$exports.content,
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: $466187d255fab208$exports.contentCenter,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: $466187d255fab208$exports.heading,
                                    children: getHeading()
                                }),
                                participants.length > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: $466187d255fab208$exports.text,
                                        children: [
                                            getUserPlaced(),
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                                className: $466187d255fab208$exports.bold,
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                        className: $466187d255fab208$exports.failedHighlight,
                                                        children: [
                                                            failedParticipants.length,
                                                            " failed"
                                                        ]
                                                    }),
                                                    " ",
                                                    "the event."
                                                ]
                                            }),
                                            mostSuccessfulFaction && /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                                children: [
                                                    "Top Players were",
                                                    " ",
                                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                        className: $466187d255fab208$exports.bold,
                                                        children: [
                                                            mostSuccessfulFaction,
                                                            "."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            !mostSuccessfulFaction && /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
                                                children: [
                                                    "There were ",
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $466187d255fab208$exports.bold,
                                                        children: "no winners!"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $466187d255fab208$exports.image,
                        style: {
                            ...customData?.summaryImage ? {
                                backgroundImage: `url("${customData.summaryImage}")`
                            } : {},
                            ...customData?.imageMask ? {
                                maskImage: `url("${customData.imageMask}")`
                            } : {}
                        }
                    }),
                    existingReactions
                ]
            }),
            reactionControls
        ]
    });
}
function $0776941ff61af1cf$export$2e2bcd8739ae039({ message: message }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const locationId = (0, $6lYLL.useAppSelector)((state)=>state.app.location.id);
    const storedEvents = (0, $6lYLL.useAppSelector)((state)=>state.feed.storedEvents);
    const storedEvent = storedEvents?.[message.data?.eventID];
    const participants = message.data?.participants || storedEvent?.data?.eventData?.participants;
    (0, $8FY87.useEffect)(()=>{
        // If no participants, and not already fetched, fetch them from API
        if (!participants && !storedEvent?.lastFetched) dispatch((0, $kyBxf.fetchEventById)(message.data.eventID));
    }, [
        message.data.eventID
    ]);
    function handleReactionSubmit(reaction) {
        dispatch((0, $kyBxf.toggleMessageReaction)([
            message.id,
            reaction,
            locationId
        ]));
        (0, $i7H0N.sendEvent)("toggle_reaction", {
            reaction: reaction
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)($0776941ff61af1cf$var$EventSummary, {
        participants: participants || [],
        reactions: message.data.reactions,
        handleReactionSubmit: handleReactionSubmit
    });
}



var $2PPWI = parcelRequire("2PPWI");
function $20d8245a36d62adb$export$2e2bcd8739ae039({ backgroundImageURL: backgroundImageURL, foregroundImageURL: foregroundImageURL, prompt: prompt, actionLabel: actionLabel, actionType: actionType }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: "relative pt-[50px]",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: "relative text-xs  p-2 bg-[#413832] rounded-md overflow-hidden ",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "absolute inset-0 bg flex",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex-1 skew-x-[-20deg] scale-150 ",
                                style: {
                                    backgroundColor: "#413832"
                                }
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "flex-1 bg-center bg-cover",
                                style: {
                                    backgroundImage: `url(${backgroundImageURL})`
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: "relative z-10 p-4 w-[60%]",
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: "pt-6 pb-6 text-[#F6CEB2]",
                                children: prompt
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: "interact text-[12px] text-[#F6CEB2]",
                                children: [
                                    ":bubble: ",
                                    actionLabel
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: "absolute right-0 bottom-0 h-full",
                src: foregroundImageURL
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");
function $33abc470521cdfbc$export$2e2bcd8739ae039({ icon: icon, color: color }) {
    const { themeId: themeId } = (0, $cEIti.useTheme)();
    function getIcon() {
        if ($33abc470521cdfbc$var$customIcons[themeId]?.[icon]) return $33abc470521cdfbc$var$customIcons[themeId][icon](color);
        if ($33abc470521cdfbc$var$defaultIcons[icon]) return $33abc470521cdfbc$var$defaultIcons[icon](color);
        console.error(`ThemeIcon: Icon "${icon}" not found for theme "${themeId}"`);
        return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: getIcon()
    });
}
const $33abc470521cdfbc$var$defaultIcons = {
    tool: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M19.2746 9.1751L15.7496 5.6501L13.6246 7.7501L11.4996 5.6501L14.3246 2.8001C14.5246 2.6001 14.7496 2.45426 14.9996 2.3626C15.2496 2.27093 15.4996 2.2251 15.7496 2.2251C16.0163 2.2251 16.2704 2.27093 16.5121 2.3626C16.7538 2.45426 16.9663 2.6001 17.1496 2.8001L19.2746 4.9251C19.5746 5.20843 19.7954 5.5376 19.9371 5.9126C20.0788 6.2876 20.1496 6.66676 20.1496 7.0501C20.1496 7.43343 20.0788 7.80843 19.9371 8.1751C19.7954 8.54176 19.5746 8.8751 19.2746 9.1751ZM5.49961 13.7751C5.19961 13.4751 5.04961 13.1209 5.04961 12.7126C5.04961 12.3043 5.19961 11.9501 5.49961 11.6501L7.94961 9.1751L10.0746 11.3001L7.59961 13.7751C7.31628 14.0751 6.97044 14.2251 6.56211 14.2251C6.15378 14.2251 5.79961 14.0751 5.49961 13.7751ZM4.42461 21.2001C4.24128 21.0001 4.09961 20.7793 3.99961 20.5376C3.89961 20.2959 3.84961 20.0418 3.84961 19.7751C3.84961 19.5084 3.89544 19.2543 3.98711 19.0126C4.07878 18.7709 4.22461 18.5501 4.42461 18.3501L11.4996 11.3001L8.32461 8.1001C8.02461 7.81676 7.87461 7.47093 7.87461 7.0626C7.87461 6.65426 8.02461 6.3001 8.32461 6.0001C8.60794 5.7001 8.95794 5.5501 9.37461 5.5501C9.79128 5.5501 10.1496 5.7001 10.4496 6.0001L13.6246 9.1751L15.0496 7.7501L17.8496 10.6001C18.0496 10.8001 18.1496 11.0334 18.1496 11.3001C18.1496 11.5668 18.0496 11.8001 17.8496 12.0001C17.6496 12.2001 17.4163 12.3001 17.1496 12.3001C16.8829 12.3001 16.6496 12.2001 16.4496 12.0001L7.24961 21.2001C7.04961 21.4001 6.82878 21.5459 6.58711 21.6376C6.34544 21.7293 6.09961 21.7751 5.84961 21.7751C5.59961 21.7751 5.34961 21.7251 5.09961 21.6251C4.84961 21.5251 4.62461 21.3834 4.42461 21.2001Z",
                fill: color
            })
        }),
    block: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C12.9 20 13.7667 19.8542 14.6 19.5625C15.4333 19.2708 16.2 18.85 16.9 18.3L5.7 7.1C5.15 7.8 4.72917 8.56667 4.4375 9.4C4.14583 10.2333 4 11.1 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20ZM18.3 16.9C18.85 16.2 19.2708 15.4333 19.5625 14.6C19.8542 13.7667 20 12.9 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C11.1 4 10.2333 4.14583 9.4 4.4375C8.56667 4.72917 7.8 5.15 7.1 5.7L18.3 16.9Z",
                fill: color
            })
        }),
    chat: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M6 18V15H19V6H22V22L18 18H6ZM2 17V2H17V13H6L2 17Z",
                fill: color
            })
        }),
    death: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M4.57536 14.5C4.44202 14.5667 4.30452 14.5708 4.16286 14.5125C4.02119 14.4542 3.92536 14.3583 3.87536 14.225L3.12536 12.225C3.04202 11.9917 3.00452 11.7625 3.01286 11.5375C3.02119 11.3125 3.12536 11.1583 3.32536 11.075C3.74202 10.9083 4.12952 10.9667 4.48786 11.25C4.84619 11.5333 5.11702 11.9 5.30036 12.35L5.70036 13.425C5.75036 13.5583 5.75452 13.6792 5.71286 13.7875C5.67119 13.8958 5.59202 13.9833 5.47536 14.05L4.57536 14.5ZM10.8254 22C10.542 22 10.2629 21.9417 9.98785 21.825C9.71285 21.7083 9.48369 21.5417 9.30036 21.325L5.25036 16.65C5.06702 16.4333 4.98369 16.1917 5.00036 15.925C5.01702 15.6583 5.13369 15.4333 5.35036 15.25C5.56702 15.0667 5.80869 14.9875 6.07536 15.0125C6.34202 15.0375 6.56702 15.15 6.75036 15.35L9.00036 17.925C9.00036 17.7917 9.01702 17.6625 9.05036 17.5375C9.08369 17.4125 9.13369 17.2833 9.20036 17.15L8.05036 13.85C7.96702 13.5833 7.98369 13.325 8.10036 13.075C8.21702 12.825 8.40869 12.6583 8.67536 12.575C8.94202 12.4917 9.20035 12.5083 9.45035 12.625C9.70035 12.7417 9.86702 12.9333 9.95035 13.2L10.9254 16H11.5004V13C11.5004 12.7167 11.5962 12.4792 11.7879 12.2875C11.9795 12.0958 12.217 12 12.5004 12C12.7837 12 13.0212 12.0958 13.2129 12.2875C13.4045 12.4792 13.5004 12.7167 13.5004 13V16H14.1004L14.6254 13.775C14.692 13.4917 14.8379 13.2792 15.0629 13.1375C15.2879 12.9958 15.542 12.9583 15.8254 13.025C16.1087 13.0917 16.3212 13.2375 16.4629 13.4625C16.6045 13.6875 16.642 13.9417 16.5754 14.225L16.1754 16C16.2587 16.0167 16.3462 16.0333 16.4379 16.05C16.5295 16.0667 16.617 16.0917 16.7004 16.125L17.0754 15.15C17.1754 14.8833 17.3504 14.6917 17.6004 14.575C17.8504 14.4583 18.1087 14.45 18.3754 14.55C18.6254 14.65 18.8045 14.825 18.9129 15.075C19.0212 15.325 19.0254 15.5833 18.9254 15.85L18.0004 18.3V20C18.0004 20.55 17.8045 21.0208 17.4129 21.4125C17.0212 21.8042 16.5504 22 16.0004 22H10.8254ZM7.77536 6.525C7.64202 6.54167 7.52119 6.50417 7.41286 6.4125C7.30452 6.32083 7.24202 6.20833 7.22536 6.075L7.00036 4.1C6.96702 3.81667 7.03786 3.57083 7.21286 3.3625C7.38786 3.15417 7.61702 3.03333 7.90036 3C8.18369 2.96667 8.42952 3.0375 8.63786 3.2125C8.84619 3.3875 8.96702 3.61667 9.00036 3.9L9.20036 5.875C9.21702 6.00833 9.17952 6.12917 9.08786 6.2375C8.99619 6.34583 8.88369 6.40833 8.75036 6.425L7.77536 6.525ZM8.32536 11.625C8.17536 11.6583 8.03786 11.6333 7.91286 11.55C7.78786 11.4667 7.71702 11.35 7.70036 11.2L7.40036 8.6C7.36702 8.31667 7.43786 8.07083 7.61286 7.8625C7.78786 7.65417 8.01702 7.53333 8.30036 7.5C8.58369 7.46667 8.82952 7.5375 9.03786 7.7125C9.24619 7.8875 9.36702 8.11667 9.40036 8.4L9.67535 10.825C9.69202 10.9583 9.66702 11.075 9.60035 11.175C9.53369 11.275 9.43369 11.3417 9.30036 11.375L8.32536 11.625ZM12.0004 11C11.867 11 11.7504 10.95 11.6504 10.85C11.5504 10.75 11.5004 10.6333 11.5004 10.5V8C11.5004 7.71667 11.5962 7.47917 11.7879 7.2875C11.9795 7.09583 12.217 7 12.5004 7C12.7837 7 13.0212 7.09583 13.2129 7.2875C13.4045 7.47917 13.5004 7.71667 13.5004 8V10.5C13.5004 10.6333 13.4504 10.75 13.3504 10.85C13.2504 10.95 13.1337 11 13.0004 11H12.0004ZM12.0004 6C11.867 6 11.7504 5.95 11.6504 5.85C11.5504 5.75 11.5004 5.63333 11.5004 5.5V3C11.5004 2.71667 11.5962 2.47917 11.7879 2.2875C11.9795 2.09583 12.217 2 12.5004 2C12.7837 2 13.0212 2.09583 13.2129 2.2875C13.4045 2.47917 13.5004 2.71667 13.5004 3V5.5C13.5004 5.63333 13.4504 5.75 13.3504 5.85C13.2504 5.95 13.1337 6 13.0004 6H12.0004ZM16.3754 12.15L15.3754 11.9C15.242 11.8667 15.142 11.8 15.0754 11.7C15.0087 11.6 14.9837 11.4833 15.0004 11.35L15.2754 8.9C15.3087 8.61667 15.4295 8.3875 15.6379 8.2125C15.8462 8.0375 16.092 7.96667 16.3754 8C16.6587 8.03333 16.8879 8.15417 17.0629 8.3625C17.2379 8.57083 17.3087 8.81667 17.2754 9.1L17.0004 11.725C16.9837 11.875 16.9129 11.9917 16.7879 12.075C16.6629 12.1583 16.5254 12.1833 16.3754 12.15ZM16.9504 7.125L15.9504 7.025C15.817 7.00833 15.7045 6.94583 15.6129 6.8375C15.5212 6.72917 15.4837 6.60833 15.5004 6.475L15.7004 4.5C15.7337 4.21667 15.8545 3.9875 16.0629 3.8125C16.2712 3.6375 16.517 3.56667 16.8004 3.6C17.0837 3.63333 17.3129 3.75417 17.4879 3.9625C17.6629 4.17083 17.7337 4.41667 17.7004 4.7L17.5004 6.675C17.4837 6.80833 17.4212 6.92083 17.3129 7.0125C17.2045 7.10417 17.0837 7.14167 16.9504 7.125ZM18.9504 13.75L17.9754 13.45C17.842 13.4167 17.7462 13.3417 17.6879 13.225C17.6295 13.1083 17.617 12.9833 17.6504 12.85L18.0254 11.45C18.1087 11.1833 18.267 10.9792 18.5004 10.8375C18.7337 10.6958 18.9837 10.6667 19.2504 10.75C19.517 10.8333 19.717 10.9875 19.8504 11.2125C19.9837 11.4375 20.017 11.6833 19.9504 11.95L19.5754 13.4C19.542 13.5333 19.4629 13.6333 19.3379 13.7C19.2129 13.7667 19.0837 13.7833 18.9504 13.75ZM20.0004 9.975L19.0254 9.725C18.892 9.69167 18.792 9.6125 18.7254 9.4875C18.6587 9.3625 18.642 9.23333 18.6754 9.1L19.0004 7.95C19.117 7.55 19.2587 7.175 19.4254 6.825C19.592 6.475 19.8504 6.34167 20.2004 6.425C20.617 6.525 20.867 6.8 20.9504 7.25C21.0337 7.7 21.0087 8.16667 20.8754 8.65L20.6004 9.625C20.567 9.75833 20.492 9.85833 20.3754 9.925C20.2587 9.99167 20.1337 10.0083 20.0004 9.975Z",
                fill: color
            })
        }),
    key: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M7 15C7.83333 15 8.54167 14.7083 9.125 14.125C9.70833 13.5417 10 12.8333 10 12C10 11.1667 9.70833 10.4583 9.125 9.875C8.54167 9.29167 7.83333 9 7 9C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15ZM7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6C8.35 6 9.52917 6.38333 10.5375 7.15C11.5458 7.91667 12.25 8.86667 12.65 10H21.025L23 11.975L19.5 15.975L17 14L15 16L13 14H12.65C12.2333 15.2 11.5083 16.1667 10.475 16.9C9.44167 17.6333 8.28333 18 7 18Z",
                fill: color
            })
        }),
    alert: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M11.0002 13H13.0002V6.99995H11.0002V13ZM12.0002 16C12.2835 16 12.521 15.9041 12.7127 15.7125C12.9044 15.5208 13.0002 15.2833 13.0002 15C13.0002 14.7166 12.9044 14.4791 12.7127 14.2875C12.521 14.0958 12.2835 14 12.0002 14C11.7169 14 11.4794 14.0958 11.2877 14.2875C11.096 14.4791 11.0002 14.7166 11.0002 15C11.0002 15.2833 11.096 15.5208 11.2877 15.7125C11.4794 15.9041 11.7169 16 12.0002 16ZM12.0002 22.8L1.2002 12L12.0002 1.19995L22.8002 12L12.0002 22.8Z",
                fill: color
            })
        }),
    puzzle: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M8.8 21H3V15.2C3.8 15.2 4.5 14.9458 5.1 14.4375C5.7 13.9292 6 13.2833 6 12.5C6 11.7167 5.7 11.0708 5.1 10.5625C4.5 10.0542 3.8 9.8 3 9.8V4H9C9 3.3 9.24167 2.70833 9.725 2.225C10.2083 1.74167 10.8 1.5 11.5 1.5C12.2 1.5 12.7917 1.74167 13.275 2.225C13.7583 2.70833 14 3.3 14 4H20V10C20.7 10 21.2917 10.2417 21.775 10.725C22.2583 11.2083 22.5 11.8 22.5 12.5C22.5 13.2 22.2583 13.7917 21.775 14.275C21.2917 14.7583 20.7 15 20 15V21H14.2C14.2 20.1667 13.9375 19.4583 13.4125 18.875C12.8875 18.2917 12.25 18 11.5 18C10.75 18 10.1125 18.2917 9.5875 18.875C9.0625 19.4583 8.8 20.1667 8.8 21Z",
                fill: color
            })
        }),
    hand: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M8.4752 23L1.2002 12.375L2.9252 10.725L7.0002 13.575V3H9.0002V12H11.0002V1H13.0002V12H15.0002V2H17.0002V12H19.0002V4H21.0002V23H8.4752Z",
                fill: color
            })
        }),
    map: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M15 21L9 18.9L4.35 20.7C4.01667 20.8333 3.70833 20.7958 3.425 20.5875C3.14167 20.3792 3 20.1 3 19.75V5.75C3 5.53333 3.0625 5.34167 3.1875 5.175C3.3125 5.00833 3.48333 4.88333 3.7 4.8L9 3L15 5.1L19.65 3.3C19.9833 3.16667 20.2917 3.20417 20.575 3.4125C20.8583 3.62083 21 3.9 21 4.25V18.25C21 18.4667 20.9375 18.6583 20.8125 18.825C20.6875 18.9917 20.5167 19.1167 20.3 19.2L15 21ZM14 18.55V6.85L10 5.45V17.15L14 18.55Z",
                fill: color
            })
        }),
    skull: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M8.98696 20.7946C9.72535 21.4775 10.8879 21.2025 11.862 20.9716C12.415 20.842 13.0497 20.7535 13.5053 21.0918C13.7347 21.2625 13.9483 21.5471 14.2311 21.4933C14.4793 21.4491 14.6019 21.1645 14.8124 21.0254C14.9601 20.9274 15.1329 20.9116 15.312 20.921C15.3497 20.8325 15.3874 20.744 15.422 20.6554C15.6168 20.1464 15.8524 19.6405 15.7519 19.1156C16.0347 18.6508 16.44 18.4579 16.616 18.0279C16.7416 17.7243 17.2287 17.6168 17.5523 17.718C17.6497 17.7465 17.7471 17.7812 17.8445 17.8002C18.5923 17.9457 19.2082 17.582 19.8146 17.2342C20.0345 17.1077 20.2042 16.9022 20.1791 16.567C20.1539 16.2224 20.0314 15.8872 20.0251 15.5647C20.0094 14.6572 19.6544 13.8573 19.4187 13.013C19.3182 12.6526 19.0668 12.3079 19.2176 11.919C19.5412 12.2447 19.8617 12.5672 20.1351 12.8423C20.974 12.8486 21.0055 12.8486 20.974 12.1751C20.9332 11.2929 21.1311 10.4013 20.8264 9.52857C20.7164 9.21238 20.974 8.81398 20.6693 8.52624C20.4053 8.27645 20.4713 7.90334 20.2765 7.61876C19.89 7.04645 19.7361 6.32869 19.1862 5.85756C18.8531 4.91847 18.0456 4.36513 17.3575 3.7612C16.8202 3.29007 16.2358 2.82527 15.4754 2.60393C14.1337 2.21501 14.1526 2.1581 12.7826 2.33517C12.5469 2.36678 12.2453 2.41105 12.0725 2.29722C11.8588 2.15493 11.6672 2.20553 11.4629 2.17707C11.2367 2.14229 11.0199 2.19288 10.7748 2.05691C10.5643 1.93676 10.2532 2.0253 9.95472 2.15177C8.56592 2.73357 7.33422 3.59362 6.03339 4.33035C5.82916 4.44734 5.68776 4.76037 5.49295 4.78567C5.0782 4.84258 4.93366 5.08605 4.77027 5.41173C4.63202 5.68682 4.40265 5.91764 4.20156 6.16111C3.88106 6.55319 3.70196 7.00851 3.67997 7.50177C3.65483 8.03298 3.38775 8.53256 3.50715 9.07642C3.20865 9.41158 3.46002 9.86058 3.27778 10.2147C3.06412 10.6321 3.24008 11.0684 3.18038 11.489C3.16467 11.5965 3.20865 11.7324 3.15838 11.8083C2.88816 12.2099 3.04841 12.6209 3.03584 13.0984C3.25264 13.0194 3.40346 12.9846 3.53543 12.9118C4.03817 12.6399 4.39322 12.1973 4.80169 11.8147C4.87396 11.7483 5.00907 11.7514 5.23216 11.6913C4.76085 12.5957 4.42779 13.4114 4.145 14.2557C3.95647 14.828 3.83393 15.1948 3.82136 15.6027C3.81194 15.8872 3.93762 16.1244 4.0853 16.3141C4.49691 16.8358 4.95251 17.3196 5.38298 17.8097C5.74432 17.7528 6.08367 17.8698 6.41987 17.6548C6.58326 17.5504 6.86605 17.6042 7.064 17.835C7.43477 18.265 7.85895 18.6508 8.1166 18.91C8.2737 19.5298 8.33655 20.0389 8.50308 20.4752C8.51565 20.4752 8.53136 20.4752 8.54392 20.4752C8.72302 20.5068 8.84871 20.6649 8.98382 20.7882L8.98696 20.7946ZM13.2791 12.9814C13.3325 12.8676 13.4236 12.7664 13.4644 12.6494C13.6812 12.0139 14.2437 11.7925 14.781 11.568C14.9192 11.5111 15.0638 11.4542 15.202 11.4099C15.3623 11.3562 15.5602 11.255 15.689 11.2676C16.0064 11.2993 16.3143 11.4384 16.6191 11.5585C16.8516 11.6502 17.0998 11.7388 17.2915 11.8937C17.4832 12.0518 17.6623 12.2131 17.7408 12.5198C17.8571 12.9751 18.1367 13.3893 18.3598 13.8446C18.1367 14.3916 17.9168 14.9007 17.722 15.4224C17.6026 15.7386 17.4612 16.0232 17.0747 15.9916C16.7196 15.96 16.418 16.1244 16.1132 16.2319C15.7676 16.3552 15.4754 16.3773 15.158 16.1686C15.0166 16.0738 14.8281 16.0517 14.6616 15.9979C14.3631 15.8999 14.0709 15.7734 13.8886 15.5078C13.587 15.0651 13.2696 14.6225 13.034 14.145C12.8329 13.734 13.1125 13.3545 13.2791 12.9846V12.9814ZM11.5226 16.8042C11.5635 16.5196 11.7771 16.2635 11.9154 15.9947H12.2704C12.5564 16.6524 12.8172 17.3386 13.1534 17.9836C13.3827 18.4263 13.2822 18.8436 13.2885 19.4065C13.0528 19.2199 12.9177 19.1061 12.7795 19.0017C12.5941 18.8626 12.393 18.7456 12.2202 18.5939C12.0851 18.4737 11.9814 18.3946 11.8211 18.5559C11.6263 18.7551 11.2713 18.4769 11.1047 18.7867C11.0262 18.714 10.9508 18.6413 10.9005 18.5939C11.0953 17.9836 11.4346 17.4492 11.5258 16.8074L11.5226 16.8042ZM7.4599 15.9979C7.27766 15.9631 7.064 16.0422 6.89433 15.9821C6.68381 15.9062 6.489 15.7608 6.31618 15.6121C6.11195 15.4382 5.63121 14.2082 5.62492 13.9363C5.61864 13.7434 5.60607 13.5537 5.80088 13.4336C5.84487 13.4051 5.88572 13.364 5.91714 13.3197C6.1905 12.896 6.31932 12.3585 6.74351 12.0613C7.15512 11.7736 7.62329 11.5649 8.06633 11.3214C8.11032 11.2961 8.15116 11.2582 8.22971 11.1981C8.7136 11.5269 9.22262 11.7008 9.66251 12.0233C9.86674 12.172 9.983 12.3111 10.0961 12.5103C10.2721 12.8233 10.3978 13.1553 10.6523 13.4336C10.8125 13.6075 10.9036 13.8731 10.7088 14.1861C10.5014 14.5213 10.4355 14.9418 10.2941 15.3212C10.181 15.628 9.99243 15.7639 9.63109 15.8588C8.49679 16.1623 8.50936 16.2034 7.4599 15.9979Z",
                fill: color
            })
        }),
    supplies: (color)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                d: "M17.9951 3.02625L17.9973 3.02628L17.9885 3.01752L17.9951 3.02625ZM17.9951 3.02625L17.1563 3.0146L16.3211 3.02628L15.4859 3.04088L14.6507 3.04672L13.8156 3.03796L12.9804 3.0438L12.1452 3.05256L11.3071 3L10.472 3.04088L10.0865 3.74173L9.67475 4.43381L9.32141 5.15801L8.91842 5.8647L8.2497 6.28228L7.62186 6.74659L7.00862 7.22842L6.3399 7.63433L5.71498 8.10448L5.06086 8.56003L5.07838 9.40688L5.07254 10.2391V11.0714L5.07838 11.9036L5.1105 12.7359L5.07254 13.5681L5.06086 14.4004L5.1105 15.2326L5.0959 16.0649L5.0667 16.8971L5.0959 17.7294V18.5646L5.07838 19.4027L5.62154 19.9429L6.17637 20.4656L6.75749 20.9416L7.5839 20.9708H8.42199L9.26008 20.9679L10.0982 20.9737L10.9363 20.9971L11.7744 20.9912L12.6125 20.9737L13.4535 21L14.2916 20.9883L15.1296 20.9591L15.9707 20.9445L16.8117 20.9883L17.6556 20.9825L18.1871 20.4276L18.774 19.9341L19.3172 19.3997L19.2909 18.5792L19.3201 17.7557L19.3464 16.9322L19.3522 16.1087L19.3084 15.2852L19.3347 14.4617L19.3055 13.6382L19.2938 12.8147L19.323 11.9912L19.3435 11.1677L19.3259 10.3443L19.2938 9.52077L19.3552 8.69727L19.3318 7.87378L19.2938 7.05029L19.3084 6.2268L19.3201 5.40039L19.2938 4.58566L18.8821 4.05711L18.4032 3.56944L17.9951 3.02625ZM16.1137 13.6177L16.105 14.3595L15.7925 14.6836L15.1676 14.6982L14.5427 14.7041L13.7309 14.9143L13.141 15.513L12.9337 16.3219L12.8811 16.9468L12.922 17.5717L12.5803 17.9192L11.8357 17.8988L11.4648 17.5717L11.4707 16.9468L11.5203 16.3219L11.2896 15.5042L10.6734 14.9348L9.87332 14.6632L9.2484 14.6807L8.62348 14.6661L8.29934 14.3624L8.30518 13.6178L8.62348 13.2995L9.2484 13.2907L9.87332 13.2586L10.6939 13.0775L11.3071 12.4818L11.4794 11.6554L11.494 11.0305L11.5232 10.4056L11.8386 10.061H12.5832L12.9074 10.4056L12.8899 11.0305V11.6554L13.1644 12.4526L13.7309 13.0629L14.5427 13.279H15.1676L15.7925 13.282L16.1137 13.6177ZM15.3049 6.43121L16.0641 6.44289L16.0699 6.43997L16.4963 5.65737L16.9343 4.87184L17.349 4.10383L16.6073 4.10967L15.8363 4.12719L15.0654 4.06879L14.2945 4.10091L13.5235 4.11259L12.7526 4.06295L11.9817 4.05711L11.2166 4.10091L10.7727 4.87476L10.3493 5.66321L9.96093 6.43705L10.6968 6.46918L11.4648 6.46042L12.2328 6.45458L13.0008 6.46334L13.7688 6.4575L14.5369 6.44289L15.3049 6.43121ZM7.44665 5.0993L7.99272 5.87899L7.32984 6.33454L6.66696 6.79593L6.00408 7.2544L5.34412 7.71287L4.80097 6.93026L4.25781 6.15057L4.92069 5.68626L5.5865 5.22779L6.24938 4.77516L6.90934 4.31961L7.44665 5.0993Z",
                fill: color
            })
        })
};
const $33abc470521cdfbc$var$customIcons = {
};





var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");

var $i7H0N = parcelRequire("i7H0N");
var $b0df8968ee4ad2ab$exports = {};

$parcel$export($b0df8968ee4ad2ab$exports, "Update", function () { return $b0df8968ee4ad2ab$export$489a84f048b0ef8; }, function (v) { return $b0df8968ee4ad2ab$export$489a84f048b0ef8 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "action", function () { return $b0df8968ee4ad2ab$export$31eb53bd5b582a97; }, function (v) { return $b0df8968ee4ad2ab$export$31eb53bd5b582a97 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "danger", function () { return $b0df8968ee4ad2ab$export$7c4df8d735fa2705; }, function (v) { return $b0df8968ee4ad2ab$export$7c4df8d735fa2705 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "displayName", function () { return $b0df8968ee4ad2ab$export$c1de35a83862cf9; }, function (v) { return $b0df8968ee4ad2ab$export$c1de35a83862cf9 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH1", function () { return $b0df8968ee4ad2ab$export$17fa98cb055e8fa7; }, function (v) { return $b0df8968ee4ad2ab$export$17fa98cb055e8fa7 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH2", function () { return $b0df8968ee4ad2ab$export$a5833c2b43ca4340; }, function (v) { return $b0df8968ee4ad2ab$export$a5833c2b43ca4340 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH3", function () { return $b0df8968ee4ad2ab$export$47511f9a6581d1d6; }, function (v) { return $b0df8968ee4ad2ab$export$47511f9a6581d1d6 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH4", function () { return $b0df8968ee4ad2ab$export$dd1c05b92185401c; }, function (v) { return $b0df8968ee4ad2ab$export$dd1c05b92185401c = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH5", function () { return $b0df8968ee4ad2ab$export$8b28cf6cd00fe080; }, function (v) { return $b0df8968ee4ad2ab$export$8b28cf6cd00fe080 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeH6", function () { return $b0df8968ee4ad2ab$export$186c650311ff0789; }, function (v) { return $b0df8968ee4ad2ab$export$186c650311ff0789 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeSmall", function () { return $b0df8968ee4ad2ab$export$6746fe0d9c9fab54; }, function (v) { return $b0df8968ee4ad2ab$export$6746fe0d9c9fab54 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizeTiny", function () { return $b0df8968ee4ad2ab$export$2bcf359f0c20e94f; }, function (v) { return $b0df8968ee4ad2ab$export$2bcf359f0c20e94f = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "fontSizep", function () { return $b0df8968ee4ad2ab$export$2903d10d531d0ac0; }, function (v) { return $b0df8968ee4ad2ab$export$2903d10d531d0ac0 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "icon", function () { return $b0df8968ee4ad2ab$export$1ca1ec8b29a4ce27; }, function (v) { return $b0df8968ee4ad2ab$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "reactionsMenu", function () { return $b0df8968ee4ad2ab$export$9df547fe976beafa; }, function (v) { return $b0df8968ee4ad2ab$export$9df547fe976beafa = v; });
$parcel$export($b0df8968ee4ad2ab$exports, "success", function () { return $b0df8968ee4ad2ab$export$fe7c49d056ea1d88; }, function (v) { return $b0df8968ee4ad2ab$export$fe7c49d056ea1d88 = v; });
var $b0df8968ee4ad2ab$export$489a84f048b0ef8;
var $b0df8968ee4ad2ab$export$31eb53bd5b582a97;
var $b0df8968ee4ad2ab$export$7c4df8d735fa2705;
var $b0df8968ee4ad2ab$export$c1de35a83862cf9;
var $b0df8968ee4ad2ab$export$17fa98cb055e8fa7;
var $b0df8968ee4ad2ab$export$a5833c2b43ca4340;
var $b0df8968ee4ad2ab$export$47511f9a6581d1d6;
var $b0df8968ee4ad2ab$export$dd1c05b92185401c;
var $b0df8968ee4ad2ab$export$8b28cf6cd00fe080;
var $b0df8968ee4ad2ab$export$186c650311ff0789;
var $b0df8968ee4ad2ab$export$6746fe0d9c9fab54;
var $b0df8968ee4ad2ab$export$2bcf359f0c20e94f;
var $b0df8968ee4ad2ab$export$2903d10d531d0ac0;
var $b0df8968ee4ad2ab$export$1ca1ec8b29a4ce27;
var $b0df8968ee4ad2ab$export$9df547fe976beafa;
var $b0df8968ee4ad2ab$export$fe7c49d056ea1d88;
$b0df8968ee4ad2ab$export$489a84f048b0ef8 = `SlhrjW_Update`;
$b0df8968ee4ad2ab$export$31eb53bd5b582a97 = `SlhrjW_action`;
$b0df8968ee4ad2ab$export$7c4df8d735fa2705 = `SlhrjW_danger`;
$b0df8968ee4ad2ab$export$c1de35a83862cf9 = `SlhrjW_displayName`;
$b0df8968ee4ad2ab$export$17fa98cb055e8fa7 = `SlhrjW_fontSizeH1`;
$b0df8968ee4ad2ab$export$a5833c2b43ca4340 = `SlhrjW_fontSizeH2`;
$b0df8968ee4ad2ab$export$47511f9a6581d1d6 = `SlhrjW_fontSizeH3`;
$b0df8968ee4ad2ab$export$dd1c05b92185401c = `SlhrjW_fontSizeH4`;
$b0df8968ee4ad2ab$export$8b28cf6cd00fe080 = `SlhrjW_fontSizeH5`;
$b0df8968ee4ad2ab$export$186c650311ff0789 = `SlhrjW_fontSizeH6`;
$b0df8968ee4ad2ab$export$6746fe0d9c9fab54 = `SlhrjW_fontSizeSmall`;
$b0df8968ee4ad2ab$export$2bcf359f0c20e94f = `SlhrjW_fontSizeTiny`;
$b0df8968ee4ad2ab$export$2903d10d531d0ac0 = `SlhrjW_fontSizep`;
$b0df8968ee4ad2ab$export$1ca1ec8b29a4ce27 = `SlhrjW_icon`;
$b0df8968ee4ad2ab$export$9df547fe976beafa = `SlhrjW_reactionsMenu`;
$b0df8968ee4ad2ab$export$fe7c49d056ea1d88 = `SlhrjW_success`;



function $e8dfdaf8e801b470$export$2e2bcd8739ae039({ data: { subjectId: subjectId, action: action, type: type, icon: icon, profile: profile, reactions: reactions, id: id }, locationId: locationId }) {
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const color = $e8dfdaf8e801b470$var$useUpdateTypeColor(type);
    const actionDesc = profile ? `${profile.displayName} ${action}` : "";
    function renderLabel() {
        if (!subjectId) return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            className: $b0df8968ee4ad2ab$exports.action,
            children: action
        });
        if (profile) return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d758aa58b83e8f34$export$2e2bcd8739ae039), {
                    profile: profile,
                    shouldLinkToProfile: true,
                    classname: $b0df8968ee4ad2ab$exports.displayName
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                    className: $b0df8968ee4ad2ab$exports.action,
                    children: [
                        " ",
                        action
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            children: "\xa0"
        });
    }
    function handleReactionSubmit(reaction) {
        dispatch((0, $kyBxf.toggleMessageReaction)([
            id,
            reaction,
            locationId
        ]));
        (0, $i7H0N.sendEvent)("toggle_reaction", {
            reaction: reaction
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($b0df8968ee4ad2ab$exports.Update, $b0df8968ee4ad2ab$exports[type]),
        "aria-label": actionDesc,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $b0df8968ee4ad2ab$exports.icon,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $33abc470521cdfbc$export$2e2bcd8739ae039), {
                    icon: icon,
                    color: color
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                children: renderLabel()
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3ccb4c7796cb7dc$export$2e2bcd8739ae039), {
                locationId: locationId,
                style: {
                    padding: "10px 0 5px 0"
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5804d2a112dd3e9c$export$2e2bcd8739ae039), {
                reactions: reactions,
                onSubmitReaction: handleReactionSubmit,
                controlsClassName: $b0df8968ee4ad2ab$exports.reactionsMenu,
                existingReactionsClassName: $b0df8968ee4ad2ab$exports.existingReactions,
                disabled: currentUserProfile?.isBanned,
                currentUserId: currentUserProfile?.userID
            })
        ]
    });
}
function $e8dfdaf8e801b470$var$useUpdateTypeColor(type) {
    const theme = (0, $cEIti.useTheme)();
    switch(type){
        case "success":
            return theme.tokens.AriseTheme1StateStateSuccessLight;
        case "danger":
            return theme.tokens.AriseTheme1StateStateErrorLight;
        case "default":
            return theme.tokens.AriseTheme1StateStateDefaultLight;
        default:
            return theme.tokens.AriseTheme1StateStateSuccessLight;
    }
}


var $84c216d80fbe7187$export$833919a382305440;
var $84c216d80fbe7187$export$e3f17d020c351329;
var $84c216d80fbe7187$export$8b47c0b3dfd40a35;
var $84c216d80fbe7187$export$e638e645f4e1184b;
var $84c216d80fbe7187$export$627c3754fccefc50;
var $84c216d80fbe7187$export$17fa98cb055e8fa7;
var $84c216d80fbe7187$export$a5833c2b43ca4340;
var $84c216d80fbe7187$export$47511f9a6581d1d6;
var $84c216d80fbe7187$export$dd1c05b92185401c;
var $84c216d80fbe7187$export$8b28cf6cd00fe080;
var $84c216d80fbe7187$export$186c650311ff0789;
var $84c216d80fbe7187$export$6746fe0d9c9fab54;
var $84c216d80fbe7187$export$2bcf359f0c20e94f;
var $84c216d80fbe7187$export$2903d10d531d0ac0;
var $84c216d80fbe7187$export$b0e94793d11e2864;
var $84c216d80fbe7187$export$b7e3ae3d7c15e42e;
var $84c216d80fbe7187$export$1aea70eb3432192b;
var $84c216d80fbe7187$export$49198556dad290f4;
var $84c216d80fbe7187$export$deaa9e6d912ce6c6;
var $84c216d80fbe7187$export$defe85febe8b728c;
var $84c216d80fbe7187$export$64282f34fe8ec365;
var $84c216d80fbe7187$export$57bf213be019eeb0;
var $84c216d80fbe7187$export$b38bf4f33e9e4c25;
var $84c216d80fbe7187$export$734e1d6d41f36a22;
$84c216d80fbe7187$export$833919a382305440 = `P3sPeG_Feed`;
$84c216d80fbe7187$export$e3f17d020c351329 = `P3sPeG_FeedContentNew`;
$84c216d80fbe7187$export$8b47c0b3dfd40a35 = `P3sPeG_FeedVirtual`;
$84c216d80fbe7187$export$e638e645f4e1184b = `P3sPeG_feedItem`;
$84c216d80fbe7187$export$627c3754fccefc50 = `P3sPeG_firstItem`;
$84c216d80fbe7187$export$17fa98cb055e8fa7 = `P3sPeG_fontSizeH1`;
$84c216d80fbe7187$export$a5833c2b43ca4340 = `P3sPeG_fontSizeH2`;
$84c216d80fbe7187$export$47511f9a6581d1d6 = `P3sPeG_fontSizeH3`;
$84c216d80fbe7187$export$dd1c05b92185401c = `P3sPeG_fontSizeH4`;
$84c216d80fbe7187$export$8b28cf6cd00fe080 = `P3sPeG_fontSizeH5`;
$84c216d80fbe7187$export$186c650311ff0789 = `P3sPeG_fontSizeH6`;
$84c216d80fbe7187$export$6746fe0d9c9fab54 = `P3sPeG_fontSizeSmall`;
$84c216d80fbe7187$export$2bcf359f0c20e94f = `P3sPeG_fontSizeTiny`;
$84c216d80fbe7187$export$2903d10d531d0ac0 = `P3sPeG_fontSizep`;
$84c216d80fbe7187$export$b0e94793d11e2864 = `P3sPeG_guestFade`;
$84c216d80fbe7187$export$b7e3ae3d7c15e42e = `P3sPeG_input`;
$84c216d80fbe7187$export$1aea70eb3432192b = `P3sPeG_itemHolder`;
$84c216d80fbe7187$export$49198556dad290f4 = `P3sPeG_loadMoreButton`;
$84c216d80fbe7187$export$deaa9e6d912ce6c6 = `P3sPeG_loadingSpinner`;
$84c216d80fbe7187$export$defe85febe8b728c = `P3sPeG_messages`;
$84c216d80fbe7187$export$64282f34fe8ec365 = `P3sPeG_scrollToBottom`;
$84c216d80fbe7187$export$57bf213be019eeb0 = `P3sPeG_show`;
$84c216d80fbe7187$export$b38bf4f33e9e4c25 = `P3sPeG_slider`;
$84c216d80fbe7187$export$734e1d6d41f36a22 = `P3sPeG_vw-list`;



var $8FY87 = parcelRequire("8FY87");
function $6217fa994cded089$var$FeedItemRenderer({ item: item }) {
    function renderFeedItem() {
        switch(item.type){
            case "chat-message":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8fb01081114880dc$export$2e2bcd8739ae039), {
                    message: item.data
                });
            case "feed-update":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e8dfdaf8e801b470$export$2e2bcd8739ae039), {
                    ...item
                });
            case "interaction-prompt":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $20d8245a36d62adb$export$2e2bcd8739ae039), {
                    ...item.data
                });
            case "event-summary":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $0776941ff61af1cf$export$2e2bcd8739ae039), {
                    message: item
                });
            default:
                // @ts-ignore
                console.error("Unknown feed item type:", item.type);
                return null;
        }
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $84c216d80fbe7187$export$e638e645f4e1184b,
        children: renderFeedItem()
    });
}
var // Memoise the FeedItemRenderer component to prevent unnecessary re-renders
$6217fa994cded089$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8FY87.memo)($6217fa994cded089$var$FeedItemRenderer, (prev, next)=>{
    if (prev.item.id !== next.item.id) return false;
    if (prev.item.data.reactions && next.item.data.reactions) {
        if (prev.item.data.reactions.length !== next.item.data.reactions.length) return false;
        else if (prev.item.data.reactions.some((reaction, index)=>{
            return reaction.count !== next.item.data.reactions[index].count;
        })) return false;
    }
    if (prev.item.data.reactions && !next.item.data.reactions || !prev.item.data.reactions && next.item.data.reactions) return false;
    return true;
});



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
function $b9d56bab3ac77896$export$2e2bcd8739ae039({ children: children, onSizeUpdate: onSizeUpdate, style: style, visible: visible = true, ...props }) {
    const ref = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        if (ref.current) {
            const { width: width, height: height } = ref.current.getBoundingClientRect();
            onSizeUpdate({
                width: width,
                height: height
            });
        }
        return ()=>{
            // Gets called when is unmounted
            onSizeUpdate({
                width: 0,
                height: 0
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        style: {
            width: "100%",
            height: !visible ? "0" : undefined,
            overflow: !visible ? "hidden" : undefined
        },
        ...props,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            style: {
                width: "100%",
                ...style
            },
            ...props,
            ref: ref,
            children: children
        })
    });
}



var $kyBxf = parcelRequire("kyBxf");

var $jLk8j = parcelRequire("jLk8j");

var $aTRs6 = parcelRequire("aTRs6");

var $f9aoP = parcelRequire("f9aoP");

// Map dispatch to props type
const $7123ce532b8af82d$var$mapDispatchToProps = (dispatch)=>({
        dispatch: dispatch
    });
// Create a connector
const $7123ce532b8af82d$var$connector = (0, $gzuKA.default)(null, $7123ce532b8af82d$var$mapDispatchToProps);
/**
 * FeedScroller
 *
 * Handling the feed items in a virtualized way. This component will only render the items that are visible in the viewport.
 * At some point it becomes easier to simply use class component rather than work around a functional component.
 *
 */ class $7123ce532b8af82d$var$FeedScroller extends (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).Component {
    constructor(props){
        super(props);
        this.viewportElemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createRef();
        this.amountVisible = 250;
        this.bufferSize = 15;
        this.elementSizes = {};
        this.startingIndexFromBottom = -1;
        this.topIndex = 0;
        this.itemsToMeausure = 0;
        this.itemsMeasued = 0;
        this.autoScroll = true;
        this.lastScrollPosition = 0;
        this.heightToAdd = 0;
        this.currentAction = null;
        this.removingFromTopCount = 0;
        this.isLoadingMore = false;
        this.newItemsAddedToTop = 0;
        this.heightAdded = 0;
        this.distanceLeftBeforeLoadMore = 750;
        this.spacingBetweenItems = 20;
        // make sure we're on http for debug so that it doesn't accidentally log in production
        this.debug = window.location.protocol === "http:" && false;
        this.setInitialIndexes = ()=>{
            this.startingIndexFromBottom = this.props.items.length - 1;
            this.topIndex = Math.max(0, this.startingIndexFromBottom - this.amountVisible - this.bufferSize);
        };
        // Figure out which items need to be rendered, and which need to be measured.
        this.prepareItemsToRender = ()=>{
            const { items: items } = this.props;
            const selection = items.slice(this.topIndex, this.startingIndexFromBottom + 1);
            let tempItemMeasureList = [];
            for(let i = 0; i < selection.length; i++){
                const item = selection[i];
                const key = item.id;
                if (!this.elementSizes[key] || this.elementSizes[key] && this.elementSizes[key].hasReactions !== $7123ce532b8af82d$var$hasReactions(item)) tempItemMeasureList.push(item);
            }
            if (tempItemMeasureList.length > 0) this.measureItems(tempItemMeasureList);
            else this.setState({
                itemsToRender: selection,
                itemsToMeausure: []
            });
        };
        this.measureItems = (items)=>{
            this.itemsToMeausure = items.length;
            this.itemsMeasued = 0;
            this.setState({
                itemsToMeausure: items
            });
        };
        this.setElementSize = (id, size)=>{
            this.elementSizes[id] = size;
            this.itemsMeasued++;
            this.heightToAdd += size.height + this.spacingBetweenItems;
            if (this.itemsMeasued === this.itemsToMeausure) this.onItemsMeasured();
        };
        this.onItemsMeasured = ()=>{
            this.prepareItemsToRender();
        };
        this.handleScroll = ()=>{
            if (this.viewportElemRef.current) {
                const MIN_SCROLL = 50;
                const newPos = this.viewportElemRef.current.scrollTop;
                if (newPos < this.distanceLeftBeforeLoadMore && this.heightAdded > 0) {
                    this.log("we added height but safari has not yet caught on, so ignore for now", newPos, this.heightAdded);
                    return;
                } else this.heightAdded = 0;
                this.log("Scrolling", newPos, this.heightAdded, "scrollHeight", this.viewportElemRef.current.scrollHeight, "scrollHeight - clientHeight - distanceLeftBeforeLoadMore", this.viewportElemRef.current.scrollHeight - this.viewportElemRef.current.clientHeight - this.distanceLeftBeforeLoadMore, "topIndex", this.topIndex, "startingIndexFromBottom", this.startingIndexFromBottom, "items.length", this.props.items.length, "currentAction", this.currentAction);
                const thresHold = this.viewportElemRef.current.scrollHeight - this.viewportElemRef.current.clientHeight - MIN_SCROLL;
                if (newPos < thresHold && this.lastScrollPosition > thresHold) {
                    // Did the user UP scroll past the threshold?
                    this.log("Scrolled Back");
                    this.props.onScrollBack();
                } else if (newPos > thresHold && this.lastScrollPosition < thresHold && this.startingIndexFromBottom === this.props.items.length - 1) {
                    // Or did the user DOWN scroll past the threshold?
                    this.log("Scrolled to Bottom");
                    this.props.onScrollToBottom();
                }
                // Passed the {this.distanceLeftBeforeLoadMore} top threshold
                if (this.state.autoLoadEnabled && newPos < this.distanceLeftBeforeLoadMore && !this.isLoadingMore && this.heightAdded == 0) {
                    if (this.topIndex === 0) {
                        this.log("Load more items");
                        this.loadMore();
                    } else if (this.currentAction !== "addingToTop") {
                        this.log("add to top");
                        this.addToTop(50);
                    }
                }
                // If at bottom
                if (newPos > this.viewportElemRef.current.scrollHeight - this.viewportElemRef.current.clientHeight - this.distanceLeftBeforeLoadMore && newPos > this.distanceLeftBeforeLoadMore) {
                    if (this.currentAction !== "addingToBottom") {
                        this.log("add to bottom, from scroll handler");
                        this.addToBottom(50);
                    }
                }
                this.lastScrollPosition = newPos;
            }
        };
        this.scrollToBottomHandler = ()=>{
            // If the virtual list no longer has the latest item at the bottom, we reset the indexes and prepare the items to render.
            if (this.startingIndexFromBottom != this.props.items.length - 1) {
                this.setInitialIndexes();
                this.prepareItemsToRender();
            } else this.scrollToBottom();
        };
        this.scrollToBottom = ()=>{
            this.log("Scrolling to bottom");
            if (this.viewportElemRef.current && this.props.shouldAutoScrollRef.current) {
                this.log("setting scrolltop :: 1");
                this.log("setting scrolltop :: 2");
                this.viewportElemRef.current.scrollTop = this.viewportElemRef.current.scrollHeight;
            }
        };
        this.loadMore = async ()=>{
            if (this.isLoadingMore) return;
            this.isLoadingMore = true;
            this.setState({
                isLoadingMore: true
            });
            // Simulate loading more items
            const firstItem = this.props.items[0];
            if (!firstItem) return;
            const newItems = await this.getMoreItems((0, $aTRs6.FEED_MESSAGES_TO_LOAD));
            this.log("Loaded more items", newItems.length);
            this.newItemsAddedToTop = newItems.length;
            this.props.dispatch((0, $kyBxf.addItemsToTop)(newItems));
            this.log(newItems.length === (0, $aTRs6.FEED_MESSAGES_TO_LOAD), newItems.length, (0, $aTRs6.FEED_MESSAGES_TO_LOAD));
            this.setState({
                isLoadingMore: false,
                // If less than FEED_MESSAGES_TO_LOAD items are loaded, that means that there are no more to load.
                hasMoreToLoad: newItems.length === (0, $aTRs6.FEED_MESSAGES_TO_LOAD)
            });
            this.isLoadingMore = false;
        };
        this.handleAddMoreButton = ()=>{
            if (this.topIndex === 0) this.loadMore();
            else if (this.currentAction !== "addingToTop") this.addToTop(50);
        };
        this.getMoreItems = async (amount)=>{
            const firstMessage = this.props.items[0];
            if (!firstMessage) return [];
            parseInt(firstMessage.timestamp);
            const newMessages = await $f9aoP.lastChats(this.props.locationId, parseInt(firstMessage.timestamp), amount);
            return newMessages;
        };
        this.state = {
            itemsToRender: [],
            itemsToMeausure: [],
            isLoadingMore: false,
            hasMoreToLoad: false,
            // Disable auto load for touch devices. This is due to scroll events being triggered differently on iOS devices causing unpredictable behavior.
            // Touch device users simply have to click the "Load More" button to load more items. This only affects users that want to see a significant amount of chat history.
            autoLoadEnabled: !(0, $jLk8j.isTouchDevice)()
        };
    }
    componentDidMount() {
        this.prepareItemsToRender();
        this.props.scrollToBottomRef.current = this.scrollToBottomHandler;
    }
    componentDidUpdate(prevProps, prevState) {
        this.log("FeedScroller componentDidUpdate");
        if (this.newItemsAddedToTop > 0 && prevProps.items.length + this.newItemsAddedToTop === this.props.items.length) {
            this.log("case 1");
            // If new items are added to the top, we need to adjust the starting index from the bottom.
            // We basically need to move the starting index from the bottom up by the number of new items added so there should be no change.
            this.topIndex += this.newItemsAddedToTop;
            this.startingIndexFromBottom += this.newItemsAddedToTop;
            this.newItemsAddedToTop = 0;
            this.prepareItemsToRender();
            setTimeout(()=>{
                this.addToTop(20);
            }, 100);
            return;
        }
        // If less than FEED_MESSAGES_TO_LOAD items are loaded, that means that there are no more to load.
        // If FEED_MESSAGES_TO_LOAD items are loaded, we can assume that there are more items to load.
        // Currently there's no way to but since we load 500 at a time we can assume this is the max.
        if (prevProps.items.length === 0 && this.props.items.length === (0, $aTRs6.FEED_MESSAGES_TO_LOAD)) {
            this.log("case 2");
            this.setState({
                hasMoreToLoad: true
            });
        }
        // If there are items, and we haven't set the starting index from the bottom, do so.
        // Once set, the starting index from the bottom will never go to 0, so it's safe to assume this only happens once when the component mounts, and the chat messages have been loaded.
        // OR
        // If new items are added, we also need to scroll to the bottom.
        if (this.props.items.length > 0 && this.startingIndexFromBottom === -1 || prevProps.items.length < this.props.items.length && this.props.shouldAutoScrollRef.current) {
            this.log("case 3");
            this.setInitialIndexes();
            this.prepareItemsToRender();
            return;
        }
        if (prevProps.items !== this.props.items || prevProps.feedUpdateTicker !== this.props.feedUpdateTicker) {
            this.log("case 4");
            this.prepareItemsToRender();
        }
        if (prevProps.feedUpdateTicker !== this.props.feedUpdateTicker && this.props.shouldAutoScrollRef.current) {
            this.log("case 5");
            this.scrollToBottom();
        }
        if (prevState.itemsToRender !== this.state.itemsToRender) {
            this.log("case 6");
            if (this.props.shouldAutoScrollRef.current) {
                this.log("case 6.1");
                this.scrollToBottom();
            } else if (prevState.itemsToRender[1] && this.state.itemsToRender[0] && prevState.itemsToRender[1].id === this.state.itemsToRender[0].id) {
                this.log("case 6.2");
                // When one item is added at the bottom, one is removed from the top. If this is the case, we need to adjust the scroll position to keep the same item in view.
                const heightOfRemovedElement = this.elementSizes[prevState.itemsToRender[0].id].height;
                this.log("setting scrolltop :: 2");
                this.viewportElemRef.current.scrollTop = this.viewportElemRef.current.scrollTop - heightOfRemovedElement;
            } else if (this.currentAction === "addingToBottom" && this.removingFromTopCount > 0) {
                this.log("case 6.3 - removingFromTopCount:", this.removingFromTopCount);
                let totalHeightOfRemovedElements = 0;
                for(let i = 0; i < this.removingFromTopCount; i++)if (prevState.itemsToRender[i]) {
                    const key = prevState.itemsToRender[i].id;
                    totalHeightOfRemovedElements += this.elementSizes[key].height;
                }
                this.log("case 6.3.1 - totalHeightOfRemovedElements:", totalHeightOfRemovedElements);
                this.viewportElemRef.current.scrollTop = this.viewportElemRef.current.scrollTop - totalHeightOfRemovedElements;
                this.removingFromTopCount = 0;
                this.currentAction = null;
            }
            if (this.currentAction === "addingToTop") {
                this.log("case 6.4");
                this.viewportElemRef.current.scrollTop = this.viewportElemRef.current.scrollTop + this.heightToAdd;
                this.heightAdded = this.heightToAdd;
                this.currentAction = null;
                // Manually trigger scroll handle for safari.
                this.handleScroll();
                var forceRepaint = this.viewportElemRef.current.offsetHeight;
            }
        }
    }
    addToTop(amount) {
        this.startingIndexFromBottom = Math.max(this.amountVisible + this.bufferSize, this.startingIndexFromBottom - amount);
        this.topIndex = Math.max(0, this.startingIndexFromBottom - this.amountVisible - this.bufferSize);
        this.currentAction = "addingToTop";
        this.heightToAdd = 0;
        this.prepareItemsToRender();
    }
    addToBottom(amount) {
        const newBottomIndex = Math.min(this.props.items.length - 1, Math.max(this.amountVisible, this.startingIndexFromBottom + amount + this.bufferSize));
        if (newBottomIndex === this.startingIndexFromBottom) // Already at bottom
        return;
        this.log("adding to bottom", this.startingIndexFromBottom, newBottomIndex);
        this.removingFromTopCount += newBottomIndex - this.startingIndexFromBottom;
        this.startingIndexFromBottom = newBottomIndex;
        this.topIndex = Math.max(0, this.startingIndexFromBottom - this.amountVisible - this.bufferSize);
        this.currentAction = "addingToBottom";
        this.heightToAdd = 0;
        this.prepareItemsToRender();
    }
    render() {
        const offsetTop = 100;
        const paddingBottom = 0;
        const { itemsToRender: itemsToRender, itemsToMeausure: itemsToMeausure } = this.state;
        let totalHeight = offsetTop;
        const renderItems = [];
        for(let i = 0; i < itemsToRender.length; i++){
            const item = itemsToRender[i];
            const key = item.id;
            const size = this.elementSizes[key];
            if (item.id == "ba3034c2-9e08-4f24-8634-f35c785053e8") this.log("====", totalHeight);
            renderItems.push(/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $84c216d80fbe7187$export$1aea70eb3432192b,
                style: {
                    top: totalHeight
                },
                "data-id": item.id,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6217fa994cded089$export$2e2bcd8739ae039), {
                    item: item
                })
            }, key));
            if (size) totalHeight += size.height + this.spacingBetweenItems;
        }
        totalHeight += paddingBottom;
        this.log("totalHeight", totalHeight);
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $84c216d80fbe7187$export$8b47c0b3dfd40a35,
            ref: this.viewportElemRef,
            onScroll: this.handleScroll,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    children: itemsToMeausure.map((item, i)=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $b9d56bab3ac77896$export$2e2bcd8739ae039), {
                            visible: false,
                            onSizeUpdate: (size)=>{
                                if (size.height > 0) this.setElementSize(item.id, {
                                    ...size,
                                    type: item.type,
                                    hasReactions: $7123ce532b8af82d$var$hasReactions(item)
                                });
                            },
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6217fa994cded089$export$2e2bcd8739ae039), {
                                    item: item
                                })
                            })
                        }, item.id))
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $84c216d80fbe7187$export$b38bf4f33e9e4c25,
                    style: {
                        height: totalHeight
                    },
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: $84c216d80fbe7187$export$627c3754fccefc50,
                            style: {
                                width: "100%",
                                top: 0,
                                height: offsetTop,
                                // backgroundColor: 'red',
                                position: "absolute"
                            },
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $84c216d80fbe7187$export$49198556dad290f4,
                                onClick: this.handleAddMoreButton,
                                style: {
                                    display: this.state.autoLoadEnabled || this.state.isLoadingMore || !this.state.hasMoreToLoad && this.topIndex === 0 ? "none" : "block"
                                },
                                children: this.state.isLoadingMore ? "Loading..." : "Load More"
                            })
                        }),
                        renderItems
                    ]
                })
            ]
        });
    }
    log(...args) {
        if (this.debug) console.log(...args);
    }
}
function $7123ce532b8af82d$var$hasReactions(item) {
    // @ts-ignore
    return item.data && item.data.reactions && item.data.reactions.length > 0;
}
var $7123ce532b8af82d$export$2e2bcd8739ae039 = $7123ce532b8af82d$var$connector($7123ce532b8af82d$var$FeedScroller);




function $73c1e15f29108937$export$2e2bcd8739ae039() {
    const theme = (0, $cEIti.useTheme)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const { roomId: roomId, messages: msgs, feedUpdateTicker: feedUpdateTicker } = (0, $6lYLL.useAppSelector)((state)=>state.feed);
    const isFeedOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.location.isFeedOpen);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const { locationId: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const scrollToBottomRef = (0, $8FY87.useRef)(()=>{});
    const shouldAutoScrollRef = (0, $8FY87.useRef)(true);
    const chatbarRecentlyResizedRef = (0, $8FY87.useRef)(false);
    const chatbarResizeTimeoutRef = (0, $8FY87.useRef)(null);
    const [showScrollToBottom, setShowScrollToBottom] = (0, $8FY87.useState)(false);
    const enableScrollListenRef = (0, $8FY87.useRef)(false);
    (0, $8FY87.useEffect)(()=>{
        setTimeout(()=>{
            enableScrollListenRef.current = true;
        }, 1000);
    }, []);
    function handleScrollToBottomClick() {
        shouldAutoScrollRef.current = true;
        scrollToBottomRef.current();
        setShowScrollToBottom(false);
    }
    function handleScrollBack() {
        if (!enableScrollListenRef.current || chatbarRecentlyResizedRef.current) return;
        setShowScrollToBottom(true);
        shouldAutoScrollRef.current = false;
    }
    function handleScrollToBottom() {
        handleScrollToBottomClick();
    }
    function handleChatbarResize() {
        if (shouldAutoScrollRef.current) setTimeout(()=>{
            scrollToBottomRef.current();
        }, 100);
        chatbarRecentlyResizedRef.current = true;
        if (chatbarResizeTimeoutRef.current) clearTimeout(chatbarResizeTimeoutRef.current);
        chatbarResizeTimeoutRef.current = setTimeout(()=>{
            chatbarRecentlyResizedRef.current = false;
        }, 250);
    }
    const getBannedMessage = ()=>{
        const banMessages = {
            short_ban: theme.metadata?.shortBanMessage,
            permanent_ban: theme.metadata?.permanentBanMessage,
            rate_limit_exceeded: theme.metadata?.rateLimitExceededMessage
        };
        const reasonId = currentUserProfile?.bannedReason;
        const themedMessage = banMessages[reasonId];
        const unthemedMessage = (0, $7b01d1532fef6caf$export$312098c5853334bd)[reasonId];
        return themedMessage ?? unthemedMessage ?? (0, $7b01d1532fef6caf$export$55a3c46850dc5b73);
    };
    const renderInputContent = ()=>{
        if (!isFeedOpen) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8bba5d05b9c0eec1$export$2e2bcd8739ae039), {
            message: "This chat is closed"
        });
        if (currentUserProfile?.isBanned) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1d07a211b3430507$export$2e2bcd8739ae039), {
            message: getBannedMessage(),
            bannedUntil: currentUserProfile?.bannedUntil
        });
        return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $97cdf55e533ea365$export$2e2bcd8739ae039), {
            placeholder: "Write a message...",
            onResize: handleChatbarResize,
            locationId: id,
            isAdmin: currentUserProfile?.role === "superadmin"
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $84c216d80fbe7187$export$833919a382305440,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $84c216d80fbe7187$export$defe85febe8b728c,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7123ce532b8af82d$export$2e2bcd8739ae039), {
                        locationId: id,
                        items: roomId === id ? msgs : [],
                        feedUpdateTicker: feedUpdateTicker,
                        shouldAutoScrollRef: shouldAutoScrollRef,
                        scrollToBottomRef: scrollToBottomRef,
                        onScrollBack: handleScrollBack,
                        onScrollToBottom: handleScrollToBottom
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($84c216d80fbe7187$export$64282f34fe8ec365, {
                            [$84c216d80fbe7187$export$57bf213be019eeb0]: showScrollToBottom
                        }),
                        onClick: handleScrollToBottomClick,
                        iconType: "arrow-downward",
                        ariaLabel: "Resume auto scroll",
                        buttonStyle: "round"
                    })
                ]
            }),
            !isGuest && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $84c216d80fbe7187$export$b7e3ae3d7c15e42e,
                children: [
                    renderInputContent(),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dd58069b9f89d3cc$export$2e2bcd8739ae039), {})
                ]
            }),
            isGuest && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $84c216d80fbe7187$export$b0e94793d11e2864,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $dd58069b9f89d3cc$export$2e2bcd8739ae039), {})
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $9s93Y = parcelRequire("9s93Y");


var $1bTT8 = parcelRequire("1bTT8");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $kyBxf = parcelRequire("kyBxf");


var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $1bTT8 = parcelRequire("1bTT8");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $1bTT8 = parcelRequire("1bTT8");
var $426328bc4cbda5bf$export$53819c0e58f98d49;
var $426328bc4cbda5bf$export$3d1d5845bd0d1ff8;
var $426328bc4cbda5bf$export$a92a40d0fcb4cbe3;
var $426328bc4cbda5bf$export$17fa98cb055e8fa7;
var $426328bc4cbda5bf$export$a5833c2b43ca4340;
var $426328bc4cbda5bf$export$47511f9a6581d1d6;
var $426328bc4cbda5bf$export$dd1c05b92185401c;
var $426328bc4cbda5bf$export$8b28cf6cd00fe080;
var $426328bc4cbda5bf$export$186c650311ff0789;
var $426328bc4cbda5bf$export$6746fe0d9c9fab54;
var $426328bc4cbda5bf$export$2bcf359f0c20e94f;
var $426328bc4cbda5bf$export$2903d10d531d0ac0;
$426328bc4cbda5bf$export$53819c0e58f98d49 = `de9p6q_Countdown`;
$426328bc4cbda5bf$export$3d1d5845bd0d1ff8 = `de9p6q_Countdown__description`;
$426328bc4cbda5bf$export$a92a40d0fcb4cbe3 = `de9p6q_Countdown__timer`;
$426328bc4cbda5bf$export$17fa98cb055e8fa7 = `de9p6q_fontSizeH1`;
$426328bc4cbda5bf$export$a5833c2b43ca4340 = `de9p6q_fontSizeH2`;
$426328bc4cbda5bf$export$47511f9a6581d1d6 = `de9p6q_fontSizeH3`;
$426328bc4cbda5bf$export$dd1c05b92185401c = `de9p6q_fontSizeH4`;
$426328bc4cbda5bf$export$8b28cf6cd00fe080 = `de9p6q_fontSizeH5`;
$426328bc4cbda5bf$export$186c650311ff0789 = `de9p6q_fontSizeH6`;
$426328bc4cbda5bf$export$6746fe0d9c9fab54 = `de9p6q_fontSizeSmall`;
$426328bc4cbda5bf$export$2bcf359f0c20e94f = `de9p6q_fontSizeTiny`;
$426328bc4cbda5bf$export$2903d10d531d0ac0 = `de9p6q_fontSizep`;


const $99a58810b45ccf89$var$msSeconds = 1000;
const $99a58810b45ccf89$var$msMinutes = 60000;
const $99a58810b45ccf89$var$msDay = 86400000;
const $99a58810b45ccf89$var$msHour = 3600000;
const $99a58810b45ccf89$var$EMPTY_COUNTDOWN_CONTENT = {
    days: "--",
    hours: "--",
    minutes: "--",
    seconds: "--"
};
const $99a58810b45ccf89$var$ZERO_COUNTDOWN_CONTENT = {
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00"
};
function $99a58810b45ccf89$export$2e2bcd8739ae039({ startTime: startTime, endTime: endTime, description: description, omitDaysAndHoursIfEmpty: omitDaysAndHoursIfEmpty, className: className, maxPreCountdownSeconds: maxPreCountdownSeconds }) {
    const formatTimeLeft = ()=>{
        if (!endTime) return $99a58810b45ccf89$var$EMPTY_COUNTDOWN_CONTENT;
        const difference = (0, $1bTT8.msTimeDifferenceFromNow)(endTime);
        if (isNaN(difference)) return $99a58810b45ccf89$var$EMPTY_COUNTDOWN_CONTENT;
        if (difference <= 0) return $99a58810b45ccf89$var$ZERO_COUNTDOWN_CONTENT;
        const pad = (num)=>`${num}`.padStart(2, "0");
        const timeLeft = {
            days: pad(Math.floor(difference / $99a58810b45ccf89$var$msDay)),
            hours: pad(Math.floor(difference % $99a58810b45ccf89$var$msDay / $99a58810b45ccf89$var$msHour)),
            minutes: pad(Math.floor(difference % $99a58810b45ccf89$var$msHour / $99a58810b45ccf89$var$msMinutes)),
            seconds: pad(Math.floor(difference % $99a58810b45ccf89$var$msMinutes / $99a58810b45ccf89$var$msSeconds))
        };
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = (0, $8FY87.useState)(formatTimeLeft());
    (0, $8FY87.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setTimeLeft(formatTimeLeft());
        }, 1000);
        return ()=>clearTimeout(timer);
    }, [
        timeLeft
    ]);
    // Render pre-countdown, where 0 is when the main countdown begins
    if (startTime) {
        const secondsTillStart = Math.floor((0, $1bTT8.msTimeDifferenceFromNow)(startTime) % $99a58810b45ccf89$var$msMinutes / $99a58810b45ccf89$var$msSeconds);
        if (secondsTillStart > 0) {
            if (maxPreCountdownSeconds && secondsTillStart > maxPreCountdownSeconds) return null;
            return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($426328bc4cbda5bf$export$53819c0e58f98d49, className),
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $426328bc4cbda5bf$export$a92a40d0fcb4cbe3,
                    role: "timer",
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        children: [
                            secondsTillStart,
                            "..."
                        ]
                    })
                })
            });
        }
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($426328bc4cbda5bf$export$53819c0e58f98d49, className),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: $426328bc4cbda5bf$export$3d1d5845bd0d1ff8,
                children: description
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $426328bc4cbda5bf$export$a92a40d0fcb4cbe3,
                role: "timer",
                children: [
                    !(omitDaysAndHoursIfEmpty && timeLeft.days === "00") && /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        children: [
                            timeLeft.days,
                            ":"
                        ]
                    }),
                    !(omitDaysAndHoursIfEmpty && timeLeft.days === "00" && timeLeft.hours === "00") && /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        children: [
                            timeLeft.hours,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        children: [
                            timeLeft.minutes,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        children: timeLeft.seconds
                    })
                ]
            })
        ]
    });
}


var $78875a9c75db1b6e$exports = {};

$parcel$export($78875a9c75db1b6e$exports, "EventTimer", function () { return $78875a9c75db1b6e$export$40d0836f3faa4a61; }, function (v) { return $78875a9c75db1b6e$export$40d0836f3faa4a61 = v; });
$parcel$export($78875a9c75db1b6e$exports, "countdown", function () { return $78875a9c75db1b6e$export$f52e29715bba3529; }, function (v) { return $78875a9c75db1b6e$export$f52e29715bba3529 = v; });
$parcel$export($78875a9c75db1b6e$exports, "failed", function () { return $78875a9c75db1b6e$export$7ab64d539530aa6c; }, function (v) { return $78875a9c75db1b6e$export$7ab64d539530aa6c = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH1", function () { return $78875a9c75db1b6e$export$17fa98cb055e8fa7; }, function (v) { return $78875a9c75db1b6e$export$17fa98cb055e8fa7 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH2", function () { return $78875a9c75db1b6e$export$a5833c2b43ca4340; }, function (v) { return $78875a9c75db1b6e$export$a5833c2b43ca4340 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH3", function () { return $78875a9c75db1b6e$export$47511f9a6581d1d6; }, function (v) { return $78875a9c75db1b6e$export$47511f9a6581d1d6 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH4", function () { return $78875a9c75db1b6e$export$dd1c05b92185401c; }, function (v) { return $78875a9c75db1b6e$export$dd1c05b92185401c = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH5", function () { return $78875a9c75db1b6e$export$8b28cf6cd00fe080; }, function (v) { return $78875a9c75db1b6e$export$8b28cf6cd00fe080 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeH6", function () { return $78875a9c75db1b6e$export$186c650311ff0789; }, function (v) { return $78875a9c75db1b6e$export$186c650311ff0789 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeSmall", function () { return $78875a9c75db1b6e$export$6746fe0d9c9fab54; }, function (v) { return $78875a9c75db1b6e$export$6746fe0d9c9fab54 = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizeTiny", function () { return $78875a9c75db1b6e$export$2bcf359f0c20e94f; }, function (v) { return $78875a9c75db1b6e$export$2bcf359f0c20e94f = v; });
$parcel$export($78875a9c75db1b6e$exports, "fontSizep", function () { return $78875a9c75db1b6e$export$2903d10d531d0ac0; }, function (v) { return $78875a9c75db1b6e$export$2903d10d531d0ac0 = v; });
$parcel$export($78875a9c75db1b6e$exports, "graphic", function () { return $78875a9c75db1b6e$export$c96b99088d96cc6d; }, function (v) { return $78875a9c75db1b6e$export$c96b99088d96cc6d = v; });
$parcel$export($78875a9c75db1b6e$exports, "move", function () { return $78875a9c75db1b6e$export$d947e5f4f4c48d48; }, function (v) { return $78875a9c75db1b6e$export$d947e5f4f4c48d48 = v; });
$parcel$export($78875a9c75db1b6e$exports, "passed", function () { return $78875a9c75db1b6e$export$8d5242772230ad0c; }, function (v) { return $78875a9c75db1b6e$export$8d5242772230ad0c = v; });
$parcel$export($78875a9c75db1b6e$exports, "progressBar", function () { return $78875a9c75db1b6e$export$9d1298853f0e77f7; }, function (v) { return $78875a9c75db1b6e$export$9d1298853f0e77f7 = v; });
$parcel$export($78875a9c75db1b6e$exports, "shake", function () { return $78875a9c75db1b6e$export$267b06a7460aa7d3; }, function (v) { return $78875a9c75db1b6e$export$267b06a7460aa7d3 = v; });
$parcel$export($78875a9c75db1b6e$exports, "statusText", function () { return $78875a9c75db1b6e$export$42232bc57e78f1d3; }, function (v) { return $78875a9c75db1b6e$export$42232bc57e78f1d3 = v; });
var $78875a9c75db1b6e$export$40d0836f3faa4a61;
var $78875a9c75db1b6e$export$f52e29715bba3529;
var $78875a9c75db1b6e$export$7ab64d539530aa6c;
var $78875a9c75db1b6e$export$17fa98cb055e8fa7;
var $78875a9c75db1b6e$export$a5833c2b43ca4340;
var $78875a9c75db1b6e$export$47511f9a6581d1d6;
var $78875a9c75db1b6e$export$dd1c05b92185401c;
var $78875a9c75db1b6e$export$8b28cf6cd00fe080;
var $78875a9c75db1b6e$export$186c650311ff0789;
var $78875a9c75db1b6e$export$6746fe0d9c9fab54;
var $78875a9c75db1b6e$export$2bcf359f0c20e94f;
var $78875a9c75db1b6e$export$2903d10d531d0ac0;
var $78875a9c75db1b6e$export$c96b99088d96cc6d;
var $78875a9c75db1b6e$export$d947e5f4f4c48d48;
var $78875a9c75db1b6e$export$8d5242772230ad0c;
var $78875a9c75db1b6e$export$9d1298853f0e77f7;
var $78875a9c75db1b6e$export$267b06a7460aa7d3;
var $78875a9c75db1b6e$export$42232bc57e78f1d3;
$78875a9c75db1b6e$export$40d0836f3faa4a61 = `-4UvlG_EventTimer`;
$78875a9c75db1b6e$export$f52e29715bba3529 = `-4UvlG_countdown`;
$78875a9c75db1b6e$export$7ab64d539530aa6c = `-4UvlG_failed`;
$78875a9c75db1b6e$export$17fa98cb055e8fa7 = `-4UvlG_fontSizeH1`;
$78875a9c75db1b6e$export$a5833c2b43ca4340 = `-4UvlG_fontSizeH2`;
$78875a9c75db1b6e$export$47511f9a6581d1d6 = `-4UvlG_fontSizeH3`;
$78875a9c75db1b6e$export$dd1c05b92185401c = `-4UvlG_fontSizeH4`;
$78875a9c75db1b6e$export$8b28cf6cd00fe080 = `-4UvlG_fontSizeH5`;
$78875a9c75db1b6e$export$186c650311ff0789 = `-4UvlG_fontSizeH6`;
$78875a9c75db1b6e$export$6746fe0d9c9fab54 = `-4UvlG_fontSizeSmall`;
$78875a9c75db1b6e$export$2bcf359f0c20e94f = `-4UvlG_fontSizeTiny`;
$78875a9c75db1b6e$export$2903d10d531d0ac0 = `-4UvlG_fontSizep`;
$78875a9c75db1b6e$export$c96b99088d96cc6d = `-4UvlG_graphic`;
$78875a9c75db1b6e$export$d947e5f4f4c48d48 = `-4UvlG_move`;
$78875a9c75db1b6e$export$d947e5f4f4c48d48;
$78875a9c75db1b6e$export$8d5242772230ad0c = `-4UvlG_passed`;
$78875a9c75db1b6e$export$9d1298853f0e77f7 = `-4UvlG_progressBar`;
$78875a9c75db1b6e$export$267b06a7460aa7d3 = `-4UvlG_shake`;
$78875a9c75db1b6e$export$267b06a7460aa7d3;
$78875a9c75db1b6e$export$42232bc57e78f1d3 = `-4UvlG_statusText`;


var $18b5d956089d0964$export$a19087a9dd8fcc34;
(function(EventTimerStatus) {
    EventTimerStatus["passed"] = "passed";
    EventTimerStatus["failed"] = "failed";
    EventTimerStatus["timing"] = "timing";
})($18b5d956089d0964$export$a19087a9dd8fcc34 || ($18b5d956089d0964$export$a19087a9dd8fcc34 = {}));
function $18b5d956089d0964$export$2e2bcd8739ae039({ startTime: startTime, endTime: endTime, status: status, imageUrl: imageUrl, className: className }) {
    const theme = (0, $cEIti.useTheme)();
    const customData = theme.customJSON.typeChallenge;
    const timeRemaining = (0, $1bTT8.msTimeDifferenceFromNow)(endTime);
    const getPercentOfTimeRemaining = ()=>{
        const duration = (0, $1bTT8.msTimeDifferenceBetweenUTCDates)(startTime, endTime);
        return timeRemaining / duration * 100;
    };
    const [percentOfTimeRemaining, setPercentOfTimeRemaining] = (0, $8FY87.useState)(getPercentOfTimeRemaining());
    const [animationDuration, setAnimationDuration] = (0, $8FY87.useState)(timeRemaining);
    (0, $8FY87.useEffect)(()=>{
        // Reset progressBar
        setAnimationDuration(0);
        setPercentOfTimeRemaining(getPercentOfTimeRemaining());
        setTimeout(()=>{
            // Set to 0% remaining to trigger transition
            setAnimationDuration(timeRemaining);
            setPercentOfTimeRemaining(0);
        }, 0);
    }, [
        startTime
    ]);
    const renderText = ()=>{
        if (status === "passed" || status === "failed") {
            const text = status === "passed" ? "Passed!" : "Failed!";
            return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: $78875a9c75db1b6e$exports.statusText,
                children: text
            });
        }
        return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99a58810b45ccf89$export$2e2bcd8739ae039), {
            className: $78875a9c75db1b6e$exports.countdown,
            endTime: endTime,
            omitDaysAndHoursIfEmpty: true,
            startTime: startTime,
            maxPreCountdownSeconds: 3
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($78875a9c75db1b6e$exports.EventTimer, $78875a9c75db1b6e$exports[status], className),
        style: {
            ...customData?.timerMask && {
                maskImage: `url("${customData.timerMask}")`
            }
        },
        children: [
            status === "timing" && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $78875a9c75db1b6e$exports.progressBar,
                style: {
                    transitionDuration: `${animationDuration}ms`,
                    left: `${percentOfTimeRemaining}%`
                }
            }),
            imageUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                "aria-hidden": "true",
                className: $78875a9c75db1b6e$exports.graphic,
                style: {
                    backgroundImage: `url(${imageUrl})`
                }
            }),
            renderText()
        ]
    });
}



var $cEIti = parcelRequire("cEIti");
var $9cc3905546b283ea$exports = {};

$parcel$export($9cc3905546b283ea$exports, "SidebarEvent", function () { return $9cc3905546b283ea$export$a55435babebd3633; }, function (v) { return $9cc3905546b283ea$export$a55435babebd3633 = v; });
$parcel$export($9cc3905546b283ea$exports, "SidebarEventContainer", function () { return $9cc3905546b283ea$export$1273754aee85c9c6; }, function (v) { return $9cc3905546b283ea$export$1273754aee85c9c6 = v; });
$parcel$export($9cc3905546b283ea$exports, "dismissButton", function () { return $9cc3905546b283ea$export$c4e59d0e70bdf50f; }, function (v) { return $9cc3905546b283ea$export$c4e59d0e70bdf50f = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH1", function () { return $9cc3905546b283ea$export$17fa98cb055e8fa7; }, function (v) { return $9cc3905546b283ea$export$17fa98cb055e8fa7 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH2", function () { return $9cc3905546b283ea$export$a5833c2b43ca4340; }, function (v) { return $9cc3905546b283ea$export$a5833c2b43ca4340 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH3", function () { return $9cc3905546b283ea$export$47511f9a6581d1d6; }, function (v) { return $9cc3905546b283ea$export$47511f9a6581d1d6 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH4", function () { return $9cc3905546b283ea$export$dd1c05b92185401c; }, function (v) { return $9cc3905546b283ea$export$dd1c05b92185401c = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH5", function () { return $9cc3905546b283ea$export$8b28cf6cd00fe080; }, function (v) { return $9cc3905546b283ea$export$8b28cf6cd00fe080 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeH6", function () { return $9cc3905546b283ea$export$186c650311ff0789; }, function (v) { return $9cc3905546b283ea$export$186c650311ff0789 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeSmall", function () { return $9cc3905546b283ea$export$6746fe0d9c9fab54; }, function (v) { return $9cc3905546b283ea$export$6746fe0d9c9fab54 = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizeTiny", function () { return $9cc3905546b283ea$export$2bcf359f0c20e94f; }, function (v) { return $9cc3905546b283ea$export$2bcf359f0c20e94f = v; });
$parcel$export($9cc3905546b283ea$exports, "fontSizep", function () { return $9cc3905546b283ea$export$2903d10d531d0ac0; }, function (v) { return $9cc3905546b283ea$export$2903d10d531d0ac0 = v; });
$parcel$export($9cc3905546b283ea$exports, "incorrect-shake", function () { return $9cc3905546b283ea$export$5e35bb83a701940b; }, function (v) { return $9cc3905546b283ea$export$5e35bb83a701940b = v; });
$parcel$export($9cc3905546b283ea$exports, "incorrectShake", function () { return $9cc3905546b283ea$export$dea760feae1e4d6b; }, function (v) { return $9cc3905546b283ea$export$dea760feae1e4d6b = v; });
$parcel$export($9cc3905546b283ea$exports, "instruction", function () { return $9cc3905546b283ea$export$76e224aa2fb0aee8; }, function (v) { return $9cc3905546b283ea$export$76e224aa2fb0aee8 = v; });
$parcel$export($9cc3905546b283ea$exports, "intro", function () { return $9cc3905546b283ea$export$affaf52642033041; }, function (v) { return $9cc3905546b283ea$export$affaf52642033041 = v; });
$parcel$export($9cc3905546b283ea$exports, "isHidden", function () { return $9cc3905546b283ea$export$ee695c13482bb5dd; }, function (v) { return $9cc3905546b283ea$export$ee695c13482bb5dd = v; });
$parcel$export($9cc3905546b283ea$exports, "lowlight", function () { return $9cc3905546b283ea$export$f4b13d60f20dd3ed; }, function (v) { return $9cc3905546b283ea$export$f4b13d60f20dd3ed = v; });
$parcel$export($9cc3905546b283ea$exports, "text", function () { return $9cc3905546b283ea$export$6f093cfa640b7166; }, function (v) { return $9cc3905546b283ea$export$6f093cfa640b7166 = v; });
$parcel$export($9cc3905546b283ea$exports, "timer", function () { return $9cc3905546b283ea$export$9dc4ecf953986f04; }, function (v) { return $9cc3905546b283ea$export$9dc4ecf953986f04 = v; });
$parcel$export($9cc3905546b283ea$exports, "winString", function () { return $9cc3905546b283ea$export$a4d51d5ba5f63ce1; }, function (v) { return $9cc3905546b283ea$export$a4d51d5ba5f63ce1 = v; });
var $9cc3905546b283ea$export$a55435babebd3633;
var $9cc3905546b283ea$export$1273754aee85c9c6;
var $9cc3905546b283ea$export$c4e59d0e70bdf50f;
var $9cc3905546b283ea$export$17fa98cb055e8fa7;
var $9cc3905546b283ea$export$a5833c2b43ca4340;
var $9cc3905546b283ea$export$47511f9a6581d1d6;
var $9cc3905546b283ea$export$dd1c05b92185401c;
var $9cc3905546b283ea$export$8b28cf6cd00fe080;
var $9cc3905546b283ea$export$186c650311ff0789;
var $9cc3905546b283ea$export$6746fe0d9c9fab54;
var $9cc3905546b283ea$export$2bcf359f0c20e94f;
var $9cc3905546b283ea$export$2903d10d531d0ac0;
var $9cc3905546b283ea$export$5e35bb83a701940b;
var $9cc3905546b283ea$export$dea760feae1e4d6b;
var $9cc3905546b283ea$export$76e224aa2fb0aee8;
var $9cc3905546b283ea$export$affaf52642033041;
var $9cc3905546b283ea$export$ee695c13482bb5dd;
var $9cc3905546b283ea$export$f4b13d60f20dd3ed;
var $9cc3905546b283ea$export$6f093cfa640b7166;
var $9cc3905546b283ea$export$9dc4ecf953986f04;
var $9cc3905546b283ea$export$a4d51d5ba5f63ce1;
$9cc3905546b283ea$export$a55435babebd3633 = `KB8y1G_SidebarEvent`;
$9cc3905546b283ea$export$1273754aee85c9c6 = `KB8y1G_SidebarEventContainer`;
$9cc3905546b283ea$export$c4e59d0e70bdf50f = `KB8y1G_dismissButton`;
$9cc3905546b283ea$export$17fa98cb055e8fa7 = `KB8y1G_fontSizeH1`;
$9cc3905546b283ea$export$a5833c2b43ca4340 = `KB8y1G_fontSizeH2`;
$9cc3905546b283ea$export$47511f9a6581d1d6 = `KB8y1G_fontSizeH3`;
$9cc3905546b283ea$export$dd1c05b92185401c = `KB8y1G_fontSizeH4`;
$9cc3905546b283ea$export$8b28cf6cd00fe080 = `KB8y1G_fontSizeH5`;
$9cc3905546b283ea$export$186c650311ff0789 = `KB8y1G_fontSizeH6`;
$9cc3905546b283ea$export$6746fe0d9c9fab54 = `KB8y1G_fontSizeSmall`;
$9cc3905546b283ea$export$2bcf359f0c20e94f = `KB8y1G_fontSizeTiny`;
$9cc3905546b283ea$export$2903d10d531d0ac0 = `KB8y1G_fontSizep`;
$9cc3905546b283ea$export$5e35bb83a701940b = `KB8y1G_incorrect-shake`;
$9cc3905546b283ea$export$5e35bb83a701940b;
$9cc3905546b283ea$export$dea760feae1e4d6b = `KB8y1G_incorrectShake`;
$9cc3905546b283ea$export$76e224aa2fb0aee8 = `KB8y1G_instruction`;
$9cc3905546b283ea$export$affaf52642033041 = `KB8y1G_intro`;
$9cc3905546b283ea$export$ee695c13482bb5dd = `KB8y1G_isHidden`;
$9cc3905546b283ea$export$f4b13d60f20dd3ed = `KB8y1G_lowlight`;
$9cc3905546b283ea$export$6f093cfa640b7166 = `KB8y1G_text`;
$9cc3905546b283ea$export$9dc4ecf953986f04 = `KB8y1G_timer`;
$9cc3905546b283ea$export$a4d51d5ba5f63ce1 = `KB8y1G_winString`;


// How long event UI continues to be visible once event has finished
const $362511cc35f84c3e$var$EXTRA_VIEWING_TIME_MS = 4000;
// Animation in and out duration
const $362511cc35f84c3e$var$ANIMATION_DURATION_MS = 200;
// Counts down from 3 before event begins
const $362511cc35f84c3e$var$PRECOUNTDOWN_LENGTH_MS = 3000;
function $362511cc35f84c3e$export$2e2bcd8739ae039() {
    const theme = (0, $cEIti.useTheme)();
    const customData = theme.customJSON.typeChallenge;
    const containerRef = (0, $8FY87.useRef)(null);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const currentEvent = (0, $6lYLL.useAppSelector)((state)=>state.feed.currentEvent);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const isSidebarOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isSidebarOpen);
    const [isIncorrect, setIsIncorrect] = (0, $8FY87.useState)(false);
    const [isVisible, setIsVisible] = (0, $8FY87.useState)(false);
    const [isPreCountdown, setIsPreCountdown] = (0, $8FY87.useState)(false);
    const currentUserParticipantData = currentEvent?.participants?.find((participant)=>participant.profile.userID === currentUserProfile?.userID);
    const stopAllEventSounds = ()=>{
        audio.stop("event__countdown");
        audio.stop("event__start");
        audio.stop("event__success");
        audio.stop("event__fail");
    };
    (0, $8FY87.useEffect)(()=>{
        // If user entered an incorrect answer
        if (currentUserParticipantData?.eventData?.success === null) {
            setIsIncorrect(true);
            setTimeout(()=>setIsIncorrect(false), 500);
        }
    }, [
        currentUserParticipantData?.lastUpdated
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Play countdown / start sound
        if (isVisible) {
            stopAllEventSounds();
            if (isPreCountdown) audio.play("event__countdown");
            else audio.play("event__start");
        }
        return ()=>{
            audio.stop("event__countdown");
            audio.stop("event__start");
        };
    }, [
        isPreCountdown
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Play success / fail sound
        if (currentUserParticipantData?.eventData?.success === true) {
            stopAllEventSounds();
            audio.play("event__success");
        }
        if (currentUserParticipantData?.eventData?.success === false) {
            stopAllEventSounds();
            audio.play("event__fail");
        }
        return ()=>{
            audio.stop("event__success");
            audio.stop("event__fail");
        };
    }, [
        currentUserParticipantData?.eventData?.success
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Set timeouts for pre-countdown, start and end of event
        let timeouts = [];
        if (currentEvent) {
            const timeUntilEventStarts = (0, $1bTT8.msTimeDifferenceFromNow)(currentEvent.startTime);
            const timeUntilCountdownShows = timeUntilEventStarts - ($362511cc35f84c3e$var$PRECOUNTDOWN_LENGTH_MS + 500);
            const timeUntilEventEnds = (0, $1bTT8.msTimeDifferenceFromNow)(currentEvent.endTime);
            if (timeUntilCountdownShows > 0 && timeUntilCountdownShows < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    setIsVisible(true);
                    setIsPreCountdown(true);
                    dispatch((0, $kyBxf.setCurrentEventIsActive)(true));
                    dispatch((0, $baXkz.closeProfile)());
                    if (!isSidebarOpen) dispatch((0, $baXkz.queueAchievement)({
                        actionPrefix: "An Event is starting",
                        action: "Head to chat now",
                        type: "danger",
                        icon: "event",
                        hasLineBreak: true
                    }));
                }, timeUntilCountdownShows);
                timeouts.push(timeout);
            }
            if (timeUntilEventStarts > 0 && timeUntilEventStarts < (0, $1bTT8.MAX_TIMEOUT)) {
                const timeout = setTimeout(()=>{
                    setIsPreCountdown(false);
                }, timeUntilEventStarts);
                timeouts.push(timeout);
            }
            if (timeUntilEventEnds > 0 && timeUntilEventEnds < (0, $1bTT8.MAX_TIMEOUT)) {
                const endOfEventTimeout = setTimeout(()=>{
                    dispatch((0, $kyBxf.setCurrentEventIsActive)(false));
                }, timeUntilEventEnds);
                timeouts.push(endOfEventTimeout);
                const eventHidesTimeout = setTimeout(()=>{
                    setIsVisible(false);
                    setTimeout(()=>{
                        dispatch((0, $kyBxf.clearCurrentEvent)());
                    }, $362511cc35f84c3e$var$ANIMATION_DURATION_MS + 10);
                }, timeUntilEventEnds + $362511cc35f84c3e$var$EXTRA_VIEWING_TIME_MS);
                timeouts.push(eventHidesTimeout);
            }
        }
        return ()=>{
            timeouts.forEach((timeout)=>{
                clearTimeout(timeout);
            });
        };
    }, [
        currentEvent?.startTime,
        currentEvent?.endTime
    ]);
    const getTimerStatus = ()=>{
        if (currentUserParticipantData?.eventData?.success === true) return (0, $18b5d956089d0964$export$a19087a9dd8fcc34).passed;
        if (currentUserParticipantData?.eventData?.success === false) return (0, $18b5d956089d0964$export$a19087a9dd8fcc34).failed;
        return (0, $18b5d956089d0964$export$a19087a9dd8fcc34).timing;
    };
    const renderTypeChallenge = ()=>{
        const text = customData?.text;
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($9cc3905546b283ea$exports.SidebarEvent, $9cc3905546b283ea$exports[status]),
            style: customData?.sidebarOverlayImage ? {
                backgroundImage: `url("${customData.sidebarOverlayImage}")`
            } : {},
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $9cc3905546b283ea$exports.text,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            className: $9cc3905546b283ea$exports.intro,
                            children: text?.intro ?? "An event is happening!"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                            className: $9cc3905546b283ea$exports.instruction,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: $9cc3905546b283ea$exports.lowlight,
                                    children: "Type"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                    className: $9cc3905546b283ea$exports.winString,
                                    children: [
                                        "\u201C",
                                        currentEvent.eventParams.winString,
                                        "\u201D"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                    className: $9cc3905546b283ea$exports.lowlight,
                                    children: text?.instructionEnd ?? "to succeed"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $18b5d956089d0964$export$2e2bcd8739ae039), {
                    startTime: currentEvent.startTime,
                    endTime: currentEvent.endTime,
                    status: getTimerStatus(),
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($9cc3905546b283ea$exports.timer, {
                        [$9cc3905546b283ea$exports.incorrectShake]: isIncorrect
                    }),
                    imageUrl: customData?.timerOverlayImage
                })
            ]
        });
    };
    (0, $8FY87.useEffect)(()=>{
        // When mobile keyboard opens, move event UI down so it can still be seen
        if (!window.visualViewport) return;
        const handleVisualViewportScroll = ()=>{
            if (!containerRef.current) return;
            const amount = document.documentElement?.clientHeight - window.visualViewport?.height;
            const containerIsOffScreen = amount > 70;
            if (containerIsOffScreen) {
                containerRef.current.style.transition = "top 200ms ease-out 200ms";
                containerRef.current.style.top = `${amount}px`;
            } else {
                containerRef.current.style.transition = "none";
                containerRef.current.style.top = "0";
            }
        };
        const throttledHandleVisualViewportScroll = (0, (/*@__PURE__*/$parcel$interopDefault($45aa3beddb37ced9$exports)))(handleVisualViewportScroll, 500);
        window.visualViewport.addEventListener("scroll", throttledHandleVisualViewportScroll);
        return ()=>{
            window.visualViewport.removeEventListener("scroll", throttledHandleVisualViewportScroll);
        };
    }, []);
    const renderEvent = ()=>{
        switch(currentEvent.eventType){
            case "typechallenge":
                return renderTypeChallenge();
            default:
                return null;
        }
    };
    const handleEventDismiss = ()=>{
        stopAllEventSounds();
        setIsVisible(false);
        setTimeout(()=>{
            dispatch((0, $kyBxf.clearCurrentEvent)());
        }, 210);
    };
    if (currentEvent) return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        ref: containerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($9cc3905546b283ea$exports.SidebarEventContainer, {
            [$9cc3905546b283ea$exports.isHidden]: !isVisible
        }),
        "aria-live": "polite",
        inert: !isVisible ? "" : undefined,
        "aria-hidden": !isVisible,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                iconType: "close",
                ariaLabel: "Dismiss event",
                title: "Dismiss event",
                buttonStyle: "icon",
                className: $9cc3905546b283ea$exports.dismissButton,
                onClick: handleEventDismiss,
                disabled: !isVisible
            }),
            renderEvent()
        ]
    });
    return null;
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $86f05cbbb857c93c$export$5558409624097e27;
var $86f05cbbb857c93c$export$8ce1fd94bee2f412;
var $86f05cbbb857c93c$export$17fa98cb055e8fa7;
var $86f05cbbb857c93c$export$a5833c2b43ca4340;
var $86f05cbbb857c93c$export$47511f9a6581d1d6;
var $86f05cbbb857c93c$export$dd1c05b92185401c;
var $86f05cbbb857c93c$export$8b28cf6cd00fe080;
var $86f05cbbb857c93c$export$186c650311ff0789;
var $86f05cbbb857c93c$export$6746fe0d9c9fab54;
var $86f05cbbb857c93c$export$2bcf359f0c20e94f;
var $86f05cbbb857c93c$export$2903d10d531d0ac0;
var $86f05cbbb857c93c$export$6f093cfa640b7166;
var $86f05cbbb857c93c$export$664c6d24e3175067;
$86f05cbbb857c93c$export$5558409624097e27 = `PkhzSW_FailedOverlay`;
$86f05cbbb857c93c$export$8ce1fd94bee2f412 = `PkhzSW_background`;
$86f05cbbb857c93c$export$17fa98cb055e8fa7 = `PkhzSW_fontSizeH1`;
$86f05cbbb857c93c$export$a5833c2b43ca4340 = `PkhzSW_fontSizeH2`;
$86f05cbbb857c93c$export$47511f9a6581d1d6 = `PkhzSW_fontSizeH3`;
$86f05cbbb857c93c$export$dd1c05b92185401c = `PkhzSW_fontSizeH4`;
$86f05cbbb857c93c$export$8b28cf6cd00fe080 = `PkhzSW_fontSizeH5`;
$86f05cbbb857c93c$export$186c650311ff0789 = `PkhzSW_fontSizeH6`;
$86f05cbbb857c93c$export$6746fe0d9c9fab54 = `PkhzSW_fontSizeSmall`;
$86f05cbbb857c93c$export$2bcf359f0c20e94f = `PkhzSW_fontSizeTiny`;
$86f05cbbb857c93c$export$2903d10d531d0ac0 = `PkhzSW_fontSizep`;
$86f05cbbb857c93c$export$6f093cfa640b7166 = `PkhzSW_text`;
$86f05cbbb857c93c$export$664c6d24e3175067 = `PkhzSW_visible`;



function $4ffaa24d6677e971$export$2e2bcd8739ae039({}) {
    const { secondsLeft: secondsLeft, hasFailed: hasFailed } = (0, $63dd9757c13a1072$export$b11b2dccbc2926bc)();
    // TODO: from cms
    const bgUrl = "/assets/global/images/failscreen/failscreen-chat-overlay.svg";
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($86f05cbbb857c93c$export$5558409624097e27, {
            [$86f05cbbb857c93c$export$664c6d24e3175067]: hasFailed
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $86f05cbbb857c93c$export$8ce1fd94bee2f412,
                style: {
                    maskImage: `url(${bgUrl})`
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $86f05cbbb857c93c$export$6f093cfa640b7166,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            color: "var(--token-LEGACY-accent-theme-1-text-text-secondary)",
                            fontSize: ".75em"
                        },
                        children: "YOU ARE"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            color: "var(--token-accent-theme-1-text-text-default)",
                            fontSize: "2.5em",
                            lineHeight: 1,
                            letterSpacing: ".05em"
                        },
                        children: "DEAD"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            color: "var(--token-accent-theme-1-text-text-default)",
                            fontSize: ".5em",
                            lineHeight: 1.1
                        },
                        children: "YOU ALERTED THE WALKERS"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        style: {
                            color: "var(--token-LEGACY-accent-theme-1-text-text-secondary)",
                            fontSize: ".5em",
                            lineHeight: 1.1
                        },
                        children: secondsLeft ? `TRY AGAIN IN ${secondsLeft}s` : `TRY AGAIN`
                    })
                ]
            })
        ]
    });
}




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $f9aoP = parcelRequire("f9aoP");


var $cEIti = parcelRequire("cEIti");


var $4MZsN = parcelRequire("4MZsN");




var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");
var $144b72310355d2e7$export$54e4eac921c907a5;
var $144b72310355d2e7$export$3481c78889e8fbe8;
var $144b72310355d2e7$export$17fa98cb055e8fa7;
var $144b72310355d2e7$export$a5833c2b43ca4340;
var $144b72310355d2e7$export$47511f9a6581d1d6;
var $144b72310355d2e7$export$dd1c05b92185401c;
var $144b72310355d2e7$export$8b28cf6cd00fe080;
var $144b72310355d2e7$export$186c650311ff0789;
var $144b72310355d2e7$export$6746fe0d9c9fab54;
var $144b72310355d2e7$export$2bcf359f0c20e94f;
var $144b72310355d2e7$export$2903d10d531d0ac0;
var $144b72310355d2e7$export$9d9f31d9032d6c17;
var $144b72310355d2e7$export$c80d57c51a11eb0a;
var $144b72310355d2e7$export$5b45238e44502ed3;
$144b72310355d2e7$export$54e4eac921c907a5 = `tVg0Pq_ThemedMenuBar`;
$144b72310355d2e7$export$3481c78889e8fbe8 = `tVg0Pq_center`;
$144b72310355d2e7$export$17fa98cb055e8fa7 = `tVg0Pq_fontSizeH1`;
$144b72310355d2e7$export$a5833c2b43ca4340 = `tVg0Pq_fontSizeH2`;
$144b72310355d2e7$export$47511f9a6581d1d6 = `tVg0Pq_fontSizeH3`;
$144b72310355d2e7$export$dd1c05b92185401c = `tVg0Pq_fontSizeH4`;
$144b72310355d2e7$export$8b28cf6cd00fe080 = `tVg0Pq_fontSizeH5`;
$144b72310355d2e7$export$186c650311ff0789 = `tVg0Pq_fontSizeH6`;
$144b72310355d2e7$export$6746fe0d9c9fab54 = `tVg0Pq_fontSizeSmall`;
$144b72310355d2e7$export$2bcf359f0c20e94f = `tVg0Pq_fontSizeTiny`;
$144b72310355d2e7$export$2903d10d531d0ac0 = `tVg0Pq_fontSizep`;
$144b72310355d2e7$export$9d9f31d9032d6c17 = `tVg0Pq_leftCap`;
$144b72310355d2e7$export$c80d57c51a11eb0a = `tVg0Pq_noBackgroundImage`;
$144b72310355d2e7$export$5b45238e44502ed3 = `tVg0Pq_rightCap`;


function $f531a9c5a97d8dd8$export$2e2bcd8739ae039({ children: children, classname: classname }) {
    const theme = (0, $cEIti.useTheme)();
    const hasImages = theme.customJSON.floatingHeaderLeftCapImageUrl && theme.customJSON.floatingHeaderCenterImageUrl;
    if (!hasImages) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($144b72310355d2e7$export$54e4eac921c907a5, $144b72310355d2e7$export$c80d57c51a11eb0a, classname),
        children: children
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($144b72310355d2e7$export$54e4eac921c907a5, classname),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                "aria-hidden": "true",
                "aria-label": " ",
                className: $144b72310355d2e7$export$9d9f31d9032d6c17,
                src: theme.customJSON.floatingHeaderLeftCapImageUrl
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $144b72310355d2e7$export$3481c78889e8fbe8,
                style: {
                    backgroundImage: `url(${theme.customJSON.floatingHeaderCenterImageUrl})`
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                "aria-hidden": "true",
                "aria-label": " ",
                className: $144b72310355d2e7$export$5b45238e44502ed3,
                src: theme.customJSON.floatingHeaderLeftCapImageUrl
            }),
            children
        ]
    });
}





var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $aTKgi = parcelRequire("aTKgi");

var $cEIti = parcelRequire("cEIti");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
const $08a9837627e4e685$var$ImageWithLoading = ({ onLoad: onLoad, ...imgProps })=>{
    const imgRef = (0, $8FY87.useRef)(null);
    const [opacity, setOpacity] = (0, $8FY87.useState)(1);
    (0, $8FY87.useEffect)(()=>{
        if (imgRef.current?.complete) // Call onLoad if the image has already loaded (from cache)
        onLoad();
    }, [
        onLoad
    ]);
    const handleError = ()=>{
        setOpacity(0); // Set opacity to 0 if the image fails to load
        onLoad();
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
        ref: imgRef,
        onLoad: onLoad,
        onError: handleError,
        style: {
            opacity: opacity
        },
        ...imgProps
    });
};
var $08a9837627e4e685$export$2e2bcd8739ae039 = $08a9837627e4e685$var$ImageWithLoading;


var $5e52deac5a83ff69$export$c36edca8f8f0427a;
var $5e52deac5a83ff69$export$f93b5d5c176c8f05;
var $5e52deac5a83ff69$export$e7930daba62240ea;
var $5e52deac5a83ff69$export$17fa98cb055e8fa7;
var $5e52deac5a83ff69$export$a5833c2b43ca4340;
var $5e52deac5a83ff69$export$47511f9a6581d1d6;
var $5e52deac5a83ff69$export$dd1c05b92185401c;
var $5e52deac5a83ff69$export$8b28cf6cd00fe080;
var $5e52deac5a83ff69$export$186c650311ff0789;
var $5e52deac5a83ff69$export$6746fe0d9c9fab54;
var $5e52deac5a83ff69$export$2bcf359f0c20e94f;
var $5e52deac5a83ff69$export$2903d10d531d0ac0;
var $5e52deac5a83ff69$export$5c452ff88e35e47d;
var $5e52deac5a83ff69$export$20bb0d907fbbe433;
var $5e52deac5a83ff69$export$1237798dc640739a;
var $5e52deac5a83ff69$export$29dd17c7f3c81c36;
$5e52deac5a83ff69$export$c36edca8f8f0427a = `OO8D2a_Rank`;
$5e52deac5a83ff69$export$f93b5d5c176c8f05 = `OO8D2a_RankBadge`;
$5e52deac5a83ff69$export$e7930daba62240ea = `OO8D2a_fallbackImage`;
$5e52deac5a83ff69$export$17fa98cb055e8fa7 = `OO8D2a_fontSizeH1`;
$5e52deac5a83ff69$export$a5833c2b43ca4340 = `OO8D2a_fontSizeH2`;
$5e52deac5a83ff69$export$47511f9a6581d1d6 = `OO8D2a_fontSizeH3`;
$5e52deac5a83ff69$export$dd1c05b92185401c = `OO8D2a_fontSizeH4`;
$5e52deac5a83ff69$export$8b28cf6cd00fe080 = `OO8D2a_fontSizeH5`;
$5e52deac5a83ff69$export$186c650311ff0789 = `OO8D2a_fontSizeH6`;
$5e52deac5a83ff69$export$6746fe0d9c9fab54 = `OO8D2a_fontSizeSmall`;
$5e52deac5a83ff69$export$2bcf359f0c20e94f = `OO8D2a_fontSizeTiny`;
$5e52deac5a83ff69$export$2903d10d531d0ac0 = `OO8D2a_fontSizep`;
$5e52deac5a83ff69$export$5c452ff88e35e47d = `OO8D2a_image`;
$5e52deac5a83ff69$export$20bb0d907fbbe433 = `OO8D2a_isLoading`;
$5e52deac5a83ff69$export$1237798dc640739a = `OO8D2a_label`;
$5e52deac5a83ff69$export$29dd17c7f3c81c36 = `OO8D2a_overlay`;


// const COLOURS = ['#FFFFFF', '#8FFF97', '#A7F0FE', '#E569FB', '#FD8917'];
const $9bcbc78dd3688f3f$var$STAR_IMAGES = [
    "/assets/global/images/rank/stars1.webp",
    "/assets/global/images/rank/stars2.webp",
    "/assets/global/images/rank/stars3.webp"
];
const $9bcbc78dd3688f3f$var$getStarImage = (starLevel)=>{
    if (!starLevel) return $9bcbc78dd3688f3f$var$STAR_IMAGES[0]; // If no level, return first image
    if ($9bcbc78dd3688f3f$var$STAR_IMAGES[starLevel - 1]) return $9bcbc78dd3688f3f$var$STAR_IMAGES[starLevel - 1]; // If correct image exists, return it
    if (starLevel > $9bcbc78dd3688f3f$var$STAR_IMAGES.length) return $9bcbc78dd3688f3f$var$STAR_IMAGES[$9bcbc78dd3688f3f$var$STAR_IMAGES.length - 1]; // If star level somehow too high, return last image
    return $9bcbc78dd3688f3f$var$STAR_IMAGES[0]; // Otherwise return first image
};
const $9bcbc78dd3688f3f$var$extractNumberFromId = (id)=>{
    // ID is format vanguard_3, survivor_2 etc.
    const match = id?.match(/\d+$/);
    return match ? parseInt(match[0], 10) : 1;
};
const $9bcbc78dd3688f3f$var$DEFAULT_COLOUR = "#FFFFFF";
const $9bcbc78dd3688f3f$var$DEFAULT_RANK_LEVEL = 1;
const $9bcbc78dd3688f3f$var$NUMBER_OF_STARS_WHEN_STARS_GET_COLOURED = 3;
function $9bcbc78dd3688f3f$export$2e2bcd8739ae039({ classname: classname, faction: faction, rank: rank }) {
    const theme = (0, $cEIti.useTheme)();
    const [factionImageIsLoaded, setFactionImageIsLoaded] = (0, $8FY87.useState)(false);
    const [starImageIsLoaded, setStarImageIsLoaded] = (0, $8FY87.useState)(false);
    if (!theme.metadata?.hasSupplyRun || !faction?.rankImagePath || !$9bcbc78dd3688f3f$var$STAR_IMAGES?.length) // Basic faction image
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5e52deac5a83ff69$export$c36edca8f8f0427a, classname),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
            className: $5e52deac5a83ff69$export$e7930daba62240ea,
            src: (0, $aTKgi.pathToURL)(faction.imagePath),
            alt: `Faction ${faction.name}`
        })
    });
    const rankLevel = rank?.rankLevel ?? $9bcbc78dd3688f3f$var$DEFAULT_RANK_LEVEL; // Rank level (e.g 13)
    const starLevel = $9bcbc78dd3688f3f$var$extractNumberFromId(rank?.id); // How many stars to show (1, 2 or 3)
    const starImage = $9bcbc78dd3688f3f$var$getStarImage(starLevel); // Image of stars
    const rankColour = rank?.rankColour ?? $9bcbc78dd3688f3f$var$DEFAULT_COLOUR; // Colour
    const key = `${faction.id}-${rankLevel}`; // Unique key stops old images showing when going between different users
    const isLoading = !(factionImageIsLoaded && starImageIsLoaded);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5e52deac5a83ff69$export$c36edca8f8f0427a, classname, {
            [$5e52deac5a83ff69$export$20bb0d907fbbe433]: isLoading
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                className: $5e52deac5a83ff69$export$1237798dc640739a,
                children: [
                    "Rank: ",
                    rankLevel
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5e52deac5a83ff69$export$f93b5d5c176c8f05),
                "aria-label": `Faction ${faction.name}, Level ${rankLevel}`,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $08a9837627e4e685$export$2e2bcd8739ae039), {
                        className: $5e52deac5a83ff69$export$5c452ff88e35e47d,
                        src: (0, $aTKgi.pathToURL)(faction.rankImagePath),
                        alt: " ",
                        "aria-hidden": true,
                        onLoad: ()=>{
                            setFactionImageIsLoaded(true);
                        }
                    }, `${key}-1`),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $5e52deac5a83ff69$export$29dd17c7f3c81c36,
                        style: {
                            backgroundColor: rankColour,
                            maskImage: `url("${(0, $aTKgi.pathToURL)(faction.rankImagePath)}")`
                        }
                    }, `${key}-2`),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $08a9837627e4e685$export$2e2bcd8739ae039), {
                        className: $5e52deac5a83ff69$export$5c452ff88e35e47d,
                        src: starImage,
                        alt: " ",
                        "aria-hidden": true,
                        onLoad: ()=>{
                            setStarImageIsLoaded(true);
                        }
                    }, `${key}-3`),
                    starLevel >= $9bcbc78dd3688f3f$var$NUMBER_OF_STARS_WHEN_STARS_GET_COLOURED && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $5e52deac5a83ff69$export$29dd17c7f3c81c36,
                        style: {
                            backgroundColor: rankColour,
                            maskImage: `url("${starImage}")`
                        }
                    }, `${key}-4`)
                ]
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $f9aoP = parcelRequire("f9aoP");

var $i7H0N = parcelRequire("i7H0N");

var $aTKgi = parcelRequire("aTKgi");

var $6lYLL = parcelRequire("6lYLL");


var $cEIti = parcelRequire("cEIti");

var $baXkz = parcelRequire("baXkz");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $4MZsN = parcelRequire("4MZsN");
var $bb5c46e9159b671c$exports = {};

$parcel$export($bb5c46e9159b671c$exports, "CardDescription", function () { return $bb5c46e9159b671c$export$16e0ed4cb97c00d4; }, function (v) { return $bb5c46e9159b671c$export$16e0ed4cb97c00d4 = v; });
$parcel$export($bb5c46e9159b671c$exports, "common", function () { return $bb5c46e9159b671c$export$919daad019702595; }, function (v) { return $bb5c46e9159b671c$export$919daad019702595 = v; });
$parcel$export($bb5c46e9159b671c$exports, "epic", function () { return $bb5c46e9159b671c$export$8ec5145af6f76965; }, function (v) { return $bb5c46e9159b671c$export$8ec5145af6f76965 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH1", function () { return $bb5c46e9159b671c$export$17fa98cb055e8fa7; }, function (v) { return $bb5c46e9159b671c$export$17fa98cb055e8fa7 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH2", function () { return $bb5c46e9159b671c$export$a5833c2b43ca4340; }, function (v) { return $bb5c46e9159b671c$export$a5833c2b43ca4340 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH3", function () { return $bb5c46e9159b671c$export$47511f9a6581d1d6; }, function (v) { return $bb5c46e9159b671c$export$47511f9a6581d1d6 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH4", function () { return $bb5c46e9159b671c$export$dd1c05b92185401c; }, function (v) { return $bb5c46e9159b671c$export$dd1c05b92185401c = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH5", function () { return $bb5c46e9159b671c$export$8b28cf6cd00fe080; }, function (v) { return $bb5c46e9159b671c$export$8b28cf6cd00fe080 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeH6", function () { return $bb5c46e9159b671c$export$186c650311ff0789; }, function (v) { return $bb5c46e9159b671c$export$186c650311ff0789 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeSmall", function () { return $bb5c46e9159b671c$export$6746fe0d9c9fab54; }, function (v) { return $bb5c46e9159b671c$export$6746fe0d9c9fab54 = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizeTiny", function () { return $bb5c46e9159b671c$export$2bcf359f0c20e94f; }, function (v) { return $bb5c46e9159b671c$export$2bcf359f0c20e94f = v; });
$parcel$export($bb5c46e9159b671c$exports, "fontSizep", function () { return $bb5c46e9159b671c$export$2903d10d531d0ac0; }, function (v) { return $bb5c46e9159b671c$export$2903d10d531d0ac0 = v; });
$parcel$export($bb5c46e9159b671c$exports, "icon", function () { return $bb5c46e9159b671c$export$1ca1ec8b29a4ce27; }, function (v) { return $bb5c46e9159b671c$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($bb5c46e9159b671c$exports, "isButton", function () { return $bb5c46e9159b671c$export$35a0171ee384c875; }, function (v) { return $bb5c46e9159b671c$export$35a0171ee384c875 = v; });
$parcel$export($bb5c46e9159b671c$exports, "legendary", function () { return $bb5c46e9159b671c$export$9738149b23403ba; }, function (v) { return $bb5c46e9159b671c$export$9738149b23403ba = v; });
$parcel$export($bb5c46e9159b671c$exports, "longTitle", function () { return $bb5c46e9159b671c$export$578fcbc4821dcd12; }, function (v) { return $bb5c46e9159b671c$export$578fcbc4821dcd12 = v; });
$parcel$export($bb5c46e9159b671c$exports, "rare", function () { return $bb5c46e9159b671c$export$b2e68d2f08b863d2; }, function (v) { return $bb5c46e9159b671c$export$b2e68d2f08b863d2 = v; });
$parcel$export($bb5c46e9159b671c$exports, "subtitle", function () { return $bb5c46e9159b671c$export$c96745152eb2740f; }, function (v) { return $bb5c46e9159b671c$export$c96745152eb2740f = v; });
$parcel$export($bb5c46e9159b671c$exports, "title", function () { return $bb5c46e9159b671c$export$fb184b623420d9be; }, function (v) { return $bb5c46e9159b671c$export$fb184b623420d9be = v; });
$parcel$export($bb5c46e9159b671c$exports, "uncommon", function () { return $bb5c46e9159b671c$export$76bf72d8613283e6; }, function (v) { return $bb5c46e9159b671c$export$76bf72d8613283e6 = v; });
var $bb5c46e9159b671c$export$16e0ed4cb97c00d4;
var $bb5c46e9159b671c$export$919daad019702595;
var $bb5c46e9159b671c$export$8ec5145af6f76965;
var $bb5c46e9159b671c$export$17fa98cb055e8fa7;
var $bb5c46e9159b671c$export$a5833c2b43ca4340;
var $bb5c46e9159b671c$export$47511f9a6581d1d6;
var $bb5c46e9159b671c$export$dd1c05b92185401c;
var $bb5c46e9159b671c$export$8b28cf6cd00fe080;
var $bb5c46e9159b671c$export$186c650311ff0789;
var $bb5c46e9159b671c$export$6746fe0d9c9fab54;
var $bb5c46e9159b671c$export$2bcf359f0c20e94f;
var $bb5c46e9159b671c$export$2903d10d531d0ac0;
var $bb5c46e9159b671c$export$1ca1ec8b29a4ce27;
var $bb5c46e9159b671c$export$35a0171ee384c875;
var $bb5c46e9159b671c$export$9738149b23403ba;
var $bb5c46e9159b671c$export$578fcbc4821dcd12;
var $bb5c46e9159b671c$export$b2e68d2f08b863d2;
var $bb5c46e9159b671c$export$c96745152eb2740f;
var $bb5c46e9159b671c$export$fb184b623420d9be;
var $bb5c46e9159b671c$export$76bf72d8613283e6;
$bb5c46e9159b671c$export$16e0ed4cb97c00d4 = `PPJVKG_CardDescription`;
$bb5c46e9159b671c$export$919daad019702595 = `PPJVKG_common`;
$bb5c46e9159b671c$export$8ec5145af6f76965 = `PPJVKG_epic`;
$bb5c46e9159b671c$export$17fa98cb055e8fa7 = `PPJVKG_fontSizeH1`;
$bb5c46e9159b671c$export$a5833c2b43ca4340 = `PPJVKG_fontSizeH2`;
$bb5c46e9159b671c$export$47511f9a6581d1d6 = `PPJVKG_fontSizeH3`;
$bb5c46e9159b671c$export$dd1c05b92185401c = `PPJVKG_fontSizeH4`;
$bb5c46e9159b671c$export$8b28cf6cd00fe080 = `PPJVKG_fontSizeH5`;
$bb5c46e9159b671c$export$186c650311ff0789 = `PPJVKG_fontSizeH6`;
$bb5c46e9159b671c$export$6746fe0d9c9fab54 = `PPJVKG_fontSizeSmall`;
$bb5c46e9159b671c$export$2bcf359f0c20e94f = `PPJVKG_fontSizeTiny`;
$bb5c46e9159b671c$export$2903d10d531d0ac0 = `PPJVKG_fontSizep`;
$bb5c46e9159b671c$export$1ca1ec8b29a4ce27 = `PPJVKG_icon`;
$bb5c46e9159b671c$export$35a0171ee384c875 = `PPJVKG_isButton`;
$bb5c46e9159b671c$export$9738149b23403ba = `PPJVKG_legendary`;
$bb5c46e9159b671c$export$578fcbc4821dcd12 = `PPJVKG_longTitle`;
$bb5c46e9159b671c$export$b2e68d2f08b863d2 = `PPJVKG_rare`;
$bb5c46e9159b671c$export$c96745152eb2740f = `PPJVKG_subtitle`;
$bb5c46e9159b671c$export$fb184b623420d9be = `PPJVKG_title`;
$bb5c46e9159b671c$export$76bf72d8613283e6 = `PPJVKG_uncommon`;


function $248e04b79658491e$export$2e2bcd8739ae039({ title: title, classname: classname, onClick: onClick, subtitle: subtitle, backgroundImage: backgroundImage, maskImage: maskImage, rarity: rarity, isSelected: isSelected, iconType: iconType, keepFontSize: keepFontSize }) {
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($bb5c46e9159b671c$exports.CardDescription, classname, $bb5c46e9159b671c$exports[rarity?.toLowerCase()], {
        [$bb5c46e9159b671c$exports.isButton]: onClick
    });
    const style = {
        ...backgroundImage && {
            backgroundImage: `url("${backgroundImage}")`
        },
        ...maskImage && {
            maskImage: `url("${maskImage}")`
        }
    };
    const content = /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($bb5c46e9159b671c$exports.title, {
                    [$bb5c46e9159b671c$exports.longTitle]: !keepFontSize && title?.length > 13
                }),
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $bb5c46e9159b671c$exports.subtitle,
                children: subtitle
            }),
            iconType && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                type: iconType,
                className: $bb5c46e9159b671c$exports.icon
            })
        ]
    });
    if (onClick) return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        onClick: onClick,
        className: classes,
        style: style,
        "aria-selected": isSelected,
        children: content
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: classes,
        style: style,
        children: content
    });
}



var $4MZsN = parcelRequire("4MZsN");
var $cdfe1d7ed48f48f2$export$ed8671f612970784;
var $cdfe1d7ed48f48f2$export$2d5d4e432b5a59e5;
var $cdfe1d7ed48f48f2$export$7a501f3c3d80f448;
var $cdfe1d7ed48f48f2$export$34ee7a0d3aa0c144;
var $cdfe1d7ed48f48f2$export$e3df13a29829f609;
var $cdfe1d7ed48f48f2$export$ea030c803b7ffdb8;
var $cdfe1d7ed48f48f2$export$41e6a90a9191b826;
var $cdfe1d7ed48f48f2$export$25ee1e0b9880f13c;
var $cdfe1d7ed48f48f2$export$9d7ea1576ea93111;
var $cdfe1d7ed48f48f2$export$17fa98cb055e8fa7;
var $cdfe1d7ed48f48f2$export$a5833c2b43ca4340;
var $cdfe1d7ed48f48f2$export$47511f9a6581d1d6;
var $cdfe1d7ed48f48f2$export$dd1c05b92185401c;
var $cdfe1d7ed48f48f2$export$8b28cf6cd00fe080;
var $cdfe1d7ed48f48f2$export$186c650311ff0789;
var $cdfe1d7ed48f48f2$export$6746fe0d9c9fab54;
var $cdfe1d7ed48f48f2$export$2bcf359f0c20e94f;
var $cdfe1d7ed48f48f2$export$2903d10d531d0ac0;
var $cdfe1d7ed48f48f2$export$c80d57c51a11eb0a;
var $cdfe1d7ed48f48f2$export$1c220dee9e4dbe34;
$cdfe1d7ed48f48f2$export$ed8671f612970784 = `MaULVa_ItemContainer`;
$cdfe1d7ed48f48f2$export$2d5d4e432b5a59e5 = `MaULVa_ItemContainer__BackgroundContainer`;
$cdfe1d7ed48f48f2$export$7a501f3c3d80f448 = `MaULVa_ItemContainer__BackgroundIcon`;
$cdfe1d7ed48f48f2$export$34ee7a0d3aa0c144 = `MaULVa_ItemContainer__Border`;
$cdfe1d7ed48f48f2$export$e3df13a29829f609 = `MaULVa_ItemContainer__Button`;
$cdfe1d7ed48f48f2$export$ea030c803b7ffdb8 = `MaULVa_ItemContainer__Button--interactable`;
$cdfe1d7ed48f48f2$export$41e6a90a9191b826 = `MaULVa_ItemContainer__Description`;
$cdfe1d7ed48f48f2$export$25ee1e0b9880f13c = `MaULVa_ItemContainer__HighlightImage`;
$cdfe1d7ed48f48f2$export$9d7ea1576ea93111 = `MaULVa_ItemContainer__Image`;
$cdfe1d7ed48f48f2$export$17fa98cb055e8fa7 = `MaULVa_fontSizeH1`;
$cdfe1d7ed48f48f2$export$a5833c2b43ca4340 = `MaULVa_fontSizeH2`;
$cdfe1d7ed48f48f2$export$47511f9a6581d1d6 = `MaULVa_fontSizeH3`;
$cdfe1d7ed48f48f2$export$dd1c05b92185401c = `MaULVa_fontSizeH4`;
$cdfe1d7ed48f48f2$export$8b28cf6cd00fe080 = `MaULVa_fontSizeH5`;
$cdfe1d7ed48f48f2$export$186c650311ff0789 = `MaULVa_fontSizeH6`;
$cdfe1d7ed48f48f2$export$6746fe0d9c9fab54 = `MaULVa_fontSizeSmall`;
$cdfe1d7ed48f48f2$export$2bcf359f0c20e94f = `MaULVa_fontSizeTiny`;
$cdfe1d7ed48f48f2$export$2903d10d531d0ac0 = `MaULVa_fontSizep`;
$cdfe1d7ed48f48f2$export$c80d57c51a11eb0a = `MaULVa_noBackgroundImage`;
$cdfe1d7ed48f48f2$export$1c220dee9e4dbe34 = `MaULVa_slide-in`;


function $bac5dde52a47c16a$export$2e2bcd8739ae039({ classname: classname, imagePath: imagePath, backgroundImagePath: backgroundImagePath, textBackgroundImagePath: textBackgroundImagePath, highlightImagePath: highlightImagePath, title: title, subtitle: subtitle, isSelected: isSelected, onSelected: onSelected, imageAlt: imageAlt, interactable: interactable, hasBorder: hasBorder = true, backgroundIconType: backgroundIconType, hideDescription: hideDescription }) {
    const highlightImageStyle = highlightImagePath ? {
        backgroundImage: `url(${highlightImagePath})`
    } : {};
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cdfe1d7ed48f48f2$export$ed8671f612970784, classname),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cdfe1d7ed48f48f2$export$e3df13a29829f609, {
                    [$cdfe1d7ed48f48f2$export$ea030c803b7ffdb8]: interactable
                }),
                onClick: ()=>onSelected && onSelected(),
                disabled: !interactable,
                "aria-selected": isSelected,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($cdfe1d7ed48f48f2$export$2d5d4e432b5a59e5, {
                            [$cdfe1d7ed48f48f2$export$c80d57c51a11eb0a]: !backgroundImagePath
                        }),
                        style: backgroundImagePath ? {
                            backgroundImage: `url("${backgroundImagePath}")`
                        } : {},
                        children: backgroundIconType && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                            className: $cdfe1d7ed48f48f2$export$7a501f3c3d80f448,
                            type: backgroundIconType
                        })
                    }),
                    hasBorder && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $cdfe1d7ed48f48f2$export$34ee7a0d3aa0c144
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        src: imagePath,
                        className: $cdfe1d7ed48f48f2$export$9d7ea1576ea93111,
                        alt: imageAlt
                    }),
                    !hideDescription && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $248e04b79658491e$export$2e2bcd8739ae039), {
                        classname: $cdfe1d7ed48f48f2$export$41e6a90a9191b826,
                        title: title,
                        subtitle: subtitle,
                        backgroundImage: textBackgroundImagePath
                    })
                ]
            }),
            highlightImagePath && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $cdfe1d7ed48f48f2$export$25ee1e0b9880f13c,
                style: highlightImageStyle
            })
        ]
    });
}


var $df22751f28ee520b$export$bbbd95bdc42c795e;
var $df22751f28ee520b$export$efe229eab43a9869;
var $df22751f28ee520b$export$a7db06668cad9adb;
var $df22751f28ee520b$export$da10a04ece02fcdc;
var $df22751f28ee520b$export$17fa98cb055e8fa7;
var $df22751f28ee520b$export$a5833c2b43ca4340;
var $df22751f28ee520b$export$47511f9a6581d1d6;
var $df22751f28ee520b$export$dd1c05b92185401c;
var $df22751f28ee520b$export$8b28cf6cd00fe080;
var $df22751f28ee520b$export$186c650311ff0789;
var $df22751f28ee520b$export$6746fe0d9c9fab54;
var $df22751f28ee520b$export$2bcf359f0c20e94f;
var $df22751f28ee520b$export$2903d10d531d0ac0;
var $df22751f28ee520b$export$ea0830439c7fc698;
var $df22751f28ee520b$export$c80d57c51a11eb0a;
var $df22751f28ee520b$export$fad3c8302a7540c6;
var $df22751f28ee520b$export$fb184b623420d9be;
var $df22751f28ee520b$export$ac052f74bbc68e2d;
$df22751f28ee520b$export$bbbd95bdc42c795e = `JDZAmq_MyPrizesDrawer`;
$df22751f28ee520b$export$efe229eab43a9869 = `JDZAmq_closeButton`;
$df22751f28ee520b$export$a7db06668cad9adb = `JDZAmq_content`;
$df22751f28ee520b$export$da10a04ece02fcdc = `JDZAmq_emptyText`;
$df22751f28ee520b$export$17fa98cb055e8fa7 = `JDZAmq_fontSizeH1`;
$df22751f28ee520b$export$a5833c2b43ca4340 = `JDZAmq_fontSizeH2`;
$df22751f28ee520b$export$47511f9a6581d1d6 = `JDZAmq_fontSizeH3`;
$df22751f28ee520b$export$dd1c05b92185401c = `JDZAmq_fontSizeH4`;
$df22751f28ee520b$export$8b28cf6cd00fe080 = `JDZAmq_fontSizeH5`;
$df22751f28ee520b$export$186c650311ff0789 = `JDZAmq_fontSizeH6`;
$df22751f28ee520b$export$6746fe0d9c9fab54 = `JDZAmq_fontSizeSmall`;
$df22751f28ee520b$export$2bcf359f0c20e94f = `JDZAmq_fontSizeTiny`;
$df22751f28ee520b$export$2903d10d531d0ac0 = `JDZAmq_fontSizep`;
$df22751f28ee520b$export$ea0830439c7fc698 = `JDZAmq_isOpen`;
$df22751f28ee520b$export$c80d57c51a11eb0a = `JDZAmq_noBackgroundImage`;
$df22751f28ee520b$export$fad3c8302a7540c6 = `JDZAmq_scrollContainer`;
$df22751f28ee520b$export$fb184b623420d9be = `JDZAmq_title`;
$df22751f28ee520b$export$ac052f74bbc68e2d = `JDZAmq_topBar`;


function $81b3408e0e08a3dd$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const isMyPrizesOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isMyPrizesOpen);
    const [prizeItems, setPrizeItems] = (0, $8FY87.useState)([]);
    const [prizeItemsAreLoading, setPrizeItemsAreLoading] = (0, $8FY87.useState)(true);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    function removeDuplicates(items) {
        const uniquePrizesMap = new Map();
        items?.forEach((item)=>{
            uniquePrizesMap.set(item.id, item);
        });
        // Convert the map back to an array
        const uniquePrizes = Array.from(uniquePrizesMap.values());
        return uniquePrizes;
    }
    const loadPrizes = ()=>{
        (0, $f9aoP.getMyPrizes)().then((items)=>{
            if (Array.isArray(items)) setPrizeItems(removeDuplicates(items));
            else console.error("Error loading prizes");
            setPrizeItemsAreLoading(false);
        }).catch(()=>{
            setPrizeItemsAreLoading(false);
            console.error("Error loading prizes");
        });
    };
    (0, $8FY87.useEffect)(()=>{
        if (isMyPrizesOpen) {
            audio?.play("gust-open");
            // Reload data when opened
            setPrizeItemsAreLoading(true);
            loadPrizes();
            (0, $i7H0N.sendEvent)("view_my_prizes");
        }
    }, [
        isMyPrizesOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isMyPrizesOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($df22751f28ee520b$export$bbbd95bdc42c795e, {
            [$df22751f28ee520b$export$ea0830439c7fc698]: isMyPrizesOpen
        }),
        inert: !isMyPrizesOpen ? "" : undefined,
        onTransitionEnd: onTransitionEnd,
        style: {
            backdropFilter: `blur(10px)`
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $df22751f28ee520b$export$fad3c8302a7540c6,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $df22751f28ee520b$export$ac052f74bbc68e2d,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            className: $df22751f28ee520b$export$fb184b623420d9be,
                            children: "Your Prizes!"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                            buttonRef: closeButtonRef,
                            iconType: "close",
                            buttonStyle: "round",
                            ariaLabel: "Close My Prizes",
                            className: $df22751f28ee520b$export$efe229eab43a9869,
                            onClick: ()=>{
                                audio?.play("gust-close");
                                dispatch((0, $baXkz.setIsMyPrizesOpen)(false));
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($df22751f28ee520b$export$a7db06668cad9adb, {
                        [$df22751f28ee520b$export$c80d57c51a11eb0a]: !theme.customJSON?.profileBackground
                    }),
                    style: theme.customJSON?.profileBackground ? {
                        backgroundImage: `url("${theme.customJSON?.profileBackground}")`,
                        borderImageSource: `url("${theme.customJSON?.profileBackground}")`
                    } : {},
                    children: [
                        prizeItems.length === 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: $df22751f28ee520b$export$da10a04ece02fcdc,
                            children: "No prizes earned yet"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                            children: prizeItems.map((item, index)=>{
                                return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                                        title: item.subtitle,
                                        imagePath: (0, $aTKgi.pathToURL)(item.secondaryImagePath),
                                        backgroundImagePath: theme.customJSON?.cardBackgroundImageUrl,
                                        textBackgroundImagePath: theme.customJSON?.cardTextBackgroundImageUrl,
                                        imageAlt: item.description,
                                        interactable: true,
                                        onSelected: ()=>dispatch((0, $baXkz.setCurrentlyViewingPrize)(item))
                                    })
                                }, `my-prize-${index}`);
                            })
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                            hasBackground: false,
                            show: prizeItemsAreLoading
                        })
                    ]
                })
            ]
        })
    });
}



var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $f9aoP = parcelRequire("f9aoP");


var $4MZsN = parcelRequire("4MZsN");
var $056654c0fe14b582$export$3cac33c15a39ad1f;
var $056654c0fe14b582$export$f1c2de779b6eb7bc;
var $056654c0fe14b582$export$f7e23bf56dfad7ba;
var $056654c0fe14b582$export$c95979b960f4acea;
var $056654c0fe14b582$export$17fa98cb055e8fa7;
var $056654c0fe14b582$export$a5833c2b43ca4340;
var $056654c0fe14b582$export$47511f9a6581d1d6;
var $056654c0fe14b582$export$dd1c05b92185401c;
var $056654c0fe14b582$export$8b28cf6cd00fe080;
var $056654c0fe14b582$export$186c650311ff0789;
var $056654c0fe14b582$export$6746fe0d9c9fab54;
var $056654c0fe14b582$export$2bcf359f0c20e94f;
var $056654c0fe14b582$export$2903d10d531d0ac0;
var $056654c0fe14b582$export$1ca1ec8b29a4ce27;
var $056654c0fe14b582$export$db3c28d99448dcff;
var $056654c0fe14b582$export$c80d57c51a11eb0a;
var $056654c0fe14b582$export$7e52df37012c0dca;
var $056654c0fe14b582$export$6f0f7e43dfb58046;
var $056654c0fe14b582$export$69657864448b6769;
var $056654c0fe14b582$export$41bdc12d2d25233b;
var $056654c0fe14b582$export$fb184b623420d9be;
var $056654c0fe14b582$export$2ab9a8f9f1186f14;
$056654c0fe14b582$export$3cac33c15a39ad1f = `qJLAhW_ProfileStatsSummary`;
$056654c0fe14b582$export$f1c2de779b6eb7bc = `qJLAhW_SummaryItem`;
$056654c0fe14b582$export$f7e23bf56dfad7ba = `qJLAhW_extraStats`;
$056654c0fe14b582$export$c95979b960f4acea = `qJLAhW_fade-in`;
$056654c0fe14b582$export$c95979b960f4acea;
$056654c0fe14b582$export$17fa98cb055e8fa7 = `qJLAhW_fontSizeH1`;
$056654c0fe14b582$export$a5833c2b43ca4340 = `qJLAhW_fontSizeH2`;
$056654c0fe14b582$export$47511f9a6581d1d6 = `qJLAhW_fontSizeH3`;
$056654c0fe14b582$export$dd1c05b92185401c = `qJLAhW_fontSizeH4`;
$056654c0fe14b582$export$8b28cf6cd00fe080 = `qJLAhW_fontSizeH5`;
$056654c0fe14b582$export$186c650311ff0789 = `qJLAhW_fontSizeH6`;
$056654c0fe14b582$export$6746fe0d9c9fab54 = `qJLAhW_fontSizeSmall`;
$056654c0fe14b582$export$2bcf359f0c20e94f = `qJLAhW_fontSizeTiny`;
$056654c0fe14b582$export$2903d10d531d0ac0 = `qJLAhW_fontSizep`;
$056654c0fe14b582$export$1ca1ec8b29a4ce27 = `qJLAhW_icon`;
$056654c0fe14b582$export$db3c28d99448dcff = `qJLAhW_logo`;
$056654c0fe14b582$export$c80d57c51a11eb0a = `qJLAhW_noBackgroundImage`;
$056654c0fe14b582$export$7e52df37012c0dca = `qJLAhW_reduceFontSize`;
$056654c0fe14b582$export$6f0f7e43dfb58046 = `qJLAhW_suffixValue`;
$056654c0fe14b582$export$69657864448b6769 = `qJLAhW_summaryItems`;
$056654c0fe14b582$export$41bdc12d2d25233b = `qJLAhW_summaryRow`;
$056654c0fe14b582$export$fb184b623420d9be = `qJLAhW_title`;
$056654c0fe14b582$export$2ab9a8f9f1186f14 = `qJLAhW_value`;


const $86b59be89ea19d3d$var$ProfileStatsSummary = ({ numberOfTitles: numberOfTitles, puzzlesCompleted: puzzlesCompleted, userID: userID, role: role, classname: classname })=>{
    const theme = (0, $cEIti.useTheme)();
    const backgroundImage = theme.customJSON?.profileBackground;
    const [supplyRunStats, setSupplyRunStats] = (0, $8FY87.useState)(null);
    const shouldShowSupplyRunData = theme.metadata?.hasSupplyRun && role !== "guest" && role !== "actor";
    const shouldReduceFontSize = supplyRunStats?.supplyPoints > 99999;
    async function getSupplyRunStats() {
        try {
            const response = await (0, $f9aoP.getSupplyRunUserProfileStats)(userID);
            setSupplyRunStats(response);
        } catch (error) {
            console.warn("Could not get SupplyRunUserProfileStats:", error);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        if (shouldShowSupplyRunData) getSupplyRunStats();
    }, [
        shouldShowSupplyRunData
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($056654c0fe14b582$export$3cac33c15a39ad1f, classname, {
            [$056654c0fe14b582$export$c80d57c51a11eb0a]: !backgroundImage
        }),
        style: backgroundImage ? {
            backgroundImage: `url("${backgroundImage}")`
        } : {},
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $056654c0fe14b582$export$db3c28d99448dcff,
                style: {
                    maskImage: `url("${theme.files.instance_mark}")`
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $056654c0fe14b582$export$69657864448b6769,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                        className: $056654c0fe14b582$export$41bdc12d2d25233b,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)($86b59be89ea19d3d$export$6e5fab54fd9c478, {
                                    iconType: "crown",
                                    title: "Titles:",
                                    value: numberOfTitles
                                })
                            }),
                            typeof puzzlesCompleted === "number" && /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)($86b59be89ea19d3d$export$6e5fab54fd9c478, {
                                    iconType: "challenge",
                                    title: "Puzzles Done:",
                                    value: puzzlesCompleted
                                })
                            })
                        ]
                    }),
                    shouldShowSupplyRunData && supplyRunStats && /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($056654c0fe14b582$export$41bdc12d2d25233b, $056654c0fe14b582$export$f7e23bf56dfad7ba),
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)($86b59be89ea19d3d$export$6e5fab54fd9c478, {
                                    iconType: "supplies",
                                    title: "Supplies:",
                                    value: (0, $aed6ee8c7b23660f$export$a6283a56ed31c98a)(supplyRunStats?.supplyPoints, 0),
                                    reduceFontSize: shouldReduceFontSize
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)($86b59be89ea19d3d$export$6e5fab54fd9c478, {
                                    iconType: "bolt",
                                    title: "Leaderboard:",
                                    value: (0, $aed6ee8c7b23660f$export$9173b52dfbd534b4)(supplyRunStats?.position),
                                    reduceFontSize: shouldReduceFontSize
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $86b59be89ea19d3d$export$6e5fab54fd9c478 = ({ iconType: iconType, title: title, value: value, suffixValue: suffixValue, classname: classname, reduceFontSize: reduceFontSize })=>{
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($056654c0fe14b582$export$f1c2de779b6eb7bc, classname, {
            [$056654c0fe14b582$export$7e52df37012c0dca]: reduceFontSize
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                className: $056654c0fe14b582$export$1ca1ec8b29a4ce27,
                type: iconType
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: $056654c0fe14b582$export$fb184b623420d9be,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        className: $056654c0fe14b582$export$2ab9a8f9f1186f14,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                children: value
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                className: $056654c0fe14b582$export$6f0f7e43dfb58046,
                                children: suffixValue
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $86b59be89ea19d3d$export$2e2bcd8739ae039 = $86b59be89ea19d3d$var$ProfileStatsSummary;



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");

var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");

var $f9aoP = parcelRequire("f9aoP");

var $6lYLL = parcelRequire("6lYLL");

var $4KKbJ = parcelRequire("4KKbJ");

var $baXkz = parcelRequire("baXkz");




var $5d93b6dd05204b89$export$9d55b23d8c4757a3;
var $5d93b6dd05204b89$export$da15e73b251818b1;
var $5d93b6dd05204b89$export$40e543e69a8b3fbb;
var $5d93b6dd05204b89$export$de251036a26f76f2;
var $5d93b6dd05204b89$export$3117ecc0d04bc057;
var $5d93b6dd05204b89$export$6e22c362a0406a2c;
var $5d93b6dd05204b89$export$441b5310849b9a95;
var $5d93b6dd05204b89$export$17fa98cb055e8fa7;
var $5d93b6dd05204b89$export$a5833c2b43ca4340;
var $5d93b6dd05204b89$export$47511f9a6581d1d6;
var $5d93b6dd05204b89$export$dd1c05b92185401c;
var $5d93b6dd05204b89$export$8b28cf6cd00fe080;
var $5d93b6dd05204b89$export$186c650311ff0789;
var $5d93b6dd05204b89$export$6746fe0d9c9fab54;
var $5d93b6dd05204b89$export$2bcf359f0c20e94f;
var $5d93b6dd05204b89$export$2903d10d531d0ac0;
var $5d93b6dd05204b89$export$6fc54610a72490ac;
var $5d93b6dd05204b89$export$39e04e72f972b885;
var $5d93b6dd05204b89$export$bfddba54107e991b;
var $5d93b6dd05204b89$export$17a1664ed1fb5d6f;
var $5d93b6dd05204b89$export$337c2b438c93a763;
var $5d93b6dd05204b89$export$c80d57c51a11eb0a;
var $5d93b6dd05204b89$export$d167761217acc355;
var $5d93b6dd05204b89$export$3843a12c911b43ce;
var $5d93b6dd05204b89$export$fb184b623420d9be;
var $5d93b6dd05204b89$export$f1d75f78361d525c;
var $5d93b6dd05204b89$export$1e95b668f3b82d;
$5d93b6dd05204b89$export$9d55b23d8c4757a3 = `XeGVQW_ProfileEditor`;
$5d93b6dd05204b89$export$da15e73b251818b1 = `XeGVQW_backgroundItem`;
$5d93b6dd05204b89$export$40e543e69a8b3fbb = `XeGVQW_bottom`;
$5d93b6dd05204b89$export$de251036a26f76f2 = `XeGVQW_characterItem`;
$5d93b6dd05204b89$export$3117ecc0d04bc057 = `XeGVQW_editorContainer`;
$5d93b6dd05204b89$export$6e22c362a0406a2c = `XeGVQW_empty`;
$5d93b6dd05204b89$export$441b5310849b9a95 = `XeGVQW_factionItem`;
$5d93b6dd05204b89$export$17fa98cb055e8fa7 = `XeGVQW_fontSizeH1`;
$5d93b6dd05204b89$export$a5833c2b43ca4340 = `XeGVQW_fontSizeH2`;
$5d93b6dd05204b89$export$47511f9a6581d1d6 = `XeGVQW_fontSizeH3`;
$5d93b6dd05204b89$export$dd1c05b92185401c = `XeGVQW_fontSizeH4`;
$5d93b6dd05204b89$export$8b28cf6cd00fe080 = `XeGVQW_fontSizeH5`;
$5d93b6dd05204b89$export$186c650311ff0789 = `XeGVQW_fontSizeH6`;
$5d93b6dd05204b89$export$6746fe0d9c9fab54 = `XeGVQW_fontSizeSmall`;
$5d93b6dd05204b89$export$2bcf359f0c20e94f = `XeGVQW_fontSizeTiny`;
$5d93b6dd05204b89$export$2903d10d531d0ac0 = `XeGVQW_fontSizep`;
$5d93b6dd05204b89$export$6fc54610a72490ac = `XeGVQW_frameItem`;
$5d93b6dd05204b89$export$39e04e72f972b885 = `XeGVQW_isActive`;
$5d93b6dd05204b89$export$bfddba54107e991b = `XeGVQW_isCurrent`;
$5d93b6dd05204b89$export$17a1664ed1fb5d6f = `XeGVQW_items`;
$5d93b6dd05204b89$export$337c2b438c93a763 = `XeGVQW_loadingScreen`;
$5d93b6dd05204b89$export$c80d57c51a11eb0a = `XeGVQW_noBackgroundImage`;
$5d93b6dd05204b89$export$d167761217acc355 = `XeGVQW_tabButtons`;
$5d93b6dd05204b89$export$3843a12c911b43ce = `XeGVQW_tabTitle`;
$5d93b6dd05204b89$export$fb184b623420d9be = `XeGVQW_title`;
$5d93b6dd05204b89$export$f1d75f78361d525c = `XeGVQW_titleItem`;
$5d93b6dd05204b89$export$1e95b668f3b82d = `XeGVQW_top`;


var $86a4daaa608bd515$var$TabType;
(function(TabType) {
    TabType["Character"] = "Character";
    TabType["Title"] = "Title";
    TabType["Background"] = "Background";
    TabType["Faction"] = "Faction";
    TabType["Frame"] = "Frame";
})($86a4daaa608bd515$var$TabType || ($86a4daaa608bd515$var$TabType = {}));
const $86a4daaa608bd515$var$ProfileEditor = ()=>{
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const [currentTab, setCurrentTab] = (0, $8FY87.useState)("Character");
    const [isLoading, setIsLoading] = (0, $8FY87.useState)(true);
    const [characters, setCharacters] = (0, $8FY87.useState)([]);
    const [titles, setTitles] = (0, $8FY87.useState)();
    const [backgrounds, setBackgrounds] = (0, $8FY87.useState)();
    const [factions, setFactions] = (0, $8FY87.useState)();
    const [frames, setFrames] = (0, $8FY87.useState)();
    const loadElements = ()=>{
        const promises = [
            $f9aoP.getTitles(currentUserProfile?.userID),
            $f9aoP.getFactions(),
            $f9aoP.getUserOwnedAssets()
        ];
        Promise.all(promises).then(([titlesData, factionsData, ownedAssetsData])=>{
            setCharacters(ownedAssetsData.characters);
            setFrames(ownedAssetsData.avatarFrames);
            setBackgrounds(ownedAssetsData.backgrounds);
            setTitles((0, $fL4mk.processTitles)(titlesData));
            setFactions(factionsData);
            setIsLoading(false);
        }).catch(()=>{
            setIsLoading(false);
            console.error("Error loading profile editor");
        });
    };
    (0, $8FY87.useEffect)(()=>{
        if (currentUserProfile?.userID) {
            loadElements();
            (0, $i7H0N.sendEvent)("profile_editor_open");
        }
    }, [
        currentUserProfile?.userID
    ]);
    const TabButton = ({ tabType: tabType, iconType: iconType })=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                    [$5d93b6dd05204b89$export$39e04e72f972b885]: currentTab === tabType
                }),
                iconType: iconType,
                ariaLabel: tabType,
                buttonStyle: "icon",
                onClick: ()=>{
                    setCurrentTab(tabType);
                    (0, $i7H0N.sendEvent)(`profile_editor_view_tab_${tabType?.toLocaleLowerCase()}`);
                },
                title: tabType
            })
        });
    const sharedCardProps = {
        backgroundImagePath: theme.customJSON?.cardBackgroundImageUrl,
        textBackgroundImagePath: theme.customJSON?.cardTextBackgroundImageUrl,
        hasBorder: false,
        interactable: true
    };
    const shopLinkCard = /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
            title: theme.customJSON.shop?.shopTitle ?? "Head to shop",
            backgroundIconType: theme.customJSON.shop?.shopButtonIcon ?? "shop",
            onSelected: ()=>{
                dispatch((0, $baXkz.setIsShopOpen)(true));
                (0, $i7H0N.sendEvent)("open_shop_from_profile_editor");
            },
            ...sharedCardProps
        })
    });
    const renderItems = ()=>{
        const Empty = ({ text: text })=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $5d93b6dd05204b89$export$6e22c362a0406a2c,
                children: text
            });
        switch(currentTab){
            case "Title":
                if (!titles?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)(Empty, {
                    text: "No titles to show"
                });
                return titles?.map((item, index)=>{
                    const isCurrent = currentUserProfile?.title?.id === item.titleID;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                            [$5d93b6dd05204b89$export$bfddba54107e991b]: isCurrent
                        }),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $248e04b79658491e$export$2e2bcd8739ae039), {
                            classname: $5d93b6dd05204b89$export$f1d75f78361d525c,
                            title: item.title,
                            subtitle: item.rarity,
                            rarity: item.rarity,
                            onClick: ()=>{
                                if (!isCurrent) {
                                    dispatch((0, $4KKbJ.setProfileTitle)(item.titleID));
                                    (0, $i7H0N.sendEvent)("profile_editor_set_title", {
                                        id: item?.titleID,
                                        name: item?.title
                                    });
                                }
                            },
                            maskImage: sharedCardProps.textBackgroundImagePath,
                            isSelected: isCurrent
                        })
                    }, index + currentTab);
                });
            case "Faction":
                if (!factions?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)(Empty, {
                    text: "No factions to show"
                });
                return factions?.map((item, index)=>{
                    const isCurrent = currentUserProfile?.factionID === item.id;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                            classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5d93b6dd05204b89$export$441b5310849b9a95, {
                                [$5d93b6dd05204b89$export$bfddba54107e991b]: isCurrent
                            }),
                            imagePath: (0, $aTKgi.pathToURL)(item.imagePath),
                            title: item.name,
                            subtitle: "Faction",
                            onSelected: ()=>{
                                if (!isCurrent) {
                                    dispatch((0, $4KKbJ.setProfileFaction)(item.id));
                                    (0, $i7H0N.sendEvent)("profile_editor_set_faction", {
                                        id: item?.id,
                                        name: item?.name
                                    });
                                }
                            },
                            isSelected: isCurrent,
                            ...sharedCardProps
                        })
                    }, index + currentTab);
                });
            case "Character":
                if (!characters?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)(Empty, {
                    text: "No characters to show"
                });
                return characters?.map((item, index)=>{
                    const isCurrent = currentUserProfile?.character?.id === item.id;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                            classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5d93b6dd05204b89$export$de251036a26f76f2, {
                                [$5d93b6dd05204b89$export$bfddba54107e991b]: isCurrent
                            }),
                            imagePath: (0, $aTKgi.pathToURL)(item.thumbnailPath),
                            title: item.name,
                            subtitle: "Character",
                            onSelected: ()=>{
                                if (!isCurrent) {
                                    (0, $fL4mk.setProfileAsset)("character", item.id);
                                    (0, $i7H0N.sendEvent)("profile_editor_set_character", {
                                        id: item?.id,
                                        name: item?.name
                                    });
                                }
                            },
                            isSelected: isCurrent,
                            ...sharedCardProps
                        })
                    }, index + currentTab);
                });
            case "Background":
                if (!backgrounds?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)(Empty, {
                    text: "No backgrounds to show"
                });
                return backgrounds?.map((item, index)=>{
                    const isCurrent = currentUserProfile?.background?.id === item.id;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                            classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5d93b6dd05204b89$export$da15e73b251818b1, {
                                [$5d93b6dd05204b89$export$bfddba54107e991b]: isCurrent
                            }),
                            imagePath: (0, $aTKgi.pathToURL)(item.thumbnailPath),
                            title: item.name,
                            subtitle: "Background",
                            onSelected: ()=>{
                                if (!isCurrent) {
                                    (0, $fL4mk.setProfileAsset)("background", item.id);
                                    (0, $i7H0N.sendEvent)("profile_editor_set_background", {
                                        id: item?.id,
                                        name: item?.name
                                    });
                                }
                            },
                            isSelected: isCurrent,
                            ...sharedCardProps
                        })
                    }, index + currentTab);
                });
            case "Frame":
                if (!frames?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)(Empty, {
                    text: "No avatar frames to show"
                });
                return frames?.map((item, index)=>{
                    const isCurrent = currentUserProfile?.avatarFrame?.id === item.id;
                    return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                            classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5d93b6dd05204b89$export$6fc54610a72490ac, {
                                [$5d93b6dd05204b89$export$bfddba54107e991b]: isCurrent
                            }),
                            imagePath: (0, $aTKgi.pathToURL)(item.imagePath),
                            title: item.name,
                            subtitle: "Frame",
                            onSelected: ()=>{
                                if (isCurrent) {
                                    (0, $fL4mk.unsetProfileAsset)("avatar_frame");
                                    (0, $i7H0N.sendEvent)("profile_editor_remove_frame", {
                                        id: item?.id,
                                        name: item?.name
                                    });
                                } else {
                                    (0, $fL4mk.setProfileAsset)("avatar_frame", item.id);
                                    (0, $i7H0N.sendEvent)("profile_editor_set_frame", {
                                        id: item?.id,
                                        name: item?.name
                                    });
                                }
                            },
                            isSelected: isCurrent,
                            ...sharedCardProps
                        })
                    }, index + currentTab);
                });
            default:
                return null;
        }
    };
    const profileBackground = theme.customJSON?.profileBackground;
    const shouldShowShopLinkCard = theme.metadata?.hasProfileShop && (currentTab === "Background" || currentTab === "Character" || currentTab === "Frame");
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $5d93b6dd05204b89$export$9d55b23d8c4757a3,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $5d93b6dd05204b89$export$1e95b668f3b82d,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: $5d93b6dd05204b89$export$fb184b623420d9be,
                    children: "Edit Character"
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $5d93b6dd05204b89$export$40e543e69a8b3fbb,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5d93b6dd05204b89$export$3117ecc0d04bc057, {
                        [$5d93b6dd05204b89$export$c80d57c51a11eb0a]: !profileBackground
                    }),
                    style: profileBackground ? {
                        backgroundImage: `url("${profileBackground}")`,
                        borderImageSource: `url("${profileBackground}")`
                    } : {},
                    children: isLoading ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                        show: isLoading,
                        classname: $5d93b6dd05204b89$export$337c2b438c93a763,
                        hasBackground: false
                    }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $5d93b6dd05204b89$export$d167761217acc355,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)(TabButton, {
                                        tabType: "Character",
                                        iconType: "character"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)(TabButton, {
                                        tabType: "Title",
                                        iconType: "crown"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)(TabButton, {
                                        tabType: "Background",
                                        iconType: "backdrop"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)(TabButton, {
                                        tabType: "Faction",
                                        iconType: "faction"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)(TabButton, {
                                        tabType: "Frame",
                                        iconType: "avatar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                                className: $5d93b6dd05204b89$export$3843a12c911b43ce,
                                children: [
                                    "Edit ",
                                    currentTab
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $5d93b6dd05204b89$export$17a1664ed1fb5d6f,
                                children: [
                                    renderItems(),
                                    shouldShowShopLinkCard && shopLinkCard
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $86a4daaa608bd515$export$2e2bcd8739ae039 = $86a4daaa608bd515$var$ProfileEditor;



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $1bTT8 = parcelRequire("1bTT8");
var $fe5db368ab8084db$export$44de8fd11e6da06;
var $fe5db368ab8084db$export$af2dba6db4e9e1f0;
var $fe5db368ab8084db$export$17fa98cb055e8fa7;
var $fe5db368ab8084db$export$a5833c2b43ca4340;
var $fe5db368ab8084db$export$47511f9a6581d1d6;
var $fe5db368ab8084db$export$dd1c05b92185401c;
var $fe5db368ab8084db$export$8b28cf6cd00fe080;
var $fe5db368ab8084db$export$186c650311ff0789;
var $fe5db368ab8084db$export$6746fe0d9c9fab54;
var $fe5db368ab8084db$export$2bcf359f0c20e94f;
var $fe5db368ab8084db$export$2903d10d531d0ac0;
var $fe5db368ab8084db$export$fe7c49d056ea1d88;
$fe5db368ab8084db$export$44de8fd11e6da06 = `GEwJ6q_ArisewareScores`;
$fe5db368ab8084db$export$af2dba6db4e9e1f0 = `GEwJ6q_failure`;
$fe5db368ab8084db$export$17fa98cb055e8fa7 = `GEwJ6q_fontSizeH1`;
$fe5db368ab8084db$export$a5833c2b43ca4340 = `GEwJ6q_fontSizeH2`;
$fe5db368ab8084db$export$47511f9a6581d1d6 = `GEwJ6q_fontSizeH3`;
$fe5db368ab8084db$export$dd1c05b92185401c = `GEwJ6q_fontSizeH4`;
$fe5db368ab8084db$export$8b28cf6cd00fe080 = `GEwJ6q_fontSizeH5`;
$fe5db368ab8084db$export$186c650311ff0789 = `GEwJ6q_fontSizeH6`;
$fe5db368ab8084db$export$6746fe0d9c9fab54 = `GEwJ6q_fontSizeSmall`;
$fe5db368ab8084db$export$2bcf359f0c20e94f = `GEwJ6q_fontSizeTiny`;
$fe5db368ab8084db$export$2903d10d531d0ac0 = `GEwJ6q_fontSizep`;
$fe5db368ab8084db$export$fe7c49d056ea1d88 = `GEwJ6q_success`;


const $3617fa56fb986c7d$var$getFormattedScoreString = (score)=>{
    if (score.score) return (0, $1bTT8.secondsIntoTimeString)(score.score);
    return score.isCompleted ? "Complete" : "Incomplete";
};
const $3617fa56fb986c7d$var$ArisewareScores = ({ arisewareScores: arisewareScores, classname: classname })=>{
    if (!arisewareScores?.length) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($fe5db368ab8084db$export$44de8fd11e6da06, classname),
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
            children: arisewareScores?.map((score, index)=>{
                return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                            children: [
                                score.displayName,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                [$fe5db368ab8084db$export$fe7c49d056ea1d88]: score.isCompleted,
                                [$fe5db368ab8084db$export$af2dba6db4e9e1f0]: !score.isCompleted
                            }),
                            children: $3617fa56fb986c7d$var$getFormattedScoreString(score)
                        })
                    ]
                }, index);
            })
        })
    });
};
var $3617fa56fb986c7d$export$2e2bcd8739ae039 = $3617fa56fb986c7d$var$ArisewareScores;


var $2183f23a9c125e68$export$8d639674747a02b2;
var $2183f23a9c125e68$export$345c5736c8054f22;
var $2183f23a9c125e68$export$7f4d16e9138f1f73;
var $2183f23a9c125e68$export$efe229eab43a9869;
var $2183f23a9c125e68$export$a7db06668cad9adb;
var $2183f23a9c125e68$export$93e1a85926f756bf;
var $2183f23a9c125e68$export$51541a32d95b706c;
var $2183f23a9c125e68$export$380d7b56e770873a;
var $2183f23a9c125e68$export$17fa98cb055e8fa7;
var $2183f23a9c125e68$export$a5833c2b43ca4340;
var $2183f23a9c125e68$export$47511f9a6581d1d6;
var $2183f23a9c125e68$export$dd1c05b92185401c;
var $2183f23a9c125e68$export$8b28cf6cd00fe080;
var $2183f23a9c125e68$export$186c650311ff0789;
var $2183f23a9c125e68$export$6746fe0d9c9fab54;
var $2183f23a9c125e68$export$2bcf359f0c20e94f;
var $2183f23a9c125e68$export$2903d10d531d0ac0;
var $2183f23a9c125e68$export$6ca2a662afed3e7f;
var $2183f23a9c125e68$export$e141060ad697f932;
var $2183f23a9c125e68$export$ea0830439c7fc698;
var $2183f23a9c125e68$export$337c2b438c93a763;
var $2183f23a9c125e68$export$ae179270c140c785;
var $2183f23a9c125e68$export$c80d57c51a11eb0a;
var $2183f23a9c125e68$export$e736b9a9cb863988;
var $2183f23a9c125e68$export$7f44af4bf779e8e6;
var $2183f23a9c125e68$export$d013e975d19ae984;
var $2183f23a9c125e68$export$73e306563b41ad18;
var $2183f23a9c125e68$export$2fca6816ddfbf6d9;
var $2183f23a9c125e68$export$b2ff14da37fadcd;
var $2183f23a9c125e68$export$1c6eb436e58424dd;
var $2183f23a9c125e68$export$a166ff361b240a63;
var $2183f23a9c125e68$export$db7a854cc39cffe0;
var $2183f23a9c125e68$export$ac052f74bbc68e2d;
$2183f23a9c125e68$export$8d639674747a02b2 = `HEBnsa_ProfileDrawer`;
$2183f23a9c125e68$export$345c5736c8054f22 = `HEBnsa_avatar`;
$2183f23a9c125e68$export$7f4d16e9138f1f73 = `HEBnsa_bottomContent`;
$2183f23a9c125e68$export$efe229eab43a9869 = `HEBnsa_closeButton`;
$2183f23a9c125e68$export$a7db06668cad9adb = `HEBnsa_content`;
$2183f23a9c125e68$export$93e1a85926f756bf = `HEBnsa_editButton`;
$2183f23a9c125e68$export$51541a32d95b706c = `HEBnsa_editingAvatar`;
$2183f23a9c125e68$export$380d7b56e770873a = `HEBnsa_factionImage`;
$2183f23a9c125e68$export$17fa98cb055e8fa7 = `HEBnsa_fontSizeH1`;
$2183f23a9c125e68$export$a5833c2b43ca4340 = `HEBnsa_fontSizeH2`;
$2183f23a9c125e68$export$47511f9a6581d1d6 = `HEBnsa_fontSizeH3`;
$2183f23a9c125e68$export$dd1c05b92185401c = `HEBnsa_fontSizeH4`;
$2183f23a9c125e68$export$8b28cf6cd00fe080 = `HEBnsa_fontSizeH5`;
$2183f23a9c125e68$export$186c650311ff0789 = `HEBnsa_fontSizeH6`;
$2183f23a9c125e68$export$6746fe0d9c9fab54 = `HEBnsa_fontSizeSmall`;
$2183f23a9c125e68$export$2bcf359f0c20e94f = `HEBnsa_fontSizeTiny`;
$2183f23a9c125e68$export$2903d10d531d0ac0 = `HEBnsa_fontSizep`;
$2183f23a9c125e68$export$6ca2a662afed3e7f = `HEBnsa_isEditing`;
$2183f23a9c125e68$export$e141060ad697f932 = `HEBnsa_isLoaded`;
$2183f23a9c125e68$export$ea0830439c7fc698 = `HEBnsa_isOpen`;
$2183f23a9c125e68$export$337c2b438c93a763 = `HEBnsa_loadingScreen`;
$2183f23a9c125e68$export$ae179270c140c785 = `HEBnsa_myPrizes`;
$2183f23a9c125e68$export$c80d57c51a11eb0a = `HEBnsa_noBackgroundImage`;
$2183f23a9c125e68$export$e736b9a9cb863988 = `HEBnsa_profileBackground`;
$2183f23a9c125e68$export$7f44af4bf779e8e6 = `HEBnsa_profileCharacter`;
$2183f23a9c125e68$export$d013e975d19ae984 = `HEBnsa_profileCharacterContainer`;
$2183f23a9c125e68$export$73e306563b41ad18 = `HEBnsa_profileLogo`;
$2183f23a9c125e68$export$2fca6816ddfbf6d9 = `HEBnsa_shopButton`;
$2183f23a9c125e68$export$b2ff14da37fadcd = `HEBnsa_themedBar`;
$2183f23a9c125e68$export$1c6eb436e58424dd = `HEBnsa_themedBarContent`;
$2183f23a9c125e68$export$a166ff361b240a63 = `HEBnsa_titleStat`;
$2183f23a9c125e68$export$db7a854cc39cffe0 = `HEBnsa_titlesUnlocked`;
$2183f23a9c125e68$export$ac052f74bbc68e2d = `HEBnsa_topBar`;


function $c292466b2c4e7afc$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const { isProfileOpen: isProfileOpen, currentlyViewingProfile: currentlyViewingProfile, isMyPrizesOpen: isMyPrizesOpen } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const isViewingOwnProfile = currentlyViewingProfile?.userID === currentUserProfile?.userID;
    const prizesBackgroundImage = theme.customJSON?.profileBackground;
    const [previousUserID, setPreviousUserID] = (0, $8FY87.useState)(null);
    const [arisewareScores, setArisewareScores] = (0, $8FY87.useState)(null);
    const [titles, setTitles] = (0, $8FY87.useState)(null);
    const [numberOfAvailableTitles, setNumberOfAvailableTitles] = (0, $8FY87.useState)(null);
    const [characterIsLoaded, setCharacterIsLoaded] = (0, $8FY87.useState)(false);
    const [backgroundIsLoaded, setBackgroundIsLoaded] = (0, $8FY87.useState)(false);
    const [isEditing, setIsEditing] = (0, $8FY87.useState)(false);
    const isFirstTimeOpened = (0, $8FY87.useRef)(true);
    // If viewing own profile, always show the latest profile data. Otherwise use data contained in message.
    const profile = isViewingOwnProfile ? currentUserProfile : currentlyViewingProfile;
    const customJsonFeatures = theme.customJSON.profileFeaturesEnabled;
    const featuresEnabled = {
        character: customJsonFeatures?.character !== false,
        background: customJsonFeatures?.background !== false,
        layeredAvatar: customJsonFeatures?.layeredAvatar !== false,
        faction: customJsonFeatures?.faction !== false,
        arisewareScores: customJsonFeatures?.arisewareScores !== false,
        statsSummary: customJsonFeatures?.statsSummary !== false,
        titles: customJsonFeatures?.titles !== false,
        showNumberOfAvailableTitles: customJsonFeatures?.showNumberOfAvailableTitles === true,
        editing: customJsonFeatures?.editing !== false,
        profileLogo: customJsonFeatures?.profileLogo !== false,
        forceFallbackBackground: customJsonFeatures?.forceFallbackBackground === true,
        // Controlled with CMS implemented toggle:
        prizes: theme.metadata?.hasPrizes,
        shopButton: theme.metadata?.hasProfileShop || theme.metadata?.hasExternalShop
    };
    const isLoading = !(previousUserID === profile?.userID && (!featuresEnabled.arisewareScores || arisewareScores !== null) && (!featuresEnabled.titles || titles !== null) && (!featuresEnabled.character || characterIsLoaded) && (!featuresEnabled.background || backgroundIsLoaded));
    (0, $8FY87.useEffect)(()=>{
        if (isProfileOpen) {
            let areRequestsStale = false; // To stop stale request issues
            try {
                if (previousUserID !== profile?.userID) {
                    // If is a different user, clear the old data
                    setArisewareScores(null);
                    setTitles(null);
                }
                featuresEnabled.arisewareScores && profile?.userID && (0, $f9aoP.getArisewareScoresForUser)(profile?.userID).then((result)=>{
                    if (!areRequestsStale) setArisewareScores(result);
                }).catch(()=>{
                    if (!areRequestsStale) setArisewareScores([]);
                });
                featuresEnabled.titles && (0, $f9aoP.getTitles)(profile?.userID, isFirstTimeOpened.current).then((result)=>{
                    if (!areRequestsStale) {
                        const processedTitles = (0, $fL4mk.processTitles)(result);
                        setTitles(processedTitles);
                    }
                }).catch(()=>{
                    if (!areRequestsStale) setTitles([]);
                });
                if (featuresEnabled.titles && featuresEnabled.showNumberOfAvailableTitles && numberOfAvailableTitles === null) (0, $f9aoP.getAvailableTitles)().then((result)=>{
                    if (Array.isArray(result) && result.length > 0) setNumberOfAvailableTitles(result.length);
                }).catch(()=>{
                    setNumberOfAvailableTitles(null);
                });
                setPreviousUserID(profile?.userID);
                isFirstTimeOpened.current = false;
            } catch (error) {}
            return ()=>{
                // Drawer closed, or ID changed, so set all requests as stale
                areRequestsStale = true;
            };
        }
    }, [
        isProfileOpen,
        profile?.userID,
        profile?.title?.title
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (isProfileOpen) {
            audio?.play("gust-open");
            (0, $i7H0N.sendEventV2)("profile_viewed");
        }
        setIsEditing(false);
    }, [
        isProfileOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isProfileOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2183f23a9c125e68$export$8d639674747a02b2, {
            [$2183f23a9c125e68$export$ea0830439c7fc698]: isProfileOpen,
            [$2183f23a9c125e68$export$e141060ad697f932]: !isLoading
        }),
        inert: !isProfileOpen ? "" : undefined,
        onTransitionEnd: onTransitionEnd,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $2183f23a9c125e68$export$ac052f74bbc68e2d,
                inert: isMyPrizesOpen ? "" : undefined,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonRef: closeButtonRef,
                        iconType: "close",
                        buttonStyle: "round",
                        ariaLabel: "Close Profile",
                        className: $2183f23a9c125e68$export$efe229eab43a9869,
                        onClick: ()=>{
                            audio?.play("gust-close");
                            dispatch((0, $baXkz.closeProfile)());
                        }
                    }),
                    featuresEnabled.shopButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: theme.customJSON.shop?.shopButtonIcon ?? "shop",
                        title: "Open Shop",
                        ariaLabel: "Open Shop",
                        onClick: ()=>{
                            dispatch((0, $baXkz.setIsShopOpen)(true));
                            (0, $i7H0N.sendEvent)("open_shop_from_profile_header");
                        },
                        className: $2183f23a9c125e68$export$2fca6816ddfbf6d9
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2183f23a9c125e68$export$a7db06668cad9adb, {
                    [$2183f23a9c125e68$export$6ca2a662afed3e7f]: isEditing
                }),
                inert: isLoading || isMyPrizesOpen ? "" : undefined,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $2183f23a9c125e68$export$d013e975d19ae984,
                        children: [
                            featuresEnabled.background && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $50fe167d1e415d38$export$2e2bcd8739ae039), {
                                classname: $2183f23a9c125e68$export$e736b9a9cb863988,
                                onLoad: ()=>setBackgroundIsLoaded(true),
                                rivUrl: featuresEnabled.forceFallbackBackground ? null : profile?.background?.rivFileURL,
                                imagePath: featuresEnabled.forceFallbackBackground ? null : profile?.background?.imagePath
                            }),
                            featuresEnabled.profileLogo && theme.customJSON?.profileLogoUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $2183f23a9c125e68$export$73e306563b41ad18,
                                style: {
                                    backgroundImage: `url("${theme.customJSON.profileLogoUrl}")`
                                }
                            }),
                            featuresEnabled.character && profile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a3c39d4e2d193d93$export$2e2bcd8739ae039), {
                                classname: $2183f23a9c125e68$export$7f44af4bf779e8e6,
                                onLoad: ()=>setCharacterIsLoaded(true),
                                rivUrl: profile.character?.rivFileURL,
                                imagePath: profile.character?.imagePath,
                                hexColour: profile.background?.colour
                            }),
                            featuresEnabled.faction && profile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $9bcbc78dd3688f3f$export$2e2bcd8739ae039), {
                                classname: $2183f23a9c125e68$export$380d7b56e770873a,
                                faction: profile.faction,
                                rank: profile.supplyRunRank
                            }, profile.userID),
                            featuresEnabled.editing && isViewingOwnProfile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                iconType: isEditing ? "priority" : "edit",
                                buttonStyle: "round",
                                ariaLabel: isEditing ? "Stop Editing profile" : "Edit Profile",
                                className: $2183f23a9c125e68$export$93e1a85926f756bf,
                                onClick: ()=>{
                                    setIsEditing(!isEditing);
                                }
                            }),
                            featuresEnabled.layeredAvatar && profile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                                classname: $2183f23a9c125e68$export$51541a32d95b706c,
                                backgroundImagePath: profile.background?.thumbnailPath,
                                characterImagePath: profile.character?.thumbnailPath,
                                frameImagePath: profile.avatarFrame?.imagePath,
                                title: `${profile.displayName}'s avatar`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2183f23a9c125e68$export$7f4d16e9138f1f73, {
                            [$2183f23a9c125e68$export$6ca2a662afed3e7f]: isEditing
                        }),
                        inert: isEditing ? "" : undefined,
                        children: [
                            profile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f531a9c5a97d8dd8$export$2e2bcd8739ae039), {
                                classname: $2183f23a9c125e68$export$b2ff14da37fadcd,
                                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: $2183f23a9c125e68$export$1c6eb436e58424dd,
                                    children: [
                                        featuresEnabled.layeredAvatar && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                                            classname: $2183f23a9c125e68$export$345c5736c8054f22,
                                            backgroundImagePath: profile.background?.thumbnailPath,
                                            characterImagePath: profile.character?.thumbnailPath,
                                            frameImagePath: profile.avatarFrame?.imagePath,
                                            title: `${profile.displayName}'s avatar`
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $13dab9088986de0c$export$2e2bcd8739ae039), {
                                            profile: profile,
                                            hasFaction: false
                                        })
                                    ]
                                })
                            }),
                            featuresEnabled.statsSummary && profile && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $86b59be89ea19d3d$export$2e2bcd8739ae039), {
                                numberOfTitles: titles?.length,
                                puzzlesCompleted: arisewareScores?.length ? arisewareScores?.filter((score)=>score.isCompleted)?.length : null,
                                userID: profile.userID,
                                role: profile.role
                            }, profile.userID),
                            featuresEnabled.prizes && isViewingOwnProfile && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2183f23a9c125e68$export$ae179270c140c785, {
                                    [$2183f23a9c125e68$export$c80d57c51a11eb0a]: !prizesBackgroundImage
                                }),
                                style: prizesBackgroundImage ? {
                                    backgroundImage: `url("${prizesBackgroundImage}")`
                                } : {},
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                        type: "action"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        children: "My Prizes"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                                        onClick: ()=>dispatch((0, $baXkz.setIsMyPrizesOpen)(true)),
                                        children: "View My Prizes"
                                    })
                                ]
                            }),
                            featuresEnabled.arisewareScores && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3617fa56fb986c7d$export$2e2bcd8739ae039), {
                                arisewareScores: arisewareScores
                            }),
                            featuresEnabled.titles && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $2183f23a9c125e68$export$db7a854cc39cffe0,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $86b59be89ea19d3d$export$6e5fab54fd9c478), {
                                        classname: $2183f23a9c125e68$export$a166ff361b240a63,
                                        iconType: "crown",
                                        title: numberOfAvailableTitles ? "Titles Earned:" : "Titles:",
                                        value: `${titles?.length}`,
                                        suffixValue: numberOfAvailableTitles ? `/${numberOfAvailableTitles}` : null
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                                        children: titles?.map((title, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44c6ed99993eabb1$export$2e2bcd8739ae039), {
                                                    text: title.title,
                                                    rarity: title.rarity,
                                                    title: title.rarity?.toString()
                                                })
                                            }, index))
                                    })
                                ]
                            })
                        ]
                    }),
                    isEditing && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $86a4daaa608bd515$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                        show: isLoading,
                        classname: $2183f23a9c125e68$export$337c2b438c93a763
                    })
                ]
            }),
            featuresEnabled.prizes && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $81b3408e0e08a3dd$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $aTRs6 = parcelRequire("aTRs6");

var $f9aoP = parcelRequire("f9aoP");
function $85e91bf523db42d5$export$988a54d054fb2a52(currency, amount) {
    try {
        if (isNaN(amount)) {
            console.error(`Could not format price for item, price is not a number: ${amount}`);
            return null;
        }
        return (amount / 100).toLocaleString("en-US", {
            style: "currency",
            currency: currency
        });
    } catch (error) {
        console.error(`Could not format price for item, values are currency: ${currency}, amount: ${amount}. Error: ${error.message}`);
        return null;
    }
}



var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");


var $cEIti = parcelRequire("cEIti");

var $baXkz = parcelRequire("baXkz");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");





var $4MZsN = parcelRequire("4MZsN");
var $46b901895c9d8ffa$export$14240dc5f8d9a4ac;
var $46b901895c9d8ffa$export$345c5736c8054f22;
var $46b901895c9d8ffa$export$1cddbd60d40d9709;
var $46b901895c9d8ffa$export$17fa98cb055e8fa7;
var $46b901895c9d8ffa$export$a5833c2b43ca4340;
var $46b901895c9d8ffa$export$47511f9a6581d1d6;
var $46b901895c9d8ffa$export$dd1c05b92185401c;
var $46b901895c9d8ffa$export$8b28cf6cd00fe080;
var $46b901895c9d8ffa$export$186c650311ff0789;
var $46b901895c9d8ffa$export$6746fe0d9c9fab54;
var $46b901895c9d8ffa$export$2bcf359f0c20e94f;
var $46b901895c9d8ffa$export$2903d10d531d0ac0;
var $46b901895c9d8ffa$export$18abeb4afc60019;
var $46b901895c9d8ffa$export$1237798dc640739a;
var $46b901895c9d8ffa$export$337c2b438c93a763;
var $46b901895c9d8ffa$export$578fcbc4821dcd12;
var $46b901895c9d8ffa$export$c80d57c51a11eb0a;
var $46b901895c9d8ffa$export$1dbc7e69d761a8b4;
$46b901895c9d8ffa$export$14240dc5f8d9a4ac = `By9l4W_BundleItem`;
$46b901895c9d8ffa$export$345c5736c8054f22 = `By9l4W_avatar`;
$46b901895c9d8ffa$export$1cddbd60d40d9709 = `By9l4W_cardDescription`;
$46b901895c9d8ffa$export$17fa98cb055e8fa7 = `By9l4W_fontSizeH1`;
$46b901895c9d8ffa$export$a5833c2b43ca4340 = `By9l4W_fontSizeH2`;
$46b901895c9d8ffa$export$47511f9a6581d1d6 = `By9l4W_fontSizeH3`;
$46b901895c9d8ffa$export$dd1c05b92185401c = `By9l4W_fontSizeH4`;
$46b901895c9d8ffa$export$8b28cf6cd00fe080 = `By9l4W_fontSizeH5`;
$46b901895c9d8ffa$export$186c650311ff0789 = `By9l4W_fontSizeH6`;
$46b901895c9d8ffa$export$6746fe0d9c9fab54 = `By9l4W_fontSizeSmall`;
$46b901895c9d8ffa$export$2bcf359f0c20e94f = `By9l4W_fontSizeTiny`;
$46b901895c9d8ffa$export$2903d10d531d0ac0 = `By9l4W_fontSizep`;
$46b901895c9d8ffa$export$18abeb4afc60019 = `By9l4W_interactionContainer`;
$46b901895c9d8ffa$export$1237798dc640739a = `By9l4W_label`;
$46b901895c9d8ffa$export$337c2b438c93a763 = `By9l4W_loadingScreen`;
$46b901895c9d8ffa$export$578fcbc4821dcd12 = `By9l4W_longTitle`;
$46b901895c9d8ffa$export$c80d57c51a11eb0a = `By9l4W_noBackgroundImage`;
$46b901895c9d8ffa$export$1dbc7e69d761a8b4 = `By9l4W_purchasedOverlay`;


const $61edd578a935b4f6$export$14240dc5f8d9a4ac = ({ classname: classname, onSelected: onSelected, pack: pack })=>{
    const theme = (0, $cEIti.useTheme)();
    if (!pack) return;
    const { background: background, character: character, avatarFrame: avatarFrame } = pack.assets;
    const formattedPrice = (0, $85e91bf523db42d5$export$988a54d054fb2a52)(pack.currency, pack.price);
    const canBePurchased = formattedPrice && !pack.purchased;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($46b901895c9d8ffa$export$14240dc5f8d9a4ac, classname, {
            [$46b901895c9d8ffa$export$578fcbc4821dcd12]: pack.name?.length > 20,
            [$46b901895c9d8ffa$export$c80d57c51a11eb0a]: !theme.customJSON?.cardBackgroundImageUrl
        }),
        style: theme.customJSON?.cardBackgroundImageUrl ? {
            backgroundImage: `url("${theme.customJSON?.cardBackgroundImageUrl}")`
        } : {},
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $24468f6f9311b4e7$export$2e2bcd8739ae039), {
                background: background,
                character: character,
                avatarFrame: avatarFrame,
                avatarClassname: $46b901895c9d8ffa$export$345c5736c8054f22
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $46b901895c9d8ffa$export$18abeb4afc60019,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $248e04b79658491e$export$2e2bcd8739ae039), {
                        classname: $46b901895c9d8ffa$export$1cddbd60d40d9709,
                        title: pack.name,
                        subtitle: pack.rarity,
                        rarity: pack.rarity,
                        onClick: canBePurchased ? onSelected : null,
                        maskImage: theme.customJSON?.cardTextBackgroundImageUrl,
                        iconType: "info",
                        keepFontSize: true
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                        onClick: onSelected,
                        disabled: !canBePurchased,
                        children: formattedPrice ? "Buy for " + formattedPrice : "Unavailable"
                    })
                ]
            }),
            pack.purchased && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($46b901895c9d8ffa$export$1dbc7e69d761a8b4),
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                            type: "priority"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            children: "Already Purchased"
                        })
                    ]
                })
            })
        ]
    });
};
var $61edd578a935b4f6$export$2e2bcd8739ae039 = $61edd578a935b4f6$export$14240dc5f8d9a4ac;



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");


var $aTKgi = parcelRequire("aTKgi");



var $i7H0N = parcelRequire("i7H0N");





var $f888bac9a90e87f8$export$56e55935f64a2495;
var $f888bac9a90e87f8$export$555f04397502546;
var $f888bac9a90e87f8$export$da15e73b251818b1;
var $f888bac9a90e87f8$export$5a2ca57322ac9b7e;
var $f888bac9a90e87f8$export$5cfd5c18b591b2db;
var $f888bac9a90e87f8$export$412fa79987e99831;
var $f888bac9a90e87f8$export$7e3f7b365e14881a;
var $f888bac9a90e87f8$export$de251036a26f76f2;
var $f888bac9a90e87f8$export$487c6698b91beb90;
var $f888bac9a90e87f8$export$efe229eab43a9869;
var $f888bac9a90e87f8$export$83f80cd4c601e758;
var $f888bac9a90e87f8$export$e1f23a027355e020;
var $f888bac9a90e87f8$export$17fa98cb055e8fa7;
var $f888bac9a90e87f8$export$a5833c2b43ca4340;
var $f888bac9a90e87f8$export$47511f9a6581d1d6;
var $f888bac9a90e87f8$export$dd1c05b92185401c;
var $f888bac9a90e87f8$export$8b28cf6cd00fe080;
var $f888bac9a90e87f8$export$186c650311ff0789;
var $f888bac9a90e87f8$export$6746fe0d9c9fab54;
var $f888bac9a90e87f8$export$2bcf359f0c20e94f;
var $f888bac9a90e87f8$export$2903d10d531d0ac0;
var $f888bac9a90e87f8$export$6fc54610a72490ac;
var $f888bac9a90e87f8$export$51fcb2d10edaf8bd;
var $f888bac9a90e87f8$export$18abeb4afc60019;
var $f888bac9a90e87f8$export$96e4b36520c26a2c;
var $f888bac9a90e87f8$export$c80d57c51a11eb0a;
var $f888bac9a90e87f8$export$fad3c8302a7540c6;
var $f888bac9a90e87f8$export$fb184b623420d9be;
$f888bac9a90e87f8$export$56e55935f64a2495 = `xggSTG_BundleModal`;
$f888bac9a90e87f8$export$555f04397502546 = `xggSTG_assets`;
$f888bac9a90e87f8$export$da15e73b251818b1 = `xggSTG_backgroundItem`;
$f888bac9a90e87f8$export$5a2ca57322ac9b7e = `xggSTG_blankItem`;
$f888bac9a90e87f8$export$5cfd5c18b591b2db = `xggSTG_bottomText`;
$f888bac9a90e87f8$export$412fa79987e99831 = `xggSTG_bulgeEffectIn`;
$f888bac9a90e87f8$export$412fa79987e99831;
$f888bac9a90e87f8$export$7e3f7b365e14881a = `xggSTG_bulgeEffectOut`;
$f888bac9a90e87f8$export$7e3f7b365e14881a;
$f888bac9a90e87f8$export$de251036a26f76f2 = `xggSTG_characterItem`;
$f888bac9a90e87f8$export$487c6698b91beb90 = `xggSTG_closeAnimation`;
$f888bac9a90e87f8$export$efe229eab43a9869 = `xggSTG_closeButton`;
$f888bac9a90e87f8$export$83f80cd4c601e758 = `xggSTG_fadeInBackground`;
$f888bac9a90e87f8$export$83f80cd4c601e758;
$f888bac9a90e87f8$export$e1f23a027355e020 = `xggSTG_fadeOutBackground`;
$f888bac9a90e87f8$export$e1f23a027355e020;
$f888bac9a90e87f8$export$17fa98cb055e8fa7 = `xggSTG_fontSizeH1`;
$f888bac9a90e87f8$export$a5833c2b43ca4340 = `xggSTG_fontSizeH2`;
$f888bac9a90e87f8$export$47511f9a6581d1d6 = `xggSTG_fontSizeH3`;
$f888bac9a90e87f8$export$dd1c05b92185401c = `xggSTG_fontSizeH4`;
$f888bac9a90e87f8$export$8b28cf6cd00fe080 = `xggSTG_fontSizeH5`;
$f888bac9a90e87f8$export$186c650311ff0789 = `xggSTG_fontSizeH6`;
$f888bac9a90e87f8$export$6746fe0d9c9fab54 = `xggSTG_fontSizeSmall`;
$f888bac9a90e87f8$export$2bcf359f0c20e94f = `xggSTG_fontSizeTiny`;
$f888bac9a90e87f8$export$2903d10d531d0ac0 = `xggSTG_fontSizep`;
$f888bac9a90e87f8$export$6fc54610a72490ac = `xggSTG_frameItem`;
$f888bac9a90e87f8$export$51fcb2d10edaf8bd = `xggSTG_guestOverlay`;
$f888bac9a90e87f8$export$18abeb4afc60019 = `xggSTG_interactionContainer`;
$f888bac9a90e87f8$export$96e4b36520c26a2c = `xggSTG_modal`;
$f888bac9a90e87f8$export$c80d57c51a11eb0a = `xggSTG_noBackgroundImage`;
$f888bac9a90e87f8$export$fad3c8302a7540c6 = `xggSTG_scrollContainer`;
$f888bac9a90e87f8$export$fb184b623420d9be = `xggSTG_title`;


const $b96c0c3a5a43d12e$export$56e55935f64a2495 = ({ onClose: onClose, classname: classname, pack: pack })=>{
    const theme = (0, $cEIti.useTheme)();
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const [transactionStatus, setTransactionStatus] = (0, $8FY87.useState)("default");
    const [shouldPlayCloseAnimation, setShouldPlayCloseAnimation] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        closeButtonRef.current?.focus();
    }, []);
    const close = ()=>{
        setShouldPlayCloseAnimation(true);
        (0, $i7H0N.sendEvent)("profile_shop_bundle_close", {
            id: pack?.id,
            name: pack?.name,
            price: pack?.price
        });
        setTimeout(()=>{
            onClose();
        }, 400); // Should match close animation duration
    };
    if (!pack) return;
    const { background: background, character: character, avatarFrame: avatarFrame } = pack.assets;
    const purchase = ()=>{
        setTransactionStatus("loading");
        (0, $882c398467ff90b2$export$b96d1a6f7d456e0f)(pack.id).then((wasSuccessful)=>{
            if (!wasSuccessful) setTransactionStatus("failed");
        });
        (0, $i7H0N.sendEvent)("profile_shop_purchase_initiated", {
            id: pack?.id,
            name: pack?.name,
            price: pack?.price
        });
    };
    const sharedCardProps = {
        backgroundImagePath: theme.customJSON?.cardBackgroundImageUrl,
        textBackgroundImagePath: theme.customJSON?.cardTextBackgroundImageUrl,
        hasBorder: false
    };
    const renderBuyButton = ()=>{
        switch(transactionStatus){
            case "loading":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: "Processing..."
                });
            case "failed":
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                    disabled: true,
                    children: "Purchase failed"
                });
            default:
                const formattedPrice = (0, $85e91bf523db42d5$export$988a54d054fb2a52)(pack.currency, pack.price);
                return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                    onClick: purchase,
                    disabled: !formattedPrice || isGuest,
                    children: formattedPrice ? "Buy for " + formattedPrice : "Unavailable"
                });
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($f888bac9a90e87f8$export$56e55935f64a2495, classname, {
            [$f888bac9a90e87f8$export$487c6698b91beb90]: shouldPlayCloseAnimation
        }),
        inert: shouldPlayCloseAnimation ? "" : undefined,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($f888bac9a90e87f8$export$96e4b36520c26a2c, {
                [$f888bac9a90e87f8$export$c80d57c51a11eb0a]: !theme.customJSON?.profileBackground
            }),
            style: theme.customJSON?.profileBackground ? {
                backgroundImage: `url("${theme.customJSON?.profileBackground}")`
            } : {},
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                    buttonRef: closeButtonRef,
                    iconType: "close",
                    buttonStyle: "round",
                    ariaLabel: "close modal",
                    className: $f888bac9a90e87f8$export$efe229eab43a9869,
                    onClick: close
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $f888bac9a90e87f8$export$fad3c8302a7540c6,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                            className: $f888bac9a90e87f8$export$fb184b623420d9be,
                            children: [
                                pack.name,
                                " includes:"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                            className: $f888bac9a90e87f8$export$555f04397502546,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                                        classname: $f888bac9a90e87f8$export$6fc54610a72490ac,
                                        imagePath: (0, $aTKgi.pathToURL)(avatarFrame.imagePath),
                                        title: avatarFrame.name,
                                        subtitle: "Frame",
                                        onSelected: ()=>{},
                                        ...sharedCardProps
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                                        classname: $f888bac9a90e87f8$export$de251036a26f76f2,
                                        imagePath: (0, $aTKgi.pathToURL)(character.thumbnailPath),
                                        title: character.name,
                                        subtitle: "Character",
                                        onSelected: ()=>{},
                                        ...sharedCardProps
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                                        classname: $f888bac9a90e87f8$export$da15e73b251818b1,
                                        imagePath: (0, $aTKgi.pathToURL)(background.thumbnailPath),
                                        title: background.name,
                                        subtitle: "Background",
                                        onSelected: ()=>{},
                                        ...sharedCardProps
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                    children: sharedCardProps.backgroundImagePath ? /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                        "aria-hidden": "true",
                                        className: $f888bac9a90e87f8$export$5a2ca57322ac9b7e,
                                        src: sharedCardProps.backgroundImagePath,
                                        alt: " "
                                    }) : /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($f888bac9a90e87f8$export$5a2ca57322ac9b7e, $f888bac9a90e87f8$export$c80d57c51a11eb0a)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: $f888bac9a90e87f8$export$18abeb4afc60019,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $248e04b79658491e$export$2e2bcd8739ae039), {
                                    title: pack.name,
                                    subtitle: pack.rarity,
                                    rarity: pack.rarity,
                                    maskImage: theme.customJSON?.cardTextBackgroundImageUrl
                                }),
                                renderBuyButton()
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: $f888bac9a90e87f8$export$5cfd5c18b591b2db,
                            children: "Once purchased, decorations will be added to your profile collection and can be applied at any time."
                        })
                    ]
                }),
                isGuest && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $f888bac9a90e87f8$export$51fcb2d10edaf8bd,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                            children: "Sign Up to check out"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            children: "You must be logged in to buy items from the shop."
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                (0, $i7H0N.sendEvent)("shop_bundle_modal_sign_up_click", {
                                    message: "Sign Up to check out, You must be logged in to buy items from the shop."
                                });
                                navigateToSignup();
                            },
                            children: "Sign Up"
                        })
                    ]
                })
            ]
        })
    });
};
var $b96c0c3a5a43d12e$export$2e2bcd8739ae039 = $b96c0c3a5a43d12e$export$56e55935f64a2495;



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $aTKgi = parcelRequire("aTKgi");

var $i7H0N = parcelRequire("i7H0N");


var $7b80074cd360efa0$export$5058c1d7a80a37e4;
var $7b80074cd360efa0$export$2ba01fb71ed41cb6;
var $7b80074cd360efa0$export$17fa98cb055e8fa7;
var $7b80074cd360efa0$export$a5833c2b43ca4340;
var $7b80074cd360efa0$export$47511f9a6581d1d6;
var $7b80074cd360efa0$export$dd1c05b92185401c;
var $7b80074cd360efa0$export$8b28cf6cd00fe080;
var $7b80074cd360efa0$export$186c650311ff0789;
var $7b80074cd360efa0$export$6746fe0d9c9fab54;
var $7b80074cd360efa0$export$2bcf359f0c20e94f;
var $7b80074cd360efa0$export$2903d10d531d0ac0;
var $7b80074cd360efa0$export$5c452ff88e35e47d;
var $7b80074cd360efa0$export$18abeb4afc60019;
var $7b80074cd360efa0$export$1237798dc640739a;
var $7b80074cd360efa0$export$c80d57c51a11eb0a;
var $7b80074cd360efa0$export$321c0b1a406de31f;
$7b80074cd360efa0$export$5058c1d7a80a37e4 = `_XoYAq_ShopExternalItem`;
$7b80074cd360efa0$export$2ba01fb71ed41cb6 = `_XoYAq_button`;
$7b80074cd360efa0$export$17fa98cb055e8fa7 = `_XoYAq_fontSizeH1`;
$7b80074cd360efa0$export$a5833c2b43ca4340 = `_XoYAq_fontSizeH2`;
$7b80074cd360efa0$export$47511f9a6581d1d6 = `_XoYAq_fontSizeH3`;
$7b80074cd360efa0$export$dd1c05b92185401c = `_XoYAq_fontSizeH4`;
$7b80074cd360efa0$export$8b28cf6cd00fe080 = `_XoYAq_fontSizeH5`;
$7b80074cd360efa0$export$186c650311ff0789 = `_XoYAq_fontSizeH6`;
$7b80074cd360efa0$export$6746fe0d9c9fab54 = `_XoYAq_fontSizeSmall`;
$7b80074cd360efa0$export$2bcf359f0c20e94f = `_XoYAq_fontSizeTiny`;
$7b80074cd360efa0$export$2903d10d531d0ac0 = `_XoYAq_fontSizep`;
$7b80074cd360efa0$export$5c452ff88e35e47d = `_XoYAq_image`;
$7b80074cd360efa0$export$18abeb4afc60019 = `_XoYAq_interactionContainer`;
$7b80074cd360efa0$export$1237798dc640739a = `_XoYAq_label`;
$7b80074cd360efa0$export$c80d57c51a11eb0a = `_XoYAq_noBackgroundImage`;
$7b80074cd360efa0$export$321c0b1a406de31f = `_XoYAq_price`;


const $e3c6ddb252bc4d8f$export$5058c1d7a80a37e4 = ({ classname: classname, item: item })=>{
    const theme = (0, $cEIti.useTheme)();
    if (!item) return;
    const buttonText = theme.customJSON.shop?.externalShopItemButtonText ?? "Shop Now";
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7b80074cd360efa0$export$5058c1d7a80a37e4, classname, {
            [$7b80074cd360efa0$export$c80d57c51a11eb0a]: !theme.customJSON?.cardBackgroundImageUrl
        }),
        style: {
            backgroundImage: `url("${theme.customJSON?.cardBackgroundImageUrl}")`
        },
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $248e04b79658491e$export$2e2bcd8739ae039), {
                classname: $7b80074cd360efa0$export$1237798dc640739a,
                title: item.title,
                subtitle: item.sub_title,
                maskImage: theme.customJSON?.cardTextBackgroundImageUrl,
                keepFontSize: true
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: $7b80074cd360efa0$export$321c0b1a406de31f,
                children: item.price
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $7b80074cd360efa0$export$5c452ff88e35e47d,
                src: (0, $aTKgi.pathToURL)(item.imagePath) + "?w=500",
                alt: item.title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $7b80074cd360efa0$export$18abeb4afc60019,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$29d11c0fe2fc51d8), {
                    className: $7b80074cd360efa0$export$2ba01fb71ed41cb6,
                    href: item.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: ()=>(0, $i7H0N.sendEvent)("external_shop_link_open", {
                            id: item.id,
                            title: item.title,
                            price: item.price,
                            url: item.link
                        }),
                    children: buttonText
                })
            })
        ]
    });
};
var $e3c6ddb252bc4d8f$export$2e2bcd8739ae039 = $e3c6ddb252bc4d8f$export$5058c1d7a80a37e4;


var $2987a0be84c656d6$export$49a7bc241e8177f9;
var $2987a0be84c656d6$export$555f04397502546;
var $2987a0be84c656d6$export$efe229eab43a9869;
var $2987a0be84c656d6$export$a7db06668cad9adb;
var $2987a0be84c656d6$export$4f81c40550d60666;
var $2987a0be84c656d6$export$da10a04ece02fcdc;
var $2987a0be84c656d6$export$17fa98cb055e8fa7;
var $2987a0be84c656d6$export$a5833c2b43ca4340;
var $2987a0be84c656d6$export$47511f9a6581d1d6;
var $2987a0be84c656d6$export$dd1c05b92185401c;
var $2987a0be84c656d6$export$8b28cf6cd00fe080;
var $2987a0be84c656d6$export$186c650311ff0789;
var $2987a0be84c656d6$export$6746fe0d9c9fab54;
var $2987a0be84c656d6$export$2bcf359f0c20e94f;
var $2987a0be84c656d6$export$2903d10d531d0ac0;
var $2987a0be84c656d6$export$39e04e72f972b885;
var $2987a0be84c656d6$export$ea0830439c7fc698;
var $2987a0be84c656d6$export$17a1664ed1fb5d6f;
var $2987a0be84c656d6$export$578fcbc4821dcd12;
var $2987a0be84c656d6$export$c80d57c51a11eb0a;
var $2987a0be84c656d6$export$fad3c8302a7540c6;
var $2987a0be84c656d6$export$d167761217acc355;
var $2987a0be84c656d6$export$fb184b623420d9be;
var $2987a0be84c656d6$export$ac052f74bbc68e2d;
$2987a0be84c656d6$export$49a7bc241e8177f9 = `QMaCRa_ShopDrawer`;
$2987a0be84c656d6$export$555f04397502546 = `QMaCRa_assets`;
$2987a0be84c656d6$export$efe229eab43a9869 = `QMaCRa_closeButton`;
$2987a0be84c656d6$export$a7db06668cad9adb = `QMaCRa_content`;
$2987a0be84c656d6$export$4f81c40550d60666 = `QMaCRa_contentTitle`;
$2987a0be84c656d6$export$da10a04ece02fcdc = `QMaCRa_emptyText`;
$2987a0be84c656d6$export$17fa98cb055e8fa7 = `QMaCRa_fontSizeH1`;
$2987a0be84c656d6$export$a5833c2b43ca4340 = `QMaCRa_fontSizeH2`;
$2987a0be84c656d6$export$47511f9a6581d1d6 = `QMaCRa_fontSizeH3`;
$2987a0be84c656d6$export$dd1c05b92185401c = `QMaCRa_fontSizeH4`;
$2987a0be84c656d6$export$8b28cf6cd00fe080 = `QMaCRa_fontSizeH5`;
$2987a0be84c656d6$export$186c650311ff0789 = `QMaCRa_fontSizeH6`;
$2987a0be84c656d6$export$6746fe0d9c9fab54 = `QMaCRa_fontSizeSmall`;
$2987a0be84c656d6$export$2bcf359f0c20e94f = `QMaCRa_fontSizeTiny`;
$2987a0be84c656d6$export$2903d10d531d0ac0 = `QMaCRa_fontSizep`;
$2987a0be84c656d6$export$39e04e72f972b885 = `QMaCRa_isActive`;
$2987a0be84c656d6$export$ea0830439c7fc698 = `QMaCRa_isOpen`;
$2987a0be84c656d6$export$17a1664ed1fb5d6f = `QMaCRa_items`;
$2987a0be84c656d6$export$578fcbc4821dcd12 = `QMaCRa_longTitle`;
$2987a0be84c656d6$export$c80d57c51a11eb0a = `QMaCRa_noBackgroundImage`;
$2987a0be84c656d6$export$fad3c8302a7540c6 = `QMaCRa_scrollContainer`;
$2987a0be84c656d6$export$d167761217acc355 = `QMaCRa_tabButtons`;
$2987a0be84c656d6$export$fb184b623420d9be = `QMaCRa_title`;
$2987a0be84c656d6$export$ac052f74bbc68e2d = `QMaCRa_topBar`;


function $8e9512a65c6350ec$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const hasExternalShop = theme.metadata?.hasExternalShop;
    const hasProfileShop = theme.metadata?.hasProfileShop;
    const isShopOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isShopOpen);
    const [currentlyShowingModalAssetPack, setCurrentlyShowingModalAssetPack] = (0, $8FY87.useState)(null);
    const [currentTab, setCurrentTab] = (0, $8FY87.useState)(hasProfileShop ? "profileShop" : "externalShop");
    const [packs, setPacks] = (0, $8FY87.useState)([]);
    const [packsAreLoading, setPacksAreLoading] = (0, $8FY87.useState)(true);
    const [externalItems, setExternalItems] = (0, $8FY87.useState)([]);
    const [externalItemsAreLoading, setExternalItemsAreLoading] = (0, $8FY87.useState)(true);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const SHOP_TITLE = theme.customJSON.shop?.shopTitle ?? "Shop";
    const PROFILE_SHOP_TITLE = theme.customJSON.shop?.profileShopTitle ?? "Profile Decoration Bundles";
    const EXTERNAL_SHOP_TITLE = theme.customJSON.shop?.externalShopTitle ?? "Exclusive Merchandise";
    const loadAssetPacks = ()=>{
        const isPackValid = (pack)=>{
            const isValid = (0, $85e91bf523db42d5$export$988a54d054fb2a52)(pack.currency, pack.price) !== null && pack.assets?.avatarFrame?.id && pack.assets?.background?.id && pack.assets?.character?.id;
            if (!isValid) console.error("Not showing invalid pack:", pack);
            return isValid;
        };
        (0, $f9aoP.getAssetPacks)().then((packs)=>{
            const validPacks = packs.filter(isPackValid).sort((a, b)=>a.order - b.order);
            setPacks(validPacks);
            setPacksAreLoading(false);
        }).catch(()=>{
            setPacksAreLoading(false);
            console.error("Error loading asset packs");
        });
    };
    const loadExternalItems = ()=>{
        const isValidExternalItem = (item)=>{
            const isValid = item.title && item.link && item.imagePath;
            if (!isValid) console.error("Not showing invalid external shop item:", item);
            return isValid;
        };
        (0, $f9aoP.getShopExternalItems)().then((items)=>{
            const validItems = items.filter(isValidExternalItem).sort((a, b)=>a.order - b.order);
            setExternalItems(validItems);
            setExternalItemsAreLoading(false);
        }).catch(()=>{
            setExternalItemsAreLoading(false);
            console.error("Error loading external shop items");
        });
    };
    (0, $8FY87.useEffect)(()=>{
        if (isShopOpen) {
            audio?.play("gust-open");
            // Reload data when opened
            if (hasProfileShop) {
                setPacksAreLoading(true);
                loadAssetPacks();
            }
            if (hasExternalShop) {
                setExternalItemsAreLoading(true);
                loadExternalItems();
            }
            (0, $i7H0N.sendEvent)("view_shop");
            dispatch((0, $baXkz.setHasSeenShop)(true));
            window.localStorage.setItem((0, $aTRs6.LS_HASSEENSHOP_KEY), "true");
        }
    }, [
        isShopOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isShopOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    const getProfileShopContent = ()=>{
        if (packsAreLoading) return null;
        return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$fb184b623420d9be, {
                        [$2987a0be84c656d6$export$578fcbc4821dcd12]: PROFILE_SHOP_TITLE?.length > 30
                    }),
                    children: PROFILE_SHOP_TITLE
                }),
                packs.length === 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: $2987a0be84c656d6$export$da10a04ece02fcdc,
                    children: "No bundles to show"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$555f04397502546),
                    children: packs.map((pack, index)=>{
                        return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $61edd578a935b4f6$export$2e2bcd8739ae039), {
                                onSelected: ()=>{
                                    setCurrentlyShowingModalAssetPack(pack);
                                    (0, $i7H0N.sendEvent)("profile_shop_bundle_open", {
                                        id: pack?.id,
                                        name: pack?.name,
                                        price: pack?.price
                                    });
                                },
                                pack: pack
                            })
                        }, `shop-profile-${index}`);
                    })
                })
            ]
        });
    };
    const getExternalShopContent = ()=>{
        if (externalItemsAreLoading) return null;
        return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$fb184b623420d9be, {
                        [$2987a0be84c656d6$export$578fcbc4821dcd12]: EXTERNAL_SHOP_TITLE?.length > 30
                    }),
                    children: EXTERNAL_SHOP_TITLE
                }),
                externalItems.length === 0 && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: $2987a0be84c656d6$export$da10a04ece02fcdc,
                    children: "No items to show"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$555f04397502546),
                    children: externalItems.map((externalItem, index)=>{
                        return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c6ddb252bc4d8f$export$2e2bcd8739ae039), {
                                item: externalItem
                            })
                        }, `shop-external-${index}`);
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$49a7bc241e8177f9, {
            [$2987a0be84c656d6$export$ea0830439c7fc698]: isShopOpen
        }),
        inert: !isShopOpen ? "" : undefined,
        onTransitionEnd: onTransitionEnd,
        style: {
            backdropFilter: `blur(10px)`
        },
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $2987a0be84c656d6$export$fad3c8302a7540c6,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $2987a0be84c656d6$export$ac052f74bbc68e2d,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$fb184b623420d9be, {
                                    [$2987a0be84c656d6$export$578fcbc4821dcd12]: SHOP_TITLE?.length > 30
                                }),
                                children: SHOP_TITLE
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                buttonRef: closeButtonRef,
                                iconType: "close",
                                buttonStyle: "round",
                                ariaLabel: "Close Shop",
                                className: $2987a0be84c656d6$export$efe229eab43a9869,
                                onClick: ()=>{
                                    audio?.play("gust-close");
                                    dispatch((0, $baXkz.setIsShopOpen)(false));
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2987a0be84c656d6$export$a7db06668cad9adb, {
                            [$2987a0be84c656d6$export$c80d57c51a11eb0a]: !theme.customJSON?.profileBackground
                        }),
                        style: theme.customJSON?.profileBackground ? {
                            backgroundImage: `url("${theme.customJSON?.profileBackground}")`,
                            borderImageSource: `url("${theme.customJSON?.profileBackground}")`
                        } : {},
                        children: [
                            hasExternalShop && hasProfileShop && /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $2987a0be84c656d6$export$d167761217acc355,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                                [$2987a0be84c656d6$export$39e04e72f972b885]: currentTab === "profileShop"
                                            }),
                                            iconType: "character",
                                            buttonStyle: "icon",
                                            ariaLabel: PROFILE_SHOP_TITLE,
                                            title: PROFILE_SHOP_TITLE,
                                            onClick: ()=>{
                                                (0, $i7H0N.sendEvent)("shop_external_tab_click");
                                                setCurrentTab("profileShop");
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                                [$2987a0be84c656d6$export$39e04e72f972b885]: currentTab === "externalShop"
                                            }),
                                            iconType: theme.customJSON?.shop?.externalShopIcon ?? "box",
                                            buttonStyle: "icon",
                                            ariaLabel: EXTERNAL_SHOP_TITLE,
                                            title: EXTERNAL_SHOP_TITLE,
                                            onClick: ()=>{
                                                (0, $i7H0N.sendEvent)("shop_profile_tab_click");
                                                setCurrentTab("externalShop");
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $2987a0be84c656d6$export$17a1664ed1fb5d6f,
                                children: [
                                    currentTab === "profileShop" ? getProfileShopContent() : getExternalShopContent(),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                                        hasBackground: false,
                                        show: currentTab === "profileShop" ? packsAreLoading : externalItemsAreLoading
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            currentlyShowingModalAssetPack && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b96c0c3a5a43d12e$export$2e2bcd8739ae039), {
                pack: currentlyShowingModalAssetPack,
                onClose: ()=>setCurrentlyShowingModalAssetPack(null)
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $6lYLL = parcelRequire("6lYLL");

var $4MZsN = parcelRequire("4MZsN");


var $aTKgi = parcelRequire("aTKgi");
var $f82645e84269191f$export$2ec836fbaca83fe7;
var $f82645e84269191f$export$4aebd143f31d0c0d;
var $f82645e84269191f$export$82e6205b15e6c637;
var $f82645e84269191f$export$17fa98cb055e8fa7;
var $f82645e84269191f$export$a5833c2b43ca4340;
var $f82645e84269191f$export$47511f9a6581d1d6;
var $f82645e84269191f$export$dd1c05b92185401c;
var $f82645e84269191f$export$8b28cf6cd00fe080;
var $f82645e84269191f$export$186c650311ff0789;
var $f82645e84269191f$export$6746fe0d9c9fab54;
var $f82645e84269191f$export$2bcf359f0c20e94f;
var $f82645e84269191f$export$2903d10d531d0ac0;
var $f82645e84269191f$export$5c452ff88e35e47d;
var $f82645e84269191f$export$a8ecead220dd38a6;
var $f82645e84269191f$export$6f093cfa640b7166;
var $f82645e84269191f$export$fb184b623420d9be;
$f82645e84269191f$export$2ec836fbaca83fe7 = `TWxbda_PinnedMessage`;
$f82645e84269191f$export$4aebd143f31d0c0d = `TWxbda_badge`;
$f82645e84269191f$export$82e6205b15e6c637 = `TWxbda_fadeIn`;
$f82645e84269191f$export$82e6205b15e6c637;
$f82645e84269191f$export$17fa98cb055e8fa7 = `TWxbda_fontSizeH1`;
$f82645e84269191f$export$a5833c2b43ca4340 = `TWxbda_fontSizeH2`;
$f82645e84269191f$export$47511f9a6581d1d6 = `TWxbda_fontSizeH3`;
$f82645e84269191f$export$dd1c05b92185401c = `TWxbda_fontSizeH4`;
$f82645e84269191f$export$8b28cf6cd00fe080 = `TWxbda_fontSizeH5`;
$f82645e84269191f$export$186c650311ff0789 = `TWxbda_fontSizeH6`;
$f82645e84269191f$export$6746fe0d9c9fab54 = `TWxbda_fontSizeSmall`;
$f82645e84269191f$export$2bcf359f0c20e94f = `TWxbda_fontSizeTiny`;
$f82645e84269191f$export$2903d10d531d0ac0 = `TWxbda_fontSizep`;
$f82645e84269191f$export$5c452ff88e35e47d = `TWxbda_image`;
$f82645e84269191f$export$a8ecead220dd38a6 = `TWxbda_message`;
$f82645e84269191f$export$6f093cfa640b7166 = `TWxbda_text`;
$f82645e84269191f$export$fb184b623420d9be = `TWxbda_title`;


function $e4036b7a136c2987$export$2e2bcd8739ae039() {
    const location = (0, $6lYLL.useAppSelector)((state)=>state.app.location);
    const { pinnedMessageTitle: pinnedMessageTitle, pinnedMessageMarkdown: pinnedMessageMarkdown, pinnedMessageImagePath: pinnedMessageImagePath, pinnedMessageIsVisible: pinnedMessageIsVisible } = location || {};
    if (!pinnedMessageIsVisible || !pinnedMessageTitle && !pinnedMessageMarkdown) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $f82645e84269191f$export$2ec836fbaca83fe7,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $f82645e84269191f$export$a8ecead220dd38a6,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $f82645e84269191f$export$4aebd143f31d0c0d,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                            type: "pin"
                        }),
                        "Pinned"
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $f82645e84269191f$export$6f093cfa640b7166,
                    children: [
                        pinnedMessageTitle && /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                            className: $f82645e84269191f$export$fb184b623420d9be,
                            children: pinnedMessageTitle
                        }),
                        pinnedMessageMarkdown && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $17855786516ea933$export$2e2bcd8739ae039), {
                            textAlign: "left",
                            base64MarkdownContent: pinnedMessageMarkdown,
                            hasDefaultStyling: false
                        })
                    ]
                }),
                pinnedMessageImagePath && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $f82645e84269191f$export$5c452ff88e35e47d,
                    style: {
                        backgroundImage: `url(${(0, $aTKgi.pathToURL)(pinnedMessageImagePath)})`
                    }
                })
            ]
        })
    });
}



var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");


var $cEIti = parcelRequire("cEIti");

var $i7H0N = parcelRequire("i7H0N");

var $jLk8j = parcelRequire("jLk8j");
var $2a60910cd4252682$export$1ba59dacbcbf90fe;
var $2a60910cd4252682$export$40e543e69a8b3fbb;
var $2a60910cd4252682$export$efe229eab43a9869;
var $2a60910cd4252682$export$e892d71c686c90c4;
var $2a60910cd4252682$export$17fa98cb055e8fa7;
var $2a60910cd4252682$export$a5833c2b43ca4340;
var $2a60910cd4252682$export$47511f9a6581d1d6;
var $2a60910cd4252682$export$dd1c05b92185401c;
var $2a60910cd4252682$export$8b28cf6cd00fe080;
var $2a60910cd4252682$export$186c650311ff0789;
var $2a60910cd4252682$export$6746fe0d9c9fab54;
var $2a60910cd4252682$export$2bcf359f0c20e94f;
var $2a60910cd4252682$export$2903d10d531d0ac0;
var $2a60910cd4252682$export$cf79e069f2284a16;
var $2a60910cd4252682$export$c3ad6a6e45c21a35;
var $2a60910cd4252682$export$2fca6816ddfbf6d9;
var $2a60910cd4252682$export$fb184b623420d9be;
var $2a60910cd4252682$export$1e95b668f3b82d;
$2a60910cd4252682$export$1ba59dacbcbf90fe = `wuwwpq_Sidebar`;
$2a60910cd4252682$export$40e543e69a8b3fbb = `wuwwpq_bottom`;
$2a60910cd4252682$export$efe229eab43a9869 = `wuwwpq_closeButton`;
$2a60910cd4252682$export$e892d71c686c90c4 = `wuwwpq_feedContainer`;
$2a60910cd4252682$export$17fa98cb055e8fa7 = `wuwwpq_fontSizeH1`;
$2a60910cd4252682$export$a5833c2b43ca4340 = `wuwwpq_fontSizeH2`;
$2a60910cd4252682$export$47511f9a6581d1d6 = `wuwwpq_fontSizeH3`;
$2a60910cd4252682$export$dd1c05b92185401c = `wuwwpq_fontSizeH4`;
$2a60910cd4252682$export$8b28cf6cd00fe080 = `wuwwpq_fontSizeH5`;
$2a60910cd4252682$export$186c650311ff0789 = `wuwwpq_fontSizeH6`;
$2a60910cd4252682$export$6746fe0d9c9fab54 = `wuwwpq_fontSizeSmall`;
$2a60910cd4252682$export$2bcf359f0c20e94f = `wuwwpq_fontSizeTiny`;
$2a60910cd4252682$export$2903d10d531d0ac0 = `wuwwpq_fontSizep`;
$2a60910cd4252682$export$cf79e069f2284a16 = `wuwwpq_headerImage`;
$2a60910cd4252682$export$c3ad6a6e45c21a35 = `wuwwpq_infobar`;
$2a60910cd4252682$export$2fca6816ddfbf6d9 = `wuwwpq_shopButton`;
$2a60910cd4252682$export$fb184b623420d9be = `wuwwpq_title`;
$2a60910cd4252682$export$1e95b668f3b82d = `wuwwpq_top`;


function $e7edf3b32b0bb599$export$2e2bcd8739ae039({ locationTitle: locationTitle, locationName: locationName }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const isSidebarOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isSidebarOpen);
    const isProfileOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isProfileOpen);
    const isShopOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isShopOpen);
    const hasSeenShop = (0, $6lYLL.useAppSelector)((state)=>state.app.hasSeenShop);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    (0, $8FY87.useEffect)(()=>{
        // Open the sidebar if the user is not on mobile
        dispatch((0, $baXkz.setIsSidebarOpen)(!(0, $jLk8j.isMobileWidth)()));
    }, []);
    const isInteractable = isSidebarOpen && !isProfileOpen && !isShopOpen;
    const sidebarHeaderImageUrl = theme.customJSON?.sidebarHeaderImageUrl; // If present, is shown instead of header text
    const shouldShowShopTooltips = theme.customJSON?.shouldShowShopTooltips;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $2a60910cd4252682$export$1ba59dacbcbf90fe,
        style: {
            backdropFilter: `blur(10px)`
        },
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $2a60910cd4252682$export$1e95b668f3b82d,
                inert: isInteractable ? undefined : "",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        iconType: "close",
                        ariaLabel: "Close chat",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($2a60910cd4252682$export$efe229eab43a9869),
                        buttonStyle: "round",
                        onClick: ()=>{
                            audio?.play("gust-close");
                            dispatch((0, $baXkz.setIsSidebarOpen)(false));
                            (0, $i7H0N.sendEvent)("chat_close");
                        }
                    }),
                    (theme.metadata?.hasProfileShop || theme.metadata?.hasExternalShop) && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: theme.customJSON.shop?.shopButtonIcon ?? "shop",
                        title: "Open Shop",
                        ariaLabel: "Open Shop",
                        onClick: ()=>{
                            dispatch((0, $baXkz.setIsShopOpen)(true));
                        },
                        className: $2a60910cd4252682$export$2fca6816ddfbf6d9,
                        tooltipContent: "New Shop",
                        tooltipIsVisible: shouldShowShopTooltips && !hasSeenShop && !(0, $jLk8j.isMobileWidth)()
                    }),
                    !sidebarHeaderImageUrl && locationTitle && /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                        className: $2a60910cd4252682$export$fb184b623420d9be,
                        children: [
                            locationTitle,
                            locationName && ":"
                        ]
                    }),
                    !sidebarHeaderImageUrl && locationName && /*#__PURE__*/ (0, $2PPWI.jsx)("h1", {
                        className: $2a60910cd4252682$export$fb184b623420d9be,
                        children: locationName
                    }),
                    sidebarHeaderImageUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                        className: $2a60910cd4252682$export$cf79e069f2284a16,
                        src: sidebarHeaderImageUrl,
                        alt: "Header logo"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $362511cc35f84c3e$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $2a60910cd4252682$export$40e543e69a8b3fbb,
                inert: isInteractable ? undefined : "",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $2a60910cd4252682$export$e892d71c686c90c4,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $73c1e15f29108937$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $2a60910cd4252682$export$c3ad6a6e45c21a35,
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e4036b7a136c2987$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c292466b2c4e7afc$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8e9512a65c6350ec$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4ffaa24d6677e971$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $4KKbJ = parcelRequire("4KKbJ");

var $kyBxf = parcelRequire("kyBxf");

var $8FY87 = parcelRequire("8FY87");

const $359862929bb6f0e3$export$e8c0cceb0fbfc44c = {
    current: null
};
function $359862929bb6f0e3$export$b3dfa3d70263abe6(iframeRef, options = {}) {
    const [ariseBridge, setAriseBridge] = (0, $8FY87.useState)(null);
    (0, $8FY87.useEffect)(()=>{
        const allowedOrigins = options.allowedOrigins || [
            "*"
        ];
        const abs = (0, $c52ffa28168ccea6$export$d5347260c4eca75c).initialise(iframeRef, allowedOrigins, options.arisewareProjectID);
        const bridge = abs.getBridge();
        setAriseBridge(bridge);
        $359862929bb6f0e3$export$e8c0cceb0fbfc44c.current = bridge;
        return ()=>{
            $359862929bb6f0e3$export$e8c0cceb0fbfc44c.current = null;
        };
    }, [
        iframeRef
    ]);
    return ariseBridge;
}




var $i7H0N = parcelRequire("i7H0N");

var $f9aoP = parcelRequire("f9aoP");


var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");

function $5aa04911bb7556d2$export$2e2bcd8739ae039(arisewareProjectID) {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const sceneSelectorData = (0, $6lYLL.useAppSelector)((state)=>state.app.sceneSelectorData);
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    // TODO: remove once goto is implemented
    function onGotoCamp() {
        const campId = undefined;
        navigate(`/location/${campId}`);
    }
    function onGoto(data) {
        const target = data.detail;
        function gotoPuzzle(index) {
            if (sceneSelectorData?.scenes?.[index]?.environmentID) {
                const id = sceneSelectorData.scenes[index].environmentID;
                navigate(`/location/${id}`);
            } else console.error("Failed to go to puzzle, index does not exist:", index);
        }
        switch(target){
            case "scene_selector":
                navigate("/selector");
                break;
            case "supply_run":
                const supplyRunId = undefined;
                navigate(`/location/${supplyRunId}`);
                break;
            case "camp":
                const campId = undefined;
                navigate(`/location/${campId}`);
                break;
            case "puzzle1":
                gotoPuzzle(0);
                break;
            case "puzzle2":
                gotoPuzzle(1);
                break;
            case "puzzle3":
                gotoPuzzle(2);
                break;
            case "signup":
                navigateToSignup();
                break;
            default:
                console.log("Unknown goto target:", target);
                break;
        }
    }
    function onSubmitResult(data) {
        const result = {
            arisewareProjectID: arisewareProjectID,
            isCompleted: true,
            score: data?.detail?.result ?? 0
        };
        dispatch((0, $baXkz.submitArisewareScore)(result));
    }
    return {
        onGotoCamp: onGotoCamp,
        onGoto: onGoto,
        onSubmitResult: onSubmitResult
    };
}
function $5aa04911bb7556d2$var$secondsToString(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    if (minutes < 1) return `${$5aa04911bb7556d2$var$padTime(remainingSeconds)} seconds`;
    return `${$5aa04911bb7556d2$var$padTime(minutes)}:${$5aa04911bb7556d2$var$padTime(remainingSeconds)} minutes`;
}
function $5aa04911bb7556d2$var$padTime(t) {
    return t.toString().padStart(2, "0");
}



function $6af27256e4670e1c$export$2e2bcd8739ae039() {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    function onGoto(data) {
        const target = data.detail;
        switch(target){
            case "prize_reveal":
                const prizeRevealId = undefined;
                navigate(`/location/${prizeRevealId}`);
                break;
            default:
                console.log("Unknown goto target:", target);
                break;
        }
    }
    return {
        onGoto: onGoto
    };
}



var $1URoE = parcelRequire("1URoE");


var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $764u1 = parcelRequire("764u1");


var $aTRs6 = parcelRequire("aTRs6");
var $455bde8018bf731a$export$959e93f94089c33c;
var $455bde8018bf731a$export$27c57cc52d388509;
var $455bde8018bf731a$export$f1b86537d9af7faa;
var $455bde8018bf731a$export$a80b3bd66acc52ff;
var $455bde8018bf731a$export$7abe78e1eda562aa;
var $455bde8018bf731a$export$db3c28d99448dcff;
var $455bde8018bf731a$export$9d6d5e5a70faaa0e;
var $455bde8018bf731a$export$87e603b6a5b79fa;
var $455bde8018bf731a$export$2478bed8f91107f0;
var $455bde8018bf731a$export$b50954cb67afd718;
$455bde8018bf731a$export$959e93f94089c33c = `af8QtW_authCopy`;
$455bde8018bf731a$export$27c57cc52d388509 = `af8QtW_collapsed`;
$455bde8018bf731a$export$f1b86537d9af7faa = `af8QtW_enrolButton`;
$455bde8018bf731a$export$a80b3bd66acc52ff = `af8QtW_info`;
$455bde8018bf731a$export$7abe78e1eda562aa = `af8QtW_loginButton`;
$455bde8018bf731a$export$db3c28d99448dcff = `af8QtW_logo`;
$455bde8018bf731a$export$9d6d5e5a70faaa0e = `af8QtW_overlayContentWrapper`;
$455bde8018bf731a$export$87e603b6a5b79fa = `af8QtW_overlayWrapper`;
$455bde8018bf731a$export$2478bed8f91107f0 = `af8QtW_questUnenrolledNotice`;
$455bde8018bf731a$export$b50954cb67afd718 = `af8QtW_quickComplete`;



var $6lYLL = parcelRequire("6lYLL");
const $3d90f95b179d4b22$var$DiscordAuthFlow = /*#__PURE__*/ (0, $8FY87.forwardRef)((props, ref)=>{
    const { authorize: authorize, openExternalLink: openExternalLink, user: user, authError: authError, authDenied: authDenied, quest: quest, authLoading: authLoading } = (0, $764u1.default)();
    const d = (0, $6lYLL.useAppSelector)((state)=>state.discord);
    (0, $8FY87.useImperativeHandle)(ref, ()=>({
            authorize: authorize,
            openExternalLink: openExternalLink,
            completeQuest: ()=>{
                if (quest) quest.complete();
            },
            setQuestProgress: (progress)=>{
                if (quest) quest.progress(progress);
            },
            getQuestStatus: async ()=>{
                if (quest) {
                    const d = await quest.check();
                    return d;
                }
                return false;
            }
        }));
    if (!(0, $aTRs6.IS_DISCORD_ACTIVITY) && window.location.hostname !== "localhost") return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    if (!user || authError) {
        if (authLoading) return /*#__PURE__*/ (0, $2PPWI.jsx)($3d90f95b179d4b22$var$TextOverlay, {
            message: "Authenticating..."
        });
        if (authDenied) return /*#__PURE__*/ (0, $2PPWI.jsx)($3d90f95b179d4b22$var$AuthRequiredOverlay, {
            authorise: authorize
        });
        // Removing auth error messaging
        // if (authError) {
        //     return <AuthErrorOverlay authorise={authorize} />;
        // }
        // If there's no user and it's not in any of the other states, show the loader
        return /*#__PURE__*/ (0, $2PPWI.jsx)($3d90f95b179d4b22$var$TextOverlay, {
            message: "Discord SDK Loading..."
        });
    }
    // return (
    //     <>
    //         <div className={styles.info}>{JSON.stringify(d, null, 4)}</div>
    //     </>
    // );
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
});
function $3d90f95b179d4b22$var$getLoadingIcon() {
    return "/assets/global/images/discord-loader.gif";
}
function $3d90f95b179d4b22$var$OverlayWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $455bde8018bf731a$export$87e603b6a5b79fa,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $455bde8018bf731a$export$9d6d5e5a70faaa0e,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                    src: $3d90f95b179d4b22$var$getLoadingIcon(),
                    className: $455bde8018bf731a$export$db3c28d99448dcff
                }),
                children
            ]
        })
    });
}
function $3d90f95b179d4b22$var$TextOverlay({ message: message }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($3d90f95b179d4b22$var$OverlayWrapper, {
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            children: message
        })
    });
}
function $3d90f95b179d4b22$var$AuthRequiredOverlay({ authorise: authorise }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($3d90f95b179d4b22$var$OverlayWrapper, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $455bde8018bf731a$export$959e93f94089c33c,
                children: "Please login with your Discord account to play this experience."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    authorise();
                },
                className: $455bde8018bf731a$export$7abe78e1eda562aa,
                children: "Log In"
            })
        ]
    });
}
function $3d90f95b179d4b22$var$AuthErrorOverlay({ authorise: authorise }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)($3d90f95b179d4b22$var$OverlayWrapper, {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $455bde8018bf731a$export$959e93f94089c33c,
                children: "Authorization error. Please try logging in again."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    authorise();
                },
                className: $455bde8018bf731a$export$7abe78e1eda562aa,
                children: "Try Again"
            })
        ]
    });
}
function $3d90f95b179d4b22$export$86908e3cbc015d52({ gotoEnroll: gotoEnroll }) {
    const [collapsed, setCollapsed] = (0, $8FY87.useState)(false);
    function renderCollapsed() {
        return /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            className: $455bde8018bf731a$export$f1b86537d9af7faa,
            onClick: gotoEnroll,
            children: "Join Quest"
        });
    }
    function renderFull() {
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    children: "Join the quest to get your reward."
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: $455bde8018bf731a$export$f1b86537d9af7faa,
                    onClick: gotoEnroll,
                    children: "Join Quest (TODO)"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    className: $455bde8018bf731a$export$f1b86537d9af7faa,
                    onClick: ()=>{
                        setCollapsed(!collapsed);
                    },
                    children: "<"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $455bde8018bf731a$export$2478bed8f91107f0 + " " + (collapsed ? $455bde8018bf731a$export$27c57cc52d388509 : ""),
        children: collapsed ? renderCollapsed() : renderFull()
    });
}
var $3d90f95b179d4b22$export$2e2bcd8739ae039 = $3d90f95b179d4b22$var$DiscordAuthFlow;



var $i7H0N = parcelRequire("i7H0N");

var $1URoE = parcelRequire("1URoE");
async function $43c90dc8b11101a9$export$63fb30b9076ed333() {
    if (0, $1URoE.isParamountInstance) {
        await $43c90dc8b11101a9$var$onOptanonScriptLoaded();
        return window["Optanon"]?.getGeolocationData?.()?.country ?? "";
    } else throw new Error("No country code available in this instance");
}
function $43c90dc8b11101a9$var$onOptanonScriptLoaded() {
    return new Promise((resolve)=>{
        const script = document.getElementById("optanon-script-id");
        if (!script) {
            resolve(); // Resolve anyway to avoid hanging
            return;
        }
        if (window["Optanon"]?.getGeolocationData) resolve();
        else script.addEventListener("load", ()=>resolve(), {
            once: true
        });
    });
}


function $f3a1c0569c2d2ecc$export$b3bc3cd373bda2b0(discordRef, bridgeRef) {
    function onCheckpointReached(data) {
        (0, $i7H0N.sendEvent)("mi_checkpoint_reached", data.detail);
    }
    async function pushCountryCode() {
        const code = await (0, $43c90dc8b11101a9$export$63fb30b9076ed333)();
        bridgeRef.sendEvent("push-country-code", code);
    }
    return {
        onCheckpointReached: onCheckpointReached,
        pushCountryCode: pushCountryCode
    };
}



var $aTRs6 = parcelRequire("aTRs6");

var $764u1 = parcelRequire("764u1");

var $6lYLL = parcelRequire("6lYLL");

var $8FY87 = parcelRequire("8FY87");
function $3e15c60b384f1766$export$2e2bcd8739ae039(bridge) {
    const userDataRef = (0, $8FY87.useRef)(null);
    const currentUserProfileV2 = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfileV2);
    const availableBadges = (0, $6lYLL.useAppSelector)((state)=>state.profile.availableBadges);
    const availableTitles = (0, $6lYLL.useAppSelector)((state)=>state.profile.availableTitles);
    const langIso = (0, $6lYLL.useAppSelector)((state)=>state.app.langIso);
    userDataRef.current = {
        langIso: langIso,
        currentUserProfileV2: currentUserProfileV2,
        availableBadges: availableBadges,
        availableTitles: availableTitles
    };
    function pushUserProfile() {
        if (userDataRef.current.currentUserProfileV2) bridge?.sendEvent("user-data", userDataRef.current.currentUserProfileV2);
    }
    function pushAvailableBadgesData() {
        if (userDataRef.current.availableBadges) bridge?.sendEvent("available-badges-data", userDataRef.current.availableBadges);
    }
    function pushAvailableTitlesData() {
        if (userDataRef.current.availableTitles) bridge?.sendEvent("available-titles-data", userDataRef.current.availableTitles);
    }
    function pushLocalisationData() {
        if (userDataRef.current.langIso) bridge?.sendEvent("localisation-data", {
            locale: userDataRef.current.langIso
        });
    }
    function pushUserData() {
        pushUserProfile();
        pushAvailableBadgesData();
        pushAvailableTitlesData();
        pushLocalisationData();
    }
    (0, $8FY87.useEffect)(()=>{
        pushUserProfile();
    }, [
        currentUserProfileV2
    ]);
    (0, $8FY87.useEffect)(()=>{
        pushAvailableBadgesData();
    }, [
        availableBadges
    ]);
    (0, $8FY87.useEffect)(()=>{
        pushAvailableTitlesData();
    }, [
        availableTitles
    ]);
    (0, $8FY87.useEffect)(()=>{
        pushLocalisationData();
    }, [
        langIso
    ]);
    return {
        pushUserData: pushUserData
    };
}


function $d612fdc595978133$export$2e2bcd8739ae039({ src: src, bridgeRef: bridgeRef, arisewareProjectID: arisewareProjectID, onReady: onReady, loadingImage: loadingImage, loadingText: loadingText, forceInFrontOfUi: forceInFrontOfUi, style: style }) {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const { locationId: locationId } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const [iframeReady, setIframeReady] = (0, $8FY87.useState)(false);
    const iframeRef = (0, $8FY87.useRef)(null);
    const discordRef = (0, $8FY87.useRef)();
    let iframeUrl = (0, $8FY87.useMemo)(()=>{
        const url = new URL(window.location.href);
        const iframeUrlParam = url.searchParams.get("iframeUrl");
        if (iframeUrlParam) src = iframeUrlParam;
        const params = new URLSearchParams(window.location.search);
        params.delete("iframeUrl");
        const paramsString = params.toString();
        if (paramsString) src = `${src}?${paramsString}`;
        return src;
    }, [
        src
    ]);
    // If iframeUrl is passed as a query param, use that instead
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const bridge = (0, $359862929bb6f0e3$export$b3dfa3d70263abe6)(iframeRef, {
        arisewareProjectID: arisewareProjectID
    });
    // Expose bridge to parent
    if (bridgeRef) bridgeRef.current = bridge;
    const titanEvents = (0, $5aa04911bb7556d2$export$2e2bcd8739ae039)(arisewareProjectID);
    const hyperionEvents = (0, $6af27256e4670e1c$export$2e2bcd8739ae039)();
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    const mimasEvents = (0, $f3a1c0569c2d2ecc$export$b3bc3cd373bda2b0)(discordRef, bridge);
    const status = (0, $6lYLL.useAppSelector)((state)=>state.discord.questStatus);
    const checked = (0, $6lYLL.useAppSelector)((state)=>state.discord.questStatusChecked);
    (0, $8FY87.useEffect)(()=>{
        console.log("[Arise FE] Quest status changed:", status, checked);
        bridge?.sendEvent("quest-status-update", {
            status: status,
            checked: checked
        });
    }, [
        bridge,
        status,
        checked
    ]);
    const { pushUserData: pushUserData } = (0, $3e15c60b384f1766$export$2e2bcd8739ae039)(bridge); // Custom hook to push user data on changes
    const shouldArisewareBeMuted = (0, $6lYLL.useAppSelector)((state)=>state.app.shouldArisewareBeMuted);
    (0, $8FY87.useEffect)(()=>{
        if (typeof shouldArisewareBeMuted === "boolean") bridge?.sendEvent("mute", shouldArisewareBeMuted);
    }, [
        shouldArisewareBeMuted
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!bridge) return;
        function onReadyHandler(data) {
            setIframeReady(data.detail);
            if (data.detail === true) onReady();
        }
        function onFailed() {
            dispatch((0, $baXkz.failedGame)({
                arisewareProjectID: arisewareProjectID
            }));
        }
        function onFeedUpdate(data) {
            dispatch((0, $baXkz.submitFeedUpdate)(data.detail));
        }
        function onQueueAchievement(data) {
            dispatch((0, $baXkz.queueAchievement)(data.detail));
        }
        function onSetNewsTickerVisibility(data) {
            dispatch((0, $baXkz.setIsNewsTickerVisible)(data.detail));
        }
        function onSetInventoryIsOpen(data) {
            dispatch((0, $baXkz.setIsInventoryOpen)(data.detail));
        }
        function onShowLeaderboard(data) {
            dispatch((0, $baXkz.setIsLeaderboardOpen)(data.detail));
        }
        async function onSubmitScore(data) {
            try {
                await (0, $f9aoP.submitScore)(data.detail);
            } catch (error) {
                console.log("Failed to submit score", error);
            }
        }
        function onSelectInventoryItem() {
            dispatch((0, $baXkz.selectInventoryItem)());
        }
        function onTrack(data) {
            const { eventType: eventType, metadata: metadata } = data.detail;
            if (typeof eventType !== "string") {
                console.error("Cannot send event from iFrame - eventType is invalid or missing:", data.detail);
                return;
            }
            (0, $i7H0N.sendEventV2)(eventType, metadata?.strings, metadata?.numbers, true);
        }
        function onCheckpoint(data) {
            const { name: name, time: time, id: id } = data.detail;
            (0, $i7H0N.sendEventV2)("checkpoint", [
                name
            ], [
                time,
                id
            ]);
        }
        function onGotoHome() {
            navigate((0, $1URoE.homePath));
        }
        function onGotoSignup() {
            navigateToSignup();
        }
        function onViewMedia(data) {
            dispatch((0, $baXkz.setCurrentlyViewingMedia)(data.detail));
        }
        function onViewPrize(data) {
            dispatch((0, $baXkz.setCurrentlyViewingPrize)(data.detail));
        }
        function onCopyText(data) {
            try {
                navigator.clipboard.writeText(data.detail);
            } catch (error) {
                console.error("Bridge event copy-text could not write to clipboard: ", error);
            }
        }
        function onOpenUrl(data) {
            (0, $i7H0N.sendEventV2)("external_link_opened", [
                data.detail
            ]);
            if (0, $aTRs6.IS_DISCORD_ACTIVITY) discordRef.current.openExternalLink(data.detail);
            else window.open(data.detail, "_blank");
        }
        function onQuestCompleted() {
            if ((0, $aTRs6.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.completeQuest();
            dispatch((0, $4KKbJ.setMissionComplete)());
        }
        function onQuestProgress(data) {
            if ((0, $aTRs6.IS_DISCORD_ACTIVITY) && discordRef.current) discordRef.current.setQuestProgress(data.detail);
        }
        async function onSendUserEvent(data) {
            const isNewsTickerDataIdOnlyItem = (item)=>{
                return "id" in item;
            };
            const item = data?.detail;
            if (item) {
                dispatch((0, $kyBxf.queueNewsTickerItem)(item));
                if (isNewsTickerDataIdOnlyItem(item)) // If is ID only item, send to backend too
                try {
                    await (0, $f9aoP.userEvent)(locationId, item.id);
                } catch (error) {
                    console.error("Bridge event sendUserEvent could not send event:", error);
                }
            }
        }
        function onSetNewsTickerTag(data) {
            dispatch((0, $kyBxf.setNewsTickerTag)(data.detail));
        }
        function onShare(data) {
            const { message: message, url: url, title: title } = data.detail;
            if (0, $aTRs6.IS_DISCORD_ACTIVITY) (0, $764u1.triggerDiscordShare)(message);
            else dispatch((0, $baXkz.setStartShare)([
                message,
                url,
                title
            ]));
        }
        function onAwardBadge(data) {
            const badgeRank = data.detail;
            dispatch((0, $4KKbJ.awardBadge)(badgeRank));
        }
        function onAwardTitle(data) {
            const titleId = data.detail;
            dispatch((0, $4KKbJ.awardTitle)(titleId));
        }
        async function onGetQuestStatus() {
            if ((0, $aTRs6.IS_DISCORD_ACTIVITY) && discordRef.current) {
                const status = await discordRef.current.getQuestStatus();
                bridge.sendEvent("quest-status-update", status);
            }
        }
        async function onGetUniverseMetadata() {
            try {
                const json = await (0, $f9aoP.getUniverseMetadata)();
                bridge.sendEvent("universe-metadata", json);
            } catch (error) {
                console.log("[Arise] Error cannot getUniverseMetadata");
            }
        }
        function pushDiscordPlatform() {
            if (0, $aTRs6.IS_DISCORD_ACTIVITY) {
                const platform = (0, $764u1.discordPlatform)();
                bridge.sendEvent("discord-platform", platform);
            }
        }
        bridge.on("ready", onReadyHandler);
        bridge.on("ready", pushUserData);
        bridge.on("ready", pushDiscordPlatform);
        bridge.on("failed", onFailed);
        bridge.on("feed-update", onFeedUpdate);
        bridge.on("queue-achievement", onQueueAchievement);
        bridge.on("set-news-ticker-visibility", onSetNewsTickerVisibility);
        bridge.on("set-inventory-is-open", onSetInventoryIsOpen);
        bridge.on("show-leaderboard", onShowLeaderboard);
        bridge.on("submit-score", onSubmitScore);
        bridge.on("select-inventory-item", onSelectInventoryItem);
        bridge.on("track", onTrack);
        bridge.on("track:checkpoint", onCheckpoint);
        bridge.on("goto_home", onGotoHome);
        bridge.on("goto_signup", onGotoSignup);
        bridge.on("view-media", onViewMedia);
        bridge.on("view-prize", onViewPrize);
        bridge.on("copy-text", onCopyText);
        bridge.on("send-user-event", onSendUserEvent);
        bridge.on("news-ticker-tag", onSetNewsTickerTag);
        bridge.on("share", onShare);
        bridge.on("open-url", onOpenUrl);
        bridge.on("quest-completed", onQuestCompleted);
        bridge.on("quest-progress", onQuestProgress);
        bridge.on("get-quest-status", onGetQuestStatus);
        bridge.on("get-universe-metadata", onGetUniverseMetadata);
        bridge.on("award-badge", onAwardBadge);
        bridge.on("award-title", onAwardTitle);
        return ()=>{
            dispatch((0, $baXkz.setIsNewsTickerVisible)(true));
            bridge.off("ready", onReady);
            bridge.off("ready", pushUserData);
            bridge.off("failed", onFailed);
            bridge.off("feed-update", onFeedUpdate);
            bridge.off("queue-achievement", onQueueAchievement);
            bridge.off("set-news-ticker-visibility", onSetNewsTickerVisibility);
            bridge.off("set-inventory-is-open", onSetInventoryIsOpen);
            bridge.off("show-leaderboard", onShowLeaderboard);
            bridge.off("submit-score", onSubmitScore);
            bridge.off("select-inventory-item", onSelectInventoryItem);
            bridge.off("track", onTrack);
            bridge.off("track:checkpoint", onCheckpoint);
            bridge.off("goto_home", onGotoHome);
            bridge.off("goto_signup", onGotoSignup);
            bridge.off("view-media", onViewMedia);
            bridge.off("view-prize", onViewPrize);
            bridge.off("copy-text", onCopyText);
            bridge.off("send-user-event", onSendUserEvent);
            bridge.off("news-ticker-tag", onSetNewsTickerTag);
            bridge.off("share", onShare);
            bridge.off("open-url", onOpenUrl);
            bridge.off("quest-completed", onQuestCompleted);
            bridge.off("award-badge", onAwardBadge);
            bridge.off("award-title", onAwardTitle);
            bridge.off("get-universe-metadata", onGetUniverseMetadata);
        };
    }, [
        bridge,
        iframeUrl
    ]);
    const forceInFrontOfUIStyle = forceInFrontOfUi ? {
        position: "absolute",
        zIndex: 100000
    } : {};
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("iframe", {
                allow: "xr-spatial-tracking",
                ref: iframeRef,
                src: iframeUrl,
                style: {
                    width: "100%",
                    height: "100%",
                    opacity: iframeReady ? 1 : 0,
                    ...style,
                    ...forceInFrontOfUIStyle
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                show: !iframeReady,
                backgroundImage: loadingImage,
                style: forceInFrontOfUIStyle,
                loadingText: loadingText
            }),
            (0, $aTRs6.IS_DISCORD_ACTIVITY) && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3d90f95b179d4b22$export$2e2bcd8739ae039), {
                ref: discordRef
            })
        ]
    });
}



var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $6lYLL = parcelRequire("6lYLL");

var $cEIti = parcelRequire("cEIti");


var $f9aoP = parcelRequire("f9aoP");

var $baXkz = parcelRequire("baXkz");



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
function $5bdae5ce4b6376e3$var$Heading({ elementName: elementName, fontType: fontType = "primary", className: className, children: children, style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $8FY87.createElement)(elementName, {
        ...props,
        style: {
            fontFamily: `var(--font-${fontType})`,
            ...style
        }
    }, children);
}
function $5bdae5ce4b6376e3$export$5523b16adee8048({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h1",
        style: {
            fontSize: 55.31,
            ...style
        }
    });
}
function $5bdae5ce4b6376e3$export$cb94397127ac9363({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h2",
        style: {
            fontSize: 44.3,
            ...style
        }
    });
}
function $5bdae5ce4b6376e3$export$746be9e3a3dfff1f({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h3",
        style: {
            fontSize: 35.4,
            ...style
        }
    });
}
function $5bdae5ce4b6376e3$export$cc5e069d64fda823({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h4",
        style: {
            fontSize: 28.3,
            ...style
        }
    });
}
function $5bdae5ce4b6376e3$export$88ef9fdaf11f7a1f({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h5",
        style: {
            fontSize: 22.7,
            ...style
        }
    });
}
function $5bdae5ce4b6376e3$export$a559fb8039b06400({ style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)($5bdae5ce4b6376e3$var$Heading, {
        ...props,
        elementName: "h6",
        style: {
            fontSize: 18.1,
            ...style
        }
    });
}



var $2PPWI = parcelRequire("2PPWI");
function $67805e06b1e16f83$export$56c0d5a1e737357d({ fontType: fontType = "primary", style: style = {}, ...props }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
        ...props,
        style: {
            fontFamily: `var(--font-${fontType})`,
            fontSize: 14.5,
            ...style
        }
    });
}





var $i7H0N = parcelRequire("i7H0N");
var $e07a49cea5ebf022$export$a033e390692f359f;
var $e07a49cea5ebf022$export$a6e186be9de5cf4;
var $e07a49cea5ebf022$export$38f7a21df7cf32b1;
var $e07a49cea5ebf022$export$827f4ee28efc37;
var $e07a49cea5ebf022$export$efe229eab43a9869;
var $e07a49cea5ebf022$export$17fa98cb055e8fa7;
var $e07a49cea5ebf022$export$a5833c2b43ca4340;
var $e07a49cea5ebf022$export$47511f9a6581d1d6;
var $e07a49cea5ebf022$export$dd1c05b92185401c;
var $e07a49cea5ebf022$export$8b28cf6cd00fe080;
var $e07a49cea5ebf022$export$186c650311ff0789;
var $e07a49cea5ebf022$export$6746fe0d9c9fab54;
var $e07a49cea5ebf022$export$2bcf359f0c20e94f;
var $e07a49cea5ebf022$export$2903d10d531d0ac0;
var $e07a49cea5ebf022$export$a80b3bd66acc52ff;
var $e07a49cea5ebf022$export$17a1664ed1fb5d6f;
var $e07a49cea5ebf022$export$20141bf56c9254ea;
var $e07a49cea5ebf022$export$c80d57c51a11eb0a;
var $e07a49cea5ebf022$export$9b197c8c4882f826;
var $e07a49cea5ebf022$export$5b1c922c81430b65;
var $e07a49cea5ebf022$export$b80d5161798977ff;
$e07a49cea5ebf022$export$a033e390692f359f = `jYBf7G_Inventory`;
$e07a49cea5ebf022$export$a6e186be9de5cf4 = `jYBf7G_InventoryDrawer`;
$e07a49cea5ebf022$export$38f7a21df7cf32b1 = `jYBf7G_InventoryDrawer__visible`;
$e07a49cea5ebf022$export$827f4ee28efc37 = `jYBf7G_box`;
$e07a49cea5ebf022$export$efe229eab43a9869 = `jYBf7G_closeButton`;
$e07a49cea5ebf022$export$17fa98cb055e8fa7 = `jYBf7G_fontSizeH1`;
$e07a49cea5ebf022$export$a5833c2b43ca4340 = `jYBf7G_fontSizeH2`;
$e07a49cea5ebf022$export$47511f9a6581d1d6 = `jYBf7G_fontSizeH3`;
$e07a49cea5ebf022$export$dd1c05b92185401c = `jYBf7G_fontSizeH4`;
$e07a49cea5ebf022$export$8b28cf6cd00fe080 = `jYBf7G_fontSizeH5`;
$e07a49cea5ebf022$export$186c650311ff0789 = `jYBf7G_fontSizeH6`;
$e07a49cea5ebf022$export$6746fe0d9c9fab54 = `jYBf7G_fontSizeSmall`;
$e07a49cea5ebf022$export$2bcf359f0c20e94f = `jYBf7G_fontSizeTiny`;
$e07a49cea5ebf022$export$2903d10d531d0ac0 = `jYBf7G_fontSizep`;
$e07a49cea5ebf022$export$a80b3bd66acc52ff = `jYBf7G_info`;
$e07a49cea5ebf022$export$17a1664ed1fb5d6f = `jYBf7G_items`;
$e07a49cea5ebf022$export$20141bf56c9254ea = `jYBf7G_nextButton`;
$e07a49cea5ebf022$export$c80d57c51a11eb0a = `jYBf7G_noBackgroundImage`;
$e07a49cea5ebf022$export$9b197c8c4882f826 = `jYBf7G_pageControls`;
$e07a49cea5ebf022$export$5b1c922c81430b65 = `jYBf7G_pageNumber`;
$e07a49cea5ebf022$export$b80d5161798977ff = `jYBf7G_previousButton`;


function $a097d059bec51579$export$2e2bcd8739ae039() {
    const isInventoryOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isInventoryOpen);
    const isInventoryUsingItem = (0, $6lYLL.useAppSelector)((state)=>state.app.isInventoryUsingItem);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const prevIsInventoryOpenRef = (0, $8FY87.useRef)(false);
    const [isOpenTransitionComplete, setIsOpenTransitionComplete] = (0, $8FY87.useState)(false);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    // Reset the using item state when the inventory closes
    // This is delayed so that can't see the flash of text changing while the inventory is closing
    (0, $8FY87.useEffect)(()=>{
        let timeout = 0;
        if (!isInventoryOpen) {
            setIsOpenTransitionComplete(false);
            timeout = setTimeout(()=>{
                dispatch((0, $baXkz.setIsInventoryUsingItem)(false));
            }, 500);
        }
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        isInventoryOpen
    ]);
    (0, $8FY87.useEffect)(()=>{
        // To stop sound playing when UI is reset etc
        if (isInventoryOpen && prevIsInventoryOpenRef.current !== true) audio?.play("inventory-open");
        else if (!isInventoryOpen && prevIsInventoryOpenRef.current !== false) audio?.play("inventory-close");
        prevIsInventoryOpenRef.current = isInventoryOpen;
    }, [
        isInventoryOpen
    ]);
    // To move focus to close button when opened
    function onTransitionEnd(e) {
        if (isInventoryOpen && e.target === e.currentTarget) setIsOpenTransitionComplete(true);
    }
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full",
                style: {
                    transition: "backdrop-filter 300ms, visibility 300ms",
                    visibility: isInventoryOpen ? "visible" : "hidden",
                    backdropFilter: isInventoryOpen ? "blur(10px)" : "blur(0px)"
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($e07a49cea5ebf022$export$a6e186be9de5cf4, {
                    [$e07a49cea5ebf022$export$38f7a21df7cf32b1]: isInventoryOpen
                }),
                onTransitionEnd: onTransitionEnd,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)($a097d059bec51579$var$Inventory, {
                    visible: isInventoryOpen,
                    usingItem: isInventoryUsingItem,
                    shouldFocusOnCloseButton: isOpenTransitionComplete
                })
            })
        ]
    });
}
function $a097d059bec51579$var$Inventory({ visible: visible, usingItem: usingItem, shouldFocusOnCloseButton: shouldFocusOnCloseButton }) {
    const ITEMS_PER_PAGE = 4;
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const inventory = (0, $6lYLL.useAppSelector)((state)=>state.app.inventory);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const previousButtonRef = (0, $8FY87.useRef)(null);
    const nextButtonRef = (0, $8FY87.useRef)(null);
    const [currentPage, setCurrentPage] = (0, $8FY87.useState)(0);
    const [hasLoaded, setHasLoaded] = (0, $8FY87.useState)(false);
    function closeInventoryWithoutSelection() {
        dispatch((0, $baXkz.setIsInventoryOpen)(false));
        (0, $c52ffa28168ccea6$export$d5347260c4eca75c).sendEvent("inventory_closed_without_selection", {});
        (0, $i7H0N.sendEvent)("inventory_close");
    }
    (0, $8FY87.useEffect)(()=>{
        // Close when user presses escape
        function onKeyUp(e) {
            if (e.key === "Escape") closeInventoryWithoutSelection();
        }
        async function fetchInventory() {
            try {
                const result = await (0, $f9aoP.getInventory)();
                dispatch((0, $baXkz.setInventory)(result));
                setHasLoaded(true);
            } catch (error) {
                console.error("Failed to fetch inventory:", error);
                setHasLoaded(true);
            }
        }
        if (visible) {
            if (!hasLoaded) fetchInventory();
            document.body.addEventListener("keyup", onKeyUp);
            return ()=>{
                document.body.removeEventListener("keyup", onKeyUp);
            };
        }
    }, [
        visible
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (shouldFocusOnCloseButton) setTimeout(()=>closeButtonRef.current?.focus(), 200);
    }, [
        shouldFocusOnCloseButton
    ]);
    (0, $8FY87.useEffect)(()=>{
        const remove1 = (0, $c52ffa28168ccea6$export$d5347260c4eca75c).on("inventory_takeItem_request__success", ()=>{
            dispatch((0, $baXkz.setIsUnseenItemInInventory)(true));
            dispatch((0, $baXkz.loadInventory)());
        });
        const remove2 = (0, $c52ffa28168ccea6$export$d5347260c4eca75c).on("inventory_dropItem_request__success", ()=>{
            dispatch((0, $baXkz.loadInventory)());
        });
        return ()=>{
            remove1();
            remove2();
        };
    }, []);
    function handleClickItem(item, index) {
        if (usingItem) {
            (0, $c52ffa28168ccea6$export$d5347260c4eca75c).sendEvent("inventory_item_selected", item);
            dispatch((0, $baXkz.setIsInventoryOpen)(false));
        }
    }
    function renderInfo() {
        if (usingItem) return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5bdae5ce4b6376e3$export$a559fb8039b06400), {
                    children: "USE AN ITEM?"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $67805e06b1e16f83$export$56c0d5a1e737357d), {
                    children: "Select an item to use"
                })
            ]
        });
        return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5bdae5ce4b6376e3$export$a559fb8039b06400), {
                    children: "YOUR INVENTORY"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $67805e06b1e16f83$export$56c0d5a1e737357d), {
                    children: "Your Collected Items"
                })
            ]
        });
    }
    function renderItem(item, i) {
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $e07a49cea5ebf022$export$827f4ee28efc37,
            onClick: item && (()=>handleClickItem(item, i)),
            children: [
                item && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                    title: item.name,
                    imagePath: item.inventoryThumbnailUrl,
                    subtitle: "",
                    backgroundImagePath: theme.customJSON?.cardBackgroundImageUrl,
                    textBackgroundImagePath: theme.customJSON?.cardTextBackgroundImageUrl,
                    imageAlt: `Inventory Item: ${item.name}`,
                    interactable: usingItem && visible
                }),
                !item && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $bac5dde52a47c16a$export$2e2bcd8739ae039), {
                    interactable: false,
                    title: "",
                    imagePath: "/assets/global/images/inventory/inventoryItem_empty.webp",
                    subtitle: "",
                    backgroundImagePath: theme.customJSON?.cardBackgroundImageUrl,
                    textBackgroundImagePath: "",
                    hideDescription: true
                })
            ]
        }, item?.id || i);
    }
    const currentPageItems = inventory.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);
    const numberOfPages = inventory.length ? Math.ceil(inventory.length / ITEMS_PER_PAGE) : 1;
    const changePage = (direction)=>{
        const newPage = currentPage + direction;
        // If button is focussed but is about to become hidden, move focus to other button.
        const wasFocussedOnPreviousButton = document.activeElement === previousButtonRef.current;
        const wasFocussedOnNextButton = document.activeElement === nextButtonRef.current;
        if (newPage >= 0 && newPage < numberOfPages) setCurrentPage(newPage);
        if (newPage === 0 && wasFocussedOnPreviousButton) setTimeout(()=>nextButtonRef?.current?.focus(), 0);
        if (newPage === numberOfPages - 1 && wasFocussedOnNextButton) setTimeout(()=>previousButtonRef?.current?.focus(), 0);
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        "aria-hidden": !visible,
        "aria-live": "polite",
        inert: !visible ? "" : undefined,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($e07a49cea5ebf022$export$a033e390692f359f, {
            [$e07a49cea5ebf022$export$c80d57c51a11eb0a]: !theme.files.inventory_backdrop
        }),
        style: theme.files.inventory_backdrop ? {
            backgroundImage: `url("${theme.files.inventory_backdrop}")`,
            borderImageSource: `url("${theme.files.inventory_backdrop}")`
        } : {},
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $e07a49cea5ebf022$export$a80b3bd66acc52ff,
                children: renderInfo()
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                iconType: "close",
                buttonStyle: "round",
                className: $e07a49cea5ebf022$export$efe229eab43a9869,
                ariaLabel: "Close Inventory",
                onClick: ()=>{
                    closeInventoryWithoutSelection();
                },
                disabled: !visible,
                buttonRef: closeButtonRef
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $e07a49cea5ebf022$export$17a1664ed1fb5d6f,
                style: {
                    opacity: hasLoaded ? 1 : 0
                },
                children: [
                    currentPageItems.map(renderItem),
                    currentPageItems.length < ITEMS_PER_PAGE && new Array(ITEMS_PER_PAGE - currentPageItems.length).fill(undefined).map(renderItem),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $e07a49cea5ebf022$export$9b197c8c4882f826,
                        children: [
                            currentPage > 0 && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                iconType: "play",
                                buttonStyle: "icon",
                                className: $e07a49cea5ebf022$export$b80d5161798977ff,
                                ariaLabel: "Previous Inventory Page",
                                onClick: ()=>{
                                    changePage(-1);
                                },
                                disabled: !visible,
                                buttonRef: previousButtonRef
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $e07a49cea5ebf022$export$5b1c922c81430b65,
                                "aria-label": `Page ${currentPage + 1} of ${numberOfPages}`,
                                children: [
                                    currentPage + 1,
                                    " / ",
                                    numberOfPages
                                ]
                            }),
                            currentPage + 1 < numberOfPages && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                                iconType: "play",
                                buttonStyle: "icon",
                                className: $e07a49cea5ebf022$export$20141bf56c9254ea,
                                ariaLabel: "Next Inventory Page",
                                onClick: ()=>{
                                    changePage(1);
                                },
                                disabled: !visible,
                                buttonRef: nextButtonRef
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
                show: !hasLoaded,
                hasBackground: false
            })
        ]
    });
}



var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");


var $fL4mk = parcelRequire("fL4mk");
const $846d17acc742908f$var$pusherMessageEvent = "client-chat-message";
const $846d17acc742908f$var$pusherMessageUpdateEvent = "client-chat-message-update";
const $846d17acc742908f$var$pusherMessageRemovalEvent = "client-chat-message-removal";
const $846d17acc742908f$var$pusherMessageReactionUpdateEvent = "client-chat-reaction-update";
const $846d17acc742908f$var$pusherEventCreationEvent = "client-event-creation";
function $846d17acc742908f$export$1be25102dee524a0(channelName, locationId) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const channelRef = (0, $8FY87.useRef)();
    const user = (0, $dbacf51e5486f7e0$export$23bbbc4533528f03)();
    (0, $8FY87.useEffect)(()=>{
        if (!channelName) return;
        function handlePusherMessage(data) {
            // @ts-ignore
            if (data.data.profile) // @ts-ignore
            data.data.profile = (0, $fL4mk.processProfileData)(data.data.profile);
            // @ts-ignore
            if (data.locationId !== locationId && data.data?.profile?.role === "actor") // exclude messages from other locations for actors
            return;
            dispatch((0, $kyBxf.addItem)(data));
        }
        function handleUpdateMessage(data) {
            // @ts-ignore
            if (data.data.profile) // @ts-ignore
            data.data.profile = (0, $fL4mk.processProfileData)(data.data.profile);
            dispatch((0, $kyBxf.updateItem)(data));
        }
        function handleRemoveMessage(data) {
            dispatch((0, $kyBxf.removeItem)(data.id));
        }
        function handleReactionUpdate(data) {
            dispatch((0, $kyBxf.updateMessageReaction)(data));
        }
        function handleCreateEvent(data) {
            dispatch((0, $kyBxf.setCurrentEvent)(data.data));
        }
        channelRef.current = (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).subscribe(channelName);
        // Chat messages
        channelRef.current?.bind($846d17acc742908f$var$pusherMessageEvent, handlePusherMessage);
        channelRef.current?.bind($846d17acc742908f$var$pusherMessageUpdateEvent, handleUpdateMessage);
        channelRef.current?.bind($846d17acc742908f$var$pusherMessageRemovalEvent, handleRemoveMessage);
        channelRef.current?.bind($846d17acc742908f$var$pusherMessageReactionUpdateEvent, handleReactionUpdate);
        // Events
        channelRef.current?.bind($846d17acc742908f$var$pusherEventCreationEvent, handleCreateEvent);
        return ()=>{
            // Chat messages
            channelRef.current?.unbind($846d17acc742908f$var$pusherMessageEvent, handlePusherMessage);
            channelRef.current?.unbind($846d17acc742908f$var$pusherMessageUpdateEvent, handleUpdateMessage);
            channelRef.current?.unbind($846d17acc742908f$var$pusherMessageRemovalEvent, handleRemoveMessage);
            channelRef.current?.unbind($846d17acc742908f$var$pusherMessageReactionUpdateEvent, handleReactionUpdate);
            // Events
            channelRef.current?.unbind($846d17acc742908f$var$pusherEventCreationEvent, handleCreateEvent);
            (0, $1be2adfe4fbf6545$export$573489cd3cea23b5).unsubscribe(channelName);
        };
    }, [
        channelName,
        user,
        locationId
    ]);
    return {
        channelRef: channelRef
    };
}



var $kyBxf = parcelRequire("kyBxf");

var $aTKgi = parcelRequire("aTKgi");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");
var $7c062acd8d051702$export$83605110e1f14ef1;
var $7c062acd8d051702$export$318abdbc66fb7950;
var $7c062acd8d051702$export$7ab64d539530aa6c;
$7c062acd8d051702$export$83605110e1f14ef1 = `_0qTcRq_FailOverlay`;
$7c062acd8d051702$export$318abdbc66fb7950 = `_0qTcRq_FailOverlayBg`;
$7c062acd8d051702$export$7ab64d539530aa6c = `_0qTcRq_failed`;


function $641a0332b178f9cd$export$2e2bcd8739ae039({ failed: failed }) {
    const theme = (0, $cEIti.useTheme)();
    const imgPath = theme.customJSON.failScreenOverlay;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7c062acd8d051702$export$318abdbc66fb7950, {
                    [$7c062acd8d051702$export$7ab64d539530aa6c]: failed
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7c062acd8d051702$export$83605110e1f14ef1, {
                    [$7c062acd8d051702$export$7ab64d539530aa6c]: failed
                }),
                children: imgPath && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                    src: imgPath,
                    alt: "Failed",
                    nopin: "nopin"
                })
            })
        ]
    });
}




var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");


var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");
var $7b15f82ce09a8a1e$export$11e33e7efe21f393;
var $7b15f82ce09a8a1e$export$7e4bdd3a42fd53ce;
var $7b15f82ce09a8a1e$export$17fa98cb055e8fa7;
var $7b15f82ce09a8a1e$export$a5833c2b43ca4340;
var $7b15f82ce09a8a1e$export$47511f9a6581d1d6;
var $7b15f82ce09a8a1e$export$dd1c05b92185401c;
var $7b15f82ce09a8a1e$export$8b28cf6cd00fe080;
var $7b15f82ce09a8a1e$export$186c650311ff0789;
var $7b15f82ce09a8a1e$export$6746fe0d9c9fab54;
var $7b15f82ce09a8a1e$export$2bcf359f0c20e94f;
var $7b15f82ce09a8a1e$export$2903d10d531d0ac0;
var $7b15f82ce09a8a1e$export$664c6d24e3175067;
$7b15f82ce09a8a1e$export$11e33e7efe21f393 = `Pn2q8W_AchievementFeed`;
$7b15f82ce09a8a1e$export$7e4bdd3a42fd53ce = `Pn2q8W_achievementContainer`;
$7b15f82ce09a8a1e$export$17fa98cb055e8fa7 = `Pn2q8W_fontSizeH1`;
$7b15f82ce09a8a1e$export$a5833c2b43ca4340 = `Pn2q8W_fontSizeH2`;
$7b15f82ce09a8a1e$export$47511f9a6581d1d6 = `Pn2q8W_fontSizeH3`;
$7b15f82ce09a8a1e$export$dd1c05b92185401c = `Pn2q8W_fontSizeH4`;
$7b15f82ce09a8a1e$export$8b28cf6cd00fe080 = `Pn2q8W_fontSizeH5`;
$7b15f82ce09a8a1e$export$186c650311ff0789 = `Pn2q8W_fontSizeH6`;
$7b15f82ce09a8a1e$export$6746fe0d9c9fab54 = `Pn2q8W_fontSizeSmall`;
$7b15f82ce09a8a1e$export$2bcf359f0c20e94f = `Pn2q8W_fontSizeTiny`;
$7b15f82ce09a8a1e$export$2903d10d531d0ac0 = `Pn2q8W_fontSizep`;
$7b15f82ce09a8a1e$export$664c6d24e3175067 = `Pn2q8W_visible`;



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");

var $8FY87 = parcelRequire("8FY87");
function $f50ae8d84257ee51$export$2e2bcd8739ae039({ icon: icon, onLoaded: onLoaded }) {
    const { themeId: themeId } = (0, $cEIti.useTheme)();
    function getIcon() {
        if ($f50ae8d84257ee51$var$achievementIcon[themeId]?.[icon]) return $f50ae8d84257ee51$var$achievementIcon[themeId][icon];
        if ($f50ae8d84257ee51$var$defaultIcons[icon]) return $f50ae8d84257ee51$var$defaultIcons[icon];
        console.error("Showing fallback achievement icon");
        return "/assets/global/images/achievements/points.webp";
    }
    const src = getIcon();
    (0, $8FY87.useEffect)(()=>{
        if (!onLoaded) return;
        const img = new Image();
        img.src = src;
        if (img.complete) setTimeout(onLoaded, 0);
        else img.onload = onLoaded;
    }, [
        icon,
        onLoaded
    ]);
    if (!src) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    // getTintFilterStyle('#8FFF97'))
    return /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
        src: src,
        alt: " "
    });
}
const $f50ae8d84257ee51$var$defaultIcons = {
    badge: "/assets/global/images/achievements/badge.webp",
    mission: "/assets/global/images/achievements/mission.webp",
    points: "/assets/global/images/achievements/points.webp",
    quest: "/assets/global/images/achievements/quest.webp",
    social: "/assets/global/images/achievements/social.webp",
    title: "/assets/global/images/achievements/title.webp",
    tb: "/assets/global/images/achievements/tb.webp"
};
const $f50ae8d84257ee51$var$achievementIcon = {
};


var $12922971673cb174$exports = {};

$parcel$export($12922971673cb174$exports, "Achievement", function () { return $12922971673cb174$export$27fdeeaa680fc644; }, function (v) { return $12922971673cb174$export$27fdeeaa680fc644 = v; });
$parcel$export($12922971673cb174$exports, "background", function () { return $12922971673cb174$export$8ce1fd94bee2f412; }, function (v) { return $12922971673cb174$export$8ce1fd94bee2f412 = v; });
$parcel$export($12922971673cb174$exports, "clickable", function () { return $12922971673cb174$export$60d5655c6babb2a0; }, function (v) { return $12922971673cb174$export$60d5655c6babb2a0 = v; });
$parcel$export($12922971673cb174$exports, "danger", function () { return $12922971673cb174$export$7c4df8d735fa2705; }, function (v) { return $12922971673cb174$export$7c4df8d735fa2705 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH1", function () { return $12922971673cb174$export$17fa98cb055e8fa7; }, function (v) { return $12922971673cb174$export$17fa98cb055e8fa7 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH2", function () { return $12922971673cb174$export$a5833c2b43ca4340; }, function (v) { return $12922971673cb174$export$a5833c2b43ca4340 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH3", function () { return $12922971673cb174$export$47511f9a6581d1d6; }, function (v) { return $12922971673cb174$export$47511f9a6581d1d6 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH4", function () { return $12922971673cb174$export$dd1c05b92185401c; }, function (v) { return $12922971673cb174$export$dd1c05b92185401c = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH5", function () { return $12922971673cb174$export$8b28cf6cd00fe080; }, function (v) { return $12922971673cb174$export$8b28cf6cd00fe080 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeH6", function () { return $12922971673cb174$export$186c650311ff0789; }, function (v) { return $12922971673cb174$export$186c650311ff0789 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeSmall", function () { return $12922971673cb174$export$6746fe0d9c9fab54; }, function (v) { return $12922971673cb174$export$6746fe0d9c9fab54 = v; });
$parcel$export($12922971673cb174$exports, "fontSizeTiny", function () { return $12922971673cb174$export$2bcf359f0c20e94f; }, function (v) { return $12922971673cb174$export$2bcf359f0c20e94f = v; });
$parcel$export($12922971673cb174$exports, "fontSizep", function () { return $12922971673cb174$export$2903d10d531d0ac0; }, function (v) { return $12922971673cb174$export$2903d10d531d0ac0 = v; });
$parcel$export($12922971673cb174$exports, "hasLineBreak", function () { return $12922971673cb174$export$32e2daa08ede162f; }, function (v) { return $12922971673cb174$export$32e2daa08ede162f = v; });
$parcel$export($12922971673cb174$exports, "highlighted", function () { return $12922971673cb174$export$ba6acb6e4dfd83c2; }, function (v) { return $12922971673cb174$export$ba6acb6e4dfd83c2 = v; });
$parcel$export($12922971673cb174$exports, "icon", function () { return $12922971673cb174$export$1ca1ec8b29a4ce27; }, function (v) { return $12922971673cb174$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($12922971673cb174$exports, "label", function () { return $12922971673cb174$export$1237798dc640739a; }, function (v) { return $12922971673cb174$export$1237798dc640739a = v; });
$parcel$export($12922971673cb174$exports, "success", function () { return $12922971673cb174$export$fe7c49d056ea1d88; }, function (v) { return $12922971673cb174$export$fe7c49d056ea1d88 = v; });
$parcel$export($12922971673cb174$exports, "visible", function () { return $12922971673cb174$export$664c6d24e3175067; }, function (v) { return $12922971673cb174$export$664c6d24e3175067 = v; });
var $12922971673cb174$export$27fdeeaa680fc644;
var $12922971673cb174$export$8ce1fd94bee2f412;
var $12922971673cb174$export$60d5655c6babb2a0;
var $12922971673cb174$export$7c4df8d735fa2705;
var $12922971673cb174$export$17fa98cb055e8fa7;
var $12922971673cb174$export$a5833c2b43ca4340;
var $12922971673cb174$export$47511f9a6581d1d6;
var $12922971673cb174$export$dd1c05b92185401c;
var $12922971673cb174$export$8b28cf6cd00fe080;
var $12922971673cb174$export$186c650311ff0789;
var $12922971673cb174$export$6746fe0d9c9fab54;
var $12922971673cb174$export$2bcf359f0c20e94f;
var $12922971673cb174$export$2903d10d531d0ac0;
var $12922971673cb174$export$32e2daa08ede162f;
var $12922971673cb174$export$ba6acb6e4dfd83c2;
var $12922971673cb174$export$1ca1ec8b29a4ce27;
var $12922971673cb174$export$1237798dc640739a;
var $12922971673cb174$export$fe7c49d056ea1d88;
var $12922971673cb174$export$664c6d24e3175067;
$12922971673cb174$export$27fdeeaa680fc644 = `MaV-MW_Achievement`;
$12922971673cb174$export$8ce1fd94bee2f412 = `MaV-MW_background`;
$12922971673cb174$export$60d5655c6babb2a0 = `MaV-MW_clickable`;
$12922971673cb174$export$7c4df8d735fa2705 = `MaV-MW_danger`;
$12922971673cb174$export$17fa98cb055e8fa7 = `MaV-MW_fontSizeH1`;
$12922971673cb174$export$a5833c2b43ca4340 = `MaV-MW_fontSizeH2`;
$12922971673cb174$export$47511f9a6581d1d6 = `MaV-MW_fontSizeH3`;
$12922971673cb174$export$dd1c05b92185401c = `MaV-MW_fontSizeH4`;
$12922971673cb174$export$8b28cf6cd00fe080 = `MaV-MW_fontSizeH5`;
$12922971673cb174$export$186c650311ff0789 = `MaV-MW_fontSizeH6`;
$12922971673cb174$export$6746fe0d9c9fab54 = `MaV-MW_fontSizeSmall`;
$12922971673cb174$export$2bcf359f0c20e94f = `MaV-MW_fontSizeTiny`;
$12922971673cb174$export$2903d10d531d0ac0 = `MaV-MW_fontSizep`;
$12922971673cb174$export$32e2daa08ede162f = `MaV-MW_hasLineBreak`;
$12922971673cb174$export$ba6acb6e4dfd83c2 = `MaV-MW_highlighted`;
$12922971673cb174$export$1ca1ec8b29a4ce27 = `MaV-MW_icon`;
$12922971673cb174$export$1237798dc640739a = `MaV-MW_label`;
$12922971673cb174$export$fe7c49d056ea1d88 = `MaV-MW_success`;
$12922971673cb174$export$664c6d24e3175067 = `MaV-MW_visible`;


function $76044dec5bf4d641$export$2e2bcd8739ae039({ actionPrefix: actionPrefix, action: action, type: type, icon: icon, onLoaded: onLoaded, isVisible: isVisible = true, hasLineBreak: hasLineBreak, onClick: onClick }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($12922971673cb174$exports.Achievement, $12922971673cb174$exports[type], {
            [$12922971673cb174$exports.visible]: isVisible,
            [$12922971673cb174$exports.clickable]: onClick
        }),
        "aria-label": `${actionPrefix} ${action}`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $12922971673cb174$exports.background
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $12922971673cb174$exports.icon,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f50ae8d84257ee51$export$2e2bcd8739ae039), {
                    icon: icon,
                    onLoaded: onLoaded
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $12922971673cb174$exports.label,
                children: /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                    children: [
                        actionPrefix,
                        " ",
                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($12922971673cb174$exports.highlighted, {
                                [$12922971673cb174$exports.hasLineBreak]: hasLineBreak
                            }),
                            children: action
                        })
                    ]
                })
            })
        ]
    });
}


const $eaf2d4aabcdd6ef8$var$TRANSITION_IN_DURATION = 300; // Duplicated in scss
const $eaf2d4aabcdd6ef8$var$ACHIEVEMENT_STATIC_DURATION = 4000;
const $eaf2d4aabcdd6ef8$var$TRANSITION_OUT_DURATION = 120; // Duplicated in scss
const $eaf2d4aabcdd6ef8$var$QUEUE_GAP_DURATION = 1000;
function $eaf2d4aabcdd6ef8$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const { achievementQueue: achievementQueue } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const [isVisible, setIsVisible] = (0, $8FY87.useState)(false); // Controls achievement CSS transition
    const [isPlaying, setIsPlaying] = (0, $8FY87.useState)(false); // If achievement animation is currently playing
    const [achievementIsLoaded, setAchievementIsLoaded] = (0, $8FY87.useState)(false); // If image inside current achievement is loaded
    (0, $8FY87.useEffect)(()=>{
        if (achievementQueue[0] && achievementIsLoaded && !isPlaying) {
            // Animate in
            setIsPlaying(true);
            setIsVisible(true);
            audio?.play($eaf2d4aabcdd6ef8$var$getAudioNameByAchievementType(achievementQueue[0].type));
            setTimeout(()=>{
                // Animate out
                setIsVisible(false);
            }, $eaf2d4aabcdd6ef8$var$TRANSITION_IN_DURATION + $eaf2d4aabcdd6ef8$var$ACHIEVEMENT_STATIC_DURATION);
            setTimeout(()=>{
                // Delete achievement from queue
                dispatch((0, $baXkz.removeFirstAchievementFromQueue)());
                setIsPlaying(false);
                setAchievementIsLoaded(false);
            }, $eaf2d4aabcdd6ef8$var$TRANSITION_IN_DURATION + $eaf2d4aabcdd6ef8$var$ACHIEVEMENT_STATIC_DURATION + $eaf2d4aabcdd6ef8$var$TRANSITION_OUT_DURATION + $eaf2d4aabcdd6ef8$var$QUEUE_GAP_DURATION);
        }
    }, [
        achievementQueue,
        achievementIsLoaded
    ]);
    const currentAchievement = achievementQueue[0];
    if (!currentAchievement) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    const ON_CLICK_ACTIONS = {
        "open-profile": ()=>{
            dispatch((0, $baXkz.openProfile)());
        }
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $7b15f82ce09a8a1e$export$11e33e7efe21f393,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            role: "alert",
            "aria-live": "assertive",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7b15f82ce09a8a1e$export$7e4bdd3a42fd53ce, {
                [$7b15f82ce09a8a1e$export$664c6d24e3175067]: isVisible
            }),
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $76044dec5bf4d641$export$2e2bcd8739ae039), {
                type: currentAchievement.type,
                icon: currentAchievement.icon,
                actionPrefix: currentAchievement.actionPrefix,
                action: currentAchievement.action,
                onLoaded: ()=>setAchievementIsLoaded(true),
                isVisible: isVisible,
                hasLineBreak: currentAchievement.hasLineBreak,
                onClick: ON_CLICK_ACTIONS[currentAchievement.onClickAction]
            })
        })
    });
}
function $eaf2d4aabcdd6ef8$var$getAudioNameByAchievementType(type) {
    switch(type){
        case "success":
            return "positive-achievement";
        case "danger":
            return "negative-achievement";
        case "default":
            return "positive-achievement";
        default:
            return "positive-achievement";
    }
}



var $2PPWI = parcelRequire("2PPWI");

var $4MZsN = parcelRequire("4MZsN");
var $7aaeab7b78b844f3$export$82e6205b15e6c637;
var $7aaeab7b78b844f3$export$17fa98cb055e8fa7;
var $7aaeab7b78b844f3$export$a5833c2b43ca4340;
var $7aaeab7b78b844f3$export$47511f9a6581d1d6;
var $7aaeab7b78b844f3$export$dd1c05b92185401c;
var $7aaeab7b78b844f3$export$8b28cf6cd00fe080;
var $7aaeab7b78b844f3$export$186c650311ff0789;
var $7aaeab7b78b844f3$export$6746fe0d9c9fab54;
var $7aaeab7b78b844f3$export$2bcf359f0c20e94f;
var $7aaeab7b78b844f3$export$2903d10d531d0ac0;
var $7aaeab7b78b844f3$export$b505a1410148f50f;
var $7aaeab7b78b844f3$export$f49cd57009bca041;
var $7aaeab7b78b844f3$export$6cee2c3049169108;
var $7aaeab7b78b844f3$export$812a67cf7777f9c7;
var $7aaeab7b78b844f3$export$69b8eb653a75577c;
var $7aaeab7b78b844f3$export$5c07a5497c9ec32a;
var $7aaeab7b78b844f3$export$f5dc490ac5e60ff9;
var $7aaeab7b78b844f3$export$44935f8a884b57b9;
var $7aaeab7b78b844f3$export$2d56362743d856ef;
$7aaeab7b78b844f3$export$82e6205b15e6c637 = `VhgSmG_fadeIn`;
$7aaeab7b78b844f3$export$82e6205b15e6c637;
$7aaeab7b78b844f3$export$17fa98cb055e8fa7 = `VhgSmG_fontSizeH1`;
$7aaeab7b78b844f3$export$a5833c2b43ca4340 = `VhgSmG_fontSizeH2`;
$7aaeab7b78b844f3$export$47511f9a6581d1d6 = `VhgSmG_fontSizeH3`;
$7aaeab7b78b844f3$export$dd1c05b92185401c = `VhgSmG_fontSizeH4`;
$7aaeab7b78b844f3$export$8b28cf6cd00fe080 = `VhgSmG_fontSizeH5`;
$7aaeab7b78b844f3$export$186c650311ff0789 = `VhgSmG_fontSizeH6`;
$7aaeab7b78b844f3$export$6746fe0d9c9fab54 = `VhgSmG_fontSizeSmall`;
$7aaeab7b78b844f3$export$2bcf359f0c20e94f = `VhgSmG_fontSizeTiny`;
$7aaeab7b78b844f3$export$2903d10d531d0ac0 = `VhgSmG_fontSizep`;
$7aaeab7b78b844f3$export$b505a1410148f50f = `VhgSmG_locationIntroduction`;
$7aaeab7b78b844f3$export$f49cd57009bca041 = `VhgSmG_locationIntroduction__image`;
$7aaeab7b78b844f3$export$6cee2c3049169108 = `VhgSmG_locationIntroduction__soundWarning`;
$7aaeab7b78b844f3$export$812a67cf7777f9c7 = `VhgSmG_locationIntroduction__text`;
$7aaeab7b78b844f3$export$69b8eb653a75577c = `VhgSmG_locationIntroduction__title`;
$7aaeab7b78b844f3$export$5c07a5497c9ec32a = `VhgSmG_locationIntroduction__titlePrefix`;
$7aaeab7b78b844f3$export$f5dc490ac5e60ff9 = `VhgSmG_locationIntroduction__titleText`;
$7aaeab7b78b844f3$export$44935f8a884b57b9 = `VhgSmG_moveUp`;
$7aaeab7b78b844f3$export$44935f8a884b57b9;
$7aaeab7b78b844f3$export$2d56362743d856ef = `VhgSmG_moveUpFaster`;
$7aaeab7b78b844f3$export$2d56362743d856ef;


function $40d9665fe7f92bb6$export$2e2bcd8739ae039({ titlePrefix: titlePrefix, titleText: titleText, text: text, imageUrl: imageUrl, hasSoundWarning: hasSoundWarning, onComplete: onComplete }) {
    setTimeout(onComplete, 2500);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $7aaeab7b78b844f3$export$b505a1410148f50f,
        children: [
            imageUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $7aaeab7b78b844f3$export$f49cd57009bca041,
                style: {
                    backgroundImage: `url('${imageUrl}')`
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                className: $7aaeab7b78b844f3$export$69b8eb653a75577c,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        className: $7aaeab7b78b844f3$export$5c07a5497c9ec32a,
                        children: [
                            titlePrefix,
                            titlePrefix ? ": " : " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                        className: $7aaeab7b78b844f3$export$f5dc490ac5e60ff9,
                        children: titleText
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
                    hasSoundWarning && /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                        className: $7aaeab7b78b844f3$export$6cee2c3049169108,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                type: "sound",
                                size: 24
                            }),
                            "Requires sound"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                className: $7aaeab7b78b844f3$export$812a67cf7777f9c7,
                children: text
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $6lYLL = parcelRequire("6lYLL");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");


var $i7H0N = parcelRequire("i7H0N");

var $jLk8j = parcelRequire("jLk8j");

function $4893fcc1f78ed63d$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const isFeedOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.location.isFeedOpen);
    const buttonHasBeenClickedOnce = (0, $8FY87.useRef)(false);
    const openChat = ()=>{
        audio?.play("gust-open");
        dispatch((0, $baXkz.setIsSidebarOpen)(true));
        (0, $i7H0N.sendEvent)("chat_open");
        if (!buttonHasBeenClickedOnce.current) buttonHasBeenClickedOnce.current = true;
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
        onClick: openChat,
        ariaLabel: "Open chat",
        buttonStyle: "round",
        iconType: "chat",
        hasDot: !buttonHasBeenClickedOnce.current && isFeedOpen && (0, $jLk8j.isMobileWidth)()
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $kyBxf = parcelRequire("kyBxf");



var $i7H0N = parcelRequire("i7H0N");

var $ee32c6e943534f17$export$d615c2866b323964;
var $ee32c6e943534f17$export$345c5736c8054f22;
var $ee32c6e943534f17$export$761970e3ff6ec536;
var $ee32c6e943534f17$export$17fa98cb055e8fa7;
var $ee32c6e943534f17$export$a5833c2b43ca4340;
var $ee32c6e943534f17$export$47511f9a6581d1d6;
var $ee32c6e943534f17$export$dd1c05b92185401c;
var $ee32c6e943534f17$export$8b28cf6cd00fe080;
var $ee32c6e943534f17$export$186c650311ff0789;
var $ee32c6e943534f17$export$6746fe0d9c9fab54;
var $ee32c6e943534f17$export$2bcf359f0c20e94f;
var $ee32c6e943534f17$export$2903d10d531d0ac0;
var $ee32c6e943534f17$export$a8ecead220dd38a6;
var $ee32c6e943534f17$export$65588215f5c347c3;
var $ee32c6e943534f17$export$aa93e98c2739f719;
var $ee32c6e943534f17$export$6f093cfa640b7166;
var $ee32c6e943534f17$export$c221de6d0aa52c0e;
var $ee32c6e943534f17$export$2f9b8fa7a12ac5b0;
var $ee32c6e943534f17$export$46fd485637f0ac7a;
$ee32c6e943534f17$export$d615c2866b323964 = `X2YSWW_QuickReact`;
$ee32c6e943534f17$export$345c5736c8054f22 = `X2YSWW_avatar`;
$ee32c6e943534f17$export$761970e3ff6ec536 = `X2YSWW_floatingReactions`;
$ee32c6e943534f17$export$17fa98cb055e8fa7 = `X2YSWW_fontSizeH1`;
$ee32c6e943534f17$export$a5833c2b43ca4340 = `X2YSWW_fontSizeH2`;
$ee32c6e943534f17$export$47511f9a6581d1d6 = `X2YSWW_fontSizeH3`;
$ee32c6e943534f17$export$dd1c05b92185401c = `X2YSWW_fontSizeH4`;
$ee32c6e943534f17$export$8b28cf6cd00fe080 = `X2YSWW_fontSizeH5`;
$ee32c6e943534f17$export$186c650311ff0789 = `X2YSWW_fontSizeH6`;
$ee32c6e943534f17$export$6746fe0d9c9fab54 = `X2YSWW_fontSizeSmall`;
$ee32c6e943534f17$export$2bcf359f0c20e94f = `X2YSWW_fontSizeTiny`;
$ee32c6e943534f17$export$2903d10d531d0ac0 = `X2YSWW_fontSizep`;
$ee32c6e943534f17$export$a8ecead220dd38a6 = `X2YSWW_message`;
$ee32c6e943534f17$export$65588215f5c347c3 = `X2YSWW_react`;
$ee32c6e943534f17$export$aa93e98c2739f719 = `X2YSWW_reactionButtonImg`;
$ee32c6e943534f17$export$6f093cfa640b7166 = `X2YSWW_text`;
$ee32c6e943534f17$export$c221de6d0aa52c0e = `X2YSWW_xAnimation`;
$ee32c6e943534f17$export$c221de6d0aa52c0e;
$ee32c6e943534f17$export$2f9b8fa7a12ac5b0 = `X2YSWW_xAnimation-alt`;
$ee32c6e943534f17$export$2f9b8fa7a12ac5b0;
$ee32c6e943534f17$export$46fd485637f0ac7a = `X2YSWW_yAnimation`;
$ee32c6e943534f17$export$46fd485637f0ac7a;


function $a37cb924fb8f2a49$export$2e2bcd8739ae039({ message: message }) {
    const locationId = (0, $6lYLL.useAppSelector)((state)=>state.app.location.id);
    const availableReactions = (0, $6lYLL.useAppSelector)((state)=>state.feed.availableReactions);
    const isSidebarOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isSidebarOpen);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const openChat = ()=>{
        audio?.play(isSidebarOpen ? "gust-close" : "gust-open");
        dispatch((0, $baXkz.toggleSidebarOpen)());
        (0, $i7H0N.sendEvent)(isSidebarOpen ? "chat_close" : "chat_open");
    };
    function getHighestCountReaction(reactions) {
        if (!reactions || reactions?.length === 0) return null;
        const highestReaction = reactions.reduce((max, current)=>current.count > max.count ? current : max, reactions[0]);
        return availableReactions[highestReaction?.type] ?? null;
    }
    const reaction = getHighestCountReaction(message?.data?.reactions);
    function handleReactionSubmit() {
        if (!message || !reaction) return;
        dispatch((0, $kyBxf.toggleMessageReaction)([
            message.id,
            reaction.type,
            locationId
        ]));
        (0, $i7H0N.sendEvent)("toggle_reaction_quick_react", {
            reaction: reaction
        });
    }
    const shouldShowReactionButton = availableReactions && reaction;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: $ee32c6e943534f17$export$d615c2866b323964,
        "aria-label": isSidebarOpen ? "Close chat" : "Open chat",
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                className: $ee32c6e943534f17$export$a8ecead220dd38a6,
                onClick: openChat,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                        classname: $ee32c6e943534f17$export$345c5736c8054f22,
                        backgroundImagePath: message?.data?.profile?.background?.thumbnailPath,
                        characterImagePath: message?.data?.profile?.character?.thumbnailPath,
                        frameImagePath: message?.data?.profile?.avatarFrame?.imagePath
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $ee32c6e943534f17$export$6f093cfa640b7166,
                        children: message?.data?.message ?? ""
                    })
                ]
            }),
            shouldShowReactionButton && /*#__PURE__*/ (0, $2PPWI.jsx)($a37cb924fb8f2a49$var$FloatingReactions, {
                reaction: reaction,
                handleReactionSubmit: handleReactionSubmit
            })
        ]
    });
}
function $a37cb924fb8f2a49$var$FloatingReactions({ reaction: reaction, handleReactionSubmit: handleReactionSubmit }) {
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const notAllowedToReact = currentUserProfile?.isBanned || isGuest;
    const ReactionImage = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("img", {
            src: reaction.imageUrl,
            alt: " "
        });
    const [reactions, setReactions] = (0, $8FY87.useState)([
        /*#__PURE__*/ (0, $2PPWI.jsx)(ReactionImage, {}, 0),
        /*#__PURE__*/ (0, $2PPWI.jsx)(ReactionImage, {}, 1),
        /*#__PURE__*/ (0, $2PPWI.jsx)(ReactionImage, {}, 2)
    ]);
    const [isDisabled, setIsDisabled] = (0, $8FY87.useState)(false);
    const onClick = ()=>{
        handleReactionSubmit();
        setReactions([
            ...reactions,
            /*#__PURE__*/ (0, $2PPWI.jsx)(ReactionImage, {}, reactions.length)
        ]);
        setIsDisabled(true); // Disable the button after click
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        className: $ee32c6e943534f17$export$65588215f5c347c3,
        onClick: onClick,
        "aria-label": `Send ${reaction.title} reaction`,
        disabled: notAllowedToReact || isDisabled,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $ee32c6e943534f17$export$761970e3ff6ec536,
                "aria-hidden": true,
                children: reactions
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $ee32c6e943534f17$export$aa93e98c2739f719,
                src: reaction.imageUrl,
                alt: reaction.title
            })
        ]
    });
}


var $9d37cfe676ec6b73$exports = {};

$parcel$export($9d37cfe676ec6b73$exports, "QuickChatDrawer", function () { return $9d37cfe676ec6b73$export$64479c3dd583203e; }, function (v) { return $9d37cfe676ec6b73$export$64479c3dd583203e = v; });
$parcel$export($9d37cfe676ec6b73$exports, "chatWidget", function () { return $9d37cfe676ec6b73$export$649324a193feb69d; }, function (v) { return $9d37cfe676ec6b73$export$649324a193feb69d = v; });
$parcel$export($9d37cfe676ec6b73$exports, "chatWidgetAndQuickReactState", function () { return $9d37cfe676ec6b73$export$fc537176e7a8f922; }, function (v) { return $9d37cfe676ec6b73$export$fc537176e7a8f922 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "chatWidgetState", function () { return $9d37cfe676ec6b73$export$3e96fd1ed7b71874; }, function (v) { return $9d37cfe676ec6b73$export$3e96fd1ed7b71874 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH1", function () { return $9d37cfe676ec6b73$export$17fa98cb055e8fa7; }, function (v) { return $9d37cfe676ec6b73$export$17fa98cb055e8fa7 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH2", function () { return $9d37cfe676ec6b73$export$a5833c2b43ca4340; }, function (v) { return $9d37cfe676ec6b73$export$a5833c2b43ca4340 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH3", function () { return $9d37cfe676ec6b73$export$47511f9a6581d1d6; }, function (v) { return $9d37cfe676ec6b73$export$47511f9a6581d1d6 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH4", function () { return $9d37cfe676ec6b73$export$dd1c05b92185401c; }, function (v) { return $9d37cfe676ec6b73$export$dd1c05b92185401c = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH5", function () { return $9d37cfe676ec6b73$export$8b28cf6cd00fe080; }, function (v) { return $9d37cfe676ec6b73$export$8b28cf6cd00fe080 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeH6", function () { return $9d37cfe676ec6b73$export$186c650311ff0789; }, function (v) { return $9d37cfe676ec6b73$export$186c650311ff0789 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeSmall", function () { return $9d37cfe676ec6b73$export$6746fe0d9c9fab54; }, function (v) { return $9d37cfe676ec6b73$export$6746fe0d9c9fab54 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizeTiny", function () { return $9d37cfe676ec6b73$export$2bcf359f0c20e94f; }, function (v) { return $9d37cfe676ec6b73$export$2bcf359f0c20e94f = v; });
$parcel$export($9d37cfe676ec6b73$exports, "fontSizep", function () { return $9d37cfe676ec6b73$export$2903d10d531d0ac0; }, function (v) { return $9d37cfe676ec6b73$export$2903d10d531d0ac0 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "hiddenState", function () { return $9d37cfe676ec6b73$export$178e888c953601b1; }, function (v) { return $9d37cfe676ec6b73$export$178e888c953601b1 = v; });
$parcel$export($9d37cfe676ec6b73$exports, "quickReact", function () { return $9d37cfe676ec6b73$export$8619c44f22cb4a18; }, function (v) { return $9d37cfe676ec6b73$export$8619c44f22cb4a18 = v; });
var $9d37cfe676ec6b73$export$64479c3dd583203e;
var $9d37cfe676ec6b73$export$649324a193feb69d;
var $9d37cfe676ec6b73$export$fc537176e7a8f922;
var $9d37cfe676ec6b73$export$3e96fd1ed7b71874;
var $9d37cfe676ec6b73$export$17fa98cb055e8fa7;
var $9d37cfe676ec6b73$export$a5833c2b43ca4340;
var $9d37cfe676ec6b73$export$47511f9a6581d1d6;
var $9d37cfe676ec6b73$export$dd1c05b92185401c;
var $9d37cfe676ec6b73$export$8b28cf6cd00fe080;
var $9d37cfe676ec6b73$export$186c650311ff0789;
var $9d37cfe676ec6b73$export$6746fe0d9c9fab54;
var $9d37cfe676ec6b73$export$2bcf359f0c20e94f;
var $9d37cfe676ec6b73$export$2903d10d531d0ac0;
var $9d37cfe676ec6b73$export$178e888c953601b1;
var $9d37cfe676ec6b73$export$8619c44f22cb4a18;
$9d37cfe676ec6b73$export$64479c3dd583203e = `OKKoGa_QuickChatDrawer`;
$9d37cfe676ec6b73$export$649324a193feb69d = `OKKoGa_chatWidget`;
$9d37cfe676ec6b73$export$fc537176e7a8f922 = `OKKoGa_chatWidgetAndQuickReactState`;
$9d37cfe676ec6b73$export$3e96fd1ed7b71874 = `OKKoGa_chatWidgetState`;
$9d37cfe676ec6b73$export$17fa98cb055e8fa7 = `OKKoGa_fontSizeH1`;
$9d37cfe676ec6b73$export$a5833c2b43ca4340 = `OKKoGa_fontSizeH2`;
$9d37cfe676ec6b73$export$47511f9a6581d1d6 = `OKKoGa_fontSizeH3`;
$9d37cfe676ec6b73$export$dd1c05b92185401c = `OKKoGa_fontSizeH4`;
$9d37cfe676ec6b73$export$8b28cf6cd00fe080 = `OKKoGa_fontSizeH5`;
$9d37cfe676ec6b73$export$186c650311ff0789 = `OKKoGa_fontSizeH6`;
$9d37cfe676ec6b73$export$6746fe0d9c9fab54 = `OKKoGa_fontSizeSmall`;
$9d37cfe676ec6b73$export$2bcf359f0c20e94f = `OKKoGa_fontSizeTiny`;
$9d37cfe676ec6b73$export$2903d10d531d0ac0 = `OKKoGa_fontSizep`;
$9d37cfe676ec6b73$export$178e888c953601b1 = `OKKoGa_hiddenState`;
$9d37cfe676ec6b73$export$8619c44f22cb4a18 = `OKKoGa_quickReact`;


const $3657b3ca0d43c577$var$convertToNumber = (text)=>text ? parseInt(text) : null;
function $3657b3ca0d43c577$export$2e2bcd8739ae039() {
    const { messages: messages, isLoadingPastMessages: isLoadingPastMessages } = (0, $6lYLL.useAppSelector)((state)=>state.feed);
    const isSidebarOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isSidebarOpen);
    const theme = (0, $cEIti.useTheme)();
    // Settings can be overridden using customJSON if needed
    const settings = {
        highlightedMessageVisibleDurationMs: $3657b3ca0d43c577$var$convertToNumber(theme.customJSON["highlightedMessageSettings"]?.["visibleDurationMs"]) ?? 4000,
        highlightedMessageGapDurationMs: $3657b3ca0d43c577$var$convertToNumber(theme.customJSON["highlightedMessageSettings"]?.["gapDurationMs"]) ?? 10000,
        highlightedMessageMaxMessageLength: $3657b3ca0d43c577$var$convertToNumber(theme.customJSON["highlightedMessageSettings"]?.["maxMessageLength"]) ?? 35,
        highlightedMessageMinReactions: $3657b3ca0d43c577$var$convertToNumber(theme.customJSON["highlightedMessageSettings"]?.["minReactions"]) ?? 1
    };
    const [highlightedMessage, setHighlightedMessage] = (0, $8FY87.useState)(null);
    const [visualStatus, setVisualStatus] = (0, $8FY87.useState)("chatWidgetState");
    const seenMessageIds = (0, $8FY87.useRef)([]);
    function getMessageToHighlight(items) {
        // Check every message from newest to oldest
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            const numberOfReactions = item.data?.["reactions"]?.length ?? 0;
            const shouldBeHighlighted = item.type === "chat-message" && !seenMessageIds.current.includes(item.id) && item.data?.message?.length <= settings.highlightedMessageMaxMessageLength && numberOfReactions >= settings.highlightedMessageMinReactions;
            if (shouldBeHighlighted) {
                // Found a message to highlight!
                seenMessageIds.current = [];
                for(let j = i; j < items.length; j++)// This message and messages older than it should never be highlighted again (to stop messages showing out of order)
                // So add them to seenMessageIds
                seenMessageIds.current.push(items[j].id);
                return item;
            }
        }
        return null;
    }
    function setAllMessagesAsSeen() {
        // We only check the 10 most recent messages, so we only need to set last 10 as seen
        const last10Items = messages.slice(-10);
        seenMessageIds.current = last10Items.map((item)=>item.id);
    }
    (0, $8FY87.useEffect)(()=>{
        if (!isSidebarOpen) // When user closes the chat, set all previous messages as seen
        setAllMessagesAsSeen();
    }, [
        isSidebarOpen
    ]);
    (0, $8FY87.useEffect)(()=>{
        // When historical messages first load in, set them all as seen
        if (!isLoadingPastMessages && messages.length) setAllMessagesAsSeen();
    }, [
        isLoadingPastMessages
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!isSidebarOpen && !highlightedMessage && !isLoadingPastMessages) {
            // If chat closed, and if no current highlighted message
            const last10Items = messages.slice(-10).reverse();
            const result = getMessageToHighlight(last10Items);
            if (result) // Highlight a message
            setHighlightedMessage(result);
        }
    }, [
        messages
    ]);
    (0, $8FY87.useEffect)(()=>{
        // When highlighted message changes
        if (!highlightedMessage) return;
        // Show it
        setVisualStatus("chatWidgetAndQuickReactState");
        // Hide it after n MS
        const visibleTimeout = setTimeout(()=>{
            setVisualStatus("chatWidgetState");
        }, settings.highlightedMessageVisibleDurationMs);
        // Allow new one to appear after n MS
        const clearMessageTimeout = setTimeout(()=>{
            setHighlightedMessage(null);
        }, settings.highlightedMessageVisibleDurationMs + settings.highlightedMessageGapDurationMs);
        return ()=>{
            clearTimeout(visibleTimeout);
            clearTimeout(clearMessageTimeout);
            setVisualStatus("chatWidgetState");
            setHighlightedMessage(null);
        };
    }, [
        highlightedMessage
    ]);
    const visualStyle = visualStatus;
    const chatWidgetIsHidden = isSidebarOpen;
    const quickReactIsHidden = visualStatus !== "chatWidgetAndQuickReactState";
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($9d37cfe676ec6b73$exports.QuickChatDrawer, $9d37cfe676ec6b73$exports[visualStyle]),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $9d37cfe676ec6b73$exports.chatWidget,
                inert: chatWidgetIsHidden ? "" : undefined,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4893fcc1f78ed63d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $9d37cfe676ec6b73$exports.quickReact,
                inert: quickReactIsHidden ? "" : undefined,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a37cb924fb8f2a49$export$2e2bcd8739ae039), {
                    message: highlightedMessage
                })
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $1URoE = parcelRequire("1URoE");


var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $i7H0N = parcelRequire("i7H0N");

var $jLk8j = parcelRequire("jLk8j");


var $4MZsN = parcelRequire("4MZsN");

var $bc64c420fc51925d$export$ba0edf94d39f51b8;
var $bc64c420fc51925d$export$2ba01fb71ed41cb6;
var $bc64c420fc51925d$export$d35c1ed5be9489b6;
var $bc64c420fc51925d$export$c4a068d767524312;
var $bc64c420fc51925d$export$b94e31e2de63b9f5;
var $bc64c420fc51925d$export$17fa98cb055e8fa7;
var $bc64c420fc51925d$export$a5833c2b43ca4340;
var $bc64c420fc51925d$export$47511f9a6581d1d6;
var $bc64c420fc51925d$export$dd1c05b92185401c;
var $bc64c420fc51925d$export$8b28cf6cd00fe080;
var $bc64c420fc51925d$export$186c650311ff0789;
var $bc64c420fc51925d$export$6746fe0d9c9fab54;
var $bc64c420fc51925d$export$2bcf359f0c20e94f;
var $bc64c420fc51925d$export$2903d10d531d0ac0;
var $bc64c420fc51925d$export$247e0fe57bb94f2;
var $bc64c420fc51925d$export$55ecc4b6d40d2156;
var $bc64c420fc51925d$export$9d5c241fe9ee2567;
var $bc64c420fc51925d$export$5eab89114764d15c;
$bc64c420fc51925d$export$ba0edf94d39f51b8 = `UAFalW_FloatingHeaderBar`;
$bc64c420fc51925d$export$2ba01fb71ed41cb6 = `UAFalW_button`;
$bc64c420fc51925d$export$d35c1ed5be9489b6 = `UAFalW_buttonStatus`;
$bc64c420fc51925d$export$c4a068d767524312 = `UAFalW_buttonsContainer`;
$bc64c420fc51925d$export$b94e31e2de63b9f5 = `UAFalW_expandButton`;
$bc64c420fc51925d$export$17fa98cb055e8fa7 = `UAFalW_fontSizeH1`;
$bc64c420fc51925d$export$a5833c2b43ca4340 = `UAFalW_fontSizeH2`;
$bc64c420fc51925d$export$47511f9a6581d1d6 = `UAFalW_fontSizeH3`;
$bc64c420fc51925d$export$dd1c05b92185401c = `UAFalW_fontSizeH4`;
$bc64c420fc51925d$export$8b28cf6cd00fe080 = `UAFalW_fontSizeH5`;
$bc64c420fc51925d$export$186c650311ff0789 = `UAFalW_fontSizeH6`;
$bc64c420fc51925d$export$6746fe0d9c9fab54 = `UAFalW_fontSizeSmall`;
$bc64c420fc51925d$export$2bcf359f0c20e94f = `UAFalW_fontSizeTiny`;
$bc64c420fc51925d$export$2903d10d531d0ac0 = `UAFalW_fontSizep`;
$bc64c420fc51925d$export$247e0fe57bb94f2 = `UAFalW_isExpanded`;
$bc64c420fc51925d$export$55ecc4b6d40d2156 = `UAFalW_isLeftAligned`;
$bc64c420fc51925d$export$9d5c241fe9ee2567 = `UAFalW_logoIcon`;
$bc64c420fc51925d$export$5eab89114764d15c = `UAFalW_noLogoIcon`;


function $60ba48ffbe0ae6e8$export$2e2bcd8739ae039({ classname: classname }) {
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { isProfileOpen: isProfileOpen, isInventoryOpen: isInventoryOpen, isShopOpen: isShopOpen, isSettingsMenuShowing: isSettingsMenuShowing, isExitLocationModalOpen: isExitLocationModalOpen, hasSeenShop: hasSeenShop, isInformationOpen: isInformationOpen, isLeaderboardOpen: isLeaderboardOpen } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const [isExpanded, setIsExpanded] = (0, $8FY87.useState)(false);
    const { locationId: locationId } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    // Some buttons are only available inside locations
    const isInLocation = locationId;
    const canShowExitModal = !(0, $1URoE.isHomePath)();
    const hasShopButton = isInLocation && (theme.metadata?.hasProfileShop || theme.metadata?.hasExternalShop);
    const hasInventoryButton = isInLocation && theme.metadata?.hasInventory;
    const shouldShowShopTooltips = theme.customJSON?.shouldShowShopTooltips;
    const hasSettingsButton = false;
    const hasInformationDrawer = theme.customJSON?.informationDrawer?.enabled;
    const isLeftAligned = theme.customJSON?.floatingMenuIsLeftAligned; // Default is right aligned
    const hasLeaderboard = theme.customJSON?.leaderboard?.enabled;
    const hasDebugMenu = (0, $9fcdfd8a99f7979e$export$69bcb768638f40fb)(theme.customJSON);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($bc64c420fc51925d$export$ba0edf94d39f51b8, classname, {
            [$bc64c420fc51925d$export$55ecc4b6d40d2156]: isLeftAligned,
            [$bc64c420fc51925d$export$247e0fe57bb94f2]: isExpanded
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                className: $bc64c420fc51925d$export$b94e31e2de63b9f5,
                onClick: ()=>setIsExpanded(!isExpanded),
                "aria-label": isExpanded ? "Collapse menu" : "Expand menu",
                children: [
                    theme.files.logo ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                className: $bc64c420fc51925d$export$9d5c241fe9ee2567,
                                src: theme.files.logo,
                                alt: "Logo Icon"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $bc64c420fc51925d$export$d35c1ed5be9489b6,
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                    type: isExpanded ? "close" : "menu",
                                    size: 12
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                        className: $bc64c420fc51925d$export$5eab89114764d15c,
                        type: isExpanded ? "close" : "menu",
                        size: 30
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $b81d3c408fcda381$export$2e2bcd8739ae039), {
                        isVisible: shouldShowShopTooltips && hasShopButton && !hasSeenShop && (0, $jLk8j.isMobileWidth)(),
                        children: "New Shop"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $bc64c420fc51925d$export$c4a068d767524312,
                inert: !isExpanded ? "" : undefined,
                children: [
                    hasInventoryButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "inventory",
                        title: isInventoryOpen ? "Close Inventory" : "Open Inventory",
                        ariaLabel: isInventoryOpen ? "Close Inventory" : "Open Inventory",
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6,
                        onClick: ()=>{
                            dispatch((0, $baXkz.toggleInventory)());
                            dispatch((0, $baXkz.setIsExitLocationModalOpen)(false));
                            dispatch((0, $baXkz.setIsLeaderboardOpen)(false));
                            (0, $i7H0N.sendEvent)(isInventoryOpen ? "close_inventory" : "open_inventory");
                        }
                    }),
                    isInLocation && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "profile",
                        title: isProfileOpen ? "Close Profile" : "Open Profile",
                        ariaLabel: isProfileOpen ? "Close Profile" : "Open Profile",
                        onClick: ()=>{
                            isProfileOpen ? dispatch((0, $baXkz.closeProfile)()) : dispatch((0, $baXkz.openProfile)());
                        // Removing due to duplicate events. Already sending open_profile and close_profile
                        // isProfileOpen
                        //     ? sendEvent('close_profile_from_main_menu')
                        //     : sendEvent('open_profile_from_main_menu');
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6
                    }),
                    hasShopButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: theme.customJSON.shop?.shopButtonIcon ?? "shop",
                        title: isShopOpen ? "Close Shop" : "Open Shop",
                        ariaLabel: isShopOpen ? "Close Shop" : "Open Shop",
                        onClick: ()=>{
                            dispatch((0, $baXkz.toggleShopOpen)());
                            isShopOpen ? (0, $i7H0N.sendEvent)("close_shop_from_main_menu") : (0, $i7H0N.sendEvent)("open_shop_from_main_menu");
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6,
                        hasDot: shouldShowShopTooltips && !hasSeenShop && isExpanded
                    }),
                    canShowExitModal && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "world",
                        title: (0, $1URoE.exitModalText),
                        ariaLabel: (0, $1URoE.exitModalText),
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6,
                        onClick: ()=>{
                            if (!isExitLocationModalOpen) {
                                dispatch((0, $baXkz.setIsExitLocationModalOpen)(true));
                                dispatch((0, $baXkz.setIsLeaderboardOpen)(false));
                                (0, $i7H0N.sendEvent)("open_exit_modal");
                            } else dispatch((0, $baXkz.setIsExitLocationModalOpen)(false));
                        }
                    }),
                    hasSettingsButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "settings",
                        title: isSettingsMenuShowing ? "Close Settings" : "Open Settings",
                        ariaLabel: isSettingsMenuShowing ? "Close Settings" : "Open Settings",
                        onClick: ()=>{
                            dispatch((0, $baXkz.toggleShowingSettingsMenu)());
                            isSettingsMenuShowing || (0, $i7H0N.sendEvent)("open_settings");
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6
                    }),
                    hasInformationDrawer && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "info",
                        title: isInformationOpen ? "Close Information" : "Open Information",
                        ariaLabel: isInformationOpen ? "Close Information" : "Open Information",
                        onClick: ()=>{
                            dispatch((0, $baXkz.setIsInformationOpen)(!isInformationOpen));
                        // isInformationOpen ? '' : sendEvent('open_information');
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6
                    }),
                    hasLeaderboard && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        buttonStyle: "round",
                        iconType: "leaderboard",
                        title: isLeaderboardOpen ? "Close Leaderboard" : "Open Leaderboard",
                        ariaLabel: isLeaderboardOpen ? "Close Leaderboard" : "Open Leaderboard",
                        onClick: ()=>{
                            dispatch((0, $baXkz.setIsLeaderboardOpen)(!isLeaderboardOpen));
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6
                    }),
                    hasDebugMenu && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        ariaLabel: "debug",
                        buttonStyle: "round",
                        iconType: "help",
                        onClick: ()=>{
                            dispatch((0, $baXkz.toggleDebugMenu)());
                        },
                        className: $bc64c420fc51925d$export$2ba01fb71ed41cb6
                    })
                ]
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $2PPWI = parcelRequire("2PPWI");

var $cEIti = parcelRequire("cEIti");
var $7fa23baf7e20e791$export$d9c2d067feb61447;
var $7fa23baf7e20e791$export$17fa98cb055e8fa7;
var $7fa23baf7e20e791$export$a5833c2b43ca4340;
var $7fa23baf7e20e791$export$47511f9a6581d1d6;
var $7fa23baf7e20e791$export$dd1c05b92185401c;
var $7fa23baf7e20e791$export$8b28cf6cd00fe080;
var $7fa23baf7e20e791$export$186c650311ff0789;
var $7fa23baf7e20e791$export$6746fe0d9c9fab54;
var $7fa23baf7e20e791$export$2bcf359f0c20e94f;
var $7fa23baf7e20e791$export$2903d10d531d0ac0;
$7fa23baf7e20e791$export$d9c2d067feb61447 = `_5b6GcW_ThemedIconButton`;
$7fa23baf7e20e791$export$17fa98cb055e8fa7 = `_5b6GcW_fontSizeH1`;
$7fa23baf7e20e791$export$a5833c2b43ca4340 = `_5b6GcW_fontSizeH2`;
$7fa23baf7e20e791$export$47511f9a6581d1d6 = `_5b6GcW_fontSizeH3`;
$7fa23baf7e20e791$export$dd1c05b92185401c = `_5b6GcW_fontSizeH4`;
$7fa23baf7e20e791$export$8b28cf6cd00fe080 = `_5b6GcW_fontSizeH5`;
$7fa23baf7e20e791$export$186c650311ff0789 = `_5b6GcW_fontSizeH6`;
$7fa23baf7e20e791$export$6746fe0d9c9fab54 = `_5b6GcW_fontSizeSmall`;
$7fa23baf7e20e791$export$2bcf359f0c20e94f = `_5b6GcW_fontSizeTiny`;
$7fa23baf7e20e791$export$2903d10d531d0ac0 = `_5b6GcW_fontSizep`;


function $d9c9da4ee8c17b10$export$2e2bcd8739ae039({ text: text, onClick: onClick, disabled: disabled, icon: icon }) {
    const theme = (0, $cEIti.useTheme)();
    const maskImage = theme.customJSON.themedButtonBackgroundMaskImage;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
        className: $7fa23baf7e20e791$export$d9c2d067feb61447,
        onClick: onClick,
        // style={maskImage ? { maskImage: `url(${maskImage})` } : {}}
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                src: $d9c9da4ee8c17b10$var$iconUrls[icon],
                alt: icon
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                children: text
            })
        ]
    });
}
const $d9c9da4ee8c17b10$var$iconUrls = {
    facebook: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5OC4zNiA5OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPGcgaWQ9ImcyMSI+CiAgICAgIDxnIGlkPSJnMjciPgogICAgICAgIDxwYXRoIGlkPSJwYXRoMjkiIGNsYXNzPSJjbHMtMSIgZD0ibTk4LjM2LDQ5LjE4Qzk4LjM2LDIyLjAyLDc2LjM0LDAsNDkuMTgsMFMwLDIyLjAyLDAsNDkuMThjMCwyMy4wNiwxNS44OCw0Mi40MiwzNy4zLDQ3Ljczdi0zMi43aC0xMC4xNHYtMTUuMDNoMTAuMTR2LTYuNDhjMC0xNi43NCw3LjU4LTI0LjUsMjQuMDEtMjQuNSwzLjEyLDAsOC40OS42MSwxMC42OSwxLjIydjEzLjYyYy0xLjE2LS4xMi0zLjE4LS4xOC01LjY4LS4xOC04LjA2LDAtMTEuMTgsMy4wNS0xMS4xOCwxMXY1LjMxaDE2LjA2bC0yLjc2LDE1LjAzaC0xMy4zdjMzLjc5YzI0LjM1LTIuOTQsNDMuMjItMjMuNjgsNDMuMjItNDguODIiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+",
    twitter: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5Ny45MiA5OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNTguMjgsNDEuNUw5NC43NCwwaC04LjY0bC0zMS42NywzNi4wM0wyOS4xNiwwSDBsMzguMjMsNTQuNDhMMCw5OGg4LjY0bDMzLjQyLTM4LjA1LDI2LjcsMzguMDVoMjkuMTZNMTEuNzUsNi4zOGgxMy4yN2w2MS4wOCw4NS41NmgtMTMuMjciLz4KICA8L2c+Cjwvc3ZnPg==",
    copy: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MC4yMSA5OC40NiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9InN2ZzkiPgogICAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMCw0My45N3YtMTguODdjMC02Ljk1LDIuNDUtMTIuODcsNy4zNC0xNy43NkMxMi4yNCwyLjQ1LDE4LjE2LDAsMjUuMSwwczEyLjg3LDIuNDUsMTcuNzYsNy4zNGM0LjksNC45LDcuMzQsMTAuODIsNy4zNCwxNy43NnYxOC44N2gtMTAuOTh2LTE4Ljg2YzAtMy45My0xLjM3LTcuMjctNC4xMi0xMC4wMi0yLjc1LTIuNzUtNi4wOC00LjEyLTEwLjAxLTQuMTJzLTcuMjYsMS4zNy0xMC4wMSw0LjEyYy0yLjc1LDIuNzUtNC4xMiw2LjA5LTQuMTIsMTAuMDJ2MTguODZIMFptMjAuMDUtMTQuNzFoMTAuMTF2MzkuOTNoLTEwLjExczAtMzkuOTMsMC0zOS45M1pNMCw1NC40OWgxMC45OHYxOC44NmMwLDMuOTMsMS4zNyw3LjI3LDQuMTIsMTAuMDIsMi43NSwyLjc1LDYuMDgsNC4xMiwxMC4wMSw0LjEyLDMuOTIsMCw3LjI2LTEuMzcsMTAuMDEtNC4xMiwyLjc1LTIuNzUsNC4xMi02LjA5LDQuMTItMTAuMDJ2LTE4Ljg2aDEwLjk4djE4Ljg3YzAsNi45NS0yLjQ1LDEyLjg3LTcuMzQsMTcuNzYtNC45LDQuOS0xMC44Miw3LjM0LTE3Ljc2LDcuMzQtNi45NSwwLTEyLjg3LTIuNDUtMTcuNzYtNy4zNC00LjktNC45LTcuMzQtMTAuODItNy4zNC0xNy43NnYtMTguODdaIi8+CiAgPC9nPgo8L3N2Zz4=",
    native: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3Ny4wMSAxMDUuNTEiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgPC9kZWZzPgogIDxnIGlkPSJzdmc5Ij4KICAgIDxwYXRoIGNsYXNzPSJjbHMtMSIgZD0ibTEwLjY4LDEwNS41MWMtMi45NiwwLTUuNDctMS4wNC03LjU2LTMuMTItMi4wOC0yLjA4LTMuMTItNC42LTMuMTItNy41NnYtNDkuNzJjMC0yLjk2LDEuMDQtNS40OCwzLjEyLTcuNTYsMi4wOC0yLjA4LDQuNi0zLjEyLDcuNTYtMy4xMmgxMy4xdjEwLjY4aC0xMy4xdjQ5LjcyaDU1LjY1di00OS43MmgtMTMuMXYtMTAuNjhoMTMuMWMyLjk2LDAsNS40NywxLjA0LDcuNTYsMy4xMiwyLjA4LDIuMDgsMy4xMiw0LjYsMy4xMiw3LjU2djQ5LjcyYzAsMi45Ni0xLjA0LDUuNDctMy4xMiw3LjU2LTIuMDgsMi4wOC00LjYsMy4xMi03LjU2LDMuMTIsMCwwLTU1LjY1LDAtNTUuNjUsMFptMjIuNDktMzNWMjAuNGwtNy41MSw3LjUxLTcuNDctNy41NkwzOC41LDBsMjAuMzIsMjAuMzUtNy40Nyw3LjU2LTcuNTEtNy41MXY1Mi4xMmgtMTAuNjhaIi8+CiAgPC9nPgo8L3N2Zz4="
};



var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");
var $c8bb3ff1d4456f1f$export$dc57ddd528b7443f;
$c8bb3ff1d4456f1f$export$dc57ddd528b7443f = `_84wVWW_buttonContainer`;



var $i7H0N = parcelRequire("i7H0N");

var $764u1 = parcelRequire("764u1");

var $aTRs6 = parcelRequire("aTRs6");

var $aooMk = parcelRequire("aooMk");
function $c28b3bc7c5a3f98b$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { shareModalOpen: shareModalOpen, shareMessage: shareMessage, shareURL: shareURL, shareModalTitle: shareModalTitle } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const i16n_shareModalTitle = (0, $aooMk.useUITranslatedText)("shareModalTitle", shareModalTitle);
    const i16n_share = (0, $aooMk.useUITranslatedText)("share", "Share");
    const i16n_copy = (0, $aooMk.useUITranslatedText)("copy", "Copy");
    const i16n_copied = (0, $aooMk.useUITranslatedText)("copied", "Copied!");
    const [copyText, setCopyText] = (0, $8FY87.useState)(i16n_copy);
    const copyTextTimeout = (0, $8FY87.useRef)(0);
    const url = encodeURIComponent(shareURL);
    const title = encodeURIComponent(shareMessage);
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${title}`;
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
    function open(url) {
        window.open(url, "_blank", "noopener,noreferrer");
    }
    // Track share button click
    function trackShare(target) {
        (0, $i7H0N.sendEventV2)("share", [
            target,
            shareMessage,
            shareURL
        ]);
    }
    (0, $8FY87.useEffect)(()=>{
        if (shareModalOpen) (0, $i7H0N.sendEventV2)("arise_share_modal_open");
    }, [
        shareModalOpen
    ]);
    const isDiscordMobile = (0, $8FY87.useMemo)(()=>{
        try {
            return (0, $aTRs6.IS_DISCORD_ACTIVITY) && (0, $764u1.isDiscordOnMobile)();
        } catch (error) {
            return false;
        }
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        title: i16n_shareModalTitle,
        onClose: ()=>{
            dispatch((0, $baXkz.setShareModalOpen)(false));
        },
        isVisible: shareModalOpen,
        zIndex: 130,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $c8bb3ff1d4456f1f$export$dc57ddd528b7443f,
            children: [
                !isDiscordMobile && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d9c9da4ee8c17b10$export$2e2bcd8739ae039), {
                            text: i16n_share,
                            onClick: ()=>{
                                trackShare("facebook");
                                open(facebookUrl);
                            },
                            disabled: false,
                            icon: "facebook"
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d9c9da4ee8c17b10$export$2e2bcd8739ae039), {
                            text: i16n_share,
                            onClick: ()=>{
                                trackShare("twitter");
                                open(twitterUrl);
                            },
                            disabled: false,
                            icon: "twitter"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d9c9da4ee8c17b10$export$2e2bcd8739ae039), {
                    text: copyText,
                    onClick: ()=>{
                        try {
                            const copyMessage = shareMessage + " \n" + shareURL;
                            navigator.clipboard.writeText(copyMessage);
                            setCopyText(i16n_copied);
                            clearTimeout(copyTextTimeout.current);
                            copyTextTimeout.current = setTimeout(()=>{
                                setCopyText(i16n_copy);
                            }, 2000);
                            trackShare("copy");
                        } catch (error) {
                            console.error("Failed to copy: ", error);
                        }
                    },
                    disabled: false,
                    icon: "copy"
                })
            ]
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");


var $1URoE = parcelRequire("1URoE");

var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");
var $4157d68bc2789d2e$export$f67fb575035cc7d0;
var $4157d68bc2789d2e$export$17fa98cb055e8fa7;
var $4157d68bc2789d2e$export$a5833c2b43ca4340;
var $4157d68bc2789d2e$export$47511f9a6581d1d6;
var $4157d68bc2789d2e$export$dd1c05b92185401c;
var $4157d68bc2789d2e$export$8b28cf6cd00fe080;
var $4157d68bc2789d2e$export$186c650311ff0789;
var $4157d68bc2789d2e$export$6746fe0d9c9fab54;
var $4157d68bc2789d2e$export$2bcf359f0c20e94f;
var $4157d68bc2789d2e$export$2903d10d531d0ac0;
$4157d68bc2789d2e$export$f67fb575035cc7d0 = `WYBeTW_ThemedButton`;
$4157d68bc2789d2e$export$17fa98cb055e8fa7 = `WYBeTW_fontSizeH1`;
$4157d68bc2789d2e$export$a5833c2b43ca4340 = `WYBeTW_fontSizeH2`;
$4157d68bc2789d2e$export$47511f9a6581d1d6 = `WYBeTW_fontSizeH3`;
$4157d68bc2789d2e$export$dd1c05b92185401c = `WYBeTW_fontSizeH4`;
$4157d68bc2789d2e$export$8b28cf6cd00fe080 = `WYBeTW_fontSizeH5`;
$4157d68bc2789d2e$export$186c650311ff0789 = `WYBeTW_fontSizeH6`;
$4157d68bc2789d2e$export$6746fe0d9c9fab54 = `WYBeTW_fontSizeSmall`;
$4157d68bc2789d2e$export$2bcf359f0c20e94f = `WYBeTW_fontSizeTiny`;
$4157d68bc2789d2e$export$2903d10d531d0ac0 = `WYBeTW_fontSizep`;


function $460d17c28e5cd86a$export$2e2bcd8739ae039({ text: text, onClick: onClick, disabled: disabled, className: className }) {
    const theme = (0, $cEIti.useTheme)();
    const maskImage = theme.customJSON.themedButtonBackgroundMaskImage;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($4157d68bc2789d2e$export$f67fb575035cc7d0, className),
        onClick: onClick,
        style: maskImage ? {
            maskImage: `url(${maskImage})`
        } : {},
        disabled: disabled,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            children: text
        })
    });
}
function $460d17c28e5cd86a$export$b0b5aeed52623827({ text: text, href: href, className: className, onClick: onClick }) {
    const theme = (0, $cEIti.useTheme)();
    const maskImage = theme.customJSON.themedButtonBackgroundMaskImage;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("a", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($4157d68bc2789d2e$export$f67fb575035cc7d0, className),
        href: href,
        style: maskImage ? {
            maskImage: `url(${maskImage})`
        } : {},
        onClick: onClick ? onClick : null,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
            children: text
        })
    });
}


function $1b92270b3f8c4d42$export$2e2bcd8739ae039() {
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const isExitLocationModalOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isExitLocationModalOpen);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        title: "Head back?",
        onClose: ()=>{
            dispatch((0, $baXkz.setIsExitLocationModalOpen)(false));
        },
        isVisible: isExitLocationModalOpen,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $460d17c28e5cd86a$export$2e2bcd8739ae039), {
            text: (0, $1URoE.exitModalText),
            onClick: ()=>{
                dispatch((0, $baXkz.setIsExitLocationModalOpen)(false));
                dispatch((0, $baXkz.setShouldShowGuestSignUpModal)(true));
                navigate((0, $1URoE.homePath));
                audio.play("slam");
                audio.play("wipe-dark1");
            },
            disabled: !isExitLocationModalOpen
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $cEIti = parcelRequire("cEIti");

var $baXkz = parcelRequire("baXkz");

var $f9aoP = parcelRequire("f9aoP");

var $fL4mk = parcelRequire("fL4mk");

var $i7H0N = parcelRequire("i7H0N");






var $4MZsN = parcelRequire("4MZsN");
var $eb87b6ec41afcd6a$exports = {};

$parcel$export($eb87b6ec41afcd6a$exports, "AllTime", function () { return $eb87b6ec41afcd6a$export$afb21cac88b83ebe; }, function (v) { return $eb87b6ec41afcd6a$export$afb21cac88b83ebe = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "Modal", function () { return $eb87b6ec41afcd6a$export$2b77a92f1a5ad772; }, function (v) { return $eb87b6ec41afcd6a$export$2b77a92f1a5ad772 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "SupplyRunLeaderboardTable", function () { return $eb87b6ec41afcd6a$export$44eb8dea7b6c249e; }, function (v) { return $eb87b6ec41afcd6a$export$44eb8dea7b6c249e = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "Today", function () { return $eb87b6ec41afcd6a$export$470b080ecc05864e; }, function (v) { return $eb87b6ec41afcd6a$export$470b080ecc05864e = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "avatar", function () { return $eb87b6ec41afcd6a$export$345c5736c8054f22; }, function (v) { return $eb87b6ec41afcd6a$export$345c5736c8054f22 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "empty", function () { return $eb87b6ec41afcd6a$export$6e22c362a0406a2c; }, function (v) { return $eb87b6ec41afcd6a$export$6e22c362a0406a2c = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "first", function () { return $eb87b6ec41afcd6a$export$43128fadae87b74a; }, function (v) { return $eb87b6ec41afcd6a$export$43128fadae87b74a = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH1", function () { return $eb87b6ec41afcd6a$export$17fa98cb055e8fa7; }, function (v) { return $eb87b6ec41afcd6a$export$17fa98cb055e8fa7 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH2", function () { return $eb87b6ec41afcd6a$export$a5833c2b43ca4340; }, function (v) { return $eb87b6ec41afcd6a$export$a5833c2b43ca4340 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH3", function () { return $eb87b6ec41afcd6a$export$47511f9a6581d1d6; }, function (v) { return $eb87b6ec41afcd6a$export$47511f9a6581d1d6 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH4", function () { return $eb87b6ec41afcd6a$export$dd1c05b92185401c; }, function (v) { return $eb87b6ec41afcd6a$export$dd1c05b92185401c = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH5", function () { return $eb87b6ec41afcd6a$export$8b28cf6cd00fe080; }, function (v) { return $eb87b6ec41afcd6a$export$8b28cf6cd00fe080 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeH6", function () { return $eb87b6ec41afcd6a$export$186c650311ff0789; }, function (v) { return $eb87b6ec41afcd6a$export$186c650311ff0789 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeSmall", function () { return $eb87b6ec41afcd6a$export$6746fe0d9c9fab54; }, function (v) { return $eb87b6ec41afcd6a$export$6746fe0d9c9fab54 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizeTiny", function () { return $eb87b6ec41afcd6a$export$2bcf359f0c20e94f; }, function (v) { return $eb87b6ec41afcd6a$export$2bcf359f0c20e94f = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "fontSizep", function () { return $eb87b6ec41afcd6a$export$2903d10d531d0ac0; }, function (v) { return $eb87b6ec41afcd6a$export$2903d10d531d0ac0 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "isCurrent", function () { return $eb87b6ec41afcd6a$export$bfddba54107e991b; }, function (v) { return $eb87b6ec41afcd6a$export$bfddba54107e991b = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "isLong", function () { return $eb87b6ec41afcd6a$export$d8c61589c31c4718; }, function (v) { return $eb87b6ec41afcd6a$export$d8c61589c31c4718 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "position", function () { return $eb87b6ec41afcd6a$export$5880b8b5730aff45; }, function (v) { return $eb87b6ec41afcd6a$export$5880b8b5730aff45 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "positionTitle", function () { return $eb87b6ec41afcd6a$export$d5cbc3ca84fde83d; }, function (v) { return $eb87b6ec41afcd6a$export$d5cbc3ca84fde83d = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "profile", function () { return $eb87b6ec41afcd6a$export$4882ae973e0491e; }, function (v) { return $eb87b6ec41afcd6a$export$4882ae973e0491e = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "stats", function () { return $eb87b6ec41afcd6a$export$7804429c45dff272; }, function (v) { return $eb87b6ec41afcd6a$export$7804429c45dff272 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "tabButtons", function () { return $eb87b6ec41afcd6a$export$d167761217acc355; }, function (v) { return $eb87b6ec41afcd6a$export$d167761217acc355 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "user", function () { return $eb87b6ec41afcd6a$export$ddb906a32562356c; }, function (v) { return $eb87b6ec41afcd6a$export$ddb906a32562356c = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "userStats", function () { return $eb87b6ec41afcd6a$export$c9e8eab29ec2f182; }, function (v) { return $eb87b6ec41afcd6a$export$c9e8eab29ec2f182 = v; });
$parcel$export($eb87b6ec41afcd6a$exports, "userTitle", function () { return $eb87b6ec41afcd6a$export$6c3180b0bb3c4aaa; }, function (v) { return $eb87b6ec41afcd6a$export$6c3180b0bb3c4aaa = v; });
var $eb87b6ec41afcd6a$export$afb21cac88b83ebe;
var $eb87b6ec41afcd6a$export$2b77a92f1a5ad772;
var $eb87b6ec41afcd6a$export$44eb8dea7b6c249e;
var $eb87b6ec41afcd6a$export$470b080ecc05864e;
var $eb87b6ec41afcd6a$export$345c5736c8054f22;
var $eb87b6ec41afcd6a$export$6e22c362a0406a2c;
var $eb87b6ec41afcd6a$export$43128fadae87b74a;
var $eb87b6ec41afcd6a$export$17fa98cb055e8fa7;
var $eb87b6ec41afcd6a$export$a5833c2b43ca4340;
var $eb87b6ec41afcd6a$export$47511f9a6581d1d6;
var $eb87b6ec41afcd6a$export$dd1c05b92185401c;
var $eb87b6ec41afcd6a$export$8b28cf6cd00fe080;
var $eb87b6ec41afcd6a$export$186c650311ff0789;
var $eb87b6ec41afcd6a$export$6746fe0d9c9fab54;
var $eb87b6ec41afcd6a$export$2bcf359f0c20e94f;
var $eb87b6ec41afcd6a$export$2903d10d531d0ac0;
var $eb87b6ec41afcd6a$export$bfddba54107e991b;
var $eb87b6ec41afcd6a$export$d8c61589c31c4718;
var $eb87b6ec41afcd6a$export$5880b8b5730aff45;
var $eb87b6ec41afcd6a$export$d5cbc3ca84fde83d;
var $eb87b6ec41afcd6a$export$4882ae973e0491e;
var $eb87b6ec41afcd6a$export$7804429c45dff272;
var $eb87b6ec41afcd6a$export$d167761217acc355;
var $eb87b6ec41afcd6a$export$ddb906a32562356c;
var $eb87b6ec41afcd6a$export$c9e8eab29ec2f182;
var $eb87b6ec41afcd6a$export$6c3180b0bb3c4aaa;
$eb87b6ec41afcd6a$export$afb21cac88b83ebe = `ax7aha_AllTime`;
$eb87b6ec41afcd6a$export$2b77a92f1a5ad772 = `ax7aha_Modal`;
$eb87b6ec41afcd6a$export$44eb8dea7b6c249e = `ax7aha_SupplyRunLeaderboardTable`;
$eb87b6ec41afcd6a$export$470b080ecc05864e = `ax7aha_Today`;
$eb87b6ec41afcd6a$export$345c5736c8054f22 = `ax7aha_avatar`;
$eb87b6ec41afcd6a$export$6e22c362a0406a2c = `ax7aha_empty`;
$eb87b6ec41afcd6a$export$43128fadae87b74a = `ax7aha_first`;
$eb87b6ec41afcd6a$export$17fa98cb055e8fa7 = `ax7aha_fontSizeH1`;
$eb87b6ec41afcd6a$export$a5833c2b43ca4340 = `ax7aha_fontSizeH2`;
$eb87b6ec41afcd6a$export$47511f9a6581d1d6 = `ax7aha_fontSizeH3`;
$eb87b6ec41afcd6a$export$dd1c05b92185401c = `ax7aha_fontSizeH4`;
$eb87b6ec41afcd6a$export$8b28cf6cd00fe080 = `ax7aha_fontSizeH5`;
$eb87b6ec41afcd6a$export$186c650311ff0789 = `ax7aha_fontSizeH6`;
$eb87b6ec41afcd6a$export$6746fe0d9c9fab54 = `ax7aha_fontSizeSmall`;
$eb87b6ec41afcd6a$export$2bcf359f0c20e94f = `ax7aha_fontSizeTiny`;
$eb87b6ec41afcd6a$export$2903d10d531d0ac0 = `ax7aha_fontSizep`;
$eb87b6ec41afcd6a$export$bfddba54107e991b = `ax7aha_isCurrent`;
$eb87b6ec41afcd6a$export$d8c61589c31c4718 = `ax7aha_isLong`;
$eb87b6ec41afcd6a$export$5880b8b5730aff45 = `ax7aha_position`;
$eb87b6ec41afcd6a$export$d5cbc3ca84fde83d = `ax7aha_positionTitle`;
$eb87b6ec41afcd6a$export$4882ae973e0491e = `ax7aha_profile`;
$eb87b6ec41afcd6a$export$7804429c45dff272 = `ax7aha_stats`;
$eb87b6ec41afcd6a$export$d167761217acc355 = `ax7aha_tabButtons`;
$eb87b6ec41afcd6a$export$ddb906a32562356c = `ax7aha_user`;
$eb87b6ec41afcd6a$export$c9e8eab29ec2f182 = `ax7aha_userStats`;
$eb87b6ec41afcd6a$export$6c3180b0bb3c4aaa = `ax7aha_userTitle`;


function $416c8a6c2bbe3c1f$export$2e2bcd8739ae039() {
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const isLeaderboardOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isLeaderboardOpen);
    const [leaderboardData, setLeaderboardData] = (0, $8FY87.useState)(null);
    const [isError, setIsError] = (0, $8FY87.useState)(false);
    async function getLeaderboardData() {
        try {
            const response = await (0, $f9aoP.getSupplyRunLeaderboardData)();
            setLeaderboardData(response);
        } catch (error) {
            console.warn("Could not get supply run data:", error);
            setIsError(true);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        if (isLeaderboardOpen) {
            getLeaderboardData();
            (0, $baXkz.setIsExitLocationModalOpen)(false);
            (0, $baXkz.setIsInventoryOpen)(false);
            (0, $i7H0N.sendEvent)("open_leaderboard");
        } else setTimeout(()=>{
            // Timeout to allow modal to move off screen
            setLeaderboardData(null);
            setIsError(false);
        }, 500);
    }, [
        isLeaderboardOpen
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        modalClassname: $eb87b6ec41afcd6a$exports.Modal,
        title: "Supply Run Leaderboard",
        isVisible: isLeaderboardOpen,
        onClose: ()=>{
            dispatch((0, $baXkz.setIsLeaderboardOpen)(false));
        },
        canScroll: true,
        isLoading: !leaderboardData && !isError,
        backgroundImageOverride: theme.customJSON.leaderboardBackgroundImageUrl,
        children: [
            isError && /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                children: "Something went wrong, please try again later."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)($416c8a6c2bbe3c1f$var$Leaderboard, {
                data: leaderboardData
            })
        ]
    });
}
const $416c8a6c2bbe3c1f$var$processUsers = (users)=>{
    const MAX_ENTRIES_PER_TABLE = 20;
    const sliced = users.slice(0, MAX_ENTRIES_PER_TABLE);
    const processed = sliced.map((user)=>{
        return {
            ...user,
            profile: (0, $fL4mk.processProfileData)(user.profile)
        };
    });
    return processed;
};
const $416c8a6c2bbe3c1f$var$ResultsTable = ({ title: title, users: users })=>{
    const dispatch = (0, $6lYLL.useAppDispatch)();
    if (!users?.length) return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $eb87b6ec41afcd6a$exports.empty,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                        type: "supplies"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                        children: "No supplies yet!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {})
        ]
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    className: $eb87b6ec41afcd6a$exports.positionTitle,
                                    children: "#"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    className: $eb87b6ec41afcd6a$exports.userTitle,
                                    children: "User"
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                    children: "Supplies"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("tbody", {
                        children: $416c8a6c2bbe3c1f$var$processUsers(users).map((user, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                    [$eb87b6ec41afcd6a$exports.first]: index === 0
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                        className: $eb87b6ec41afcd6a$exports.position,
                                        children: user.position
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            className: $eb87b6ec41afcd6a$exports.user,
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                                                    classname: $eb87b6ec41afcd6a$exports.avatar,
                                                    backgroundImagePath: user.profile.background?.thumbnailPath,
                                                    characterImagePath: user.profile.character?.thumbnailPath,
                                                    frameImagePath: user.profile.avatarFrame?.imagePath,
                                                    onClick: ()=>dispatch((0, $baXkz.openProfile)(user.profile)),
                                                    title: `View ${user.profile.displayName}'s Profile`
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d758aa58b83e8f34$export$2e2bcd8739ae039), {
                                                    profile: user.profile,
                                                    shouldLinkToProfile: true,
                                                    classname: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                                        [$eb87b6ec41afcd6a$exports.isLong]: user.profile.displayName.length > 12
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                        children: (0, $aed6ee8c7b23660f$export$a6283a56ed31c98a)(user.score, "N/A")
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
const $416c8a6c2bbe3c1f$var$Leaderboard = ({ data: data })=>{
    let TabType;
    (function(TabType) {
        TabType["Today"] = "Today";
        TabType["AllTime"] = "AllTime";
    })(TabType || (TabType = {}));
    const [currentTab, setCurrentTab] = (0, $8FY87.useState)("Today");
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    if (!data) return null;
    const { globalLeaderboard: globalLeaderboard, userStats: userStats } = data;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($eb87b6ec41afcd6a$exports.SupplyRunLeaderboardTable, $eb87b6ec41afcd6a$exports[currentTab]),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $eb87b6ec41afcd6a$exports.tabButtons,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: ()=>{
                            setCurrentTab("Today");
                            (0, $i7H0N.sendEvent)("leaderboard_tab_click", {
                                tab: "Today"
                            });
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                            [$eb87b6ec41afcd6a$exports.isCurrent]: currentTab === "Today"
                        }),
                        disabled: currentTab === "Today",
                        children: "Today"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                        onClick: ()=>{
                            setCurrentTab("AllTime");
                            (0, $i7H0N.sendEvent)("leaderboard_tab_click", {
                                tab: "AllTime"
                            });
                        },
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                            [$eb87b6ec41afcd6a$exports.isCurrent]: currentTab === "AllTime"
                        }),
                        disabled: currentTab === "AllTime",
                        children: "All Time"
                    })
                ]
            }),
            userStats && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $eb87b6ec41afcd6a$exports.userStats,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $eb87b6ec41afcd6a$exports.profile,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $202cb0ceec6045cf$export$2e2bcd8739ae039), {
                                classname: $eb87b6ec41afcd6a$exports.avatar,
                                backgroundImagePath: currentUserProfile.background?.thumbnailPath,
                                characterImagePath: currentUserProfile.character?.thumbnailPath,
                                frameImagePath: currentUserProfile.avatarFrame?.imagePath,
                                onClick: ()=>dispatch((0, $baXkz.openProfile)(currentUserProfile))
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d758aa58b83e8f34$export$2e2bcd8739ae039), {
                                profile: currentUserProfile,
                                shouldLinkToProfile: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                        className: $eb87b6ec41afcd6a$exports.stats,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $86b59be89ea19d3d$export$6e5fab54fd9c478), {
                                    iconType: "supplies",
                                    title: currentTab === "Today" ? "Supplies Today:" : "All Time Supplies:",
                                    value: currentTab === "Today" ? (0, $aed6ee8c7b23660f$export$a6283a56ed31c98a)(userStats.totalAccumulatedThisPeriod?.score, 0) : (0, $aed6ee8c7b23660f$export$a6283a56ed31c98a)(userStats.totalAccumulated?.score, 0)
                                })
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $86b59be89ea19d3d$export$6e5fab54fd9c478), {
                                    iconType: "bolt",
                                    title: currentTab === "Today" ? "Leaderboard Today:" : "All Time Leaderboard:",
                                    value: currentTab === "Today" ? (0, $aed6ee8c7b23660f$export$9173b52dfbd534b4)(userStats.totalAccumulatedThisPeriod?.position) : (0, $aed6ee8c7b23660f$export$9173b52dfbd534b4)(userStats.totalAccumulated?.position)
                                })
                            })
                        ]
                    })
                ]
            }),
            currentTab === "Today" && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)($416c8a6c2bbe3c1f$var$ResultsTable, {
                        title: "Today's Top Suppliers",
                        users: globalLeaderboard.totalAccumulatedThisPeriod
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($416c8a6c2bbe3c1f$var$ResultsTable, {
                        title: "Today's Best Single Run",
                        users: globalLeaderboard.highestSingleRunThisPeriod
                    })
                ]
            }),
            currentTab === "AllTime" && /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)($416c8a6c2bbe3c1f$var$ResultsTable, {
                        title: "All Time Top Suppliers",
                        users: globalLeaderboard.totalAccumulated
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)($416c8a6c2bbe3c1f$var$ResultsTable, {
                        title: "All Time Best Single Run",
                        users: globalLeaderboard.highestSingleRun
                    })
                ]
            })
        ]
    });
};



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $6lYLL = parcelRequire("6lYLL");

var $aTRs6 = parcelRequire("aTRs6");

var $baXkz = parcelRequire("baXkz");



var $i7H0N = parcelRequire("i7H0N");

var $f9aoP = parcelRequire("f9aoP");
var $1ca928792b739323$export$6d8fd250b3594944;
var $1ca928792b739323$export$a7db06668cad9adb;
var $1ca928792b739323$export$17fa98cb055e8fa7;
var $1ca928792b739323$export$a5833c2b43ca4340;
var $1ca928792b739323$export$47511f9a6581d1d6;
var $1ca928792b739323$export$dd1c05b92185401c;
var $1ca928792b739323$export$8b28cf6cd00fe080;
var $1ca928792b739323$export$186c650311ff0789;
var $1ca928792b739323$export$6746fe0d9c9fab54;
var $1ca928792b739323$export$2bcf359f0c20e94f;
var $1ca928792b739323$export$2903d10d531d0ac0;
$1ca928792b739323$export$6d8fd250b3594944 = `_6Iveqa_NewsModal`;
$1ca928792b739323$export$a7db06668cad9adb = `_6Iveqa_content`;
$1ca928792b739323$export$17fa98cb055e8fa7 = `_6Iveqa_fontSizeH1`;
$1ca928792b739323$export$a5833c2b43ca4340 = `_6Iveqa_fontSizeH2`;
$1ca928792b739323$export$47511f9a6581d1d6 = `_6Iveqa_fontSizeH3`;
$1ca928792b739323$export$dd1c05b92185401c = `_6Iveqa_fontSizeH4`;
$1ca928792b739323$export$8b28cf6cd00fe080 = `_6Iveqa_fontSizeH5`;
$1ca928792b739323$export$186c650311ff0789 = `_6Iveqa_fontSizeH6`;
$1ca928792b739323$export$6746fe0d9c9fab54 = `_6Iveqa_fontSizeSmall`;
$1ca928792b739323$export$2bcf359f0c20e94f = `_6Iveqa_fontSizeTiny`;
$1ca928792b739323$export$2903d10d531d0ac0 = `_6Iveqa_fontSizep`;


function $a111644098382f12$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const newsModalLastVersionSeen = (0, $6lYLL.useAppSelector)((state)=>state.app.newsModalLastVersionSeen);
    const [isOpen, setIsOpen] = (0, $8FY87.useState)(false);
    const [modalData, setModalData] = (0, $8FY87.useState)();
    const [currentModal, setCurrentModal] = (0, $8FY87.useState)();
    async function getData() {
        try {
            const response = await (0, $f9aoP.getNewsModal)();
            setModalData(response);
        } catch (error) {
            console.warn("Could not get News Modal data:", error);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        getData();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!modalData?.length) return;
        checkIfModalAvailableAndShow();
        // Check every 10 seconds if we should show a new modal
        const interval = setInterval(()=>{
            checkIfModalAvailableAndShow();
        }, 10000);
        return ()=>clearInterval(interval);
    }, [
        modalData,
        newsModalLastVersionSeen
    ]);
    const checkIfModalAvailableAndShow = ()=>{
        // Only show user each modal once
        const currentModal = $a111644098382f12$var$getCurrentModal(modalData);
        const lastVersionSeen = newsModalLastVersionSeen || window.localStorage.getItem((0, $aTRs6.LS_NEWSMODAL_LAST_VERSION_SEEN_KEY));
        if (currentModal && currentModal.id !== lastVersionSeen) {
            setCurrentModal(currentModal);
            setIsOpen(true);
            window.localStorage.setItem((0, $aTRs6.LS_NEWSMODAL_LAST_VERSION_SEEN_KEY), currentModal.id);
            dispatch((0, $baXkz.setNewsModalLastVersionSeen)(currentModal.id));
            (0, $i7H0N.sendEvent)("newsmodal_shown", {
                version: currentModal.id
            });
        }
    };
    if (!currentModal?.markdown) return;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        zIndex: 1000,
        modalClassname: $1ca928792b739323$export$6d8fd250b3594944,
        onClose: ()=>{
            setIsOpen(false);
            (0, $i7H0N.sendEvent)("newsmodal_closed", {
                version: currentModal.id
            });
        },
        isVisible: isOpen,
        canScroll: true,
        leaveSpaceAboveAndBelow: false,
        contentClassname: $1ca928792b739323$export$a7db06668cad9adb,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $17855786516ea933$export$2e2bcd8739ae039), {
            base64MarkdownContent: currentModal.markdown,
            textAlign: "center"
        })
    });
}
// Modals are ordered in reverse chronological order (e.g. 2025 before 2024).
const $a111644098382f12$var$getCurrentModal = (modalData)=>{
    // Remove modals which are in the future
    const pastModals = modalData?.filter((modal)=>new Date(modal.startsDate) < new Date());
    // Next modal in array must be most recent one in the past
    return pastModals?.[pastModals?.length - 1];
};



var $2PPWI = parcelRequire("2PPWI");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $cEIti = parcelRequire("cEIti");

var $i7H0N = parcelRequire("i7H0N");




var $1URoE = parcelRequire("1URoE");


var $3f613f59ad7a6a8d$export$e8f55753cd691b20;
var $3f613f59ad7a6a8d$export$17fa98cb055e8fa7;
var $3f613f59ad7a6a8d$export$a5833c2b43ca4340;
var $3f613f59ad7a6a8d$export$47511f9a6581d1d6;
var $3f613f59ad7a6a8d$export$dd1c05b92185401c;
var $3f613f59ad7a6a8d$export$8b28cf6cd00fe080;
var $3f613f59ad7a6a8d$export$186c650311ff0789;
var $3f613f59ad7a6a8d$export$6746fe0d9c9fab54;
var $3f613f59ad7a6a8d$export$2bcf359f0c20e94f;
var $3f613f59ad7a6a8d$export$2903d10d531d0ac0;
var $3f613f59ad7a6a8d$export$e21c3a5f86411451;
$3f613f59ad7a6a8d$export$e8f55753cd691b20 = `_2TGWPa_GuestSignUpModal`;
$3f613f59ad7a6a8d$export$17fa98cb055e8fa7 = `_2TGWPa_fontSizeH1`;
$3f613f59ad7a6a8d$export$a5833c2b43ca4340 = `_2TGWPa_fontSizeH2`;
$3f613f59ad7a6a8d$export$47511f9a6581d1d6 = `_2TGWPa_fontSizeH3`;
$3f613f59ad7a6a8d$export$dd1c05b92185401c = `_2TGWPa_fontSizeH4`;
$3f613f59ad7a6a8d$export$8b28cf6cd00fe080 = `_2TGWPa_fontSizeH5`;
$3f613f59ad7a6a8d$export$186c650311ff0789 = `_2TGWPa_fontSizeH6`;
$3f613f59ad7a6a8d$export$6746fe0d9c9fab54 = `_2TGWPa_fontSizeSmall`;
$3f613f59ad7a6a8d$export$2bcf359f0c20e94f = `_2TGWPa_fontSizeTiny`;
$3f613f59ad7a6a8d$export$2903d10d531d0ac0 = `_2TGWPa_fontSizep`;
$3f613f59ad7a6a8d$export$e21c3a5f86411451 = `_2TGWPa_joinButton`;


function $594d75f980968ad1$export$2e2bcd8739ae039() {
    const isGuest = (0, $bcb49290e039a826$export$c3ab02d49994a165)();
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const hasData = theme.metadata?.guestModalMarkdown;
    const guestModalCount = (0, $6lYLL.useAppSelector)((state)=>state.app.guestModalCount);
    const shouldShowGuestSignUpModal = (0, $6lYLL.useAppSelector)((state)=>state.app.shouldShowGuestSignUpModal);
    if (!isGuest || !hasData || !(0, $1URoE.isHomePath)()) return;
    // Only show modal every other time it is requested by app
    const shouldShow = shouldShowGuestSignUpModal && guestModalCount % 2 !== 0;
    if (shouldShow) (0, $i7H0N.sendEvent)("view_guest_signup_modal");
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        modalClassname: $3f613f59ad7a6a8d$export$e8f55753cd691b20,
        zIndex: 1000,
        onClose: ()=>{
            dispatch((0, $baXkz.setShouldShowGuestSignUpModal)(false));
            (0, $i7H0N.sendEvent)("close_guest_signup_modal");
        },
        isVisible: shouldShow,
        canScroll: true,
        leaveSpaceAboveAndBelow: false,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $17855786516ea933$export$2e2bcd8739ae039), {
                base64MarkdownContent: theme.metadata?.guestModalMarkdown
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $460d17c28e5cd86a$export$2e2bcd8739ae039), {
                className: $3f613f59ad7a6a8d$export$e21c3a5f86411451,
                onClick: ()=>{
                    (0, $i7H0N.sendEvent)("signup_guest_signup_modal");
                    navigateToSignup();
                },
                text: "Sign Up"
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $8FY87 = parcelRequire("8FY87");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $d5e694cf5f7e70cc$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $d5e694cf5f7e70cc$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $d5e694cf5f7e70cc$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $d5e694cf5f7e70cc$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $d5e694cf5f7e70cc$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $d5e694cf5f7e70cc$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $d5e694cf5f7e70cc$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $d5e694cf5f7e70cc$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $d5e694cf5f7e70cc$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $d5e694cf5f7e70cc$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $d5e694cf5f7e70cc$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $d5e694cf5f7e70cc$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $d5e694cf5f7e70cc$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $d5e694cf5f7e70cc$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $d5e694cf5f7e70cc$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $d5e694cf5f7e70cc$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $d5e694cf5f7e70cc$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $d5e694cf5f7e70cc$var$animations = {
    easeOut: $d5e694cf5f7e70cc$var$easeOut,
    linear: $d5e694cf5f7e70cc$var$linear,
    easeInQuad: $d5e694cf5f7e70cc$var$easeInQuad,
    easeOutQuad: $d5e694cf5f7e70cc$var$easeOutQuad,
    easeInOutQuad: $d5e694cf5f7e70cc$var$easeInOutQuad,
    easeInCubic: $d5e694cf5f7e70cc$var$easeInCubic,
    easeOutCubic: $d5e694cf5f7e70cc$var$easeOutCubic,
    easeInOutCubic: $d5e694cf5f7e70cc$var$easeInOutCubic,
    easeInQuart: $d5e694cf5f7e70cc$var$easeInQuart,
    easeOutQuart: $d5e694cf5f7e70cc$var$easeOutQuart,
    easeInOutQuart: $d5e694cf5f7e70cc$var$easeInOutQuart,
    easeInQuint: $d5e694cf5f7e70cc$var$easeInQuint,
    easeOutQuint: $d5e694cf5f7e70cc$var$easeOutQuint,
    easeInOutQuint: $d5e694cf5f7e70cc$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $d5e694cf5f7e70cc$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $d5e694cf5f7e70cc$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $d5e694cf5f7e70cc$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $d5e694cf5f7e70cc$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $d5e694cf5f7e70cc$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $d5e694cf5f7e70cc$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $d5e694cf5f7e70cc$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $d5e694cf5f7e70cc$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $d5e694cf5f7e70cc$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $d5e694cf5f7e70cc$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $d5e694cf5f7e70cc$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $d5e694cf5f7e70cc$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $d5e694cf5f7e70cc$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $d5e694cf5f7e70cc$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $d5e694cf5f7e70cc$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $d5e694cf5f7e70cc$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $d5e694cf5f7e70cc$var$roundNumber(value, 2);
    if (value < minBound) return $d5e694cf5f7e70cc$var$roundNumber(minBound, 2);
    if (value > maxBound) return $d5e694cf5f7e70cc$var$roundNumber(maxBound, 2);
    return $d5e694cf5f7e70cc$var$roundNumber(value, 2);
};
var $d5e694cf5f7e70cc$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $d5e694cf5f7e70cc$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $d5e694cf5f7e70cc$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $d5e694cf5f7e70cc$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $d5e694cf5f7e70cc$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $d5e694cf5f7e70cc$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $d5e694cf5f7e70cc$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $d5e694cf5f7e70cc$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $d5e694cf5f7e70cc$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $d5e694cf5f7e70cc$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $d5e694cf5f7e70cc$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $d5e694cf5f7e70cc$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $d5e694cf5f7e70cc$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $d5e694cf5f7e70cc$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $d5e694cf5f7e70cc$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $d5e694cf5f7e70cc$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $d5e694cf5f7e70cc$var$getPaddingValue = function(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $d5e694cf5f7e70cc$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $d5e694cf5f7e70cc$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $d5e694cf5f7e70cc$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $d5e694cf5f7e70cc$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $d5e694cf5f7e70cc$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $d5e694cf5f7e70cc$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $d5e694cf5f7e70cc$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $d5e694cf5f7e70cc$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $d5e694cf5f7e70cc$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $d5e694cf5f7e70cc$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $d5e694cf5f7e70cc$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $d5e694cf5f7e70cc$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $d5e694cf5f7e70cc$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $d5e694cf5f7e70cc$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $d5e694cf5f7e70cc$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $d5e694cf5f7e70cc$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $d5e694cf5f7e70cc$var$handleCancelAnimation(contextInstance);
    $d5e694cf5f7e70cc$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $d5e694cf5f7e70cc$var$handleTouchPanningSetup(contextInstance, event);
    else $d5e694cf5f7e70cc$var$handlePanningSetup(contextInstance, event);
}
function $d5e694cf5f7e70cc$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $d5e694cf5f7e70cc$var$handlePanToBounds(contextInstance);
    if (targetState) $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $d5e694cf5f7e70cc$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $d5e694cf5f7e70cc$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeY);
    $d5e694cf5f7e70cc$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $d5e694cf5f7e70cc$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $d5e694cf5f7e70cc$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $d5e694cf5f7e70cc$var$handleVelocityPanning(contextInstance);
        else $d5e694cf5f7e70cc$var$handleAlignToBounds(contextInstance);
    }
}
function $d5e694cf5f7e70cc$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $d5e694cf5f7e70cc$var$checkZoomBounds($d5e694cf5f7e70cc$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $d5e694cf5f7e70cc$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $d5e694cf5f7e70cc$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $d5e694cf5f7e70cc$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $d5e694cf5f7e70cc$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $d5e694cf5f7e70cc$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $d5e694cf5f7e70cc$var$__assign = function() {
    $d5e694cf5f7e70cc$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d5e694cf5f7e70cc$var$__assign.apply(this, arguments);
};
function $d5e694cf5f7e70cc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d5e694cf5f7e70cc$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $d5e694cf5f7e70cc$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $d5e694cf5f7e70cc$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        wheelPanning: false,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $d5e694cf5f7e70cc$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $d5e694cf5f7e70cc$var$createState = function(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $d5e694cf5f7e70cc$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $d5e694cf5f7e70cc$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $d5e694cf5f7e70cc$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $d5e694cf5f7e70cc$var$initialState.positionY
    };
};
var $d5e694cf5f7e70cc$var$createSetup = function(props) {
    var newSetup = $d5e694cf5f7e70cc$var$__assign({}, $d5e694cf5f7e70cc$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $d5e694cf5f7e70cc$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($d5e694cf5f7e70cc$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $d5e694cf5f7e70cc$var$__assign($d5e694cf5f7e70cc$var$__assign({}, $d5e694cf5f7e70cc$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $d5e694cf5f7e70cc$var$__spreadArray($d5e694cf5f7e70cc$var$__spreadArray([], $d5e694cf5f7e70cc$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $d5e694cf5f7e70cc$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $d5e694cf5f7e70cc$var$checkZoomBounds($d5e694cf5f7e70cc$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $d5e694cf5f7e70cc$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $d5e694cf5f7e70cc$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $d5e694cf5f7e70cc$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $d5e694cf5f7e70cc$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $d5e694cf5f7e70cc$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $d5e694cf5f7e70cc$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $d5e694cf5f7e70cc$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $d5e694cf5f7e70cc$var$animate(contextInstance, newState, animationTime, animationType);
}
function $d5e694cf5f7e70cc$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $d5e694cf5f7e70cc$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $d5e694cf5f7e70cc$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $d5e694cf5f7e70cc$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $d5e694cf5f7e70cc$var$calculateBounds(contextInstance, newScale);
    var _b = $d5e694cf5f7e70cc$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $d5e694cf5f7e70cc$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $d5e694cf5f7e70cc$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $d5e694cf5f7e70cc$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $d5e694cf5f7e70cc$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $d5e694cf5f7e70cc$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $d5e694cf5f7e70cc$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $d5e694cf5f7e70cc$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $d5e694cf5f7e70cc$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $d5e694cf5f7e70cc$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $d5e694cf5f7e70cc$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $d5e694cf5f7e70cc$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $d5e694cf5f7e70cc$var$calculateZoomToNode(contextInstance, target, scale);
            $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $d5e694cf5f7e70cc$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $d5e694cf5f7e70cc$var$zoomIn(contextInstance),
        zoomOut: $d5e694cf5f7e70cc$var$zoomOut(contextInstance),
        setTransform: $d5e694cf5f7e70cc$var$setTransform(contextInstance),
        resetTransform: $d5e694cf5f7e70cc$var$resetTransform(contextInstance),
        centerView: $d5e694cf5f7e70cc$var$centerView(contextInstance),
        zoomToElement: $d5e694cf5f7e70cc$var$zoomToElement(contextInstance)
    };
};
var $d5e694cf5f7e70cc$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $d5e694cf5f7e70cc$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $d5e694cf5f7e70cc$var$getState(contextInstance));
    Object.assign(ref, $d5e694cf5f7e70cc$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $d5e694cf5f7e70cc$var$passiveSupported = false;
function $d5e694cf5f7e70cc$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $d5e694cf5f7e70cc$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $d5e694cf5f7e70cc$var$passiveSupported = false;
        return $d5e694cf5f7e70cc$var$passiveSupported;
    }
}
var $d5e694cf5f7e70cc$var$matchPrefix = ".".concat($d5e694cf5f7e70cc$var$baseClasses.wrapperClass);
var $d5e694cf5f7e70cc$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($d5e694cf5f7e70cc$var$matchPrefix, " ").concat(exclude, ", ").concat($d5e694cf5f7e70cc$var$matchPrefix, " .").concat(exclude, ", ").concat($d5e694cf5f7e70cc$var$matchPrefix, " ").concat(exclude, " *, ").concat($d5e694cf5f7e70cc$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $d5e694cf5f7e70cc$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $d5e694cf5f7e70cc$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $d5e694cf5f7e70cc$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $d5e694cf5f7e70cc$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $d5e694cf5f7e70cc$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $d5e694cf5f7e70cc$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $d5e694cf5f7e70cc$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $d5e694cf5f7e70cc$var$getDelta(event, customDelta) {
    var deltaY = $d5e694cf5f7e70cc$var$getDeltaY(event);
    var delta = $d5e694cf5f7e70cc$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $d5e694cf5f7e70cc$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $d5e694cf5f7e70cc$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $d5e694cf5f7e70cc$var$checkZoomBounds($d5e694cf5f7e70cc$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $d5e694cf5f7e70cc$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $d5e694cf5f7e70cc$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $d5e694cf5f7e70cc$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $d5e694cf5f7e70cc$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $d5e694cf5f7e70cc$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $d5e694cf5f7e70cc$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $d5e694cf5f7e70cc$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $d5e694cf5f7e70cc$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $d5e694cf5f7e70cc$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $d5e694cf5f7e70cc$var$checkZoomBounds($d5e694cf5f7e70cc$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $d5e694cf5f7e70cc$var$wheelStopEventTime = 160;
var $d5e694cf5f7e70cc$var$wheelAnimationTime = 100;
var $d5e694cf5f7e70cc$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $d5e694cf5f7e70cc$var$handleCancelAnimation(contextInstance);
        $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onWheelStart);
        $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $d5e694cf5f7e70cc$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $d5e694cf5f7e70cc$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $d5e694cf5f7e70cc$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $d5e694cf5f7e70cc$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $d5e694cf5f7e70cc$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $d5e694cf5f7e70cc$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onWheel);
    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoom);
};
var $d5e694cf5f7e70cc$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $d5e694cf5f7e70cc$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $d5e694cf5f7e70cc$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $d5e694cf5f7e70cc$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $d5e694cf5f7e70cc$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $d5e694cf5f7e70cc$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onWheelStop);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoomStop);
        }, $d5e694cf5f7e70cc$var$wheelStopEventTime);
    }
};
var $d5e694cf5f7e70cc$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $d5e694cf5f7e70cc$var$handlePinchStart = function(contextInstance, event) {
    var distance = $d5e694cf5f7e70cc$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    var center = $d5e694cf5f7e70cc$var$getTouchCenter(event);
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    $d5e694cf5f7e70cc$var$handleCancelAnimation(contextInstance);
};
var $d5e694cf5f7e70cc$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, alignmentAnimation = _a.alignmentAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $d5e694cf5f7e70cc$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $d5e694cf5f7e70cc$var$getTouchDistance(event);
    var newScale = $d5e694cf5f7e70cc$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $d5e694cf5f7e70cc$var$getTouchCenter(event);
    // pan should be scale invariant.
    var panX = center.x - (contextInstance.pinchLastCenterX || 0);
    var panY = center.y - (contextInstance.pinchLastCenterY || 0);
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchLastCenterX = center.x;
    contextInstance.pinchLastCenterY = center.y;
    var bounds = $d5e694cf5f7e70cc$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $d5e694cf5f7e70cc$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY;
    var paddingValueX = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $d5e694cf5f7e70cc$var$getPaddingValue(contextInstance, sizeY);
    var newPositionX = x + panX;
    var newPositionY = y + panY;
    var _c = $d5e694cf5f7e70cc$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
    contextInstance.setTransformState(newScale, finalX, finalY);
};
var $d5e694cf5f7e70cc$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $d5e694cf5f7e70cc$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $d5e694cf5f7e70cc$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $d5e694cf5f7e70cc$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $d5e694cf5f7e70cc$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoomStart);
    $d5e694cf5f7e70cc$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoom);
    });
    $d5e694cf5f7e70cc$var$handleDoubleClickStop(contextInstance, event);
};
function $d5e694cf5f7e70cc$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $d5e694cf5f7e70cc$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $d5e694cf5f7e70cc$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $d5e694cf5f7e70cc$var$getDoubleClickScale(mode, contextInstance.transformState.scale);
    var newScale = $d5e694cf5f7e70cc$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $d5e694cf5f7e70cc$var$getMousePosition(event, contentComponent, scale);
    var targetState = $d5e694cf5f7e70cc$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(contextInstance), event, onZoom);
    $d5e694cf5f7e70cc$var$animate(contextInstance, targetState, animationTime, animationType);
    $d5e694cf5f7e70cc$var$handleDoubleClickStop(contextInstance, event);
}
var $d5e694cf5f7e70cc$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $d5e694cf5f7e70cc$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $d5e694cf5f7e70cc$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.pinchLastCenterX = null;
        this.pinchLastCenterY = null;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            $d5e694cf5f7e70cc$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $d5e694cf5f7e70cc$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b;
            var passive = $d5e694cf5f7e70cc$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $d5e694cf5f7e70cc$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $d5e694cf5f7e70cc$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $d5e694cf5f7e70cc$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($d5e694cf5f7e70cc$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($d5e694cf5f7e70cc$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $d5e694cf5f7e70cc$var$handleWheelStart(_this, event);
            $d5e694cf5f7e70cc$var$handleWheelZoom(_this, event);
            $d5e694cf5f7e70cc$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onWheelPanning = function(event) {
            var _a = _this.setup, disabled = _a.disabled, wheel = _a.wheel, panning = _a.panning;
            if (!_this.wrapperComponent || !_this.contentComponent || disabled || !wheel.wheelDisabled || panning.disabled || !panning.wheelPanning || event.ctrlKey) return;
            event.preventDefault();
            event.stopPropagation();
            var _b = _this.transformState, positionX = _b.positionX, positionY = _b.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = panning.lockAxisX ? positionX : mouseX;
            var newPositionY = panning.lockAxisY ? positionY : mouseY;
            var _c = _this.setup.alignmentAnimation, sizeX = _c.sizeX, sizeY = _c.sizeY;
            var paddingValueX = $d5e694cf5f7e70cc$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $d5e694cf5f7e70cc$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $d5e694cf5f7e70cc$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
        };
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $d5e694cf5f7e70cc$var$handleCancelAnimation(_this);
            $d5e694cf5f7e70cc$var$handlePanningStart(_this, event);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $d5e694cf5f7e70cc$var$handlePanning(_this, event.clientX, event.clientY);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $d5e694cf5f7e70cc$var$handlePanningEnd(_this);
                $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $d5e694cf5f7e70cc$var$handlePinchStart(_this, event);
            $d5e694cf5f7e70cc$var$handleCancelAnimation(_this);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPinchingStart);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $d5e694cf5f7e70cc$var$handlePinchZoom(_this, event);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPinching);
            $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $d5e694cf5f7e70cc$var$handlePinchStop(_this);
                $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPinchingStop);
                $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) _this.onDoubleClick(event);
            else {
                _this.lastTouch = +new Date();
                $d5e694cf5f7e70cc$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $d5e694cf5f7e70cc$var$handleCancelAnimation(_this);
                    $d5e694cf5f7e70cc$var$handlePanningStart(_this, event);
                    $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $d5e694cf5f7e70cc$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $d5e694cf5f7e70cc$var$handlePanning(_this, touch.clientX, touch.clientY);
                $d5e694cf5f7e70cc$var$handleCallback($d5e694cf5f7e70cc$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $d5e694cf5f7e70cc$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $d5e694cf5f7e70cc$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $d5e694cf5f7e70cc$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $d5e694cf5f7e70cc$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $d5e694cf5f7e70cc$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $d5e694cf5f7e70cc$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $d5e694cf5f7e70cc$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $d5e694cf5f7e70cc$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $d5e694cf5f7e70cc$var$getContext(_this);
            $d5e694cf5f7e70cc$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $d5e694cf5f7e70cc$var$createSetup(this.props);
        this.transformState = $d5e694cf5f7e70cc$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $d5e694cf5f7e70cc$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createContext(null);
var $d5e694cf5f7e70cc$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $d5e694cf5f7e70cc$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).forwardRef(function(props, ref) {
    var instance = (0, $8FY87.useRef)(new $d5e694cf5f7e70cc$var$ZoomPanPinch(props)).current;
    var content = $d5e694cf5f7e70cc$var$getContent(props.children, $d5e694cf5f7e70cc$var$getControls(instance));
    (0, $8FY87.useImperativeHandle)(ref, function() {
        return $d5e694cf5f7e70cc$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $8FY87.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement($d5e694cf5f7e70cc$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $d5e694cf5f7e70cc$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).forwardRef(function(props, ref) {
    var localRef = (0, $8FY87.useRef)(null);
    var instance = (0, $8FY87.useContext)($d5e694cf5f7e70cc$export$841858b892ce1f4c);
    (0, $8FY87.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", $d5e694cf5f7e70cc$var$__assign({}, props, {
        ref: $d5e694cf5f7e70cc$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $d5e694cf5f7e70cc$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $d5e694cf5f7e70cc$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $8FY87.useRef)();
    var rectRef = (0, $8FY87.useRef)($d5e694cf5f7e70cc$var$initialElementRect);
    var didUnmount = (0, $8FY87.useRef)(false);
    (0, $8FY87.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d5e694cf5f7e70cc$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $d5e694cf5f7e70cc$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $d5e694cf5f7e70cc$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $d5e694cf5f7e70cc$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $8FY87.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $d5e694cf5f7e70cc$export$1708b11af87412f8();
    var miniMapInstance = (0, $8FY87.useRef)(null);
    var mainRef = (0, $8FY87.useRef)(null);
    var wrapperRef = (0, $8FY87.useRef)(null);
    var previewRef = (0, $8FY87.useRef)(null);
    var getViewportSize = (0, $8FY87.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $8FY87.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $8FY87.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $d5e694cf5f7e70cc$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $d5e694cf5f7e70cc$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $d5e694cf5f7e70cc$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $8FY87.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $8FY87.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", $d5e694cf5f7e70cc$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", $d5e694cf5f7e70cc$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $d5e694cf5f7e70cc$var$__assign($d5e694cf5f7e70cc$var$__assign({}, $d5e694cf5f7e70cc$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $d5e694cf5f7e70cc$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $d5e694cf5f7e70cc$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $d5e694cf5f7e70cc$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$d5e694cf5f7e70cc$var$styleInject($d5e694cf5f7e70cc$var$css_248z);
var $d5e694cf5f7e70cc$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $8FY87.useContext)($d5e694cf5f7e70cc$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $8FY87.useRef)(null);
    var contentRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", $d5e694cf5f7e70cc$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($d5e694cf5f7e70cc$var$baseClasses.wrapperClass, " ").concat($d5e694cf5f7e70cc$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).createElement("div", $d5e694cf5f7e70cc$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "".concat($d5e694cf5f7e70cc$var$baseClasses.contentClass, " ").concat($d5e694cf5f7e70cc$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $d5e694cf5f7e70cc$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $8FY87.useContext)($d5e694cf5f7e70cc$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $d5e694cf5f7e70cc$export$8a75c83865bcf9dd = function() {
    var libraryContext = $d5e694cf5f7e70cc$export$1708b11af87412f8();
    return $d5e694cf5f7e70cc$var$getControls(libraryContext);
};
var $d5e694cf5f7e70cc$export$e14839139473133b = function(callback) {
    var libraryContext = $d5e694cf5f7e70cc$export$1708b11af87412f8();
    (0, $8FY87.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($d5e694cf5f7e70cc$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($d5e694cf5f7e70cc$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $d5e694cf5f7e70cc$export$769cca75086a299c = function(callback) {
    var libraryContext = $d5e694cf5f7e70cc$export$1708b11af87412f8();
    (0, $8FY87.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($d5e694cf5f7e70cc$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $d5e694cf5f7e70cc$export$4915c4f91c47b682(callback) {
    var libraryContext = $d5e694cf5f7e70cc$export$1708b11af87412f8();
    var _a = (0, $8FY87.useState)(callback($d5e694cf5f7e70cc$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $8FY87.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($d5e694cf5f7e70cc$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}



var $9s93Y = parcelRequire("9s93Y");


var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");



var $4KKbJ = parcelRequire("4KKbJ");

var $cEIti = parcelRequire("cEIti");

var $764u1 = parcelRequire("764u1");

var $hzaQx = parcelRequire("hzaQx");

var $aTRs6 = parcelRequire("aTRs6");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");
/**
 * RoundProgressBarRefDriven
 *
 * This component is intentionally *not* updated through React props or state.
 * Instead, it exposes refs (circleRef + textRef) that the parent updates
 * directly inside a requestAnimationFrame loop.
 *
 * Why?
 * - Avoids React re-renders at ~60fps (bad for performance, especially on mobile)
 * - Keeps React completely asleep during video playback
 * - Allows smooth, cheap DOM updates driven by the YouTube player
 *
 * TL;DR — Visual only. Logic lives in the parent. All animation happens via refs.
 */ function $ec8d695c690d3bd5$var$RoundProgressBarRefDriven({ circleRef: circleRef, textRef: textRef, radius: radius, circumference: circumference, className: className }) {
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                viewBox: "0 0 120 120",
                style: {
                    transform: "rotate(-90deg)"
                },
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                        cx: "60",
                        cy: "60",
                        r: radius,
                        stroke: "#444",
                        strokeWidth: "8",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                        ref: circleRef,
                        cx: "60",
                        cy: "60",
                        r: radius,
                        stroke: "#ffffffff",
                        strokeWidth: "8",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeDasharray: circumference,
                        strokeDashoffset: circumference
                    })
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                ref: textRef,
                style: {
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                },
                children: "0%"
            })
        ]
    });
}
function $ec8d695c690d3bd5$export$d73074b7512a7248({ playerRef: playerRef, force100: force100, className: className }) {
    const rafRef = (0, $8FY87.useRef)(null); // Request animation frame ref
    const circleRef = (0, $8FY87.useRef)(null);
    const textRef = (0, $8FY87.useRef)(null);
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    const lastPercent = (0, $8FY87.useRef)(0);
    const setVisualPercent = (percent)=>{
        const clamped = Math.max(0, Math.min(100, percent));
        const offset = circumference * (1 - clamped / 100);
        // Always update the circle (smooth animation)
        if (circleRef.current) circleRef.current.style.strokeDashoffset = String(offset);
        // Only update text when it actually changes
        if (clamped !== lastPercent.current) {
            lastPercent.current = clamped;
            if (textRef.current) textRef.current.textContent = clamped + "%";
        }
    };
    (0, $8FY87.useEffect)(()=>{
        // If forced to 100%, skip ticking entirely
        if (force100) {
            setVisualPercent(100);
            return; // Do not start RAF loop
        }
        const tick = ()=>{
            const player = playerRef.current;
            if (!player) {
                rafRef.current = requestAnimationFrame(tick);
                return;
            }
            const videoTime = player.getCurrentTime();
            const videoDuration = player.getDuration();
            if (!videoDuration) {
                rafRef.current = requestAnimationFrame(tick);
                return;
            }
            const percent = Math.floor(videoTime / videoDuration * 100);
            setVisualPercent(percent);
            rafRef.current = requestAnimationFrame(tick);
        };
        rafRef.current = requestAnimationFrame(tick);
        return ()=>cancelAnimationFrame(rafRef.current);
    }, [
        force100
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($ec8d695c690d3bd5$var$RoundProgressBarRefDriven, {
        className: className,
        circleRef: circleRef,
        textRef: textRef,
        radius: radius,
        circumference: circumference
    });
}




var $i7H0N = parcelRequire("i7H0N");
function $0f214ca5522ffca2$export$949cdc0afd1b6cf3(eventType, videoUrl, additionalStrings = [], numbers = []) {
    (0, $i7H0N.sendEventV2)("video_engagement", [
        eventType,
        videoUrl,
        ...additionalStrings
    ], numbers);
}
function $0f214ca5522ffca2$export$b618680f92f27e47(currentTime, duration, videoUrl, milestonesTracked, onComplete, onMilestone) {
    if (duration === 0) return;
    const percentage = currentTime / duration * 100;
    const milestones = [
        {
            threshold: 10,
            label: "10%"
        },
        {
            threshold: 20,
            label: "20%"
        },
        {
            threshold: 30,
            label: "30%"
        },
        {
            threshold: 40,
            label: "40%"
        },
        {
            threshold: 50,
            label: "50%"
        },
        {
            threshold: 60,
            label: "60%"
        },
        {
            threshold: 70,
            label: "70%"
        },
        {
            threshold: 80,
            label: "80%"
        },
        {
            threshold: 90,
            label: "90%"
        },
        {
            threshold: 100,
            label: "100%"
        }
    ];
    milestones.forEach((milestone)=>{
        if (percentage >= milestone.threshold && !milestonesTracked.has(milestone.label)) {
            milestonesTracked.add(milestone.label);
            $0f214ca5522ffca2$export$949cdc0afd1b6cf3("milestone", videoUrl, [
                milestone.label
            ], [
                currentTime,
                duration
            ]);
            if (onMilestone) onMilestone(milestone.threshold);
        }
    });
}
function $0f214ca5522ffca2$export$7aac5f8126fa4668(currentTime, duration, videoUrl, lastKnownTime) {
    const timeDiff = Math.abs(currentTime - lastKnownTime);
    if (timeDiff > 1 && lastKnownTime > 0) $0f214ca5522ffca2$export$949cdc0afd1b6cf3("seek", videoUrl, [], [
        lastKnownTime,
        currentTime,
        duration
    ]);
    return currentTime;
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


function $60ce9ce3870329ca$export$d6f3e0479583ca37(onReady) {
    if (window.YT && window.YT.Player) {
        onReady();
        return;
    }
    const existingScript = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
    if (existingScript) {
        window.onYouTubeIframeAPIReady = onReady;
        return;
    }
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = onReady;
}
function $60ce9ce3870329ca$export$acf5185a61c48950(url) {
    try {
        if (url.includes("youtube.com/watch")) return new URL(url).searchParams.get("v");
    } catch (e) {
        console.warn("Failed to parse YouTube URL:", e);
    }
    return null;
}
function $60ce9ce3870329ca$export$9990abda26fec7fc(videoUrl) {
    return (event)=>{
        const rate = event.data;
        (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("playback_rate", videoUrl, [], [
            rate
        ]);
    };
}


function $8b125a4c545bf36a$var$createYouTubePlayerWrapper(player) {
    return {
        getCurrentTime: ()=>{
            return typeof player?.getCurrentTime === "function" ? player.getCurrentTime() : undefined;
        },
        getDuration: ()=>{
            return typeof player?.getDuration === "function" ? player.getDuration() : undefined;
        },
        isEnded: ()=>{
            return typeof player?.getPlayerState === "function" ? player.getPlayerState() === window.YT?.PlayerState.ENDED : undefined;
        }
    };
}
function $8b125a4c545bf36a$export$50da724f0fa6e6a9({ videoUrl: videoUrl, videoId: videoId, className: className, hasControls: hasControls, shouldAutoplay: shouldAutoplay, playerRef: playerRef, onPlay: onPlay, onPause: onPause, onEnded: onEnded, onReady: onReady }) {
    const playerContainerRef = (0, $8FY87.useRef)(null);
    const [isYouTubeAPIReady, setIsYouTubeAPIReady] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const nativePlayerRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        (0, $60ce9ce3870329ca$export$d6f3e0479583ca37)(()=>setIsYouTubeAPIReady(true));
    }, []);
    const onPlaybackRateChange = (0, $60ce9ce3870329ca$export$9990abda26fec7fc)(videoUrl);
    (0, $8FY87.useEffect)(()=>{
        if (!isYouTubeAPIReady) return;
        if (!videoUrl) return;
        if (!videoUrl.includes("youtube.com/watch")) return;
        if (!videoId) {
            console.warn("Invalid YouTube video URL");
            return;
        }
        if (playerContainerRef.current && window.YT && window.YT.Player) {
            if (nativePlayerRef.current) nativePlayerRef.current.destroy();
            const player = new window.YT.Player(playerContainerRef.current, {
                videoId: videoId,
                width: "100%",
                height: "100%",
                playerVars: {
                    playsinline: 1,
                    enablejsapi: 1,
                    controls: hasControls ? 1 : 0,
                    disablekb: hasControls ? 0 : 1,
                    autoplay: shouldAutoplay ? 1 : 0
                },
                events: {
                    onReady: (event)=>{
                        const iframe = event.target.getIframe();
                        if (iframe) {
                            iframe.setAttribute("title", "YouTube video player");
                            iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share");
                            iframe.setAttribute("referrerPolicy", "strict-origin-when-cross-origin");
                            iframe.setAttribute("allowFullScreen", "");
                        }
                        onReady();
                    },
                    onStateChange: (event)=>{
                        const player = event.target;
                        const state = event.data;
                        const currentTime = player.getCurrentTime();
                        const duration = player.getDuration();
                        // Track video engagement events
                        switch(state){
                            case window.YT.PlayerState.PLAYING:
                                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("play", videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                onPlay();
                                break;
                            case window.YT.PlayerState.PAUSED:
                                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("pause", videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                onPause();
                                break;
                            case window.YT.PlayerState.ENDED:
                                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("ended", videoUrl, [], [
                                    duration
                                ]);
                                onEnded();
                                break;
                            case window.YT.PlayerState.BUFFERING:
                                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("buffering", videoUrl, [], [
                                    currentTime,
                                    duration
                                ]);
                                break;
                            default:
                                break;
                        }
                    },
                    onPlaybackRateChange: onPlaybackRateChange
                }
            });
            nativePlayerRef.current = player;
            playerRef.current = $8b125a4c545bf36a$var$createYouTubePlayerWrapper(player);
        }
        return ()=>{
            if (nativePlayerRef.current) {
                nativePlayerRef.current.destroy();
                nativePlayerRef.current = null;
            }
            playerRef.current = null;
        };
    }, [
        isYouTubeAPIReady,
        videoUrl,
        hasControls,
        videoId
    ]);
    if (!videoUrl?.includes("youtube.com/watch")) {
        console.warn("Invalid YouTube video URL");
        return null;
    }
    if (!videoId) {
        console.warn("Invalid YouTube video URL");
        return null;
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        ref: playerContainerRef,
        className: className
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $2PPWI = parcelRequire("2PPWI");
parcelRequire("8FY87");
var $710389149c3139af$exports = {};

$parcel$export($710389149c3139af$exports, "playButton", function () { return $710389149c3139af$export$73e4574fc43cf3a2; }, function (v) { return $710389149c3139af$export$73e4574fc43cf3a2 = v; });
var $710389149c3139af$export$73e4574fc43cf3a2;
$710389149c3139af$export$73e4574fc43cf3a2 = `F4HaDa_playButton`;


function $1a17e1ba15fe0a88$export$fbed5f62d839a0cd() {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
        width: "130",
        height: "130",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($710389149c3139af$exports))).playButton,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
            d: "M14 15.06V33a2 2 0 0 0 2.93 1.77l17.09-8.97a2 2 0 0 0 0-3.54L16.93 13.3A2 2 0 0 0 14 15.06z"
        })
    });
}



function $ab6be940c2b62fa3$export$94e93caed8fbced4(onReady) {
    if (window.Stream) {
        onReady();
        return;
    }
    const existingScript = document.querySelector('script[src="https://embed.cloudflarestream.com/embed/sdk.latest.js"]');
    if (existingScript) {
        existingScript.addEventListener("load", onReady);
        return;
    }
    const script = document.createElement("script");
    script.src = "https://embed.cloudflarestream.com/embed/sdk.latest.js";
    script.async = true;
    script.onload = onReady;
    document.head.appendChild(script);
}
function $ab6be940c2b62fa3$export$f3460e1f346f034d(url) {
    try {
        if (url.includes("cloudflarestream.com")) {
            const match = url.match(/cloudflarestream\.com\/([a-f0-9]+)\//);
            return match ? match[1] : null;
        }
    } catch (e) {
        console.warn("Failed to parse Cloudflare Stream URL:", e);
    }
    return null;
}


function $7c15ff379d332b6c$var$createCloudflarePlayerWrapper(player) {
    return {
        getCurrentTime: ()=>{
            return typeof player?.currentTime === "number" ? player.currentTime : undefined;
        },
        getDuration: ()=>{
            return typeof player?.duration === "number" ? player.duration : undefined;
        },
        isEnded: ()=>{
            return typeof player?.ended === "boolean" ? player.ended === true : undefined;
        }
    };
}
function $7c15ff379d332b6c$export$359be76a4eee9a5({ videoUrl: videoUrl, videoId: videoId, className: className, hasControls: hasControls, shouldAutoplay: shouldAutoplay, playerRef: playerRef, onPlay: onPlay, onPause: onPause, onEnded: onEnded, onReady: onReady }) {
    const iframeRef = (0, $8FY87.useRef)(null);
    const [isCloudflareAPIReady, setIsCloudflareAPIReady] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const [isPlaying, setIsPlaying] = (0, (/*@__PURE__*/$parcel$interopDefault($8FY87))).useState(false);
    const nativePlayerRef = (0, $8FY87.useRef)(null);
    (0, $8FY87.useEffect)(()=>{
        (0, $ab6be940c2b62fa3$export$94e93caed8fbced4)(()=>setIsCloudflareAPIReady(true));
    }, []);
    const handleIframeClick = ()=>{
        const player = nativePlayerRef.current;
        if (!player) return;
        if (hasControls) return; // Only handle clicks when controls are disabled
        try {
            if (isPlaying) player.pause();
            else player.play();
        } catch (error) {
            console.log("Warning: Error toggling play/pause", error);
        }
    };
    (0, $8FY87.useEffect)(()=>{
        if (!isCloudflareAPIReady) return;
        if (!videoUrl) return;
        if (!videoUrl.includes("cloudflarestream.com")) return;
        if (!videoId) {
            console.warn("Invalid Cloudflare Stream video URL");
            return;
        }
        if (iframeRef.current && window.Stream) {
            const player = window.Stream(iframeRef.current);
            nativePlayerRef.current = player;
            playerRef.current = $7c15ff379d332b6c$var$createCloudflarePlayerWrapper(player);
            player.addEventListener("play", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("play", videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
                setIsPlaying(true);
                onPlay();
            });
            player.addEventListener("pause", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("pause", videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
                setIsPlaying(false);
                onPause();
            });
            player.addEventListener("ended", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("ended", videoUrl, [], [
                    player.duration
                ]);
                setIsPlaying(false);
                onEnded();
            });
            player.addEventListener("seeking", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("seeking", videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
            });
            player.addEventListener("seeked", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("seeked", videoUrl, [], [
                    player.currentTime,
                    player.duration
                ]);
            });
            player.addEventListener("volumechange", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("volume_change", videoUrl, [], [
                    player.volume
                ]);
            });
            player.addEventListener("loadedmetadata", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("loaded_metadata", videoUrl, [], [
                    player.duration
                ]);
                onReady();
            });
            player.addEventListener("error", ()=>{
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("error", videoUrl, [], []);
            });
            player.controls = hasControls;
        }
        return ()=>{
            nativePlayerRef.current = null;
            playerRef.current = null;
        };
    }, [
        isCloudflareAPIReady,
        videoUrl,
        hasControls,
        videoId
    ]);
    if (!videoUrl?.includes("cloudflarestream.com")) {
        console.warn("Invalid Cloudflare Stream video URL");
        return null;
    }
    if (!videoId) {
        console.warn("Invalid Cloudflare Stream video URL");
        return null;
    }
    let iframeSrc = videoUrl;
    if (shouldAutoplay) {
        const url = new URL(videoUrl);
        url.searchParams.set("autoplay", "true");
        iframeSrc = url.toString();
    }
    const currentTime = nativePlayerRef.current?.currentTime ?? 0;
    const showPlayButton = !hasControls && !isPlaying && currentTime === 0;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        onClick: handleIframeClick,
        style: {
            width: "100%",
            height: "100%",
            position: "relative",
            cursor: !hasControls ? "pointer" : "default"
        },
        children: [
            showPlayButton && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1a17e1ba15fe0a88$export$fbed5f62d839a0cd), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)("iframe", {
                ref: iframeRef,
                src: iframeSrc,
                className: className,
                style: {
                    border: "none",
                    width: "100%",
                    height: "100%",
                    pointerEvents: hasControls ? "auto" : "none"
                },
                allow: "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;",
                allowFullScreen: true,
                title: "Video player"
            })
        ]
    });
}


function $0d29274c22c69851$export$f503bc85d719e8b0({ videoUrl: videoUrl, videoId: videoId, playerType: playerType, className: className, onComplete: onComplete, enforcedViewing: enforcedViewing, onMilestone: onMilestone, roundProgressBarClassName: roundProgressBarClassName, completionTextClassName: completionTextClassName, hasCompletionText: hasCompletionText, preCompletionText: preCompletionText, postCompletionText: postCompletionText }) {
    const playerRef = (0, $8FY87.useRef)(null);
    const pollingIntervalRef = (0, $8FY87.useRef)(null);
    const progressIntervalRef = (0, $8FY87.useRef)(null);
    const stopPollingTimeoutRef = (0, $8FY87.useRef)(null);
    const lastKnownTimeRef = (0, $8FY87.useRef)(0);
    const lastKnownDurationRef = (0, $8FY87.useRef)(0);
    const milestonesTrackedRef = (0, $8FY87.useRef)(new Set());
    const onCompleteRef = (0, $8FY87.useRef)(onComplete);
    const onVideoCompleteCallbackHasBeenCalledRef = (0, $8FY87.useRef)(false);
    const onMilestoneRef = (0, $8FY87.useRef)(onMilestone);
    const savedData = (0, $8FY87.useRef)((0, $0cf842c3a6817596$export$34250dbee1b3714)(videoId));
    const [hasCompletedAtLeastOnce, setHasCompletedAtLeastOnce] = (0, $8FY87.useState)(()=>{
        return savedData?.current?.completed === true;
    });
    // Component config
    const hasControls = !enforcedViewing || hasCompletedAtLeastOnce;
    const shouldAutoplay = !hasControls;
    const hasProgressCircle = enforcedViewing;
    const shouldPersistProgress = enforcedViewing && !hasCompletedAtLeastOnce;
    // Keep onComplete & onMilestone refs up to date
    (0, $8FY87.useEffect)(()=>{
        onCompleteRef.current = onComplete;
    }, [
        onComplete
    ]);
    (0, $8FY87.useEffect)(()=>{
        onMilestoneRef.current = onMilestone;
    }, [
        onMilestone
    ]);
    const onVideoComplete = ()=>{
        // Stop oncomplete being called multiple times
        if (!onVideoCompleteCallbackHasBeenCalledRef.current) {
            onCompleteRef.current?.(!hasCompletedAtLeastOnce);
            onVideoCompleteCallbackHasBeenCalledRef.current = true;
        }
        console.log("User has finished the video");
        stopPolling();
        stopProgressSaving();
        (0, $0cf842c3a6817596$export$f56a20f73da3ee39)(videoId);
        setTimeout(()=>{
            setHasCompletedAtLeastOnce(true);
            milestonesTrackedRef.current?.clear();
        }, 100);
    };
    const onVideoMilestone = (val)=>{
        const getIsFirstTimeMilestoneReached = ()=>{
            if (hasCompletedAtLeastOnce) return false;
            if (!lastKnownDurationRef.current) return true;
            // If user has not completed the video for the first time yet...
            // Check the saved progress to see if we already reached milestone on previous session
            // (Can't just check milestonesTrackedRef as it gets cleared when component remounts)
            const savedProgress = savedData.current?.progress;
            const savedPercent = savedProgress / lastKnownDurationRef.current * 100 || 0;
            return val > savedPercent;
        };
        onMilestoneRef.current?.(val, getIsFirstTimeMilestoneReached());
    };
    const startProgressSaving = (videoId, player)=>{
        if (!shouldPersistProgress) return;
        if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
        progressIntervalRef.current = window.setInterval(()=>{
            try {
                const currentTime = player.getCurrentTime();
                if (currentTime) (0, $0cf842c3a6817596$export$e20713ec10f02e66)(videoId, currentTime);
            } catch (error) {
                console.log("Warning: Video progress not saved", error);
            }
        }, 2000);
    };
    const stopProgressSaving = ()=>{
        if (progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }
    };
    const startPolling = ()=>{
        if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = window.setInterval(()=>{
            const player = playerRef.current;
            if (!player) return;
            try {
                const currentTime = player.getCurrentTime();
                const duration = player.getDuration();
                if (typeof currentTime !== "number" || typeof duration !== "number") return;
                lastKnownTimeRef.current = (0, $0f214ca5522ffca2$export$7aac5f8126fa4668)(currentTime, duration, videoUrl, lastKnownTimeRef.current);
                lastKnownDurationRef.current = duration;
                (0, $0f214ca5522ffca2$export$b618680f92f27e47)(currentTime, duration, videoUrl, milestonesTrackedRef.current, onVideoComplete, onVideoMilestone);
                // Backup end detection which runs on poll
                if (player.isEnded()) onVideoComplete();
            } catch (error) {
                console.log("Warning: Polling error", error);
            }
        }, 500);
    };
    const stopPolling = ()=>{
        if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
            pollingIntervalRef.current = null;
        }
    };
    const handlePlay = ()=>{
        clearTimeout(stopPollingTimeoutRef.current);
        startPolling();
    };
    const handlePause = ()=>{
        // Wait 1000ms before stopping to allow end events to send via poll if needed
        stopPollingTimeoutRef.current = setTimeout(stopPolling, 1000);
    };
    const handleEnded = ()=>{
        stopPolling();
        onVideoComplete();
    };
    const handleReady = ()=>{
        const player = playerRef.current;
        if (!player) return;
        if (shouldPersistProgress) startProgressSaving(videoId, player);
    };
    // Cleanup on unmount
    (0, $8FY87.useEffect)(()=>{
        return ()=>{
            const currentTime = lastKnownTimeRef.current;
            const duration = lastKnownDurationRef.current;
            if (currentTime > 0 && duration > 0) {
                (0, $0f214ca5522ffca2$export$949cdc0afd1b6cf3)("closed", videoUrl, [], [
                    currentTime,
                    duration
                ]);
                if (shouldPersistProgress) (0, $0cf842c3a6817596$export$e20713ec10f02e66)(videoId, currentTime);
            }
            stopPolling();
            stopProgressSaving();
            lastKnownTimeRef.current = 0;
            lastKnownDurationRef.current = 0;
            milestonesTrackedRef.current.clear();
        };
    }, [
        videoUrl,
        videoId,
        shouldPersistProgress
    ]);
    const coreProps = {
        videoUrl: videoUrl,
        videoId: videoId,
        className: className,
        hasControls: hasControls,
        shouldAutoplay: shouldAutoplay,
        playerRef: playerRef,
        onPlay: handlePlay,
        onPause: handlePause,
        onEnded: handleEnded,
        onReady: handleReady
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            hasCompletionText && preCompletionText && postCompletionText && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: completionTextClassName,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                    children: hasCompletedAtLeastOnce ? postCompletionText : preCompletionText
                })
            }),
            hasProgressCircle && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ec8d695c690d3bd5$export$d73074b7512a7248), {
                playerRef: playerRef,
                className: roundProgressBarClassName,
                force100: hasCompletedAtLeastOnce
            }),
            playerType === "youtube" ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8b125a4c545bf36a$export$50da724f0fa6e6a9), {
                ...coreProps
            }) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7c15ff379d332b6c$export$359be76a4eee9a5), {
                ...coreProps
            })
        ]
    });
}




var $50adab4d566913c2$exports = {};

$parcel$export($50adab4d566913c2$exports, "MediaViewer", function () { return $50adab4d566913c2$export$fe6485e420d37282; }, function (v) { return $50adab4d566913c2$export$fe6485e420d37282 = v; });
$parcel$export($50adab4d566913c2$exports, "closeButton", function () { return $50adab4d566913c2$export$efe229eab43a9869; }, function (v) { return $50adab4d566913c2$export$efe229eab43a9869 = v; });
$parcel$export($50adab4d566913c2$exports, "completionText", function () { return $50adab4d566913c2$export$3ea4c15e263a0c0f; }, function (v) { return $50adab4d566913c2$export$3ea4c15e263a0c0f = v; });
$parcel$export($50adab4d566913c2$exports, "externalLinkButton", function () { return $50adab4d566913c2$export$f02cbb504f26b596; }, function (v) { return $50adab4d566913c2$export$f02cbb504f26b596 = v; });
$parcel$export($50adab4d566913c2$exports, "externalLinkImage", function () { return $50adab4d566913c2$export$e8043fb4712c8bde; }, function (v) { return $50adab4d566913c2$export$e8043fb4712c8bde = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH1", function () { return $50adab4d566913c2$export$17fa98cb055e8fa7; }, function (v) { return $50adab4d566913c2$export$17fa98cb055e8fa7 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH2", function () { return $50adab4d566913c2$export$a5833c2b43ca4340; }, function (v) { return $50adab4d566913c2$export$a5833c2b43ca4340 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH3", function () { return $50adab4d566913c2$export$47511f9a6581d1d6; }, function (v) { return $50adab4d566913c2$export$47511f9a6581d1d6 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH4", function () { return $50adab4d566913c2$export$dd1c05b92185401c; }, function (v) { return $50adab4d566913c2$export$dd1c05b92185401c = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH5", function () { return $50adab4d566913c2$export$8b28cf6cd00fe080; }, function (v) { return $50adab4d566913c2$export$8b28cf6cd00fe080 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeH6", function () { return $50adab4d566913c2$export$186c650311ff0789; }, function (v) { return $50adab4d566913c2$export$186c650311ff0789 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeSmall", function () { return $50adab4d566913c2$export$6746fe0d9c9fab54; }, function (v) { return $50adab4d566913c2$export$6746fe0d9c9fab54 = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizeTiny", function () { return $50adab4d566913c2$export$2bcf359f0c20e94f; }, function (v) { return $50adab4d566913c2$export$2bcf359f0c20e94f = v; });
$parcel$export($50adab4d566913c2$exports, "fontSizep", function () { return $50adab4d566913c2$export$2903d10d531d0ac0; }, function (v) { return $50adab4d566913c2$export$2903d10d531d0ac0 = v; });
$parcel$export($50adab4d566913c2$exports, "imageViewerImage", function () { return $50adab4d566913c2$export$65303a24f2d95a8e; }, function (v) { return $50adab4d566913c2$export$65303a24f2d95a8e = v; });
$parcel$export($50adab4d566913c2$exports, "mediaContainer", function () { return $50adab4d566913c2$export$e91e3cc91e00b6bb; }, function (v) { return $50adab4d566913c2$export$e91e3cc91e00b6bb = v; });
$parcel$export($50adab4d566913c2$exports, "modalContent", function () { return $50adab4d566913c2$export$add244bda2f9423c; }, function (v) { return $50adab4d566913c2$export$add244bda2f9423c = v; });
$parcel$export($50adab4d566913c2$exports, "overlay", function () { return $50adab4d566913c2$export$29dd17c7f3c81c36; }, function (v) { return $50adab4d566913c2$export$29dd17c7f3c81c36 = v; });
$parcel$export($50adab4d566913c2$exports, "roundVideoProgressBar", function () { return $50adab4d566913c2$export$9a127c71011fa931; }, function (v) { return $50adab4d566913c2$export$9a127c71011fa931 = v; });
$parcel$export($50adab4d566913c2$exports, "scale-up", function () { return $50adab4d566913c2$export$369cc45c1d328fdd; }, function (v) { return $50adab4d566913c2$export$369cc45c1d328fdd = v; });
$parcel$export($50adab4d566913c2$exports, "transformContent", function () { return $50adab4d566913c2$export$b7cb80c25ebba28e; }, function (v) { return $50adab4d566913c2$export$b7cb80c25ebba28e = v; });
$parcel$export($50adab4d566913c2$exports, "transformWrapper", function () { return $50adab4d566913c2$export$c3bda81a5133bfa4; }, function (v) { return $50adab4d566913c2$export$c3bda81a5133bfa4 = v; });
$parcel$export($50adab4d566913c2$exports, "videoIframe", function () { return $50adab4d566913c2$export$4e866d6d2e0629f8; }, function (v) { return $50adab4d566913c2$export$4e866d6d2e0629f8 = v; });
$parcel$export($50adab4d566913c2$exports, "videoWrapper", function () { return $50adab4d566913c2$export$b82b8842228620ec; }, function (v) { return $50adab4d566913c2$export$b82b8842228620ec = v; });
var $50adab4d566913c2$export$fe6485e420d37282;
var $50adab4d566913c2$export$efe229eab43a9869;
var $50adab4d566913c2$export$3ea4c15e263a0c0f;
var $50adab4d566913c2$export$f02cbb504f26b596;
var $50adab4d566913c2$export$e8043fb4712c8bde;
var $50adab4d566913c2$export$17fa98cb055e8fa7;
var $50adab4d566913c2$export$a5833c2b43ca4340;
var $50adab4d566913c2$export$47511f9a6581d1d6;
var $50adab4d566913c2$export$dd1c05b92185401c;
var $50adab4d566913c2$export$8b28cf6cd00fe080;
var $50adab4d566913c2$export$186c650311ff0789;
var $50adab4d566913c2$export$6746fe0d9c9fab54;
var $50adab4d566913c2$export$2bcf359f0c20e94f;
var $50adab4d566913c2$export$2903d10d531d0ac0;
var $50adab4d566913c2$export$65303a24f2d95a8e;
var $50adab4d566913c2$export$e91e3cc91e00b6bb;
var $50adab4d566913c2$export$add244bda2f9423c;
var $50adab4d566913c2$export$29dd17c7f3c81c36;
var $50adab4d566913c2$export$9a127c71011fa931;
var $50adab4d566913c2$export$369cc45c1d328fdd;
var $50adab4d566913c2$export$b7cb80c25ebba28e;
var $50adab4d566913c2$export$c3bda81a5133bfa4;
var $50adab4d566913c2$export$4e866d6d2e0629f8;
var $50adab4d566913c2$export$b82b8842228620ec;
$50adab4d566913c2$export$fe6485e420d37282 = `xM81vW_MediaViewer`;
$50adab4d566913c2$export$efe229eab43a9869 = `xM81vW_closeButton`;
$50adab4d566913c2$export$3ea4c15e263a0c0f = `xM81vW_completionText`;
$50adab4d566913c2$export$f02cbb504f26b596 = `xM81vW_externalLinkButton`;
$50adab4d566913c2$export$e8043fb4712c8bde = `xM81vW_externalLinkImage`;
$50adab4d566913c2$export$17fa98cb055e8fa7 = `xM81vW_fontSizeH1`;
$50adab4d566913c2$export$a5833c2b43ca4340 = `xM81vW_fontSizeH2`;
$50adab4d566913c2$export$47511f9a6581d1d6 = `xM81vW_fontSizeH3`;
$50adab4d566913c2$export$dd1c05b92185401c = `xM81vW_fontSizeH4`;
$50adab4d566913c2$export$8b28cf6cd00fe080 = `xM81vW_fontSizeH5`;
$50adab4d566913c2$export$186c650311ff0789 = `xM81vW_fontSizeH6`;
$50adab4d566913c2$export$6746fe0d9c9fab54 = `xM81vW_fontSizeSmall`;
$50adab4d566913c2$export$2bcf359f0c20e94f = `xM81vW_fontSizeTiny`;
$50adab4d566913c2$export$2903d10d531d0ac0 = `xM81vW_fontSizep`;
$50adab4d566913c2$export$65303a24f2d95a8e = `xM81vW_imageViewerImage`;
$50adab4d566913c2$export$e91e3cc91e00b6bb = `xM81vW_mediaContainer`;
$50adab4d566913c2$export$add244bda2f9423c = `xM81vW_modalContent`;
$50adab4d566913c2$export$29dd17c7f3c81c36 = `xM81vW_overlay`;
$50adab4d566913c2$export$9a127c71011fa931 = `xM81vW_roundVideoProgressBar`;
$50adab4d566913c2$export$369cc45c1d328fdd = `xM81vW_scale-up`;
$50adab4d566913c2$export$369cc45c1d328fdd;
$50adab4d566913c2$export$b7cb80c25ebba28e = `xM81vW_transformContent`;
$50adab4d566913c2$export$c3bda81a5133bfa4 = `xM81vW_transformWrapper`;
$50adab4d566913c2$export$4e866d6d2e0629f8 = `xM81vW_videoIframe`;
$50adab4d566913c2$export$b82b8842228620ec = `xM81vW_videoWrapper`;


// Conditionally import theme-specific styles (which include base styles via @import)
const $7cf519921f906496$var$styles = (()=>{
    return $50adab4d566913c2$exports;
})();
function $7cf519921f906496$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const currentlyViewingMedia = (0, $6lYLL.useAppSelector)((state)=>state.app.currentlyViewingMedia);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const theme = (0, $cEIti.useTheme)();
    const videoBorderImageUrl = theme.customJSON?.mediaViewer?.videoBorderImageUrl;
    (0, $8FY87.useEffect)(()=>{
        if (currentlyViewingMedia?.resourceUrl) {
            (0, $i7H0N.sendEventV2)("media_viewed", [
                currentlyViewingMedia.resourceType,
                currentlyViewingMedia.resourceUrl
            ]);
            setTimeout(()=>{
                closeButtonRef.current?.focus();
            }, 200);
        }
    }, [
        currentlyViewingMedia?.resourceUrl
    ]);
    if (!currentlyViewingMedia?.resourceUrl || !currentlyViewingMedia?.resourceType) return null;
    const ImageContainer = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)((0, $d5e694cf5f7e70cc$export$51cb649375dcd655), {
            limitToBounds: true,
            centerOnInit: true,
            doubleClick: {
                mode: "toggle"
            },
            centerZoomedOut: true,
            pinch: {
                step: 10
            },
            panning: {
                velocityDisabled: true
            },
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d5e694cf5f7e70cc$export$1def2aa75b7c7fe0), {
                wrapperClass: $7cf519921f906496$var$styles.transformWrapper,
                contentClass: $7cf519921f906496$var$styles.transformContent,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                    className: $7cf519921f906496$var$styles.imageViewerImage,
                    src: currentlyViewingMedia?.resourceUrl || "",
                    alt: currentlyViewingMedia?.description ?? " "
                })
            })
        });
    const VideoContainer = ()=>{
        if (!currentlyViewingMedia?.resourceUrl) {
            console.warn("Cannot display content - no resource URL");
            return "Cannot display content";
        }
        const url = currentlyViewingMedia.resourceUrl;
        let playerType = null;
        let videoId = null;
        // Determine player type and extract video ID
        if (url.includes("youtube.com/watch")) {
            playerType = "youtube";
            videoId = (0, $60ce9ce3870329ca$export$acf5185a61c48950)(url);
        } else if (url.includes("cloudflarestream.com")) {
            playerType = "cloudflare";
            videoId = (0, $ab6be940c2b62fa3$export$f3460e1f346f034d)(url);
        }
        if (!playerType || !videoId) {
            console.warn("Unrecognised video type or invalid video URL");
            return "Cannot display content";
        }
        return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: $7cf519921f906496$var$styles.videoWrapper,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $0d29274c22c69851$export$f503bc85d719e8b0), {
                videoUrl: url,
                videoId: videoId,
                playerType: playerType,
                className: $7cf519921f906496$var$styles.videoIframe,
                roundProgressBarClassName: $7cf519921f906496$var$styles.roundVideoProgressBar,
                completionTextClassName: $7cf519921f906496$var$styles.completionText,
                hasCompletionText: currentlyViewingMedia.requiredForMissionComplete,
                preCompletionText: "Complete the video to unlock reward",
                postCompletionText: "Video completed",
                enforcedViewing: currentlyViewingMedia.enforcedViewing,
                onMilestone: (val, isFirstTimeMilestoneReached)=>{
                    if (currentlyViewingMedia.requiredForMissionComplete) {
                        // After 90% we will wait for 100 to complete quest
                        if (val <= 90 && isFirstTimeMilestoneReached) {
                            if (0, $aTRs6.IS_DISCORD_ACTIVITY) // Only send each quest progress once ever as not critical and to avoid progress api spam
                            (0, $764u1.setQuestProgress)(val);
                        }
                    }
                },
                onComplete: ()=>{
                    (0, $359862929bb6f0e3$export$e8c0cceb0fbfc44c).current?.sendEvent("video-completed", currentlyViewingMedia);
                    if (currentlyViewingMedia.requiredForMissionComplete) {
                        dispatch((0, $4KKbJ.setMissionComplete)());
                        if (0, $aTRs6.IS_DISCORD_ACTIVITY) {
                            // Send quest complete regardless of isFirstWatch in case previous completion failed
                            (0, $764u1.setQuestCompleted)();
                            dispatch((0, $hzaQx.setQuestStatus)("completed"));
                        }
                    }
                }
            })
        });
    };
    const LinkContainer = ()=>{
        if (currentlyViewingMedia?.additionalImageUrl && currentlyViewingMedia?.resourceUrl && currentlyViewingMedia?.description) return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                    className: $7cf519921f906496$var$styles.externalLinkImage,
                    src: currentlyViewingMedia.additionalImageUrl,
                    alt: " "
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $99c71e3b0a0dc87b$export$29d11c0fe2fc51d8), {
                    className: $7cf519921f906496$var$styles.externalLinkButton,
                    href: currentlyViewingMedia.resourceUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: currentlyViewingMedia.description
                })
            ]
        });
        console.warn("Cannot display externalLink");
        return "Cannot display content";
    };
    const getMedia = ()=>{
        switch(currentlyViewingMedia?.resourceType){
            case "image":
                return ImageContainer();
            case "video":
                return VideoContainer();
            case "externalLink":
                return LinkContainer();
            default:
                console.warn("Cannot display content, unrecognised type: " + currentlyViewingMedia?.resourceType);
                return "Cannot display content";
        }
    };
    const onClose = ()=>{
        if (currentlyViewingMedia?.resourceType && currentlyViewingMedia?.resourceUrl) (0, $i7H0N.sendEventV2)("media_closed", [
            currentlyViewingMedia.resourceType,
            currentlyViewingMedia.resourceUrl
        ]);
        dispatch((0, $baXkz.setCurrentlyViewingMedia)(null));
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7cf519921f906496$var$styles.MediaViewer, $7cf519921f906496$var$styles[currentlyViewingMedia?.resourceType]),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $7cf519921f906496$var$styles.overlay
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: $7cf519921f906496$var$styles.modalContent,
                "aria-modal": true,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        iconType: "close",
                        onClick: onClose,
                        className: $7cf519921f906496$var$styles.closeButton,
                        buttonStyle: "round",
                        ariaLabel: "Close Image",
                        buttonRef: closeButtonRef
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $7cf519921f906496$var$styles.mediaContainer,
                        style: videoBorderImageUrl ? {
                            backgroundImage: `url('${videoBorderImageUrl}')`
                        } : undefined,
                        children: getMedia()
                    })
                ]
            })
        ]
    });
} /* 
Can be activated using arise events such as:
arise.postMessage('view-media', {resourceUrl: 'http://www.link.com', resourceType: 'externalLink', description: 'Click me for stuff', additionalImageUrl: 'www.image.com/image.png' });
arise.postMessage('view-media', {resourceUrl: 'https://url.com/2KULjU8xlO.webp', resourceType: 'image', description: 'Something'});
arise.postMessage('view-media', {resourceUrl: 'https://www.youtube.com/watch?v=vlxi3CwQd4Q', resourceType: 'video', description: 'Something'});
arise.postMessage('view-media', {resourceUrl: 'https://customer-c6kmyujkvesrdmhe.cloudflarestream.com/8518455b5c04c692392f39562eaf8fa2/iframe', resourceType: 'video', enforcedViewing: true});
*/ 




var $625rg = parcelRequire("625rg");
function $72d7b920133c70e4$export$2eb236097d011acd() {
    const data = {
        platform: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).name,
        device: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).product,
        device_manufacturer: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).manufacturer,
        device_model: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).product,
        os_name: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).os.family,
        os_version: (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).os.version
    };
    if (!data.device_manufacturer) {
        if (data.os_name === "OS X") data.device_manufacturer = "Apple";
    }
    return data;
}
function $72d7b920133c70e4$export$9fe8015f50ae7666() {
    const referrer = document.referrer || "";
    const browser = `${(0, (/*@__PURE__*/$parcel$interopDefault($625rg))).name || "Unknown"} ${(0, (/*@__PURE__*/$parcel$interopDefault($625rg))).version || ""}`.trim();
    const os = (0, (/*@__PURE__*/$parcel$interopDefault($625rg))).os?.family || "Unknown";
    const page = window.location.href;
    const userAgent = navigator.userAgent;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    return {
        strings: [
            referrer,
            browser,
            os,
            page,
            userAgent
        ],
        numbers: [
            screenWidth,
            screenHeight
        ]
    };
}



var $i7H0N = parcelRequire("i7H0N");
function $a28589f4827e1ded$export$a0769f17975cb672() {
    try {
        const { strings: strings, numbers: numbers } = (0, $72d7b920133c70e4$export$9fe8015f50ae7666)();
        (0, $i7H0N.sendEventV2Once)("pageview", strings, numbers);
    } catch (err) {
        console.warn("Failed to send pageview event", err);
    }
}
function $a28589f4827e1ded$var$isSoftwareRenderer(renderer) {
    const softwareRenderers = [
        "swiftshader",
        "llvmpipe",
        "softpipe",
        "lavapipe",
        "microsoft basic render",
        "direct3d11 warp",
        "warp",
        "gdi generic",
        "software rasterizer",
        "software renderer",
        "software adapter",
        "apple software renderer"
    ];
    return softwareRenderers.some((sw)=>renderer.toLowerCase().includes(sw));
}
function $a28589f4827e1ded$export$b494c8ee88b3a008() {
    try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        let renderer = "unknown";
        let type = "software";
        if (gl) {
            const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
            if (debugInfo) {
                const r = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
                if (typeof r === "string") {
                    renderer = r;
                    type = $a28589f4827e1ded$var$isSoftwareRenderer(renderer) ? "software" : "hardware";
                }
            } else {
                console.log("[Arise] Graphics capability: No debug renderer info, defaulting to hardware");
                type = "hardware";
            }
        }
        console.log("[Arise] Graphics capability:", [
            renderer,
            type
        ]);
        (0, $i7H0N.sendEventV2Once)("graphics_capability", [
            renderer,
            type
        ]);
    } catch (err) {
        console.log("[Arise] Graphics capability failed to send", err);
    }
}



var $f9aoP = parcelRequire("f9aoP");

var $1URoE = parcelRequire("1URoE");

var $cEIti = parcelRequire("cEIti");
var $1c24d8d5442c4687$export$2a82ddc22e8c7fbb;
var $1c24d8d5442c4687$export$fc6855fecb80bb3f;
var $1c24d8d5442c4687$export$17fa98cb055e8fa7;
var $1c24d8d5442c4687$export$a5833c2b43ca4340;
var $1c24d8d5442c4687$export$47511f9a6581d1d6;
var $1c24d8d5442c4687$export$dd1c05b92185401c;
var $1c24d8d5442c4687$export$8b28cf6cd00fe080;
var $1c24d8d5442c4687$export$186c650311ff0789;
var $1c24d8d5442c4687$export$6746fe0d9c9fab54;
var $1c24d8d5442c4687$export$2bcf359f0c20e94f;
var $1c24d8d5442c4687$export$2903d10d531d0ac0;
var $1c24d8d5442c4687$export$1a2a2e04fdf9f489;
var $1c24d8d5442c4687$export$cc09b7862278318c;
$1c24d8d5442c4687$export$2a82ddc22e8c7fbb = `iF1WSW_contentWrapper`;
$1c24d8d5442c4687$export$fc6855fecb80bb3f = `iF1WSW_contentWrapper--sidebarOpen`;
$1c24d8d5442c4687$export$17fa98cb055e8fa7 = `iF1WSW_fontSizeH1`;
$1c24d8d5442c4687$export$a5833c2b43ca4340 = `iF1WSW_fontSizeH2`;
$1c24d8d5442c4687$export$47511f9a6581d1d6 = `iF1WSW_fontSizeH3`;
$1c24d8d5442c4687$export$dd1c05b92185401c = `iF1WSW_fontSizeH4`;
$1c24d8d5442c4687$export$8b28cf6cd00fe080 = `iF1WSW_fontSizeH5`;
$1c24d8d5442c4687$export$186c650311ff0789 = `iF1WSW_fontSizeH6`;
$1c24d8d5442c4687$export$6746fe0d9c9fab54 = `iF1WSW_fontSizeSmall`;
$1c24d8d5442c4687$export$2bcf359f0c20e94f = `iF1WSW_fontSizeTiny`;
$1c24d8d5442c4687$export$2903d10d531d0ac0 = `iF1WSW_fontSizep`;
$1c24d8d5442c4687$export$1a2a2e04fdf9f489 = `iF1WSW_sidebarWrapper`;
$1c24d8d5442c4687$export$cc09b7862278318c = `iF1WSW_sidebarWrapper--sidebarOpen`;


function $f526d2822c310d5a$export$2e2bcd8739ae039() {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const [isBackgroundReady, setIsBackgroundReady] = (0, $8FY87.useState)(false);
    const [isIFrameReady, setIsIFrameReady] = (0, $8FY87.useState)(false);
    const [locationIntroductionHasCompleted, setLocationIntroductionHasCompleted] = (0, $8FY87.useState)(false);
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const { universeId: universeId, location: location, isLocationLoading: isLocationLoading, isSidebarOpen: isSidebarOpen, isExitLocationModalOpen: isExitLocationModalOpen, isLeaderboardOpen: isLeaderboardOpen, locationLoadErrorId: locationLoadErrorId, isInventoryOpen: isInventoryOpen, isPurchaseInProgress: isPurchaseInProgress } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const { hasFailed: hasFailed } = (0, $63dd9757c13a1072$export$2e2bcd8739ae039)();
    const { locationId: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    const pusherChannel = (0, $8FY87.useMemo)(()=>{
        if (location) {
            if (location.customJSON && location.customJSON.useGlobalChat) return "private-arise-global-chat-" + universeId;
            else return "private-" + id;
        }
        return "";
    }, [
        location
    ]);
    (0, $846d17acc742908f$export$1be25102dee524a0)(pusherChannel, id);
    const locationIsClosed = !isLocationLoading && location?.id === id && !location.isOpen;
    (0, $8FY87.useEffect)(()=>{
        // Redirect if closed
        // Allow superadmins to access location when closed
        if (locationIsClosed && currentUserProfile && currentUserProfile.role !== "superadmin") navigate((0, $1URoE.homePath));
    }, [
        isLocationLoading,
        location,
        currentUserProfile?.role
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Redirect if not found
        if (locationLoadErrorId === id) navigate((0, $1URoE.homePath));
    }, [
        locationLoadErrorId
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Reset UI on load
        dispatch((0, $baXkz.setIsInventoryOpen)(false));
        dispatch((0, $baXkz.setIsExitLocationModalOpen)(false));
        dispatch((0, $baXkz.setIsLeaderboardOpen)(false));
        dispatch((0, $baXkz.closeProfile)());
        // Clear event on load
        // TODO: In future make call to check for events
        dispatch((0, $kyBxf.clearCurrentEvent)());
        if ((!location || location.id !== id) && !isLocationLoading) dispatch((0, $baXkz.loadLocation)(id));
        dispatch((0, $kyBxf.loadAvailableReactions)());
        (0, $a28589f4827e1ded$export$a0769f17975cb672)();
        (0, $a28589f4827e1ded$export$b494c8ee88b3a008)();
        $f9aoP.heartbeat(id);
        const interval = setInterval(()=>{
            $f9aoP.heartbeat(id);
        }, 30000); // 30s
        return ()=>{
            clearInterval(interval);
        };
    }, [
        id
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (!location) return;
        const globalChat = location.customJSON && location.customJSON.useGlobalChat;
        dispatch((0, $kyBxf.getPreviousMessages)({
            id: id,
            globalChat: globalChat,
            isLatest: true
        }));
    }, [
        location
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Play location background music from CMS
        audio.stopAll();
        if (location?.backgroundMusicURL) {
            const backgroundMusicId = `location-bg-music-${location.id}`;
            if (!audio.hasTrack(backgroundMusicId)) audio.addTrack({
                id: backgroundMusicId,
                src: location.backgroundMusicURL,
                ambient: true,
                volume: 0.5
            });
            audio.playOnly(backgroundMusicId);
        }
    }, [
        location?.backgroundMusicURL
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (isPurchaseInProgress) // If doing a purchase, don't show location intro
        setLocationIntroductionHasCompleted(true);
    }, [
        isPurchaseInProgress
    ]);
    // TODO: loading
    if (!location || location.id !== id || locationIsClosed && currentUserProfile?.role !== "superadmin") return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    const iframeURL = location.iframeURL || location.latestArisewareBuildURL;
    const isAModalOpen = isInventoryOpen || isExitLocationModalOpen || isLeaderboardOpen;
    const getBackgroundTransformOrigin = ()=>{
        const yValue = isSidebarOpen ? "70%" : "center";
        const xValue = isAModalOpen || !isIFrameReady ? "60%" : "center";
        return yValue + " " + xValue;
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $35917d57cc14df8a$export$2e2bcd8739ae039), {
                    imagePath: (0, $aTKgi.pathToURL)(location.backgroundImagePath),
                    blur: isBackgroundReady ? 0 : 10,
                    zoom: 1.5,
                    transformOrigin: getBackgroundTransformOrigin(),
                    onImageLoaded: ()=>setIsBackgroundReady(true)
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1c24d8d5442c4687$export$2a82ddc22e8c7fbb, {
                        [$1c24d8d5442c4687$export$fc6855fecb80bb3f]: isSidebarOpen
                    }),
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d612fdc595978133$export$2e2bcd8739ae039), {
                            src: iframeURL,
                            arisewareProjectID: location.arisewareProjectID,
                            style: {
                                transition: "transform 310ms linear"
                            },
                            onReady: ()=>setIsIFrameReady(true),
                            loadingText: theme.metadata?.customJSON?.loadingText
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a097d059bec51579$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1b92270b3f8c4d42$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $416c8a6c2bbe3c1f$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c28b3bc7c5a3f98b$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $641a0332b178f9cd$export$2e2bcd8739ae039), {
                            failed: hasFailed
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $60ba48ffbe0ae6e8$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3657b3ca0d43c577$export$2e2bcd8739ae039), {})
            ]
        });
    };
    if (location.hasRoomIntroduction && !locationIntroductionHasCompleted) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $40d9665fe7f92bb6$export$2e2bcd8739ae039), {
        titlePrefix: location.locationNamePrefix,
        titleText: location.name,
        text: location.roomIntroductionText,
        imageUrl: location.customJSON.roomIntroductionImage,
        hasSoundWarning: location.roomIntroductionHasSoundWarning,
        onComplete: ()=>setLocationIntroductionHasCompleted(true)
    });
    else return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4eb1e267ba3c534d$export$2e2bcd8739ae039), {
        pageHasProfileDrawer: true,
        children: [
            renderContent(),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1c24d8d5442c4687$export$1a2a2e04fdf9f489, {
                    [$1c24d8d5442c4687$export$cc09b7862278318c]: isSidebarOpen
                }),
                children: location && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e7edf3b32b0bb599$export$2e2bcd8739ae039), {
                    locationTitle: location.locationNamePrefix,
                    locationName: location.name
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7cf519921f906496$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eaf2d4aabcdd6ef8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $594d75f980968ad1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a111644098382f12$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $9s93Y = parcelRequire("9s93Y");



var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $aTRs6 = parcelRequire("aTRs6");

var $cEIti = parcelRequire("cEIti");

var $4KKbJ = parcelRequire("4KKbJ");

var $764u1 = parcelRequire("764u1");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");



var $4MZsN = parcelRequire("4MZsN");

var $i7H0N = parcelRequire("i7H0N");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $aTKgi = parcelRequire("aTKgi");
var $757ced1cfabc3dd8$export$f8ab115d87e210a;
var $757ced1cfabc3dd8$export$17fa98cb055e8fa7;
var $757ced1cfabc3dd8$export$a5833c2b43ca4340;
var $757ced1cfabc3dd8$export$47511f9a6581d1d6;
var $757ced1cfabc3dd8$export$dd1c05b92185401c;
var $757ced1cfabc3dd8$export$8b28cf6cd00fe080;
var $757ced1cfabc3dd8$export$186c650311ff0789;
var $757ced1cfabc3dd8$export$6746fe0d9c9fab54;
var $757ced1cfabc3dd8$export$2bcf359f0c20e94f;
var $757ced1cfabc3dd8$export$2903d10d531d0ac0;
var $757ced1cfabc3dd8$export$73920f18ca706874;
var $757ced1cfabc3dd8$export$5c452ff88e35e47d;
var $757ced1cfabc3dd8$export$c7187bbd1a7a9244;
var $757ced1cfabc3dd8$export$4a6dd88bada4e7d2;
var $757ced1cfabc3dd8$export$e14a7373aa46b344;
$757ced1cfabc3dd8$export$f8ab115d87e210a = `oDT0tG_LevelBadge`;
$757ced1cfabc3dd8$export$17fa98cb055e8fa7 = `oDT0tG_fontSizeH1`;
$757ced1cfabc3dd8$export$a5833c2b43ca4340 = `oDT0tG_fontSizeH2`;
$757ced1cfabc3dd8$export$47511f9a6581d1d6 = `oDT0tG_fontSizeH3`;
$757ced1cfabc3dd8$export$dd1c05b92185401c = `oDT0tG_fontSizeH4`;
$757ced1cfabc3dd8$export$8b28cf6cd00fe080 = `oDT0tG_fontSizeH5`;
$757ced1cfabc3dd8$export$186c650311ff0789 = `oDT0tG_fontSizeH6`;
$757ced1cfabc3dd8$export$6746fe0d9c9fab54 = `oDT0tG_fontSizeSmall`;
$757ced1cfabc3dd8$export$2bcf359f0c20e94f = `oDT0tG_fontSizeTiny`;
$757ced1cfabc3dd8$export$2903d10d531d0ac0 = `oDT0tG_fontSizep`;
$757ced1cfabc3dd8$export$73920f18ca706874 = `oDT0tG_hidden`;
$757ced1cfabc3dd8$export$5c452ff88e35e47d = `oDT0tG_image`;
$757ced1cfabc3dd8$export$c7187bbd1a7a9244 = `oDT0tG_placeholder`;
$757ced1cfabc3dd8$export$4a6dd88bada4e7d2 = `oDT0tG_shimmer`;
$757ced1cfabc3dd8$export$4a6dd88bada4e7d2;
$757ced1cfabc3dd8$export$e14a7373aa46b344 = `oDT0tG_shiny`;


function $30206c92d1e90dc2$export$2e2bcd8739ae039({ imagePath: imagePath, isLoading: isLoading, isLocked: isLocked, classname: classname, shimmerDelay: shimmerDelay = 0 }) {
    const [imageIsLoading, setImageIsLoading] = (0, $8FY87.useState)(true);
    const shouldShowPlaceholder = isLoading || imageIsLoading;
    const imageUrl = imagePath ? (0, $aTKgi.pathToURL)(imagePath) : "";
    const handleImageLoad = ()=>{
        setImageIsLoading(false);
    };
    // Once loaded, show padlock icon if locked
    if (!isLoading && isLocked) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($757ced1cfabc3dd8$export$f8ab115d87e210a, classname),
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
            className: $757ced1cfabc3dd8$export$5c452ff88e35e47d,
            width: "127",
            height: "111",
            viewBox: "0 0 127 111",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z",
                    fill: "#4E4E4E"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M85.8068 55.3966L85.6556 51.8232C84.9669 50.9671 84.4713 50.355 83.7825 49.4989L80.5529 48.6097L80.7209 48.0969L82.0858 43.8783L82.4932 38.6754L80.8973 33.6959L77.3737 29.8289L72.6994 27.5087L67.4832 27L62.5065 28.6378L58.4874 31.9465L55.8499 36.471L54.6698 40.7475L54.5606 41.1321L51.499 40.2801C50.4364 40.6855 49.6931 40.9667 48.6263 41.372L46.6986 44.4077L43.3976 48.8496L45.7873 54.5322L44.4224 58.6763L43.2422 62.8163L41.4699 63.6765L40 67.9737L43.3598 71.3444L46.56 74.8309L49.7057 78.3711L52.9101 81.8535L56.1607 82.8254L56.9586 83.0612L60.2429 84L64.8122 82.6186L69.4655 81.5433L74.0097 80.0792L78.6294 78.8633L79.6962 74.4752L78.8184 72.8209L79.9187 68.6974L81.0107 64.4913L86 60.86L85.8068 55.4007V55.3966ZM66.0217 61.4928L64.7786 71.2782L55.8625 68.7595L60.0749 59.8137L57.6558 55.5165L65.8411 51.0457L70.3811 59.1064L66.0175 61.4887L66.0217 61.4928ZM75.908 43.3696L74.837 47.0257L73.8711 46.7569L68.0502 44.966L67.2775 44.6434L61.3558 43.2125L60.6166 42.985L61.7254 39.2958C61.9396 38.5886 62.2839 37.9269 62.7459 37.3437L64.4384 35.2096C65.0978 34.3742 66.0721 33.8365 67.1389 33.7083L69.4151 33.4395C70.4525 33.3154 71.4982 33.5925 72.334 34.2129L74.1903 35.5901C75.0722 36.2436 75.6434 37.2238 75.7736 38.2991L76.1012 41.0577C76.1936 41.8352 76.1264 42.6252 75.908 43.3779V43.3696Z",
                    fill: "#1D1D1D"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($757ced1cfabc3dd8$export$f8ab115d87e210a, classname),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($757ced1cfabc3dd8$export$5c452ff88e35e47d, {
                    [$757ced1cfabc3dd8$export$73920f18ca706874]: shouldShowPlaceholder
                }),
                src: imageUrl,
                alt: " ",
                crossOrigin: "anonymous",
                onLoad: handleImageLoad
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("svg", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($757ced1cfabc3dd8$export$5c452ff88e35e47d, $757ced1cfabc3dd8$export$c7187bbd1a7a9244, {
                    [$757ced1cfabc3dd8$export$73920f18ca706874]: !shouldShowPlaceholder
                }),
                width: "127",
                height: "111",
                viewBox: "0 0 127 111",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("path", {
                    d: "M125.557 53C126.45 54.547 126.45 56.453 125.557 58L96.6934 107.993C95.8002 109.54 94.1496 110.493 92.3632 110.493L34.6368 110.493C32.8504 110.493 31.1998 109.54 30.3066 107.993L1.44338 58C0.550221 56.453 0.550214 54.547 1.44338 53L30.3066 3.00738C31.1998 1.46038 32.8504 0.507385 34.6368 0.507385L92.3632 0.507388C94.1496 0.507388 95.8002 1.46038 96.6934 3.00739L125.557 53Z",
                    fill: "#1B1B1B"
                })
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $757ced1cfabc3dd8$export$e14a7373aa46b344,
                style: {
                    maskImage: `url(${imageUrl})`
                },
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    style: {
                        animationDelay: `${shimmerDelay * 2}s`
                    }
                })
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $4MZsN = parcelRequire("4MZsN");
var $19f02e0698dd162d$export$f33936b5e796863b;
var $19f02e0698dd162d$export$5bb2c6667794e5f8;
var $19f02e0698dd162d$export$17fa98cb055e8fa7;
var $19f02e0698dd162d$export$a5833c2b43ca4340;
var $19f02e0698dd162d$export$47511f9a6581d1d6;
var $19f02e0698dd162d$export$dd1c05b92185401c;
var $19f02e0698dd162d$export$8b28cf6cd00fe080;
var $19f02e0698dd162d$export$186c650311ff0789;
var $19f02e0698dd162d$export$6746fe0d9c9fab54;
var $19f02e0698dd162d$export$2bcf359f0c20e94f;
var $19f02e0698dd162d$export$2903d10d531d0ac0;
var $19f02e0698dd162d$export$1ca1ec8b29a4ce27;
var $19f02e0698dd162d$export$acf4eaf431084f78;
var $19f02e0698dd162d$export$4662439d93cf9393;
var $19f02e0698dd162d$export$ff6b2b0d8ced9310;
$19f02e0698dd162d$export$f33936b5e796863b = `_15WVcW_RoundProgressBar`;
$19f02e0698dd162d$export$5bb2c6667794e5f8 = `_15WVcW_backgroundCircle`;
$19f02e0698dd162d$export$17fa98cb055e8fa7 = `_15WVcW_fontSizeH1`;
$19f02e0698dd162d$export$a5833c2b43ca4340 = `_15WVcW_fontSizeH2`;
$19f02e0698dd162d$export$47511f9a6581d1d6 = `_15WVcW_fontSizeH3`;
$19f02e0698dd162d$export$dd1c05b92185401c = `_15WVcW_fontSizeH4`;
$19f02e0698dd162d$export$8b28cf6cd00fe080 = `_15WVcW_fontSizeH5`;
$19f02e0698dd162d$export$186c650311ff0789 = `_15WVcW_fontSizeH6`;
$19f02e0698dd162d$export$6746fe0d9c9fab54 = `_15WVcW_fontSizeSmall`;
$19f02e0698dd162d$export$2bcf359f0c20e94f = `_15WVcW_fontSizeTiny`;
$19f02e0698dd162d$export$2903d10d531d0ac0 = `_15WVcW_fontSizep`;
$19f02e0698dd162d$export$1ca1ec8b29a4ce27 = `_15WVcW_icon`;
$19f02e0698dd162d$export$acf4eaf431084f78 = `_15WVcW_iconContainer`;
$19f02e0698dd162d$export$4662439d93cf9393 = `_15WVcW_progressCircle`;
$19f02e0698dd162d$export$ff6b2b0d8ced9310 = `_15WVcW_progressSvg`;


function $07475a5ca7821ac5$export$2e2bcd8739ae039({ percent: percent, className: className, icon: icon }) {
    const radius = 45;
    const circumference = 2 * Math.PI * radius;
    if (percent === 0) percent = 1; // Minimum is 1% as looks better
    const strokeDashoffset = percent ? circumference - percent / 100 * circumference : 0;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($19f02e0698dd162d$export$f33936b5e796863b, className),
        "aria-label": `Progress: ${percent}%`,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("svg", {
                className: $19f02e0698dd162d$export$ff6b2b0d8ced9310,
                viewBox: "0 0 100 100",
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                        className: $19f02e0698dd162d$export$5bb2c6667794e5f8,
                        cx: "50",
                        cy: "50",
                        r: radius,
                        strokeWidth: "8",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("circle", {
                        className: $19f02e0698dd162d$export$4662439d93cf9393,
                        cx: "50",
                        cy: "50",
                        r: radius,
                        strokeWidth: "8",
                        fill: "none",
                        strokeDasharray: circumference,
                        strokeDashoffset: strokeDashoffset
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $19f02e0698dd162d$export$acf4eaf431084f78,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                    type: icon,
                    className: $19f02e0698dd162d$export$1ca1ec8b29a4ce27
                })
            })
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $347ac75261c79584$export$4901f5ee9fa34af9;
var $347ac75261c79584$export$e141060ad697f932;
var $347ac75261c79584$export$4a6dd88bada4e7d2;
$347ac75261c79584$export$4901f5ee9fa34af9 = `KoX25a_ShinyLoader`;
$347ac75261c79584$export$e141060ad697f932 = `KoX25a_isLoaded`;
$347ac75261c79584$export$4a6dd88bada4e7d2 = `KoX25a_shimmer`;
$347ac75261c79584$export$4a6dd88bada4e7d2;


function $1145929b19f809ce$export$2e2bcd8739ae039({ isLoaded: isLoaded, className: className }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($347ac75261c79584$export$4901f5ee9fa34af9, {
            [$347ac75261c79584$export$e141060ad697f932]: isLoaded
        }, className)
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");
var $0d08c6f4c5ecd814$exports = {};

$parcel$export($0d08c6f4c5ecd814$exports, "Badge", function () { return $0d08c6f4c5ecd814$export$37acb3580601e69a; }, function (v) { return $0d08c6f4c5ecd814$export$37acb3580601e69a = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "common", function () { return $0d08c6f4c5ecd814$export$919daad019702595; }, function (v) { return $0d08c6f4c5ecd814$export$919daad019702595 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "epic", function () { return $0d08c6f4c5ecd814$export$8ec5145af6f76965; }, function (v) { return $0d08c6f4c5ecd814$export$8ec5145af6f76965 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH1", function () { return $0d08c6f4c5ecd814$export$17fa98cb055e8fa7; }, function (v) { return $0d08c6f4c5ecd814$export$17fa98cb055e8fa7 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH2", function () { return $0d08c6f4c5ecd814$export$a5833c2b43ca4340; }, function (v) { return $0d08c6f4c5ecd814$export$a5833c2b43ca4340 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH3", function () { return $0d08c6f4c5ecd814$export$47511f9a6581d1d6; }, function (v) { return $0d08c6f4c5ecd814$export$47511f9a6581d1d6 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH4", function () { return $0d08c6f4c5ecd814$export$dd1c05b92185401c; }, function (v) { return $0d08c6f4c5ecd814$export$dd1c05b92185401c = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH5", function () { return $0d08c6f4c5ecd814$export$8b28cf6cd00fe080; }, function (v) { return $0d08c6f4c5ecd814$export$8b28cf6cd00fe080 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeH6", function () { return $0d08c6f4c5ecd814$export$186c650311ff0789; }, function (v) { return $0d08c6f4c5ecd814$export$186c650311ff0789 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeSmall", function () { return $0d08c6f4c5ecd814$export$6746fe0d9c9fab54; }, function (v) { return $0d08c6f4c5ecd814$export$6746fe0d9c9fab54 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizeTiny", function () { return $0d08c6f4c5ecd814$export$2bcf359f0c20e94f; }, function (v) { return $0d08c6f4c5ecd814$export$2bcf359f0c20e94f = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "fontSizep", function () { return $0d08c6f4c5ecd814$export$2903d10d531d0ac0; }, function (v) { return $0d08c6f4c5ecd814$export$2903d10d531d0ac0 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "legendary", function () { return $0d08c6f4c5ecd814$export$9738149b23403ba; }, function (v) { return $0d08c6f4c5ecd814$export$9738149b23403ba = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "rare", function () { return $0d08c6f4c5ecd814$export$b2e68d2f08b863d2; }, function (v) { return $0d08c6f4c5ecd814$export$b2e68d2f08b863d2 = v; });
$parcel$export($0d08c6f4c5ecd814$exports, "uncommon", function () { return $0d08c6f4c5ecd814$export$76bf72d8613283e6; }, function (v) { return $0d08c6f4c5ecd814$export$76bf72d8613283e6 = v; });
var $0d08c6f4c5ecd814$export$37acb3580601e69a;
var $0d08c6f4c5ecd814$export$919daad019702595;
var $0d08c6f4c5ecd814$export$8ec5145af6f76965;
var $0d08c6f4c5ecd814$export$17fa98cb055e8fa7;
var $0d08c6f4c5ecd814$export$a5833c2b43ca4340;
var $0d08c6f4c5ecd814$export$47511f9a6581d1d6;
var $0d08c6f4c5ecd814$export$dd1c05b92185401c;
var $0d08c6f4c5ecd814$export$8b28cf6cd00fe080;
var $0d08c6f4c5ecd814$export$186c650311ff0789;
var $0d08c6f4c5ecd814$export$6746fe0d9c9fab54;
var $0d08c6f4c5ecd814$export$2bcf359f0c20e94f;
var $0d08c6f4c5ecd814$export$2903d10d531d0ac0;
var $0d08c6f4c5ecd814$export$9738149b23403ba;
var $0d08c6f4c5ecd814$export$b2e68d2f08b863d2;
var $0d08c6f4c5ecd814$export$76bf72d8613283e6;
$0d08c6f4c5ecd814$export$37acb3580601e69a = `KzALYW_Badge`;
$0d08c6f4c5ecd814$export$919daad019702595 = `KzALYW_common`;
$0d08c6f4c5ecd814$export$8ec5145af6f76965 = `KzALYW_epic`;
$0d08c6f4c5ecd814$export$17fa98cb055e8fa7 = `KzALYW_fontSizeH1`;
$0d08c6f4c5ecd814$export$a5833c2b43ca4340 = `KzALYW_fontSizeH2`;
$0d08c6f4c5ecd814$export$47511f9a6581d1d6 = `KzALYW_fontSizeH3`;
$0d08c6f4c5ecd814$export$dd1c05b92185401c = `KzALYW_fontSizeH4`;
$0d08c6f4c5ecd814$export$8b28cf6cd00fe080 = `KzALYW_fontSizeH5`;
$0d08c6f4c5ecd814$export$186c650311ff0789 = `KzALYW_fontSizeH6`;
$0d08c6f4c5ecd814$export$6746fe0d9c9fab54 = `KzALYW_fontSizeSmall`;
$0d08c6f4c5ecd814$export$2bcf359f0c20e94f = `KzALYW_fontSizeTiny`;
$0d08c6f4c5ecd814$export$2903d10d531d0ac0 = `KzALYW_fontSizep`;
$0d08c6f4c5ecd814$export$9738149b23403ba = `KzALYW_legendary`;
$0d08c6f4c5ecd814$export$b2e68d2f08b863d2 = `KzALYW_rare`;
$0d08c6f4c5ecd814$export$76bf72d8613283e6 = `KzALYW_uncommon`;


function $70b304448aa01420$export$2e2bcd8739ae039({ text: text, rarity: rarity, classname: classname }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($0d08c6f4c5ecd814$exports.Badge, $0d08c6f4c5ecd814$exports[rarity?.toLowerCase()], classname),
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("p", {
            children: [
                "\u201C",
                text,
                "\u201C"
            ]
        })
    });
}



var $8dWjV = parcelRequire("8dWjV");
function $b1cc9907e8d0b608$export$f85c16a6d62f7d63(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) return url;
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) return window.location.protocol + url;
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) return url;
    const doc = document.implementation.createHTMLDocument();
    const base = doc.createElement("base");
    const a = doc.createElement("a");
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
const $b1cc9907e8d0b608$export$31b40729666a4ae0 = (()=>{
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    let counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    const random = ()=>// eslint-disable-next-line no-bitwise
        `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
})();
function $b1cc9907e8d0b608$export$1391212d75b2ee65(ms) {
    return (args)=>new Promise((resolve)=>{
            setTimeout(()=>resolve(args), ms);
        });
}
function $b1cc9907e8d0b608$export$45b10814cc054894(arrayLike) {
    const arr = [];
    for(let i = 0, l = arrayLike.length; i < l; i++)arr.push(arrayLike[i]);
    return arr;
}
let $b1cc9907e8d0b608$var$styleProps = null;
function $b1cc9907e8d0b608$export$be6bf80faea8d5af(options = {}) {
    if ($b1cc9907e8d0b608$var$styleProps) return $b1cc9907e8d0b608$var$styleProps;
    if (options.includeStyleProperties) {
        $b1cc9907e8d0b608$var$styleProps = options.includeStyleProperties;
        return $b1cc9907e8d0b608$var$styleProps;
    }
    $b1cc9907e8d0b608$var$styleProps = $b1cc9907e8d0b608$export$45b10814cc054894(window.getComputedStyle(document.documentElement));
    return $b1cc9907e8d0b608$var$styleProps;
}
function $b1cc9907e8d0b608$var$px(node, styleProperty) {
    const win = node.ownerDocument.defaultView || window;
    const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace("px", "")) : 0;
}
function $b1cc9907e8d0b608$var$getNodeWidth(node) {
    const leftBorder = $b1cc9907e8d0b608$var$px(node, "border-left-width");
    const rightBorder = $b1cc9907e8d0b608$var$px(node, "border-right-width");
    return node.clientWidth + leftBorder + rightBorder;
}
function $b1cc9907e8d0b608$var$getNodeHeight(node) {
    const topBorder = $b1cc9907e8d0b608$var$px(node, "border-top-width");
    const bottomBorder = $b1cc9907e8d0b608$var$px(node, "border-bottom-width");
    return node.clientHeight + topBorder + bottomBorder;
}
function $b1cc9907e8d0b608$export$ada5537b2c061996(targetNode, options = {}) {
    const width = options.width || $b1cc9907e8d0b608$var$getNodeWidth(targetNode);
    const height = options.height || $b1cc9907e8d0b608$var$getNodeHeight(targetNode);
    return {
        width: width,
        height: height
    };
}
function $b1cc9907e8d0b608$export$d39ce20a37bba061() {
    let ratio;
    let FINAL_PROCESS;
    try {
        FINAL_PROCESS = $8dWjV;
    } catch (e) {
    // pass
    }
    const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) ratio = 1;
    }
    return ratio || window.devicePixelRatio || 1;
}
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
const $b1cc9907e8d0b608$var$canvasDimensionLimit = 16384;
function $b1cc9907e8d0b608$export$c2c809a2fe6b0f1a(canvas) {
    if (canvas.width > $b1cc9907e8d0b608$var$canvasDimensionLimit || canvas.height > $b1cc9907e8d0b608$var$canvasDimensionLimit) {
        if (canvas.width > $b1cc9907e8d0b608$var$canvasDimensionLimit && canvas.height > $b1cc9907e8d0b608$var$canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= $b1cc9907e8d0b608$var$canvasDimensionLimit / canvas.width;
                canvas.width = $b1cc9907e8d0b608$var$canvasDimensionLimit;
            } else {
                canvas.width *= $b1cc9907e8d0b608$var$canvasDimensionLimit / canvas.height;
                canvas.height = $b1cc9907e8d0b608$var$canvasDimensionLimit;
            }
        } else if (canvas.width > $b1cc9907e8d0b608$var$canvasDimensionLimit) {
            canvas.height *= $b1cc9907e8d0b608$var$canvasDimensionLimit / canvas.width;
            canvas.width = $b1cc9907e8d0b608$var$canvasDimensionLimit;
        } else {
            canvas.width *= $b1cc9907e8d0b608$var$canvasDimensionLimit / canvas.height;
            canvas.height = $b1cc9907e8d0b608$var$canvasDimensionLimit;
        }
    }
}
function $b1cc9907e8d0b608$export$403d539f215df596(canvas, options = {}) {
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, options.type ? options.type : "image/png", options.quality ? options.quality : 1);
    });
    return new Promise((resolve)=>{
        const binaryString = window.atob(canvas.toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined).split(",")[1]);
        const len = binaryString.length;
        const binaryArray = new Uint8Array(len);
        for(let i = 0; i < len; i += 1)binaryArray[i] = binaryString.charCodeAt(i);
        resolve(new Blob([
            binaryArray
        ], {
            type: options.type ? options.type : "image/png"
        }));
    });
}
function $b1cc9907e8d0b608$export$ec664d7487540b(url) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            img.decode().then(()=>{
                requestAnimationFrame(()=>resolve(img));
            });
        };
        img.onerror = reject;
        img.crossOrigin = "anonymous";
        img.decoding = "async";
        img.src = url;
    });
}
async function $b1cc9907e8d0b608$export$fe77aa9c02de4599(svg) {
    return Promise.resolve().then(()=>new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html)=>`data:image/svg+xml;charset=utf-8,${html}`);
}
async function $b1cc9907e8d0b608$export$b62810fb8ca515fa(node, width, height) {
    const xmlns = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(xmlns, "svg");
    const foreignObject = document.createElementNS(xmlns, "foreignObject");
    svg.setAttribute("width", `${width}`);
    svg.setAttribute("height", `${height}`);
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    foreignObject.setAttribute("width", "100%");
    foreignObject.setAttribute("height", "100%");
    foreignObject.setAttribute("x", "0");
    foreignObject.setAttribute("y", "0");
    foreignObject.setAttribute("externalResourcesRequired", "true");
    svg.appendChild(foreignObject);
    foreignObject.appendChild(node);
    return $b1cc9907e8d0b608$export$fe77aa9c02de4599(svg);
}
const $b1cc9907e8d0b608$export$3a92fc9ec83ef360 = (node, instance)=>{
    if (node instanceof instance) return true;
    const nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null) return false;
    return nodePrototype.constructor.name === instance.name || $b1cc9907e8d0b608$export$3a92fc9ec83ef360(nodePrototype, instance);
};


function $33570b972b8a80f1$var$formatCSSText(style) {
    const content = style.getPropertyValue("content");
    return `${style.cssText} content: '${content.replace(/'|"/g, "")}';`;
}
function $33570b972b8a80f1$var$formatCSSProperties(style, options) {
    return (0, $b1cc9907e8d0b608$export$be6bf80faea8d5af)(options).map((name)=>{
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        return `${name}: ${value}${priority ? " !important" : ""};`;
    }).join(" ");
}
function $33570b972b8a80f1$var$getPseudoElementStyle(className, pseudo, style, options) {
    const selector = `.${className}:${pseudo}`;
    const cssText = style.cssText ? $33570b972b8a80f1$var$formatCSSText(style) : $33570b972b8a80f1$var$formatCSSProperties(style, options);
    return document.createTextNode(`${selector}{${cssText}}`);
}
function $33570b972b8a80f1$var$clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
    const style = window.getComputedStyle(nativeNode, pseudo);
    const content = style.getPropertyValue("content");
    if (content === "" || content === "none") return;
    const className = (0, $b1cc9907e8d0b608$export$31b40729666a4ae0)();
    try {
        clonedNode.className = `${clonedNode.className} ${className}`;
    } catch (err) {
        return;
    }
    const styleElement = document.createElement("style");
    styleElement.appendChild($33570b972b8a80f1$var$getPseudoElementStyle(className, pseudo, style, options));
    clonedNode.appendChild(styleElement);
}
function $33570b972b8a80f1$export$8df63687a708ed2e(nativeNode, clonedNode, options) {
    $33570b972b8a80f1$var$clonePseudoElement(nativeNode, clonedNode, ":before", options);
    $33570b972b8a80f1$var$clonePseudoElement(nativeNode, clonedNode, ":after", options);
}



const $bb4ebf18d0dbf71b$var$WOFF = "application/font-woff";
const $bb4ebf18d0dbf71b$var$JPEG = "image/jpeg";
const $bb4ebf18d0dbf71b$var$mimes = {
    woff: $bb4ebf18d0dbf71b$var$WOFF,
    woff2: $bb4ebf18d0dbf71b$var$WOFF,
    ttf: "application/font-truetype",
    eot: "application/vnd.ms-fontobject",
    png: "image/png",
    jpg: $bb4ebf18d0dbf71b$var$JPEG,
    jpeg: $bb4ebf18d0dbf71b$var$JPEG,
    gif: "image/gif",
    tiff: "image/tiff",
    svg: "image/svg+xml",
    webp: "image/webp"
};
function $bb4ebf18d0dbf71b$var$getExtension(url) {
    const match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : "";
}
function $bb4ebf18d0dbf71b$export$200548c990602f61(url) {
    const extension = $bb4ebf18d0dbf71b$var$getExtension(url).toLowerCase();
    return $bb4ebf18d0dbf71b$var$mimes[extension] || "";
}


function $ba1060397f0562f7$var$getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function $ba1060397f0562f7$export$f8a05efa20ffd5a(url) {
    return url.search(/^(data:)/) !== -1;
}
function $ba1060397f0562f7$export$68336ea1617fa80a(content, mimeType) {
    return `data:${mimeType};base64,${content}`;
}
async function $ba1060397f0562f7$export$c20a8b76c95b0d41(url, init, process) {
    const res = await fetch(url, init);
    if (res.status === 404) throw new Error(`Resource "${res.url}" not found`);
    const blob = await res.blob();
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onloadend = ()=>{
            try {
                resolve(process({
                    res: res,
                    result: reader.result
                }));
            } catch (error) {
                reject(error);
            }
        };
        reader.readAsDataURL(blob);
    });
}
const $ba1060397f0562f7$var$cache = {};
function $ba1060397f0562f7$var$getCacheKey(url, contentType, includeQueryParams) {
    let key = url.replace(/\?.*/, "");
    if (includeQueryParams) key = url;
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) key = key.replace(/.*\//, "");
    return contentType ? `[${contentType}]${key}` : key;
}
async function $ba1060397f0562f7$export$bdf0422c029b202a(resourceUrl, contentType, options) {
    const cacheKey = $ba1060397f0562f7$var$getCacheKey(resourceUrl, contentType, options.includeQueryParams);
    if ($ba1060397f0562f7$var$cache[cacheKey] != null) return $ba1060397f0562f7$var$cache[cacheKey];
    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
    if (options.cacheBust) // eslint-disable-next-line no-param-reassign
    resourceUrl += (/\?/.test(resourceUrl) ? "&" : "?") + new Date().getTime();
    let dataURL;
    try {
        const content = await $ba1060397f0562f7$export$c20a8b76c95b0d41(resourceUrl, options.fetchRequestInit, ({ res: res, result: result })=>{
            if (!contentType) // eslint-disable-next-line no-param-reassign
            contentType = res.headers.get("Content-Type") || "";
            return $ba1060397f0562f7$var$getContentFromDataUrl(result);
        });
        dataURL = $ba1060397f0562f7$export$68336ea1617fa80a(content, contentType);
    } catch (error) {
        dataURL = options.imagePlaceholder || "";
        let msg = `Failed to fetch resource: ${resourceUrl}`;
        if (error) msg = typeof error === "string" ? error : error.message;
        if (msg) console.warn(msg);
    }
    $ba1060397f0562f7$var$cache[cacheKey] = dataURL;
    return dataURL;
}


async function $3a3699ac68a171c8$var$cloneCanvasElement(canvas) {
    const dataURL = canvas.toDataURL();
    if (dataURL === "data:,") return canvas.cloneNode(false);
    return (0, $b1cc9907e8d0b608$export$ec664d7487540b)(dataURL);
}
async function $3a3699ac68a171c8$var$cloneVideoElement(video, options) {
    if (video.currentSrc) {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        ctx === null || ctx === void 0 || ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL();
        return (0, $b1cc9907e8d0b608$export$ec664d7487540b)(dataURL);
    }
    const poster = video.poster;
    const contentType = (0, $bb4ebf18d0dbf71b$export$200548c990602f61)(poster);
    const dataURL = await (0, $ba1060397f0562f7$export$bdf0422c029b202a)(poster, contentType, options);
    return (0, $b1cc9907e8d0b608$export$ec664d7487540b)(dataURL);
}
async function $3a3699ac68a171c8$var$cloneIFrameElement(iframe, options) {
    var _a;
    try {
        if ((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body) return await $3a3699ac68a171c8$export$ae8e35ea29ddac22(iframe.contentDocument.body, options, true);
    } catch (_b) {
    // Failed to clone iframe
    }
    return iframe.cloneNode(false);
}
async function $3a3699ac68a171c8$var$cloneSingleNode(node, options) {
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(node, HTMLCanvasElement)) return $3a3699ac68a171c8$var$cloneCanvasElement(node);
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(node, HTMLVideoElement)) return $3a3699ac68a171c8$var$cloneVideoElement(node, options);
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(node, HTMLIFrameElement)) return $3a3699ac68a171c8$var$cloneIFrameElement(node, options);
    return node.cloneNode($3a3699ac68a171c8$var$isSVGElement(node));
}
const $3a3699ac68a171c8$var$isSlotElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === "SLOT";
const $3a3699ac68a171c8$var$isSVGElement = (node)=>node.tagName != null && node.tagName.toUpperCase() === "SVG";
async function $3a3699ac68a171c8$var$cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    if ($3a3699ac68a171c8$var$isSVGElement(clonedNode)) return clonedNode;
    let children = [];
    if ($3a3699ac68a171c8$var$isSlotElement(nativeNode) && nativeNode.assignedNodes) children = (0, $b1cc9907e8d0b608$export$45b10814cc054894)(nativeNode.assignedNodes());
    else if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) children = (0, $b1cc9907e8d0b608$export$45b10814cc054894)(nativeNode.contentDocument.body.childNodes);
    else children = (0, $b1cc9907e8d0b608$export$45b10814cc054894)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
    if (children.length === 0 || (0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLVideoElement)) return clonedNode;
    await children.reduce((deferred, child)=>deferred.then(()=>$3a3699ac68a171c8$export$ae8e35ea29ddac22(child, options)).then((clonedChild)=>{
            if (clonedChild) clonedNode.appendChild(clonedChild);
        }), Promise.resolve());
    return clonedNode;
}
function $3a3699ac68a171c8$var$cloneCSSStyle(nativeNode, clonedNode, options) {
    const targetStyle = clonedNode.style;
    if (!targetStyle) return;
    const sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    } else (0, $b1cc9907e8d0b608$export$be6bf80faea8d5af)(options).forEach((name)=>{
        let value = sourceStyle.getPropertyValue(name);
        if (name === "font-size" && value.endsWith("px")) {
            const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
            value = `${reducedFont}px`;
        }
        if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLIFrameElement) && name === "display" && value === "inline") value = "block";
        if (name === "d" && clonedNode.getAttribute("d")) value = `path(${clonedNode.getAttribute("d")})`;
        targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
}
function $3a3699ac68a171c8$var$cloneInputValue(nativeNode, clonedNode) {
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLTextAreaElement)) clonedNode.innerHTML = nativeNode.value;
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLInputElement)) clonedNode.setAttribute("value", nativeNode.value);
}
function $3a3699ac68a171c8$var$cloneSelectValue(nativeNode, clonedNode) {
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(nativeNode, HTMLSelectElement)) {
        const clonedSelect = clonedNode;
        const selectedOption = Array.from(clonedSelect.children).find((child)=>nativeNode.value === child.getAttribute("value"));
        if (selectedOption) selectedOption.setAttribute("selected", "");
    }
}
function $3a3699ac68a171c8$var$decorate(nativeNode, clonedNode, options) {
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        $3a3699ac68a171c8$var$cloneCSSStyle(nativeNode, clonedNode, options);
        (0, $33570b972b8a80f1$export$8df63687a708ed2e)(nativeNode, clonedNode, options);
        $3a3699ac68a171c8$var$cloneInputValue(nativeNode, clonedNode);
        $3a3699ac68a171c8$var$cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
async function $3a3699ac68a171c8$var$ensureSVGSymbols(clone, options) {
    const uses = clone.querySelectorAll ? clone.querySelectorAll("use") : [];
    if (uses.length === 0) return clone;
    const processedDefs = {};
    for(let i = 0; i < uses.length; i++){
        const use = uses[i];
        const id = use.getAttribute("xlink:href");
        if (id) {
            const exist = clone.querySelector(id);
            const definition = document.querySelector(id);
            if (!exist && definition && !processedDefs[id]) // eslint-disable-next-line no-await-in-loop
            processedDefs[id] = await $3a3699ac68a171c8$export$ae8e35ea29ddac22(definition, options, true);
        }
    }
    const nodes = Object.values(processedDefs);
    if (nodes.length) {
        const ns = "http://www.w3.org/1999/xhtml";
        const svg = document.createElementNS(ns, "svg");
        svg.setAttribute("xmlns", ns);
        svg.style.position = "absolute";
        svg.style.width = "0";
        svg.style.height = "0";
        svg.style.overflow = "hidden";
        svg.style.display = "none";
        const defs = document.createElementNS(ns, "defs");
        svg.appendChild(defs);
        for(let i = 0; i < nodes.length; i++)defs.appendChild(nodes[i]);
        clone.appendChild(svg);
    }
    return clone;
}
async function $3a3699ac68a171c8$export$ae8e35ea29ddac22(node, options, isRoot) {
    if (!isRoot && options.filter && !options.filter(node)) return null;
    return Promise.resolve(node).then((clonedNode)=>$3a3699ac68a171c8$var$cloneSingleNode(clonedNode, options)).then((clonedNode)=>$3a3699ac68a171c8$var$cloneChildren(node, clonedNode, options)).then((clonedNode)=>$3a3699ac68a171c8$var$decorate(node, clonedNode, options)).then((clonedNode)=>$3a3699ac68a171c8$var$ensureSVGSymbols(clonedNode, options));
}





const $281817f1177ff3f1$var$URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
const $281817f1177ff3f1$var$URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $281817f1177ff3f1$var$FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $281817f1177ff3f1$var$toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, "g");
}
function $281817f1177ff3f1$export$d04549d631b8762d(cssText) {
    const urls = [];
    cssText.replace($281817f1177ff3f1$var$URL_REGEX, (raw, quotation, url)=>{
        urls.push(url);
        return raw;
    });
    return urls.filter((url)=>!(0, $ba1060397f0562f7$export$f8a05efa20ffd5a)(url));
}
async function $281817f1177ff3f1$export$2be46bb7e96db87f(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    try {
        const resolvedURL = baseURL ? (0, $b1cc9907e8d0b608$export$f85c16a6d62f7d63)(resourceURL, baseURL) : resourceURL;
        const contentType = (0, $bb4ebf18d0dbf71b$export$200548c990602f61)(resourceURL);
        let dataURL;
        if (getContentFromUrl) {
            const content = await getContentFromUrl(resolvedURL);
            dataURL = (0, $ba1060397f0562f7$export$68336ea1617fa80a)(content, contentType);
        } else dataURL = await (0, $ba1060397f0562f7$export$bdf0422c029b202a)(resolvedURL, contentType, options);
        return cssText.replace($281817f1177ff3f1$var$toRegex(resourceURL), `$1${dataURL}$3`);
    } catch (error) {
    // pass
    }
    return cssText;
}
function $281817f1177ff3f1$var$filterPreferredFontFormat(str, { preferredFontFormat: preferredFontFormat }) {
    return !preferredFontFormat ? str : str.replace($281817f1177ff3f1$var$FONT_SRC_REGEX, (match)=>{
        // eslint-disable-next-line no-constant-condition
        while(true){
            const [src, , format] = $281817f1177ff3f1$var$URL_WITH_FORMAT_REGEX.exec(match) || [];
            if (!format) return "";
            if (format === preferredFontFormat) return `src: ${src};`;
        }
    });
}
function $281817f1177ff3f1$export$7b668369e5eab853(url) {
    return url.search($281817f1177ff3f1$var$URL_REGEX) !== -1;
}
async function $281817f1177ff3f1$export$3d88803585cbbc21(cssText, baseUrl, options) {
    if (!$281817f1177ff3f1$export$7b668369e5eab853(cssText)) return cssText;
    const filteredCSSText = $281817f1177ff3f1$var$filterPreferredFontFormat(cssText, options);
    const urls = $281817f1177ff3f1$export$d04549d631b8762d(filteredCSSText);
    return urls.reduce((deferred, url)=>deferred.then((css)=>$281817f1177ff3f1$export$2be46bb7e96db87f(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}





async function $ac5e03210fc19baa$var$embedProp(propName, node, options) {
    var _a;
    const propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
    if (propValue) {
        const cssString = await (0, $281817f1177ff3f1$export$3d88803585cbbc21)(propValue, null, options);
        node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
        return true;
    }
    return false;
}
async function $ac5e03210fc19baa$var$embedBackground(clonedNode, options) {
    await $ac5e03210fc19baa$var$embedProp("background", clonedNode, options) || await $ac5e03210fc19baa$var$embedProp("background-image", clonedNode, options);
    await $ac5e03210fc19baa$var$embedProp("mask", clonedNode, options) || await $ac5e03210fc19baa$var$embedProp("-webkit-mask", clonedNode, options) || await $ac5e03210fc19baa$var$embedProp("mask-image", clonedNode, options) || await $ac5e03210fc19baa$var$embedProp("-webkit-mask-image", clonedNode, options);
}
async function $ac5e03210fc19baa$var$embedImageNode(clonedNode, options) {
    const isImageElement = (0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(clonedNode, HTMLImageElement);
    if (!(isImageElement && !(0, $ba1060397f0562f7$export$f8a05efa20ffd5a)(clonedNode.src)) && !((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(clonedNode, SVGImageElement) && !(0, $ba1060397f0562f7$export$f8a05efa20ffd5a)(clonedNode.href.baseVal))) return;
    const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
    const dataURL = await (0, $ba1060397f0562f7$export$bdf0422c029b202a)(url, (0, $bb4ebf18d0dbf71b$export$200548c990602f61)(url), options);
    await new Promise((resolve, reject)=>{
        clonedNode.onload = resolve;
        clonedNode.onerror = options.onImageErrorHandler ? (...attributes)=>{
            try {
                resolve(options.onImageErrorHandler(...attributes));
            } catch (error) {
                reject(error);
            }
        } : reject;
        const image = clonedNode;
        if (image.decode) image.decode = resolve;
        if (image.loading === "lazy") image.loading = "eager";
        if (isImageElement) {
            clonedNode.srcset = "";
            clonedNode.src = dataURL;
        } else clonedNode.href.baseVal = dataURL;
    });
}
async function $ac5e03210fc19baa$var$embedChildren(clonedNode, options) {
    const children = (0, $b1cc9907e8d0b608$export$45b10814cc054894)(clonedNode.childNodes);
    const deferreds = children.map((child)=>$ac5e03210fc19baa$export$6660fa8dd20e53aa(child, options));
    await Promise.all(deferreds).then(()=>clonedNode);
}
async function $ac5e03210fc19baa$export$6660fa8dd20e53aa(clonedNode, options) {
    if ((0, $b1cc9907e8d0b608$export$3a92fc9ec83ef360)(clonedNode, Element)) {
        await $ac5e03210fc19baa$var$embedBackground(clonedNode, options);
        await $ac5e03210fc19baa$var$embedImageNode(clonedNode, options);
        await $ac5e03210fc19baa$var$embedChildren(clonedNode, options);
    }
}


function $c57242652782c2d2$export$d63a6b7859608045(node, options) {
    const { style: style } = node;
    if (options.backgroundColor) style.backgroundColor = options.backgroundColor;
    if (options.width) style.width = `${options.width}px`;
    if (options.height) style.height = `${options.height}px`;
    const manual = options.style;
    if (manual != null) Object.keys(manual).forEach((key)=>{
        style[key] = manual[key];
    });
    return node;
}





const $d14d6511e87bc5ec$var$cssFetchCache = {};
async function $d14d6511e87bc5ec$var$fetchCSS(url) {
    let cache = $d14d6511e87bc5ec$var$cssFetchCache[url];
    if (cache != null) return cache;
    const res = await fetch(url);
    const cssText = await res.text();
    cache = {
        url: url,
        cssText: cssText
    };
    $d14d6511e87bc5ec$var$cssFetchCache[url] = cache;
    return cache;
}
async function $d14d6511e87bc5ec$var$embedFonts(data, options) {
    let cssText = data.cssText;
    const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
    const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
    const loadFonts = fontLocs.map(async (loc)=>{
        let url = loc.replace(regexUrl, "$1");
        if (!url.startsWith("https://")) url = new URL(url, data.url).href;
        return (0, $ba1060397f0562f7$export$c20a8b76c95b0d41)(url, options.fetchRequestInit, ({ result: result })=>{
            cssText = cssText.replace(loc, `url(${result})`);
            return [
                loc,
                result
            ];
        });
    });
    return Promise.all(loadFonts).then(()=>cssText);
}
function $d14d6511e87bc5ec$var$parseCSS(source) {
    if (source == null) return [];
    const result = [];
    const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    let cssText = source.replace(commentsRegex, "");
    // eslint-disable-next-line prefer-regex-literals
    const keyframesRegex = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        const matches = keyframesRegex.exec(cssText);
        if (matches === null) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, "");
    const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
    // unified regex
    const unifiedRegex = new RegExp(combinedCSSRegex, "gi");
    // eslint-disable-next-line no-constant-condition
    while(true){
        let matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) break;
            else importRegex.lastIndex = unifiedRegex.lastIndex;
        } else unifiedRegex.lastIndex = importRegex.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
async function $d14d6511e87bc5ec$var$getCSSRules(styleSheets, options) {
    const ret = [];
    const deferreds = [];
    // First loop inlines imports
    styleSheets.forEach((sheet)=>{
        if ("cssRules" in sheet) try {
            (0, $b1cc9907e8d0b608$export$45b10814cc054894)(sheet.cssRules || []).forEach((item, index)=>{
                if (item.type === CSSRule.IMPORT_RULE) {
                    let importIndex = index + 1;
                    const url = item.href;
                    const deferred = $d14d6511e87bc5ec$var$fetchCSS(url).then((metadata)=>$d14d6511e87bc5ec$var$embedFonts(metadata, options)).then((cssText)=>$d14d6511e87bc5ec$var$parseCSS(cssText).forEach((rule)=>{
                            try {
                                sheet.insertRule(rule, rule.startsWith("@import") ? importIndex += 1 : sheet.cssRules.length);
                            } catch (error) {
                                console.error("Error inserting rule from remote css", {
                                    rule: rule,
                                    error: error
                                });
                            }
                        })).catch((e)=>{
                        console.error("Error loading remote css", e.toString());
                    });
                    deferreds.push(deferred);
                }
            });
        } catch (e) {
            const inline = styleSheets.find((a)=>a.href == null) || document.styleSheets[0];
            if (sheet.href != null) deferreds.push($d14d6511e87bc5ec$var$fetchCSS(sheet.href).then((metadata)=>$d14d6511e87bc5ec$var$embedFonts(metadata, options)).then((cssText)=>$d14d6511e87bc5ec$var$parseCSS(cssText).forEach((rule)=>{
                    inline.insertRule(rule, inline.cssRules.length);
                })).catch((err)=>{
                console.error("Error loading remote stylesheet", err);
            }));
            console.error("Error inlining remote css file", e);
        }
    });
    return Promise.all(deferreds).then(()=>{
        // Second loop parses rules
        styleSheets.forEach((sheet)=>{
            if ("cssRules" in sheet) try {
                (0, $b1cc9907e8d0b608$export$45b10814cc054894)(sheet.cssRules || []).forEach((item)=>{
                    ret.push(item);
                });
            } catch (e) {
                console.error(`Error while reading CSS rules from ${sheet.href}`, e);
            }
        });
        return ret;
    });
}
function $d14d6511e87bc5ec$var$getWebFontRules(cssRules) {
    return cssRules.filter((rule)=>rule.type === CSSRule.FONT_FACE_RULE).filter((rule)=>(0, $281817f1177ff3f1$export$7b668369e5eab853)(rule.style.getPropertyValue("src")));
}
async function $d14d6511e87bc5ec$var$parseWebFontRules(node, options) {
    if (node.ownerDocument == null) throw new Error("Provided element is not within a Document");
    const styleSheets = (0, $b1cc9907e8d0b608$export$45b10814cc054894)(node.ownerDocument.styleSheets);
    const cssRules = await $d14d6511e87bc5ec$var$getCSSRules(styleSheets, options);
    return $d14d6511e87bc5ec$var$getWebFontRules(cssRules);
}
function $d14d6511e87bc5ec$var$normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, "");
}
function $d14d6511e87bc5ec$var$getUsedFonts(node) {
    const fonts = new Set();
    function traverse(node) {
        const fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(",").forEach((font)=>{
            fonts.add($d14d6511e87bc5ec$var$normalizeFontFamily(font));
        });
        Array.from(node.children).forEach((child)=>{
            if (child instanceof HTMLElement) traverse(child);
        });
    }
    traverse(node);
    return fonts;
}
async function $d14d6511e87bc5ec$export$253c9aa3d83a57b6(node, options) {
    const rules = await $d14d6511e87bc5ec$var$parseWebFontRules(node, options);
    const usedFonts = $d14d6511e87bc5ec$var$getUsedFonts(node);
    const cssTexts = await Promise.all(rules.filter((rule)=>usedFonts.has($d14d6511e87bc5ec$var$normalizeFontFamily(rule.style.fontFamily))).map((rule)=>{
        const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
        return (0, $281817f1177ff3f1$export$3d88803585cbbc21)(rule.cssText, baseUrl, options);
    }));
    return cssTexts.join("\n");
}
async function $d14d6511e87bc5ec$export$2c2c83b77c8cb421(clonedNode, options) {
    const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await $d14d6511e87bc5ec$export$253c9aa3d83a57b6(clonedNode, options);
    if (cssText) {
        const styleNode = document.createElement("style");
        const sytleContent = document.createTextNode(cssText);
        styleNode.appendChild(sytleContent);
        if (clonedNode.firstChild) clonedNode.insertBefore(styleNode, clonedNode.firstChild);
        else clonedNode.appendChild(styleNode);
    }
}



async function $c51e798bc9490e38$export$20d300cb2d558b7(node, options = {}) {
    const { width: width, height: height } = (0, $b1cc9907e8d0b608$export$ada5537b2c061996)(node, options);
    const clonedNode = await (0, $3a3699ac68a171c8$export$ae8e35ea29ddac22)(node, options, true);
    await (0, $d14d6511e87bc5ec$export$2c2c83b77c8cb421)(clonedNode, options);
    await (0, $ac5e03210fc19baa$export$6660fa8dd20e53aa)(clonedNode, options);
    (0, $c57242652782c2d2$export$d63a6b7859608045)(clonedNode, options);
    const datauri = await (0, $b1cc9907e8d0b608$export$b62810fb8ca515fa)(clonedNode, width, height);
    return datauri;
}
async function $c51e798bc9490e38$export$f87f6982d1fd4f81(node, options = {}) {
    const { width: width, height: height } = (0, $b1cc9907e8d0b608$export$ada5537b2c061996)(node, options);
    const svg = await $c51e798bc9490e38$export$20d300cb2d558b7(node, options);
    const img = await (0, $b1cc9907e8d0b608$export$ec664d7487540b)(svg);
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const ratio = options.pixelRatio || (0, $b1cc9907e8d0b608$export$d39ce20a37bba061)();
    const canvasWidth = options.canvasWidth || width;
    const canvasHeight = options.canvasHeight || height;
    canvas.width = canvasWidth * ratio;
    canvas.height = canvasHeight * ratio;
    if (!options.skipAutoScale) (0, $b1cc9907e8d0b608$export$c2c809a2fe6b0f1a)(canvas);
    canvas.style.width = `${canvasWidth}`;
    canvas.style.height = `${canvasHeight}`;
    if (options.backgroundColor) {
        context.fillStyle = options.backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
    }
    context.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas;
}
async function $c51e798bc9490e38$export$6f9e32581c0cde11(node, options = {}) {
    const { width: width, height: height } = (0, $b1cc9907e8d0b608$export$ada5537b2c061996)(node, options);
    const canvas = await $c51e798bc9490e38$export$f87f6982d1fd4f81(node, options);
    const ctx = canvas.getContext("2d");
    return ctx.getImageData(0, 0, width, height).data;
}
async function $c51e798bc9490e38$export$aba256f33615c92e(node, options = {}) {
    const canvas = await $c51e798bc9490e38$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL();
}
async function $c51e798bc9490e38$export$ed218bd2440d33a5(node, options = {}) {
    const canvas = await $c51e798bc9490e38$export$f87f6982d1fd4f81(node, options);
    return canvas.toDataURL("image/jpeg", options.quality || 1);
}
async function $c51e798bc9490e38$export$b20f4ee19ffa0668(node, options = {}) {
    const canvas = await $c51e798bc9490e38$export$f87f6982d1fd4f81(node, options);
    const blob = await (0, $b1cc9907e8d0b608$export$403d539f215df596)(canvas);
    return blob;
}
async function $c51e798bc9490e38$export$92678bad7eef403b(node, options = {}) {
    return (0, $d14d6511e87bc5ec$export$253c9aa3d83a57b6)(node, options);
}


async function $76f7c06a5bd7857a$export$2e2bcd8739ae039(backgroundUrl) {
    const node = document.getElementById("arise-profile-scorecard");
    const BACKGROUND_WIDTH = 704; // 16:9
    const BACKGROUND_HEIGHT = 396;
    const OVERLAY_PIXEL_RATIO = 4;
    const OVERLAY_PADDING_OFFSET = 25;
    const EXPORT_SCALE = 2;
    // Stop shine animation so it's not captured
    node.classList.add("stop-all-animations");
    // Do it once first to ensure all assets load in and stop safari bug
    await $c51e798bc9490e38$export$aba256f33615c92e(node);
    const overlayDataUrl = await $c51e798bc9490e38$export$aba256f33615c92e(node, {
        pixelRatio: OVERLAY_PIXEL_RATIO,
        style: {
            filter: "none"
        }
    });
    node.classList.remove("stop-all-animations");
    let backgroundImg = null;
    try {
        backgroundImg = await new Promise((resolve, reject)=>{
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = ()=>resolve(img);
            img.onerror = reject;
            img.src = backgroundUrl;
        });
    } catch  {
        backgroundImg = null;
    }
    const overlayImg = await new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>resolve(img);
        img.onerror = reject;
        img.src = overlayDataUrl;
    });
    const canvas = document.createElement("canvas");
    canvas.width = BACKGROUND_WIDTH * EXPORT_SCALE;
    canvas.height = BACKGROUND_HEIGHT * EXPORT_SCALE;
    const ctx = canvas.getContext("2d");
    // Draw background at full size
    if (backgroundImg) ctx.drawImage(backgroundImg, 0, 0, canvas.width, canvas.height);
    else {
        ctx.fillStyle = "#181818"; // Fallback grey bg
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    // Scale overlay down to reverse pixelRatio = 4
    const scaledWidth = overlayImg.width / OVERLAY_PIXEL_RATIO * EXPORT_SCALE;
    const scaledHeight = overlayImg.height / OVERLAY_PIXEL_RATIO * EXPORT_SCALE;
    // Draw overlay at requested position with drop shadow
    ctx.save();
    ctx.filter = "drop-shadow(5px 5px 8px rgba(0,0,0,0.8))";
    ctx.drawImage(overlayImg, canvas.width - scaledWidth - OVERLAY_PADDING_OFFSET * EXPORT_SCALE, OVERLAY_PADDING_OFFSET * EXPORT_SCALE, scaledWidth, scaledHeight);
    ctx.restore(); // Remove the filter state in case we want to draw more things
    const blob = await $76f7c06a5bd7857a$var$getCanvasBlob(canvas);
    const url = URL.createObjectURL(blob);
    // (Optional) Append to DOM for testing
    // const testImg = new Image();
    // testImg.src = url;
    // testImg.style = `
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     z-index: 10000;
    //     width: 50%;
    //     border: 1px solid red;
    // `;
    // document.body.appendChild(testImg);
    return url;
}
function $76f7c06a5bd7857a$var$getCanvasBlob(canvas) {
    return new Promise((resolve)=>{
        canvas.toBlob((blob)=>resolve(blob), "image/png");
    });
}


var $8787b6314d954f8e$exports = {};

$parcel$export($8787b6314d954f8e$exports, "ProfileDrawer", function () { return $8787b6314d954f8e$export$8d639674747a02b2; }, function (v) { return $8787b6314d954f8e$export$8d639674747a02b2 = v; });
$parcel$export($8787b6314d954f8e$exports, "active", function () { return $8787b6314d954f8e$export$89da14300d534261; }, function (v) { return $8787b6314d954f8e$export$89da14300d534261 = v; });
$parcel$export($8787b6314d954f8e$exports, "bgImage", function () { return $8787b6314d954f8e$export$b2345e0581a48a31; }, function (v) { return $8787b6314d954f8e$export$b2345e0581a48a31 = v; });
$parcel$export($8787b6314d954f8e$exports, "box", function () { return $8787b6314d954f8e$export$827f4ee28efc37; }, function (v) { return $8787b6314d954f8e$export$827f4ee28efc37 = v; });
$parcel$export($8787b6314d954f8e$exports, "brandLogo", function () { return $8787b6314d954f8e$export$392d16e71632d55b; }, function (v) { return $8787b6314d954f8e$export$392d16e71632d55b = v; });
$parcel$export($8787b6314d954f8e$exports, "closeButton", function () { return $8787b6314d954f8e$export$efe229eab43a9869; }, function (v) { return $8787b6314d954f8e$export$efe229eab43a9869 = v; });
$parcel$export($8787b6314d954f8e$exports, "common", function () { return $8787b6314d954f8e$export$919daad019702595; }, function (v) { return $8787b6314d954f8e$export$919daad019702595 = v; });
$parcel$export($8787b6314d954f8e$exports, "content", function () { return $8787b6314d954f8e$export$a7db06668cad9adb; }, function (v) { return $8787b6314d954f8e$export$a7db06668cad9adb = v; });
$parcel$export($8787b6314d954f8e$exports, "ctaButtonsContainer", function () { return $8787b6314d954f8e$export$712f96671067efb4; }, function (v) { return $8787b6314d954f8e$export$712f96671067efb4 = v; });
$parcel$export($8787b6314d954f8e$exports, "divider", function () { return $8787b6314d954f8e$export$e8c9778bf415dd08; }, function (v) { return $8787b6314d954f8e$export$e8c9778bf415dd08 = v; });
$parcel$export($8787b6314d954f8e$exports, "epic", function () { return $8787b6314d954f8e$export$8ec5145af6f76965; }, function (v) { return $8787b6314d954f8e$export$8ec5145af6f76965 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH1", function () { return $8787b6314d954f8e$export$17fa98cb055e8fa7; }, function (v) { return $8787b6314d954f8e$export$17fa98cb055e8fa7 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH2", function () { return $8787b6314d954f8e$export$a5833c2b43ca4340; }, function (v) { return $8787b6314d954f8e$export$a5833c2b43ca4340 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH3", function () { return $8787b6314d954f8e$export$47511f9a6581d1d6; }, function (v) { return $8787b6314d954f8e$export$47511f9a6581d1d6 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH4", function () { return $8787b6314d954f8e$export$dd1c05b92185401c; }, function (v) { return $8787b6314d954f8e$export$dd1c05b92185401c = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH5", function () { return $8787b6314d954f8e$export$8b28cf6cd00fe080; }, function (v) { return $8787b6314d954f8e$export$8b28cf6cd00fe080 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeH6", function () { return $8787b6314d954f8e$export$186c650311ff0789; }, function (v) { return $8787b6314d954f8e$export$186c650311ff0789 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeSmall", function () { return $8787b6314d954f8e$export$6746fe0d9c9fab54; }, function (v) { return $8787b6314d954f8e$export$6746fe0d9c9fab54 = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizeTiny", function () { return $8787b6314d954f8e$export$2bcf359f0c20e94f; }, function (v) { return $8787b6314d954f8e$export$2bcf359f0c20e94f = v; });
$parcel$export($8787b6314d954f8e$exports, "fontSizep", function () { return $8787b6314d954f8e$export$2903d10d531d0ac0; }, function (v) { return $8787b6314d954f8e$export$2903d10d531d0ac0 = v; });
$parcel$export($8787b6314d954f8e$exports, "gridContainer", function () { return $8787b6314d954f8e$export$711e2b273dbb00ac; }, function (v) { return $8787b6314d954f8e$export$711e2b273dbb00ac = v; });
$parcel$export($8787b6314d954f8e$exports, "hasLine", function () { return $8787b6314d954f8e$export$76ebae8949fce754; }, function (v) { return $8787b6314d954f8e$export$76ebae8949fce754 = v; });
$parcel$export($8787b6314d954f8e$exports, "highlight", function () { return $8787b6314d954f8e$export$e4043f67d36cbb26; }, function (v) { return $8787b6314d954f8e$export$e4043f67d36cbb26 = v; });
$parcel$export($8787b6314d954f8e$exports, "hintButton", function () { return $8787b6314d954f8e$export$fab3f91e652f07ba; }, function (v) { return $8787b6314d954f8e$export$fab3f91e652f07ba = v; });
$parcel$export($8787b6314d954f8e$exports, "icon", function () { return $8787b6314d954f8e$export$1ca1ec8b29a4ce27; }, function (v) { return $8787b6314d954f8e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($8787b6314d954f8e$exports, "isOpen", function () { return $8787b6314d954f8e$export$ea0830439c7fc698; }, function (v) { return $8787b6314d954f8e$export$ea0830439c7fc698 = v; });
$parcel$export($8787b6314d954f8e$exports, "largerText", function () { return $8787b6314d954f8e$export$56dd976d44607735; }, function (v) { return $8787b6314d954f8e$export$56dd976d44607735 = v; });
$parcel$export($8787b6314d954f8e$exports, "left", function () { return $8787b6314d954f8e$export$eabcd2c8791e7bf4; }, function (v) { return $8787b6314d954f8e$export$eabcd2c8791e7bf4 = v; });
$parcel$export($8787b6314d954f8e$exports, "legendary", function () { return $8787b6314d954f8e$export$9738149b23403ba; }, function (v) { return $8787b6314d954f8e$export$9738149b23403ba = v; });
$parcel$export($8787b6314d954f8e$exports, "level", function () { return $8787b6314d954f8e$export$617f828bbf323ba2; }, function (v) { return $8787b6314d954f8e$export$617f828bbf323ba2 = v; });
$parcel$export($8787b6314d954f8e$exports, "levelBadge", function () { return $8787b6314d954f8e$export$fad0c4d9d422c6d3; }, function (v) { return $8787b6314d954f8e$export$fad0c4d9d422c6d3 = v; });
$parcel$export($8787b6314d954f8e$exports, "levelInfoBox", function () { return $8787b6314d954f8e$export$d7a6b934f302e93f; }, function (v) { return $8787b6314d954f8e$export$d7a6b934f302e93f = v; });
$parcel$export($8787b6314d954f8e$exports, "levelInfoBoxes", function () { return $8787b6314d954f8e$export$9085649ded432365; }, function (v) { return $8787b6314d954f8e$export$9085649ded432365 = v; });
$parcel$export($8787b6314d954f8e$exports, "lockedIcon", function () { return $8787b6314d954f8e$export$b6335e2e4852d2f8; }, function (v) { return $8787b6314d954f8e$export$b6335e2e4852d2f8 = v; });
$parcel$export($8787b6314d954f8e$exports, "pageBgImage", function () { return $8787b6314d954f8e$export$ef8b3c650f0e5fb3; }, function (v) { return $8787b6314d954f8e$export$ef8b3c650f0e5fb3 = v; });
$parcel$export($8787b6314d954f8e$exports, "platformLogo", function () { return $8787b6314d954f8e$export$3471600b91f1cae6; }, function (v) { return $8787b6314d954f8e$export$3471600b91f1cae6 = v; });
$parcel$export($8787b6314d954f8e$exports, "progress", function () { return $8787b6314d954f8e$export$504d7abb21fa8c9; }, function (v) { return $8787b6314d954f8e$export$504d7abb21fa8c9 = v; });
$parcel$export($8787b6314d954f8e$exports, "quest", function () { return $8787b6314d954f8e$export$cbc1416578dd3747; }, function (v) { return $8787b6314d954f8e$export$cbc1416578dd3747 = v; });
$parcel$export($8787b6314d954f8e$exports, "rare", function () { return $8787b6314d954f8e$export$b2e68d2f08b863d2; }, function (v) { return $8787b6314d954f8e$export$b2e68d2f08b863d2 = v; });
$parcel$export($8787b6314d954f8e$exports, "scorecard", function () { return $8787b6314d954f8e$export$97678cb1dc0e0fc0; }, function (v) { return $8787b6314d954f8e$export$97678cb1dc0e0fc0 = v; });
$parcel$export($8787b6314d954f8e$exports, "scorecardContent", function () { return $8787b6314d954f8e$export$bc4b99392c7330b9; }, function (v) { return $8787b6314d954f8e$export$bc4b99392c7330b9 = v; });
$parcel$export($8787b6314d954f8e$exports, "scrollContainer", function () { return $8787b6314d954f8e$export$fad3c8302a7540c6; }, function (v) { return $8787b6314d954f8e$export$fad3c8302a7540c6 = v; });
$parcel$export($8787b6314d954f8e$exports, "shareError", function () { return $8787b6314d954f8e$export$5a3af59d4539c451; }, function (v) { return $8787b6314d954f8e$export$5a3af59d4539c451 = v; });
$parcel$export($8787b6314d954f8e$exports, "statBox", function () { return $8787b6314d954f8e$export$5ebab997b8566089; }, function (v) { return $8787b6314d954f8e$export$5ebab997b8566089 = v; });
$parcel$export($8787b6314d954f8e$exports, "statBoxContainer", function () { return $8787b6314d954f8e$export$a9366fbbda880794; }, function (v) { return $8787b6314d954f8e$export$a9366fbbda880794 = v; });
$parcel$export($8787b6314d954f8e$exports, "statBoxLong", function () { return $8787b6314d954f8e$export$e0dc3265b8932732; }, function (v) { return $8787b6314d954f8e$export$e0dc3265b8932732 = v; });
$parcel$export($8787b6314d954f8e$exports, "statTextContainer", function () { return $8787b6314d954f8e$export$197356bebb306e39; }, function (v) { return $8787b6314d954f8e$export$197356bebb306e39 = v; });
$parcel$export($8787b6314d954f8e$exports, "statTitle", function () { return $8787b6314d954f8e$export$a19053e6a5f4b6a8; }, function (v) { return $8787b6314d954f8e$export$a19053e6a5f4b6a8 = v; });
$parcel$export($8787b6314d954f8e$exports, "subtitle", function () { return $8787b6314d954f8e$export$c96745152eb2740f; }, function (v) { return $8787b6314d954f8e$export$c96745152eb2740f = v; });
$parcel$export($8787b6314d954f8e$exports, "tabButtons", function () { return $8787b6314d954f8e$export$d167761217acc355; }, function (v) { return $8787b6314d954f8e$export$d167761217acc355 = v; });
$parcel$export($8787b6314d954f8e$exports, "tabGroup", function () { return $8787b6314d954f8e$export$e8251cd941786af1; }, function (v) { return $8787b6314d954f8e$export$e8251cd941786af1 = v; });
$parcel$export($8787b6314d954f8e$exports, "tabGroupLoader", function () { return $8787b6314d954f8e$export$faecd7a64ed7d994; }, function (v) { return $8787b6314d954f8e$export$faecd7a64ed7d994 = v; });
$parcel$export($8787b6314d954f8e$exports, "textContainer", function () { return $8787b6314d954f8e$export$2cedfd664bb3bd01; }, function (v) { return $8787b6314d954f8e$export$2cedfd664bb3bd01 = v; });
$parcel$export($8787b6314d954f8e$exports, "titleBar", function () { return $8787b6314d954f8e$export$870b5cbff008e1ed; }, function (v) { return $8787b6314d954f8e$export$870b5cbff008e1ed = v; });
$parcel$export($8787b6314d954f8e$exports, "titles", function () { return $8787b6314d954f8e$export$1cbbc5990c2ee230; }, function (v) { return $8787b6314d954f8e$export$1cbbc5990c2ee230 = v; });
$parcel$export($8787b6314d954f8e$exports, "titlesNumber", function () { return $8787b6314d954f8e$export$ad38ce7e9fa921f3; }, function (v) { return $8787b6314d954f8e$export$ad38ce7e9fa921f3 = v; });
$parcel$export($8787b6314d954f8e$exports, "topBar", function () { return $8787b6314d954f8e$export$ac052f74bbc68e2d; }, function (v) { return $8787b6314d954f8e$export$ac052f74bbc68e2d = v; });
$parcel$export($8787b6314d954f8e$exports, "uncommon", function () { return $8787b6314d954f8e$export$76bf72d8613283e6; }, function (v) { return $8787b6314d954f8e$export$76bf72d8613283e6 = v; });
$parcel$export($8787b6314d954f8e$exports, "username", function () { return $8787b6314d954f8e$export$5e1be761f603d585; }, function (v) { return $8787b6314d954f8e$export$5e1be761f603d585 = v; });
$parcel$export($8787b6314d954f8e$exports, "yourStats", function () { return $8787b6314d954f8e$export$ea0f4417b3a15bd9; }, function (v) { return $8787b6314d954f8e$export$ea0f4417b3a15bd9 = v; });
var $8787b6314d954f8e$export$8d639674747a02b2;
var $8787b6314d954f8e$export$89da14300d534261;
var $8787b6314d954f8e$export$b2345e0581a48a31;
var $8787b6314d954f8e$export$827f4ee28efc37;
var $8787b6314d954f8e$export$392d16e71632d55b;
var $8787b6314d954f8e$export$efe229eab43a9869;
var $8787b6314d954f8e$export$919daad019702595;
var $8787b6314d954f8e$export$a7db06668cad9adb;
var $8787b6314d954f8e$export$712f96671067efb4;
var $8787b6314d954f8e$export$e8c9778bf415dd08;
var $8787b6314d954f8e$export$8ec5145af6f76965;
var $8787b6314d954f8e$export$17fa98cb055e8fa7;
var $8787b6314d954f8e$export$a5833c2b43ca4340;
var $8787b6314d954f8e$export$47511f9a6581d1d6;
var $8787b6314d954f8e$export$dd1c05b92185401c;
var $8787b6314d954f8e$export$8b28cf6cd00fe080;
var $8787b6314d954f8e$export$186c650311ff0789;
var $8787b6314d954f8e$export$6746fe0d9c9fab54;
var $8787b6314d954f8e$export$2bcf359f0c20e94f;
var $8787b6314d954f8e$export$2903d10d531d0ac0;
var $8787b6314d954f8e$export$711e2b273dbb00ac;
var $8787b6314d954f8e$export$76ebae8949fce754;
var $8787b6314d954f8e$export$e4043f67d36cbb26;
var $8787b6314d954f8e$export$fab3f91e652f07ba;
var $8787b6314d954f8e$export$1ca1ec8b29a4ce27;
var $8787b6314d954f8e$export$ea0830439c7fc698;
var $8787b6314d954f8e$export$56dd976d44607735;
var $8787b6314d954f8e$export$eabcd2c8791e7bf4;
var $8787b6314d954f8e$export$9738149b23403ba;
var $8787b6314d954f8e$export$617f828bbf323ba2;
var $8787b6314d954f8e$export$fad0c4d9d422c6d3;
var $8787b6314d954f8e$export$d7a6b934f302e93f;
var $8787b6314d954f8e$export$9085649ded432365;
var $8787b6314d954f8e$export$b6335e2e4852d2f8;
var $8787b6314d954f8e$export$ef8b3c650f0e5fb3;
var $8787b6314d954f8e$export$3471600b91f1cae6;
var $8787b6314d954f8e$export$504d7abb21fa8c9;
var $8787b6314d954f8e$export$cbc1416578dd3747;
var $8787b6314d954f8e$export$b2e68d2f08b863d2;
var $8787b6314d954f8e$export$97678cb1dc0e0fc0;
var $8787b6314d954f8e$export$bc4b99392c7330b9;
var $8787b6314d954f8e$export$fad3c8302a7540c6;
var $8787b6314d954f8e$export$5a3af59d4539c451;
var $8787b6314d954f8e$export$5ebab997b8566089;
var $8787b6314d954f8e$export$a9366fbbda880794;
var $8787b6314d954f8e$export$e0dc3265b8932732;
var $8787b6314d954f8e$export$197356bebb306e39;
var $8787b6314d954f8e$export$a19053e6a5f4b6a8;
var $8787b6314d954f8e$export$c96745152eb2740f;
var $8787b6314d954f8e$export$d167761217acc355;
var $8787b6314d954f8e$export$e8251cd941786af1;
var $8787b6314d954f8e$export$faecd7a64ed7d994;
var $8787b6314d954f8e$export$2cedfd664bb3bd01;
var $8787b6314d954f8e$export$870b5cbff008e1ed;
var $8787b6314d954f8e$export$1cbbc5990c2ee230;
var $8787b6314d954f8e$export$ad38ce7e9fa921f3;
var $8787b6314d954f8e$export$ac052f74bbc68e2d;
var $8787b6314d954f8e$export$76bf72d8613283e6;
var $8787b6314d954f8e$export$5e1be761f603d585;
var $8787b6314d954f8e$export$ea0f4417b3a15bd9;
$8787b6314d954f8e$export$8d639674747a02b2 = `mjApAq_ProfileDrawer`;
$8787b6314d954f8e$export$89da14300d534261 = `mjApAq_active`;
$8787b6314d954f8e$export$b2345e0581a48a31 = `mjApAq_bgImage`;
$8787b6314d954f8e$export$827f4ee28efc37 = `mjApAq_box`;
$8787b6314d954f8e$export$392d16e71632d55b = `mjApAq_brandLogo`;
$8787b6314d954f8e$export$efe229eab43a9869 = `mjApAq_closeButton`;
$8787b6314d954f8e$export$919daad019702595 = `mjApAq_common`;
$8787b6314d954f8e$export$a7db06668cad9adb = `mjApAq_content`;
$8787b6314d954f8e$export$712f96671067efb4 = `mjApAq_ctaButtonsContainer`;
$8787b6314d954f8e$export$e8c9778bf415dd08 = `mjApAq_divider`;
$8787b6314d954f8e$export$8ec5145af6f76965 = `mjApAq_epic`;
$8787b6314d954f8e$export$17fa98cb055e8fa7 = `mjApAq_fontSizeH1`;
$8787b6314d954f8e$export$a5833c2b43ca4340 = `mjApAq_fontSizeH2`;
$8787b6314d954f8e$export$47511f9a6581d1d6 = `mjApAq_fontSizeH3`;
$8787b6314d954f8e$export$dd1c05b92185401c = `mjApAq_fontSizeH4`;
$8787b6314d954f8e$export$8b28cf6cd00fe080 = `mjApAq_fontSizeH5`;
$8787b6314d954f8e$export$186c650311ff0789 = `mjApAq_fontSizeH6`;
$8787b6314d954f8e$export$6746fe0d9c9fab54 = `mjApAq_fontSizeSmall`;
$8787b6314d954f8e$export$2bcf359f0c20e94f = `mjApAq_fontSizeTiny`;
$8787b6314d954f8e$export$2903d10d531d0ac0 = `mjApAq_fontSizep`;
$8787b6314d954f8e$export$711e2b273dbb00ac = `mjApAq_gridContainer`;
$8787b6314d954f8e$export$76ebae8949fce754 = `mjApAq_hasLine`;
$8787b6314d954f8e$export$e4043f67d36cbb26 = `mjApAq_highlight`;
$8787b6314d954f8e$export$fab3f91e652f07ba = `mjApAq_hintButton`;
$8787b6314d954f8e$export$1ca1ec8b29a4ce27 = `mjApAq_icon`;
$8787b6314d954f8e$export$ea0830439c7fc698 = `mjApAq_isOpen`;
$8787b6314d954f8e$export$56dd976d44607735 = `mjApAq_largerText`;
$8787b6314d954f8e$export$eabcd2c8791e7bf4 = `mjApAq_left`;
$8787b6314d954f8e$export$9738149b23403ba = `mjApAq_legendary`;
$8787b6314d954f8e$export$617f828bbf323ba2 = `mjApAq_level`;
$8787b6314d954f8e$export$fad0c4d9d422c6d3 = `mjApAq_levelBadge`;
$8787b6314d954f8e$export$d7a6b934f302e93f = `mjApAq_levelInfoBox`;
$8787b6314d954f8e$export$9085649ded432365 = `mjApAq_levelInfoBoxes`;
$8787b6314d954f8e$export$b6335e2e4852d2f8 = `mjApAq_lockedIcon`;
$8787b6314d954f8e$export$ef8b3c650f0e5fb3 = `mjApAq_pageBgImage`;
$8787b6314d954f8e$export$3471600b91f1cae6 = `mjApAq_platformLogo`;
$8787b6314d954f8e$export$504d7abb21fa8c9 = `mjApAq_progress`;
$8787b6314d954f8e$export$cbc1416578dd3747 = `mjApAq_quest`;
$8787b6314d954f8e$export$b2e68d2f08b863d2 = `mjApAq_rare`;
$8787b6314d954f8e$export$97678cb1dc0e0fc0 = `mjApAq_scorecard`;
$8787b6314d954f8e$export$bc4b99392c7330b9 = `mjApAq_scorecardContent`;
$8787b6314d954f8e$export$fad3c8302a7540c6 = `mjApAq_scrollContainer`;
$8787b6314d954f8e$export$5a3af59d4539c451 = `mjApAq_shareError`;
$8787b6314d954f8e$export$5ebab997b8566089 = `mjApAq_statBox`;
$8787b6314d954f8e$export$a9366fbbda880794 = `mjApAq_statBoxContainer`;
$8787b6314d954f8e$export$e0dc3265b8932732 = `mjApAq_statBoxLong`;
$8787b6314d954f8e$export$197356bebb306e39 = `mjApAq_statTextContainer`;
$8787b6314d954f8e$export$a19053e6a5f4b6a8 = `mjApAq_statTitle`;
$8787b6314d954f8e$export$c96745152eb2740f = `mjApAq_subtitle`;
$8787b6314d954f8e$export$d167761217acc355 = `mjApAq_tabButtons`;
$8787b6314d954f8e$export$e8251cd941786af1 = `mjApAq_tabGroup`;
$8787b6314d954f8e$export$faecd7a64ed7d994 = `mjApAq_tabGroupLoader`;
$8787b6314d954f8e$export$2cedfd664bb3bd01 = `mjApAq_textContainer`;
$8787b6314d954f8e$export$870b5cbff008e1ed = `mjApAq_titleBar`;
$8787b6314d954f8e$export$1cbbc5990c2ee230 = `mjApAq_titles`;
$8787b6314d954f8e$export$ad38ce7e9fa921f3 = `mjApAq_titlesNumber`;
$8787b6314d954f8e$export$ac052f74bbc68e2d = `mjApAq_topBar`;
$8787b6314d954f8e$export$76bf72d8613283e6 = `mjApAq_uncommon`;
$8787b6314d954f8e$export$5e1be761f603d585 = `mjApAq_username`;
$8787b6314d954f8e$export$ea0f4417b3a15bd9 = `mjApAq_yourStats`;


function $c795c3392da37fa9$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const isProfileOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isProfileOpen);
    const { currentUserProfileV2: currentUserProfileV2, availableBadges: availableBadges, availableTitles: availableTitles } = (0, $6lYLL.useAppSelector)((state)=>state.profile);
    const loggedIn = (0, $6lYLL.useAppSelector)((state)=>state.auth.loggedIn);
    const brandingData = theme.customJSON.profileDrawerV2;
    const shareText = theme.customJSON.informationDrawer?.shareButton?.shareText;
    // const isDiscordBranded = IS_DISCORD_ACTIVITY;
    const isDiscordBranded = true; // No web versions currently so leave as discord branded
    (0, $8FY87.useEffect)(()=>{
        if (isProfileOpen) {
            audio?.play("gust-open");
            (0, $i7H0N.sendEventV2)("open_profile");
        }
    }, [
        isProfileOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isProfileOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    (0, $8FY87.useEffect)(()=>{
        // Load data initially
        dispatch((0, $4KKbJ.getAvailableBadges)());
        dispatch((0, $4KKbJ.getAvailableTitles)());
    }, [
        loggedIn
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Load data initially, and then again once user is logged in
        dispatch((0, $4KKbJ.loadCurrentUserProfileV2)());
    }, [
        loggedIn
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.ProfileDrawer, {
            [$8787b6314d954f8e$exports["isOpen"]]: isProfileOpen
        }),
        inert: !isProfileOpen ? "" : undefined,
        onTransitionEnd: onTransitionEnd,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                buttonRef: closeButtonRef,
                iconType: "close",
                buttonStyle: "round",
                ariaLabel: "Close Profile",
                className: $8787b6314d954f8e$exports.closeButton,
                onClick: ()=>{
                    audio?.play("gust-close");
                    (0, $i7H0N.sendEventV2)("close_profile");
                    dispatch((0, $baXkz.closeProfile)());
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)($c795c3392da37fa9$var$ProfileDrawerV2Contents, {
                isVisible: isProfileOpen,
                availableTitles: availableTitles,
                usersTitles: currentUserProfileV2?.titles,
                availableBadges: availableBadges,
                usersBadges: currentUserProfileV2?.badges,
                hasGameCompletionUI: brandingData?.hasGameCompletionUI !== false,
                isGameCompleted: currentUserProfileV2?.missionCompleted,
                username: currentUserProfileV2?.displayName,
                brandCardImage: brandingData?.cardImageUrl,
                brandLogo: brandingData?.logoImageUrl,
                brandBackgroundImage: brandingData?.backgroundImageUrl,
                platformIcon: isDiscordBranded ? "discord" : "profile",
                gameDescriptionWord: isDiscordBranded ? "Quest" : "Mission",
                gameIcon: isDiscordBranded ? "wreath" : "action",
                hideBadgesLine: brandingData?.hideBadgesLine,
                shareText: shareText
            })
        ]
    });
}
function $c795c3392da37fa9$var$ProfileDrawerV2Contents({ isVisible: isVisible, availableTitles: availableTitles, usersTitles: usersTitles, availableBadges: availableBadges, usersBadges: usersBadges, username: username, brandCardImage: brandCardImage, brandLogo: brandLogo, brandBackgroundImage: brandBackgroundImage, hasGameCompletionUI: hasGameCompletionUI = true, isGameCompleted: isGameCompleted, platformIcon: platformIcon, gameDescriptionWord: gameDescriptionWord, gameIcon: gameIcon, hideBadgesLine: hideBadgesLine, shareText: shareText }) {
    const [currentTab, setCurrentTab] = (0, $8FY87.useState)("levels");
    const [isShareError, setIsShareError] = (0, $8FY87.useState)(false);
    const [isShareLoading, setIsShareLoading] = (0, $8FY87.useState)(false);
    const [revealedHints, setRevealedHints] = (0, $8FY87.useState)(new Set());
    const handleRevealHint = (id)=>{
        setRevealedHints((prev)=>new Set(prev).add(id));
        (0, $i7H0N.sendEventV2)("profile_view_hint", [
            id
        ]);
    };
    const COMPLETED_COLOR = "#7FBF5A";
    // Current badge is badge with highest order number (e.g. gold with order of 2 is shown over bronze with 0)
    const currentBadge = usersBadges.length ? usersBadges.reduce((a, b)=>b.order > a.order ? b : a) : null;
    const levelColor = currentBadge?.color ?? "white";
    const gameStatusText = isGameCompleted ? "Complete" : "Incomplete";
    const numberOfCompletedTitles = usersTitles?.length || 0;
    const numberOfAvailableTitles = availableTitles?.length || 0;
    const titlesPercent = numberOfCompletedTitles / numberOfAvailableTitles * 100 || 0;
    async function openProfileImage() {
        setIsShareLoading(true);
        setIsShareError(false);
        try {
            const filename = `${gameDescriptionWord} Scorecard.png`;
            // Give 2 extra seconds to allow device sharing functions to load
            const ADDITIONAL_LOADING_TIME_MS = 2000;
            if (0, $aTRs6.IS_DISCORD_ACTIVITY) {
                if ((0, $764u1.isDiscordOnMobile)()) {
                    // Don't share the card on discord mobile as not supported
                    await (0, $764u1.triggerDiscordShare)(shareText);
                    setTimeout(()=>{
                        setIsShareLoading(false);
                    }, ADDITIONAL_LOADING_TIME_MS);
                } else {
                    // Discord desktop
                    const imageUrl = await (0, $76f7c06a5bd7857a$export$2e2bcd8739ae039)(brandBackgroundImage);
                    await (0, $764u1.shareImageInDiscordDesktop)(imageUrl, filename);
                    (0, $i7H0N.sendEventV2)("share_profile_image", [
                        "discord"
                    ]);
                    setTimeout(()=>{
                        setIsShareLoading(false);
                    }, ADDITIONAL_LOADING_TIME_MS);
                }
            } else {
                // Web
                const imageUrl = await (0, $76f7c06a5bd7857a$export$2e2bcd8739ae039)(brandBackgroundImage);
                (0, $i7H0N.sendEventV2)("share_profile_image", [
                    "web"
                ]);
                // Does not work in iPhone browser
                window.open(imageUrl, "_blank", "noopener");
                setTimeout(()=>{
                    setIsShareLoading(false);
                }, ADDITIONAL_LOADING_TIME_MS);
            }
        } catch (error) {
            console.log("Error sharing profile:", error);
            setIsShareError(true);
            setIsShareLoading(false);
        }
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $8787b6314d954f8e$exports.scrollContainer,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $8787b6314d954f8e$exports.content,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $8787b6314d954f8e$exports.pageBgImage,
                    style: {
                        backgroundImage: `url("${brandBackgroundImage}")`
                    }
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                    className: $8787b6314d954f8e$exports.scorecard,
                    id: "arise-profile-scorecard",
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                        className: $8787b6314d954f8e$exports.scorecardContent,
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $8787b6314d954f8e$exports.bgImage,
                                style: {
                                    backgroundImage: `url("${brandCardImage}")`
                                }
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $8787b6314d954f8e$exports.divider
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $8787b6314d954f8e$exports.topBar,
                                children: [
                                    brandLogo && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                                        src: brandLogo,
                                        className: $8787b6314d954f8e$exports.brandLogo,
                                        crossOrigin: "anonymous"
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                        className: $8787b6314d954f8e$exports.platformLogo,
                                        type: platformIcon
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                className: $8787b6314d954f8e$exports.titleBar,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                                        children: [
                                            gameDescriptionWord,
                                            " Scorecard"
                                        ]
                                    }),
                                    username && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                        className: $8787b6314d954f8e$exports.username,
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                className: $8787b6314d954f8e$exports.icon,
                                                type: platformIcon
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                children: username
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $8787b6314d954f8e$exports.divider
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $8787b6314d954f8e$exports.statBoxContainer,
                                children: [
                                    hasGameCompletionUI && /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                        className: $8787b6314d954f8e$exports.statBox,
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                                isLoaded: typeof isGameCompleted === "boolean"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                className: $8787b6314d954f8e$exports.icon,
                                                type: gameIcon
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                className: $8787b6314d954f8e$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.statTitle,
                                                        children: gameDescriptionWord
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.subtitle,
                                                        children: gameStatusText
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                        className: $8787b6314d954f8e$exports.statBox,
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                                isLoaded: typeof numberOfCompletedTitles === "number" && typeof numberOfAvailableTitles === "number"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                className: $8787b6314d954f8e$exports.icon,
                                                type: "crown"
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                className: $8787b6314d954f8e$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                        className: $8787b6314d954f8e$exports.statTitle,
                                                        children: [
                                                            numberOfCompletedTitles,
                                                            "/",
                                                            numberOfAvailableTitles
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.subtitle,
                                                        children: "Titles"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.statBox, $8787b6314d954f8e$exports.statBoxLong),
                                        children: [
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                                isLoaded: !!usersBadges
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.icon, $8787b6314d954f8e$exports.active),
                                                type: "shield",
                                                style: {
                                                    fill: levelColor
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                className: $8787b6314d954f8e$exports.statTextContainer,
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.subtitle,
                                                        children: "Level:"
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.statTitle,
                                                        style: {
                                                            color: levelColor
                                                        },
                                                        children: currentBadge?.name ?? "Incomplete"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $30206c92d1e90dc2$export$2e2bcd8739ae039), {
                                        classname: $8787b6314d954f8e$exports.levelBadge,
                                        imagePath: currentBadge?.imagePath,
                                        isLocked: !currentBadge,
                                        isLoading: !usersBadges,
                                        shimmerDelay: 3
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                className: $8787b6314d954f8e$exports.divider
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $8787b6314d954f8e$exports.ctaButtonsContainer,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                            onClick: openProfileImage,
                            disabled: isShareLoading,
                            children: [
                                "Share",
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                    type: isShareLoading ? "animated-spinner" : "share"
                                })
                            ]
                        }),
                        isShareError && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                            className: $8787b6314d954f8e$exports.shareError,
                            children: "Unable to share, try again later"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                    className: $8787b6314d954f8e$exports.yourStats,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.icon),
                                    type: "bolt"
                                }),
                                "Your stats"
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: $8787b6314d954f8e$exports.gridContainer,
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.level, $8787b6314d954f8e$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                            isLoaded: !!usersBadges
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $30206c92d1e90dc2$export$2e2bcd8739ae039), {
                                            classname: $8787b6314d954f8e$exports.levelBadge,
                                            imagePath: currentBadge?.imagePath,
                                            isLoading: !usersBadges,
                                            shimmerDelay: 4,
                                            isLocked: !currentBadge
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                            className: $8787b6314d954f8e$exports.statTitle,
                                            style: {
                                                color: levelColor
                                            },
                                            children: currentBadge?.name ?? "Incomplete"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                            className: $8787b6314d954f8e$exports.subtitle,
                                            children: "Your Level"
                                        })
                                    ]
                                }),
                                hasGameCompletionUI && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.statBox, $8787b6314d954f8e$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                            isLoaded: typeof isGameCompleted === "boolean"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: $8787b6314d954f8e$exports.left,
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.icon, $8787b6314d954f8e$exports.active),
                                                type: gameIcon,
                                                style: {
                                                    fill: isGameCompleted ? COMPLETED_COLOR : "#BF5A5A"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                    className: $8787b6314d954f8e$exports.statTitle,
                                                    children: gameDescriptionWord
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                    className: $8787b6314d954f8e$exports.subtitle,
                                                    children: gameStatusText
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.statBox, $8787b6314d954f8e$exports.box),
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                            isLoaded: typeof numberOfCompletedTitles === "number" && typeof numberOfAvailableTitles === "number"
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                            className: $8787b6314d954f8e$exports.left,
                                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $07475a5ca7821ac5$export$2e2bcd8739ae039), {
                                                percent: isVisible ? titlesPercent : 100,
                                                className: $8787b6314d954f8e$exports.progress,
                                                icon: "crown"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                    className: $8787b6314d954f8e$exports.titlesNumber,
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                            className: $8787b6314d954f8e$exports.highlight,
                                                            children: numberOfCompletedTitles
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                            children: [
                                                                "/",
                                                                numberOfAvailableTitles
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                    className: $8787b6314d954f8e$exports.subtitle,
                                                    children: "Titles Unlocked"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("section", {
                    className: $8787b6314d954f8e$exports.tabGroup,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: $8787b6314d954f8e$exports.tabButtons,
                            role: "tablist",
                            "aria-label": "Stat Information Options",
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                        [$8787b6314d954f8e$exports.active]: currentTab === "levels"
                                    }),
                                    role: "tab",
                                    "aria-selected": currentTab === "levels",
                                    disabled: currentTab === "levels",
                                    "aria-controls": "panel-levels",
                                    id: "tab-levels",
                                    onClick: ()=>{
                                        setCurrentTab("levels");
                                        (0, $i7H0N.sendEventV2)("view_profile_section", [
                                            "levels"
                                        ]);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                            type: "shield"
                                        }),
                                        "Levels"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsxs)("button", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                                        [$8787b6314d954f8e$exports.active]: currentTab === "titles"
                                    }),
                                    role: "tab",
                                    "aria-selected": currentTab === "titles",
                                    disabled: currentTab === "titles",
                                    "aria-controls": "panel-titles",
                                    id: "tab-titles",
                                    onClick: ()=>{
                                        setCurrentTab("titles");
                                        (0, $i7H0N.sendEventV2)("view_profile_section", [
                                            "titles"
                                        ]);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                            type: "crown"
                                        }),
                                        "Titles"
                                    ]
                                })
                            ]
                        }),
                        currentTab === "levels" && /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                            id: "panel-levels",
                            role: "tabpanel",
                            "aria-labelledby": "tab-levels",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $8787b6314d954f8e$exports.levelInfoBoxes,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                        isLoaded: availableBadges && !!usersBadges,
                                        className: $8787b6314d954f8e$exports.tabGroupLoader
                                    }),
                                    availableBadges && usersBadges && availableBadges?.map((badge, index)=>{
                                        const badgeIsCompleted = usersBadges?.some((userBadge)=>userBadge.id === badge.id);
                                        return /*#__PURE__*/ (0, $2PPWI.jsxs)("li", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8787b6314d954f8e$exports.levelInfoBox, {
                                                [$8787b6314d954f8e$exports.hasLine]: !hideBadgesLine
                                            }),
                                            children: [
                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $30206c92d1e90dc2$export$2e2bcd8739ae039), {
                                                    classname: $8787b6314d954f8e$exports.levelBadge,
                                                    imagePath: badge.imagePath,
                                                    isLoading: !usersBadges,
                                                    shimmerDelay: index,
                                                    isLocked: !badgeIsCompleted
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                                                    className: $8787b6314d954f8e$exports.textContainer,
                                                    children: [
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                            className: $8787b6314d954f8e$exports.largerText,
                                                            style: {
                                                                color: badge.color
                                                            },
                                                            children: badge.name
                                                        }),
                                                        /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                            className: $8787b6314d954f8e$exports.subtitle,
                                                            children: badge.description
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                    className: $8787b6314d954f8e$exports.icon,
                                                    type: "checked-box",
                                                    style: {
                                                        fill: badgeIsCompleted ? COMPLETED_COLOR : "#4E4E4E"
                                                    }
                                                })
                                            ]
                                        }, badge.id);
                                    })
                                ]
                            })
                        }),
                        currentTab === "titles" && /*#__PURE__*/ (0, $2PPWI.jsx)("section", {
                            id: "panel-titles",
                            role: "tabpanel",
                            "aria-labelledby": "tab-titles",
                            children: /*#__PURE__*/ (0, $2PPWI.jsxs)("ul", {
                                className: $8787b6314d954f8e$exports.titles,
                                children: [
                                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1145929b19f809ce$export$2e2bcd8739ae039), {
                                        isLoaded: !!availableTitles,
                                        className: $8787b6314d954f8e$exports.tabGroupLoader
                                    }),
                                    availableTitles?.map((title)=>{
                                        const titleIsCompleted = usersTitles?.some((userBadge)=>userBadge.id === title.id);
                                        return /*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                                            children: titleIsCompleted ? /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                        className: $8787b6314d954f8e$exports.left,
                                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $70b304448aa01420$export$2e2bcd8739ae039), {
                                                            text: title.title,
                                                            rarity: title.rarity
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                        className: $8787b6314d954f8e$exports.subtitle,
                                                        children: [
                                                            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                                                                className: $8787b6314d954f8e$exports[title.rarity?.toLowerCase()],
                                                                children: [
                                                                    title.rarity,
                                                                    ":",
                                                                    " "
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                                children: title.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                                                        className: $8787b6314d954f8e$exports.left,
                                                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                                                            className: $8787b6314d954f8e$exports.lockedIcon,
                                                            type: "locked"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                                        className: $8787b6314d954f8e$exports.subtitle,
                                                        children: revealedHints.has(title.id) ? title.hint : "You haven\u2019t found this Title yet!"
                                                    }),
                                                    !revealedHints.has(title.id) && /*#__PURE__*/ (0, $2PPWI.jsx)("button", {
                                                        onClick: ()=>handleRevealHint(title.id),
                                                        className: $8787b6314d954f8e$exports.hintButton,
                                                        children: "Hint"
                                                    })
                                                ]
                                            })
                                        }, title.id);
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}




var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");
class $30d64d450ce962a3$export$42a112c78ab9c376 {
    begin(callback, delay) {
        this.clear();
        this.remaining = delay;
        this.callback = callback;
        this.resume();
    }
    pause() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
            this.remaining -= Date.now() - this.start;
        }
    }
    resume() {
        if (this.timerId !== null || !this.callback || this.remaining <= 0) return;
        this.start = Date.now();
        this.timerId = window.setTimeout(()=>{
            try {
                this.callback?.();
            } catch (e) {
                console.error("PauseableTimeout callback error:", e);
            }
            this.timerId = null;
        }, this.remaining);
    }
    clear() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.callback = null;
    }
    constructor(){
        this.timerId = null;
        this.start = 0;
        this.remaining = 0;
        this.callback = null;
    }
}



var $6lYLL = parcelRequire("6lYLL");

var $kyBxf = parcelRequire("kyBxf");

var $f9aoP = parcelRequire("f9aoP");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $4MZsN = parcelRequire("4MZsN");
var $63f95629fc7f8338$exports = {};

$parcel$export($63f95629fc7f8338$exports, "NewsTickerItem", function () { return $63f95629fc7f8338$export$1bfd873cb97abd02; }, function (v) { return $63f95629fc7f8338$export$1bfd873cb97abd02 = v; });
$parcel$export($63f95629fc7f8338$exports, "achievement", function () { return $63f95629fc7f8338$export$f8c0c7d510456e0; }, function (v) { return $63f95629fc7f8338$export$f8c0c7d510456e0 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH1", function () { return $63f95629fc7f8338$export$17fa98cb055e8fa7; }, function (v) { return $63f95629fc7f8338$export$17fa98cb055e8fa7 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH2", function () { return $63f95629fc7f8338$export$a5833c2b43ca4340; }, function (v) { return $63f95629fc7f8338$export$a5833c2b43ca4340 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH3", function () { return $63f95629fc7f8338$export$47511f9a6581d1d6; }, function (v) { return $63f95629fc7f8338$export$47511f9a6581d1d6 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH4", function () { return $63f95629fc7f8338$export$dd1c05b92185401c; }, function (v) { return $63f95629fc7f8338$export$dd1c05b92185401c = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH5", function () { return $63f95629fc7f8338$export$8b28cf6cd00fe080; }, function (v) { return $63f95629fc7f8338$export$8b28cf6cd00fe080 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeH6", function () { return $63f95629fc7f8338$export$186c650311ff0789; }, function (v) { return $63f95629fc7f8338$export$186c650311ff0789 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeSmall", function () { return $63f95629fc7f8338$export$6746fe0d9c9fab54; }, function (v) { return $63f95629fc7f8338$export$6746fe0d9c9fab54 = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizeTiny", function () { return $63f95629fc7f8338$export$2bcf359f0c20e94f; }, function (v) { return $63f95629fc7f8338$export$2bcf359f0c20e94f = v; });
$parcel$export($63f95629fc7f8338$exports, "fontSizep", function () { return $63f95629fc7f8338$export$2903d10d531d0ac0; }, function (v) { return $63f95629fc7f8338$export$2903d10d531d0ac0 = v; });
$parcel$export($63f95629fc7f8338$exports, "general", function () { return $63f95629fc7f8338$export$78b80bc2f5d4953a; }, function (v) { return $63f95629fc7f8338$export$78b80bc2f5d4953a = v; });
$parcel$export($63f95629fc7f8338$exports, "hasLowerTransparency", function () { return $63f95629fc7f8338$export$8cc8c8a9ccbfef4c; }, function (v) { return $63f95629fc7f8338$export$8cc8c8a9ccbfef4c = v; });
$parcel$export($63f95629fc7f8338$exports, "icon", function () { return $63f95629fc7f8338$export$1ca1ec8b29a4ce27; }, function (v) { return $63f95629fc7f8338$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($63f95629fc7f8338$exports, "message", function () { return $63f95629fc7f8338$export$a8ecead220dd38a6; }, function (v) { return $63f95629fc7f8338$export$a8ecead220dd38a6 = v; });
$parcel$export($63f95629fc7f8338$exports, "negative", function () { return $63f95629fc7f8338$export$5f47f64d03acd206; }, function (v) { return $63f95629fc7f8338$export$5f47f64d03acd206 = v; });
$parcel$export($63f95629fc7f8338$exports, "notification", function () { return $63f95629fc7f8338$export$2adf6238a2d0dafa; }, function (v) { return $63f95629fc7f8338$export$2adf6238a2d0dafa = v; });
$parcel$export($63f95629fc7f8338$exports, "positive", function () { return $63f95629fc7f8338$export$aa5128ab863cd04; }, function (v) { return $63f95629fc7f8338$export$aa5128ab863cd04 = v; });
var $63f95629fc7f8338$export$1bfd873cb97abd02;
var $63f95629fc7f8338$export$f8c0c7d510456e0;
var $63f95629fc7f8338$export$17fa98cb055e8fa7;
var $63f95629fc7f8338$export$a5833c2b43ca4340;
var $63f95629fc7f8338$export$47511f9a6581d1d6;
var $63f95629fc7f8338$export$dd1c05b92185401c;
var $63f95629fc7f8338$export$8b28cf6cd00fe080;
var $63f95629fc7f8338$export$186c650311ff0789;
var $63f95629fc7f8338$export$6746fe0d9c9fab54;
var $63f95629fc7f8338$export$2bcf359f0c20e94f;
var $63f95629fc7f8338$export$2903d10d531d0ac0;
var $63f95629fc7f8338$export$78b80bc2f5d4953a;
var $63f95629fc7f8338$export$8cc8c8a9ccbfef4c;
var $63f95629fc7f8338$export$1ca1ec8b29a4ce27;
var $63f95629fc7f8338$export$a8ecead220dd38a6;
var $63f95629fc7f8338$export$5f47f64d03acd206;
var $63f95629fc7f8338$export$2adf6238a2d0dafa;
var $63f95629fc7f8338$export$aa5128ab863cd04;
$63f95629fc7f8338$export$1bfd873cb97abd02 = `VaAOEq_NewsTickerItem`;
$63f95629fc7f8338$export$f8c0c7d510456e0 = `VaAOEq_achievement`;
$63f95629fc7f8338$export$17fa98cb055e8fa7 = `VaAOEq_fontSizeH1`;
$63f95629fc7f8338$export$a5833c2b43ca4340 = `VaAOEq_fontSizeH2`;
$63f95629fc7f8338$export$47511f9a6581d1d6 = `VaAOEq_fontSizeH3`;
$63f95629fc7f8338$export$dd1c05b92185401c = `VaAOEq_fontSizeH4`;
$63f95629fc7f8338$export$8b28cf6cd00fe080 = `VaAOEq_fontSizeH5`;
$63f95629fc7f8338$export$186c650311ff0789 = `VaAOEq_fontSizeH6`;
$63f95629fc7f8338$export$6746fe0d9c9fab54 = `VaAOEq_fontSizeSmall`;
$63f95629fc7f8338$export$2bcf359f0c20e94f = `VaAOEq_fontSizeTiny`;
$63f95629fc7f8338$export$2903d10d531d0ac0 = `VaAOEq_fontSizep`;
$63f95629fc7f8338$export$78b80bc2f5d4953a = `VaAOEq_general`;
$63f95629fc7f8338$export$8cc8c8a9ccbfef4c = `VaAOEq_hasLowerTransparency`;
$63f95629fc7f8338$export$1ca1ec8b29a4ce27 = `VaAOEq_icon`;
$63f95629fc7f8338$export$a8ecead220dd38a6 = `VaAOEq_message`;
$63f95629fc7f8338$export$5f47f64d03acd206 = `VaAOEq_negative`;
$63f95629fc7f8338$export$2adf6238a2d0dafa = `VaAOEq_notification`;
$63f95629fc7f8338$export$aa5128ab863cd04 = `VaAOEq_positive`;


const $ed30b0241b39f363$var$TRANSITION_DURATION_MS = 600;
const $ed30b0241b39f363$var$NewsTickerItem = ({ status: status, message: message, hasLowerTransparency: hasLowerTransparency })=>{
    const currentMessage = (0, $8FY87.useRef)(message);
    if (status === "middle") // Only update text when item is off screen
    currentMessage.current = message;
    const transitionDuration = status === "bottom" ? 0 : $ed30b0241b39f363$var$TRANSITION_DURATION_MS;
    const statusToY = {
        bottom: "100%",
        middle: "0",
        top: "-100%"
    };
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($63f95629fc7f8338$exports.NewsTickerItem, {
            [$63f95629fc7f8338$exports.hasLowerTransparency]: hasLowerTransparency
        }),
        style: {
            transform: `translateY(${statusToY[status]})`,
            transitionDuration: transitionDuration + "ms"
        },
        children: currentMessage.current && /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($63f95629fc7f8338$exports.message, $63f95629fc7f8338$exports[currentMessage.current.type]),
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $63f95629fc7f8338$exports.icon,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                        type: currentMessage.current.icon,
                        size: 12
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    children: $ed30b0241b39f363$var$formatMessage(currentMessage.current.message, currentMessage.current.data)
                })
            ]
        })
    });
};
function $ed30b0241b39f363$var$formatMessage(message, data) {
    if (!data) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: message
    });
    // Example message: [person] did the thing. So did [others].
    const PLACEHOLDER_REGEX = /(\[.*?\])/g;
    const SQUARE_BRACKETS_REGEX = /\[|\]/g;
    // Split into parts
    const parts = message.split(PLACEHOLDER_REGEX).map((part, index)=>{
        // If part is a placeholder...
        if (part.match(PLACEHOLDER_REGEX)) {
            // Remove the square brackets
            const key = part.replace(SQUARE_BRACKETS_REGEX, "");
            // If found inside the data, replace the key with the data and put inside a span.
            return data.hasOwnProperty(key) ? /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                children: data[key]
            }, `${key}-${index}`) : key;
        }
        return part;
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {
        children: parts
    });
}
var $ed30b0241b39f363$export$2e2bcd8739ae039 = $ed30b0241b39f363$var$NewsTickerItem;


var $a9b40beeeab93fd6$export$22ab3915f81c0ba8;
var $a9b40beeeab93fd6$export$17fa98cb055e8fa7;
var $a9b40beeeab93fd6$export$a5833c2b43ca4340;
var $a9b40beeeab93fd6$export$47511f9a6581d1d6;
var $a9b40beeeab93fd6$export$dd1c05b92185401c;
var $a9b40beeeab93fd6$export$8b28cf6cd00fe080;
var $a9b40beeeab93fd6$export$186c650311ff0789;
var $a9b40beeeab93fd6$export$6746fe0d9c9fab54;
var $a9b40beeeab93fd6$export$2bcf359f0c20e94f;
var $a9b40beeeab93fd6$export$2903d10d531d0ac0;
var $a9b40beeeab93fd6$export$8cc8c8a9ccbfef4c;
var $a9b40beeeab93fd6$export$73920f18ca706874;
$a9b40beeeab93fd6$export$22ab3915f81c0ba8 = `Sg01jW_NewsTicker`;
$a9b40beeeab93fd6$export$17fa98cb055e8fa7 = `Sg01jW_fontSizeH1`;
$a9b40beeeab93fd6$export$a5833c2b43ca4340 = `Sg01jW_fontSizeH2`;
$a9b40beeeab93fd6$export$47511f9a6581d1d6 = `Sg01jW_fontSizeH3`;
$a9b40beeeab93fd6$export$dd1c05b92185401c = `Sg01jW_fontSizeH4`;
$a9b40beeeab93fd6$export$8b28cf6cd00fe080 = `Sg01jW_fontSizeH5`;
$a9b40beeeab93fd6$export$186c650311ff0789 = `Sg01jW_fontSizeH6`;
$a9b40beeeab93fd6$export$6746fe0d9c9fab54 = `Sg01jW_fontSizeSmall`;
$a9b40beeeab93fd6$export$2bcf359f0c20e94f = `Sg01jW_fontSizeTiny`;
$a9b40beeeab93fd6$export$2903d10d531d0ac0 = `Sg01jW_fontSizep`;
$a9b40beeeab93fd6$export$8cc8c8a9ccbfef4c = `Sg01jW_hasLowerTransparency`;
$a9b40beeeab93fd6$export$73920f18ca706874 = `Sg01jW_hidden`;


const $6284a37f3a600919$var$REMOTE_DATA_POLL_FREQUENCY_MIN = 5; // Remote data poll frequency in MINUTES
const $6284a37f3a600919$var$MIN_MESSAGE_VISIBILITY_MS = 2000; // Minimum amount of time a message must be visible for, in milliseconds
const $6284a37f3a600919$var$MAX_MESSAGE_VISIBILITY_MS = 10000; // Maximum amount of time a message must be visible for, in milliseconds
const $6284a37f3a600919$var$NewsTickerContainer = ()=>{
    const theme = (0, $cEIti.useTheme)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const newsTickerQueue = (0, $6lYLL.useAppSelector)((state)=>state.feed.newsTickerQueue);
    const newsTickerTag = (0, $6lYLL.useAppSelector)((state)=>state.feed.newsTickerTag);
    const isNewsTickerVisible = (0, $6lYLL.useAppSelector)((state)=>state.app.isNewsTickerVisible);
    const customJsonData = theme.customJSON?.newsTicker;
    const [messageToShow, setMessageToShow] = (0, $8FY87.useState)();
    const remoteData = (0, $8FY87.useRef)();
    const highPriorityMessages = (0, $8FY87.useRef)([]);
    const filteredGenericEvents = (0, $8FY87.useRef)([]);
    const genericEventsCurrentIndex = (0, $8FY87.useRef)(0);
    const currentNewsTickerTag = (0, $8FY87.useRef)("");
    const canShowMessage = (0, $8FY87.useRef)(true); // e.g if MIN_MESSAGE_VISIBILITY_MS has elapsed
    const maxTimeout = (0, $8FY87.useRef)(new (0, $30d64d450ce962a3$export$42a112c78ab9c376)());
    const minTimeout = (0, $8FY87.useRef)(new (0, $30d64d450ce962a3$export$42a112c78ab9c376)());
    async function getRemoteData() {
        try {
            const response = await (0, $f9aoP.getNewsTickerData)();
            const isValid = Array.isArray(response.genericEvents) && response.genericEvents?.length > 0 && response.hasOwnProperty("userSpecificEvents");
            if (!isValid) throw new Error("Data is invalid");
            remoteData.current = response;
            updateFilteredGenericEvents();
        } catch (error) {
            console.warn("Could not get news ticker data", error);
        }
    }
    function isFullNewsTickerItemData(item) {
        return "type" in item;
    }
    function itemMatchesTag(item) {
        if (!currentNewsTickerTag?.current) return true;
        if (isFullNewsTickerItemData(item)) return !Array.isArray(item.tags) || item.tags.length === 0 || item.tags.includes(currentNewsTickerTag.current);
        return false;
    }
    function updateFilteredGenericEvents() {
        // Ensure only items which match current tag are shown
        const allGenericEvents = remoteData?.current?.genericEvents;
        if (allGenericEvents?.length) filteredGenericEvents.current = allGenericEvents.filter(itemMatchesTag);
        else filteredGenericEvents.current = [];
        genericEventsCurrentIndex.current = 0;
        // Show first low-priority message if nothing is showing and allowed
        if (!!customJsonData?.showImmediately && canShowMessage.current && !messageToShow) showLowPriorityMessage();
    }
    function addHighPriorityMessage(item) {
        if (isFullNewsTickerItemData(item)) highPriorityMessages.current?.push(item);
        else if ("id" in item) {
            // Find the message ID in the remote data and add it to the queue
            const message = remoteData.current?.userSpecificEvents?.[item.id];
            if (message) highPriorityMessages.current?.push(message);
        }
        showHighPriorityMessage();
    }
    (0, $8FY87.useEffect)(()=>{
        // Whenever a message changes, time X seconds before showing a generic message
        if (messageToShow) maxTimeout.current?.begin(()=>{
            showLowPriorityMessage();
        }, $6284a37f3a600919$var$MAX_MESSAGE_VISIBILITY_MS);
        return ()=>{
            maxTimeout.current?.clear();
        };
    }, [
        messageToShow
    ]);
    (0, $8FY87.useEffect)(()=>{
        isNewsTickerVisible ? maxTimeout.current?.resume() : maxTimeout.current?.pause();
        isNewsTickerVisible ? minTimeout.current?.resume() : minTimeout.current?.pause();
        // If newsTicker becomes visible, but has no messages, start showing generic messages
        if (isNewsTickerVisible && canShowMessage.current && !messageToShow) showLowPriorityMessage();
    }, [
        isNewsTickerVisible
    ]);
    function showHighPriorityMessage() {
        // Remove message from start of queue and show it
        if (canShowMessage.current && highPriorityMessages.current[0]) {
            const message = highPriorityMessages.current?.shift();
            showMessage(message);
        }
    }
    function showLowPriorityMessage() {
        // Get next message from generic array and show it
        if (filteredGenericEvents.current?.length) {
            // If index is too high, set back to 0
            if (genericEventsCurrentIndex.current >= filteredGenericEvents.current.length) genericEventsCurrentIndex.current = 0;
            const message = filteredGenericEvents.current[genericEventsCurrentIndex.current];
            showMessage(message);
            genericEventsCurrentIndex.current++;
        }
    }
    function showMessage(message) {
        if (message && canShowMessage.current) {
            setMessageToShow(message);
            canShowMessage.current = false;
            // Stop new messages from showing for X seconds
            minTimeout.current?.begin(()=>{
                canShowMessage.current = true;
                showHighPriorityMessage();
            }, $6284a37f3a600919$var$MIN_MESSAGE_VISIBILITY_MS);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        // When a news ticker message is added to state via the bridge...
        // Add it to the local array and remove it from the state.
        const newItem = newsTickerQueue[0];
        if (newItem) {
            addHighPriorityMessage(newItem);
            dispatch((0, $kyBxf.removeFirstNewsTickerItemFromQueue)());
        }
    }, [
        newsTickerQueue
    ]);
    (0, $8FY87.useEffect)(()=>{
        currentNewsTickerTag.current = newsTickerTag;
        updateFilteredGenericEvents();
    }, [
        newsTickerTag
    ]);
    (0, $8FY87.useEffect)(()=>{
        getRemoteData();
        // Get fresh remote data every n minutes
        const pollInterval = setInterval(getRemoteData, $6284a37f3a600919$var$REMOTE_DATA_POLL_FREQUENCY_MIN * 60000);
        return ()=>{
            clearInterval(pollInterval);
        };
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)($6284a37f3a600919$var$NewsTicker, {
        messageToShow: messageToShow,
        isVisible: isNewsTickerVisible,
        hasLowerTransparency: customJsonData?.lowerTransparency
    });
};
// Dumb component only controlled via its own props
const $6284a37f3a600919$var$NewsTicker = ({ messageToShow: messageToShow, isVisible: isVisible, hasLowerTransparency: hasLowerTransparency })=>{
    const [itemAState, setItemAState] = (0, $8FY87.useState)("bottom");
    const [itemBState, setItemBState] = (0, $8FY87.useState)("top");
    const [itemCState, setItemCState] = (0, $8FY87.useState)("middle");
    const [itemAMessage, setItemAMessage] = (0, $8FY87.useState)();
    const [itemBMessage, setItemBMessage] = (0, $8FY87.useState)();
    const [itemCMessage, setItemCMessage] = (0, $8FY87.useState)();
    const numberOfMessagesSeen = (0, $8FY87.useRef)(0);
    (0, $8FY87.useEffect)(()=>{
        if (messageToShow) showMessage(messageToShow);
    }, [
        messageToShow
    ]);
    function getNextState(currentState) {
        if (currentState === "top") return "bottom";
        if (currentState === "middle") return "top";
        if (currentState === "bottom") return "middle";
    }
    function animateTicker() {
        setItemAState((prev)=>getNextState(prev));
        setItemBState((prev)=>getNextState(prev));
        setItemCState((prev)=>getNextState(prev));
        numberOfMessagesSeen.current++;
    }
    function setBottomMessage(message) {
        const options = [
            setItemAMessage,
            setItemBMessage,
            setItemCMessage
        ];
        const functionToUse = options[numberOfMessagesSeen.current % 3];
        functionToUse(message);
    }
    function showMessage(message) {
        setBottomMessage(message);
        animateTicker();
    }
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($a9b40beeeab93fd6$export$22ab3915f81c0ba8, {
            [$a9b40beeeab93fd6$export$73920f18ca706874]: !isVisible,
            [$a9b40beeeab93fd6$export$8cc8c8a9ccbfef4c]: hasLowerTransparency
        }),
        "aria-hidden": !isVisible,
        inert: !isVisible ? "" : undefined,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ed30b0241b39f363$export$2e2bcd8739ae039), {
                    status: itemAState,
                    message: itemAMessage,
                    hasLowerTransparency: hasLowerTransparency
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ed30b0241b39f363$export$2e2bcd8739ae039), {
                    status: itemBState,
                    message: itemBMessage,
                    hasLowerTransparency: hasLowerTransparency
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ed30b0241b39f363$export$2e2bcd8739ae039), {
                    status: itemCState,
                    message: itemCMessage,
                    hasLowerTransparency: hasLowerTransparency
                })
            ]
        })
    });
};
var $6284a37f3a600919$export$2e2bcd8739ae039 = $6284a37f3a600919$var$NewsTickerContainer;



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");


var $cEIti = parcelRequire("cEIti");

var $baXkz = parcelRequire("baXkz");

var $8d81dc9250f8e061$export$9e75746c9c02d3b5;
var $8d81dc9250f8e061$export$efe229eab43a9869;
var $8d81dc9250f8e061$export$8f981dffec84ba52;
var $8d81dc9250f8e061$export$17fa98cb055e8fa7;
var $8d81dc9250f8e061$export$a5833c2b43ca4340;
var $8d81dc9250f8e061$export$47511f9a6581d1d6;
var $8d81dc9250f8e061$export$dd1c05b92185401c;
var $8d81dc9250f8e061$export$8b28cf6cd00fe080;
var $8d81dc9250f8e061$export$186c650311ff0789;
var $8d81dc9250f8e061$export$6746fe0d9c9fab54;
var $8d81dc9250f8e061$export$2bcf359f0c20e94f;
var $8d81dc9250f8e061$export$2903d10d531d0ac0;
var $8d81dc9250f8e061$export$ea0830439c7fc698;
var $8d81dc9250f8e061$export$fad3c8302a7540c6;
$8d81dc9250f8e061$export$9e75746c9c02d3b5 = `M5xZwa_InformationDrawer`;
$8d81dc9250f8e061$export$efe229eab43a9869 = `M5xZwa_closeButton`;
$8d81dc9250f8e061$export$8f981dffec84ba52 = `M5xZwa_contentContainer`;
$8d81dc9250f8e061$export$17fa98cb055e8fa7 = `M5xZwa_fontSizeH1`;
$8d81dc9250f8e061$export$a5833c2b43ca4340 = `M5xZwa_fontSizeH2`;
$8d81dc9250f8e061$export$47511f9a6581d1d6 = `M5xZwa_fontSizeH3`;
$8d81dc9250f8e061$export$dd1c05b92185401c = `M5xZwa_fontSizeH4`;
$8d81dc9250f8e061$export$8b28cf6cd00fe080 = `M5xZwa_fontSizeH5`;
$8d81dc9250f8e061$export$186c650311ff0789 = `M5xZwa_fontSizeH6`;
$8d81dc9250f8e061$export$6746fe0d9c9fab54 = `M5xZwa_fontSizeSmall`;
$8d81dc9250f8e061$export$2bcf359f0c20e94f = `M5xZwa_fontSizeTiny`;
$8d81dc9250f8e061$export$2903d10d531d0ac0 = `M5xZwa_fontSizep`;
$8d81dc9250f8e061$export$ea0830439c7fc698 = `M5xZwa_isOpen`;
$8d81dc9250f8e061$export$fad3c8302a7540c6 = `M5xZwa_scrollContainer`;



function $8a2a3bc183b65809$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const theme = (0, $cEIti.useTheme)();
    const isInformationOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isInformationOpen);
    const closeButtonRef = (0, $8FY87.useRef)(null);
    const drawerData = theme.customJSON?.informationDrawer;
    (0, $8FY87.useEffect)(()=>{
        if (isInformationOpen) {
            audio?.play("gust-open");
            (0, $i7H0N.sendEventV2)("information_drawer_viewed");
        }
    }, [
        isInformationOpen
    ]);
    // Move focus to drawer when opened
    function onTransitionEnd(e) {
        if (isInformationOpen && e.target === e.currentTarget) setTimeout(()=>{
            closeButtonRef.current?.focus();
        }, 200);
    }
    // Import custom content per instance
    const InfoDrawerContent = /*#__PURE__*/ (0, $8FY87.lazy)(()=>{
        return (parcelRequire("4uLFE"));
    });
    if (!drawerData?.enabled) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($8d81dc9250f8e061$export$9e75746c9c02d3b5, {
            [$8d81dc9250f8e061$export$ea0830439c7fc698]: isInformationOpen
        }),
        inert: !isInformationOpen ? "" : undefined,
        onTransitionEnd: onTransitionEnd,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $8d81dc9250f8e061$export$fad3c8302a7540c6,
            style: {
                backgroundImage: `url("${drawerData?.topBackgroundImageUrl}")`
            },
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                    buttonRef: closeButtonRef,
                    iconType: "close",
                    buttonStyle: "round",
                    ariaLabel: "Close Information",
                    className: $8d81dc9250f8e061$export$efe229eab43a9869,
                    onClick: ()=>{
                        audio?.play("gust-close");
                        dispatch((0, $baXkz.setIsInformationOpen)(false));
                    }
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $8d81dc9250f8e061$export$8f981dffec84ba52,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8FY87.Suspense), {
                        fallback: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            children: "Loading"
                        }),
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)(InfoDrawerContent, {})
                    })
                })
            ]
        })
    });
}





var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $f9aoP = parcelRequire("f9aoP");

var $i7H0N = parcelRequire("i7H0N");


var $ba3ce4eaa5bf18e0$export$463872088a60c6cb;
var $ba3ce4eaa5bf18e0$export$2b77a92f1a5ad772;
var $ba3ce4eaa5bf18e0$export$17fa98cb055e8fa7;
var $ba3ce4eaa5bf18e0$export$a5833c2b43ca4340;
var $ba3ce4eaa5bf18e0$export$47511f9a6581d1d6;
var $ba3ce4eaa5bf18e0$export$dd1c05b92185401c;
var $ba3ce4eaa5bf18e0$export$8b28cf6cd00fe080;
var $ba3ce4eaa5bf18e0$export$186c650311ff0789;
var $ba3ce4eaa5bf18e0$export$6746fe0d9c9fab54;
var $ba3ce4eaa5bf18e0$export$2bcf359f0c20e94f;
var $ba3ce4eaa5bf18e0$export$2903d10d531d0ac0;
$ba3ce4eaa5bf18e0$export$463872088a60c6cb = `GTxPVW_GenericLeaderboard`;
$ba3ce4eaa5bf18e0$export$2b77a92f1a5ad772 = `GTxPVW_Modal`;
$ba3ce4eaa5bf18e0$export$17fa98cb055e8fa7 = `GTxPVW_fontSizeH1`;
$ba3ce4eaa5bf18e0$export$a5833c2b43ca4340 = `GTxPVW_fontSizeH2`;
$ba3ce4eaa5bf18e0$export$47511f9a6581d1d6 = `GTxPVW_fontSizeH3`;
$ba3ce4eaa5bf18e0$export$dd1c05b92185401c = `GTxPVW_fontSizeH4`;
$ba3ce4eaa5bf18e0$export$8b28cf6cd00fe080 = `GTxPVW_fontSizeH5`;
$ba3ce4eaa5bf18e0$export$186c650311ff0789 = `GTxPVW_fontSizeH6`;
$ba3ce4eaa5bf18e0$export$6746fe0d9c9fab54 = `GTxPVW_fontSizeSmall`;
$ba3ce4eaa5bf18e0$export$2bcf359f0c20e94f = `GTxPVW_fontSizeTiny`;
$ba3ce4eaa5bf18e0$export$2903d10d531d0ac0 = `GTxPVW_fontSizep`;


function $38be9655d6d88675$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const isLeaderboardOpen = (0, $6lYLL.useAppSelector)((state)=>state.app.isLeaderboardOpen);
    const [leaderboardData, setLeaderboardData] = (0, $8FY87.useState)(null);
    const [isError, setIsError] = (0, $8FY87.useState)(false);
    async function getData() {
        try {
            const response = await (0, $f9aoP.getGenericLeaderboardData)();
            setLeaderboardData(response);
        } catch (error) {
            console.warn("Could not get leaderboard data:", error);
            setIsError(true);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        if (isLeaderboardOpen) {
            getData();
            (0, $i7H0N.sendEvent)("open_leaderboard");
        } else setTimeout(()=>{
            // Timeout to allow modal to move off screen
            setLeaderboardData(null);
            setIsError(false);
        }, 500);
    }, [
        isLeaderboardOpen
    ]);
    const hasLeaderboard = theme.customJSON?.leaderboard?.enabled;
    if (!hasLeaderboard) return null;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        modalClassname: $ba3ce4eaa5bf18e0$export$2b77a92f1a5ad772,
        title: "Leaderboard",
        isVisible: isLeaderboardOpen,
        onClose: ()=>{
            dispatch((0, $baXkz.setIsLeaderboardOpen)(false));
        },
        canScroll: true,
        isLoading: !leaderboardData && !isError,
        leaveSpaceAboveAndBelow: false,
        zIndex: 1000,
        children: leaderboardData || isError ? /*#__PURE__*/ (0, $2PPWI.jsx)($38be9655d6d88675$var$Leaderboard, {
            entries: leaderboardData?.leaderboard,
            emptyMessage: "Once you complete the mission, your ranking will appear here!",
            errorMessage: "We\u2019re having trouble loading the leaderboard right now.",
            isError: isError
        }) : null
    });
}
const $38be9655d6d88675$var$Leaderboard = ({ entries: entries, emptyMessage: emptyMessage, errorMessage: errorMessage, isError: isError })=>{
    if (isError) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $ba3ce4eaa5bf18e0$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
            children: errorMessage ?? "Try again later"
        })
    });
    if (!entries?.length) return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $ba3ce4eaa5bf18e0$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $2PPWI.jsx)("h3", {
            children: emptyMessage
        })
    });
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $ba3ce4eaa5bf18e0$export$463872088a60c6cb,
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("table", {
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                children: "#"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                children: "User"
                            }),
                            /*#__PURE__*/ (0, $2PPWI.jsx)("th", {
                                children: "Score"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("tbody", {
                    children: entries.map((entry, index)=>/*#__PURE__*/ (0, $2PPWI.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                    children: (0, $aed6ee8c7b23660f$export$9173b52dfbd534b4)(entry.position)
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                                        children: entry.displayName
                                    })
                                }),
                                /*#__PURE__*/ (0, $2PPWI.jsx)("td", {
                                    children: (0, $aed6ee8c7b23660f$export$a6283a56ed31c98a)(entry.score, "N/A")
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
};




var $1URoE = parcelRequire("1URoE");

var $cEIti = parcelRequire("cEIti");

var $f9aoP = parcelRequire("f9aoP");

function $3e5ffd7ffe6e1c1b$export$2e2bcd8739ae039() {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const { location: location, isLocationLoading: isLocationLoading, isProfileOpen: isProfileOpen, isInformationOpen: isInformationOpen, locationLoadErrorId: locationLoadErrorId, shouldHideUi: shouldHideUi } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const loggedIn = (0, $6lYLL.useAppSelector)((state)=>state.auth.loggedIn);
    const { locationId: id } = (0, $d5fb2d3e42b0c581$export$99eaa27ddbbb95ef)();
    (0, $8FY87.useEffect)(()=>{
        // Redirect if not found
        if (locationLoadErrorId === id) navigate((0, $1URoE.homePath));
    }, [
        locationLoadErrorId
    ]);
    (0, $8FY87.useEffect)(()=>{
        if ((!location || location.id !== id) && !isLocationLoading) dispatch((0, $baXkz.loadLocation)(id));
        (0, $a28589f4827e1ded$export$a0769f17975cb672)();
        (0, $a28589f4827e1ded$export$b494c8ee88b3a008)();
        // Reset UI on load
        dispatch((0, $baXkz.setIsNewsTickerVisible)(!!theme.customJSON?.newsTicker?.showImmediately));
    }, [
        id
    ]);
    (0, $8FY87.useEffect)(()=>{
        let interval;
        let timeout;
        if (id && loggedIn) // Begin heartbeat after 2 seconds
        timeout = setTimeout(()=>{
            (0, $f9aoP.heartbeat)(id);
            interval = setInterval(()=>{
                (0, $f9aoP.heartbeat)(id);
            }, 30000); // 30s
        }, 2000);
        return ()=>{
            if (timeout) clearTimeout(timeout);
            if (interval) clearInterval(interval);
        };
    }, [
        id,
        loggedIn
    ]);
    if (!location || location.id !== id) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    const sidebarIsOpen = (isProfileOpen || isInformationOpen) && !shouldHideUi;
    const hasProfileDrawer = true;
    const hasProfileDrawerV2 = "true";
    const hasInformationDrawer = theme.customJSON?.informationDrawer?.enabled;
    const hasNewsTicker = true;
    const hasMenu = true;
    const arisewareLoadingImageUrl = location.customJSON?.arisewareLoadingImageUrl;
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4eb1e267ba3c534d$export$2e2bcd8739ae039), {
        pageHasProfileDrawer: hasProfileDrawer,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1c24d8d5442c4687$export$2a82ddc22e8c7fbb, {
                    [$1c24d8d5442c4687$export$fc6855fecb80bb3f]: sidebarIsOpen
                }),
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d612fdc595978133$export$2e2bcd8739ae039), {
                        forceInFrontOfUi: shouldHideUi,
                        src: location.iframeURL || location.latestArisewareBuildURL,
                        arisewareProjectID: location.arisewareProjectID,
                        onReady: ()=>{},
                        loadingImage: arisewareLoadingImageUrl ? arisewareLoadingImageUrl : null,
                        loadingText: theme.metadata?.customJSON?.loadingText
                    }),
                    hasNewsTicker && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6284a37f3a600919$export$2e2bcd8739ae039), {}),
                    hasMenu && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $60ba48ffbe0ae6e8$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1c24d8d5442c4687$export$1a2a2e04fdf9f489, {
                    [$1c24d8d5442c4687$export$cc09b7862278318c]: sidebarIsOpen
                }),
                children: [
                    hasProfileDrawer && (hasProfileDrawerV2 ? /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c795c3392da37fa9$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c292466b2c4e7afc$export$2e2bcd8739ae039), {})),
                    hasInformationDrawer && /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8a2a3bc183b65809$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $38be9655d6d88675$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7cf519921f906496$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eaf2d4aabcdd6ef8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $c28b3bc7c5a3f98b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1b92270b3f8c4d42$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $cEIti = parcelRequire("cEIti");

var $aTRs6 = parcelRequire("aTRs6");


var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $2PPWI = parcelRequire("2PPWI");

var $9s93Y = parcelRequire("9s93Y");

var $8FY87 = parcelRequire("8FY87");
var $046f38f7ed62274d$exports = {};

$parcel$export($046f38f7ed62274d$exports, "AnimatedFullscreenText", function () { return $046f38f7ed62274d$export$176a62fda607b5a0; }, function (v) { return $046f38f7ed62274d$export$176a62fda607b5a0 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH1", function () { return $046f38f7ed62274d$export$17fa98cb055e8fa7; }, function (v) { return $046f38f7ed62274d$export$17fa98cb055e8fa7 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH2", function () { return $046f38f7ed62274d$export$a5833c2b43ca4340; }, function (v) { return $046f38f7ed62274d$export$a5833c2b43ca4340 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH3", function () { return $046f38f7ed62274d$export$47511f9a6581d1d6; }, function (v) { return $046f38f7ed62274d$export$47511f9a6581d1d6 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH4", function () { return $046f38f7ed62274d$export$dd1c05b92185401c; }, function (v) { return $046f38f7ed62274d$export$dd1c05b92185401c = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH5", function () { return $046f38f7ed62274d$export$8b28cf6cd00fe080; }, function (v) { return $046f38f7ed62274d$export$8b28cf6cd00fe080 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeH6", function () { return $046f38f7ed62274d$export$186c650311ff0789; }, function (v) { return $046f38f7ed62274d$export$186c650311ff0789 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeSmall", function () { return $046f38f7ed62274d$export$6746fe0d9c9fab54; }, function (v) { return $046f38f7ed62274d$export$6746fe0d9c9fab54 = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizeTiny", function () { return $046f38f7ed62274d$export$2bcf359f0c20e94f; }, function (v) { return $046f38f7ed62274d$export$2bcf359f0c20e94f = v; });
$parcel$export($046f38f7ed62274d$exports, "fontSizep", function () { return $046f38f7ed62274d$export$2903d10d531d0ac0; }, function (v) { return $046f38f7ed62274d$export$2903d10d531d0ac0 = v; });
$parcel$export($046f38f7ed62274d$exports, "highlighted", function () { return $046f38f7ed62274d$export$ba6acb6e4dfd83c2; }, function (v) { return $046f38f7ed62274d$export$ba6acb6e4dfd83c2 = v; });
$parcel$export($046f38f7ed62274d$exports, "longTitle", function () { return $046f38f7ed62274d$export$578fcbc4821dcd12; }, function (v) { return $046f38f7ed62274d$export$578fcbc4821dcd12 = v; });
$parcel$export($046f38f7ed62274d$exports, "moveUp", function () { return $046f38f7ed62274d$export$44935f8a884b57b9; }, function (v) { return $046f38f7ed62274d$export$44935f8a884b57b9 = v; });
$parcel$export($046f38f7ed62274d$exports, "page-transition-postVisible", function () { return $046f38f7ed62274d$export$635eb3172be88cc1; }, function (v) { return $046f38f7ed62274d$export$635eb3172be88cc1 = v; });
$parcel$export($046f38f7ed62274d$exports, "page-transition-preVisible", function () { return $046f38f7ed62274d$export$d0da582c244d7927; }, function (v) { return $046f38f7ed62274d$export$d0da582c244d7927 = v; });
$parcel$export($046f38f7ed62274d$exports, "page-transition-visible", function () { return $046f38f7ed62274d$export$110dabf6daad8b9a; }, function (v) { return $046f38f7ed62274d$export$110dabf6daad8b9a = v; });
$parcel$export($046f38f7ed62274d$exports, "title", function () { return $046f38f7ed62274d$export$fb184b623420d9be; }, function (v) { return $046f38f7ed62274d$export$fb184b623420d9be = v; });
var $046f38f7ed62274d$export$176a62fda607b5a0;
var $046f38f7ed62274d$export$17fa98cb055e8fa7;
var $046f38f7ed62274d$export$a5833c2b43ca4340;
var $046f38f7ed62274d$export$47511f9a6581d1d6;
var $046f38f7ed62274d$export$dd1c05b92185401c;
var $046f38f7ed62274d$export$8b28cf6cd00fe080;
var $046f38f7ed62274d$export$186c650311ff0789;
var $046f38f7ed62274d$export$6746fe0d9c9fab54;
var $046f38f7ed62274d$export$2bcf359f0c20e94f;
var $046f38f7ed62274d$export$2903d10d531d0ac0;
var $046f38f7ed62274d$export$ba6acb6e4dfd83c2;
var $046f38f7ed62274d$export$578fcbc4821dcd12;
var $046f38f7ed62274d$export$44935f8a884b57b9;
var $046f38f7ed62274d$export$635eb3172be88cc1;
var $046f38f7ed62274d$export$d0da582c244d7927;
var $046f38f7ed62274d$export$110dabf6daad8b9a;
var $046f38f7ed62274d$export$fb184b623420d9be;
$046f38f7ed62274d$export$176a62fda607b5a0 = `TglI0W_AnimatedFullscreenText`;
$046f38f7ed62274d$export$17fa98cb055e8fa7 = `TglI0W_fontSizeH1`;
$046f38f7ed62274d$export$a5833c2b43ca4340 = `TglI0W_fontSizeH2`;
$046f38f7ed62274d$export$47511f9a6581d1d6 = `TglI0W_fontSizeH3`;
$046f38f7ed62274d$export$dd1c05b92185401c = `TglI0W_fontSizeH4`;
$046f38f7ed62274d$export$8b28cf6cd00fe080 = `TglI0W_fontSizeH5`;
$046f38f7ed62274d$export$186c650311ff0789 = `TglI0W_fontSizeH6`;
$046f38f7ed62274d$export$6746fe0d9c9fab54 = `TglI0W_fontSizeSmall`;
$046f38f7ed62274d$export$2bcf359f0c20e94f = `TglI0W_fontSizeTiny`;
$046f38f7ed62274d$export$2903d10d531d0ac0 = `TglI0W_fontSizep`;
$046f38f7ed62274d$export$ba6acb6e4dfd83c2 = `TglI0W_highlighted`;
$046f38f7ed62274d$export$578fcbc4821dcd12 = `TglI0W_longTitle`;
$046f38f7ed62274d$export$44935f8a884b57b9 = `TglI0W_moveUp`;
$046f38f7ed62274d$export$44935f8a884b57b9;
$046f38f7ed62274d$export$635eb3172be88cc1 = `TglI0W_page-transition-postVisible`;
$046f38f7ed62274d$export$d0da582c244d7927 = `TglI0W_page-transition-preVisible`;
$046f38f7ed62274d$export$110dabf6daad8b9a = `TglI0W_page-transition-visible`;
$046f38f7ed62274d$export$fb184b623420d9be = `TglI0W_title`;



function $d9635d0fc63992ea$export$2e2bcd8739ae039({ titles: titles, transitionState: transitionState, onComplete: onComplete }) {
    const [visibleTitleIndex, setVisibleTitleIndex] = (0, $8FY87.useState)(-1);
    const getWords = (title)=>{
        const arrayOfWords = title.split(" ");
        const animateInDurationMs = 1000;
        const durationPerWord = animateInDurationMs / arrayOfWords.length;
        return arrayOfWords.map((word, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("span", {
                style: {
                    animationDelay: `-${durationPerWord * (arrayOfWords.length - 1 - index)}ms`
                },
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))({
                    [$046f38f7ed62274d$exports.highlighted]: index === arrayOfWords.length - 1
                }),
                children: word + (index < arrayOfWords.length - 1 ? " " : "")
            }, index));
    };
    (0, $8FY87.useEffect)(()=>{
        // Transition between titles
        if (!titles || transitionState !== (0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible) return;
        const getAnimationDuration = (index)=>{
            switch(index){
                case -1:
                    return 0;
                case 0:
                    return 2000;
                default:
                    return 1000;
            }
        };
        let timeout;
        if (visibleTitleIndex < titles.length) timeout = setTimeout(()=>{
            setVisibleTitleIndex(visibleTitleIndex + 1);
        }, getAnimationDuration(visibleTitleIndex));
        else // No more titles to show
        onComplete();
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        visibleTitleIndex,
        titles,
        transitionState
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($046f38f7ed62274d$exports.AnimatedFullscreenText, $046f38f7ed62274d$exports[transitionState]),
        "aria-hidden": transitionState !== (0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible,
        "aria-live": "assertive",
        "aria-label": titles && titles.join(". "),
        children: titles && titles.map((title, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($046f38f7ed62274d$exports.title, {
                    [$046f38f7ed62274d$exports[(0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible]]: visibleTitleIndex < index,
                    [$046f38f7ed62274d$exports[(0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible]]: visibleTitleIndex === index,
                    [$046f38f7ed62274d$exports[(0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible]]: visibleTitleIndex > index && index !== titles.length - 1,
                    [$046f38f7ed62274d$exports.longTitle]: title.length > 16
                }),
                children: getWords(title)
            }, index))
    });
}


function $44dd682fc34d463c$export$2e2bcd8739ae039({ children: children }) {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const theme = (0, $cEIti.useTheme)();
    const hasWorldIntroPlayed = (0, $6lYLL.useAppSelector)((state)=>state.app.hasWorldIntroPlayed);
    const isPurchaseInProgress = (0, $6lYLL.useAppSelector)((state)=>state.app.isPurchaseInProgress);
    const [transitionState, setTransitionState] = (0, $8FY87.useState)((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible);
    const titles = theme.customJSON?.worldIntroductionText;
    (0, $8FY87.useEffect)(()=>{
        // Only show intro to user once
        const hasSeenWorldIntro = hasWorldIntroPlayed || window.localStorage.getItem((0, $aTRs6.LS_HASSEENWORLDINTRO_KEY)) || !titles?.length;
        if (hasSeenWorldIntro) dispatch((0, $baXkz.setHasWorldIntroPlayed)(true));
        else setTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible);
    }, [
        theme
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (isPurchaseInProgress) // If doing a purchase, don't show world intro
        onComplete();
    }, [
        isPurchaseInProgress
    ]);
    const onComplete = ()=>{
        setTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible);
        window.localStorage.setItem((0, $aTRs6.LS_HASSEENWORLDINTRO_KEY), "true");
        dispatch((0, $baXkz.setHasWorldIntroPlayed)(true));
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $2PPWI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d9635d0fc63992ea$export$2e2bcd8739ae039), {
                titles: titles,
                transitionState: transitionState,
                onComplete: onComplete
            }),
            hasWorldIntroPlayed && children
        ]
    });
}


function $08d8b97892d92b00$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44dd682fc34d463c$export$2e2bcd8739ae039), {
        children: children
    });
}



var $2PPWI = parcelRequire("2PPWI");

function $79ed83bfaac0c5ef$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $44dd682fc34d463c$export$2e2bcd8739ae039), {
        children: children
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $9s93Y = parcelRequire("9s93Y");

var $2PPWI = parcelRequire("2PPWI");
var $1f88dc252fa45b9b$export$ae0b394994a19059;
var $1f88dc252fa45b9b$export$773b1e3435eb66a6;
var $1f88dc252fa45b9b$export$524e34c32c7e633;
var $1f88dc252fa45b9b$export$cb8d04ae725acbee;
var $1f88dc252fa45b9b$export$3761835a330c4434;
var $1f88dc252fa45b9b$export$3d6893050d2bb9b2;
var $1f88dc252fa45b9b$export$914d2a30a703750b;
var $1f88dc252fa45b9b$export$4bdb6170bbc0ab05;
var $1f88dc252fa45b9b$export$b60232580c012a69;
var $1f88dc252fa45b9b$export$c9719e800df92493;
var $1f88dc252fa45b9b$export$79042b3680c83597;
var $1f88dc252fa45b9b$export$17fa98cb055e8fa7;
var $1f88dc252fa45b9b$export$a5833c2b43ca4340;
var $1f88dc252fa45b9b$export$47511f9a6581d1d6;
var $1f88dc252fa45b9b$export$dd1c05b92185401c;
var $1f88dc252fa45b9b$export$8b28cf6cd00fe080;
var $1f88dc252fa45b9b$export$186c650311ff0789;
var $1f88dc252fa45b9b$export$6746fe0d9c9fab54;
var $1f88dc252fa45b9b$export$2bcf359f0c20e94f;
var $1f88dc252fa45b9b$export$2903d10d531d0ac0;
$1f88dc252fa45b9b$export$ae0b394994a19059 = `zCW8cW_SceneSelectorTile`;
$1f88dc252fa45b9b$export$773b1e3435eb66a6 = `zCW8cW_SceneSelectorTile--inCenter`;
$1f88dc252fa45b9b$export$524e34c32c7e633 = `zCW8cW_SceneSelectorTile--locked`;
$1f88dc252fa45b9b$export$cb8d04ae725acbee = `zCW8cW_SceneSelectorTile__anchor`;
$1f88dc252fa45b9b$export$3761835a330c4434 = `zCW8cW_SceneSelectorTile__customBorder`;
$1f88dc252fa45b9b$export$3d6893050d2bb9b2 = `zCW8cW_SceneSelectorTile__image`;
$1f88dc252fa45b9b$export$914d2a30a703750b = `zCW8cW_SceneSelectorTile__imageContainer`;
$1f88dc252fa45b9b$export$4bdb6170bbc0ab05 = `zCW8cW_SceneSelectorTile__lockedIcon`;
$1f88dc252fa45b9b$export$b60232580c012a69 = `zCW8cW_SceneSelectorTile__lockedSubtext`;
$1f88dc252fa45b9b$export$c9719e800df92493 = `zCW8cW_SceneSelectorTile__playButton`;
$1f88dc252fa45b9b$export$79042b3680c83597 = `zCW8cW_SceneSelectorTile__textContainer`;
$1f88dc252fa45b9b$export$17fa98cb055e8fa7 = `zCW8cW_fontSizeH1`;
$1f88dc252fa45b9b$export$a5833c2b43ca4340 = `zCW8cW_fontSizeH2`;
$1f88dc252fa45b9b$export$47511f9a6581d1d6 = `zCW8cW_fontSizeH3`;
$1f88dc252fa45b9b$export$dd1c05b92185401c = `zCW8cW_fontSizeH4`;
$1f88dc252fa45b9b$export$8b28cf6cd00fe080 = `zCW8cW_fontSizeH5`;
$1f88dc252fa45b9b$export$186c650311ff0789 = `zCW8cW_fontSizeH6`;
$1f88dc252fa45b9b$export$6746fe0d9c9fab54 = `zCW8cW_fontSizeSmall`;
$1f88dc252fa45b9b$export$2bcf359f0c20e94f = `zCW8cW_fontSizeTiny`;
$1f88dc252fa45b9b$export$2903d10d531d0ac0 = `zCW8cW_fontSizep`;



var $9s93Y = parcelRequire("9s93Y");

var $4MZsN = parcelRequire("4MZsN");

function $8b34429b21da2d90$export$2e2bcd8739ae039({ onClick: onClick, imageUrl: imageUrl, imageMaskUrl: imageMaskUrl, lockedImageUrl: lockedImageUrl, description: description, lockedText: lockedText, lockedSubtext: lockedSubtext, tabbable: tabbable = true, isInCenter: isInCenter = true, isOpen: isOpen }) {
    function handleKeyDown(e) {
        if (e.key === "Enter" && onClick) onClick();
    }
    const renderLockedText = ()=>/*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $1f88dc252fa45b9b$export$79042b3680c83597,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    children: lockedText
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    className: $1f88dc252fa45b9b$export$b60232580c012a69,
                    children: lockedSubtext
                })
            ]
        });
    const renderUnlockedText = ()=>/*#__PURE__*/ (0, $2PPWI.jsx)("div", {
            className: $1f88dc252fa45b9b$export$79042b3680c83597,
            children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: description
            })
        });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($1f88dc252fa45b9b$export$ae0b394994a19059, {
            [$1f88dc252fa45b9b$export$524e34c32c7e633]: !isOpen,
            [$1f88dc252fa45b9b$export$773b1e3435eb66a6]: isInCenter
        }),
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsxs)("a", {
                className: $1f88dc252fa45b9b$export$cb8d04ae725acbee,
                onClick: onClick,
                tabIndex: tabbable ? 0 : -1,
                onKeyDown: handleKeyDown,
                children: [
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $1f88dc252fa45b9b$export$3761835a330c4434,
                        style: imageMaskUrl ? {
                            maskImage: `url(${imageMaskUrl})`
                        } : {}
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $1f88dc252fa45b9b$export$914d2a30a703750b,
                        style: imageMaskUrl ? {
                            maskImage: `url(${imageMaskUrl})`
                        } : {},
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: $1f88dc252fa45b9b$export$3d6893050d2bb9b2,
                            style: {
                                backgroundImage: isOpen ? `url(${imageUrl})` : `url(${lockedImageUrl})`
                            }
                        })
                    }),
                    isOpen ? null : /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                        className: $1f88dc252fa45b9b$export$4bdb6170bbc0ab05,
                        children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $4MZsN.default), {
                            type: "locked",
                            size: 72
                        })
                    }),
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $27b023d5f3a79a4c$export$2e2bcd8739ae039), {
                        className: $1f88dc252fa45b9b$export$c9719e800df92493,
                        iconType: isOpen ? "play" : "padlock",
                        ariaLabel: "",
                        buttonStyle: "diamond",
                        disabled: !isOpen,
                        "aria-hidden": true,
                        tabIndex: -1
                    })
                ]
            }),
            isOpen ? renderUnlockedText() : renderLockedText()
        ]
    });
}



var $8FY87 = parcelRequire("8FY87");
const $e443732a029f4a10$export$4837e907045e94e6 = (ref, maxWaitMs)=>{
    const [status, setStatus] = (0, $8FY87.useState)(false);
    (0, $8FY87.useEffect)(()=>{
        const updateStatus = (images)=>{
            if (!status) setStatus(images.map((image)=>image.complete).every((item)=>item === true));
        };
        if (!ref?.current) return;
        const imagesLoaded = Array.from(ref.current.querySelectorAll("img"));
        if (imagesLoaded.length === 0) {
            setStatus(true);
            return;
        }
        imagesLoaded.forEach((image)=>{
            if (image.complete) updateStatus(imagesLoaded);
            image.addEventListener("load", ()=>updateStatus(imagesLoaded), {
                once: true
            });
            image.addEventListener("error", ()=>updateStatus(imagesLoaded), {
                once: true
            });
        });
        // If maximum waiting time exceeded, set status to true anyway (e.g for if UI is waiting)
        let timeout;
        if (maxWaitMs) timeout = setTimeout(()=>{
            setStatus(true);
        }, maxWaitMs);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    return status;
};




var $i7H0N = parcelRequire("i7H0N");

var $aTKgi = parcelRequire("aTKgi");
var $5a5fa516964a52bc$exports = {};

$parcel$export($5a5fa516964a52bc$exports, "SceneSelector", function () { return $5a5fa516964a52bc$export$2b7ed800b7c0fd5; }, function (v) { return $5a5fa516964a52bc$export$2b7ed800b7c0fd5 = v; });
$parcel$export($5a5fa516964a52bc$exports, "SceneSelector__parallax", function () { return $5a5fa516964a52bc$export$388e960b27fc36c6; }, function (v) { return $5a5fa516964a52bc$export$388e960b27fc36c6 = v; });
$parcel$export($5a5fa516964a52bc$exports, "SceneSelector__parallaxContainer", function () { return $5a5fa516964a52bc$export$353aa0772f14428f; }, function (v) { return $5a5fa516964a52bc$export$353aa0772f14428f = v; });
$parcel$export($5a5fa516964a52bc$exports, "SceneSelector__sceneContainer", function () { return $5a5fa516964a52bc$export$e4d9e4009fe698b8; }, function (v) { return $5a5fa516964a52bc$export$e4d9e4009fe698b8 = v; });
$parcel$export($5a5fa516964a52bc$exports, "SceneSelector__scenes", function () { return $5a5fa516964a52bc$export$b468b48907a5ed1b; }, function (v) { return $5a5fa516964a52bc$export$b468b48907a5ed1b = v; });
$parcel$export($5a5fa516964a52bc$exports, "StoryText", function () { return $5a5fa516964a52bc$export$d70e31f26e6bf2ad; }, function (v) { return $5a5fa516964a52bc$export$d70e31f26e6bf2ad = v; });
$parcel$export($5a5fa516964a52bc$exports, "StoryText__Item", function () { return $5a5fa516964a52bc$export$526a6cc6ebac9a16; }, function (v) { return $5a5fa516964a52bc$export$526a6cc6ebac9a16 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH1", function () { return $5a5fa516964a52bc$export$17fa98cb055e8fa7; }, function (v) { return $5a5fa516964a52bc$export$17fa98cb055e8fa7 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH2", function () { return $5a5fa516964a52bc$export$a5833c2b43ca4340; }, function (v) { return $5a5fa516964a52bc$export$a5833c2b43ca4340 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH3", function () { return $5a5fa516964a52bc$export$47511f9a6581d1d6; }, function (v) { return $5a5fa516964a52bc$export$47511f9a6581d1d6 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH4", function () { return $5a5fa516964a52bc$export$dd1c05b92185401c; }, function (v) { return $5a5fa516964a52bc$export$dd1c05b92185401c = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH5", function () { return $5a5fa516964a52bc$export$8b28cf6cd00fe080; }, function (v) { return $5a5fa516964a52bc$export$8b28cf6cd00fe080 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeH6", function () { return $5a5fa516964a52bc$export$186c650311ff0789; }, function (v) { return $5a5fa516964a52bc$export$186c650311ff0789 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeSmall", function () { return $5a5fa516964a52bc$export$6746fe0d9c9fab54; }, function (v) { return $5a5fa516964a52bc$export$6746fe0d9c9fab54 = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizeTiny", function () { return $5a5fa516964a52bc$export$2bcf359f0c20e94f; }, function (v) { return $5a5fa516964a52bc$export$2bcf359f0c20e94f = v; });
$parcel$export($5a5fa516964a52bc$exports, "fontSizep", function () { return $5a5fa516964a52bc$export$2903d10d531d0ac0; }, function (v) { return $5a5fa516964a52bc$export$2903d10d531d0ac0 = v; });
$parcel$export($5a5fa516964a52bc$exports, "page-transition-postVisible", function () { return $5a5fa516964a52bc$export$635eb3172be88cc1; }, function (v) { return $5a5fa516964a52bc$export$635eb3172be88cc1 = v; });
$parcel$export($5a5fa516964a52bc$exports, "page-transition-preVisible", function () { return $5a5fa516964a52bc$export$d0da582c244d7927; }, function (v) { return $5a5fa516964a52bc$export$d0da582c244d7927 = v; });
$parcel$export($5a5fa516964a52bc$exports, "page-transition-visible", function () { return $5a5fa516964a52bc$export$110dabf6daad8b9a; }, function (v) { return $5a5fa516964a52bc$export$110dabf6daad8b9a = v; });
$parcel$export($5a5fa516964a52bc$exports, "parallaxLayer", function () { return $5a5fa516964a52bc$export$596a1a10b8f9fb9e; }, function (v) { return $5a5fa516964a52bc$export$596a1a10b8f9fb9e = v; });
$parcel$export($5a5fa516964a52bc$exports, "parallaxLayer-bg", function () { return $5a5fa516964a52bc$export$8c6beb81202d0cb5; }, function (v) { return $5a5fa516964a52bc$export$8c6beb81202d0cb5 = v; });
$parcel$export($5a5fa516964a52bc$exports, "parallaxLayer-fg", function () { return $5a5fa516964a52bc$export$43cc4c3b84502d2; }, function (v) { return $5a5fa516964a52bc$export$43cc4c3b84502d2 = v; });
$parcel$export($5a5fa516964a52bc$exports, "parallaxLayer-mg", function () { return $5a5fa516964a52bc$export$6a15004e8514d664; }, function (v) { return $5a5fa516964a52bc$export$6a15004e8514d664 = v; });
$parcel$export($5a5fa516964a52bc$exports, "parallaxLayerFrontCover", function () { return $5a5fa516964a52bc$export$e26f8eab2ebab0e7; }, function (v) { return $5a5fa516964a52bc$export$e26f8eab2ebab0e7 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-0", function () { return $5a5fa516964a52bc$export$930ac4122142f541; }, function (v) { return $5a5fa516964a52bc$export$930ac4122142f541 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-1", function () { return $5a5fa516964a52bc$export$57ac4d42dc1193e7; }, function (v) { return $5a5fa516964a52bc$export$57ac4d42dc1193e7 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-10", function () { return $5a5fa516964a52bc$export$2e6ccdb8e4a80d71; }, function (v) { return $5a5fa516964a52bc$export$2e6ccdb8e4a80d71 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-2", function () { return $5a5fa516964a52bc$export$3cebc3ae43d9a7c7; }, function (v) { return $5a5fa516964a52bc$export$3cebc3ae43d9a7c7 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-3", function () { return $5a5fa516964a52bc$export$6fe21125b1eed5c7; }, function (v) { return $5a5fa516964a52bc$export$6fe21125b1eed5c7 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-4", function () { return $5a5fa516964a52bc$export$5f6b8b5195f6de9e; }, function (v) { return $5a5fa516964a52bc$export$5f6b8b5195f6de9e = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-5", function () { return $5a5fa516964a52bc$export$17f5069f57b10678; }, function (v) { return $5a5fa516964a52bc$export$17f5069f57b10678 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-6", function () { return $5a5fa516964a52bc$export$ac37f416112289d9; }, function (v) { return $5a5fa516964a52bc$export$ac37f416112289d9 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-7", function () { return $5a5fa516964a52bc$export$1eda0b0012b6697; }, function (v) { return $5a5fa516964a52bc$export$1eda0b0012b6697 = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-8", function () { return $5a5fa516964a52bc$export$3f7a2856edd45fae; }, function (v) { return $5a5fa516964a52bc$export$3f7a2856edd45fae = v; });
$parcel$export($5a5fa516964a52bc$exports, "scene-9", function () { return $5a5fa516964a52bc$export$17864ba3c50e11be; }, function (v) { return $5a5fa516964a52bc$export$17864ba3c50e11be = v; });
$parcel$export($5a5fa516964a52bc$exports, "sway-animation-bg", function () { return $5a5fa516964a52bc$export$e3f1d39b47982989; }, function (v) { return $5a5fa516964a52bc$export$e3f1d39b47982989 = v; });
$parcel$export($5a5fa516964a52bc$exports, "sway-animation-fg", function () { return $5a5fa516964a52bc$export$9a54826d8b933881; }, function (v) { return $5a5fa516964a52bc$export$9a54826d8b933881 = v; });
$parcel$export($5a5fa516964a52bc$exports, "sway-animation-mg", function () { return $5a5fa516964a52bc$export$40ac614f3549460c; }, function (v) { return $5a5fa516964a52bc$export$40ac614f3549460c = v; });
var $5a5fa516964a52bc$export$2b7ed800b7c0fd5;
var $5a5fa516964a52bc$export$388e960b27fc36c6;
var $5a5fa516964a52bc$export$353aa0772f14428f;
var $5a5fa516964a52bc$export$e4d9e4009fe698b8;
var $5a5fa516964a52bc$export$b468b48907a5ed1b;
var $5a5fa516964a52bc$export$d70e31f26e6bf2ad;
var $5a5fa516964a52bc$export$526a6cc6ebac9a16;
var $5a5fa516964a52bc$export$17fa98cb055e8fa7;
var $5a5fa516964a52bc$export$a5833c2b43ca4340;
var $5a5fa516964a52bc$export$47511f9a6581d1d6;
var $5a5fa516964a52bc$export$dd1c05b92185401c;
var $5a5fa516964a52bc$export$8b28cf6cd00fe080;
var $5a5fa516964a52bc$export$186c650311ff0789;
var $5a5fa516964a52bc$export$6746fe0d9c9fab54;
var $5a5fa516964a52bc$export$2bcf359f0c20e94f;
var $5a5fa516964a52bc$export$2903d10d531d0ac0;
var $5a5fa516964a52bc$export$635eb3172be88cc1;
var $5a5fa516964a52bc$export$d0da582c244d7927;
var $5a5fa516964a52bc$export$110dabf6daad8b9a;
var $5a5fa516964a52bc$export$596a1a10b8f9fb9e;
var $5a5fa516964a52bc$export$8c6beb81202d0cb5;
var $5a5fa516964a52bc$export$43cc4c3b84502d2;
var $5a5fa516964a52bc$export$6a15004e8514d664;
var $5a5fa516964a52bc$export$e26f8eab2ebab0e7;
var $5a5fa516964a52bc$export$930ac4122142f541;
var $5a5fa516964a52bc$export$57ac4d42dc1193e7;
var $5a5fa516964a52bc$export$2e6ccdb8e4a80d71;
var $5a5fa516964a52bc$export$3cebc3ae43d9a7c7;
var $5a5fa516964a52bc$export$6fe21125b1eed5c7;
var $5a5fa516964a52bc$export$5f6b8b5195f6de9e;
var $5a5fa516964a52bc$export$17f5069f57b10678;
var $5a5fa516964a52bc$export$ac37f416112289d9;
var $5a5fa516964a52bc$export$1eda0b0012b6697;
var $5a5fa516964a52bc$export$3f7a2856edd45fae;
var $5a5fa516964a52bc$export$17864ba3c50e11be;
var $5a5fa516964a52bc$export$e3f1d39b47982989;
var $5a5fa516964a52bc$export$9a54826d8b933881;
var $5a5fa516964a52bc$export$40ac614f3549460c;
$5a5fa516964a52bc$export$2b7ed800b7c0fd5 = `kAzX_W_SceneSelector`;
$5a5fa516964a52bc$export$388e960b27fc36c6 = `kAzX_W_SceneSelector__parallax`;
$5a5fa516964a52bc$export$353aa0772f14428f = `kAzX_W_SceneSelector__parallaxContainer`;
$5a5fa516964a52bc$export$e4d9e4009fe698b8 = `kAzX_W_SceneSelector__sceneContainer`;
$5a5fa516964a52bc$export$b468b48907a5ed1b = `kAzX_W_SceneSelector__scenes`;
$5a5fa516964a52bc$export$d70e31f26e6bf2ad = `kAzX_W_StoryText`;
$5a5fa516964a52bc$export$526a6cc6ebac9a16 = `kAzX_W_StoryText__Item`;
$5a5fa516964a52bc$export$17fa98cb055e8fa7 = `kAzX_W_fontSizeH1`;
$5a5fa516964a52bc$export$a5833c2b43ca4340 = `kAzX_W_fontSizeH2`;
$5a5fa516964a52bc$export$47511f9a6581d1d6 = `kAzX_W_fontSizeH3`;
$5a5fa516964a52bc$export$dd1c05b92185401c = `kAzX_W_fontSizeH4`;
$5a5fa516964a52bc$export$8b28cf6cd00fe080 = `kAzX_W_fontSizeH5`;
$5a5fa516964a52bc$export$186c650311ff0789 = `kAzX_W_fontSizeH6`;
$5a5fa516964a52bc$export$6746fe0d9c9fab54 = `kAzX_W_fontSizeSmall`;
$5a5fa516964a52bc$export$2bcf359f0c20e94f = `kAzX_W_fontSizeTiny`;
$5a5fa516964a52bc$export$2903d10d531d0ac0 = `kAzX_W_fontSizep`;
$5a5fa516964a52bc$export$635eb3172be88cc1 = `kAzX_W_page-transition-postVisible`;
$5a5fa516964a52bc$export$d0da582c244d7927 = `kAzX_W_page-transition-preVisible`;
$5a5fa516964a52bc$export$110dabf6daad8b9a = `kAzX_W_page-transition-visible`;
$5a5fa516964a52bc$export$596a1a10b8f9fb9e = `kAzX_W_parallaxLayer`;
$5a5fa516964a52bc$export$8c6beb81202d0cb5 = `kAzX_W_parallaxLayer-bg`;
$5a5fa516964a52bc$export$43cc4c3b84502d2 = `kAzX_W_parallaxLayer-fg`;
$5a5fa516964a52bc$export$6a15004e8514d664 = `kAzX_W_parallaxLayer-mg`;
$5a5fa516964a52bc$export$e26f8eab2ebab0e7 = `kAzX_W_parallaxLayerFrontCover`;
$5a5fa516964a52bc$export$930ac4122142f541 = `kAzX_W_scene-0`;
$5a5fa516964a52bc$export$57ac4d42dc1193e7 = `kAzX_W_scene-1`;
$5a5fa516964a52bc$export$2e6ccdb8e4a80d71 = `kAzX_W_scene-10`;
$5a5fa516964a52bc$export$3cebc3ae43d9a7c7 = `kAzX_W_scene-2`;
$5a5fa516964a52bc$export$6fe21125b1eed5c7 = `kAzX_W_scene-3`;
$5a5fa516964a52bc$export$5f6b8b5195f6de9e = `kAzX_W_scene-4`;
$5a5fa516964a52bc$export$17f5069f57b10678 = `kAzX_W_scene-5`;
$5a5fa516964a52bc$export$ac37f416112289d9 = `kAzX_W_scene-6`;
$5a5fa516964a52bc$export$1eda0b0012b6697 = `kAzX_W_scene-7`;
$5a5fa516964a52bc$export$3f7a2856edd45fae = `kAzX_W_scene-8`;
$5a5fa516964a52bc$export$17864ba3c50e11be = `kAzX_W_scene-9`;
$5a5fa516964a52bc$export$e3f1d39b47982989 = `kAzX_W_sway-animation-bg`;
$5a5fa516964a52bc$export$e3f1d39b47982989;
$5a5fa516964a52bc$export$9a54826d8b933881 = `kAzX_W_sway-animation-fg`;
$5a5fa516964a52bc$export$9a54826d8b933881;
$5a5fa516964a52bc$export$40ac614f3549460c = `kAzX_W_sway-animation-mg`;
$5a5fa516964a52bc$export$40ac614f3549460c;


function $5257621ad393fe9f$export$2e2bcd8739ae039({ scenes: scenes, sceneSelectorSettings: sceneSelectorSettings, transitionState: transitionState, onSceneSelected: onSceneSelected, onParallaxLoaded: onParallaxLoaded, leftAlignScenes: leftAlignScenes }) {
    const parallaxImagesWrapperRef = (0, $8FY87.useRef)(null);
    const containerRef = (0, $8FY87.useRef)(null);
    const areParallaxImagesLoaded = (0, $e443732a029f4a10$export$4837e907045e94e6)(parallaxImagesWrapperRef, 5000);
    const [currentScene, setCurrentScene] = (0, $8FY87.useState)(scenes?.[0]);
    const lastSwipeTime = (0, $8FY87.useRef)(0);
    const previousScenesValue = (0, $8FY87.useRef)([]);
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const SWIPE_DELAY = 1000; // Should match SASS $transition-tiles duration
    const currentSceneId = currentScene?.environmentID;
    const initialSceneNumber = sceneSelectorSettings.initialSceneOrder;
    const getCurrentIndex = ()=>{
        const currentSceneIndex = scenes.map((scene)=>scene.environmentID).indexOf(currentSceneId);
        return currentSceneIndex < 0 ? 0 : currentSceneIndex;
    };
    const currentIndex = getCurrentIndex();
    function onClick(sceneID) {
        if (sceneID === currentSceneId) onSceneSelected(currentSceneId);
        else {
            // Animate to scene
            setCurrentScene(scenes.find((scene)=>scene.environmentID === sceneID));
            audio.play(SCROLL_AUDIO_ID);
            (0, $i7H0N.sendEvent)("scene_selector_navigate", {
                scene_id: sceneID
            });
        }
    }
    function doesScrollNeedResetting(previousScenes, newScenes) {
        if (previousScenes.length !== newScenes.length) return true;
        for(let i = 0; i < previousScenes.length; i++){
            if (previousScenes[i].locationId !== newScenes[i].locationId) return true;
        }
        return false;
    }
    (0, $8FY87.useEffect)(()=>{
        if (doesScrollNeedResetting(previousScenesValue.current, scenes)) setCurrentScene(scenes[initialSceneNumber] ?? scenes[0]);
        previousScenesValue.current = scenes;
    }, [
        scenes
    ]);
    (0, $8FY87.useEffect)(()=>{
        if (areParallaxImagesLoaded) onParallaxLoaded();
    }, [
        areParallaxImagesLoaded
    ]);
    (0, $8FY87.useEffect)(()=>{
        // Handle swiping left and right on mobile
        let start = null;
        function onTouchStart(e) {
            start = e.changedTouches[0];
        }
        function onTouchEnd(e) {
            const end = e.changedTouches[0];
            if (end?.screenX - start?.screenX > 0) swipe(-1);
            else if (end?.screenX - start?.screenX < 0) swipe(1);
        }
        containerRef.current?.addEventListener("touchstart", onTouchStart);
        containerRef.current?.addEventListener("touchend", onTouchEnd);
        const swipe = (direction)=>{
            // Do not allow another swipe for SWIPE_DELAY ms
            if (Date.now() - lastSwipeTime.current < SWIPE_DELAY) return;
            const newId = scenes[currentIndex + direction]?.environmentID;
            if (newId) {
                // If swipe valid, animate to next or previous scene
                setCurrentScene(scenes.find((scene)=>scene.environmentID === newId));
                lastSwipeTime.current = Date.now();
            }
        };
        return ()=>{
            containerRef.current?.removeEventListener("touchstart", onTouchStart);
            containerRef.current?.removeEventListener("touchend", onTouchEnd);
        };
    }, [
        currentSceneId
    ]);
    // Load audio from CMS
    const SCROLL_AUDIO_ID = "scene-selector-scroll";
    const BACKGROUND_AUDIO_ID = "scene-selector-bg-music";
    const getSceneAudioID = (sceneIndex)=>"scene-selector-bg-audio-" + sceneIndex;
    const loadAudio = ()=>{
        if (!audio.hasTrack(SCROLL_AUDIO_ID)) audio.addTrack({
            id: SCROLL_AUDIO_ID,
            src: sceneSelectorSettings.scrollAudio,
            ambient: false,
            volume: 0.8
        });
        if (!audio.hasTrack(BACKGROUND_AUDIO_ID)) audio.addTrack({
            id: BACKGROUND_AUDIO_ID,
            src: sceneSelectorSettings.backgroundAudio,
            ambient: true,
            volume: 0.5
        });
        scenes.forEach((scene, index)=>{
            if (!audio.hasTrack(getSceneAudioID(index))) audio.addTrack({
                id: getSceneAudioID(index),
                src: scene.backgroundAudio,
                ambient: true,
                volume: 0.5
            });
        });
    };
    (0, $8FY87.useEffect)(()=>{
        loadAudio();
        // Play scene selector background audio for all scenes
        audio.playOnly(BACKGROUND_AUDIO_ID);
        setCurrentScene(scenes[0]);
        setTimeout(()=>{
            setCurrentScene(scenes[initialSceneNumber] ?? scenes[0]);
        }, 100);
        // Returning this function to stop all audio when the component is unmounted
        return ()=>{
            // TODO: this should fade out slowly
            audio.stopAll();
        };
    }, []);
    (0, $8FY87.useEffect)(()=>{
        // Stop all background music from other scenes
        scenes.forEach((scene, index)=>{
            if (audio.hasTrack(getSceneAudioID(index))) audio.stop(getSceneAudioID(index));
        });
        // Play scene background music from CMS
        audio.play(getSceneAudioID(currentIndex));
    }, [
        currentSceneId
    ]);
    const renderScenes = ()=>{
        if (scenes && scenes.length) {
            const getIsOnScreen = (index)=>{
                if (currentIndex === 0) return index < 2;
                return index > currentIndex - 2 && index < currentIndex + 2;
            };
            return scenes.map((scene, index)=>/*#__PURE__*/ (0, $2PPWI.jsx)("li", {
                    className: $5a5fa516964a52bc$exports.SceneSelector__sceneContainer,
                    children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $8b34429b21da2d90$export$2e2bcd8739ae039), {
                        description: scene.openLowerText,
                        lockedText: scene.closedLowerText,
                        tabbable: getIsOnScreen(index),
                        onClick: ()=>onClick(scene.environmentID),
                        isInCenter: index === currentIndex,
                        isOpen: scene.isOpen,
                        imageUrl: (0, $aTKgi.pathToURL)(scene.openThumbnailImagePath),
                        lockedImageUrl: (0, $aTKgi.pathToURL)(scene.closedThumbnailImagePath),
                        imageMaskUrl: (0, $aTKgi.pathToURL)(sceneSelectorSettings.thumbnailImageMaskPath)
                    })
                }, index));
        } else return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    };
    const renderTextboxes = ()=>{
        const backgroundImage = (0, $aTKgi.pathToURL)(sceneSelectorSettings.upperTextBackgroundImagePath);
        if (scenes && scenes.length) return scenes.map((scene, index)=>{
            const text = scene.isOpen ? scene.openUpperText : scene.closedUpperText;
            return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a5fa516964a52bc$exports.StoryText__Item),
                style: {
                    width: `${100 / scenes.length}%`
                },
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                    style: {
                        borderImageSource: `url(${backgroundImage})`,
                        backgroundImage: `url(${backgroundImage})`,
                        visibility: text ? "visible" : "hidden"
                    },
                    children: text
                })
            }, index);
        });
        else return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
    };
    function getParallaxValue(layerId) {
        // Distance layer is from camera
        const distances = {
            bg: -10,
            mg: 0,
            fg: 5
        };
        // First and last scenes have distances of 0
        const isLastScene = currentIndex === scenes.length - 1;
        const distance = isLastScene ? 0 : distances[layerId];
        const percent = currentIndex * (100 + distance);
        // Scroll to left of scene, or center, depending on prop
        const leftAlignValue = `-${percent}%`;
        const centerAlignValue = `calc(-${percent}% - 50% + 50vw)`;
        return leftAlignScenes ? leftAlignValue : centerAlignValue;
    }
    const renderParallax = ()=>{
        const getImageUrl = (path)=>{
            const url = (0, $aTKgi.pathToURL)(path);
            return window.innerWidth <= 1400 ? url + "?h=540" : url + "?h=1080";
        };
        return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $5a5fa516964a52bc$exports.SceneSelector__parallaxContainer,
            children: [
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $5a5fa516964a52bc$exports.SceneSelector__parallax,
                    ref: parallaxImagesWrapperRef,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a5fa516964a52bc$exports.parallaxLayer, $5a5fa516964a52bc$exports["parallaxLayer-bg"]),
                            src: getImageUrl(sceneSelectorSettings.backgroundImagePath),
                            style: {
                                left: getParallaxValue("bg")
                            },
                            "aria-hidden": "true"
                        }, 0),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a5fa516964a52bc$exports.parallaxLayer, $5a5fa516964a52bc$exports["parallaxLayer-mg"]),
                            src: getImageUrl(sceneSelectorSettings.midgroundImagePath),
                            style: {
                                left: getParallaxValue("mg")
                            },
                            "aria-hidden": "true"
                        }, 1),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a5fa516964a52bc$exports.parallaxLayer, $5a5fa516964a52bc$exports["parallaxLayer-fg"]),
                            src: getImageUrl(sceneSelectorSettings.foregroundImagePath),
                            style: {
                                left: getParallaxValue("fg")
                            },
                            "aria-hidden": "true"
                        }, 2),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: $5a5fa516964a52bc$exports.parallaxLayerFrontCover
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                    className: $5a5fa516964a52bc$exports.StoryText,
                    style: {
                        left: `-${currentIndex * 100}%`,
                        width: `${scenes.length * 100}%`
                    },
                    children: renderTextboxes()
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($5a5fa516964a52bc$exports.SceneSelector, $5a5fa516964a52bc$exports[`scene-${currentIndex}`], $5a5fa516964a52bc$exports[transitionState]),
        ref: containerRef,
        children: [
            renderParallax(),
            /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                className: $5a5fa516964a52bc$exports.SceneSelector__scenes,
                children: /*#__PURE__*/ (0, $2PPWI.jsx)("ul", {
                    children: renderScenes()
                })
            })
        ]
    });
}








var $6lYLL = parcelRequire("6lYLL");

var $baXkz = parcelRequire("baXkz");

var $6lYLL = parcelRequire("6lYLL");
function $72f886a2d836531a$export$8535247f55db5d21() {
    const { locations: locations, isFetchingLocations: isFetchingLocations, areas: areas, isFetchingAreas: isFetchingAreas, regions: regions, isFetchingRegions: isFetchingRegions } = (0, $6lYLL.useAppSelector)((state)=>state.app);
    const isLoading = isFetchingLocations || isFetchingAreas || isFetchingRegions;
    return {
        locations: locations,
        areas: areas,
        regions: regions,
        isLoading: isLoading
    };
}



var $cEIti = parcelRequire("cEIti");


function $285f042c51009450$export$2e2bcd8739ae039() {
    const { isLoading: areLocationsLoading, locations: locations } = (0, $72f886a2d836531a$export$8535247f55db5d21)();
    const theme = (0, $cEIti.useTheme)();
    const { audio: audio } = (0, $091540b7cd96f6c1$export$91047320af7bf70b)();
    const sceneSelectorData = (0, $6lYLL.useAppSelector)((state)=>state.app.sceneSelectorData);
    const currentUserProfile = (0, $6lYLL.useAppSelector)((state)=>state.profile.currentUserProfile);
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const [selectorTransitionState, setSelectorTransitionState] = (0, $8FY87.useState)((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).preVisible);
    const [areParallaxImagesLoaded, setAreParallaxImagesLoaded] = (0, $8FY87.useState)(false);
    const shouldShowLoadingScreen = !theme.themeId || !sceneSelectorData || !locations;
    (0, $8FY87.useEffect)(()=>{
        dispatch((0, $baXkz.loadSceneSelectorData)());
        if (areLocationsLoading) return;
        dispatch((0, $baXkz.loadLocations)());
        // We set has failed to false here to reset the state if the user navigates back to this page.
        // Since the death state is only shown for 5 to 10 seconds it's not an issue if someone tries to circumvent it.
        dispatch((0, $baXkz.setHasFailed)(false));
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (!areLocationsLoading && areParallaxImagesLoaded && !shouldShowLoadingScreen) setSelectorTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).visible);
    }, [
        areLocationsLoading,
        areParallaxImagesLoaded,
        shouldShowLoadingScreen
    ]);
    const scenesData = (0, $8FY87.useMemo)(()=>{
        if (!locations) return [];
        return sceneSelectorData?.scenes.map((scene)=>{
            const matchingLocation = locations[scene.environmentID];
            return {
                ...scene,
                isOpen: matchingLocation?.isOpen
            };
        });
    }, [
        locations,
        sceneSelectorData
    ]);
    const navigateToScene = (locationId)=>{
        // Allow superadmins to access location when closed
        if (locations[locationId]?.isOpen || currentUserProfile?.role === "superadmin") {
            setSelectorTransitionState((0, $0d18f4b3a1d9aea0$export$f36897288fd2d497).postVisible);
            audio.play("slam");
            setTimeout(()=>{
                navigate("/location/" + locationId);
            }, (0, $0d18f4b3a1d9aea0$export$b88b8034d859c8af));
        }
    };
    if (shouldShowLoadingScreen) return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $e3c473a9e2ed9ab7$export$2e2bcd8739ae039), {
        show: true
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $4eb1e267ba3c534d$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $5257621ad393fe9f$export$2e2bcd8739ae039), {
                transitionState: selectorTransitionState,
                scenes: scenesData,
                sceneSelectorSettings: sceneSelectorData,
                onSceneSelected: (locationId)=>navigateToScene(locationId),
                onParallaxLoaded: ()=>setAreParallaxImagesLoaded(true),
                leftAlignScenes: theme.customJSON?.shouldLeftAlignSceneSelector
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1b92270b3f8c4d42$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $60ba48ffbe0ae6e8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $594d75f980968ad1$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $a111644098382f12$export$2e2bcd8739ae039), {})
        ]
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $f9aoP = parcelRequire("f9aoP");

var $jJtwY = parcelRequire("jJtwY");

var $6lYLL = parcelRequire("6lYLL");

var $8FY87 = parcelRequire("8FY87");
function $3314a408cbad15a9$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const auth = (0, $6lYLL.useAppSelector)((state)=>state.auth);
    // todo - way of setting display name
    (0, $8FY87.useEffect)(()=>{
        (async ()=>{
            const query = window.location.search;
            const token = new URLSearchParams(query).get("token");
            if (!token) {
                console.error("No token found");
                window.location.href = "/";
                return;
            }
            try {
                await (0, $f9aoP.oAuthExchange)(token);
                dispatch((0, $jJtwY.postLogin)());
            } catch (err) {
                console.error(err);
                window.location.href = "/";
            }
        })();
    }, []);
    (0, $8FY87.useEffect)(()=>{
        if (auth.loggedIn) window.location.href = "/";
    }, [
        auth.loggedIn
    ]);
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {});
}



var $2PPWI = parcelRequire("2PPWI");

var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");

var $1URoE = parcelRequire("1URoE");

var $f9aoP = parcelRequire("f9aoP");





function $7ef659b75f2c828c$export$2e2bcd8739ae039() {
    const [errorCode, setErrorCode] = (0, $8FY87.useState)();
    const [token, setToken] = (0, $8FY87.useState)("");
    const [email, setEmail] = (0, $8FY87.useState)("");
    const [password, setPassword] = (0, $8FY87.useState)("");
    const [passwordConfirmation, setPasswordConfirmation] = (0, $8FY87.useState)("");
    const [uiStatus, setUiStatus] = (0, $8FY87.useState)("enterDetails");
    async function onSubmit() {
        if (!(0, $5e60b378ec730cd4$export$371e338370561054)(email)) {
            setErrorCode("EMAIL_INVALID");
            return;
        }
        if (password !== passwordConfirmation) {
            setErrorCode("PASSWORD_MISMATCH");
            return;
        }
        if (!(0, $5e60b378ec730cd4$export$1cf356d314abea16)(password)) {
            setErrorCode("PASSWORD_TOO_SHORT");
            return;
        }
        try {
            await (0, $f9aoP.passwordChange)(email, token, passwordConfirmation);
            setUiStatus("passwordChanged");
        } catch (error) {
            setErrorCode(error.message ?? "UNKNOWN_ERROR");
            console.error("Could not reset password", error);
        }
    }
    (0, $8FY87.useEffect)(()=>{
        const query = window.location.search;
        const urlToken = new URLSearchParams(query).get("token");
        if (!urlToken) {
            console.warn("No password reset url token found");
            window.location.href = "/";
        }
        setToken(urlToken);
    }, []);
    const EnterDetails = /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Reset your password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "Please enter your new password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-password-reset-email",
                children: "Email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-email",
                value: email,
                onChange: (e)=>setEmail(e.target.value),
                placeholder: "Email Address",
                autoComplete: "email"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-password-reset-password",
                children: "New Password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-password",
                value: password,
                onChange: (e)=>setPassword(e.target.value),
                placeholder: "Password",
                type: "password",
                autoComplete: "new-password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("label", {
                htmlFor: "arise-password-reset-password-confirmation",
                children: "Confirm Password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d354a0cea93b322d$export$2e2bcd8739ae039), {
                className: $f84adfbb9c6e021a$export$b7e3ae3d7c15e42e,
                id: "arise-password-reset-password-confirmation",
                value: passwordConfirmation,
                onChange: (e)=>setPasswordConfirmation(e.target.value),
                placeholder: "Password",
                type: "password",
                autoComplete: "new-password"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                disabled: !(token && email && password && passwordConfirmation),
                text: "Change Password",
                onClick: onSubmit
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$493b5823483d2c4e,
                children: $7ef659b75f2c828c$var$getPasswordResetErrorMessage(errorCode)
            })
        ]
    });
    const PasswordChanged = /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                children: "Password Changed"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                children: "Your password has been changed successfully!"
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)("br", {}),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                text: "Back to Home",
                onClick: ()=>window.location.href = "/"
            })
        ]
    });
    return /*#__PURE__*/ (0, $2PPWI.jsxs)((0, $c025c3ad15b82d88$export$2e2bcd8739ae039), {
        canScroll: true,
        isVisible: true,
        onClose: ()=>{
            window.location.href = "/";
        },
        modalClassname: $f84adfbb9c6e021a$export$4adafe2b4f22b75f,
        closeButtonClassname: $f84adfbb9c6e021a$export$efe229eab43a9869,
        closeButtonStyle: "icon",
        shouldCloseOnExternalClick: false,
        zIndex: 1000,
        leaveSpaceAboveAndBelow: false,
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                className: $f84adfbb9c6e021a$export$db3c28d99448dcff,
                alt: "Those Beyond Logo",
                src: "/assets/global/those-beyond-icon.svg"
            }),
            uiStatus === "enterDetails" ? EnterDetails : PasswordChanged
        ]
    });
}
function $7ef659b75f2c828c$var$getPasswordResetErrorMessage(errorCode) {
    if (!errorCode) return "";
    switch(errorCode){
        case "EMAIL_INVALID":
            return 0, $5e60b378ec730cd4$export$aa8c7e6540925da0;
        case "INVALID_RESET_TOKEN":
            return "Could not reset password, the link may be expired. Please try again.";
        case "PASSWORD_MISMATCH":
            return "The passwords do not match.";
        case "PASSWORD_TOO_SHORT":
            return 0, $5e60b378ec730cd4$export$22f782bed1cafd3f;
        default:
            return `Could not reset password. Check your details are correct, or contact ${0, $1URoE.SUPPORT_EMAIL}`;
    }
}


function $ed116069ec05b84c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $7ef659b75f2c828c$export$2e2bcd8739ae039), {});
}



var $2PPWI = parcelRequire("2PPWI");

var $8FY87 = parcelRequire("8FY87");


var $9s93Y = parcelRequire("9s93Y");

var $cEIti = parcelRequire("cEIti");

var $1URoE = parcelRequire("1URoE");

var $6lYLL = parcelRequire("6lYLL");

var $2PPWI = parcelRequire("2PPWI");



var $jJtwY = parcelRequire("jJtwY");

var $i7H0N = parcelRequire("i7H0N");

var $6lYLL = parcelRequire("6lYLL");


function $ac30c8b914972a15$export$2e2bcd8739ae039() {
    const dispatch = (0, $6lYLL.useAppDispatch)();
    const navigateToSignup = (0, $dbacf51e5486f7e0$export$c9c1802ef9b13040)();
    const navigateToLogin = (0, $dbacf51e5486f7e0$export$932dac77da3ee9c3)();
    return /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                className: $f84adfbb9c6e021a$export$60877daf335d779,
                style: {
                    marginBottom: 20
                },
                children: "A place where fans can connect, explore, and participate together in the worlds they love."
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                text: "Sign up",
                onClick: ()=>{
                    (0, $i7H0N.sendEvent)("landing_page_sign_up_click");
                    navigateToSignup();
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eb3e3f19617c14ef$export$c43bfb5198aa7b21), {
                isHighlighted: false,
                text: "Continue as Guest",
                onClick: ()=>{
                    dispatch((0, $jJtwY.loginAsGuest)());
                    (0, $i7H0N.sendEvent)("landing_page_continue_as_guest_click");
                },
                style: {
                    marginTop: 16
                }
            }),
            /*#__PURE__*/ (0, $2PPWI.jsxs)("span", {
                className: $f84adfbb9c6e021a$export$5cfd5c18b591b2db,
                children: [
                    "Have an account?",
                    " ",
                    /*#__PURE__*/ (0, $2PPWI.jsx)((0, $eeb4f69889bc3099$export$d5992c1fec905475), {
                        isHighlighted: true,
                        onClick: ()=>{
                            (0, $i7H0N.sendEvent)("landing_page_log_in_click");
                            navigateToLogin();
                        },
                        children: "Log in"
                    })
                ]
            })
        ]
    });
}


var $7f30f9757447fa90$export$355f3d6a1f8b250c;
var $7f30f9757447fa90$export$34e0f9847d4c02dd;
var $7f30f9757447fa90$export$a7db06668cad9adb;
var $7f30f9757447fa90$export$50e46ea94d9c038c;
var $7f30f9757447fa90$export$17fa98cb055e8fa7;
var $7f30f9757447fa90$export$a5833c2b43ca4340;
var $7f30f9757447fa90$export$47511f9a6581d1d6;
var $7f30f9757447fa90$export$dd1c05b92185401c;
var $7f30f9757447fa90$export$8b28cf6cd00fe080;
var $7f30f9757447fa90$export$186c650311ff0789;
var $7f30f9757447fa90$export$6746fe0d9c9fab54;
var $7f30f9757447fa90$export$2bcf359f0c20e94f;
var $7f30f9757447fa90$export$2903d10d531d0ac0;
var $7f30f9757447fa90$export$231ba5fc42c01d86;
var $7f30f9757447fa90$export$fcf916772c508c4a;
var $7f30f9757447fa90$export$db3c28d99448dcff;
$7f30f9757447fa90$export$355f3d6a1f8b250c = `EgaQbW_LandingPage`;
$7f30f9757447fa90$export$34e0f9847d4c02dd = `EgaQbW_container`;
$7f30f9757447fa90$export$a7db06668cad9adb = `EgaQbW_content`;
$7f30f9757447fa90$export$50e46ea94d9c038c = `EgaQbW_dividerLine`;
$7f30f9757447fa90$export$17fa98cb055e8fa7 = `EgaQbW_fontSizeH1`;
$7f30f9757447fa90$export$a5833c2b43ca4340 = `EgaQbW_fontSizeH2`;
$7f30f9757447fa90$export$47511f9a6581d1d6 = `EgaQbW_fontSizeH3`;
$7f30f9757447fa90$export$dd1c05b92185401c = `EgaQbW_fontSizeH4`;
$7f30f9757447fa90$export$8b28cf6cd00fe080 = `EgaQbW_fontSizeH5`;
$7f30f9757447fa90$export$186c650311ff0789 = `EgaQbW_fontSizeH6`;
$7f30f9757447fa90$export$6746fe0d9c9fab54 = `EgaQbW_fontSizeSmall`;
$7f30f9757447fa90$export$2bcf359f0c20e94f = `EgaQbW_fontSizeTiny`;
$7f30f9757447fa90$export$2903d10d531d0ac0 = `EgaQbW_fontSizep`;
$7f30f9757447fa90$export$231ba5fc42c01d86 = `EgaQbW_formContainer`;
$7f30f9757447fa90$export$fcf916772c508c4a = `EgaQbW_landingText`;
$7f30f9757447fa90$export$db3c28d99448dcff = `EgaQbW_logo`;


function $88d5d9dcc7bdcff9$export$2e2bcd8739ae039() {
    const loggedIn = (0, $6lYLL.useAppSelector)((state)=>state.auth.loggedIn);
    const theme = (0, $cEIti.useTheme)();
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    (0, $8FY87.useEffect)(()=>{
        if (loggedIn) navigate((0, $1URoE.homePath));
    }, [
        loggedIn
    ]);
    const data = theme.customJSON?.login;
    return /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
        className: $7f30f9757447fa90$export$355f3d6a1f8b250c,
        style: {
            backgroundImage: `url("${data?.backgroundImageUrl}")`
        },
        children: /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
            className: $7f30f9757447fa90$export$34e0f9847d4c02dd,
            children: [
                data?.logoImageUrl && /*#__PURE__*/ (0, $2PPWI.jsx)("img", {
                    className: $7f30f9757447fa90$export$db3c28d99448dcff,
                    src: data?.logoImageUrl,
                    alt: "Logo"
                }),
                /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                    className: $7f30f9757447fa90$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $2PPWI.jsxs)("div", {
                            className: $7f30f9757447fa90$export$fcf916772c508c4a,
                            children: [
                                data?.title && /*#__PURE__*/ (0, $2PPWI.jsx)("h2", {
                                    children: data?.title
                                }),
                                data?.subtitle && /*#__PURE__*/ (0, $2PPWI.jsx)("p", {
                                    children: data?.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2PPWI.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9s93Y)))($7f30f9757447fa90$export$231ba5fc42c01d86, {
                                [$7f30f9757447fa90$export$50e46ea94d9c038c]: data?.title || data?.subtitle
                            }),
                            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ac30c8b914972a15$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
}



var $2PPWI = parcelRequire("2PPWI");

var $f9aoP = parcelRequire("f9aoP");

var $jJtwY = parcelRequire("jJtwY");

var $6lYLL = parcelRequire("6lYLL");

var $1URoE = parcelRequire("1URoE");


var $i7H0N = parcelRequire("i7H0N");

var $8FY87 = parcelRequire("8FY87");

function $3267d0cfcd7de1a7$export$2e2bcd8739ae039() {
    const navigate = (0, $d5fb2d3e42b0c581$export$9770f232ac06a008)();
    const dispatch = (0, $6lYLL.useAppDispatch)();
    (0, $8FY87.useEffect)(()=>{
        (async ()=>{
            // get query params
            const urlParams = new URLSearchParams(window.location.search);
            const insidersJWT = urlParams.get("jwt");
            if (!insidersJWT) {
                console.error("No jwt found in query params");
                navigate("/");
                (0, $i7H0N.sendEvent)("login_return_from_insiders_error", {
                    message: "No jwt found in query params"
                });
                return;
            }
            // remove jwt token from query params in url
            window.history.replaceState({}, document.title, window.location.pathname);
            $31fa90eb063711bb$export$57e714f81a2c3d86(insidersJWT);
            try {
                // TODO: verify we can get user info from insiders once CORS is fixed
                // const insidersMe = await insiders.me();
                (0, $i7H0N.sendEvent)("login_return_from_insiders_success");
                const res = await (0, $f9aoP.tokenExchange)(insidersJWT, "insiders");
                await dispatch((0, $jJtwY.postLogin)());
                if (res.me.profile) navigate((0, $1URoE.homePath));
                else navigate("/edit-profile");
            } catch (error) {
                // TODO: handle error better, message to user?
                console.error(error);
                (0, $i7H0N.sendEvent)("login_return_from_insiders_error", {
                    message: "Token exchange or other error"
                });
                setTimeout(()=>{
                    // redirect to home page after 2 seconds (gives us a chance to see error in console)
                    navigate("/");
                }, 2000);
            }
        })();
    }, []);
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2PPWI.Fragment), {});
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $397e837685cf6c77$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $39f3dc9338074fd7$export$31499a9cd224b78c = "8.55.0";


/** Get's the global object for the current JavaScript runtime */ const $a43cb91080741442$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a43cb91080741442$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $a43cb91080741442$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const versionedCarrier = __SENTRY__[0, $39f3dc9338074fd7$export$31499a9cd224b78c] = __SENTRY__[0, $39f3dc9338074fd7$export$31499a9cd224b78c] || {};
    return versionedCarrier[name] || (versionedCarrier[name] = creator());
}


/** Prefix for logging strings */ const $3eec9ca128c747ee$var$PREFIX = "Sentry Logger ";
const $3eec9ca128c747ee$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $3eec9ca128c747ee$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $3eec9ca128c747ee$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $a43cb91080741442$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $a43cb91080741442$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($3eec9ca128c747ee$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $3eec9ca128c747ee$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $3eec9ca128c747ee$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $397e837685cf6c77$export$16a28057038b10ef) $3eec9ca128c747ee$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $3eec9ca128c747ee$export$cda52e2a8927a2ca(()=>{
                (0, $a43cb91080741442$export$f1a6cdb1459e81d1).console[name](`${$3eec9ca128c747ee$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $3eec9ca128c747ee$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $3eec9ca128c747ee$export$af88d00dbe7f521 = (0, $a43cb91080741442$export$7e223ec222791509)("logger", $3eec9ca128c747ee$var$makeLogger);



/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $c2bb9fe9679abcfe$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $c2bb9fe9679abcfe$export$c8bfa33e4e8ae492((0, $a43cb91080741442$export$f1a6cdb1459e81d1));
    return 0, $a43cb91080741442$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $c2bb9fe9679abcfe$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $39f3dc9338074fd7$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $39f3dc9338074fd7$export$31499a9cd224b78c] = __SENTRY__[0, $39f3dc9338074fd7$export$31499a9cd224b78c] || {};
}




// eslint-disable-next-line @typescript-eslint/unbound-method
const $993607ba485f5a1a$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$e6127cc7fe7395c3(wat) {
    switch($993607ba485f5a1a$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $993607ba485f5a1a$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$var$isBuiltin(wat, className) {
    return $993607ba485f5a1a$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$9f9636d330b71954(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$ef9e2056653f0c8e(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$12e869b2a583f783(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$844ec244b1367d54(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$c3825b437cbdea5c(wat) {
    return wat === null || $993607ba485f5a1a$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$53b83ca8eaab0383(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $993607ba485f5a1a$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $993607ba485f5a1a$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$49841c62b9eff15(wat) {
    return $993607ba485f5a1a$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $993607ba485f5a1a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$bc2894c7158efbac(wat) {
    return $993607ba485f5a1a$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $993607ba485f5a1a$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



const $27a0a82f2f1ccbbe$var$WINDOW = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
const $27a0a82f2f1ccbbe$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $27a0a82f2f1ccbbe$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $27a0a82f2f1ccbbe$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $27a0a82f2f1ccbbe$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $27a0a82f2f1ccbbe$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($27a0a82f2f1ccbbe$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $993607ba485f5a1a$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $27a0a82f2f1ccbbe$export$1cfafeee2987818b() {
    try {
        return $27a0a82f2f1ccbbe$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existence of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 *
 * @deprecated This method is deprecated and will be removed in the next major version.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $27a0a82f2f1ccbbe$export$c660c1f3ab49225c(selector) {
    if ($27a0a82f2f1ccbbe$var$WINDOW.document && $27a0a82f2f1ccbbe$var$WINDOW.document.querySelector) return $27a0a82f2f1ccbbe$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $27a0a82f2f1ccbbe$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$27a0a82f2f1ccbbe$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f78c16ff2e9b8c1f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f78c16ff2e9b8c1f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $f78c16ff2e9b8c1f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $993607ba485f5a1a$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f78c16ff2e9b8c1f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $993607ba485f5a1a$export$844ec244b1367d54)(value)) return false;
    if ((0, $993607ba485f5a1a$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $993607ba485f5a1a$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f78c16ff2e9b8c1f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f78c16ff2e9b8c1f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $74cf667769cee067$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $74cf667769cee067$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $74cf667769cee067$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $74cf667769cee067$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $74cf667769cee067$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $74cf667769cee067$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 *
 * @deprecated This function is deprecated and will be removed in the next major version of the SDK.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $74cf667769cee067$export$9ef804feabbcbaf1(object) {
    return Object.entries(object).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $74cf667769cee067$export$62ff257738bf57f5(value) {
    if ((0, $993607ba485f5a1a$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$74cf667769cee067$var$getOwnProperties(value)
    };
    else if ((0, $993607ba485f5a1a$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $74cf667769cee067$var$serializeEventTarget(value.target),
            currentTarget: $74cf667769cee067$var$serializeEventTarget(value.currentTarget),
            ...$74cf667769cee067$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $993607ba485f5a1a$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $74cf667769cee067$var$serializeEventTarget(target) {
    try {
        return (0, $993607ba485f5a1a$export$45a5e7f76e0caa8d)(target) ? (0, $27a0a82f2f1ccbbe$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $74cf667769cee067$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $74cf667769cee067$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($74cf667769cee067$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $74cf667769cee067$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $74cf667769cee067$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $74cf667769cee067$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($74cf667769cee067$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.getOwnPropertyNames(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $74cf667769cee067$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($74cf667769cee067$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $74cf667769cee067$var$isPojo(input) {
    if (!(0, $993607ba485f5a1a$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e2) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $74cf667769cee067$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $993607ba485f5a1a$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



const $ecefd11e704deb48$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $ecefd11e704deb48$export$7740643b9eeaf0c4() {
    return Date.now() / $ecefd11e704deb48$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $ecefd11e704deb48$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $ecefd11e704deb48$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $ecefd11e704deb48$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $ecefd11e704deb48$export$ee52dced521e3e18 = $ecefd11e704deb48$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 *
 * @deprecated This variable will be removed in the next major version.
 */ let $ecefd11e704deb48$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $ecefd11e704deb48$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        // eslint-disable-next-line deprecation/deprecation
        $ecefd11e704deb48$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            // eslint-disable-next-line deprecation/deprecation
            $ecefd11e704deb48$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            // eslint-disable-next-line deprecation/deprecation
            $ecefd11e704deb48$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    // eslint-disable-next-line deprecation/deprecation
    $ecefd11e704deb48$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $41f2c72e646fedbd$export$19f53698e68b2496() {
    const gbl = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $41f2c72e646fedbd$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $41f2c72e646fedbd$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $41f2c72e646fedbd$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $41f2c72e646fedbd$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $41f2c72e646fedbd$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $41f2c72e646fedbd$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $41f2c72e646fedbd$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $41f2c72e646fedbd$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $41f2c72e646fedbd$export$d364f2020ab30578(input) {
    const match = input.match($41f2c72e646fedbd$var$SEMVER_REGEXP) || [];
    const major = $41f2c72e646fedbd$var$_parseInt(match[1]);
    const minor = $41f2c72e646fedbd$var$_parseInt(match[2]);
    const patch = $41f2c72e646fedbd$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $41f2c72e646fedbd$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $f78c16ff2e9b8c1f$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $f78c16ff2e9b8c1f$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $f78c16ff2e9b8c1f$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $41f2c72e646fedbd$export$6de4ffac6a2f1098(exception) {
    if ($41f2c72e646fedbd$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $74cf667769cee067$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $41f2c72e646fedbd$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 *
 * @deprecated This function has been deprecated and will not be replaced.
 */ function $41f2c72e646fedbd$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $c24103a5c77e4f3f$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $ecefd11e704deb48$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $41f2c72e646fedbd$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$c24103a5c77e4f3f$var$sessionToJSON(session)
    };
    if (context) $c24103a5c77e4f3f$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $c24103a5c77e4f3f$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $ecefd11e704deb48$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $c24103a5c77e4f3f$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $c24103a5c77e4f3f$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $c24103a5c77e4f3f$var$sessionToJSON(session) {
    return (0, $74cf667769cee067$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}






/**
 * Returns a new minimal propagation context.
 *
 * @deprecated Use `generateTraceId` and `generateSpanId` instead.
 */ function $470923e5fd0ace17$export$37f0f2f9cf343e5e() {
    return {
        traceId: $470923e5fd0ace17$export$dc6d7ea554bcce10(),
        spanId: $470923e5fd0ace17$export$295213bc4d0c54ad()
    };
}
/**
 * Generate a random, valid trace ID.
 */ function $470923e5fd0ace17$export$dc6d7ea554bcce10() {
    return (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $470923e5fd0ace17$export$295213bc4d0c54ad() {
    return (0, $41f2c72e646fedbd$export$19f53698e68b2496)().substring(16);
}



/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $eaa9bb263aec0b3f$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && mergeObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $eaa9bb263aec0b3f$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $f41fbb253966bc9f$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f41fbb253966bc9f$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $74cf667769cee067$export$e73679ffaf56810e)(scope, $f41fbb253966bc9f$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$f41fbb253966bc9f$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $f41fbb253966bc9f$export$91f063ebb8eff307(scope) {
    return scope[$f41fbb253966bc9f$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $d07459e697bcdade$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $d07459e697bcdade$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ // eslint-disable-next-line deprecation/deprecation
    /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $470923e5fd0ace17$export$dc6d7ea554bcce10)(),
            spanId: (0, $470923e5fd0ace17$export$295213bc4d0c54ad)()
        };
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $d07459e697bcdade$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $f41fbb253966bc9f$export$3f25fa50c18e20ca)(newScope, (0, $f41fbb253966bc9f$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $c24103a5c77e4f3f$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $d07459e697bcdade$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $993607ba485f5a1a$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $f41fbb253966bc9f$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $470923e5fd0ace17$export$dc6d7ea554bcce10)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $d07459e697bcdade$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $ecefd11e704deb48$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            if (this._client) this._client.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $f41fbb253966bc9f$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $eaa9bb263aec0b3f$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = {
            // eslint-disable-next-line deprecation/deprecation
            spanId: (0, $470923e5fd0ace17$export$295213bc4d0c54ad)(),
            ...context
        };
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Holds additional event information.
 */ const $d07459e697bcdade$export$775b6bb06e53a214 = $d07459e697bcdade$var$ScopeClass;



/** Get the default current scope. */ function $5a7d8c1cdf94e43c$export$6f1b9191db9c4d5() {
    return (0, $a43cb91080741442$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $d07459e697bcdade$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $5a7d8c1cdf94e43c$export$de9862929b76bf57() {
    return (0, $a43cb91080741442$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $d07459e697bcdade$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $7088aecc544bb40f$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $d07459e697bcdade$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $d07459e697bcdade$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $993607ba485f5a1a$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $7088aecc544bb40f$var$getAsyncContextStack() {
    const registry = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const sentry = (0, $c2bb9fe9679abcfe$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $7088aecc544bb40f$export$d36ec451f120cfba((0, $5a7d8c1cdf94e43c$export$6f1b9191db9c4d5)(), (0, $5a7d8c1cdf94e43c$export$de9862929b76bf57)());
}
function $7088aecc544bb40f$var$withScope(callback) {
    return $7088aecc544bb40f$var$getAsyncContextStack().withScope(callback);
}
function $7088aecc544bb40f$var$withSetScope(scope, callback) {
    const stack = $7088aecc544bb40f$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $7088aecc544bb40f$var$withIsolationScope(callback) {
    return $7088aecc544bb40f$var$getAsyncContextStack().withScope(()=>{
        return callback($7088aecc544bb40f$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $7088aecc544bb40f$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $7088aecc544bb40f$var$withIsolationScope,
        withScope: $7088aecc544bb40f$var$withScope,
        withSetScope: $7088aecc544bb40f$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $7088aecc544bb40f$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$7088aecc544bb40f$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$7088aecc544bb40f$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $f6033e65fe013b1d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const sentry = (0, $c2bb9fe9679abcfe$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $f6033e65fe013b1d$export$f639b0c2752203be(carrier) {
    const sentry = (0, $c2bb9fe9679abcfe$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $7088aecc544bb40f$export$329d4d4d54e42710)();
}






/**
 * Get the currently active scope.
 */ function $d9c634b0176f110a$export$c7be4b0125a10cba() {
    const carrier = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const acs = (0, $f6033e65fe013b1d$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $d9c634b0176f110a$export$68f3af03034c9e90() {
    const carrier = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const acs = (0, $f6033e65fe013b1d$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $d9c634b0176f110a$export$aa55d5ab8e05984f() {
    return (0, $a43cb91080741442$export$7e223ec222791509)("globalScope", ()=>new (0, $d07459e697bcdade$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $d9c634b0176f110a$export$ec58d9285c204497(...rest) {
    const carrier = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const acs = (0, $f6033e65fe013b1d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $d9c634b0176f110a$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const acs = (0, $f6033e65fe013b1d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $d9c634b0176f110a$export$6bb76d6eba7e258c() {
    return $d9c634b0176f110a$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $d9c634b0176f110a$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    // TODO(v9): Use generateSpanId() instead of spanId
    // eslint-disable-next-line deprecation/deprecation
    const { traceId: traceId, spanId: spanId, parentSpanId: parentSpanId } = propagationContext;
    const traceContext = (0, $74cf667769cee067$export$d25f2688db1bb433)({
        trace_id: traceId,
        span_id: spanId,
        parent_span_id: parentSpanId
    });
    return traceContext;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $873988e1817a1f64$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $e5d45905f90d44b8$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $e5d45905f90d44b8$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $e5d45905f90d44b8$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    const finalIntegrations = $e5d45905f90d44b8$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = finalIntegrations.findIndex((integration)=>integration.name === "Debug");
    if (debugIndex > -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $e5d45905f90d44b8$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $e5d45905f90d44b8$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $e5d45905f90d44b8$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $e5d45905f90d44b8$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($e5d45905f90d44b8$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $e5d45905f90d44b8$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $e5d45905f90d44b8$export$2d8f5188773bcddd(integration) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $e5d45905f90d44b8$export$2323046b9414659f(fn) {
    return fn;
}




const $93d9feb480276d57$var$STACKTRACE_FRAME_LIMIT = 50;
const $93d9feb480276d57$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $93d9feb480276d57$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $93d9feb480276d57$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $93d9feb480276d57$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $93d9feb480276d57$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($93d9feb480276d57$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $93d9feb480276d57$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $93d9feb480276d57$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $93d9feb480276d57$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $93d9feb480276d57$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $93d9feb480276d57$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($93d9feb480276d57$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($93d9feb480276d57$var$STRIP_FRAME_REGEXP.test($93d9feb480276d57$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($93d9feb480276d57$var$STRIP_FRAME_REGEXP.test($93d9feb480276d57$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $93d9feb480276d57$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $93d9feb480276d57$var$getLastStackFrame(localStack).filename,
            function: frame.function || $93d9feb480276d57$export$27c7e15d453fc0ac
        }));
}
function $93d9feb480276d57$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $93d9feb480276d57$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $93d9feb480276d57$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $93d9feb480276d57$var$defaultFunctionName;
        return fn.name || $93d9feb480276d57$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $93d9feb480276d57$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $93d9feb480276d57$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $586ee3c1605d4497$var$INTEGRATION_NAME = "Dedupe";
const $586ee3c1605d4497$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $586ee3c1605d4497$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($586ee3c1605d4497$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $586ee3c1605d4497$export$6d39aa44cd0c7567 = (0, $e5d45905f90d44b8$export$2323046b9414659f)($586ee3c1605d4497$var$_dedupeIntegration);
/** only exported for tests. */ function $586ee3c1605d4497$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($586ee3c1605d4497$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($586ee3c1605d4497$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $586ee3c1605d4497$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$586ee3c1605d4497$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$586ee3c1605d4497$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $586ee3c1605d4497$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $586ee3c1605d4497$var$_getExceptionFromEvent(previousEvent);
    const currentException = $586ee3c1605d4497$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$586ee3c1605d4497$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$586ee3c1605d4497$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $586ee3c1605d4497$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $93d9feb480276d57$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $93d9feb480276d57$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $586ee3c1605d4497$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $586ee3c1605d4497$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}




let $3097e92e64b6a17a$var$originalFunctionToString;
const $3097e92e64b6a17a$var$INTEGRATION_NAME = "FunctionToString";
const $3097e92e64b6a17a$var$SETUP_CLIENTS = new WeakMap();
const $3097e92e64b6a17a$var$_functionToStringIntegration = ()=>{
    return {
        name: $3097e92e64b6a17a$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $3097e92e64b6a17a$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $74cf667769cee067$export$e6cc1e135e2092e5)(this);
                    const context = $3097e92e64b6a17a$var$SETUP_CLIENTS.has((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $3097e92e64b6a17a$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $3097e92e64b6a17a$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $3097e92e64b6a17a$export$7918117e9202e4fb = (0, $e5d45905f90d44b8$export$2323046b9414659f)($3097e92e64b6a17a$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $2527d88b2be07e78$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $2527d88b2be07e78$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $2527d88b2be07e78$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $2527d88b2be07e78$export$b892860177f70a30(str) {
    const match = $2527d88b2be07e78$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $2527d88b2be07e78$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $2527d88b2be07e78$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $2527d88b2be07e78$var$validateDsn(dsn) {
    if (!(0, $397e837685cf6c77$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$2527d88b2be07e78$var$isValidProtocol(protocol)) {
        (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $2527d88b2be07e78$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $2527d88b2be07e78$export$b892860177f70a30(from) : $2527d88b2be07e78$var$dsnFromComponents(from);
    if (!components || !$2527d88b2be07e78$var$validateDsn(components)) return undefined;
    return components;
}


const $60e099ae9f552201$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $60e099ae9f552201$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $60e099ae9f552201$var$_getIngestEndpoint(dsn) {
    return `${$60e099ae9f552201$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $60e099ae9f552201$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $60e099ae9f552201$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $60e099ae9f552201$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$60e099ae9f552201$var$_getIngestEndpoint(dsn)}?${$60e099ae9f552201$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $60e099ae9f552201$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $2527d88b2be07e78$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$60e099ae9f552201$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $2527d88b2be07e78$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $c4ffff227fd4d51c$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    "undefined is not an object (evaluating 'a.L')",
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/
];
/** Options for the InboundFilters integration */ const $c4ffff227fd4d51c$var$INTEGRATION_NAME = "InboundFilters";
const $c4ffff227fd4d51c$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $c4ffff227fd4d51c$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $c4ffff227fd4d51c$var$_mergeOptions(options, clientOptions);
            return $c4ffff227fd4d51c$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $c4ffff227fd4d51c$export$cb3c5c2ceb9818ba = (0, $e5d45905f90d44b8$export$2323046b9414659f)($c4ffff227fd4d51c$var$_inboundFiltersIntegration);
function $c4ffff227fd4d51c$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $c4ffff227fd4d51c$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $c4ffff227fd4d51c$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $c4ffff227fd4d51c$var$_isSentryError(event)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($c4ffff227fd4d51c$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($c4ffff227fd4d51c$var$_isUselessError(event)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($c4ffff227fd4d51c$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($c4ffff227fd4d51c$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}.\nUrl: ${$c4ffff227fd4d51c$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$c4ffff227fd4d51c$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}.\nUrl: ${$c4ffff227fd4d51c$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $c4ffff227fd4d51c$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $c4ffff227fd4d51c$var$_getPossibleEventMessages(event).some((message)=>(0, $f78c16ff2e9b8c1f$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $c4ffff227fd4d51c$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $f78c16ff2e9b8c1f$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $c4ffff227fd4d51c$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $c4ffff227fd4d51c$var$_getEventFilterUrl(event);
    return !url ? false : (0, $f78c16ff2e9b8c1f$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $c4ffff227fd4d51c$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $c4ffff227fd4d51c$var$_getEventFilterUrl(event);
    return !url ? true : (0, $f78c16ff2e9b8c1f$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $c4ffff227fd4d51c$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $c4ffff227fd4d51c$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $c4ffff227fd4d51c$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $c4ffff227fd4d51c$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $c4ffff227fd4d51c$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $41f2c72e646fedbd$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $c4ffff227fd4d51c$var$_isUselessError(event) {
    if (event.type) // event is not an error
    return false;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception || !event.exception.values || event.exception.values.length === 0) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $d3a9624d92b26f35$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $873988e1817a1f64$export$16a28057038b10ef) (0, $3eec9ca128c747ee$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $d3a9624d92b26f35$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $d3a9624d92b26f35$export$ecb76f41d43c0e43(client) {
    (0, $d9c634b0176f110a$export$c7be4b0125a10cba)().setClient(client);
}

const $5e89a563faadcb66$export$849dbeeeda01ae98 = "production";
















/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $73b14e1e70e0f591$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($73b14e1e70e0f591$var$States || ($73b14e1e70e0f591$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $73b14e1e70e0f591$export$1fda8aa4d135f8aa(value) {
    return new $73b14e1e70e0f591$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $73b14e1e70e0f591$export$78e43115b553f358(reason) {
    return new $73b14e1e70e0f591$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $73b14e1e70e0f591$export$6f292d4960313241 {
    constructor(executor){
        $73b14e1e70e0f591$export$6f292d4960313241.prototype.__init.call(this);
        $73b14e1e70e0f591$export$6f292d4960313241.prototype.__init2.call(this);
        $73b14e1e70e0f591$export$6f292d4960313241.prototype.__init3.call(this);
        $73b14e1e70e0f591$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $73b14e1e70e0f591$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $73b14e1e70e0f591$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $73b14e1e70e0f591$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($73b14e1e70e0f591$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($73b14e1e70e0f591$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $73b14e1e70e0f591$var$States.PENDING) return;
            if ((0, $993607ba485f5a1a$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $73b14e1e70e0f591$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $73b14e1e70e0f591$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $73b14e1e70e0f591$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $0f0f484de413ae20$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $73b14e1e70e0f591$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $873988e1817a1f64$export$16a28057038b10ef) && processor.id && result === null && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $993607ba485f5a1a$export$f5b060c2914b97c8)(result)) result.then((final)=>$0f0f484de413ae20$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $0f0f484de413ae20$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $e8db5e146840303a$var$parsedStackResults;
let $e8db5e146840303a$var$lastKeysCount;
let $e8db5e146840303a$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $e8db5e146840303a$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $a43cb91080741442$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($e8db5e146840303a$var$cachedFilenameDebugIds && debugIdKeys.length === $e8db5e146840303a$var$lastKeysCount) return $e8db5e146840303a$var$cachedFilenameDebugIds;
    $e8db5e146840303a$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $e8db5e146840303a$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$e8db5e146840303a$var$parsedStackResults) $e8db5e146840303a$var$parsedStackResults = {};
        const result = $e8db5e146840303a$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame && stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $e8db5e146840303a$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $e8db5e146840303a$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $e8db5e146840303a$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $e8db5e146840303a$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 *
 * @deprecated This function is deprecated and will be removed in the next major version.
 */ // TODO(v9): Move this function into normalize() directly
function $3bcca2a403a098b2$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $079c29e177c61359$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $079c29e177c61359$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $079c29e177c61359$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $079c29e177c61359$export$a3295358bff77e(object, depth);
    if ($079c29e177c61359$var$jsonSize(normalized) > maxSize) return $079c29e177c61359$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $079c29e177c61359$var$visit(key, value, depth = Infinity, maxProperties = Infinity, // eslint-disable-next-line deprecation/deprecation
memo = (0, $3bcca2a403a098b2$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $079c29e177c61359$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $079c29e177c61359$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $74cf667769cee067$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $079c29e177c61359$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $079c29e177c61359$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $993607ba485f5a1a$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $993607ba485f5a1a$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $93d9feb480276d57$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $079c29e177c61359$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $079c29e177c61359$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $079c29e177c61359$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $079c29e177c61359$var$jsonSize(value) {
    return $079c29e177c61359$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $079c29e177c61359$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $3686d22df6290c4e$export$d7a7d984b0791405 = "sentry.source";
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $3686d22df6290c4e$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $3686d22df6290c4e$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $3686d22df6290c4e$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $3686d22df6290c4e$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $3686d22df6290c4e$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $3686d22df6290c4e$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $3686d22df6290c4e$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $3686d22df6290c4e$export$1efec95406bbe327 = "sentry.profile_id";
const $3686d22df6290c4e$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $3686d22df6290c4e$export$b016f89ac1066ec = "cache.hit";
const $3686d22df6290c4e$export$3110e4c3f4386399 = "cache.key";
const $3686d22df6290c4e$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $3686d22df6290c4e$export$be7a251980e7e946 = "http.request.method";
const $3686d22df6290c4e$export$25dfd73e0e32c6e1 = "url.full";





/**
 * @deprecated Use a `"baggage"` string directly
 */ const $ceb70e4addaa970c$export$9ca9946bd449ac06 = "baggage";
const $ceb70e4addaa970c$export$6e69537d67fa20f = "sentry-";
const $ceb70e4addaa970c$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $ceb70e4addaa970c$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $ceb70e4addaa970c$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $ceb70e4addaa970c$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($ceb70e4addaa970c$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($ceb70e4addaa970c$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $ceb70e4addaa970c$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$ceb70e4addaa970c$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $ceb70e4addaa970c$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $ceb70e4addaa970c$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $993607ba485f5a1a$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $ceb70e4addaa970c$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $ceb70e4addaa970c$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $ceb70e4addaa970c$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $ceb70e4addaa970c$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $ceb70e4addaa970c$export$bdd844ddb2def819) {
            (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $e4bd5aa3626d724f$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    // eslint-disable-next-line deprecation/deprecation
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ const $41ddc8bfc6930c2f$var$METRICS_SPAN_FIELD = "_sentryMetrics";
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $41ddc8bfc6930c2f$export$2e7205e45c58797d(span) {
    const storage = span[$41ddc8bfc6930c2f$var$METRICS_SPAN_FIELD];
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        const arr = output[exportKey] || (output[exportKey] = []);
        arr.push((0, $74cf667769cee067$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $41ddc8bfc6930c2f$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const existingStorage = span[$41ddc8bfc6930c2f$var$METRICS_SPAN_FIELD];
    const storage = existingStorage || (span[$41ddc8bfc6930c2f$var$METRICS_SPAN_FIELD] = new Map());
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
}



const $42d8bcd40982e39a$export$136e25984ba4a383 = 0;
const $42d8bcd40982e39a$export$58f7963109c806fc = 1;
const $42d8bcd40982e39a$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $42d8bcd40982e39a$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $42d8bcd40982e39a$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $42d8bcd40982e39a$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $42d8bcd40982e39a$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $42d8bcd40982e39a$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $42d8bcd40982e39a$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}








// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $e9a3b8e048c79036$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $e9a3b8e048c79036$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($e9a3b8e048c79036$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $e9a3b8e048c79036$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e9a3b8e048c79036$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $ceb70e4addaa970c$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData || !traceparentData.traceId) return {
        traceId: (0, $470923e5fd0ace17$export$dc6d7ea554bcce10)(),
        spanId: (0, $470923e5fd0ace17$export$295213bc4d0c54ad)()
    };
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    const virtualSpanId = (0, $470923e5fd0ace17$export$295213bc4d0c54ad)();
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        spanId: virtualSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $e9a3b8e048c79036$export$f35d907436da45cf(traceId = (0, $470923e5fd0ace17$export$dc6d7ea554bcce10)(), spanId = (0, $470923e5fd0ace17$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}



// These are aligned with OpenTelemetry trace flags
const $7a4abbfbaaa3e87a$export$208d5b368507fb8b = 0x0;
const $7a4abbfbaaa3e87a$export$eb571cd9b5d98de8 = 0x1;
// todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`
let $7a4abbfbaaa3e87a$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $7a4abbfbaaa3e87a$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $7a4abbfbaaa3e87a$export$92d8c23565496537(span);
    return (0, $74cf667769cee067$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $7a4abbfbaaa3e87a$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $7a4abbfbaaa3e87a$export$92d8c23565496537(span).parent_span_id;
    const span_id = isRemote ? (0, $470923e5fd0ace17$export$295213bc4d0c54ad)() : spanId;
    return (0, $74cf667769cee067$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $7a4abbfbaaa3e87a$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7a4abbfbaaa3e87a$export$5caecac1caaf3a71(span);
    return (0, $e9a3b8e048c79036$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $7a4abbfbaaa3e87a$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $7a4abbfbaaa3e87a$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $7a4abbfbaaa3e87a$var$ensureTimestampInSeconds(input.getTime());
    return (0, $ecefd11e704deb48$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $7a4abbfbaaa3e87a$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $7a4abbfbaaa3e87a$export$92d8c23565496537(span) {
    if ($7a4abbfbaaa3e87a$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($7a4abbfbaaa3e87a$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $74cf667769cee067$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $7a4abbfbaaa3e87a$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $7a4abbfbaaa3e87a$export$3f7581298f56c6d7(endTime) || undefined,
                status: $7a4abbfbaaa3e87a$export$e238a77ea3a8cd66(status),
                op: attributes[0, $3686d22df6290c4e$export$1a413bd9a88fdb09],
                origin: attributes[0, $3686d22df6290c4e$export$cca8dd30f57f805e],
                _metrics_summary: (0, $41ddc8bfc6930c2f$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $7a4abbfbaaa3e87a$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $7a4abbfbaaa3e87a$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $7a4abbfbaaa3e87a$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $7a4abbfbaaa3e87a$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $7a4abbfbaaa3e87a$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $42d8bcd40982e39a$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $42d8bcd40982e39a$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $7a4abbfbaaa3e87a$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $7a4abbfbaaa3e87a$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$7a4abbfbaaa3e87a$var$ROOT_SPAN_FIELD] || span;
    (0, $74cf667769cee067$export$e73679ffaf56810e)(childSpan, $7a4abbfbaaa3e87a$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD]) span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $74cf667769cee067$export$e73679ffaf56810e)(span, $7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $7a4abbfbaaa3e87a$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD]) span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $7a4abbfbaaa3e87a$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($7a4abbfbaaa3e87a$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD] ? Array.from(span[$7a4abbfbaaa3e87a$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $7a4abbfbaaa3e87a$export$c4c6a79b1260ca1b(span) {
    return span[$7a4abbfbaaa3e87a$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $7a4abbfbaaa3e87a$export$1be426a8e585c83e() {
    const carrier = (0, $c2bb9fe9679abcfe$export$19eade501500c6c1)();
    const acs = (0, $f6033e65fe013b1d$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $f41fbb253966bc9f$export$91f063ebb8eff307)((0, $d9c634b0176f110a$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $7a4abbfbaaa3e87a$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $7a4abbfbaaa3e87a$export$1be426a8e585c83e();
    if (span) (0, $41ddc8bfc6930c2f$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 *
 * todo(v9): Remove this once we've stopped dropping spans via `beforeSendSpan`.
 */ function $7a4abbfbaaa3e87a$export$d11691ff45a3e535() {
    if (!$7a4abbfbaaa3e87a$var$hasShownSpanDropWarning) {
        (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.");
        });
        $7a4abbfbaaa3e87a$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $7a4abbfbaaa3e87a$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $3686d22df6290c4e$export$d7a7d984b0791405)]: "custom",
        [(0, $3686d22df6290c4e$export$165ce9a229f6f050)]: name
    });
}


/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $510e1fd39ea0ffd1$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $510e1fd39ea0ffd1$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $74cf667769cee067$export$e73679ffaf56810e)(spanWithMaybeDsc, $510e1fd39ea0ffd1$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $510e1fd39ea0ffd1$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $74cf667769cee067$export$d25f2688db1bb433)({
        environment: options.environment || (0, $5e89a563faadcb66$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $510e1fd39ea0ffd1$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $510e1fd39ea0ffd1$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $510e1fd39ea0ffd1$export$a117f995597e25df(span) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $7a4abbfbaaa3e87a$export$c4c6a79b1260ca1b)(span);
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$510e1fd39ea0ffd1$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceState = rootSpan.spanContext().traceState;
    const traceStateDsc = traceState && traceState.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $ceb70e4addaa970c$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return dscOnTraceState;
    // Else, we generate it from the span
    const dsc = $510e1fd39ea0ffd1$export$366bad00d6815eed(span.spanContext().traceId, client);
    const jsonSpan = (0, $7a4abbfbaaa3e87a$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $3686d22df6290c4e$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $3686d22df6290c4e$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = jsonSpan.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasTracingEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $e4bd5aa3626d724f$export$5008da00b1b6dee6)()) dsc.sampled = String((0, $7a4abbfbaaa3e87a$export$5caecac1caaf3a71)(rootSpan));
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $510e1fd39ea0ffd1$export$95cf936fdacaff7b(span) {
    const dsc = $510e1fd39ea0ffd1$export$a117f995597e25df(span);
    return (0, $ceb70e4addaa970c$export$56766feef403f365)(dsc);
}





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $796bb071f6b9ec9b$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $796bb071f6b9ec9b$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $796bb071f6b9ec9b$var$applySpanToEvent(event, span);
    $796bb071f6b9ec9b$var$applyFingerprintToEvent(event, fingerprint);
    $796bb071f6b9ec9b$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $796bb071f6b9ec9b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $796bb071f6b9ec9b$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $796bb071f6b9ec9b$export$b1a120a2871faa46(data, "extra", extra);
    $796bb071f6b9ec9b$export$b1a120a2871faa46(data, "tags", tags);
    $796bb071f6b9ec9b$export$b1a120a2871faa46(data, "user", user);
    $796bb071f6b9ec9b$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $eaa9bb263aec0b3f$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $796bb071f6b9ec9b$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $eaa9bb263aec0b3f$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $796bb071f6b9ec9b$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $74cf667769cee067$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $74cf667769cee067$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $74cf667769cee067$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $74cf667769cee067$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $796bb071f6b9ec9b$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $796bb071f6b9ec9b$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $796bb071f6b9ec9b$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $7a4abbfbaaa3e87a$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $510e1fd39ea0ffd1$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $7a4abbfbaaa3e87a$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $7a4abbfbaaa3e87a$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $796bb071f6b9ec9b$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $e9d4894818b02698$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $41f2c72e646fedbd$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $ecefd11e704deb48$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $e9d4894818b02698$export$d7e04067a6fbc882(prepared, options);
    $e9d4894818b02698$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $e9d4894818b02698$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $e9d4894818b02698$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $d9c634b0176f110a$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $796bb071f6b9ec9b$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $796bb071f6b9ec9b$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $796bb071f6b9ec9b$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $0f0f484de413ae20$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $e9d4894818b02698$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $e9d4894818b02698$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $e9d4894818b02698$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $5e89a563faadcb66$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    if (event.message) event.message = (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $e9d4894818b02698$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $e8db5e146840303a$export$e069fee9c632ed00)(stackParser);
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (filenameDebugIdMap && frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $e9d4894818b02698$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $e9d4894818b02698$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $e9d4894818b02698$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $079c29e177c61359$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $079c29e177c61359$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $079c29e177c61359$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $079c29e177c61359$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $079c29e177c61359$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $079c29e177c61359$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts && event.contexts.flags && normalized.contexts) normalized.contexts.flags = (0, $079c29e177c61359$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $e9d4894818b02698$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $d07459e697bcdade$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $e9d4894818b02698$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($e9d4894818b02698$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($e9d4894818b02698$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $e9d4894818b02698$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $d07459e697bcdade$export$775b6bb06e53a214) || typeof hint === "function";
}
const $e9d4894818b02698$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $e9d4894818b02698$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$e9d4894818b02698$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $25ed9a2fc5ad35c9$export$f5282963edea4a68(exception, hint) {
    return (0, $d9c634b0176f110a$export$c7be4b0125a10cba)().captureException(exception, (0, $e9d4894818b02698$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $25ed9a2fc5ad35c9$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $d9c634b0176f110a$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $25ed9a2fc5ad35c9$export$1462b974fdcf6ba2(event, hint) {
    return (0, $d9c634b0176f110a$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $25ed9a2fc5ad35c9$export$2f04de43fe27971a(name, context) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $25ed9a2fc5ad35c9$export$bb4922da0dd51b92(extras) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $25ed9a2fc5ad35c9$export$8e8e7789d42ed61d(key, extra) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $25ed9a2fc5ad35c9$export$74a8fb34822092e6(tags) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $25ed9a2fc5ad35c9$export$a37d07ee78eb4569(key, value) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $25ed9a2fc5ad35c9$export$8b6bb3dd62a01be2(user) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $25ed9a2fc5ad35c9$export$5d4e9fd7fac8e617() {
    return (0, $d9c634b0176f110a$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $25ed9a2fc5ad35c9$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (!client) (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $25ed9a2fc5ad35c9$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $25ed9a2fc5ad35c9$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $ecefd11e704deb48$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $25ed9a2fc5ad35c9$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $d9c634b0176f110a$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $993607ba485f5a1a$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $25ed9a2fc5ad35c9$export$4909b86c8034bf73(timeout) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $25ed9a2fc5ad35c9$export$8360e631d277ea4d(timeout) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $25ed9a2fc5ad35c9$export$3f95c6f800b78024() {
    return !!(0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $25ed9a2fc5ad35c9$export$3b029eb57ac4d562() {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $25ed9a2fc5ad35c9$export$9aac0b9f77928fbf(callback) {
    (0, $d9c634b0176f110a$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $25ed9a2fc5ad35c9$export$c0d84948cecf78d8(context) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $d9c634b0176f110a$export$68f3af03034c9e90)();
    const currentScope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $5e89a563faadcb66$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $a43cb91080741442$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $c24103a5c77e4f3f$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $c24103a5c77e4f3f$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $25ed9a2fc5ad35c9$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $25ed9a2fc5ad35c9$export$17a5be43989a0bc1() {
    const isolationScope = (0, $d9c634b0176f110a$export$68f3af03034c9e90)();
    const currentScope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $c24103a5c77e4f3f$export$56521d9ba90f62ee)(session);
    $25ed9a2fc5ad35c9$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $25ed9a2fc5ad35c9$var$_sendSessionUpdate() {
    const isolationScope = (0, $d9c634b0176f110a$export$68f3af03034c9e90)();
    const currentScope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $25ed9a2fc5ad35c9$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $25ed9a2fc5ad35c9$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $25ed9a2fc5ad35c9$var$_sendSessionUpdate();
}




const $dadbb4ba0cb1970b$var$WINDOW = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $dadbb4ba0cb1970b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $dadbb4ba0cb1970b$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $dadbb4ba0cb1970b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$dadbb4ba0cb1970b$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($dadbb4ba0cb1970b$export$d5f608b368e73f38($dadbb4ba0cb1970b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $dadbb4ba0cb1970b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $dadbb4ba0cb1970b$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$531055a6c684a70a() {
    return "ReportingObserver" in $dadbb4ba0cb1970b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $dadbb4ba0cb1970b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$dadbb4ba0cb1970b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $d7f863f53386af74$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $39f3dc9338074fd7$export$31499a9cd224b78c)
            })),
        version: (0, $39f3dc9338074fd7$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}










/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b5714e6000d86929$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b5714e6000d86929$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $b5714e6000d86929$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $b5714e6000d86929$export$604a45d95a155e2b(envelope, types) {
    return $b5714e6000d86929$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $b5714e6000d86929$var$encodeUTF8(input) {
    return (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $b5714e6000d86929$var$decodeUTF8(input) {
    return (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $a43cb91080741442$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $b5714e6000d86929$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $b5714e6000d86929$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $b5714e6000d86929$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $079c29e177c61359$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $b5714e6000d86929$var$concatBuffers(parts);
}
function $b5714e6000d86929$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $b5714e6000d86929$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $b5714e6000d86929$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($b5714e6000d86929$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $b5714e6000d86929$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $b5714e6000d86929$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $b5714e6000d86929$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $74cf667769cee067$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $b5714e6000d86929$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket",
    raw_security: "security"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $b5714e6000d86929$export$b11169581eeaf237(type) {
    return $b5714e6000d86929$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $b5714e6000d86929$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $b5714e6000d86929$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $2527d88b2be07e78$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $74cf667769cee067$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $a7d63624dc03971c$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $a7d63624dc03971c$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b5714e6000d86929$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $2527d88b2be07e78$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $b5714e6000d86929$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $a7d63624dc03971c$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b5714e6000d86929$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $a7d63624dc03971c$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $b5714e6000d86929$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $b5714e6000d86929$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $a7d63624dc03971c$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $510e1fd39ea0ffd1$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $2527d88b2be07e78$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = beforeSendSpan((0, $7a4abbfbaaa3e87a$export$92d8c23565496537)(span));
        if (!spanJson) (0, $7a4abbfbaaa3e87a$export$d11691ff45a3e535)();
        return spanJson;
    } : (span)=>(0, $7a4abbfbaaa3e87a$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $b5714e6000d86929$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $b5714e6000d86929$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $785d4359b7299d1d$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $ecefd11e704deb48$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $b5714e6000d86929$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/** An error emitted by Sentry SDKs and related utilities. */ class $fca5dcb9074abcc2$export$5949942ba2a7c0e2 extends Error {
    constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.logLevel = logLevel;
    }
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $16b2a89a612f428f$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}




const $5f9f6ae1fcd5aa9d$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5f9f6ae1fcd5aa9d$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $2527d88b2be07e78$export$128827c3562ec0cb)(options.dsn);
        else (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $60e099ae9f552201$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // TODO(v9): Remove this deprecation warning
        const tracingOptions = [
            "enableTracing",
            "tracesSampleRate",
            "tracesSampler"
        ];
        const undefinedOption = tracingOptions.find((option)=>option in options && options[option] == undefined);
        if (undefinedOption) (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[Sentry] Deprecation warning: \`${undefinedOption}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
        });
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint, scope) {
        const eventId = (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $41f2c72e646fedbd$export$6de4ffac6a2f1098)(exception)) {
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log($5f9f6ae1fcd5aa9d$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $41f2c72e646fedbd$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $993607ba485f5a1a$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $993607ba485f5a1a$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $41f2c72e646fedbd$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $41f2c72e646fedbd$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log($5f9f6ae1fcd5aa9d$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $c24103a5c77e4f3f$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $e5d45905f90d44b8$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $e5d45905f90d44b8$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $a7d63624dc03971c$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $b5714e6000d86929$export$d650323442802f6f)(env, (0, $b5714e6000d86929$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $a7d63624dc03971c$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === "number" ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $e5d45905f90d44b8$export$51abed9797baa598)(this, integrations);
        (0, $e5d45905f90d44b8$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $c24103a5c77e4f3f$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $73b14e1e70e0f591$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)(), isolationScope = (0, $d9c634b0176f110a$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $e9d4894818b02698$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            evt.contexts = {
                trace: (0, $d9c634b0176f110a$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $510e1fd39ea0ffd1$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $873988e1817a1f64$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                if (reason instanceof (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2) && reason.logLevel === "log") (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(reason.message);
                else (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5f9f6ae1fcd5aa9d$var$isTransactionEvent(event);
        const isError = $5f9f6ae1fcd5aa9d$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $16b2a89a612f428f$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $73b14e1e70e0f591$export$78e43115b553f358)(new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5f9f6ae1fcd5aa9d$var$processBeforeSend(this, options, prepared, hint);
            return $5f9f6ae1fcd5aa9d$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $785d4359b7299d1d$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $2527d88b2be07e78$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5f9f6ae1fcd5aa9d$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $993607ba485f5a1a$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $993607ba485f5a1a$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $993607ba485f5a1a$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5f9f6ae1fcd5aa9d$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($5f9f6ae1fcd5aa9d$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5f9f6ae1fcd5aa9d$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
                else {
                    (0, $7a4abbfbaaa3e87a$export$d11691ff45a3e535)();
                    client.recordDroppedEvent("before_send", "span");
                }
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) {
            if (event.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = event.spans.length;
                event.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(event, hint);
        }
    }
    return event;
}
function $5f9f6ae1fcd5aa9d$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5f9f6ae1fcd5aa9d$var$isTransactionEvent(event) {
    return event.type === "transaction";
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $ec3a33ee9d5bf79e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $ec3a33ee9d5bf79e$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2b3fd96956b11e20$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * This function creates an exception from a JavaScript Error
 */ function $c9d6bc63670bccc5$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $c9d6bc63670bccc5$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $c9d6bc63670bccc5$export$2e9ae379995d99e3(ex),
        value: $c9d6bc63670bccc5$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $c9d6bc63670bccc5$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $c9d6bc63670bccc5$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $079c29e177c61359$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c9d6bc63670bccc5$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $993607ba485f5a1a$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c9d6bc63670bccc5$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c9d6bc63670bccc5$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c9d6bc63670bccc5$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c9d6bc63670bccc5$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $c9d6bc63670bccc5$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $c9d6bc63670bccc5$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c9d6bc63670bccc5$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $c9d6bc63670bccc5$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $c9d6bc63670bccc5$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c9d6bc63670bccc5$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $c9d6bc63670bccc5$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $c9d6bc63670bccc5$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $c9d6bc63670bccc5$export$2e9ae379995d99e3(ex) {
    const name = ex && ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $c9d6bc63670bccc5$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $c9d6bc63670bccc5$export$86005d1b62804363(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
    if ($c9d6bc63670bccc5$var$isWebAssemblyException(ex) && Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $c9d6bc63670bccc5$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c9d6bc63670bccc5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $c9d6bc63670bccc5$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c9d6bc63670bccc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $c9d6bc63670bccc5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $993607ba485f5a1a$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $c9d6bc63670bccc5$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $993607ba485f5a1a$export$ef9e2056653f0c8e)(exception) || (0, $993607ba485f5a1a$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $c9d6bc63670bccc5$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $993607ba485f5a1a$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c9d6bc63670bccc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $41f2c72e646fedbd$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $993607ba485f5a1a$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $c9d6bc63670bccc5$var$eventFromError(stackParser, exception);
    if ((0, $993607ba485f5a1a$export$53b83ca8eaab0383)(exception) || (0, $993607ba485f5a1a$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $c9d6bc63670bccc5$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c9d6bc63670bccc5$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $41f2c72e646fedbd$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $c9d6bc63670bccc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c9d6bc63670bccc5$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $993607ba485f5a1a$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c9d6bc63670bccc5$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $74cf667769cee067$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $993607ba485f5a1a$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $993607ba485f5a1a$export$9671ea99bd126ace)(exception)) {
        const className = $c9d6bc63670bccc5$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c9d6bc63670bccc5$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $c9d6bc63670bccc5$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $88b8429cc4ddcd3a$export$56d8a8a25bd48b81 = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
let $88b8429cc4ddcd3a$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $88b8429cc4ddcd3a$export$b79738ab10c590b2() {
    return $88b8429cc4ddcd3a$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $88b8429cc4ddcd3a$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $88b8429cc4ddcd3a$var$ignoreOnError++;
    setTimeout(()=>{
        $88b8429cc4ddcd3a$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $88b8429cc4ddcd3a$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $74cf667769cee067$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$88b8429cc4ddcd3a$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $88b8429cc4ddcd3a$export$1265a142ff5ba165();
            (0, $d9c634b0176f110a$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $41f2c72e646fedbd$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $41f2c72e646fedbd$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $25ed9a2fc5ad35c9$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e2) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $74cf667769cee067$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $74cf667769cee067$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch (e3) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $1b9c5a08625879d7$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $2527d88b2be07e78$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $1b9c5a08625879d7$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $b5714e6000d86929$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $1b9c5a08625879d7$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $412dcef8a085c15c$export$1df9218a526d318d extends (0, $5f9f6ae1fcd5aa9d$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $ec3a33ee9d5bf79e$export$8ad33f488b1ab046)();
        (0, $d7f863f53386af74$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document) (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $c9d6bc63670bccc5$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $c9d6bc63670bccc5$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $1b9c5a08625879d7$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
}







// We keep the handlers globally
const $c9107f20861bb82c$var$handlers = {};
const $c9107f20861bb82c$var$instrumented = {};
/** Add a handler function. */ function $c9107f20861bb82c$export$a4e09611e30da72e(type, handler) {
    $c9107f20861bb82c$var$handlers[type] = $c9107f20861bb82c$var$handlers[type] || [];
    $c9107f20861bb82c$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $c9107f20861bb82c$export$b17eab759a1cb5fe() {
    Object.keys($c9107f20861bb82c$var$handlers).forEach((key)=>{
        $c9107f20861bb82c$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $c9107f20861bb82c$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$c9107f20861bb82c$var$instrumented[type]) {
        $c9107f20861bb82c$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $c9107f20861bb82c$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $c9107f20861bb82c$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $397e837685cf6c77$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $93d9feb480276d57$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $5280bded108e0add$export$56d8a8a25bd48b81 = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);


const $6027411d0e9f81fd$var$DEBOUNCE_DURATION = 1000;
let $6027411d0e9f81fd$var$debounceTimerID;
let $6027411d0e9f81fd$var$lastCapturedEventType;
let $6027411d0e9f81fd$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6027411d0e9f81fd$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $6027411d0e9f81fd$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $6027411d0e9f81fd$export$3014bbf0af0e1d4a() {
    if (!(0, $5280bded108e0add$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $c9107f20861bb82c$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $6027411d0e9f81fd$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $5280bded108e0add$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $5280bded108e0add$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $5280bded108e0add$export$56d8a8a25bd48b81);
        const targetObj = globalObject[target];
        const proto = targetObj && targetObj.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $74cf667769cee067$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $6027411d0e9f81fd$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $74cf667769cee067$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $6027411d0e9f81fd$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $6027411d0e9f81fd$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $6027411d0e9f81fd$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $6027411d0e9f81fd$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $6027411d0e9f81fd$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $6027411d0e9f81fd$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($6027411d0e9f81fd$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $74cf667769cee067$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $74cf667769cee067$export$e73679ffaf56810e)(target, "_sentryId", (0, $41f2c72e646fedbd$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$6027411d0e9f81fd$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $6027411d0e9f81fd$var$lastCapturedEventType = event.type;
            $6027411d0e9f81fd$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($6027411d0e9f81fd$var$debounceTimerID);
        $6027411d0e9f81fd$var$debounceTimerID = (0, $5280bded108e0add$export$56d8a8a25bd48b81).setTimeout(()=>{
            $6027411d0e9f81fd$var$lastCapturedEventTargetId = undefined;
            $6027411d0e9f81fd$var$lastCapturedEventType = undefined;
        }, $6027411d0e9f81fd$var$DEBOUNCE_DURATION);
    };
}
function $6027411d0e9f81fd$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $de29e8b1f414cacf$var$WINDOW = (0, $a43cb91080741442$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $de29e8b1f414cacf$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    // TODO(v9): Remove this custom check, it is pretty old and likely not needed anymore
    const chromeVar = $de29e8b1f414cacf$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    const hasHistoryApi = "history" in $de29e8b1f414cacf$var$WINDOW && !!$de29e8b1f414cacf$var$WINDOW.history.pushState && !!$de29e8b1f414cacf$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



let $53d15a79be781ce1$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $53d15a79be781ce1$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $53d15a79be781ce1$var$instrumentHistory);
}
function $53d15a79be781ce1$var$instrumentHistory() {
    if (!(0, $de29e8b1f414cacf$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $5280bded108e0add$export$56d8a8a25bd48b81).onpopstate;
    (0, $5280bded108e0add$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $5280bded108e0add$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $53d15a79be781ce1$var$lastHref;
        $53d15a79be781ce1$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $c9107f20861bb82c$export$b18c893e424d3127)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $53d15a79be781ce1$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $53d15a79be781ce1$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $c9107f20861bb82c$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $5280bded108e0add$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $5280bded108e0add$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}



const $526b37ab5ac1a018$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $526b37ab5ac1a018$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $526b37ab5ac1a018$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $526b37ab5ac1a018$export$c67d533bf77cbf54() {
    if (!(0, $5280bded108e0add$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $993607ba485f5a1a$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $526b37ab5ac1a018$var$parseUrl(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$526b37ab5ac1a018$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$526b37ab5ac1a018$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $c9107f20861bb82c$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$526b37ab5ac1a018$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $993607ba485f5a1a$export$844ec244b1367d54)(header) && (0, $993607ba485f5a1a$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$526b37ab5ac1a018$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $c9107f20861bb82c$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
function $526b37ab5ac1a018$var$parseUrl(url) {
    if ((0, $993607ba485f5a1a$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $1fb09568a8271428$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $1fb09568a8271428$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $d9c634b0176f110a$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $1fb09568a8271428$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $ecefd11e704deb48$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $d2111bee8bd0d117$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $d2111bee8bd0d117$var$instrumentConsole);
}
function $d2111bee8bd0d117$var$instrumentConsole() {
    if (!("console" in (0, $a43cb91080741442$export$f1a6cdb1459e81d1))) return;
    (0, $3eec9ca128c747ee$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $a43cb91080741442$export$f1a6cdb1459e81d1).console)) return;
        (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $a43cb91080741442$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $3eec9ca128c747ee$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $c9107f20861bb82c$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $3eec9ca128c747ee$export$77c4ce905194557b)[level];
                log && log.apply((0, $a43cb91080741442$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $407b8bbdd52c0fb2$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, ()=>$407b8bbdd52c0fb2$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $407b8bbdd52c0fb2$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, ()=>$407b8bbdd52c0fb2$var$instrumentFetch($407b8bbdd52c0fb2$var$streamHandler));
}
function $407b8bbdd52c0fb2$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $dadbb4ba0cb1970b$export$c82d238e23c40b21)()) return;
    (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $a43cb91080741442$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $407b8bbdd52c0fb2$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $c9107f20861bb82c$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $a43cb91080741442$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $c9107f20861bb82c$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $c9107f20861bb82c$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $993607ba485f5a1a$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $74cf667769cee067$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $407b8bbdd52c0fb2$var$resolveResponse(res, onFinishedResolving) {
    if (res && res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $407b8bbdd52c0fb2$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $407b8bbdd52c0fb2$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $c9107f20861bb82c$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $ecefd11e704deb48$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $407b8bbdd52c0fb2$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $407b8bbdd52c0fb2$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($407b8bbdd52c0fb2$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $407b8bbdd52c0fb2$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $407b8bbdd52c0fb2$var$getUrlFromResource(url),
            method: $407b8bbdd52c0fb2$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $407b8bbdd52c0fb2$var$getUrlFromResource(arg),
        method: $407b8bbdd52c0fb2$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $165736b7f36fd7e0$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $631fbb32bcf1e106$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $631fbb32bcf1e106$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 *
 * @deprecated This function will be removed in the next major version.
 */ // TODO(v9): Hoist this function into the places where we use it. (as it stands only react router v6 instrumentation)
function $631fbb32bcf1e106$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $631fbb32bcf1e106$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

/**
 * @deprecated This variable has been deprecated and will be removed in the next major version.
 */ const $3fed5539b59fbc94$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $3fed5539b59fbc94$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $4e19028608fa5deb$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $4e19028608fa5deb$var$INTEGRATION_NAME = "Breadcrumbs";
const $4e19028608fa5deb$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $4e19028608fa5deb$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $d2111bee8bd0d117$export$1d6e0d073f9e6723)($4e19028608fa5deb$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $6027411d0e9f81fd$export$5aeffd3db2cf9df7)($4e19028608fa5deb$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $526b37ab5ac1a018$export$26ace48dd54c9aea)($4e19028608fa5deb$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $407b8bbdd52c0fb2$export$f75d3c772c923df0)($4e19028608fa5deb$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $53d15a79be781ce1$export$3f18c56c58114e75)($4e19028608fa5deb$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $4e19028608fa5deb$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $4e19028608fa5deb$export$c079d904b326663a = (0, $e5d45905f90d44b8$export$2323046b9414659f)($4e19028608fa5deb$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $4e19028608fa5deb$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        (0, $1fb09568a8271428$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $41f2c72e646fedbd$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $4e19028608fa5deb$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $4e19028608fa5deb$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$4e19028608fa5deb$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$4e19028608fa5deb$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $4e19028608fa5deb$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $4e19028608fa5deb$var$_isEvent(event) ? event.target : event;
            target = (0, $27a0a82f2f1ccbbe$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $27a0a82f2f1ccbbe$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $1fb09568a8271428$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $4e19028608fa5deb$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $3fed5539b59fbc94$export$d771ef054122c30a)(handlerData.level),
            message: (0, $f78c16ff2e9b8c1f$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $f78c16ff2e9b8c1f$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $1fb09568a8271428$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $4e19028608fa5deb$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $526b37ab5ac1a018$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const level = (0, $165736b7f36fd7e0$export$b8cfcc4175694bcc)(status_code);
        (0, $1fb09568a8271428$export$efda9a273d7a036d)({
            category: "xhr",
            data: data,
            type: "http",
            level: level
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $4e19028608fa5deb$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $1fb09568a8271428$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const level = (0, $165736b7f36fd7e0$export$b8cfcc4175694bcc)(data.status_code);
            (0, $1fb09568a8271428$export$efda9a273d7a036d)({
                category: "fetch",
                data: data,
                type: "http",
                level: level
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $4e19028608fa5deb$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $631fbb32bcf1e106$export$7a5253c0f62e0150)((0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $631fbb32bcf1e106$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $631fbb32bcf1e106$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $1fb09568a8271428$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $4e19028608fa5deb$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $68636222c003578a$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $68636222c003578a$var$INTEGRATION_NAME = "BrowserApiErrors";
const $68636222c003578a$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $68636222c003578a$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81), "setTimeout", $68636222c003578a$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81), "setInterval", $68636222c003578a$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $74cf667769cee067$export$9563e054e6f787fb)((0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81), "requestAnimationFrame", $68636222c003578a$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81)) (0, $74cf667769cee067$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $68636222c003578a$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $68636222c003578a$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($68636222c003578a$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $68636222c003578a$export$59bfe9f1c76150e = (0, $e5d45905f90d44b8$export$2323046b9414659f)($68636222c003578a$var$_browserApiErrorsIntegration);
function $68636222c003578a$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $88b8429cc4ddcd3a$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $93d9feb480276d57$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $68636222c003578a$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $88b8429cc4ddcd3a$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $93d9feb480276d57$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $68636222c003578a$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $74cf667769cee067$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $93d9feb480276d57$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $74cf667769cee067$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $93d9feb480276d57$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $88b8429cc4ddcd3a$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $68636222c003578a$var$_wrapEventTarget(target) {
    const globalObject = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81);
    const targetObj = globalObject[target];
    const proto = targetObj && targetObj.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $74cf667769cee067$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($68636222c003578a$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $88b8429cc4ddcd3a$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $93d9feb480276d57$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (e2) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $88b8429cc4ddcd3a$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $93d9feb480276d57$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $74cf667769cee067$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $68636222c003578a$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $9fcfdc6f705cf45a$export$1baa7880e357371c = (0, $e5d45905f90d44b8$export$2323046b9414659f)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $25ed9a2fc5ad35c9$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $25ed9a2fc5ad35c9$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $53d15a79be781ce1$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $25ed9a2fc5ad35c9$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $25ed9a2fc5ad35c9$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $92441e581552f150$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $92441e581552f150$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $92441e581552f150$var$instrumentError);
}
function $92441e581552f150$var$instrumentError() {
    $92441e581552f150$var$_oldOnErrorHandler = (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $c9107f20861bb82c$export$b18c893e424d3127)("error", handlerData);
        if ($92441e581552f150$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $92441e581552f150$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $830e96ab64b81938$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $830e96ab64b81938$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $c9107f20861bb82c$export$a4e09611e30da72e)(type, handler);
    (0, $c9107f20861bb82c$export$e18d6c5462c01368)(type, $830e96ab64b81938$var$instrumentUnhandledRejection);
}
function $830e96ab64b81938$var$instrumentUnhandledRejection() {
    $830e96ab64b81938$var$_oldOnUnhandledRejectionHandler = (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $c9107f20861bb82c$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($830e96ab64b81938$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $830e96ab64b81938$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $a43cb91080741442$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $0be1134de0a15137$var$INTEGRATION_NAME = "GlobalHandlers";
const $0be1134de0a15137$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $0be1134de0a15137$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $0be1134de0a15137$var$_installGlobalOnErrorHandler(client);
                $0be1134de0a15137$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $0be1134de0a15137$var$_installGlobalOnUnhandledRejectionHandler(client);
                $0be1134de0a15137$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $0be1134de0a15137$export$66acc70e8cf2b71a = (0, $e5d45905f90d44b8$export$2323046b9414659f)($0be1134de0a15137$var$_globalHandlersIntegration);
function $0be1134de0a15137$var$_installGlobalOnErrorHandler(client) {
    (0, $92441e581552f150$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $0be1134de0a15137$var$getOptions();
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client || (0, $88b8429cc4ddcd3a$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $0be1134de0a15137$var$_enhanceEventWithInitialFrame((0, $c9d6bc63670bccc5$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $25ed9a2fc5ad35c9$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $0be1134de0a15137$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $830e96ab64b81938$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $0be1134de0a15137$var$getOptions();
        if ((0, $d9c634b0176f110a$export$6bb76d6eba7e258c)() !== client || (0, $88b8429cc4ddcd3a$export$b79738ab10c590b2)()) return;
        const error = $0be1134de0a15137$var$_getUnhandledRejectionError(e);
        const event = (0, $993607ba485f5a1a$export$c3825b437cbdea5c)(error) ? $0be1134de0a15137$var$_eventFromRejectionWithPrimitive(error) : (0, $c9d6bc63670bccc5$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $25ed9a2fc5ad35c9$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $0be1134de0a15137$var$_getUnhandledRejectionError(error) {
    if ((0, $993607ba485f5a1a$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $0be1134de0a15137$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $0be1134de0a15137$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $993607ba485f5a1a$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $27a0a82f2f1ccbbe$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $93d9feb480276d57$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $0be1134de0a15137$var$globalHandlerLog(type) {
    (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $0be1134de0a15137$var$getOptions() {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $6067e12a64becc99$export$1378794447170364 = (0, $e5d45905f90d44b8$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).navigator && !(0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location && !(0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $a4c693e1ef3034c8$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $993607ba485f5a1a$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $a4c693e1ef3034c8$var$truncateAggregateExceptions($a4c693e1ef3034c8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $a4c693e1ef3034c8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $993607ba485f5a1a$export$49034edbe6b62415)(error[key], Error)) {
        $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $a4c693e1ef3034c8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $993607ba485f5a1a$export$49034edbe6b62415)(childError, Error)) {
            $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $a4c693e1ef3034c8$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $a4c693e1ef3034c8$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $a4c693e1ef3034c8$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $f78c16ff2e9b8c1f$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $fe56bae285431ea9$var$DEFAULT_KEY = "cause";
const $fe56bae285431ea9$var$DEFAULT_LIMIT = 5;
const $fe56bae285431ea9$var$INTEGRATION_NAME = "LinkedErrors";
const $fe56bae285431ea9$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $fe56bae285431ea9$var$DEFAULT_LIMIT;
    const key = options.key || $fe56bae285431ea9$var$DEFAULT_KEY;
    return {
        name: $fe56bae285431ea9$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $a4c693e1ef3034c8$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $c9d6bc63670bccc5$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $fe56bae285431ea9$export$ebabb00eb7f3a395 = (0, $e5d45905f90d44b8$export$2323046b9414659f)($fe56bae285431ea9$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $80523d93773bd442$var$OPERA10_PRIORITY = 10;
const $80523d93773bd442$var$OPERA11_PRIORITY = 20;
const $80523d93773bd442$var$CHROME_PRIORITY = 30;
const $80523d93773bd442$var$WINJS_PRIORITY = 40;
const $80523d93773bd442$var$GECKO_PRIORITY = 50;
function $80523d93773bd442$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $93d9feb480276d57$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $80523d93773bd442$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $80523d93773bd442$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $80523d93773bd442$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $80523d93773bd442$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $80523d93773bd442$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $80523d93773bd442$var$createFrame(filename, (0, $93d9feb480276d57$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $80523d93773bd442$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $80523d93773bd442$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $80523d93773bd442$var$extractSafariExtensionDetails(parts[1] || (0, $93d9feb480276d57$export$27c7e15d453fc0ac), parts[2]);
        return $80523d93773bd442$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $80523d93773bd442$export$263a749fff749872 = [
    $80523d93773bd442$var$CHROME_PRIORITY,
    $80523d93773bd442$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $80523d93773bd442$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $80523d93773bd442$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $80523d93773bd442$var$gecko = (line)=>{
    const parts = $80523d93773bd442$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $80523d93773bd442$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $93d9feb480276d57$export$27c7e15d453fc0ac);
        [func, filename] = $80523d93773bd442$var$extractSafariExtensionDetails(func, filename);
        return $80523d93773bd442$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $80523d93773bd442$export$cdba47a5dd2804d = [
    $80523d93773bd442$var$GECKO_PRIORITY,
    $80523d93773bd442$var$gecko
];
const $80523d93773bd442$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $80523d93773bd442$var$winjs = (line)=>{
    const parts = $80523d93773bd442$var$winjsRegex.exec(line);
    return parts ? $80523d93773bd442$var$createFrame(parts[2], parts[1] || (0, $93d9feb480276d57$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $80523d93773bd442$export$179460296da408e8 = [
    $80523d93773bd442$var$WINJS_PRIORITY,
    $80523d93773bd442$var$winjs
];
const $80523d93773bd442$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $80523d93773bd442$var$opera10 = (line)=>{
    const parts = $80523d93773bd442$var$opera10Regex.exec(line);
    return parts ? $80523d93773bd442$var$createFrame(parts[2], parts[3] || (0, $93d9feb480276d57$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $80523d93773bd442$export$f892b52c880ffc7a = [
    $80523d93773bd442$var$OPERA10_PRIORITY,
    $80523d93773bd442$var$opera10
];
const $80523d93773bd442$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $80523d93773bd442$var$opera11 = (line)=>{
    const parts = $80523d93773bd442$var$opera11Regex.exec(line);
    return parts ? $80523d93773bd442$var$createFrame(parts[5], parts[3] || parts[4] || (0, $93d9feb480276d57$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $80523d93773bd442$export$af11af13f09fb0dc = [
    $80523d93773bd442$var$OPERA11_PRIORITY,
    $80523d93773bd442$var$opera11
];
const $80523d93773bd442$export$7197c0fe6554c079 = [
    $80523d93773bd442$export$263a749fff749872,
    $80523d93773bd442$export$cdba47a5dd2804d
];
const $80523d93773bd442$export$2b2b997d81bf3907 = (0, $93d9feb480276d57$export$a5739666fb2d03d4)(...$80523d93773bd442$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $80523d93773bd442$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $93d9feb480276d57$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f6602c3ed388ae67$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $1d6d783f6f25db5d$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $1d6d783f6f25db5d$export$e464f4a514ac28a8(name) {
    const cached = $1d6d783f6f25db5d$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $5280bded108e0add$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $dadbb4ba0cb1970b$export$d5f608b368e73f38)(impl)) return $1d6d783f6f25db5d$var$cachedImplementations[name] = impl.bind((0, $5280bded108e0add$export$56d8a8a25bd48b81));
    const document = (0, $5280bded108e0add$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $f6602c3ed388ae67$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $1d6d783f6f25db5d$var$cachedImplementations[name] = impl.bind((0, $5280bded108e0add$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $1d6d783f6f25db5d$export$8aa36702e8c8978(name) {
    $1d6d783f6f25db5d$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $1d6d783f6f25db5d$export$e7aa7bc5c1b3cfb3(...rest) {
    return $1d6d783f6f25db5d$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $1d6d783f6f25db5d$export$831dc9f2ab0a617b(...rest) {
    return $1d6d783f6f25db5d$export$e464f4a514ac28a8("setTimeout")(...rest);
}








/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $9f36e6fea2a7ae05$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $73b14e1e70e0f591$export$78e43115b553f358)(new (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $73b14e1e70e0f591$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $ca39bfdb822ac957$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $ca39bfdb822ac957$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $ca39bfdb822ac957$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $ca39bfdb822ac957$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $ca39bfdb822ac957$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $ca39bfdb822ac957$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $ca39bfdb822ac957$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $ca39bfdb822ac957$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $424304c4e79a6e1c$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $424304c4e79a6e1c$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $9f36e6fea2a7ae05$export$85a4f67f852183e6)(options.bufferSize || $424304c4e79a6e1c$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $b5714e6000d86929$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $b5714e6000d86929$export$b11169581eeaf237)(type);
            if ((0, $ca39bfdb822ac957$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $424304c4e79a6e1c$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $b5714e6000d86929$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $b5714e6000d86929$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $424304c4e79a6e1c$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $b5714e6000d86929$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $b5714e6000d86929$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $ca39bfdb822ac957$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $fca5dcb9074abcc2$export$5949942ba2a7c0e2)) {
                (0, $873988e1817a1f64$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $73b14e1e70e0f591$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $424304c4e79a6e1c$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $ea4a6aa3e672b09d$export$b2311068c46d7cc8(options, nativeFetch = (0, $1d6d783f6f25db5d$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $1d6d783f6f25db5d$export$8aa36702e8c8978)("fetch");
            return (0, $73b14e1e70e0f591$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $1d6d783f6f25db5d$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $73b14e1e70e0f591$export$78e43115b553f358)(e);
        }
    }
    return (0, $424304c4e79a6e1c$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $014f885e9d827e1f$export$5783b2920b1d62b9(options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ const integrations = [
        (0, $c4ffff227fd4d51c$export$cb3c5c2ceb9818ba)(),
        (0, $3097e92e64b6a17a$export$7918117e9202e4fb)(),
        (0, $68636222c003578a$export$59bfe9f1c76150e)(),
        (0, $4e19028608fa5deb$export$c079d904b326663a)(),
        (0, $0be1134de0a15137$export$66acc70e8cf2b71a)(),
        (0, $fe56bae285431ea9$export$ebabb00eb7f3a395)(),
        (0, $586ee3c1605d4497$export$6d39aa44cd0c7567)(),
        (0, $6067e12a64becc99$export$1378794447170364)()
    ];
    // eslint-disable-next-line deprecation/deprecation
    if (options.autoSessionTracking !== false) integrations.push((0, $9fcfdc6f705cf45a$export$1baa7880e357371c)());
    return integrations;
}
function $014f885e9d827e1f$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $014f885e9d827e1f$export$5783b2920b1d62b9(optionsArg),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    // TODO: Instead of dropping just `defaultIntegrations`, we should simply
    // call `dropUndefinedKeys` on the entire `optionsArg`.
    // However, for this to work we need to adjust the `hasTracingEnabled()` logic
    // first as it differentiates between `undefined` and the key not being in the object.
    if (optionsArg.defaultIntegrations == null) delete optionsArg.defaultIntegrations;
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $014f885e9d827e1f$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).window !== "undefined" && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject && extensionObject.runtime && extensionObject.runtime.id;
    const href = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).location.href || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81) === (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $014f885e9d827e1f$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $014f885e9d827e1f$var$applyDefaultOptions(browserOptions);
    if (!options.skipBrowserExtensionCheck && $014f885e9d827e1f$var$shouldShowBrowserExtensionError()) {
        (0, $3eec9ca128c747ee$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if (0, $2b3fd96956b11e20$export$16a28057038b10ef) {
        if (!(0, $dadbb4ba0cb1970b$export$edf3cb81fd7d2a3e)()) (0, $3eec9ca128c747ee$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $93d9feb480276d57$export$1d5cf88b347146d4)(options.stackParser || (0, $80523d93773bd442$export$2b2b997d81bf3907)),
        integrations: (0, $e5d45905f90d44b8$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $ea4a6aa3e672b09d$export$b2311068c46d7cc8)
    };
    return (0, $d3a9624d92b26f35$export$5333c3f1c58d9bc1)((0, $412dcef8a085c15c$export$1df9218a526d318d), clientOptions);
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $014f885e9d827e1f$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document) {
        (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $d9c634b0176f110a$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $25ed9a2fc5ad35c9$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $60e099ae9f552201$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document.head || (0, $88b8429cc4ddcd3a$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $2b3fd96956b11e20$export$16a28057038b10ef) && (0, $3eec9ca128c747ee$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $014f885e9d827e1f$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $014f885e9d827e1f$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $014f885e9d827e1f$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $d9c634b0176f110a$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}




var $8FY87 = parcelRequire("8FY87");
/**
 * Inits the React SDK
 */ function $6be2f97e1ec52773$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $d7f863f53386af74$export$b9f95b027256052c)(opts, "react");
    (0, $25ed9a2fc5ad35c9$export$2f04de43fe27971a)("react", {
        version: $8FY87.version
    });
    return (0, $014f885e9d827e1f$export$2cd8252107eb640b)(opts);
}


function $7cc2099d0489abd3$export$f5ae3c4820871661() {
    try {
        const release = `arise-frontend@${"brickhouse-prod-v1.0.1"}`;
        if (release) console.info(`Version ${"brickhouse-prod-v1.0.1"}`);
        $6be2f97e1ec52773$export$2cd8252107eb640b({
            dsn: undefined,
            integrations: [],
            environment: "prod",
            release: release
        });
        $25ed9a2fc5ad35c9$export$a37d07ee78eb4569("instance", "brickhouse");
    } catch (err) {
        console.error("Failed to initialize Sentry", err);
    }
}



var $1URoE = parcelRequire("1URoE");

var $6lYLL = parcelRequire("6lYLL");

var $aTRs6 = parcelRequire("aTRs6");

var $8FY87 = parcelRequire("8FY87");
function $68a0e038b32f657d$export$2e2bcd8739ae039({ to: to }) {
    (0, $8FY87.useEffect)(()=>{
        window.location.href = to;
    }, [
        to
    ]);
    return null;
}


// e.g. not insiders
const $e44220deb002a90a$var$authRoutesDefault = [
    {
        path: "landing",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6lYLL.Provider), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $88d5d9dcc7bdcff9$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: "reset-password",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6lYLL.Provider), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $ed116069ec05b84c$export$2e2bcd8739ae039), {})
            })
        })
    }
];
const $e44220deb002a90a$var$getAuthRoutesInsiders = ()=>{
    // Prev used <InsidersExternalRedirect />
    const authRoutes = [
        {
            path: "insiders",
            element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3267d0cfcd7de1a7$export$2e2bcd8739ae039), {})
            })
        }
    ];
    return authRoutes;
};
const $e44220deb002a90a$var$defaultRouter = (0, $734169eef5d6795a$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)($e44220deb002a90a$var$NavigateToWithExistingQuery, {
            to: (0, $1URoE.homePath)
        })
    },
    {
        path: "/auth",
        children: (0, $1URoE.isInsidersInstance) ? $e44220deb002a90a$var$getAuthRoutesInsiders() : $e44220deb002a90a$var$authRoutesDefault
    },
    {
        path: "/edit-profile",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $2e3540a01ec72769$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $1f7f5122cbc52b81$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: "/edit-display-name",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6lYLL.Provider), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $439070a6692e5164$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: "/oauth/exchange",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $6lYLL.Provider), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3314a408cbad15a9$export$2e2bcd8739ae039), {})
        })
    },
    {
        path: "/location/:locationId",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $f2c7960aa4e3ca7c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $08d8b97892d92b00$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $3e5ffd7ffe6e1c1b$export$2e2bcd8739ae039), {})
            })
        })
    },
    {
        path: "*",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)($e44220deb002a90a$var$NavigateToWithExistingQuery, {
            to: "/"
        })
    }
]);
// Router for soft disabling site, e.g. outside of discord
const $e44220deb002a90a$var$disabledRouter = (0, $734169eef5d6795a$export$1f3f55432a00e06d)([
    {
        path: "*",
        element: /*#__PURE__*/ (0, $2PPWI.jsx)((0, $68a0e038b32f657d$export$2e2bcd8739ae039), {
            to: "https://www.thosebeyond.io/"
        })
    }
]);
const $e44220deb002a90a$var$allowWebParam = new URLSearchParams(window.location.search).has("allowWeb");
const $e44220deb002a90a$var$isDisabled = !(0, $aTRs6.IS_DISCORD_ACTIVITY) && !$e44220deb002a90a$var$allowWebParam;
const $e44220deb002a90a$var$router = $e44220deb002a90a$var$isDisabled ? $e44220deb002a90a$var$disabledRouter : $e44220deb002a90a$var$defaultRouter;
(0, $7cc2099d0489abd3$export$f5ae3c4820871661)();
const $e44220deb002a90a$var$root = document.createElement("div");
document.body.appendChild($e44220deb002a90a$var$root);
$adc227c367c2f6aa$export$882461b6382ed46c($e44220deb002a90a$var$root).render(/*#__PURE__*/ (0, $2PPWI.jsx)((0, $734169eef5d6795a$export$323e4fc2fa4753fb), {
    router: $e44220deb002a90a$var$router
}));
function $e44220deb002a90a$var$NavigateToWithExistingQuery({ to: to }) {
    const searchParams = new URLSearchParams(window.location.search);
    const navigateTo = searchParams ? `${to}?${searchParams}` : to;
    return /*#__PURE__*/ (0, $2PPWI.jsx)((0, $d5fb2d3e42b0c581$export$444b3ab0cb9aec40), {
        to: navigateTo
    });
}

})();
//# sourceMappingURL=index.811c48d9.js.map
